import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  applicant_enum: any;
  bigint: any;
  company_managers_view_all_contractors_access: any;
  company_marketplace_access: any;
  currency: any;
  custom_request_status: any;
  date: any;
  document_project_access_scope: any;
  float8: any;
  jsonb: any;
  numeric: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  timetz: any;
  uuid: any;
};


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: Maybe<Scalars['Float']>;
  _gt?: Maybe<Scalars['Float']>;
  _gte?: Maybe<Scalars['Float']>;
  _in?: Maybe<Array<Scalars['Float']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Float']>;
  _lte?: Maybe<Scalars['Float']>;
  _neq?: Maybe<Scalars['Float']>;
  _nin?: Maybe<Array<Scalars['Float']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: Maybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: Maybe<Array<Scalars['String']>>;
  _eq?: Maybe<Array<Scalars['String']>>;
  _gt?: Maybe<Array<Scalars['String']>>;
  _gte?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Array<Scalars['String']>>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Array<Scalars['String']>>;
  _lte?: Maybe<Array<Scalars['String']>>;
  _neq?: Maybe<Array<Scalars['String']>>;
  _nin?: Maybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

/** columns and relationships of "admin" */
export type Admin = {
  __typename?: 'admin';
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  declined_visit_matches: Array<Declined_Visit_Matches>;
  /** An aggregate relationship */
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  smart_match_bookmarks: Array<Smart_Match_Bookmark>;
  /** An aggregate relationship */
  smart_match_bookmarks_aggregate: Smart_Match_Bookmark_Aggregate;
  /** An object relationship */
  smart_match_config?: Maybe<Smart_Match_Configs>;
  subscription_info_showed: Scalars['Boolean'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "admin" */
export type AdminDeclined_Visit_MatchesArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "admin" */
export type AdminDeclined_Visit_Matches_AggregateArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "admin" */
export type AdminSmart_Match_BookmarksArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


/** columns and relationships of "admin" */
export type AdminSmart_Match_Bookmarks_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};

/** aggregated selection of "admin" */
export type Admin_Aggregate = {
  __typename?: 'admin_aggregate';
  aggregate?: Maybe<Admin_Aggregate_Fields>;
  nodes: Array<Admin>;
};

export type Admin_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Admin_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Admin_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Admin_Aggregate_Bool_Exp_Count>;
};

export type Admin_Aggregate_Bool_Exp_Bool_And = {
  arguments: Admin_Select_Column_Admin_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Admin_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Admin_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Admin_Select_Column_Admin_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Admin_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Admin_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Admin_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Admin_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "admin" */
export type Admin_Aggregate_Fields = {
  __typename?: 'admin_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Admin_Max_Fields>;
  min?: Maybe<Admin_Min_Fields>;
};


/** aggregate fields of "admin" */
export type Admin_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Admin_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin" */
export type Admin_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Admin_Max_Order_By>;
  min?: Maybe<Admin_Min_Order_By>;
};

/** input type for inserting array relation for remote table "admin" */
export type Admin_Arr_Rel_Insert_Input = {
  data: Array<Admin_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Admin_On_Conflict>;
};

/** Boolean expression to filter rows from the table "admin". All fields are combined with a logical 'AND'. */
export type Admin_Bool_Exp = {
  _and?: Maybe<Array<Admin_Bool_Exp>>;
  _not?: Maybe<Admin_Bool_Exp>;
  _or?: Maybe<Array<Admin_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Bool_Exp>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Bool_Exp>;
  smart_match_config?: Maybe<Smart_Match_Configs_Bool_Exp>;
  subscription_info_showed?: Maybe<Boolean_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin" */
export enum Admin_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdminPkey = 'admin_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AdminUserIdKey = 'admin_user_id_key'
}

/** input type for inserting data into table "admin" */
export type Admin_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Arr_Rel_Insert_Input>;
  smart_match_config?: Maybe<Smart_Match_Configs_Obj_Rel_Insert_Input>;
  subscription_info_showed?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Admin_Max_Fields = {
  __typename?: 'admin_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "admin" */
export type Admin_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Admin_Min_Fields = {
  __typename?: 'admin_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "admin" */
export type Admin_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "admin" */
export type Admin_Mutation_Response = {
  __typename?: 'admin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin>;
};

/** input type for inserting object relation for remote table "admin" */
export type Admin_Obj_Rel_Insert_Input = {
  data: Admin_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Admin_On_Conflict>;
};

/** on_conflict condition type for table "admin" */
export type Admin_On_Conflict = {
  constraint: Admin_Constraint;
  update_columns?: Array<Admin_Update_Column>;
  where?: Maybe<Admin_Bool_Exp>;
};

/** Ordering options when selecting data from "admin". */
export type Admin_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Order_By>;
  smart_match_config?: Maybe<Smart_Match_Configs_Order_By>;
  subscription_info_showed?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: admin */
export type Admin_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "admin" */
export enum Admin_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionInfoShowed = 'subscription_info_showed',
  /** column name */
  UserId = 'user_id'
}

/** select "admin_aggregate_bool_exp_bool_and_arguments_columns" columns of table "admin" */
export enum Admin_Select_Column_Admin_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SubscriptionInfoShowed = 'subscription_info_showed'
}

/** select "admin_aggregate_bool_exp_bool_or_arguments_columns" columns of table "admin" */
export enum Admin_Select_Column_Admin_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SubscriptionInfoShowed = 'subscription_info_showed'
}

/** input type for updating data in table "admin" */
export type Admin_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_info_showed?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "admin" */
export type Admin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  subscription_info_showed?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "admin" */
export enum Admin_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriptionInfoShowed = 'subscription_info_showed',
  /** column name */
  UserId = 'user_id'
}

export type Admin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Admin_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_Bool_Exp;
};


/** Boolean expression to compare columns of type "applicant_enum". All fields are combined with logical 'AND'. */
export type Applicant_Enum_Comparison_Exp = {
  _eq?: Maybe<Scalars['applicant_enum']>;
  _gt?: Maybe<Scalars['applicant_enum']>;
  _gte?: Maybe<Scalars['applicant_enum']>;
  _in?: Maybe<Array<Scalars['applicant_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['applicant_enum']>;
  _lte?: Maybe<Scalars['applicant_enum']>;
  _neq?: Maybe<Scalars['applicant_enum']>;
  _nin?: Maybe<Array<Scalars['applicant_enum']>>;
};

/** columns and relationships of "application" */
export type Application = {
  __typename?: 'application';
  /** An array relationship */
  candidates: Array<Candidate>;
  /** An aggregate relationship */
  candidates_aggregate: Candidate_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  document?: Maybe<Document>;
  document_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  interviewed_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  interviewer?: Maybe<User>;
  is_cancelled?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  /** An object relationship */
  posting: Posting;
  posting_id: Scalars['uuid'];
  status?: Maybe<Scalars['applicant_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "application" */
export type ApplicationCandidatesArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "application" */
export type ApplicationCandidates_AggregateArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};

/** aggregated selection of "application" */
export type Application_Aggregate = {
  __typename?: 'application_aggregate';
  aggregate?: Maybe<Application_Aggregate_Fields>;
  nodes: Array<Application>;
};

export type Application_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Application_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Application_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Application_Aggregate_Bool_Exp_Count>;
};

export type Application_Aggregate_Bool_Exp_Bool_And = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Application_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Application_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "application" */
export type Application_Aggregate_Fields = {
  __typename?: 'application_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Application_Max_Fields>;
  min?: Maybe<Application_Min_Fields>;
};


/** aggregate fields of "application" */
export type Application_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Application_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "application" */
export type Application_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Application_Max_Order_By>;
  min?: Maybe<Application_Min_Order_By>;
};

/** input type for inserting array relation for remote table "application" */
export type Application_Arr_Rel_Insert_Input = {
  data: Array<Application_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Application_On_Conflict>;
};

/** Boolean expression to filter rows from the table "application". All fields are combined with a logical 'AND'. */
export type Application_Bool_Exp = {
  _and?: Maybe<Array<Application_Bool_Exp>>;
  _not?: Maybe<Application_Bool_Exp>;
  _or?: Maybe<Array<Application_Bool_Exp>>;
  candidates?: Maybe<Candidate_Bool_Exp>;
  candidates_aggregate?: Maybe<Candidate_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  document?: Maybe<Document_Bool_Exp>;
  document_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  interviewed_by?: Maybe<Uuid_Comparison_Exp>;
  interviewer?: Maybe<User_Bool_Exp>;
  is_cancelled?: Maybe<Boolean_Comparison_Exp>;
  note?: Maybe<String_Comparison_Exp>;
  posting?: Maybe<Posting_Bool_Exp>;
  posting_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Applicant_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "application" */
export enum Application_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationPkey = 'application_pkey',
  /** unique or primary key constraint on columns "user_id", "posting_id" */
  ApplicationPostingIdUserIdKey = 'application_posting_id_user_id_key'
}

/** input type for inserting data into table "application" */
export type Application_Insert_Input = {
  candidates?: Maybe<Candidate_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Document_Obj_Rel_Insert_Input>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  interviewed_by?: Maybe<Scalars['uuid']>;
  interviewer?: Maybe<User_Obj_Rel_Insert_Input>;
  is_cancelled?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  posting?: Maybe<Posting_Obj_Rel_Insert_Input>;
  posting_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['applicant_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Application_Max_Fields = {
  __typename?: 'application_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  interviewed_by?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  posting_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['applicant_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "application" */
export type Application_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interviewed_by?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Application_Min_Fields = {
  __typename?: 'application_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  interviewed_by?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  posting_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['applicant_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "application" */
export type Application_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interviewed_by?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "application" */
export type Application_Mutation_Response = {
  __typename?: 'application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Application>;
};

/** input type for inserting object relation for remote table "application" */
export type Application_Obj_Rel_Insert_Input = {
  data: Application_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Application_On_Conflict>;
};

/** on_conflict condition type for table "application" */
export type Application_On_Conflict = {
  constraint: Application_Constraint;
  update_columns?: Array<Application_Update_Column>;
  where?: Maybe<Application_Bool_Exp>;
};

/** Ordering options when selecting data from "application". */
export type Application_Order_By = {
  candidates_aggregate?: Maybe<Candidate_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  document?: Maybe<Document_Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interviewed_by?: Maybe<Order_By>;
  interviewer?: Maybe<User_Order_By>;
  is_cancelled?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  posting?: Maybe<Posting_Order_By>;
  posting_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: application */
export type Application_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "application" */
export enum Application_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewedBy = 'interviewed_by',
  /** column name */
  IsCancelled = 'is_cancelled',
  /** column name */
  Note = 'note',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "application_aggregate_bool_exp_bool_and_arguments_columns" columns of table "application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCancelled = 'is_cancelled'
}

/** select "application_aggregate_bool_exp_bool_or_arguments_columns" columns of table "application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCancelled = 'is_cancelled'
}

/** input type for updating data in table "application" */
export type Application_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  interviewed_by?: Maybe<Scalars['uuid']>;
  is_cancelled?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  posting_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['applicant_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "application" */
export type Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  interviewed_by?: Maybe<Scalars['uuid']>;
  is_cancelled?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  posting_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['applicant_enum']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "application" */
export enum Application_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  InterviewedBy = 'interviewed_by',
  /** column name */
  IsCancelled = 'is_cancelled',
  /** column name */
  Note = 'note',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Application_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Application_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Bool_Exp;
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "candidate" */
export type Candidate = {
  __typename?: 'candidate';
  /** An object relationship */
  application: Application;
  application_id: Scalars['uuid'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  onboardings: Array<Onboarding>;
  /** An aggregate relationship */
  onboardings_aggregate: Onboarding_Aggregate;
  status?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "candidate" */
export type CandidateOnboardingsArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


/** columns and relationships of "candidate" */
export type CandidateOnboardings_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};

/** aggregated selection of "candidate" */
export type Candidate_Aggregate = {
  __typename?: 'candidate_aggregate';
  aggregate?: Maybe<Candidate_Aggregate_Fields>;
  nodes: Array<Candidate>;
};

export type Candidate_Aggregate_Bool_Exp = {
  count?: Maybe<Candidate_Aggregate_Bool_Exp_Count>;
};

export type Candidate_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Candidate_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Candidate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "candidate" */
export type Candidate_Aggregate_Fields = {
  __typename?: 'candidate_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Candidate_Max_Fields>;
  min?: Maybe<Candidate_Min_Fields>;
};


/** aggregate fields of "candidate" */
export type Candidate_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Candidate_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "candidate" */
export type Candidate_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Candidate_Max_Order_By>;
  min?: Maybe<Candidate_Min_Order_By>;
};

/** input type for inserting array relation for remote table "candidate" */
export type Candidate_Arr_Rel_Insert_Input = {
  data: Array<Candidate_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Candidate_On_Conflict>;
};

/** Boolean expression to filter rows from the table "candidate". All fields are combined with a logical 'AND'. */
export type Candidate_Bool_Exp = {
  _and?: Maybe<Array<Candidate_Bool_Exp>>;
  _not?: Maybe<Candidate_Bool_Exp>;
  _or?: Maybe<Array<Candidate_Bool_Exp>>;
  application?: Maybe<Application_Bool_Exp>;
  application_id?: Maybe<Uuid_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  onboardings?: Maybe<Onboarding_Bool_Exp>;
  onboardings_aggregate?: Maybe<Onboarding_Aggregate_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "candidate" */
export enum Candidate_Constraint {
  /** unique or primary key constraint on columns "user_id", "application_id", "company_id" */
  CandidateApplicationIdUserIdCompanyIdKey = 'candidate_application_id_user_id_company_id_key',
  /** unique or primary key constraint on columns "id" */
  CandidatePkey = 'candidate_pkey'
}

/** input type for inserting data into table "candidate" */
export type Candidate_Insert_Input = {
  application?: Maybe<Application_Obj_Rel_Insert_Input>;
  application_id?: Maybe<Scalars['uuid']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  onboardings?: Maybe<Onboarding_Arr_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Candidate_Max_Fields = {
  __typename?: 'candidate_max_fields';
  application_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "candidate" */
export type Candidate_Max_Order_By = {
  application_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Candidate_Min_Fields = {
  __typename?: 'candidate_min_fields';
  application_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "candidate" */
export type Candidate_Min_Order_By = {
  application_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "candidate" */
export type Candidate_Mutation_Response = {
  __typename?: 'candidate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Candidate>;
};

/** input type for inserting object relation for remote table "candidate" */
export type Candidate_Obj_Rel_Insert_Input = {
  data: Candidate_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Candidate_On_Conflict>;
};

/** on_conflict condition type for table "candidate" */
export type Candidate_On_Conflict = {
  constraint: Candidate_Constraint;
  update_columns?: Array<Candidate_Update_Column>;
  where?: Maybe<Candidate_Bool_Exp>;
};

/** Ordering options when selecting data from "candidate". */
export type Candidate_Order_By = {
  application?: Maybe<Application_Order_By>;
  application_id?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  onboardings_aggregate?: Maybe<Onboarding_Aggregate_Order_By>;
  status?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: candidate */
export type Candidate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "candidate" */
export enum Candidate_Select_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "candidate" */
export type Candidate_Set_Input = {
  application_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "candidate" */
export type Candidate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Candidate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Candidate_Stream_Cursor_Value_Input = {
  application_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "candidate" */
export enum Candidate_Update_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'user_id'
}

export type Candidate_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Candidate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Candidate_Bool_Exp;
};

/** columns and relationships of "chart_admin_contractors" */
export type Chart_Admin_Contractors = {
  __typename?: 'chart_admin_contractors';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
};

/** aggregated selection of "chart_admin_contractors" */
export type Chart_Admin_Contractors_Aggregate = {
  __typename?: 'chart_admin_contractors_aggregate';
  aggregate?: Maybe<Chart_Admin_Contractors_Aggregate_Fields>;
  nodes: Array<Chart_Admin_Contractors>;
};

/** aggregate fields of "chart_admin_contractors" */
export type Chart_Admin_Contractors_Aggregate_Fields = {
  __typename?: 'chart_admin_contractors_aggregate_fields';
  avg?: Maybe<Chart_Admin_Contractors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Chart_Admin_Contractors_Max_Fields>;
  min?: Maybe<Chart_Admin_Contractors_Min_Fields>;
  stddev?: Maybe<Chart_Admin_Contractors_Stddev_Fields>;
  stddev_pop?: Maybe<Chart_Admin_Contractors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chart_Admin_Contractors_Stddev_Samp_Fields>;
  sum?: Maybe<Chart_Admin_Contractors_Sum_Fields>;
  var_pop?: Maybe<Chart_Admin_Contractors_Var_Pop_Fields>;
  var_samp?: Maybe<Chart_Admin_Contractors_Var_Samp_Fields>;
  variance?: Maybe<Chart_Admin_Contractors_Variance_Fields>;
};


/** aggregate fields of "chart_admin_contractors" */
export type Chart_Admin_Contractors_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Chart_Admin_Contractors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Chart_Admin_Contractors_Avg_Fields = {
  __typename?: 'chart_admin_contractors_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "chart_admin_contractors". All fields are combined with a logical 'AND'. */
export type Chart_Admin_Contractors_Bool_Exp = {
  _and?: Maybe<Array<Chart_Admin_Contractors_Bool_Exp>>;
  _not?: Maybe<Chart_Admin_Contractors_Bool_Exp>;
  _or?: Maybe<Array<Chart_Admin_Contractors_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  count?: Maybe<Bigint_Comparison_Exp>;
  created_at_date?: Maybe<Date_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chart_Admin_Contractors_Max_Fields = {
  __typename?: 'chart_admin_contractors_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
};

/** aggregate min on columns */
export type Chart_Admin_Contractors_Min_Fields = {
  __typename?: 'chart_admin_contractors_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
};

/** Ordering options when selecting data from "chart_admin_contractors". */
export type Chart_Admin_Contractors_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  count?: Maybe<Order_By>;
  created_at_date?: Maybe<Order_By>;
};

/** select columns of table "chart_admin_contractors" */
export enum Chart_Admin_Contractors_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAtDate = 'created_at_date'
}

/** aggregate stddev on columns */
export type Chart_Admin_Contractors_Stddev_Fields = {
  __typename?: 'chart_admin_contractors_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Chart_Admin_Contractors_Stddev_Pop_Fields = {
  __typename?: 'chart_admin_contractors_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Chart_Admin_Contractors_Stddev_Samp_Fields = {
  __typename?: 'chart_admin_contractors_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "chart_admin_contractors" */
export type Chart_Admin_Contractors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chart_Admin_Contractors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chart_Admin_Contractors_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Chart_Admin_Contractors_Sum_Fields = {
  __typename?: 'chart_admin_contractors_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Chart_Admin_Contractors_Var_Pop_Fields = {
  __typename?: 'chart_admin_contractors_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Chart_Admin_Contractors_Var_Samp_Fields = {
  __typename?: 'chart_admin_contractors_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Chart_Admin_Contractors_Variance_Fields = {
  __typename?: 'chart_admin_contractors_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "chart_manager_contractors" */
export type Chart_Manager_Contractors = {
  __typename?: 'chart_manager_contractors';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  manager?: Maybe<Manager>;
  manager_db_count?: Maybe<Scalars['bigint']>;
  manager_id?: Maybe<Scalars['uuid']>;
  manager_request_count?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "chart_manager_contractors" */
export type Chart_Manager_Contractors_Aggregate = {
  __typename?: 'chart_manager_contractors_aggregate';
  aggregate?: Maybe<Chart_Manager_Contractors_Aggregate_Fields>;
  nodes: Array<Chart_Manager_Contractors>;
};

/** aggregate fields of "chart_manager_contractors" */
export type Chart_Manager_Contractors_Aggregate_Fields = {
  __typename?: 'chart_manager_contractors_aggregate_fields';
  avg?: Maybe<Chart_Manager_Contractors_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Chart_Manager_Contractors_Max_Fields>;
  min?: Maybe<Chart_Manager_Contractors_Min_Fields>;
  stddev?: Maybe<Chart_Manager_Contractors_Stddev_Fields>;
  stddev_pop?: Maybe<Chart_Manager_Contractors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chart_Manager_Contractors_Stddev_Samp_Fields>;
  sum?: Maybe<Chart_Manager_Contractors_Sum_Fields>;
  var_pop?: Maybe<Chart_Manager_Contractors_Var_Pop_Fields>;
  var_samp?: Maybe<Chart_Manager_Contractors_Var_Samp_Fields>;
  variance?: Maybe<Chart_Manager_Contractors_Variance_Fields>;
};


/** aggregate fields of "chart_manager_contractors" */
export type Chart_Manager_Contractors_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Chart_Manager_Contractors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Chart_Manager_Contractors_Avg_Fields = {
  __typename?: 'chart_manager_contractors_avg_fields';
  manager_db_count?: Maybe<Scalars['Float']>;
  manager_request_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "chart_manager_contractors". All fields are combined with a logical 'AND'. */
export type Chart_Manager_Contractors_Bool_Exp = {
  _and?: Maybe<Array<Chart_Manager_Contractors_Bool_Exp>>;
  _not?: Maybe<Chart_Manager_Contractors_Bool_Exp>;
  _or?: Maybe<Array<Chart_Manager_Contractors_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at_date?: Maybe<Date_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_db_count?: Maybe<Bigint_Comparison_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  manager_request_count?: Maybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chart_Manager_Contractors_Max_Fields = {
  __typename?: 'chart_manager_contractors_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at_date?: Maybe<Scalars['date']>;
  manager_db_count?: Maybe<Scalars['bigint']>;
  manager_id?: Maybe<Scalars['uuid']>;
  manager_request_count?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Chart_Manager_Contractors_Min_Fields = {
  __typename?: 'chart_manager_contractors_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at_date?: Maybe<Scalars['date']>;
  manager_db_count?: Maybe<Scalars['bigint']>;
  manager_id?: Maybe<Scalars['uuid']>;
  manager_request_count?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "chart_manager_contractors". */
export type Chart_Manager_Contractors_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at_date?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_db_count?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  manager_request_count?: Maybe<Order_By>;
};

/** select columns of table "chart_manager_contractors" */
export enum Chart_Manager_Contractors_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAtDate = 'created_at_date',
  /** column name */
  ManagerDbCount = 'manager_db_count',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  ManagerRequestCount = 'manager_request_count'
}

/** aggregate stddev on columns */
export type Chart_Manager_Contractors_Stddev_Fields = {
  __typename?: 'chart_manager_contractors_stddev_fields';
  manager_db_count?: Maybe<Scalars['Float']>;
  manager_request_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Chart_Manager_Contractors_Stddev_Pop_Fields = {
  __typename?: 'chart_manager_contractors_stddev_pop_fields';
  manager_db_count?: Maybe<Scalars['Float']>;
  manager_request_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Chart_Manager_Contractors_Stddev_Samp_Fields = {
  __typename?: 'chart_manager_contractors_stddev_samp_fields';
  manager_db_count?: Maybe<Scalars['Float']>;
  manager_request_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "chart_manager_contractors" */
export type Chart_Manager_Contractors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chart_Manager_Contractors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chart_Manager_Contractors_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at_date?: Maybe<Scalars['date']>;
  manager_db_count?: Maybe<Scalars['bigint']>;
  manager_id?: Maybe<Scalars['uuid']>;
  manager_request_count?: Maybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Chart_Manager_Contractors_Sum_Fields = {
  __typename?: 'chart_manager_contractors_sum_fields';
  manager_db_count?: Maybe<Scalars['bigint']>;
  manager_request_count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Chart_Manager_Contractors_Var_Pop_Fields = {
  __typename?: 'chart_manager_contractors_var_pop_fields';
  manager_db_count?: Maybe<Scalars['Float']>;
  manager_request_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Chart_Manager_Contractors_Var_Samp_Fields = {
  __typename?: 'chart_manager_contractors_var_samp_fields';
  manager_db_count?: Maybe<Scalars['Float']>;
  manager_request_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Chart_Manager_Contractors_Variance_Fields = {
  __typename?: 'chart_manager_contractors_variance_fields';
  manager_db_count?: Maybe<Scalars['Float']>;
  manager_request_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "chart_projects" */
export type Chart_Projects = {
  __typename?: 'chart_projects';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  manager?: Maybe<Manager>;
  manager_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "chart_projects" */
export type Chart_Projects_Aggregate = {
  __typename?: 'chart_projects_aggregate';
  aggregate?: Maybe<Chart_Projects_Aggregate_Fields>;
  nodes: Array<Chart_Projects>;
};

/** aggregate fields of "chart_projects" */
export type Chart_Projects_Aggregate_Fields = {
  __typename?: 'chart_projects_aggregate_fields';
  avg?: Maybe<Chart_Projects_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Chart_Projects_Max_Fields>;
  min?: Maybe<Chart_Projects_Min_Fields>;
  stddev?: Maybe<Chart_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Chart_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chart_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Chart_Projects_Sum_Fields>;
  var_pop?: Maybe<Chart_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Chart_Projects_Var_Samp_Fields>;
  variance?: Maybe<Chart_Projects_Variance_Fields>;
};


/** aggregate fields of "chart_projects" */
export type Chart_Projects_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Chart_Projects_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Chart_Projects_Avg_Fields = {
  __typename?: 'chart_projects_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "chart_projects". All fields are combined with a logical 'AND'. */
export type Chart_Projects_Bool_Exp = {
  _and?: Maybe<Array<Chart_Projects_Bool_Exp>>;
  _not?: Maybe<Chart_Projects_Bool_Exp>;
  _or?: Maybe<Array<Chart_Projects_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  count?: Maybe<Bigint_Comparison_Exp>;
  created_at_date?: Maybe<Date_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chart_Projects_Max_Fields = {
  __typename?: 'chart_projects_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
  manager_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Chart_Projects_Min_Fields = {
  __typename?: 'chart_projects_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
  manager_id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "chart_projects". */
export type Chart_Projects_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  count?: Maybe<Order_By>;
  created_at_date?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
};

/** select columns of table "chart_projects" */
export enum Chart_Projects_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Count = 'count',
  /** column name */
  CreatedAtDate = 'created_at_date',
  /** column name */
  ManagerId = 'manager_id'
}

/** aggregate stddev on columns */
export type Chart_Projects_Stddev_Fields = {
  __typename?: 'chart_projects_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Chart_Projects_Stddev_Pop_Fields = {
  __typename?: 'chart_projects_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Chart_Projects_Stddev_Samp_Fields = {
  __typename?: 'chart_projects_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "chart_projects" */
export type Chart_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chart_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chart_Projects_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
  created_at_date?: Maybe<Scalars['date']>;
  manager_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Chart_Projects_Sum_Fields = {
  __typename?: 'chart_projects_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Chart_Projects_Var_Pop_Fields = {
  __typename?: 'chart_projects_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Chart_Projects_Var_Samp_Fields = {
  __typename?: 'chart_projects_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Chart_Projects_Variance_Fields = {
  __typename?: 'chart_projects_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "checkin_status" */
export type Checkin_Status = {
  __typename?: 'checkin_status';
  value: Scalars['String'];
};

/** aggregated selection of "checkin_status" */
export type Checkin_Status_Aggregate = {
  __typename?: 'checkin_status_aggregate';
  aggregate?: Maybe<Checkin_Status_Aggregate_Fields>;
  nodes: Array<Checkin_Status>;
};

/** aggregate fields of "checkin_status" */
export type Checkin_Status_Aggregate_Fields = {
  __typename?: 'checkin_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Checkin_Status_Max_Fields>;
  min?: Maybe<Checkin_Status_Min_Fields>;
};


/** aggregate fields of "checkin_status" */
export type Checkin_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Checkin_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "checkin_status". All fields are combined with a logical 'AND'. */
export type Checkin_Status_Bool_Exp = {
  _and?: Maybe<Array<Checkin_Status_Bool_Exp>>;
  _not?: Maybe<Checkin_Status_Bool_Exp>;
  _or?: Maybe<Array<Checkin_Status_Bool_Exp>>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkin_status" */
export enum Checkin_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  CheckinStatusPkey = 'checkin_status_pkey',
  /** unique or primary key constraint on columns "value" */
  CheckinStatusValueKey = 'checkin_status_value_key'
}

/** input type for inserting data into table "checkin_status" */
export type Checkin_Status_Insert_Input = {
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Checkin_Status_Max_Fields = {
  __typename?: 'checkin_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Checkin_Status_Min_Fields = {
  __typename?: 'checkin_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "checkin_status" */
export type Checkin_Status_Mutation_Response = {
  __typename?: 'checkin_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Checkin_Status>;
};

/** on_conflict condition type for table "checkin_status" */
export type Checkin_Status_On_Conflict = {
  constraint: Checkin_Status_Constraint;
  update_columns?: Array<Checkin_Status_Update_Column>;
  where?: Maybe<Checkin_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "checkin_status". */
export type Checkin_Status_Order_By = {
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: checkin_status */
export type Checkin_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "checkin_status" */
export enum Checkin_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "checkin_status" */
export type Checkin_Status_Set_Input = {
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "checkin_status" */
export type Checkin_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Checkin_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Checkin_Status_Stream_Cursor_Value_Input = {
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "checkin_status" */
export enum Checkin_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Checkin_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Checkin_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Checkin_Status_Bool_Exp;
};

/** columns and relationships of "checkout_status" */
export type Checkout_Status = {
  __typename?: 'checkout_status';
  value: Scalars['String'];
};

/** aggregated selection of "checkout_status" */
export type Checkout_Status_Aggregate = {
  __typename?: 'checkout_status_aggregate';
  aggregate?: Maybe<Checkout_Status_Aggregate_Fields>;
  nodes: Array<Checkout_Status>;
};

/** aggregate fields of "checkout_status" */
export type Checkout_Status_Aggregate_Fields = {
  __typename?: 'checkout_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Checkout_Status_Max_Fields>;
  min?: Maybe<Checkout_Status_Min_Fields>;
};


/** aggregate fields of "checkout_status" */
export type Checkout_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Checkout_Status_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "checkout_status". All fields are combined with a logical 'AND'. */
export type Checkout_Status_Bool_Exp = {
  _and?: Maybe<Array<Checkout_Status_Bool_Exp>>;
  _not?: Maybe<Checkout_Status_Bool_Exp>;
  _or?: Maybe<Array<Checkout_Status_Bool_Exp>>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "checkout_status" */
export enum Checkout_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  CheckoutStatusPkey = 'checkout_status_pkey'
}

/** input type for inserting data into table "checkout_status" */
export type Checkout_Status_Insert_Input = {
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Checkout_Status_Max_Fields = {
  __typename?: 'checkout_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Checkout_Status_Min_Fields = {
  __typename?: 'checkout_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "checkout_status" */
export type Checkout_Status_Mutation_Response = {
  __typename?: 'checkout_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Checkout_Status>;
};

/** on_conflict condition type for table "checkout_status" */
export type Checkout_Status_On_Conflict = {
  constraint: Checkout_Status_Constraint;
  update_columns?: Array<Checkout_Status_Update_Column>;
  where?: Maybe<Checkout_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "checkout_status". */
export type Checkout_Status_Order_By = {
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: checkout_status */
export type Checkout_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "checkout_status" */
export enum Checkout_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "checkout_status" */
export type Checkout_Status_Set_Input = {
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "checkout_status" */
export type Checkout_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Checkout_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Checkout_Status_Stream_Cursor_Value_Input = {
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "checkout_status" */
export enum Checkout_Status_Update_Column {
  /** column name */
  Value = 'value'
}

export type Checkout_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Checkout_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Checkout_Status_Bool_Exp;
};

/** columns and relationships of "client_care_plan" */
export type Client_Care_Plan = {
  __typename?: 'client_care_plan';
  address?: Maybe<Scalars['String']>;
  allergy_environmental?: Maybe<Scalars['String']>;
  allergy_food?: Maybe<Scalars['String']>;
  allergy_medication?: Maybe<Scalars['String']>;
  ambulance_pain_monitoring?: Maybe<Scalars['String']>;
  ambulance_support_type?: Maybe<Scalars['String']>;
  bathing_frequency?: Maybe<Scalars['String']>;
  bathing_supervision_level?: Maybe<Scalars['String']>;
  care_plan_created_at?: Maybe<Scalars['timestamptz']>;
  care_plan_created_by?: Maybe<Scalars['String']>;
  care_plan_end_date?: Maybe<Scalars['timestamptz']>;
  care_plan_start_date?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_at?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_services?: Maybe<Array<Scalars['String']>>;
  client_services_gen_notes?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_general_notes?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  communication_notes?: Maybe<Scalars['String']>;
  dietary_goals_frequency?: Maybe<Scalars['String']>;
  dietary_goals_special_requirement?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  doc_incident_reports?: Maybe<Scalars['String']>;
  doc_progress_notes?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fall_risk?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender_Enum>;
  /** An object relationship */
  genderByGender?: Maybe<Gender>;
  home_env_accessibility_issues?: Maybe<Scalars['String']>;
  home_env_notes?: Maybe<Scalars['String']>;
  home_env_pets?: Maybe<Scalars['String']>;
  home_env_safety?: Maybe<Scalars['String']>;
  housekeeping_assistance_level?: Maybe<Scalars['String']>;
  housekeeping_daily_task?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  infectious_diseases?: Maybe<Scalars['String']>;
  medication_goals_supervision?: Maybe<Scalars['String']>;
  medication_goals_timing?: Maybe<Scalars['String']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  nutrition_goals_description?: Maybe<Scalars['String']>;
  nutrition_goals_diagnosis?: Maybe<Scalars['String']>;
  nutrition_goals_type?: Maybe<Scalars['String']>;
  personal_cultural_practice?: Maybe<Scalars['String']>;
  personal_goals_hygiene?: Maybe<Scalars['String']>;
  personal_goals_self_care?: Maybe<Scalars['String']>;
  personal_hobbies?: Maybe<Scalars['String']>;
  personal_notes?: Maybe<Scalars['String']>;
  personal_social?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  precautions_description?: Maybe<Scalars['String']>;
  precautions_general_notes?: Maybe<Scalars['String']>;
  precautions_related_notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['uuid']>;
  review_changes_notes?: Maybe<Scalars['String']>;
  review_general_notes?: Maybe<Scalars['String']>;
  review_new_goals?: Maybe<Scalars['String']>;
  skin_goals_notes?: Maybe<Scalars['String']>;
  skin_goals_reporting?: Maybe<Scalars['String']>;
  skin_goals_wound?: Maybe<Scalars['String']>;
  substance_use_considerations?: Maybe<Scalars['String']>;
  toileting_frequency?: Maybe<Scalars['String']>;
  toileting_hygiene?: Maybe<Scalars['String']>;
  toileting_notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "client_care_plan" */
export type Client_Care_Plan_Aggregate = {
  __typename?: 'client_care_plan_aggregate';
  aggregate?: Maybe<Client_Care_Plan_Aggregate_Fields>;
  nodes: Array<Client_Care_Plan>;
};

export type Client_Care_Plan_Aggregate_Bool_Exp = {
  count?: Maybe<Client_Care_Plan_Aggregate_Bool_Exp_Count>;
};

export type Client_Care_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Client_Care_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "client_care_plan" */
export type Client_Care_Plan_Aggregate_Fields = {
  __typename?: 'client_care_plan_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Care_Plan_Max_Fields>;
  min?: Maybe<Client_Care_Plan_Min_Fields>;
};


/** aggregate fields of "client_care_plan" */
export type Client_Care_Plan_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "client_care_plan" */
export type Client_Care_Plan_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Client_Care_Plan_Max_Order_By>;
  min?: Maybe<Client_Care_Plan_Min_Order_By>;
};

/** input type for inserting array relation for remote table "client_care_plan" */
export type Client_Care_Plan_Arr_Rel_Insert_Input = {
  data: Array<Client_Care_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Client_Care_Plan_On_Conflict>;
};

/** Boolean expression to filter rows from the table "client_care_plan". All fields are combined with a logical 'AND'. */
export type Client_Care_Plan_Bool_Exp = {
  _and?: Maybe<Array<Client_Care_Plan_Bool_Exp>>;
  _not?: Maybe<Client_Care_Plan_Bool_Exp>;
  _or?: Maybe<Array<Client_Care_Plan_Bool_Exp>>;
  address?: Maybe<String_Comparison_Exp>;
  allergy_environmental?: Maybe<String_Comparison_Exp>;
  allergy_food?: Maybe<String_Comparison_Exp>;
  allergy_medication?: Maybe<String_Comparison_Exp>;
  ambulance_pain_monitoring?: Maybe<String_Comparison_Exp>;
  ambulance_support_type?: Maybe<String_Comparison_Exp>;
  bathing_frequency?: Maybe<String_Comparison_Exp>;
  bathing_supervision_level?: Maybe<String_Comparison_Exp>;
  care_plan_created_at?: Maybe<Timestamptz_Comparison_Exp>;
  care_plan_created_by?: Maybe<String_Comparison_Exp>;
  care_plan_end_date?: Maybe<Timestamptz_Comparison_Exp>;
  care_plan_start_date?: Maybe<Timestamptz_Comparison_Exp>;
  care_plan_updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  care_plan_updated_by?: Maybe<String_Comparison_Exp>;
  client_id?: Maybe<String_Comparison_Exp>;
  client_name?: Maybe<String_Comparison_Exp>;
  client_services?: Maybe<String_Array_Comparison_Exp>;
  client_services_gen_notes?: Maybe<String_Comparison_Exp>;
  cognitive_concerns?: Maybe<String_Comparison_Exp>;
  cognitive_general_notes?: Maybe<String_Comparison_Exp>;
  cognitive_notes?: Maybe<String_Comparison_Exp>;
  communication_notes?: Maybe<String_Comparison_Exp>;
  dietary_goals_frequency?: Maybe<String_Comparison_Exp>;
  dietary_goals_special_requirement?: Maybe<String_Comparison_Exp>;
  dnr_copy_attached?: Maybe<String_Comparison_Exp>;
  dnr_order?: Maybe<String_Comparison_Exp>;
  dob?: Maybe<Timestamptz_Comparison_Exp>;
  doc_incident_reports?: Maybe<String_Comparison_Exp>;
  doc_progress_notes?: Maybe<String_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  fall_risk?: Maybe<String_Comparison_Exp>;
  frequency?: Maybe<String_Comparison_Exp>;
  gender?: Maybe<Gender_Enum_Comparison_Exp>;
  genderByGender?: Maybe<Gender_Bool_Exp>;
  home_env_accessibility_issues?: Maybe<String_Comparison_Exp>;
  home_env_notes?: Maybe<String_Comparison_Exp>;
  home_env_pets?: Maybe<String_Comparison_Exp>;
  home_env_safety?: Maybe<String_Comparison_Exp>;
  housekeeping_assistance_level?: Maybe<String_Comparison_Exp>;
  housekeeping_daily_task?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  infectious_diseases?: Maybe<String_Comparison_Exp>;
  medication_goals_supervision?: Maybe<String_Comparison_Exp>;
  medication_goals_timing?: Maybe<String_Comparison_Exp>;
  mobility_level?: Maybe<String_Comparison_Exp>;
  mobility_notes?: Maybe<String_Comparison_Exp>;
  nutrition_goals_description?: Maybe<String_Comparison_Exp>;
  nutrition_goals_diagnosis?: Maybe<String_Comparison_Exp>;
  nutrition_goals_type?: Maybe<String_Comparison_Exp>;
  personal_cultural_practice?: Maybe<String_Comparison_Exp>;
  personal_goals_hygiene?: Maybe<String_Comparison_Exp>;
  personal_goals_self_care?: Maybe<String_Comparison_Exp>;
  personal_hobbies?: Maybe<String_Comparison_Exp>;
  personal_notes?: Maybe<String_Comparison_Exp>;
  personal_social?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<String_Comparison_Exp>;
  precautions_description?: Maybe<String_Comparison_Exp>;
  precautions_general_notes?: Maybe<String_Comparison_Exp>;
  precautions_related_notes?: Maybe<String_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  review_changes_notes?: Maybe<String_Comparison_Exp>;
  review_general_notes?: Maybe<String_Comparison_Exp>;
  review_new_goals?: Maybe<String_Comparison_Exp>;
  skin_goals_notes?: Maybe<String_Comparison_Exp>;
  skin_goals_reporting?: Maybe<String_Comparison_Exp>;
  skin_goals_wound?: Maybe<String_Comparison_Exp>;
  substance_use_considerations?: Maybe<String_Comparison_Exp>;
  toileting_frequency?: Maybe<String_Comparison_Exp>;
  toileting_hygiene?: Maybe<String_Comparison_Exp>;
  toileting_notes?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_care_plan" */
export enum Client_Care_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientCarePlanPkey = 'client_care_plan_pkey',
  /** unique or primary key constraint on columns "project_id" */
  ClientCarePlanProjectIdKey = 'client_care_plan_project_id_key'
}

/** input type for inserting data into table "client_care_plan" */
export type Client_Care_Plan_Insert_Input = {
  address?: Maybe<Scalars['String']>;
  allergy_environmental?: Maybe<Scalars['String']>;
  allergy_food?: Maybe<Scalars['String']>;
  allergy_medication?: Maybe<Scalars['String']>;
  ambulance_pain_monitoring?: Maybe<Scalars['String']>;
  ambulance_support_type?: Maybe<Scalars['String']>;
  bathing_frequency?: Maybe<Scalars['String']>;
  bathing_supervision_level?: Maybe<Scalars['String']>;
  care_plan_created_at?: Maybe<Scalars['timestamptz']>;
  care_plan_created_by?: Maybe<Scalars['String']>;
  care_plan_end_date?: Maybe<Scalars['timestamptz']>;
  care_plan_start_date?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_at?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_services?: Maybe<Array<Scalars['String']>>;
  client_services_gen_notes?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_general_notes?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  communication_notes?: Maybe<Scalars['String']>;
  dietary_goals_frequency?: Maybe<Scalars['String']>;
  dietary_goals_special_requirement?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  doc_incident_reports?: Maybe<Scalars['String']>;
  doc_progress_notes?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fall_risk?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender_Enum>;
  genderByGender?: Maybe<Gender_Obj_Rel_Insert_Input>;
  home_env_accessibility_issues?: Maybe<Scalars['String']>;
  home_env_notes?: Maybe<Scalars['String']>;
  home_env_pets?: Maybe<Scalars['String']>;
  home_env_safety?: Maybe<Scalars['String']>;
  housekeeping_assistance_level?: Maybe<Scalars['String']>;
  housekeeping_daily_task?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  infectious_diseases?: Maybe<Scalars['String']>;
  medication_goals_supervision?: Maybe<Scalars['String']>;
  medication_goals_timing?: Maybe<Scalars['String']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  nutrition_goals_description?: Maybe<Scalars['String']>;
  nutrition_goals_diagnosis?: Maybe<Scalars['String']>;
  nutrition_goals_type?: Maybe<Scalars['String']>;
  personal_cultural_practice?: Maybe<Scalars['String']>;
  personal_goals_hygiene?: Maybe<Scalars['String']>;
  personal_goals_self_care?: Maybe<Scalars['String']>;
  personal_hobbies?: Maybe<Scalars['String']>;
  personal_notes?: Maybe<Scalars['String']>;
  personal_social?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  precautions_description?: Maybe<Scalars['String']>;
  precautions_general_notes?: Maybe<Scalars['String']>;
  precautions_related_notes?: Maybe<Scalars['String']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  review_changes_notes?: Maybe<Scalars['String']>;
  review_general_notes?: Maybe<Scalars['String']>;
  review_new_goals?: Maybe<Scalars['String']>;
  skin_goals_notes?: Maybe<Scalars['String']>;
  skin_goals_reporting?: Maybe<Scalars['String']>;
  skin_goals_wound?: Maybe<Scalars['String']>;
  substance_use_considerations?: Maybe<Scalars['String']>;
  toileting_frequency?: Maybe<Scalars['String']>;
  toileting_hygiene?: Maybe<Scalars['String']>;
  toileting_notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Client_Care_Plan_Max_Fields = {
  __typename?: 'client_care_plan_max_fields';
  address?: Maybe<Scalars['String']>;
  allergy_environmental?: Maybe<Scalars['String']>;
  allergy_food?: Maybe<Scalars['String']>;
  allergy_medication?: Maybe<Scalars['String']>;
  ambulance_pain_monitoring?: Maybe<Scalars['String']>;
  ambulance_support_type?: Maybe<Scalars['String']>;
  bathing_frequency?: Maybe<Scalars['String']>;
  bathing_supervision_level?: Maybe<Scalars['String']>;
  care_plan_created_at?: Maybe<Scalars['timestamptz']>;
  care_plan_created_by?: Maybe<Scalars['String']>;
  care_plan_end_date?: Maybe<Scalars['timestamptz']>;
  care_plan_start_date?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_at?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_services?: Maybe<Array<Scalars['String']>>;
  client_services_gen_notes?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_general_notes?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  communication_notes?: Maybe<Scalars['String']>;
  dietary_goals_frequency?: Maybe<Scalars['String']>;
  dietary_goals_special_requirement?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  doc_incident_reports?: Maybe<Scalars['String']>;
  doc_progress_notes?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fall_risk?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  home_env_accessibility_issues?: Maybe<Scalars['String']>;
  home_env_notes?: Maybe<Scalars['String']>;
  home_env_pets?: Maybe<Scalars['String']>;
  home_env_safety?: Maybe<Scalars['String']>;
  housekeeping_assistance_level?: Maybe<Scalars['String']>;
  housekeeping_daily_task?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  infectious_diseases?: Maybe<Scalars['String']>;
  medication_goals_supervision?: Maybe<Scalars['String']>;
  medication_goals_timing?: Maybe<Scalars['String']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  nutrition_goals_description?: Maybe<Scalars['String']>;
  nutrition_goals_diagnosis?: Maybe<Scalars['String']>;
  nutrition_goals_type?: Maybe<Scalars['String']>;
  personal_cultural_practice?: Maybe<Scalars['String']>;
  personal_goals_hygiene?: Maybe<Scalars['String']>;
  personal_goals_self_care?: Maybe<Scalars['String']>;
  personal_hobbies?: Maybe<Scalars['String']>;
  personal_notes?: Maybe<Scalars['String']>;
  personal_social?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  precautions_description?: Maybe<Scalars['String']>;
  precautions_general_notes?: Maybe<Scalars['String']>;
  precautions_related_notes?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  review_changes_notes?: Maybe<Scalars['String']>;
  review_general_notes?: Maybe<Scalars['String']>;
  review_new_goals?: Maybe<Scalars['String']>;
  skin_goals_notes?: Maybe<Scalars['String']>;
  skin_goals_reporting?: Maybe<Scalars['String']>;
  skin_goals_wound?: Maybe<Scalars['String']>;
  substance_use_considerations?: Maybe<Scalars['String']>;
  toileting_frequency?: Maybe<Scalars['String']>;
  toileting_hygiene?: Maybe<Scalars['String']>;
  toileting_notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "client_care_plan" */
export type Client_Care_Plan_Max_Order_By = {
  address?: Maybe<Order_By>;
  allergy_environmental?: Maybe<Order_By>;
  allergy_food?: Maybe<Order_By>;
  allergy_medication?: Maybe<Order_By>;
  ambulance_pain_monitoring?: Maybe<Order_By>;
  ambulance_support_type?: Maybe<Order_By>;
  bathing_frequency?: Maybe<Order_By>;
  bathing_supervision_level?: Maybe<Order_By>;
  care_plan_created_at?: Maybe<Order_By>;
  care_plan_created_by?: Maybe<Order_By>;
  care_plan_end_date?: Maybe<Order_By>;
  care_plan_start_date?: Maybe<Order_By>;
  care_plan_updated_at?: Maybe<Order_By>;
  care_plan_updated_by?: Maybe<Order_By>;
  client_id?: Maybe<Order_By>;
  client_name?: Maybe<Order_By>;
  client_services?: Maybe<Order_By>;
  client_services_gen_notes?: Maybe<Order_By>;
  cognitive_concerns?: Maybe<Order_By>;
  cognitive_general_notes?: Maybe<Order_By>;
  cognitive_notes?: Maybe<Order_By>;
  communication_notes?: Maybe<Order_By>;
  dietary_goals_frequency?: Maybe<Order_By>;
  dietary_goals_special_requirement?: Maybe<Order_By>;
  dnr_copy_attached?: Maybe<Order_By>;
  dnr_order?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  doc_incident_reports?: Maybe<Order_By>;
  doc_progress_notes?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  fall_risk?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  home_env_accessibility_issues?: Maybe<Order_By>;
  home_env_notes?: Maybe<Order_By>;
  home_env_pets?: Maybe<Order_By>;
  home_env_safety?: Maybe<Order_By>;
  housekeeping_assistance_level?: Maybe<Order_By>;
  housekeeping_daily_task?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  infectious_diseases?: Maybe<Order_By>;
  medication_goals_supervision?: Maybe<Order_By>;
  medication_goals_timing?: Maybe<Order_By>;
  mobility_level?: Maybe<Order_By>;
  mobility_notes?: Maybe<Order_By>;
  nutrition_goals_description?: Maybe<Order_By>;
  nutrition_goals_diagnosis?: Maybe<Order_By>;
  nutrition_goals_type?: Maybe<Order_By>;
  personal_cultural_practice?: Maybe<Order_By>;
  personal_goals_hygiene?: Maybe<Order_By>;
  personal_goals_self_care?: Maybe<Order_By>;
  personal_hobbies?: Maybe<Order_By>;
  personal_notes?: Maybe<Order_By>;
  personal_social?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  precautions_description?: Maybe<Order_By>;
  precautions_general_notes?: Maybe<Order_By>;
  precautions_related_notes?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  review_changes_notes?: Maybe<Order_By>;
  review_general_notes?: Maybe<Order_By>;
  review_new_goals?: Maybe<Order_By>;
  skin_goals_notes?: Maybe<Order_By>;
  skin_goals_reporting?: Maybe<Order_By>;
  skin_goals_wound?: Maybe<Order_By>;
  substance_use_considerations?: Maybe<Order_By>;
  toileting_frequency?: Maybe<Order_By>;
  toileting_hygiene?: Maybe<Order_By>;
  toileting_notes?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Care_Plan_Min_Fields = {
  __typename?: 'client_care_plan_min_fields';
  address?: Maybe<Scalars['String']>;
  allergy_environmental?: Maybe<Scalars['String']>;
  allergy_food?: Maybe<Scalars['String']>;
  allergy_medication?: Maybe<Scalars['String']>;
  ambulance_pain_monitoring?: Maybe<Scalars['String']>;
  ambulance_support_type?: Maybe<Scalars['String']>;
  bathing_frequency?: Maybe<Scalars['String']>;
  bathing_supervision_level?: Maybe<Scalars['String']>;
  care_plan_created_at?: Maybe<Scalars['timestamptz']>;
  care_plan_created_by?: Maybe<Scalars['String']>;
  care_plan_end_date?: Maybe<Scalars['timestamptz']>;
  care_plan_start_date?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_at?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_services?: Maybe<Array<Scalars['String']>>;
  client_services_gen_notes?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_general_notes?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  communication_notes?: Maybe<Scalars['String']>;
  dietary_goals_frequency?: Maybe<Scalars['String']>;
  dietary_goals_special_requirement?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  doc_incident_reports?: Maybe<Scalars['String']>;
  doc_progress_notes?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fall_risk?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  home_env_accessibility_issues?: Maybe<Scalars['String']>;
  home_env_notes?: Maybe<Scalars['String']>;
  home_env_pets?: Maybe<Scalars['String']>;
  home_env_safety?: Maybe<Scalars['String']>;
  housekeeping_assistance_level?: Maybe<Scalars['String']>;
  housekeeping_daily_task?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  infectious_diseases?: Maybe<Scalars['String']>;
  medication_goals_supervision?: Maybe<Scalars['String']>;
  medication_goals_timing?: Maybe<Scalars['String']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  nutrition_goals_description?: Maybe<Scalars['String']>;
  nutrition_goals_diagnosis?: Maybe<Scalars['String']>;
  nutrition_goals_type?: Maybe<Scalars['String']>;
  personal_cultural_practice?: Maybe<Scalars['String']>;
  personal_goals_hygiene?: Maybe<Scalars['String']>;
  personal_goals_self_care?: Maybe<Scalars['String']>;
  personal_hobbies?: Maybe<Scalars['String']>;
  personal_notes?: Maybe<Scalars['String']>;
  personal_social?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  precautions_description?: Maybe<Scalars['String']>;
  precautions_general_notes?: Maybe<Scalars['String']>;
  precautions_related_notes?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  review_changes_notes?: Maybe<Scalars['String']>;
  review_general_notes?: Maybe<Scalars['String']>;
  review_new_goals?: Maybe<Scalars['String']>;
  skin_goals_notes?: Maybe<Scalars['String']>;
  skin_goals_reporting?: Maybe<Scalars['String']>;
  skin_goals_wound?: Maybe<Scalars['String']>;
  substance_use_considerations?: Maybe<Scalars['String']>;
  toileting_frequency?: Maybe<Scalars['String']>;
  toileting_hygiene?: Maybe<Scalars['String']>;
  toileting_notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "client_care_plan" */
export type Client_Care_Plan_Min_Order_By = {
  address?: Maybe<Order_By>;
  allergy_environmental?: Maybe<Order_By>;
  allergy_food?: Maybe<Order_By>;
  allergy_medication?: Maybe<Order_By>;
  ambulance_pain_monitoring?: Maybe<Order_By>;
  ambulance_support_type?: Maybe<Order_By>;
  bathing_frequency?: Maybe<Order_By>;
  bathing_supervision_level?: Maybe<Order_By>;
  care_plan_created_at?: Maybe<Order_By>;
  care_plan_created_by?: Maybe<Order_By>;
  care_plan_end_date?: Maybe<Order_By>;
  care_plan_start_date?: Maybe<Order_By>;
  care_plan_updated_at?: Maybe<Order_By>;
  care_plan_updated_by?: Maybe<Order_By>;
  client_id?: Maybe<Order_By>;
  client_name?: Maybe<Order_By>;
  client_services?: Maybe<Order_By>;
  client_services_gen_notes?: Maybe<Order_By>;
  cognitive_concerns?: Maybe<Order_By>;
  cognitive_general_notes?: Maybe<Order_By>;
  cognitive_notes?: Maybe<Order_By>;
  communication_notes?: Maybe<Order_By>;
  dietary_goals_frequency?: Maybe<Order_By>;
  dietary_goals_special_requirement?: Maybe<Order_By>;
  dnr_copy_attached?: Maybe<Order_By>;
  dnr_order?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  doc_incident_reports?: Maybe<Order_By>;
  doc_progress_notes?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  fall_risk?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  home_env_accessibility_issues?: Maybe<Order_By>;
  home_env_notes?: Maybe<Order_By>;
  home_env_pets?: Maybe<Order_By>;
  home_env_safety?: Maybe<Order_By>;
  housekeeping_assistance_level?: Maybe<Order_By>;
  housekeeping_daily_task?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  infectious_diseases?: Maybe<Order_By>;
  medication_goals_supervision?: Maybe<Order_By>;
  medication_goals_timing?: Maybe<Order_By>;
  mobility_level?: Maybe<Order_By>;
  mobility_notes?: Maybe<Order_By>;
  nutrition_goals_description?: Maybe<Order_By>;
  nutrition_goals_diagnosis?: Maybe<Order_By>;
  nutrition_goals_type?: Maybe<Order_By>;
  personal_cultural_practice?: Maybe<Order_By>;
  personal_goals_hygiene?: Maybe<Order_By>;
  personal_goals_self_care?: Maybe<Order_By>;
  personal_hobbies?: Maybe<Order_By>;
  personal_notes?: Maybe<Order_By>;
  personal_social?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  precautions_description?: Maybe<Order_By>;
  precautions_general_notes?: Maybe<Order_By>;
  precautions_related_notes?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  review_changes_notes?: Maybe<Order_By>;
  review_general_notes?: Maybe<Order_By>;
  review_new_goals?: Maybe<Order_By>;
  skin_goals_notes?: Maybe<Order_By>;
  skin_goals_reporting?: Maybe<Order_By>;
  skin_goals_wound?: Maybe<Order_By>;
  substance_use_considerations?: Maybe<Order_By>;
  toileting_frequency?: Maybe<Order_By>;
  toileting_hygiene?: Maybe<Order_By>;
  toileting_notes?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "client_care_plan" */
export type Client_Care_Plan_Mutation_Response = {
  __typename?: 'client_care_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Care_Plan>;
};

/** input type for inserting object relation for remote table "client_care_plan" */
export type Client_Care_Plan_Obj_Rel_Insert_Input = {
  data: Client_Care_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Client_Care_Plan_On_Conflict>;
};

/** on_conflict condition type for table "client_care_plan" */
export type Client_Care_Plan_On_Conflict = {
  constraint: Client_Care_Plan_Constraint;
  update_columns?: Array<Client_Care_Plan_Update_Column>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "client_care_plan". */
export type Client_Care_Plan_Order_By = {
  address?: Maybe<Order_By>;
  allergy_environmental?: Maybe<Order_By>;
  allergy_food?: Maybe<Order_By>;
  allergy_medication?: Maybe<Order_By>;
  ambulance_pain_monitoring?: Maybe<Order_By>;
  ambulance_support_type?: Maybe<Order_By>;
  bathing_frequency?: Maybe<Order_By>;
  bathing_supervision_level?: Maybe<Order_By>;
  care_plan_created_at?: Maybe<Order_By>;
  care_plan_created_by?: Maybe<Order_By>;
  care_plan_end_date?: Maybe<Order_By>;
  care_plan_start_date?: Maybe<Order_By>;
  care_plan_updated_at?: Maybe<Order_By>;
  care_plan_updated_by?: Maybe<Order_By>;
  client_id?: Maybe<Order_By>;
  client_name?: Maybe<Order_By>;
  client_services?: Maybe<Order_By>;
  client_services_gen_notes?: Maybe<Order_By>;
  cognitive_concerns?: Maybe<Order_By>;
  cognitive_general_notes?: Maybe<Order_By>;
  cognitive_notes?: Maybe<Order_By>;
  communication_notes?: Maybe<Order_By>;
  dietary_goals_frequency?: Maybe<Order_By>;
  dietary_goals_special_requirement?: Maybe<Order_By>;
  dnr_copy_attached?: Maybe<Order_By>;
  dnr_order?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  doc_incident_reports?: Maybe<Order_By>;
  doc_progress_notes?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  fall_risk?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  genderByGender?: Maybe<Gender_Order_By>;
  home_env_accessibility_issues?: Maybe<Order_By>;
  home_env_notes?: Maybe<Order_By>;
  home_env_pets?: Maybe<Order_By>;
  home_env_safety?: Maybe<Order_By>;
  housekeeping_assistance_level?: Maybe<Order_By>;
  housekeeping_daily_task?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  infectious_diseases?: Maybe<Order_By>;
  medication_goals_supervision?: Maybe<Order_By>;
  medication_goals_timing?: Maybe<Order_By>;
  mobility_level?: Maybe<Order_By>;
  mobility_notes?: Maybe<Order_By>;
  nutrition_goals_description?: Maybe<Order_By>;
  nutrition_goals_diagnosis?: Maybe<Order_By>;
  nutrition_goals_type?: Maybe<Order_By>;
  personal_cultural_practice?: Maybe<Order_By>;
  personal_goals_hygiene?: Maybe<Order_By>;
  personal_goals_self_care?: Maybe<Order_By>;
  personal_hobbies?: Maybe<Order_By>;
  personal_notes?: Maybe<Order_By>;
  personal_social?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  precautions_description?: Maybe<Order_By>;
  precautions_general_notes?: Maybe<Order_By>;
  precautions_related_notes?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
  review_changes_notes?: Maybe<Order_By>;
  review_general_notes?: Maybe<Order_By>;
  review_new_goals?: Maybe<Order_By>;
  skin_goals_notes?: Maybe<Order_By>;
  skin_goals_reporting?: Maybe<Order_By>;
  skin_goals_wound?: Maybe<Order_By>;
  substance_use_considerations?: Maybe<Order_By>;
  toileting_frequency?: Maybe<Order_By>;
  toileting_hygiene?: Maybe<Order_By>;
  toileting_notes?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: client_care_plan */
export type Client_Care_Plan_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "client_care_plan" */
export enum Client_Care_Plan_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AllergyEnvironmental = 'allergy_environmental',
  /** column name */
  AllergyFood = 'allergy_food',
  /** column name */
  AllergyMedication = 'allergy_medication',
  /** column name */
  AmbulancePainMonitoring = 'ambulance_pain_monitoring',
  /** column name */
  AmbulanceSupportType = 'ambulance_support_type',
  /** column name */
  BathingFrequency = 'bathing_frequency',
  /** column name */
  BathingSupervisionLevel = 'bathing_supervision_level',
  /** column name */
  CarePlanCreatedAt = 'care_plan_created_at',
  /** column name */
  CarePlanCreatedBy = 'care_plan_created_by',
  /** column name */
  CarePlanEndDate = 'care_plan_end_date',
  /** column name */
  CarePlanStartDate = 'care_plan_start_date',
  /** column name */
  CarePlanUpdatedAt = 'care_plan_updated_at',
  /** column name */
  CarePlanUpdatedBy = 'care_plan_updated_by',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientName = 'client_name',
  /** column name */
  ClientServices = 'client_services',
  /** column name */
  ClientServicesGenNotes = 'client_services_gen_notes',
  /** column name */
  CognitiveConcerns = 'cognitive_concerns',
  /** column name */
  CognitiveGeneralNotes = 'cognitive_general_notes',
  /** column name */
  CognitiveNotes = 'cognitive_notes',
  /** column name */
  CommunicationNotes = 'communication_notes',
  /** column name */
  DietaryGoalsFrequency = 'dietary_goals_frequency',
  /** column name */
  DietaryGoalsSpecialRequirement = 'dietary_goals_special_requirement',
  /** column name */
  DnrCopyAttached = 'dnr_copy_attached',
  /** column name */
  DnrOrder = 'dnr_order',
  /** column name */
  Dob = 'dob',
  /** column name */
  DocIncidentReports = 'doc_incident_reports',
  /** column name */
  DocProgressNotes = 'doc_progress_notes',
  /** column name */
  Email = 'email',
  /** column name */
  FallRisk = 'fall_risk',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Gender = 'gender',
  /** column name */
  HomeEnvAccessibilityIssues = 'home_env_accessibility_issues',
  /** column name */
  HomeEnvNotes = 'home_env_notes',
  /** column name */
  HomeEnvPets = 'home_env_pets',
  /** column name */
  HomeEnvSafety = 'home_env_safety',
  /** column name */
  HousekeepingAssistanceLevel = 'housekeeping_assistance_level',
  /** column name */
  HousekeepingDailyTask = 'housekeeping_daily_task',
  /** column name */
  Id = 'id',
  /** column name */
  InfectiousDiseases = 'infectious_diseases',
  /** column name */
  MedicationGoalsSupervision = 'medication_goals_supervision',
  /** column name */
  MedicationGoalsTiming = 'medication_goals_timing',
  /** column name */
  MobilityLevel = 'mobility_level',
  /** column name */
  MobilityNotes = 'mobility_notes',
  /** column name */
  NutritionGoalsDescription = 'nutrition_goals_description',
  /** column name */
  NutritionGoalsDiagnosis = 'nutrition_goals_diagnosis',
  /** column name */
  NutritionGoalsType = 'nutrition_goals_type',
  /** column name */
  PersonalCulturalPractice = 'personal_cultural_practice',
  /** column name */
  PersonalGoalsHygiene = 'personal_goals_hygiene',
  /** column name */
  PersonalGoalsSelfCare = 'personal_goals_self_care',
  /** column name */
  PersonalHobbies = 'personal_hobbies',
  /** column name */
  PersonalNotes = 'personal_notes',
  /** column name */
  PersonalSocial = 'personal_social',
  /** column name */
  Phone = 'phone',
  /** column name */
  PrecautionsDescription = 'precautions_description',
  /** column name */
  PrecautionsGeneralNotes = 'precautions_general_notes',
  /** column name */
  PrecautionsRelatedNotes = 'precautions_related_notes',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ReviewChangesNotes = 'review_changes_notes',
  /** column name */
  ReviewGeneralNotes = 'review_general_notes',
  /** column name */
  ReviewNewGoals = 'review_new_goals',
  /** column name */
  SkinGoalsNotes = 'skin_goals_notes',
  /** column name */
  SkinGoalsReporting = 'skin_goals_reporting',
  /** column name */
  SkinGoalsWound = 'skin_goals_wound',
  /** column name */
  SubstanceUseConsiderations = 'substance_use_considerations',
  /** column name */
  ToiletingFrequency = 'toileting_frequency',
  /** column name */
  ToiletingHygiene = 'toileting_hygiene',
  /** column name */
  ToiletingNotes = 'toileting_notes',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "client_care_plan" */
export type Client_Care_Plan_Set_Input = {
  address?: Maybe<Scalars['String']>;
  allergy_environmental?: Maybe<Scalars['String']>;
  allergy_food?: Maybe<Scalars['String']>;
  allergy_medication?: Maybe<Scalars['String']>;
  ambulance_pain_monitoring?: Maybe<Scalars['String']>;
  ambulance_support_type?: Maybe<Scalars['String']>;
  bathing_frequency?: Maybe<Scalars['String']>;
  bathing_supervision_level?: Maybe<Scalars['String']>;
  care_plan_created_at?: Maybe<Scalars['timestamptz']>;
  care_plan_created_by?: Maybe<Scalars['String']>;
  care_plan_end_date?: Maybe<Scalars['timestamptz']>;
  care_plan_start_date?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_at?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_services?: Maybe<Array<Scalars['String']>>;
  client_services_gen_notes?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_general_notes?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  communication_notes?: Maybe<Scalars['String']>;
  dietary_goals_frequency?: Maybe<Scalars['String']>;
  dietary_goals_special_requirement?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  doc_incident_reports?: Maybe<Scalars['String']>;
  doc_progress_notes?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fall_risk?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender_Enum>;
  home_env_accessibility_issues?: Maybe<Scalars['String']>;
  home_env_notes?: Maybe<Scalars['String']>;
  home_env_pets?: Maybe<Scalars['String']>;
  home_env_safety?: Maybe<Scalars['String']>;
  housekeeping_assistance_level?: Maybe<Scalars['String']>;
  housekeeping_daily_task?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  infectious_diseases?: Maybe<Scalars['String']>;
  medication_goals_supervision?: Maybe<Scalars['String']>;
  medication_goals_timing?: Maybe<Scalars['String']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  nutrition_goals_description?: Maybe<Scalars['String']>;
  nutrition_goals_diagnosis?: Maybe<Scalars['String']>;
  nutrition_goals_type?: Maybe<Scalars['String']>;
  personal_cultural_practice?: Maybe<Scalars['String']>;
  personal_goals_hygiene?: Maybe<Scalars['String']>;
  personal_goals_self_care?: Maybe<Scalars['String']>;
  personal_hobbies?: Maybe<Scalars['String']>;
  personal_notes?: Maybe<Scalars['String']>;
  personal_social?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  precautions_description?: Maybe<Scalars['String']>;
  precautions_general_notes?: Maybe<Scalars['String']>;
  precautions_related_notes?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  review_changes_notes?: Maybe<Scalars['String']>;
  review_general_notes?: Maybe<Scalars['String']>;
  review_new_goals?: Maybe<Scalars['String']>;
  skin_goals_notes?: Maybe<Scalars['String']>;
  skin_goals_reporting?: Maybe<Scalars['String']>;
  skin_goals_wound?: Maybe<Scalars['String']>;
  substance_use_considerations?: Maybe<Scalars['String']>;
  toileting_frequency?: Maybe<Scalars['String']>;
  toileting_hygiene?: Maybe<Scalars['String']>;
  toileting_notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "client_care_plan" */
export type Client_Care_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Care_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Care_Plan_Stream_Cursor_Value_Input = {
  address?: Maybe<Scalars['String']>;
  allergy_environmental?: Maybe<Scalars['String']>;
  allergy_food?: Maybe<Scalars['String']>;
  allergy_medication?: Maybe<Scalars['String']>;
  ambulance_pain_monitoring?: Maybe<Scalars['String']>;
  ambulance_support_type?: Maybe<Scalars['String']>;
  bathing_frequency?: Maybe<Scalars['String']>;
  bathing_supervision_level?: Maybe<Scalars['String']>;
  care_plan_created_at?: Maybe<Scalars['timestamptz']>;
  care_plan_created_by?: Maybe<Scalars['String']>;
  care_plan_end_date?: Maybe<Scalars['timestamptz']>;
  care_plan_start_date?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_at?: Maybe<Scalars['timestamptz']>;
  care_plan_updated_by?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  client_services?: Maybe<Array<Scalars['String']>>;
  client_services_gen_notes?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_general_notes?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  communication_notes?: Maybe<Scalars['String']>;
  dietary_goals_frequency?: Maybe<Scalars['String']>;
  dietary_goals_special_requirement?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  doc_incident_reports?: Maybe<Scalars['String']>;
  doc_progress_notes?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fall_risk?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender_Enum>;
  home_env_accessibility_issues?: Maybe<Scalars['String']>;
  home_env_notes?: Maybe<Scalars['String']>;
  home_env_pets?: Maybe<Scalars['String']>;
  home_env_safety?: Maybe<Scalars['String']>;
  housekeeping_assistance_level?: Maybe<Scalars['String']>;
  housekeeping_daily_task?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  infectious_diseases?: Maybe<Scalars['String']>;
  medication_goals_supervision?: Maybe<Scalars['String']>;
  medication_goals_timing?: Maybe<Scalars['String']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  nutrition_goals_description?: Maybe<Scalars['String']>;
  nutrition_goals_diagnosis?: Maybe<Scalars['String']>;
  nutrition_goals_type?: Maybe<Scalars['String']>;
  personal_cultural_practice?: Maybe<Scalars['String']>;
  personal_goals_hygiene?: Maybe<Scalars['String']>;
  personal_goals_self_care?: Maybe<Scalars['String']>;
  personal_hobbies?: Maybe<Scalars['String']>;
  personal_notes?: Maybe<Scalars['String']>;
  personal_social?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  precautions_description?: Maybe<Scalars['String']>;
  precautions_general_notes?: Maybe<Scalars['String']>;
  precautions_related_notes?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  review_changes_notes?: Maybe<Scalars['String']>;
  review_general_notes?: Maybe<Scalars['String']>;
  review_new_goals?: Maybe<Scalars['String']>;
  skin_goals_notes?: Maybe<Scalars['String']>;
  skin_goals_reporting?: Maybe<Scalars['String']>;
  skin_goals_wound?: Maybe<Scalars['String']>;
  substance_use_considerations?: Maybe<Scalars['String']>;
  toileting_frequency?: Maybe<Scalars['String']>;
  toileting_hygiene?: Maybe<Scalars['String']>;
  toileting_notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** update columns of table "client_care_plan" */
export enum Client_Care_Plan_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AllergyEnvironmental = 'allergy_environmental',
  /** column name */
  AllergyFood = 'allergy_food',
  /** column name */
  AllergyMedication = 'allergy_medication',
  /** column name */
  AmbulancePainMonitoring = 'ambulance_pain_monitoring',
  /** column name */
  AmbulanceSupportType = 'ambulance_support_type',
  /** column name */
  BathingFrequency = 'bathing_frequency',
  /** column name */
  BathingSupervisionLevel = 'bathing_supervision_level',
  /** column name */
  CarePlanCreatedAt = 'care_plan_created_at',
  /** column name */
  CarePlanCreatedBy = 'care_plan_created_by',
  /** column name */
  CarePlanEndDate = 'care_plan_end_date',
  /** column name */
  CarePlanStartDate = 'care_plan_start_date',
  /** column name */
  CarePlanUpdatedAt = 'care_plan_updated_at',
  /** column name */
  CarePlanUpdatedBy = 'care_plan_updated_by',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientName = 'client_name',
  /** column name */
  ClientServices = 'client_services',
  /** column name */
  ClientServicesGenNotes = 'client_services_gen_notes',
  /** column name */
  CognitiveConcerns = 'cognitive_concerns',
  /** column name */
  CognitiveGeneralNotes = 'cognitive_general_notes',
  /** column name */
  CognitiveNotes = 'cognitive_notes',
  /** column name */
  CommunicationNotes = 'communication_notes',
  /** column name */
  DietaryGoalsFrequency = 'dietary_goals_frequency',
  /** column name */
  DietaryGoalsSpecialRequirement = 'dietary_goals_special_requirement',
  /** column name */
  DnrCopyAttached = 'dnr_copy_attached',
  /** column name */
  DnrOrder = 'dnr_order',
  /** column name */
  Dob = 'dob',
  /** column name */
  DocIncidentReports = 'doc_incident_reports',
  /** column name */
  DocProgressNotes = 'doc_progress_notes',
  /** column name */
  Email = 'email',
  /** column name */
  FallRisk = 'fall_risk',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Gender = 'gender',
  /** column name */
  HomeEnvAccessibilityIssues = 'home_env_accessibility_issues',
  /** column name */
  HomeEnvNotes = 'home_env_notes',
  /** column name */
  HomeEnvPets = 'home_env_pets',
  /** column name */
  HomeEnvSafety = 'home_env_safety',
  /** column name */
  HousekeepingAssistanceLevel = 'housekeeping_assistance_level',
  /** column name */
  HousekeepingDailyTask = 'housekeeping_daily_task',
  /** column name */
  Id = 'id',
  /** column name */
  InfectiousDiseases = 'infectious_diseases',
  /** column name */
  MedicationGoalsSupervision = 'medication_goals_supervision',
  /** column name */
  MedicationGoalsTiming = 'medication_goals_timing',
  /** column name */
  MobilityLevel = 'mobility_level',
  /** column name */
  MobilityNotes = 'mobility_notes',
  /** column name */
  NutritionGoalsDescription = 'nutrition_goals_description',
  /** column name */
  NutritionGoalsDiagnosis = 'nutrition_goals_diagnosis',
  /** column name */
  NutritionGoalsType = 'nutrition_goals_type',
  /** column name */
  PersonalCulturalPractice = 'personal_cultural_practice',
  /** column name */
  PersonalGoalsHygiene = 'personal_goals_hygiene',
  /** column name */
  PersonalGoalsSelfCare = 'personal_goals_self_care',
  /** column name */
  PersonalHobbies = 'personal_hobbies',
  /** column name */
  PersonalNotes = 'personal_notes',
  /** column name */
  PersonalSocial = 'personal_social',
  /** column name */
  Phone = 'phone',
  /** column name */
  PrecautionsDescription = 'precautions_description',
  /** column name */
  PrecautionsGeneralNotes = 'precautions_general_notes',
  /** column name */
  PrecautionsRelatedNotes = 'precautions_related_notes',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ReviewChangesNotes = 'review_changes_notes',
  /** column name */
  ReviewGeneralNotes = 'review_general_notes',
  /** column name */
  ReviewNewGoals = 'review_new_goals',
  /** column name */
  SkinGoalsNotes = 'skin_goals_notes',
  /** column name */
  SkinGoalsReporting = 'skin_goals_reporting',
  /** column name */
  SkinGoalsWound = 'skin_goals_wound',
  /** column name */
  SubstanceUseConsiderations = 'substance_use_considerations',
  /** column name */
  ToiletingFrequency = 'toileting_frequency',
  /** column name */
  ToiletingHygiene = 'toileting_hygiene',
  /** column name */
  ToiletingNotes = 'toileting_notes',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Client_Care_Plan_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Client_Care_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Client_Care_Plan_Bool_Exp;
};

/** columns and relationships of "client_medications" */
export type Client_Medications = {
  __typename?: 'client_medications';
  client_id?: Maybe<Scalars['uuid']>;
  dosage?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Project>;
};

/** aggregated selection of "client_medications" */
export type Client_Medications_Aggregate = {
  __typename?: 'client_medications_aggregate';
  aggregate?: Maybe<Client_Medications_Aggregate_Fields>;
  nodes: Array<Client_Medications>;
};

export type Client_Medications_Aggregate_Bool_Exp = {
  count?: Maybe<Client_Medications_Aggregate_Bool_Exp_Count>;
};

export type Client_Medications_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Client_Medications_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Client_Medications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "client_medications" */
export type Client_Medications_Aggregate_Fields = {
  __typename?: 'client_medications_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Client_Medications_Max_Fields>;
  min?: Maybe<Client_Medications_Min_Fields>;
};


/** aggregate fields of "client_medications" */
export type Client_Medications_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Client_Medications_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "client_medications" */
export type Client_Medications_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Client_Medications_Max_Order_By>;
  min?: Maybe<Client_Medications_Min_Order_By>;
};

/** input type for inserting array relation for remote table "client_medications" */
export type Client_Medications_Arr_Rel_Insert_Input = {
  data: Array<Client_Medications_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Client_Medications_On_Conflict>;
};

/** Boolean expression to filter rows from the table "client_medications". All fields are combined with a logical 'AND'. */
export type Client_Medications_Bool_Exp = {
  _and?: Maybe<Array<Client_Medications_Bool_Exp>>;
  _not?: Maybe<Client_Medications_Bool_Exp>;
  _or?: Maybe<Array<Client_Medications_Bool_Exp>>;
  client_id?: Maybe<Uuid_Comparison_Exp>;
  dosage?: Maybe<String_Comparison_Exp>;
  file?: Maybe<String_Comparison_Exp>;
  frequency?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
};

/** unique or primary key constraints on table "client_medications" */
export enum Client_Medications_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientMedicationsPkey = 'client_medications_pkey'
}

/** input type for inserting data into table "client_medications" */
export type Client_Medications_Insert_Input = {
  client_id?: Maybe<Scalars['uuid']>;
  dosage?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Client_Medications_Max_Fields = {
  __typename?: 'client_medications_max_fields';
  client_id?: Maybe<Scalars['uuid']>;
  dosage?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "client_medications" */
export type Client_Medications_Max_Order_By = {
  client_id?: Maybe<Order_By>;
  dosage?: Maybe<Order_By>;
  file?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Medications_Min_Fields = {
  __typename?: 'client_medications_min_fields';
  client_id?: Maybe<Scalars['uuid']>;
  dosage?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "client_medications" */
export type Client_Medications_Min_Order_By = {
  client_id?: Maybe<Order_By>;
  dosage?: Maybe<Order_By>;
  file?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** response of any mutation on the table "client_medications" */
export type Client_Medications_Mutation_Response = {
  __typename?: 'client_medications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Medications>;
};

/** on_conflict condition type for table "client_medications" */
export type Client_Medications_On_Conflict = {
  constraint: Client_Medications_Constraint;
  update_columns?: Array<Client_Medications_Update_Column>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};

/** Ordering options when selecting data from "client_medications". */
export type Client_Medications_Order_By = {
  client_id?: Maybe<Order_By>;
  dosage?: Maybe<Order_By>;
  file?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
};

/** primary key columns input for table: client_medications */
export type Client_Medications_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "client_medications" */
export enum Client_Medications_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Dosage = 'dosage',
  /** column name */
  File = 'file',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "client_medications" */
export type Client_Medications_Set_Input = {
  client_id?: Maybe<Scalars['uuid']>;
  dosage?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "client_medications" */
export type Client_Medications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Medications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Medications_Stream_Cursor_Value_Input = {
  client_id?: Maybe<Scalars['uuid']>;
  dosage?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "client_medications" */
export enum Client_Medications_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Dosage = 'dosage',
  /** column name */
  File = 'file',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Client_Medications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Client_Medications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Client_Medications_Bool_Exp;
};

/** columns and relationships of "company" */
export type Company = {
  __typename?: 'company';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** An array relationship */
  admins: Array<Admin>;
  /** An aggregate relationship */
  admins_aggregate: Admin_Aggregate;
  allow_managers_view_all_contractors?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  allow_managers_view_all_projects?: Maybe<Scalars['Boolean']>;
  allow_managers_view_all_teams: Scalars['Boolean'];
  business_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  candidates: Array<Candidate>;
  /** An aggregate relationship */
  candidates_aggregate: Candidate_Aggregate;
  city?: Maybe<Scalars['String']>;
  company_logo?: Maybe<Scalars['String']>;
  /** An array relationship */
  contractors: Array<Contractor>;
  /** An aggregate relationship */
  contractors_aggregate: Contractor_Aggregate;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  custom_requests: Array<Custom_Request>;
  /** An aggregate relationship */
  custom_requests_aggregate: Custom_Request_Aggregate;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** An array relationship */
  followers: Array<Company_Follower>;
  /** An aggregate relationship */
  followers_aggregate: Company_Follower_Aggregate;
  id: Scalars['uuid'];
  industry?: Maybe<Scalars['String']>;
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  /** An array relationship */
  managers: Array<Manager>;
  /** An aggregate relationship */
  managers_aggregate: Manager_Aggregate;
  marketplace_access_type: Scalars['company_marketplace_access'];
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  /** An array relationship */
  onboardings: Array<Onboarding>;
  /** An aggregate relationship */
  onboardings_aggregate: Onboarding_Aggregate;
  phone_number?: Maybe<Scalars['numeric']>;
  postal_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  postings: Array<Posting>;
  /** An aggregate relationship */
  postings_aggregate: Posting_Aggregate;
  private: Scalars['Boolean'];
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  /** An array relationship */
  skills: Array<Skill>;
  /** An aggregate relationship */
  skills_aggregate: Skill_Aggregate;
  state?: Maybe<Scalars['String']>;
  /** An array relationship */
  subscriptions: Array<Subscription>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscription_Aggregate;
  /** An array relationship */
  teams: Array<Team>;
  /** An aggregate relationship */
  teams_aggregate: Team_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<User>;
  /** An array relationship */
  user_job_titles: Array<User_Job_Title>;
  /** An aggregate relationship */
  user_job_titles_aggregate: User_Job_Title_Aggregate;
  /** An array relationship */
  users: Array<User_Company>;
  /** An aggregate relationship */
  users_aggregate: User_Company_Aggregate;
  /** An array relationship */
  users_disabled_notifications: Array<Company_User_Notifications>;
  /** An aggregate relationship */
  users_disabled_notifications_aggregate: Company_User_Notifications_Aggregate;
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "company" */
export type CompanyAdminsArgs = {
  distinct_on?: Maybe<Array<Admin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Admin_Order_By>>;
  where?: Maybe<Admin_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyAdmins_AggregateArgs = {
  distinct_on?: Maybe<Array<Admin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Admin_Order_By>>;
  where?: Maybe<Admin_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyCandidatesArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyCandidates_AggregateArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyContractorsArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyContractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyCustom_RequestsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyCustom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyDocumentsArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyFollowersArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyFollowers_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyInvitationsArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyInvitations_AggregateArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyManagersArgs = {
  distinct_on?: Maybe<Array<Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Order_By>>;
  where?: Maybe<Manager_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyManagers_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Order_By>>;
  where?: Maybe<Manager_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyOnboardingsArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyOnboardings_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyPostingsArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyPostings_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyProjectsArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyProjects_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanySkillsArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanySkills_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanySubscriptionsArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanySubscriptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyTeamsArgs = {
  distinct_on?: Maybe<Array<Team_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Order_By>>;
  where?: Maybe<Team_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyTeams_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Order_By>>;
  where?: Maybe<Team_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUser_Job_TitlesArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUser_Job_Titles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUsersArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUsers_Disabled_NotificationsArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


/** columns and relationships of "company" */
export type CompanyUsers_Disabled_Notifications_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};

/** aggregated selection of "company" */
export type Company_Aggregate = {
  __typename?: 'company_aggregate';
  aggregate?: Maybe<Company_Aggregate_Fields>;
  nodes: Array<Company>;
};

export type Company_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Company_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Company_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Company_Aggregate_Bool_Exp_Count>;
};

export type Company_Aggregate_Bool_Exp_Bool_And = {
  arguments: Company_Select_Column_Company_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Company_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Company_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Company_Select_Column_Company_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Company_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Company_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Company_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Company_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "company" */
export type Company_Aggregate_Fields = {
  __typename?: 'company_aggregate_fields';
  avg?: Maybe<Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Max_Fields>;
  min?: Maybe<Company_Min_Fields>;
  stddev?: Maybe<Company_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Sum_Fields>;
  var_pop?: Maybe<Company_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Var_Samp_Fields>;
  variance?: Maybe<Company_Variance_Fields>;
};


/** aggregate fields of "company" */
export type Company_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company" */
export type Company_Aggregate_Order_By = {
  avg?: Maybe<Company_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Company_Max_Order_By>;
  min?: Maybe<Company_Min_Order_By>;
  stddev?: Maybe<Company_Stddev_Order_By>;
  stddev_pop?: Maybe<Company_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Company_Stddev_Samp_Order_By>;
  sum?: Maybe<Company_Sum_Order_By>;
  var_pop?: Maybe<Company_Var_Pop_Order_By>;
  var_samp?: Maybe<Company_Var_Samp_Order_By>;
  variance?: Maybe<Company_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "company" */
export type Company_Arr_Rel_Insert_Input = {
  data: Array<Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Company_On_Conflict>;
};

/** aggregate avg on columns */
export type Company_Avg_Fields = {
  __typename?: 'company_avg_fields';
  max_admin_limit?: Maybe<Scalars['Float']>;
  max_contractor_limit?: Maybe<Scalars['Float']>;
  max_manager_limit?: Maybe<Scalars['Float']>;
  number_of_employee?: Maybe<Scalars['Float']>;
  phone_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "company" */
export type Company_Avg_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp = {
  _and?: Maybe<Array<Company_Bool_Exp>>;
  _not?: Maybe<Company_Bool_Exp>;
  _or?: Maybe<Array<Company_Bool_Exp>>;
  address1?: Maybe<String_Comparison_Exp>;
  address2?: Maybe<String_Comparison_Exp>;
  admins?: Maybe<Admin_Bool_Exp>;
  admins_aggregate?: Maybe<Admin_Aggregate_Bool_Exp>;
  allow_managers_view_all_contractors?: Maybe<Company_Managers_View_All_Contractors_Access_Comparison_Exp>;
  allow_managers_view_all_projects?: Maybe<Boolean_Comparison_Exp>;
  allow_managers_view_all_teams?: Maybe<Boolean_Comparison_Exp>;
  business_name?: Maybe<String_Comparison_Exp>;
  candidates?: Maybe<Candidate_Bool_Exp>;
  candidates_aggregate?: Maybe<Candidate_Aggregate_Bool_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  company_logo?: Maybe<String_Comparison_Exp>;
  contractors?: Maybe<Contractor_Bool_Exp>;
  contractors_aggregate?: Maybe<Contractor_Aggregate_Bool_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  custom_requests?: Maybe<Custom_Request_Bool_Exp>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Bool_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  documents?: Maybe<Document_Bool_Exp>;
  documents_aggregate?: Maybe<Document_Aggregate_Bool_Exp>;
  followers?: Maybe<Company_Follower_Bool_Exp>;
  followers_aggregate?: Maybe<Company_Follower_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  industry?: Maybe<String_Comparison_Exp>;
  invitations?: Maybe<Invitation_Bool_Exp>;
  invitations_aggregate?: Maybe<Invitation_Aggregate_Bool_Exp>;
  managers?: Maybe<Manager_Bool_Exp>;
  managers_aggregate?: Maybe<Manager_Aggregate_Bool_Exp>;
  marketplace_access_type?: Maybe<Company_Marketplace_Access_Comparison_Exp>;
  max_admin_limit?: Maybe<Int_Comparison_Exp>;
  max_contractor_limit?: Maybe<Int_Comparison_Exp>;
  max_manager_limit?: Maybe<Int_Comparison_Exp>;
  number_of_employee?: Maybe<Int_Comparison_Exp>;
  onboardings?: Maybe<Onboarding_Bool_Exp>;
  onboardings_aggregate?: Maybe<Onboarding_Aggregate_Bool_Exp>;
  phone_number?: Maybe<Numeric_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  postings?: Maybe<Posting_Bool_Exp>;
  postings_aggregate?: Maybe<Posting_Aggregate_Bool_Exp>;
  private?: Maybe<Boolean_Comparison_Exp>;
  projects?: Maybe<Project_Bool_Exp>;
  projects_aggregate?: Maybe<Project_Aggregate_Bool_Exp>;
  skills?: Maybe<Skill_Bool_Exp>;
  skills_aggregate?: Maybe<Skill_Aggregate_Bool_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  subscriptions?: Maybe<Subscription_Bool_Exp>;
  subscriptions_aggregate?: Maybe<Subscription_Aggregate_Bool_Exp>;
  teams?: Maybe<Team_Bool_Exp>;
  teams_aggregate?: Maybe<Team_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_job_titles?: Maybe<User_Job_Title_Bool_Exp>;
  user_job_titles_aggregate?: Maybe<User_Job_Title_Aggregate_Bool_Exp>;
  users?: Maybe<User_Company_Bool_Exp>;
  users_aggregate?: Maybe<User_Company_Aggregate_Bool_Exp>;
  users_disabled_notifications?: Maybe<Company_User_Notifications_Bool_Exp>;
  users_disabled_notifications_aggregate?: Maybe<Company_User_Notifications_Aggregate_Bool_Exp>;
  website?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "company" */
export enum Company_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompanyPkey = 'company_pkey'
}

/** columns and relationships of "company_follower" */
export type Company_Follower = {
  __typename?: 'company_follower';
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "company_follower" */
export type Company_Follower_Aggregate = {
  __typename?: 'company_follower_aggregate';
  aggregate?: Maybe<Company_Follower_Aggregate_Fields>;
  nodes: Array<Company_Follower>;
};

export type Company_Follower_Aggregate_Bool_Exp = {
  count?: Maybe<Company_Follower_Aggregate_Bool_Exp_Count>;
};

export type Company_Follower_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Company_Follower_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Company_Follower_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "company_follower" */
export type Company_Follower_Aggregate_Fields = {
  __typename?: 'company_follower_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_Follower_Max_Fields>;
  min?: Maybe<Company_Follower_Min_Fields>;
};


/** aggregate fields of "company_follower" */
export type Company_Follower_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_Follower_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_follower" */
export type Company_Follower_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Company_Follower_Max_Order_By>;
  min?: Maybe<Company_Follower_Min_Order_By>;
};

/** input type for inserting array relation for remote table "company_follower" */
export type Company_Follower_Arr_Rel_Insert_Input = {
  data: Array<Company_Follower_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Company_Follower_On_Conflict>;
};

/** Boolean expression to filter rows from the table "company_follower". All fields are combined with a logical 'AND'. */
export type Company_Follower_Bool_Exp = {
  _and?: Maybe<Array<Company_Follower_Bool_Exp>>;
  _not?: Maybe<Company_Follower_Bool_Exp>;
  _or?: Maybe<Array<Company_Follower_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_follower" */
export enum Company_Follower_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompanyFollowerPkey = 'company_follower_pkey',
  /** unique or primary key constraint on columns "user_id", "company_id" */
  CompanyFollowerUserIdCompanyIdKey = 'company_follower_user_id_company_id_key'
}

/** input type for inserting data into table "company_follower" */
export type Company_Follower_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Company_Follower_Max_Fields = {
  __typename?: 'company_follower_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "company_follower" */
export type Company_Follower_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Company_Follower_Min_Fields = {
  __typename?: 'company_follower_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "company_follower" */
export type Company_Follower_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "company_follower" */
export type Company_Follower_Mutation_Response = {
  __typename?: 'company_follower_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_Follower>;
};

/** on_conflict condition type for table "company_follower" */
export type Company_Follower_On_Conflict = {
  constraint: Company_Follower_Constraint;
  update_columns?: Array<Company_Follower_Update_Column>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};

/** Ordering options when selecting data from "company_follower". */
export type Company_Follower_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: company_follower */
export type Company_Follower_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "company_follower" */
export enum Company_Follower_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "company_follower" */
export type Company_Follower_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "company_follower" */
export type Company_Follower_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Follower_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Follower_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "company_follower" */
export enum Company_Follower_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Company_Follower_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Company_Follower_Set_Input>;
  /** filter the rows which have to be updated */
  where: Company_Follower_Bool_Exp;
};

/** input type for incrementing numeric columns in table "company" */
export type Company_Inc_Input = {
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "company" */
export type Company_Insert_Input = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  admins?: Maybe<Admin_Arr_Rel_Insert_Input>;
  allow_managers_view_all_contractors?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  allow_managers_view_all_projects?: Maybe<Scalars['Boolean']>;
  allow_managers_view_all_teams?: Maybe<Scalars['Boolean']>;
  business_name?: Maybe<Scalars['String']>;
  candidates?: Maybe<Candidate_Arr_Rel_Insert_Input>;
  city?: Maybe<Scalars['String']>;
  company_logo?: Maybe<Scalars['String']>;
  contractors?: Maybe<Contractor_Arr_Rel_Insert_Input>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  custom_requests?: Maybe<Custom_Request_Arr_Rel_Insert_Input>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Document_Arr_Rel_Insert_Input>;
  followers?: Maybe<Company_Follower_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Scalars['String']>;
  invitations?: Maybe<Invitation_Arr_Rel_Insert_Input>;
  managers?: Maybe<Manager_Arr_Rel_Insert_Input>;
  marketplace_access_type?: Maybe<Scalars['company_marketplace_access']>;
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  onboardings?: Maybe<Onboarding_Arr_Rel_Insert_Input>;
  phone_number?: Maybe<Scalars['numeric']>;
  postal_code?: Maybe<Scalars['String']>;
  postings?: Maybe<Posting_Arr_Rel_Insert_Input>;
  private?: Maybe<Scalars['Boolean']>;
  projects?: Maybe<Project_Arr_Rel_Insert_Input>;
  skills?: Maybe<Skill_Arr_Rel_Insert_Input>;
  state?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Subscription_Arr_Rel_Insert_Input>;
  teams?: Maybe<Team_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_job_titles?: Maybe<User_Job_Title_Arr_Rel_Insert_Input>;
  users?: Maybe<User_Company_Arr_Rel_Insert_Input>;
  users_disabled_notifications?: Maybe<Company_User_Notifications_Arr_Rel_Insert_Input>;
  website?: Maybe<Scalars['String']>;
};


/** Boolean expression to compare columns of type "company_managers_view_all_contractors_access". All fields are combined with logical 'AND'. */
export type Company_Managers_View_All_Contractors_Access_Comparison_Exp = {
  _eq?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  _gt?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  _gte?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  _in?: Maybe<Array<Scalars['company_managers_view_all_contractors_access']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  _lte?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  _neq?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  _nin?: Maybe<Array<Scalars['company_managers_view_all_contractors_access']>>;
};


/** Boolean expression to compare columns of type "company_marketplace_access". All fields are combined with logical 'AND'. */
export type Company_Marketplace_Access_Comparison_Exp = {
  _eq?: Maybe<Scalars['company_marketplace_access']>;
  _gt?: Maybe<Scalars['company_marketplace_access']>;
  _gte?: Maybe<Scalars['company_marketplace_access']>;
  _in?: Maybe<Array<Scalars['company_marketplace_access']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['company_marketplace_access']>;
  _lte?: Maybe<Scalars['company_marketplace_access']>;
  _neq?: Maybe<Scalars['company_marketplace_access']>;
  _nin?: Maybe<Array<Scalars['company_marketplace_access']>>;
};

/** aggregate max on columns */
export type Company_Max_Fields = {
  __typename?: 'company_max_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  allow_managers_view_all_contractors?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  business_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_logo?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Scalars['String']>;
  marketplace_access_type?: Maybe<Scalars['company_marketplace_access']>;
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['numeric']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "company" */
export type Company_Max_Order_By = {
  address1?: Maybe<Order_By>;
  address2?: Maybe<Order_By>;
  allow_managers_view_all_contractors?: Maybe<Order_By>;
  business_name?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_logo?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry?: Maybe<Order_By>;
  marketplace_access_type?: Maybe<Order_By>;
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Company_Min_Fields = {
  __typename?: 'company_min_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  allow_managers_view_all_contractors?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  business_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_logo?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Scalars['String']>;
  marketplace_access_type?: Maybe<Scalars['company_marketplace_access']>;
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['numeric']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "company" */
export type Company_Min_Order_By = {
  address1?: Maybe<Order_By>;
  address2?: Maybe<Order_By>;
  allow_managers_view_all_contractors?: Maybe<Order_By>;
  business_name?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_logo?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry?: Maybe<Order_By>;
  marketplace_access_type?: Maybe<Order_By>;
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
};

/** response of any mutation on the table "company" */
export type Company_Mutation_Response = {
  __typename?: 'company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company>;
};

/** input type for inserting object relation for remote table "company" */
export type Company_Obj_Rel_Insert_Input = {
  data: Company_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Company_On_Conflict>;
};

/** on_conflict condition type for table "company" */
export type Company_On_Conflict = {
  constraint: Company_Constraint;
  update_columns?: Array<Company_Update_Column>;
  where?: Maybe<Company_Bool_Exp>;
};

/** Ordering options when selecting data from "company". */
export type Company_Order_By = {
  address1?: Maybe<Order_By>;
  address2?: Maybe<Order_By>;
  admins_aggregate?: Maybe<Admin_Aggregate_Order_By>;
  allow_managers_view_all_contractors?: Maybe<Order_By>;
  allow_managers_view_all_projects?: Maybe<Order_By>;
  allow_managers_view_all_teams?: Maybe<Order_By>;
  business_name?: Maybe<Order_By>;
  candidates_aggregate?: Maybe<Candidate_Aggregate_Order_By>;
  city?: Maybe<Order_By>;
  company_logo?: Maybe<Order_By>;
  contractors_aggregate?: Maybe<Contractor_Aggregate_Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Order_By>;
  description?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Document_Aggregate_Order_By>;
  followers_aggregate?: Maybe<Company_Follower_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  industry?: Maybe<Order_By>;
  invitations_aggregate?: Maybe<Invitation_Aggregate_Order_By>;
  managers_aggregate?: Maybe<Manager_Aggregate_Order_By>;
  marketplace_access_type?: Maybe<Order_By>;
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  onboardings_aggregate?: Maybe<Onboarding_Aggregate_Order_By>;
  phone_number?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  postings_aggregate?: Maybe<Posting_Aggregate_Order_By>;
  private?: Maybe<Order_By>;
  projects_aggregate?: Maybe<Project_Aggregate_Order_By>;
  skills_aggregate?: Maybe<Skill_Aggregate_Order_By>;
  state?: Maybe<Order_By>;
  subscriptions_aggregate?: Maybe<Subscription_Aggregate_Order_By>;
  teams_aggregate?: Maybe<Team_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_job_titles_aggregate?: Maybe<User_Job_Title_Aggregate_Order_By>;
  users_aggregate?: Maybe<User_Company_Aggregate_Order_By>;
  users_disabled_notifications_aggregate?: Maybe<Company_User_Notifications_Aggregate_Order_By>;
  website?: Maybe<Order_By>;
};

/** primary key columns input for table: company */
export type Company_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "company" */
export enum Company_Select_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  AllowManagersViewAllContractors = 'allow_managers_view_all_contractors',
  /** column name */
  AllowManagersViewAllProjects = 'allow_managers_view_all_projects',
  /** column name */
  AllowManagersViewAllTeams = 'allow_managers_view_all_teams',
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  City = 'city',
  /** column name */
  CompanyLogo = 'company_logo',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Industry = 'industry',
  /** column name */
  MarketplaceAccessType = 'marketplace_access_type',
  /** column name */
  MaxAdminLimit = 'max_admin_limit',
  /** column name */
  MaxContractorLimit = 'max_contractor_limit',
  /** column name */
  MaxManagerLimit = 'max_manager_limit',
  /** column name */
  NumberOfEmployee = 'number_of_employee',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Private = 'private',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

/** select "company_aggregate_bool_exp_bool_and_arguments_columns" columns of table "company" */
export enum Company_Select_Column_Company_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowManagersViewAllProjects = 'allow_managers_view_all_projects',
  /** column name */
  AllowManagersViewAllTeams = 'allow_managers_view_all_teams',
  /** column name */
  Private = 'private'
}

/** select "company_aggregate_bool_exp_bool_or_arguments_columns" columns of table "company" */
export enum Company_Select_Column_Company_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowManagersViewAllProjects = 'allow_managers_view_all_projects',
  /** column name */
  AllowManagersViewAllTeams = 'allow_managers_view_all_teams',
  /** column name */
  Private = 'private'
}

/** input type for updating data in table "company" */
export type Company_Set_Input = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  allow_managers_view_all_contractors?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  allow_managers_view_all_projects?: Maybe<Scalars['Boolean']>;
  allow_managers_view_all_teams?: Maybe<Scalars['Boolean']>;
  business_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_logo?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Scalars['String']>;
  marketplace_access_type?: Maybe<Scalars['company_marketplace_access']>;
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['numeric']>;
  postal_code?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Company_Stddev_Fields = {
  __typename?: 'company_stddev_fields';
  max_admin_limit?: Maybe<Scalars['Float']>;
  max_contractor_limit?: Maybe<Scalars['Float']>;
  max_manager_limit?: Maybe<Scalars['Float']>;
  number_of_employee?: Maybe<Scalars['Float']>;
  phone_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "company" */
export type Company_Stddev_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Company_Stddev_Pop_Fields = {
  __typename?: 'company_stddev_pop_fields';
  max_admin_limit?: Maybe<Scalars['Float']>;
  max_contractor_limit?: Maybe<Scalars['Float']>;
  max_manager_limit?: Maybe<Scalars['Float']>;
  number_of_employee?: Maybe<Scalars['Float']>;
  phone_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "company" */
export type Company_Stddev_Pop_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Company_Stddev_Samp_Fields = {
  __typename?: 'company_stddev_samp_fields';
  max_admin_limit?: Maybe<Scalars['Float']>;
  max_contractor_limit?: Maybe<Scalars['Float']>;
  max_manager_limit?: Maybe<Scalars['Float']>;
  number_of_employee?: Maybe<Scalars['Float']>;
  phone_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "company" */
export type Company_Stddev_Samp_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** Streaming cursor of the table "company" */
export type Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Stream_Cursor_Value_Input = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  allow_managers_view_all_contractors?: Maybe<Scalars['company_managers_view_all_contractors_access']>;
  allow_managers_view_all_projects?: Maybe<Scalars['Boolean']>;
  allow_managers_view_all_teams?: Maybe<Scalars['Boolean']>;
  business_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_logo?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Scalars['String']>;
  marketplace_access_type?: Maybe<Scalars['company_marketplace_access']>;
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['numeric']>;
  postal_code?: Maybe<Scalars['String']>;
  private?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Company_Sum_Fields = {
  __typename?: 'company_sum_fields';
  max_admin_limit?: Maybe<Scalars['Int']>;
  max_contractor_limit?: Maybe<Scalars['Int']>;
  max_manager_limit?: Maybe<Scalars['Int']>;
  number_of_employee?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "company" */
export type Company_Sum_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** update columns of table "company" */
export enum Company_Update_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  AllowManagersViewAllContractors = 'allow_managers_view_all_contractors',
  /** column name */
  AllowManagersViewAllProjects = 'allow_managers_view_all_projects',
  /** column name */
  AllowManagersViewAllTeams = 'allow_managers_view_all_teams',
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  City = 'city',
  /** column name */
  CompanyLogo = 'company_logo',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Industry = 'industry',
  /** column name */
  MarketplaceAccessType = 'marketplace_access_type',
  /** column name */
  MaxAdminLimit = 'max_admin_limit',
  /** column name */
  MaxContractorLimit = 'max_contractor_limit',
  /** column name */
  MaxManagerLimit = 'max_manager_limit',
  /** column name */
  NumberOfEmployee = 'number_of_employee',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Private = 'private',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

export type Company_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Company_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Company_Set_Input>;
  /** filter the rows which have to be updated */
  where: Company_Bool_Exp;
};

/** If a record exists in the table, it means that the user has disabled notifications from that company. */
export type Company_User_Notifications = {
  __typename?: 'company_user_notifications';
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "company_user_notifications" */
export type Company_User_Notifications_Aggregate = {
  __typename?: 'company_user_notifications_aggregate';
  aggregate?: Maybe<Company_User_Notifications_Aggregate_Fields>;
  nodes: Array<Company_User_Notifications>;
};

export type Company_User_Notifications_Aggregate_Bool_Exp = {
  count?: Maybe<Company_User_Notifications_Aggregate_Bool_Exp_Count>;
};

export type Company_User_Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Company_User_Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "company_user_notifications" */
export type Company_User_Notifications_Aggregate_Fields = {
  __typename?: 'company_user_notifications_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Company_User_Notifications_Max_Fields>;
  min?: Maybe<Company_User_Notifications_Min_Fields>;
};


/** aggregate fields of "company_user_notifications" */
export type Company_User_Notifications_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "company_user_notifications" */
export type Company_User_Notifications_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Company_User_Notifications_Max_Order_By>;
  min?: Maybe<Company_User_Notifications_Min_Order_By>;
};

/** input type for inserting array relation for remote table "company_user_notifications" */
export type Company_User_Notifications_Arr_Rel_Insert_Input = {
  data: Array<Company_User_Notifications_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Company_User_Notifications_On_Conflict>;
};

/** Boolean expression to filter rows from the table "company_user_notifications". All fields are combined with a logical 'AND'. */
export type Company_User_Notifications_Bool_Exp = {
  _and?: Maybe<Array<Company_User_Notifications_Bool_Exp>>;
  _not?: Maybe<Company_User_Notifications_Bool_Exp>;
  _or?: Maybe<Array<Company_User_Notifications_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "company_user_notifications" */
export enum Company_User_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  CompanyUserNotificationsPkey = 'company_user_notifications_pkey',
  /** unique or primary key constraint on columns "user_id", "company_id" */
  CompanyUserNotificationsUserIdCompanyIdKey = 'company_user_notifications_user_id_company_id_key'
}

/** input type for inserting data into table "company_user_notifications" */
export type Company_User_Notifications_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Company_User_Notifications_Max_Fields = {
  __typename?: 'company_user_notifications_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "company_user_notifications" */
export type Company_User_Notifications_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Company_User_Notifications_Min_Fields = {
  __typename?: 'company_user_notifications_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "company_user_notifications" */
export type Company_User_Notifications_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "company_user_notifications" */
export type Company_User_Notifications_Mutation_Response = {
  __typename?: 'company_user_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_User_Notifications>;
};

/** on_conflict condition type for table "company_user_notifications" */
export type Company_User_Notifications_On_Conflict = {
  constraint: Company_User_Notifications_Constraint;
  update_columns?: Array<Company_User_Notifications_Update_Column>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "company_user_notifications". */
export type Company_User_Notifications_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: company_user_notifications */
export type Company_User_Notifications_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "company_user_notifications" */
export enum Company_User_Notifications_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "company_user_notifications" */
export type Company_User_Notifications_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "company_user_notifications" */
export type Company_User_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_User_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_User_Notifications_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "company_user_notifications" */
export enum Company_User_Notifications_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Company_User_Notifications_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Company_User_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Company_User_Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Company_Var_Pop_Fields = {
  __typename?: 'company_var_pop_fields';
  max_admin_limit?: Maybe<Scalars['Float']>;
  max_contractor_limit?: Maybe<Scalars['Float']>;
  max_manager_limit?: Maybe<Scalars['Float']>;
  number_of_employee?: Maybe<Scalars['Float']>;
  phone_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "company" */
export type Company_Var_Pop_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Company_Var_Samp_Fields = {
  __typename?: 'company_var_samp_fields';
  max_admin_limit?: Maybe<Scalars['Float']>;
  max_contractor_limit?: Maybe<Scalars['Float']>;
  max_manager_limit?: Maybe<Scalars['Float']>;
  number_of_employee?: Maybe<Scalars['Float']>;
  phone_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "company" */
export type Company_Var_Samp_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Company_Variance_Fields = {
  __typename?: 'company_variance_fields';
  max_admin_limit?: Maybe<Scalars['Float']>;
  max_contractor_limit?: Maybe<Scalars['Float']>;
  max_manager_limit?: Maybe<Scalars['Float']>;
  number_of_employee?: Maybe<Scalars['Float']>;
  phone_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "company" */
export type Company_Variance_Order_By = {
  max_admin_limit?: Maybe<Order_By>;
  max_contractor_limit?: Maybe<Order_By>;
  max_manager_limit?: Maybe<Order_By>;
  number_of_employee?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
};

/** columns and relationships of "contractor" */
export type Contractor = {
  __typename?: 'contractor';
  approved: Scalars['Boolean'];
  archived?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  /** An array relationship */
  contractor_notes: Array<Contractor_Note>;
  /** An aggregate relationship */
  contractor_notes_aggregate: Contractor_Note_Aggregate;
  /** An array relationship */
  contractor_ratings: Array<Contractor_Rating>;
  /** An aggregate relationship */
  contractor_ratings_aggregate: Contractor_Rating_Aggregate;
  /** An array relationship */
  contractor_staff_notes: Array<Contractor_Staff_Note>;
  /** An aggregate relationship */
  contractor_staff_notes_aggregate: Contractor_Staff_Note_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted: Scalars['Boolean'];
  /** An array relationship */
  document_contractor_accesses: Array<Document_Contractor_Access>;
  /** An aggregate relationship */
  document_contractor_accesses_aggregate: Document_Contractor_Access_Aggregate;
  from_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  managers: Array<Manager_Contractor>;
  /** An aggregate relationship */
  managers_aggregate: Manager_Contractor_Aggregate;
  notes?: Maybe<Scalars['String']>;
  /** An array relationship */
  postings: Array<Contractor_Posting>;
  /** An aggregate relationship */
  postings_aggregate: Contractor_Posting_Aggregate;
  profile_link?: Maybe<Scalars['String']>;
  /** An array relationship */
  project_activities: Array<Project_Activity>;
  /** An aggregate relationship */
  project_activities_aggregate: Project_Activity_Aggregate;
  /** An array relationship */
  project_activity_times: Array<Project_Activity_Time>;
  /** An aggregate relationship */
  project_activity_times_aggregate: Project_Activity_Time_Aggregate;
  /** An array relationship */
  projects: Array<Contractor_Project>;
  /** An aggregate relationship */
  projects_aggregate: Contractor_Project_Aggregate;
  rate?: Maybe<Scalars['Int']>;
  /** An array relationship */
  resource_information_cards: Array<Resource_Information_Card>;
  /** An aggregate relationship */
  resource_information_cards_aggregate: Resource_Information_Card_Aggregate;
  /** An object relationship */
  source?: Maybe<Source>;
  source_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  /** An object relationship */
  tag?: Maybe<Tag>;
  tag_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  teams: Array<Team_Contractor>;
  /** An aggregate relationship */
  teams_aggregate: Team_Contractor_Aggregate;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "contractor" */
export type ContractorContractor_NotesArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorContractor_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorContractor_RatingsArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorContractor_Ratings_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorContractor_Staff_NotesArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorContractor_Staff_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorDocument_Contractor_AccessesArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorDocument_Contractor_Accesses_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorManagersArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorManagers_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorPostingsArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorPostings_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorProject_ActivitiesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorProject_Activities_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorProject_Activity_TimesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorProject_Activity_Times_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorProjectsArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorProjects_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorResource_Information_CardsArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorResource_Information_Cards_AggregateArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorTeamsArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


/** columns and relationships of "contractor" */
export type ContractorTeams_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};

/** aggregated selection of "contractor" */
export type Contractor_Aggregate = {
  __typename?: 'contractor_aggregate';
  aggregate?: Maybe<Contractor_Aggregate_Fields>;
  nodes: Array<Contractor>;
};

export type Contractor_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Contractor_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Contractor_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Contractor_Aggregate_Bool_Exp_Count>;
};

export type Contractor_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contractor_Select_Column_Contractor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contractor_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contractor_Select_Column_Contractor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contractor_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Contractor_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contractor" */
export type Contractor_Aggregate_Fields = {
  __typename?: 'contractor_aggregate_fields';
  avg?: Maybe<Contractor_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contractor_Max_Fields>;
  min?: Maybe<Contractor_Min_Fields>;
  stddev?: Maybe<Contractor_Stddev_Fields>;
  stddev_pop?: Maybe<Contractor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contractor_Stddev_Samp_Fields>;
  sum?: Maybe<Contractor_Sum_Fields>;
  var_pop?: Maybe<Contractor_Var_Pop_Fields>;
  var_samp?: Maybe<Contractor_Var_Samp_Fields>;
  variance?: Maybe<Contractor_Variance_Fields>;
};


/** aggregate fields of "contractor" */
export type Contractor_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Contractor_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contractor" */
export type Contractor_Aggregate_Order_By = {
  avg?: Maybe<Contractor_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Contractor_Max_Order_By>;
  min?: Maybe<Contractor_Min_Order_By>;
  stddev?: Maybe<Contractor_Stddev_Order_By>;
  stddev_pop?: Maybe<Contractor_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Contractor_Stddev_Samp_Order_By>;
  sum?: Maybe<Contractor_Sum_Order_By>;
  var_pop?: Maybe<Contractor_Var_Pop_Order_By>;
  var_samp?: Maybe<Contractor_Var_Samp_Order_By>;
  variance?: Maybe<Contractor_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "contractor" */
export type Contractor_Arr_Rel_Insert_Input = {
  data: Array<Contractor_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Contractor_On_Conflict>;
};

/** aggregate avg on columns */
export type Contractor_Avg_Fields = {
  __typename?: 'contractor_avg_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "contractor" */
export type Contractor_Avg_Order_By = {
  rate?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "contractor". All fields are combined with a logical 'AND'. */
export type Contractor_Bool_Exp = {
  _and?: Maybe<Array<Contractor_Bool_Exp>>;
  _not?: Maybe<Contractor_Bool_Exp>;
  _or?: Maybe<Array<Contractor_Bool_Exp>>;
  approved?: Maybe<Boolean_Comparison_Exp>;
  archived?: Maybe<Boolean_Comparison_Exp>;
  availability?: Maybe<Boolean_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  contractor_notes?: Maybe<Contractor_Note_Bool_Exp>;
  contractor_notes_aggregate?: Maybe<Contractor_Note_Aggregate_Bool_Exp>;
  contractor_ratings?: Maybe<Contractor_Rating_Bool_Exp>;
  contractor_ratings_aggregate?: Maybe<Contractor_Rating_Aggregate_Bool_Exp>;
  contractor_staff_notes?: Maybe<Contractor_Staff_Note_Bool_Exp>;
  contractor_staff_notes_aggregate?: Maybe<Contractor_Staff_Note_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  document_contractor_accesses?: Maybe<Document_Contractor_Access_Bool_Exp>;
  document_contractor_accesses_aggregate?: Maybe<Document_Contractor_Access_Aggregate_Bool_Exp>;
  from_date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  managers?: Maybe<Manager_Contractor_Bool_Exp>;
  managers_aggregate?: Maybe<Manager_Contractor_Aggregate_Bool_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  postings?: Maybe<Contractor_Posting_Bool_Exp>;
  postings_aggregate?: Maybe<Contractor_Posting_Aggregate_Bool_Exp>;
  profile_link?: Maybe<String_Comparison_Exp>;
  project_activities?: Maybe<Project_Activity_Bool_Exp>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Bool_Exp>;
  project_activity_times?: Maybe<Project_Activity_Time_Bool_Exp>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Bool_Exp>;
  projects?: Maybe<Contractor_Project_Bool_Exp>;
  projects_aggregate?: Maybe<Contractor_Project_Aggregate_Bool_Exp>;
  rate?: Maybe<Int_Comparison_Exp>;
  resource_information_cards?: Maybe<Resource_Information_Card_Bool_Exp>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Bool_Exp>;
  source?: Maybe<Source_Bool_Exp>;
  source_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  tag?: Maybe<Tag_Bool_Exp>;
  tag_id?: Maybe<Uuid_Comparison_Exp>;
  teams?: Maybe<Team_Contractor_Bool_Exp>;
  teams_aggregate?: Maybe<Team_Contractor_Aggregate_Bool_Exp>;
  to_date?: Maybe<Date_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "contractor" */
export enum Contractor_Constraint {
  /** unique or primary key constraint on columns "user_id", "company_id" */
  ContractorCompanyIdUserIdKey = 'contractor_company_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  ContractorPkey = 'contractor_pkey'
}

/** input type for incrementing numeric columns in table "contractor" */
export type Contractor_Inc_Input = {
  rate?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "contractor" */
export type Contractor_Insert_Input = {
  approved?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  contractor_notes?: Maybe<Contractor_Note_Arr_Rel_Insert_Input>;
  contractor_ratings?: Maybe<Contractor_Rating_Arr_Rel_Insert_Input>;
  contractor_staff_notes?: Maybe<Contractor_Staff_Note_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  document_contractor_accesses?: Maybe<Document_Contractor_Access_Arr_Rel_Insert_Input>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  managers?: Maybe<Manager_Contractor_Arr_Rel_Insert_Input>;
  notes?: Maybe<Scalars['String']>;
  postings?: Maybe<Contractor_Posting_Arr_Rel_Insert_Input>;
  profile_link?: Maybe<Scalars['String']>;
  project_activities?: Maybe<Project_Activity_Arr_Rel_Insert_Input>;
  project_activity_times?: Maybe<Project_Activity_Time_Arr_Rel_Insert_Input>;
  projects?: Maybe<Contractor_Project_Arr_Rel_Insert_Input>;
  rate?: Maybe<Scalars['Int']>;
  resource_information_cards?: Maybe<Resource_Information_Card_Arr_Rel_Insert_Input>;
  source?: Maybe<Source_Obj_Rel_Insert_Input>;
  source_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  tag?: Maybe<Tag_Obj_Rel_Insert_Input>;
  tag_id?: Maybe<Scalars['uuid']>;
  teams?: Maybe<Team_Contractor_Arr_Rel_Insert_Input>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Contractor_Max_Fields = {
  __typename?: 'contractor_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "contractor" */
export type Contractor_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  profile_link?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  source_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Contractor_Min_Fields = {
  __typename?: 'contractor_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "contractor" */
export type Contractor_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  profile_link?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  source_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "contractor" */
export type Contractor_Mutation_Response = {
  __typename?: 'contractor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contractor>;
};

/** columns and relationships of "contractor_note" */
export type Contractor_Note = {
  __typename?: 'contractor_note';
  /** An object relationship */
  contractor?: Maybe<Contractor>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  manager_id?: Maybe<Scalars['uuid']>;
  note: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
};

/** aggregated selection of "contractor_note" */
export type Contractor_Note_Aggregate = {
  __typename?: 'contractor_note_aggregate';
  aggregate?: Maybe<Contractor_Note_Aggregate_Fields>;
  nodes: Array<Contractor_Note>;
};

export type Contractor_Note_Aggregate_Bool_Exp = {
  count?: Maybe<Contractor_Note_Aggregate_Bool_Exp_Count>;
};

export type Contractor_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Contractor_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contractor_note" */
export type Contractor_Note_Aggregate_Fields = {
  __typename?: 'contractor_note_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Contractor_Note_Max_Fields>;
  min?: Maybe<Contractor_Note_Min_Fields>;
};


/** aggregate fields of "contractor_note" */
export type Contractor_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Contractor_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contractor_note" */
export type Contractor_Note_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Contractor_Note_Max_Order_By>;
  min?: Maybe<Contractor_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "contractor_note" */
export type Contractor_Note_Arr_Rel_Insert_Input = {
  data: Array<Contractor_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Contractor_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "contractor_note". All fields are combined with a logical 'AND'. */
export type Contractor_Note_Bool_Exp = {
  _and?: Maybe<Array<Contractor_Note_Bool_Exp>>;
  _not?: Maybe<Contractor_Note_Bool_Exp>;
  _or?: Maybe<Array<Contractor_Note_Bool_Exp>>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  note?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "contractor_note" */
export enum Contractor_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractorNotePkey = 'contractor_note_pkey'
}

/** input type for inserting data into table "contractor_note" */
export type Contractor_Note_Insert_Input = {
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Contractor_Note_Max_Fields = {
  __typename?: 'contractor_note_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "contractor_note" */
export type Contractor_Note_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Contractor_Note_Min_Fields = {
  __typename?: 'contractor_note_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "contractor_note" */
export type Contractor_Note_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "contractor_note" */
export type Contractor_Note_Mutation_Response = {
  __typename?: 'contractor_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contractor_Note>;
};

/** on_conflict condition type for table "contractor_note" */
export type Contractor_Note_On_Conflict = {
  constraint: Contractor_Note_Constraint;
  update_columns?: Array<Contractor_Note_Update_Column>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "contractor_note". */
export type Contractor_Note_Order_By = {
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
};

/** primary key columns input for table: contractor_note */
export type Contractor_Note_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "contractor_note" */
export enum Contractor_Note_Select_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  Note = 'note',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "contractor_note" */
export type Contractor_Note_Set_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "contractor_note" */
export type Contractor_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contractor_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contractor_Note_Stream_Cursor_Value_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "contractor_note" */
export enum Contractor_Note_Update_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  Note = 'note',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Contractor_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Contractor_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contractor_Note_Bool_Exp;
};

/** input type for inserting object relation for remote table "contractor" */
export type Contractor_Obj_Rel_Insert_Input = {
  data: Contractor_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Contractor_On_Conflict>;
};

/** on_conflict condition type for table "contractor" */
export type Contractor_On_Conflict = {
  constraint: Contractor_Constraint;
  update_columns?: Array<Contractor_Update_Column>;
  where?: Maybe<Contractor_Bool_Exp>;
};

/** Ordering options when selecting data from "contractor". */
export type Contractor_Order_By = {
  approved?: Maybe<Order_By>;
  archived?: Maybe<Order_By>;
  availability?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  contractor_notes_aggregate?: Maybe<Contractor_Note_Aggregate_Order_By>;
  contractor_ratings_aggregate?: Maybe<Contractor_Rating_Aggregate_Order_By>;
  contractor_staff_notes_aggregate?: Maybe<Contractor_Staff_Note_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  deleted?: Maybe<Order_By>;
  document_contractor_accesses_aggregate?: Maybe<Document_Contractor_Access_Aggregate_Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  managers_aggregate?: Maybe<Manager_Contractor_Aggregate_Order_By>;
  notes?: Maybe<Order_By>;
  postings_aggregate?: Maybe<Contractor_Posting_Aggregate_Order_By>;
  profile_link?: Maybe<Order_By>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Order_By>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Order_By>;
  projects_aggregate?: Maybe<Contractor_Project_Aggregate_Order_By>;
  rate?: Maybe<Order_By>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Order_By>;
  source?: Maybe<Source_Order_By>;
  source_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tag?: Maybe<Tag_Order_By>;
  tag_id?: Maybe<Order_By>;
  teams_aggregate?: Maybe<Team_Contractor_Aggregate_Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: contractor */
export type Contractor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "contractor_posting" */
export type Contractor_Posting = {
  __typename?: 'contractor_posting';
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  posting: Posting;
  posting_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "contractor_posting" */
export type Contractor_Posting_Aggregate = {
  __typename?: 'contractor_posting_aggregate';
  aggregate?: Maybe<Contractor_Posting_Aggregate_Fields>;
  nodes: Array<Contractor_Posting>;
};

export type Contractor_Posting_Aggregate_Bool_Exp = {
  count?: Maybe<Contractor_Posting_Aggregate_Bool_Exp_Count>;
};

export type Contractor_Posting_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Contractor_Posting_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Posting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contractor_posting" */
export type Contractor_Posting_Aggregate_Fields = {
  __typename?: 'contractor_posting_aggregate_fields';
  avg?: Maybe<Contractor_Posting_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contractor_Posting_Max_Fields>;
  min?: Maybe<Contractor_Posting_Min_Fields>;
  stddev?: Maybe<Contractor_Posting_Stddev_Fields>;
  stddev_pop?: Maybe<Contractor_Posting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contractor_Posting_Stddev_Samp_Fields>;
  sum?: Maybe<Contractor_Posting_Sum_Fields>;
  var_pop?: Maybe<Contractor_Posting_Var_Pop_Fields>;
  var_samp?: Maybe<Contractor_Posting_Var_Samp_Fields>;
  variance?: Maybe<Contractor_Posting_Variance_Fields>;
};


/** aggregate fields of "contractor_posting" */
export type Contractor_Posting_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Contractor_Posting_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contractor_posting" */
export type Contractor_Posting_Aggregate_Order_By = {
  avg?: Maybe<Contractor_Posting_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Contractor_Posting_Max_Order_By>;
  min?: Maybe<Contractor_Posting_Min_Order_By>;
  stddev?: Maybe<Contractor_Posting_Stddev_Order_By>;
  stddev_pop?: Maybe<Contractor_Posting_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Contractor_Posting_Stddev_Samp_Order_By>;
  sum?: Maybe<Contractor_Posting_Sum_Order_By>;
  var_pop?: Maybe<Contractor_Posting_Var_Pop_Order_By>;
  var_samp?: Maybe<Contractor_Posting_Var_Samp_Order_By>;
  variance?: Maybe<Contractor_Posting_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "contractor_posting" */
export type Contractor_Posting_Arr_Rel_Insert_Input = {
  data: Array<Contractor_Posting_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Contractor_Posting_On_Conflict>;
};

/** aggregate avg on columns */
export type Contractor_Posting_Avg_Fields = {
  __typename?: 'contractor_posting_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "contractor_posting" */
export type Contractor_Posting_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "contractor_posting". All fields are combined with a logical 'AND'. */
export type Contractor_Posting_Bool_Exp = {
  _and?: Maybe<Array<Contractor_Posting_Bool_Exp>>;
  _not?: Maybe<Contractor_Posting_Bool_Exp>;
  _or?: Maybe<Array<Contractor_Posting_Bool_Exp>>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  posting?: Maybe<Posting_Bool_Exp>;
  posting_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "contractor_posting" */
export enum Contractor_Posting_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractorPostingPkey = 'contractor_posting_pkey'
}

/** input type for incrementing numeric columns in table "contractor_posting" */
export type Contractor_Posting_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "contractor_posting" */
export type Contractor_Posting_Insert_Input = {
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  posting?: Maybe<Posting_Obj_Rel_Insert_Input>;
  posting_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Contractor_Posting_Max_Fields = {
  __typename?: 'contractor_posting_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "contractor_posting" */
export type Contractor_Posting_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Contractor_Posting_Min_Fields = {
  __typename?: 'contractor_posting_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "contractor_posting" */
export type Contractor_Posting_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "contractor_posting" */
export type Contractor_Posting_Mutation_Response = {
  __typename?: 'contractor_posting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contractor_Posting>;
};

/** on_conflict condition type for table "contractor_posting" */
export type Contractor_Posting_On_Conflict = {
  constraint: Contractor_Posting_Constraint;
  update_columns?: Array<Contractor_Posting_Update_Column>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};

/** Ordering options when selecting data from "contractor_posting". */
export type Contractor_Posting_Order_By = {
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting?: Maybe<Posting_Order_By>;
  posting_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: contractor_posting */
export type Contractor_Posting_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "contractor_posting" */
export enum Contractor_Posting_Select_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "contractor_posting" */
export type Contractor_Posting_Set_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Contractor_Posting_Stddev_Fields = {
  __typename?: 'contractor_posting_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "contractor_posting" */
export type Contractor_Posting_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contractor_Posting_Stddev_Pop_Fields = {
  __typename?: 'contractor_posting_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "contractor_posting" */
export type Contractor_Posting_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contractor_Posting_Stddev_Samp_Fields = {
  __typename?: 'contractor_posting_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "contractor_posting" */
export type Contractor_Posting_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "contractor_posting" */
export type Contractor_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contractor_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contractor_Posting_Stream_Cursor_Value_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Contractor_Posting_Sum_Fields = {
  __typename?: 'contractor_posting_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "contractor_posting" */
export type Contractor_Posting_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "contractor_posting" */
export enum Contractor_Posting_Update_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Contractor_Posting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Contractor_Posting_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Contractor_Posting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contractor_Posting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contractor_Posting_Var_Pop_Fields = {
  __typename?: 'contractor_posting_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "contractor_posting" */
export type Contractor_Posting_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contractor_Posting_Var_Samp_Fields = {
  __typename?: 'contractor_posting_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "contractor_posting" */
export type Contractor_Posting_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Contractor_Posting_Variance_Fields = {
  __typename?: 'contractor_posting_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "contractor_posting" */
export type Contractor_Posting_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "contractor_project" */
export type Contractor_Project = {
  __typename?: 'contractor_project';
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid'];
};

/** aggregated selection of "contractor_project" */
export type Contractor_Project_Aggregate = {
  __typename?: 'contractor_project_aggregate';
  aggregate?: Maybe<Contractor_Project_Aggregate_Fields>;
  nodes: Array<Contractor_Project>;
};

export type Contractor_Project_Aggregate_Bool_Exp = {
  count?: Maybe<Contractor_Project_Aggregate_Bool_Exp_Count>;
};

export type Contractor_Project_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Contractor_Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contractor_project" */
export type Contractor_Project_Aggregate_Fields = {
  __typename?: 'contractor_project_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Contractor_Project_Max_Fields>;
  min?: Maybe<Contractor_Project_Min_Fields>;
};


/** aggregate fields of "contractor_project" */
export type Contractor_Project_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Contractor_Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contractor_project" */
export type Contractor_Project_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Contractor_Project_Max_Order_By>;
  min?: Maybe<Contractor_Project_Min_Order_By>;
};

/** input type for inserting array relation for remote table "contractor_project" */
export type Contractor_Project_Arr_Rel_Insert_Input = {
  data: Array<Contractor_Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Contractor_Project_On_Conflict>;
};

/** Boolean expression to filter rows from the table "contractor_project". All fields are combined with a logical 'AND'. */
export type Contractor_Project_Bool_Exp = {
  _and?: Maybe<Array<Contractor_Project_Bool_Exp>>;
  _not?: Maybe<Contractor_Project_Bool_Exp>;
  _or?: Maybe<Array<Contractor_Project_Bool_Exp>>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "contractor_project" */
export enum Contractor_Project_Constraint {
  /** unique or primary key constraint on columns "project_id", "contractor_id" */
  ContractorProjectContractorIdProjectIdKey = 'contractor_project_contractor_id_project_id_key',
  /** unique or primary key constraint on columns "id" */
  ContractorProjectPkey = 'contractor_project_pkey'
}

/** input type for inserting data into table "contractor_project" */
export type Contractor_Project_Insert_Input = {
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Contractor_Project_Max_Fields = {
  __typename?: 'contractor_project_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "contractor_project" */
export type Contractor_Project_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Contractor_Project_Min_Fields = {
  __typename?: 'contractor_project_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "contractor_project" */
export type Contractor_Project_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "contractor_project" */
export type Contractor_Project_Mutation_Response = {
  __typename?: 'contractor_project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contractor_Project>;
};

/** on_conflict condition type for table "contractor_project" */
export type Contractor_Project_On_Conflict = {
  constraint: Contractor_Project_Constraint;
  update_columns?: Array<Contractor_Project_Update_Column>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};

/** Ordering options when selecting data from "contractor_project". */
export type Contractor_Project_Order_By = {
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
};

/** primary key columns input for table: contractor_project */
export type Contractor_Project_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "contractor_project" */
export enum Contractor_Project_Select_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "contractor_project" */
export type Contractor_Project_Set_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "contractor_project" */
export type Contractor_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contractor_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contractor_Project_Stream_Cursor_Value_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "contractor_project" */
export enum Contractor_Project_Update_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id'
}

export type Contractor_Project_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Contractor_Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contractor_Project_Bool_Exp;
};

/** columns and relationships of "contractor_rating" */
export type Contractor_Rating = {
  __typename?: 'contractor_rating';
  activity_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  project_activity?: Maybe<Project_Activity>;
  /** An object relationship */
  public_project_details?: Maybe<Public_Project_Details>;
  review: Scalars['String'];
  /** An object relationship */
  reviewer: User;
  reviewer_id: Scalars['uuid'];
  score: Scalars['Float'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "contractor_rating" */
export type Contractor_Rating_Aggregate = {
  __typename?: 'contractor_rating_aggregate';
  aggregate?: Maybe<Contractor_Rating_Aggregate_Fields>;
  nodes: Array<Contractor_Rating>;
};

export type Contractor_Rating_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Contractor_Rating_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Contractor_Rating_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Contractor_Rating_Aggregate_Bool_Exp_Count>;
};

export type Contractor_Rating_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contractor_Rating_Select_Column_Contractor_Rating_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Rating_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contractor_Rating_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contractor_Rating_Select_Column_Contractor_Rating_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Rating_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contractor_Rating_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Contractor_Rating_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Rating_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contractor_rating" */
export type Contractor_Rating_Aggregate_Fields = {
  __typename?: 'contractor_rating_aggregate_fields';
  avg?: Maybe<Contractor_Rating_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contractor_Rating_Max_Fields>;
  min?: Maybe<Contractor_Rating_Min_Fields>;
  stddev?: Maybe<Contractor_Rating_Stddev_Fields>;
  stddev_pop?: Maybe<Contractor_Rating_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contractor_Rating_Stddev_Samp_Fields>;
  sum?: Maybe<Contractor_Rating_Sum_Fields>;
  var_pop?: Maybe<Contractor_Rating_Var_Pop_Fields>;
  var_samp?: Maybe<Contractor_Rating_Var_Samp_Fields>;
  variance?: Maybe<Contractor_Rating_Variance_Fields>;
};


/** aggregate fields of "contractor_rating" */
export type Contractor_Rating_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Contractor_Rating_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contractor_rating" */
export type Contractor_Rating_Aggregate_Order_By = {
  avg?: Maybe<Contractor_Rating_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Contractor_Rating_Max_Order_By>;
  min?: Maybe<Contractor_Rating_Min_Order_By>;
  stddev?: Maybe<Contractor_Rating_Stddev_Order_By>;
  stddev_pop?: Maybe<Contractor_Rating_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Contractor_Rating_Stddev_Samp_Order_By>;
  sum?: Maybe<Contractor_Rating_Sum_Order_By>;
  var_pop?: Maybe<Contractor_Rating_Var_Pop_Order_By>;
  var_samp?: Maybe<Contractor_Rating_Var_Samp_Order_By>;
  variance?: Maybe<Contractor_Rating_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "contractor_rating" */
export type Contractor_Rating_Arr_Rel_Insert_Input = {
  data: Array<Contractor_Rating_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Contractor_Rating_On_Conflict>;
};

/** aggregate avg on columns */
export type Contractor_Rating_Avg_Fields = {
  __typename?: 'contractor_rating_avg_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "contractor_rating" */
export type Contractor_Rating_Avg_Order_By = {
  score?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "contractor_rating". All fields are combined with a logical 'AND'. */
export type Contractor_Rating_Bool_Exp = {
  _and?: Maybe<Array<Contractor_Rating_Bool_Exp>>;
  _not?: Maybe<Contractor_Rating_Bool_Exp>;
  _or?: Maybe<Array<Contractor_Rating_Bool_Exp>>;
  activity_id?: Maybe<Uuid_Comparison_Exp>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  public_project_details?: Maybe<Public_Project_Details_Bool_Exp>;
  review?: Maybe<String_Comparison_Exp>;
  reviewer?: Maybe<User_Bool_Exp>;
  reviewer_id?: Maybe<Uuid_Comparison_Exp>;
  score?: Maybe<Float_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "contractor_rating" */
export enum Contractor_Rating_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractorRatingPkey = 'contractor_rating_pkey',
  /** unique or primary key constraint on columns "reviewer_id", "activity_id" */
  ContractorRatingReviewerIdActivityIdKey = 'contractor_rating_reviewer_id_activity_id_key'
}

/** input type for incrementing numeric columns in table "contractor_rating" */
export type Contractor_Rating_Inc_Input = {
  score?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "contractor_rating" */
export type Contractor_Rating_Insert_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  public_project_details?: Maybe<Public_Project_Details_Obj_Rel_Insert_Input>;
  review?: Maybe<Scalars['String']>;
  reviewer?: Maybe<User_Obj_Rel_Insert_Input>;
  reviewer_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Contractor_Rating_Max_Fields = {
  __typename?: 'contractor_rating_max_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  review?: Maybe<Scalars['String']>;
  reviewer_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "contractor_rating" */
export type Contractor_Rating_Max_Order_By = {
  activity_id?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  review?: Maybe<Order_By>;
  reviewer_id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Contractor_Rating_Min_Fields = {
  __typename?: 'contractor_rating_min_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  review?: Maybe<Scalars['String']>;
  reviewer_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "contractor_rating" */
export type Contractor_Rating_Min_Order_By = {
  activity_id?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  review?: Maybe<Order_By>;
  reviewer_id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "contractor_rating" */
export type Contractor_Rating_Mutation_Response = {
  __typename?: 'contractor_rating_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contractor_Rating>;
};

/** on_conflict condition type for table "contractor_rating" */
export type Contractor_Rating_On_Conflict = {
  constraint: Contractor_Rating_Constraint;
  update_columns?: Array<Contractor_Rating_Update_Column>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};

/** Ordering options when selecting data from "contractor_rating". */
export type Contractor_Rating_Order_By = {
  activity_id?: Maybe<Order_By>;
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  public_project_details?: Maybe<Public_Project_Details_Order_By>;
  review?: Maybe<Order_By>;
  reviewer?: Maybe<User_Order_By>;
  reviewer_id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: contractor_rating */
export type Contractor_Rating_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "contractor_rating" */
export enum Contractor_Rating_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Review = 'review',
  /** column name */
  ReviewerId = 'reviewer_id',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "contractor_rating_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contractor_rating" */
export enum Contractor_Rating_Select_Column_Contractor_Rating_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "contractor_rating_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contractor_rating" */
export enum Contractor_Rating_Select_Column_Contractor_Rating_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "contractor_rating" */
export type Contractor_Rating_Set_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  review?: Maybe<Scalars['String']>;
  reviewer_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Contractor_Rating_Stddev_Fields = {
  __typename?: 'contractor_rating_stddev_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "contractor_rating" */
export type Contractor_Rating_Stddev_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contractor_Rating_Stddev_Pop_Fields = {
  __typename?: 'contractor_rating_stddev_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "contractor_rating" */
export type Contractor_Rating_Stddev_Pop_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contractor_Rating_Stddev_Samp_Fields = {
  __typename?: 'contractor_rating_stddev_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "contractor_rating" */
export type Contractor_Rating_Stddev_Samp_Order_By = {
  score?: Maybe<Order_By>;
};

/** Streaming cursor of the table "contractor_rating" */
export type Contractor_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contractor_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contractor_Rating_Stream_Cursor_Value_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  review?: Maybe<Scalars['String']>;
  reviewer_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Contractor_Rating_Sum_Fields = {
  __typename?: 'contractor_rating_sum_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "contractor_rating" */
export type Contractor_Rating_Sum_Order_By = {
  score?: Maybe<Order_By>;
};

/** update columns of table "contractor_rating" */
export enum Contractor_Rating_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Review = 'review',
  /** column name */
  ReviewerId = 'reviewer_id',
  /** column name */
  Score = 'score',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Contractor_Rating_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Contractor_Rating_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Contractor_Rating_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contractor_Rating_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contractor_Rating_Var_Pop_Fields = {
  __typename?: 'contractor_rating_var_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "contractor_rating" */
export type Contractor_Rating_Var_Pop_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contractor_Rating_Var_Samp_Fields = {
  __typename?: 'contractor_rating_var_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "contractor_rating" */
export type Contractor_Rating_Var_Samp_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Contractor_Rating_Variance_Fields = {
  __typename?: 'contractor_rating_variance_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "contractor_rating" */
export type Contractor_Rating_Variance_Order_By = {
  score?: Maybe<Order_By>;
};

/** select columns of table "contractor" */
export enum Contractor_Select_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  Archived = 'archived',
  /** column name */
  Availability = 'availability',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  FromDate = 'from_date',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProfileLink = 'profile_link',
  /** column name */
  Rate = 'rate',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  Status = 'status',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  ToDate = 'to_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "contractor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contractor" */
export enum Contractor_Select_Column_Contractor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Approved = 'approved',
  /** column name */
  Archived = 'archived',
  /** column name */
  Availability = 'availability',
  /** column name */
  Deleted = 'deleted'
}

/** select "contractor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contractor" */
export enum Contractor_Select_Column_Contractor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Approved = 'approved',
  /** column name */
  Archived = 'archived',
  /** column name */
  Availability = 'availability',
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "contractor" */
export type Contractor_Set_Input = {
  approved?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "contractor_staff_note" */
export type Contractor_Staff_Note = {
  __typename?: 'contractor_staff_note';
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  note?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Project>;
  /** An object relationship */
  project_activity?: Maybe<Project_Activity>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "contractor_staff_note" */
export type Contractor_Staff_Note_Aggregate = {
  __typename?: 'contractor_staff_note_aggregate';
  aggregate?: Maybe<Contractor_Staff_Note_Aggregate_Fields>;
  nodes: Array<Contractor_Staff_Note>;
};

export type Contractor_Staff_Note_Aggregate_Bool_Exp = {
  count?: Maybe<Contractor_Staff_Note_Aggregate_Bool_Exp_Count>;
};

export type Contractor_Staff_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Contractor_Staff_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contractor_staff_note" */
export type Contractor_Staff_Note_Aggregate_Fields = {
  __typename?: 'contractor_staff_note_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Contractor_Staff_Note_Max_Fields>;
  min?: Maybe<Contractor_Staff_Note_Min_Fields>;
};


/** aggregate fields of "contractor_staff_note" */
export type Contractor_Staff_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contractor_staff_note" */
export type Contractor_Staff_Note_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Contractor_Staff_Note_Max_Order_By>;
  min?: Maybe<Contractor_Staff_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "contractor_staff_note" */
export type Contractor_Staff_Note_Arr_Rel_Insert_Input = {
  data: Array<Contractor_Staff_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Contractor_Staff_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "contractor_staff_note". All fields are combined with a logical 'AND'. */
export type Contractor_Staff_Note_Bool_Exp = {
  _and?: Maybe<Array<Contractor_Staff_Note_Bool_Exp>>;
  _not?: Maybe<Contractor_Staff_Note_Bool_Exp>;
  _or?: Maybe<Array<Contractor_Staff_Note_Bool_Exp>>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  note?: Maybe<String_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_id?: Maybe<Uuid_Comparison_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "contractor_staff_note" */
export enum Contractor_Staff_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractorStaffNotePkey = 'contractor_staff_note_pkey'
}

/** input type for inserting data into table "contractor_staff_note" */
export type Contractor_Staff_Note_Insert_Input = {
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Contractor_Staff_Note_Max_Fields = {
  __typename?: 'contractor_staff_note_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "contractor_staff_note" */
export type Contractor_Staff_Note_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Contractor_Staff_Note_Min_Fields = {
  __typename?: 'contractor_staff_note_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "contractor_staff_note" */
export type Contractor_Staff_Note_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "contractor_staff_note" */
export type Contractor_Staff_Note_Mutation_Response = {
  __typename?: 'contractor_staff_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contractor_Staff_Note>;
};

/** on_conflict condition type for table "contractor_staff_note" */
export type Contractor_Staff_Note_On_Conflict = {
  constraint: Contractor_Staff_Note_Constraint;
  update_columns?: Array<Contractor_Staff_Note_Update_Column>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "contractor_staff_note". */
export type Contractor_Staff_Note_Order_By = {
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
};

/** primary key columns input for table: contractor_staff_note */
export type Contractor_Staff_Note_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "contractor_staff_note" */
export enum Contractor_Staff_Note_Select_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "contractor_staff_note" */
export type Contractor_Staff_Note_Set_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "contractor_staff_note" */
export type Contractor_Staff_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contractor_Staff_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contractor_Staff_Note_Stream_Cursor_Value_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "contractor_staff_note" */
export enum Contractor_Staff_Note_Update_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  ProjectId = 'project_id'
}

export type Contractor_Staff_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Contractor_Staff_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contractor_Staff_Note_Bool_Exp;
};

/** aggregate stddev on columns */
export type Contractor_Stddev_Fields = {
  __typename?: 'contractor_stddev_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "contractor" */
export type Contractor_Stddev_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contractor_Stddev_Pop_Fields = {
  __typename?: 'contractor_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "contractor" */
export type Contractor_Stddev_Pop_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contractor_Stddev_Samp_Fields = {
  __typename?: 'contractor_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "contractor" */
export type Contractor_Stddev_Samp_Order_By = {
  rate?: Maybe<Order_By>;
};

/** Streaming cursor of the table "contractor" */
export type Contractor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contractor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contractor_Stream_Cursor_Value_Input = {
  approved?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Contractor_Sum_Fields = {
  __typename?: 'contractor_sum_fields';
  rate?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "contractor" */
export type Contractor_Sum_Order_By = {
  rate?: Maybe<Order_By>;
};

/** update columns of table "contractor" */
export enum Contractor_Update_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  Archived = 'archived',
  /** column name */
  Availability = 'availability',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  FromDate = 'from_date',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProfileLink = 'profile_link',
  /** column name */
  Rate = 'rate',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  Status = 'status',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  ToDate = 'to_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Contractor_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Contractor_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Contractor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contractor_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contractor_Var_Pop_Fields = {
  __typename?: 'contractor_var_pop_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "contractor" */
export type Contractor_Var_Pop_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contractor_Var_Samp_Fields = {
  __typename?: 'contractor_var_samp_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "contractor" */
export type Contractor_Var_Samp_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Contractor_Variance_Fields = {
  __typename?: 'contractor_variance_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "contractor" */
export type Contractor_Variance_Order_By = {
  rate?: Maybe<Order_By>;
};

/** columns and relationships of "conversation" */
export type Conversation = {
  __typename?: 'conversation';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  custom_requests: Array<Custom_Request>;
  /** An aggregate relationship */
  custom_requests_aggregate: Custom_Request_Aggregate;
  id: Scalars['uuid'];
  is_custom_request_conversation: Scalars['Boolean'];
  /** An array relationship */
  messages: Array<Message>;
  /** An aggregate relationship */
  messages_aggregate: Message_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  recipient_messages: Array<Recipient_Message>;
  /** An aggregate relationship */
  recipient_messages_aggregate: Recipient_Message_Aggregate;
  /** An array relationship */
  unread_view: Array<Unread_Messages>;
  /** An aggregate relationship */
  unread_view_aggregate: Unread_Messages_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  users: Array<User_Conversation>;
  /** An aggregate relationship */
  users_aggregate: User_Conversation_Aggregate;
};


/** columns and relationships of "conversation" */
export type ConversationCustom_RequestsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationCustom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationMessagesArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationRecipient_MessagesArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationRecipient_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationUnread_ViewArgs = {
  distinct_on?: Maybe<Array<Unread_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unread_Messages_Order_By>>;
  where?: Maybe<Unread_Messages_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationUnread_View_AggregateArgs = {
  distinct_on?: Maybe<Array<Unread_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unread_Messages_Order_By>>;
  where?: Maybe<Unread_Messages_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationUsersArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


/** columns and relationships of "conversation" */
export type ConversationUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};

/** aggregated selection of "conversation" */
export type Conversation_Aggregate = {
  __typename?: 'conversation_aggregate';
  aggregate?: Maybe<Conversation_Aggregate_Fields>;
  nodes: Array<Conversation>;
};

/** aggregate fields of "conversation" */
export type Conversation_Aggregate_Fields = {
  __typename?: 'conversation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Conversation_Max_Fields>;
  min?: Maybe<Conversation_Min_Fields>;
};


/** aggregate fields of "conversation" */
export type Conversation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Conversation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "conversation". All fields are combined with a logical 'AND'. */
export type Conversation_Bool_Exp = {
  _and?: Maybe<Array<Conversation_Bool_Exp>>;
  _not?: Maybe<Conversation_Bool_Exp>;
  _or?: Maybe<Array<Conversation_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  custom_requests?: Maybe<Custom_Request_Bool_Exp>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_custom_request_conversation?: Maybe<Boolean_Comparison_Exp>;
  messages?: Maybe<Message_Bool_Exp>;
  messages_aggregate?: Maybe<Message_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  recipient_messages?: Maybe<Recipient_Message_Bool_Exp>;
  recipient_messages_aggregate?: Maybe<Recipient_Message_Aggregate_Bool_Exp>;
  unread_view?: Maybe<Unread_Messages_Bool_Exp>;
  unread_view_aggregate?: Maybe<Unread_Messages_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  users?: Maybe<User_Conversation_Bool_Exp>;
  users_aggregate?: Maybe<User_Conversation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "conversation" */
export enum Conversation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConversationPkey = 'conversation_pkey'
}

/** input type for inserting data into table "conversation" */
export type Conversation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  custom_requests?: Maybe<Custom_Request_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  is_custom_request_conversation?: Maybe<Scalars['Boolean']>;
  messages?: Maybe<Message_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  recipient_messages?: Maybe<Recipient_Message_Arr_Rel_Insert_Input>;
  unread_view?: Maybe<Unread_Messages_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  users?: Maybe<User_Conversation_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Conversation_Max_Fields = {
  __typename?: 'conversation_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Conversation_Min_Fields = {
  __typename?: 'conversation_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "conversation" */
export type Conversation_Mutation_Response = {
  __typename?: 'conversation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Conversation>;
};

/** input type for inserting object relation for remote table "conversation" */
export type Conversation_Obj_Rel_Insert_Input = {
  data: Conversation_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Conversation_On_Conflict>;
};

/** on_conflict condition type for table "conversation" */
export type Conversation_On_Conflict = {
  constraint: Conversation_Constraint;
  update_columns?: Array<Conversation_Update_Column>;
  where?: Maybe<Conversation_Bool_Exp>;
};

/** Ordering options when selecting data from "conversation". */
export type Conversation_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  is_custom_request_conversation?: Maybe<Order_By>;
  messages_aggregate?: Maybe<Message_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  recipient_messages_aggregate?: Maybe<Recipient_Message_Aggregate_Order_By>;
  unread_view_aggregate?: Maybe<Unread_Messages_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  users_aggregate?: Maybe<User_Conversation_Aggregate_Order_By>;
};

/** primary key columns input for table: conversation */
export type Conversation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "conversation" */
export enum Conversation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomRequestConversation = 'is_custom_request_conversation',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "conversation" */
export type Conversation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_custom_request_conversation?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "conversation" */
export type Conversation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Conversation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Conversation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_custom_request_conversation?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "conversation" */
export enum Conversation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomRequestConversation = 'is_custom_request_conversation',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Conversation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Conversation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Conversation_Bool_Exp;
};


/** Boolean expression to compare columns of type "currency". All fields are combined with logical 'AND'. */
export type Currency_Comparison_Exp = {
  _eq?: Maybe<Scalars['currency']>;
  _gt?: Maybe<Scalars['currency']>;
  _gte?: Maybe<Scalars['currency']>;
  _in?: Maybe<Array<Scalars['currency']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['currency']>;
  _lte?: Maybe<Scalars['currency']>;
  _neq?: Maybe<Scalars['currency']>;
  _nin?: Maybe<Array<Scalars['currency']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "custom_request" */
export type Custom_Request = {
  __typename?: 'custom_request';
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  /** An object relationship */
  conversation?: Maybe<Conversation>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: User;
  created_by_id: Scalars['uuid'];
  /** An array relationship */
  custom_request_skills: Array<Custom_Request_Skills>;
  /** An aggregate relationship */
  custom_request_skills_aggregate: Custom_Request_Skills_Aggregate;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  document_custom_requests: Array<Document_Custom_Request>;
  /** An aggregate relationship */
  document_custom_requests_aggregate: Document_Custom_Request_Aggregate;
  from_date?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  job_title: Scalars['String'];
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  number_of_contractors?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Project>;
  /** An object relationship */
  project_activity?: Maybe<Project_Activity>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  status: Scalars['custom_request_status'];
  /** An object relationship */
  tag?: Maybe<Tag>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  updated_by?: Maybe<User>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "custom_request" */
export type Custom_RequestCustom_Request_SkillsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


/** columns and relationships of "custom_request" */
export type Custom_RequestCustom_Request_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


/** columns and relationships of "custom_request" */
export type Custom_RequestDocument_Custom_RequestsArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


/** columns and relationships of "custom_request" */
export type Custom_RequestDocument_Custom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};

/** aggregated selection of "custom_request" */
export type Custom_Request_Aggregate = {
  __typename?: 'custom_request_aggregate';
  aggregate?: Maybe<Custom_Request_Aggregate_Fields>;
  nodes: Array<Custom_Request>;
};

export type Custom_Request_Aggregate_Bool_Exp = {
  count?: Maybe<Custom_Request_Aggregate_Bool_Exp_Count>;
};

export type Custom_Request_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Custom_Request_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Custom_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "custom_request" */
export type Custom_Request_Aggregate_Fields = {
  __typename?: 'custom_request_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Custom_Request_Max_Fields>;
  min?: Maybe<Custom_Request_Min_Fields>;
};


/** aggregate fields of "custom_request" */
export type Custom_Request_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Custom_Request_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "custom_request" */
export type Custom_Request_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Custom_Request_Max_Order_By>;
  min?: Maybe<Custom_Request_Min_Order_By>;
};

/** input type for inserting array relation for remote table "custom_request" */
export type Custom_Request_Arr_Rel_Insert_Input = {
  data: Array<Custom_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Custom_Request_On_Conflict>;
};

/** Boolean expression to filter rows from the table "custom_request". All fields are combined with a logical 'AND'. */
export type Custom_Request_Bool_Exp = {
  _and?: Maybe<Array<Custom_Request_Bool_Exp>>;
  _not?: Maybe<Custom_Request_Bool_Exp>;
  _or?: Maybe<Array<Custom_Request_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  conversation?: Maybe<Conversation_Bool_Exp>;
  conversation_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<User_Bool_Exp>;
  created_by_id?: Maybe<Uuid_Comparison_Exp>;
  custom_request_skills?: Maybe<Custom_Request_Skills_Bool_Exp>;
  custom_request_skills_aggregate?: Maybe<Custom_Request_Skills_Aggregate_Bool_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  document_custom_requests?: Maybe<Document_Custom_Request_Bool_Exp>;
  document_custom_requests_aggregate?: Maybe<Document_Custom_Request_Aggregate_Bool_Exp>;
  from_date?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  job_title?: Maybe<String_Comparison_Exp>;
  max_budget?: Maybe<String_Comparison_Exp>;
  min_budget?: Maybe<String_Comparison_Exp>;
  number_of_contractors?: Maybe<String_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_id?: Maybe<Uuid_Comparison_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<Custom_Request_Status_Comparison_Exp>;
  tag?: Maybe<Tag_Bool_Exp>;
  tag_id?: Maybe<Uuid_Comparison_Exp>;
  to_date?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<User_Bool_Exp>;
  updated_by_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_request" */
export enum Custom_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomRequestPkey = 'custom_request_pkey'
}

/** input type for inserting data into table "custom_request" */
export type Custom_Request_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  conversation?: Maybe<Conversation_Obj_Rel_Insert_Input>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<User_Obj_Rel_Insert_Input>;
  created_by_id?: Maybe<Scalars['uuid']>;
  custom_request_skills?: Maybe<Custom_Request_Skills_Arr_Rel_Insert_Input>;
  description?: Maybe<Scalars['String']>;
  document_custom_requests?: Maybe<Document_Custom_Request_Arr_Rel_Insert_Input>;
  from_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  number_of_contractors?: Maybe<Scalars['String']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['custom_request_status']>;
  tag?: Maybe<Tag_Obj_Rel_Insert_Input>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<User_Obj_Rel_Insert_Input>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Custom_Request_Max_Fields = {
  __typename?: 'custom_request_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  from_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  number_of_contractors?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['custom_request_status']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "custom_request" */
export type Custom_Request_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
  number_of_contractors?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Custom_Request_Min_Fields = {
  __typename?: 'custom_request_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  from_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  number_of_contractors?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['custom_request_status']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "custom_request" */
export type Custom_Request_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
  number_of_contractors?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "custom_request" */
export type Custom_Request_Mutation_Response = {
  __typename?: 'custom_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Request>;
};

/** input type for inserting object relation for remote table "custom_request" */
export type Custom_Request_Obj_Rel_Insert_Input = {
  data: Custom_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Custom_Request_On_Conflict>;
};

/** on_conflict condition type for table "custom_request" */
export type Custom_Request_On_Conflict = {
  constraint: Custom_Request_Constraint;
  update_columns?: Array<Custom_Request_Update_Column>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_request". */
export type Custom_Request_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  conversation?: Maybe<Conversation_Order_By>;
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<User_Order_By>;
  created_by_id?: Maybe<Order_By>;
  custom_request_skills_aggregate?: Maybe<Custom_Request_Skills_Aggregate_Order_By>;
  description?: Maybe<Order_By>;
  document_custom_requests_aggregate?: Maybe<Document_Custom_Request_Aggregate_Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
  number_of_contractors?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tag?: Maybe<Tag_Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<User_Order_By>;
  updated_by_id?: Maybe<Order_By>;
};

/** primary key columns input for table: custom_request */
export type Custom_Request_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "custom_request" */
export enum Custom_Request_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  FromDate = 'from_date',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NumberOfContractors = 'number_of_contractors',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  ToDate = 'to_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "custom_request" */
export type Custom_Request_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  from_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  number_of_contractors?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['custom_request_status']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "custom_request_skills" */
export type Custom_Request_Skills = {
  __typename?: 'custom_request_skills';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  customRequest: Custom_Request;
  custom_request_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  skill: Skill;
  skill_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "custom_request_skills" */
export type Custom_Request_Skills_Aggregate = {
  __typename?: 'custom_request_skills_aggregate';
  aggregate?: Maybe<Custom_Request_Skills_Aggregate_Fields>;
  nodes: Array<Custom_Request_Skills>;
};

export type Custom_Request_Skills_Aggregate_Bool_Exp = {
  count?: Maybe<Custom_Request_Skills_Aggregate_Bool_Exp_Count>;
};

export type Custom_Request_Skills_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Custom_Request_Skills_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "custom_request_skills" */
export type Custom_Request_Skills_Aggregate_Fields = {
  __typename?: 'custom_request_skills_aggregate_fields';
  avg?: Maybe<Custom_Request_Skills_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Custom_Request_Skills_Max_Fields>;
  min?: Maybe<Custom_Request_Skills_Min_Fields>;
  stddev?: Maybe<Custom_Request_Skills_Stddev_Fields>;
  stddev_pop?: Maybe<Custom_Request_Skills_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Custom_Request_Skills_Stddev_Samp_Fields>;
  sum?: Maybe<Custom_Request_Skills_Sum_Fields>;
  var_pop?: Maybe<Custom_Request_Skills_Var_Pop_Fields>;
  var_samp?: Maybe<Custom_Request_Skills_Var_Samp_Fields>;
  variance?: Maybe<Custom_Request_Skills_Variance_Fields>;
};


/** aggregate fields of "custom_request_skills" */
export type Custom_Request_Skills_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "custom_request_skills" */
export type Custom_Request_Skills_Aggregate_Order_By = {
  avg?: Maybe<Custom_Request_Skills_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Custom_Request_Skills_Max_Order_By>;
  min?: Maybe<Custom_Request_Skills_Min_Order_By>;
  stddev?: Maybe<Custom_Request_Skills_Stddev_Order_By>;
  stddev_pop?: Maybe<Custom_Request_Skills_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Custom_Request_Skills_Stddev_Samp_Order_By>;
  sum?: Maybe<Custom_Request_Skills_Sum_Order_By>;
  var_pop?: Maybe<Custom_Request_Skills_Var_Pop_Order_By>;
  var_samp?: Maybe<Custom_Request_Skills_Var_Samp_Order_By>;
  variance?: Maybe<Custom_Request_Skills_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "custom_request_skills" */
export type Custom_Request_Skills_Arr_Rel_Insert_Input = {
  data: Array<Custom_Request_Skills_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Custom_Request_Skills_On_Conflict>;
};

/** aggregate avg on columns */
export type Custom_Request_Skills_Avg_Fields = {
  __typename?: 'custom_request_skills_avg_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Avg_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "custom_request_skills". All fields are combined with a logical 'AND'. */
export type Custom_Request_Skills_Bool_Exp = {
  _and?: Maybe<Array<Custom_Request_Skills_Bool_Exp>>;
  _not?: Maybe<Custom_Request_Skills_Bool_Exp>;
  _or?: Maybe<Array<Custom_Request_Skills_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  customRequest?: Maybe<Custom_Request_Bool_Exp>;
  custom_request_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  skill?: Maybe<Skill_Bool_Exp>;
  skill_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_request_skills" */
export enum Custom_Request_Skills_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomRequestSkillsPkey = 'custom_request_skills_pkey'
}

/** input type for incrementing numeric columns in table "custom_request_skills" */
export type Custom_Request_Skills_Inc_Input = {
  skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "custom_request_skills" */
export type Custom_Request_Skills_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  customRequest?: Maybe<Custom_Request_Obj_Rel_Insert_Input>;
  custom_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  skill?: Maybe<Skill_Obj_Rel_Insert_Input>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Custom_Request_Skills_Max_Fields = {
  __typename?: 'custom_request_skills_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  custom_request_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Custom_Request_Skills_Min_Fields = {
  __typename?: 'custom_request_skills_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  custom_request_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "custom_request_skills" */
export type Custom_Request_Skills_Mutation_Response = {
  __typename?: 'custom_request_skills_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Request_Skills>;
};

/** on_conflict condition type for table "custom_request_skills" */
export type Custom_Request_Skills_On_Conflict = {
  constraint: Custom_Request_Skills_Constraint;
  update_columns?: Array<Custom_Request_Skills_Update_Column>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_request_skills". */
export type Custom_Request_Skills_Order_By = {
  created_at?: Maybe<Order_By>;
  customRequest?: Maybe<Custom_Request_Order_By>;
  custom_request_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill?: Maybe<Skill_Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: custom_request_skills */
export type Custom_Request_Skills_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "custom_request_skills" */
export enum Custom_Request_Skills_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomRequestId = 'custom_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "custom_request_skills" */
export type Custom_Request_Skills_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Custom_Request_Skills_Stddev_Fields = {
  __typename?: 'custom_request_skills_stddev_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Stddev_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Custom_Request_Skills_Stddev_Pop_Fields = {
  __typename?: 'custom_request_skills_stddev_pop_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Stddev_Pop_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Custom_Request_Skills_Stddev_Samp_Fields = {
  __typename?: 'custom_request_skills_stddev_samp_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Stddev_Samp_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "custom_request_skills" */
export type Custom_Request_Skills_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Request_Skills_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Request_Skills_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Custom_Request_Skills_Sum_Fields = {
  __typename?: 'custom_request_skills_sum_fields';
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Sum_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** update columns of table "custom_request_skills" */
export enum Custom_Request_Skills_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomRequestId = 'custom_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Custom_Request_Skills_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Custom_Request_Skills_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Custom_Request_Skills_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Request_Skills_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Custom_Request_Skills_Var_Pop_Fields = {
  __typename?: 'custom_request_skills_var_pop_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Var_Pop_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Custom_Request_Skills_Var_Samp_Fields = {
  __typename?: 'custom_request_skills_var_samp_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Var_Samp_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Custom_Request_Skills_Variance_Fields = {
  __typename?: 'custom_request_skills_variance_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "custom_request_skills" */
export type Custom_Request_Skills_Variance_Order_By = {
  skill_id?: Maybe<Order_By>;
};


/** Boolean expression to compare columns of type "custom_request_status". All fields are combined with logical 'AND'. */
export type Custom_Request_Status_Comparison_Exp = {
  _eq?: Maybe<Scalars['custom_request_status']>;
  _gt?: Maybe<Scalars['custom_request_status']>;
  _gte?: Maybe<Scalars['custom_request_status']>;
  _in?: Maybe<Array<Scalars['custom_request_status']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['custom_request_status']>;
  _lte?: Maybe<Scalars['custom_request_status']>;
  _neq?: Maybe<Scalars['custom_request_status']>;
  _nin?: Maybe<Array<Scalars['custom_request_status']>>;
};

/** Streaming cursor of the table "custom_request" */
export type Custom_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Request_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  from_date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  max_budget?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['String']>;
  number_of_contractors?: Maybe<Scalars['String']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['custom_request_status']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "custom_request" */
export enum Custom_Request_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  FromDate = 'from_date',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NumberOfContractors = 'number_of_contractors',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  ToDate = 'to_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export type Custom_Request_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Custom_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Request_Bool_Exp;
};


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

/** columns and relationships of "declined_visit_matches" */
export type Declined_Visit_Matches = {
  __typename?: 'declined_visit_matches';
  /** An object relationship */
  admin?: Maybe<Admin>;
  admin_id?: Maybe<Scalars['uuid']>;
  bookmark_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** An object relationship */
  manager?: Maybe<Manager>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage: Scalars['Int'];
  /** An object relationship */
  project_activity: Project_Activity;
  project_activity_id: Scalars['uuid'];
  /** An object relationship */
  smart_match_bookmark?: Maybe<Smart_Match_Bookmark>;
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "declined_visit_matches" */
export type Declined_Visit_Matches_Aggregate = {
  __typename?: 'declined_visit_matches_aggregate';
  aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Fields>;
  nodes: Array<Declined_Visit_Matches>;
};

export type Declined_Visit_Matches_Aggregate_Bool_Exp = {
  count?: Maybe<Declined_Visit_Matches_Aggregate_Bool_Exp_Count>;
};

export type Declined_Visit_Matches_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Declined_Visit_Matches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "declined_visit_matches" */
export type Declined_Visit_Matches_Aggregate_Fields = {
  __typename?: 'declined_visit_matches_aggregate_fields';
  avg?: Maybe<Declined_Visit_Matches_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Declined_Visit_Matches_Max_Fields>;
  min?: Maybe<Declined_Visit_Matches_Min_Fields>;
  stddev?: Maybe<Declined_Visit_Matches_Stddev_Fields>;
  stddev_pop?: Maybe<Declined_Visit_Matches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Declined_Visit_Matches_Stddev_Samp_Fields>;
  sum?: Maybe<Declined_Visit_Matches_Sum_Fields>;
  var_pop?: Maybe<Declined_Visit_Matches_Var_Pop_Fields>;
  var_samp?: Maybe<Declined_Visit_Matches_Var_Samp_Fields>;
  variance?: Maybe<Declined_Visit_Matches_Variance_Fields>;
};


/** aggregate fields of "declined_visit_matches" */
export type Declined_Visit_Matches_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "declined_visit_matches" */
export type Declined_Visit_Matches_Aggregate_Order_By = {
  avg?: Maybe<Declined_Visit_Matches_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Declined_Visit_Matches_Max_Order_By>;
  min?: Maybe<Declined_Visit_Matches_Min_Order_By>;
  stddev?: Maybe<Declined_Visit_Matches_Stddev_Order_By>;
  stddev_pop?: Maybe<Declined_Visit_Matches_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Declined_Visit_Matches_Stddev_Samp_Order_By>;
  sum?: Maybe<Declined_Visit_Matches_Sum_Order_By>;
  var_pop?: Maybe<Declined_Visit_Matches_Var_Pop_Order_By>;
  var_samp?: Maybe<Declined_Visit_Matches_Var_Samp_Order_By>;
  variance?: Maybe<Declined_Visit_Matches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "declined_visit_matches" */
export type Declined_Visit_Matches_Arr_Rel_Insert_Input = {
  data: Array<Declined_Visit_Matches_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Declined_Visit_Matches_On_Conflict>;
};

/** aggregate avg on columns */
export type Declined_Visit_Matches_Avg_Fields = {
  __typename?: 'declined_visit_matches_avg_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Avg_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declined_visit_matches". All fields are combined with a logical 'AND'. */
export type Declined_Visit_Matches_Bool_Exp = {
  _and?: Maybe<Array<Declined_Visit_Matches_Bool_Exp>>;
  _not?: Maybe<Declined_Visit_Matches_Bool_Exp>;
  _or?: Maybe<Array<Declined_Visit_Matches_Bool_Exp>>;
  admin?: Maybe<Admin_Bool_Exp>;
  admin_id?: Maybe<Uuid_Comparison_Exp>;
  bookmark_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamp_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  match_percentage?: Maybe<Int_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_id?: Maybe<Uuid_Comparison_Exp>;
  smart_match_bookmark?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
  updated_at?: Maybe<Timestamp_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "declined_visit_matches" */
export enum Declined_Visit_Matches_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeclinedVisitMatchesPkey = 'declined_visit_matches_pkey'
}

/** input type for incrementing numeric columns in table "declined_visit_matches" */
export type Declined_Visit_Matches_Inc_Input = {
  match_percentage?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "declined_visit_matches" */
export type Declined_Visit_Matches_Insert_Input = {
  admin?: Maybe<Admin_Obj_Rel_Insert_Input>;
  admin_id?: Maybe<Scalars['uuid']>;
  bookmark_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  smart_match_bookmark?: Maybe<Smart_Match_Bookmark_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Declined_Visit_Matches_Max_Fields = {
  __typename?: 'declined_visit_matches_max_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  bookmark_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Max_Order_By = {
  admin_id?: Maybe<Order_By>;
  bookmark_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  match_percentage?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Declined_Visit_Matches_Min_Fields = {
  __typename?: 'declined_visit_matches_min_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  bookmark_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Min_Order_By = {
  admin_id?: Maybe<Order_By>;
  bookmark_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  match_percentage?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "declined_visit_matches" */
export type Declined_Visit_Matches_Mutation_Response = {
  __typename?: 'declined_visit_matches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declined_Visit_Matches>;
};

/** on_conflict condition type for table "declined_visit_matches" */
export type Declined_Visit_Matches_On_Conflict = {
  constraint: Declined_Visit_Matches_Constraint;
  update_columns?: Array<Declined_Visit_Matches_Update_Column>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};

/** Ordering options when selecting data from "declined_visit_matches". */
export type Declined_Visit_Matches_Order_By = {
  admin?: Maybe<Admin_Order_By>;
  admin_id?: Maybe<Order_By>;
  bookmark_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
  match_percentage?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_id?: Maybe<Order_By>;
  smart_match_bookmark?: Maybe<Smart_Match_Bookmark_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: declined_visit_matches */
export type Declined_Visit_Matches_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "declined_visit_matches" */
export enum Declined_Visit_Matches_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  BookmarkId = 'bookmark_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MatchPercentage = 'match_percentage',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "declined_visit_matches" */
export type Declined_Visit_Matches_Set_Input = {
  admin_id?: Maybe<Scalars['uuid']>;
  bookmark_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Declined_Visit_Matches_Stddev_Fields = {
  __typename?: 'declined_visit_matches_stddev_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Stddev_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Declined_Visit_Matches_Stddev_Pop_Fields = {
  __typename?: 'declined_visit_matches_stddev_pop_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Stddev_Pop_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Declined_Visit_Matches_Stddev_Samp_Fields = {
  __typename?: 'declined_visit_matches_stddev_samp_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Stddev_Samp_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** Streaming cursor of the table "declined_visit_matches" */
export type Declined_Visit_Matches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declined_Visit_Matches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declined_Visit_Matches_Stream_Cursor_Value_Input = {
  admin_id?: Maybe<Scalars['uuid']>;
  bookmark_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Declined_Visit_Matches_Sum_Fields = {
  __typename?: 'declined_visit_matches_sum_fields';
  match_percentage?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Sum_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** update columns of table "declined_visit_matches" */
export enum Declined_Visit_Matches_Update_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  BookmarkId = 'bookmark_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MatchPercentage = 'match_percentage',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Declined_Visit_Matches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Declined_Visit_Matches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Declined_Visit_Matches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Declined_Visit_Matches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Declined_Visit_Matches_Var_Pop_Fields = {
  __typename?: 'declined_visit_matches_var_pop_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Var_Pop_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Declined_Visit_Matches_Var_Samp_Fields = {
  __typename?: 'declined_visit_matches_var_samp_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Var_Samp_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Declined_Visit_Matches_Variance_Fields = {
  __typename?: 'declined_visit_matches_variance_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "declined_visit_matches" */
export type Declined_Visit_Matches_Variance_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** columns and relationships of "document" */
export type Document = {
  __typename?: 'document';
  added_by?: Maybe<Scalars['String']>;
  /** An array relationship */
  applications: Array<Application>;
  /** An aggregate relationship */
  applications_aggregate: Application_Aggregate;
  /** An array relationship */
  attached_to: Array<Document_User>;
  /** An aggregate relationship */
  attached_to_aggregate: Document_User_Aggregate;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  document_contractor_accesses: Array<Document_Contractor_Access>;
  /** An aggregate relationship */
  document_contractor_accesses_aggregate: Document_Contractor_Access_Aggregate;
  /** An array relationship */
  document_custom_requests: Array<Document_Custom_Request>;
  /** An aggregate relationship */
  document_custom_requests_aggregate: Document_Custom_Request_Aggregate;
  /** An array relationship */
  document_projects: Array<Document_Project>;
  /** An aggregate relationship */
  document_projects_aggregate: Document_Project_Aggregate;
  filename?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** An object relationship */
  team?: Maybe<Team>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<User>;
};


/** columns and relationships of "document" */
export type DocumentApplicationsArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentApplications_AggregateArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentAttached_ToArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentAttached_To_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_Contractor_AccessesArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_Contractor_Accesses_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_Custom_RequestsArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_Custom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_ProjectsArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


/** columns and relationships of "document" */
export type DocumentDocument_Projects_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};

/** aggregated selection of "document" */
export type Document_Aggregate = {
  __typename?: 'document_aggregate';
  aggregate?: Maybe<Document_Aggregate_Fields>;
  nodes: Array<Document>;
};

export type Document_Aggregate_Bool_Exp = {
  count?: Maybe<Document_Aggregate_Bool_Exp_Count>;
};

export type Document_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "document" */
export type Document_Aggregate_Fields = {
  __typename?: 'document_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_Max_Fields>;
  min?: Maybe<Document_Min_Fields>;
};


/** aggregate fields of "document" */
export type Document_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document" */
export type Document_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Document_Max_Order_By>;
  min?: Maybe<Document_Min_Order_By>;
};

/** input type for inserting array relation for remote table "document" */
export type Document_Arr_Rel_Insert_Input = {
  data: Array<Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Document_On_Conflict>;
};

/** Boolean expression to filter rows from the table "document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: Maybe<Array<Document_Bool_Exp>>;
  _not?: Maybe<Document_Bool_Exp>;
  _or?: Maybe<Array<Document_Bool_Exp>>;
  added_by?: Maybe<String_Comparison_Exp>;
  applications?: Maybe<Application_Bool_Exp>;
  applications_aggregate?: Maybe<Application_Aggregate_Bool_Exp>;
  attached_to?: Maybe<Document_User_Bool_Exp>;
  attached_to_aggregate?: Maybe<Document_User_Aggregate_Bool_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  document_contractor_accesses?: Maybe<Document_Contractor_Access_Bool_Exp>;
  document_contractor_accesses_aggregate?: Maybe<Document_Contractor_Access_Aggregate_Bool_Exp>;
  document_custom_requests?: Maybe<Document_Custom_Request_Bool_Exp>;
  document_custom_requests_aggregate?: Maybe<Document_Custom_Request_Aggregate_Bool_Exp>;
  document_projects?: Maybe<Document_Project_Bool_Exp>;
  document_projects_aggregate?: Maybe<Document_Project_Aggregate_Bool_Exp>;
  filename?: Maybe<String_Comparison_Exp>;
  format?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  size?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  team?: Maybe<Team_Bool_Exp>;
  team_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  uploaded_by?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "document" */
export enum Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentPkey = 'document_pkey'
}

/** columns and relationships of "document_contractor_access" */
export type Document_Contractor_Access = {
  __typename?: 'document_contractor_access';
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  document: Document;
  document_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "document_contractor_access" */
export type Document_Contractor_Access_Aggregate = {
  __typename?: 'document_contractor_access_aggregate';
  aggregate?: Maybe<Document_Contractor_Access_Aggregate_Fields>;
  nodes: Array<Document_Contractor_Access>;
};

export type Document_Contractor_Access_Aggregate_Bool_Exp = {
  count?: Maybe<Document_Contractor_Access_Aggregate_Bool_Exp_Count>;
};

export type Document_Contractor_Access_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Contractor_Access_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "document_contractor_access" */
export type Document_Contractor_Access_Aggregate_Fields = {
  __typename?: 'document_contractor_access_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_Contractor_Access_Max_Fields>;
  min?: Maybe<Document_Contractor_Access_Min_Fields>;
};


/** aggregate fields of "document_contractor_access" */
export type Document_Contractor_Access_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_contractor_access" */
export type Document_Contractor_Access_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Document_Contractor_Access_Max_Order_By>;
  min?: Maybe<Document_Contractor_Access_Min_Order_By>;
};

/** input type for inserting array relation for remote table "document_contractor_access" */
export type Document_Contractor_Access_Arr_Rel_Insert_Input = {
  data: Array<Document_Contractor_Access_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Document_Contractor_Access_On_Conflict>;
};

/** Boolean expression to filter rows from the table "document_contractor_access". All fields are combined with a logical 'AND'. */
export type Document_Contractor_Access_Bool_Exp = {
  _and?: Maybe<Array<Document_Contractor_Access_Bool_Exp>>;
  _not?: Maybe<Document_Contractor_Access_Bool_Exp>;
  _or?: Maybe<Array<Document_Contractor_Access_Bool_Exp>>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  document?: Maybe<Document_Bool_Exp>;
  document_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_contractor_access" */
export enum Document_Contractor_Access_Constraint {
  /** unique or primary key constraint on columns "contractor_id", "document_id" */
  DocumentContractorAccessContractorIdDocumentIdKey = 'document_contractor_access_contractor_id_document_id_key',
  /** unique or primary key constraint on columns "id" */
  DocumentContractorAccessPkey = 'document_contractor_access_pkey'
}

/** input type for inserting data into table "document_contractor_access" */
export type Document_Contractor_Access_Insert_Input = {
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Document_Obj_Rel_Insert_Input>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Document_Contractor_Access_Max_Fields = {
  __typename?: 'document_contractor_access_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "document_contractor_access" */
export type Document_Contractor_Access_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Contractor_Access_Min_Fields = {
  __typename?: 'document_contractor_access_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "document_contractor_access" */
export type Document_Contractor_Access_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "document_contractor_access" */
export type Document_Contractor_Access_Mutation_Response = {
  __typename?: 'document_contractor_access_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Contractor_Access>;
};

/** on_conflict condition type for table "document_contractor_access" */
export type Document_Contractor_Access_On_Conflict = {
  constraint: Document_Contractor_Access_Constraint;
  update_columns?: Array<Document_Contractor_Access_Update_Column>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "document_contractor_access". */
export type Document_Contractor_Access_Order_By = {
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document?: Maybe<Document_Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: document_contractor_access */
export type Document_Contractor_Access_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "document_contractor_access" */
export enum Document_Contractor_Access_Select_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "document_contractor_access" */
export type Document_Contractor_Access_Set_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "document_contractor_access" */
export type Document_Contractor_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Contractor_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Contractor_Access_Stream_Cursor_Value_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "document_contractor_access" */
export enum Document_Contractor_Access_Update_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id'
}

export type Document_Contractor_Access_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Contractor_Access_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Contractor_Access_Bool_Exp;
};

/** Track documents attached to a custom request */
export type Document_Custom_Request = {
  __typename?: 'document_custom_request';
  created_at: Scalars['timestamptz'];
  /** User who uploaded the document */
  created_by: Scalars['uuid'];
  /** An object relationship */
  custom_request: Custom_Request;
  /** Custom request to which the document is attached to */
  custom_request_id: Scalars['uuid'];
  /** An object relationship */
  document: Document;
  /** The document in question */
  document_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: User;
};

/** aggregated selection of "document_custom_request" */
export type Document_Custom_Request_Aggregate = {
  __typename?: 'document_custom_request_aggregate';
  aggregate?: Maybe<Document_Custom_Request_Aggregate_Fields>;
  nodes: Array<Document_Custom_Request>;
};

export type Document_Custom_Request_Aggregate_Bool_Exp = {
  count?: Maybe<Document_Custom_Request_Aggregate_Bool_Exp_Count>;
};

export type Document_Custom_Request_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Custom_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "document_custom_request" */
export type Document_Custom_Request_Aggregate_Fields = {
  __typename?: 'document_custom_request_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_Custom_Request_Max_Fields>;
  min?: Maybe<Document_Custom_Request_Min_Fields>;
};


/** aggregate fields of "document_custom_request" */
export type Document_Custom_Request_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_custom_request" */
export type Document_Custom_Request_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Document_Custom_Request_Max_Order_By>;
  min?: Maybe<Document_Custom_Request_Min_Order_By>;
};

/** input type for inserting array relation for remote table "document_custom_request" */
export type Document_Custom_Request_Arr_Rel_Insert_Input = {
  data: Array<Document_Custom_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Document_Custom_Request_On_Conflict>;
};

/** Boolean expression to filter rows from the table "document_custom_request". All fields are combined with a logical 'AND'. */
export type Document_Custom_Request_Bool_Exp = {
  _and?: Maybe<Array<Document_Custom_Request_Bool_Exp>>;
  _not?: Maybe<Document_Custom_Request_Bool_Exp>;
  _or?: Maybe<Array<Document_Custom_Request_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  custom_request?: Maybe<Custom_Request_Bool_Exp>;
  custom_request_id?: Maybe<Uuid_Comparison_Exp>;
  document?: Maybe<Document_Bool_Exp>;
  document_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "document_custom_request" */
export enum Document_Custom_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentCustomRequestPkey = 'document_custom_request_pkey'
}

/** input type for inserting data into table "document_custom_request" */
export type Document_Custom_Request_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** User who uploaded the document */
  created_by?: Maybe<Scalars['uuid']>;
  custom_request?: Maybe<Custom_Request_Obj_Rel_Insert_Input>;
  /** Custom request to which the document is attached to */
  custom_request_id?: Maybe<Scalars['uuid']>;
  document?: Maybe<Document_Obj_Rel_Insert_Input>;
  /** The document in question */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Document_Custom_Request_Max_Fields = {
  __typename?: 'document_custom_request_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** User who uploaded the document */
  created_by?: Maybe<Scalars['uuid']>;
  /** Custom request to which the document is attached to */
  custom_request_id?: Maybe<Scalars['uuid']>;
  /** The document in question */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "document_custom_request" */
export type Document_Custom_Request_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  /** User who uploaded the document */
  created_by?: Maybe<Order_By>;
  /** Custom request to which the document is attached to */
  custom_request_id?: Maybe<Order_By>;
  /** The document in question */
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Custom_Request_Min_Fields = {
  __typename?: 'document_custom_request_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** User who uploaded the document */
  created_by?: Maybe<Scalars['uuid']>;
  /** Custom request to which the document is attached to */
  custom_request_id?: Maybe<Scalars['uuid']>;
  /** The document in question */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "document_custom_request" */
export type Document_Custom_Request_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  /** User who uploaded the document */
  created_by?: Maybe<Order_By>;
  /** Custom request to which the document is attached to */
  custom_request_id?: Maybe<Order_By>;
  /** The document in question */
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "document_custom_request" */
export type Document_Custom_Request_Mutation_Response = {
  __typename?: 'document_custom_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Custom_Request>;
};

/** on_conflict condition type for table "document_custom_request" */
export type Document_Custom_Request_On_Conflict = {
  constraint: Document_Custom_Request_Constraint;
  update_columns?: Array<Document_Custom_Request_Update_Column>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "document_custom_request". */
export type Document_Custom_Request_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  custom_request?: Maybe<Custom_Request_Order_By>;
  custom_request_id?: Maybe<Order_By>;
  document?: Maybe<Document_Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
};

/** primary key columns input for table: document_custom_request */
export type Document_Custom_Request_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "document_custom_request" */
export enum Document_Custom_Request_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomRequestId = 'custom_request_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "document_custom_request" */
export type Document_Custom_Request_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** User who uploaded the document */
  created_by?: Maybe<Scalars['uuid']>;
  /** Custom request to which the document is attached to */
  custom_request_id?: Maybe<Scalars['uuid']>;
  /** The document in question */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "document_custom_request" */
export type Document_Custom_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Custom_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Custom_Request_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** User who uploaded the document */
  created_by?: Maybe<Scalars['uuid']>;
  /** Custom request to which the document is attached to */
  custom_request_id?: Maybe<Scalars['uuid']>;
  /** The document in question */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "document_custom_request" */
export enum Document_Custom_Request_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomRequestId = 'custom_request_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id'
}

export type Document_Custom_Request_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Custom_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Custom_Request_Bool_Exp;
};

/** input type for inserting data into table "document" */
export type Document_Insert_Input = {
  added_by?: Maybe<Scalars['String']>;
  applications?: Maybe<Application_Arr_Rel_Insert_Input>;
  attached_to?: Maybe<Document_User_Arr_Rel_Insert_Input>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_contractor_accesses?: Maybe<Document_Contractor_Access_Arr_Rel_Insert_Input>;
  document_custom_requests?: Maybe<Document_Custom_Request_Arr_Rel_Insert_Input>;
  document_projects?: Maybe<Document_Project_Arr_Rel_Insert_Input>;
  filename?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  team?: Maybe<Team_Obj_Rel_Insert_Input>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_by?: Maybe<Scalars['uuid']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Document_Max_Fields = {
  __typename?: 'document_max_fields';
  added_by?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "document" */
export type Document_Max_Order_By = {
  added_by?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  filename?: Maybe<Order_By>;
  format?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uploaded_by?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Min_Fields = {
  __typename?: 'document_min_fields';
  added_by?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "document" */
export type Document_Min_Order_By = {
  added_by?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  filename?: Maybe<Order_By>;
  format?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uploaded_by?: Maybe<Order_By>;
};

/** response of any mutation on the table "document" */
export type Document_Mutation_Response = {
  __typename?: 'document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document>;
};

/** input type for inserting object relation for remote table "document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Document_On_Conflict>;
};

/** on_conflict condition type for table "document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: Maybe<Document_Bool_Exp>;
};

/** Ordering options when selecting data from "document". */
export type Document_Order_By = {
  added_by?: Maybe<Order_By>;
  applications_aggregate?: Maybe<Application_Aggregate_Order_By>;
  attached_to_aggregate?: Maybe<Document_User_Aggregate_Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_contractor_accesses_aggregate?: Maybe<Document_Contractor_Access_Aggregate_Order_By>;
  document_custom_requests_aggregate?: Maybe<Document_Custom_Request_Aggregate_Order_By>;
  document_projects_aggregate?: Maybe<Document_Project_Aggregate_Order_By>;
  filename?: Maybe<Order_By>;
  format?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  team?: Maybe<Team_Order_By>;
  team_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uploaded_by?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
};

/** primary key columns input for table: document */
export type Document_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "document_project" */
export type Document_Project = {
  __typename?: 'document_project';
  access_scope: Scalars['document_project_access_scope'];
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  document: Document;
  document_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_core_plan?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid'];
};


/** Boolean expression to compare columns of type "document_project_access_scope". All fields are combined with logical 'AND'. */
export type Document_Project_Access_Scope_Comparison_Exp = {
  _eq?: Maybe<Scalars['document_project_access_scope']>;
  _gt?: Maybe<Scalars['document_project_access_scope']>;
  _gte?: Maybe<Scalars['document_project_access_scope']>;
  _in?: Maybe<Array<Scalars['document_project_access_scope']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['document_project_access_scope']>;
  _lte?: Maybe<Scalars['document_project_access_scope']>;
  _neq?: Maybe<Scalars['document_project_access_scope']>;
  _nin?: Maybe<Array<Scalars['document_project_access_scope']>>;
};

/** aggregated selection of "document_project" */
export type Document_Project_Aggregate = {
  __typename?: 'document_project_aggregate';
  aggregate?: Maybe<Document_Project_Aggregate_Fields>;
  nodes: Array<Document_Project>;
};

export type Document_Project_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Document_Project_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Document_Project_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Document_Project_Aggregate_Bool_Exp_Count>;
};

export type Document_Project_Aggregate_Bool_Exp_Bool_And = {
  arguments: Document_Project_Select_Column_Document_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Document_Project_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Document_Project_Select_Column_Document_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Document_Project_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Document_Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "document_project" */
export type Document_Project_Aggregate_Fields = {
  __typename?: 'document_project_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_Project_Max_Fields>;
  min?: Maybe<Document_Project_Min_Fields>;
};


/** aggregate fields of "document_project" */
export type Document_Project_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_project" */
export type Document_Project_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Document_Project_Max_Order_By>;
  min?: Maybe<Document_Project_Min_Order_By>;
};

/** input type for inserting array relation for remote table "document_project" */
export type Document_Project_Arr_Rel_Insert_Input = {
  data: Array<Document_Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Document_Project_On_Conflict>;
};

/** Boolean expression to filter rows from the table "document_project". All fields are combined with a logical 'AND'. */
export type Document_Project_Bool_Exp = {
  _and?: Maybe<Array<Document_Project_Bool_Exp>>;
  _not?: Maybe<Document_Project_Bool_Exp>;
  _or?: Maybe<Array<Document_Project_Bool_Exp>>;
  access_scope?: Maybe<Document_Project_Access_Scope_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  document?: Maybe<Document_Bool_Exp>;
  document_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_core_plan?: Maybe<Boolean_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_project" */
export enum Document_Project_Constraint {
  /** unique or primary key constraint on columns "project_id", "document_id" */
  DocumentProjectDocumentIdProjectIdKey = 'document_project_document_id_project_id_key',
  /** unique or primary key constraint on columns "id" */
  DocumentProjectPkey = 'document_project_pkey'
}

/** input type for inserting data into table "document_project" */
export type Document_Project_Insert_Input = {
  access_scope?: Maybe<Scalars['document_project_access_scope']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Document_Obj_Rel_Insert_Input>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_core_plan?: Maybe<Scalars['Boolean']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Document_Project_Max_Fields = {
  __typename?: 'document_project_max_fields';
  access_scope?: Maybe<Scalars['document_project_access_scope']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "document_project" */
export type Document_Project_Max_Order_By = {
  access_scope?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Project_Min_Fields = {
  __typename?: 'document_project_min_fields';
  access_scope?: Maybe<Scalars['document_project_access_scope']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "document_project" */
export type Document_Project_Min_Order_By = {
  access_scope?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "document_project" */
export type Document_Project_Mutation_Response = {
  __typename?: 'document_project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Project>;
};

/** on_conflict condition type for table "document_project" */
export type Document_Project_On_Conflict = {
  constraint: Document_Project_Constraint;
  update_columns?: Array<Document_Project_Update_Column>;
  where?: Maybe<Document_Project_Bool_Exp>;
};

/** Ordering options when selecting data from "document_project". */
export type Document_Project_Order_By = {
  access_scope?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  document?: Maybe<Document_Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_core_plan?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
};

/** primary key columns input for table: document_project */
export type Document_Project_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "document_project" */
export enum Document_Project_Select_Column {
  /** column name */
  AccessScope = 'access_scope',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorePlan = 'is_core_plan',
  /** column name */
  ProjectId = 'project_id'
}

/** select "document_project_aggregate_bool_exp_bool_and_arguments_columns" columns of table "document_project" */
export enum Document_Project_Select_Column_Document_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCorePlan = 'is_core_plan'
}

/** select "document_project_aggregate_bool_exp_bool_or_arguments_columns" columns of table "document_project" */
export enum Document_Project_Select_Column_Document_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCorePlan = 'is_core_plan'
}

/** input type for updating data in table "document_project" */
export type Document_Project_Set_Input = {
  access_scope?: Maybe<Scalars['document_project_access_scope']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_core_plan?: Maybe<Scalars['Boolean']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "document_project" */
export type Document_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Project_Stream_Cursor_Value_Input = {
  access_scope?: Maybe<Scalars['document_project_access_scope']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_core_plan?: Maybe<Scalars['Boolean']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "document_project" */
export enum Document_Project_Update_Column {
  /** column name */
  AccessScope = 'access_scope',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsCorePlan = 'is_core_plan',
  /** column name */
  ProjectId = 'project_id'
}

export type Document_Project_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Project_Bool_Exp;
};

/** select columns of table "document" */
export enum Document_Select_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Format = 'format',
  /** column name */
  Id = 'id',
  /** column name */
  Size = 'size',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedBy = 'uploaded_by'
}

/** input type for updating data in table "document" */
export type Document_Set_Input = {
  added_by?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_by?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  added_by?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  filename?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_by?: Maybe<Scalars['uuid']>;
};

/** update columns of table "document" */
export enum Document_Update_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Filename = 'filename',
  /** column name */
  Format = 'format',
  /** column name */
  Id = 'id',
  /** column name */
  Size = 'size',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedBy = 'uploaded_by'
}

export type Document_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Bool_Exp;
};

/** columns and relationships of "document_user" */
export type Document_User = {
  __typename?: 'document_user';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  document: Document;
  /** The Document attached to the user */
  document_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: User;
  /** The user to which the document was attached */
  user_id: Scalars['uuid'];
};

/** aggregated selection of "document_user" */
export type Document_User_Aggregate = {
  __typename?: 'document_user_aggregate';
  aggregate?: Maybe<Document_User_Aggregate_Fields>;
  nodes: Array<Document_User>;
};

export type Document_User_Aggregate_Bool_Exp = {
  count?: Maybe<Document_User_Aggregate_Bool_Exp_Count>;
};

export type Document_User_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Document_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Document_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "document_user" */
export type Document_User_Aggregate_Fields = {
  __typename?: 'document_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Document_User_Max_Fields>;
  min?: Maybe<Document_User_Min_Fields>;
};


/** aggregate fields of "document_user" */
export type Document_User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Document_User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "document_user" */
export type Document_User_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Document_User_Max_Order_By>;
  min?: Maybe<Document_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "document_user" */
export type Document_User_Arr_Rel_Insert_Input = {
  data: Array<Document_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Document_User_On_Conflict>;
};

/** Boolean expression to filter rows from the table "document_user". All fields are combined with a logical 'AND'. */
export type Document_User_Bool_Exp = {
  _and?: Maybe<Array<Document_User_Bool_Exp>>;
  _not?: Maybe<Document_User_Bool_Exp>;
  _or?: Maybe<Array<Document_User_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  document?: Maybe<Document_Bool_Exp>;
  document_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_user" */
export enum Document_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentUserPkey = 'document_user_pkey'
}

/** input type for inserting data into table "document_user" */
export type Document_User_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  document?: Maybe<Document_Obj_Rel_Insert_Input>;
  /** The Document attached to the user */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  /** The user to which the document was attached */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Document_User_Max_Fields = {
  __typename?: 'document_user_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Document attached to the user */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The user to which the document was attached */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "document_user" */
export type Document_User_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  /** The Document attached to the user */
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  /** The user to which the document was attached */
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Document_User_Min_Fields = {
  __typename?: 'document_user_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Document attached to the user */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The user to which the document was attached */
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "document_user" */
export type Document_User_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  /** The Document attached to the user */
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  /** The user to which the document was attached */
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "document_user" */
export type Document_User_Mutation_Response = {
  __typename?: 'document_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_User>;
};

/** on_conflict condition type for table "document_user" */
export type Document_User_On_Conflict = {
  constraint: Document_User_Constraint;
  update_columns?: Array<Document_User_Update_Column>;
  where?: Maybe<Document_User_Bool_Exp>;
};

/** Ordering options when selecting data from "document_user". */
export type Document_User_Order_By = {
  created_at?: Maybe<Order_By>;
  document?: Maybe<Document_Order_By>;
  document_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: document_user */
export type Document_User_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "document_user" */
export enum Document_User_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "document_user" */
export type Document_User_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Document attached to the user */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The user to which the document was attached */
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "document_user" */
export type Document_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_User_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  /** The Document attached to the user */
  document_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** The user to which the document was attached */
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "document_user" */
export enum Document_User_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Document_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Document_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_User_Bool_Exp;
};

/** columns and relationships of "email_regex" */
export type Email_Regex = {
  __typename?: 'email_regex';
  active_status?: Maybe<Scalars['Boolean']>;
  email_extension?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "email_regex" */
export type Email_Regex_Aggregate = {
  __typename?: 'email_regex_aggregate';
  aggregate?: Maybe<Email_Regex_Aggregate_Fields>;
  nodes: Array<Email_Regex>;
};

/** aggregate fields of "email_regex" */
export type Email_Regex_Aggregate_Fields = {
  __typename?: 'email_regex_aggregate_fields';
  avg?: Maybe<Email_Regex_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Email_Regex_Max_Fields>;
  min?: Maybe<Email_Regex_Min_Fields>;
  stddev?: Maybe<Email_Regex_Stddev_Fields>;
  stddev_pop?: Maybe<Email_Regex_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Email_Regex_Stddev_Samp_Fields>;
  sum?: Maybe<Email_Regex_Sum_Fields>;
  var_pop?: Maybe<Email_Regex_Var_Pop_Fields>;
  var_samp?: Maybe<Email_Regex_Var_Samp_Fields>;
  variance?: Maybe<Email_Regex_Variance_Fields>;
};


/** aggregate fields of "email_regex" */
export type Email_Regex_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Email_Regex_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Email_Regex_Avg_Fields = {
  __typename?: 'email_regex_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "email_regex". All fields are combined with a logical 'AND'. */
export type Email_Regex_Bool_Exp = {
  _and?: Maybe<Array<Email_Regex_Bool_Exp>>;
  _not?: Maybe<Email_Regex_Bool_Exp>;
  _or?: Maybe<Array<Email_Regex_Bool_Exp>>;
  active_status?: Maybe<Boolean_Comparison_Exp>;
  email_extension?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_regex" */
export enum Email_Regex_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailRegexPkey = 'email_regex_pkey'
}

/** input type for incrementing numeric columns in table "email_regex" */
export type Email_Regex_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "email_regex" */
export type Email_Regex_Insert_Input = {
  active_status?: Maybe<Scalars['Boolean']>;
  email_extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Email_Regex_Max_Fields = {
  __typename?: 'email_regex_max_fields';
  email_extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Email_Regex_Min_Fields = {
  __typename?: 'email_regex_min_fields';
  email_extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "email_regex" */
export type Email_Regex_Mutation_Response = {
  __typename?: 'email_regex_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Regex>;
};

/** on_conflict condition type for table "email_regex" */
export type Email_Regex_On_Conflict = {
  constraint: Email_Regex_Constraint;
  update_columns?: Array<Email_Regex_Update_Column>;
  where?: Maybe<Email_Regex_Bool_Exp>;
};

/** Ordering options when selecting data from "email_regex". */
export type Email_Regex_Order_By = {
  active_status?: Maybe<Order_By>;
  email_extension?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** primary key columns input for table: email_regex */
export type Email_Regex_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "email_regex" */
export enum Email_Regex_Select_Column {
  /** column name */
  ActiveStatus = 'active_status',
  /** column name */
  EmailExtension = 'email_extension',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "email_regex" */
export type Email_Regex_Set_Input = {
  active_status?: Maybe<Scalars['Boolean']>;
  email_extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Email_Regex_Stddev_Fields = {
  __typename?: 'email_regex_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Email_Regex_Stddev_Pop_Fields = {
  __typename?: 'email_regex_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Email_Regex_Stddev_Samp_Fields = {
  __typename?: 'email_regex_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "email_regex" */
export type Email_Regex_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Regex_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Regex_Stream_Cursor_Value_Input = {
  active_status?: Maybe<Scalars['Boolean']>;
  email_extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Email_Regex_Sum_Fields = {
  __typename?: 'email_regex_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "email_regex" */
export enum Email_Regex_Update_Column {
  /** column name */
  ActiveStatus = 'active_status',
  /** column name */
  EmailExtension = 'email_extension',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Email_Regex_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Email_Regex_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Email_Regex_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Regex_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Regex_Var_Pop_Fields = {
  __typename?: 'email_regex_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Email_Regex_Var_Samp_Fields = {
  __typename?: 'email_regex_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Email_Regex_Variance_Fields = {
  __typename?: 'email_regex_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "experience_skill" */
export type Experience_Skill = {
  __typename?: 'experience_skill';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  experience: User_Experience;
  experience_id: Scalars['uuid'];
  id: Scalars['Int'];
  /** An object relationship */
  skill: Skill;
  skill_id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "experience_skill" */
export type Experience_Skill_Aggregate = {
  __typename?: 'experience_skill_aggregate';
  aggregate?: Maybe<Experience_Skill_Aggregate_Fields>;
  nodes: Array<Experience_Skill>;
};

export type Experience_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Experience_Skill_Aggregate_Bool_Exp_Count>;
};

export type Experience_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Experience_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Experience_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "experience_skill" */
export type Experience_Skill_Aggregate_Fields = {
  __typename?: 'experience_skill_aggregate_fields';
  avg?: Maybe<Experience_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Experience_Skill_Max_Fields>;
  min?: Maybe<Experience_Skill_Min_Fields>;
  stddev?: Maybe<Experience_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Experience_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Experience_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Experience_Skill_Sum_Fields>;
  var_pop?: Maybe<Experience_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Experience_Skill_Var_Samp_Fields>;
  variance?: Maybe<Experience_Skill_Variance_Fields>;
};


/** aggregate fields of "experience_skill" */
export type Experience_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Experience_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "experience_skill" */
export type Experience_Skill_Aggregate_Order_By = {
  avg?: Maybe<Experience_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Experience_Skill_Max_Order_By>;
  min?: Maybe<Experience_Skill_Min_Order_By>;
  stddev?: Maybe<Experience_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Experience_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Experience_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Experience_Skill_Sum_Order_By>;
  var_pop?: Maybe<Experience_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Experience_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Experience_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "experience_skill" */
export type Experience_Skill_Arr_Rel_Insert_Input = {
  data: Array<Experience_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Experience_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Experience_Skill_Avg_Fields = {
  __typename?: 'experience_skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "experience_skill" */
export type Experience_Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "experience_skill". All fields are combined with a logical 'AND'. */
export type Experience_Skill_Bool_Exp = {
  _and?: Maybe<Array<Experience_Skill_Bool_Exp>>;
  _not?: Maybe<Experience_Skill_Bool_Exp>;
  _or?: Maybe<Array<Experience_Skill_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  experience?: Maybe<User_Experience_Bool_Exp>;
  experience_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  skill?: Maybe<Skill_Bool_Exp>;
  skill_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "experience_skill" */
export enum Experience_Skill_Constraint {
  /** unique or primary key constraint on columns "skill_id", "experience_id" */
  ExperienceSkillExperienceIdSkillIdKey = 'experience_skill_experience_id_skill_id_key',
  /** unique or primary key constraint on columns "id" */
  ExperienceSkillPkey = 'experience_skill_pkey'
}

/** input type for incrementing numeric columns in table "experience_skill" */
export type Experience_Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "experience_skill" */
export type Experience_Skill_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  experience?: Maybe<User_Experience_Obj_Rel_Insert_Input>;
  experience_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  skill?: Maybe<Skill_Obj_Rel_Insert_Input>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Experience_Skill_Max_Fields = {
  __typename?: 'experience_skill_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  experience_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "experience_skill" */
export type Experience_Skill_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  experience_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Experience_Skill_Min_Fields = {
  __typename?: 'experience_skill_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  experience_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "experience_skill" */
export type Experience_Skill_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  experience_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "experience_skill" */
export type Experience_Skill_Mutation_Response = {
  __typename?: 'experience_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Experience_Skill>;
};

/** on_conflict condition type for table "experience_skill" */
export type Experience_Skill_On_Conflict = {
  constraint: Experience_Skill_Constraint;
  update_columns?: Array<Experience_Skill_Update_Column>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "experience_skill". */
export type Experience_Skill_Order_By = {
  created_at?: Maybe<Order_By>;
  experience?: Maybe<User_Experience_Order_By>;
  experience_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill?: Maybe<Skill_Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: experience_skill */
export type Experience_Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "experience_skill" */
export enum Experience_Skill_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExperienceId = 'experience_id',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "experience_skill" */
export type Experience_Skill_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  experience_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Experience_Skill_Stddev_Fields = {
  __typename?: 'experience_skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "experience_skill" */
export type Experience_Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Experience_Skill_Stddev_Pop_Fields = {
  __typename?: 'experience_skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "experience_skill" */
export type Experience_Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Experience_Skill_Stddev_Samp_Fields = {
  __typename?: 'experience_skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "experience_skill" */
export type Experience_Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "experience_skill" */
export type Experience_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Experience_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Experience_Skill_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  experience_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Experience_Skill_Sum_Fields = {
  __typename?: 'experience_skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "experience_skill" */
export type Experience_Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** update columns of table "experience_skill" */
export enum Experience_Skill_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExperienceId = 'experience_id',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Experience_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Experience_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Experience_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Experience_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Experience_Skill_Var_Pop_Fields = {
  __typename?: 'experience_skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "experience_skill" */
export type Experience_Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Experience_Skill_Var_Samp_Fields = {
  __typename?: 'experience_skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "experience_skill" */
export type Experience_Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Experience_Skill_Variance_Fields = {
  __typename?: 'experience_skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "experience_skill" */
export type Experience_Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "gender" */
export type Gender = {
  __typename?: 'gender';
  /** An array relationship */
  client_care_plans: Array<Client_Care_Plan>;
  /** An aggregate relationship */
  client_care_plans_aggregate: Client_Care_Plan_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "gender" */
export type GenderClient_Care_PlansArgs = {
  distinct_on?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Care_Plan_Order_By>>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};


/** columns and relationships of "gender" */
export type GenderClient_Care_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Care_Plan_Order_By>>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};

/** aggregated selection of "gender" */
export type Gender_Aggregate = {
  __typename?: 'gender_aggregate';
  aggregate?: Maybe<Gender_Aggregate_Fields>;
  nodes: Array<Gender>;
};

/** aggregate fields of "gender" */
export type Gender_Aggregate_Fields = {
  __typename?: 'gender_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Gender_Max_Fields>;
  min?: Maybe<Gender_Min_Fields>;
};


/** aggregate fields of "gender" */
export type Gender_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Gender_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "gender". All fields are combined with a logical 'AND'. */
export type Gender_Bool_Exp = {
  _and?: Maybe<Array<Gender_Bool_Exp>>;
  _not?: Maybe<Gender_Bool_Exp>;
  _or?: Maybe<Array<Gender_Bool_Exp>>;
  client_care_plans?: Maybe<Client_Care_Plan_Bool_Exp>;
  client_care_plans_aggregate?: Maybe<Client_Care_Plan_Aggregate_Bool_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gender" */
export enum Gender_Constraint {
  /** unique or primary key constraint on columns "value" */
  GenderPkey = 'gender_pkey'
}

export enum Gender_Enum {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

/** Boolean expression to compare columns of type "gender_enum". All fields are combined with logical 'AND'. */
export type Gender_Enum_Comparison_Exp = {
  _eq?: Maybe<Gender_Enum>;
  _in?: Maybe<Array<Gender_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Gender_Enum>;
  _nin?: Maybe<Array<Gender_Enum>>;
};

/** input type for inserting data into table "gender" */
export type Gender_Insert_Input = {
  client_care_plans?: Maybe<Client_Care_Plan_Arr_Rel_Insert_Input>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Gender_Max_Fields = {
  __typename?: 'gender_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Gender_Min_Fields = {
  __typename?: 'gender_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gender" */
export type Gender_Mutation_Response = {
  __typename?: 'gender_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gender>;
};

/** input type for inserting object relation for remote table "gender" */
export type Gender_Obj_Rel_Insert_Input = {
  data: Gender_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Gender_On_Conflict>;
};

/** on_conflict condition type for table "gender" */
export type Gender_On_Conflict = {
  constraint: Gender_Constraint;
  update_columns?: Array<Gender_Update_Column>;
  where?: Maybe<Gender_Bool_Exp>;
};

/** Ordering options when selecting data from "gender". */
export type Gender_Order_By = {
  client_care_plans_aggregate?: Maybe<Client_Care_Plan_Aggregate_Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: gender */
export type Gender_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "gender" */
export enum Gender_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "gender" */
export type Gender_Set_Input = {
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "gender" */
export type Gender_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gender_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gender_Stream_Cursor_Value_Input = {
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "gender" */
export enum Gender_Update_Column {
  /** column name */
  Value = 'value'
}

export type Gender_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Gender_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gender_Bool_Exp;
};

/** columns and relationships of "industry" */
export type Industry = {
  __typename?: 'industry';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  posting_industries: Array<Posting_Industry>;
  /** An aggregate relationship */
  posting_industries_aggregate: Posting_Industry_Aggregate;
  /** An array relationship */
  user_experiences: Array<User_Experience>;
  /** An aggregate relationship */
  user_experiences_aggregate: User_Experience_Aggregate;
  /** An array relationship */
  users: Array<User_Industry>;
  /** An aggregate relationship */
  users_aggregate: User_Industry_Aggregate;
};


/** columns and relationships of "industry" */
export type IndustryPosting_IndustriesArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


/** columns and relationships of "industry" */
export type IndustryPosting_Industries_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


/** columns and relationships of "industry" */
export type IndustryUser_ExperiencesArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


/** columns and relationships of "industry" */
export type IndustryUser_Experiences_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


/** columns and relationships of "industry" */
export type IndustryUsersArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


/** columns and relationships of "industry" */
export type IndustryUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};

/** aggregated selection of "industry" */
export type Industry_Aggregate = {
  __typename?: 'industry_aggregate';
  aggregate?: Maybe<Industry_Aggregate_Fields>;
  nodes: Array<Industry>;
};

/** aggregate fields of "industry" */
export type Industry_Aggregate_Fields = {
  __typename?: 'industry_aggregate_fields';
  avg?: Maybe<Industry_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Industry_Max_Fields>;
  min?: Maybe<Industry_Min_Fields>;
  stddev?: Maybe<Industry_Stddev_Fields>;
  stddev_pop?: Maybe<Industry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Industry_Stddev_Samp_Fields>;
  sum?: Maybe<Industry_Sum_Fields>;
  var_pop?: Maybe<Industry_Var_Pop_Fields>;
  var_samp?: Maybe<Industry_Var_Samp_Fields>;
  variance?: Maybe<Industry_Variance_Fields>;
};


/** aggregate fields of "industry" */
export type Industry_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Industry_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Industry_Avg_Fields = {
  __typename?: 'industry_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "industry". All fields are combined with a logical 'AND'. */
export type Industry_Bool_Exp = {
  _and?: Maybe<Array<Industry_Bool_Exp>>;
  _not?: Maybe<Industry_Bool_Exp>;
  _or?: Maybe<Array<Industry_Bool_Exp>>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  posting_industries?: Maybe<Posting_Industry_Bool_Exp>;
  posting_industries_aggregate?: Maybe<Posting_Industry_Aggregate_Bool_Exp>;
  user_experiences?: Maybe<User_Experience_Bool_Exp>;
  user_experiences_aggregate?: Maybe<User_Experience_Aggregate_Bool_Exp>;
  users?: Maybe<User_Industry_Bool_Exp>;
  users_aggregate?: Maybe<User_Industry_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "industry" */
export enum Industry_Constraint {
  /** unique or primary key constraint on columns "name" */
  IndustryNameKey = 'industry_name_key',
  /** unique or primary key constraint on columns "id" */
  IndustryPkey = 'industry_pkey'
}

/** input type for incrementing numeric columns in table "industry" */
export type Industry_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "industry" */
export type Industry_Insert_Input = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  posting_industries?: Maybe<Posting_Industry_Arr_Rel_Insert_Input>;
  user_experiences?: Maybe<User_Experience_Arr_Rel_Insert_Input>;
  users?: Maybe<User_Industry_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Industry_Max_Fields = {
  __typename?: 'industry_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Industry_Min_Fields = {
  __typename?: 'industry_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "industry" */
export type Industry_Mutation_Response = {
  __typename?: 'industry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Industry>;
};

/** input type for inserting object relation for remote table "industry" */
export type Industry_Obj_Rel_Insert_Input = {
  data: Industry_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Industry_On_Conflict>;
};

/** on_conflict condition type for table "industry" */
export type Industry_On_Conflict = {
  constraint: Industry_Constraint;
  update_columns?: Array<Industry_Update_Column>;
  where?: Maybe<Industry_Bool_Exp>;
};

/** Ordering options when selecting data from "industry". */
export type Industry_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  posting_industries_aggregate?: Maybe<Posting_Industry_Aggregate_Order_By>;
  user_experiences_aggregate?: Maybe<User_Experience_Aggregate_Order_By>;
  users_aggregate?: Maybe<User_Industry_Aggregate_Order_By>;
};

/** primary key columns input for table: industry */
export type Industry_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "industry" */
export enum Industry_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "industry" */
export type Industry_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Industry_Stddev_Fields = {
  __typename?: 'industry_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Industry_Stddev_Pop_Fields = {
  __typename?: 'industry_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Industry_Stddev_Samp_Fields = {
  __typename?: 'industry_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "industry" */
export type Industry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Industry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Industry_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Industry_Sum_Fields = {
  __typename?: 'industry_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "industry" */
export enum Industry_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Industry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Industry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Industry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Industry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Industry_Var_Pop_Fields = {
  __typename?: 'industry_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Industry_Var_Samp_Fields = {
  __typename?: 'industry_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Industry_Variance_Fields = {
  __typename?: 'industry_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "invitation" */
export type Invitation = {
  __typename?: 'invitation';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  invited_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invited_by_user?: Maybe<User>;
  new_user?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "invitation" */
export type Invitation_Aggregate = {
  __typename?: 'invitation_aggregate';
  aggregate?: Maybe<Invitation_Aggregate_Fields>;
  nodes: Array<Invitation>;
};

export type Invitation_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Invitation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Invitation_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Invitation_Aggregate_Bool_Exp_Count>;
};

export type Invitation_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invitation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invitation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invitation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invitation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Invitation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invitation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invitation" */
export type Invitation_Aggregate_Fields = {
  __typename?: 'invitation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invitation_Max_Fields>;
  min?: Maybe<Invitation_Min_Fields>;
};


/** aggregate fields of "invitation" */
export type Invitation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Invitation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invitation" */
export type Invitation_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Invitation_Max_Order_By>;
  min?: Maybe<Invitation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "invitation" */
export type Invitation_Arr_Rel_Insert_Input = {
  data: Array<Invitation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Invitation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invitation". All fields are combined with a logical 'AND'. */
export type Invitation_Bool_Exp = {
  _and?: Maybe<Array<Invitation_Bool_Exp>>;
  _not?: Maybe<Invitation_Bool_Exp>;
  _or?: Maybe<Array<Invitation_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  family_name?: Maybe<String_Comparison_Exp>;
  given_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invited_by?: Maybe<Uuid_Comparison_Exp>;
  invited_by_user?: Maybe<User_Bool_Exp>;
  new_user?: Maybe<Boolean_Comparison_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitation" */
export enum Invitation_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvitationPkey = 'invitation_pkey',
  /** unique or primary key constraint on columns "user_id", "company_id" */
  InvitationUserIdCompanyIdKey = 'invitation_user_id_company_id_key'
}

/** input type for inserting data into table "invitation" */
export type Invitation_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invited_by?: Maybe<Scalars['uuid']>;
  invited_by_user?: Maybe<User_Obj_Rel_Insert_Input>;
  new_user?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Invitation_Max_Fields = {
  __typename?: 'invitation_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invited_by?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invitation" */
export type Invitation_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  family_name?: Maybe<Order_By>;
  given_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invited_by?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Invitation_Min_Fields = {
  __typename?: 'invitation_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invited_by?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invitation" */
export type Invitation_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  family_name?: Maybe<Order_By>;
  given_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invited_by?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "invitation" */
export type Invitation_Mutation_Response = {
  __typename?: 'invitation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitation>;
};

/** on_conflict condition type for table "invitation" */
export type Invitation_On_Conflict = {
  constraint: Invitation_Constraint;
  update_columns?: Array<Invitation_Update_Column>;
  where?: Maybe<Invitation_Bool_Exp>;
};

/** Ordering options when selecting data from "invitation". */
export type Invitation_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  family_name?: Maybe<Order_By>;
  given_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invited_by?: Maybe<Order_By>;
  invited_by_user?: Maybe<User_Order_By>;
  new_user?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: invitation */
export type Invitation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "invitation" */
export enum Invitation_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'family_name',
  /** column name */
  GivenName = 'given_name',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedBy = 'invited_by',
  /** column name */
  NewUser = 'new_user',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "invitation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invitation" */
export enum Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NewUser = 'new_user'
}

/** select "invitation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invitation" */
export enum Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NewUser = 'new_user'
}

/** input type for updating data in table "invitation" */
export type Invitation_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invited_by?: Maybe<Scalars['uuid']>;
  new_user?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "invitation" */
export type Invitation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitation_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invited_by?: Maybe<Scalars['uuid']>;
  new_user?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "invitation" */
export enum Invitation_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'family_name',
  /** column name */
  GivenName = 'given_name',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedBy = 'invited_by',
  /** column name */
  NewUser = 'new_user',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Invitation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Invitation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invitation_Bool_Exp;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  external_link?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  invoice_ref?: Maybe<Scalars['String']>;
  invoice_submission_date?: Maybe<Scalars['date']>;
  is_opened?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  project: Project;
  /** An array relationship */
  project_activities: Array<Project_Activity>;
  /** An aggregate relationship */
  project_activities_aggregate: Project_Activity_Aggregate;
  /** An array relationship */
  project_activity_times: Array<Project_Activity_Time>;
  /** An aggregate relationship */
  project_activity_times_aggregate: Project_Activity_Time_Aggregate;
  project_id: Scalars['uuid'];
  rate?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  submit_by: Scalars['uuid'];
  total_amount: Scalars['float8'];
  total_hours?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
};


/** columns and relationships of "invoice" */
export type InvoiceFileArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "invoice" */
export type InvoiceProject_ActivitiesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceProject_Activities_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceProject_Activity_TimesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceProject_Activity_Times_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

export type Invoice_Aggregate_Bool_Exp = {
  avg?: Maybe<Invoice_Aggregate_Bool_Exp_Avg>;
  bool_and?: Maybe<Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Invoice_Aggregate_Bool_Exp_Bool_Or>;
  corr?: Maybe<Invoice_Aggregate_Bool_Exp_Corr>;
  count?: Maybe<Invoice_Aggregate_Bool_Exp_Count>;
  covar_samp?: Maybe<Invoice_Aggregate_Bool_Exp_Covar_Samp>;
  max?: Maybe<Invoice_Aggregate_Bool_Exp_Max>;
  min?: Maybe<Invoice_Aggregate_Bool_Exp_Min>;
  stddev_samp?: Maybe<Invoice_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: Maybe<Invoice_Aggregate_Bool_Exp_Sum>;
  var_samp?: Maybe<Invoice_Aggregate_Bool_Exp_Var_Samp>;
};

export type Invoice_Aggregate_Bool_Exp_Avg = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Corr = {
  arguments: Invoice_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Invoice_Aggregate_Bool_Exp_Max = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Min = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Sum = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Invoice_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Invoice_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice" */
export type Invoice_Aggregate_Order_By = {
  avg?: Maybe<Invoice_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Invoice_Max_Order_By>;
  min?: Maybe<Invoice_Min_Order_By>;
  stddev?: Maybe<Invoice_Stddev_Order_By>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Order_By>;
  sum?: Maybe<Invoice_Sum_Order_By>;
  var_pop?: Maybe<Invoice_Var_Pop_Order_By>;
  var_samp?: Maybe<Invoice_Var_Samp_Order_By>;
  variance?: Maybe<Invoice_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Append_Input = {
  file?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invoice" */
export type Invoice_Arr_Rel_Insert_Input = {
  data: Array<Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_hours?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice" */
export type Invoice_Avg_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: Maybe<Array<Invoice_Bool_Exp>>;
  _not?: Maybe<Invoice_Bool_Exp>;
  _or?: Maybe<Array<Invoice_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  external_link?: Maybe<String_Comparison_Exp>;
  file?: Maybe<Jsonb_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoice_ref?: Maybe<String_Comparison_Exp>;
  invoice_submission_date?: Maybe<Date_Comparison_Exp>;
  is_opened?: Maybe<Boolean_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_activities?: Maybe<Project_Activity_Bool_Exp>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Bool_Exp>;
  project_activity_times?: Maybe<Project_Activity_Time_Bool_Exp>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  rate?: Maybe<Int_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  submit_by?: Maybe<Uuid_Comparison_Exp>;
  total_amount?: Maybe<Float8_Comparison_Exp>;
  total_hours?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "invoice" */
export enum Invoice_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvoicePkey = 'invoice_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invoice_Delete_At_Path_Input = {
  file?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invoice_Delete_Elem_Input = {
  file?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invoice_Delete_Key_Input = {
  file?: Maybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "invoice" */
export type Invoice_Inc_Input = {
  rate?: Maybe<Scalars['Int']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_hours?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "invoice" */
export type Invoice_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_link?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_ref?: Maybe<Scalars['String']>;
  invoice_submission_date?: Maybe<Scalars['date']>;
  is_opened?: Maybe<Scalars['Boolean']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_activities?: Maybe<Project_Activity_Arr_Rel_Insert_Input>;
  project_activity_times?: Maybe<Project_Activity_Time_Arr_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  submit_by?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_hours?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_ref?: Maybe<Scalars['String']>;
  invoice_submission_date?: Maybe<Scalars['date']>;
  project_id?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  submit_by?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_hours?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice" */
export type Invoice_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  external_link?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_ref?: Maybe<Order_By>;
  invoice_submission_date?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  submit_by?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_ref?: Maybe<Scalars['String']>;
  invoice_submission_date?: Maybe<Scalars['date']>;
  project_id?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  submit_by?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_hours?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice" */
export type Invoice_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  external_link?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_ref?: Maybe<Order_By>;
  invoice_submission_date?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  submit_by?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** on_conflict condition type for table "invoice" */
export type Invoice_On_Conflict = {
  constraint: Invoice_Constraint;
  update_columns?: Array<Invoice_Update_Column>;
  where?: Maybe<Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  external_link?: Maybe<Order_By>;
  file?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_ref?: Maybe<Order_By>;
  invoice_submission_date?: Maybe<Order_By>;
  is_opened?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Order_By>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Order_By>;
  project_id?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  submit_by?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
};

/** primary key columns input for table: invoice */
export type Invoice_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Prepend_Input = {
  file?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "invoice" */
export enum Invoice_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalLink = 'external_link',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceRef = 'invoice_ref',
  /** column name */
  InvoiceSubmissionDate = 'invoice_submission_date',
  /** column name */
  IsOpened = 'is_opened',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  Status = 'status',
  /** column name */
  SubmitBy = 'submit_by',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "invoice_aggregate_bool_exp_avg_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** select "invoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsOpened = 'is_opened'
}

/** select "invoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsOpened = 'is_opened'
}

/** select "invoice_aggregate_bool_exp_corr_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** select "invoice_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** select "invoice_aggregate_bool_exp_max_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** select "invoice_aggregate_bool_exp_min_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** select "invoice_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** select "invoice_aggregate_bool_exp_sum_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** select "invoice_aggregate_bool_exp_var_samp_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours'
}

/** input type for updating data in table "invoice" */
export type Invoice_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_link?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_ref?: Maybe<Scalars['String']>;
  invoice_submission_date?: Maybe<Scalars['date']>;
  is_opened?: Maybe<Scalars['Boolean']>;
  project_id?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  submit_by?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_hours?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_hours?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice" */
export type Invoice_Stddev_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_hours?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice" */
export type Invoice_Stddev_Pop_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_hours?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice" */
export type Invoice_Stddev_Samp_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  external_link?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_ref?: Maybe<Scalars['String']>;
  invoice_submission_date?: Maybe<Scalars['date']>;
  is_opened?: Maybe<Scalars['Boolean']>;
  project_id?: Maybe<Scalars['uuid']>;
  rate?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  submit_by?: Maybe<Scalars['uuid']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_hours?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  rate?: Maybe<Scalars['Int']>;
  total_amount?: Maybe<Scalars['float8']>;
  total_hours?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "invoice" */
export type Invoice_Sum_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};

/** update columns of table "invoice" */
export enum Invoice_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalLink = 'external_link',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceRef = 'invoice_ref',
  /** column name */
  InvoiceSubmissionDate = 'invoice_submission_date',
  /** column name */
  IsOpened = 'is_opened',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  Status = 'status',
  /** column name */
  SubmitBy = 'submit_by',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalHours = 'total_hours',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Invoice_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<Invoice_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<Invoice_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<Invoice_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<Invoice_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Invoice_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<Invoice_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_hours?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice" */
export type Invoice_Var_Pop_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_hours?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice" */
export type Invoice_Var_Samp_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  rate?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_hours?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice" */
export type Invoice_Variance_Order_By = {
  rate?: Maybe<Order_By>;
  total_amount?: Maybe<Order_By>;
  total_hours?: Maybe<Order_By>;
};


export type Jsonb_Cast_Exp = {
  String?: Maybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Maybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "language" */
export type Language = {
  __typename?: 'language';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  native_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_languages: Array<User_Language>;
  /** An aggregate relationship */
  user_languages_aggregate: User_Language_Aggregate;
};


/** columns and relationships of "language" */
export type LanguageUser_LanguagesArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "language" */
export type LanguageUser_Languages_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};

/** aggregated selection of "language" */
export type Language_Aggregate = {
  __typename?: 'language_aggregate';
  aggregate?: Maybe<Language_Aggregate_Fields>;
  nodes: Array<Language>;
};

/** aggregate fields of "language" */
export type Language_Aggregate_Fields = {
  __typename?: 'language_aggregate_fields';
  avg?: Maybe<Language_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Language_Max_Fields>;
  min?: Maybe<Language_Min_Fields>;
  stddev?: Maybe<Language_Stddev_Fields>;
  stddev_pop?: Maybe<Language_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Language_Stddev_Samp_Fields>;
  sum?: Maybe<Language_Sum_Fields>;
  var_pop?: Maybe<Language_Var_Pop_Fields>;
  var_samp?: Maybe<Language_Var_Samp_Fields>;
  variance?: Maybe<Language_Variance_Fields>;
};


/** aggregate fields of "language" */
export type Language_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Language_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Language_Avg_Fields = {
  __typename?: 'language_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "language". All fields are combined with a logical 'AND'. */
export type Language_Bool_Exp = {
  _and?: Maybe<Array<Language_Bool_Exp>>;
  _not?: Maybe<Language_Bool_Exp>;
  _or?: Maybe<Array<Language_Bool_Exp>>;
  code?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  native_name?: Maybe<String_Comparison_Exp>;
  user_languages?: Maybe<User_Language_Bool_Exp>;
  user_languages_aggregate?: Maybe<User_Language_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "language" */
export enum Language_Constraint {
  /** unique or primary key constraint on columns "id" */
  LanguagePkey = 'language_pkey'
}

/** input type for incrementing numeric columns in table "language" */
export type Language_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "language" */
export type Language_Insert_Input = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  native_name?: Maybe<Scalars['String']>;
  user_languages?: Maybe<User_Language_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Language_Max_Fields = {
  __typename?: 'language_max_fields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  native_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Language_Min_Fields = {
  __typename?: 'language_min_fields';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  native_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "language" */
export type Language_Mutation_Response = {
  __typename?: 'language_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Language>;
};

/** input type for inserting object relation for remote table "language" */
export type Language_Obj_Rel_Insert_Input = {
  data: Language_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Language_On_Conflict>;
};

/** on_conflict condition type for table "language" */
export type Language_On_Conflict = {
  constraint: Language_Constraint;
  update_columns?: Array<Language_Update_Column>;
  where?: Maybe<Language_Bool_Exp>;
};

/** Ordering options when selecting data from "language". */
export type Language_Order_By = {
  code?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  native_name?: Maybe<Order_By>;
  user_languages_aggregate?: Maybe<User_Language_Aggregate_Order_By>;
};

/** primary key columns input for table: language */
export type Language_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "language" */
export enum Language_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NativeName = 'native_name'
}

/** input type for updating data in table "language" */
export type Language_Set_Input = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  native_name?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Language_Stddev_Fields = {
  __typename?: 'language_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Language_Stddev_Pop_Fields = {
  __typename?: 'language_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Language_Stddev_Samp_Fields = {
  __typename?: 'language_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "language" */
export type Language_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Language_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Language_Stream_Cursor_Value_Input = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  native_name?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Language_Sum_Fields = {
  __typename?: 'language_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "language" */
export enum Language_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NativeName = 'native_name'
}

export type Language_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Language_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Language_Set_Input>;
  /** filter the rows which have to be updated */
  where: Language_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Language_Var_Pop_Fields = {
  __typename?: 'language_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Language_Var_Samp_Fields = {
  __typename?: 'language_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Language_Variance_Fields = {
  __typename?: 'language_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "manager" */
export type Manager = {
  __typename?: 'manager';
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  /** An array relationship */
  contractors: Array<Manager_Contractor>;
  /** An aggregate relationship */
  contractors_aggregate: Manager_Contractor_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  declined_visit_matches: Array<Declined_Visit_Matches>;
  /** An aggregate relationship */
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  id: Scalars['uuid'];
  marketplace_access_allowed: Scalars['Boolean'];
  marketplace_access_requested: Scalars['Boolean'];
  /** An array relationship */
  postings: Array<Posting>;
  /** An aggregate relationship */
  postings_aggregate: Posting_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  resources_access_allowed?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  smart_match_bookmarks: Array<Smart_Match_Bookmark>;
  /** An aggregate relationship */
  smart_match_bookmarks_aggregate: Smart_Match_Bookmark_Aggregate;
  /** An object relationship */
  smart_match_config?: Maybe<Smart_Match_Configs>;
  status?: Maybe<Scalars['String']>;
  /** An array relationship */
  teams: Array<Team_Manager>;
  /** An aggregate relationship */
  teams_aggregate: Team_Manager_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "manager" */
export type ManagerContractorsArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerContractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerDeclined_Visit_MatchesArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerDeclined_Visit_Matches_AggregateArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerPostingsArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerPostings_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerProjectsArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerProjects_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerSmart_Match_BookmarksArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerSmart_Match_Bookmarks_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerTeamsArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


/** columns and relationships of "manager" */
export type ManagerTeams_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};

/** aggregated selection of "manager" */
export type Manager_Aggregate = {
  __typename?: 'manager_aggregate';
  aggregate?: Maybe<Manager_Aggregate_Fields>;
  nodes: Array<Manager>;
};

export type Manager_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Manager_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Manager_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Manager_Aggregate_Bool_Exp_Count>;
};

export type Manager_Aggregate_Bool_Exp_Bool_And = {
  arguments: Manager_Select_Column_Manager_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Manager_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Manager_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Manager_Select_Column_Manager_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Manager_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Manager_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Manager_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Manager_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "manager" */
export type Manager_Aggregate_Fields = {
  __typename?: 'manager_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Manager_Max_Fields>;
  min?: Maybe<Manager_Min_Fields>;
};


/** aggregate fields of "manager" */
export type Manager_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manager_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manager" */
export type Manager_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Manager_Max_Order_By>;
  min?: Maybe<Manager_Min_Order_By>;
};

/** input type for inserting array relation for remote table "manager" */
export type Manager_Arr_Rel_Insert_Input = {
  data: Array<Manager_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Manager_On_Conflict>;
};

/** Boolean expression to filter rows from the table "manager". All fields are combined with a logical 'AND'. */
export type Manager_Bool_Exp = {
  _and?: Maybe<Array<Manager_Bool_Exp>>;
  _not?: Maybe<Manager_Bool_Exp>;
  _or?: Maybe<Array<Manager_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  contractors?: Maybe<Manager_Contractor_Bool_Exp>;
  contractors_aggregate?: Maybe<Manager_Contractor_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Bool_Exp>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  marketplace_access_allowed?: Maybe<Boolean_Comparison_Exp>;
  marketplace_access_requested?: Maybe<Boolean_Comparison_Exp>;
  postings?: Maybe<Posting_Bool_Exp>;
  postings_aggregate?: Maybe<Posting_Aggregate_Bool_Exp>;
  projects?: Maybe<Project_Bool_Exp>;
  projects_aggregate?: Maybe<Project_Aggregate_Bool_Exp>;
  resources_access_allowed?: Maybe<Boolean_Comparison_Exp>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Bool_Exp>;
  smart_match_config?: Maybe<Smart_Match_Configs_Bool_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  teams?: Maybe<Team_Manager_Bool_Exp>;
  teams_aggregate?: Maybe<Team_Manager_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "manager" */
export enum Manager_Constraint {
  /** unique or primary key constraint on columns "id" */
  ManagerPkey = 'manager_pkey',
  /** unique or primary key constraint on columns "user_id" */
  ManagerUserIdKey = 'manager_user_id_key'
}

/** columns and relationships of "manager_contractor" */
export type Manager_Contractor = {
  __typename?: 'manager_contractor';
  approved: Scalars['Boolean'];
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<User>;
  id: Scalars['uuid'];
  /** An object relationship */
  manager: Manager;
  manager_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "manager_contractor" */
export type Manager_Contractor_Aggregate = {
  __typename?: 'manager_contractor_aggregate';
  aggregate?: Maybe<Manager_Contractor_Aggregate_Fields>;
  nodes: Array<Manager_Contractor>;
};

export type Manager_Contractor_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Manager_Contractor_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Manager_Contractor_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Manager_Contractor_Aggregate_Bool_Exp_Count>;
};

export type Manager_Contractor_Aggregate_Bool_Exp_Bool_And = {
  arguments: Manager_Contractor_Select_Column_Manager_Contractor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Manager_Contractor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Manager_Contractor_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Manager_Contractor_Select_Column_Manager_Contractor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Manager_Contractor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Manager_Contractor_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Manager_Contractor_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Manager_Contractor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "manager_contractor" */
export type Manager_Contractor_Aggregate_Fields = {
  __typename?: 'manager_contractor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Manager_Contractor_Max_Fields>;
  min?: Maybe<Manager_Contractor_Min_Fields>;
};


/** aggregate fields of "manager_contractor" */
export type Manager_Contractor_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manager_Contractor_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manager_contractor" */
export type Manager_Contractor_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Manager_Contractor_Max_Order_By>;
  min?: Maybe<Manager_Contractor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "manager_contractor" */
export type Manager_Contractor_Arr_Rel_Insert_Input = {
  data: Array<Manager_Contractor_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Manager_Contractor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "manager_contractor". All fields are combined with a logical 'AND'. */
export type Manager_Contractor_Bool_Exp = {
  _and?: Maybe<Array<Manager_Contractor_Bool_Exp>>;
  _not?: Maybe<Manager_Contractor_Bool_Exp>;
  _or?: Maybe<Array<Manager_Contractor_Bool_Exp>>;
  approved?: Maybe<Boolean_Comparison_Exp>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  created_by_user?: Maybe<User_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "manager_contractor" */
export enum Manager_Contractor_Constraint {
  /** unique or primary key constraint on columns "manager_id", "contractor_id" */
  ManagerContractorManagerIdContractorIdKey = 'manager_contractor_manager_id_contractor_id_key',
  /** unique or primary key constraint on columns "id" */
  ManagerContractorPkey = 'manager_contractor_pkey'
}

/** input type for inserting data into table "manager_contractor" */
export type Manager_Contractor_Insert_Input = {
  approved?: Maybe<Scalars['Boolean']>;
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  created_by_user?: Maybe<User_Obj_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Manager_Contractor_Max_Fields = {
  __typename?: 'manager_contractor_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "manager_contractor" */
export type Manager_Contractor_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manager_Contractor_Min_Fields = {
  __typename?: 'manager_contractor_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "manager_contractor" */
export type Manager_Contractor_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "manager_contractor" */
export type Manager_Contractor_Mutation_Response = {
  __typename?: 'manager_contractor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manager_Contractor>;
};

/** on_conflict condition type for table "manager_contractor" */
export type Manager_Contractor_On_Conflict = {
  constraint: Manager_Contractor_Constraint;
  update_columns?: Array<Manager_Contractor_Update_Column>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};

/** Ordering options when selecting data from "manager_contractor". */
export type Manager_Contractor_Order_By = {
  approved?: Maybe<Order_By>;
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  created_by_user?: Maybe<User_Order_By>;
  id?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: manager_contractor */
export type Manager_Contractor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "manager_contractor" */
export enum Manager_Contractor_Select_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "manager_contractor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "manager_contractor" */
export enum Manager_Contractor_Select_Column_Manager_Contractor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Approved = 'approved'
}

/** select "manager_contractor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "manager_contractor" */
export enum Manager_Contractor_Select_Column_Manager_Contractor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Approved = 'approved'
}

/** input type for updating data in table "manager_contractor" */
export type Manager_Contractor_Set_Input = {
  approved?: Maybe<Scalars['Boolean']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "manager_contractor" */
export type Manager_Contractor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Manager_Contractor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Manager_Contractor_Stream_Cursor_Value_Input = {
  approved?: Maybe<Scalars['Boolean']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "manager_contractor" */
export enum Manager_Contractor_Update_Column {
  /** column name */
  Approved = 'approved',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Manager_Contractor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Manager_Contractor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Manager_Contractor_Bool_Exp;
};

/** input type for inserting data into table "manager" */
export type Manager_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  contractors?: Maybe<Manager_Contractor_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  marketplace_access_allowed?: Maybe<Scalars['Boolean']>;
  marketplace_access_requested?: Maybe<Scalars['Boolean']>;
  postings?: Maybe<Posting_Arr_Rel_Insert_Input>;
  projects?: Maybe<Project_Arr_Rel_Insert_Input>;
  resources_access_allowed?: Maybe<Scalars['Boolean']>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Arr_Rel_Insert_Input>;
  smart_match_config?: Maybe<Smart_Match_Configs_Obj_Rel_Insert_Input>;
  status?: Maybe<Scalars['String']>;
  teams?: Maybe<Team_Manager_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Manager_Max_Fields = {
  __typename?: 'manager_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "manager" */
export type Manager_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manager_Min_Fields = {
  __typename?: 'manager_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "manager" */
export type Manager_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "manager" */
export type Manager_Mutation_Response = {
  __typename?: 'manager_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manager>;
};

/** input type for inserting object relation for remote table "manager" */
export type Manager_Obj_Rel_Insert_Input = {
  data: Manager_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Manager_On_Conflict>;
};

/** on_conflict condition type for table "manager" */
export type Manager_On_Conflict = {
  constraint: Manager_Constraint;
  update_columns?: Array<Manager_Update_Column>;
  where?: Maybe<Manager_Bool_Exp>;
};

/** Ordering options when selecting data from "manager". */
export type Manager_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  contractors_aggregate?: Maybe<Manager_Contractor_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  marketplace_access_allowed?: Maybe<Order_By>;
  marketplace_access_requested?: Maybe<Order_By>;
  postings_aggregate?: Maybe<Posting_Aggregate_Order_By>;
  projects_aggregate?: Maybe<Project_Aggregate_Order_By>;
  resources_access_allowed?: Maybe<Order_By>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Order_By>;
  smart_match_config?: Maybe<Smart_Match_Configs_Order_By>;
  status?: Maybe<Order_By>;
  teams_aggregate?: Maybe<Team_Manager_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: manager */
export type Manager_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "manager" */
export enum Manager_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MarketplaceAccessAllowed = 'marketplace_access_allowed',
  /** column name */
  MarketplaceAccessRequested = 'marketplace_access_requested',
  /** column name */
  ResourcesAccessAllowed = 'resources_access_allowed',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "manager_aggregate_bool_exp_bool_and_arguments_columns" columns of table "manager" */
export enum Manager_Select_Column_Manager_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  MarketplaceAccessAllowed = 'marketplace_access_allowed',
  /** column name */
  MarketplaceAccessRequested = 'marketplace_access_requested',
  /** column name */
  ResourcesAccessAllowed = 'resources_access_allowed'
}

/** select "manager_aggregate_bool_exp_bool_or_arguments_columns" columns of table "manager" */
export enum Manager_Select_Column_Manager_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  MarketplaceAccessAllowed = 'marketplace_access_allowed',
  /** column name */
  MarketplaceAccessRequested = 'marketplace_access_requested',
  /** column name */
  ResourcesAccessAllowed = 'resources_access_allowed'
}

/** input type for updating data in table "manager" */
export type Manager_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  marketplace_access_allowed?: Maybe<Scalars['Boolean']>;
  marketplace_access_requested?: Maybe<Scalars['Boolean']>;
  resources_access_allowed?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "manager" */
export type Manager_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Manager_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Manager_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  marketplace_access_allowed?: Maybe<Scalars['Boolean']>;
  marketplace_access_requested?: Maybe<Scalars['Boolean']>;
  resources_access_allowed?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "manager" */
export enum Manager_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MarketplaceAccessAllowed = 'marketplace_access_allowed',
  /** column name */
  MarketplaceAccessRequested = 'marketplace_access_requested',
  /** column name */
  ResourcesAccessAllowed = 'resources_access_allowed',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Manager_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Manager_Set_Input>;
  /** filter the rows which have to be updated */
  where: Manager_Bool_Exp;
};

/** columns and relationships of "message" */
export type Message = {
  __typename?: 'message';
  attachment?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  /** An object relationship */
  conversation: Conversation;
  conversation_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  notified_by_email: Scalars['Boolean'];
  notified_in_app: Scalars['Boolean'];
  read: Scalars['Boolean'];
  /** An array relationship */
  recipient_message: Array<Recipient_Message>;
  /** An aggregate relationship */
  recipient_message_aggregate: Recipient_Message_Aggregate;
  /** An object relationship */
  sender: User;
  sender_id: Scalars['uuid'];
};


/** columns and relationships of "message" */
export type MessageRecipient_MessageArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


/** columns and relationships of "message" */
export type MessageRecipient_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};

/** aggregated selection of "message" */
export type Message_Aggregate = {
  __typename?: 'message_aggregate';
  aggregate?: Maybe<Message_Aggregate_Fields>;
  nodes: Array<Message>;
};

export type Message_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Message_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Message_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Message_Aggregate_Bool_Exp_Count>;
};

export type Message_Aggregate_Bool_Exp_Bool_And = {
  arguments: Message_Select_Column_Message_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Message_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Message_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Message_Select_Column_Message_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Message_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Message_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "message" */
export type Message_Aggregate_Fields = {
  __typename?: 'message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Message_Max_Fields>;
  min?: Maybe<Message_Min_Fields>;
};


/** aggregate fields of "message" */
export type Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "message" */
export type Message_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Message_Max_Order_By>;
  min?: Maybe<Message_Min_Order_By>;
};

/** input type for inserting array relation for remote table "message" */
export type Message_Arr_Rel_Insert_Input = {
  data: Array<Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Message_On_Conflict>;
};

/** Boolean expression to filter rows from the table "message". All fields are combined with a logical 'AND'. */
export type Message_Bool_Exp = {
  _and?: Maybe<Array<Message_Bool_Exp>>;
  _not?: Maybe<Message_Bool_Exp>;
  _or?: Maybe<Array<Message_Bool_Exp>>;
  attachment?: Maybe<String_Comparison_Exp>;
  content?: Maybe<String_Comparison_Exp>;
  conversation?: Maybe<Conversation_Bool_Exp>;
  conversation_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  notified_by_email?: Maybe<Boolean_Comparison_Exp>;
  notified_in_app?: Maybe<Boolean_Comparison_Exp>;
  read?: Maybe<Boolean_Comparison_Exp>;
  recipient_message?: Maybe<Recipient_Message_Bool_Exp>;
  recipient_message_aggregate?: Maybe<Recipient_Message_Aggregate_Bool_Exp>;
  sender?: Maybe<User_Bool_Exp>;
  sender_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "message" */
export enum Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagePkey = 'message_pkey'
}

/** input type for inserting data into table "message" */
export type Message_Insert_Input = {
  attachment?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  conversation?: Maybe<Conversation_Obj_Rel_Insert_Input>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notified_by_email?: Maybe<Scalars['Boolean']>;
  notified_in_app?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  recipient_message?: Maybe<Recipient_Message_Arr_Rel_Insert_Input>;
  sender?: Maybe<User_Obj_Rel_Insert_Input>;
  sender_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Message_Max_Fields = {
  __typename?: 'message_max_fields';
  attachment?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  sender_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "message" */
export type Message_Max_Order_By = {
  attachment?: Maybe<Order_By>;
  content?: Maybe<Order_By>;
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Message_Min_Fields = {
  __typename?: 'message_min_fields';
  attachment?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  sender_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "message" */
export type Message_Min_Order_By = {
  attachment?: Maybe<Order_By>;
  content?: Maybe<Order_By>;
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "message" */
export type Message_Mutation_Response = {
  __typename?: 'message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Message>;
};

/** input type for inserting object relation for remote table "message" */
export type Message_Obj_Rel_Insert_Input = {
  data: Message_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Message_On_Conflict>;
};

/** on_conflict condition type for table "message" */
export type Message_On_Conflict = {
  constraint: Message_Constraint;
  update_columns?: Array<Message_Update_Column>;
  where?: Maybe<Message_Bool_Exp>;
};

/** Ordering options when selecting data from "message". */
export type Message_Order_By = {
  attachment?: Maybe<Order_By>;
  content?: Maybe<Order_By>;
  conversation?: Maybe<Conversation_Order_By>;
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notified_by_email?: Maybe<Order_By>;
  notified_in_app?: Maybe<Order_By>;
  read?: Maybe<Order_By>;
  recipient_message_aggregate?: Maybe<Recipient_Message_Aggregate_Order_By>;
  sender?: Maybe<User_Order_By>;
  sender_id?: Maybe<Order_By>;
};

/** primary key columns input for table: message */
export type Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "message" */
export enum Message_Select_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  Content = 'content',
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read',
  /** column name */
  SenderId = 'sender_id'
}

/** select "message_aggregate_bool_exp_bool_and_arguments_columns" columns of table "message" */
export enum Message_Select_Column_Message_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read'
}

/** select "message_aggregate_bool_exp_bool_or_arguments_columns" columns of table "message" */
export enum Message_Select_Column_Message_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read'
}

/** input type for updating data in table "message" */
export type Message_Set_Input = {
  attachment?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notified_by_email?: Maybe<Scalars['Boolean']>;
  notified_in_app?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "message" */
export type Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Message_Stream_Cursor_Value_Input = {
  attachment?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  notified_by_email?: Maybe<Scalars['Boolean']>;
  notified_in_app?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "message" */
export enum Message_Update_Column {
  /** column name */
  Attachment = 'attachment',
  /** column name */
  Content = 'content',
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read',
  /** column name */
  SenderId = 'sender_id'
}

export type Message_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Message_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "admin" */
  delete_admin?: Maybe<Admin_Mutation_Response>;
  /** delete single row from the table: "admin" */
  delete_admin_by_pk?: Maybe<Admin>;
  /** delete data from the table: "application" */
  delete_application?: Maybe<Application_Mutation_Response>;
  /** delete single row from the table: "application" */
  delete_application_by_pk?: Maybe<Application>;
  /** delete data from the table: "candidate" */
  delete_candidate?: Maybe<Candidate_Mutation_Response>;
  /** delete single row from the table: "candidate" */
  delete_candidate_by_pk?: Maybe<Candidate>;
  /** delete data from the table: "checkin_status" */
  delete_checkin_status?: Maybe<Checkin_Status_Mutation_Response>;
  /** delete single row from the table: "checkin_status" */
  delete_checkin_status_by_pk?: Maybe<Checkin_Status>;
  /** delete data from the table: "checkout_status" */
  delete_checkout_status?: Maybe<Checkout_Status_Mutation_Response>;
  /** delete single row from the table: "checkout_status" */
  delete_checkout_status_by_pk?: Maybe<Checkout_Status>;
  /** delete data from the table: "client_care_plan" */
  delete_client_care_plan?: Maybe<Client_Care_Plan_Mutation_Response>;
  /** delete single row from the table: "client_care_plan" */
  delete_client_care_plan_by_pk?: Maybe<Client_Care_Plan>;
  /** delete data from the table: "client_medications" */
  delete_client_medications?: Maybe<Client_Medications_Mutation_Response>;
  /** delete single row from the table: "client_medications" */
  delete_client_medications_by_pk?: Maybe<Client_Medications>;
  /** delete data from the table: "company" */
  delete_company?: Maybe<Company_Mutation_Response>;
  /** delete single row from the table: "company" */
  delete_company_by_pk?: Maybe<Company>;
  /** delete data from the table: "company_follower" */
  delete_company_follower?: Maybe<Company_Follower_Mutation_Response>;
  /** delete single row from the table: "company_follower" */
  delete_company_follower_by_pk?: Maybe<Company_Follower>;
  /** delete data from the table: "company_user_notifications" */
  delete_company_user_notifications?: Maybe<Company_User_Notifications_Mutation_Response>;
  /** delete single row from the table: "company_user_notifications" */
  delete_company_user_notifications_by_pk?: Maybe<Company_User_Notifications>;
  /** delete data from the table: "contractor" */
  delete_contractor?: Maybe<Contractor_Mutation_Response>;
  /** delete single row from the table: "contractor" */
  delete_contractor_by_pk?: Maybe<Contractor>;
  /** delete data from the table: "contractor_note" */
  delete_contractor_note?: Maybe<Contractor_Note_Mutation_Response>;
  /** delete single row from the table: "contractor_note" */
  delete_contractor_note_by_pk?: Maybe<Contractor_Note>;
  /** delete data from the table: "contractor_posting" */
  delete_contractor_posting?: Maybe<Contractor_Posting_Mutation_Response>;
  /** delete single row from the table: "contractor_posting" */
  delete_contractor_posting_by_pk?: Maybe<Contractor_Posting>;
  /** delete data from the table: "contractor_project" */
  delete_contractor_project?: Maybe<Contractor_Project_Mutation_Response>;
  /** delete single row from the table: "contractor_project" */
  delete_contractor_project_by_pk?: Maybe<Contractor_Project>;
  /** delete data from the table: "contractor_rating" */
  delete_contractor_rating?: Maybe<Contractor_Rating_Mutation_Response>;
  /** delete single row from the table: "contractor_rating" */
  delete_contractor_rating_by_pk?: Maybe<Contractor_Rating>;
  /** delete data from the table: "contractor_staff_note" */
  delete_contractor_staff_note?: Maybe<Contractor_Staff_Note_Mutation_Response>;
  /** delete single row from the table: "contractor_staff_note" */
  delete_contractor_staff_note_by_pk?: Maybe<Contractor_Staff_Note>;
  /** delete data from the table: "conversation" */
  delete_conversation?: Maybe<Conversation_Mutation_Response>;
  /** delete single row from the table: "conversation" */
  delete_conversation_by_pk?: Maybe<Conversation>;
  /** delete data from the table: "custom_request" */
  delete_custom_request?: Maybe<Custom_Request_Mutation_Response>;
  /** delete single row from the table: "custom_request" */
  delete_custom_request_by_pk?: Maybe<Custom_Request>;
  /** delete data from the table: "custom_request_skills" */
  delete_custom_request_skills?: Maybe<Custom_Request_Skills_Mutation_Response>;
  /** delete single row from the table: "custom_request_skills" */
  delete_custom_request_skills_by_pk?: Maybe<Custom_Request_Skills>;
  /** delete data from the table: "declined_visit_matches" */
  delete_declined_visit_matches?: Maybe<Declined_Visit_Matches_Mutation_Response>;
  /** delete single row from the table: "declined_visit_matches" */
  delete_declined_visit_matches_by_pk?: Maybe<Declined_Visit_Matches>;
  /** delete data from the table: "document" */
  delete_document?: Maybe<Document_Mutation_Response>;
  /** delete single row from the table: "document" */
  delete_document_by_pk?: Maybe<Document>;
  /** delete data from the table: "document_contractor_access" */
  delete_document_contractor_access?: Maybe<Document_Contractor_Access_Mutation_Response>;
  /** delete single row from the table: "document_contractor_access" */
  delete_document_contractor_access_by_pk?: Maybe<Document_Contractor_Access>;
  /** delete data from the table: "document_custom_request" */
  delete_document_custom_request?: Maybe<Document_Custom_Request_Mutation_Response>;
  /** delete single row from the table: "document_custom_request" */
  delete_document_custom_request_by_pk?: Maybe<Document_Custom_Request>;
  /** delete data from the table: "document_project" */
  delete_document_project?: Maybe<Document_Project_Mutation_Response>;
  /** delete single row from the table: "document_project" */
  delete_document_project_by_pk?: Maybe<Document_Project>;
  /** delete data from the table: "document_user" */
  delete_document_user?: Maybe<Document_User_Mutation_Response>;
  /** delete single row from the table: "document_user" */
  delete_document_user_by_pk?: Maybe<Document_User>;
  /** delete data from the table: "email_regex" */
  delete_email_regex?: Maybe<Email_Regex_Mutation_Response>;
  /** delete single row from the table: "email_regex" */
  delete_email_regex_by_pk?: Maybe<Email_Regex>;
  /** delete data from the table: "experience_skill" */
  delete_experience_skill?: Maybe<Experience_Skill_Mutation_Response>;
  /** delete single row from the table: "experience_skill" */
  delete_experience_skill_by_pk?: Maybe<Experience_Skill>;
  /** delete data from the table: "gender" */
  delete_gender?: Maybe<Gender_Mutation_Response>;
  /** delete single row from the table: "gender" */
  delete_gender_by_pk?: Maybe<Gender>;
  /** delete data from the table: "industry" */
  delete_industry?: Maybe<Industry_Mutation_Response>;
  /** delete single row from the table: "industry" */
  delete_industry_by_pk?: Maybe<Industry>;
  /** delete data from the table: "invitation" */
  delete_invitation?: Maybe<Invitation_Mutation_Response>;
  /** delete single row from the table: "invitation" */
  delete_invitation_by_pk?: Maybe<Invitation>;
  /** delete data from the table: "invoice" */
  delete_invoice?: Maybe<Invoice_Mutation_Response>;
  /** delete single row from the table: "invoice" */
  delete_invoice_by_pk?: Maybe<Invoice>;
  /** delete data from the table: "language" */
  delete_language?: Maybe<Language_Mutation_Response>;
  /** delete single row from the table: "language" */
  delete_language_by_pk?: Maybe<Language>;
  /** delete data from the table: "manager" */
  delete_manager?: Maybe<Manager_Mutation_Response>;
  /** delete single row from the table: "manager" */
  delete_manager_by_pk?: Maybe<Manager>;
  /** delete data from the table: "manager_contractor" */
  delete_manager_contractor?: Maybe<Manager_Contractor_Mutation_Response>;
  /** delete single row from the table: "manager_contractor" */
  delete_manager_contractor_by_pk?: Maybe<Manager_Contractor>;
  /** delete data from the table: "message" */
  delete_message?: Maybe<Message_Mutation_Response>;
  /** delete single row from the table: "message" */
  delete_message_by_pk?: Maybe<Message>;
  /** delete data from the table: "notification" */
  delete_notification?: Maybe<Notification_Mutation_Response>;
  /** delete single row from the table: "notification" */
  delete_notification_by_pk?: Maybe<Notification>;
  /** delete data from the table: "onboarding" */
  delete_onboarding?: Maybe<Onboarding_Mutation_Response>;
  /** delete single row from the table: "onboarding" */
  delete_onboarding_by_pk?: Maybe<Onboarding>;
  /** delete data from the table: "payment_card" */
  delete_payment_card?: Maybe<Payment_Card_Mutation_Response>;
  /** delete single row from the table: "payment_card" */
  delete_payment_card_by_pk?: Maybe<Payment_Card>;
  /** delete data from the table: "posting" */
  delete_posting?: Maybe<Posting_Mutation_Response>;
  /** delete single row from the table: "posting" */
  delete_posting_by_pk?: Maybe<Posting>;
  /** delete data from the table: "posting_industry" */
  delete_posting_industry?: Maybe<Posting_Industry_Mutation_Response>;
  /** delete single row from the table: "posting_industry" */
  delete_posting_industry_by_pk?: Maybe<Posting_Industry>;
  /** delete data from the table: "posting_skill" */
  delete_posting_skill?: Maybe<Posting_Skill_Mutation_Response>;
  /** delete single row from the table: "posting_skill" */
  delete_posting_skill_by_pk?: Maybe<Posting_Skill>;
  /** delete data from the table: "posting_tags" */
  delete_posting_tags?: Maybe<Posting_Tags_Mutation_Response>;
  /** delete single row from the table: "posting_tags" */
  delete_posting_tags_by_pk?: Maybe<Posting_Tags>;
  /** delete data from the table: "project" */
  delete_project?: Maybe<Project_Mutation_Response>;
  /** delete data from the table: "project_activity" */
  delete_project_activity?: Maybe<Project_Activity_Mutation_Response>;
  /** delete single row from the table: "project_activity" */
  delete_project_activity_by_pk?: Maybe<Project_Activity>;
  /** delete data from the table: "project_activity_note" */
  delete_project_activity_note?: Maybe<Project_Activity_Note_Mutation_Response>;
  /** delete single row from the table: "project_activity_note" */
  delete_project_activity_note_by_pk?: Maybe<Project_Activity_Note>;
  /** delete data from the table: "project_activity_request_more_hours" */
  delete_project_activity_request_more_hours?: Maybe<Project_Activity_Request_More_Hours_Mutation_Response>;
  /** delete single row from the table: "project_activity_request_more_hours" */
  delete_project_activity_request_more_hours_by_pk?: Maybe<Project_Activity_Request_More_Hours>;
  /** delete data from the table: "project_activity_skill" */
  delete_project_activity_skill?: Maybe<Project_Activity_Skill_Mutation_Response>;
  /** delete single row from the table: "project_activity_skill" */
  delete_project_activity_skill_by_pk?: Maybe<Project_Activity_Skill>;
  /** delete data from the table: "project_activity_soft_skill" */
  delete_project_activity_soft_skill?: Maybe<Project_Activity_Soft_Skill_Mutation_Response>;
  /** delete single row from the table: "project_activity_soft_skill" */
  delete_project_activity_soft_skill_by_pk?: Maybe<Project_Activity_Soft_Skill>;
  /** delete data from the table: "project_activity_tag" */
  delete_project_activity_tag?: Maybe<Project_Activity_Tag_Mutation_Response>;
  /** delete single row from the table: "project_activity_tag" */
  delete_project_activity_tag_by_pk?: Maybe<Project_Activity_Tag>;
  /** delete data from the table: "project_activity_time" */
  delete_project_activity_time?: Maybe<Project_Activity_Time_Mutation_Response>;
  /** delete single row from the table: "project_activity_time" */
  delete_project_activity_time_by_pk?: Maybe<Project_Activity_Time>;
  /** delete data from the table: "project_activity_tracked_time" */
  delete_project_activity_tracked_time?: Maybe<Project_Activity_Tracked_Time_Mutation_Response>;
  /** delete single row from the table: "project_activity_tracked_time" */
  delete_project_activity_tracked_time_by_pk?: Maybe<Project_Activity_Tracked_Time>;
  /** delete single row from the table: "project" */
  delete_project_by_pk?: Maybe<Project>;
  /** delete data from the table: "project_skill" */
  delete_project_skill?: Maybe<Project_Skill_Mutation_Response>;
  /** delete single row from the table: "project_skill" */
  delete_project_skill_by_pk?: Maybe<Project_Skill>;
  /** delete data from the table: "project_soft_skill" */
  delete_project_soft_skill?: Maybe<Project_Soft_Skill_Mutation_Response>;
  /** delete single row from the table: "project_soft_skill" */
  delete_project_soft_skill_by_pk?: Maybe<Project_Soft_Skill>;
  /** delete data from the table: "project_tag" */
  delete_project_tag?: Maybe<Project_Tag_Mutation_Response>;
  /** delete single row from the table: "project_tag" */
  delete_project_tag_by_pk?: Maybe<Project_Tag>;
  /** delete data from the table: "recipient_message" */
  delete_recipient_message?: Maybe<Recipient_Message_Mutation_Response>;
  /** delete single row from the table: "recipient_message" */
  delete_recipient_message_by_pk?: Maybe<Recipient_Message>;
  /** delete data from the table: "resource_information_card" */
  delete_resource_information_card?: Maybe<Resource_Information_Card_Mutation_Response>;
  /** delete single row from the table: "resource_information_card" */
  delete_resource_information_card_by_pk?: Maybe<Resource_Information_Card>;
  /** delete data from the table: "skill" */
  delete_skill?: Maybe<Skill_Mutation_Response>;
  /** delete single row from the table: "skill" */
  delete_skill_by_pk?: Maybe<Skill>;
  /** delete data from the table: "skills_short_name_first" */
  delete_skills_short_name_first?: Maybe<Skills_Short_Name_First_Mutation_Response>;
  /** delete data from the table: "smart_match_bookmark" */
  delete_smart_match_bookmark?: Maybe<Smart_Match_Bookmark_Mutation_Response>;
  /** delete single row from the table: "smart_match_bookmark" */
  delete_smart_match_bookmark_by_pk?: Maybe<Smart_Match_Bookmark>;
  /** delete data from the table: "smart_match_config_transportation" */
  delete_smart_match_config_transportation?: Maybe<Smart_Match_Config_Transportation_Mutation_Response>;
  /** delete single row from the table: "smart_match_config_transportation" */
  delete_smart_match_config_transportation_by_pk?: Maybe<Smart_Match_Config_Transportation>;
  /** delete data from the table: "smart_match_configs" */
  delete_smart_match_configs?: Maybe<Smart_Match_Configs_Mutation_Response>;
  /** delete single row from the table: "smart_match_configs" */
  delete_smart_match_configs_by_pk?: Maybe<Smart_Match_Configs>;
  /** delete data from the table: "smart_match_criteria_order" */
  delete_smart_match_criteria_order?: Maybe<Smart_Match_Criteria_Order_Mutation_Response>;
  /** delete single row from the table: "smart_match_criteria_order" */
  delete_smart_match_criteria_order_by_pk?: Maybe<Smart_Match_Criteria_Order>;
  /** delete data from the table: "soft_skill" */
  delete_soft_skill?: Maybe<Soft_Skill_Mutation_Response>;
  /** delete single row from the table: "soft_skill" */
  delete_soft_skill_by_pk?: Maybe<Soft_Skill>;
  /** delete data from the table: "source" */
  delete_source?: Maybe<Source_Mutation_Response>;
  /** delete single row from the table: "source" */
  delete_source_by_pk?: Maybe<Source>;
  /** delete data from the table: "subscription" */
  delete_subscription?: Maybe<Subscription_Mutation_Response>;
  /** delete single row from the table: "subscription" */
  delete_subscription_by_pk?: Maybe<Subscription>;
  /** delete data from the table: "subscription_plan" */
  delete_subscription_plan?: Maybe<Subscription_Plan_Mutation_Response>;
  /** delete data from the table: "subscription_plan_access_permissions" */
  delete_subscription_plan_access_permissions?: Maybe<Subscription_Plan_Access_Permissions_Mutation_Response>;
  /** delete single row from the table: "subscription_plan_access_permissions" */
  delete_subscription_plan_access_permissions_by_pk?: Maybe<Subscription_Plan_Access_Permissions>;
  /** delete single row from the table: "subscription_plan" */
  delete_subscription_plan_by_pk?: Maybe<Subscription_Plan>;
  /** delete data from the table: "tag" */
  delete_tag?: Maybe<Tag_Mutation_Response>;
  /** delete single row from the table: "tag" */
  delete_tag_by_pk?: Maybe<Tag>;
  /** delete data from the table: "team" */
  delete_team?: Maybe<Team_Mutation_Response>;
  /** delete single row from the table: "team" */
  delete_team_by_pk?: Maybe<Team>;
  /** delete data from the table: "team_contractor" */
  delete_team_contractor?: Maybe<Team_Contractor_Mutation_Response>;
  /** delete single row from the table: "team_contractor" */
  delete_team_contractor_by_pk?: Maybe<Team_Contractor>;
  /** delete data from the table: "team_manager" */
  delete_team_manager?: Maybe<Team_Manager_Mutation_Response>;
  /** delete single row from the table: "team_manager" */
  delete_team_manager_by_pk?: Maybe<Team_Manager>;
  /** delete data from the table: "team_posting" */
  delete_team_posting?: Maybe<Team_Posting_Mutation_Response>;
  /** delete single row from the table: "team_posting" */
  delete_team_posting_by_pk?: Maybe<Team_Posting>;
  /** delete data from the table: "team_project" */
  delete_team_project?: Maybe<Team_Project_Mutation_Response>;
  /** delete single row from the table: "team_project" */
  delete_team_project_by_pk?: Maybe<Team_Project>;
  /** delete data from the table: "team_skill" */
  delete_team_skill?: Maybe<Team_Skill_Mutation_Response>;
  /** delete single row from the table: "team_skill" */
  delete_team_skill_by_pk?: Maybe<Team_Skill>;
  /** delete data from the table: "timesheet" */
  delete_timesheet?: Maybe<Timesheet_Mutation_Response>;
  /** delete single row from the table: "timesheet" */
  delete_timesheet_by_pk?: Maybe<Timesheet>;
  /** delete data from the table: "type_of_visit" */
  delete_type_of_visit?: Maybe<Type_Of_Visit_Mutation_Response>;
  /** delete single row from the table: "type_of_visit" */
  delete_type_of_visit_by_pk?: Maybe<Type_Of_Visit>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "user_affinda_profile" */
  delete_user_affinda_profile?: Maybe<User_Affinda_Profile_Mutation_Response>;
  /** delete single row from the table: "user_affinda_profile" */
  delete_user_affinda_profile_by_pk?: Maybe<User_Affinda_Profile>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_certification" */
  delete_user_certification?: Maybe<User_Certification_Mutation_Response>;
  /** delete single row from the table: "user_certification" */
  delete_user_certification_by_pk?: Maybe<User_Certification>;
  /** delete data from the table: "user_company" */
  delete_user_company?: Maybe<User_Company_Mutation_Response>;
  /** delete single row from the table: "user_company" */
  delete_user_company_by_pk?: Maybe<User_Company>;
  /** delete data from the table: "user_conversation" */
  delete_user_conversation?: Maybe<User_Conversation_Mutation_Response>;
  /** delete single row from the table: "user_conversation" */
  delete_user_conversation_by_pk?: Maybe<User_Conversation>;
  /** delete data from the table: "user_education" */
  delete_user_education?: Maybe<User_Education_Mutation_Response>;
  /** delete single row from the table: "user_education" */
  delete_user_education_by_pk?: Maybe<User_Education>;
  /** delete data from the table: "user_experience" */
  delete_user_experience?: Maybe<User_Experience_Mutation_Response>;
  /** delete single row from the table: "user_experience" */
  delete_user_experience_by_pk?: Maybe<User_Experience>;
  /** delete data from the table: "user_favorite" */
  delete_user_favorite?: Maybe<User_Favorite_Mutation_Response>;
  /** delete single row from the table: "user_favorite" */
  delete_user_favorite_by_pk?: Maybe<User_Favorite>;
  /** delete data from the table: "user_industry" */
  delete_user_industry?: Maybe<User_Industry_Mutation_Response>;
  /** delete single row from the table: "user_industry" */
  delete_user_industry_by_pk?: Maybe<User_Industry>;
  /** delete data from the table: "user_job_title" */
  delete_user_job_title?: Maybe<User_Job_Title_Mutation_Response>;
  /** delete single row from the table: "user_job_title" */
  delete_user_job_title_by_pk?: Maybe<User_Job_Title>;
  /** delete data from the table: "user_language" */
  delete_user_language?: Maybe<User_Language_Mutation_Response>;
  /** delete single row from the table: "user_language" */
  delete_user_language_by_pk?: Maybe<User_Language>;
  /** delete data from the table: "user_private_data" */
  delete_user_private_data?: Maybe<User_Private_Data_Mutation_Response>;
  /** delete data from the table: "user_profile" */
  delete_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** delete data from the table: "user_profile_by_management" */
  delete_user_profile_by_management?: Maybe<User_Profile_By_Management_Mutation_Response>;
  /** delete single row from the table: "user_profile_by_management" */
  delete_user_profile_by_management_by_pk?: Maybe<User_Profile_By_Management>;
  /** delete single row from the table: "user_profile" */
  delete_user_profile_by_pk?: Maybe<User_Profile>;
  /** delete data from the table: "user_rating" */
  delete_user_rating?: Maybe<User_Rating_Mutation_Response>;
  /** delete single row from the table: "user_rating" */
  delete_user_rating_by_pk?: Maybe<User_Rating>;
  /** delete data from the table: "user_skill" */
  delete_user_skill?: Maybe<User_Skill_Mutation_Response>;
  /** delete single row from the table: "user_skill" */
  delete_user_skill_by_pk?: Maybe<User_Skill>;
  /** delete data from the table: "user_soft_skill" */
  delete_user_soft_skill?: Maybe<User_Soft_Skill_Mutation_Response>;
  /** delete single row from the table: "user_soft_skill" */
  delete_user_soft_skill_by_pk?: Maybe<User_Soft_Skill>;
  /** delete data from the table: "user_transportation" */
  delete_user_transportation?: Maybe<User_Transportation_Mutation_Response>;
  /** delete single row from the table: "user_transportation" */
  delete_user_transportation_by_pk?: Maybe<User_Transportation>;
  /** delete data from the table: "user_watchlist" */
  delete_user_watchlist?: Maybe<User_Watchlist_Mutation_Response>;
  /** delete single row from the table: "user_watchlist" */
  delete_user_watchlist_by_pk?: Maybe<User_Watchlist>;
  /** insert data into the table: "admin" */
  insert_admin?: Maybe<Admin_Mutation_Response>;
  /** insert a single row into the table: "admin" */
  insert_admin_one?: Maybe<Admin>;
  /** insert data into the table: "application" */
  insert_application?: Maybe<Application_Mutation_Response>;
  /** insert a single row into the table: "application" */
  insert_application_one?: Maybe<Application>;
  /** insert data into the table: "candidate" */
  insert_candidate?: Maybe<Candidate_Mutation_Response>;
  /** insert a single row into the table: "candidate" */
  insert_candidate_one?: Maybe<Candidate>;
  /** insert data into the table: "checkin_status" */
  insert_checkin_status?: Maybe<Checkin_Status_Mutation_Response>;
  /** insert a single row into the table: "checkin_status" */
  insert_checkin_status_one?: Maybe<Checkin_Status>;
  /** insert data into the table: "checkout_status" */
  insert_checkout_status?: Maybe<Checkout_Status_Mutation_Response>;
  /** insert a single row into the table: "checkout_status" */
  insert_checkout_status_one?: Maybe<Checkout_Status>;
  /** insert data into the table: "client_care_plan" */
  insert_client_care_plan?: Maybe<Client_Care_Plan_Mutation_Response>;
  /** insert a single row into the table: "client_care_plan" */
  insert_client_care_plan_one?: Maybe<Client_Care_Plan>;
  /** insert data into the table: "client_medications" */
  insert_client_medications?: Maybe<Client_Medications_Mutation_Response>;
  /** insert a single row into the table: "client_medications" */
  insert_client_medications_one?: Maybe<Client_Medications>;
  /** insert data into the table: "company" */
  insert_company?: Maybe<Company_Mutation_Response>;
  /** insert data into the table: "company_follower" */
  insert_company_follower?: Maybe<Company_Follower_Mutation_Response>;
  /** insert a single row into the table: "company_follower" */
  insert_company_follower_one?: Maybe<Company_Follower>;
  /** insert a single row into the table: "company" */
  insert_company_one?: Maybe<Company>;
  /** insert data into the table: "company_user_notifications" */
  insert_company_user_notifications?: Maybe<Company_User_Notifications_Mutation_Response>;
  /** insert a single row into the table: "company_user_notifications" */
  insert_company_user_notifications_one?: Maybe<Company_User_Notifications>;
  /** insert data into the table: "contractor" */
  insert_contractor?: Maybe<Contractor_Mutation_Response>;
  /** insert data into the table: "contractor_note" */
  insert_contractor_note?: Maybe<Contractor_Note_Mutation_Response>;
  /** insert a single row into the table: "contractor_note" */
  insert_contractor_note_one?: Maybe<Contractor_Note>;
  /** insert a single row into the table: "contractor" */
  insert_contractor_one?: Maybe<Contractor>;
  /** insert data into the table: "contractor_posting" */
  insert_contractor_posting?: Maybe<Contractor_Posting_Mutation_Response>;
  /** insert a single row into the table: "contractor_posting" */
  insert_contractor_posting_one?: Maybe<Contractor_Posting>;
  /** insert data into the table: "contractor_project" */
  insert_contractor_project?: Maybe<Contractor_Project_Mutation_Response>;
  /** insert a single row into the table: "contractor_project" */
  insert_contractor_project_one?: Maybe<Contractor_Project>;
  /** insert data into the table: "contractor_rating" */
  insert_contractor_rating?: Maybe<Contractor_Rating_Mutation_Response>;
  /** insert a single row into the table: "contractor_rating" */
  insert_contractor_rating_one?: Maybe<Contractor_Rating>;
  /** insert data into the table: "contractor_staff_note" */
  insert_contractor_staff_note?: Maybe<Contractor_Staff_Note_Mutation_Response>;
  /** insert a single row into the table: "contractor_staff_note" */
  insert_contractor_staff_note_one?: Maybe<Contractor_Staff_Note>;
  /** insert data into the table: "conversation" */
  insert_conversation?: Maybe<Conversation_Mutation_Response>;
  /** insert a single row into the table: "conversation" */
  insert_conversation_one?: Maybe<Conversation>;
  /** insert data into the table: "custom_request" */
  insert_custom_request?: Maybe<Custom_Request_Mutation_Response>;
  /** insert a single row into the table: "custom_request" */
  insert_custom_request_one?: Maybe<Custom_Request>;
  /** insert data into the table: "custom_request_skills" */
  insert_custom_request_skills?: Maybe<Custom_Request_Skills_Mutation_Response>;
  /** insert a single row into the table: "custom_request_skills" */
  insert_custom_request_skills_one?: Maybe<Custom_Request_Skills>;
  /** insert data into the table: "declined_visit_matches" */
  insert_declined_visit_matches?: Maybe<Declined_Visit_Matches_Mutation_Response>;
  /** insert a single row into the table: "declined_visit_matches" */
  insert_declined_visit_matches_one?: Maybe<Declined_Visit_Matches>;
  /** insert data into the table: "document" */
  insert_document?: Maybe<Document_Mutation_Response>;
  /** insert data into the table: "document_contractor_access" */
  insert_document_contractor_access?: Maybe<Document_Contractor_Access_Mutation_Response>;
  /** insert a single row into the table: "document_contractor_access" */
  insert_document_contractor_access_one?: Maybe<Document_Contractor_Access>;
  /** insert data into the table: "document_custom_request" */
  insert_document_custom_request?: Maybe<Document_Custom_Request_Mutation_Response>;
  /** insert a single row into the table: "document_custom_request" */
  insert_document_custom_request_one?: Maybe<Document_Custom_Request>;
  /** insert a single row into the table: "document" */
  insert_document_one?: Maybe<Document>;
  /** insert data into the table: "document_project" */
  insert_document_project?: Maybe<Document_Project_Mutation_Response>;
  /** insert a single row into the table: "document_project" */
  insert_document_project_one?: Maybe<Document_Project>;
  /** insert data into the table: "document_user" */
  insert_document_user?: Maybe<Document_User_Mutation_Response>;
  /** insert a single row into the table: "document_user" */
  insert_document_user_one?: Maybe<Document_User>;
  /** insert data into the table: "email_regex" */
  insert_email_regex?: Maybe<Email_Regex_Mutation_Response>;
  /** insert a single row into the table: "email_regex" */
  insert_email_regex_one?: Maybe<Email_Regex>;
  /** insert data into the table: "experience_skill" */
  insert_experience_skill?: Maybe<Experience_Skill_Mutation_Response>;
  /** insert a single row into the table: "experience_skill" */
  insert_experience_skill_one?: Maybe<Experience_Skill>;
  /** insert data into the table: "gender" */
  insert_gender?: Maybe<Gender_Mutation_Response>;
  /** insert a single row into the table: "gender" */
  insert_gender_one?: Maybe<Gender>;
  /** insert data into the table: "industry" */
  insert_industry?: Maybe<Industry_Mutation_Response>;
  /** insert a single row into the table: "industry" */
  insert_industry_one?: Maybe<Industry>;
  /** insert data into the table: "invitation" */
  insert_invitation?: Maybe<Invitation_Mutation_Response>;
  /** insert a single row into the table: "invitation" */
  insert_invitation_one?: Maybe<Invitation>;
  /** insert data into the table: "invoice" */
  insert_invoice?: Maybe<Invoice_Mutation_Response>;
  /** insert a single row into the table: "invoice" */
  insert_invoice_one?: Maybe<Invoice>;
  /** insert data into the table: "language" */
  insert_language?: Maybe<Language_Mutation_Response>;
  /** insert a single row into the table: "language" */
  insert_language_one?: Maybe<Language>;
  /** insert data into the table: "manager" */
  insert_manager?: Maybe<Manager_Mutation_Response>;
  /** insert data into the table: "manager_contractor" */
  insert_manager_contractor?: Maybe<Manager_Contractor_Mutation_Response>;
  /** insert a single row into the table: "manager_contractor" */
  insert_manager_contractor_one?: Maybe<Manager_Contractor>;
  /** insert a single row into the table: "manager" */
  insert_manager_one?: Maybe<Manager>;
  /** insert data into the table: "message" */
  insert_message?: Maybe<Message_Mutation_Response>;
  /** insert a single row into the table: "message" */
  insert_message_one?: Maybe<Message>;
  /** insert data into the table: "notification" */
  insert_notification?: Maybe<Notification_Mutation_Response>;
  /** insert a single row into the table: "notification" */
  insert_notification_one?: Maybe<Notification>;
  /** insert data into the table: "onboarding" */
  insert_onboarding?: Maybe<Onboarding_Mutation_Response>;
  /** insert a single row into the table: "onboarding" */
  insert_onboarding_one?: Maybe<Onboarding>;
  /** insert data into the table: "payment_card" */
  insert_payment_card?: Maybe<Payment_Card_Mutation_Response>;
  /** insert a single row into the table: "payment_card" */
  insert_payment_card_one?: Maybe<Payment_Card>;
  /** insert data into the table: "posting" */
  insert_posting?: Maybe<Posting_Mutation_Response>;
  /** insert data into the table: "posting_industry" */
  insert_posting_industry?: Maybe<Posting_Industry_Mutation_Response>;
  /** insert a single row into the table: "posting_industry" */
  insert_posting_industry_one?: Maybe<Posting_Industry>;
  /** insert a single row into the table: "posting" */
  insert_posting_one?: Maybe<Posting>;
  /** insert data into the table: "posting_skill" */
  insert_posting_skill?: Maybe<Posting_Skill_Mutation_Response>;
  /** insert a single row into the table: "posting_skill" */
  insert_posting_skill_one?: Maybe<Posting_Skill>;
  /** insert data into the table: "posting_tags" */
  insert_posting_tags?: Maybe<Posting_Tags_Mutation_Response>;
  /** insert a single row into the table: "posting_tags" */
  insert_posting_tags_one?: Maybe<Posting_Tags>;
  /** insert data into the table: "project" */
  insert_project?: Maybe<Project_Mutation_Response>;
  /** insert data into the table: "project_activity" */
  insert_project_activity?: Maybe<Project_Activity_Mutation_Response>;
  /** insert data into the table: "project_activity_note" */
  insert_project_activity_note?: Maybe<Project_Activity_Note_Mutation_Response>;
  /** insert a single row into the table: "project_activity_note" */
  insert_project_activity_note_one?: Maybe<Project_Activity_Note>;
  /** insert a single row into the table: "project_activity" */
  insert_project_activity_one?: Maybe<Project_Activity>;
  /** insert data into the table: "project_activity_request_more_hours" */
  insert_project_activity_request_more_hours?: Maybe<Project_Activity_Request_More_Hours_Mutation_Response>;
  /** insert a single row into the table: "project_activity_request_more_hours" */
  insert_project_activity_request_more_hours_one?: Maybe<Project_Activity_Request_More_Hours>;
  /** insert data into the table: "project_activity_skill" */
  insert_project_activity_skill?: Maybe<Project_Activity_Skill_Mutation_Response>;
  /** insert a single row into the table: "project_activity_skill" */
  insert_project_activity_skill_one?: Maybe<Project_Activity_Skill>;
  /** insert data into the table: "project_activity_soft_skill" */
  insert_project_activity_soft_skill?: Maybe<Project_Activity_Soft_Skill_Mutation_Response>;
  /** insert a single row into the table: "project_activity_soft_skill" */
  insert_project_activity_soft_skill_one?: Maybe<Project_Activity_Soft_Skill>;
  /** insert data into the table: "project_activity_tag" */
  insert_project_activity_tag?: Maybe<Project_Activity_Tag_Mutation_Response>;
  /** insert a single row into the table: "project_activity_tag" */
  insert_project_activity_tag_one?: Maybe<Project_Activity_Tag>;
  /** insert data into the table: "project_activity_time" */
  insert_project_activity_time?: Maybe<Project_Activity_Time_Mutation_Response>;
  /** insert a single row into the table: "project_activity_time" */
  insert_project_activity_time_one?: Maybe<Project_Activity_Time>;
  /** insert data into the table: "project_activity_tracked_time" */
  insert_project_activity_tracked_time?: Maybe<Project_Activity_Tracked_Time_Mutation_Response>;
  /** insert a single row into the table: "project_activity_tracked_time" */
  insert_project_activity_tracked_time_one?: Maybe<Project_Activity_Tracked_Time>;
  /** insert a single row into the table: "project" */
  insert_project_one?: Maybe<Project>;
  /** insert data into the table: "project_skill" */
  insert_project_skill?: Maybe<Project_Skill_Mutation_Response>;
  /** insert a single row into the table: "project_skill" */
  insert_project_skill_one?: Maybe<Project_Skill>;
  /** insert data into the table: "project_soft_skill" */
  insert_project_soft_skill?: Maybe<Project_Soft_Skill_Mutation_Response>;
  /** insert a single row into the table: "project_soft_skill" */
  insert_project_soft_skill_one?: Maybe<Project_Soft_Skill>;
  /** insert data into the table: "project_tag" */
  insert_project_tag?: Maybe<Project_Tag_Mutation_Response>;
  /** insert a single row into the table: "project_tag" */
  insert_project_tag_one?: Maybe<Project_Tag>;
  /** insert data into the table: "recipient_message" */
  insert_recipient_message?: Maybe<Recipient_Message_Mutation_Response>;
  /** insert a single row into the table: "recipient_message" */
  insert_recipient_message_one?: Maybe<Recipient_Message>;
  /** insert data into the table: "resource_information_card" */
  insert_resource_information_card?: Maybe<Resource_Information_Card_Mutation_Response>;
  /** insert a single row into the table: "resource_information_card" */
  insert_resource_information_card_one?: Maybe<Resource_Information_Card>;
  /** insert data into the table: "skill" */
  insert_skill?: Maybe<Skill_Mutation_Response>;
  /** insert a single row into the table: "skill" */
  insert_skill_one?: Maybe<Skill>;
  /** insert data into the table: "skills_short_name_first" */
  insert_skills_short_name_first?: Maybe<Skills_Short_Name_First_Mutation_Response>;
  /** insert a single row into the table: "skills_short_name_first" */
  insert_skills_short_name_first_one?: Maybe<Skills_Short_Name_First>;
  /** insert data into the table: "smart_match_bookmark" */
  insert_smart_match_bookmark?: Maybe<Smart_Match_Bookmark_Mutation_Response>;
  /** insert a single row into the table: "smart_match_bookmark" */
  insert_smart_match_bookmark_one?: Maybe<Smart_Match_Bookmark>;
  /** insert data into the table: "smart_match_config_transportation" */
  insert_smart_match_config_transportation?: Maybe<Smart_Match_Config_Transportation_Mutation_Response>;
  /** insert a single row into the table: "smart_match_config_transportation" */
  insert_smart_match_config_transportation_one?: Maybe<Smart_Match_Config_Transportation>;
  /** insert data into the table: "smart_match_configs" */
  insert_smart_match_configs?: Maybe<Smart_Match_Configs_Mutation_Response>;
  /** insert a single row into the table: "smart_match_configs" */
  insert_smart_match_configs_one?: Maybe<Smart_Match_Configs>;
  /** insert data into the table: "smart_match_criteria_order" */
  insert_smart_match_criteria_order?: Maybe<Smart_Match_Criteria_Order_Mutation_Response>;
  /** insert a single row into the table: "smart_match_criteria_order" */
  insert_smart_match_criteria_order_one?: Maybe<Smart_Match_Criteria_Order>;
  /** insert data into the table: "soft_skill" */
  insert_soft_skill?: Maybe<Soft_Skill_Mutation_Response>;
  /** insert a single row into the table: "soft_skill" */
  insert_soft_skill_one?: Maybe<Soft_Skill>;
  /** insert data into the table: "source" */
  insert_source?: Maybe<Source_Mutation_Response>;
  /** insert a single row into the table: "source" */
  insert_source_one?: Maybe<Source>;
  /** insert data into the table: "subscription" */
  insert_subscription?: Maybe<Subscription_Mutation_Response>;
  /** insert a single row into the table: "subscription" */
  insert_subscription_one?: Maybe<Subscription>;
  /** insert data into the table: "subscription_plan" */
  insert_subscription_plan?: Maybe<Subscription_Plan_Mutation_Response>;
  /** insert data into the table: "subscription_plan_access_permissions" */
  insert_subscription_plan_access_permissions?: Maybe<Subscription_Plan_Access_Permissions_Mutation_Response>;
  /** insert a single row into the table: "subscription_plan_access_permissions" */
  insert_subscription_plan_access_permissions_one?: Maybe<Subscription_Plan_Access_Permissions>;
  /** insert a single row into the table: "subscription_plan" */
  insert_subscription_plan_one?: Maybe<Subscription_Plan>;
  /** insert data into the table: "tag" */
  insert_tag?: Maybe<Tag_Mutation_Response>;
  /** insert a single row into the table: "tag" */
  insert_tag_one?: Maybe<Tag>;
  /** insert data into the table: "team" */
  insert_team?: Maybe<Team_Mutation_Response>;
  /** insert data into the table: "team_contractor" */
  insert_team_contractor?: Maybe<Team_Contractor_Mutation_Response>;
  /** insert a single row into the table: "team_contractor" */
  insert_team_contractor_one?: Maybe<Team_Contractor>;
  /** insert data into the table: "team_manager" */
  insert_team_manager?: Maybe<Team_Manager_Mutation_Response>;
  /** insert a single row into the table: "team_manager" */
  insert_team_manager_one?: Maybe<Team_Manager>;
  /** insert a single row into the table: "team" */
  insert_team_one?: Maybe<Team>;
  /** insert data into the table: "team_posting" */
  insert_team_posting?: Maybe<Team_Posting_Mutation_Response>;
  /** insert a single row into the table: "team_posting" */
  insert_team_posting_one?: Maybe<Team_Posting>;
  /** insert data into the table: "team_project" */
  insert_team_project?: Maybe<Team_Project_Mutation_Response>;
  /** insert a single row into the table: "team_project" */
  insert_team_project_one?: Maybe<Team_Project>;
  /** insert data into the table: "team_skill" */
  insert_team_skill?: Maybe<Team_Skill_Mutation_Response>;
  /** insert a single row into the table: "team_skill" */
  insert_team_skill_one?: Maybe<Team_Skill>;
  /** insert data into the table: "timesheet" */
  insert_timesheet?: Maybe<Timesheet_Mutation_Response>;
  /** insert a single row into the table: "timesheet" */
  insert_timesheet_one?: Maybe<Timesheet>;
  /** insert data into the table: "type_of_visit" */
  insert_type_of_visit?: Maybe<Type_Of_Visit_Mutation_Response>;
  /** insert a single row into the table: "type_of_visit" */
  insert_type_of_visit_one?: Maybe<Type_Of_Visit>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_affinda_profile" */
  insert_user_affinda_profile?: Maybe<User_Affinda_Profile_Mutation_Response>;
  /** insert a single row into the table: "user_affinda_profile" */
  insert_user_affinda_profile_one?: Maybe<User_Affinda_Profile>;
  /** insert data into the table: "user_certification" */
  insert_user_certification?: Maybe<User_Certification_Mutation_Response>;
  /** insert a single row into the table: "user_certification" */
  insert_user_certification_one?: Maybe<User_Certification>;
  /** insert data into the table: "user_company" */
  insert_user_company?: Maybe<User_Company_Mutation_Response>;
  /** insert a single row into the table: "user_company" */
  insert_user_company_one?: Maybe<User_Company>;
  /** insert data into the table: "user_conversation" */
  insert_user_conversation?: Maybe<User_Conversation_Mutation_Response>;
  /** insert a single row into the table: "user_conversation" */
  insert_user_conversation_one?: Maybe<User_Conversation>;
  /** insert data into the table: "user_education" */
  insert_user_education?: Maybe<User_Education_Mutation_Response>;
  /** insert a single row into the table: "user_education" */
  insert_user_education_one?: Maybe<User_Education>;
  /** insert data into the table: "user_experience" */
  insert_user_experience?: Maybe<User_Experience_Mutation_Response>;
  /** insert a single row into the table: "user_experience" */
  insert_user_experience_one?: Maybe<User_Experience>;
  /** insert data into the table: "user_favorite" */
  insert_user_favorite?: Maybe<User_Favorite_Mutation_Response>;
  /** insert a single row into the table: "user_favorite" */
  insert_user_favorite_one?: Maybe<User_Favorite>;
  /** insert data into the table: "user_industry" */
  insert_user_industry?: Maybe<User_Industry_Mutation_Response>;
  /** insert a single row into the table: "user_industry" */
  insert_user_industry_one?: Maybe<User_Industry>;
  /** insert data into the table: "user_job_title" */
  insert_user_job_title?: Maybe<User_Job_Title_Mutation_Response>;
  /** insert a single row into the table: "user_job_title" */
  insert_user_job_title_one?: Maybe<User_Job_Title>;
  /** insert data into the table: "user_language" */
  insert_user_language?: Maybe<User_Language_Mutation_Response>;
  /** insert a single row into the table: "user_language" */
  insert_user_language_one?: Maybe<User_Language>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_private_data" */
  insert_user_private_data?: Maybe<User_Private_Data_Mutation_Response>;
  /** insert a single row into the table: "user_private_data" */
  insert_user_private_data_one?: Maybe<User_Private_Data>;
  /** insert data into the table: "user_profile" */
  insert_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** insert data into the table: "user_profile_by_management" */
  insert_user_profile_by_management?: Maybe<User_Profile_By_Management_Mutation_Response>;
  /** insert a single row into the table: "user_profile_by_management" */
  insert_user_profile_by_management_one?: Maybe<User_Profile_By_Management>;
  /** insert a single row into the table: "user_profile" */
  insert_user_profile_one?: Maybe<User_Profile>;
  /** insert data into the table: "user_rating" */
  insert_user_rating?: Maybe<User_Rating_Mutation_Response>;
  /** insert a single row into the table: "user_rating" */
  insert_user_rating_one?: Maybe<User_Rating>;
  /** insert data into the table: "user_skill" */
  insert_user_skill?: Maybe<User_Skill_Mutation_Response>;
  /** insert a single row into the table: "user_skill" */
  insert_user_skill_one?: Maybe<User_Skill>;
  /** insert data into the table: "user_soft_skill" */
  insert_user_soft_skill?: Maybe<User_Soft_Skill_Mutation_Response>;
  /** insert a single row into the table: "user_soft_skill" */
  insert_user_soft_skill_one?: Maybe<User_Soft_Skill>;
  /** insert data into the table: "user_transportation" */
  insert_user_transportation?: Maybe<User_Transportation_Mutation_Response>;
  /** insert a single row into the table: "user_transportation" */
  insert_user_transportation_one?: Maybe<User_Transportation>;
  /** insert data into the table: "user_watchlist" */
  insert_user_watchlist?: Maybe<User_Watchlist_Mutation_Response>;
  /** insert a single row into the table: "user_watchlist" */
  insert_user_watchlist_one?: Maybe<User_Watchlist>;
  /** update data of the table: "admin" */
  update_admin?: Maybe<Admin_Mutation_Response>;
  /** update single row of the table: "admin" */
  update_admin_by_pk?: Maybe<Admin>;
  /** update multiples rows of table: "admin" */
  update_admin_many?: Maybe<Array<Maybe<Admin_Mutation_Response>>>;
  /** update data of the table: "application" */
  update_application?: Maybe<Application_Mutation_Response>;
  /** update single row of the table: "application" */
  update_application_by_pk?: Maybe<Application>;
  /** update multiples rows of table: "application" */
  update_application_many?: Maybe<Array<Maybe<Application_Mutation_Response>>>;
  /** update data of the table: "candidate" */
  update_candidate?: Maybe<Candidate_Mutation_Response>;
  /** update single row of the table: "candidate" */
  update_candidate_by_pk?: Maybe<Candidate>;
  /** update multiples rows of table: "candidate" */
  update_candidate_many?: Maybe<Array<Maybe<Candidate_Mutation_Response>>>;
  /** update data of the table: "checkin_status" */
  update_checkin_status?: Maybe<Checkin_Status_Mutation_Response>;
  /** update single row of the table: "checkin_status" */
  update_checkin_status_by_pk?: Maybe<Checkin_Status>;
  /** update multiples rows of table: "checkin_status" */
  update_checkin_status_many?: Maybe<Array<Maybe<Checkin_Status_Mutation_Response>>>;
  /** update data of the table: "checkout_status" */
  update_checkout_status?: Maybe<Checkout_Status_Mutation_Response>;
  /** update single row of the table: "checkout_status" */
  update_checkout_status_by_pk?: Maybe<Checkout_Status>;
  /** update multiples rows of table: "checkout_status" */
  update_checkout_status_many?: Maybe<Array<Maybe<Checkout_Status_Mutation_Response>>>;
  /** update data of the table: "client_care_plan" */
  update_client_care_plan?: Maybe<Client_Care_Plan_Mutation_Response>;
  /** update single row of the table: "client_care_plan" */
  update_client_care_plan_by_pk?: Maybe<Client_Care_Plan>;
  /** update multiples rows of table: "client_care_plan" */
  update_client_care_plan_many?: Maybe<Array<Maybe<Client_Care_Plan_Mutation_Response>>>;
  /** update data of the table: "client_medications" */
  update_client_medications?: Maybe<Client_Medications_Mutation_Response>;
  /** update single row of the table: "client_medications" */
  update_client_medications_by_pk?: Maybe<Client_Medications>;
  /** update multiples rows of table: "client_medications" */
  update_client_medications_many?: Maybe<Array<Maybe<Client_Medications_Mutation_Response>>>;
  /** update data of the table: "company" */
  update_company?: Maybe<Company_Mutation_Response>;
  /** update single row of the table: "company" */
  update_company_by_pk?: Maybe<Company>;
  /** update data of the table: "company_follower" */
  update_company_follower?: Maybe<Company_Follower_Mutation_Response>;
  /** update single row of the table: "company_follower" */
  update_company_follower_by_pk?: Maybe<Company_Follower>;
  /** update multiples rows of table: "company_follower" */
  update_company_follower_many?: Maybe<Array<Maybe<Company_Follower_Mutation_Response>>>;
  /** update multiples rows of table: "company" */
  update_company_many?: Maybe<Array<Maybe<Company_Mutation_Response>>>;
  /** update data of the table: "company_user_notifications" */
  update_company_user_notifications?: Maybe<Company_User_Notifications_Mutation_Response>;
  /** update single row of the table: "company_user_notifications" */
  update_company_user_notifications_by_pk?: Maybe<Company_User_Notifications>;
  /** update multiples rows of table: "company_user_notifications" */
  update_company_user_notifications_many?: Maybe<Array<Maybe<Company_User_Notifications_Mutation_Response>>>;
  /** update data of the table: "contractor" */
  update_contractor?: Maybe<Contractor_Mutation_Response>;
  /** update single row of the table: "contractor" */
  update_contractor_by_pk?: Maybe<Contractor>;
  /** update multiples rows of table: "contractor" */
  update_contractor_many?: Maybe<Array<Maybe<Contractor_Mutation_Response>>>;
  /** update data of the table: "contractor_note" */
  update_contractor_note?: Maybe<Contractor_Note_Mutation_Response>;
  /** update single row of the table: "contractor_note" */
  update_contractor_note_by_pk?: Maybe<Contractor_Note>;
  /** update multiples rows of table: "contractor_note" */
  update_contractor_note_many?: Maybe<Array<Maybe<Contractor_Note_Mutation_Response>>>;
  /** update data of the table: "contractor_posting" */
  update_contractor_posting?: Maybe<Contractor_Posting_Mutation_Response>;
  /** update single row of the table: "contractor_posting" */
  update_contractor_posting_by_pk?: Maybe<Contractor_Posting>;
  /** update multiples rows of table: "contractor_posting" */
  update_contractor_posting_many?: Maybe<Array<Maybe<Contractor_Posting_Mutation_Response>>>;
  /** update data of the table: "contractor_project" */
  update_contractor_project?: Maybe<Contractor_Project_Mutation_Response>;
  /** update single row of the table: "contractor_project" */
  update_contractor_project_by_pk?: Maybe<Contractor_Project>;
  /** update multiples rows of table: "contractor_project" */
  update_contractor_project_many?: Maybe<Array<Maybe<Contractor_Project_Mutation_Response>>>;
  /** update data of the table: "contractor_rating" */
  update_contractor_rating?: Maybe<Contractor_Rating_Mutation_Response>;
  /** update single row of the table: "contractor_rating" */
  update_contractor_rating_by_pk?: Maybe<Contractor_Rating>;
  /** update multiples rows of table: "contractor_rating" */
  update_contractor_rating_many?: Maybe<Array<Maybe<Contractor_Rating_Mutation_Response>>>;
  /** update data of the table: "contractor_staff_note" */
  update_contractor_staff_note?: Maybe<Contractor_Staff_Note_Mutation_Response>;
  /** update single row of the table: "contractor_staff_note" */
  update_contractor_staff_note_by_pk?: Maybe<Contractor_Staff_Note>;
  /** update multiples rows of table: "contractor_staff_note" */
  update_contractor_staff_note_many?: Maybe<Array<Maybe<Contractor_Staff_Note_Mutation_Response>>>;
  /** update data of the table: "conversation" */
  update_conversation?: Maybe<Conversation_Mutation_Response>;
  /** update single row of the table: "conversation" */
  update_conversation_by_pk?: Maybe<Conversation>;
  /** update multiples rows of table: "conversation" */
  update_conversation_many?: Maybe<Array<Maybe<Conversation_Mutation_Response>>>;
  /** update data of the table: "custom_request" */
  update_custom_request?: Maybe<Custom_Request_Mutation_Response>;
  /** update single row of the table: "custom_request" */
  update_custom_request_by_pk?: Maybe<Custom_Request>;
  /** update multiples rows of table: "custom_request" */
  update_custom_request_many?: Maybe<Array<Maybe<Custom_Request_Mutation_Response>>>;
  /** update data of the table: "custom_request_skills" */
  update_custom_request_skills?: Maybe<Custom_Request_Skills_Mutation_Response>;
  /** update single row of the table: "custom_request_skills" */
  update_custom_request_skills_by_pk?: Maybe<Custom_Request_Skills>;
  /** update multiples rows of table: "custom_request_skills" */
  update_custom_request_skills_many?: Maybe<Array<Maybe<Custom_Request_Skills_Mutation_Response>>>;
  /** update data of the table: "declined_visit_matches" */
  update_declined_visit_matches?: Maybe<Declined_Visit_Matches_Mutation_Response>;
  /** update single row of the table: "declined_visit_matches" */
  update_declined_visit_matches_by_pk?: Maybe<Declined_Visit_Matches>;
  /** update multiples rows of table: "declined_visit_matches" */
  update_declined_visit_matches_many?: Maybe<Array<Maybe<Declined_Visit_Matches_Mutation_Response>>>;
  /** update data of the table: "document" */
  update_document?: Maybe<Document_Mutation_Response>;
  /** update single row of the table: "document" */
  update_document_by_pk?: Maybe<Document>;
  /** update data of the table: "document_contractor_access" */
  update_document_contractor_access?: Maybe<Document_Contractor_Access_Mutation_Response>;
  /** update single row of the table: "document_contractor_access" */
  update_document_contractor_access_by_pk?: Maybe<Document_Contractor_Access>;
  /** update multiples rows of table: "document_contractor_access" */
  update_document_contractor_access_many?: Maybe<Array<Maybe<Document_Contractor_Access_Mutation_Response>>>;
  /** update data of the table: "document_custom_request" */
  update_document_custom_request?: Maybe<Document_Custom_Request_Mutation_Response>;
  /** update single row of the table: "document_custom_request" */
  update_document_custom_request_by_pk?: Maybe<Document_Custom_Request>;
  /** update multiples rows of table: "document_custom_request" */
  update_document_custom_request_many?: Maybe<Array<Maybe<Document_Custom_Request_Mutation_Response>>>;
  /** update multiples rows of table: "document" */
  update_document_many?: Maybe<Array<Maybe<Document_Mutation_Response>>>;
  /** update data of the table: "document_project" */
  update_document_project?: Maybe<Document_Project_Mutation_Response>;
  /** update single row of the table: "document_project" */
  update_document_project_by_pk?: Maybe<Document_Project>;
  /** update multiples rows of table: "document_project" */
  update_document_project_many?: Maybe<Array<Maybe<Document_Project_Mutation_Response>>>;
  /** update data of the table: "document_user" */
  update_document_user?: Maybe<Document_User_Mutation_Response>;
  /** update single row of the table: "document_user" */
  update_document_user_by_pk?: Maybe<Document_User>;
  /** update multiples rows of table: "document_user" */
  update_document_user_many?: Maybe<Array<Maybe<Document_User_Mutation_Response>>>;
  /** update data of the table: "email_regex" */
  update_email_regex?: Maybe<Email_Regex_Mutation_Response>;
  /** update single row of the table: "email_regex" */
  update_email_regex_by_pk?: Maybe<Email_Regex>;
  /** update multiples rows of table: "email_regex" */
  update_email_regex_many?: Maybe<Array<Maybe<Email_Regex_Mutation_Response>>>;
  /** update data of the table: "experience_skill" */
  update_experience_skill?: Maybe<Experience_Skill_Mutation_Response>;
  /** update single row of the table: "experience_skill" */
  update_experience_skill_by_pk?: Maybe<Experience_Skill>;
  /** update multiples rows of table: "experience_skill" */
  update_experience_skill_many?: Maybe<Array<Maybe<Experience_Skill_Mutation_Response>>>;
  /** update data of the table: "gender" */
  update_gender?: Maybe<Gender_Mutation_Response>;
  /** update single row of the table: "gender" */
  update_gender_by_pk?: Maybe<Gender>;
  /** update multiples rows of table: "gender" */
  update_gender_many?: Maybe<Array<Maybe<Gender_Mutation_Response>>>;
  /** update data of the table: "industry" */
  update_industry?: Maybe<Industry_Mutation_Response>;
  /** update single row of the table: "industry" */
  update_industry_by_pk?: Maybe<Industry>;
  /** update multiples rows of table: "industry" */
  update_industry_many?: Maybe<Array<Maybe<Industry_Mutation_Response>>>;
  /** update data of the table: "invitation" */
  update_invitation?: Maybe<Invitation_Mutation_Response>;
  /** update single row of the table: "invitation" */
  update_invitation_by_pk?: Maybe<Invitation>;
  /** update multiples rows of table: "invitation" */
  update_invitation_many?: Maybe<Array<Maybe<Invitation_Mutation_Response>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<Invoice_Mutation_Response>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "language" */
  update_language?: Maybe<Language_Mutation_Response>;
  /** update single row of the table: "language" */
  update_language_by_pk?: Maybe<Language>;
  /** update multiples rows of table: "language" */
  update_language_many?: Maybe<Array<Maybe<Language_Mutation_Response>>>;
  /** update data of the table: "manager" */
  update_manager?: Maybe<Manager_Mutation_Response>;
  /** update single row of the table: "manager" */
  update_manager_by_pk?: Maybe<Manager>;
  /** update data of the table: "manager_contractor" */
  update_manager_contractor?: Maybe<Manager_Contractor_Mutation_Response>;
  /** update single row of the table: "manager_contractor" */
  update_manager_contractor_by_pk?: Maybe<Manager_Contractor>;
  /** update multiples rows of table: "manager_contractor" */
  update_manager_contractor_many?: Maybe<Array<Maybe<Manager_Contractor_Mutation_Response>>>;
  /** update multiples rows of table: "manager" */
  update_manager_many?: Maybe<Array<Maybe<Manager_Mutation_Response>>>;
  /** update data of the table: "message" */
  update_message?: Maybe<Message_Mutation_Response>;
  /** update single row of the table: "message" */
  update_message_by_pk?: Maybe<Message>;
  /** update multiples rows of table: "message" */
  update_message_many?: Maybe<Array<Maybe<Message_Mutation_Response>>>;
  /** update data of the table: "notification" */
  update_notification?: Maybe<Notification_Mutation_Response>;
  /** update single row of the table: "notification" */
  update_notification_by_pk?: Maybe<Notification>;
  /** update multiples rows of table: "notification" */
  update_notification_many?: Maybe<Array<Maybe<Notification_Mutation_Response>>>;
  /** update data of the table: "onboarding" */
  update_onboarding?: Maybe<Onboarding_Mutation_Response>;
  /** update single row of the table: "onboarding" */
  update_onboarding_by_pk?: Maybe<Onboarding>;
  /** update multiples rows of table: "onboarding" */
  update_onboarding_many?: Maybe<Array<Maybe<Onboarding_Mutation_Response>>>;
  /** update data of the table: "payment_card" */
  update_payment_card?: Maybe<Payment_Card_Mutation_Response>;
  /** update single row of the table: "payment_card" */
  update_payment_card_by_pk?: Maybe<Payment_Card>;
  /** update multiples rows of table: "payment_card" */
  update_payment_card_many?: Maybe<Array<Maybe<Payment_Card_Mutation_Response>>>;
  /** update data of the table: "posting" */
  update_posting?: Maybe<Posting_Mutation_Response>;
  /** update single row of the table: "posting" */
  update_posting_by_pk?: Maybe<Posting>;
  /** update data of the table: "posting_industry" */
  update_posting_industry?: Maybe<Posting_Industry_Mutation_Response>;
  /** update single row of the table: "posting_industry" */
  update_posting_industry_by_pk?: Maybe<Posting_Industry>;
  /** update multiples rows of table: "posting_industry" */
  update_posting_industry_many?: Maybe<Array<Maybe<Posting_Industry_Mutation_Response>>>;
  /** update multiples rows of table: "posting" */
  update_posting_many?: Maybe<Array<Maybe<Posting_Mutation_Response>>>;
  /** update data of the table: "posting_skill" */
  update_posting_skill?: Maybe<Posting_Skill_Mutation_Response>;
  /** update single row of the table: "posting_skill" */
  update_posting_skill_by_pk?: Maybe<Posting_Skill>;
  /** update multiples rows of table: "posting_skill" */
  update_posting_skill_many?: Maybe<Array<Maybe<Posting_Skill_Mutation_Response>>>;
  /** update data of the table: "posting_tags" */
  update_posting_tags?: Maybe<Posting_Tags_Mutation_Response>;
  /** update single row of the table: "posting_tags" */
  update_posting_tags_by_pk?: Maybe<Posting_Tags>;
  /** update multiples rows of table: "posting_tags" */
  update_posting_tags_many?: Maybe<Array<Maybe<Posting_Tags_Mutation_Response>>>;
  /** update data of the table: "project" */
  update_project?: Maybe<Project_Mutation_Response>;
  /** update data of the table: "project_activity" */
  update_project_activity?: Maybe<Project_Activity_Mutation_Response>;
  /** update single row of the table: "project_activity" */
  update_project_activity_by_pk?: Maybe<Project_Activity>;
  /** update multiples rows of table: "project_activity" */
  update_project_activity_many?: Maybe<Array<Maybe<Project_Activity_Mutation_Response>>>;
  /** update data of the table: "project_activity_note" */
  update_project_activity_note?: Maybe<Project_Activity_Note_Mutation_Response>;
  /** update single row of the table: "project_activity_note" */
  update_project_activity_note_by_pk?: Maybe<Project_Activity_Note>;
  /** update multiples rows of table: "project_activity_note" */
  update_project_activity_note_many?: Maybe<Array<Maybe<Project_Activity_Note_Mutation_Response>>>;
  /** update data of the table: "project_activity_request_more_hours" */
  update_project_activity_request_more_hours?: Maybe<Project_Activity_Request_More_Hours_Mutation_Response>;
  /** update single row of the table: "project_activity_request_more_hours" */
  update_project_activity_request_more_hours_by_pk?: Maybe<Project_Activity_Request_More_Hours>;
  /** update multiples rows of table: "project_activity_request_more_hours" */
  update_project_activity_request_more_hours_many?: Maybe<Array<Maybe<Project_Activity_Request_More_Hours_Mutation_Response>>>;
  /** update data of the table: "project_activity_skill" */
  update_project_activity_skill?: Maybe<Project_Activity_Skill_Mutation_Response>;
  /** update single row of the table: "project_activity_skill" */
  update_project_activity_skill_by_pk?: Maybe<Project_Activity_Skill>;
  /** update multiples rows of table: "project_activity_skill" */
  update_project_activity_skill_many?: Maybe<Array<Maybe<Project_Activity_Skill_Mutation_Response>>>;
  /** update data of the table: "project_activity_soft_skill" */
  update_project_activity_soft_skill?: Maybe<Project_Activity_Soft_Skill_Mutation_Response>;
  /** update single row of the table: "project_activity_soft_skill" */
  update_project_activity_soft_skill_by_pk?: Maybe<Project_Activity_Soft_Skill>;
  /** update multiples rows of table: "project_activity_soft_skill" */
  update_project_activity_soft_skill_many?: Maybe<Array<Maybe<Project_Activity_Soft_Skill_Mutation_Response>>>;
  /** update data of the table: "project_activity_tag" */
  update_project_activity_tag?: Maybe<Project_Activity_Tag_Mutation_Response>;
  /** update single row of the table: "project_activity_tag" */
  update_project_activity_tag_by_pk?: Maybe<Project_Activity_Tag>;
  /** update multiples rows of table: "project_activity_tag" */
  update_project_activity_tag_many?: Maybe<Array<Maybe<Project_Activity_Tag_Mutation_Response>>>;
  /** update data of the table: "project_activity_time" */
  update_project_activity_time?: Maybe<Project_Activity_Time_Mutation_Response>;
  /** update single row of the table: "project_activity_time" */
  update_project_activity_time_by_pk?: Maybe<Project_Activity_Time>;
  /** update multiples rows of table: "project_activity_time" */
  update_project_activity_time_many?: Maybe<Array<Maybe<Project_Activity_Time_Mutation_Response>>>;
  /** update data of the table: "project_activity_tracked_time" */
  update_project_activity_tracked_time?: Maybe<Project_Activity_Tracked_Time_Mutation_Response>;
  /** update single row of the table: "project_activity_tracked_time" */
  update_project_activity_tracked_time_by_pk?: Maybe<Project_Activity_Tracked_Time>;
  /** update multiples rows of table: "project_activity_tracked_time" */
  update_project_activity_tracked_time_many?: Maybe<Array<Maybe<Project_Activity_Tracked_Time_Mutation_Response>>>;
  /** update single row of the table: "project" */
  update_project_by_pk?: Maybe<Project>;
  /** update multiples rows of table: "project" */
  update_project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "project_skill" */
  update_project_skill?: Maybe<Project_Skill_Mutation_Response>;
  /** update single row of the table: "project_skill" */
  update_project_skill_by_pk?: Maybe<Project_Skill>;
  /** update multiples rows of table: "project_skill" */
  update_project_skill_many?: Maybe<Array<Maybe<Project_Skill_Mutation_Response>>>;
  /** update data of the table: "project_soft_skill" */
  update_project_soft_skill?: Maybe<Project_Soft_Skill_Mutation_Response>;
  /** update single row of the table: "project_soft_skill" */
  update_project_soft_skill_by_pk?: Maybe<Project_Soft_Skill>;
  /** update multiples rows of table: "project_soft_skill" */
  update_project_soft_skill_many?: Maybe<Array<Maybe<Project_Soft_Skill_Mutation_Response>>>;
  /** update data of the table: "project_tag" */
  update_project_tag?: Maybe<Project_Tag_Mutation_Response>;
  /** update single row of the table: "project_tag" */
  update_project_tag_by_pk?: Maybe<Project_Tag>;
  /** update multiples rows of table: "project_tag" */
  update_project_tag_many?: Maybe<Array<Maybe<Project_Tag_Mutation_Response>>>;
  /** update data of the table: "recipient_message" */
  update_recipient_message?: Maybe<Recipient_Message_Mutation_Response>;
  /** update single row of the table: "recipient_message" */
  update_recipient_message_by_pk?: Maybe<Recipient_Message>;
  /** update multiples rows of table: "recipient_message" */
  update_recipient_message_many?: Maybe<Array<Maybe<Recipient_Message_Mutation_Response>>>;
  /** update data of the table: "resource_information_card" */
  update_resource_information_card?: Maybe<Resource_Information_Card_Mutation_Response>;
  /** update single row of the table: "resource_information_card" */
  update_resource_information_card_by_pk?: Maybe<Resource_Information_Card>;
  /** update multiples rows of table: "resource_information_card" */
  update_resource_information_card_many?: Maybe<Array<Maybe<Resource_Information_Card_Mutation_Response>>>;
  /** update data of the table: "skill" */
  update_skill?: Maybe<Skill_Mutation_Response>;
  /** update single row of the table: "skill" */
  update_skill_by_pk?: Maybe<Skill>;
  /** update multiples rows of table: "skill" */
  update_skill_many?: Maybe<Array<Maybe<Skill_Mutation_Response>>>;
  /** update data of the table: "skills_short_name_first" */
  update_skills_short_name_first?: Maybe<Skills_Short_Name_First_Mutation_Response>;
  /** update multiples rows of table: "skills_short_name_first" */
  update_skills_short_name_first_many?: Maybe<Array<Maybe<Skills_Short_Name_First_Mutation_Response>>>;
  /** update data of the table: "smart_match_bookmark" */
  update_smart_match_bookmark?: Maybe<Smart_Match_Bookmark_Mutation_Response>;
  /** update single row of the table: "smart_match_bookmark" */
  update_smart_match_bookmark_by_pk?: Maybe<Smart_Match_Bookmark>;
  /** update multiples rows of table: "smart_match_bookmark" */
  update_smart_match_bookmark_many?: Maybe<Array<Maybe<Smart_Match_Bookmark_Mutation_Response>>>;
  /** update data of the table: "smart_match_config_transportation" */
  update_smart_match_config_transportation?: Maybe<Smart_Match_Config_Transportation_Mutation_Response>;
  /** update single row of the table: "smart_match_config_transportation" */
  update_smart_match_config_transportation_by_pk?: Maybe<Smart_Match_Config_Transportation>;
  /** update multiples rows of table: "smart_match_config_transportation" */
  update_smart_match_config_transportation_many?: Maybe<Array<Maybe<Smart_Match_Config_Transportation_Mutation_Response>>>;
  /** update data of the table: "smart_match_configs" */
  update_smart_match_configs?: Maybe<Smart_Match_Configs_Mutation_Response>;
  /** update single row of the table: "smart_match_configs" */
  update_smart_match_configs_by_pk?: Maybe<Smart_Match_Configs>;
  /** update multiples rows of table: "smart_match_configs" */
  update_smart_match_configs_many?: Maybe<Array<Maybe<Smart_Match_Configs_Mutation_Response>>>;
  /** update data of the table: "smart_match_criteria_order" */
  update_smart_match_criteria_order?: Maybe<Smart_Match_Criteria_Order_Mutation_Response>;
  /** update single row of the table: "smart_match_criteria_order" */
  update_smart_match_criteria_order_by_pk?: Maybe<Smart_Match_Criteria_Order>;
  /** update multiples rows of table: "smart_match_criteria_order" */
  update_smart_match_criteria_order_many?: Maybe<Array<Maybe<Smart_Match_Criteria_Order_Mutation_Response>>>;
  /** update data of the table: "soft_skill" */
  update_soft_skill?: Maybe<Soft_Skill_Mutation_Response>;
  /** update single row of the table: "soft_skill" */
  update_soft_skill_by_pk?: Maybe<Soft_Skill>;
  /** update multiples rows of table: "soft_skill" */
  update_soft_skill_many?: Maybe<Array<Maybe<Soft_Skill_Mutation_Response>>>;
  /** update data of the table: "source" */
  update_source?: Maybe<Source_Mutation_Response>;
  /** update single row of the table: "source" */
  update_source_by_pk?: Maybe<Source>;
  /** update multiples rows of table: "source" */
  update_source_many?: Maybe<Array<Maybe<Source_Mutation_Response>>>;
  /** update data of the table: "subscription" */
  update_subscription?: Maybe<Subscription_Mutation_Response>;
  /** update single row of the table: "subscription" */
  update_subscription_by_pk?: Maybe<Subscription>;
  /** update multiples rows of table: "subscription" */
  update_subscription_many?: Maybe<Array<Maybe<Subscription_Mutation_Response>>>;
  /** update data of the table: "subscription_plan" */
  update_subscription_plan?: Maybe<Subscription_Plan_Mutation_Response>;
  /** update data of the table: "subscription_plan_access_permissions" */
  update_subscription_plan_access_permissions?: Maybe<Subscription_Plan_Access_Permissions_Mutation_Response>;
  /** update single row of the table: "subscription_plan_access_permissions" */
  update_subscription_plan_access_permissions_by_pk?: Maybe<Subscription_Plan_Access_Permissions>;
  /** update multiples rows of table: "subscription_plan_access_permissions" */
  update_subscription_plan_access_permissions_many?: Maybe<Array<Maybe<Subscription_Plan_Access_Permissions_Mutation_Response>>>;
  /** update single row of the table: "subscription_plan" */
  update_subscription_plan_by_pk?: Maybe<Subscription_Plan>;
  /** update multiples rows of table: "subscription_plan" */
  update_subscription_plan_many?: Maybe<Array<Maybe<Subscription_Plan_Mutation_Response>>>;
  /** update data of the table: "tag" */
  update_tag?: Maybe<Tag_Mutation_Response>;
  /** update single row of the table: "tag" */
  update_tag_by_pk?: Maybe<Tag>;
  /** update multiples rows of table: "tag" */
  update_tag_many?: Maybe<Array<Maybe<Tag_Mutation_Response>>>;
  /** update data of the table: "team" */
  update_team?: Maybe<Team_Mutation_Response>;
  /** update single row of the table: "team" */
  update_team_by_pk?: Maybe<Team>;
  /** update data of the table: "team_contractor" */
  update_team_contractor?: Maybe<Team_Contractor_Mutation_Response>;
  /** update single row of the table: "team_contractor" */
  update_team_contractor_by_pk?: Maybe<Team_Contractor>;
  /** update multiples rows of table: "team_contractor" */
  update_team_contractor_many?: Maybe<Array<Maybe<Team_Contractor_Mutation_Response>>>;
  /** update data of the table: "team_manager" */
  update_team_manager?: Maybe<Team_Manager_Mutation_Response>;
  /** update single row of the table: "team_manager" */
  update_team_manager_by_pk?: Maybe<Team_Manager>;
  /** update multiples rows of table: "team_manager" */
  update_team_manager_many?: Maybe<Array<Maybe<Team_Manager_Mutation_Response>>>;
  /** update multiples rows of table: "team" */
  update_team_many?: Maybe<Array<Maybe<Team_Mutation_Response>>>;
  /** update data of the table: "team_posting" */
  update_team_posting?: Maybe<Team_Posting_Mutation_Response>;
  /** update single row of the table: "team_posting" */
  update_team_posting_by_pk?: Maybe<Team_Posting>;
  /** update multiples rows of table: "team_posting" */
  update_team_posting_many?: Maybe<Array<Maybe<Team_Posting_Mutation_Response>>>;
  /** update data of the table: "team_project" */
  update_team_project?: Maybe<Team_Project_Mutation_Response>;
  /** update single row of the table: "team_project" */
  update_team_project_by_pk?: Maybe<Team_Project>;
  /** update multiples rows of table: "team_project" */
  update_team_project_many?: Maybe<Array<Maybe<Team_Project_Mutation_Response>>>;
  /** update data of the table: "team_skill" */
  update_team_skill?: Maybe<Team_Skill_Mutation_Response>;
  /** update single row of the table: "team_skill" */
  update_team_skill_by_pk?: Maybe<Team_Skill>;
  /** update multiples rows of table: "team_skill" */
  update_team_skill_many?: Maybe<Array<Maybe<Team_Skill_Mutation_Response>>>;
  /** update data of the table: "timesheet" */
  update_timesheet?: Maybe<Timesheet_Mutation_Response>;
  /** update single row of the table: "timesheet" */
  update_timesheet_by_pk?: Maybe<Timesheet>;
  /** update multiples rows of table: "timesheet" */
  update_timesheet_many?: Maybe<Array<Maybe<Timesheet_Mutation_Response>>>;
  /** update data of the table: "type_of_visit" */
  update_type_of_visit?: Maybe<Type_Of_Visit_Mutation_Response>;
  /** update single row of the table: "type_of_visit" */
  update_type_of_visit_by_pk?: Maybe<Type_Of_Visit>;
  /** update multiples rows of table: "type_of_visit" */
  update_type_of_visit_many?: Maybe<Array<Maybe<Type_Of_Visit_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update data of the table: "user_affinda_profile" */
  update_user_affinda_profile?: Maybe<User_Affinda_Profile_Mutation_Response>;
  /** update single row of the table: "user_affinda_profile" */
  update_user_affinda_profile_by_pk?: Maybe<User_Affinda_Profile>;
  /** update multiples rows of table: "user_affinda_profile" */
  update_user_affinda_profile_many?: Maybe<Array<Maybe<User_Affinda_Profile_Mutation_Response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_certification" */
  update_user_certification?: Maybe<User_Certification_Mutation_Response>;
  /** update single row of the table: "user_certification" */
  update_user_certification_by_pk?: Maybe<User_Certification>;
  /** update multiples rows of table: "user_certification" */
  update_user_certification_many?: Maybe<Array<Maybe<User_Certification_Mutation_Response>>>;
  /** update data of the table: "user_company" */
  update_user_company?: Maybe<User_Company_Mutation_Response>;
  /** update single row of the table: "user_company" */
  update_user_company_by_pk?: Maybe<User_Company>;
  /** update multiples rows of table: "user_company" */
  update_user_company_many?: Maybe<Array<Maybe<User_Company_Mutation_Response>>>;
  /** update data of the table: "user_conversation" */
  update_user_conversation?: Maybe<User_Conversation_Mutation_Response>;
  /** update single row of the table: "user_conversation" */
  update_user_conversation_by_pk?: Maybe<User_Conversation>;
  /** update multiples rows of table: "user_conversation" */
  update_user_conversation_many?: Maybe<Array<Maybe<User_Conversation_Mutation_Response>>>;
  /** update data of the table: "user_education" */
  update_user_education?: Maybe<User_Education_Mutation_Response>;
  /** update single row of the table: "user_education" */
  update_user_education_by_pk?: Maybe<User_Education>;
  /** update multiples rows of table: "user_education" */
  update_user_education_many?: Maybe<Array<Maybe<User_Education_Mutation_Response>>>;
  /** update data of the table: "user_experience" */
  update_user_experience?: Maybe<User_Experience_Mutation_Response>;
  /** update single row of the table: "user_experience" */
  update_user_experience_by_pk?: Maybe<User_Experience>;
  /** update multiples rows of table: "user_experience" */
  update_user_experience_many?: Maybe<Array<Maybe<User_Experience_Mutation_Response>>>;
  /** update data of the table: "user_favorite" */
  update_user_favorite?: Maybe<User_Favorite_Mutation_Response>;
  /** update single row of the table: "user_favorite" */
  update_user_favorite_by_pk?: Maybe<User_Favorite>;
  /** update multiples rows of table: "user_favorite" */
  update_user_favorite_many?: Maybe<Array<Maybe<User_Favorite_Mutation_Response>>>;
  /** update data of the table: "user_industry" */
  update_user_industry?: Maybe<User_Industry_Mutation_Response>;
  /** update single row of the table: "user_industry" */
  update_user_industry_by_pk?: Maybe<User_Industry>;
  /** update multiples rows of table: "user_industry" */
  update_user_industry_many?: Maybe<Array<Maybe<User_Industry_Mutation_Response>>>;
  /** update data of the table: "user_job_title" */
  update_user_job_title?: Maybe<User_Job_Title_Mutation_Response>;
  /** update single row of the table: "user_job_title" */
  update_user_job_title_by_pk?: Maybe<User_Job_Title>;
  /** update multiples rows of table: "user_job_title" */
  update_user_job_title_many?: Maybe<Array<Maybe<User_Job_Title_Mutation_Response>>>;
  /** update data of the table: "user_language" */
  update_user_language?: Maybe<User_Language_Mutation_Response>;
  /** update single row of the table: "user_language" */
  update_user_language_by_pk?: Maybe<User_Language>;
  /** update multiples rows of table: "user_language" */
  update_user_language_many?: Maybe<Array<Maybe<User_Language_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_private_data" */
  update_user_private_data?: Maybe<User_Private_Data_Mutation_Response>;
  /** update multiples rows of table: "user_private_data" */
  update_user_private_data_many?: Maybe<Array<Maybe<User_Private_Data_Mutation_Response>>>;
  /** update data of the table: "user_profile" */
  update_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** update data of the table: "user_profile_by_management" */
  update_user_profile_by_management?: Maybe<User_Profile_By_Management_Mutation_Response>;
  /** update single row of the table: "user_profile_by_management" */
  update_user_profile_by_management_by_pk?: Maybe<User_Profile_By_Management>;
  /** update multiples rows of table: "user_profile_by_management" */
  update_user_profile_by_management_many?: Maybe<Array<Maybe<User_Profile_By_Management_Mutation_Response>>>;
  /** update single row of the table: "user_profile" */
  update_user_profile_by_pk?: Maybe<User_Profile>;
  /** update multiples rows of table: "user_profile" */
  update_user_profile_many?: Maybe<Array<Maybe<User_Profile_Mutation_Response>>>;
  /** update data of the table: "user_rating" */
  update_user_rating?: Maybe<User_Rating_Mutation_Response>;
  /** update single row of the table: "user_rating" */
  update_user_rating_by_pk?: Maybe<User_Rating>;
  /** update multiples rows of table: "user_rating" */
  update_user_rating_many?: Maybe<Array<Maybe<User_Rating_Mutation_Response>>>;
  /** update data of the table: "user_skill" */
  update_user_skill?: Maybe<User_Skill_Mutation_Response>;
  /** update single row of the table: "user_skill" */
  update_user_skill_by_pk?: Maybe<User_Skill>;
  /** update multiples rows of table: "user_skill" */
  update_user_skill_many?: Maybe<Array<Maybe<User_Skill_Mutation_Response>>>;
  /** update data of the table: "user_soft_skill" */
  update_user_soft_skill?: Maybe<User_Soft_Skill_Mutation_Response>;
  /** update single row of the table: "user_soft_skill" */
  update_user_soft_skill_by_pk?: Maybe<User_Soft_Skill>;
  /** update multiples rows of table: "user_soft_skill" */
  update_user_soft_skill_many?: Maybe<Array<Maybe<User_Soft_Skill_Mutation_Response>>>;
  /** update data of the table: "user_transportation" */
  update_user_transportation?: Maybe<User_Transportation_Mutation_Response>;
  /** update single row of the table: "user_transportation" */
  update_user_transportation_by_pk?: Maybe<User_Transportation>;
  /** update multiples rows of table: "user_transportation" */
  update_user_transportation_many?: Maybe<Array<Maybe<User_Transportation_Mutation_Response>>>;
  /** update data of the table: "user_watchlist" */
  update_user_watchlist?: Maybe<User_Watchlist_Mutation_Response>;
  /** update single row of the table: "user_watchlist" */
  update_user_watchlist_by_pk?: Maybe<User_Watchlist>;
  /** update multiples rows of table: "user_watchlist" */
  update_user_watchlist_many?: Maybe<Array<Maybe<User_Watchlist_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AdminArgs = {
  where: Admin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ApplicationArgs = {
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CandidateArgs = {
  where: Candidate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Candidate_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Checkin_StatusArgs = {
  where: Checkin_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Checkin_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Checkout_StatusArgs = {
  where: Checkout_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Checkout_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Client_Care_PlanArgs = {
  where: Client_Care_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Care_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Client_MedicationsArgs = {
  where: Client_Medications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Medications_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyArgs = {
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Company_FollowerArgs = {
  where: Company_Follower_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_Follower_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Company_User_NotificationsArgs = {
  where: Company_User_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Company_User_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ContractorArgs = {
  where: Contractor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contractor_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Contractor_NoteArgs = {
  where: Contractor_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contractor_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Contractor_PostingArgs = {
  where: Contractor_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contractor_Posting_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Contractor_ProjectArgs = {
  where: Contractor_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contractor_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Contractor_RatingArgs = {
  where: Contractor_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contractor_Rating_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Contractor_Staff_NoteArgs = {
  where: Contractor_Staff_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contractor_Staff_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ConversationArgs = {
  where: Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Conversation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_RequestArgs = {
  where: Custom_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Request_SkillsArgs = {
  where: Custom_Request_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Request_Skills_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Declined_Visit_MatchesArgs = {
  where: Declined_Visit_Matches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declined_Visit_Matches_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentArgs = {
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Contractor_AccessArgs = {
  where: Document_Contractor_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Contractor_Access_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Custom_RequestArgs = {
  where: Document_Custom_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Custom_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_ProjectArgs = {
  where: Document_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_UserArgs = {
  where: Document_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_User_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_RegexArgs = {
  where: Email_Regex_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Regex_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Experience_SkillArgs = {
  where: Experience_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Experience_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_GenderArgs = {
  where: Gender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gender_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_IndustryArgs = {
  where: Industry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Industry_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InvitationArgs = {
  where: Invitation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invitation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InvoiceArgs = {
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LanguageArgs = {
  where: Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Language_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ManagerArgs = {
  where: Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manager_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Manager_ContractorArgs = {
  where: Manager_Contractor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manager_Contractor_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MessageArgs = {
  where: Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationArgs = {
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OnboardingArgs = {
  where: Onboarding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Onboarding_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_CardArgs = {
  where: Payment_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PostingArgs = {
  where: Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Posting_IndustryArgs = {
  where: Posting_Industry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_Industry_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Posting_SkillArgs = {
  where: Posting_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Posting_TagsArgs = {
  where: Posting_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_Tags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_ActivityArgs = {
  where: Project_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_NoteArgs = {
  where: Project_Activity_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Request_More_HoursArgs = {
  where: Project_Activity_Request_More_Hours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Request_More_Hours_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_SkillArgs = {
  where: Project_Activity_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Soft_SkillArgs = {
  where: Project_Activity_Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Soft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_TagArgs = {
  where: Project_Activity_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_TimeArgs = {
  where: Project_Activity_Time_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Time_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Tracked_TimeArgs = {
  where: Project_Activity_Tracked_Time_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Activity_Tracked_Time_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_SkillArgs = {
  where: Project_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Soft_SkillArgs = {
  where: Project_Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Soft_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Project_TagArgs = {
  where: Project_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Recipient_MessageArgs = {
  where: Recipient_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Recipient_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Information_CardArgs = {
  where: Resource_Information_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Information_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SkillArgs = {
  where: Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Skills_Short_Name_FirstArgs = {
  where: Skills_Short_Name_First_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_BookmarkArgs = {
  where: Smart_Match_Bookmark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_Bookmark_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_Config_TransportationArgs = {
  where: Smart_Match_Config_Transportation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_Config_Transportation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_ConfigsArgs = {
  where: Smart_Match_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_Configs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_Criteria_OrderArgs = {
  where: Smart_Match_Criteria_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Smart_Match_Criteria_Order_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Soft_SkillArgs = {
  where: Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Soft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SourceArgs = {
  where: Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Source_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionArgs = {
  where: Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_PlanArgs = {
  where: Subscription_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Plan_Access_PermissionsArgs = {
  where: Subscription_Plan_Access_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Plan_Access_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TagArgs = {
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TeamArgs = {
  where: Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Team_ContractorArgs = {
  where: Team_Contractor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Contractor_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Team_ManagerArgs = {
  where: Team_Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Manager_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Team_PostingArgs = {
  where: Team_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Team_ProjectArgs = {
  where: Team_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Team_SkillArgs = {
  where: Team_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TimesheetArgs = {
  where: Timesheet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Timesheet_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Type_Of_VisitArgs = {
  where: Type_Of_Visit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Type_Of_Visit_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Affinda_ProfileArgs = {
  where: User_Affinda_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Affinda_Profile_By_PkArgs = {
  document_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_CertificationArgs = {
  where: User_Certification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Certification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_CompanyArgs = {
  where: User_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Company_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_ConversationArgs = {
  where: User_Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Conversation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_EducationArgs = {
  where: User_Education_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Education_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_ExperienceArgs = {
  where: User_Experience_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Experience_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_FavoriteArgs = {
  where: User_Favorite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Favorite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_IndustryArgs = {
  where: User_Industry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Industry_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Job_TitleArgs = {
  where: User_Job_Title_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Job_Title_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_LanguageArgs = {
  where: User_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Language_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Private_DataArgs = {
  where: User_Private_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_ProfileArgs = {
  where: User_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_By_ManagementArgs = {
  where: User_Profile_By_Management_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_By_Management_By_PkArgs = {
  added_by_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_By_PkArgs = {
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_RatingArgs = {
  where: User_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Rating_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_SkillArgs = {
  where: User_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Soft_SkillArgs = {
  where: User_Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Soft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_TransportationArgs = {
  where: User_Transportation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Transportation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_WatchlistArgs = {
  where: User_Watchlist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Watchlist_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_AdminArgs = {
  objects: Array<Admin_Insert_Input>;
  on_conflict?: Maybe<Admin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_OneArgs = {
  object: Admin_Insert_Input;
  on_conflict?: Maybe<Admin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationArgs = {
  objects: Array<Application_Insert_Input>;
  on_conflict?: Maybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_OneArgs = {
  object: Application_Insert_Input;
  on_conflict?: Maybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CandidateArgs = {
  objects: Array<Candidate_Insert_Input>;
  on_conflict?: Maybe<Candidate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Candidate_OneArgs = {
  object: Candidate_Insert_Input;
  on_conflict?: Maybe<Candidate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Checkin_StatusArgs = {
  objects: Array<Checkin_Status_Insert_Input>;
  on_conflict?: Maybe<Checkin_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Checkin_Status_OneArgs = {
  object: Checkin_Status_Insert_Input;
  on_conflict?: Maybe<Checkin_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Checkout_StatusArgs = {
  objects: Array<Checkout_Status_Insert_Input>;
  on_conflict?: Maybe<Checkout_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Checkout_Status_OneArgs = {
  object: Checkout_Status_Insert_Input;
  on_conflict?: Maybe<Checkout_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Care_PlanArgs = {
  objects: Array<Client_Care_Plan_Insert_Input>;
  on_conflict?: Maybe<Client_Care_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Care_Plan_OneArgs = {
  object: Client_Care_Plan_Insert_Input;
  on_conflict?: Maybe<Client_Care_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_MedicationsArgs = {
  objects: Array<Client_Medications_Insert_Input>;
  on_conflict?: Maybe<Client_Medications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Medications_OneArgs = {
  object: Client_Medications_Insert_Input;
  on_conflict?: Maybe<Client_Medications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyArgs = {
  objects: Array<Company_Insert_Input>;
  on_conflict?: Maybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_FollowerArgs = {
  objects: Array<Company_Follower_Insert_Input>;
  on_conflict?: Maybe<Company_Follower_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_Follower_OneArgs = {
  object: Company_Follower_Insert_Input;
  on_conflict?: Maybe<Company_Follower_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_OneArgs = {
  object: Company_Insert_Input;
  on_conflict?: Maybe<Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_User_NotificationsArgs = {
  objects: Array<Company_User_Notifications_Insert_Input>;
  on_conflict?: Maybe<Company_User_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Company_User_Notifications_OneArgs = {
  object: Company_User_Notifications_Insert_Input;
  on_conflict?: Maybe<Company_User_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContractorArgs = {
  objects: Array<Contractor_Insert_Input>;
  on_conflict?: Maybe<Contractor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_NoteArgs = {
  objects: Array<Contractor_Note_Insert_Input>;
  on_conflict?: Maybe<Contractor_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_Note_OneArgs = {
  object: Contractor_Note_Insert_Input;
  on_conflict?: Maybe<Contractor_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_OneArgs = {
  object: Contractor_Insert_Input;
  on_conflict?: Maybe<Contractor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_PostingArgs = {
  objects: Array<Contractor_Posting_Insert_Input>;
  on_conflict?: Maybe<Contractor_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_Posting_OneArgs = {
  object: Contractor_Posting_Insert_Input;
  on_conflict?: Maybe<Contractor_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_ProjectArgs = {
  objects: Array<Contractor_Project_Insert_Input>;
  on_conflict?: Maybe<Contractor_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_Project_OneArgs = {
  object: Contractor_Project_Insert_Input;
  on_conflict?: Maybe<Contractor_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_RatingArgs = {
  objects: Array<Contractor_Rating_Insert_Input>;
  on_conflict?: Maybe<Contractor_Rating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_Rating_OneArgs = {
  object: Contractor_Rating_Insert_Input;
  on_conflict?: Maybe<Contractor_Rating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_Staff_NoteArgs = {
  objects: Array<Contractor_Staff_Note_Insert_Input>;
  on_conflict?: Maybe<Contractor_Staff_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contractor_Staff_Note_OneArgs = {
  object: Contractor_Staff_Note_Insert_Input;
  on_conflict?: Maybe<Contractor_Staff_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConversationArgs = {
  objects: Array<Conversation_Insert_Input>;
  on_conflict?: Maybe<Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Conversation_OneArgs = {
  object: Conversation_Insert_Input;
  on_conflict?: Maybe<Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_RequestArgs = {
  objects: Array<Custom_Request_Insert_Input>;
  on_conflict?: Maybe<Custom_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Request_OneArgs = {
  object: Custom_Request_Insert_Input;
  on_conflict?: Maybe<Custom_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Request_SkillsArgs = {
  objects: Array<Custom_Request_Skills_Insert_Input>;
  on_conflict?: Maybe<Custom_Request_Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Request_Skills_OneArgs = {
  object: Custom_Request_Skills_Insert_Input;
  on_conflict?: Maybe<Custom_Request_Skills_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declined_Visit_MatchesArgs = {
  objects: Array<Declined_Visit_Matches_Insert_Input>;
  on_conflict?: Maybe<Declined_Visit_Matches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declined_Visit_Matches_OneArgs = {
  object: Declined_Visit_Matches_Insert_Input;
  on_conflict?: Maybe<Declined_Visit_Matches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentArgs = {
  objects: Array<Document_Insert_Input>;
  on_conflict?: Maybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Contractor_AccessArgs = {
  objects: Array<Document_Contractor_Access_Insert_Input>;
  on_conflict?: Maybe<Document_Contractor_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Contractor_Access_OneArgs = {
  object: Document_Contractor_Access_Insert_Input;
  on_conflict?: Maybe<Document_Contractor_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Custom_RequestArgs = {
  objects: Array<Document_Custom_Request_Insert_Input>;
  on_conflict?: Maybe<Document_Custom_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Custom_Request_OneArgs = {
  object: Document_Custom_Request_Insert_Input;
  on_conflict?: Maybe<Document_Custom_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_OneArgs = {
  object: Document_Insert_Input;
  on_conflict?: Maybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_ProjectArgs = {
  objects: Array<Document_Project_Insert_Input>;
  on_conflict?: Maybe<Document_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Project_OneArgs = {
  object: Document_Project_Insert_Input;
  on_conflict?: Maybe<Document_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_UserArgs = {
  objects: Array<Document_User_Insert_Input>;
  on_conflict?: Maybe<Document_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_User_OneArgs = {
  object: Document_User_Insert_Input;
  on_conflict?: Maybe<Document_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_RegexArgs = {
  objects: Array<Email_Regex_Insert_Input>;
  on_conflict?: Maybe<Email_Regex_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Regex_OneArgs = {
  object: Email_Regex_Insert_Input;
  on_conflict?: Maybe<Email_Regex_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Experience_SkillArgs = {
  objects: Array<Experience_Skill_Insert_Input>;
  on_conflict?: Maybe<Experience_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Experience_Skill_OneArgs = {
  object: Experience_Skill_Insert_Input;
  on_conflict?: Maybe<Experience_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GenderArgs = {
  objects: Array<Gender_Insert_Input>;
  on_conflict?: Maybe<Gender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gender_OneArgs = {
  object: Gender_Insert_Input;
  on_conflict?: Maybe<Gender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndustryArgs = {
  objects: Array<Industry_Insert_Input>;
  on_conflict?: Maybe<Industry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Industry_OneArgs = {
  object: Industry_Insert_Input;
  on_conflict?: Maybe<Industry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvitationArgs = {
  objects: Array<Invitation_Insert_Input>;
  on_conflict?: Maybe<Invitation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitation_OneArgs = {
  object: Invitation_Insert_Input;
  on_conflict?: Maybe<Invitation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoiceArgs = {
  objects: Array<Invoice_Insert_Input>;
  on_conflict?: Maybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_OneArgs = {
  object: Invoice_Insert_Input;
  on_conflict?: Maybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LanguageArgs = {
  objects: Array<Language_Insert_Input>;
  on_conflict?: Maybe<Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Language_OneArgs = {
  object: Language_Insert_Input;
  on_conflict?: Maybe<Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ManagerArgs = {
  objects: Array<Manager_Insert_Input>;
  on_conflict?: Maybe<Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manager_ContractorArgs = {
  objects: Array<Manager_Contractor_Insert_Input>;
  on_conflict?: Maybe<Manager_Contractor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manager_Contractor_OneArgs = {
  object: Manager_Contractor_Insert_Input;
  on_conflict?: Maybe<Manager_Contractor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manager_OneArgs = {
  object: Manager_Insert_Input;
  on_conflict?: Maybe<Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MessageArgs = {
  objects: Array<Message_Insert_Input>;
  on_conflict?: Maybe<Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Message_OneArgs = {
  object: Message_Insert_Input;
  on_conflict?: Maybe<Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationArgs = {
  objects: Array<Notification_Insert_Input>;
  on_conflict?: Maybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_OneArgs = {
  object: Notification_Insert_Input;
  on_conflict?: Maybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OnboardingArgs = {
  objects: Array<Onboarding_Insert_Input>;
  on_conflict?: Maybe<Onboarding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Onboarding_OneArgs = {
  object: Onboarding_Insert_Input;
  on_conflict?: Maybe<Onboarding_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_CardArgs = {
  objects: Array<Payment_Card_Insert_Input>;
  on_conflict?: Maybe<Payment_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Card_OneArgs = {
  object: Payment_Card_Insert_Input;
  on_conflict?: Maybe<Payment_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PostingArgs = {
  objects: Array<Posting_Insert_Input>;
  on_conflict?: Maybe<Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_IndustryArgs = {
  objects: Array<Posting_Industry_Insert_Input>;
  on_conflict?: Maybe<Posting_Industry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Industry_OneArgs = {
  object: Posting_Industry_Insert_Input;
  on_conflict?: Maybe<Posting_Industry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_OneArgs = {
  object: Posting_Insert_Input;
  on_conflict?: Maybe<Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_SkillArgs = {
  objects: Array<Posting_Skill_Insert_Input>;
  on_conflict?: Maybe<Posting_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Skill_OneArgs = {
  object: Posting_Skill_Insert_Input;
  on_conflict?: Maybe<Posting_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_TagsArgs = {
  objects: Array<Posting_Tags_Insert_Input>;
  on_conflict?: Maybe<Posting_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Tags_OneArgs = {
  object: Posting_Tags_Insert_Input;
  on_conflict?: Maybe<Posting_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: Maybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ActivityArgs = {
  objects: Array<Project_Activity_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_NoteArgs = {
  objects: Array<Project_Activity_Note_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Note_OneArgs = {
  object: Project_Activity_Note_Insert_Input;
  on_conflict?: Maybe<Project_Activity_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_OneArgs = {
  object: Project_Activity_Insert_Input;
  on_conflict?: Maybe<Project_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Request_More_HoursArgs = {
  objects: Array<Project_Activity_Request_More_Hours_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_Request_More_Hours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Request_More_Hours_OneArgs = {
  object: Project_Activity_Request_More_Hours_Insert_Input;
  on_conflict?: Maybe<Project_Activity_Request_More_Hours_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_SkillArgs = {
  objects: Array<Project_Activity_Skill_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Skill_OneArgs = {
  object: Project_Activity_Skill_Insert_Input;
  on_conflict?: Maybe<Project_Activity_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Soft_SkillArgs = {
  objects: Array<Project_Activity_Soft_Skill_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Soft_Skill_OneArgs = {
  object: Project_Activity_Soft_Skill_Insert_Input;
  on_conflict?: Maybe<Project_Activity_Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_TagArgs = {
  objects: Array<Project_Activity_Tag_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Tag_OneArgs = {
  object: Project_Activity_Tag_Insert_Input;
  on_conflict?: Maybe<Project_Activity_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_TimeArgs = {
  objects: Array<Project_Activity_Time_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_Time_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Time_OneArgs = {
  object: Project_Activity_Time_Insert_Input;
  on_conflict?: Maybe<Project_Activity_Time_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Tracked_TimeArgs = {
  objects: Array<Project_Activity_Tracked_Time_Insert_Input>;
  on_conflict?: Maybe<Project_Activity_Tracked_Time_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Activity_Tracked_Time_OneArgs = {
  object: Project_Activity_Tracked_Time_Insert_Input;
  on_conflict?: Maybe<Project_Activity_Tracked_Time_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: Maybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_SkillArgs = {
  objects: Array<Project_Skill_Insert_Input>;
  on_conflict?: Maybe<Project_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Skill_OneArgs = {
  object: Project_Skill_Insert_Input;
  on_conflict?: Maybe<Project_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Soft_SkillArgs = {
  objects: Array<Project_Soft_Skill_Insert_Input>;
  on_conflict?: Maybe<Project_Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Soft_Skill_OneArgs = {
  object: Project_Soft_Skill_Insert_Input;
  on_conflict?: Maybe<Project_Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_TagArgs = {
  objects: Array<Project_Tag_Insert_Input>;
  on_conflict?: Maybe<Project_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Tag_OneArgs = {
  object: Project_Tag_Insert_Input;
  on_conflict?: Maybe<Project_Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recipient_MessageArgs = {
  objects: Array<Recipient_Message_Insert_Input>;
  on_conflict?: Maybe<Recipient_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Recipient_Message_OneArgs = {
  object: Recipient_Message_Insert_Input;
  on_conflict?: Maybe<Recipient_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Information_CardArgs = {
  objects: Array<Resource_Information_Card_Insert_Input>;
  on_conflict?: Maybe<Resource_Information_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Information_Card_OneArgs = {
  object: Resource_Information_Card_Insert_Input;
  on_conflict?: Maybe<Resource_Information_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SkillArgs = {
  objects: Array<Skill_Insert_Input>;
  on_conflict?: Maybe<Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Skill_OneArgs = {
  object: Skill_Insert_Input;
  on_conflict?: Maybe<Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Skills_Short_Name_FirstArgs = {
  objects: Array<Skills_Short_Name_First_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Skills_Short_Name_First_OneArgs = {
  object: Skills_Short_Name_First_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_BookmarkArgs = {
  objects: Array<Smart_Match_Bookmark_Insert_Input>;
  on_conflict?: Maybe<Smart_Match_Bookmark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_Bookmark_OneArgs = {
  object: Smart_Match_Bookmark_Insert_Input;
  on_conflict?: Maybe<Smart_Match_Bookmark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_Config_TransportationArgs = {
  objects: Array<Smart_Match_Config_Transportation_Insert_Input>;
  on_conflict?: Maybe<Smart_Match_Config_Transportation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_Config_Transportation_OneArgs = {
  object: Smart_Match_Config_Transportation_Insert_Input;
  on_conflict?: Maybe<Smart_Match_Config_Transportation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_ConfigsArgs = {
  objects: Array<Smart_Match_Configs_Insert_Input>;
  on_conflict?: Maybe<Smart_Match_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_Configs_OneArgs = {
  object: Smart_Match_Configs_Insert_Input;
  on_conflict?: Maybe<Smart_Match_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_Criteria_OrderArgs = {
  objects: Array<Smart_Match_Criteria_Order_Insert_Input>;
  on_conflict?: Maybe<Smart_Match_Criteria_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Match_Criteria_Order_OneArgs = {
  object: Smart_Match_Criteria_Order_Insert_Input;
  on_conflict?: Maybe<Smart_Match_Criteria_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Soft_SkillArgs = {
  objects: Array<Soft_Skill_Insert_Input>;
  on_conflict?: Maybe<Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Soft_Skill_OneArgs = {
  object: Soft_Skill_Insert_Input;
  on_conflict?: Maybe<Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SourceArgs = {
  objects: Array<Source_Insert_Input>;
  on_conflict?: Maybe<Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Source_OneArgs = {
  object: Source_Insert_Input;
  on_conflict?: Maybe<Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionArgs = {
  objects: Array<Subscription_Insert_Input>;
  on_conflict?: Maybe<Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_OneArgs = {
  object: Subscription_Insert_Input;
  on_conflict?: Maybe<Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_PlanArgs = {
  objects: Array<Subscription_Plan_Insert_Input>;
  on_conflict?: Maybe<Subscription_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Plan_Access_PermissionsArgs = {
  objects: Array<Subscription_Plan_Access_Permissions_Insert_Input>;
  on_conflict?: Maybe<Subscription_Plan_Access_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Plan_Access_Permissions_OneArgs = {
  object: Subscription_Plan_Access_Permissions_Insert_Input;
  on_conflict?: Maybe<Subscription_Plan_Access_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Plan_OneArgs = {
  object: Subscription_Plan_Insert_Input;
  on_conflict?: Maybe<Subscription_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagArgs = {
  objects: Array<Tag_Insert_Input>;
  on_conflict?: Maybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_OneArgs = {
  object: Tag_Insert_Input;
  on_conflict?: Maybe<Tag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamArgs = {
  objects: Array<Team_Insert_Input>;
  on_conflict?: Maybe<Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_ContractorArgs = {
  objects: Array<Team_Contractor_Insert_Input>;
  on_conflict?: Maybe<Team_Contractor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Contractor_OneArgs = {
  object: Team_Contractor_Insert_Input;
  on_conflict?: Maybe<Team_Contractor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_ManagerArgs = {
  objects: Array<Team_Manager_Insert_Input>;
  on_conflict?: Maybe<Team_Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Manager_OneArgs = {
  object: Team_Manager_Insert_Input;
  on_conflict?: Maybe<Team_Manager_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_OneArgs = {
  object: Team_Insert_Input;
  on_conflict?: Maybe<Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_PostingArgs = {
  objects: Array<Team_Posting_Insert_Input>;
  on_conflict?: Maybe<Team_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Posting_OneArgs = {
  object: Team_Posting_Insert_Input;
  on_conflict?: Maybe<Team_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_ProjectArgs = {
  objects: Array<Team_Project_Insert_Input>;
  on_conflict?: Maybe<Team_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Project_OneArgs = {
  object: Team_Project_Insert_Input;
  on_conflict?: Maybe<Team_Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_SkillArgs = {
  objects: Array<Team_Skill_Insert_Input>;
  on_conflict?: Maybe<Team_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Skill_OneArgs = {
  object: Team_Skill_Insert_Input;
  on_conflict?: Maybe<Team_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TimesheetArgs = {
  objects: Array<Timesheet_Insert_Input>;
  on_conflict?: Maybe<Timesheet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Timesheet_OneArgs = {
  object: Timesheet_Insert_Input;
  on_conflict?: Maybe<Timesheet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Type_Of_VisitArgs = {
  objects: Array<Type_Of_Visit_Insert_Input>;
  on_conflict?: Maybe<Type_Of_Visit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Type_Of_Visit_OneArgs = {
  object: Type_Of_Visit_Insert_Input;
  on_conflict?: Maybe<Type_Of_Visit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: Maybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Affinda_ProfileArgs = {
  objects: Array<User_Affinda_Profile_Insert_Input>;
  on_conflict?: Maybe<User_Affinda_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Affinda_Profile_OneArgs = {
  object: User_Affinda_Profile_Insert_Input;
  on_conflict?: Maybe<User_Affinda_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_CertificationArgs = {
  objects: Array<User_Certification_Insert_Input>;
  on_conflict?: Maybe<User_Certification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Certification_OneArgs = {
  object: User_Certification_Insert_Input;
  on_conflict?: Maybe<User_Certification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_CompanyArgs = {
  objects: Array<User_Company_Insert_Input>;
  on_conflict?: Maybe<User_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Company_OneArgs = {
  object: User_Company_Insert_Input;
  on_conflict?: Maybe<User_Company_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ConversationArgs = {
  objects: Array<User_Conversation_Insert_Input>;
  on_conflict?: Maybe<User_Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Conversation_OneArgs = {
  object: User_Conversation_Insert_Input;
  on_conflict?: Maybe<User_Conversation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_EducationArgs = {
  objects: Array<User_Education_Insert_Input>;
  on_conflict?: Maybe<User_Education_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Education_OneArgs = {
  object: User_Education_Insert_Input;
  on_conflict?: Maybe<User_Education_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ExperienceArgs = {
  objects: Array<User_Experience_Insert_Input>;
  on_conflict?: Maybe<User_Experience_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Experience_OneArgs = {
  object: User_Experience_Insert_Input;
  on_conflict?: Maybe<User_Experience_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FavoriteArgs = {
  objects: Array<User_Favorite_Insert_Input>;
  on_conflict?: Maybe<User_Favorite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Favorite_OneArgs = {
  object: User_Favorite_Insert_Input;
  on_conflict?: Maybe<User_Favorite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_IndustryArgs = {
  objects: Array<User_Industry_Insert_Input>;
  on_conflict?: Maybe<User_Industry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Industry_OneArgs = {
  object: User_Industry_Insert_Input;
  on_conflict?: Maybe<User_Industry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Job_TitleArgs = {
  objects: Array<User_Job_Title_Insert_Input>;
  on_conflict?: Maybe<User_Job_Title_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Job_Title_OneArgs = {
  object: User_Job_Title_Insert_Input;
  on_conflict?: Maybe<User_Job_Title_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_LanguageArgs = {
  objects: Array<User_Language_Insert_Input>;
  on_conflict?: Maybe<User_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Language_OneArgs = {
  object: User_Language_Insert_Input;
  on_conflict?: Maybe<User_Language_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: Maybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Private_DataArgs = {
  objects: Array<User_Private_Data_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_User_Private_Data_OneArgs = {
  object: User_Private_Data_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfileArgs = {
  objects: Array<User_Profile_Insert_Input>;
  on_conflict?: Maybe<User_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_By_ManagementArgs = {
  objects: Array<User_Profile_By_Management_Insert_Input>;
  on_conflict?: Maybe<User_Profile_By_Management_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_By_Management_OneArgs = {
  object: User_Profile_By_Management_Insert_Input;
  on_conflict?: Maybe<User_Profile_By_Management_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_OneArgs = {
  object: User_Profile_Insert_Input;
  on_conflict?: Maybe<User_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RatingArgs = {
  objects: Array<User_Rating_Insert_Input>;
  on_conflict?: Maybe<User_Rating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Rating_OneArgs = {
  object: User_Rating_Insert_Input;
  on_conflict?: Maybe<User_Rating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SkillArgs = {
  objects: Array<User_Skill_Insert_Input>;
  on_conflict?: Maybe<User_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Skill_OneArgs = {
  object: User_Skill_Insert_Input;
  on_conflict?: Maybe<User_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Soft_SkillArgs = {
  objects: Array<User_Soft_Skill_Insert_Input>;
  on_conflict?: Maybe<User_Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Soft_Skill_OneArgs = {
  object: User_Soft_Skill_Insert_Input;
  on_conflict?: Maybe<User_Soft_Skill_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_TransportationArgs = {
  objects: Array<User_Transportation_Insert_Input>;
  on_conflict?: Maybe<User_Transportation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Transportation_OneArgs = {
  object: User_Transportation_Insert_Input;
  on_conflict?: Maybe<User_Transportation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_WatchlistArgs = {
  objects: Array<User_Watchlist_Insert_Input>;
  on_conflict?: Maybe<User_Watchlist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Watchlist_OneArgs = {
  object: User_Watchlist_Insert_Input;
  on_conflict?: Maybe<User_Watchlist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AdminArgs = {
  _set?: Maybe<Admin_Set_Input>;
  where: Admin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_By_PkArgs = {
  _set?: Maybe<Admin_Set_Input>;
  pk_columns: Admin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_ManyArgs = {
  updates: Array<Admin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationArgs = {
  _set?: Maybe<Application_Set_Input>;
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_By_PkArgs = {
  _set?: Maybe<Application_Set_Input>;
  pk_columns: Application_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_ManyArgs = {
  updates: Array<Application_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CandidateArgs = {
  _set?: Maybe<Candidate_Set_Input>;
  where: Candidate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Candidate_By_PkArgs = {
  _set?: Maybe<Candidate_Set_Input>;
  pk_columns: Candidate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Candidate_ManyArgs = {
  updates: Array<Candidate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Checkin_StatusArgs = {
  _set?: Maybe<Checkin_Status_Set_Input>;
  where: Checkin_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Checkin_Status_By_PkArgs = {
  _set?: Maybe<Checkin_Status_Set_Input>;
  pk_columns: Checkin_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Checkin_Status_ManyArgs = {
  updates: Array<Checkin_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Checkout_StatusArgs = {
  _set?: Maybe<Checkout_Status_Set_Input>;
  where: Checkout_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Checkout_Status_By_PkArgs = {
  _set?: Maybe<Checkout_Status_Set_Input>;
  pk_columns: Checkout_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Checkout_Status_ManyArgs = {
  updates: Array<Checkout_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Care_PlanArgs = {
  _set?: Maybe<Client_Care_Plan_Set_Input>;
  where: Client_Care_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Care_Plan_By_PkArgs = {
  _set?: Maybe<Client_Care_Plan_Set_Input>;
  pk_columns: Client_Care_Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Care_Plan_ManyArgs = {
  updates: Array<Client_Care_Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Client_MedicationsArgs = {
  _set?: Maybe<Client_Medications_Set_Input>;
  where: Client_Medications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Medications_By_PkArgs = {
  _set?: Maybe<Client_Medications_Set_Input>;
  pk_columns: Client_Medications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Medications_ManyArgs = {
  updates: Array<Client_Medications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyArgs = {
  _inc?: Maybe<Company_Inc_Input>;
  _set?: Maybe<Company_Set_Input>;
  where: Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_By_PkArgs = {
  _inc?: Maybe<Company_Inc_Input>;
  _set?: Maybe<Company_Set_Input>;
  pk_columns: Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_FollowerArgs = {
  _set?: Maybe<Company_Follower_Set_Input>;
  where: Company_Follower_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Follower_By_PkArgs = {
  _set?: Maybe<Company_Follower_Set_Input>;
  pk_columns: Company_Follower_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_Follower_ManyArgs = {
  updates: Array<Company_Follower_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_ManyArgs = {
  updates: Array<Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_User_NotificationsArgs = {
  _set?: Maybe<Company_User_Notifications_Set_Input>;
  where: Company_User_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Company_User_Notifications_By_PkArgs = {
  _set?: Maybe<Company_User_Notifications_Set_Input>;
  pk_columns: Company_User_Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Company_User_Notifications_ManyArgs = {
  updates: Array<Company_User_Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContractorArgs = {
  _inc?: Maybe<Contractor_Inc_Input>;
  _set?: Maybe<Contractor_Set_Input>;
  where: Contractor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_By_PkArgs = {
  _inc?: Maybe<Contractor_Inc_Input>;
  _set?: Maybe<Contractor_Set_Input>;
  pk_columns: Contractor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_ManyArgs = {
  updates: Array<Contractor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_NoteArgs = {
  _set?: Maybe<Contractor_Note_Set_Input>;
  where: Contractor_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Note_By_PkArgs = {
  _set?: Maybe<Contractor_Note_Set_Input>;
  pk_columns: Contractor_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Note_ManyArgs = {
  updates: Array<Contractor_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_PostingArgs = {
  _inc?: Maybe<Contractor_Posting_Inc_Input>;
  _set?: Maybe<Contractor_Posting_Set_Input>;
  where: Contractor_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Posting_By_PkArgs = {
  _inc?: Maybe<Contractor_Posting_Inc_Input>;
  _set?: Maybe<Contractor_Posting_Set_Input>;
  pk_columns: Contractor_Posting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Posting_ManyArgs = {
  updates: Array<Contractor_Posting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_ProjectArgs = {
  _set?: Maybe<Contractor_Project_Set_Input>;
  where: Contractor_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Project_By_PkArgs = {
  _set?: Maybe<Contractor_Project_Set_Input>;
  pk_columns: Contractor_Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Project_ManyArgs = {
  updates: Array<Contractor_Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_RatingArgs = {
  _inc?: Maybe<Contractor_Rating_Inc_Input>;
  _set?: Maybe<Contractor_Rating_Set_Input>;
  where: Contractor_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Rating_By_PkArgs = {
  _inc?: Maybe<Contractor_Rating_Inc_Input>;
  _set?: Maybe<Contractor_Rating_Set_Input>;
  pk_columns: Contractor_Rating_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Rating_ManyArgs = {
  updates: Array<Contractor_Rating_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Staff_NoteArgs = {
  _set?: Maybe<Contractor_Staff_Note_Set_Input>;
  where: Contractor_Staff_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Staff_Note_By_PkArgs = {
  _set?: Maybe<Contractor_Staff_Note_Set_Input>;
  pk_columns: Contractor_Staff_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contractor_Staff_Note_ManyArgs = {
  updates: Array<Contractor_Staff_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConversationArgs = {
  _set?: Maybe<Conversation_Set_Input>;
  where: Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Conversation_By_PkArgs = {
  _set?: Maybe<Conversation_Set_Input>;
  pk_columns: Conversation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Conversation_ManyArgs = {
  updates: Array<Conversation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_RequestArgs = {
  _set?: Maybe<Custom_Request_Set_Input>;
  where: Custom_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Request_By_PkArgs = {
  _set?: Maybe<Custom_Request_Set_Input>;
  pk_columns: Custom_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Request_ManyArgs = {
  updates: Array<Custom_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Request_SkillsArgs = {
  _inc?: Maybe<Custom_Request_Skills_Inc_Input>;
  _set?: Maybe<Custom_Request_Skills_Set_Input>;
  where: Custom_Request_Skills_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Request_Skills_By_PkArgs = {
  _inc?: Maybe<Custom_Request_Skills_Inc_Input>;
  _set?: Maybe<Custom_Request_Skills_Set_Input>;
  pk_columns: Custom_Request_Skills_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Request_Skills_ManyArgs = {
  updates: Array<Custom_Request_Skills_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declined_Visit_MatchesArgs = {
  _inc?: Maybe<Declined_Visit_Matches_Inc_Input>;
  _set?: Maybe<Declined_Visit_Matches_Set_Input>;
  where: Declined_Visit_Matches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declined_Visit_Matches_By_PkArgs = {
  _inc?: Maybe<Declined_Visit_Matches_Inc_Input>;
  _set?: Maybe<Declined_Visit_Matches_Set_Input>;
  pk_columns: Declined_Visit_Matches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declined_Visit_Matches_ManyArgs = {
  updates: Array<Declined_Visit_Matches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentArgs = {
  _set?: Maybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_By_PkArgs = {
  _set?: Maybe<Document_Set_Input>;
  pk_columns: Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Contractor_AccessArgs = {
  _set?: Maybe<Document_Contractor_Access_Set_Input>;
  where: Document_Contractor_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Contractor_Access_By_PkArgs = {
  _set?: Maybe<Document_Contractor_Access_Set_Input>;
  pk_columns: Document_Contractor_Access_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Contractor_Access_ManyArgs = {
  updates: Array<Document_Contractor_Access_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Custom_RequestArgs = {
  _set?: Maybe<Document_Custom_Request_Set_Input>;
  where: Document_Custom_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Custom_Request_By_PkArgs = {
  _set?: Maybe<Document_Custom_Request_Set_Input>;
  pk_columns: Document_Custom_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Custom_Request_ManyArgs = {
  updates: Array<Document_Custom_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ManyArgs = {
  updates: Array<Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ProjectArgs = {
  _set?: Maybe<Document_Project_Set_Input>;
  where: Document_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Project_By_PkArgs = {
  _set?: Maybe<Document_Project_Set_Input>;
  pk_columns: Document_Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Project_ManyArgs = {
  updates: Array<Document_Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_UserArgs = {
  _set?: Maybe<Document_User_Set_Input>;
  where: Document_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_User_By_PkArgs = {
  _set?: Maybe<Document_User_Set_Input>;
  pk_columns: Document_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_User_ManyArgs = {
  updates: Array<Document_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_RegexArgs = {
  _inc?: Maybe<Email_Regex_Inc_Input>;
  _set?: Maybe<Email_Regex_Set_Input>;
  where: Email_Regex_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Regex_By_PkArgs = {
  _inc?: Maybe<Email_Regex_Inc_Input>;
  _set?: Maybe<Email_Regex_Set_Input>;
  pk_columns: Email_Regex_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Regex_ManyArgs = {
  updates: Array<Email_Regex_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Experience_SkillArgs = {
  _inc?: Maybe<Experience_Skill_Inc_Input>;
  _set?: Maybe<Experience_Skill_Set_Input>;
  where: Experience_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Experience_Skill_By_PkArgs = {
  _inc?: Maybe<Experience_Skill_Inc_Input>;
  _set?: Maybe<Experience_Skill_Set_Input>;
  pk_columns: Experience_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Experience_Skill_ManyArgs = {
  updates: Array<Experience_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GenderArgs = {
  _set?: Maybe<Gender_Set_Input>;
  where: Gender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gender_By_PkArgs = {
  _set?: Maybe<Gender_Set_Input>;
  pk_columns: Gender_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gender_ManyArgs = {
  updates: Array<Gender_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IndustryArgs = {
  _inc?: Maybe<Industry_Inc_Input>;
  _set?: Maybe<Industry_Set_Input>;
  where: Industry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Industry_By_PkArgs = {
  _inc?: Maybe<Industry_Inc_Input>;
  _set?: Maybe<Industry_Set_Input>;
  pk_columns: Industry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Industry_ManyArgs = {
  updates: Array<Industry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitationArgs = {
  _set?: Maybe<Invitation_Set_Input>;
  where: Invitation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_By_PkArgs = {
  _set?: Maybe<Invitation_Set_Input>;
  pk_columns: Invitation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_ManyArgs = {
  updates: Array<Invitation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceArgs = {
  _append?: Maybe<Invoice_Append_Input>;
  _delete_at_path?: Maybe<Invoice_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Invoice_Delete_Elem_Input>;
  _delete_key?: Maybe<Invoice_Delete_Key_Input>;
  _inc?: Maybe<Invoice_Inc_Input>;
  _prepend?: Maybe<Invoice_Prepend_Input>;
  _set?: Maybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_By_PkArgs = {
  _append?: Maybe<Invoice_Append_Input>;
  _delete_at_path?: Maybe<Invoice_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Invoice_Delete_Elem_Input>;
  _delete_key?: Maybe<Invoice_Delete_Key_Input>;
  _inc?: Maybe<Invoice_Inc_Input>;
  _prepend?: Maybe<Invoice_Prepend_Input>;
  _set?: Maybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LanguageArgs = {
  _inc?: Maybe<Language_Inc_Input>;
  _set?: Maybe<Language_Set_Input>;
  where: Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Language_By_PkArgs = {
  _inc?: Maybe<Language_Inc_Input>;
  _set?: Maybe<Language_Set_Input>;
  pk_columns: Language_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Language_ManyArgs = {
  updates: Array<Language_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ManagerArgs = {
  _set?: Maybe<Manager_Set_Input>;
  where: Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manager_By_PkArgs = {
  _set?: Maybe<Manager_Set_Input>;
  pk_columns: Manager_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manager_ContractorArgs = {
  _set?: Maybe<Manager_Contractor_Set_Input>;
  where: Manager_Contractor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manager_Contractor_By_PkArgs = {
  _set?: Maybe<Manager_Contractor_Set_Input>;
  pk_columns: Manager_Contractor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manager_Contractor_ManyArgs = {
  updates: Array<Manager_Contractor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Manager_ManyArgs = {
  updates: Array<Manager_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MessageArgs = {
  _set?: Maybe<Message_Set_Input>;
  where: Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Message_By_PkArgs = {
  _set?: Maybe<Message_Set_Input>;
  pk_columns: Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Message_ManyArgs = {
  updates: Array<Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationArgs = {
  _set?: Maybe<Notification_Set_Input>;
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_By_PkArgs = {
  _set?: Maybe<Notification_Set_Input>;
  pk_columns: Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ManyArgs = {
  updates: Array<Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OnboardingArgs = {
  _set?: Maybe<Onboarding_Set_Input>;
  where: Onboarding_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Onboarding_By_PkArgs = {
  _set?: Maybe<Onboarding_Set_Input>;
  pk_columns: Onboarding_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Onboarding_ManyArgs = {
  updates: Array<Onboarding_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_CardArgs = {
  _set?: Maybe<Payment_Card_Set_Input>;
  where: Payment_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Card_By_PkArgs = {
  _set?: Maybe<Payment_Card_Set_Input>;
  pk_columns: Payment_Card_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Card_ManyArgs = {
  updates: Array<Payment_Card_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PostingArgs = {
  _inc?: Maybe<Posting_Inc_Input>;
  _set?: Maybe<Posting_Set_Input>;
  where: Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_By_PkArgs = {
  _inc?: Maybe<Posting_Inc_Input>;
  _set?: Maybe<Posting_Set_Input>;
  pk_columns: Posting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_IndustryArgs = {
  _inc?: Maybe<Posting_Industry_Inc_Input>;
  _set?: Maybe<Posting_Industry_Set_Input>;
  where: Posting_Industry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Industry_By_PkArgs = {
  _inc?: Maybe<Posting_Industry_Inc_Input>;
  _set?: Maybe<Posting_Industry_Set_Input>;
  pk_columns: Posting_Industry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Industry_ManyArgs = {
  updates: Array<Posting_Industry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_ManyArgs = {
  updates: Array<Posting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_SkillArgs = {
  _inc?: Maybe<Posting_Skill_Inc_Input>;
  _set?: Maybe<Posting_Skill_Set_Input>;
  where: Posting_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Skill_By_PkArgs = {
  _inc?: Maybe<Posting_Skill_Inc_Input>;
  _set?: Maybe<Posting_Skill_Set_Input>;
  pk_columns: Posting_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Skill_ManyArgs = {
  updates: Array<Posting_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_TagsArgs = {
  _set?: Maybe<Posting_Tags_Set_Input>;
  where: Posting_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Tags_By_PkArgs = {
  _set?: Maybe<Posting_Tags_Set_Input>;
  pk_columns: Posting_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Tags_ManyArgs = {
  updates: Array<Posting_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _inc?: Maybe<Project_Inc_Input>;
  _set?: Maybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ActivityArgs = {
  _inc?: Maybe<Project_Activity_Inc_Input>;
  _set?: Maybe<Project_Activity_Set_Input>;
  where: Project_Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_By_PkArgs = {
  _inc?: Maybe<Project_Activity_Inc_Input>;
  _set?: Maybe<Project_Activity_Set_Input>;
  pk_columns: Project_Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_ManyArgs = {
  updates: Array<Project_Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_NoteArgs = {
  _set?: Maybe<Project_Activity_Note_Set_Input>;
  where: Project_Activity_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Note_By_PkArgs = {
  _set?: Maybe<Project_Activity_Note_Set_Input>;
  pk_columns: Project_Activity_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Note_ManyArgs = {
  updates: Array<Project_Activity_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Request_More_HoursArgs = {
  _inc?: Maybe<Project_Activity_Request_More_Hours_Inc_Input>;
  _set?: Maybe<Project_Activity_Request_More_Hours_Set_Input>;
  where: Project_Activity_Request_More_Hours_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Request_More_Hours_By_PkArgs = {
  _inc?: Maybe<Project_Activity_Request_More_Hours_Inc_Input>;
  _set?: Maybe<Project_Activity_Request_More_Hours_Set_Input>;
  pk_columns: Project_Activity_Request_More_Hours_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Request_More_Hours_ManyArgs = {
  updates: Array<Project_Activity_Request_More_Hours_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_SkillArgs = {
  _inc?: Maybe<Project_Activity_Skill_Inc_Input>;
  _set?: Maybe<Project_Activity_Skill_Set_Input>;
  where: Project_Activity_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Skill_By_PkArgs = {
  _inc?: Maybe<Project_Activity_Skill_Inc_Input>;
  _set?: Maybe<Project_Activity_Skill_Set_Input>;
  pk_columns: Project_Activity_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Skill_ManyArgs = {
  updates: Array<Project_Activity_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Soft_SkillArgs = {
  _inc?: Maybe<Project_Activity_Soft_Skill_Inc_Input>;
  _set?: Maybe<Project_Activity_Soft_Skill_Set_Input>;
  where: Project_Activity_Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Soft_Skill_By_PkArgs = {
  _inc?: Maybe<Project_Activity_Soft_Skill_Inc_Input>;
  _set?: Maybe<Project_Activity_Soft_Skill_Set_Input>;
  pk_columns: Project_Activity_Soft_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Soft_Skill_ManyArgs = {
  updates: Array<Project_Activity_Soft_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_TagArgs = {
  _inc?: Maybe<Project_Activity_Tag_Inc_Input>;
  _set?: Maybe<Project_Activity_Tag_Set_Input>;
  where: Project_Activity_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Tag_By_PkArgs = {
  _inc?: Maybe<Project_Activity_Tag_Inc_Input>;
  _set?: Maybe<Project_Activity_Tag_Set_Input>;
  pk_columns: Project_Activity_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Tag_ManyArgs = {
  updates: Array<Project_Activity_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_TimeArgs = {
  _inc?: Maybe<Project_Activity_Time_Inc_Input>;
  _set?: Maybe<Project_Activity_Time_Set_Input>;
  where: Project_Activity_Time_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Time_By_PkArgs = {
  _inc?: Maybe<Project_Activity_Time_Inc_Input>;
  _set?: Maybe<Project_Activity_Time_Set_Input>;
  pk_columns: Project_Activity_Time_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Time_ManyArgs = {
  updates: Array<Project_Activity_Time_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Tracked_TimeArgs = {
  _inc?: Maybe<Project_Activity_Tracked_Time_Inc_Input>;
  _set?: Maybe<Project_Activity_Tracked_Time_Set_Input>;
  where: Project_Activity_Tracked_Time_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Tracked_Time_By_PkArgs = {
  _inc?: Maybe<Project_Activity_Tracked_Time_Inc_Input>;
  _set?: Maybe<Project_Activity_Tracked_Time_Set_Input>;
  pk_columns: Project_Activity_Tracked_Time_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Activity_Tracked_Time_ManyArgs = {
  updates: Array<Project_Activity_Tracked_Time_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _inc?: Maybe<Project_Inc_Input>;
  _set?: Maybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_SkillArgs = {
  _inc?: Maybe<Project_Skill_Inc_Input>;
  _set?: Maybe<Project_Skill_Set_Input>;
  where: Project_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Skill_By_PkArgs = {
  _inc?: Maybe<Project_Skill_Inc_Input>;
  _set?: Maybe<Project_Skill_Set_Input>;
  pk_columns: Project_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Skill_ManyArgs = {
  updates: Array<Project_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Soft_SkillArgs = {
  _inc?: Maybe<Project_Soft_Skill_Inc_Input>;
  _set?: Maybe<Project_Soft_Skill_Set_Input>;
  where: Project_Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Soft_Skill_By_PkArgs = {
  _inc?: Maybe<Project_Soft_Skill_Inc_Input>;
  _set?: Maybe<Project_Soft_Skill_Set_Input>;
  pk_columns: Project_Soft_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Soft_Skill_ManyArgs = {
  updates: Array<Project_Soft_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_TagArgs = {
  _inc?: Maybe<Project_Tag_Inc_Input>;
  _set?: Maybe<Project_Tag_Set_Input>;
  where: Project_Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tag_By_PkArgs = {
  _inc?: Maybe<Project_Tag_Inc_Input>;
  _set?: Maybe<Project_Tag_Set_Input>;
  pk_columns: Project_Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tag_ManyArgs = {
  updates: Array<Project_Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Recipient_MessageArgs = {
  _set?: Maybe<Recipient_Message_Set_Input>;
  where: Recipient_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Recipient_Message_By_PkArgs = {
  _set?: Maybe<Recipient_Message_Set_Input>;
  pk_columns: Recipient_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Recipient_Message_ManyArgs = {
  updates: Array<Recipient_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Information_CardArgs = {
  _inc?: Maybe<Resource_Information_Card_Inc_Input>;
  _set?: Maybe<Resource_Information_Card_Set_Input>;
  where: Resource_Information_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Information_Card_By_PkArgs = {
  _inc?: Maybe<Resource_Information_Card_Inc_Input>;
  _set?: Maybe<Resource_Information_Card_Set_Input>;
  pk_columns: Resource_Information_Card_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Information_Card_ManyArgs = {
  updates: Array<Resource_Information_Card_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SkillArgs = {
  _inc?: Maybe<Skill_Inc_Input>;
  _set?: Maybe<Skill_Set_Input>;
  where: Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_By_PkArgs = {
  _inc?: Maybe<Skill_Inc_Input>;
  _set?: Maybe<Skill_Set_Input>;
  pk_columns: Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Skill_ManyArgs = {
  updates: Array<Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Skills_Short_Name_FirstArgs = {
  _inc?: Maybe<Skills_Short_Name_First_Inc_Input>;
  _set?: Maybe<Skills_Short_Name_First_Set_Input>;
  where: Skills_Short_Name_First_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Skills_Short_Name_First_ManyArgs = {
  updates: Array<Skills_Short_Name_First_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_BookmarkArgs = {
  _inc?: Maybe<Smart_Match_Bookmark_Inc_Input>;
  _set?: Maybe<Smart_Match_Bookmark_Set_Input>;
  where: Smart_Match_Bookmark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Bookmark_By_PkArgs = {
  _inc?: Maybe<Smart_Match_Bookmark_Inc_Input>;
  _set?: Maybe<Smart_Match_Bookmark_Set_Input>;
  pk_columns: Smart_Match_Bookmark_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Bookmark_ManyArgs = {
  updates: Array<Smart_Match_Bookmark_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Config_TransportationArgs = {
  _set?: Maybe<Smart_Match_Config_Transportation_Set_Input>;
  where: Smart_Match_Config_Transportation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Config_Transportation_By_PkArgs = {
  _set?: Maybe<Smart_Match_Config_Transportation_Set_Input>;
  pk_columns: Smart_Match_Config_Transportation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Config_Transportation_ManyArgs = {
  updates: Array<Smart_Match_Config_Transportation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_ConfigsArgs = {
  _inc?: Maybe<Smart_Match_Configs_Inc_Input>;
  _set?: Maybe<Smart_Match_Configs_Set_Input>;
  where: Smart_Match_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Configs_By_PkArgs = {
  _inc?: Maybe<Smart_Match_Configs_Inc_Input>;
  _set?: Maybe<Smart_Match_Configs_Set_Input>;
  pk_columns: Smart_Match_Configs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Configs_ManyArgs = {
  updates: Array<Smart_Match_Configs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Criteria_OrderArgs = {
  _inc?: Maybe<Smart_Match_Criteria_Order_Inc_Input>;
  _set?: Maybe<Smart_Match_Criteria_Order_Set_Input>;
  where: Smart_Match_Criteria_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Criteria_Order_By_PkArgs = {
  _inc?: Maybe<Smart_Match_Criteria_Order_Inc_Input>;
  _set?: Maybe<Smart_Match_Criteria_Order_Set_Input>;
  pk_columns: Smart_Match_Criteria_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Match_Criteria_Order_ManyArgs = {
  updates: Array<Smart_Match_Criteria_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Soft_SkillArgs = {
  _inc?: Maybe<Soft_Skill_Inc_Input>;
  _set?: Maybe<Soft_Skill_Set_Input>;
  where: Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Soft_Skill_By_PkArgs = {
  _inc?: Maybe<Soft_Skill_Inc_Input>;
  _set?: Maybe<Soft_Skill_Set_Input>;
  pk_columns: Soft_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Soft_Skill_ManyArgs = {
  updates: Array<Soft_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SourceArgs = {
  _set?: Maybe<Source_Set_Input>;
  where: Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Source_By_PkArgs = {
  _set?: Maybe<Source_Set_Input>;
  pk_columns: Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Source_ManyArgs = {
  updates: Array<Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionArgs = {
  _inc?: Maybe<Subscription_Inc_Input>;
  _set?: Maybe<Subscription_Set_Input>;
  where: Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_By_PkArgs = {
  _inc?: Maybe<Subscription_Inc_Input>;
  _set?: Maybe<Subscription_Set_Input>;
  pk_columns: Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_ManyArgs = {
  updates: Array<Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_PlanArgs = {
  _set?: Maybe<Subscription_Plan_Set_Input>;
  where: Subscription_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Plan_Access_PermissionsArgs = {
  _inc?: Maybe<Subscription_Plan_Access_Permissions_Inc_Input>;
  _set?: Maybe<Subscription_Plan_Access_Permissions_Set_Input>;
  where: Subscription_Plan_Access_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Plan_Access_Permissions_By_PkArgs = {
  _inc?: Maybe<Subscription_Plan_Access_Permissions_Inc_Input>;
  _set?: Maybe<Subscription_Plan_Access_Permissions_Set_Input>;
  pk_columns: Subscription_Plan_Access_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Plan_Access_Permissions_ManyArgs = {
  updates: Array<Subscription_Plan_Access_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Plan_By_PkArgs = {
  _set?: Maybe<Subscription_Plan_Set_Input>;
  pk_columns: Subscription_Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Plan_ManyArgs = {
  updates: Array<Subscription_Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagArgs = {
  _set?: Maybe<Tag_Set_Input>;
  where: Tag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_By_PkArgs = {
  _set?: Maybe<Tag_Set_Input>;
  pk_columns: Tag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_ManyArgs = {
  updates: Array<Tag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamArgs = {
  _set?: Maybe<Team_Set_Input>;
  where: Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_By_PkArgs = {
  _set?: Maybe<Team_Set_Input>;
  pk_columns: Team_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_ContractorArgs = {
  _set?: Maybe<Team_Contractor_Set_Input>;
  where: Team_Contractor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Contractor_By_PkArgs = {
  _set?: Maybe<Team_Contractor_Set_Input>;
  pk_columns: Team_Contractor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Contractor_ManyArgs = {
  updates: Array<Team_Contractor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_ManagerArgs = {
  _set?: Maybe<Team_Manager_Set_Input>;
  where: Team_Manager_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Manager_By_PkArgs = {
  _set?: Maybe<Team_Manager_Set_Input>;
  pk_columns: Team_Manager_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Manager_ManyArgs = {
  updates: Array<Team_Manager_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_ManyArgs = {
  updates: Array<Team_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_PostingArgs = {
  _set?: Maybe<Team_Posting_Set_Input>;
  where: Team_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Posting_By_PkArgs = {
  _set?: Maybe<Team_Posting_Set_Input>;
  pk_columns: Team_Posting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Posting_ManyArgs = {
  updates: Array<Team_Posting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_ProjectArgs = {
  _set?: Maybe<Team_Project_Set_Input>;
  where: Team_Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Project_By_PkArgs = {
  _set?: Maybe<Team_Project_Set_Input>;
  pk_columns: Team_Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Project_ManyArgs = {
  updates: Array<Team_Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_SkillArgs = {
  _inc?: Maybe<Team_Skill_Inc_Input>;
  _set?: Maybe<Team_Skill_Set_Input>;
  where: Team_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Skill_By_PkArgs = {
  _inc?: Maybe<Team_Skill_Inc_Input>;
  _set?: Maybe<Team_Skill_Set_Input>;
  pk_columns: Team_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Skill_ManyArgs = {
  updates: Array<Team_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TimesheetArgs = {
  _inc?: Maybe<Timesheet_Inc_Input>;
  _set?: Maybe<Timesheet_Set_Input>;
  where: Timesheet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Timesheet_By_PkArgs = {
  _inc?: Maybe<Timesheet_Inc_Input>;
  _set?: Maybe<Timesheet_Set_Input>;
  pk_columns: Timesheet_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Timesheet_ManyArgs = {
  updates: Array<Timesheet_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Type_Of_VisitArgs = {
  _set?: Maybe<Type_Of_Visit_Set_Input>;
  where: Type_Of_Visit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Type_Of_Visit_By_PkArgs = {
  _set?: Maybe<Type_Of_Visit_Set_Input>;
  pk_columns: Type_Of_Visit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Type_Of_Visit_ManyArgs = {
  updates: Array<Type_Of_Visit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _append?: Maybe<User_Append_Input>;
  _delete_at_path?: Maybe<User_Delete_At_Path_Input>;
  _delete_elem?: Maybe<User_Delete_Elem_Input>;
  _delete_key?: Maybe<User_Delete_Key_Input>;
  _inc?: Maybe<User_Inc_Input>;
  _prepend?: Maybe<User_Prepend_Input>;
  _set?: Maybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Affinda_ProfileArgs = {
  _set?: Maybe<User_Affinda_Profile_Set_Input>;
  where: User_Affinda_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Affinda_Profile_By_PkArgs = {
  _set?: Maybe<User_Affinda_Profile_Set_Input>;
  pk_columns: User_Affinda_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Affinda_Profile_ManyArgs = {
  updates: Array<User_Affinda_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _append?: Maybe<User_Append_Input>;
  _delete_at_path?: Maybe<User_Delete_At_Path_Input>;
  _delete_elem?: Maybe<User_Delete_Elem_Input>;
  _delete_key?: Maybe<User_Delete_Key_Input>;
  _inc?: Maybe<User_Inc_Input>;
  _prepend?: Maybe<User_Prepend_Input>;
  _set?: Maybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_CertificationArgs = {
  _inc?: Maybe<User_Certification_Inc_Input>;
  _set?: Maybe<User_Certification_Set_Input>;
  where: User_Certification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Certification_By_PkArgs = {
  _inc?: Maybe<User_Certification_Inc_Input>;
  _set?: Maybe<User_Certification_Set_Input>;
  pk_columns: User_Certification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Certification_ManyArgs = {
  updates: Array<User_Certification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_CompanyArgs = {
  _set?: Maybe<User_Company_Set_Input>;
  where: User_Company_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_By_PkArgs = {
  _set?: Maybe<User_Company_Set_Input>;
  pk_columns: User_Company_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Company_ManyArgs = {
  updates: Array<User_Company_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ConversationArgs = {
  _set?: Maybe<User_Conversation_Set_Input>;
  where: User_Conversation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Conversation_By_PkArgs = {
  _set?: Maybe<User_Conversation_Set_Input>;
  pk_columns: User_Conversation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Conversation_ManyArgs = {
  updates: Array<User_Conversation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_EducationArgs = {
  _inc?: Maybe<User_Education_Inc_Input>;
  _set?: Maybe<User_Education_Set_Input>;
  where: User_Education_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Education_By_PkArgs = {
  _inc?: Maybe<User_Education_Inc_Input>;
  _set?: Maybe<User_Education_Set_Input>;
  pk_columns: User_Education_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Education_ManyArgs = {
  updates: Array<User_Education_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ExperienceArgs = {
  _inc?: Maybe<User_Experience_Inc_Input>;
  _set?: Maybe<User_Experience_Set_Input>;
  where: User_Experience_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Experience_By_PkArgs = {
  _inc?: Maybe<User_Experience_Inc_Input>;
  _set?: Maybe<User_Experience_Set_Input>;
  pk_columns: User_Experience_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Experience_ManyArgs = {
  updates: Array<User_Experience_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_FavoriteArgs = {
  _set?: Maybe<User_Favorite_Set_Input>;
  where: User_Favorite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Favorite_By_PkArgs = {
  _set?: Maybe<User_Favorite_Set_Input>;
  pk_columns: User_Favorite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Favorite_ManyArgs = {
  updates: Array<User_Favorite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_IndustryArgs = {
  _inc?: Maybe<User_Industry_Inc_Input>;
  _set?: Maybe<User_Industry_Set_Input>;
  where: User_Industry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Industry_By_PkArgs = {
  _inc?: Maybe<User_Industry_Inc_Input>;
  _set?: Maybe<User_Industry_Set_Input>;
  pk_columns: User_Industry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Industry_ManyArgs = {
  updates: Array<User_Industry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Job_TitleArgs = {
  _inc?: Maybe<User_Job_Title_Inc_Input>;
  _set?: Maybe<User_Job_Title_Set_Input>;
  where: User_Job_Title_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Job_Title_By_PkArgs = {
  _inc?: Maybe<User_Job_Title_Inc_Input>;
  _set?: Maybe<User_Job_Title_Set_Input>;
  pk_columns: User_Job_Title_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Job_Title_ManyArgs = {
  updates: Array<User_Job_Title_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_LanguageArgs = {
  _inc?: Maybe<User_Language_Inc_Input>;
  _set?: Maybe<User_Language_Set_Input>;
  where: User_Language_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Language_By_PkArgs = {
  _inc?: Maybe<User_Language_Inc_Input>;
  _set?: Maybe<User_Language_Set_Input>;
  pk_columns: User_Language_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Language_ManyArgs = {
  updates: Array<User_Language_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Private_DataArgs = {
  _inc?: Maybe<User_Private_Data_Inc_Input>;
  _set?: Maybe<User_Private_Data_Set_Input>;
  where: User_Private_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Private_Data_ManyArgs = {
  updates: Array<User_Private_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfileArgs = {
  _inc?: Maybe<User_Profile_Inc_Input>;
  _set?: Maybe<User_Profile_Set_Input>;
  where: User_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_By_ManagementArgs = {
  _inc?: Maybe<User_Profile_By_Management_Inc_Input>;
  _set?: Maybe<User_Profile_By_Management_Set_Input>;
  where: User_Profile_By_Management_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_By_Management_By_PkArgs = {
  _inc?: Maybe<User_Profile_By_Management_Inc_Input>;
  _set?: Maybe<User_Profile_By_Management_Set_Input>;
  pk_columns: User_Profile_By_Management_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_By_Management_ManyArgs = {
  updates: Array<User_Profile_By_Management_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_By_PkArgs = {
  _inc?: Maybe<User_Profile_Inc_Input>;
  _set?: Maybe<User_Profile_Set_Input>;
  pk_columns: User_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_ManyArgs = {
  updates: Array<User_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RatingArgs = {
  _inc?: Maybe<User_Rating_Inc_Input>;
  _set?: Maybe<User_Rating_Set_Input>;
  where: User_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Rating_By_PkArgs = {
  _inc?: Maybe<User_Rating_Inc_Input>;
  _set?: Maybe<User_Rating_Set_Input>;
  pk_columns: User_Rating_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Rating_ManyArgs = {
  updates: Array<User_Rating_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SkillArgs = {
  _inc?: Maybe<User_Skill_Inc_Input>;
  _set?: Maybe<User_Skill_Set_Input>;
  where: User_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Skill_By_PkArgs = {
  _inc?: Maybe<User_Skill_Inc_Input>;
  _set?: Maybe<User_Skill_Set_Input>;
  pk_columns: User_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Skill_ManyArgs = {
  updates: Array<User_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Soft_SkillArgs = {
  _inc?: Maybe<User_Soft_Skill_Inc_Input>;
  _set?: Maybe<User_Soft_Skill_Set_Input>;
  where: User_Soft_Skill_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Soft_Skill_By_PkArgs = {
  _inc?: Maybe<User_Soft_Skill_Inc_Input>;
  _set?: Maybe<User_Soft_Skill_Set_Input>;
  pk_columns: User_Soft_Skill_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Soft_Skill_ManyArgs = {
  updates: Array<User_Soft_Skill_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_TransportationArgs = {
  _set?: Maybe<User_Transportation_Set_Input>;
  where: User_Transportation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Transportation_By_PkArgs = {
  _set?: Maybe<User_Transportation_Set_Input>;
  pk_columns: User_Transportation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Transportation_ManyArgs = {
  updates: Array<User_Transportation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_WatchlistArgs = {
  _set?: Maybe<User_Watchlist_Set_Input>;
  where: User_Watchlist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Watchlist_By_PkArgs = {
  _set?: Maybe<User_Watchlist_Set_Input>;
  pk_columns: User_Watchlist_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Watchlist_ManyArgs = {
  updates: Array<User_Watchlist_Updates>;
};

/** columns and relationships of "notification" */
export type Notification = {
  __typename?: 'notification';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read: Scalars['Boolean'];
  shown?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "notification" */
export type Notification_Aggregate = {
  __typename?: 'notification_aggregate';
  aggregate?: Maybe<Notification_Aggregate_Fields>;
  nodes: Array<Notification>;
};

/** aggregate fields of "notification" */
export type Notification_Aggregate_Fields = {
  __typename?: 'notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Max_Fields>;
  min?: Maybe<Notification_Min_Fields>;
};


/** aggregate fields of "notification" */
export type Notification_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Notification_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification". All fields are combined with a logical 'AND'. */
export type Notification_Bool_Exp = {
  _and?: Maybe<Array<Notification_Bool_Exp>>;
  _not?: Maybe<Notification_Bool_Exp>;
  _or?: Maybe<Array<Notification_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  link?: Maybe<String_Comparison_Exp>;
  message?: Maybe<String_Comparison_Exp>;
  read?: Maybe<Boolean_Comparison_Exp>;
  shown?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification" */
export enum Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationPkey = 'notification_pkey'
}

/** input type for inserting data into table "notification" */
export type Notification_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  shown?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Notification_Max_Fields = {
  __typename?: 'notification_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Notification_Min_Fields = {
  __typename?: 'notification_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "notification" */
export type Notification_Mutation_Response = {
  __typename?: 'notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification>;
};

/** on_conflict condition type for table "notification" */
export type Notification_On_Conflict = {
  constraint: Notification_Constraint;
  update_columns?: Array<Notification_Update_Column>;
  where?: Maybe<Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "notification". */
export type Notification_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  link?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  read?: Maybe<Order_By>;
  shown?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: notification */
export type Notification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "notification" */
export enum Notification_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Message = 'message',
  /** column name */
  Read = 'read',
  /** column name */
  Shown = 'shown',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "notification" */
export type Notification_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  shown?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "notification" */
export type Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  shown?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "notification" */
export enum Notification_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Message = 'message',
  /** column name */
  Read = 'read',
  /** column name */
  Shown = 'shown',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Notification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Bool_Exp;
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "onboarding" */
export type Onboarding = {
  __typename?: 'onboarding';
  /** An object relationship */
  candidate?: Maybe<Candidate>;
  candidate_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "onboarding" */
export type Onboarding_Aggregate = {
  __typename?: 'onboarding_aggregate';
  aggregate?: Maybe<Onboarding_Aggregate_Fields>;
  nodes: Array<Onboarding>;
};

export type Onboarding_Aggregate_Bool_Exp = {
  count?: Maybe<Onboarding_Aggregate_Bool_Exp_Count>;
};

export type Onboarding_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Onboarding_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Onboarding_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "onboarding" */
export type Onboarding_Aggregate_Fields = {
  __typename?: 'onboarding_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Onboarding_Max_Fields>;
  min?: Maybe<Onboarding_Min_Fields>;
};


/** aggregate fields of "onboarding" */
export type Onboarding_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Onboarding_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "onboarding" */
export type Onboarding_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Onboarding_Max_Order_By>;
  min?: Maybe<Onboarding_Min_Order_By>;
};

/** input type for inserting array relation for remote table "onboarding" */
export type Onboarding_Arr_Rel_Insert_Input = {
  data: Array<Onboarding_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Onboarding_On_Conflict>;
};

/** Boolean expression to filter rows from the table "onboarding". All fields are combined with a logical 'AND'. */
export type Onboarding_Bool_Exp = {
  _and?: Maybe<Array<Onboarding_Bool_Exp>>;
  _not?: Maybe<Onboarding_Bool_Exp>;
  _or?: Maybe<Array<Onboarding_Bool_Exp>>;
  candidate?: Maybe<Candidate_Bool_Exp>;
  candidate_id?: Maybe<Uuid_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "onboarding" */
export enum Onboarding_Constraint {
  /** unique or primary key constraint on columns "id" */
  OnboardingPkey = 'onboarding_pkey',
  /** unique or primary key constraint on columns "user_id", "candidate_id" */
  OnboardingUserIdCandidateIdKey = 'onboarding_user_id_candidate_id_key'
}

/** input type for inserting data into table "onboarding" */
export type Onboarding_Insert_Input = {
  candidate?: Maybe<Candidate_Obj_Rel_Insert_Input>;
  candidate_id?: Maybe<Scalars['uuid']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Onboarding_Max_Fields = {
  __typename?: 'onboarding_max_fields';
  candidate_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "onboarding" */
export type Onboarding_Max_Order_By = {
  candidate_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Onboarding_Min_Fields = {
  __typename?: 'onboarding_min_fields';
  candidate_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "onboarding" */
export type Onboarding_Min_Order_By = {
  candidate_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "onboarding" */
export type Onboarding_Mutation_Response = {
  __typename?: 'onboarding_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Onboarding>;
};

/** on_conflict condition type for table "onboarding" */
export type Onboarding_On_Conflict = {
  constraint: Onboarding_Constraint;
  update_columns?: Array<Onboarding_Update_Column>;
  where?: Maybe<Onboarding_Bool_Exp>;
};

/** Ordering options when selecting data from "onboarding". */
export type Onboarding_Order_By = {
  candidate?: Maybe<Candidate_Order_By>;
  candidate_id?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: onboarding */
export type Onboarding_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "onboarding" */
export enum Onboarding_Select_Column {
  /** column name */
  CandidateId = 'candidate_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "onboarding" */
export type Onboarding_Set_Input = {
  candidate_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "onboarding" */
export type Onboarding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Onboarding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Onboarding_Stream_Cursor_Value_Input = {
  candidate_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "onboarding" */
export enum Onboarding_Update_Column {
  /** column name */
  CandidateId = 'candidate_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Onboarding_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Onboarding_Set_Input>;
  /** filter the rows which have to be updated */
  where: Onboarding_Bool_Exp;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "payment_card" */
export type Payment_Card = {
  __typename?: 'payment_card';
  brand: Scalars['String'];
  created_at: Scalars['timestamptz'];
  exp_month: Scalars['String'];
  exp_year: Scalars['String'];
  id: Scalars['uuid'];
  last4: Scalars['String'];
  stripe_card_id: Scalars['String'];
  /** An array relationship */
  subscriptions: Array<Subscription>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscription_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "payment_card" */
export type Payment_CardSubscriptionsArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


/** columns and relationships of "payment_card" */
export type Payment_CardSubscriptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};

/** aggregated selection of "payment_card" */
export type Payment_Card_Aggregate = {
  __typename?: 'payment_card_aggregate';
  aggregate?: Maybe<Payment_Card_Aggregate_Fields>;
  nodes: Array<Payment_Card>;
};

export type Payment_Card_Aggregate_Bool_Exp = {
  count?: Maybe<Payment_Card_Aggregate_Bool_Exp_Count>;
};

export type Payment_Card_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Payment_Card_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Payment_Card_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "payment_card" */
export type Payment_Card_Aggregate_Fields = {
  __typename?: 'payment_card_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Payment_Card_Max_Fields>;
  min?: Maybe<Payment_Card_Min_Fields>;
};


/** aggregate fields of "payment_card" */
export type Payment_Card_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Payment_Card_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment_card" */
export type Payment_Card_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Payment_Card_Max_Order_By>;
  min?: Maybe<Payment_Card_Min_Order_By>;
};

/** input type for inserting array relation for remote table "payment_card" */
export type Payment_Card_Arr_Rel_Insert_Input = {
  data: Array<Payment_Card_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Payment_Card_On_Conflict>;
};

/** Boolean expression to filter rows from the table "payment_card". All fields are combined with a logical 'AND'. */
export type Payment_Card_Bool_Exp = {
  _and?: Maybe<Array<Payment_Card_Bool_Exp>>;
  _not?: Maybe<Payment_Card_Bool_Exp>;
  _or?: Maybe<Array<Payment_Card_Bool_Exp>>;
  brand?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  exp_month?: Maybe<String_Comparison_Exp>;
  exp_year?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  last4?: Maybe<String_Comparison_Exp>;
  stripe_card_id?: Maybe<String_Comparison_Exp>;
  subscriptions?: Maybe<Subscription_Bool_Exp>;
  subscriptions_aggregate?: Maybe<Subscription_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_card" */
export enum Payment_Card_Constraint {
  /** unique or primary key constraint on columns "stripe_card_id" */
  PaymentCardCardIdKey = 'payment_card_card_id_key',
  /** unique or primary key constraint on columns "id" */
  PaymentCardPkey = 'payment_card_pkey'
}

/** input type for inserting data into table "payment_card" */
export type Payment_Card_Insert_Input = {
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exp_month?: Maybe<Scalars['String']>;
  exp_year?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  stripe_card_id?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Subscription_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Payment_Card_Max_Fields = {
  __typename?: 'payment_card_max_fields';
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exp_month?: Maybe<Scalars['String']>;
  exp_year?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  stripe_card_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "payment_card" */
export type Payment_Card_Max_Order_By = {
  brand?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exp_month?: Maybe<Order_By>;
  exp_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last4?: Maybe<Order_By>;
  stripe_card_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Card_Min_Fields = {
  __typename?: 'payment_card_min_fields';
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exp_month?: Maybe<Scalars['String']>;
  exp_year?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  stripe_card_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "payment_card" */
export type Payment_Card_Min_Order_By = {
  brand?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exp_month?: Maybe<Order_By>;
  exp_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last4?: Maybe<Order_By>;
  stripe_card_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "payment_card" */
export type Payment_Card_Mutation_Response = {
  __typename?: 'payment_card_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Card>;
};

/** input type for inserting object relation for remote table "payment_card" */
export type Payment_Card_Obj_Rel_Insert_Input = {
  data: Payment_Card_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Payment_Card_On_Conflict>;
};

/** on_conflict condition type for table "payment_card" */
export type Payment_Card_On_Conflict = {
  constraint: Payment_Card_Constraint;
  update_columns?: Array<Payment_Card_Update_Column>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_card". */
export type Payment_Card_Order_By = {
  brand?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exp_month?: Maybe<Order_By>;
  exp_year?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  last4?: Maybe<Order_By>;
  stripe_card_id?: Maybe<Order_By>;
  subscriptions_aggregate?: Maybe<Subscription_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: payment_card */
export type Payment_Card_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "payment_card" */
export enum Payment_Card_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpMonth = 'exp_month',
  /** column name */
  ExpYear = 'exp_year',
  /** column name */
  Id = 'id',
  /** column name */
  Last4 = 'last4',
  /** column name */
  StripeCardId = 'stripe_card_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "payment_card" */
export type Payment_Card_Set_Input = {
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exp_month?: Maybe<Scalars['String']>;
  exp_year?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  stripe_card_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "payment_card" */
export type Payment_Card_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Card_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Card_Stream_Cursor_Value_Input = {
  brand?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exp_month?: Maybe<Scalars['String']>;
  exp_year?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last4?: Maybe<Scalars['String']>;
  stripe_card_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "payment_card" */
export enum Payment_Card_Update_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpMonth = 'exp_month',
  /** column name */
  ExpYear = 'exp_year',
  /** column name */
  Id = 'id',
  /** column name */
  Last4 = 'last4',
  /** column name */
  StripeCardId = 'stripe_card_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Payment_Card_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Payment_Card_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Card_Bool_Exp;
};

/** columns and relationships of "posting" */
export type Posting = {
  __typename?: 'posting';
  active: Scalars['Boolean'];
  /** An array relationship */
  applications: Array<Application>;
  /** An aggregate relationship */
  applications_aggregate: Application_Aggregate;
  city?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  /** An array relationship */
  contractor_postings: Array<Contractor_Posting>;
  /** An aggregate relationship */
  contractor_postings_aggregate: Contractor_Posting_Aggregate;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  duration_type?: Maybe<Scalars['String']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** An array relationship */
  industries: Array<Posting_Industry>;
  /** An aggregate relationship */
  industries_aggregate: Posting_Industry_Aggregate;
  job_title?: Maybe<Scalars['String']>;
  /** An object relationship */
  manager?: Maybe<Manager>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  posting_tags: Array<Posting_Tags>;
  /** An aggregate relationship */
  posting_tags_aggregate: Posting_Tags_Aggregate;
  public: Scalars['Boolean'];
  /** An array relationship */
  skills: Array<Posting_Skill>;
  /** An aggregate relationship */
  skills_aggregate: Posting_Skill_Aggregate;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  /** An array relationship */
  team_postings: Array<Team_Posting>;
  /** An aggregate relationship */
  team_postings_aggregate: Team_Posting_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "posting" */
export type PostingApplicationsArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingApplications_AggregateArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingContractor_PostingsArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingContractor_Postings_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingIndustriesArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingIndustries_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingPosting_TagsArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingPosting_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingSkillsArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingSkills_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingTeam_PostingsArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


/** columns and relationships of "posting" */
export type PostingTeam_Postings_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};

/** aggregated selection of "posting" */
export type Posting_Aggregate = {
  __typename?: 'posting_aggregate';
  aggregate?: Maybe<Posting_Aggregate_Fields>;
  nodes: Array<Posting>;
};

export type Posting_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Posting_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Posting_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Posting_Aggregate_Bool_Exp_Count>;
};

export type Posting_Aggregate_Bool_Exp_Bool_And = {
  arguments: Posting_Select_Column_Posting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Posting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Posting_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Posting_Select_Column_Posting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Posting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Posting_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Posting_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Posting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting" */
export type Posting_Aggregate_Fields = {
  __typename?: 'posting_aggregate_fields';
  avg?: Maybe<Posting_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Posting_Max_Fields>;
  min?: Maybe<Posting_Min_Fields>;
  stddev?: Maybe<Posting_Stddev_Fields>;
  stddev_pop?: Maybe<Posting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posting_Stddev_Samp_Fields>;
  sum?: Maybe<Posting_Sum_Fields>;
  var_pop?: Maybe<Posting_Var_Pop_Fields>;
  var_samp?: Maybe<Posting_Var_Samp_Fields>;
  variance?: Maybe<Posting_Variance_Fields>;
};


/** aggregate fields of "posting" */
export type Posting_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Posting_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting" */
export type Posting_Aggregate_Order_By = {
  avg?: Maybe<Posting_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Posting_Max_Order_By>;
  min?: Maybe<Posting_Min_Order_By>;
  stddev?: Maybe<Posting_Stddev_Order_By>;
  stddev_pop?: Maybe<Posting_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Posting_Stddev_Samp_Order_By>;
  sum?: Maybe<Posting_Sum_Order_By>;
  var_pop?: Maybe<Posting_Var_Pop_Order_By>;
  var_samp?: Maybe<Posting_Var_Samp_Order_By>;
  variance?: Maybe<Posting_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posting" */
export type Posting_Arr_Rel_Insert_Input = {
  data: Array<Posting_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Posting_On_Conflict>;
};

/** aggregate avg on columns */
export type Posting_Avg_Fields = {
  __typename?: 'posting_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  estimate_rate?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "posting" */
export type Posting_Avg_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posting". All fields are combined with a logical 'AND'. */
export type Posting_Bool_Exp = {
  _and?: Maybe<Array<Posting_Bool_Exp>>;
  _not?: Maybe<Posting_Bool_Exp>;
  _or?: Maybe<Array<Posting_Bool_Exp>>;
  active?: Maybe<Boolean_Comparison_Exp>;
  applications?: Maybe<Application_Bool_Exp>;
  applications_aggregate?: Maybe<Application_Aggregate_Bool_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  contractor_postings?: Maybe<Contractor_Posting_Bool_Exp>;
  contractor_postings_aggregate?: Maybe<Contractor_Posting_Aggregate_Bool_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  duration?: Maybe<Int_Comparison_Exp>;
  duration_type?: Maybe<String_Comparison_Exp>;
  employment_type?: Maybe<String_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  estimate_rate?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  industries?: Maybe<Posting_Industry_Bool_Exp>;
  industries_aggregate?: Maybe<Posting_Industry_Aggregate_Bool_Exp>;
  job_title?: Maybe<String_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  max_rate?: Maybe<Bigint_Comparison_Exp>;
  min_rate?: Maybe<Bigint_Comparison_Exp>;
  posting_tags?: Maybe<Posting_Tags_Bool_Exp>;
  posting_tags_aggregate?: Maybe<Posting_Tags_Aggregate_Bool_Exp>;
  public?: Maybe<Boolean_Comparison_Exp>;
  skills?: Maybe<Posting_Skill_Bool_Exp>;
  skills_aggregate?: Maybe<Posting_Skill_Aggregate_Bool_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  team_postings?: Maybe<Team_Posting_Bool_Exp>;
  team_postings_aggregate?: Maybe<Team_Posting_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting" */
export enum Posting_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostingPkey = 'posting_pkey'
}

/** input type for incrementing numeric columns in table "posting" */
export type Posting_Inc_Input = {
  duration?: Maybe<Scalars['Int']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "posting_industry" */
export type Posting_Industry = {
  __typename?: 'posting_industry';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  industry: Industry;
  industry_id: Scalars['Int'];
  /** An object relationship */
  posting: Posting;
  posting_id: Scalars['uuid'];
};

/** aggregated selection of "posting_industry" */
export type Posting_Industry_Aggregate = {
  __typename?: 'posting_industry_aggregate';
  aggregate?: Maybe<Posting_Industry_Aggregate_Fields>;
  nodes: Array<Posting_Industry>;
};

export type Posting_Industry_Aggregate_Bool_Exp = {
  count?: Maybe<Posting_Industry_Aggregate_Bool_Exp_Count>;
};

export type Posting_Industry_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Posting_Industry_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Posting_Industry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting_industry" */
export type Posting_Industry_Aggregate_Fields = {
  __typename?: 'posting_industry_aggregate_fields';
  avg?: Maybe<Posting_Industry_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Posting_Industry_Max_Fields>;
  min?: Maybe<Posting_Industry_Min_Fields>;
  stddev?: Maybe<Posting_Industry_Stddev_Fields>;
  stddev_pop?: Maybe<Posting_Industry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posting_Industry_Stddev_Samp_Fields>;
  sum?: Maybe<Posting_Industry_Sum_Fields>;
  var_pop?: Maybe<Posting_Industry_Var_Pop_Fields>;
  var_samp?: Maybe<Posting_Industry_Var_Samp_Fields>;
  variance?: Maybe<Posting_Industry_Variance_Fields>;
};


/** aggregate fields of "posting_industry" */
export type Posting_Industry_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Posting_Industry_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting_industry" */
export type Posting_Industry_Aggregate_Order_By = {
  avg?: Maybe<Posting_Industry_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Posting_Industry_Max_Order_By>;
  min?: Maybe<Posting_Industry_Min_Order_By>;
  stddev?: Maybe<Posting_Industry_Stddev_Order_By>;
  stddev_pop?: Maybe<Posting_Industry_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Posting_Industry_Stddev_Samp_Order_By>;
  sum?: Maybe<Posting_Industry_Sum_Order_By>;
  var_pop?: Maybe<Posting_Industry_Var_Pop_Order_By>;
  var_samp?: Maybe<Posting_Industry_Var_Samp_Order_By>;
  variance?: Maybe<Posting_Industry_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posting_industry" */
export type Posting_Industry_Arr_Rel_Insert_Input = {
  data: Array<Posting_Industry_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Posting_Industry_On_Conflict>;
};

/** aggregate avg on columns */
export type Posting_Industry_Avg_Fields = {
  __typename?: 'posting_industry_avg_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "posting_industry" */
export type Posting_Industry_Avg_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posting_industry". All fields are combined with a logical 'AND'. */
export type Posting_Industry_Bool_Exp = {
  _and?: Maybe<Array<Posting_Industry_Bool_Exp>>;
  _not?: Maybe<Posting_Industry_Bool_Exp>;
  _or?: Maybe<Array<Posting_Industry_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  industry?: Maybe<Industry_Bool_Exp>;
  industry_id?: Maybe<Int_Comparison_Exp>;
  posting?: Maybe<Posting_Bool_Exp>;
  posting_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting_industry" */
export enum Posting_Industry_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostingIndustryPkey = 'posting_industry_pkey'
}

/** input type for incrementing numeric columns in table "posting_industry" */
export type Posting_Industry_Inc_Input = {
  industry_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "posting_industry" */
export type Posting_Industry_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Industry_Obj_Rel_Insert_Input>;
  industry_id?: Maybe<Scalars['Int']>;
  posting?: Maybe<Posting_Obj_Rel_Insert_Input>;
  posting_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Posting_Industry_Max_Fields = {
  __typename?: 'posting_industry_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "posting_industry" */
export type Posting_Industry_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_Industry_Min_Fields = {
  __typename?: 'posting_industry_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "posting_industry" */
export type Posting_Industry_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "posting_industry" */
export type Posting_Industry_Mutation_Response = {
  __typename?: 'posting_industry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting_Industry>;
};

/** on_conflict condition type for table "posting_industry" */
export type Posting_Industry_On_Conflict = {
  constraint: Posting_Industry_Constraint;
  update_columns?: Array<Posting_Industry_Update_Column>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};

/** Ordering options when selecting data from "posting_industry". */
export type Posting_Industry_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry?: Maybe<Industry_Order_By>;
  industry_id?: Maybe<Order_By>;
  posting?: Maybe<Posting_Order_By>;
  posting_id?: Maybe<Order_By>;
};

/** primary key columns input for table: posting_industry */
export type Posting_Industry_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting_industry" */
export enum Posting_Industry_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndustryId = 'industry_id',
  /** column name */
  PostingId = 'posting_id'
}

/** input type for updating data in table "posting_industry" */
export type Posting_Industry_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Posting_Industry_Stddev_Fields = {
  __typename?: 'posting_industry_stddev_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "posting_industry" */
export type Posting_Industry_Stddev_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posting_Industry_Stddev_Pop_Fields = {
  __typename?: 'posting_industry_stddev_pop_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "posting_industry" */
export type Posting_Industry_Stddev_Pop_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posting_Industry_Stddev_Samp_Fields = {
  __typename?: 'posting_industry_stddev_samp_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "posting_industry" */
export type Posting_Industry_Stddev_Samp_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "posting_industry" */
export type Posting_Industry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Industry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Industry_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  posting_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Posting_Industry_Sum_Fields = {
  __typename?: 'posting_industry_sum_fields';
  industry_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "posting_industry" */
export type Posting_Industry_Sum_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** update columns of table "posting_industry" */
export enum Posting_Industry_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndustryId = 'industry_id',
  /** column name */
  PostingId = 'posting_id'
}

export type Posting_Industry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Posting_Industry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Posting_Industry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_Industry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posting_Industry_Var_Pop_Fields = {
  __typename?: 'posting_industry_var_pop_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "posting_industry" */
export type Posting_Industry_Var_Pop_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posting_Industry_Var_Samp_Fields = {
  __typename?: 'posting_industry_var_samp_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "posting_industry" */
export type Posting_Industry_Var_Samp_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Posting_Industry_Variance_Fields = {
  __typename?: 'posting_industry_variance_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "posting_industry" */
export type Posting_Industry_Variance_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** input type for inserting data into table "posting" */
export type Posting_Insert_Input = {
  active?: Maybe<Scalars['Boolean']>;
  applications?: Maybe<Application_Arr_Rel_Insert_Input>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  contractor_postings?: Maybe<Contractor_Posting_Arr_Rel_Insert_Input>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  duration_type?: Maybe<Scalars['String']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  industries?: Maybe<Posting_Industry_Arr_Rel_Insert_Input>;
  job_title?: Maybe<Scalars['String']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
  posting_tags?: Maybe<Posting_Tags_Arr_Rel_Insert_Input>;
  public?: Maybe<Scalars['Boolean']>;
  skills?: Maybe<Posting_Skill_Arr_Rel_Insert_Input>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  team_postings?: Maybe<Team_Posting_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Posting_Max_Fields = {
  __typename?: 'posting_max_fields';
  city?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  duration_type?: Maybe<Scalars['String']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "posting" */
export type Posting_Max_Order_By = {
  city?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  duration_type?: Maybe<Order_By>;
  employment_type?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_Min_Fields = {
  __typename?: 'posting_min_fields';
  city?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  duration_type?: Maybe<Scalars['String']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "posting" */
export type Posting_Min_Order_By = {
  city?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  duration_type?: Maybe<Order_By>;
  employment_type?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "posting" */
export type Posting_Mutation_Response = {
  __typename?: 'posting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting>;
};

/** input type for inserting object relation for remote table "posting" */
export type Posting_Obj_Rel_Insert_Input = {
  data: Posting_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Posting_On_Conflict>;
};

/** on_conflict condition type for table "posting" */
export type Posting_On_Conflict = {
  constraint: Posting_Constraint;
  update_columns?: Array<Posting_Update_Column>;
  where?: Maybe<Posting_Bool_Exp>;
};

/** Ordering options when selecting data from "posting". */
export type Posting_Order_By = {
  active?: Maybe<Order_By>;
  applications_aggregate?: Maybe<Application_Aggregate_Order_By>;
  city?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  contractor_postings_aggregate?: Maybe<Contractor_Posting_Aggregate_Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  duration?: Maybe<Order_By>;
  duration_type?: Maybe<Order_By>;
  employment_type?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industries_aggregate?: Maybe<Posting_Industry_Aggregate_Order_By>;
  job_title?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  posting_tags_aggregate?: Maybe<Posting_Tags_Aggregate_Order_By>;
  public?: Maybe<Order_By>;
  skills_aggregate?: Maybe<Posting_Skill_Aggregate_Order_By>;
  start_date?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  team_postings_aggregate?: Maybe<Team_Posting_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: posting */
export type Posting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting" */
export enum Posting_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  City = 'city',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  DurationType = 'duration_type',
  /** column name */
  EmploymentType = 'employment_type',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EstimateRate = 'estimate_rate',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  Public = 'public',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "posting_aggregate_bool_exp_bool_and_arguments_columns" columns of table "posting" */
export enum Posting_Select_Column_Posting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Public = 'public'
}

/** select "posting_aggregate_bool_exp_bool_or_arguments_columns" columns of table "posting" */
export enum Posting_Select_Column_Posting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Public = 'public'
}

/** input type for updating data in table "posting" */
export type Posting_Set_Input = {
  active?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  duration_type?: Maybe<Scalars['String']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
  public?: Maybe<Scalars['Boolean']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "posting_skill" */
export type Posting_Skill = {
  __typename?: 'posting_skill';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  posting: Posting;
  posting_id: Scalars['uuid'];
  /** An object relationship */
  skill: Skill;
  skill_id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "posting_skill" */
export type Posting_Skill_Aggregate = {
  __typename?: 'posting_skill_aggregate';
  aggregate?: Maybe<Posting_Skill_Aggregate_Fields>;
  nodes: Array<Posting_Skill>;
};

export type Posting_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Posting_Skill_Aggregate_Bool_Exp_Count>;
};

export type Posting_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Posting_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Posting_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting_skill" */
export type Posting_Skill_Aggregate_Fields = {
  __typename?: 'posting_skill_aggregate_fields';
  avg?: Maybe<Posting_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Posting_Skill_Max_Fields>;
  min?: Maybe<Posting_Skill_Min_Fields>;
  stddev?: Maybe<Posting_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Posting_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posting_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Posting_Skill_Sum_Fields>;
  var_pop?: Maybe<Posting_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Posting_Skill_Var_Samp_Fields>;
  variance?: Maybe<Posting_Skill_Variance_Fields>;
};


/** aggregate fields of "posting_skill" */
export type Posting_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Posting_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting_skill" */
export type Posting_Skill_Aggregate_Order_By = {
  avg?: Maybe<Posting_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Posting_Skill_Max_Order_By>;
  min?: Maybe<Posting_Skill_Min_Order_By>;
  stddev?: Maybe<Posting_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Posting_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Posting_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Posting_Skill_Sum_Order_By>;
  var_pop?: Maybe<Posting_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Posting_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Posting_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "posting_skill" */
export type Posting_Skill_Arr_Rel_Insert_Input = {
  data: Array<Posting_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Posting_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Posting_Skill_Avg_Fields = {
  __typename?: 'posting_skill_avg_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "posting_skill" */
export type Posting_Skill_Avg_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "posting_skill". All fields are combined with a logical 'AND'. */
export type Posting_Skill_Bool_Exp = {
  _and?: Maybe<Array<Posting_Skill_Bool_Exp>>;
  _not?: Maybe<Posting_Skill_Bool_Exp>;
  _or?: Maybe<Array<Posting_Skill_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  posting?: Maybe<Posting_Bool_Exp>;
  posting_id?: Maybe<Uuid_Comparison_Exp>;
  skill?: Maybe<Skill_Bool_Exp>;
  skill_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting_skill" */
export enum Posting_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostingSkillPkey = 'posting_skill_pkey'
}

/** input type for incrementing numeric columns in table "posting_skill" */
export type Posting_Skill_Inc_Input = {
  skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "posting_skill" */
export type Posting_Skill_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting?: Maybe<Posting_Obj_Rel_Insert_Input>;
  posting_id?: Maybe<Scalars['uuid']>;
  skill?: Maybe<Skill_Obj_Rel_Insert_Input>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Posting_Skill_Max_Fields = {
  __typename?: 'posting_skill_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "posting_skill" */
export type Posting_Skill_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_Skill_Min_Fields = {
  __typename?: 'posting_skill_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "posting_skill" */
export type Posting_Skill_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "posting_skill" */
export type Posting_Skill_Mutation_Response = {
  __typename?: 'posting_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting_Skill>;
};

/** on_conflict condition type for table "posting_skill" */
export type Posting_Skill_On_Conflict = {
  constraint: Posting_Skill_Constraint;
  update_columns?: Array<Posting_Skill_Update_Column>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "posting_skill". */
export type Posting_Skill_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting?: Maybe<Posting_Order_By>;
  posting_id?: Maybe<Order_By>;
  skill?: Maybe<Skill_Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: posting_skill */
export type Posting_Skill_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting_skill" */
export enum Posting_Skill_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "posting_skill" */
export type Posting_Skill_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Posting_Skill_Stddev_Fields = {
  __typename?: 'posting_skill_stddev_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "posting_skill" */
export type Posting_Skill_Stddev_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posting_Skill_Stddev_Pop_Fields = {
  __typename?: 'posting_skill_stddev_pop_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "posting_skill" */
export type Posting_Skill_Stddev_Pop_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posting_Skill_Stddev_Samp_Fields = {
  __typename?: 'posting_skill_stddev_samp_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "posting_skill" */
export type Posting_Skill_Stddev_Samp_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "posting_skill" */
export type Posting_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Skill_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Posting_Skill_Sum_Fields = {
  __typename?: 'posting_skill_sum_fields';
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "posting_skill" */
export type Posting_Skill_Sum_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** update columns of table "posting_skill" */
export enum Posting_Skill_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Posting_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Posting_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Posting_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posting_Skill_Var_Pop_Fields = {
  __typename?: 'posting_skill_var_pop_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "posting_skill" */
export type Posting_Skill_Var_Pop_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posting_Skill_Var_Samp_Fields = {
  __typename?: 'posting_skill_var_samp_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "posting_skill" */
export type Posting_Skill_Var_Samp_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Posting_Skill_Variance_Fields = {
  __typename?: 'posting_skill_variance_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "posting_skill" */
export type Posting_Skill_Variance_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev on columns */
export type Posting_Stddev_Fields = {
  __typename?: 'posting_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  estimate_rate?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "posting" */
export type Posting_Stddev_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Posting_Stddev_Pop_Fields = {
  __typename?: 'posting_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  estimate_rate?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "posting" */
export type Posting_Stddev_Pop_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Posting_Stddev_Samp_Fields = {
  __typename?: 'posting_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  estimate_rate?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "posting" */
export type Posting_Stddev_Samp_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** Streaming cursor of the table "posting" */
export type Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Stream_Cursor_Value_Input = {
  active?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  duration_type?: Maybe<Scalars['String']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_title?: Maybe<Scalars['String']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
  public?: Maybe<Scalars['Boolean']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Posting_Sum_Fields = {
  __typename?: 'posting_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  estimate_rate?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['bigint']>;
  min_rate?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "posting" */
export type Posting_Sum_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** columns and relationships of "posting_tags" */
export type Posting_Tags = {
  __typename?: 'posting_tags';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  posting: Posting;
  posting_id: Scalars['uuid'];
  /** An object relationship */
  tag: Tag;
  tag_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "posting_tags" */
export type Posting_Tags_Aggregate = {
  __typename?: 'posting_tags_aggregate';
  aggregate?: Maybe<Posting_Tags_Aggregate_Fields>;
  nodes: Array<Posting_Tags>;
};

export type Posting_Tags_Aggregate_Bool_Exp = {
  count?: Maybe<Posting_Tags_Aggregate_Bool_Exp_Count>;
};

export type Posting_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Posting_Tags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Posting_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting_tags" */
export type Posting_Tags_Aggregate_Fields = {
  __typename?: 'posting_tags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Posting_Tags_Max_Fields>;
  min?: Maybe<Posting_Tags_Min_Fields>;
};


/** aggregate fields of "posting_tags" */
export type Posting_Tags_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Posting_Tags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting_tags" */
export type Posting_Tags_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Posting_Tags_Max_Order_By>;
  min?: Maybe<Posting_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "posting_tags" */
export type Posting_Tags_Arr_Rel_Insert_Input = {
  data: Array<Posting_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Posting_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "posting_tags". All fields are combined with a logical 'AND'. */
export type Posting_Tags_Bool_Exp = {
  _and?: Maybe<Array<Posting_Tags_Bool_Exp>>;
  _not?: Maybe<Posting_Tags_Bool_Exp>;
  _or?: Maybe<Array<Posting_Tags_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  posting?: Maybe<Posting_Bool_Exp>;
  posting_id?: Maybe<Uuid_Comparison_Exp>;
  tag?: Maybe<Tag_Bool_Exp>;
  tag_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting_tags" */
export enum Posting_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostingTagsPkey = 'posting_tags_pkey'
}

/** input type for inserting data into table "posting_tags" */
export type Posting_Tags_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting?: Maybe<Posting_Obj_Rel_Insert_Input>;
  posting_id?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Tag_Obj_Rel_Insert_Input>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Posting_Tags_Max_Fields = {
  __typename?: 'posting_tags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "posting_tags" */
export type Posting_Tags_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_Tags_Min_Fields = {
  __typename?: 'posting_tags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "posting_tags" */
export type Posting_Tags_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "posting_tags" */
export type Posting_Tags_Mutation_Response = {
  __typename?: 'posting_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting_Tags>;
};

/** on_conflict condition type for table "posting_tags" */
export type Posting_Tags_On_Conflict = {
  constraint: Posting_Tags_Constraint;
  update_columns?: Array<Posting_Tags_Update_Column>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "posting_tags". */
export type Posting_Tags_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting?: Maybe<Posting_Order_By>;
  posting_id?: Maybe<Order_By>;
  tag?: Maybe<Tag_Order_By>;
  tag_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: posting_tags */
export type Posting_Tags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting_tags" */
export enum Posting_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "posting_tags" */
export type Posting_Tags_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "posting_tags" */
export type Posting_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Tags_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "posting_tags" */
export enum Posting_Tags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Posting_Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Posting_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_Tags_Bool_Exp;
};

/** update columns of table "posting" */
export enum Posting_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  City = 'city',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Duration = 'duration',
  /** column name */
  DurationType = 'duration_type',
  /** column name */
  EmploymentType = 'employment_type',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EstimateRate = 'estimate_rate',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  Public = 'public',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Posting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Posting_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Posting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Posting_Var_Pop_Fields = {
  __typename?: 'posting_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  estimate_rate?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "posting" */
export type Posting_Var_Pop_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Posting_Var_Samp_Fields = {
  __typename?: 'posting_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  estimate_rate?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "posting" */
export type Posting_Var_Samp_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Posting_Variance_Fields = {
  __typename?: 'posting_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  estimate_rate?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "posting" */
export type Posting_Variance_Order_By = {
  duration?: Maybe<Order_By>;
  estimate_rate?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
};

/** columns and relationships of "project" */
export type Project = {
  __typename?: 'project';
  access_id?: Maybe<Scalars['uuid']>;
  access_number?: Maybe<Scalars['String']>;
  access_type?: Maybe<Scalars['String']>;
  access_type_other?: Maybe<Scalars['String']>;
  accessibility_issues?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  additional_general_notes?: Maybe<Scalars['String']>;
  additional_other_information?: Maybe<Scalars['String']>;
  additional_special_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  allergies_environmental?: Maybe<Array<Scalars['String']>>;
  allergies_food?: Maybe<Array<Scalars['String']>>;
  allergies_medication?: Maybe<Array<Scalars['String']>>;
  archived: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  /** An object relationship */
  client_care_plan?: Maybe<Client_Care_Plan>;
  client_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  client_medications: Array<Client_Medications>;
  /** An aggregate relationship */
  client_medications_aggregate: Client_Medications_Aggregate;
  client_name?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  cognitive_others?: Maybe<Scalars['String']>;
  communication_ability?: Maybe<Scalars['String']>;
  communication_languages_spoken?: Maybe<Array<Scalars['String']>>;
  communication_notes?: Maybe<Scalars['String']>;
  communication_others?: Maybe<Scalars['String']>;
  community_resources?: Maybe<Scalars['String']>;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  completed: Scalars['Boolean'];
  /** An array relationship */
  contractor_staff_notes: Array<Contractor_Staff_Note>;
  /** An aggregate relationship */
  contractor_staff_notes_aggregate: Contractor_Staff_Note_Aggregate;
  /** An array relationship */
  contractors: Array<Contractor_Project>;
  /** An aggregate relationship */
  contractors_aggregate: Contractor_Project_Aggregate;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cultural_considerations?: Maybe<Scalars['String']>;
  /** An array relationship */
  custom_requests: Array<Custom_Request>;
  /** An aggregate relationship */
  custom_requests_aggregate: Custom_Request_Aggregate;
  date_completed?: Maybe<Scalars['date']>;
  date_started?: Maybe<Scalars['date']>;
  description: Scalars['String'];
  desired_outcomes?: Maybe<Scalars['String']>;
  dietary_restrictions?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  drafted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  emergency_additional_notes?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_email?: Maybe<Scalars['String']>;
  emergency_phone_number?: Maybe<Scalars['String']>;
  emergency_relationship?: Maybe<Scalars['String']>;
  emergency_secondary_contact?: Maybe<Scalars['String']>;
  enable_visit_based_clock_ins?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  extra_notes?: Maybe<Scalars['String']>;
  family_medical_history?: Maybe<Scalars['String']>;
  family_support?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Array<Scalars['String']>>;
  home_general_notes?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  immunizations?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['String']>;
  interpreter_needed?: Maybe<Scalars['String']>;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  is_clockin?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  long_term_goals?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  manager?: Maybe<Manager>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_budget?: Maybe<Scalars['Int']>;
  medical_conditions?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['Int']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  mobility_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notify_admin_by_email?: Maybe<Scalars['Boolean']>;
  notify_manager_by_email?: Maybe<Scalars['Boolean']>;
  past_conditions?: Maybe<Scalars['String']>;
  past_surgeries?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Scalars['String']>>;
  phone_number?: Maybe<Scalars['String']>;
  preferred_communication_style?: Maybe<Scalars['String']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  previous_hospitalizations?: Maybe<Scalars['String']>;
  primary_contact_number?: Maybe<Scalars['String']>;
  professional_care_contacts?: Maybe<Scalars['String']>;
  /** An array relationship */
  project_activities: Array<Project_Activity>;
  /** An aggregate relationship */
  project_activities_aggregate: Project_Activity_Aggregate;
  /** An array relationship */
  project_documents: Array<Document_Project>;
  /** An aggregate relationship */
  project_documents_aggregate: Document_Project_Aggregate;
  /** An array relationship */
  project_skills: Array<Project_Skill>;
  /** An aggregate relationship */
  project_skills_aggregate: Project_Skill_Aggregate;
  /** An array relationship */
  project_soft_skills: Array<Project_Soft_Skill>;
  /** An aggregate relationship */
  project_soft_skills_aggregate: Project_Soft_Skill_Aggregate;
  /** An array relationship */
  project_tags: Array<Project_Tag>;
  /** An aggregate relationship */
  project_tags_aggregate: Project_Tag_Aggregate;
  reference?: Maybe<Scalars['String']>;
  religious_practices?: Maybe<Scalars['String']>;
  safety_concerns?: Maybe<Scalars['String']>;
  secondar_contact_number?: Maybe<Scalars['String']>;
  self_directed_care_preferences?: Maybe<Scalars['String']>;
  short_term_goals?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  smart_home_features?: Maybe<Scalars['String']>;
  /** An array relationship */
  smart_match_bookmarks: Array<Smart_Match_Bookmark>;
  /** An aggregate relationship */
  smart_match_bookmarks_aggregate: Smart_Match_Bookmark_Aggregate;
  social_connections?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  specific_care_needs?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  support_type?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  /** An array relationship */
  teams: Array<Team_Project>;
  /** An aggregate relationship */
  teams_aggregate: Team_Project_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  visual_communication_style?: Maybe<Scalars['String']>;
};


/** columns and relationships of "project" */
export type ProjectClient_MedicationsArgs = {
  distinct_on?: Maybe<Array<Client_Medications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Medications_Order_By>>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectClient_Medications_AggregateArgs = {
  distinct_on?: Maybe<Array<Client_Medications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Medications_Order_By>>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectContractor_Staff_NotesArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectContractor_Staff_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectContractorsArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectContractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectCustom_RequestsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectCustom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectInvoicesArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectInvoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_ActivitiesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Activities_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_DocumentsArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_SkillsArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Soft_SkillsArgs = {
  distinct_on?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Soft_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_TagsArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectSmart_Match_BookmarksArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectSmart_Match_Bookmarks_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectTeamsArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectTeams_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};

/** columns and relationships of "project_activity" */
export type Project_Activity = {
  __typename?: 'project_activity';
  accepted?: Maybe<Scalars['Boolean']>;
  accepted_on?: Maybe<Scalars['timestamptz']>;
  budget: Scalars['numeric'];
  cancelled?: Maybe<Scalars['Boolean']>;
  check_geo?: Maybe<Scalars['Boolean']>;
  checkin_status?: Maybe<Scalars['String']>;
  checkin_time?: Maybe<Scalars['timestamptz']>;
  checkout_status?: Maybe<Scalars['String']>;
  checkout_time?: Maybe<Scalars['timestamptz']>;
  completed: Scalars['Boolean'];
  confirmed_hours?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  contractor?: Maybe<Contractor>;
  contractor_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  contractor_ratings: Array<Contractor_Rating>;
  /** An aggregate relationship */
  contractor_ratings_aggregate: Contractor_Rating_Aggregate;
  /** An array relationship */
  contractor_staff_notes: Array<Contractor_Staff_Note>;
  /** An aggregate relationship */
  contractor_staff_notes_aggregate: Contractor_Staff_Note_Aggregate;
  contractor_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['uuid']>;
  currency: Scalars['currency'];
  /** An array relationship */
  custom_requests: Array<Custom_Request>;
  /** An aggregate relationship */
  custom_requests_aggregate: Custom_Request_Aggregate;
  /** An array relationship */
  declined_visit_matches: Array<Declined_Visit_Matches>;
  /** An aggregate relationship */
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  deleted: Scalars['Boolean'];
  disable_time_alerts?: Maybe<Scalars['Boolean']>;
  drafted?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  extra_notes?: Maybe<Scalars['String']>;
  extra_notes_created_at?: Maybe<Scalars['timestamptz']>;
  extra_notes_updated_at?: Maybe<Scalars['timestamptz']>;
  fallback_num?: Maybe<Scalars['String']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  final_report_confirmed: Scalars['Boolean'];
  id: Scalars['uuid'];
  invoice_id?: Maybe<Scalars['uuid']>;
  is_empty_visit_notify?: Maybe<Scalars['Boolean']>;
  last_email_alert_at?: Maybe<Scalars['timestamptz']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  note: Scalars['String'];
  note_updated_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  /** An object relationship */
  project: Project;
  /** An array relationship */
  project_activity_notes: Array<Project_Activity_Note>;
  /** An aggregate relationship */
  project_activity_notes_aggregate: Project_Activity_Note_Aggregate;
  /** An array relationship */
  project_activity_request_more_hours: Array<Project_Activity_Request_More_Hours>;
  /** An aggregate relationship */
  project_activity_request_more_hours_aggregate: Project_Activity_Request_More_Hours_Aggregate;
  /** An array relationship */
  project_activity_skills: Array<Project_Activity_Skill>;
  /** An aggregate relationship */
  project_activity_skills_aggregate: Project_Activity_Skill_Aggregate;
  /** An array relationship */
  project_activity_soft_skills: Array<Project_Activity_Soft_Skill>;
  /** An aggregate relationship */
  project_activity_soft_skills_aggregate: Project_Activity_Soft_Skill_Aggregate;
  /** An array relationship */
  project_activity_tags: Array<Project_Activity_Tag>;
  /** An aggregate relationship */
  project_activity_tags_aggregate: Project_Activity_Tag_Aggregate;
  /** An array relationship */
  project_activity_times: Array<Project_Activity_Time>;
  /** An aggregate relationship */
  project_activity_times_aggregate: Project_Activity_Time_Aggregate;
  /** An array relationship */
  project_activity_tracked_times: Array<Project_Activity_Tracked_Time>;
  /** An aggregate relationship */
  project_activity_tracked_times_aggregate: Project_Activity_Tracked_Time_Aggregate;
  project_id: Scalars['uuid'];
  rejected?: Maybe<Scalars['Boolean']>;
  requested_hours?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type_of_visit?: Maybe<Type_Of_Visit_Enum>;
  /** An object relationship */
  user?: Maybe<User>;
  virtual?: Maybe<Scalars['Boolean']>;
  virtual_meeting_link?: Maybe<Scalars['String']>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityContractor_RatingsArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityContractor_Ratings_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityContractor_Staff_NotesArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityContractor_Staff_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityCustom_RequestsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityCustom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityDeclined_Visit_MatchesArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityDeclined_Visit_Matches_AggregateArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_NotesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Note_Order_By>>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Note_Order_By>>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Request_More_HoursArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Request_More_Hours_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_SkillsArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Soft_SkillsArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Soft_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_TagsArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_TimesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Times_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Tracked_TimesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


/** columns and relationships of "project_activity" */
export type Project_ActivityProject_Activity_Tracked_Times_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};

/** aggregated selection of "project_activity" */
export type Project_Activity_Aggregate = {
  __typename?: 'project_activity_aggregate';
  aggregate?: Maybe<Project_Activity_Aggregate_Fields>;
  nodes: Array<Project_Activity>;
};

export type Project_Activity_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Project_Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Project_Activity_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Project_Activity_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Activity_Select_Column_Project_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Activity_Select_Column_Project_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Activity_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity" */
export type Project_Activity_Aggregate_Fields = {
  __typename?: 'project_activity_aggregate_fields';
  avg?: Maybe<Project_Activity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Max_Fields>;
  min?: Maybe<Project_Activity_Min_Fields>;
  stddev?: Maybe<Project_Activity_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Activity_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Activity_Sum_Fields>;
  var_pop?: Maybe<Project_Activity_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Activity_Var_Samp_Fields>;
  variance?: Maybe<Project_Activity_Variance_Fields>;
};


/** aggregate fields of "project_activity" */
export type Project_Activity_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity" */
export type Project_Activity_Aggregate_Order_By = {
  avg?: Maybe<Project_Activity_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Max_Order_By>;
  min?: Maybe<Project_Activity_Min_Order_By>;
  stddev?: Maybe<Project_Activity_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Activity_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Activity_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Activity_Sum_Order_By>;
  var_pop?: Maybe<Project_Activity_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Activity_Var_Samp_Order_By>;
  variance?: Maybe<Project_Activity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity" */
export type Project_Activity_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Activity_Avg_Fields = {
  __typename?: 'project_activity_avg_fields';
  budget?: Maybe<Scalars['Float']>;
  confirmed_hours?: Maybe<Scalars['Float']>;
  final_cost?: Maybe<Scalars['Float']>;
  final_hours?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  requested_hours?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_activity" */
export type Project_Activity_Avg_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_activity". All fields are combined with a logical 'AND'. */
export type Project_Activity_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Bool_Exp>>;
  accepted?: Maybe<Boolean_Comparison_Exp>;
  accepted_on?: Maybe<Timestamptz_Comparison_Exp>;
  budget?: Maybe<Numeric_Comparison_Exp>;
  cancelled?: Maybe<Boolean_Comparison_Exp>;
  check_geo?: Maybe<Boolean_Comparison_Exp>;
  checkin_status?: Maybe<String_Comparison_Exp>;
  checkin_time?: Maybe<Timestamptz_Comparison_Exp>;
  checkout_status?: Maybe<String_Comparison_Exp>;
  checkout_time?: Maybe<Timestamptz_Comparison_Exp>;
  completed?: Maybe<Boolean_Comparison_Exp>;
  confirmed_hours?: Maybe<Numeric_Comparison_Exp>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  contractor_ratings?: Maybe<Contractor_Rating_Bool_Exp>;
  contractor_ratings_aggregate?: Maybe<Contractor_Rating_Aggregate_Bool_Exp>;
  contractor_staff_notes?: Maybe<Contractor_Staff_Note_Bool_Exp>;
  contractor_staff_notes_aggregate?: Maybe<Contractor_Staff_Note_Aggregate_Bool_Exp>;
  contractor_updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  currency?: Maybe<Currency_Comparison_Exp>;
  custom_requests?: Maybe<Custom_Request_Bool_Exp>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Bool_Exp>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Bool_Exp>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Bool_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  disable_time_alerts?: Maybe<Boolean_Comparison_Exp>;
  drafted?: Maybe<Boolean_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  end_time?: Maybe<Timestamptz_Comparison_Exp>;
  extra_notes?: Maybe<String_Comparison_Exp>;
  extra_notes_created_at?: Maybe<Timestamptz_Comparison_Exp>;
  extra_notes_updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  fallback_num?: Maybe<String_Comparison_Exp>;
  final_cost?: Maybe<Int_Comparison_Exp>;
  final_hours?: Maybe<Int_Comparison_Exp>;
  final_report_confirmed?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoice_id?: Maybe<Uuid_Comparison_Exp>;
  is_empty_visit_notify?: Maybe<Boolean_Comparison_Exp>;
  last_email_alert_at?: Maybe<Timestamptz_Comparison_Exp>;
  latitude?: Maybe<Numeric_Comparison_Exp>;
  location?: Maybe<String_Comparison_Exp>;
  longitude?: Maybe<Numeric_Comparison_Exp>;
  note?: Maybe<String_Comparison_Exp>;
  note_updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  priority?: Maybe<String_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_activity_notes?: Maybe<Project_Activity_Note_Bool_Exp>;
  project_activity_notes_aggregate?: Maybe<Project_Activity_Note_Aggregate_Bool_Exp>;
  project_activity_request_more_hours?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
  project_activity_request_more_hours_aggregate?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Bool_Exp>;
  project_activity_skills?: Maybe<Project_Activity_Skill_Bool_Exp>;
  project_activity_skills_aggregate?: Maybe<Project_Activity_Skill_Aggregate_Bool_Exp>;
  project_activity_soft_skills?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
  project_activity_soft_skills_aggregate?: Maybe<Project_Activity_Soft_Skill_Aggregate_Bool_Exp>;
  project_activity_tags?: Maybe<Project_Activity_Tag_Bool_Exp>;
  project_activity_tags_aggregate?: Maybe<Project_Activity_Tag_Aggregate_Bool_Exp>;
  project_activity_times?: Maybe<Project_Activity_Time_Bool_Exp>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Bool_Exp>;
  project_activity_tracked_times?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
  project_activity_tracked_times_aggregate?: Maybe<Project_Activity_Tracked_Time_Aggregate_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  rejected?: Maybe<Boolean_Comparison_Exp>;
  requested_hours?: Maybe<Int_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  start_time?: Maybe<Timestamptz_Comparison_Exp>;
  timezone?: Maybe<String_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  type_of_visit?: Maybe<Type_Of_Visit_Enum_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  virtual?: Maybe<Boolean_Comparison_Exp>;
  virtual_meeting_link?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity" */
export enum Project_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivityPkey = 'project_activity_pkey'
}

/** input type for incrementing numeric columns in table "project_activity" */
export type Project_Activity_Inc_Input = {
  budget?: Maybe<Scalars['numeric']>;
  confirmed_hours?: Maybe<Scalars['numeric']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  requested_hours?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_activity" */
export type Project_Activity_Insert_Input = {
  accepted?: Maybe<Scalars['Boolean']>;
  accepted_on?: Maybe<Scalars['timestamptz']>;
  budget?: Maybe<Scalars['numeric']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  check_geo?: Maybe<Scalars['Boolean']>;
  checkin_status?: Maybe<Scalars['String']>;
  checkin_time?: Maybe<Scalars['timestamptz']>;
  checkout_status?: Maybe<Scalars['String']>;
  checkout_time?: Maybe<Scalars['timestamptz']>;
  completed?: Maybe<Scalars['Boolean']>;
  confirmed_hours?: Maybe<Scalars['numeric']>;
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  contractor_ratings?: Maybe<Contractor_Rating_Arr_Rel_Insert_Input>;
  contractor_staff_notes?: Maybe<Contractor_Staff_Note_Arr_Rel_Insert_Input>;
  contractor_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  currency?: Maybe<Scalars['currency']>;
  custom_requests?: Maybe<Custom_Request_Arr_Rel_Insert_Input>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Arr_Rel_Insert_Input>;
  deleted?: Maybe<Scalars['Boolean']>;
  disable_time_alerts?: Maybe<Scalars['Boolean']>;
  drafted?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  extra_notes?: Maybe<Scalars['String']>;
  extra_notes_created_at?: Maybe<Scalars['timestamptz']>;
  extra_notes_updated_at?: Maybe<Scalars['timestamptz']>;
  fallback_num?: Maybe<Scalars['String']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  final_report_confirmed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  is_empty_visit_notify?: Maybe<Scalars['Boolean']>;
  last_email_alert_at?: Maybe<Scalars['timestamptz']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  note?: Maybe<Scalars['String']>;
  note_updated_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_activity_notes?: Maybe<Project_Activity_Note_Arr_Rel_Insert_Input>;
  project_activity_request_more_hours?: Maybe<Project_Activity_Request_More_Hours_Arr_Rel_Insert_Input>;
  project_activity_skills?: Maybe<Project_Activity_Skill_Arr_Rel_Insert_Input>;
  project_activity_soft_skills?: Maybe<Project_Activity_Soft_Skill_Arr_Rel_Insert_Input>;
  project_activity_tags?: Maybe<Project_Activity_Tag_Arr_Rel_Insert_Input>;
  project_activity_times?: Maybe<Project_Activity_Time_Arr_Rel_Insert_Input>;
  project_activity_tracked_times?: Maybe<Project_Activity_Tracked_Time_Arr_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  rejected?: Maybe<Scalars['Boolean']>;
  requested_hours?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type_of_visit?: Maybe<Type_Of_Visit_Enum>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  virtual?: Maybe<Scalars['Boolean']>;
  virtual_meeting_link?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Activity_Max_Fields = {
  __typename?: 'project_activity_max_fields';
  accepted_on?: Maybe<Scalars['timestamptz']>;
  budget?: Maybe<Scalars['numeric']>;
  checkin_status?: Maybe<Scalars['String']>;
  checkin_time?: Maybe<Scalars['timestamptz']>;
  checkout_status?: Maybe<Scalars['String']>;
  checkout_time?: Maybe<Scalars['timestamptz']>;
  confirmed_hours?: Maybe<Scalars['numeric']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  contractor_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  currency?: Maybe<Scalars['currency']>;
  end_date?: Maybe<Scalars['date']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  extra_notes?: Maybe<Scalars['String']>;
  extra_notes_created_at?: Maybe<Scalars['timestamptz']>;
  extra_notes_updated_at?: Maybe<Scalars['timestamptz']>;
  fallback_num?: Maybe<Scalars['String']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  last_email_alert_at?: Maybe<Scalars['timestamptz']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  note?: Maybe<Scalars['String']>;
  note_updated_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  requested_hours?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  virtual_meeting_link?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_activity" */
export type Project_Activity_Max_Order_By = {
  accepted_on?: Maybe<Order_By>;
  budget?: Maybe<Order_By>;
  checkin_status?: Maybe<Order_By>;
  checkin_time?: Maybe<Order_By>;
  checkout_status?: Maybe<Order_By>;
  checkout_time?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  contractor_updated_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  extra_notes?: Maybe<Order_By>;
  extra_notes_created_at?: Maybe<Order_By>;
  extra_notes_updated_at?: Maybe<Order_By>;
  fallback_num?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_id?: Maybe<Order_By>;
  last_email_alert_at?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  note_updated_at?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  virtual_meeting_link?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Min_Fields = {
  __typename?: 'project_activity_min_fields';
  accepted_on?: Maybe<Scalars['timestamptz']>;
  budget?: Maybe<Scalars['numeric']>;
  checkin_status?: Maybe<Scalars['String']>;
  checkin_time?: Maybe<Scalars['timestamptz']>;
  checkout_status?: Maybe<Scalars['String']>;
  checkout_time?: Maybe<Scalars['timestamptz']>;
  confirmed_hours?: Maybe<Scalars['numeric']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  contractor_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  currency?: Maybe<Scalars['currency']>;
  end_date?: Maybe<Scalars['date']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  extra_notes?: Maybe<Scalars['String']>;
  extra_notes_created_at?: Maybe<Scalars['timestamptz']>;
  extra_notes_updated_at?: Maybe<Scalars['timestamptz']>;
  fallback_num?: Maybe<Scalars['String']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  last_email_alert_at?: Maybe<Scalars['timestamptz']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  note?: Maybe<Scalars['String']>;
  note_updated_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  requested_hours?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  virtual_meeting_link?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_activity" */
export type Project_Activity_Min_Order_By = {
  accepted_on?: Maybe<Order_By>;
  budget?: Maybe<Order_By>;
  checkin_status?: Maybe<Order_By>;
  checkin_time?: Maybe<Order_By>;
  checkout_status?: Maybe<Order_By>;
  checkout_time?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  contractor_updated_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  extra_notes?: Maybe<Order_By>;
  extra_notes_created_at?: Maybe<Order_By>;
  extra_notes_updated_at?: Maybe<Order_By>;
  fallback_num?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_id?: Maybe<Order_By>;
  last_email_alert_at?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  note_updated_at?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  virtual_meeting_link?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity" */
export type Project_Activity_Mutation_Response = {
  __typename?: 'project_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity>;
};

/** columns and relationships of "project_activity_note" */
export type Project_Activity_Note = {
  __typename?: 'project_activity_note';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  project_activity_id: Scalars['uuid'];
  text: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "project_activity_note" */
export type Project_Activity_Note_Aggregate = {
  __typename?: 'project_activity_note_aggregate';
  aggregate?: Maybe<Project_Activity_Note_Aggregate_Fields>;
  nodes: Array<Project_Activity_Note>;
};

export type Project_Activity_Note_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Activity_Note_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Note_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity_note" */
export type Project_Activity_Note_Aggregate_Fields = {
  __typename?: 'project_activity_note_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Note_Max_Fields>;
  min?: Maybe<Project_Activity_Note_Min_Fields>;
};


/** aggregate fields of "project_activity_note" */
export type Project_Activity_Note_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity_note" */
export type Project_Activity_Note_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Note_Max_Order_By>;
  min?: Maybe<Project_Activity_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity_note" */
export type Project_Activity_Note_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_activity_note". All fields are combined with a logical 'AND'. */
export type Project_Activity_Note_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Note_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Note_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Note_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  project_activity_id?: Maybe<Uuid_Comparison_Exp>;
  text?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity_note" */
export enum Project_Activity_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivityNotePkey = 'project_activity_note_pkey'
}

/** input type for inserting data into table "project_activity_note" */
export type Project_Activity_Note_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Activity_Note_Max_Fields = {
  __typename?: 'project_activity_note_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_activity_note" */
export type Project_Activity_Note_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Note_Min_Fields = {
  __typename?: 'project_activity_note_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_activity_note" */
export type Project_Activity_Note_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity_note" */
export type Project_Activity_Note_Mutation_Response = {
  __typename?: 'project_activity_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity_Note>;
};

/** on_conflict condition type for table "project_activity_note" */
export type Project_Activity_Note_On_Conflict = {
  constraint: Project_Activity_Note_Constraint;
  update_columns?: Array<Project_Activity_Note_Update_Column>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity_note". */
export type Project_Activity_Note_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  text?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity_note */
export type Project_Activity_Note_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_activity_note" */
export enum Project_Activity_Note_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_activity_note" */
export type Project_Activity_Note_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "project_activity_note" */
export type Project_Activity_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Note_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "project_activity_note" */
export enum Project_Activity_Note_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Activity_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Note_Bool_Exp;
};

/** input type for inserting object relation for remote table "project_activity" */
export type Project_Activity_Obj_Rel_Insert_Input = {
  data: Project_Activity_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_On_Conflict>;
};

/** on_conflict condition type for table "project_activity" */
export type Project_Activity_On_Conflict = {
  constraint: Project_Activity_Constraint;
  update_columns?: Array<Project_Activity_Update_Column>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity". */
export type Project_Activity_Order_By = {
  accepted?: Maybe<Order_By>;
  accepted_on?: Maybe<Order_By>;
  budget?: Maybe<Order_By>;
  cancelled?: Maybe<Order_By>;
  check_geo?: Maybe<Order_By>;
  checkin_status?: Maybe<Order_By>;
  checkin_time?: Maybe<Order_By>;
  checkout_status?: Maybe<Order_By>;
  checkout_time?: Maybe<Order_By>;
  completed?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  contractor_ratings_aggregate?: Maybe<Contractor_Rating_Aggregate_Order_By>;
  contractor_staff_notes_aggregate?: Maybe<Contractor_Staff_Note_Aggregate_Order_By>;
  contractor_updated_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Order_By>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Order_By>;
  deleted?: Maybe<Order_By>;
  disable_time_alerts?: Maybe<Order_By>;
  drafted?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  extra_notes?: Maybe<Order_By>;
  extra_notes_created_at?: Maybe<Order_By>;
  extra_notes_updated_at?: Maybe<Order_By>;
  fallback_num?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  final_report_confirmed?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_id?: Maybe<Order_By>;
  is_empty_visit_notify?: Maybe<Order_By>;
  last_email_alert_at?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  note_updated_at?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_activity_notes_aggregate?: Maybe<Project_Activity_Note_Aggregate_Order_By>;
  project_activity_request_more_hours_aggregate?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Order_By>;
  project_activity_skills_aggregate?: Maybe<Project_Activity_Skill_Aggregate_Order_By>;
  project_activity_soft_skills_aggregate?: Maybe<Project_Activity_Soft_Skill_Aggregate_Order_By>;
  project_activity_tags_aggregate?: Maybe<Project_Activity_Tag_Aggregate_Order_By>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Order_By>;
  project_activity_tracked_times_aggregate?: Maybe<Project_Activity_Tracked_Time_Aggregate_Order_By>;
  project_id?: Maybe<Order_By>;
  rejected?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  timezone?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type_of_visit?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  virtual?: Maybe<Order_By>;
  virtual_meeting_link?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity */
export type Project_Activity_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** Track contractors' requests for more hours than given to task by creator */
export type Project_Activity_Request_More_Hours = {
  __typename?: 'project_activity_request_more_hours';
  /** Activity for which more hours are being requested for */
  activity_id: Scalars['uuid'];
  /** An object relationship */
  actor?: Maybe<User>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Scalars['uuid']>;
  /** Date of creating request */
  created_at: Scalars['date'];
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Scalars['String']>;
  /** The more hours being requested */
  hours: Scalars['numeric'];
  id: Scalars['uuid'];
  /** An object relationship */
  project_activity: Project_Activity;
  /** Reason for requesting more hours */
  reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  requester: User;
  /** Contractor requesting more hours for task */
  requester_id: Scalars['uuid'];
  /** Action taken or status applied by actor to request */
  status: Scalars['String'];
  /** Date of acting on the request */
  updated_at: Scalars['date'];
};

/** aggregated selection of "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Aggregate = {
  __typename?: 'project_activity_request_more_hours_aggregate';
  aggregate?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Fields>;
  nodes: Array<Project_Activity_Request_More_Hours>;
};

export type Project_Activity_Request_More_Hours_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Request_More_Hours_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Aggregate_Fields = {
  __typename?: 'project_activity_request_more_hours_aggregate_fields';
  avg?: Maybe<Project_Activity_Request_More_Hours_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Request_More_Hours_Max_Fields>;
  min?: Maybe<Project_Activity_Request_More_Hours_Min_Fields>;
  stddev?: Maybe<Project_Activity_Request_More_Hours_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Activity_Request_More_Hours_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Activity_Request_More_Hours_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Activity_Request_More_Hours_Sum_Fields>;
  var_pop?: Maybe<Project_Activity_Request_More_Hours_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Activity_Request_More_Hours_Var_Samp_Fields>;
  variance?: Maybe<Project_Activity_Request_More_Hours_Variance_Fields>;
};


/** aggregate fields of "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Aggregate_Order_By = {
  avg?: Maybe<Project_Activity_Request_More_Hours_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Request_More_Hours_Max_Order_By>;
  min?: Maybe<Project_Activity_Request_More_Hours_Min_Order_By>;
  stddev?: Maybe<Project_Activity_Request_More_Hours_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Activity_Request_More_Hours_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Activity_Request_More_Hours_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Activity_Request_More_Hours_Sum_Order_By>;
  var_pop?: Maybe<Project_Activity_Request_More_Hours_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Activity_Request_More_Hours_Var_Samp_Order_By>;
  variance?: Maybe<Project_Activity_Request_More_Hours_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Request_More_Hours_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Request_More_Hours_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Activity_Request_More_Hours_Avg_Fields = {
  __typename?: 'project_activity_request_more_hours_avg_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Avg_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_activity_request_more_hours". All fields are combined with a logical 'AND'. */
export type Project_Activity_Request_More_Hours_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Request_More_Hours_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Request_More_Hours_Bool_Exp>>;
  activity_id?: Maybe<Uuid_Comparison_Exp>;
  actor?: Maybe<User_Bool_Exp>;
  actor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Date_Comparison_Exp>;
  decline_reason?: Maybe<String_Comparison_Exp>;
  hours?: Maybe<Numeric_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  reason?: Maybe<String_Comparison_Exp>;
  requester?: Maybe<User_Bool_Exp>;
  requester_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity_request_more_hours" */
export enum Project_Activity_Request_More_Hours_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivityRequestMoreHoursPkey = 'project_activity_request_more_hours_pkey'
}

/** input type for incrementing numeric columns in table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Inc_Input = {
  /** The more hours being requested */
  hours?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Insert_Input = {
  /** Activity for which more hours are being requested for */
  activity_id?: Maybe<Scalars['uuid']>;
  actor?: Maybe<User_Obj_Rel_Insert_Input>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Scalars['uuid']>;
  /** Date of creating request */
  created_at?: Maybe<Scalars['date']>;
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Scalars['String']>;
  /** The more hours being requested */
  hours?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  /** Reason for requesting more hours */
  reason?: Maybe<Scalars['String']>;
  requester?: Maybe<User_Obj_Rel_Insert_Input>;
  /** Contractor requesting more hours for task */
  requester_id?: Maybe<Scalars['uuid']>;
  /** Action taken or status applied by actor to request */
  status?: Maybe<Scalars['String']>;
  /** Date of acting on the request */
  updated_at?: Maybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Project_Activity_Request_More_Hours_Max_Fields = {
  __typename?: 'project_activity_request_more_hours_max_fields';
  /** Activity for which more hours are being requested for */
  activity_id?: Maybe<Scalars['uuid']>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Scalars['uuid']>;
  /** Date of creating request */
  created_at?: Maybe<Scalars['date']>;
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Scalars['String']>;
  /** The more hours being requested */
  hours?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** Reason for requesting more hours */
  reason?: Maybe<Scalars['String']>;
  /** Contractor requesting more hours for task */
  requester_id?: Maybe<Scalars['uuid']>;
  /** Action taken or status applied by actor to request */
  status?: Maybe<Scalars['String']>;
  /** Date of acting on the request */
  updated_at?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Max_Order_By = {
  /** Activity for which more hours are being requested for */
  activity_id?: Maybe<Order_By>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Order_By>;
  /** Date of creating request */
  created_at?: Maybe<Order_By>;
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Order_By>;
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  /** Reason for requesting more hours */
  reason?: Maybe<Order_By>;
  /** Contractor requesting more hours for task */
  requester_id?: Maybe<Order_By>;
  /** Action taken or status applied by actor to request */
  status?: Maybe<Order_By>;
  /** Date of acting on the request */
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Request_More_Hours_Min_Fields = {
  __typename?: 'project_activity_request_more_hours_min_fields';
  /** Activity for which more hours are being requested for */
  activity_id?: Maybe<Scalars['uuid']>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Scalars['uuid']>;
  /** Date of creating request */
  created_at?: Maybe<Scalars['date']>;
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Scalars['String']>;
  /** The more hours being requested */
  hours?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** Reason for requesting more hours */
  reason?: Maybe<Scalars['String']>;
  /** Contractor requesting more hours for task */
  requester_id?: Maybe<Scalars['uuid']>;
  /** Action taken or status applied by actor to request */
  status?: Maybe<Scalars['String']>;
  /** Date of acting on the request */
  updated_at?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Min_Order_By = {
  /** Activity for which more hours are being requested for */
  activity_id?: Maybe<Order_By>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Order_By>;
  /** Date of creating request */
  created_at?: Maybe<Order_By>;
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Order_By>;
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  /** Reason for requesting more hours */
  reason?: Maybe<Order_By>;
  /** Contractor requesting more hours for task */
  requester_id?: Maybe<Order_By>;
  /** Action taken or status applied by actor to request */
  status?: Maybe<Order_By>;
  /** Date of acting on the request */
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Mutation_Response = {
  __typename?: 'project_activity_request_more_hours_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity_Request_More_Hours>;
};

/** on_conflict condition type for table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_On_Conflict = {
  constraint: Project_Activity_Request_More_Hours_Constraint;
  update_columns?: Array<Project_Activity_Request_More_Hours_Update_Column>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity_request_more_hours". */
export type Project_Activity_Request_More_Hours_Order_By = {
  activity_id?: Maybe<Order_By>;
  actor?: Maybe<User_Order_By>;
  actor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  decline_reason?: Maybe<Order_By>;
  hours?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  reason?: Maybe<Order_By>;
  requester?: Maybe<User_Order_By>;
  requester_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity_request_more_hours */
export type Project_Activity_Request_More_Hours_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_activity_request_more_hours" */
export enum Project_Activity_Request_More_Hours_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActorId = 'actor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeclineReason = 'decline_reason',
  /** column name */
  Hours = 'hours',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequesterId = 'requester_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Set_Input = {
  /** Activity for which more hours are being requested for */
  activity_id?: Maybe<Scalars['uuid']>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Scalars['uuid']>;
  /** Date of creating request */
  created_at?: Maybe<Scalars['date']>;
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Scalars['String']>;
  /** The more hours being requested */
  hours?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** Reason for requesting more hours */
  reason?: Maybe<Scalars['String']>;
  /** Contractor requesting more hours for task */
  requester_id?: Maybe<Scalars['uuid']>;
  /** Action taken or status applied by actor to request */
  status?: Maybe<Scalars['String']>;
  /** Date of acting on the request */
  updated_at?: Maybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Project_Activity_Request_More_Hours_Stddev_Fields = {
  __typename?: 'project_activity_request_more_hours_stddev_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Stddev_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Activity_Request_More_Hours_Stddev_Pop_Fields = {
  __typename?: 'project_activity_request_more_hours_stddev_pop_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Stddev_Pop_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Activity_Request_More_Hours_Stddev_Samp_Fields = {
  __typename?: 'project_activity_request_more_hours_stddev_samp_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Stddev_Samp_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Request_More_Hours_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Request_More_Hours_Stream_Cursor_Value_Input = {
  /** Activity for which more hours are being requested for */
  activity_id?: Maybe<Scalars['uuid']>;
  /** Management person who acted on the request */
  actor_id?: Maybe<Scalars['uuid']>;
  /** Date of creating request */
  created_at?: Maybe<Scalars['date']>;
  /** Reason for actor to decline request */
  decline_reason?: Maybe<Scalars['String']>;
  /** The more hours being requested */
  hours?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  /** Reason for requesting more hours */
  reason?: Maybe<Scalars['String']>;
  /** Contractor requesting more hours for task */
  requester_id?: Maybe<Scalars['uuid']>;
  /** Action taken or status applied by actor to request */
  status?: Maybe<Scalars['String']>;
  /** Date of acting on the request */
  updated_at?: Maybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Project_Activity_Request_More_Hours_Sum_Fields = {
  __typename?: 'project_activity_request_more_hours_sum_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Sum_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** update columns of table "project_activity_request_more_hours" */
export enum Project_Activity_Request_More_Hours_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActorId = 'actor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeclineReason = 'decline_reason',
  /** column name */
  Hours = 'hours',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequesterId = 'requester_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Activity_Request_More_Hours_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Activity_Request_More_Hours_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Request_More_Hours_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Request_More_Hours_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Activity_Request_More_Hours_Var_Pop_Fields = {
  __typename?: 'project_activity_request_more_hours_var_pop_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Var_Pop_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Activity_Request_More_Hours_Var_Samp_Fields = {
  __typename?: 'project_activity_request_more_hours_var_samp_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Var_Samp_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Activity_Request_More_Hours_Variance_Fields = {
  __typename?: 'project_activity_request_more_hours_variance_fields';
  /** The more hours being requested */
  hours?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_activity_request_more_hours" */
export type Project_Activity_Request_More_Hours_Variance_Order_By = {
  /** The more hours being requested */
  hours?: Maybe<Order_By>;
};

/** select columns of table "project_activity" */
export enum Project_Activity_Select_Column {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  AcceptedOn = 'accepted_on',
  /** column name */
  Budget = 'budget',
  /** column name */
  Cancelled = 'cancelled',
  /** column name */
  CheckGeo = 'check_geo',
  /** column name */
  CheckinStatus = 'checkin_status',
  /** column name */
  CheckinTime = 'checkin_time',
  /** column name */
  CheckoutStatus = 'checkout_status',
  /** column name */
  CheckoutTime = 'checkout_time',
  /** column name */
  Completed = 'completed',
  /** column name */
  ConfirmedHours = 'confirmed_hours',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  ContractorUpdatedAt = 'contractor_updated_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DisableTimeAlerts = 'disable_time_alerts',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ExtraNotes = 'extra_notes',
  /** column name */
  ExtraNotesCreatedAt = 'extra_notes_created_at',
  /** column name */
  ExtraNotesUpdatedAt = 'extra_notes_updated_at',
  /** column name */
  FallbackNum = 'fallback_num',
  /** column name */
  FinalCost = 'final_cost',
  /** column name */
  FinalHours = 'final_hours',
  /** column name */
  FinalReportConfirmed = 'final_report_confirmed',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsEmptyVisitNotify = 'is_empty_visit_notify',
  /** column name */
  LastEmailAlertAt = 'last_email_alert_at',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Location = 'location',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Note = 'note',
  /** column name */
  NoteUpdatedAt = 'note_updated_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rejected = 'rejected',
  /** column name */
  RequestedHours = 'requested_hours',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title',
  /** column name */
  TypeOfVisit = 'type_of_visit',
  /** column name */
  Virtual = 'virtual',
  /** column name */
  VirtualMeetingLink = 'virtual_meeting_link'
}

/** select "project_activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_activity" */
export enum Project_Activity_Select_Column_Project_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  Cancelled = 'cancelled',
  /** column name */
  CheckGeo = 'check_geo',
  /** column name */
  Completed = 'completed',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DisableTimeAlerts = 'disable_time_alerts',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  FinalReportConfirmed = 'final_report_confirmed',
  /** column name */
  IsEmptyVisitNotify = 'is_empty_visit_notify',
  /** column name */
  Rejected = 'rejected',
  /** column name */
  Virtual = 'virtual'
}

/** select "project_activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_activity" */
export enum Project_Activity_Select_Column_Project_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  Cancelled = 'cancelled',
  /** column name */
  CheckGeo = 'check_geo',
  /** column name */
  Completed = 'completed',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DisableTimeAlerts = 'disable_time_alerts',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  FinalReportConfirmed = 'final_report_confirmed',
  /** column name */
  IsEmptyVisitNotify = 'is_empty_visit_notify',
  /** column name */
  Rejected = 'rejected',
  /** column name */
  Virtual = 'virtual'
}

/** input type for updating data in table "project_activity" */
export type Project_Activity_Set_Input = {
  accepted?: Maybe<Scalars['Boolean']>;
  accepted_on?: Maybe<Scalars['timestamptz']>;
  budget?: Maybe<Scalars['numeric']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  check_geo?: Maybe<Scalars['Boolean']>;
  checkin_status?: Maybe<Scalars['String']>;
  checkin_time?: Maybe<Scalars['timestamptz']>;
  checkout_status?: Maybe<Scalars['String']>;
  checkout_time?: Maybe<Scalars['timestamptz']>;
  completed?: Maybe<Scalars['Boolean']>;
  confirmed_hours?: Maybe<Scalars['numeric']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  contractor_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  currency?: Maybe<Scalars['currency']>;
  deleted?: Maybe<Scalars['Boolean']>;
  disable_time_alerts?: Maybe<Scalars['Boolean']>;
  drafted?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  extra_notes?: Maybe<Scalars['String']>;
  extra_notes_created_at?: Maybe<Scalars['timestamptz']>;
  extra_notes_updated_at?: Maybe<Scalars['timestamptz']>;
  fallback_num?: Maybe<Scalars['String']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  final_report_confirmed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  is_empty_visit_notify?: Maybe<Scalars['Boolean']>;
  last_email_alert_at?: Maybe<Scalars['timestamptz']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  note?: Maybe<Scalars['String']>;
  note_updated_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  rejected?: Maybe<Scalars['Boolean']>;
  requested_hours?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type_of_visit?: Maybe<Type_Of_Visit_Enum>;
  virtual?: Maybe<Scalars['Boolean']>;
  virtual_meeting_link?: Maybe<Scalars['String']>;
};

/** columns and relationships of "project_activity_skill" */
export type Project_Activity_Skill = {
  __typename?: 'project_activity_skill';
  id: Scalars['Int'];
  /** An object relationship */
  project_activity: Project_Activity;
  project_activity_id: Scalars['uuid'];
  /** An object relationship */
  skill: Skill;
  skill_id: Scalars['Int'];
};

/** aggregated selection of "project_activity_skill" */
export type Project_Activity_Skill_Aggregate = {
  __typename?: 'project_activity_skill_aggregate';
  aggregate?: Maybe<Project_Activity_Skill_Aggregate_Fields>;
  nodes: Array<Project_Activity_Skill>;
};

export type Project_Activity_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Activity_Skill_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity_skill" */
export type Project_Activity_Skill_Aggregate_Fields = {
  __typename?: 'project_activity_skill_aggregate_fields';
  avg?: Maybe<Project_Activity_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Skill_Max_Fields>;
  min?: Maybe<Project_Activity_Skill_Min_Fields>;
  stddev?: Maybe<Project_Activity_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Activity_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Activity_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Activity_Skill_Sum_Fields>;
  var_pop?: Maybe<Project_Activity_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Activity_Skill_Var_Samp_Fields>;
  variance?: Maybe<Project_Activity_Skill_Variance_Fields>;
};


/** aggregate fields of "project_activity_skill" */
export type Project_Activity_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity_skill" */
export type Project_Activity_Skill_Aggregate_Order_By = {
  avg?: Maybe<Project_Activity_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Skill_Max_Order_By>;
  min?: Maybe<Project_Activity_Skill_Min_Order_By>;
  stddev?: Maybe<Project_Activity_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Activity_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Activity_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Activity_Skill_Sum_Order_By>;
  var_pop?: Maybe<Project_Activity_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Activity_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Project_Activity_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity_skill" */
export type Project_Activity_Skill_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Activity_Skill_Avg_Fields = {
  __typename?: 'project_activity_skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_activity_skill". All fields are combined with a logical 'AND'. */
export type Project_Activity_Skill_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Skill_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Skill_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Skill_Bool_Exp>>;
  id?: Maybe<Int_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_id?: Maybe<Uuid_Comparison_Exp>;
  skill?: Maybe<Skill_Bool_Exp>;
  skill_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity_skill" */
export enum Project_Activity_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivitySkillPkey = 'project_activity_skill_pkey'
}

/** input type for incrementing numeric columns in table "project_activity_skill" */
export type Project_Activity_Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_activity_skill" */
export type Project_Activity_Skill_Insert_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  skill?: Maybe<Skill_Obj_Rel_Insert_Input>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Project_Activity_Skill_Max_Fields = {
  __typename?: 'project_activity_skill_max_fields';
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Max_Order_By = {
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Skill_Min_Fields = {
  __typename?: 'project_activity_skill_min_fields';
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Min_Order_By = {
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity_skill" */
export type Project_Activity_Skill_Mutation_Response = {
  __typename?: 'project_activity_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity_Skill>;
};

/** on_conflict condition type for table "project_activity_skill" */
export type Project_Activity_Skill_On_Conflict = {
  constraint: Project_Activity_Skill_Constraint;
  update_columns?: Array<Project_Activity_Skill_Update_Column>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity_skill". */
export type Project_Activity_Skill_Order_By = {
  id?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_id?: Maybe<Order_By>;
  skill?: Maybe<Skill_Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity_skill */
export type Project_Activity_Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_activity_skill" */
export enum Project_Activity_Skill_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  SkillId = 'skill_id'
}

/** input type for updating data in table "project_activity_skill" */
export type Project_Activity_Skill_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Project_Activity_Skill_Stddev_Fields = {
  __typename?: 'project_activity_skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Activity_Skill_Stddev_Pop_Fields = {
  __typename?: 'project_activity_skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Activity_Skill_Stddev_Samp_Fields = {
  __typename?: 'project_activity_skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_activity_skill" */
export type Project_Activity_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Skill_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Project_Activity_Skill_Sum_Fields = {
  __typename?: 'project_activity_skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** update columns of table "project_activity_skill" */
export enum Project_Activity_Skill_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  SkillId = 'skill_id'
}

export type Project_Activity_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Activity_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Activity_Skill_Var_Pop_Fields = {
  __typename?: 'project_activity_skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Activity_Skill_Var_Samp_Fields = {
  __typename?: 'project_activity_skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Activity_Skill_Variance_Fields = {
  __typename?: 'project_activity_skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_activity_skill" */
export type Project_Activity_Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** columns and relationships of "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill = {
  __typename?: 'project_activity_soft_skill';
  id: Scalars['Int'];
  /** An object relationship */
  project_activity: Project_Activity;
  project_activity_id: Scalars['uuid'];
  /** An object relationship */
  soft_skill: Soft_Skill;
  soft_skill_id: Scalars['Int'];
};

/** aggregated selection of "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Aggregate = {
  __typename?: 'project_activity_soft_skill_aggregate';
  aggregate?: Maybe<Project_Activity_Soft_Skill_Aggregate_Fields>;
  nodes: Array<Project_Activity_Soft_Skill>;
};

export type Project_Activity_Soft_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Activity_Soft_Skill_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Soft_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Aggregate_Fields = {
  __typename?: 'project_activity_soft_skill_aggregate_fields';
  avg?: Maybe<Project_Activity_Soft_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Soft_Skill_Max_Fields>;
  min?: Maybe<Project_Activity_Soft_Skill_Min_Fields>;
  stddev?: Maybe<Project_Activity_Soft_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Activity_Soft_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Activity_Soft_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Activity_Soft_Skill_Sum_Fields>;
  var_pop?: Maybe<Project_Activity_Soft_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Activity_Soft_Skill_Var_Samp_Fields>;
  variance?: Maybe<Project_Activity_Soft_Skill_Variance_Fields>;
};


/** aggregate fields of "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Aggregate_Order_By = {
  avg?: Maybe<Project_Activity_Soft_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Soft_Skill_Max_Order_By>;
  min?: Maybe<Project_Activity_Soft_Skill_Min_Order_By>;
  stddev?: Maybe<Project_Activity_Soft_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Activity_Soft_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Activity_Soft_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Activity_Soft_Skill_Sum_Order_By>;
  var_pop?: Maybe<Project_Activity_Soft_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Activity_Soft_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Project_Activity_Soft_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Soft_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Soft_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Activity_Soft_Skill_Avg_Fields = {
  __typename?: 'project_activity_soft_skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_activity_soft_skill". All fields are combined with a logical 'AND'. */
export type Project_Activity_Soft_Skill_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Soft_Skill_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Soft_Skill_Bool_Exp>>;
  id?: Maybe<Int_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_id?: Maybe<Uuid_Comparison_Exp>;
  soft_skill?: Maybe<Soft_Skill_Bool_Exp>;
  soft_skill_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity_soft_skill" */
export enum Project_Activity_Soft_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivitySoftSkillPkey = 'project_activity_soft_skill_pkey',
  /** unique or primary key constraint on columns "project_activity_id", "soft_skill_id" */
  ProjectActivitySoftSkillProjectActivityIdSoftSkillKey = 'project_activity_soft_skill_project_activity_id_soft_skill__key'
}

/** input type for incrementing numeric columns in table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Insert_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  soft_skill?: Maybe<Soft_Skill_Obj_Rel_Insert_Input>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Project_Activity_Soft_Skill_Max_Fields = {
  __typename?: 'project_activity_soft_skill_max_fields';
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Max_Order_By = {
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Soft_Skill_Min_Fields = {
  __typename?: 'project_activity_soft_skill_min_fields';
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Min_Order_By = {
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Mutation_Response = {
  __typename?: 'project_activity_soft_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity_Soft_Skill>;
};

/** on_conflict condition type for table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_On_Conflict = {
  constraint: Project_Activity_Soft_Skill_Constraint;
  update_columns?: Array<Project_Activity_Soft_Skill_Update_Column>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity_soft_skill". */
export type Project_Activity_Soft_Skill_Order_By = {
  id?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_id?: Maybe<Order_By>;
  soft_skill?: Maybe<Soft_Skill_Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity_soft_skill */
export type Project_Activity_Soft_Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_activity_soft_skill" */
export enum Project_Activity_Soft_Skill_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  SoftSkillId = 'soft_skill_id'
}

/** input type for updating data in table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Project_Activity_Soft_Skill_Stddev_Fields = {
  __typename?: 'project_activity_soft_skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Activity_Soft_Skill_Stddev_Pop_Fields = {
  __typename?: 'project_activity_soft_skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Activity_Soft_Skill_Stddev_Samp_Fields = {
  __typename?: 'project_activity_soft_skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Soft_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Soft_Skill_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Project_Activity_Soft_Skill_Sum_Fields = {
  __typename?: 'project_activity_soft_skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** update columns of table "project_activity_soft_skill" */
export enum Project_Activity_Soft_Skill_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  SoftSkillId = 'soft_skill_id'
}

export type Project_Activity_Soft_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Activity_Soft_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Soft_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Soft_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Activity_Soft_Skill_Var_Pop_Fields = {
  __typename?: 'project_activity_soft_skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Activity_Soft_Skill_Var_Samp_Fields = {
  __typename?: 'project_activity_soft_skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Activity_Soft_Skill_Variance_Fields = {
  __typename?: 'project_activity_soft_skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_activity_soft_skill" */
export type Project_Activity_Soft_Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev on columns */
export type Project_Activity_Stddev_Fields = {
  __typename?: 'project_activity_stddev_fields';
  budget?: Maybe<Scalars['Float']>;
  confirmed_hours?: Maybe<Scalars['Float']>;
  final_cost?: Maybe<Scalars['Float']>;
  final_hours?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  requested_hours?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_activity" */
export type Project_Activity_Stddev_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Activity_Stddev_Pop_Fields = {
  __typename?: 'project_activity_stddev_pop_fields';
  budget?: Maybe<Scalars['Float']>;
  confirmed_hours?: Maybe<Scalars['Float']>;
  final_cost?: Maybe<Scalars['Float']>;
  final_hours?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  requested_hours?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_activity" */
export type Project_Activity_Stddev_Pop_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Activity_Stddev_Samp_Fields = {
  __typename?: 'project_activity_stddev_samp_fields';
  budget?: Maybe<Scalars['Float']>;
  confirmed_hours?: Maybe<Scalars['Float']>;
  final_cost?: Maybe<Scalars['Float']>;
  final_hours?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  requested_hours?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_activity" */
export type Project_Activity_Stddev_Samp_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_activity" */
export type Project_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Stream_Cursor_Value_Input = {
  accepted?: Maybe<Scalars['Boolean']>;
  accepted_on?: Maybe<Scalars['timestamptz']>;
  budget?: Maybe<Scalars['numeric']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  check_geo?: Maybe<Scalars['Boolean']>;
  checkin_status?: Maybe<Scalars['String']>;
  checkin_time?: Maybe<Scalars['timestamptz']>;
  checkout_status?: Maybe<Scalars['String']>;
  checkout_time?: Maybe<Scalars['timestamptz']>;
  completed?: Maybe<Scalars['Boolean']>;
  confirmed_hours?: Maybe<Scalars['numeric']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  contractor_updated_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  currency?: Maybe<Scalars['currency']>;
  deleted?: Maybe<Scalars['Boolean']>;
  disable_time_alerts?: Maybe<Scalars['Boolean']>;
  drafted?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  extra_notes?: Maybe<Scalars['String']>;
  extra_notes_created_at?: Maybe<Scalars['timestamptz']>;
  extra_notes_updated_at?: Maybe<Scalars['timestamptz']>;
  fallback_num?: Maybe<Scalars['String']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  final_report_confirmed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  is_empty_visit_notify?: Maybe<Scalars['Boolean']>;
  last_email_alert_at?: Maybe<Scalars['timestamptz']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  note?: Maybe<Scalars['String']>;
  note_updated_at?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  rejected?: Maybe<Scalars['Boolean']>;
  requested_hours?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['date']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type_of_visit?: Maybe<Type_Of_Visit_Enum>;
  virtual?: Maybe<Scalars['Boolean']>;
  virtual_meeting_link?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Activity_Sum_Fields = {
  __typename?: 'project_activity_sum_fields';
  budget?: Maybe<Scalars['numeric']>;
  confirmed_hours?: Maybe<Scalars['numeric']>;
  final_cost?: Maybe<Scalars['Int']>;
  final_hours?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  requested_hours?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_activity" */
export type Project_Activity_Sum_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** columns and relationships of "project_activity_tag" */
export type Project_Activity_Tag = {
  __typename?: 'project_activity_tag';
  id: Scalars['Int'];
  /** An object relationship */
  project_activity: Project_Activity;
  project_activity_id: Scalars['uuid'];
  /** An object relationship */
  tag: Tag;
  tag_id: Scalars['uuid'];
};

/** aggregated selection of "project_activity_tag" */
export type Project_Activity_Tag_Aggregate = {
  __typename?: 'project_activity_tag_aggregate';
  aggregate?: Maybe<Project_Activity_Tag_Aggregate_Fields>;
  nodes: Array<Project_Activity_Tag>;
};

export type Project_Activity_Tag_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Activity_Tag_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity_tag" */
export type Project_Activity_Tag_Aggregate_Fields = {
  __typename?: 'project_activity_tag_aggregate_fields';
  avg?: Maybe<Project_Activity_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Tag_Max_Fields>;
  min?: Maybe<Project_Activity_Tag_Min_Fields>;
  stddev?: Maybe<Project_Activity_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Activity_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Activity_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Activity_Tag_Sum_Fields>;
  var_pop?: Maybe<Project_Activity_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Activity_Tag_Var_Samp_Fields>;
  variance?: Maybe<Project_Activity_Tag_Variance_Fields>;
};


/** aggregate fields of "project_activity_tag" */
export type Project_Activity_Tag_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity_tag" */
export type Project_Activity_Tag_Aggregate_Order_By = {
  avg?: Maybe<Project_Activity_Tag_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Tag_Max_Order_By>;
  min?: Maybe<Project_Activity_Tag_Min_Order_By>;
  stddev?: Maybe<Project_Activity_Tag_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Activity_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Activity_Tag_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Activity_Tag_Sum_Order_By>;
  var_pop?: Maybe<Project_Activity_Tag_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Activity_Tag_Var_Samp_Order_By>;
  variance?: Maybe<Project_Activity_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity_tag" */
export type Project_Activity_Tag_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Activity_Tag_Avg_Fields = {
  __typename?: 'project_activity_tag_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_activity_tag". All fields are combined with a logical 'AND'. */
export type Project_Activity_Tag_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Tag_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Tag_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Tag_Bool_Exp>>;
  id?: Maybe<Int_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_id?: Maybe<Uuid_Comparison_Exp>;
  tag?: Maybe<Tag_Bool_Exp>;
  tag_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity_tag" */
export enum Project_Activity_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivityTagPkey = 'project_activity_tag_pkey'
}

/** input type for incrementing numeric columns in table "project_activity_tag" */
export type Project_Activity_Tag_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_activity_tag" */
export type Project_Activity_Tag_Insert_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Tag_Obj_Rel_Insert_Input>;
  tag_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Project_Activity_Tag_Max_Fields = {
  __typename?: 'project_activity_tag_max_fields';
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Max_Order_By = {
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Tag_Min_Fields = {
  __typename?: 'project_activity_tag_min_fields';
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Min_Order_By = {
  id?: Maybe<Order_By>;
  project_activity_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity_tag" */
export type Project_Activity_Tag_Mutation_Response = {
  __typename?: 'project_activity_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity_Tag>;
};

/** on_conflict condition type for table "project_activity_tag" */
export type Project_Activity_Tag_On_Conflict = {
  constraint: Project_Activity_Tag_Constraint;
  update_columns?: Array<Project_Activity_Tag_Update_Column>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity_tag". */
export type Project_Activity_Tag_Order_By = {
  id?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_id?: Maybe<Order_By>;
  tag?: Maybe<Tag_Order_By>;
  tag_id?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity_tag */
export type Project_Activity_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_activity_tag" */
export enum Project_Activity_Tag_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  TagId = 'tag_id'
}

/** input type for updating data in table "project_activity_tag" */
export type Project_Activity_Tag_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Project_Activity_Tag_Stddev_Fields = {
  __typename?: 'project_activity_tag_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Activity_Tag_Stddev_Pop_Fields = {
  __typename?: 'project_activity_tag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Activity_Tag_Stddev_Samp_Fields = {
  __typename?: 'project_activity_tag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_activity_tag" */
export type Project_Activity_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Tag_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['Int']>;
  project_activity_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Project_Activity_Tag_Sum_Fields = {
  __typename?: 'project_activity_tag_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "project_activity_tag" */
export enum Project_Activity_Tag_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProjectActivityId = 'project_activity_id',
  /** column name */
  TagId = 'tag_id'
}

export type Project_Activity_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Activity_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Activity_Tag_Var_Pop_Fields = {
  __typename?: 'project_activity_tag_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Activity_Tag_Var_Samp_Fields = {
  __typename?: 'project_activity_tag_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Activity_Tag_Variance_Fields = {
  __typename?: 'project_activity_tag_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_activity_tag" */
export type Project_Activity_Tag_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "project_activity_time" */
export type Project_Activity_Time = {
  __typename?: 'project_activity_time';
  activity_id: Scalars['uuid'];
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  end_time?: Maybe<Scalars['time']>;
  id: Scalars['uuid'];
  invoice_id?: Maybe<Scalars['uuid']>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  project_activity: Project_Activity;
  /** An array relationship */
  project_activity_tracked_times: Array<Project_Activity_Tracked_Time>;
  /** An aggregate relationship */
  project_activity_tracked_times_aggregate: Project_Activity_Tracked_Time_Aggregate;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['time']>;
  status: Scalars['String'];
  /** Time during which contractor's work was being tracked (in seconds) */
  time: Scalars['numeric'];
  /** An object relationship */
  timesheet?: Maybe<Timesheet>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  /** Day that the contractor reportedly worked */
  tracked_date: Scalars['date'];
};


/** columns and relationships of "project_activity_time" */
export type Project_Activity_TimeProject_Activity_Tracked_TimesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


/** columns and relationships of "project_activity_time" */
export type Project_Activity_TimeProject_Activity_Tracked_Times_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};

/** aggregated selection of "project_activity_time" */
export type Project_Activity_Time_Aggregate = {
  __typename?: 'project_activity_time_aggregate';
  aggregate?: Maybe<Project_Activity_Time_Aggregate_Fields>;
  nodes: Array<Project_Activity_Time>;
};

export type Project_Activity_Time_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Activity_Time_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Time_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Time_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity_time" */
export type Project_Activity_Time_Aggregate_Fields = {
  __typename?: 'project_activity_time_aggregate_fields';
  avg?: Maybe<Project_Activity_Time_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Time_Max_Fields>;
  min?: Maybe<Project_Activity_Time_Min_Fields>;
  stddev?: Maybe<Project_Activity_Time_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Activity_Time_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Activity_Time_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Activity_Time_Sum_Fields>;
  var_pop?: Maybe<Project_Activity_Time_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Activity_Time_Var_Samp_Fields>;
  variance?: Maybe<Project_Activity_Time_Variance_Fields>;
};


/** aggregate fields of "project_activity_time" */
export type Project_Activity_Time_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity_time" */
export type Project_Activity_Time_Aggregate_Order_By = {
  avg?: Maybe<Project_Activity_Time_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Time_Max_Order_By>;
  min?: Maybe<Project_Activity_Time_Min_Order_By>;
  stddev?: Maybe<Project_Activity_Time_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Activity_Time_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Activity_Time_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Activity_Time_Sum_Order_By>;
  var_pop?: Maybe<Project_Activity_Time_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Activity_Time_Var_Samp_Order_By>;
  variance?: Maybe<Project_Activity_Time_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity_time" */
export type Project_Activity_Time_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Time_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Time_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Activity_Time_Avg_Fields = {
  __typename?: 'project_activity_time_avg_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_activity_time" */
export type Project_Activity_Time_Avg_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_activity_time". All fields are combined with a logical 'AND'. */
export type Project_Activity_Time_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Time_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Time_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Time_Bool_Exp>>;
  activity_id?: Maybe<Uuid_Comparison_Exp>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_time?: Maybe<Time_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invoice_id?: Maybe<Uuid_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_tracked_times?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
  project_activity_tracked_times_aggregate?: Maybe<Project_Activity_Tracked_Time_Aggregate_Bool_Exp>;
  reason?: Maybe<String_Comparison_Exp>;
  start_time?: Maybe<Time_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  time?: Maybe<Numeric_Comparison_Exp>;
  timesheet?: Maybe<Timesheet_Bool_Exp>;
  timesheet_id?: Maybe<Uuid_Comparison_Exp>;
  tracked_date?: Maybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity_time" */
export enum Project_Activity_Time_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivityTimePkey = 'project_activity_time_pkey'
}

/** input type for incrementing numeric columns in table "project_activity_time" */
export type Project_Activity_Time_Inc_Input = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "project_activity_time" */
export type Project_Activity_Time_Insert_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['time']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Scalars['String']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_tracked_times?: Maybe<Project_Activity_Tracked_Time_Arr_Rel_Insert_Input>;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['time']>;
  status?: Maybe<Scalars['String']>;
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['numeric']>;
  timesheet?: Maybe<Timesheet_Obj_Rel_Insert_Input>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  /** Day that the contractor reportedly worked */
  tracked_date?: Maybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Project_Activity_Time_Max_Fields = {
  __typename?: 'project_activity_time_max_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Scalars['String']>;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['numeric']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  /** Day that the contractor reportedly worked */
  tracked_date?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "project_activity_time" */
export type Project_Activity_Time_Max_Order_By = {
  activity_id?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_id?: Maybe<Order_By>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Order_By>;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
  timesheet_id?: Maybe<Order_By>;
  /** Day that the contractor reportedly worked */
  tracked_date?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Time_Min_Fields = {
  __typename?: 'project_activity_time_min_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Scalars['String']>;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['numeric']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  /** Day that the contractor reportedly worked */
  tracked_date?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "project_activity_time" */
export type Project_Activity_Time_Min_Order_By = {
  activity_id?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_id?: Maybe<Order_By>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Order_By>;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
  timesheet_id?: Maybe<Order_By>;
  /** Day that the contractor reportedly worked */
  tracked_date?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity_time" */
export type Project_Activity_Time_Mutation_Response = {
  __typename?: 'project_activity_time_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity_Time>;
};

/** input type for inserting object relation for remote table "project_activity_time" */
export type Project_Activity_Time_Obj_Rel_Insert_Input = {
  data: Project_Activity_Time_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Time_On_Conflict>;
};

/** on_conflict condition type for table "project_activity_time" */
export type Project_Activity_Time_On_Conflict = {
  constraint: Project_Activity_Time_Constraint;
  update_columns?: Array<Project_Activity_Time_Update_Column>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity_time". */
export type Project_Activity_Time_Order_By = {
  activity_id?: Maybe<Order_By>;
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invoice_id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_tracked_times_aggregate?: Maybe<Project_Activity_Tracked_Time_Aggregate_Order_By>;
  reason?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  time?: Maybe<Order_By>;
  timesheet?: Maybe<Timesheet_Order_By>;
  timesheet_id?: Maybe<Order_By>;
  tracked_date?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity_time */
export type Project_Activity_Time_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_activity_time" */
export enum Project_Activity_Time_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Reason = 'reason',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  Time = 'time',
  /** column name */
  TimesheetId = 'timesheet_id',
  /** column name */
  TrackedDate = 'tracked_date'
}

/** input type for updating data in table "project_activity_time" */
export type Project_Activity_Time_Set_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['time']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Scalars['String']>;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['time']>;
  status?: Maybe<Scalars['String']>;
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['numeric']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  /** Day that the contractor reportedly worked */
  tracked_date?: Maybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Project_Activity_Time_Stddev_Fields = {
  __typename?: 'project_activity_time_stddev_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_activity_time" */
export type Project_Activity_Time_Stddev_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Activity_Time_Stddev_Pop_Fields = {
  __typename?: 'project_activity_time_stddev_pop_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_activity_time" */
export type Project_Activity_Time_Stddev_Pop_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Activity_Time_Stddev_Samp_Fields = {
  __typename?: 'project_activity_time_stddev_samp_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_activity_time" */
export type Project_Activity_Time_Stddev_Samp_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_activity_time" */
export type Project_Activity_Time_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Time_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Time_Stream_Cursor_Value_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['time']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_id?: Maybe<Scalars['uuid']>;
  /** Notes from the contractor about what they were doing during recorded time */
  notes?: Maybe<Scalars['String']>;
  /** Reason given by management for their actions on time record */
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['time']>;
  status?: Maybe<Scalars['String']>;
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['numeric']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  /** Day that the contractor reportedly worked */
  tracked_date?: Maybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Project_Activity_Time_Sum_Fields = {
  __typename?: 'project_activity_time_sum_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "project_activity_time" */
export type Project_Activity_Time_Sum_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** update columns of table "project_activity_time" */
export enum Project_Activity_Time_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Reason = 'reason',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  Time = 'time',
  /** column name */
  TimesheetId = 'timesheet_id',
  /** column name */
  TrackedDate = 'tracked_date'
}

export type Project_Activity_Time_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Activity_Time_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Time_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Time_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Activity_Time_Var_Pop_Fields = {
  __typename?: 'project_activity_time_var_pop_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_activity_time" */
export type Project_Activity_Time_Var_Pop_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Activity_Time_Var_Samp_Fields = {
  __typename?: 'project_activity_time_var_samp_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_activity_time" */
export type Project_Activity_Time_Var_Samp_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Activity_Time_Variance_Fields = {
  __typename?: 'project_activity_time_variance_fields';
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_activity_time" */
export type Project_Activity_Time_Variance_Order_By = {
  /** Time during which contractor's work was being tracked (in seconds) */
  time?: Maybe<Order_By>;
};

/** columns and relationships of "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time = {
  __typename?: 'project_activity_tracked_time';
  activity_id: Scalars['uuid'];
  activity_time_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id: Scalars['uuid'];
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  project_activity: Project_Activity;
  /** An object relationship */
  project_activity_time?: Maybe<Project_Activity_Time>;
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Float']>;
  /** An object relationship */
  timesheet?: Maybe<Timesheet>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Aggregate = {
  __typename?: 'project_activity_tracked_time_aggregate';
  aggregate?: Maybe<Project_Activity_Tracked_Time_Aggregate_Fields>;
  nodes: Array<Project_Activity_Tracked_Time>;
};

export type Project_Activity_Tracked_Time_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Activity_Tracked_Time_Aggregate_Bool_Exp_Count>;
};

export type Project_Activity_Tracked_Time_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Aggregate_Fields = {
  __typename?: 'project_activity_tracked_time_aggregate_fields';
  avg?: Maybe<Project_Activity_Tracked_Time_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Activity_Tracked_Time_Max_Fields>;
  min?: Maybe<Project_Activity_Tracked_Time_Min_Fields>;
  stddev?: Maybe<Project_Activity_Tracked_Time_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Activity_Tracked_Time_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Activity_Tracked_Time_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Activity_Tracked_Time_Sum_Fields>;
  var_pop?: Maybe<Project_Activity_Tracked_Time_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Activity_Tracked_Time_Var_Samp_Fields>;
  variance?: Maybe<Project_Activity_Tracked_Time_Variance_Fields>;
};


/** aggregate fields of "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Aggregate_Order_By = {
  avg?: Maybe<Project_Activity_Tracked_Time_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Activity_Tracked_Time_Max_Order_By>;
  min?: Maybe<Project_Activity_Tracked_Time_Min_Order_By>;
  stddev?: Maybe<Project_Activity_Tracked_Time_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Activity_Tracked_Time_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Activity_Tracked_Time_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Activity_Tracked_Time_Sum_Order_By>;
  var_pop?: Maybe<Project_Activity_Tracked_Time_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Activity_Tracked_Time_Var_Samp_Order_By>;
  variance?: Maybe<Project_Activity_Tracked_Time_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Arr_Rel_Insert_Input = {
  data: Array<Project_Activity_Tracked_Time_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Activity_Tracked_Time_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Activity_Tracked_Time_Avg_Fields = {
  __typename?: 'project_activity_tracked_time_avg_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Avg_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_activity_tracked_time". All fields are combined with a logical 'AND'. */
export type Project_Activity_Tracked_Time_Bool_Exp = {
  _and?: Maybe<Array<Project_Activity_Tracked_Time_Bool_Exp>>;
  _not?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
  _or?: Maybe<Array<Project_Activity_Tracked_Time_Bool_Exp>>;
  activity_id?: Maybe<Uuid_Comparison_Exp>;
  activity_time_id?: Maybe<Uuid_Comparison_Exp>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_time?: Maybe<Timetz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_activity_time?: Maybe<Project_Activity_Time_Bool_Exp>;
  reason?: Maybe<String_Comparison_Exp>;
  start_time?: Maybe<Timetz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  time?: Maybe<Float_Comparison_Exp>;
  timesheet?: Maybe<Timesheet_Bool_Exp>;
  timesheet_id?: Maybe<Uuid_Comparison_Exp>;
  tracked_time?: Maybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_activity_tracked_time" */
export enum Project_Activity_Tracked_Time_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectActivityTrackedTimePkey = 'project_activity_tracked_time_pkey'
}

/** input type for incrementing numeric columns in table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Inc_Input = {
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Insert_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  activity_time_id?: Maybe<Scalars['uuid']>;
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_activity_time?: Maybe<Project_Activity_Time_Obj_Rel_Insert_Input>;
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Float']>;
  timesheet?: Maybe<Timesheet_Obj_Rel_Insert_Input>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Project_Activity_Tracked_Time_Max_Fields = {
  __typename?: 'project_activity_tracked_time_max_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  activity_time_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Float']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Max_Order_By = {
  activity_id?: Maybe<Order_By>;
  activity_time_id?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  time?: Maybe<Order_By>;
  timesheet_id?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Activity_Tracked_Time_Min_Fields = {
  __typename?: 'project_activity_tracked_time_min_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  activity_time_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Float']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Min_Order_By = {
  activity_id?: Maybe<Order_By>;
  activity_time_id?: Maybe<Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  reason?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  time?: Maybe<Order_By>;
  timesheet_id?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Mutation_Response = {
  __typename?: 'project_activity_tracked_time_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Activity_Tracked_Time>;
};

/** on_conflict condition type for table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_On_Conflict = {
  constraint: Project_Activity_Tracked_Time_Constraint;
  update_columns?: Array<Project_Activity_Tracked_Time_Update_Column>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};

/** Ordering options when selecting data from "project_activity_tracked_time". */
export type Project_Activity_Tracked_Time_Order_By = {
  activity_id?: Maybe<Order_By>;
  activity_time_id?: Maybe<Order_By>;
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_activity_time?: Maybe<Project_Activity_Time_Order_By>;
  reason?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  time?: Maybe<Order_By>;
  timesheet?: Maybe<Timesheet_Order_By>;
  timesheet_id?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** primary key columns input for table: project_activity_tracked_time */
export type Project_Activity_Tracked_Time_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_activity_tracked_time" */
export enum Project_Activity_Tracked_Time_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActivityTimeId = 'activity_time_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Reason = 'reason',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  Time = 'time',
  /** column name */
  TimesheetId = 'timesheet_id',
  /** column name */
  TrackedTime = 'tracked_time'
}

/** input type for updating data in table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Set_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  activity_time_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Float']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Project_Activity_Tracked_Time_Stddev_Fields = {
  __typename?: 'project_activity_tracked_time_stddev_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Stddev_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Activity_Tracked_Time_Stddev_Pop_Fields = {
  __typename?: 'project_activity_tracked_time_stddev_pop_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Stddev_Pop_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Activity_Tracked_Time_Stddev_Samp_Fields = {
  __typename?: 'project_activity_tracked_time_stddev_samp_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Stddev_Samp_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Activity_Tracked_Time_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Activity_Tracked_Time_Stream_Cursor_Value_Input = {
  activity_id?: Maybe<Scalars['uuid']>;
  activity_time_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['timetz']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Float']>;
  timesheet_id?: Maybe<Scalars['uuid']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Project_Activity_Tracked_Time_Sum_Fields = {
  __typename?: 'project_activity_tracked_time_sum_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Sum_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** update columns of table "project_activity_tracked_time" */
export enum Project_Activity_Tracked_Time_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActivityTimeId = 'activity_time_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  Reason = 'reason',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  Time = 'time',
  /** column name */
  TimesheetId = 'timesheet_id',
  /** column name */
  TrackedTime = 'tracked_time'
}

export type Project_Activity_Tracked_Time_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Activity_Tracked_Time_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Tracked_Time_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Tracked_Time_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Activity_Tracked_Time_Var_Pop_Fields = {
  __typename?: 'project_activity_tracked_time_var_pop_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Var_Pop_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Activity_Tracked_Time_Var_Samp_Fields = {
  __typename?: 'project_activity_tracked_time_var_samp_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Var_Samp_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Activity_Tracked_Time_Variance_Fields = {
  __typename?: 'project_activity_tracked_time_variance_fields';
  time?: Maybe<Scalars['Float']>;
  tracked_time?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_activity_tracked_time" */
export type Project_Activity_Tracked_Time_Variance_Order_By = {
  time?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
};

/** update columns of table "project_activity" */
export enum Project_Activity_Update_Column {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  AcceptedOn = 'accepted_on',
  /** column name */
  Budget = 'budget',
  /** column name */
  Cancelled = 'cancelled',
  /** column name */
  CheckGeo = 'check_geo',
  /** column name */
  CheckinStatus = 'checkin_status',
  /** column name */
  CheckinTime = 'checkin_time',
  /** column name */
  CheckoutStatus = 'checkout_status',
  /** column name */
  CheckoutTime = 'checkout_time',
  /** column name */
  Completed = 'completed',
  /** column name */
  ConfirmedHours = 'confirmed_hours',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  ContractorUpdatedAt = 'contractor_updated_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DisableTimeAlerts = 'disable_time_alerts',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ExtraNotes = 'extra_notes',
  /** column name */
  ExtraNotesCreatedAt = 'extra_notes_created_at',
  /** column name */
  ExtraNotesUpdatedAt = 'extra_notes_updated_at',
  /** column name */
  FallbackNum = 'fallback_num',
  /** column name */
  FinalCost = 'final_cost',
  /** column name */
  FinalHours = 'final_hours',
  /** column name */
  FinalReportConfirmed = 'final_report_confirmed',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  IsEmptyVisitNotify = 'is_empty_visit_notify',
  /** column name */
  LastEmailAlertAt = 'last_email_alert_at',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Location = 'location',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Note = 'note',
  /** column name */
  NoteUpdatedAt = 'note_updated_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rejected = 'rejected',
  /** column name */
  RequestedHours = 'requested_hours',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title',
  /** column name */
  TypeOfVisit = 'type_of_visit',
  /** column name */
  Virtual = 'virtual',
  /** column name */
  VirtualMeetingLink = 'virtual_meeting_link'
}

export type Project_Activity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Activity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Activity_Var_Pop_Fields = {
  __typename?: 'project_activity_var_pop_fields';
  budget?: Maybe<Scalars['Float']>;
  confirmed_hours?: Maybe<Scalars['Float']>;
  final_cost?: Maybe<Scalars['Float']>;
  final_hours?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  requested_hours?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_activity" */
export type Project_Activity_Var_Pop_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Activity_Var_Samp_Fields = {
  __typename?: 'project_activity_var_samp_fields';
  budget?: Maybe<Scalars['Float']>;
  confirmed_hours?: Maybe<Scalars['Float']>;
  final_cost?: Maybe<Scalars['Float']>;
  final_hours?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  requested_hours?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_activity" */
export type Project_Activity_Var_Samp_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Activity_Variance_Fields = {
  __typename?: 'project_activity_variance_fields';
  budget?: Maybe<Scalars['Float']>;
  confirmed_hours?: Maybe<Scalars['Float']>;
  final_cost?: Maybe<Scalars['Float']>;
  final_hours?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  requested_hours?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_activity" */
export type Project_Activity_Variance_Order_By = {
  budget?: Maybe<Order_By>;
  confirmed_hours?: Maybe<Order_By>;
  final_cost?: Maybe<Order_By>;
  final_hours?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  requested_hours?: Maybe<Order_By>;
};

/** aggregated selection of "project" */
export type Project_Aggregate = {
  __typename?: 'project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

export type Project_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Project_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Project_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Project_Aggregate_Bool_Exp_Count>;
};

export type Project_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project" */
export type Project_Aggregate_Fields = {
  __typename?: 'project_aggregate_fields';
  avg?: Maybe<Project_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
  stddev?: Maybe<Project_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Sum_Fields>;
  var_pop?: Maybe<Project_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Var_Samp_Fields>;
  variance?: Maybe<Project_Variance_Fields>;
};


/** aggregate fields of "project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project" */
export type Project_Aggregate_Order_By = {
  avg?: Maybe<Project_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Max_Order_By>;
  min?: Maybe<Project_Min_Order_By>;
  stddev?: Maybe<Project_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Sum_Order_By>;
  var_pop?: Maybe<Project_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Var_Samp_Order_By>;
  variance?: Maybe<Project_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project" */
export type Project_Arr_Rel_Insert_Input = {
  data: Array<Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Avg_Fields = {
  __typename?: 'project_avg_fields';
  age?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  max_budget?: Maybe<Scalars['Float']>;
  min_budget?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project" */
export type Project_Avg_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  _and?: Maybe<Array<Project_Bool_Exp>>;
  _not?: Maybe<Project_Bool_Exp>;
  _or?: Maybe<Array<Project_Bool_Exp>>;
  access_id?: Maybe<Uuid_Comparison_Exp>;
  access_number?: Maybe<String_Comparison_Exp>;
  access_type?: Maybe<String_Comparison_Exp>;
  access_type_other?: Maybe<String_Comparison_Exp>;
  accessibility_issues?: Maybe<String_Comparison_Exp>;
  active?: Maybe<Boolean_Comparison_Exp>;
  additional_general_notes?: Maybe<String_Comparison_Exp>;
  additional_other_information?: Maybe<String_Comparison_Exp>;
  additional_special_instructions?: Maybe<String_Comparison_Exp>;
  address?: Maybe<String_Comparison_Exp>;
  age?: Maybe<Int_Comparison_Exp>;
  allergies_environmental?: Maybe<String_Array_Comparison_Exp>;
  allergies_food?: Maybe<String_Array_Comparison_Exp>;
  allergies_medication?: Maybe<String_Array_Comparison_Exp>;
  archived?: Maybe<Boolean_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  client_care_plan?: Maybe<Client_Care_Plan_Bool_Exp>;
  client_id?: Maybe<String_Comparison_Exp>;
  client_medications?: Maybe<Client_Medications_Bool_Exp>;
  client_medications_aggregate?: Maybe<Client_Medications_Aggregate_Bool_Exp>;
  client_name?: Maybe<String_Comparison_Exp>;
  cognitive_concerns?: Maybe<String_Comparison_Exp>;
  cognitive_notes?: Maybe<String_Comparison_Exp>;
  cognitive_others?: Maybe<String_Comparison_Exp>;
  communication_ability?: Maybe<String_Comparison_Exp>;
  communication_languages_spoken?: Maybe<String_Array_Comparison_Exp>;
  communication_notes?: Maybe<String_Comparison_Exp>;
  communication_others?: Maybe<String_Comparison_Exp>;
  community_resources?: Maybe<String_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  completed?: Maybe<Boolean_Comparison_Exp>;
  contractor_staff_notes?: Maybe<Contractor_Staff_Note_Bool_Exp>;
  contractor_staff_notes_aggregate?: Maybe<Contractor_Staff_Note_Aggregate_Bool_Exp>;
  contractors?: Maybe<Contractor_Project_Bool_Exp>;
  contractors_aggregate?: Maybe<Contractor_Project_Aggregate_Bool_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<String_Comparison_Exp>;
  cultural_considerations?: Maybe<String_Comparison_Exp>;
  custom_requests?: Maybe<Custom_Request_Bool_Exp>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Bool_Exp>;
  date_completed?: Maybe<Date_Comparison_Exp>;
  date_started?: Maybe<Date_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  desired_outcomes?: Maybe<String_Comparison_Exp>;
  dietary_restrictions?: Maybe<String_Comparison_Exp>;
  dnr_copy_attached?: Maybe<String_Comparison_Exp>;
  dnr_order?: Maybe<String_Comparison_Exp>;
  dob?: Maybe<Timestamptz_Comparison_Exp>;
  drafted?: Maybe<Boolean_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  email_address?: Maybe<String_Comparison_Exp>;
  emergency_additional_notes?: Maybe<String_Comparison_Exp>;
  emergency_contact_name?: Maybe<String_Comparison_Exp>;
  emergency_email?: Maybe<String_Comparison_Exp>;
  emergency_phone_number?: Maybe<String_Comparison_Exp>;
  emergency_relationship?: Maybe<String_Comparison_Exp>;
  emergency_secondary_contact?: Maybe<String_Comparison_Exp>;
  enable_visit_based_clock_ins?: Maybe<Boolean_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  extra_notes?: Maybe<String_Comparison_Exp>;
  family_medical_history?: Maybe<String_Comparison_Exp>;
  family_support?: Maybe<String_Comparison_Exp>;
  firstname?: Maybe<String_Comparison_Exp>;
  frequency?: Maybe<String_Comparison_Exp>;
  gender?: Maybe<String_Comparison_Exp>;
  hobbies?: Maybe<String_Array_Comparison_Exp>;
  home_general_notes?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  immunizations?: Maybe<String_Comparison_Exp>;
  interests?: Maybe<String_Comparison_Exp>;
  interpreter_needed?: Maybe<String_Comparison_Exp>;
  invoices?: Maybe<Invoice_Bool_Exp>;
  invoices_aggregate?: Maybe<Invoice_Aggregate_Bool_Exp>;
  is_clockin?: Maybe<Boolean_Comparison_Exp>;
  lastname?: Maybe<String_Comparison_Exp>;
  latitude?: Maybe<Numeric_Comparison_Exp>;
  location?: Maybe<String_Comparison_Exp>;
  long_term_goals?: Maybe<String_Comparison_Exp>;
  longitude?: Maybe<Numeric_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  max_budget?: Maybe<Int_Comparison_Exp>;
  medical_conditions?: Maybe<String_Comparison_Exp>;
  min_budget?: Maybe<Int_Comparison_Exp>;
  mobility_level?: Maybe<String_Comparison_Exp>;
  mobility_notes?: Maybe<String_Comparison_Exp>;
  mobility_status?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  notify_admin_by_email?: Maybe<Boolean_Comparison_Exp>;
  notify_manager_by_email?: Maybe<Boolean_Comparison_Exp>;
  past_conditions?: Maybe<String_Comparison_Exp>;
  past_surgeries?: Maybe<String_Comparison_Exp>;
  pets?: Maybe<String_Array_Comparison_Exp>;
  phone_number?: Maybe<String_Comparison_Exp>;
  preferred_communication_style?: Maybe<String_Comparison_Exp>;
  preferred_language?: Maybe<String_Comparison_Exp>;
  preferred_name?: Maybe<String_Comparison_Exp>;
  previous_hospitalizations?: Maybe<String_Comparison_Exp>;
  primary_contact_number?: Maybe<String_Comparison_Exp>;
  professional_care_contacts?: Maybe<String_Comparison_Exp>;
  project_activities?: Maybe<Project_Activity_Bool_Exp>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Bool_Exp>;
  project_documents?: Maybe<Document_Project_Bool_Exp>;
  project_documents_aggregate?: Maybe<Document_Project_Aggregate_Bool_Exp>;
  project_skills?: Maybe<Project_Skill_Bool_Exp>;
  project_skills_aggregate?: Maybe<Project_Skill_Aggregate_Bool_Exp>;
  project_soft_skills?: Maybe<Project_Soft_Skill_Bool_Exp>;
  project_soft_skills_aggregate?: Maybe<Project_Soft_Skill_Aggregate_Bool_Exp>;
  project_tags?: Maybe<Project_Tag_Bool_Exp>;
  project_tags_aggregate?: Maybe<Project_Tag_Aggregate_Bool_Exp>;
  reference?: Maybe<String_Comparison_Exp>;
  religious_practices?: Maybe<String_Comparison_Exp>;
  safety_concerns?: Maybe<String_Comparison_Exp>;
  secondar_contact_number?: Maybe<String_Comparison_Exp>;
  self_directed_care_preferences?: Maybe<String_Comparison_Exp>;
  short_term_goals?: Maybe<String_Comparison_Exp>;
  slug?: Maybe<String_Comparison_Exp>;
  smart_home_features?: Maybe<String_Comparison_Exp>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Bool_Exp>;
  social_connections?: Maybe<String_Comparison_Exp>;
  special_instructions?: Maybe<String_Comparison_Exp>;
  specific_care_needs?: Maybe<String_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  support_type?: Maybe<String_Array_Comparison_Exp>;
  tags?: Maybe<String_Array_Comparison_Exp>;
  teams?: Maybe<Team_Project_Bool_Exp>;
  teams_aggregate?: Maybe<Team_Project_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_by?: Maybe<String_Comparison_Exp>;
  visual_communication_style?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project" */
export enum Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectPkey = 'project_pkey',
  /** unique or primary key constraint on columns "slug" */
  ProjectSlugKey = 'project_slug_key'
}

/** input type for incrementing numeric columns in table "project" */
export type Project_Inc_Input = {
  age?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  max_budget?: Maybe<Scalars['Int']>;
  min_budget?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project" */
export type Project_Insert_Input = {
  access_id?: Maybe<Scalars['uuid']>;
  access_number?: Maybe<Scalars['String']>;
  access_type?: Maybe<Scalars['String']>;
  access_type_other?: Maybe<Scalars['String']>;
  accessibility_issues?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  additional_general_notes?: Maybe<Scalars['String']>;
  additional_other_information?: Maybe<Scalars['String']>;
  additional_special_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  allergies_environmental?: Maybe<Array<Scalars['String']>>;
  allergies_food?: Maybe<Array<Scalars['String']>>;
  allergies_medication?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  client_care_plan?: Maybe<Client_Care_Plan_Obj_Rel_Insert_Input>;
  client_id?: Maybe<Scalars['String']>;
  client_medications?: Maybe<Client_Medications_Arr_Rel_Insert_Input>;
  client_name?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  cognitive_others?: Maybe<Scalars['String']>;
  communication_ability?: Maybe<Scalars['String']>;
  communication_languages_spoken?: Maybe<Array<Scalars['String']>>;
  communication_notes?: Maybe<Scalars['String']>;
  communication_others?: Maybe<Scalars['String']>;
  community_resources?: Maybe<Scalars['String']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  completed?: Maybe<Scalars['Boolean']>;
  contractor_staff_notes?: Maybe<Contractor_Staff_Note_Arr_Rel_Insert_Input>;
  contractors?: Maybe<Contractor_Project_Arr_Rel_Insert_Input>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cultural_considerations?: Maybe<Scalars['String']>;
  custom_requests?: Maybe<Custom_Request_Arr_Rel_Insert_Input>;
  date_completed?: Maybe<Scalars['date']>;
  date_started?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  desired_outcomes?: Maybe<Scalars['String']>;
  dietary_restrictions?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  drafted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  emergency_additional_notes?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_email?: Maybe<Scalars['String']>;
  emergency_phone_number?: Maybe<Scalars['String']>;
  emergency_relationship?: Maybe<Scalars['String']>;
  emergency_secondary_contact?: Maybe<Scalars['String']>;
  enable_visit_based_clock_ins?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  extra_notes?: Maybe<Scalars['String']>;
  family_medical_history?: Maybe<Scalars['String']>;
  family_support?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Array<Scalars['String']>>;
  home_general_notes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  immunizations?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['String']>;
  interpreter_needed?: Maybe<Scalars['String']>;
  invoices?: Maybe<Invoice_Arr_Rel_Insert_Input>;
  is_clockin?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  long_term_goals?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_budget?: Maybe<Scalars['Int']>;
  medical_conditions?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['Int']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  mobility_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notify_admin_by_email?: Maybe<Scalars['Boolean']>;
  notify_manager_by_email?: Maybe<Scalars['Boolean']>;
  past_conditions?: Maybe<Scalars['String']>;
  past_surgeries?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Scalars['String']>>;
  phone_number?: Maybe<Scalars['String']>;
  preferred_communication_style?: Maybe<Scalars['String']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  previous_hospitalizations?: Maybe<Scalars['String']>;
  primary_contact_number?: Maybe<Scalars['String']>;
  professional_care_contacts?: Maybe<Scalars['String']>;
  project_activities?: Maybe<Project_Activity_Arr_Rel_Insert_Input>;
  project_documents?: Maybe<Document_Project_Arr_Rel_Insert_Input>;
  project_skills?: Maybe<Project_Skill_Arr_Rel_Insert_Input>;
  project_soft_skills?: Maybe<Project_Soft_Skill_Arr_Rel_Insert_Input>;
  project_tags?: Maybe<Project_Tag_Arr_Rel_Insert_Input>;
  reference?: Maybe<Scalars['String']>;
  religious_practices?: Maybe<Scalars['String']>;
  safety_concerns?: Maybe<Scalars['String']>;
  secondar_contact_number?: Maybe<Scalars['String']>;
  self_directed_care_preferences?: Maybe<Scalars['String']>;
  short_term_goals?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  smart_home_features?: Maybe<Scalars['String']>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Arr_Rel_Insert_Input>;
  social_connections?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  specific_care_needs?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  support_type?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  teams?: Maybe<Team_Project_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  visual_communication_style?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'project_max_fields';
  access_id?: Maybe<Scalars['uuid']>;
  access_number?: Maybe<Scalars['String']>;
  access_type?: Maybe<Scalars['String']>;
  access_type_other?: Maybe<Scalars['String']>;
  accessibility_issues?: Maybe<Scalars['String']>;
  additional_general_notes?: Maybe<Scalars['String']>;
  additional_other_information?: Maybe<Scalars['String']>;
  additional_special_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  allergies_environmental?: Maybe<Array<Scalars['String']>>;
  allergies_food?: Maybe<Array<Scalars['String']>>;
  allergies_medication?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  cognitive_others?: Maybe<Scalars['String']>;
  communication_ability?: Maybe<Scalars['String']>;
  communication_languages_spoken?: Maybe<Array<Scalars['String']>>;
  communication_notes?: Maybe<Scalars['String']>;
  communication_others?: Maybe<Scalars['String']>;
  community_resources?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cultural_considerations?: Maybe<Scalars['String']>;
  date_completed?: Maybe<Scalars['date']>;
  date_started?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  desired_outcomes?: Maybe<Scalars['String']>;
  dietary_restrictions?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  emergency_additional_notes?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_email?: Maybe<Scalars['String']>;
  emergency_phone_number?: Maybe<Scalars['String']>;
  emergency_relationship?: Maybe<Scalars['String']>;
  emergency_secondary_contact?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  extra_notes?: Maybe<Scalars['String']>;
  family_medical_history?: Maybe<Scalars['String']>;
  family_support?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Array<Scalars['String']>>;
  home_general_notes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  immunizations?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['String']>;
  interpreter_needed?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  long_term_goals?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_budget?: Maybe<Scalars['Int']>;
  medical_conditions?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['Int']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  mobility_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  past_conditions?: Maybe<Scalars['String']>;
  past_surgeries?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Scalars['String']>>;
  phone_number?: Maybe<Scalars['String']>;
  preferred_communication_style?: Maybe<Scalars['String']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  previous_hospitalizations?: Maybe<Scalars['String']>;
  primary_contact_number?: Maybe<Scalars['String']>;
  professional_care_contacts?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  religious_practices?: Maybe<Scalars['String']>;
  safety_concerns?: Maybe<Scalars['String']>;
  secondar_contact_number?: Maybe<Scalars['String']>;
  self_directed_care_preferences?: Maybe<Scalars['String']>;
  short_term_goals?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  smart_home_features?: Maybe<Scalars['String']>;
  social_connections?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  specific_care_needs?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  support_type?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  visual_communication_style?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project" */
export type Project_Max_Order_By = {
  access_id?: Maybe<Order_By>;
  access_number?: Maybe<Order_By>;
  access_type?: Maybe<Order_By>;
  access_type_other?: Maybe<Order_By>;
  accessibility_issues?: Maybe<Order_By>;
  additional_general_notes?: Maybe<Order_By>;
  additional_other_information?: Maybe<Order_By>;
  additional_special_instructions?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  age?: Maybe<Order_By>;
  allergies_environmental?: Maybe<Order_By>;
  allergies_food?: Maybe<Order_By>;
  allergies_medication?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  client_id?: Maybe<Order_By>;
  client_name?: Maybe<Order_By>;
  cognitive_concerns?: Maybe<Order_By>;
  cognitive_notes?: Maybe<Order_By>;
  cognitive_others?: Maybe<Order_By>;
  communication_ability?: Maybe<Order_By>;
  communication_languages_spoken?: Maybe<Order_By>;
  communication_notes?: Maybe<Order_By>;
  communication_others?: Maybe<Order_By>;
  community_resources?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  cultural_considerations?: Maybe<Order_By>;
  date_completed?: Maybe<Order_By>;
  date_started?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  desired_outcomes?: Maybe<Order_By>;
  dietary_restrictions?: Maybe<Order_By>;
  dnr_copy_attached?: Maybe<Order_By>;
  dnr_order?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  email_address?: Maybe<Order_By>;
  emergency_additional_notes?: Maybe<Order_By>;
  emergency_contact_name?: Maybe<Order_By>;
  emergency_email?: Maybe<Order_By>;
  emergency_phone_number?: Maybe<Order_By>;
  emergency_relationship?: Maybe<Order_By>;
  emergency_secondary_contact?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  extra_notes?: Maybe<Order_By>;
  family_medical_history?: Maybe<Order_By>;
  family_support?: Maybe<Order_By>;
  firstname?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  hobbies?: Maybe<Order_By>;
  home_general_notes?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  immunizations?: Maybe<Order_By>;
  interests?: Maybe<Order_By>;
  interpreter_needed?: Maybe<Order_By>;
  lastname?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  long_term_goals?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  medical_conditions?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
  mobility_level?: Maybe<Order_By>;
  mobility_notes?: Maybe<Order_By>;
  mobility_status?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  past_conditions?: Maybe<Order_By>;
  past_surgeries?: Maybe<Order_By>;
  pets?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  preferred_communication_style?: Maybe<Order_By>;
  preferred_language?: Maybe<Order_By>;
  preferred_name?: Maybe<Order_By>;
  previous_hospitalizations?: Maybe<Order_By>;
  primary_contact_number?: Maybe<Order_By>;
  professional_care_contacts?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  religious_practices?: Maybe<Order_By>;
  safety_concerns?: Maybe<Order_By>;
  secondar_contact_number?: Maybe<Order_By>;
  self_directed_care_preferences?: Maybe<Order_By>;
  short_term_goals?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  smart_home_features?: Maybe<Order_By>;
  social_connections?: Maybe<Order_By>;
  special_instructions?: Maybe<Order_By>;
  specific_care_needs?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  support_type?: Maybe<Order_By>;
  tags?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  visual_communication_style?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'project_min_fields';
  access_id?: Maybe<Scalars['uuid']>;
  access_number?: Maybe<Scalars['String']>;
  access_type?: Maybe<Scalars['String']>;
  access_type_other?: Maybe<Scalars['String']>;
  accessibility_issues?: Maybe<Scalars['String']>;
  additional_general_notes?: Maybe<Scalars['String']>;
  additional_other_information?: Maybe<Scalars['String']>;
  additional_special_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  allergies_environmental?: Maybe<Array<Scalars['String']>>;
  allergies_food?: Maybe<Array<Scalars['String']>>;
  allergies_medication?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  cognitive_others?: Maybe<Scalars['String']>;
  communication_ability?: Maybe<Scalars['String']>;
  communication_languages_spoken?: Maybe<Array<Scalars['String']>>;
  communication_notes?: Maybe<Scalars['String']>;
  communication_others?: Maybe<Scalars['String']>;
  community_resources?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cultural_considerations?: Maybe<Scalars['String']>;
  date_completed?: Maybe<Scalars['date']>;
  date_started?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  desired_outcomes?: Maybe<Scalars['String']>;
  dietary_restrictions?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  emergency_additional_notes?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_email?: Maybe<Scalars['String']>;
  emergency_phone_number?: Maybe<Scalars['String']>;
  emergency_relationship?: Maybe<Scalars['String']>;
  emergency_secondary_contact?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  extra_notes?: Maybe<Scalars['String']>;
  family_medical_history?: Maybe<Scalars['String']>;
  family_support?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Array<Scalars['String']>>;
  home_general_notes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  immunizations?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['String']>;
  interpreter_needed?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  long_term_goals?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_budget?: Maybe<Scalars['Int']>;
  medical_conditions?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['Int']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  mobility_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  past_conditions?: Maybe<Scalars['String']>;
  past_surgeries?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Scalars['String']>>;
  phone_number?: Maybe<Scalars['String']>;
  preferred_communication_style?: Maybe<Scalars['String']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  previous_hospitalizations?: Maybe<Scalars['String']>;
  primary_contact_number?: Maybe<Scalars['String']>;
  professional_care_contacts?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  religious_practices?: Maybe<Scalars['String']>;
  safety_concerns?: Maybe<Scalars['String']>;
  secondar_contact_number?: Maybe<Scalars['String']>;
  self_directed_care_preferences?: Maybe<Scalars['String']>;
  short_term_goals?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  smart_home_features?: Maybe<Scalars['String']>;
  social_connections?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  specific_care_needs?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  support_type?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  visual_communication_style?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project" */
export type Project_Min_Order_By = {
  access_id?: Maybe<Order_By>;
  access_number?: Maybe<Order_By>;
  access_type?: Maybe<Order_By>;
  access_type_other?: Maybe<Order_By>;
  accessibility_issues?: Maybe<Order_By>;
  additional_general_notes?: Maybe<Order_By>;
  additional_other_information?: Maybe<Order_By>;
  additional_special_instructions?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  age?: Maybe<Order_By>;
  allergies_environmental?: Maybe<Order_By>;
  allergies_food?: Maybe<Order_By>;
  allergies_medication?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  client_id?: Maybe<Order_By>;
  client_name?: Maybe<Order_By>;
  cognitive_concerns?: Maybe<Order_By>;
  cognitive_notes?: Maybe<Order_By>;
  cognitive_others?: Maybe<Order_By>;
  communication_ability?: Maybe<Order_By>;
  communication_languages_spoken?: Maybe<Order_By>;
  communication_notes?: Maybe<Order_By>;
  communication_others?: Maybe<Order_By>;
  community_resources?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  cultural_considerations?: Maybe<Order_By>;
  date_completed?: Maybe<Order_By>;
  date_started?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  desired_outcomes?: Maybe<Order_By>;
  dietary_restrictions?: Maybe<Order_By>;
  dnr_copy_attached?: Maybe<Order_By>;
  dnr_order?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  email_address?: Maybe<Order_By>;
  emergency_additional_notes?: Maybe<Order_By>;
  emergency_contact_name?: Maybe<Order_By>;
  emergency_email?: Maybe<Order_By>;
  emergency_phone_number?: Maybe<Order_By>;
  emergency_relationship?: Maybe<Order_By>;
  emergency_secondary_contact?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  extra_notes?: Maybe<Order_By>;
  family_medical_history?: Maybe<Order_By>;
  family_support?: Maybe<Order_By>;
  firstname?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  hobbies?: Maybe<Order_By>;
  home_general_notes?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  immunizations?: Maybe<Order_By>;
  interests?: Maybe<Order_By>;
  interpreter_needed?: Maybe<Order_By>;
  lastname?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  long_term_goals?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  medical_conditions?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
  mobility_level?: Maybe<Order_By>;
  mobility_notes?: Maybe<Order_By>;
  mobility_status?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  past_conditions?: Maybe<Order_By>;
  past_surgeries?: Maybe<Order_By>;
  pets?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  preferred_communication_style?: Maybe<Order_By>;
  preferred_language?: Maybe<Order_By>;
  preferred_name?: Maybe<Order_By>;
  previous_hospitalizations?: Maybe<Order_By>;
  primary_contact_number?: Maybe<Order_By>;
  professional_care_contacts?: Maybe<Order_By>;
  reference?: Maybe<Order_By>;
  religious_practices?: Maybe<Order_By>;
  safety_concerns?: Maybe<Order_By>;
  secondar_contact_number?: Maybe<Order_By>;
  self_directed_care_preferences?: Maybe<Order_By>;
  short_term_goals?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  smart_home_features?: Maybe<Order_By>;
  social_connections?: Maybe<Order_By>;
  special_instructions?: Maybe<Order_By>;
  specific_care_needs?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  support_type?: Maybe<Order_By>;
  tags?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  visual_communication_style?: Maybe<Order_By>;
};

/** response of any mutation on the table "project" */
export type Project_Mutation_Response = {
  __typename?: 'project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: Maybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "project". */
export type Project_Order_By = {
  access_id?: Maybe<Order_By>;
  access_number?: Maybe<Order_By>;
  access_type?: Maybe<Order_By>;
  access_type_other?: Maybe<Order_By>;
  accessibility_issues?: Maybe<Order_By>;
  active?: Maybe<Order_By>;
  additional_general_notes?: Maybe<Order_By>;
  additional_other_information?: Maybe<Order_By>;
  additional_special_instructions?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  age?: Maybe<Order_By>;
  allergies_environmental?: Maybe<Order_By>;
  allergies_food?: Maybe<Order_By>;
  allergies_medication?: Maybe<Order_By>;
  archived?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  client_care_plan?: Maybe<Client_Care_Plan_Order_By>;
  client_id?: Maybe<Order_By>;
  client_medications_aggregate?: Maybe<Client_Medications_Aggregate_Order_By>;
  client_name?: Maybe<Order_By>;
  cognitive_concerns?: Maybe<Order_By>;
  cognitive_notes?: Maybe<Order_By>;
  cognitive_others?: Maybe<Order_By>;
  communication_ability?: Maybe<Order_By>;
  communication_languages_spoken?: Maybe<Order_By>;
  communication_notes?: Maybe<Order_By>;
  communication_others?: Maybe<Order_By>;
  community_resources?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  completed?: Maybe<Order_By>;
  contractor_staff_notes_aggregate?: Maybe<Contractor_Staff_Note_Aggregate_Order_By>;
  contractors_aggregate?: Maybe<Contractor_Project_Aggregate_Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  cultural_considerations?: Maybe<Order_By>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Order_By>;
  date_completed?: Maybe<Order_By>;
  date_started?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  desired_outcomes?: Maybe<Order_By>;
  dietary_restrictions?: Maybe<Order_By>;
  dnr_copy_attached?: Maybe<Order_By>;
  dnr_order?: Maybe<Order_By>;
  dob?: Maybe<Order_By>;
  drafted?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  email_address?: Maybe<Order_By>;
  emergency_additional_notes?: Maybe<Order_By>;
  emergency_contact_name?: Maybe<Order_By>;
  emergency_email?: Maybe<Order_By>;
  emergency_phone_number?: Maybe<Order_By>;
  emergency_relationship?: Maybe<Order_By>;
  emergency_secondary_contact?: Maybe<Order_By>;
  enable_visit_based_clock_ins?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  extra_notes?: Maybe<Order_By>;
  family_medical_history?: Maybe<Order_By>;
  family_support?: Maybe<Order_By>;
  firstname?: Maybe<Order_By>;
  frequency?: Maybe<Order_By>;
  gender?: Maybe<Order_By>;
  hobbies?: Maybe<Order_By>;
  home_general_notes?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  immunizations?: Maybe<Order_By>;
  interests?: Maybe<Order_By>;
  interpreter_needed?: Maybe<Order_By>;
  invoices_aggregate?: Maybe<Invoice_Aggregate_Order_By>;
  is_clockin?: Maybe<Order_By>;
  lastname?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  long_term_goals?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  medical_conditions?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
  mobility_level?: Maybe<Order_By>;
  mobility_notes?: Maybe<Order_By>;
  mobility_status?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notify_admin_by_email?: Maybe<Order_By>;
  notify_manager_by_email?: Maybe<Order_By>;
  past_conditions?: Maybe<Order_By>;
  past_surgeries?: Maybe<Order_By>;
  pets?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  preferred_communication_style?: Maybe<Order_By>;
  preferred_language?: Maybe<Order_By>;
  preferred_name?: Maybe<Order_By>;
  previous_hospitalizations?: Maybe<Order_By>;
  primary_contact_number?: Maybe<Order_By>;
  professional_care_contacts?: Maybe<Order_By>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Order_By>;
  project_documents_aggregate?: Maybe<Document_Project_Aggregate_Order_By>;
  project_skills_aggregate?: Maybe<Project_Skill_Aggregate_Order_By>;
  project_soft_skills_aggregate?: Maybe<Project_Soft_Skill_Aggregate_Order_By>;
  project_tags_aggregate?: Maybe<Project_Tag_Aggregate_Order_By>;
  reference?: Maybe<Order_By>;
  religious_practices?: Maybe<Order_By>;
  safety_concerns?: Maybe<Order_By>;
  secondar_contact_number?: Maybe<Order_By>;
  self_directed_care_preferences?: Maybe<Order_By>;
  short_term_goals?: Maybe<Order_By>;
  slug?: Maybe<Order_By>;
  smart_home_features?: Maybe<Order_By>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Order_By>;
  social_connections?: Maybe<Order_By>;
  special_instructions?: Maybe<Order_By>;
  specific_care_needs?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  support_type?: Maybe<Order_By>;
  tags?: Maybe<Order_By>;
  teams_aggregate?: Maybe<Team_Project_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  updated_by?: Maybe<Order_By>;
  visual_communication_style?: Maybe<Order_By>;
};

/** primary key columns input for table: project */
export type Project_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project" */
export enum Project_Select_Column {
  /** column name */
  AccessId = 'access_id',
  /** column name */
  AccessNumber = 'access_number',
  /** column name */
  AccessType = 'access_type',
  /** column name */
  AccessTypeOther = 'access_type_other',
  /** column name */
  AccessibilityIssues = 'accessibility_issues',
  /** column name */
  Active = 'active',
  /** column name */
  AdditionalGeneralNotes = 'additional_general_notes',
  /** column name */
  AdditionalOtherInformation = 'additional_other_information',
  /** column name */
  AdditionalSpecialInstructions = 'additional_special_instructions',
  /** column name */
  Address = 'address',
  /** column name */
  Age = 'age',
  /** column name */
  AllergiesEnvironmental = 'allergies_environmental',
  /** column name */
  AllergiesFood = 'allergies_food',
  /** column name */
  AllergiesMedication = 'allergies_medication',
  /** column name */
  Archived = 'archived',
  /** column name */
  City = 'city',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientName = 'client_name',
  /** column name */
  CognitiveConcerns = 'cognitive_concerns',
  /** column name */
  CognitiveNotes = 'cognitive_notes',
  /** column name */
  CognitiveOthers = 'cognitive_others',
  /** column name */
  CommunicationAbility = 'communication_ability',
  /** column name */
  CommunicationLanguagesSpoken = 'communication_languages_spoken',
  /** column name */
  CommunicationNotes = 'communication_notes',
  /** column name */
  CommunicationOthers = 'communication_others',
  /** column name */
  CommunityResources = 'community_resources',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Completed = 'completed',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CulturalConsiderations = 'cultural_considerations',
  /** column name */
  DateCompleted = 'date_completed',
  /** column name */
  DateStarted = 'date_started',
  /** column name */
  Description = 'description',
  /** column name */
  DesiredOutcomes = 'desired_outcomes',
  /** column name */
  DietaryRestrictions = 'dietary_restrictions',
  /** column name */
  DnrCopyAttached = 'dnr_copy_attached',
  /** column name */
  DnrOrder = 'dnr_order',
  /** column name */
  Dob = 'dob',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  Email = 'email',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  EmergencyAdditionalNotes = 'emergency_additional_notes',
  /** column name */
  EmergencyContactName = 'emergency_contact_name',
  /** column name */
  EmergencyEmail = 'emergency_email',
  /** column name */
  EmergencyPhoneNumber = 'emergency_phone_number',
  /** column name */
  EmergencyRelationship = 'emergency_relationship',
  /** column name */
  EmergencySecondaryContact = 'emergency_secondary_contact',
  /** column name */
  EnableVisitBasedClockIns = 'enable_visit_based_clock_ins',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExtraNotes = 'extra_notes',
  /** column name */
  FamilyMedicalHistory = 'family_medical_history',
  /** column name */
  FamilySupport = 'family_support',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Gender = 'gender',
  /** column name */
  Hobbies = 'hobbies',
  /** column name */
  HomeGeneralNotes = 'home_general_notes',
  /** column name */
  Id = 'id',
  /** column name */
  Immunizations = 'immunizations',
  /** column name */
  Interests = 'interests',
  /** column name */
  InterpreterNeeded = 'interpreter_needed',
  /** column name */
  IsClockin = 'is_clockin',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Location = 'location',
  /** column name */
  LongTermGoals = 'long_term_goals',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MedicalConditions = 'medical_conditions',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  MobilityLevel = 'mobility_level',
  /** column name */
  MobilityNotes = 'mobility_notes',
  /** column name */
  MobilityStatus = 'mobility_status',
  /** column name */
  Name = 'name',
  /** column name */
  NotifyAdminByEmail = 'notify_admin_by_email',
  /** column name */
  NotifyManagerByEmail = 'notify_manager_by_email',
  /** column name */
  PastConditions = 'past_conditions',
  /** column name */
  PastSurgeries = 'past_surgeries',
  /** column name */
  Pets = 'pets',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PreferredCommunicationStyle = 'preferred_communication_style',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  PreviousHospitalizations = 'previous_hospitalizations',
  /** column name */
  PrimaryContactNumber = 'primary_contact_number',
  /** column name */
  ProfessionalCareContacts = 'professional_care_contacts',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReligiousPractices = 'religious_practices',
  /** column name */
  SafetyConcerns = 'safety_concerns',
  /** column name */
  SecondarContactNumber = 'secondar_contact_number',
  /** column name */
  SelfDirectedCarePreferences = 'self_directed_care_preferences',
  /** column name */
  ShortTermGoals = 'short_term_goals',
  /** column name */
  Slug = 'slug',
  /** column name */
  SmartHomeFeatures = 'smart_home_features',
  /** column name */
  SocialConnections = 'social_connections',
  /** column name */
  SpecialInstructions = 'special_instructions',
  /** column name */
  SpecificCareNeeds = 'specific_care_needs',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  State = 'state',
  /** column name */
  SupportType = 'support_type',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VisualCommunicationStyle = 'visual_communication_style'
}

/** select "project_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Archived = 'archived',
  /** column name */
  Completed = 'completed',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  EnableVisitBasedClockIns = 'enable_visit_based_clock_ins',
  /** column name */
  IsClockin = 'is_clockin',
  /** column name */
  NotifyAdminByEmail = 'notify_admin_by_email',
  /** column name */
  NotifyManagerByEmail = 'notify_manager_by_email'
}

/** select "project_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project" */
export enum Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Archived = 'archived',
  /** column name */
  Completed = 'completed',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  EnableVisitBasedClockIns = 'enable_visit_based_clock_ins',
  /** column name */
  IsClockin = 'is_clockin',
  /** column name */
  NotifyAdminByEmail = 'notify_admin_by_email',
  /** column name */
  NotifyManagerByEmail = 'notify_manager_by_email'
}

/** input type for updating data in table "project" */
export type Project_Set_Input = {
  access_id?: Maybe<Scalars['uuid']>;
  access_number?: Maybe<Scalars['String']>;
  access_type?: Maybe<Scalars['String']>;
  access_type_other?: Maybe<Scalars['String']>;
  accessibility_issues?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  additional_general_notes?: Maybe<Scalars['String']>;
  additional_other_information?: Maybe<Scalars['String']>;
  additional_special_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  allergies_environmental?: Maybe<Array<Scalars['String']>>;
  allergies_food?: Maybe<Array<Scalars['String']>>;
  allergies_medication?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  cognitive_others?: Maybe<Scalars['String']>;
  communication_ability?: Maybe<Scalars['String']>;
  communication_languages_spoken?: Maybe<Array<Scalars['String']>>;
  communication_notes?: Maybe<Scalars['String']>;
  communication_others?: Maybe<Scalars['String']>;
  community_resources?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  completed?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cultural_considerations?: Maybe<Scalars['String']>;
  date_completed?: Maybe<Scalars['date']>;
  date_started?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  desired_outcomes?: Maybe<Scalars['String']>;
  dietary_restrictions?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  drafted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  emergency_additional_notes?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_email?: Maybe<Scalars['String']>;
  emergency_phone_number?: Maybe<Scalars['String']>;
  emergency_relationship?: Maybe<Scalars['String']>;
  emergency_secondary_contact?: Maybe<Scalars['String']>;
  enable_visit_based_clock_ins?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  extra_notes?: Maybe<Scalars['String']>;
  family_medical_history?: Maybe<Scalars['String']>;
  family_support?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Array<Scalars['String']>>;
  home_general_notes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  immunizations?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['String']>;
  interpreter_needed?: Maybe<Scalars['String']>;
  is_clockin?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  long_term_goals?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_budget?: Maybe<Scalars['Int']>;
  medical_conditions?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['Int']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  mobility_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notify_admin_by_email?: Maybe<Scalars['Boolean']>;
  notify_manager_by_email?: Maybe<Scalars['Boolean']>;
  past_conditions?: Maybe<Scalars['String']>;
  past_surgeries?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Scalars['String']>>;
  phone_number?: Maybe<Scalars['String']>;
  preferred_communication_style?: Maybe<Scalars['String']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  previous_hospitalizations?: Maybe<Scalars['String']>;
  primary_contact_number?: Maybe<Scalars['String']>;
  professional_care_contacts?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  religious_practices?: Maybe<Scalars['String']>;
  safety_concerns?: Maybe<Scalars['String']>;
  secondar_contact_number?: Maybe<Scalars['String']>;
  self_directed_care_preferences?: Maybe<Scalars['String']>;
  short_term_goals?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  smart_home_features?: Maybe<Scalars['String']>;
  social_connections?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  specific_care_needs?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  support_type?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  visual_communication_style?: Maybe<Scalars['String']>;
};

/** columns and relationships of "project_skill" */
export type Project_Skill = {
  __typename?: 'project_skill';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid'];
  /** An object relationship */
  skill: Skill;
  skill_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "project_skill" */
export type Project_Skill_Aggregate = {
  __typename?: 'project_skill_aggregate';
  aggregate?: Maybe<Project_Skill_Aggregate_Fields>;
  nodes: Array<Project_Skill>;
};

export type Project_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Skill_Aggregate_Bool_Exp_Count>;
};

export type Project_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_skill" */
export type Project_Skill_Aggregate_Fields = {
  __typename?: 'project_skill_aggregate_fields';
  avg?: Maybe<Project_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Skill_Max_Fields>;
  min?: Maybe<Project_Skill_Min_Fields>;
  stddev?: Maybe<Project_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Skill_Sum_Fields>;
  var_pop?: Maybe<Project_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Skill_Var_Samp_Fields>;
  variance?: Maybe<Project_Skill_Variance_Fields>;
};


/** aggregate fields of "project_skill" */
export type Project_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_skill" */
export type Project_Skill_Aggregate_Order_By = {
  avg?: Maybe<Project_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Skill_Max_Order_By>;
  min?: Maybe<Project_Skill_Min_Order_By>;
  stddev?: Maybe<Project_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Skill_Sum_Order_By>;
  var_pop?: Maybe<Project_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Project_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_skill" */
export type Project_Skill_Arr_Rel_Insert_Input = {
  data: Array<Project_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Skill_Avg_Fields = {
  __typename?: 'project_skill_avg_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_skill" */
export type Project_Skill_Avg_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_skill". All fields are combined with a logical 'AND'. */
export type Project_Skill_Bool_Exp = {
  _and?: Maybe<Array<Project_Skill_Bool_Exp>>;
  _not?: Maybe<Project_Skill_Bool_Exp>;
  _or?: Maybe<Array<Project_Skill_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  skill?: Maybe<Skill_Bool_Exp>;
  skill_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_skill" */
export enum Project_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectSkillPkey = 'project_skill_pkey'
}

/** input type for incrementing numeric columns in table "project_skill" */
export type Project_Skill_Inc_Input = {
  skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_skill" */
export type Project_Skill_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  skill?: Maybe<Skill_Obj_Rel_Insert_Input>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Skill_Max_Fields = {
  __typename?: 'project_skill_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_skill" */
export type Project_Skill_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Skill_Min_Fields = {
  __typename?: 'project_skill_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_skill" */
export type Project_Skill_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_skill" */
export type Project_Skill_Mutation_Response = {
  __typename?: 'project_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Skill>;
};

/** on_conflict condition type for table "project_skill" */
export type Project_Skill_On_Conflict = {
  constraint: Project_Skill_Constraint;
  update_columns?: Array<Project_Skill_Update_Column>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "project_skill". */
export type Project_Skill_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
  skill?: Maybe<Skill_Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: project_skill */
export type Project_Skill_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_skill" */
export enum Project_Skill_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_skill" */
export type Project_Skill_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Project_Skill_Stddev_Fields = {
  __typename?: 'project_skill_stddev_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_skill" */
export type Project_Skill_Stddev_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Skill_Stddev_Pop_Fields = {
  __typename?: 'project_skill_stddev_pop_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_skill" */
export type Project_Skill_Stddev_Pop_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Skill_Stddev_Samp_Fields = {
  __typename?: 'project_skill_stddev_samp_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_skill" */
export type Project_Skill_Stddev_Samp_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_skill" */
export type Project_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Skill_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Project_Skill_Sum_Fields = {
  __typename?: 'project_skill_sum_fields';
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_skill" */
export type Project_Skill_Sum_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** update columns of table "project_skill" */
export enum Project_Skill_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Skill_Var_Pop_Fields = {
  __typename?: 'project_skill_var_pop_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_skill" */
export type Project_Skill_Var_Pop_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Skill_Var_Samp_Fields = {
  __typename?: 'project_skill_var_samp_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_skill" */
export type Project_Skill_Var_Samp_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Skill_Variance_Fields = {
  __typename?: 'project_skill_variance_fields';
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_skill" */
export type Project_Skill_Variance_Order_By = {
  skill_id?: Maybe<Order_By>;
};

/** columns and relationships of "project_soft_skill" */
export type Project_Soft_Skill = {
  __typename?: 'project_soft_skill';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid'];
  /** An object relationship */
  soft_skill: Soft_Skill;
  soft_skill_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "project_soft_skill" */
export type Project_Soft_Skill_Aggregate = {
  __typename?: 'project_soft_skill_aggregate';
  aggregate?: Maybe<Project_Soft_Skill_Aggregate_Fields>;
  nodes: Array<Project_Soft_Skill>;
};

export type Project_Soft_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Soft_Skill_Aggregate_Bool_Exp_Count>;
};

export type Project_Soft_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Soft_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_soft_skill" */
export type Project_Soft_Skill_Aggregate_Fields = {
  __typename?: 'project_soft_skill_aggregate_fields';
  avg?: Maybe<Project_Soft_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Soft_Skill_Max_Fields>;
  min?: Maybe<Project_Soft_Skill_Min_Fields>;
  stddev?: Maybe<Project_Soft_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Soft_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Soft_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Soft_Skill_Sum_Fields>;
  var_pop?: Maybe<Project_Soft_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Soft_Skill_Var_Samp_Fields>;
  variance?: Maybe<Project_Soft_Skill_Variance_Fields>;
};


/** aggregate fields of "project_soft_skill" */
export type Project_Soft_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_soft_skill" */
export type Project_Soft_Skill_Aggregate_Order_By = {
  avg?: Maybe<Project_Soft_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Soft_Skill_Max_Order_By>;
  min?: Maybe<Project_Soft_Skill_Min_Order_By>;
  stddev?: Maybe<Project_Soft_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Soft_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Soft_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Soft_Skill_Sum_Order_By>;
  var_pop?: Maybe<Project_Soft_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Soft_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Project_Soft_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_soft_skill" */
export type Project_Soft_Skill_Arr_Rel_Insert_Input = {
  data: Array<Project_Soft_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Soft_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Soft_Skill_Avg_Fields = {
  __typename?: 'project_soft_skill_avg_fields';
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Avg_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_soft_skill". All fields are combined with a logical 'AND'. */
export type Project_Soft_Skill_Bool_Exp = {
  _and?: Maybe<Array<Project_Soft_Skill_Bool_Exp>>;
  _not?: Maybe<Project_Soft_Skill_Bool_Exp>;
  _or?: Maybe<Array<Project_Soft_Skill_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  soft_skill?: Maybe<Soft_Skill_Bool_Exp>;
  soft_skill_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_soft_skill" */
export enum Project_Soft_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectSoftSkillPkey = 'project_soft_skill_pkey'
}

/** input type for incrementing numeric columns in table "project_soft_skill" */
export type Project_Soft_Skill_Inc_Input = {
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_soft_skill" */
export type Project_Soft_Skill_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  soft_skill?: Maybe<Soft_Skill_Obj_Rel_Insert_Input>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Soft_Skill_Max_Fields = {
  __typename?: 'project_soft_skill_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Soft_Skill_Min_Fields = {
  __typename?: 'project_soft_skill_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_soft_skill" */
export type Project_Soft_Skill_Mutation_Response = {
  __typename?: 'project_soft_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Soft_Skill>;
};

/** on_conflict condition type for table "project_soft_skill" */
export type Project_Soft_Skill_On_Conflict = {
  constraint: Project_Soft_Skill_Constraint;
  update_columns?: Array<Project_Soft_Skill_Update_Column>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "project_soft_skill". */
export type Project_Soft_Skill_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
  soft_skill?: Maybe<Soft_Skill_Order_By>;
  soft_skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: project_soft_skill */
export type Project_Soft_Skill_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_soft_skill" */
export enum Project_Soft_Skill_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SoftSkillId = 'soft_skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_soft_skill" */
export type Project_Soft_Skill_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Project_Soft_Skill_Stddev_Fields = {
  __typename?: 'project_soft_skill_stddev_fields';
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Stddev_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Soft_Skill_Stddev_Pop_Fields = {
  __typename?: 'project_soft_skill_stddev_pop_fields';
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Stddev_Pop_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Soft_Skill_Stddev_Samp_Fields = {
  __typename?: 'project_soft_skill_stddev_samp_fields';
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Stddev_Samp_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_soft_skill" */
export type Project_Soft_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Soft_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Soft_Skill_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Project_Soft_Skill_Sum_Fields = {
  __typename?: 'project_soft_skill_sum_fields';
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Sum_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** update columns of table "project_soft_skill" */
export enum Project_Soft_Skill_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  SoftSkillId = 'soft_skill_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Soft_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Soft_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Soft_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Soft_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Soft_Skill_Var_Pop_Fields = {
  __typename?: 'project_soft_skill_var_pop_fields';
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Var_Pop_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Soft_Skill_Var_Samp_Fields = {
  __typename?: 'project_soft_skill_var_samp_fields';
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Var_Samp_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Soft_Skill_Variance_Fields = {
  __typename?: 'project_soft_skill_variance_fields';
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_soft_skill" */
export type Project_Soft_Skill_Variance_Order_By = {
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev on columns */
export type Project_Stddev_Fields = {
  __typename?: 'project_stddev_fields';
  age?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  max_budget?: Maybe<Scalars['Float']>;
  min_budget?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project" */
export type Project_Stddev_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Stddev_Pop_Fields = {
  __typename?: 'project_stddev_pop_fields';
  age?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  max_budget?: Maybe<Scalars['Float']>;
  min_budget?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project" */
export type Project_Stddev_Pop_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Stddev_Samp_Fields = {
  __typename?: 'project_stddev_samp_fields';
  age?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  max_budget?: Maybe<Scalars['Float']>;
  min_budget?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project" */
export type Project_Stddev_Samp_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  access_id?: Maybe<Scalars['uuid']>;
  access_number?: Maybe<Scalars['String']>;
  access_type?: Maybe<Scalars['String']>;
  access_type_other?: Maybe<Scalars['String']>;
  accessibility_issues?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  additional_general_notes?: Maybe<Scalars['String']>;
  additional_other_information?: Maybe<Scalars['String']>;
  additional_special_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  allergies_environmental?: Maybe<Array<Scalars['String']>>;
  allergies_food?: Maybe<Array<Scalars['String']>>;
  allergies_medication?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['String']>;
  client_name?: Maybe<Scalars['String']>;
  cognitive_concerns?: Maybe<Scalars['String']>;
  cognitive_notes?: Maybe<Scalars['String']>;
  cognitive_others?: Maybe<Scalars['String']>;
  communication_ability?: Maybe<Scalars['String']>;
  communication_languages_spoken?: Maybe<Array<Scalars['String']>>;
  communication_notes?: Maybe<Scalars['String']>;
  communication_others?: Maybe<Scalars['String']>;
  community_resources?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['uuid']>;
  completed?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cultural_considerations?: Maybe<Scalars['String']>;
  date_completed?: Maybe<Scalars['date']>;
  date_started?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  desired_outcomes?: Maybe<Scalars['String']>;
  dietary_restrictions?: Maybe<Scalars['String']>;
  dnr_copy_attached?: Maybe<Scalars['String']>;
  dnr_order?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['timestamptz']>;
  drafted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  emergency_additional_notes?: Maybe<Scalars['String']>;
  emergency_contact_name?: Maybe<Scalars['String']>;
  emergency_email?: Maybe<Scalars['String']>;
  emergency_phone_number?: Maybe<Scalars['String']>;
  emergency_relationship?: Maybe<Scalars['String']>;
  emergency_secondary_contact?: Maybe<Scalars['String']>;
  enable_visit_based_clock_ins?: Maybe<Scalars['Boolean']>;
  end_date?: Maybe<Scalars['date']>;
  extra_notes?: Maybe<Scalars['String']>;
  family_medical_history?: Maybe<Scalars['String']>;
  family_support?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hobbies?: Maybe<Array<Scalars['String']>>;
  home_general_notes?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  immunizations?: Maybe<Scalars['String']>;
  interests?: Maybe<Scalars['String']>;
  interpreter_needed?: Maybe<Scalars['String']>;
  is_clockin?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  long_term_goals?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['numeric']>;
  manager_id?: Maybe<Scalars['uuid']>;
  max_budget?: Maybe<Scalars['Int']>;
  medical_conditions?: Maybe<Scalars['String']>;
  min_budget?: Maybe<Scalars['Int']>;
  mobility_level?: Maybe<Scalars['String']>;
  mobility_notes?: Maybe<Scalars['String']>;
  mobility_status?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notify_admin_by_email?: Maybe<Scalars['Boolean']>;
  notify_manager_by_email?: Maybe<Scalars['Boolean']>;
  past_conditions?: Maybe<Scalars['String']>;
  past_surgeries?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Scalars['String']>>;
  phone_number?: Maybe<Scalars['String']>;
  preferred_communication_style?: Maybe<Scalars['String']>;
  preferred_language?: Maybe<Scalars['String']>;
  preferred_name?: Maybe<Scalars['String']>;
  previous_hospitalizations?: Maybe<Scalars['String']>;
  primary_contact_number?: Maybe<Scalars['String']>;
  professional_care_contacts?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  religious_practices?: Maybe<Scalars['String']>;
  safety_concerns?: Maybe<Scalars['String']>;
  secondar_contact_number?: Maybe<Scalars['String']>;
  self_directed_care_preferences?: Maybe<Scalars['String']>;
  short_term_goals?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  smart_home_features?: Maybe<Scalars['String']>;
  social_connections?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  specific_care_needs?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  state?: Maybe<Scalars['String']>;
  support_type?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  visual_communication_style?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Sum_Fields = {
  __typename?: 'project_sum_fields';
  age?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  max_budget?: Maybe<Scalars['Int']>;
  min_budget?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project" */
export type Project_Sum_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** columns and relationships of "project_tag" */
export type Project_Tag = {
  __typename?: 'project_tag';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid'];
  /** An object relationship */
  tag: Tag;
  tag_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "project_tag" */
export type Project_Tag_Aggregate = {
  __typename?: 'project_tag_aggregate';
  aggregate?: Maybe<Project_Tag_Aggregate_Fields>;
  nodes: Array<Project_Tag>;
};

export type Project_Tag_Aggregate_Bool_Exp = {
  count?: Maybe<Project_Tag_Aggregate_Bool_Exp_Count>;
};

export type Project_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Project_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Project_Tag_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_tag" */
export type Project_Tag_Aggregate_Fields = {
  __typename?: 'project_tag_aggregate_fields';
  avg?: Maybe<Project_Tag_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Tag_Max_Fields>;
  min?: Maybe<Project_Tag_Min_Fields>;
  stddev?: Maybe<Project_Tag_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Tag_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Tag_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Tag_Sum_Fields>;
  var_pop?: Maybe<Project_Tag_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Tag_Var_Samp_Fields>;
  variance?: Maybe<Project_Tag_Variance_Fields>;
};


/** aggregate fields of "project_tag" */
export type Project_Tag_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Project_Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_tag" */
export type Project_Tag_Aggregate_Order_By = {
  avg?: Maybe<Project_Tag_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Project_Tag_Max_Order_By>;
  min?: Maybe<Project_Tag_Min_Order_By>;
  stddev?: Maybe<Project_Tag_Stddev_Order_By>;
  stddev_pop?: Maybe<Project_Tag_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Project_Tag_Stddev_Samp_Order_By>;
  sum?: Maybe<Project_Tag_Sum_Order_By>;
  var_pop?: Maybe<Project_Tag_Var_Pop_Order_By>;
  var_samp?: Maybe<Project_Tag_Var_Samp_Order_By>;
  variance?: Maybe<Project_Tag_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_tag" */
export type Project_Tag_Arr_Rel_Insert_Input = {
  data: Array<Project_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Project_Tag_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Tag_Avg_Fields = {
  __typename?: 'project_tag_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_tag" */
export type Project_Tag_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_tag". All fields are combined with a logical 'AND'. */
export type Project_Tag_Bool_Exp = {
  _and?: Maybe<Array<Project_Tag_Bool_Exp>>;
  _not?: Maybe<Project_Tag_Bool_Exp>;
  _or?: Maybe<Array<Project_Tag_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  tag?: Maybe<Tag_Bool_Exp>;
  tag_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_tag" */
export enum Project_Tag_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectTagPkey = 'project_tag_pkey'
}

/** input type for incrementing numeric columns in table "project_tag" */
export type Project_Tag_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_tag" */
export type Project_Tag_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Tag_Obj_Rel_Insert_Input>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Tag_Max_Fields = {
  __typename?: 'project_tag_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_tag" */
export type Project_Tag_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Tag_Min_Fields = {
  __typename?: 'project_tag_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_tag" */
export type Project_Tag_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "project_tag" */
export type Project_Tag_Mutation_Response = {
  __typename?: 'project_tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Tag>;
};

/** on_conflict condition type for table "project_tag" */
export type Project_Tag_On_Conflict = {
  constraint: Project_Tag_Constraint;
  update_columns?: Array<Project_Tag_Update_Column>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "project_tag". */
export type Project_Tag_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
  tag?: Maybe<Tag_Order_By>;
  tag_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: project_tag */
export type Project_Tag_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_tag" */
export enum Project_Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_tag" */
export type Project_Tag_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Project_Tag_Stddev_Fields = {
  __typename?: 'project_tag_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_tag" */
export type Project_Tag_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Tag_Stddev_Pop_Fields = {
  __typename?: 'project_tag_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_tag" */
export type Project_Tag_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Tag_Stddev_Samp_Fields = {
  __typename?: 'project_tag_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_tag" */
export type Project_Tag_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "project_tag" */
export type Project_Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Tag_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Project_Tag_Sum_Fields = {
  __typename?: 'project_tag_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_tag" */
export type Project_Tag_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "project_tag" */
export enum Project_Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Tag_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Tag_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Tag_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Tag_Var_Pop_Fields = {
  __typename?: 'project_tag_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_tag" */
export type Project_Tag_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Tag_Var_Samp_Fields = {
  __typename?: 'project_tag_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_tag" */
export type Project_Tag_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Tag_Variance_Fields = {
  __typename?: 'project_tag_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_tag" */
export type Project_Tag_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "project" */
export enum Project_Update_Column {
  /** column name */
  AccessId = 'access_id',
  /** column name */
  AccessNumber = 'access_number',
  /** column name */
  AccessType = 'access_type',
  /** column name */
  AccessTypeOther = 'access_type_other',
  /** column name */
  AccessibilityIssues = 'accessibility_issues',
  /** column name */
  Active = 'active',
  /** column name */
  AdditionalGeneralNotes = 'additional_general_notes',
  /** column name */
  AdditionalOtherInformation = 'additional_other_information',
  /** column name */
  AdditionalSpecialInstructions = 'additional_special_instructions',
  /** column name */
  Address = 'address',
  /** column name */
  Age = 'age',
  /** column name */
  AllergiesEnvironmental = 'allergies_environmental',
  /** column name */
  AllergiesFood = 'allergies_food',
  /** column name */
  AllergiesMedication = 'allergies_medication',
  /** column name */
  Archived = 'archived',
  /** column name */
  City = 'city',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  ClientName = 'client_name',
  /** column name */
  CognitiveConcerns = 'cognitive_concerns',
  /** column name */
  CognitiveNotes = 'cognitive_notes',
  /** column name */
  CognitiveOthers = 'cognitive_others',
  /** column name */
  CommunicationAbility = 'communication_ability',
  /** column name */
  CommunicationLanguagesSpoken = 'communication_languages_spoken',
  /** column name */
  CommunicationNotes = 'communication_notes',
  /** column name */
  CommunicationOthers = 'communication_others',
  /** column name */
  CommunityResources = 'community_resources',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Completed = 'completed',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CulturalConsiderations = 'cultural_considerations',
  /** column name */
  DateCompleted = 'date_completed',
  /** column name */
  DateStarted = 'date_started',
  /** column name */
  Description = 'description',
  /** column name */
  DesiredOutcomes = 'desired_outcomes',
  /** column name */
  DietaryRestrictions = 'dietary_restrictions',
  /** column name */
  DnrCopyAttached = 'dnr_copy_attached',
  /** column name */
  DnrOrder = 'dnr_order',
  /** column name */
  Dob = 'dob',
  /** column name */
  Drafted = 'drafted',
  /** column name */
  Email = 'email',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  EmergencyAdditionalNotes = 'emergency_additional_notes',
  /** column name */
  EmergencyContactName = 'emergency_contact_name',
  /** column name */
  EmergencyEmail = 'emergency_email',
  /** column name */
  EmergencyPhoneNumber = 'emergency_phone_number',
  /** column name */
  EmergencyRelationship = 'emergency_relationship',
  /** column name */
  EmergencySecondaryContact = 'emergency_secondary_contact',
  /** column name */
  EnableVisitBasedClockIns = 'enable_visit_based_clock_ins',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExtraNotes = 'extra_notes',
  /** column name */
  FamilyMedicalHistory = 'family_medical_history',
  /** column name */
  FamilySupport = 'family_support',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Gender = 'gender',
  /** column name */
  Hobbies = 'hobbies',
  /** column name */
  HomeGeneralNotes = 'home_general_notes',
  /** column name */
  Id = 'id',
  /** column name */
  Immunizations = 'immunizations',
  /** column name */
  Interests = 'interests',
  /** column name */
  InterpreterNeeded = 'interpreter_needed',
  /** column name */
  IsClockin = 'is_clockin',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Location = 'location',
  /** column name */
  LongTermGoals = 'long_term_goals',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MedicalConditions = 'medical_conditions',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  MobilityLevel = 'mobility_level',
  /** column name */
  MobilityNotes = 'mobility_notes',
  /** column name */
  MobilityStatus = 'mobility_status',
  /** column name */
  Name = 'name',
  /** column name */
  NotifyAdminByEmail = 'notify_admin_by_email',
  /** column name */
  NotifyManagerByEmail = 'notify_manager_by_email',
  /** column name */
  PastConditions = 'past_conditions',
  /** column name */
  PastSurgeries = 'past_surgeries',
  /** column name */
  Pets = 'pets',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PreferredCommunicationStyle = 'preferred_communication_style',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  PreferredName = 'preferred_name',
  /** column name */
  PreviousHospitalizations = 'previous_hospitalizations',
  /** column name */
  PrimaryContactNumber = 'primary_contact_number',
  /** column name */
  ProfessionalCareContacts = 'professional_care_contacts',
  /** column name */
  Reference = 'reference',
  /** column name */
  ReligiousPractices = 'religious_practices',
  /** column name */
  SafetyConcerns = 'safety_concerns',
  /** column name */
  SecondarContactNumber = 'secondar_contact_number',
  /** column name */
  SelfDirectedCarePreferences = 'self_directed_care_preferences',
  /** column name */
  ShortTermGoals = 'short_term_goals',
  /** column name */
  Slug = 'slug',
  /** column name */
  SmartHomeFeatures = 'smart_home_features',
  /** column name */
  SocialConnections = 'social_connections',
  /** column name */
  SpecialInstructions = 'special_instructions',
  /** column name */
  SpecificCareNeeds = 'specific_care_needs',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  State = 'state',
  /** column name */
  SupportType = 'support_type',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  VisualCommunicationStyle = 'visual_communication_style'
}

export type Project_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Project_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Var_Pop_Fields = {
  __typename?: 'project_var_pop_fields';
  age?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  max_budget?: Maybe<Scalars['Float']>;
  min_budget?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project" */
export type Project_Var_Pop_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Var_Samp_Fields = {
  __typename?: 'project_var_samp_fields';
  age?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  max_budget?: Maybe<Scalars['Float']>;
  min_budget?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project" */
export type Project_Var_Samp_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Variance_Fields = {
  __typename?: 'project_variance_fields';
  age?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  max_budget?: Maybe<Scalars['Float']>;
  min_budget?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project" */
export type Project_Variance_Order_By = {
  age?: Maybe<Order_By>;
  latitude?: Maybe<Order_By>;
  longitude?: Maybe<Order_By>;
  max_budget?: Maybe<Order_By>;
  min_budget?: Maybe<Order_By>;
};

/** columns and relationships of "public_project_details" */
export type Public_Project_Details = {
  __typename?: 'public_project_details';
  activity_deleted?: Maybe<Scalars['Boolean']>;
  activity_id?: Maybe<Scalars['uuid']>;
  activity_title?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Project>;
  /** An object relationship */
  project_activity?: Maybe<Project_Activity>;
  project_id?: Maybe<Scalars['uuid']>;
  project_name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "public_project_details" */
export type Public_Project_Details_Aggregate = {
  __typename?: 'public_project_details_aggregate';
  aggregate?: Maybe<Public_Project_Details_Aggregate_Fields>;
  nodes: Array<Public_Project_Details>;
};

/** aggregate fields of "public_project_details" */
export type Public_Project_Details_Aggregate_Fields = {
  __typename?: 'public_project_details_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Public_Project_Details_Max_Fields>;
  min?: Maybe<Public_Project_Details_Min_Fields>;
};


/** aggregate fields of "public_project_details" */
export type Public_Project_Details_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Public_Project_Details_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "public_project_details". All fields are combined with a logical 'AND'. */
export type Public_Project_Details_Bool_Exp = {
  _and?: Maybe<Array<Public_Project_Details_Bool_Exp>>;
  _not?: Maybe<Public_Project_Details_Bool_Exp>;
  _or?: Maybe<Array<Public_Project_Details_Bool_Exp>>;
  activity_deleted?: Maybe<Boolean_Comparison_Exp>;
  activity_id?: Maybe<Uuid_Comparison_Exp>;
  activity_title?: Maybe<String_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_activity?: Maybe<Project_Activity_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  project_name?: Maybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "public_project_details" */
export type Public_Project_Details_Insert_Input = {
  activity_deleted?: Maybe<Scalars['Boolean']>;
  activity_id?: Maybe<Scalars['uuid']>;
  activity_title?: Maybe<Scalars['String']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_activity?: Maybe<Project_Activity_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  project_name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Public_Project_Details_Max_Fields = {
  __typename?: 'public_project_details_max_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  activity_title?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  project_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Public_Project_Details_Min_Fields = {
  __typename?: 'public_project_details_min_fields';
  activity_id?: Maybe<Scalars['uuid']>;
  activity_title?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  project_name?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "public_project_details" */
export type Public_Project_Details_Obj_Rel_Insert_Input = {
  data: Public_Project_Details_Insert_Input;
};

/** Ordering options when selecting data from "public_project_details". */
export type Public_Project_Details_Order_By = {
  activity_deleted?: Maybe<Order_By>;
  activity_id?: Maybe<Order_By>;
  activity_title?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_activity?: Maybe<Project_Activity_Order_By>;
  project_id?: Maybe<Order_By>;
  project_name?: Maybe<Order_By>;
};

/** select columns of table "public_project_details" */
export enum Public_Project_Details_Select_Column {
  /** column name */
  ActivityDeleted = 'activity_deleted',
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActivityTitle = 'activity_title',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name'
}

/** Streaming cursor of the table "public_project_details" */
export type Public_Project_Details_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Public_Project_Details_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Public_Project_Details_Stream_Cursor_Value_Input = {
  activity_deleted?: Maybe<Scalars['Boolean']>;
  activity_id?: Maybe<Scalars['uuid']>;
  activity_title?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  project_name?: Maybe<Scalars['String']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "admin" */
  admin: Array<Admin>;
  /** fetch aggregated fields from the table: "admin" */
  admin_aggregate: Admin_Aggregate;
  /** fetch data from the table: "admin" using primary key columns */
  admin_by_pk?: Maybe<Admin>;
  /** fetch data from the table: "application" */
  application: Array<Application>;
  /** fetch aggregated fields from the table: "application" */
  application_aggregate: Application_Aggregate;
  /** fetch data from the table: "application" using primary key columns */
  application_by_pk?: Maybe<Application>;
  /** fetch data from the table: "candidate" */
  candidate: Array<Candidate>;
  /** fetch aggregated fields from the table: "candidate" */
  candidate_aggregate: Candidate_Aggregate;
  /** fetch data from the table: "candidate" using primary key columns */
  candidate_by_pk?: Maybe<Candidate>;
  /** fetch data from the table: "chart_admin_contractors" */
  chart_admin_contractors: Array<Chart_Admin_Contractors>;
  /** fetch aggregated fields from the table: "chart_admin_contractors" */
  chart_admin_contractors_aggregate: Chart_Admin_Contractors_Aggregate;
  /** fetch data from the table: "chart_manager_contractors" */
  chart_manager_contractors: Array<Chart_Manager_Contractors>;
  /** fetch aggregated fields from the table: "chart_manager_contractors" */
  chart_manager_contractors_aggregate: Chart_Manager_Contractors_Aggregate;
  /** fetch data from the table: "chart_projects" */
  chart_projects: Array<Chart_Projects>;
  /** fetch aggregated fields from the table: "chart_projects" */
  chart_projects_aggregate: Chart_Projects_Aggregate;
  /** fetch data from the table: "checkin_status" */
  checkin_status: Array<Checkin_Status>;
  /** fetch aggregated fields from the table: "checkin_status" */
  checkin_status_aggregate: Checkin_Status_Aggregate;
  /** fetch data from the table: "checkin_status" using primary key columns */
  checkin_status_by_pk?: Maybe<Checkin_Status>;
  /** fetch data from the table: "checkout_status" */
  checkout_status: Array<Checkout_Status>;
  /** fetch aggregated fields from the table: "checkout_status" */
  checkout_status_aggregate: Checkout_Status_Aggregate;
  /** fetch data from the table: "checkout_status" using primary key columns */
  checkout_status_by_pk?: Maybe<Checkout_Status>;
  /** fetch data from the table: "client_care_plan" */
  client_care_plan: Array<Client_Care_Plan>;
  /** fetch aggregated fields from the table: "client_care_plan" */
  client_care_plan_aggregate: Client_Care_Plan_Aggregate;
  /** fetch data from the table: "client_care_plan" using primary key columns */
  client_care_plan_by_pk?: Maybe<Client_Care_Plan>;
  /** An array relationship */
  client_medications: Array<Client_Medications>;
  /** An aggregate relationship */
  client_medications_aggregate: Client_Medications_Aggregate;
  /** fetch data from the table: "client_medications" using primary key columns */
  client_medications_by_pk?: Maybe<Client_Medications>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_follower" */
  company_follower: Array<Company_Follower>;
  /** fetch aggregated fields from the table: "company_follower" */
  company_follower_aggregate: Company_Follower_Aggregate;
  /** fetch data from the table: "company_follower" using primary key columns */
  company_follower_by_pk?: Maybe<Company_Follower>;
  /** fetch data from the table: "company_user_notifications" */
  company_user_notifications: Array<Company_User_Notifications>;
  /** fetch aggregated fields from the table: "company_user_notifications" */
  company_user_notifications_aggregate: Company_User_Notifications_Aggregate;
  /** fetch data from the table: "company_user_notifications" using primary key columns */
  company_user_notifications_by_pk?: Maybe<Company_User_Notifications>;
  /** fetch data from the table: "contractor" */
  contractor: Array<Contractor>;
  /** fetch aggregated fields from the table: "contractor" */
  contractor_aggregate: Contractor_Aggregate;
  /** fetch data from the table: "contractor" using primary key columns */
  contractor_by_pk?: Maybe<Contractor>;
  /** fetch data from the table: "contractor_note" */
  contractor_note: Array<Contractor_Note>;
  /** fetch aggregated fields from the table: "contractor_note" */
  contractor_note_aggregate: Contractor_Note_Aggregate;
  /** fetch data from the table: "contractor_note" using primary key columns */
  contractor_note_by_pk?: Maybe<Contractor_Note>;
  /** fetch data from the table: "contractor_posting" */
  contractor_posting: Array<Contractor_Posting>;
  /** fetch aggregated fields from the table: "contractor_posting" */
  contractor_posting_aggregate: Contractor_Posting_Aggregate;
  /** fetch data from the table: "contractor_posting" using primary key columns */
  contractor_posting_by_pk?: Maybe<Contractor_Posting>;
  /** fetch data from the table: "contractor_project" */
  contractor_project: Array<Contractor_Project>;
  /** fetch aggregated fields from the table: "contractor_project" */
  contractor_project_aggregate: Contractor_Project_Aggregate;
  /** fetch data from the table: "contractor_project" using primary key columns */
  contractor_project_by_pk?: Maybe<Contractor_Project>;
  /** fetch data from the table: "contractor_rating" */
  contractor_rating: Array<Contractor_Rating>;
  /** fetch aggregated fields from the table: "contractor_rating" */
  contractor_rating_aggregate: Contractor_Rating_Aggregate;
  /** fetch data from the table: "contractor_rating" using primary key columns */
  contractor_rating_by_pk?: Maybe<Contractor_Rating>;
  /** fetch data from the table: "contractor_staff_note" */
  contractor_staff_note: Array<Contractor_Staff_Note>;
  /** fetch aggregated fields from the table: "contractor_staff_note" */
  contractor_staff_note_aggregate: Contractor_Staff_Note_Aggregate;
  /** fetch data from the table: "contractor_staff_note" using primary key columns */
  contractor_staff_note_by_pk?: Maybe<Contractor_Staff_Note>;
  /** fetch data from the table: "conversation" */
  conversation: Array<Conversation>;
  /** fetch aggregated fields from the table: "conversation" */
  conversation_aggregate: Conversation_Aggregate;
  /** fetch data from the table: "conversation" using primary key columns */
  conversation_by_pk?: Maybe<Conversation>;
  /** fetch data from the table: "custom_request" */
  custom_request: Array<Custom_Request>;
  /** fetch aggregated fields from the table: "custom_request" */
  custom_request_aggregate: Custom_Request_Aggregate;
  /** fetch data from the table: "custom_request" using primary key columns */
  custom_request_by_pk?: Maybe<Custom_Request>;
  /** An array relationship */
  custom_request_skills: Array<Custom_Request_Skills>;
  /** An aggregate relationship */
  custom_request_skills_aggregate: Custom_Request_Skills_Aggregate;
  /** fetch data from the table: "custom_request_skills" using primary key columns */
  custom_request_skills_by_pk?: Maybe<Custom_Request_Skills>;
  /** An array relationship */
  declined_visit_matches: Array<Declined_Visit_Matches>;
  /** An aggregate relationship */
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  /** fetch data from the table: "declined_visit_matches" using primary key columns */
  declined_visit_matches_by_pk?: Maybe<Declined_Visit_Matches>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "document_contractor_access" */
  document_contractor_access: Array<Document_Contractor_Access>;
  /** fetch aggregated fields from the table: "document_contractor_access" */
  document_contractor_access_aggregate: Document_Contractor_Access_Aggregate;
  /** fetch data from the table: "document_contractor_access" using primary key columns */
  document_contractor_access_by_pk?: Maybe<Document_Contractor_Access>;
  /** fetch data from the table: "document_custom_request" */
  document_custom_request: Array<Document_Custom_Request>;
  /** fetch aggregated fields from the table: "document_custom_request" */
  document_custom_request_aggregate: Document_Custom_Request_Aggregate;
  /** fetch data from the table: "document_custom_request" using primary key columns */
  document_custom_request_by_pk?: Maybe<Document_Custom_Request>;
  /** fetch data from the table: "document_project" */
  document_project: Array<Document_Project>;
  /** fetch aggregated fields from the table: "document_project" */
  document_project_aggregate: Document_Project_Aggregate;
  /** fetch data from the table: "document_project" using primary key columns */
  document_project_by_pk?: Maybe<Document_Project>;
  /** fetch data from the table: "document_user" */
  document_user: Array<Document_User>;
  /** fetch aggregated fields from the table: "document_user" */
  document_user_aggregate: Document_User_Aggregate;
  /** fetch data from the table: "document_user" using primary key columns */
  document_user_by_pk?: Maybe<Document_User>;
  /** fetch data from the table: "email_regex" */
  email_regex: Array<Email_Regex>;
  /** fetch aggregated fields from the table: "email_regex" */
  email_regex_aggregate: Email_Regex_Aggregate;
  /** fetch data from the table: "email_regex" using primary key columns */
  email_regex_by_pk?: Maybe<Email_Regex>;
  /** fetch data from the table: "experience_skill" */
  experience_skill: Array<Experience_Skill>;
  /** fetch aggregated fields from the table: "experience_skill" */
  experience_skill_aggregate: Experience_Skill_Aggregate;
  /** fetch data from the table: "experience_skill" using primary key columns */
  experience_skill_by_pk?: Maybe<Experience_Skill>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  gender_aggregate: Gender_Aggregate;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  /** fetch data from the table: "industry" */
  industry: Array<Industry>;
  /** fetch aggregated fields from the table: "industry" */
  industry_aggregate: Industry_Aggregate;
  /** fetch data from the table: "industry" using primary key columns */
  industry_by_pk?: Maybe<Industry>;
  /** fetch data from the table: "invitation" */
  invitation: Array<Invitation>;
  /** fetch aggregated fields from the table: "invitation" */
  invitation_aggregate: Invitation_Aggregate;
  /** fetch data from the table: "invitation" using primary key columns */
  invitation_by_pk?: Maybe<Invitation>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: Language_Aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table: "manager" */
  manager: Array<Manager>;
  /** fetch aggregated fields from the table: "manager" */
  manager_aggregate: Manager_Aggregate;
  /** fetch data from the table: "manager" using primary key columns */
  manager_by_pk?: Maybe<Manager>;
  /** fetch data from the table: "manager_contractor" */
  manager_contractor: Array<Manager_Contractor>;
  /** fetch aggregated fields from the table: "manager_contractor" */
  manager_contractor_aggregate: Manager_Contractor_Aggregate;
  /** fetch data from the table: "manager_contractor" using primary key columns */
  manager_contractor_by_pk?: Maybe<Manager_Contractor>;
  /** fetch data from the table: "message" */
  message: Array<Message>;
  /** fetch aggregated fields from the table: "message" */
  message_aggregate: Message_Aggregate;
  /** fetch data from the table: "message" using primary key columns */
  message_by_pk?: Maybe<Message>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table: "onboarding" */
  onboarding: Array<Onboarding>;
  /** fetch aggregated fields from the table: "onboarding" */
  onboarding_aggregate: Onboarding_Aggregate;
  /** fetch data from the table: "onboarding" using primary key columns */
  onboarding_by_pk?: Maybe<Onboarding>;
  /** fetch data from the table: "payment_card" */
  payment_card: Array<Payment_Card>;
  /** fetch aggregated fields from the table: "payment_card" */
  payment_card_aggregate: Payment_Card_Aggregate;
  /** fetch data from the table: "payment_card" using primary key columns */
  payment_card_by_pk?: Maybe<Payment_Card>;
  /** fetch data from the table: "posting" */
  posting: Array<Posting>;
  /** fetch aggregated fields from the table: "posting" */
  posting_aggregate: Posting_Aggregate;
  /** fetch data from the table: "posting" using primary key columns */
  posting_by_pk?: Maybe<Posting>;
  /** fetch data from the table: "posting_industry" */
  posting_industry: Array<Posting_Industry>;
  /** fetch aggregated fields from the table: "posting_industry" */
  posting_industry_aggregate: Posting_Industry_Aggregate;
  /** fetch data from the table: "posting_industry" using primary key columns */
  posting_industry_by_pk?: Maybe<Posting_Industry>;
  /** fetch data from the table: "posting_skill" */
  posting_skill: Array<Posting_Skill>;
  /** fetch aggregated fields from the table: "posting_skill" */
  posting_skill_aggregate: Posting_Skill_Aggregate;
  /** fetch data from the table: "posting_skill" using primary key columns */
  posting_skill_by_pk?: Maybe<Posting_Skill>;
  /** An array relationship */
  posting_tags: Array<Posting_Tags>;
  /** An aggregate relationship */
  posting_tags_aggregate: Posting_Tags_Aggregate;
  /** fetch data from the table: "posting_tags" using primary key columns */
  posting_tags_by_pk?: Maybe<Posting_Tags>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch data from the table: "project_activity" */
  project_activity: Array<Project_Activity>;
  /** fetch aggregated fields from the table: "project_activity" */
  project_activity_aggregate: Project_Activity_Aggregate;
  /** fetch data from the table: "project_activity" using primary key columns */
  project_activity_by_pk?: Maybe<Project_Activity>;
  /** fetch data from the table: "project_activity_note" */
  project_activity_note: Array<Project_Activity_Note>;
  /** fetch aggregated fields from the table: "project_activity_note" */
  project_activity_note_aggregate: Project_Activity_Note_Aggregate;
  /** fetch data from the table: "project_activity_note" using primary key columns */
  project_activity_note_by_pk?: Maybe<Project_Activity_Note>;
  /** An array relationship */
  project_activity_request_more_hours: Array<Project_Activity_Request_More_Hours>;
  /** An aggregate relationship */
  project_activity_request_more_hours_aggregate: Project_Activity_Request_More_Hours_Aggregate;
  /** fetch data from the table: "project_activity_request_more_hours" using primary key columns */
  project_activity_request_more_hours_by_pk?: Maybe<Project_Activity_Request_More_Hours>;
  /** fetch data from the table: "project_activity_skill" */
  project_activity_skill: Array<Project_Activity_Skill>;
  /** fetch aggregated fields from the table: "project_activity_skill" */
  project_activity_skill_aggregate: Project_Activity_Skill_Aggregate;
  /** fetch data from the table: "project_activity_skill" using primary key columns */
  project_activity_skill_by_pk?: Maybe<Project_Activity_Skill>;
  /** fetch data from the table: "project_activity_soft_skill" */
  project_activity_soft_skill: Array<Project_Activity_Soft_Skill>;
  /** fetch aggregated fields from the table: "project_activity_soft_skill" */
  project_activity_soft_skill_aggregate: Project_Activity_Soft_Skill_Aggregate;
  /** fetch data from the table: "project_activity_soft_skill" using primary key columns */
  project_activity_soft_skill_by_pk?: Maybe<Project_Activity_Soft_Skill>;
  /** fetch data from the table: "project_activity_tag" */
  project_activity_tag: Array<Project_Activity_Tag>;
  /** fetch aggregated fields from the table: "project_activity_tag" */
  project_activity_tag_aggregate: Project_Activity_Tag_Aggregate;
  /** fetch data from the table: "project_activity_tag" using primary key columns */
  project_activity_tag_by_pk?: Maybe<Project_Activity_Tag>;
  /** fetch data from the table: "project_activity_time" */
  project_activity_time: Array<Project_Activity_Time>;
  /** fetch aggregated fields from the table: "project_activity_time" */
  project_activity_time_aggregate: Project_Activity_Time_Aggregate;
  /** fetch data from the table: "project_activity_time" using primary key columns */
  project_activity_time_by_pk?: Maybe<Project_Activity_Time>;
  /** fetch data from the table: "project_activity_tracked_time" */
  project_activity_tracked_time: Array<Project_Activity_Tracked_Time>;
  /** fetch aggregated fields from the table: "project_activity_tracked_time" */
  project_activity_tracked_time_aggregate: Project_Activity_Tracked_Time_Aggregate;
  /** fetch data from the table: "project_activity_tracked_time" using primary key columns */
  project_activity_tracked_time_by_pk?: Maybe<Project_Activity_Tracked_Time>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_skill" */
  project_skill: Array<Project_Skill>;
  /** fetch aggregated fields from the table: "project_skill" */
  project_skill_aggregate: Project_Skill_Aggregate;
  /** fetch data from the table: "project_skill" using primary key columns */
  project_skill_by_pk?: Maybe<Project_Skill>;
  /** fetch data from the table: "project_soft_skill" */
  project_soft_skill: Array<Project_Soft_Skill>;
  /** fetch aggregated fields from the table: "project_soft_skill" */
  project_soft_skill_aggregate: Project_Soft_Skill_Aggregate;
  /** fetch data from the table: "project_soft_skill" using primary key columns */
  project_soft_skill_by_pk?: Maybe<Project_Soft_Skill>;
  /** fetch data from the table: "project_tag" */
  project_tag: Array<Project_Tag>;
  /** fetch aggregated fields from the table: "project_tag" */
  project_tag_aggregate: Project_Tag_Aggregate;
  /** fetch data from the table: "project_tag" using primary key columns */
  project_tag_by_pk?: Maybe<Project_Tag>;
  /** fetch data from the table: "public_project_details" */
  public_project_details: Array<Public_Project_Details>;
  /** fetch aggregated fields from the table: "public_project_details" */
  public_project_details_aggregate: Public_Project_Details_Aggregate;
  /** An array relationship */
  recipient_message: Array<Recipient_Message>;
  /** An aggregate relationship */
  recipient_message_aggregate: Recipient_Message_Aggregate;
  /** fetch data from the table: "recipient_message" using primary key columns */
  recipient_message_by_pk?: Maybe<Recipient_Message>;
  /** fetch data from the table: "resource_information_card" */
  resource_information_card: Array<Resource_Information_Card>;
  /** fetch aggregated fields from the table: "resource_information_card" */
  resource_information_card_aggregate: Resource_Information_Card_Aggregate;
  /** fetch data from the table: "resource_information_card" using primary key columns */
  resource_information_card_by_pk?: Maybe<Resource_Information_Card>;
  /** execute function "search_industry" which returns "industry" */
  search_industry: Array<Industry>;
  /** execute function "search_industry" and query aggregates on result of table type "industry" */
  search_industry_aggregate: Industry_Aggregate;
  /** execute function "search_skill" which returns "skill" */
  search_skill: Array<Skill>;
  /** execute function "search_skill" and query aggregates on result of table type "skill" */
  search_skill_aggregate: Skill_Aggregate;
  /** fetch data from the table: "skill" */
  skill: Array<Skill>;
  /** fetch aggregated fields from the table: "skill" */
  skill_aggregate: Skill_Aggregate;
  /** fetch data from the table: "skill" using primary key columns */
  skill_by_pk?: Maybe<Skill>;
  /** fetch data from the table: "skills_short_name_first" */
  skills_short_name_first: Array<Skills_Short_Name_First>;
  /** fetch aggregated fields from the table: "skills_short_name_first" */
  skills_short_name_first_aggregate: Skills_Short_Name_First_Aggregate;
  /** fetch data from the table: "smart_match_bookmark" */
  smart_match_bookmark: Array<Smart_Match_Bookmark>;
  /** fetch aggregated fields from the table: "smart_match_bookmark" */
  smart_match_bookmark_aggregate: Smart_Match_Bookmark_Aggregate;
  /** fetch data from the table: "smart_match_bookmark" using primary key columns */
  smart_match_bookmark_by_pk?: Maybe<Smart_Match_Bookmark>;
  /** fetch data from the table: "smart_match_config_transportation" */
  smart_match_config_transportation: Array<Smart_Match_Config_Transportation>;
  /** fetch aggregated fields from the table: "smart_match_config_transportation" */
  smart_match_config_transportation_aggregate: Smart_Match_Config_Transportation_Aggregate;
  /** fetch data from the table: "smart_match_config_transportation" using primary key columns */
  smart_match_config_transportation_by_pk?: Maybe<Smart_Match_Config_Transportation>;
  /** fetch data from the table: "smart_match_configs" */
  smart_match_configs: Array<Smart_Match_Configs>;
  /** fetch aggregated fields from the table: "smart_match_configs" */
  smart_match_configs_aggregate: Smart_Match_Configs_Aggregate;
  /** fetch data from the table: "smart_match_configs" using primary key columns */
  smart_match_configs_by_pk?: Maybe<Smart_Match_Configs>;
  /** fetch data from the table: "smart_match_criteria_order" */
  smart_match_criteria_order: Array<Smart_Match_Criteria_Order>;
  /** fetch aggregated fields from the table: "smart_match_criteria_order" */
  smart_match_criteria_order_aggregate: Smart_Match_Criteria_Order_Aggregate;
  /** fetch data from the table: "smart_match_criteria_order" using primary key columns */
  smart_match_criteria_order_by_pk?: Maybe<Smart_Match_Criteria_Order>;
  /** fetch data from the table: "soft_skill" */
  soft_skill: Array<Soft_Skill>;
  /** fetch aggregated fields from the table: "soft_skill" */
  soft_skill_aggregate: Soft_Skill_Aggregate;
  /** fetch data from the table: "soft_skill" using primary key columns */
  soft_skill_by_pk?: Maybe<Soft_Skill>;
  /** fetch data from the table: "source" */
  source: Array<Source>;
  /** fetch aggregated fields from the table: "source" */
  source_aggregate: Source_Aggregate;
  /** fetch data from the table: "source" using primary key columns */
  source_by_pk?: Maybe<Source>;
  /** fetch data from the table: "subscription" */
  subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "subscription" */
  subscription_aggregate: Subscription_Aggregate;
  /** fetch data from the table: "subscription" using primary key columns */
  subscription_by_pk?: Maybe<Subscription>;
  /** fetch data from the table: "subscription_plan" */
  subscription_plan: Array<Subscription_Plan>;
  /** fetch data from the table: "subscription_plan_access_permissions" */
  subscription_plan_access_permissions: Array<Subscription_Plan_Access_Permissions>;
  /** fetch aggregated fields from the table: "subscription_plan_access_permissions" */
  subscription_plan_access_permissions_aggregate: Subscription_Plan_Access_Permissions_Aggregate;
  /** fetch data from the table: "subscription_plan_access_permissions" using primary key columns */
  subscription_plan_access_permissions_by_pk?: Maybe<Subscription_Plan_Access_Permissions>;
  /** fetch aggregated fields from the table: "subscription_plan" */
  subscription_plan_aggregate: Subscription_Plan_Aggregate;
  /** fetch data from the table: "subscription_plan" using primary key columns */
  subscription_plan_by_pk?: Maybe<Subscription_Plan>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table: "team" */
  team: Array<Team>;
  /** fetch aggregated fields from the table: "team" */
  team_aggregate: Team_Aggregate;
  /** fetch data from the table: "team" using primary key columns */
  team_by_pk?: Maybe<Team>;
  /** fetch data from the table: "team_contractor" */
  team_contractor: Array<Team_Contractor>;
  /** fetch aggregated fields from the table: "team_contractor" */
  team_contractor_aggregate: Team_Contractor_Aggregate;
  /** fetch data from the table: "team_contractor" using primary key columns */
  team_contractor_by_pk?: Maybe<Team_Contractor>;
  /** fetch data from the table: "team_manager" */
  team_manager: Array<Team_Manager>;
  /** fetch aggregated fields from the table: "team_manager" */
  team_manager_aggregate: Team_Manager_Aggregate;
  /** fetch data from the table: "team_manager" using primary key columns */
  team_manager_by_pk?: Maybe<Team_Manager>;
  /** fetch data from the table: "team_posting" */
  team_posting: Array<Team_Posting>;
  /** fetch aggregated fields from the table: "team_posting" */
  team_posting_aggregate: Team_Posting_Aggregate;
  /** fetch data from the table: "team_posting" using primary key columns */
  team_posting_by_pk?: Maybe<Team_Posting>;
  /** fetch data from the table: "team_project" */
  team_project: Array<Team_Project>;
  /** fetch aggregated fields from the table: "team_project" */
  team_project_aggregate: Team_Project_Aggregate;
  /** fetch data from the table: "team_project" using primary key columns */
  team_project_by_pk?: Maybe<Team_Project>;
  /** fetch data from the table: "team_skill" */
  team_skill: Array<Team_Skill>;
  /** fetch aggregated fields from the table: "team_skill" */
  team_skill_aggregate: Team_Skill_Aggregate;
  /** fetch data from the table: "team_skill" using primary key columns */
  team_skill_by_pk?: Maybe<Team_Skill>;
  /** fetch data from the table: "timesheet" */
  timesheet: Array<Timesheet>;
  /** fetch aggregated fields from the table: "timesheet" */
  timesheet_aggregate: Timesheet_Aggregate;
  /** fetch data from the table: "timesheet" using primary key columns */
  timesheet_by_pk?: Maybe<Timesheet>;
  /** fetch data from the table: "type_of_visit" */
  type_of_visit: Array<Type_Of_Visit>;
  /** fetch aggregated fields from the table: "type_of_visit" */
  type_of_visit_aggregate: Type_Of_Visit_Aggregate;
  /** fetch data from the table: "type_of_visit" using primary key columns */
  type_of_visit_by_pk?: Maybe<Type_Of_Visit>;
  /** fetch data from the table: "unread_messages" */
  unread_messages: Array<Unread_Messages>;
  /** fetch aggregated fields from the table: "unread_messages" */
  unread_messages_aggregate: Unread_Messages_Aggregate;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_affinda_profile" */
  user_affinda_profile: Array<User_Affinda_Profile>;
  /** fetch aggregated fields from the table: "user_affinda_profile" */
  user_affinda_profile_aggregate: User_Affinda_Profile_Aggregate;
  /** fetch data from the table: "user_affinda_profile" using primary key columns */
  user_affinda_profile_by_pk?: Maybe<User_Affinda_Profile>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_certification" */
  user_certification: Array<User_Certification>;
  /** fetch aggregated fields from the table: "user_certification" */
  user_certification_aggregate: User_Certification_Aggregate;
  /** fetch data from the table: "user_certification" using primary key columns */
  user_certification_by_pk?: Maybe<User_Certification>;
  /** fetch data from the table: "user_company" */
  user_company: Array<User_Company>;
  /** fetch aggregated fields from the table: "user_company" */
  user_company_aggregate: User_Company_Aggregate;
  /** fetch data from the table: "user_company" using primary key columns */
  user_company_by_pk?: Maybe<User_Company>;
  /** fetch data from the table: "user_conversation" */
  user_conversation: Array<User_Conversation>;
  /** fetch aggregated fields from the table: "user_conversation" */
  user_conversation_aggregate: User_Conversation_Aggregate;
  /** fetch data from the table: "user_conversation" using primary key columns */
  user_conversation_by_pk?: Maybe<User_Conversation>;
  /** fetch data from the table: "user_education" */
  user_education: Array<User_Education>;
  /** fetch aggregated fields from the table: "user_education" */
  user_education_aggregate: User_Education_Aggregate;
  /** fetch data from the table: "user_education" using primary key columns */
  user_education_by_pk?: Maybe<User_Education>;
  /** fetch data from the table: "user_experience" */
  user_experience: Array<User_Experience>;
  /** fetch aggregated fields from the table: "user_experience" */
  user_experience_aggregate: User_Experience_Aggregate;
  /** fetch data from the table: "user_experience" using primary key columns */
  user_experience_by_pk?: Maybe<User_Experience>;
  /** fetch data from the table: "user_favorite" */
  user_favorite: Array<User_Favorite>;
  /** fetch aggregated fields from the table: "user_favorite" */
  user_favorite_aggregate: User_Favorite_Aggregate;
  /** fetch data from the table: "user_favorite" using primary key columns */
  user_favorite_by_pk?: Maybe<User_Favorite>;
  /** fetch data from the table: "user_industry" */
  user_industry: Array<User_Industry>;
  /** fetch aggregated fields from the table: "user_industry" */
  user_industry_aggregate: User_Industry_Aggregate;
  /** fetch data from the table: "user_industry" using primary key columns */
  user_industry_by_pk?: Maybe<User_Industry>;
  /** fetch data from the table: "user_job_title" */
  user_job_title: Array<User_Job_Title>;
  /** fetch aggregated fields from the table: "user_job_title" */
  user_job_title_aggregate: User_Job_Title_Aggregate;
  /** fetch data from the table: "user_job_title" using primary key columns */
  user_job_title_by_pk?: Maybe<User_Job_Title>;
  /** fetch data from the table: "user_language" */
  user_language: Array<User_Language>;
  /** fetch aggregated fields from the table: "user_language" */
  user_language_aggregate: User_Language_Aggregate;
  /** fetch data from the table: "user_language" using primary key columns */
  user_language_by_pk?: Maybe<User_Language>;
  /** fetch data from the table: "user_private_data" */
  user_private_data: Array<User_Private_Data>;
  /** fetch aggregated fields from the table: "user_private_data" */
  user_private_data_aggregate: User_Private_Data_Aggregate;
  /** fetch data from the table: "user_profile" */
  user_profile: Array<User_Profile>;
  /** fetch aggregated fields from the table: "user_profile" */
  user_profile_aggregate: User_Profile_Aggregate;
  /** fetch data from the table: "user_profile_by_management" */
  user_profile_by_management: Array<User_Profile_By_Management>;
  /** fetch aggregated fields from the table: "user_profile_by_management" */
  user_profile_by_management_aggregate: User_Profile_By_Management_Aggregate;
  /** fetch data from the table: "user_profile_by_management" using primary key columns */
  user_profile_by_management_by_pk?: Maybe<User_Profile_By_Management>;
  /** fetch data from the table: "user_profile" using primary key columns */
  user_profile_by_pk?: Maybe<User_Profile>;
  /** fetch data from the table: "user_rating" */
  user_rating: Array<User_Rating>;
  /** fetch aggregated fields from the table: "user_rating" */
  user_rating_aggregate: User_Rating_Aggregate;
  /** fetch data from the table: "user_rating" using primary key columns */
  user_rating_by_pk?: Maybe<User_Rating>;
  /** fetch data from the table: "user_skill" */
  user_skill: Array<User_Skill>;
  /** fetch aggregated fields from the table: "user_skill" */
  user_skill_aggregate: User_Skill_Aggregate;
  /** fetch data from the table: "user_skill" using primary key columns */
  user_skill_by_pk?: Maybe<User_Skill>;
  /** fetch data from the table: "user_soft_skill" */
  user_soft_skill: Array<User_Soft_Skill>;
  /** fetch aggregated fields from the table: "user_soft_skill" */
  user_soft_skill_aggregate: User_Soft_Skill_Aggregate;
  /** fetch data from the table: "user_soft_skill" using primary key columns */
  user_soft_skill_by_pk?: Maybe<User_Soft_Skill>;
  /** fetch data from the table: "user_transportation" */
  user_transportation: Array<User_Transportation>;
  /** fetch aggregated fields from the table: "user_transportation" */
  user_transportation_aggregate: User_Transportation_Aggregate;
  /** fetch data from the table: "user_transportation" using primary key columns */
  user_transportation_by_pk?: Maybe<User_Transportation>;
  /** fetch data from the table: "user_watchlist" */
  user_watchlist: Array<User_Watchlist>;
  /** fetch aggregated fields from the table: "user_watchlist" */
  user_watchlist_aggregate: User_Watchlist_Aggregate;
  /** fetch data from the table: "user_watchlist" using primary key columns */
  user_watchlist_by_pk?: Maybe<User_Watchlist>;
};


export type Query_RootAdminArgs = {
  distinct_on?: Maybe<Array<Admin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Admin_Order_By>>;
  where?: Maybe<Admin_Bool_Exp>;
};


export type Query_RootAdmin_AggregateArgs = {
  distinct_on?: Maybe<Array<Admin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Admin_Order_By>>;
  where?: Maybe<Admin_Bool_Exp>;
};


export type Query_RootAdmin_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootApplicationArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


export type Query_RootApplication_AggregateArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


export type Query_RootApplication_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCandidateArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


export type Query_RootCandidate_AggregateArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


export type Query_RootCandidate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChart_Admin_ContractorsArgs = {
  distinct_on?: Maybe<Array<Chart_Admin_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Admin_Contractors_Order_By>>;
  where?: Maybe<Chart_Admin_Contractors_Bool_Exp>;
};


export type Query_RootChart_Admin_Contractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Chart_Admin_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Admin_Contractors_Order_By>>;
  where?: Maybe<Chart_Admin_Contractors_Bool_Exp>;
};


export type Query_RootChart_Manager_ContractorsArgs = {
  distinct_on?: Maybe<Array<Chart_Manager_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Manager_Contractors_Order_By>>;
  where?: Maybe<Chart_Manager_Contractors_Bool_Exp>;
};


export type Query_RootChart_Manager_Contractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Chart_Manager_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Manager_Contractors_Order_By>>;
  where?: Maybe<Chart_Manager_Contractors_Bool_Exp>;
};


export type Query_RootChart_ProjectsArgs = {
  distinct_on?: Maybe<Array<Chart_Projects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Projects_Order_By>>;
  where?: Maybe<Chart_Projects_Bool_Exp>;
};


export type Query_RootChart_Projects_AggregateArgs = {
  distinct_on?: Maybe<Array<Chart_Projects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Projects_Order_By>>;
  where?: Maybe<Chart_Projects_Bool_Exp>;
};


export type Query_RootCheckin_StatusArgs = {
  distinct_on?: Maybe<Array<Checkin_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkin_Status_Order_By>>;
  where?: Maybe<Checkin_Status_Bool_Exp>;
};


export type Query_RootCheckin_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Checkin_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkin_Status_Order_By>>;
  where?: Maybe<Checkin_Status_Bool_Exp>;
};


export type Query_RootCheckin_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootCheckout_StatusArgs = {
  distinct_on?: Maybe<Array<Checkout_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkout_Status_Order_By>>;
  where?: Maybe<Checkout_Status_Bool_Exp>;
};


export type Query_RootCheckout_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Checkout_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkout_Status_Order_By>>;
  where?: Maybe<Checkout_Status_Bool_Exp>;
};


export type Query_RootCheckout_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootClient_Care_PlanArgs = {
  distinct_on?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Care_Plan_Order_By>>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};


export type Query_RootClient_Care_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Care_Plan_Order_By>>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};


export type Query_RootClient_Care_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClient_MedicationsArgs = {
  distinct_on?: Maybe<Array<Client_Medications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Medications_Order_By>>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};


export type Query_RootClient_Medications_AggregateArgs = {
  distinct_on?: Maybe<Array<Client_Medications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Medications_Order_By>>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};


export type Query_RootClient_Medications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompanyArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Query_RootCompany_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Query_RootCompany_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompany_FollowerArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


export type Query_RootCompany_Follower_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


export type Query_RootCompany_Follower_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompany_User_NotificationsArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


export type Query_RootCompany_User_Notifications_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


export type Query_RootCompany_User_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractorArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


export type Query_RootContractor_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


export type Query_RootContractor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractor_NoteArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


export type Query_RootContractor_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


export type Query_RootContractor_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractor_PostingArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


export type Query_RootContractor_Posting_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


export type Query_RootContractor_Posting_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootContractor_ProjectArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


export type Query_RootContractor_Project_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


export type Query_RootContractor_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractor_RatingArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


export type Query_RootContractor_Rating_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


export type Query_RootContractor_Rating_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContractor_Staff_NoteArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


export type Query_RootContractor_Staff_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


export type Query_RootContractor_Staff_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootConversationArgs = {
  distinct_on?: Maybe<Array<Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Conversation_Order_By>>;
  where?: Maybe<Conversation_Bool_Exp>;
};


export type Query_RootConversation_AggregateArgs = {
  distinct_on?: Maybe<Array<Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Conversation_Order_By>>;
  where?: Maybe<Conversation_Bool_Exp>;
};


export type Query_RootConversation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCustom_RequestArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


export type Query_RootCustom_Request_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


export type Query_RootCustom_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCustom_Request_SkillsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


export type Query_RootCustom_Request_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


export type Query_RootCustom_Request_Skills_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDeclined_Visit_MatchesArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


export type Query_RootDeclined_Visit_Matches_AggregateArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


export type Query_RootDeclined_Visit_Matches_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocumentArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


export type Query_RootDocument_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_Contractor_AccessArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


export type Query_RootDocument_Contractor_Access_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


export type Query_RootDocument_Contractor_Access_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_Custom_RequestArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


export type Query_RootDocument_Custom_Request_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


export type Query_RootDocument_Custom_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_ProjectArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


export type Query_RootDocument_Project_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


export type Query_RootDocument_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDocument_UserArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


export type Query_RootDocument_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


export type Query_RootDocument_User_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_RegexArgs = {
  distinct_on?: Maybe<Array<Email_Regex_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Regex_Order_By>>;
  where?: Maybe<Email_Regex_Bool_Exp>;
};


export type Query_RootEmail_Regex_AggregateArgs = {
  distinct_on?: Maybe<Array<Email_Regex_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Regex_Order_By>>;
  where?: Maybe<Email_Regex_Bool_Exp>;
};


export type Query_RootEmail_Regex_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootExperience_SkillArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


export type Query_RootExperience_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


export type Query_RootExperience_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGenderArgs = {
  distinct_on?: Maybe<Array<Gender_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Gender_Order_By>>;
  where?: Maybe<Gender_Bool_Exp>;
};


export type Query_RootGender_AggregateArgs = {
  distinct_on?: Maybe<Array<Gender_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Gender_Order_By>>;
  where?: Maybe<Gender_Bool_Exp>;
};


export type Query_RootGender_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootIndustryArgs = {
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Query_RootIndustry_AggregateArgs = {
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Query_RootIndustry_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInvitationArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


export type Query_RootInvitation_AggregateArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


export type Query_RootInvitation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInvoiceArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLanguageArgs = {
  distinct_on?: Maybe<Array<Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Language_Order_By>>;
  where?: Maybe<Language_Bool_Exp>;
};


export type Query_RootLanguage_AggregateArgs = {
  distinct_on?: Maybe<Array<Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Language_Order_By>>;
  where?: Maybe<Language_Bool_Exp>;
};


export type Query_RootLanguage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootManagerArgs = {
  distinct_on?: Maybe<Array<Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Order_By>>;
  where?: Maybe<Manager_Bool_Exp>;
};


export type Query_RootManager_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Order_By>>;
  where?: Maybe<Manager_Bool_Exp>;
};


export type Query_RootManager_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootManager_ContractorArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


export type Query_RootManager_Contractor_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


export type Query_RootManager_Contractor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMessageArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Query_RootMessage_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Query_RootMessage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNotificationArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOnboardingArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


export type Query_RootOnboarding_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


export type Query_RootOnboarding_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPayment_CardArgs = {
  distinct_on?: Maybe<Array<Payment_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Card_Order_By>>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};


export type Query_RootPayment_Card_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Card_Order_By>>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};


export type Query_RootPayment_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPostingArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


export type Query_RootPosting_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


export type Query_RootPosting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPosting_IndustryArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


export type Query_RootPosting_Industry_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


export type Query_RootPosting_Industry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPosting_SkillArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


export type Query_RootPosting_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


export type Query_RootPosting_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPosting_TagsArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


export type Query_RootPosting_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


export type Query_RootPosting_Tags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProjectArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


export type Query_RootProject_ActivityArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


export type Query_RootProject_Activity_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


export type Query_RootProject_Activity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_Activity_NoteArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Note_Order_By>>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};


export type Query_RootProject_Activity_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Note_Order_By>>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};


export type Query_RootProject_Activity_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_Activity_Request_More_HoursArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


export type Query_RootProject_Activity_Request_More_Hours_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


export type Query_RootProject_Activity_Request_More_Hours_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_Activity_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


export type Query_RootProject_Activity_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


export type Query_RootProject_Activity_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_Activity_Soft_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};


export type Query_RootProject_Activity_Soft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};


export type Query_RootProject_Activity_Soft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_Activity_TagArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


export type Query_RootProject_Activity_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


export type Query_RootProject_Activity_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_Activity_TimeArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


export type Query_RootProject_Activity_Time_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


export type Query_RootProject_Activity_Time_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_Activity_Tracked_TimeArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


export type Query_RootProject_Activity_Tracked_Time_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


export type Query_RootProject_Activity_Tracked_Time_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


export type Query_RootProject_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


export type Query_RootProject_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


export type Query_RootProject_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_Soft_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};


export type Query_RootProject_Soft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};


export type Query_RootProject_Soft_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProject_TagArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


export type Query_RootProject_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


export type Query_RootProject_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPublic_Project_DetailsArgs = {
  distinct_on?: Maybe<Array<Public_Project_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Public_Project_Details_Order_By>>;
  where?: Maybe<Public_Project_Details_Bool_Exp>;
};


export type Query_RootPublic_Project_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Public_Project_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Public_Project_Details_Order_By>>;
  where?: Maybe<Public_Project_Details_Bool_Exp>;
};


export type Query_RootRecipient_MessageArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


export type Query_RootRecipient_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


export type Query_RootRecipient_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootResource_Information_CardArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


export type Query_RootResource_Information_Card_AggregateArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


export type Query_RootResource_Information_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSearch_IndustryArgs = {
  args: Search_Industry_Args;
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Query_RootSearch_Industry_AggregateArgs = {
  args: Search_Industry_Args;
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Query_RootSearch_SkillArgs = {
  args: Search_Skill_Args;
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Query_RootSearch_Skill_AggregateArgs = {
  args: Search_Skill_Args;
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Query_RootSkillArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Query_RootSkill_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Query_RootSkill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSkills_Short_Name_FirstArgs = {
  distinct_on?: Maybe<Array<Skills_Short_Name_First_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skills_Short_Name_First_Order_By>>;
  where?: Maybe<Skills_Short_Name_First_Bool_Exp>;
};


export type Query_RootSkills_Short_Name_First_AggregateArgs = {
  distinct_on?: Maybe<Array<Skills_Short_Name_First_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skills_Short_Name_First_Order_By>>;
  where?: Maybe<Skills_Short_Name_First_Bool_Exp>;
};


export type Query_RootSmart_Match_BookmarkArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


export type Query_RootSmart_Match_Bookmark_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


export type Query_RootSmart_Match_Bookmark_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSmart_Match_Config_TransportationArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Config_Transportation_Order_By>>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};


export type Query_RootSmart_Match_Config_Transportation_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Config_Transportation_Order_By>>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};


export type Query_RootSmart_Match_Config_Transportation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSmart_Match_ConfigsArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Configs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Configs_Order_By>>;
  where?: Maybe<Smart_Match_Configs_Bool_Exp>;
};


export type Query_RootSmart_Match_Configs_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Configs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Configs_Order_By>>;
  where?: Maybe<Smart_Match_Configs_Bool_Exp>;
};


export type Query_RootSmart_Match_Configs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSmart_Match_Criteria_OrderArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Criteria_Order_Order_By>>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};


export type Query_RootSmart_Match_Criteria_Order_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Criteria_Order_Order_By>>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};


export type Query_RootSmart_Match_Criteria_Order_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSoft_SkillArgs = {
  distinct_on?: Maybe<Array<Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Soft_Skill_Order_By>>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};


export type Query_RootSoft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Soft_Skill_Order_By>>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};


export type Query_RootSoft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSourceArgs = {
  distinct_on?: Maybe<Array<Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Source_Order_By>>;
  where?: Maybe<Source_Bool_Exp>;
};


export type Query_RootSource_AggregateArgs = {
  distinct_on?: Maybe<Array<Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Source_Order_By>>;
  where?: Maybe<Source_Bool_Exp>;
};


export type Query_RootSource_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscriptionArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


export type Query_RootSubscription_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


export type Query_RootSubscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_PlanArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Order_By>>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};


export type Query_RootSubscription_Plan_Access_PermissionsArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Access_Permissions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Access_Permissions_Order_By>>;
  where?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
};


export type Query_RootSubscription_Plan_Access_Permissions_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Access_Permissions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Access_Permissions_Order_By>>;
  where?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
};


export type Query_RootSubscription_Plan_Access_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscription_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Order_By>>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};


export type Query_RootSubscription_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTagArgs = {
  distinct_on?: Maybe<Array<Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tag_Order_By>>;
  where?: Maybe<Tag_Bool_Exp>;
};


export type Query_RootTag_AggregateArgs = {
  distinct_on?: Maybe<Array<Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tag_Order_By>>;
  where?: Maybe<Tag_Bool_Exp>;
};


export type Query_RootTag_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTeamArgs = {
  distinct_on?: Maybe<Array<Team_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Order_By>>;
  where?: Maybe<Team_Bool_Exp>;
};


export type Query_RootTeam_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Order_By>>;
  where?: Maybe<Team_Bool_Exp>;
};


export type Query_RootTeam_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTeam_ContractorArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


export type Query_RootTeam_Contractor_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


export type Query_RootTeam_Contractor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTeam_ManagerArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


export type Query_RootTeam_Manager_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


export type Query_RootTeam_Manager_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTeam_PostingArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


export type Query_RootTeam_Posting_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


export type Query_RootTeam_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTeam_ProjectArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


export type Query_RootTeam_Project_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


export type Query_RootTeam_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTeam_SkillArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


export type Query_RootTeam_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


export type Query_RootTeam_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTimesheetArgs = {
  distinct_on?: Maybe<Array<Timesheet_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Timesheet_Order_By>>;
  where?: Maybe<Timesheet_Bool_Exp>;
};


export type Query_RootTimesheet_AggregateArgs = {
  distinct_on?: Maybe<Array<Timesheet_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Timesheet_Order_By>>;
  where?: Maybe<Timesheet_Bool_Exp>;
};


export type Query_RootTimesheet_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootType_Of_VisitArgs = {
  distinct_on?: Maybe<Array<Type_Of_Visit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Of_Visit_Order_By>>;
  where?: Maybe<Type_Of_Visit_Bool_Exp>;
};


export type Query_RootType_Of_Visit_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Of_Visit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Of_Visit_Order_By>>;
  where?: Maybe<Type_Of_Visit_Bool_Exp>;
};


export type Query_RootType_Of_Visit_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootUnread_MessagesArgs = {
  distinct_on?: Maybe<Array<Unread_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unread_Messages_Order_By>>;
  where?: Maybe<Unread_Messages_Bool_Exp>;
};


export type Query_RootUnread_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Unread_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unread_Messages_Order_By>>;
  where?: Maybe<Unread_Messages_Bool_Exp>;
};


export type Query_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Query_RootUser_Affinda_ProfileArgs = {
  distinct_on?: Maybe<Array<User_Affinda_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Affinda_Profile_Order_By>>;
  where?: Maybe<User_Affinda_Profile_Bool_Exp>;
};


export type Query_RootUser_Affinda_Profile_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Affinda_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Affinda_Profile_Order_By>>;
  where?: Maybe<User_Affinda_Profile_Bool_Exp>;
};


export type Query_RootUser_Affinda_Profile_By_PkArgs = {
  document_id: Scalars['String'];
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_CertificationArgs = {
  distinct_on?: Maybe<Array<User_Certification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Certification_Order_By>>;
  where?: Maybe<User_Certification_Bool_Exp>;
};


export type Query_RootUser_Certification_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Certification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Certification_Order_By>>;
  where?: Maybe<User_Certification_Bool_Exp>;
};


export type Query_RootUser_Certification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_CompanyArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


export type Query_RootUser_Company_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


export type Query_RootUser_Company_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_ConversationArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


export type Query_RootUser_Conversation_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


export type Query_RootUser_Conversation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_EducationArgs = {
  distinct_on?: Maybe<Array<User_Education_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Education_Order_By>>;
  where?: Maybe<User_Education_Bool_Exp>;
};


export type Query_RootUser_Education_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Education_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Education_Order_By>>;
  where?: Maybe<User_Education_Bool_Exp>;
};


export type Query_RootUser_Education_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_ExperienceArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


export type Query_RootUser_Experience_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


export type Query_RootUser_Experience_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_FavoriteArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


export type Query_RootUser_Favorite_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


export type Query_RootUser_Favorite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_IndustryArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


export type Query_RootUser_Industry_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


export type Query_RootUser_Industry_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Job_TitleArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


export type Query_RootUser_Job_Title_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


export type Query_RootUser_Job_Title_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_LanguageArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


export type Query_RootUser_Language_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


export type Query_RootUser_Language_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Private_DataArgs = {
  distinct_on?: Maybe<Array<User_Private_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Private_Data_Order_By>>;
  where?: Maybe<User_Private_Data_Bool_Exp>;
};


export type Query_RootUser_Private_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Private_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Private_Data_Order_By>>;
  where?: Maybe<User_Private_Data_Bool_Exp>;
};


export type Query_RootUser_ProfileArgs = {
  distinct_on?: Maybe<Array<User_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_Order_By>>;
  where?: Maybe<User_Profile_Bool_Exp>;
};


export type Query_RootUser_Profile_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_Order_By>>;
  where?: Maybe<User_Profile_Bool_Exp>;
};


export type Query_RootUser_Profile_By_ManagementArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


export type Query_RootUser_Profile_By_Management_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


export type Query_RootUser_Profile_By_Management_By_PkArgs = {
  added_by_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Query_RootUser_Profile_By_PkArgs = {
  user_id: Scalars['uuid'];
};


export type Query_RootUser_RatingArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


export type Query_RootUser_Rating_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


export type Query_RootUser_Rating_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_SkillArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


export type Query_RootUser_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


export type Query_RootUser_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Soft_SkillArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


export type Query_RootUser_Soft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


export type Query_RootUser_Soft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_TransportationArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


export type Query_RootUser_Transportation_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


export type Query_RootUser_Transportation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_WatchlistArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};


export type Query_RootUser_Watchlist_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};


export type Query_RootUser_Watchlist_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "recipient_message" */
export type Recipient_Message = {
  __typename?: 'recipient_message';
  /** An object relationship */
  conversation: Conversation;
  conversation_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  message: Message;
  message_id: Scalars['uuid'];
  notified_by_email: Scalars['Boolean'];
  notified_in_app: Scalars['Boolean'];
  read: Scalars['Boolean'];
  /** An object relationship */
  recipient: User;
  recipient_id: Scalars['uuid'];
};

/** aggregated selection of "recipient_message" */
export type Recipient_Message_Aggregate = {
  __typename?: 'recipient_message_aggregate';
  aggregate?: Maybe<Recipient_Message_Aggregate_Fields>;
  nodes: Array<Recipient_Message>;
};

export type Recipient_Message_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Recipient_Message_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Recipient_Message_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Recipient_Message_Aggregate_Bool_Exp_Count>;
};

export type Recipient_Message_Aggregate_Bool_Exp_Bool_And = {
  arguments: Recipient_Message_Select_Column_Recipient_Message_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Recipient_Message_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Recipient_Message_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Recipient_Message_Select_Column_Recipient_Message_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Recipient_Message_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Recipient_Message_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Recipient_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Recipient_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "recipient_message" */
export type Recipient_Message_Aggregate_Fields = {
  __typename?: 'recipient_message_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Recipient_Message_Max_Fields>;
  min?: Maybe<Recipient_Message_Min_Fields>;
};


/** aggregate fields of "recipient_message" */
export type Recipient_Message_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Recipient_Message_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recipient_message" */
export type Recipient_Message_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Recipient_Message_Max_Order_By>;
  min?: Maybe<Recipient_Message_Min_Order_By>;
};

/** input type for inserting array relation for remote table "recipient_message" */
export type Recipient_Message_Arr_Rel_Insert_Input = {
  data: Array<Recipient_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Recipient_Message_On_Conflict>;
};

/** Boolean expression to filter rows from the table "recipient_message". All fields are combined with a logical 'AND'. */
export type Recipient_Message_Bool_Exp = {
  _and?: Maybe<Array<Recipient_Message_Bool_Exp>>;
  _not?: Maybe<Recipient_Message_Bool_Exp>;
  _or?: Maybe<Array<Recipient_Message_Bool_Exp>>;
  conversation?: Maybe<Conversation_Bool_Exp>;
  conversation_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  message?: Maybe<Message_Bool_Exp>;
  message_id?: Maybe<Uuid_Comparison_Exp>;
  notified_by_email?: Maybe<Boolean_Comparison_Exp>;
  notified_in_app?: Maybe<Boolean_Comparison_Exp>;
  read?: Maybe<Boolean_Comparison_Exp>;
  recipient?: Maybe<User_Bool_Exp>;
  recipient_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "recipient_message" */
export enum Recipient_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  RecipientMessagePkey = 'recipient_message_pkey'
}

/** input type for inserting data into table "recipient_message" */
export type Recipient_Message_Insert_Input = {
  conversation?: Maybe<Conversation_Obj_Rel_Insert_Input>;
  conversation_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Message_Obj_Rel_Insert_Input>;
  message_id?: Maybe<Scalars['uuid']>;
  notified_by_email?: Maybe<Scalars['Boolean']>;
  notified_in_app?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  recipient?: Maybe<User_Obj_Rel_Insert_Input>;
  recipient_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Recipient_Message_Max_Fields = {
  __typename?: 'recipient_message_max_fields';
  conversation_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  recipient_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "recipient_message" */
export type Recipient_Message_Max_Order_By = {
  conversation_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message_id?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Recipient_Message_Min_Fields = {
  __typename?: 'recipient_message_min_fields';
  conversation_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  recipient_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "recipient_message" */
export type Recipient_Message_Min_Order_By = {
  conversation_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message_id?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "recipient_message" */
export type Recipient_Message_Mutation_Response = {
  __typename?: 'recipient_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recipient_Message>;
};

/** on_conflict condition type for table "recipient_message" */
export type Recipient_Message_On_Conflict = {
  constraint: Recipient_Message_Constraint;
  update_columns?: Array<Recipient_Message_Update_Column>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "recipient_message". */
export type Recipient_Message_Order_By = {
  conversation?: Maybe<Conversation_Order_By>;
  conversation_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Message_Order_By>;
  message_id?: Maybe<Order_By>;
  notified_by_email?: Maybe<Order_By>;
  notified_in_app?: Maybe<Order_By>;
  read?: Maybe<Order_By>;
  recipient?: Maybe<User_Order_By>;
  recipient_id?: Maybe<Order_By>;
};

/** primary key columns input for table: recipient_message */
export type Recipient_Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "recipient_message" */
export enum Recipient_Message_Select_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read',
  /** column name */
  RecipientId = 'recipient_id'
}

/** select "recipient_message_aggregate_bool_exp_bool_and_arguments_columns" columns of table "recipient_message" */
export enum Recipient_Message_Select_Column_Recipient_Message_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read'
}

/** select "recipient_message_aggregate_bool_exp_bool_or_arguments_columns" columns of table "recipient_message" */
export enum Recipient_Message_Select_Column_Recipient_Message_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read'
}

/** input type for updating data in table "recipient_message" */
export type Recipient_Message_Set_Input = {
  conversation_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  notified_by_email?: Maybe<Scalars['Boolean']>;
  notified_in_app?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  recipient_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "recipient_message" */
export type Recipient_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Recipient_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Recipient_Message_Stream_Cursor_Value_Input = {
  conversation_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['uuid']>;
  notified_by_email?: Maybe<Scalars['Boolean']>;
  notified_in_app?: Maybe<Scalars['Boolean']>;
  read?: Maybe<Scalars['Boolean']>;
  recipient_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "recipient_message" */
export enum Recipient_Message_Update_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NotifiedByEmail = 'notified_by_email',
  /** column name */
  NotifiedInApp = 'notified_in_app',
  /** column name */
  Read = 'read',
  /** column name */
  RecipientId = 'recipient_id'
}

export type Recipient_Message_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Recipient_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Recipient_Message_Bool_Exp;
};

/** columns and relationships of "resource_information_card" */
export type Resource_Information_Card = {
  __typename?: 'resource_information_card';
  availability?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  contractor?: Maybe<Contractor>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  /** An object relationship */
  source?: Maybe<Source>;
  source_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  tag?: Maybe<Tag>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "resource_information_card" */
export type Resource_Information_Card_Aggregate = {
  __typename?: 'resource_information_card_aggregate';
  aggregate?: Maybe<Resource_Information_Card_Aggregate_Fields>;
  nodes: Array<Resource_Information_Card>;
};

export type Resource_Information_Card_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Resource_Information_Card_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Resource_Information_Card_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Resource_Information_Card_Aggregate_Bool_Exp_Count>;
};

export type Resource_Information_Card_Aggregate_Bool_Exp_Bool_And = {
  arguments: Resource_Information_Card_Select_Column_Resource_Information_Card_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Resource_Information_Card_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Resource_Information_Card_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Resource_Information_Card_Select_Column_Resource_Information_Card_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Resource_Information_Card_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Resource_Information_Card_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Resource_Information_Card_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "resource_information_card" */
export type Resource_Information_Card_Aggregate_Fields = {
  __typename?: 'resource_information_card_aggregate_fields';
  avg?: Maybe<Resource_Information_Card_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Resource_Information_Card_Max_Fields>;
  min?: Maybe<Resource_Information_Card_Min_Fields>;
  stddev?: Maybe<Resource_Information_Card_Stddev_Fields>;
  stddev_pop?: Maybe<Resource_Information_Card_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Resource_Information_Card_Stddev_Samp_Fields>;
  sum?: Maybe<Resource_Information_Card_Sum_Fields>;
  var_pop?: Maybe<Resource_Information_Card_Var_Pop_Fields>;
  var_samp?: Maybe<Resource_Information_Card_Var_Samp_Fields>;
  variance?: Maybe<Resource_Information_Card_Variance_Fields>;
};


/** aggregate fields of "resource_information_card" */
export type Resource_Information_Card_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "resource_information_card" */
export type Resource_Information_Card_Aggregate_Order_By = {
  avg?: Maybe<Resource_Information_Card_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Resource_Information_Card_Max_Order_By>;
  min?: Maybe<Resource_Information_Card_Min_Order_By>;
  stddev?: Maybe<Resource_Information_Card_Stddev_Order_By>;
  stddev_pop?: Maybe<Resource_Information_Card_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Resource_Information_Card_Stddev_Samp_Order_By>;
  sum?: Maybe<Resource_Information_Card_Sum_Order_By>;
  var_pop?: Maybe<Resource_Information_Card_Var_Pop_Order_By>;
  var_samp?: Maybe<Resource_Information_Card_Var_Samp_Order_By>;
  variance?: Maybe<Resource_Information_Card_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "resource_information_card" */
export type Resource_Information_Card_Arr_Rel_Insert_Input = {
  data: Array<Resource_Information_Card_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Resource_Information_Card_On_Conflict>;
};

/** aggregate avg on columns */
export type Resource_Information_Card_Avg_Fields = {
  __typename?: 'resource_information_card_avg_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "resource_information_card" */
export type Resource_Information_Card_Avg_Order_By = {
  rate?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "resource_information_card". All fields are combined with a logical 'AND'. */
export type Resource_Information_Card_Bool_Exp = {
  _and?: Maybe<Array<Resource_Information_Card_Bool_Exp>>;
  _not?: Maybe<Resource_Information_Card_Bool_Exp>;
  _or?: Maybe<Array<Resource_Information_Card_Bool_Exp>>;
  availability?: Maybe<Boolean_Comparison_Exp>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  from_date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  profile_link?: Maybe<String_Comparison_Exp>;
  rate?: Maybe<Int_Comparison_Exp>;
  source?: Maybe<Source_Bool_Exp>;
  source_id?: Maybe<Uuid_Comparison_Exp>;
  tag?: Maybe<Tag_Bool_Exp>;
  tag_id?: Maybe<Uuid_Comparison_Exp>;
  to_date?: Maybe<Date_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_information_card" */
export enum Resource_Information_Card_Constraint {
  /** unique or primary key constraint on columns "id" */
  ResourceInformationCardPkey = 'resource_information_card_pkey'
}

/** input type for incrementing numeric columns in table "resource_information_card" */
export type Resource_Information_Card_Inc_Input = {
  rate?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "resource_information_card" */
export type Resource_Information_Card_Insert_Input = {
  availability?: Maybe<Scalars['Boolean']>;
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source?: Maybe<Source_Obj_Rel_Insert_Input>;
  source_id?: Maybe<Scalars['uuid']>;
  tag?: Maybe<Tag_Obj_Rel_Insert_Input>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Resource_Information_Card_Max_Fields = {
  __typename?: 'resource_information_card_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "resource_information_card" */
export type Resource_Information_Card_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  profile_link?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  source_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Resource_Information_Card_Min_Fields = {
  __typename?: 'resource_information_card_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "resource_information_card" */
export type Resource_Information_Card_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  profile_link?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  source_id?: Maybe<Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "resource_information_card" */
export type Resource_Information_Card_Mutation_Response = {
  __typename?: 'resource_information_card_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Information_Card>;
};

/** on_conflict condition type for table "resource_information_card" */
export type Resource_Information_Card_On_Conflict = {
  constraint: Resource_Information_Card_Constraint;
  update_columns?: Array<Resource_Information_Card_Update_Column>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_information_card". */
export type Resource_Information_Card_Order_By = {
  availability?: Maybe<Order_By>;
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  from_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  profile_link?: Maybe<Order_By>;
  rate?: Maybe<Order_By>;
  source?: Maybe<Source_Order_By>;
  source_id?: Maybe<Order_By>;
  tag?: Maybe<Tag_Order_By>;
  tag_id?: Maybe<Order_By>;
  to_date?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: resource_information_card */
export type Resource_Information_Card_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "resource_information_card" */
export enum Resource_Information_Card_Select_Column {
  /** column name */
  Availability = 'availability',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FromDate = 'from_date',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProfileLink = 'profile_link',
  /** column name */
  Rate = 'rate',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  ToDate = 'to_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "resource_information_card_aggregate_bool_exp_bool_and_arguments_columns" columns of table "resource_information_card" */
export enum Resource_Information_Card_Select_Column_Resource_Information_Card_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Availability = 'availability'
}

/** select "resource_information_card_aggregate_bool_exp_bool_or_arguments_columns" columns of table "resource_information_card" */
export enum Resource_Information_Card_Select_Column_Resource_Information_Card_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Availability = 'availability'
}

/** input type for updating data in table "resource_information_card" */
export type Resource_Information_Card_Set_Input = {
  availability?: Maybe<Scalars['Boolean']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Resource_Information_Card_Stddev_Fields = {
  __typename?: 'resource_information_card_stddev_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "resource_information_card" */
export type Resource_Information_Card_Stddev_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Resource_Information_Card_Stddev_Pop_Fields = {
  __typename?: 'resource_information_card_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "resource_information_card" */
export type Resource_Information_Card_Stddev_Pop_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Resource_Information_Card_Stddev_Samp_Fields = {
  __typename?: 'resource_information_card_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "resource_information_card" */
export type Resource_Information_Card_Stddev_Samp_Order_By = {
  rate?: Maybe<Order_By>;
};

/** Streaming cursor of the table "resource_information_card" */
export type Resource_Information_Card_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Information_Card_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Information_Card_Stream_Cursor_Value_Input = {
  availability?: Maybe<Scalars['Boolean']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  notes?: Maybe<Scalars['String']>;
  profile_link?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
  to_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Resource_Information_Card_Sum_Fields = {
  __typename?: 'resource_information_card_sum_fields';
  rate?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "resource_information_card" */
export type Resource_Information_Card_Sum_Order_By = {
  rate?: Maybe<Order_By>;
};

/** update columns of table "resource_information_card" */
export enum Resource_Information_Card_Update_Column {
  /** column name */
  Availability = 'availability',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FromDate = 'from_date',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProfileLink = 'profile_link',
  /** column name */
  Rate = 'rate',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  ToDate = 'to_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Resource_Information_Card_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Resource_Information_Card_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Resource_Information_Card_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Information_Card_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Resource_Information_Card_Var_Pop_Fields = {
  __typename?: 'resource_information_card_var_pop_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "resource_information_card" */
export type Resource_Information_Card_Var_Pop_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Resource_Information_Card_Var_Samp_Fields = {
  __typename?: 'resource_information_card_var_samp_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "resource_information_card" */
export type Resource_Information_Card_Var_Samp_Order_By = {
  rate?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Resource_Information_Card_Variance_Fields = {
  __typename?: 'resource_information_card_variance_fields';
  rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "resource_information_card" */
export type Resource_Information_Card_Variance_Order_By = {
  rate?: Maybe<Order_By>;
};

export type Search_Industry_Args = {
  search?: Maybe<Scalars['String']>;
};

export type Search_Skill_Args = {
  search?: Maybe<Scalars['String']>;
};

/** columns and relationships of "skill" */
export type Skill = {
  __typename?: 'skill';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  custom_request_skills: Array<Custom_Request_Skills>;
  /** An aggregate relationship */
  custom_request_skills_aggregate: Custom_Request_Skills_Aggregate;
  /** An array relationship */
  experiences: Array<Experience_Skill>;
  /** An aggregate relationship */
  experiences_aggregate: Experience_Skill_Aggregate;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  postings: Array<Posting_Skill>;
  /** An aggregate relationship */
  postings_aggregate: Posting_Skill_Aggregate;
  /** An array relationship */
  project_activity_skills: Array<Project_Activity_Skill>;
  /** An aggregate relationship */
  project_activity_skills_aggregate: Project_Activity_Skill_Aggregate;
  /** An array relationship */
  project_skills: Array<Project_Skill>;
  /** An aggregate relationship */
  project_skills_aggregate: Project_Skill_Aggregate;
  /** An array relationship */
  teams: Array<Team_Skill>;
  /** An aggregate relationship */
  teams_aggregate: Team_Skill_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  users: Array<User_Skill>;
  /** An aggregate relationship */
  users_aggregate: User_Skill_Aggregate;
};


/** columns and relationships of "skill" */
export type SkillCustom_Request_SkillsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillCustom_Request_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillExperiencesArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillExperiences_AggregateArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillPostingsArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillPostings_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillProject_Activity_SkillsArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillProject_Activity_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillProject_SkillsArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillProject_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillTeamsArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillTeams_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillUsersArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


/** columns and relationships of "skill" */
export type SkillUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};

/** aggregated selection of "skill" */
export type Skill_Aggregate = {
  __typename?: 'skill_aggregate';
  aggregate?: Maybe<Skill_Aggregate_Fields>;
  nodes: Array<Skill>;
};

export type Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Skill_Aggregate_Bool_Exp_Count>;
};

export type Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "skill" */
export type Skill_Aggregate_Fields = {
  __typename?: 'skill_aggregate_fields';
  avg?: Maybe<Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skill_Max_Fields>;
  min?: Maybe<Skill_Min_Fields>;
  stddev?: Maybe<Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Skill_Sum_Fields>;
  var_pop?: Maybe<Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Skill_Var_Samp_Fields>;
  variance?: Maybe<Skill_Variance_Fields>;
};


/** aggregate fields of "skill" */
export type Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "skill" */
export type Skill_Aggregate_Order_By = {
  avg?: Maybe<Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Skill_Max_Order_By>;
  min?: Maybe<Skill_Min_Order_By>;
  stddev?: Maybe<Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Skill_Sum_Order_By>;
  var_pop?: Maybe<Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Skill_Var_Samp_Order_By>;
  variance?: Maybe<Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "skill" */
export type Skill_Arr_Rel_Insert_Input = {
  data: Array<Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Skill_Avg_Fields = {
  __typename?: 'skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "skill" */
export type Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "skill". All fields are combined with a logical 'AND'. */
export type Skill_Bool_Exp = {
  _and?: Maybe<Array<Skill_Bool_Exp>>;
  _not?: Maybe<Skill_Bool_Exp>;
  _or?: Maybe<Array<Skill_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  custom_request_skills?: Maybe<Custom_Request_Skills_Bool_Exp>;
  custom_request_skills_aggregate?: Maybe<Custom_Request_Skills_Aggregate_Bool_Exp>;
  experiences?: Maybe<Experience_Skill_Bool_Exp>;
  experiences_aggregate?: Maybe<Experience_Skill_Aggregate_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  postings?: Maybe<Posting_Skill_Bool_Exp>;
  postings_aggregate?: Maybe<Posting_Skill_Aggregate_Bool_Exp>;
  project_activity_skills?: Maybe<Project_Activity_Skill_Bool_Exp>;
  project_activity_skills_aggregate?: Maybe<Project_Activity_Skill_Aggregate_Bool_Exp>;
  project_skills?: Maybe<Project_Skill_Bool_Exp>;
  project_skills_aggregate?: Maybe<Project_Skill_Aggregate_Bool_Exp>;
  teams?: Maybe<Team_Skill_Bool_Exp>;
  teams_aggregate?: Maybe<Team_Skill_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  users?: Maybe<User_Skill_Bool_Exp>;
  users_aggregate?: Maybe<User_Skill_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "skill" */
export enum Skill_Constraint {
  /** unique or primary key constraint on columns "name", "company_id" */
  SkillNameCompanyIdKey = 'skill_name_company_id_key',
  /** unique or primary key constraint on columns "user_id", "name" */
  SkillNameUserIdKey = 'skill_name_user_id_key',
  /** unique or primary key constraint on columns "id" */
  SkillPkey = 'skill_pkey'
}

/** input type for incrementing numeric columns in table "skill" */
export type Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "skill" */
export type Skill_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_request_skills?: Maybe<Custom_Request_Skills_Arr_Rel_Insert_Input>;
  experiences?: Maybe<Experience_Skill_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  postings?: Maybe<Posting_Skill_Arr_Rel_Insert_Input>;
  project_activity_skills?: Maybe<Project_Activity_Skill_Arr_Rel_Insert_Input>;
  project_skills?: Maybe<Project_Skill_Arr_Rel_Insert_Input>;
  teams?: Maybe<Team_Skill_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  users?: Maybe<User_Skill_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Skill_Max_Fields = {
  __typename?: 'skill_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "skill" */
export type Skill_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Skill_Min_Fields = {
  __typename?: 'skill_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "skill" */
export type Skill_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "skill" */
export type Skill_Mutation_Response = {
  __typename?: 'skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skill>;
};

/** input type for inserting object relation for remote table "skill" */
export type Skill_Obj_Rel_Insert_Input = {
  data: Skill_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Skill_On_Conflict>;
};

/** on_conflict condition type for table "skill" */
export type Skill_On_Conflict = {
  constraint: Skill_Constraint;
  update_columns?: Array<Skill_Update_Column>;
  where?: Maybe<Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "skill". */
export type Skill_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  custom_request_skills_aggregate?: Maybe<Custom_Request_Skills_Aggregate_Order_By>;
  experiences_aggregate?: Maybe<Experience_Skill_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  postings_aggregate?: Maybe<Posting_Skill_Aggregate_Order_By>;
  project_activity_skills_aggregate?: Maybe<Project_Activity_Skill_Aggregate_Order_By>;
  project_skills_aggregate?: Maybe<Project_Skill_Aggregate_Order_By>;
  teams_aggregate?: Maybe<Team_Skill_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
  users_aggregate?: Maybe<User_Skill_Aggregate_Order_By>;
};

/** primary key columns input for table: skill */
export type Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "skill" */
export enum Skill_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "skill" */
export type Skill_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Skill_Stddev_Fields = {
  __typename?: 'skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "skill" */
export type Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Skill_Stddev_Pop_Fields = {
  __typename?: 'skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "skill" */
export type Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Skill_Stddev_Samp_Fields = {
  __typename?: 'skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "skill" */
export type Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "skill" */
export type Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skill_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Skill_Sum_Fields = {
  __typename?: 'skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "skill" */
export type Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "skill" */
export enum Skill_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skill_Var_Pop_Fields = {
  __typename?: 'skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "skill" */
export type Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Skill_Var_Samp_Fields = {
  __typename?: 'skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "skill" */
export type Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Skill_Variance_Fields = {
  __typename?: 'skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "skill" */
export type Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "skills_short_name_first" */
export type Skills_Short_Name_First = {
  __typename?: 'skills_short_name_first';
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "skills_short_name_first" */
export type Skills_Short_Name_First_Aggregate = {
  __typename?: 'skills_short_name_first_aggregate';
  aggregate?: Maybe<Skills_Short_Name_First_Aggregate_Fields>;
  nodes: Array<Skills_Short_Name_First>;
};

/** aggregate fields of "skills_short_name_first" */
export type Skills_Short_Name_First_Aggregate_Fields = {
  __typename?: 'skills_short_name_first_aggregate_fields';
  avg?: Maybe<Skills_Short_Name_First_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Skills_Short_Name_First_Max_Fields>;
  min?: Maybe<Skills_Short_Name_First_Min_Fields>;
  stddev?: Maybe<Skills_Short_Name_First_Stddev_Fields>;
  stddev_pop?: Maybe<Skills_Short_Name_First_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Skills_Short_Name_First_Stddev_Samp_Fields>;
  sum?: Maybe<Skills_Short_Name_First_Sum_Fields>;
  var_pop?: Maybe<Skills_Short_Name_First_Var_Pop_Fields>;
  var_samp?: Maybe<Skills_Short_Name_First_Var_Samp_Fields>;
  variance?: Maybe<Skills_Short_Name_First_Variance_Fields>;
};


/** aggregate fields of "skills_short_name_first" */
export type Skills_Short_Name_First_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Skills_Short_Name_First_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Skills_Short_Name_First_Avg_Fields = {
  __typename?: 'skills_short_name_first_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "skills_short_name_first". All fields are combined with a logical 'AND'. */
export type Skills_Short_Name_First_Bool_Exp = {
  _and?: Maybe<Array<Skills_Short_Name_First_Bool_Exp>>;
  _not?: Maybe<Skills_Short_Name_First_Bool_Exp>;
  _or?: Maybe<Array<Skills_Short_Name_First_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "skills_short_name_first" */
export type Skills_Short_Name_First_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "skills_short_name_first" */
export type Skills_Short_Name_First_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Skills_Short_Name_First_Max_Fields = {
  __typename?: 'skills_short_name_first_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Skills_Short_Name_First_Min_Fields = {
  __typename?: 'skills_short_name_first_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "skills_short_name_first" */
export type Skills_Short_Name_First_Mutation_Response = {
  __typename?: 'skills_short_name_first_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Skills_Short_Name_First>;
};

/** Ordering options when selecting data from "skills_short_name_first". */
export type Skills_Short_Name_First_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** select columns of table "skills_short_name_first" */
export enum Skills_Short_Name_First_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "skills_short_name_first" */
export type Skills_Short_Name_First_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Skills_Short_Name_First_Stddev_Fields = {
  __typename?: 'skills_short_name_first_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Skills_Short_Name_First_Stddev_Pop_Fields = {
  __typename?: 'skills_short_name_first_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Skills_Short_Name_First_Stddev_Samp_Fields = {
  __typename?: 'skills_short_name_first_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "skills_short_name_first" */
export type Skills_Short_Name_First_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Skills_Short_Name_First_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Skills_Short_Name_First_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Skills_Short_Name_First_Sum_Fields = {
  __typename?: 'skills_short_name_first_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

export type Skills_Short_Name_First_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Skills_Short_Name_First_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Skills_Short_Name_First_Set_Input>;
  /** filter the rows which have to be updated */
  where: Skills_Short_Name_First_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Skills_Short_Name_First_Var_Pop_Fields = {
  __typename?: 'skills_short_name_first_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Skills_Short_Name_First_Var_Samp_Fields = {
  __typename?: 'skills_short_name_first_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Skills_Short_Name_First_Variance_Fields = {
  __typename?: 'skills_short_name_first_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "smart_match_bookmark" */
export type Smart_Match_Bookmark = {
  __typename?: 'smart_match_bookmark';
  /** An object relationship */
  admin?: Maybe<Admin>;
  admin_id?: Maybe<Scalars['uuid']>;
  bookmarked_at: Scalars['timestamptz'];
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  declined_visit_matches: Array<Declined_Visit_Matches>;
  /** An aggregate relationship */
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  manager?: Maybe<Manager>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage: Scalars['Int'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "smart_match_bookmark" */
export type Smart_Match_BookmarkDeclined_Visit_MatchesArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "smart_match_bookmark" */
export type Smart_Match_BookmarkDeclined_Visit_Matches_AggregateArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};

/** aggregated selection of "smart_match_bookmark" */
export type Smart_Match_Bookmark_Aggregate = {
  __typename?: 'smart_match_bookmark_aggregate';
  aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Fields>;
  nodes: Array<Smart_Match_Bookmark>;
};

export type Smart_Match_Bookmark_Aggregate_Bool_Exp = {
  count?: Maybe<Smart_Match_Bookmark_Aggregate_Bool_Exp_Count>;
};

export type Smart_Match_Bookmark_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "smart_match_bookmark" */
export type Smart_Match_Bookmark_Aggregate_Fields = {
  __typename?: 'smart_match_bookmark_aggregate_fields';
  avg?: Maybe<Smart_Match_Bookmark_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Smart_Match_Bookmark_Max_Fields>;
  min?: Maybe<Smart_Match_Bookmark_Min_Fields>;
  stddev?: Maybe<Smart_Match_Bookmark_Stddev_Fields>;
  stddev_pop?: Maybe<Smart_Match_Bookmark_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Smart_Match_Bookmark_Stddev_Samp_Fields>;
  sum?: Maybe<Smart_Match_Bookmark_Sum_Fields>;
  var_pop?: Maybe<Smart_Match_Bookmark_Var_Pop_Fields>;
  var_samp?: Maybe<Smart_Match_Bookmark_Var_Samp_Fields>;
  variance?: Maybe<Smart_Match_Bookmark_Variance_Fields>;
};


/** aggregate fields of "smart_match_bookmark" */
export type Smart_Match_Bookmark_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Aggregate_Order_By = {
  avg?: Maybe<Smart_Match_Bookmark_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Smart_Match_Bookmark_Max_Order_By>;
  min?: Maybe<Smart_Match_Bookmark_Min_Order_By>;
  stddev?: Maybe<Smart_Match_Bookmark_Stddev_Order_By>;
  stddev_pop?: Maybe<Smart_Match_Bookmark_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Smart_Match_Bookmark_Stddev_Samp_Order_By>;
  sum?: Maybe<Smart_Match_Bookmark_Sum_Order_By>;
  var_pop?: Maybe<Smart_Match_Bookmark_Var_Pop_Order_By>;
  var_samp?: Maybe<Smart_Match_Bookmark_Var_Samp_Order_By>;
  variance?: Maybe<Smart_Match_Bookmark_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Arr_Rel_Insert_Input = {
  data: Array<Smart_Match_Bookmark_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Smart_Match_Bookmark_On_Conflict>;
};

/** aggregate avg on columns */
export type Smart_Match_Bookmark_Avg_Fields = {
  __typename?: 'smart_match_bookmark_avg_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Avg_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "smart_match_bookmark". All fields are combined with a logical 'AND'. */
export type Smart_Match_Bookmark_Bool_Exp = {
  _and?: Maybe<Array<Smart_Match_Bookmark_Bool_Exp>>;
  _not?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
  _or?: Maybe<Array<Smart_Match_Bookmark_Bool_Exp>>;
  admin?: Maybe<Admin_Bool_Exp>;
  admin_id?: Maybe<Uuid_Comparison_Exp>;
  bookmarked_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Bool_Exp>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  match_percentage?: Maybe<Int_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "smart_match_bookmark" */
export enum Smart_Match_Bookmark_Constraint {
  /** unique or primary key constraint on columns "user_id", "manager_id", "project_id" */
  SmartMatchBookmarkManagerIdProjectIdUserIdKey = 'smart_match_bookmark_manager_id_project_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  SmartMatchBookmarkPkey = 'smart_match_bookmark_pkey',
  /** unique or primary key constraint on columns "user_id", "project_id", "admin_id" */
  SmartMatchBookmarkUserIdAdminIdProjectIdKey = 'smart_match_bookmark_user_id_admin_id_project_id_key'
}

/** input type for incrementing numeric columns in table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Inc_Input = {
  match_percentage?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Insert_Input = {
  admin?: Maybe<Admin_Obj_Rel_Insert_Input>;
  admin_id?: Maybe<Scalars['uuid']>;
  bookmarked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Smart_Match_Bookmark_Max_Fields = {
  __typename?: 'smart_match_bookmark_max_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  bookmarked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Max_Order_By = {
  admin_id?: Maybe<Order_By>;
  bookmarked_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  match_percentage?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Smart_Match_Bookmark_Min_Fields = {
  __typename?: 'smart_match_bookmark_min_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  bookmarked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Min_Order_By = {
  admin_id?: Maybe<Order_By>;
  bookmarked_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  match_percentage?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Mutation_Response = {
  __typename?: 'smart_match_bookmark_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Match_Bookmark>;
};

/** input type for inserting object relation for remote table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Obj_Rel_Insert_Input = {
  data: Smart_Match_Bookmark_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Smart_Match_Bookmark_On_Conflict>;
};

/** on_conflict condition type for table "smart_match_bookmark" */
export type Smart_Match_Bookmark_On_Conflict = {
  constraint: Smart_Match_Bookmark_Constraint;
  update_columns?: Array<Smart_Match_Bookmark_Update_Column>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};

/** Ordering options when selecting data from "smart_match_bookmark". */
export type Smart_Match_Bookmark_Order_By = {
  admin?: Maybe<Admin_Order_By>;
  admin_id?: Maybe<Order_By>;
  bookmarked_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
  match_percentage?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: smart_match_bookmark */
export type Smart_Match_Bookmark_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "smart_match_bookmark" */
export enum Smart_Match_Bookmark_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  BookmarkedAt = 'bookmarked_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MatchPercentage = 'match_percentage',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Set_Input = {
  admin_id?: Maybe<Scalars['uuid']>;
  bookmarked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Smart_Match_Bookmark_Stddev_Fields = {
  __typename?: 'smart_match_bookmark_stddev_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Stddev_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Smart_Match_Bookmark_Stddev_Pop_Fields = {
  __typename?: 'smart_match_bookmark_stddev_pop_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Stddev_Pop_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Smart_Match_Bookmark_Stddev_Samp_Fields = {
  __typename?: 'smart_match_bookmark_stddev_samp_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Stddev_Samp_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** Streaming cursor of the table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Match_Bookmark_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Match_Bookmark_Stream_Cursor_Value_Input = {
  admin_id?: Maybe<Scalars['uuid']>;
  bookmarked_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  match_percentage?: Maybe<Scalars['Int']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Smart_Match_Bookmark_Sum_Fields = {
  __typename?: 'smart_match_bookmark_sum_fields';
  match_percentage?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Sum_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** update columns of table "smart_match_bookmark" */
export enum Smart_Match_Bookmark_Update_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  BookmarkedAt = 'bookmarked_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  MatchPercentage = 'match_percentage',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Smart_Match_Bookmark_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Smart_Match_Bookmark_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Smart_Match_Bookmark_Set_Input>;
  /** filter the rows which have to be updated */
  where: Smart_Match_Bookmark_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Smart_Match_Bookmark_Var_Pop_Fields = {
  __typename?: 'smart_match_bookmark_var_pop_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Var_Pop_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Smart_Match_Bookmark_Var_Samp_Fields = {
  __typename?: 'smart_match_bookmark_var_samp_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Var_Samp_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Smart_Match_Bookmark_Variance_Fields = {
  __typename?: 'smart_match_bookmark_variance_fields';
  match_percentage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "smart_match_bookmark" */
export type Smart_Match_Bookmark_Variance_Order_By = {
  match_percentage?: Maybe<Order_By>;
};

/** columns and relationships of "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation = {
  __typename?: 'smart_match_config_transportation';
  config_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  smart_match_config: Smart_Match_Configs;
  transportation_type: Scalars['String'];
};

/** aggregated selection of "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Aggregate = {
  __typename?: 'smart_match_config_transportation_aggregate';
  aggregate?: Maybe<Smart_Match_Config_Transportation_Aggregate_Fields>;
  nodes: Array<Smart_Match_Config_Transportation>;
};

export type Smart_Match_Config_Transportation_Aggregate_Bool_Exp = {
  count?: Maybe<Smart_Match_Config_Transportation_Aggregate_Bool_Exp_Count>;
};

export type Smart_Match_Config_Transportation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Aggregate_Fields = {
  __typename?: 'smart_match_config_transportation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Smart_Match_Config_Transportation_Max_Fields>;
  min?: Maybe<Smart_Match_Config_Transportation_Min_Fields>;
};


/** aggregate fields of "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Smart_Match_Config_Transportation_Max_Order_By>;
  min?: Maybe<Smart_Match_Config_Transportation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Arr_Rel_Insert_Input = {
  data: Array<Smart_Match_Config_Transportation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Smart_Match_Config_Transportation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "smart_match_config_transportation". All fields are combined with a logical 'AND'. */
export type Smart_Match_Config_Transportation_Bool_Exp = {
  _and?: Maybe<Array<Smart_Match_Config_Transportation_Bool_Exp>>;
  _not?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
  _or?: Maybe<Array<Smart_Match_Config_Transportation_Bool_Exp>>;
  config_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  smart_match_config?: Maybe<Smart_Match_Configs_Bool_Exp>;
  transportation_type?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "smart_match_config_transportation" */
export enum Smart_Match_Config_Transportation_Constraint {
  /** unique or primary key constraint on columns "config_id", "transportation_type" */
  SmartMatchConfigTransportaConfigIdTransportationTypeKey = 'smart_match_config_transporta_config_id_transportation_type_key',
  /** unique or primary key constraint on columns "id" */
  SmartMatchConfigTransportationPkey = 'smart_match_config_transportation_pkey'
}

/** input type for inserting data into table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Insert_Input = {
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  smart_match_config?: Maybe<Smart_Match_Configs_Obj_Rel_Insert_Input>;
  transportation_type?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Smart_Match_Config_Transportation_Max_Fields = {
  __typename?: 'smart_match_config_transportation_max_fields';
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Max_Order_By = {
  config_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  transportation_type?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Smart_Match_Config_Transportation_Min_Fields = {
  __typename?: 'smart_match_config_transportation_min_fields';
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Min_Order_By = {
  config_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  transportation_type?: Maybe<Order_By>;
};

/** response of any mutation on the table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Mutation_Response = {
  __typename?: 'smart_match_config_transportation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Match_Config_Transportation>;
};

/** on_conflict condition type for table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_On_Conflict = {
  constraint: Smart_Match_Config_Transportation_Constraint;
  update_columns?: Array<Smart_Match_Config_Transportation_Update_Column>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};

/** Ordering options when selecting data from "smart_match_config_transportation". */
export type Smart_Match_Config_Transportation_Order_By = {
  config_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  smart_match_config?: Maybe<Smart_Match_Configs_Order_By>;
  transportation_type?: Maybe<Order_By>;
};

/** primary key columns input for table: smart_match_config_transportation */
export type Smart_Match_Config_Transportation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "smart_match_config_transportation" */
export enum Smart_Match_Config_Transportation_Select_Column {
  /** column name */
  ConfigId = 'config_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransportationType = 'transportation_type'
}

/** input type for updating data in table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Set_Input = {
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "smart_match_config_transportation" */
export type Smart_Match_Config_Transportation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Match_Config_Transportation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Match_Config_Transportation_Stream_Cursor_Value_Input = {
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
};

/** update columns of table "smart_match_config_transportation" */
export enum Smart_Match_Config_Transportation_Update_Column {
  /** column name */
  ConfigId = 'config_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransportationType = 'transportation_type'
}

export type Smart_Match_Config_Transportation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Smart_Match_Config_Transportation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Smart_Match_Config_Transportation_Bool_Exp;
};

/** columns and relationships of "smart_match_configs" */
export type Smart_Match_Configs = {
  __typename?: 'smart_match_configs';
  /** An object relationship */
  admin?: Maybe<Admin>;
  admin_id?: Maybe<Scalars['uuid']>;
  availability_enabled: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  exclude_do_not_use_enabled: Scalars['Boolean'];
  favourited_resource_enabled: Scalars['Boolean'];
  hours_available_enabled: Scalars['Boolean'];
  hours_available_min: Scalars['Int'];
  id: Scalars['uuid'];
  location_radius_enabled: Scalars['Boolean'];
  location_radius_unit: Scalars['String'];
  location_radius_value: Scalars['Int'];
  /** An object relationship */
  manager?: Maybe<Manager>;
  manager_id?: Maybe<Scalars['uuid']>;
  preferred_language_enabled: Scalars['Boolean'];
  preferred_language_proficiency: Scalars['Int'];
  previous_engagements_enabled: Scalars['Boolean'];
  previous_engagements_min: Scalars['Int'];
  rating_enabled: Scalars['Boolean'];
  rating_min_stars: Scalars['Int'];
  required_skills_enabled: Scalars['Boolean'];
  /** An array relationship */
  smart_match_config_transportations: Array<Smart_Match_Config_Transportation>;
  /** An aggregate relationship */
  smart_match_config_transportations_aggregate: Smart_Match_Config_Transportation_Aggregate;
  /** An array relationship */
  smart_match_criteria_orders: Array<Smart_Match_Criteria_Order>;
  /** An aggregate relationship */
  smart_match_criteria_orders_aggregate: Smart_Match_Criteria_Order_Aggregate;
  smart_match_enabled: Scalars['Boolean'];
  soft_skills_enabled: Scalars['Boolean'];
  title_type_match_enabled: Scalars['Boolean'];
  transportation_enabled: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "smart_match_configs" */
export type Smart_Match_ConfigsSmart_Match_Config_TransportationsArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Config_Transportation_Order_By>>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};


/** columns and relationships of "smart_match_configs" */
export type Smart_Match_ConfigsSmart_Match_Config_Transportations_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Config_Transportation_Order_By>>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};


/** columns and relationships of "smart_match_configs" */
export type Smart_Match_ConfigsSmart_Match_Criteria_OrdersArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Criteria_Order_Order_By>>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};


/** columns and relationships of "smart_match_configs" */
export type Smart_Match_ConfigsSmart_Match_Criteria_Orders_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Criteria_Order_Order_By>>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};

/** aggregated selection of "smart_match_configs" */
export type Smart_Match_Configs_Aggregate = {
  __typename?: 'smart_match_configs_aggregate';
  aggregate?: Maybe<Smart_Match_Configs_Aggregate_Fields>;
  nodes: Array<Smart_Match_Configs>;
};

/** aggregate fields of "smart_match_configs" */
export type Smart_Match_Configs_Aggregate_Fields = {
  __typename?: 'smart_match_configs_aggregate_fields';
  avg?: Maybe<Smart_Match_Configs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Smart_Match_Configs_Max_Fields>;
  min?: Maybe<Smart_Match_Configs_Min_Fields>;
  stddev?: Maybe<Smart_Match_Configs_Stddev_Fields>;
  stddev_pop?: Maybe<Smart_Match_Configs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Smart_Match_Configs_Stddev_Samp_Fields>;
  sum?: Maybe<Smart_Match_Configs_Sum_Fields>;
  var_pop?: Maybe<Smart_Match_Configs_Var_Pop_Fields>;
  var_samp?: Maybe<Smart_Match_Configs_Var_Samp_Fields>;
  variance?: Maybe<Smart_Match_Configs_Variance_Fields>;
};


/** aggregate fields of "smart_match_configs" */
export type Smart_Match_Configs_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Smart_Match_Configs_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Smart_Match_Configs_Avg_Fields = {
  __typename?: 'smart_match_configs_avg_fields';
  hours_available_min?: Maybe<Scalars['Float']>;
  location_radius_value?: Maybe<Scalars['Float']>;
  preferred_language_proficiency?: Maybe<Scalars['Float']>;
  previous_engagements_min?: Maybe<Scalars['Float']>;
  rating_min_stars?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "smart_match_configs". All fields are combined with a logical 'AND'. */
export type Smart_Match_Configs_Bool_Exp = {
  _and?: Maybe<Array<Smart_Match_Configs_Bool_Exp>>;
  _not?: Maybe<Smart_Match_Configs_Bool_Exp>;
  _or?: Maybe<Array<Smart_Match_Configs_Bool_Exp>>;
  admin?: Maybe<Admin_Bool_Exp>;
  admin_id?: Maybe<Uuid_Comparison_Exp>;
  availability_enabled?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  exclude_do_not_use_enabled?: Maybe<Boolean_Comparison_Exp>;
  favourited_resource_enabled?: Maybe<Boolean_Comparison_Exp>;
  hours_available_enabled?: Maybe<Boolean_Comparison_Exp>;
  hours_available_min?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  location_radius_enabled?: Maybe<Boolean_Comparison_Exp>;
  location_radius_unit?: Maybe<String_Comparison_Exp>;
  location_radius_value?: Maybe<Int_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  preferred_language_enabled?: Maybe<Boolean_Comparison_Exp>;
  preferred_language_proficiency?: Maybe<Int_Comparison_Exp>;
  previous_engagements_enabled?: Maybe<Boolean_Comparison_Exp>;
  previous_engagements_min?: Maybe<Int_Comparison_Exp>;
  rating_enabled?: Maybe<Boolean_Comparison_Exp>;
  rating_min_stars?: Maybe<Int_Comparison_Exp>;
  required_skills_enabled?: Maybe<Boolean_Comparison_Exp>;
  smart_match_config_transportations?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
  smart_match_config_transportations_aggregate?: Maybe<Smart_Match_Config_Transportation_Aggregate_Bool_Exp>;
  smart_match_criteria_orders?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
  smart_match_criteria_orders_aggregate?: Maybe<Smart_Match_Criteria_Order_Aggregate_Bool_Exp>;
  smart_match_enabled?: Maybe<Boolean_Comparison_Exp>;
  soft_skills_enabled?: Maybe<Boolean_Comparison_Exp>;
  title_type_match_enabled?: Maybe<Boolean_Comparison_Exp>;
  transportation_enabled?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "smart_match_configs" */
export enum Smart_Match_Configs_Constraint {
  /** unique or primary key constraint on columns "admin_id" */
  SmartMatchConfigsAdminIdKey = 'smart_match_configs_admin_id_key',
  /** unique or primary key constraint on columns "manager_id" */
  SmartMatchConfigsManagerIdKey = 'smart_match_configs_manager_id_key',
  /** unique or primary key constraint on columns "id" */
  SmartMatchConfigsPkey = 'smart_match_configs_pkey'
}

/** input type for incrementing numeric columns in table "smart_match_configs" */
export type Smart_Match_Configs_Inc_Input = {
  hours_available_min?: Maybe<Scalars['Int']>;
  location_radius_value?: Maybe<Scalars['Int']>;
  preferred_language_proficiency?: Maybe<Scalars['Int']>;
  previous_engagements_min?: Maybe<Scalars['Int']>;
  rating_min_stars?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "smart_match_configs" */
export type Smart_Match_Configs_Insert_Input = {
  admin?: Maybe<Admin_Obj_Rel_Insert_Input>;
  admin_id?: Maybe<Scalars['uuid']>;
  availability_enabled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_do_not_use_enabled?: Maybe<Scalars['Boolean']>;
  favourited_resource_enabled?: Maybe<Scalars['Boolean']>;
  hours_available_enabled?: Maybe<Scalars['Boolean']>;
  hours_available_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location_radius_enabled?: Maybe<Scalars['Boolean']>;
  location_radius_unit?: Maybe<Scalars['String']>;
  location_radius_value?: Maybe<Scalars['Int']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_id?: Maybe<Scalars['uuid']>;
  preferred_language_enabled?: Maybe<Scalars['Boolean']>;
  preferred_language_proficiency?: Maybe<Scalars['Int']>;
  previous_engagements_enabled?: Maybe<Scalars['Boolean']>;
  previous_engagements_min?: Maybe<Scalars['Int']>;
  rating_enabled?: Maybe<Scalars['Boolean']>;
  rating_min_stars?: Maybe<Scalars['Int']>;
  required_skills_enabled?: Maybe<Scalars['Boolean']>;
  smart_match_config_transportations?: Maybe<Smart_Match_Config_Transportation_Arr_Rel_Insert_Input>;
  smart_match_criteria_orders?: Maybe<Smart_Match_Criteria_Order_Arr_Rel_Insert_Input>;
  smart_match_enabled?: Maybe<Scalars['Boolean']>;
  soft_skills_enabled?: Maybe<Scalars['Boolean']>;
  title_type_match_enabled?: Maybe<Scalars['Boolean']>;
  transportation_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Smart_Match_Configs_Max_Fields = {
  __typename?: 'smart_match_configs_max_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hours_available_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location_radius_unit?: Maybe<Scalars['String']>;
  location_radius_value?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['uuid']>;
  preferred_language_proficiency?: Maybe<Scalars['Int']>;
  previous_engagements_min?: Maybe<Scalars['Int']>;
  rating_min_stars?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Smart_Match_Configs_Min_Fields = {
  __typename?: 'smart_match_configs_min_fields';
  admin_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hours_available_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location_radius_unit?: Maybe<Scalars['String']>;
  location_radius_value?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['uuid']>;
  preferred_language_proficiency?: Maybe<Scalars['Int']>;
  previous_engagements_min?: Maybe<Scalars['Int']>;
  rating_min_stars?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "smart_match_configs" */
export type Smart_Match_Configs_Mutation_Response = {
  __typename?: 'smart_match_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Match_Configs>;
};

/** input type for inserting object relation for remote table "smart_match_configs" */
export type Smart_Match_Configs_Obj_Rel_Insert_Input = {
  data: Smart_Match_Configs_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Smart_Match_Configs_On_Conflict>;
};

/** on_conflict condition type for table "smart_match_configs" */
export type Smart_Match_Configs_On_Conflict = {
  constraint: Smart_Match_Configs_Constraint;
  update_columns?: Array<Smart_Match_Configs_Update_Column>;
  where?: Maybe<Smart_Match_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "smart_match_configs". */
export type Smart_Match_Configs_Order_By = {
  admin?: Maybe<Admin_Order_By>;
  admin_id?: Maybe<Order_By>;
  availability_enabled?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exclude_do_not_use_enabled?: Maybe<Order_By>;
  favourited_resource_enabled?: Maybe<Order_By>;
  hours_available_enabled?: Maybe<Order_By>;
  hours_available_min?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  location_radius_enabled?: Maybe<Order_By>;
  location_radius_unit?: Maybe<Order_By>;
  location_radius_value?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
  preferred_language_enabled?: Maybe<Order_By>;
  preferred_language_proficiency?: Maybe<Order_By>;
  previous_engagements_enabled?: Maybe<Order_By>;
  previous_engagements_min?: Maybe<Order_By>;
  rating_enabled?: Maybe<Order_By>;
  rating_min_stars?: Maybe<Order_By>;
  required_skills_enabled?: Maybe<Order_By>;
  smart_match_config_transportations_aggregate?: Maybe<Smart_Match_Config_Transportation_Aggregate_Order_By>;
  smart_match_criteria_orders_aggregate?: Maybe<Smart_Match_Criteria_Order_Aggregate_Order_By>;
  smart_match_enabled?: Maybe<Order_By>;
  soft_skills_enabled?: Maybe<Order_By>;
  title_type_match_enabled?: Maybe<Order_By>;
  transportation_enabled?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: smart_match_configs */
export type Smart_Match_Configs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "smart_match_configs" */
export enum Smart_Match_Configs_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  AvailabilityEnabled = 'availability_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExcludeDoNotUseEnabled = 'exclude_do_not_use_enabled',
  /** column name */
  FavouritedResourceEnabled = 'favourited_resource_enabled',
  /** column name */
  HoursAvailableEnabled = 'hours_available_enabled',
  /** column name */
  HoursAvailableMin = 'hours_available_min',
  /** column name */
  Id = 'id',
  /** column name */
  LocationRadiusEnabled = 'location_radius_enabled',
  /** column name */
  LocationRadiusUnit = 'location_radius_unit',
  /** column name */
  LocationRadiusValue = 'location_radius_value',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  PreferredLanguageEnabled = 'preferred_language_enabled',
  /** column name */
  PreferredLanguageProficiency = 'preferred_language_proficiency',
  /** column name */
  PreviousEngagementsEnabled = 'previous_engagements_enabled',
  /** column name */
  PreviousEngagementsMin = 'previous_engagements_min',
  /** column name */
  RatingEnabled = 'rating_enabled',
  /** column name */
  RatingMinStars = 'rating_min_stars',
  /** column name */
  RequiredSkillsEnabled = 'required_skills_enabled',
  /** column name */
  SmartMatchEnabled = 'smart_match_enabled',
  /** column name */
  SoftSkillsEnabled = 'soft_skills_enabled',
  /** column name */
  TitleTypeMatchEnabled = 'title_type_match_enabled',
  /** column name */
  TransportationEnabled = 'transportation_enabled',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "smart_match_configs" */
export type Smart_Match_Configs_Set_Input = {
  admin_id?: Maybe<Scalars['uuid']>;
  availability_enabled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_do_not_use_enabled?: Maybe<Scalars['Boolean']>;
  favourited_resource_enabled?: Maybe<Scalars['Boolean']>;
  hours_available_enabled?: Maybe<Scalars['Boolean']>;
  hours_available_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location_radius_enabled?: Maybe<Scalars['Boolean']>;
  location_radius_unit?: Maybe<Scalars['String']>;
  location_radius_value?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['uuid']>;
  preferred_language_enabled?: Maybe<Scalars['Boolean']>;
  preferred_language_proficiency?: Maybe<Scalars['Int']>;
  previous_engagements_enabled?: Maybe<Scalars['Boolean']>;
  previous_engagements_min?: Maybe<Scalars['Int']>;
  rating_enabled?: Maybe<Scalars['Boolean']>;
  rating_min_stars?: Maybe<Scalars['Int']>;
  required_skills_enabled?: Maybe<Scalars['Boolean']>;
  smart_match_enabled?: Maybe<Scalars['Boolean']>;
  soft_skills_enabled?: Maybe<Scalars['Boolean']>;
  title_type_match_enabled?: Maybe<Scalars['Boolean']>;
  transportation_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Smart_Match_Configs_Stddev_Fields = {
  __typename?: 'smart_match_configs_stddev_fields';
  hours_available_min?: Maybe<Scalars['Float']>;
  location_radius_value?: Maybe<Scalars['Float']>;
  preferred_language_proficiency?: Maybe<Scalars['Float']>;
  previous_engagements_min?: Maybe<Scalars['Float']>;
  rating_min_stars?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Smart_Match_Configs_Stddev_Pop_Fields = {
  __typename?: 'smart_match_configs_stddev_pop_fields';
  hours_available_min?: Maybe<Scalars['Float']>;
  location_radius_value?: Maybe<Scalars['Float']>;
  preferred_language_proficiency?: Maybe<Scalars['Float']>;
  previous_engagements_min?: Maybe<Scalars['Float']>;
  rating_min_stars?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Smart_Match_Configs_Stddev_Samp_Fields = {
  __typename?: 'smart_match_configs_stddev_samp_fields';
  hours_available_min?: Maybe<Scalars['Float']>;
  location_radius_value?: Maybe<Scalars['Float']>;
  preferred_language_proficiency?: Maybe<Scalars['Float']>;
  previous_engagements_min?: Maybe<Scalars['Float']>;
  rating_min_stars?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "smart_match_configs" */
export type Smart_Match_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Match_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Match_Configs_Stream_Cursor_Value_Input = {
  admin_id?: Maybe<Scalars['uuid']>;
  availability_enabled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exclude_do_not_use_enabled?: Maybe<Scalars['Boolean']>;
  favourited_resource_enabled?: Maybe<Scalars['Boolean']>;
  hours_available_enabled?: Maybe<Scalars['Boolean']>;
  hours_available_min?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  location_radius_enabled?: Maybe<Scalars['Boolean']>;
  location_radius_unit?: Maybe<Scalars['String']>;
  location_radius_value?: Maybe<Scalars['Int']>;
  manager_id?: Maybe<Scalars['uuid']>;
  preferred_language_enabled?: Maybe<Scalars['Boolean']>;
  preferred_language_proficiency?: Maybe<Scalars['Int']>;
  previous_engagements_enabled?: Maybe<Scalars['Boolean']>;
  previous_engagements_min?: Maybe<Scalars['Int']>;
  rating_enabled?: Maybe<Scalars['Boolean']>;
  rating_min_stars?: Maybe<Scalars['Int']>;
  required_skills_enabled?: Maybe<Scalars['Boolean']>;
  smart_match_enabled?: Maybe<Scalars['Boolean']>;
  soft_skills_enabled?: Maybe<Scalars['Boolean']>;
  title_type_match_enabled?: Maybe<Scalars['Boolean']>;
  transportation_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Smart_Match_Configs_Sum_Fields = {
  __typename?: 'smart_match_configs_sum_fields';
  hours_available_min?: Maybe<Scalars['Int']>;
  location_radius_value?: Maybe<Scalars['Int']>;
  preferred_language_proficiency?: Maybe<Scalars['Int']>;
  previous_engagements_min?: Maybe<Scalars['Int']>;
  rating_min_stars?: Maybe<Scalars['Int']>;
};

/** update columns of table "smart_match_configs" */
export enum Smart_Match_Configs_Update_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  AvailabilityEnabled = 'availability_enabled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExcludeDoNotUseEnabled = 'exclude_do_not_use_enabled',
  /** column name */
  FavouritedResourceEnabled = 'favourited_resource_enabled',
  /** column name */
  HoursAvailableEnabled = 'hours_available_enabled',
  /** column name */
  HoursAvailableMin = 'hours_available_min',
  /** column name */
  Id = 'id',
  /** column name */
  LocationRadiusEnabled = 'location_radius_enabled',
  /** column name */
  LocationRadiusUnit = 'location_radius_unit',
  /** column name */
  LocationRadiusValue = 'location_radius_value',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  PreferredLanguageEnabled = 'preferred_language_enabled',
  /** column name */
  PreferredLanguageProficiency = 'preferred_language_proficiency',
  /** column name */
  PreviousEngagementsEnabled = 'previous_engagements_enabled',
  /** column name */
  PreviousEngagementsMin = 'previous_engagements_min',
  /** column name */
  RatingEnabled = 'rating_enabled',
  /** column name */
  RatingMinStars = 'rating_min_stars',
  /** column name */
  RequiredSkillsEnabled = 'required_skills_enabled',
  /** column name */
  SmartMatchEnabled = 'smart_match_enabled',
  /** column name */
  SoftSkillsEnabled = 'soft_skills_enabled',
  /** column name */
  TitleTypeMatchEnabled = 'title_type_match_enabled',
  /** column name */
  TransportationEnabled = 'transportation_enabled',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Smart_Match_Configs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Smart_Match_Configs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Smart_Match_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Smart_Match_Configs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Smart_Match_Configs_Var_Pop_Fields = {
  __typename?: 'smart_match_configs_var_pop_fields';
  hours_available_min?: Maybe<Scalars['Float']>;
  location_radius_value?: Maybe<Scalars['Float']>;
  preferred_language_proficiency?: Maybe<Scalars['Float']>;
  previous_engagements_min?: Maybe<Scalars['Float']>;
  rating_min_stars?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Smart_Match_Configs_Var_Samp_Fields = {
  __typename?: 'smart_match_configs_var_samp_fields';
  hours_available_min?: Maybe<Scalars['Float']>;
  location_radius_value?: Maybe<Scalars['Float']>;
  preferred_language_proficiency?: Maybe<Scalars['Float']>;
  previous_engagements_min?: Maybe<Scalars['Float']>;
  rating_min_stars?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Smart_Match_Configs_Variance_Fields = {
  __typename?: 'smart_match_configs_variance_fields';
  hours_available_min?: Maybe<Scalars['Float']>;
  location_radius_value?: Maybe<Scalars['Float']>;
  preferred_language_proficiency?: Maybe<Scalars['Float']>;
  previous_engagements_min?: Maybe<Scalars['Float']>;
  rating_min_stars?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order = {
  __typename?: 'smart_match_criteria_order';
  config_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  criterion_type: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  smart_match_config: Smart_Match_Configs;
  sort_order: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Aggregate = {
  __typename?: 'smart_match_criteria_order_aggregate';
  aggregate?: Maybe<Smart_Match_Criteria_Order_Aggregate_Fields>;
  nodes: Array<Smart_Match_Criteria_Order>;
};

export type Smart_Match_Criteria_Order_Aggregate_Bool_Exp = {
  count?: Maybe<Smart_Match_Criteria_Order_Aggregate_Bool_Exp_Count>;
};

export type Smart_Match_Criteria_Order_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Aggregate_Fields = {
  __typename?: 'smart_match_criteria_order_aggregate_fields';
  avg?: Maybe<Smart_Match_Criteria_Order_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Smart_Match_Criteria_Order_Max_Fields>;
  min?: Maybe<Smart_Match_Criteria_Order_Min_Fields>;
  stddev?: Maybe<Smart_Match_Criteria_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Smart_Match_Criteria_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Smart_Match_Criteria_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Smart_Match_Criteria_Order_Sum_Fields>;
  var_pop?: Maybe<Smart_Match_Criteria_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Smart_Match_Criteria_Order_Var_Samp_Fields>;
  variance?: Maybe<Smart_Match_Criteria_Order_Variance_Fields>;
};


/** aggregate fields of "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Aggregate_Order_By = {
  avg?: Maybe<Smart_Match_Criteria_Order_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Smart_Match_Criteria_Order_Max_Order_By>;
  min?: Maybe<Smart_Match_Criteria_Order_Min_Order_By>;
  stddev?: Maybe<Smart_Match_Criteria_Order_Stddev_Order_By>;
  stddev_pop?: Maybe<Smart_Match_Criteria_Order_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Smart_Match_Criteria_Order_Stddev_Samp_Order_By>;
  sum?: Maybe<Smart_Match_Criteria_Order_Sum_Order_By>;
  var_pop?: Maybe<Smart_Match_Criteria_Order_Var_Pop_Order_By>;
  var_samp?: Maybe<Smart_Match_Criteria_Order_Var_Samp_Order_By>;
  variance?: Maybe<Smart_Match_Criteria_Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Arr_Rel_Insert_Input = {
  data: Array<Smart_Match_Criteria_Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Smart_Match_Criteria_Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Smart_Match_Criteria_Order_Avg_Fields = {
  __typename?: 'smart_match_criteria_order_avg_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Avg_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "smart_match_criteria_order". All fields are combined with a logical 'AND'. */
export type Smart_Match_Criteria_Order_Bool_Exp = {
  _and?: Maybe<Array<Smart_Match_Criteria_Order_Bool_Exp>>;
  _not?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
  _or?: Maybe<Array<Smart_Match_Criteria_Order_Bool_Exp>>;
  config_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  criterion_type?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  smart_match_config?: Maybe<Smart_Match_Configs_Bool_Exp>;
  sort_order?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "smart_match_criteria_order" */
export enum Smart_Match_Criteria_Order_Constraint {
  /** unique or primary key constraint on columns "config_id", "criterion_type" */
  SmartMatchCriteriaOrderConfigIdCriterionTypeKey = 'smart_match_criteria_order_config_id_criterion_type_key',
  /** unique or primary key constraint on columns "sort_order", "config_id" */
  SmartMatchCriteriaOrderConfigIdSortOrderKey = 'smart_match_criteria_order_config_id_sort_order_key',
  /** unique or primary key constraint on columns "id" */
  SmartMatchCriteriaOrderPkey = 'smart_match_criteria_order_pkey'
}

/** input type for incrementing numeric columns in table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Inc_Input = {
  sort_order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Insert_Input = {
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  criterion_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  smart_match_config?: Maybe<Smart_Match_Configs_Obj_Rel_Insert_Input>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Smart_Match_Criteria_Order_Max_Fields = {
  __typename?: 'smart_match_criteria_order_max_fields';
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  criterion_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Max_Order_By = {
  config_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  criterion_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sort_order?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Smart_Match_Criteria_Order_Min_Fields = {
  __typename?: 'smart_match_criteria_order_min_fields';
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  criterion_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Min_Order_By = {
  config_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  criterion_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  sort_order?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Mutation_Response = {
  __typename?: 'smart_match_criteria_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Match_Criteria_Order>;
};

/** on_conflict condition type for table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_On_Conflict = {
  constraint: Smart_Match_Criteria_Order_Constraint;
  update_columns?: Array<Smart_Match_Criteria_Order_Update_Column>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "smart_match_criteria_order". */
export type Smart_Match_Criteria_Order_Order_By = {
  config_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  criterion_type?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  smart_match_config?: Maybe<Smart_Match_Configs_Order_By>;
  sort_order?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: smart_match_criteria_order */
export type Smart_Match_Criteria_Order_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "smart_match_criteria_order" */
export enum Smart_Match_Criteria_Order_Select_Column {
  /** column name */
  ConfigId = 'config_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CriterionType = 'criterion_type',
  /** column name */
  Id = 'id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Set_Input = {
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  criterion_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Smart_Match_Criteria_Order_Stddev_Fields = {
  __typename?: 'smart_match_criteria_order_stddev_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Stddev_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Smart_Match_Criteria_Order_Stddev_Pop_Fields = {
  __typename?: 'smart_match_criteria_order_stddev_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Stddev_Pop_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Smart_Match_Criteria_Order_Stddev_Samp_Fields = {
  __typename?: 'smart_match_criteria_order_stddev_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Stddev_Samp_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** Streaming cursor of the table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Match_Criteria_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Match_Criteria_Order_Stream_Cursor_Value_Input = {
  config_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  criterion_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Smart_Match_Criteria_Order_Sum_Fields = {
  __typename?: 'smart_match_criteria_order_sum_fields';
  sort_order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Sum_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** update columns of table "smart_match_criteria_order" */
export enum Smart_Match_Criteria_Order_Update_Column {
  /** column name */
  ConfigId = 'config_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CriterionType = 'criterion_type',
  /** column name */
  Id = 'id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Smart_Match_Criteria_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Smart_Match_Criteria_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Smart_Match_Criteria_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Smart_Match_Criteria_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Smart_Match_Criteria_Order_Var_Pop_Fields = {
  __typename?: 'smart_match_criteria_order_var_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Var_Pop_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Smart_Match_Criteria_Order_Var_Samp_Fields = {
  __typename?: 'smart_match_criteria_order_var_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Var_Samp_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Smart_Match_Criteria_Order_Variance_Fields = {
  __typename?: 'smart_match_criteria_order_variance_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "smart_match_criteria_order" */
export type Smart_Match_Criteria_Order_Variance_Order_By = {
  sort_order?: Maybe<Order_By>;
};

/** columns and relationships of "soft_skill" */
export type Soft_Skill = {
  __typename?: 'soft_skill';
  company_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "soft_skill" */
export type Soft_Skill_Aggregate = {
  __typename?: 'soft_skill_aggregate';
  aggregate?: Maybe<Soft_Skill_Aggregate_Fields>;
  nodes: Array<Soft_Skill>;
};

export type Soft_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Soft_Skill_Aggregate_Bool_Exp_Count>;
};

export type Soft_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Soft_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "soft_skill" */
export type Soft_Skill_Aggregate_Fields = {
  __typename?: 'soft_skill_aggregate_fields';
  avg?: Maybe<Soft_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Soft_Skill_Max_Fields>;
  min?: Maybe<Soft_Skill_Min_Fields>;
  stddev?: Maybe<Soft_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Soft_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Soft_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Soft_Skill_Sum_Fields>;
  var_pop?: Maybe<Soft_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Soft_Skill_Var_Samp_Fields>;
  variance?: Maybe<Soft_Skill_Variance_Fields>;
};


/** aggregate fields of "soft_skill" */
export type Soft_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "soft_skill" */
export type Soft_Skill_Aggregate_Order_By = {
  avg?: Maybe<Soft_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Soft_Skill_Max_Order_By>;
  min?: Maybe<Soft_Skill_Min_Order_By>;
  stddev?: Maybe<Soft_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Soft_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Soft_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Soft_Skill_Sum_Order_By>;
  var_pop?: Maybe<Soft_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Soft_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Soft_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "soft_skill" */
export type Soft_Skill_Arr_Rel_Insert_Input = {
  data: Array<Soft_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Soft_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Soft_Skill_Avg_Fields = {
  __typename?: 'soft_skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "soft_skill" */
export type Soft_Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "soft_skill". All fields are combined with a logical 'AND'. */
export type Soft_Skill_Bool_Exp = {
  _and?: Maybe<Array<Soft_Skill_Bool_Exp>>;
  _not?: Maybe<Soft_Skill_Bool_Exp>;
  _or?: Maybe<Array<Soft_Skill_Bool_Exp>>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "soft_skill" */
export enum Soft_Skill_Constraint {
  /** unique or primary key constraint on columns "name", "company_id" */
  SoftSkillNameCompanyIdKey = 'soft_skill_name_company_id_key',
  /** unique or primary key constraint on columns "user_id", "name" */
  SoftSkillNameUserIdKey = 'soft_skill_name_user_id_key',
  /** unique or primary key constraint on columns "id" */
  SoftSkillPkey = 'soft_skill_pkey'
}

/** input type for incrementing numeric columns in table "soft_skill" */
export type Soft_Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "soft_skill" */
export type Soft_Skill_Insert_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Soft_Skill_Max_Fields = {
  __typename?: 'soft_skill_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "soft_skill" */
export type Soft_Skill_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Soft_Skill_Min_Fields = {
  __typename?: 'soft_skill_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "soft_skill" */
export type Soft_Skill_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "soft_skill" */
export type Soft_Skill_Mutation_Response = {
  __typename?: 'soft_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Soft_Skill>;
};

/** input type for inserting object relation for remote table "soft_skill" */
export type Soft_Skill_Obj_Rel_Insert_Input = {
  data: Soft_Skill_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Soft_Skill_On_Conflict>;
};

/** on_conflict condition type for table "soft_skill" */
export type Soft_Skill_On_Conflict = {
  constraint: Soft_Skill_Constraint;
  update_columns?: Array<Soft_Skill_Update_Column>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "soft_skill". */
export type Soft_Skill_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: soft_skill */
export type Soft_Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "soft_skill" */
export enum Soft_Skill_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "soft_skill" */
export type Soft_Skill_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Soft_Skill_Stddev_Fields = {
  __typename?: 'soft_skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "soft_skill" */
export type Soft_Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Soft_Skill_Stddev_Pop_Fields = {
  __typename?: 'soft_skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "soft_skill" */
export type Soft_Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Soft_Skill_Stddev_Samp_Fields = {
  __typename?: 'soft_skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "soft_skill" */
export type Soft_Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "soft_skill" */
export type Soft_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Soft_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Soft_Skill_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Soft_Skill_Sum_Fields = {
  __typename?: 'soft_skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "soft_skill" */
export type Soft_Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "soft_skill" */
export enum Soft_Skill_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Soft_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Soft_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Soft_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Soft_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Soft_Skill_Var_Pop_Fields = {
  __typename?: 'soft_skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "soft_skill" */
export type Soft_Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Soft_Skill_Var_Samp_Fields = {
  __typename?: 'soft_skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "soft_skill" */
export type Soft_Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Soft_Skill_Variance_Fields = {
  __typename?: 'soft_skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "soft_skill" */
export type Soft_Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** for resource source */
export type Source = {
  __typename?: 'source';
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  resource_information_cards: Array<Resource_Information_Card>;
  /** An aggregate relationship */
  resource_information_cards_aggregate: Resource_Information_Card_Aggregate;
  source_url?: Maybe<Scalars['String']>;
};


/** for resource source */
export type SourceResource_Information_CardsArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


/** for resource source */
export type SourceResource_Information_Cards_AggregateArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};

/** aggregated selection of "source" */
export type Source_Aggregate = {
  __typename?: 'source_aggregate';
  aggregate?: Maybe<Source_Aggregate_Fields>;
  nodes: Array<Source>;
};

/** aggregate fields of "source" */
export type Source_Aggregate_Fields = {
  __typename?: 'source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Source_Max_Fields>;
  min?: Maybe<Source_Min_Fields>;
};


/** aggregate fields of "source" */
export type Source_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Source_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "source". All fields are combined with a logical 'AND'. */
export type Source_Bool_Exp = {
  _and?: Maybe<Array<Source_Bool_Exp>>;
  _not?: Maybe<Source_Bool_Exp>;
  _or?: Maybe<Array<Source_Bool_Exp>>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  resource_information_cards?: Maybe<Resource_Information_Card_Bool_Exp>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Bool_Exp>;
  source_url?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "source" */
export enum Source_Constraint {
  /** unique or primary key constraint on columns "id" */
  SourcePkey = 'source_pkey'
}

/** input type for inserting data into table "source" */
export type Source_Insert_Input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  resource_information_cards?: Maybe<Resource_Information_Card_Arr_Rel_Insert_Input>;
  source_url?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Source_Max_Fields = {
  __typename?: 'source_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Source_Min_Fields = {
  __typename?: 'source_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "source" */
export type Source_Mutation_Response = {
  __typename?: 'source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Source>;
};

/** input type for inserting object relation for remote table "source" */
export type Source_Obj_Rel_Insert_Input = {
  data: Source_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Source_On_Conflict>;
};

/** on_conflict condition type for table "source" */
export type Source_On_Conflict = {
  constraint: Source_Constraint;
  update_columns?: Array<Source_Update_Column>;
  where?: Maybe<Source_Bool_Exp>;
};

/** Ordering options when selecting data from "source". */
export type Source_Order_By = {
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Order_By>;
  source_url?: Maybe<Order_By>;
};

/** primary key columns input for table: source */
export type Source_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "source" */
export enum Source_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SourceUrl = 'source_url'
}

/** input type for updating data in table "source" */
export type Source_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "source" */
export type Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Source_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
};

/** update columns of table "source" */
export enum Source_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SourceUrl = 'source_url'
}

export type Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Source_Bool_Exp;
};

/** columns and relationships of "subscription" */
export type Subscription = {
  __typename?: 'subscription';
  cancel_at_period_end: Scalars['Boolean'];
  canceled_by_user: Scalars['Boolean'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  current_period_end?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** An object relationship */
  payment_card?: Maybe<Payment_Card>;
  payment_card_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  stripe_subscription_id?: Maybe<Scalars['String']>;
  stripe_subscription_item_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  subscription_plan: Subscription_Plan;
  subscription_plan_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "subscription" */
export type Subscription_Aggregate = {
  __typename?: 'subscription_aggregate';
  aggregate?: Maybe<Subscription_Aggregate_Fields>;
  nodes: Array<Subscription>;
};

export type Subscription_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Subscription_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Subscription_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Subscription_Aggregate_Bool_Exp_Count>;
};

export type Subscription_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Subscription_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Subscription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscription" */
export type Subscription_Aggregate_Fields = {
  __typename?: 'subscription_aggregate_fields';
  avg?: Maybe<Subscription_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Max_Fields>;
  min?: Maybe<Subscription_Min_Fields>;
  stddev?: Maybe<Subscription_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Sum_Fields>;
  var_pop?: Maybe<Subscription_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Variance_Fields>;
};


/** aggregate fields of "subscription" */
export type Subscription_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Subscription_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription" */
export type Subscription_Aggregate_Order_By = {
  avg?: Maybe<Subscription_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Subscription_Max_Order_By>;
  min?: Maybe<Subscription_Min_Order_By>;
  stddev?: Maybe<Subscription_Stddev_Order_By>;
  stddev_pop?: Maybe<Subscription_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Subscription_Stddev_Samp_Order_By>;
  sum?: Maybe<Subscription_Sum_Order_By>;
  var_pop?: Maybe<Subscription_Var_Pop_Order_By>;
  var_samp?: Maybe<Subscription_Var_Samp_Order_By>;
  variance?: Maybe<Subscription_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription" */
export type Subscription_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Subscription_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscription_Avg_Fields = {
  __typename?: 'subscription_avg_fields';
  current_period_end?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subscription" */
export type Subscription_Avg_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscription". All fields are combined with a logical 'AND'. */
export type Subscription_Bool_Exp = {
  _and?: Maybe<Array<Subscription_Bool_Exp>>;
  _not?: Maybe<Subscription_Bool_Exp>;
  _or?: Maybe<Array<Subscription_Bool_Exp>>;
  cancel_at_period_end?: Maybe<Boolean_Comparison_Exp>;
  canceled_by_user?: Maybe<Boolean_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  current_period_end?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  payment_card?: Maybe<Payment_Card_Bool_Exp>;
  payment_card_id?: Maybe<Uuid_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  stripe_subscription_id?: Maybe<String_Comparison_Exp>;
  stripe_subscription_item_id?: Maybe<String_Comparison_Exp>;
  subscription_plan?: Maybe<Subscription_Plan_Bool_Exp>;
  subscription_plan_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription" */
export enum Subscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPkey = 'subscription_pkey',
  /** unique or primary key constraint on columns "stripe_subscription_id" */
  SubscriptionStripeSubscriptionIdKey = 'subscription_stripe_subscription_id_key',
  /** unique or primary key constraint on columns "stripe_subscription_item_id" */
  SubscriptionStripeSubscriptionItemIdKey = 'subscription_stripe_subscription_item_id_key'
}

/** input type for incrementing numeric columns in table "subscription" */
export type Subscription_Inc_Input = {
  current_period_end?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription" */
export type Subscription_Insert_Input = {
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  canceled_by_user?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  payment_card?: Maybe<Payment_Card_Obj_Rel_Insert_Input>;
  payment_card_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  stripe_subscription_item_id?: Maybe<Scalars['String']>;
  subscription_plan?: Maybe<Subscription_Plan_Obj_Rel_Insert_Input>;
  subscription_plan_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Subscription_Max_Fields = {
  __typename?: 'subscription_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  payment_card_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  stripe_subscription_item_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription" */
export type Subscription_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  current_period_end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payment_card_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  stripe_subscription_id?: Maybe<Order_By>;
  stripe_subscription_item_id?: Maybe<Order_By>;
  subscription_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Min_Fields = {
  __typename?: 'subscription_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  payment_card_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  stripe_subscription_item_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "subscription" */
export type Subscription_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  current_period_end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payment_card_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  stripe_subscription_id?: Maybe<Order_By>;
  stripe_subscription_item_id?: Maybe<Order_By>;
  subscription_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "subscription" */
export type Subscription_Mutation_Response = {
  __typename?: 'subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription>;
};

/** on_conflict condition type for table "subscription" */
export type Subscription_On_Conflict = {
  constraint: Subscription_Constraint;
  update_columns?: Array<Subscription_Update_Column>;
  where?: Maybe<Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription". */
export type Subscription_Order_By = {
  cancel_at_period_end?: Maybe<Order_By>;
  canceled_by_user?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  current_period_end?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payment_card?: Maybe<Payment_Card_Order_By>;
  payment_card_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  stripe_subscription_id?: Maybe<Order_By>;
  stripe_subscription_item_id?: Maybe<Order_By>;
  subscription_plan?: Maybe<Subscription_Plan_Order_By>;
  subscription_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: subscription */
export type Subscription_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "subscription_plan" */
export type Subscription_Plan = {
  __typename?: 'subscription_plan';
  access_permissions_id?: Maybe<Scalars['uuid']>;
  archived: Scalars['Boolean'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  inner_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id: Scalars['String'];
  /** An object relationship */
  subscription_plan_access_permission?: Maybe<Subscription_Plan_Access_Permissions>;
  /** An array relationship */
  subscriptions: Array<Subscription>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscription_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "subscription_plan" */
export type Subscription_PlanSubscriptionsArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


/** columns and relationships of "subscription_plan" */
export type Subscription_PlanSubscriptions_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};

/** columns and relationships of "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions = {
  __typename?: 'subscription_plan_access_permissions';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  managers_count: Scalars['Int'];
  /** An array relationship */
  subscription_plans: Array<Subscription_Plan>;
  /** An aggregate relationship */
  subscription_plans_aggregate: Subscription_Plan_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_PermissionsSubscription_PlansArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Order_By>>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};


/** columns and relationships of "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_PermissionsSubscription_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Order_By>>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};

/** aggregated selection of "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Aggregate = {
  __typename?: 'subscription_plan_access_permissions_aggregate';
  aggregate?: Maybe<Subscription_Plan_Access_Permissions_Aggregate_Fields>;
  nodes: Array<Subscription_Plan_Access_Permissions>;
};

/** aggregate fields of "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Aggregate_Fields = {
  __typename?: 'subscription_plan_access_permissions_aggregate_fields';
  avg?: Maybe<Subscription_Plan_Access_Permissions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscription_Plan_Access_Permissions_Max_Fields>;
  min?: Maybe<Subscription_Plan_Access_Permissions_Min_Fields>;
  stddev?: Maybe<Subscription_Plan_Access_Permissions_Stddev_Fields>;
  stddev_pop?: Maybe<Subscription_Plan_Access_Permissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscription_Plan_Access_Permissions_Stddev_Samp_Fields>;
  sum?: Maybe<Subscription_Plan_Access_Permissions_Sum_Fields>;
  var_pop?: Maybe<Subscription_Plan_Access_Permissions_Var_Pop_Fields>;
  var_samp?: Maybe<Subscription_Plan_Access_Permissions_Var_Samp_Fields>;
  variance?: Maybe<Subscription_Plan_Access_Permissions_Variance_Fields>;
};


/** aggregate fields of "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Subscription_Plan_Access_Permissions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Subscription_Plan_Access_Permissions_Avg_Fields = {
  __typename?: 'subscription_plan_access_permissions_avg_fields';
  managers_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "subscription_plan_access_permissions". All fields are combined with a logical 'AND'. */
export type Subscription_Plan_Access_Permissions_Bool_Exp = {
  _and?: Maybe<Array<Subscription_Plan_Access_Permissions_Bool_Exp>>;
  _not?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
  _or?: Maybe<Array<Subscription_Plan_Access_Permissions_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  managers_count?: Maybe<Int_Comparison_Exp>;
  subscription_plans?: Maybe<Subscription_Plan_Bool_Exp>;
  subscription_plans_aggregate?: Maybe<Subscription_Plan_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan_access_permissions" */
export enum Subscription_Plan_Access_Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanAccessPermissionsPkey = 'subscription_plan_access_permissions_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Inc_Input = {
  managers_count?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  managers_count?: Maybe<Scalars['Int']>;
  subscription_plans?: Maybe<Subscription_Plan_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Subscription_Plan_Access_Permissions_Max_Fields = {
  __typename?: 'subscription_plan_access_permissions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  managers_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Subscription_Plan_Access_Permissions_Min_Fields = {
  __typename?: 'subscription_plan_access_permissions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  managers_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Mutation_Response = {
  __typename?: 'subscription_plan_access_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Plan_Access_Permissions>;
};

/** input type for inserting object relation for remote table "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Obj_Rel_Insert_Input = {
  data: Subscription_Plan_Access_Permissions_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Subscription_Plan_Access_Permissions_On_Conflict>;
};

/** on_conflict condition type for table "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_On_Conflict = {
  constraint: Subscription_Plan_Access_Permissions_Constraint;
  update_columns?: Array<Subscription_Plan_Access_Permissions_Update_Column>;
  where?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan_access_permissions". */
export type Subscription_Plan_Access_Permissions_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  managers_count?: Maybe<Order_By>;
  subscription_plans_aggregate?: Maybe<Subscription_Plan_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: subscription_plan_access_permissions */
export type Subscription_Plan_Access_Permissions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscription_plan_access_permissions" */
export enum Subscription_Plan_Access_Permissions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagersCount = 'managers_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  managers_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Subscription_Plan_Access_Permissions_Stddev_Fields = {
  __typename?: 'subscription_plan_access_permissions_stddev_fields';
  managers_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Plan_Access_Permissions_Stddev_Pop_Fields = {
  __typename?: 'subscription_plan_access_permissions_stddev_pop_fields';
  managers_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Plan_Access_Permissions_Stddev_Samp_Fields = {
  __typename?: 'subscription_plan_access_permissions_stddev_samp_fields';
  managers_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "subscription_plan_access_permissions" */
export type Subscription_Plan_Access_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Plan_Access_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Plan_Access_Permissions_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  managers_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Subscription_Plan_Access_Permissions_Sum_Fields = {
  __typename?: 'subscription_plan_access_permissions_sum_fields';
  managers_count?: Maybe<Scalars['Int']>;
};

/** update columns of table "subscription_plan_access_permissions" */
export enum Subscription_Plan_Access_Permissions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagersCount = 'managers_count',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscription_Plan_Access_Permissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Subscription_Plan_Access_Permissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Subscription_Plan_Access_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Plan_Access_Permissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Plan_Access_Permissions_Var_Pop_Fields = {
  __typename?: 'subscription_plan_access_permissions_var_pop_fields';
  managers_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Subscription_Plan_Access_Permissions_Var_Samp_Fields = {
  __typename?: 'subscription_plan_access_permissions_var_samp_fields';
  managers_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Subscription_Plan_Access_Permissions_Variance_Fields = {
  __typename?: 'subscription_plan_access_permissions_variance_fields';
  managers_count?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "subscription_plan" */
export type Subscription_Plan_Aggregate = {
  __typename?: 'subscription_plan_aggregate';
  aggregate?: Maybe<Subscription_Plan_Aggregate_Fields>;
  nodes: Array<Subscription_Plan>;
};

export type Subscription_Plan_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Subscription_Plan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Subscription_Plan_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Subscription_Plan_Aggregate_Bool_Exp_Count>;
};

export type Subscription_Plan_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Subscription_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Plan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Subscription_Plan_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscription_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Subscription_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Subscription_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscription_plan" */
export type Subscription_Plan_Aggregate_Fields = {
  __typename?: 'subscription_plan_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Subscription_Plan_Max_Fields>;
  min?: Maybe<Subscription_Plan_Min_Fields>;
};


/** aggregate fields of "subscription_plan" */
export type Subscription_Plan_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Subscription_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subscription_plan" */
export type Subscription_Plan_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Subscription_Plan_Max_Order_By>;
  min?: Maybe<Subscription_Plan_Min_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan" */
export type Subscription_Plan_Arr_Rel_Insert_Input = {
  data: Array<Subscription_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Subscription_Plan_On_Conflict>;
};

/** Boolean expression to filter rows from the table "subscription_plan". All fields are combined with a logical 'AND'. */
export type Subscription_Plan_Bool_Exp = {
  _and?: Maybe<Array<Subscription_Plan_Bool_Exp>>;
  _not?: Maybe<Subscription_Plan_Bool_Exp>;
  _or?: Maybe<Array<Subscription_Plan_Bool_Exp>>;
  access_permissions_id?: Maybe<Uuid_Comparison_Exp>;
  archived?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  inner_name?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  price?: Maybe<String_Comparison_Exp>;
  stripe_price_id?: Maybe<String_Comparison_Exp>;
  stripe_product_id?: Maybe<String_Comparison_Exp>;
  subscription_plan_access_permission?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
  subscriptions?: Maybe<Subscription_Bool_Exp>;
  subscriptions_aggregate?: Maybe<Subscription_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan" */
export enum Subscription_Plan_Constraint {
  /** unique or primary key constraint on columns "inner_name" */
  SubscriptionPlanInnerNameKey = 'subscription_plan_inner_name_key',
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanPkey = 'subscription_plan_pkey',
  /** unique or primary key constraint on columns "stripe_product_id" */
  SubscriptionPlanStripeProductIdKey = 'subscription_plan_stripe_product_id_key'
}

/** input type for inserting data into table "subscription_plan" */
export type Subscription_Plan_Insert_Input = {
  access_permissions_id?: Maybe<Scalars['uuid']>;
  archived?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inner_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  subscription_plan_access_permission?: Maybe<Subscription_Plan_Access_Permissions_Obj_Rel_Insert_Input>;
  subscriptions?: Maybe<Subscription_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Subscription_Plan_Max_Fields = {
  __typename?: 'subscription_plan_max_fields';
  access_permissions_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inner_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription_plan" */
export type Subscription_Plan_Max_Order_By = {
  access_permissions_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  inner_name?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  price?: Maybe<Order_By>;
  stripe_price_id?: Maybe<Order_By>;
  stripe_product_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Subscription_Plan_Min_Fields = {
  __typename?: 'subscription_plan_min_fields';
  access_permissions_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inner_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "subscription_plan" */
export type Subscription_Plan_Min_Order_By = {
  access_permissions_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  inner_name?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  price?: Maybe<Order_By>;
  stripe_price_id?: Maybe<Order_By>;
  stripe_product_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "subscription_plan" */
export type Subscription_Plan_Mutation_Response = {
  __typename?: 'subscription_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Plan>;
};

/** input type for inserting object relation for remote table "subscription_plan" */
export type Subscription_Plan_Obj_Rel_Insert_Input = {
  data: Subscription_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Subscription_Plan_On_Conflict>;
};

/** on_conflict condition type for table "subscription_plan" */
export type Subscription_Plan_On_Conflict = {
  constraint: Subscription_Plan_Constraint;
  update_columns?: Array<Subscription_Plan_Update_Column>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan". */
export type Subscription_Plan_Order_By = {
  access_permissions_id?: Maybe<Order_By>;
  archived?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  inner_name?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  price?: Maybe<Order_By>;
  stripe_price_id?: Maybe<Order_By>;
  stripe_product_id?: Maybe<Order_By>;
  subscription_plan_access_permission?: Maybe<Subscription_Plan_Access_Permissions_Order_By>;
  subscriptions_aggregate?: Maybe<Subscription_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: subscription_plan */
export type Subscription_Plan_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "subscription_plan" */
export enum Subscription_Plan_Select_Column {
  /** column name */
  AccessPermissionsId = 'access_permissions_id',
  /** column name */
  Archived = 'archived',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InnerName = 'inner_name',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscription_plan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription_plan" */
export enum Subscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** select "subscription_plan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription_plan" */
export enum Subscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** input type for updating data in table "subscription_plan" */
export type Subscription_Plan_Set_Input = {
  access_permissions_id?: Maybe<Scalars['uuid']>;
  archived?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inner_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "subscription_plan" */
export type Subscription_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Plan_Stream_Cursor_Value_Input = {
  access_permissions_id?: Maybe<Scalars['uuid']>;
  archived?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inner_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "subscription_plan" */
export enum Subscription_Plan_Update_Column {
  /** column name */
  AccessPermissionsId = 'access_permissions_id',
  /** column name */
  Archived = 'archived',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InnerName = 'inner_name',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscription_Plan_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Subscription_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Plan_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "admin" */
  admin: Array<Admin>;
  /** fetch aggregated fields from the table: "admin" */
  admin_aggregate: Admin_Aggregate;
  /** fetch data from the table: "admin" using primary key columns */
  admin_by_pk?: Maybe<Admin>;
  /** fetch data from the table in a streaming manner: "admin" */
  admin_stream: Array<Admin>;
  /** fetch data from the table: "application" */
  application: Array<Application>;
  /** fetch aggregated fields from the table: "application" */
  application_aggregate: Application_Aggregate;
  /** fetch data from the table: "application" using primary key columns */
  application_by_pk?: Maybe<Application>;
  /** fetch data from the table in a streaming manner: "application" */
  application_stream: Array<Application>;
  /** fetch data from the table: "candidate" */
  candidate: Array<Candidate>;
  /** fetch aggregated fields from the table: "candidate" */
  candidate_aggregate: Candidate_Aggregate;
  /** fetch data from the table: "candidate" using primary key columns */
  candidate_by_pk?: Maybe<Candidate>;
  /** fetch data from the table in a streaming manner: "candidate" */
  candidate_stream: Array<Candidate>;
  /** fetch data from the table: "chart_admin_contractors" */
  chart_admin_contractors: Array<Chart_Admin_Contractors>;
  /** fetch aggregated fields from the table: "chart_admin_contractors" */
  chart_admin_contractors_aggregate: Chart_Admin_Contractors_Aggregate;
  /** fetch data from the table in a streaming manner: "chart_admin_contractors" */
  chart_admin_contractors_stream: Array<Chart_Admin_Contractors>;
  /** fetch data from the table: "chart_manager_contractors" */
  chart_manager_contractors: Array<Chart_Manager_Contractors>;
  /** fetch aggregated fields from the table: "chart_manager_contractors" */
  chart_manager_contractors_aggregate: Chart_Manager_Contractors_Aggregate;
  /** fetch data from the table in a streaming manner: "chart_manager_contractors" */
  chart_manager_contractors_stream: Array<Chart_Manager_Contractors>;
  /** fetch data from the table: "chart_projects" */
  chart_projects: Array<Chart_Projects>;
  /** fetch aggregated fields from the table: "chart_projects" */
  chart_projects_aggregate: Chart_Projects_Aggregate;
  /** fetch data from the table in a streaming manner: "chart_projects" */
  chart_projects_stream: Array<Chart_Projects>;
  /** fetch data from the table: "checkin_status" */
  checkin_status: Array<Checkin_Status>;
  /** fetch aggregated fields from the table: "checkin_status" */
  checkin_status_aggregate: Checkin_Status_Aggregate;
  /** fetch data from the table: "checkin_status" using primary key columns */
  checkin_status_by_pk?: Maybe<Checkin_Status>;
  /** fetch data from the table in a streaming manner: "checkin_status" */
  checkin_status_stream: Array<Checkin_Status>;
  /** fetch data from the table: "checkout_status" */
  checkout_status: Array<Checkout_Status>;
  /** fetch aggregated fields from the table: "checkout_status" */
  checkout_status_aggregate: Checkout_Status_Aggregate;
  /** fetch data from the table: "checkout_status" using primary key columns */
  checkout_status_by_pk?: Maybe<Checkout_Status>;
  /** fetch data from the table in a streaming manner: "checkout_status" */
  checkout_status_stream: Array<Checkout_Status>;
  /** fetch data from the table: "client_care_plan" */
  client_care_plan: Array<Client_Care_Plan>;
  /** fetch aggregated fields from the table: "client_care_plan" */
  client_care_plan_aggregate: Client_Care_Plan_Aggregate;
  /** fetch data from the table: "client_care_plan" using primary key columns */
  client_care_plan_by_pk?: Maybe<Client_Care_Plan>;
  /** fetch data from the table in a streaming manner: "client_care_plan" */
  client_care_plan_stream: Array<Client_Care_Plan>;
  /** An array relationship */
  client_medications: Array<Client_Medications>;
  /** An aggregate relationship */
  client_medications_aggregate: Client_Medications_Aggregate;
  /** fetch data from the table: "client_medications" using primary key columns */
  client_medications_by_pk?: Maybe<Client_Medications>;
  /** fetch data from the table in a streaming manner: "client_medications" */
  client_medications_stream: Array<Client_Medications>;
  /** fetch data from the table: "company" */
  company: Array<Company>;
  /** fetch aggregated fields from the table: "company" */
  company_aggregate: Company_Aggregate;
  /** fetch data from the table: "company" using primary key columns */
  company_by_pk?: Maybe<Company>;
  /** fetch data from the table: "company_follower" */
  company_follower: Array<Company_Follower>;
  /** fetch aggregated fields from the table: "company_follower" */
  company_follower_aggregate: Company_Follower_Aggregate;
  /** fetch data from the table: "company_follower" using primary key columns */
  company_follower_by_pk?: Maybe<Company_Follower>;
  /** fetch data from the table in a streaming manner: "company_follower" */
  company_follower_stream: Array<Company_Follower>;
  /** fetch data from the table in a streaming manner: "company" */
  company_stream: Array<Company>;
  /** fetch data from the table: "company_user_notifications" */
  company_user_notifications: Array<Company_User_Notifications>;
  /** fetch aggregated fields from the table: "company_user_notifications" */
  company_user_notifications_aggregate: Company_User_Notifications_Aggregate;
  /** fetch data from the table: "company_user_notifications" using primary key columns */
  company_user_notifications_by_pk?: Maybe<Company_User_Notifications>;
  /** fetch data from the table in a streaming manner: "company_user_notifications" */
  company_user_notifications_stream: Array<Company_User_Notifications>;
  /** fetch data from the table: "contractor" */
  contractor: Array<Contractor>;
  /** fetch aggregated fields from the table: "contractor" */
  contractor_aggregate: Contractor_Aggregate;
  /** fetch data from the table: "contractor" using primary key columns */
  contractor_by_pk?: Maybe<Contractor>;
  /** fetch data from the table: "contractor_note" */
  contractor_note: Array<Contractor_Note>;
  /** fetch aggregated fields from the table: "contractor_note" */
  contractor_note_aggregate: Contractor_Note_Aggregate;
  /** fetch data from the table: "contractor_note" using primary key columns */
  contractor_note_by_pk?: Maybe<Contractor_Note>;
  /** fetch data from the table in a streaming manner: "contractor_note" */
  contractor_note_stream: Array<Contractor_Note>;
  /** fetch data from the table: "contractor_posting" */
  contractor_posting: Array<Contractor_Posting>;
  /** fetch aggregated fields from the table: "contractor_posting" */
  contractor_posting_aggregate: Contractor_Posting_Aggregate;
  /** fetch data from the table: "contractor_posting" using primary key columns */
  contractor_posting_by_pk?: Maybe<Contractor_Posting>;
  /** fetch data from the table in a streaming manner: "contractor_posting" */
  contractor_posting_stream: Array<Contractor_Posting>;
  /** fetch data from the table: "contractor_project" */
  contractor_project: Array<Contractor_Project>;
  /** fetch aggregated fields from the table: "contractor_project" */
  contractor_project_aggregate: Contractor_Project_Aggregate;
  /** fetch data from the table: "contractor_project" using primary key columns */
  contractor_project_by_pk?: Maybe<Contractor_Project>;
  /** fetch data from the table in a streaming manner: "contractor_project" */
  contractor_project_stream: Array<Contractor_Project>;
  /** fetch data from the table: "contractor_rating" */
  contractor_rating: Array<Contractor_Rating>;
  /** fetch aggregated fields from the table: "contractor_rating" */
  contractor_rating_aggregate: Contractor_Rating_Aggregate;
  /** fetch data from the table: "contractor_rating" using primary key columns */
  contractor_rating_by_pk?: Maybe<Contractor_Rating>;
  /** fetch data from the table in a streaming manner: "contractor_rating" */
  contractor_rating_stream: Array<Contractor_Rating>;
  /** fetch data from the table: "contractor_staff_note" */
  contractor_staff_note: Array<Contractor_Staff_Note>;
  /** fetch aggregated fields from the table: "contractor_staff_note" */
  contractor_staff_note_aggregate: Contractor_Staff_Note_Aggregate;
  /** fetch data from the table: "contractor_staff_note" using primary key columns */
  contractor_staff_note_by_pk?: Maybe<Contractor_Staff_Note>;
  /** fetch data from the table in a streaming manner: "contractor_staff_note" */
  contractor_staff_note_stream: Array<Contractor_Staff_Note>;
  /** fetch data from the table in a streaming manner: "contractor" */
  contractor_stream: Array<Contractor>;
  /** fetch data from the table: "conversation" */
  conversation: Array<Conversation>;
  /** fetch aggregated fields from the table: "conversation" */
  conversation_aggregate: Conversation_Aggregate;
  /** fetch data from the table: "conversation" using primary key columns */
  conversation_by_pk?: Maybe<Conversation>;
  /** fetch data from the table in a streaming manner: "conversation" */
  conversation_stream: Array<Conversation>;
  /** fetch data from the table: "custom_request" */
  custom_request: Array<Custom_Request>;
  /** fetch aggregated fields from the table: "custom_request" */
  custom_request_aggregate: Custom_Request_Aggregate;
  /** fetch data from the table: "custom_request" using primary key columns */
  custom_request_by_pk?: Maybe<Custom_Request>;
  /** An array relationship */
  custom_request_skills: Array<Custom_Request_Skills>;
  /** An aggregate relationship */
  custom_request_skills_aggregate: Custom_Request_Skills_Aggregate;
  /** fetch data from the table: "custom_request_skills" using primary key columns */
  custom_request_skills_by_pk?: Maybe<Custom_Request_Skills>;
  /** fetch data from the table in a streaming manner: "custom_request_skills" */
  custom_request_skills_stream: Array<Custom_Request_Skills>;
  /** fetch data from the table in a streaming manner: "custom_request" */
  custom_request_stream: Array<Custom_Request>;
  /** An array relationship */
  declined_visit_matches: Array<Declined_Visit_Matches>;
  /** An aggregate relationship */
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  /** fetch data from the table: "declined_visit_matches" using primary key columns */
  declined_visit_matches_by_pk?: Maybe<Declined_Visit_Matches>;
  /** fetch data from the table in a streaming manner: "declined_visit_matches" */
  declined_visit_matches_stream: Array<Declined_Visit_Matches>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "document_contractor_access" */
  document_contractor_access: Array<Document_Contractor_Access>;
  /** fetch aggregated fields from the table: "document_contractor_access" */
  document_contractor_access_aggregate: Document_Contractor_Access_Aggregate;
  /** fetch data from the table: "document_contractor_access" using primary key columns */
  document_contractor_access_by_pk?: Maybe<Document_Contractor_Access>;
  /** fetch data from the table in a streaming manner: "document_contractor_access" */
  document_contractor_access_stream: Array<Document_Contractor_Access>;
  /** fetch data from the table: "document_custom_request" */
  document_custom_request: Array<Document_Custom_Request>;
  /** fetch aggregated fields from the table: "document_custom_request" */
  document_custom_request_aggregate: Document_Custom_Request_Aggregate;
  /** fetch data from the table: "document_custom_request" using primary key columns */
  document_custom_request_by_pk?: Maybe<Document_Custom_Request>;
  /** fetch data from the table in a streaming manner: "document_custom_request" */
  document_custom_request_stream: Array<Document_Custom_Request>;
  /** fetch data from the table: "document_project" */
  document_project: Array<Document_Project>;
  /** fetch aggregated fields from the table: "document_project" */
  document_project_aggregate: Document_Project_Aggregate;
  /** fetch data from the table: "document_project" using primary key columns */
  document_project_by_pk?: Maybe<Document_Project>;
  /** fetch data from the table in a streaming manner: "document_project" */
  document_project_stream: Array<Document_Project>;
  /** fetch data from the table in a streaming manner: "document" */
  document_stream: Array<Document>;
  /** fetch data from the table: "document_user" */
  document_user: Array<Document_User>;
  /** fetch aggregated fields from the table: "document_user" */
  document_user_aggregate: Document_User_Aggregate;
  /** fetch data from the table: "document_user" using primary key columns */
  document_user_by_pk?: Maybe<Document_User>;
  /** fetch data from the table in a streaming manner: "document_user" */
  document_user_stream: Array<Document_User>;
  /** fetch data from the table: "email_regex" */
  email_regex: Array<Email_Regex>;
  /** fetch aggregated fields from the table: "email_regex" */
  email_regex_aggregate: Email_Regex_Aggregate;
  /** fetch data from the table: "email_regex" using primary key columns */
  email_regex_by_pk?: Maybe<Email_Regex>;
  /** fetch data from the table in a streaming manner: "email_regex" */
  email_regex_stream: Array<Email_Regex>;
  /** fetch data from the table: "experience_skill" */
  experience_skill: Array<Experience_Skill>;
  /** fetch aggregated fields from the table: "experience_skill" */
  experience_skill_aggregate: Experience_Skill_Aggregate;
  /** fetch data from the table: "experience_skill" using primary key columns */
  experience_skill_by_pk?: Maybe<Experience_Skill>;
  /** fetch data from the table in a streaming manner: "experience_skill" */
  experience_skill_stream: Array<Experience_Skill>;
  /** fetch data from the table: "gender" */
  gender: Array<Gender>;
  /** fetch aggregated fields from the table: "gender" */
  gender_aggregate: Gender_Aggregate;
  /** fetch data from the table: "gender" using primary key columns */
  gender_by_pk?: Maybe<Gender>;
  /** fetch data from the table in a streaming manner: "gender" */
  gender_stream: Array<Gender>;
  /** fetch data from the table: "industry" */
  industry: Array<Industry>;
  /** fetch aggregated fields from the table: "industry" */
  industry_aggregate: Industry_Aggregate;
  /** fetch data from the table: "industry" using primary key columns */
  industry_by_pk?: Maybe<Industry>;
  /** fetch data from the table in a streaming manner: "industry" */
  industry_stream: Array<Industry>;
  /** fetch data from the table: "invitation" */
  invitation: Array<Invitation>;
  /** fetch aggregated fields from the table: "invitation" */
  invitation_aggregate: Invitation_Aggregate;
  /** fetch data from the table: "invitation" using primary key columns */
  invitation_by_pk?: Maybe<Invitation>;
  /** fetch data from the table in a streaming manner: "invitation" */
  invitation_stream: Array<Invitation>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table in a streaming manner: "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "language" */
  language: Array<Language>;
  /** fetch aggregated fields from the table: "language" */
  language_aggregate: Language_Aggregate;
  /** fetch data from the table: "language" using primary key columns */
  language_by_pk?: Maybe<Language>;
  /** fetch data from the table in a streaming manner: "language" */
  language_stream: Array<Language>;
  /** fetch data from the table: "manager" */
  manager: Array<Manager>;
  /** fetch aggregated fields from the table: "manager" */
  manager_aggregate: Manager_Aggregate;
  /** fetch data from the table: "manager" using primary key columns */
  manager_by_pk?: Maybe<Manager>;
  /** fetch data from the table: "manager_contractor" */
  manager_contractor: Array<Manager_Contractor>;
  /** fetch aggregated fields from the table: "manager_contractor" */
  manager_contractor_aggregate: Manager_Contractor_Aggregate;
  /** fetch data from the table: "manager_contractor" using primary key columns */
  manager_contractor_by_pk?: Maybe<Manager_Contractor>;
  /** fetch data from the table in a streaming manner: "manager_contractor" */
  manager_contractor_stream: Array<Manager_Contractor>;
  /** fetch data from the table in a streaming manner: "manager" */
  manager_stream: Array<Manager>;
  /** fetch data from the table: "message" */
  message: Array<Message>;
  /** fetch aggregated fields from the table: "message" */
  message_aggregate: Message_Aggregate;
  /** fetch data from the table: "message" using primary key columns */
  message_by_pk?: Maybe<Message>;
  /** fetch data from the table in a streaming manner: "message" */
  message_stream: Array<Message>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table in a streaming manner: "notification" */
  notification_stream: Array<Notification>;
  /** fetch data from the table: "onboarding" */
  onboarding: Array<Onboarding>;
  /** fetch aggregated fields from the table: "onboarding" */
  onboarding_aggregate: Onboarding_Aggregate;
  /** fetch data from the table: "onboarding" using primary key columns */
  onboarding_by_pk?: Maybe<Onboarding>;
  /** fetch data from the table in a streaming manner: "onboarding" */
  onboarding_stream: Array<Onboarding>;
  /** fetch data from the table: "payment_card" */
  payment_card: Array<Payment_Card>;
  /** fetch aggregated fields from the table: "payment_card" */
  payment_card_aggregate: Payment_Card_Aggregate;
  /** fetch data from the table: "payment_card" using primary key columns */
  payment_card_by_pk?: Maybe<Payment_Card>;
  /** fetch data from the table in a streaming manner: "payment_card" */
  payment_card_stream: Array<Payment_Card>;
  /** fetch data from the table: "posting" */
  posting: Array<Posting>;
  /** fetch aggregated fields from the table: "posting" */
  posting_aggregate: Posting_Aggregate;
  /** fetch data from the table: "posting" using primary key columns */
  posting_by_pk?: Maybe<Posting>;
  /** fetch data from the table: "posting_industry" */
  posting_industry: Array<Posting_Industry>;
  /** fetch aggregated fields from the table: "posting_industry" */
  posting_industry_aggregate: Posting_Industry_Aggregate;
  /** fetch data from the table: "posting_industry" using primary key columns */
  posting_industry_by_pk?: Maybe<Posting_Industry>;
  /** fetch data from the table in a streaming manner: "posting_industry" */
  posting_industry_stream: Array<Posting_Industry>;
  /** fetch data from the table: "posting_skill" */
  posting_skill: Array<Posting_Skill>;
  /** fetch aggregated fields from the table: "posting_skill" */
  posting_skill_aggregate: Posting_Skill_Aggregate;
  /** fetch data from the table: "posting_skill" using primary key columns */
  posting_skill_by_pk?: Maybe<Posting_Skill>;
  /** fetch data from the table in a streaming manner: "posting_skill" */
  posting_skill_stream: Array<Posting_Skill>;
  /** fetch data from the table in a streaming manner: "posting" */
  posting_stream: Array<Posting>;
  /** An array relationship */
  posting_tags: Array<Posting_Tags>;
  /** An aggregate relationship */
  posting_tags_aggregate: Posting_Tags_Aggregate;
  /** fetch data from the table: "posting_tags" using primary key columns */
  posting_tags_by_pk?: Maybe<Posting_Tags>;
  /** fetch data from the table in a streaming manner: "posting_tags" */
  posting_tags_stream: Array<Posting_Tags>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch data from the table: "project_activity" */
  project_activity: Array<Project_Activity>;
  /** fetch aggregated fields from the table: "project_activity" */
  project_activity_aggregate: Project_Activity_Aggregate;
  /** fetch data from the table: "project_activity" using primary key columns */
  project_activity_by_pk?: Maybe<Project_Activity>;
  /** fetch data from the table: "project_activity_note" */
  project_activity_note: Array<Project_Activity_Note>;
  /** fetch aggregated fields from the table: "project_activity_note" */
  project_activity_note_aggregate: Project_Activity_Note_Aggregate;
  /** fetch data from the table: "project_activity_note" using primary key columns */
  project_activity_note_by_pk?: Maybe<Project_Activity_Note>;
  /** fetch data from the table in a streaming manner: "project_activity_note" */
  project_activity_note_stream: Array<Project_Activity_Note>;
  /** An array relationship */
  project_activity_request_more_hours: Array<Project_Activity_Request_More_Hours>;
  /** An aggregate relationship */
  project_activity_request_more_hours_aggregate: Project_Activity_Request_More_Hours_Aggregate;
  /** fetch data from the table: "project_activity_request_more_hours" using primary key columns */
  project_activity_request_more_hours_by_pk?: Maybe<Project_Activity_Request_More_Hours>;
  /** fetch data from the table in a streaming manner: "project_activity_request_more_hours" */
  project_activity_request_more_hours_stream: Array<Project_Activity_Request_More_Hours>;
  /** fetch data from the table: "project_activity_skill" */
  project_activity_skill: Array<Project_Activity_Skill>;
  /** fetch aggregated fields from the table: "project_activity_skill" */
  project_activity_skill_aggregate: Project_Activity_Skill_Aggregate;
  /** fetch data from the table: "project_activity_skill" using primary key columns */
  project_activity_skill_by_pk?: Maybe<Project_Activity_Skill>;
  /** fetch data from the table in a streaming manner: "project_activity_skill" */
  project_activity_skill_stream: Array<Project_Activity_Skill>;
  /** fetch data from the table: "project_activity_soft_skill" */
  project_activity_soft_skill: Array<Project_Activity_Soft_Skill>;
  /** fetch aggregated fields from the table: "project_activity_soft_skill" */
  project_activity_soft_skill_aggregate: Project_Activity_Soft_Skill_Aggregate;
  /** fetch data from the table: "project_activity_soft_skill" using primary key columns */
  project_activity_soft_skill_by_pk?: Maybe<Project_Activity_Soft_Skill>;
  /** fetch data from the table in a streaming manner: "project_activity_soft_skill" */
  project_activity_soft_skill_stream: Array<Project_Activity_Soft_Skill>;
  /** fetch data from the table in a streaming manner: "project_activity" */
  project_activity_stream: Array<Project_Activity>;
  /** fetch data from the table: "project_activity_tag" */
  project_activity_tag: Array<Project_Activity_Tag>;
  /** fetch aggregated fields from the table: "project_activity_tag" */
  project_activity_tag_aggregate: Project_Activity_Tag_Aggregate;
  /** fetch data from the table: "project_activity_tag" using primary key columns */
  project_activity_tag_by_pk?: Maybe<Project_Activity_Tag>;
  /** fetch data from the table in a streaming manner: "project_activity_tag" */
  project_activity_tag_stream: Array<Project_Activity_Tag>;
  /** fetch data from the table: "project_activity_time" */
  project_activity_time: Array<Project_Activity_Time>;
  /** fetch aggregated fields from the table: "project_activity_time" */
  project_activity_time_aggregate: Project_Activity_Time_Aggregate;
  /** fetch data from the table: "project_activity_time" using primary key columns */
  project_activity_time_by_pk?: Maybe<Project_Activity_Time>;
  /** fetch data from the table in a streaming manner: "project_activity_time" */
  project_activity_time_stream: Array<Project_Activity_Time>;
  /** fetch data from the table: "project_activity_tracked_time" */
  project_activity_tracked_time: Array<Project_Activity_Tracked_Time>;
  /** fetch aggregated fields from the table: "project_activity_tracked_time" */
  project_activity_tracked_time_aggregate: Project_Activity_Tracked_Time_Aggregate;
  /** fetch data from the table: "project_activity_tracked_time" using primary key columns */
  project_activity_tracked_time_by_pk?: Maybe<Project_Activity_Tracked_Time>;
  /** fetch data from the table in a streaming manner: "project_activity_tracked_time" */
  project_activity_tracked_time_stream: Array<Project_Activity_Tracked_Time>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_skill" */
  project_skill: Array<Project_Skill>;
  /** fetch aggregated fields from the table: "project_skill" */
  project_skill_aggregate: Project_Skill_Aggregate;
  /** fetch data from the table: "project_skill" using primary key columns */
  project_skill_by_pk?: Maybe<Project_Skill>;
  /** fetch data from the table in a streaming manner: "project_skill" */
  project_skill_stream: Array<Project_Skill>;
  /** fetch data from the table: "project_soft_skill" */
  project_soft_skill: Array<Project_Soft_Skill>;
  /** fetch aggregated fields from the table: "project_soft_skill" */
  project_soft_skill_aggregate: Project_Soft_Skill_Aggregate;
  /** fetch data from the table: "project_soft_skill" using primary key columns */
  project_soft_skill_by_pk?: Maybe<Project_Soft_Skill>;
  /** fetch data from the table in a streaming manner: "project_soft_skill" */
  project_soft_skill_stream: Array<Project_Soft_Skill>;
  /** fetch data from the table in a streaming manner: "project" */
  project_stream: Array<Project>;
  /** fetch data from the table: "project_tag" */
  project_tag: Array<Project_Tag>;
  /** fetch aggregated fields from the table: "project_tag" */
  project_tag_aggregate: Project_Tag_Aggregate;
  /** fetch data from the table: "project_tag" using primary key columns */
  project_tag_by_pk?: Maybe<Project_Tag>;
  /** fetch data from the table in a streaming manner: "project_tag" */
  project_tag_stream: Array<Project_Tag>;
  /** fetch data from the table: "public_project_details" */
  public_project_details: Array<Public_Project_Details>;
  /** fetch aggregated fields from the table: "public_project_details" */
  public_project_details_aggregate: Public_Project_Details_Aggregate;
  /** fetch data from the table in a streaming manner: "public_project_details" */
  public_project_details_stream: Array<Public_Project_Details>;
  /** An array relationship */
  recipient_message: Array<Recipient_Message>;
  /** An aggregate relationship */
  recipient_message_aggregate: Recipient_Message_Aggregate;
  /** fetch data from the table: "recipient_message" using primary key columns */
  recipient_message_by_pk?: Maybe<Recipient_Message>;
  /** fetch data from the table in a streaming manner: "recipient_message" */
  recipient_message_stream: Array<Recipient_Message>;
  /** fetch data from the table: "resource_information_card" */
  resource_information_card: Array<Resource_Information_Card>;
  /** fetch aggregated fields from the table: "resource_information_card" */
  resource_information_card_aggregate: Resource_Information_Card_Aggregate;
  /** fetch data from the table: "resource_information_card" using primary key columns */
  resource_information_card_by_pk?: Maybe<Resource_Information_Card>;
  /** fetch data from the table in a streaming manner: "resource_information_card" */
  resource_information_card_stream: Array<Resource_Information_Card>;
  /** execute function "search_industry" which returns "industry" */
  search_industry: Array<Industry>;
  /** execute function "search_industry" and query aggregates on result of table type "industry" */
  search_industry_aggregate: Industry_Aggregate;
  /** execute function "search_skill" which returns "skill" */
  search_skill: Array<Skill>;
  /** execute function "search_skill" and query aggregates on result of table type "skill" */
  search_skill_aggregate: Skill_Aggregate;
  /** fetch data from the table: "skill" */
  skill: Array<Skill>;
  /** fetch aggregated fields from the table: "skill" */
  skill_aggregate: Skill_Aggregate;
  /** fetch data from the table: "skill" using primary key columns */
  skill_by_pk?: Maybe<Skill>;
  /** fetch data from the table in a streaming manner: "skill" */
  skill_stream: Array<Skill>;
  /** fetch data from the table: "skills_short_name_first" */
  skills_short_name_first: Array<Skills_Short_Name_First>;
  /** fetch aggregated fields from the table: "skills_short_name_first" */
  skills_short_name_first_aggregate: Skills_Short_Name_First_Aggregate;
  /** fetch data from the table in a streaming manner: "skills_short_name_first" */
  skills_short_name_first_stream: Array<Skills_Short_Name_First>;
  /** fetch data from the table: "smart_match_bookmark" */
  smart_match_bookmark: Array<Smart_Match_Bookmark>;
  /** fetch aggregated fields from the table: "smart_match_bookmark" */
  smart_match_bookmark_aggregate: Smart_Match_Bookmark_Aggregate;
  /** fetch data from the table: "smart_match_bookmark" using primary key columns */
  smart_match_bookmark_by_pk?: Maybe<Smart_Match_Bookmark>;
  /** fetch data from the table in a streaming manner: "smart_match_bookmark" */
  smart_match_bookmark_stream: Array<Smart_Match_Bookmark>;
  /** fetch data from the table: "smart_match_config_transportation" */
  smart_match_config_transportation: Array<Smart_Match_Config_Transportation>;
  /** fetch aggregated fields from the table: "smart_match_config_transportation" */
  smart_match_config_transportation_aggregate: Smart_Match_Config_Transportation_Aggregate;
  /** fetch data from the table: "smart_match_config_transportation" using primary key columns */
  smart_match_config_transportation_by_pk?: Maybe<Smart_Match_Config_Transportation>;
  /** fetch data from the table in a streaming manner: "smart_match_config_transportation" */
  smart_match_config_transportation_stream: Array<Smart_Match_Config_Transportation>;
  /** fetch data from the table: "smart_match_configs" */
  smart_match_configs: Array<Smart_Match_Configs>;
  /** fetch aggregated fields from the table: "smart_match_configs" */
  smart_match_configs_aggregate: Smart_Match_Configs_Aggregate;
  /** fetch data from the table: "smart_match_configs" using primary key columns */
  smart_match_configs_by_pk?: Maybe<Smart_Match_Configs>;
  /** fetch data from the table in a streaming manner: "smart_match_configs" */
  smart_match_configs_stream: Array<Smart_Match_Configs>;
  /** fetch data from the table: "smart_match_criteria_order" */
  smart_match_criteria_order: Array<Smart_Match_Criteria_Order>;
  /** fetch aggregated fields from the table: "smart_match_criteria_order" */
  smart_match_criteria_order_aggregate: Smart_Match_Criteria_Order_Aggregate;
  /** fetch data from the table: "smart_match_criteria_order" using primary key columns */
  smart_match_criteria_order_by_pk?: Maybe<Smart_Match_Criteria_Order>;
  /** fetch data from the table in a streaming manner: "smart_match_criteria_order" */
  smart_match_criteria_order_stream: Array<Smart_Match_Criteria_Order>;
  /** fetch data from the table: "soft_skill" */
  soft_skill: Array<Soft_Skill>;
  /** fetch aggregated fields from the table: "soft_skill" */
  soft_skill_aggregate: Soft_Skill_Aggregate;
  /** fetch data from the table: "soft_skill" using primary key columns */
  soft_skill_by_pk?: Maybe<Soft_Skill>;
  /** fetch data from the table in a streaming manner: "soft_skill" */
  soft_skill_stream: Array<Soft_Skill>;
  /** fetch data from the table: "source" */
  source: Array<Source>;
  /** fetch aggregated fields from the table: "source" */
  source_aggregate: Source_Aggregate;
  /** fetch data from the table: "source" using primary key columns */
  source_by_pk?: Maybe<Source>;
  /** fetch data from the table in a streaming manner: "source" */
  source_stream: Array<Source>;
  /** fetch data from the table: "subscription" */
  subscription: Array<Subscription>;
  /** fetch aggregated fields from the table: "subscription" */
  subscription_aggregate: Subscription_Aggregate;
  /** fetch data from the table: "subscription" using primary key columns */
  subscription_by_pk?: Maybe<Subscription>;
  /** fetch data from the table: "subscription_plan" */
  subscription_plan: Array<Subscription_Plan>;
  /** fetch data from the table: "subscription_plan_access_permissions" */
  subscription_plan_access_permissions: Array<Subscription_Plan_Access_Permissions>;
  /** fetch aggregated fields from the table: "subscription_plan_access_permissions" */
  subscription_plan_access_permissions_aggregate: Subscription_Plan_Access_Permissions_Aggregate;
  /** fetch data from the table: "subscription_plan_access_permissions" using primary key columns */
  subscription_plan_access_permissions_by_pk?: Maybe<Subscription_Plan_Access_Permissions>;
  /** fetch data from the table in a streaming manner: "subscription_plan_access_permissions" */
  subscription_plan_access_permissions_stream: Array<Subscription_Plan_Access_Permissions>;
  /** fetch aggregated fields from the table: "subscription_plan" */
  subscription_plan_aggregate: Subscription_Plan_Aggregate;
  /** fetch data from the table: "subscription_plan" using primary key columns */
  subscription_plan_by_pk?: Maybe<Subscription_Plan>;
  /** fetch data from the table in a streaming manner: "subscription_plan" */
  subscription_plan_stream: Array<Subscription_Plan>;
  /** fetch data from the table in a streaming manner: "subscription" */
  subscription_stream: Array<Subscription>;
  /** fetch data from the table: "tag" */
  tag: Array<Tag>;
  /** fetch aggregated fields from the table: "tag" */
  tag_aggregate: Tag_Aggregate;
  /** fetch data from the table: "tag" using primary key columns */
  tag_by_pk?: Maybe<Tag>;
  /** fetch data from the table in a streaming manner: "tag" */
  tag_stream: Array<Tag>;
  /** fetch data from the table: "team" */
  team: Array<Team>;
  /** fetch aggregated fields from the table: "team" */
  team_aggregate: Team_Aggregate;
  /** fetch data from the table: "team" using primary key columns */
  team_by_pk?: Maybe<Team>;
  /** fetch data from the table: "team_contractor" */
  team_contractor: Array<Team_Contractor>;
  /** fetch aggregated fields from the table: "team_contractor" */
  team_contractor_aggregate: Team_Contractor_Aggregate;
  /** fetch data from the table: "team_contractor" using primary key columns */
  team_contractor_by_pk?: Maybe<Team_Contractor>;
  /** fetch data from the table in a streaming manner: "team_contractor" */
  team_contractor_stream: Array<Team_Contractor>;
  /** fetch data from the table: "team_manager" */
  team_manager: Array<Team_Manager>;
  /** fetch aggregated fields from the table: "team_manager" */
  team_manager_aggregate: Team_Manager_Aggregate;
  /** fetch data from the table: "team_manager" using primary key columns */
  team_manager_by_pk?: Maybe<Team_Manager>;
  /** fetch data from the table in a streaming manner: "team_manager" */
  team_manager_stream: Array<Team_Manager>;
  /** fetch data from the table: "team_posting" */
  team_posting: Array<Team_Posting>;
  /** fetch aggregated fields from the table: "team_posting" */
  team_posting_aggregate: Team_Posting_Aggregate;
  /** fetch data from the table: "team_posting" using primary key columns */
  team_posting_by_pk?: Maybe<Team_Posting>;
  /** fetch data from the table in a streaming manner: "team_posting" */
  team_posting_stream: Array<Team_Posting>;
  /** fetch data from the table: "team_project" */
  team_project: Array<Team_Project>;
  /** fetch aggregated fields from the table: "team_project" */
  team_project_aggregate: Team_Project_Aggregate;
  /** fetch data from the table: "team_project" using primary key columns */
  team_project_by_pk?: Maybe<Team_Project>;
  /** fetch data from the table in a streaming manner: "team_project" */
  team_project_stream: Array<Team_Project>;
  /** fetch data from the table: "team_skill" */
  team_skill: Array<Team_Skill>;
  /** fetch aggregated fields from the table: "team_skill" */
  team_skill_aggregate: Team_Skill_Aggregate;
  /** fetch data from the table: "team_skill" using primary key columns */
  team_skill_by_pk?: Maybe<Team_Skill>;
  /** fetch data from the table in a streaming manner: "team_skill" */
  team_skill_stream: Array<Team_Skill>;
  /** fetch data from the table in a streaming manner: "team" */
  team_stream: Array<Team>;
  /** fetch data from the table: "timesheet" */
  timesheet: Array<Timesheet>;
  /** fetch aggregated fields from the table: "timesheet" */
  timesheet_aggregate: Timesheet_Aggregate;
  /** fetch data from the table: "timesheet" using primary key columns */
  timesheet_by_pk?: Maybe<Timesheet>;
  /** fetch data from the table in a streaming manner: "timesheet" */
  timesheet_stream: Array<Timesheet>;
  /** fetch data from the table: "type_of_visit" */
  type_of_visit: Array<Type_Of_Visit>;
  /** fetch aggregated fields from the table: "type_of_visit" */
  type_of_visit_aggregate: Type_Of_Visit_Aggregate;
  /** fetch data from the table: "type_of_visit" using primary key columns */
  type_of_visit_by_pk?: Maybe<Type_Of_Visit>;
  /** fetch data from the table in a streaming manner: "type_of_visit" */
  type_of_visit_stream: Array<Type_Of_Visit>;
  /** fetch data from the table: "unread_messages" */
  unread_messages: Array<Unread_Messages>;
  /** fetch aggregated fields from the table: "unread_messages" */
  unread_messages_aggregate: Unread_Messages_Aggregate;
  /** fetch data from the table in a streaming manner: "unread_messages" */
  unread_messages_stream: Array<Unread_Messages>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user_affinda_profile" */
  user_affinda_profile: Array<User_Affinda_Profile>;
  /** fetch aggregated fields from the table: "user_affinda_profile" */
  user_affinda_profile_aggregate: User_Affinda_Profile_Aggregate;
  /** fetch data from the table: "user_affinda_profile" using primary key columns */
  user_affinda_profile_by_pk?: Maybe<User_Affinda_Profile>;
  /** fetch data from the table in a streaming manner: "user_affinda_profile" */
  user_affinda_profile_stream: Array<User_Affinda_Profile>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_certification" */
  user_certification: Array<User_Certification>;
  /** fetch aggregated fields from the table: "user_certification" */
  user_certification_aggregate: User_Certification_Aggregate;
  /** fetch data from the table: "user_certification" using primary key columns */
  user_certification_by_pk?: Maybe<User_Certification>;
  /** fetch data from the table in a streaming manner: "user_certification" */
  user_certification_stream: Array<User_Certification>;
  /** fetch data from the table: "user_company" */
  user_company: Array<User_Company>;
  /** fetch aggregated fields from the table: "user_company" */
  user_company_aggregate: User_Company_Aggregate;
  /** fetch data from the table: "user_company" using primary key columns */
  user_company_by_pk?: Maybe<User_Company>;
  /** fetch data from the table in a streaming manner: "user_company" */
  user_company_stream: Array<User_Company>;
  /** fetch data from the table: "user_conversation" */
  user_conversation: Array<User_Conversation>;
  /** fetch aggregated fields from the table: "user_conversation" */
  user_conversation_aggregate: User_Conversation_Aggregate;
  /** fetch data from the table: "user_conversation" using primary key columns */
  user_conversation_by_pk?: Maybe<User_Conversation>;
  /** fetch data from the table in a streaming manner: "user_conversation" */
  user_conversation_stream: Array<User_Conversation>;
  /** fetch data from the table: "user_education" */
  user_education: Array<User_Education>;
  /** fetch aggregated fields from the table: "user_education" */
  user_education_aggregate: User_Education_Aggregate;
  /** fetch data from the table: "user_education" using primary key columns */
  user_education_by_pk?: Maybe<User_Education>;
  /** fetch data from the table in a streaming manner: "user_education" */
  user_education_stream: Array<User_Education>;
  /** fetch data from the table: "user_experience" */
  user_experience: Array<User_Experience>;
  /** fetch aggregated fields from the table: "user_experience" */
  user_experience_aggregate: User_Experience_Aggregate;
  /** fetch data from the table: "user_experience" using primary key columns */
  user_experience_by_pk?: Maybe<User_Experience>;
  /** fetch data from the table in a streaming manner: "user_experience" */
  user_experience_stream: Array<User_Experience>;
  /** fetch data from the table: "user_favorite" */
  user_favorite: Array<User_Favorite>;
  /** fetch aggregated fields from the table: "user_favorite" */
  user_favorite_aggregate: User_Favorite_Aggregate;
  /** fetch data from the table: "user_favorite" using primary key columns */
  user_favorite_by_pk?: Maybe<User_Favorite>;
  /** fetch data from the table in a streaming manner: "user_favorite" */
  user_favorite_stream: Array<User_Favorite>;
  /** fetch data from the table: "user_industry" */
  user_industry: Array<User_Industry>;
  /** fetch aggregated fields from the table: "user_industry" */
  user_industry_aggregate: User_Industry_Aggregate;
  /** fetch data from the table: "user_industry" using primary key columns */
  user_industry_by_pk?: Maybe<User_Industry>;
  /** fetch data from the table in a streaming manner: "user_industry" */
  user_industry_stream: Array<User_Industry>;
  /** fetch data from the table: "user_job_title" */
  user_job_title: Array<User_Job_Title>;
  /** fetch aggregated fields from the table: "user_job_title" */
  user_job_title_aggregate: User_Job_Title_Aggregate;
  /** fetch data from the table: "user_job_title" using primary key columns */
  user_job_title_by_pk?: Maybe<User_Job_Title>;
  /** fetch data from the table in a streaming manner: "user_job_title" */
  user_job_title_stream: Array<User_Job_Title>;
  /** fetch data from the table: "user_language" */
  user_language: Array<User_Language>;
  /** fetch aggregated fields from the table: "user_language" */
  user_language_aggregate: User_Language_Aggregate;
  /** fetch data from the table: "user_language" using primary key columns */
  user_language_by_pk?: Maybe<User_Language>;
  /** fetch data from the table in a streaming manner: "user_language" */
  user_language_stream: Array<User_Language>;
  /** fetch data from the table: "user_private_data" */
  user_private_data: Array<User_Private_Data>;
  /** fetch aggregated fields from the table: "user_private_data" */
  user_private_data_aggregate: User_Private_Data_Aggregate;
  /** fetch data from the table in a streaming manner: "user_private_data" */
  user_private_data_stream: Array<User_Private_Data>;
  /** fetch data from the table: "user_profile" */
  user_profile: Array<User_Profile>;
  /** fetch aggregated fields from the table: "user_profile" */
  user_profile_aggregate: User_Profile_Aggregate;
  /** fetch data from the table: "user_profile_by_management" */
  user_profile_by_management: Array<User_Profile_By_Management>;
  /** fetch aggregated fields from the table: "user_profile_by_management" */
  user_profile_by_management_aggregate: User_Profile_By_Management_Aggregate;
  /** fetch data from the table: "user_profile_by_management" using primary key columns */
  user_profile_by_management_by_pk?: Maybe<User_Profile_By_Management>;
  /** fetch data from the table in a streaming manner: "user_profile_by_management" */
  user_profile_by_management_stream: Array<User_Profile_By_Management>;
  /** fetch data from the table: "user_profile" using primary key columns */
  user_profile_by_pk?: Maybe<User_Profile>;
  /** fetch data from the table in a streaming manner: "user_profile" */
  user_profile_stream: Array<User_Profile>;
  /** fetch data from the table: "user_rating" */
  user_rating: Array<User_Rating>;
  /** fetch aggregated fields from the table: "user_rating" */
  user_rating_aggregate: User_Rating_Aggregate;
  /** fetch data from the table: "user_rating" using primary key columns */
  user_rating_by_pk?: Maybe<User_Rating>;
  /** fetch data from the table in a streaming manner: "user_rating" */
  user_rating_stream: Array<User_Rating>;
  /** fetch data from the table: "user_skill" */
  user_skill: Array<User_Skill>;
  /** fetch aggregated fields from the table: "user_skill" */
  user_skill_aggregate: User_Skill_Aggregate;
  /** fetch data from the table: "user_skill" using primary key columns */
  user_skill_by_pk?: Maybe<User_Skill>;
  /** fetch data from the table in a streaming manner: "user_skill" */
  user_skill_stream: Array<User_Skill>;
  /** fetch data from the table: "user_soft_skill" */
  user_soft_skill: Array<User_Soft_Skill>;
  /** fetch aggregated fields from the table: "user_soft_skill" */
  user_soft_skill_aggregate: User_Soft_Skill_Aggregate;
  /** fetch data from the table: "user_soft_skill" using primary key columns */
  user_soft_skill_by_pk?: Maybe<User_Soft_Skill>;
  /** fetch data from the table in a streaming manner: "user_soft_skill" */
  user_soft_skill_stream: Array<User_Soft_Skill>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "user_transportation" */
  user_transportation: Array<User_Transportation>;
  /** fetch aggregated fields from the table: "user_transportation" */
  user_transportation_aggregate: User_Transportation_Aggregate;
  /** fetch data from the table: "user_transportation" using primary key columns */
  user_transportation_by_pk?: Maybe<User_Transportation>;
  /** fetch data from the table in a streaming manner: "user_transportation" */
  user_transportation_stream: Array<User_Transportation>;
  /** fetch data from the table: "user_watchlist" */
  user_watchlist: Array<User_Watchlist>;
  /** fetch aggregated fields from the table: "user_watchlist" */
  user_watchlist_aggregate: User_Watchlist_Aggregate;
  /** fetch data from the table: "user_watchlist" using primary key columns */
  user_watchlist_by_pk?: Maybe<User_Watchlist>;
  /** fetch data from the table in a streaming manner: "user_watchlist" */
  user_watchlist_stream: Array<User_Watchlist>;
};


export type Subscription_RootAdminArgs = {
  distinct_on?: Maybe<Array<Admin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Admin_Order_By>>;
  where?: Maybe<Admin_Bool_Exp>;
};


export type Subscription_RootAdmin_AggregateArgs = {
  distinct_on?: Maybe<Array<Admin_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Admin_Order_By>>;
  where?: Maybe<Admin_Bool_Exp>;
};


export type Subscription_RootAdmin_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAdmin_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Admin_Stream_Cursor_Input>>;
  where?: Maybe<Admin_Bool_Exp>;
};


export type Subscription_RootApplicationArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


export type Subscription_RootApplication_AggregateArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


export type Subscription_RootApplication_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootApplication_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Application_Stream_Cursor_Input>>;
  where?: Maybe<Application_Bool_Exp>;
};


export type Subscription_RootCandidateArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


export type Subscription_RootCandidate_AggregateArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


export type Subscription_RootCandidate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCandidate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Candidate_Stream_Cursor_Input>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


export type Subscription_RootChart_Admin_ContractorsArgs = {
  distinct_on?: Maybe<Array<Chart_Admin_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Admin_Contractors_Order_By>>;
  where?: Maybe<Chart_Admin_Contractors_Bool_Exp>;
};


export type Subscription_RootChart_Admin_Contractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Chart_Admin_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Admin_Contractors_Order_By>>;
  where?: Maybe<Chart_Admin_Contractors_Bool_Exp>;
};


export type Subscription_RootChart_Admin_Contractors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Chart_Admin_Contractors_Stream_Cursor_Input>>;
  where?: Maybe<Chart_Admin_Contractors_Bool_Exp>;
};


export type Subscription_RootChart_Manager_ContractorsArgs = {
  distinct_on?: Maybe<Array<Chart_Manager_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Manager_Contractors_Order_By>>;
  where?: Maybe<Chart_Manager_Contractors_Bool_Exp>;
};


export type Subscription_RootChart_Manager_Contractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Chart_Manager_Contractors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Manager_Contractors_Order_By>>;
  where?: Maybe<Chart_Manager_Contractors_Bool_Exp>;
};


export type Subscription_RootChart_Manager_Contractors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Chart_Manager_Contractors_Stream_Cursor_Input>>;
  where?: Maybe<Chart_Manager_Contractors_Bool_Exp>;
};


export type Subscription_RootChart_ProjectsArgs = {
  distinct_on?: Maybe<Array<Chart_Projects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Projects_Order_By>>;
  where?: Maybe<Chart_Projects_Bool_Exp>;
};


export type Subscription_RootChart_Projects_AggregateArgs = {
  distinct_on?: Maybe<Array<Chart_Projects_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Chart_Projects_Order_By>>;
  where?: Maybe<Chart_Projects_Bool_Exp>;
};


export type Subscription_RootChart_Projects_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Chart_Projects_Stream_Cursor_Input>>;
  where?: Maybe<Chart_Projects_Bool_Exp>;
};


export type Subscription_RootCheckin_StatusArgs = {
  distinct_on?: Maybe<Array<Checkin_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkin_Status_Order_By>>;
  where?: Maybe<Checkin_Status_Bool_Exp>;
};


export type Subscription_RootCheckin_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Checkin_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkin_Status_Order_By>>;
  where?: Maybe<Checkin_Status_Bool_Exp>;
};


export type Subscription_RootCheckin_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCheckin_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Checkin_Status_Stream_Cursor_Input>>;
  where?: Maybe<Checkin_Status_Bool_Exp>;
};


export type Subscription_RootCheckout_StatusArgs = {
  distinct_on?: Maybe<Array<Checkout_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkout_Status_Order_By>>;
  where?: Maybe<Checkout_Status_Bool_Exp>;
};


export type Subscription_RootCheckout_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Checkout_Status_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Checkout_Status_Order_By>>;
  where?: Maybe<Checkout_Status_Bool_Exp>;
};


export type Subscription_RootCheckout_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCheckout_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Checkout_Status_Stream_Cursor_Input>>;
  where?: Maybe<Checkout_Status_Bool_Exp>;
};


export type Subscription_RootClient_Care_PlanArgs = {
  distinct_on?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Care_Plan_Order_By>>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};


export type Subscription_RootClient_Care_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Client_Care_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Care_Plan_Order_By>>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};


export type Subscription_RootClient_Care_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClient_Care_Plan_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Client_Care_Plan_Stream_Cursor_Input>>;
  where?: Maybe<Client_Care_Plan_Bool_Exp>;
};


export type Subscription_RootClient_MedicationsArgs = {
  distinct_on?: Maybe<Array<Client_Medications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Medications_Order_By>>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};


export type Subscription_RootClient_Medications_AggregateArgs = {
  distinct_on?: Maybe<Array<Client_Medications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Client_Medications_Order_By>>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};


export type Subscription_RootClient_Medications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClient_Medications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Client_Medications_Stream_Cursor_Input>>;
  where?: Maybe<Client_Medications_Bool_Exp>;
};


export type Subscription_RootCompanyArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompany_FollowerArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


export type Subscription_RootCompany_Follower_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


export type Subscription_RootCompany_Follower_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompany_Follower_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Company_Follower_Stream_Cursor_Input>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


export type Subscription_RootCompany_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Company_Stream_Cursor_Input>>;
  where?: Maybe<Company_Bool_Exp>;
};


export type Subscription_RootCompany_User_NotificationsArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


export type Subscription_RootCompany_User_Notifications_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


export type Subscription_RootCompany_User_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCompany_User_Notifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Company_User_Notifications_Stream_Cursor_Input>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


export type Subscription_RootContractorArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


export type Subscription_RootContractor_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


export type Subscription_RootContractor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContractor_NoteArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


export type Subscription_RootContractor_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


export type Subscription_RootContractor_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContractor_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Contractor_Note_Stream_Cursor_Input>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


export type Subscription_RootContractor_PostingArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


export type Subscription_RootContractor_Posting_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Posting_Order_By>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


export type Subscription_RootContractor_Posting_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootContractor_Posting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Contractor_Posting_Stream_Cursor_Input>>;
  where?: Maybe<Contractor_Posting_Bool_Exp>;
};


export type Subscription_RootContractor_ProjectArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


export type Subscription_RootContractor_Project_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Project_Order_By>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


export type Subscription_RootContractor_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContractor_Project_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Contractor_Project_Stream_Cursor_Input>>;
  where?: Maybe<Contractor_Project_Bool_Exp>;
};


export type Subscription_RootContractor_RatingArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


export type Subscription_RootContractor_Rating_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


export type Subscription_RootContractor_Rating_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContractor_Rating_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Contractor_Rating_Stream_Cursor_Input>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


export type Subscription_RootContractor_Staff_NoteArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


export type Subscription_RootContractor_Staff_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Staff_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Staff_Note_Order_By>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


export type Subscription_RootContractor_Staff_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootContractor_Staff_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Contractor_Staff_Note_Stream_Cursor_Input>>;
  where?: Maybe<Contractor_Staff_Note_Bool_Exp>;
};


export type Subscription_RootContractor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Contractor_Stream_Cursor_Input>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


export type Subscription_RootConversationArgs = {
  distinct_on?: Maybe<Array<Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Conversation_Order_By>>;
  where?: Maybe<Conversation_Bool_Exp>;
};


export type Subscription_RootConversation_AggregateArgs = {
  distinct_on?: Maybe<Array<Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Conversation_Order_By>>;
  where?: Maybe<Conversation_Bool_Exp>;
};


export type Subscription_RootConversation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootConversation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Conversation_Stream_Cursor_Input>>;
  where?: Maybe<Conversation_Bool_Exp>;
};


export type Subscription_RootCustom_RequestArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


export type Subscription_RootCustom_Request_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


export type Subscription_RootCustom_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCustom_Request_SkillsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


export type Subscription_RootCustom_Request_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Skills_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Skills_Order_By>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


export type Subscription_RootCustom_Request_Skills_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCustom_Request_Skills_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Custom_Request_Skills_Stream_Cursor_Input>>;
  where?: Maybe<Custom_Request_Skills_Bool_Exp>;
};


export type Subscription_RootCustom_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Custom_Request_Stream_Cursor_Input>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


export type Subscription_RootDeclined_Visit_MatchesArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


export type Subscription_RootDeclined_Visit_Matches_AggregateArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


export type Subscription_RootDeclined_Visit_Matches_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDeclined_Visit_Matches_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Declined_Visit_Matches_Stream_Cursor_Input>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


export type Subscription_RootDocumentArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_Contractor_AccessArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


export type Subscription_RootDocument_Contractor_Access_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Contractor_Access_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Contractor_Access_Order_By>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


export type Subscription_RootDocument_Contractor_Access_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_Contractor_Access_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Contractor_Access_Stream_Cursor_Input>>;
  where?: Maybe<Document_Contractor_Access_Bool_Exp>;
};


export type Subscription_RootDocument_Custom_RequestArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


export type Subscription_RootDocument_Custom_Request_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


export type Subscription_RootDocument_Custom_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_Custom_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Custom_Request_Stream_Cursor_Input>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


export type Subscription_RootDocument_ProjectArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


export type Subscription_RootDocument_Project_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Project_Order_By>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


export type Subscription_RootDocument_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_Project_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Project_Stream_Cursor_Input>>;
  where?: Maybe<Document_Project_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_Stream_Cursor_Input>>;
  where?: Maybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_UserArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


export type Subscription_RootDocument_User_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


export type Subscription_RootDocument_User_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Document_User_Stream_Cursor_Input>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


export type Subscription_RootEmail_RegexArgs = {
  distinct_on?: Maybe<Array<Email_Regex_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Regex_Order_By>>;
  where?: Maybe<Email_Regex_Bool_Exp>;
};


export type Subscription_RootEmail_Regex_AggregateArgs = {
  distinct_on?: Maybe<Array<Email_Regex_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Email_Regex_Order_By>>;
  where?: Maybe<Email_Regex_Bool_Exp>;
};


export type Subscription_RootEmail_Regex_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEmail_Regex_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Email_Regex_Stream_Cursor_Input>>;
  where?: Maybe<Email_Regex_Bool_Exp>;
};


export type Subscription_RootExperience_SkillArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


export type Subscription_RootExperience_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


export type Subscription_RootExperience_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootExperience_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Experience_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


export type Subscription_RootGenderArgs = {
  distinct_on?: Maybe<Array<Gender_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Gender_Order_By>>;
  where?: Maybe<Gender_Bool_Exp>;
};


export type Subscription_RootGender_AggregateArgs = {
  distinct_on?: Maybe<Array<Gender_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Gender_Order_By>>;
  where?: Maybe<Gender_Bool_Exp>;
};


export type Subscription_RootGender_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootGender_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Gender_Stream_Cursor_Input>>;
  where?: Maybe<Gender_Bool_Exp>;
};


export type Subscription_RootIndustryArgs = {
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Subscription_RootIndustry_AggregateArgs = {
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Subscription_RootIndustry_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootIndustry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Industry_Stream_Cursor_Input>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Subscription_RootInvitationArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvitation_AggregateArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvitation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvitation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Invitation_Stream_Cursor_Input>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Invoice_Stream_Cursor_Input>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


export type Subscription_RootLanguageArgs = {
  distinct_on?: Maybe<Array<Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Language_Order_By>>;
  where?: Maybe<Language_Bool_Exp>;
};


export type Subscription_RootLanguage_AggregateArgs = {
  distinct_on?: Maybe<Array<Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Language_Order_By>>;
  where?: Maybe<Language_Bool_Exp>;
};


export type Subscription_RootLanguage_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLanguage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Language_Stream_Cursor_Input>>;
  where?: Maybe<Language_Bool_Exp>;
};


export type Subscription_RootManagerArgs = {
  distinct_on?: Maybe<Array<Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Order_By>>;
  where?: Maybe<Manager_Bool_Exp>;
};


export type Subscription_RootManager_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Order_By>>;
  where?: Maybe<Manager_Bool_Exp>;
};


export type Subscription_RootManager_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootManager_ContractorArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


export type Subscription_RootManager_Contractor_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


export type Subscription_RootManager_Contractor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootManager_Contractor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Manager_Contractor_Stream_Cursor_Input>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


export type Subscription_RootManager_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Manager_Stream_Cursor_Input>>;
  where?: Maybe<Manager_Bool_Exp>;
};


export type Subscription_RootMessageArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Subscription_RootMessage_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Subscription_RootMessage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMessage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Message_Stream_Cursor_Input>>;
  where?: Maybe<Message_Bool_Exp>;
};


export type Subscription_RootNotificationArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_AggregateArgs = {
  distinct_on?: Maybe<Array<Notification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Notification_Order_By>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Notification_Stream_Cursor_Input>>;
  where?: Maybe<Notification_Bool_Exp>;
};


export type Subscription_RootOnboardingArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


export type Subscription_RootOnboarding_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


export type Subscription_RootOnboarding_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOnboarding_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Onboarding_Stream_Cursor_Input>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


export type Subscription_RootPayment_CardArgs = {
  distinct_on?: Maybe<Array<Payment_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Card_Order_By>>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};


export type Subscription_RootPayment_Card_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Card_Order_By>>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};


export type Subscription_RootPayment_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPayment_Card_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Payment_Card_Stream_Cursor_Input>>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};


export type Subscription_RootPostingArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


export type Subscription_RootPosting_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Order_By>>;
  where?: Maybe<Posting_Bool_Exp>;
};


export type Subscription_RootPosting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_IndustryArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


export type Subscription_RootPosting_Industry_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Industry_Order_By>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


export type Subscription_RootPosting_Industry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_Industry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Posting_Industry_Stream_Cursor_Input>>;
  where?: Maybe<Posting_Industry_Bool_Exp>;
};


export type Subscription_RootPosting_SkillArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


export type Subscription_RootPosting_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Skill_Order_By>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


export type Subscription_RootPosting_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Posting_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Posting_Skill_Bool_Exp>;
};


export type Subscription_RootPosting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Posting_Stream_Cursor_Input>>;
  where?: Maybe<Posting_Bool_Exp>;
};


export type Subscription_RootPosting_TagsArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


export type Subscription_RootPosting_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


export type Subscription_RootPosting_Tags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Posting_Tags_Stream_Cursor_Input>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_ActivityArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


export type Subscription_RootProject_Activity_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


export type Subscription_RootProject_Activity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_Activity_NoteArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Note_Order_By>>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Note_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Note_Order_By>>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_Activity_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Note_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Note_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Request_More_HoursArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Request_More_Hours_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Request_More_Hours_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_Activity_Request_More_Hours_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Request_More_Hours_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


export type Subscription_RootProject_Activity_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Activity_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Soft_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Soft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Soft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Activity_Soft_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Soft_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Activity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


export type Subscription_RootProject_Activity_TagArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Activity_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Tag_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


export type Subscription_RootProject_Activity_TimeArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Time_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Time_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_Activity_Time_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Time_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Tracked_TimeArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Tracked_Time_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


export type Subscription_RootProject_Activity_Tracked_Time_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_Activity_Tracked_Time_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Activity_Tracked_Time_Stream_Cursor_Input>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Order_By>>;
  where?: Maybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Skill_Order_By>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Project_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Soft_SkillArgs = {
  distinct_on?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Soft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Soft_Skill_Order_By>>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootProject_Soft_Skill_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProject_Soft_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Soft_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Project_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Stream_Cursor_Input>>;
  where?: Maybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_TagArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


export type Subscription_RootProject_Tag_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


export type Subscription_RootProject_Tag_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Tag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Project_Tag_Stream_Cursor_Input>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


export type Subscription_RootPublic_Project_DetailsArgs = {
  distinct_on?: Maybe<Array<Public_Project_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Public_Project_Details_Order_By>>;
  where?: Maybe<Public_Project_Details_Bool_Exp>;
};


export type Subscription_RootPublic_Project_Details_AggregateArgs = {
  distinct_on?: Maybe<Array<Public_Project_Details_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Public_Project_Details_Order_By>>;
  where?: Maybe<Public_Project_Details_Bool_Exp>;
};


export type Subscription_RootPublic_Project_Details_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Public_Project_Details_Stream_Cursor_Input>>;
  where?: Maybe<Public_Project_Details_Bool_Exp>;
};


export type Subscription_RootRecipient_MessageArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


export type Subscription_RootRecipient_Message_AggregateArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


export type Subscription_RootRecipient_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRecipient_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Recipient_Message_Stream_Cursor_Input>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


export type Subscription_RootResource_Information_CardArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


export type Subscription_RootResource_Information_Card_AggregateArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


export type Subscription_RootResource_Information_Card_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootResource_Information_Card_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Resource_Information_Card_Stream_Cursor_Input>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


export type Subscription_RootSearch_IndustryArgs = {
  args: Search_Industry_Args;
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Subscription_RootSearch_Industry_AggregateArgs = {
  args: Search_Industry_Args;
  distinct_on?: Maybe<Array<Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Industry_Order_By>>;
  where?: Maybe<Industry_Bool_Exp>;
};


export type Subscription_RootSearch_SkillArgs = {
  args: Search_Skill_Args;
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Subscription_RootSearch_Skill_AggregateArgs = {
  args: Search_Skill_Args;
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Subscription_RootSkillArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Subscription_RootSkill_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Subscription_RootSkill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSkill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skill_Stream_Cursor_Input>>;
  where?: Maybe<Skill_Bool_Exp>;
};


export type Subscription_RootSkills_Short_Name_FirstArgs = {
  distinct_on?: Maybe<Array<Skills_Short_Name_First_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skills_Short_Name_First_Order_By>>;
  where?: Maybe<Skills_Short_Name_First_Bool_Exp>;
};


export type Subscription_RootSkills_Short_Name_First_AggregateArgs = {
  distinct_on?: Maybe<Array<Skills_Short_Name_First_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skills_Short_Name_First_Order_By>>;
  where?: Maybe<Skills_Short_Name_First_Bool_Exp>;
};


export type Subscription_RootSkills_Short_Name_First_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Skills_Short_Name_First_Stream_Cursor_Input>>;
  where?: Maybe<Skills_Short_Name_First_Bool_Exp>;
};


export type Subscription_RootSmart_Match_BookmarkArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Bookmark_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Bookmark_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSmart_Match_Bookmark_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Smart_Match_Bookmark_Stream_Cursor_Input>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Config_TransportationArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Config_Transportation_Order_By>>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Config_Transportation_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Config_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Config_Transportation_Order_By>>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Config_Transportation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSmart_Match_Config_Transportation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Smart_Match_Config_Transportation_Stream_Cursor_Input>>;
  where?: Maybe<Smart_Match_Config_Transportation_Bool_Exp>;
};


export type Subscription_RootSmart_Match_ConfigsArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Configs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Configs_Order_By>>;
  where?: Maybe<Smart_Match_Configs_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Configs_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Configs_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Configs_Order_By>>;
  where?: Maybe<Smart_Match_Configs_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Configs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSmart_Match_Configs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Smart_Match_Configs_Stream_Cursor_Input>>;
  where?: Maybe<Smart_Match_Configs_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Criteria_OrderArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Criteria_Order_Order_By>>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Criteria_Order_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Criteria_Order_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Criteria_Order_Order_By>>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};


export type Subscription_RootSmart_Match_Criteria_Order_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSmart_Match_Criteria_Order_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Smart_Match_Criteria_Order_Stream_Cursor_Input>>;
  where?: Maybe<Smart_Match_Criteria_Order_Bool_Exp>;
};


export type Subscription_RootSoft_SkillArgs = {
  distinct_on?: Maybe<Array<Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Soft_Skill_Order_By>>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};


export type Subscription_RootSoft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Soft_Skill_Order_By>>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};


export type Subscription_RootSoft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSoft_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Soft_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};


export type Subscription_RootSourceArgs = {
  distinct_on?: Maybe<Array<Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Source_Order_By>>;
  where?: Maybe<Source_Bool_Exp>;
};


export type Subscription_RootSource_AggregateArgs = {
  distinct_on?: Maybe<Array<Source_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Source_Order_By>>;
  where?: Maybe<Source_Bool_Exp>;
};


export type Subscription_RootSource_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSource_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Source_Stream_Cursor_Input>>;
  where?: Maybe<Source_Bool_Exp>;
};


export type Subscription_RootSubscriptionArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


export type Subscription_RootSubscription_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Order_By>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


export type Subscription_RootSubscription_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_PlanArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Order_By>>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};


export type Subscription_RootSubscription_Plan_Access_PermissionsArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Access_Permissions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Access_Permissions_Order_By>>;
  where?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
};


export type Subscription_RootSubscription_Plan_Access_Permissions_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Access_Permissions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Access_Permissions_Order_By>>;
  where?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
};


export type Subscription_RootSubscription_Plan_Access_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_Plan_Access_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Subscription_Plan_Access_Permissions_Stream_Cursor_Input>>;
  where?: Maybe<Subscription_Plan_Access_Permissions_Bool_Exp>;
};


export type Subscription_RootSubscription_Plan_AggregateArgs = {
  distinct_on?: Maybe<Array<Subscription_Plan_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Subscription_Plan_Order_By>>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};


export type Subscription_RootSubscription_Plan_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubscription_Plan_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Subscription_Plan_Stream_Cursor_Input>>;
  where?: Maybe<Subscription_Plan_Bool_Exp>;
};


export type Subscription_RootSubscription_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Subscription_Stream_Cursor_Input>>;
  where?: Maybe<Subscription_Bool_Exp>;
};


export type Subscription_RootTagArgs = {
  distinct_on?: Maybe<Array<Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tag_Order_By>>;
  where?: Maybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_AggregateArgs = {
  distinct_on?: Maybe<Array<Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tag_Order_By>>;
  where?: Maybe<Tag_Bool_Exp>;
};


export type Subscription_RootTag_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Tag_Stream_Cursor_Input>>;
  where?: Maybe<Tag_Bool_Exp>;
};


export type Subscription_RootTeamArgs = {
  distinct_on?: Maybe<Array<Team_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Order_By>>;
  where?: Maybe<Team_Bool_Exp>;
};


export type Subscription_RootTeam_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Order_By>>;
  where?: Maybe<Team_Bool_Exp>;
};


export type Subscription_RootTeam_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeam_ContractorArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


export type Subscription_RootTeam_Contractor_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


export type Subscription_RootTeam_Contractor_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeam_Contractor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Team_Contractor_Stream_Cursor_Input>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


export type Subscription_RootTeam_ManagerArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


export type Subscription_RootTeam_Manager_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


export type Subscription_RootTeam_Manager_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeam_Manager_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Team_Manager_Stream_Cursor_Input>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


export type Subscription_RootTeam_PostingArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


export type Subscription_RootTeam_Posting_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


export type Subscription_RootTeam_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeam_Posting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Team_Posting_Stream_Cursor_Input>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


export type Subscription_RootTeam_ProjectArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


export type Subscription_RootTeam_Project_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


export type Subscription_RootTeam_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeam_Project_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Team_Project_Stream_Cursor_Input>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


export type Subscription_RootTeam_SkillArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


export type Subscription_RootTeam_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


export type Subscription_RootTeam_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTeam_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Team_Skill_Stream_Cursor_Input>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


export type Subscription_RootTeam_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Team_Stream_Cursor_Input>>;
  where?: Maybe<Team_Bool_Exp>;
};


export type Subscription_RootTimesheetArgs = {
  distinct_on?: Maybe<Array<Timesheet_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Timesheet_Order_By>>;
  where?: Maybe<Timesheet_Bool_Exp>;
};


export type Subscription_RootTimesheet_AggregateArgs = {
  distinct_on?: Maybe<Array<Timesheet_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Timesheet_Order_By>>;
  where?: Maybe<Timesheet_Bool_Exp>;
};


export type Subscription_RootTimesheet_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTimesheet_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Timesheet_Stream_Cursor_Input>>;
  where?: Maybe<Timesheet_Bool_Exp>;
};


export type Subscription_RootType_Of_VisitArgs = {
  distinct_on?: Maybe<Array<Type_Of_Visit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Of_Visit_Order_By>>;
  where?: Maybe<Type_Of_Visit_Bool_Exp>;
};


export type Subscription_RootType_Of_Visit_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Of_Visit_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Of_Visit_Order_By>>;
  where?: Maybe<Type_Of_Visit_Bool_Exp>;
};


export type Subscription_RootType_Of_Visit_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootType_Of_Visit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Type_Of_Visit_Stream_Cursor_Input>>;
  where?: Maybe<Type_Of_Visit_Bool_Exp>;
};


export type Subscription_RootUnread_MessagesArgs = {
  distinct_on?: Maybe<Array<Unread_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unread_Messages_Order_By>>;
  where?: Maybe<Unread_Messages_Bool_Exp>;
};


export type Subscription_RootUnread_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Unread_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Unread_Messages_Order_By>>;
  where?: Maybe<Unread_Messages_Bool_Exp>;
};


export type Subscription_RootUnread_Messages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<Unread_Messages_Stream_Cursor_Input>>;
  where?: Maybe<Unread_Messages_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Subscription_RootUser_Affinda_ProfileArgs = {
  distinct_on?: Maybe<Array<User_Affinda_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Affinda_Profile_Order_By>>;
  where?: Maybe<User_Affinda_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Affinda_Profile_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Affinda_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Affinda_Profile_Order_By>>;
  where?: Maybe<User_Affinda_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Affinda_Profile_By_PkArgs = {
  document_id: Scalars['String'];
};


export type Subscription_RootUser_Affinda_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Affinda_Profile_Stream_Cursor_Input>>;
  where?: Maybe<User_Affinda_Profile_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Order_By>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_CertificationArgs = {
  distinct_on?: Maybe<Array<User_Certification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Certification_Order_By>>;
  where?: Maybe<User_Certification_Bool_Exp>;
};


export type Subscription_RootUser_Certification_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Certification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Certification_Order_By>>;
  where?: Maybe<User_Certification_Bool_Exp>;
};


export type Subscription_RootUser_Certification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Certification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Certification_Stream_Cursor_Input>>;
  where?: Maybe<User_Certification_Bool_Exp>;
};


export type Subscription_RootUser_CompanyArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


export type Subscription_RootUser_Company_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


export type Subscription_RootUser_Company_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Company_Stream_Cursor_Input>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


export type Subscription_RootUser_ConversationArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


export type Subscription_RootUser_Conversation_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


export type Subscription_RootUser_Conversation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Conversation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Conversation_Stream_Cursor_Input>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


export type Subscription_RootUser_EducationArgs = {
  distinct_on?: Maybe<Array<User_Education_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Education_Order_By>>;
  where?: Maybe<User_Education_Bool_Exp>;
};


export type Subscription_RootUser_Education_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Education_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Education_Order_By>>;
  where?: Maybe<User_Education_Bool_Exp>;
};


export type Subscription_RootUser_Education_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Education_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Education_Stream_Cursor_Input>>;
  where?: Maybe<User_Education_Bool_Exp>;
};


export type Subscription_RootUser_ExperienceArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


export type Subscription_RootUser_Experience_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


export type Subscription_RootUser_Experience_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Experience_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Experience_Stream_Cursor_Input>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


export type Subscription_RootUser_FavoriteArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


export type Subscription_RootUser_Favorite_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


export type Subscription_RootUser_Favorite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Favorite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Favorite_Stream_Cursor_Input>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


export type Subscription_RootUser_IndustryArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


export type Subscription_RootUser_Industry_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


export type Subscription_RootUser_Industry_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Industry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Industry_Stream_Cursor_Input>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


export type Subscription_RootUser_Job_TitleArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


export type Subscription_RootUser_Job_Title_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


export type Subscription_RootUser_Job_Title_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Job_Title_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Job_Title_Stream_Cursor_Input>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


export type Subscription_RootUser_LanguageArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


export type Subscription_RootUser_Language_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


export type Subscription_RootUser_Language_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Language_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Language_Stream_Cursor_Input>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


export type Subscription_RootUser_Private_DataArgs = {
  distinct_on?: Maybe<Array<User_Private_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Private_Data_Order_By>>;
  where?: Maybe<User_Private_Data_Bool_Exp>;
};


export type Subscription_RootUser_Private_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Private_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Private_Data_Order_By>>;
  where?: Maybe<User_Private_Data_Bool_Exp>;
};


export type Subscription_RootUser_Private_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Private_Data_Stream_Cursor_Input>>;
  where?: Maybe<User_Private_Data_Bool_Exp>;
};


export type Subscription_RootUser_ProfileArgs = {
  distinct_on?: Maybe<Array<User_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_Order_By>>;
  where?: Maybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Profile_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_Order_By>>;
  where?: Maybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Profile_By_ManagementArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


export type Subscription_RootUser_Profile_By_Management_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


export type Subscription_RootUser_Profile_By_Management_By_PkArgs = {
  added_by_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootUser_Profile_By_Management_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Profile_By_Management_Stream_Cursor_Input>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


export type Subscription_RootUser_Profile_By_PkArgs = {
  user_id: Scalars['uuid'];
};


export type Subscription_RootUser_Profile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Profile_Stream_Cursor_Input>>;
  where?: Maybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_RatingArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


export type Subscription_RootUser_Rating_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


export type Subscription_RootUser_Rating_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Rating_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Rating_Stream_Cursor_Input>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


export type Subscription_RootUser_SkillArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


export type Subscription_RootUser_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


export type Subscription_RootUser_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Skill_Stream_Cursor_Input>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


export type Subscription_RootUser_Soft_SkillArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootUser_Soft_Skill_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootUser_Soft_Skill_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Soft_Skill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Soft_Skill_Stream_Cursor_Input>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Stream_Cursor_Input>>;
  where?: Maybe<User_Bool_Exp>;
};


export type Subscription_RootUser_TransportationArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


export type Subscription_RootUser_Transportation_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


export type Subscription_RootUser_Transportation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Transportation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Transportation_Stream_Cursor_Input>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


export type Subscription_RootUser_WatchlistArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};


export type Subscription_RootUser_Watchlist_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};


export type Subscription_RootUser_Watchlist_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Watchlist_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<Maybe<User_Watchlist_Stream_Cursor_Input>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};

/** select columns of table "subscription" */
export enum Subscription_Select_Column {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledByUser = 'canceled_by_user',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCardId = 'payment_card_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  StripeSubscriptionItemId = 'stripe_subscription_item_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscription_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription" */
export enum Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledByUser = 'canceled_by_user'
}

/** select "subscription_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription" */
export enum Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledByUser = 'canceled_by_user'
}

/** input type for updating data in table "subscription" */
export type Subscription_Set_Input = {
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  canceled_by_user?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  payment_card_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  stripe_subscription_item_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Subscription_Stddev_Fields = {
  __typename?: 'subscription_stddev_fields';
  current_period_end?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subscription" */
export type Subscription_Stddev_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscription_Stddev_Pop_Fields = {
  __typename?: 'subscription_stddev_pop_fields';
  current_period_end?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subscription" */
export type Subscription_Stddev_Pop_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscription_Stddev_Samp_Fields = {
  __typename?: 'subscription_stddev_samp_fields';
  current_period_end?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subscription" */
export type Subscription_Stddev_Samp_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** Streaming cursor of the table "subscription" */
export type Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Stream_Cursor_Value_Input = {
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  canceled_by_user?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_period_end?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  payment_card_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  stripe_subscription_item_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Subscription_Sum_Fields = {
  __typename?: 'subscription_sum_fields';
  current_period_end?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription" */
export type Subscription_Sum_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** update columns of table "subscription" */
export enum Subscription_Update_Column {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledByUser = 'canceled_by_user',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCardId = 'payment_card_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  StripeSubscriptionItemId = 'stripe_subscription_item_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Subscription_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscription_Var_Pop_Fields = {
  __typename?: 'subscription_var_pop_fields';
  current_period_end?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subscription" */
export type Subscription_Var_Pop_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscription_Var_Samp_Fields = {
  __typename?: 'subscription_var_samp_fields';
  current_period_end?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subscription" */
export type Subscription_Var_Samp_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscription_Variance_Fields = {
  __typename?: 'subscription_variance_fields';
  current_period_end?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subscription" */
export type Subscription_Variance_Order_By = {
  current_period_end?: Maybe<Order_By>;
};

/** columns and relationships of "tag" */
export type Tag = {
  __typename?: 'tag';
  /** An array relationship */
  contractors: Array<Contractor>;
  /** An aggregate relationship */
  contractors_aggregate: Contractor_Aggregate;
  /** An array relationship */
  custom_requests: Array<Custom_Request>;
  /** An aggregate relationship */
  custom_requests_aggregate: Custom_Request_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  posting_tags: Array<Posting_Tags>;
  /** An aggregate relationship */
  posting_tags_aggregate: Posting_Tags_Aggregate;
  /** An array relationship */
  project_activity_tags: Array<Project_Activity_Tag>;
  /** An aggregate relationship */
  project_activity_tags_aggregate: Project_Activity_Tag_Aggregate;
  /** An array relationship */
  project_tags: Array<Project_Tag>;
  /** An aggregate relationship */
  project_tags_aggregate: Project_Tag_Aggregate;
  /** An array relationship */
  resource_information_cards: Array<Resource_Information_Card>;
  /** An aggregate relationship */
  resource_information_cards_aggregate: Resource_Information_Card_Aggregate;
};


/** columns and relationships of "tag" */
export type TagContractorsArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagContractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagCustom_RequestsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagCustom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagPosting_TagsArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagPosting_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Posting_Tags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Posting_Tags_Order_By>>;
  where?: Maybe<Posting_Tags_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagProject_Activity_TagsArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagProject_Activity_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tag_Order_By>>;
  where?: Maybe<Project_Activity_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagProject_TagsArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagProject_Tags_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Tag_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Tag_Order_By>>;
  where?: Maybe<Project_Tag_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagResource_Information_CardsArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


/** columns and relationships of "tag" */
export type TagResource_Information_Cards_AggregateArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};

/** aggregated selection of "tag" */
export type Tag_Aggregate = {
  __typename?: 'tag_aggregate';
  aggregate?: Maybe<Tag_Aggregate_Fields>;
  nodes: Array<Tag>;
};

/** aggregate fields of "tag" */
export type Tag_Aggregate_Fields = {
  __typename?: 'tag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tag_Max_Fields>;
  min?: Maybe<Tag_Min_Fields>;
};


/** aggregate fields of "tag" */
export type Tag_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tag_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "tag". All fields are combined with a logical 'AND'. */
export type Tag_Bool_Exp = {
  _and?: Maybe<Array<Tag_Bool_Exp>>;
  _not?: Maybe<Tag_Bool_Exp>;
  _or?: Maybe<Array<Tag_Bool_Exp>>;
  contractors?: Maybe<Contractor_Bool_Exp>;
  contractors_aggregate?: Maybe<Contractor_Aggregate_Bool_Exp>;
  custom_requests?: Maybe<Custom_Request_Bool_Exp>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  posting_tags?: Maybe<Posting_Tags_Bool_Exp>;
  posting_tags_aggregate?: Maybe<Posting_Tags_Aggregate_Bool_Exp>;
  project_activity_tags?: Maybe<Project_Activity_Tag_Bool_Exp>;
  project_activity_tags_aggregate?: Maybe<Project_Activity_Tag_Aggregate_Bool_Exp>;
  project_tags?: Maybe<Project_Tag_Bool_Exp>;
  project_tags_aggregate?: Maybe<Project_Tag_Aggregate_Bool_Exp>;
  resource_information_cards?: Maybe<Resource_Information_Card_Bool_Exp>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tag" */
export enum Tag_Constraint {
  /** unique or primary key constraint on columns "name" */
  TagNameKey = 'tag_name_key',
  /** unique or primary key constraint on columns "id" */
  TagPkey = 'tag_pkey'
}

/** input type for inserting data into table "tag" */
export type Tag_Insert_Input = {
  contractors?: Maybe<Contractor_Arr_Rel_Insert_Input>;
  custom_requests?: Maybe<Custom_Request_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  posting_tags?: Maybe<Posting_Tags_Arr_Rel_Insert_Input>;
  project_activity_tags?: Maybe<Project_Activity_Tag_Arr_Rel_Insert_Input>;
  project_tags?: Maybe<Project_Tag_Arr_Rel_Insert_Input>;
  resource_information_cards?: Maybe<Resource_Information_Card_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tag_Max_Fields = {
  __typename?: 'tag_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tag_Min_Fields = {
  __typename?: 'tag_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tag" */
export type Tag_Mutation_Response = {
  __typename?: 'tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag>;
};

/** input type for inserting object relation for remote table "tag" */
export type Tag_Obj_Rel_Insert_Input = {
  data: Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Tag_On_Conflict>;
};

/** on_conflict condition type for table "tag" */
export type Tag_On_Conflict = {
  constraint: Tag_Constraint;
  update_columns?: Array<Tag_Update_Column>;
  where?: Maybe<Tag_Bool_Exp>;
};

/** Ordering options when selecting data from "tag". */
export type Tag_Order_By = {
  contractors_aggregate?: Maybe<Contractor_Aggregate_Order_By>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  posting_tags_aggregate?: Maybe<Posting_Tags_Aggregate_Order_By>;
  project_activity_tags_aggregate?: Maybe<Project_Activity_Tag_Aggregate_Order_By>;
  project_tags_aggregate?: Maybe<Project_Tag_Aggregate_Order_By>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Order_By>;
};

/** primary key columns input for table: tag */
export type Tag_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tag" */
export enum Tag_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "tag" */
export type Tag_Set_Input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "tag" */
export type Tag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "tag" */
export enum Tag_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Tag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Tag_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Bool_Exp;
};

/** columns and relationships of "team" */
export type Team = {
  __typename?: 'team';
  archived: Scalars['Boolean'];
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  /** An array relationship */
  contractors: Array<Team_Contractor>;
  /** An aggregate relationship */
  contractors_aggregate: Team_Contractor_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  id: Scalars['uuid'];
  location?: Maybe<Scalars['String']>;
  /** An array relationship */
  managers: Array<Team_Manager>;
  /** An aggregate relationship */
  managers_aggregate: Team_Manager_Aggregate;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  postings: Array<Team_Posting>;
  /** An aggregate relationship */
  postings_aggregate: Team_Posting_Aggregate;
  /** An array relationship */
  projects: Array<Team_Project>;
  /** An aggregate relationship */
  projects_aggregate: Team_Project_Aggregate;
  /** An array relationship */
  skills: Array<Team_Skill>;
  /** An aggregate relationship */
  skills_aggregate: Team_Skill_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "team" */
export type TeamContractorsArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamContractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Contractor_Order_By>>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamDocumentsArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamManagersArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamManagers_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Manager_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Manager_Order_By>>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamPostingsArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamPostings_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Posting_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Posting_Order_By>>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamProjectsArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamProjects_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Project_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Project_Order_By>>;
  where?: Maybe<Team_Project_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamSkillsArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamSkills_AggregateArgs = {
  distinct_on?: Maybe<Array<Team_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Team_Skill_Order_By>>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};

/** aggregated selection of "team" */
export type Team_Aggregate = {
  __typename?: 'team_aggregate';
  aggregate?: Maybe<Team_Aggregate_Fields>;
  nodes: Array<Team>;
};

export type Team_Aggregate_Bool_Exp = {
  bool_and?: Maybe<Team_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<Team_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<Team_Aggregate_Bool_Exp_Count>;
};

export type Team_Aggregate_Bool_Exp_Bool_And = {
  arguments: Team_Select_Column_Team_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Team_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Team_Select_Column_Team_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Team_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Team_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team" */
export type Team_Aggregate_Fields = {
  __typename?: 'team_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Team_Max_Fields>;
  min?: Maybe<Team_Min_Fields>;
};


/** aggregate fields of "team" */
export type Team_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Team_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team" */
export type Team_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Team_Max_Order_By>;
  min?: Maybe<Team_Min_Order_By>;
};

/** input type for inserting array relation for remote table "team" */
export type Team_Arr_Rel_Insert_Input = {
  data: Array<Team_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Team_On_Conflict>;
};

/** Boolean expression to filter rows from the table "team". All fields are combined with a logical 'AND'. */
export type Team_Bool_Exp = {
  _and?: Maybe<Array<Team_Bool_Exp>>;
  _not?: Maybe<Team_Bool_Exp>;
  _or?: Maybe<Array<Team_Bool_Exp>>;
  archived?: Maybe<Boolean_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  contractors?: Maybe<Team_Contractor_Bool_Exp>;
  contractors_aggregate?: Maybe<Team_Contractor_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  documents?: Maybe<Document_Bool_Exp>;
  documents_aggregate?: Maybe<Document_Aggregate_Bool_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  location?: Maybe<String_Comparison_Exp>;
  managers?: Maybe<Team_Manager_Bool_Exp>;
  managers_aggregate?: Maybe<Team_Manager_Aggregate_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  postings?: Maybe<Team_Posting_Bool_Exp>;
  postings_aggregate?: Maybe<Team_Posting_Aggregate_Bool_Exp>;
  projects?: Maybe<Team_Project_Bool_Exp>;
  projects_aggregate?: Maybe<Team_Project_Aggregate_Bool_Exp>;
  skills?: Maybe<Team_Skill_Bool_Exp>;
  skills_aggregate?: Maybe<Team_Skill_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "team" */
export enum Team_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamPkey = 'team_pkey'
}

/** columns and relationships of "team_contractor" */
export type Team_Contractor = {
  __typename?: 'team_contractor';
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  team: Team;
  team_id: Scalars['uuid'];
};

/** aggregated selection of "team_contractor" */
export type Team_Contractor_Aggregate = {
  __typename?: 'team_contractor_aggregate';
  aggregate?: Maybe<Team_Contractor_Aggregate_Fields>;
  nodes: Array<Team_Contractor>;
};

export type Team_Contractor_Aggregate_Bool_Exp = {
  count?: Maybe<Team_Contractor_Aggregate_Bool_Exp_Count>;
};

export type Team_Contractor_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Team_Contractor_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Contractor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_contractor" */
export type Team_Contractor_Aggregate_Fields = {
  __typename?: 'team_contractor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Team_Contractor_Max_Fields>;
  min?: Maybe<Team_Contractor_Min_Fields>;
};


/** aggregate fields of "team_contractor" */
export type Team_Contractor_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Team_Contractor_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_contractor" */
export type Team_Contractor_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Team_Contractor_Max_Order_By>;
  min?: Maybe<Team_Contractor_Min_Order_By>;
};

/** input type for inserting array relation for remote table "team_contractor" */
export type Team_Contractor_Arr_Rel_Insert_Input = {
  data: Array<Team_Contractor_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Team_Contractor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "team_contractor". All fields are combined with a logical 'AND'. */
export type Team_Contractor_Bool_Exp = {
  _and?: Maybe<Array<Team_Contractor_Bool_Exp>>;
  _not?: Maybe<Team_Contractor_Bool_Exp>;
  _or?: Maybe<Array<Team_Contractor_Bool_Exp>>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  team?: Maybe<Team_Bool_Exp>;
  team_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_contractor" */
export enum Team_Contractor_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamContractorPkey = 'team_contractor_pkey'
}

/** input type for inserting data into table "team_contractor" */
export type Team_Contractor_Insert_Input = {
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  team?: Maybe<Team_Obj_Rel_Insert_Input>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Team_Contractor_Max_Fields = {
  __typename?: 'team_contractor_max_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "team_contractor" */
export type Team_Contractor_Max_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Contractor_Min_Fields = {
  __typename?: 'team_contractor_min_fields';
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "team_contractor" */
export type Team_Contractor_Min_Order_By = {
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "team_contractor" */
export type Team_Contractor_Mutation_Response = {
  __typename?: 'team_contractor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Contractor>;
};

/** on_conflict condition type for table "team_contractor" */
export type Team_Contractor_On_Conflict = {
  constraint: Team_Contractor_Constraint;
  update_columns?: Array<Team_Contractor_Update_Column>;
  where?: Maybe<Team_Contractor_Bool_Exp>;
};

/** Ordering options when selecting data from "team_contractor". */
export type Team_Contractor_Order_By = {
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  team?: Maybe<Team_Order_By>;
  team_id?: Maybe<Order_By>;
};

/** primary key columns input for table: team_contractor */
export type Team_Contractor_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "team_contractor" */
export enum Team_Contractor_Select_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "team_contractor" */
export type Team_Contractor_Set_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "team_contractor" */
export type Team_Contractor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Contractor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Contractor_Stream_Cursor_Value_Input = {
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "team_contractor" */
export enum Team_Contractor_Update_Column {
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id'
}

export type Team_Contractor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Team_Contractor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Contractor_Bool_Exp;
};

/** input type for inserting data into table "team" */
export type Team_Insert_Input = {
  archived?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  contractors?: Maybe<Team_Contractor_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  documents?: Maybe<Document_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  managers?: Maybe<Team_Manager_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  postings?: Maybe<Team_Posting_Arr_Rel_Insert_Input>;
  projects?: Maybe<Team_Project_Arr_Rel_Insert_Input>;
  skills?: Maybe<Team_Skill_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "team_manager" */
export type Team_Manager = {
  __typename?: 'team_manager';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  manager: Manager;
  manager_id: Scalars['uuid'];
  /** An object relationship */
  team: Team;
  team_id: Scalars['uuid'];
};

/** aggregated selection of "team_manager" */
export type Team_Manager_Aggregate = {
  __typename?: 'team_manager_aggregate';
  aggregate?: Maybe<Team_Manager_Aggregate_Fields>;
  nodes: Array<Team_Manager>;
};

export type Team_Manager_Aggregate_Bool_Exp = {
  count?: Maybe<Team_Manager_Aggregate_Bool_Exp_Count>;
};

export type Team_Manager_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Team_Manager_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Manager_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_manager" */
export type Team_Manager_Aggregate_Fields = {
  __typename?: 'team_manager_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Team_Manager_Max_Fields>;
  min?: Maybe<Team_Manager_Min_Fields>;
};


/** aggregate fields of "team_manager" */
export type Team_Manager_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Team_Manager_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_manager" */
export type Team_Manager_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Team_Manager_Max_Order_By>;
  min?: Maybe<Team_Manager_Min_Order_By>;
};

/** input type for inserting array relation for remote table "team_manager" */
export type Team_Manager_Arr_Rel_Insert_Input = {
  data: Array<Team_Manager_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Team_Manager_On_Conflict>;
};

/** Boolean expression to filter rows from the table "team_manager". All fields are combined with a logical 'AND'. */
export type Team_Manager_Bool_Exp = {
  _and?: Maybe<Array<Team_Manager_Bool_Exp>>;
  _not?: Maybe<Team_Manager_Bool_Exp>;
  _or?: Maybe<Array<Team_Manager_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_id?: Maybe<Uuid_Comparison_Exp>;
  team?: Maybe<Team_Bool_Exp>;
  team_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_manager" */
export enum Team_Manager_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamManagerPkey = 'team_manager_pkey'
}

/** input type for inserting data into table "team_manager" */
export type Team_Manager_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_id?: Maybe<Scalars['uuid']>;
  team?: Maybe<Team_Obj_Rel_Insert_Input>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Team_Manager_Max_Fields = {
  __typename?: 'team_manager_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "team_manager" */
export type Team_Manager_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Manager_Min_Fields = {
  __typename?: 'team_manager_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "team_manager" */
export type Team_Manager_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "team_manager" */
export type Team_Manager_Mutation_Response = {
  __typename?: 'team_manager_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Manager>;
};

/** on_conflict condition type for table "team_manager" */
export type Team_Manager_On_Conflict = {
  constraint: Team_Manager_Constraint;
  update_columns?: Array<Team_Manager_Update_Column>;
  where?: Maybe<Team_Manager_Bool_Exp>;
};

/** Ordering options when selecting data from "team_manager". */
export type Team_Manager_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_id?: Maybe<Order_By>;
  team?: Maybe<Team_Order_By>;
  team_id?: Maybe<Order_By>;
};

/** primary key columns input for table: team_manager */
export type Team_Manager_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "team_manager" */
export enum Team_Manager_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "team_manager" */
export type Team_Manager_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "team_manager" */
export type Team_Manager_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Manager_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Manager_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  manager_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "team_manager" */
export enum Team_Manager_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManagerId = 'manager_id',
  /** column name */
  TeamId = 'team_id'
}

export type Team_Manager_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Team_Manager_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Manager_Bool_Exp;
};

/** aggregate max on columns */
export type Team_Max_Fields = {
  __typename?: 'team_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "team" */
export type Team_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Min_Fields = {
  __typename?: 'team_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "team" */
export type Team_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "team" */
export type Team_Mutation_Response = {
  __typename?: 'team_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team>;
};

/** input type for inserting object relation for remote table "team" */
export type Team_Obj_Rel_Insert_Input = {
  data: Team_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Team_On_Conflict>;
};

/** on_conflict condition type for table "team" */
export type Team_On_Conflict = {
  constraint: Team_Constraint;
  update_columns?: Array<Team_Update_Column>;
  where?: Maybe<Team_Bool_Exp>;
};

/** Ordering options when selecting data from "team". */
export type Team_Order_By = {
  archived?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  contractors_aggregate?: Maybe<Team_Contractor_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  documents_aggregate?: Maybe<Document_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  managers_aggregate?: Maybe<Team_Manager_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  postings_aggregate?: Maybe<Team_Posting_Aggregate_Order_By>;
  projects_aggregate?: Maybe<Team_Project_Aggregate_Order_By>;
  skills_aggregate?: Maybe<Team_Skill_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: team */
export type Team_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "team_posting" */
export type Team_Posting = {
  __typename?: 'team_posting';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  posting: Posting;
  posting_id: Scalars['uuid'];
  /** An object relationship */
  team: Team;
  team_id: Scalars['uuid'];
};

/** aggregated selection of "team_posting" */
export type Team_Posting_Aggregate = {
  __typename?: 'team_posting_aggregate';
  aggregate?: Maybe<Team_Posting_Aggregate_Fields>;
  nodes: Array<Team_Posting>;
};

export type Team_Posting_Aggregate_Bool_Exp = {
  count?: Maybe<Team_Posting_Aggregate_Bool_Exp_Count>;
};

export type Team_Posting_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Team_Posting_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Posting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_posting" */
export type Team_Posting_Aggregate_Fields = {
  __typename?: 'team_posting_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Team_Posting_Max_Fields>;
  min?: Maybe<Team_Posting_Min_Fields>;
};


/** aggregate fields of "team_posting" */
export type Team_Posting_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Team_Posting_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_posting" */
export type Team_Posting_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Team_Posting_Max_Order_By>;
  min?: Maybe<Team_Posting_Min_Order_By>;
};

/** input type for inserting array relation for remote table "team_posting" */
export type Team_Posting_Arr_Rel_Insert_Input = {
  data: Array<Team_Posting_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Team_Posting_On_Conflict>;
};

/** Boolean expression to filter rows from the table "team_posting". All fields are combined with a logical 'AND'. */
export type Team_Posting_Bool_Exp = {
  _and?: Maybe<Array<Team_Posting_Bool_Exp>>;
  _not?: Maybe<Team_Posting_Bool_Exp>;
  _or?: Maybe<Array<Team_Posting_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  posting?: Maybe<Posting_Bool_Exp>;
  posting_id?: Maybe<Uuid_Comparison_Exp>;
  team?: Maybe<Team_Bool_Exp>;
  team_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_posting" */
export enum Team_Posting_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamPostingPkey = 'team_posting_pkey'
}

/** input type for inserting data into table "team_posting" */
export type Team_Posting_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting?: Maybe<Posting_Obj_Rel_Insert_Input>;
  posting_id?: Maybe<Scalars['uuid']>;
  team?: Maybe<Team_Obj_Rel_Insert_Input>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Team_Posting_Max_Fields = {
  __typename?: 'team_posting_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "team_posting" */
export type Team_Posting_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Posting_Min_Fields = {
  __typename?: 'team_posting_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "team_posting" */
export type Team_Posting_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "team_posting" */
export type Team_Posting_Mutation_Response = {
  __typename?: 'team_posting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Posting>;
};

/** on_conflict condition type for table "team_posting" */
export type Team_Posting_On_Conflict = {
  constraint: Team_Posting_Constraint;
  update_columns?: Array<Team_Posting_Update_Column>;
  where?: Maybe<Team_Posting_Bool_Exp>;
};

/** Ordering options when selecting data from "team_posting". */
export type Team_Posting_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  posting?: Maybe<Posting_Order_By>;
  posting_id?: Maybe<Order_By>;
  team?: Maybe<Team_Order_By>;
  team_id?: Maybe<Order_By>;
};

/** primary key columns input for table: team_posting */
export type Team_Posting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "team_posting" */
export enum Team_Posting_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "team_posting" */
export type Team_Posting_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "team_posting" */
export type Team_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Posting_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  posting_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "team_posting" */
export enum Team_Posting_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  TeamId = 'team_id'
}

export type Team_Posting_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Team_Posting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Posting_Bool_Exp;
};

/** columns and relationships of "team_project" */
export type Team_Project = {
  __typename?: 'team_project';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['uuid'];
  /** An object relationship */
  team: Team;
  team_id: Scalars['uuid'];
};

/** aggregated selection of "team_project" */
export type Team_Project_Aggregate = {
  __typename?: 'team_project_aggregate';
  aggregate?: Maybe<Team_Project_Aggregate_Fields>;
  nodes: Array<Team_Project>;
};

export type Team_Project_Aggregate_Bool_Exp = {
  count?: Maybe<Team_Project_Aggregate_Bool_Exp_Count>;
};

export type Team_Project_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Team_Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_project" */
export type Team_Project_Aggregate_Fields = {
  __typename?: 'team_project_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Team_Project_Max_Fields>;
  min?: Maybe<Team_Project_Min_Fields>;
};


/** aggregate fields of "team_project" */
export type Team_Project_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Team_Project_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_project" */
export type Team_Project_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Team_Project_Max_Order_By>;
  min?: Maybe<Team_Project_Min_Order_By>;
};

/** input type for inserting array relation for remote table "team_project" */
export type Team_Project_Arr_Rel_Insert_Input = {
  data: Array<Team_Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Team_Project_On_Conflict>;
};

/** Boolean expression to filter rows from the table "team_project". All fields are combined with a logical 'AND'. */
export type Team_Project_Bool_Exp = {
  _and?: Maybe<Array<Team_Project_Bool_Exp>>;
  _not?: Maybe<Team_Project_Bool_Exp>;
  _or?: Maybe<Array<Team_Project_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  project?: Maybe<Project_Bool_Exp>;
  project_id?: Maybe<Uuid_Comparison_Exp>;
  team?: Maybe<Team_Bool_Exp>;
  team_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_project" */
export enum Team_Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamProjectPkey = 'team_project_pkey'
}

/** input type for inserting data into table "team_project" */
export type Team_Project_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project?: Maybe<Project_Obj_Rel_Insert_Input>;
  project_id?: Maybe<Scalars['uuid']>;
  team?: Maybe<Team_Obj_Rel_Insert_Input>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Team_Project_Max_Fields = {
  __typename?: 'team_project_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "team_project" */
export type Team_Project_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Project_Min_Fields = {
  __typename?: 'team_project_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "team_project" */
export type Team_Project_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "team_project" */
export type Team_Project_Mutation_Response = {
  __typename?: 'team_project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Project>;
};

/** on_conflict condition type for table "team_project" */
export type Team_Project_On_Conflict = {
  constraint: Team_Project_Constraint;
  update_columns?: Array<Team_Project_Update_Column>;
  where?: Maybe<Team_Project_Bool_Exp>;
};

/** Ordering options when selecting data from "team_project". */
export type Team_Project_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  project?: Maybe<Project_Order_By>;
  project_id?: Maybe<Order_By>;
  team?: Maybe<Team_Order_By>;
  team_id?: Maybe<Order_By>;
};

/** primary key columns input for table: team_project */
export type Team_Project_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "team_project" */
export enum Team_Project_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "team_project" */
export type Team_Project_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "team_project" */
export type Team_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Project_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  team_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "team_project" */
export enum Team_Project_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TeamId = 'team_id'
}

export type Team_Project_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Team_Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Project_Bool_Exp;
};

/** select columns of table "team" */
export enum Team_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "team_aggregate_bool_exp_bool_and_arguments_columns" columns of table "team" */
export enum Team_Select_Column_Team_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** select "team_aggregate_bool_exp_bool_or_arguments_columns" columns of table "team" */
export enum Team_Select_Column_Team_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** input type for updating data in table "team" */
export type Team_Set_Input = {
  archived?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "team_skill" */
export type Team_Skill = {
  __typename?: 'team_skill';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  skill: Skill;
  skill_id: Scalars['Int'];
  /** An object relationship */
  team: Team;
  team_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "team_skill" */
export type Team_Skill_Aggregate = {
  __typename?: 'team_skill_aggregate';
  aggregate?: Maybe<Team_Skill_Aggregate_Fields>;
  nodes: Array<Team_Skill>;
};

export type Team_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<Team_Skill_Aggregate_Bool_Exp_Count>;
};

export type Team_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Team_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Team_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_skill" */
export type Team_Skill_Aggregate_Fields = {
  __typename?: 'team_skill_aggregate_fields';
  avg?: Maybe<Team_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Team_Skill_Max_Fields>;
  min?: Maybe<Team_Skill_Min_Fields>;
  stddev?: Maybe<Team_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<Team_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Team_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<Team_Skill_Sum_Fields>;
  var_pop?: Maybe<Team_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<Team_Skill_Var_Samp_Fields>;
  variance?: Maybe<Team_Skill_Variance_Fields>;
};


/** aggregate fields of "team_skill" */
export type Team_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Team_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_skill" */
export type Team_Skill_Aggregate_Order_By = {
  avg?: Maybe<Team_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Team_Skill_Max_Order_By>;
  min?: Maybe<Team_Skill_Min_Order_By>;
  stddev?: Maybe<Team_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<Team_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Team_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<Team_Skill_Sum_Order_By>;
  var_pop?: Maybe<Team_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<Team_Skill_Var_Samp_Order_By>;
  variance?: Maybe<Team_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "team_skill" */
export type Team_Skill_Arr_Rel_Insert_Input = {
  data: Array<Team_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<Team_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type Team_Skill_Avg_Fields = {
  __typename?: 'team_skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "team_skill" */
export type Team_Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "team_skill". All fields are combined with a logical 'AND'. */
export type Team_Skill_Bool_Exp = {
  _and?: Maybe<Array<Team_Skill_Bool_Exp>>;
  _not?: Maybe<Team_Skill_Bool_Exp>;
  _or?: Maybe<Array<Team_Skill_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  skill?: Maybe<Skill_Bool_Exp>;
  skill_id?: Maybe<Int_Comparison_Exp>;
  team?: Maybe<Team_Bool_Exp>;
  team_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_skill" */
export enum Team_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamSkillPkey = 'team_skill_pkey'
}

/** input type for incrementing numeric columns in table "team_skill" */
export type Team_Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "team_skill" */
export type Team_Skill_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill?: Maybe<Skill_Obj_Rel_Insert_Input>;
  skill_id?: Maybe<Scalars['Int']>;
  team?: Maybe<Team_Obj_Rel_Insert_Input>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Team_Skill_Max_Fields = {
  __typename?: 'team_skill_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "team_skill" */
export type Team_Skill_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Skill_Min_Fields = {
  __typename?: 'team_skill_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "team_skill" */
export type Team_Skill_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  team_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "team_skill" */
export type Team_Skill_Mutation_Response = {
  __typename?: 'team_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Skill>;
};

/** on_conflict condition type for table "team_skill" */
export type Team_Skill_On_Conflict = {
  constraint: Team_Skill_Constraint;
  update_columns?: Array<Team_Skill_Update_Column>;
  where?: Maybe<Team_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "team_skill". */
export type Team_Skill_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill?: Maybe<Skill_Order_By>;
  skill_id?: Maybe<Order_By>;
  team?: Maybe<Team_Order_By>;
  team_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: team_skill */
export type Team_Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "team_skill" */
export enum Team_Skill_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "team_skill" */
export type Team_Skill_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Team_Skill_Stddev_Fields = {
  __typename?: 'team_skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "team_skill" */
export type Team_Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Team_Skill_Stddev_Pop_Fields = {
  __typename?: 'team_skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "team_skill" */
export type Team_Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Team_Skill_Stddev_Samp_Fields = {
  __typename?: 'team_skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "team_skill" */
export type Team_Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "team_skill" */
export type Team_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Skill_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Team_Skill_Sum_Fields = {
  __typename?: 'team_skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "team_skill" */
export type Team_Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** update columns of table "team_skill" */
export enum Team_Skill_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Team_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Team_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Team_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Team_Skill_Var_Pop_Fields = {
  __typename?: 'team_skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "team_skill" */
export type Team_Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Team_Skill_Var_Samp_Fields = {
  __typename?: 'team_skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "team_skill" */
export type Team_Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Team_Skill_Variance_Fields = {
  __typename?: 'team_skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "team_skill" */
export type Team_Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "team" */
export type Team_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Stream_Cursor_Value_Input = {
  archived?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "team" */
export enum Team_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Team_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Team_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Bool_Exp;
};


/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: Maybe<Scalars['time']>;
  _gt?: Maybe<Scalars['time']>;
  _gte?: Maybe<Scalars['time']>;
  _in?: Maybe<Array<Scalars['time']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['time']>;
  _lte?: Maybe<Scalars['time']>;
  _neq?: Maybe<Scalars['time']>;
  _nin?: Maybe<Array<Scalars['time']>>;
};

/** columns and relationships of "timesheet" */
export type Timesheet = {
  __typename?: 'timesheet';
  active?: Maybe<Scalars['Boolean']>;
  approved_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  contractor: Contractor;
  contractor_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date: Scalars['date'];
  id: Scalars['uuid'];
  is_new?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  project_activity_times: Array<Project_Activity_Time>;
  /** An aggregate relationship */
  project_activity_times_aggregate: Project_Activity_Time_Aggregate;
  /** An array relationship */
  project_activity_tracked_times: Array<Project_Activity_Tracked_Time>;
  /** An aggregate relationship */
  project_activity_tracked_times_aggregate: Project_Activity_Tracked_Time_Aggregate;
  reject_reason?: Maybe<Scalars['String']>;
  start_date: Scalars['date'];
  status: Scalars['String'];
  tracked_time?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "timesheet" */
export type TimesheetProject_Activity_TimesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


/** columns and relationships of "timesheet" */
export type TimesheetProject_Activity_Times_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Time_Order_By>>;
  where?: Maybe<Project_Activity_Time_Bool_Exp>;
};


/** columns and relationships of "timesheet" */
export type TimesheetProject_Activity_Tracked_TimesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};


/** columns and relationships of "timesheet" */
export type TimesheetProject_Activity_Tracked_Times_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Tracked_Time_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Tracked_Time_Order_By>>;
  where?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
};

/** aggregated selection of "timesheet" */
export type Timesheet_Aggregate = {
  __typename?: 'timesheet_aggregate';
  aggregate?: Maybe<Timesheet_Aggregate_Fields>;
  nodes: Array<Timesheet>;
};

/** aggregate fields of "timesheet" */
export type Timesheet_Aggregate_Fields = {
  __typename?: 'timesheet_aggregate_fields';
  avg?: Maybe<Timesheet_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Timesheet_Max_Fields>;
  min?: Maybe<Timesheet_Min_Fields>;
  stddev?: Maybe<Timesheet_Stddev_Fields>;
  stddev_pop?: Maybe<Timesheet_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Timesheet_Stddev_Samp_Fields>;
  sum?: Maybe<Timesheet_Sum_Fields>;
  var_pop?: Maybe<Timesheet_Var_Pop_Fields>;
  var_samp?: Maybe<Timesheet_Var_Samp_Fields>;
  variance?: Maybe<Timesheet_Variance_Fields>;
};


/** aggregate fields of "timesheet" */
export type Timesheet_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Timesheet_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Timesheet_Avg_Fields = {
  __typename?: 'timesheet_avg_fields';
  tracked_time?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "timesheet". All fields are combined with a logical 'AND'. */
export type Timesheet_Bool_Exp = {
  _and?: Maybe<Array<Timesheet_Bool_Exp>>;
  _not?: Maybe<Timesheet_Bool_Exp>;
  _or?: Maybe<Array<Timesheet_Bool_Exp>>;
  active?: Maybe<Boolean_Comparison_Exp>;
  approved_by?: Maybe<Uuid_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  contractor?: Maybe<Contractor_Bool_Exp>;
  contractor_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  is_new?: Maybe<Boolean_Comparison_Exp>;
  project_activity_times?: Maybe<Project_Activity_Time_Bool_Exp>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Bool_Exp>;
  project_activity_tracked_times?: Maybe<Project_Activity_Tracked_Time_Bool_Exp>;
  project_activity_tracked_times_aggregate?: Maybe<Project_Activity_Tracked_Time_Aggregate_Bool_Exp>;
  reject_reason?: Maybe<String_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  tracked_time?: Maybe<Float8_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "timesheet" */
export enum Timesheet_Constraint {
  /** unique or primary key constraint on columns "id" */
  TimesheetPkey = 'timesheet_pkey'
}

/** input type for incrementing numeric columns in table "timesheet" */
export type Timesheet_Inc_Input = {
  tracked_time?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "timesheet" */
export type Timesheet_Insert_Input = {
  active?: Maybe<Scalars['Boolean']>;
  approved_by?: Maybe<Scalars['uuid']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  contractor?: Maybe<Contractor_Obj_Rel_Insert_Input>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  is_new?: Maybe<Scalars['Boolean']>;
  project_activity_times?: Maybe<Project_Activity_Time_Arr_Rel_Insert_Input>;
  project_activity_tracked_times?: Maybe<Project_Activity_Tracked_Time_Arr_Rel_Insert_Input>;
  reject_reason?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  tracked_time?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Timesheet_Max_Fields = {
  __typename?: 'timesheet_max_fields';
  approved_by?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  reject_reason?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  tracked_time?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Timesheet_Min_Fields = {
  __typename?: 'timesheet_min_fields';
  approved_by?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  reject_reason?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  tracked_time?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "timesheet" */
export type Timesheet_Mutation_Response = {
  __typename?: 'timesheet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Timesheet>;
};

/** input type for inserting object relation for remote table "timesheet" */
export type Timesheet_Obj_Rel_Insert_Input = {
  data: Timesheet_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<Timesheet_On_Conflict>;
};

/** on_conflict condition type for table "timesheet" */
export type Timesheet_On_Conflict = {
  constraint: Timesheet_Constraint;
  update_columns?: Array<Timesheet_Update_Column>;
  where?: Maybe<Timesheet_Bool_Exp>;
};

/** Ordering options when selecting data from "timesheet". */
export type Timesheet_Order_By = {
  active?: Maybe<Order_By>;
  approved_by?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  contractor?: Maybe<Contractor_Order_By>;
  contractor_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_new?: Maybe<Order_By>;
  project_activity_times_aggregate?: Maybe<Project_Activity_Time_Aggregate_Order_By>;
  project_activity_tracked_times_aggregate?: Maybe<Project_Activity_Tracked_Time_Aggregate_Order_By>;
  reject_reason?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  tracked_time?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: timesheet */
export type Timesheet_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "timesheet" */
export enum Timesheet_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsNew = 'is_new',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  TrackedTime = 'tracked_time',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "timesheet" */
export type Timesheet_Set_Input = {
  active?: Maybe<Scalars['Boolean']>;
  approved_by?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  is_new?: Maybe<Scalars['Boolean']>;
  reject_reason?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  tracked_time?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Timesheet_Stddev_Fields = {
  __typename?: 'timesheet_stddev_fields';
  tracked_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Timesheet_Stddev_Pop_Fields = {
  __typename?: 'timesheet_stddev_pop_fields';
  tracked_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Timesheet_Stddev_Samp_Fields = {
  __typename?: 'timesheet_stddev_samp_fields';
  tracked_time?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "timesheet" */
export type Timesheet_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Timesheet_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Timesheet_Stream_Cursor_Value_Input = {
  active?: Maybe<Scalars['Boolean']>;
  approved_by?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  contractor_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  is_new?: Maybe<Scalars['Boolean']>;
  reject_reason?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  status?: Maybe<Scalars['String']>;
  tracked_time?: Maybe<Scalars['float8']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Timesheet_Sum_Fields = {
  __typename?: 'timesheet_sum_fields';
  tracked_time?: Maybe<Scalars['float8']>;
};

/** update columns of table "timesheet" */
export enum Timesheet_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ApprovedBy = 'approved_by',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  ContractorId = 'contractor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsNew = 'is_new',
  /** column name */
  RejectReason = 'reject_reason',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  TrackedTime = 'tracked_time',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Timesheet_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<Timesheet_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Timesheet_Set_Input>;
  /** filter the rows which have to be updated */
  where: Timesheet_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Timesheet_Var_Pop_Fields = {
  __typename?: 'timesheet_var_pop_fields';
  tracked_time?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Timesheet_Var_Samp_Fields = {
  __typename?: 'timesheet_var_samp_fields';
  tracked_time?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Timesheet_Variance_Fields = {
  __typename?: 'timesheet_variance_fields';
  tracked_time?: Maybe<Scalars['Float']>;
};


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};


/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timetz']>;
  _gt?: Maybe<Scalars['timetz']>;
  _gte?: Maybe<Scalars['timetz']>;
  _in?: Maybe<Array<Scalars['timetz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timetz']>;
  _lte?: Maybe<Scalars['timetz']>;
  _neq?: Maybe<Scalars['timetz']>;
  _nin?: Maybe<Array<Scalars['timetz']>>;
};

/** columns and relationships of "type_of_visit" */
export type Type_Of_Visit = {
  __typename?: 'type_of_visit';
  value: Scalars['String'];
};

/** aggregated selection of "type_of_visit" */
export type Type_Of_Visit_Aggregate = {
  __typename?: 'type_of_visit_aggregate';
  aggregate?: Maybe<Type_Of_Visit_Aggregate_Fields>;
  nodes: Array<Type_Of_Visit>;
};

/** aggregate fields of "type_of_visit" */
export type Type_Of_Visit_Aggregate_Fields = {
  __typename?: 'type_of_visit_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Type_Of_Visit_Max_Fields>;
  min?: Maybe<Type_Of_Visit_Min_Fields>;
};


/** aggregate fields of "type_of_visit" */
export type Type_Of_Visit_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Type_Of_Visit_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "type_of_visit". All fields are combined with a logical 'AND'. */
export type Type_Of_Visit_Bool_Exp = {
  _and?: Maybe<Array<Type_Of_Visit_Bool_Exp>>;
  _not?: Maybe<Type_Of_Visit_Bool_Exp>;
  _or?: Maybe<Array<Type_Of_Visit_Bool_Exp>>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "type_of_visit" */
export enum Type_Of_Visit_Constraint {
  /** unique or primary key constraint on columns "value" */
  TypeOfVisitPkey = 'type_of_visit_pkey'
}

export enum Type_Of_Visit_Enum {
  Companionship = 'COMPANIONSHIP',
  Diagnostic = 'DIAGNOSTIC',
  Housekeeping = 'HOUSEKEEPING',
  MealPreparation = 'MEAL_PREPARATION',
  Monitoring = 'MONITORING',
  NursingService = 'NURSING_SERVICE',
  PersonalCare = 'PERSONAL_CARE',
  SpecializedCare = 'SPECIALIZED_CARE',
  TherapeuticSupport = 'THERAPEUTIC_SUPPORT',
  TransportationAssistance = 'TRANSPORTATION_ASSISTANCE'
}

/** Boolean expression to compare columns of type "type_of_visit_enum". All fields are combined with logical 'AND'. */
export type Type_Of_Visit_Enum_Comparison_Exp = {
  _eq?: Maybe<Type_Of_Visit_Enum>;
  _in?: Maybe<Array<Type_Of_Visit_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Type_Of_Visit_Enum>;
  _nin?: Maybe<Array<Type_Of_Visit_Enum>>;
};

/** input type for inserting data into table "type_of_visit" */
export type Type_Of_Visit_Insert_Input = {
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Type_Of_Visit_Max_Fields = {
  __typename?: 'type_of_visit_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Type_Of_Visit_Min_Fields = {
  __typename?: 'type_of_visit_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "type_of_visit" */
export type Type_Of_Visit_Mutation_Response = {
  __typename?: 'type_of_visit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Type_Of_Visit>;
};

/** on_conflict condition type for table "type_of_visit" */
export type Type_Of_Visit_On_Conflict = {
  constraint: Type_Of_Visit_Constraint;
  update_columns?: Array<Type_Of_Visit_Update_Column>;
  where?: Maybe<Type_Of_Visit_Bool_Exp>;
};

/** Ordering options when selecting data from "type_of_visit". */
export type Type_Of_Visit_Order_By = {
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: type_of_visit */
export type Type_Of_Visit_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "type_of_visit" */
export enum Type_Of_Visit_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "type_of_visit" */
export type Type_Of_Visit_Set_Input = {
  value?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "type_of_visit" */
export type Type_Of_Visit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Type_Of_Visit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Type_Of_Visit_Stream_Cursor_Value_Input = {
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "type_of_visit" */
export enum Type_Of_Visit_Update_Column {
  /** column name */
  Value = 'value'
}

export type Type_Of_Visit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<Type_Of_Visit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Type_Of_Visit_Bool_Exp;
};

/** columns and relationships of "unread_messages" */
export type Unread_Messages = {
  __typename?: 'unread_messages';
  /** An object relationship */
  conversation?: Maybe<Conversation>;
  conversation_id?: Maybe<Scalars['uuid']>;
  not_notified_by_email?: Maybe<Scalars['bigint']>;
  not_notified_in_app?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  recipient?: Maybe<User>;
  recipient_id?: Maybe<Scalars['uuid']>;
  unread_count?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "unread_messages" */
export type Unread_Messages_Aggregate = {
  __typename?: 'unread_messages_aggregate';
  aggregate?: Maybe<Unread_Messages_Aggregate_Fields>;
  nodes: Array<Unread_Messages>;
};

export type Unread_Messages_Aggregate_Bool_Exp = {
  count?: Maybe<Unread_Messages_Aggregate_Bool_Exp_Count>;
};

export type Unread_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<Unread_Messages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<Unread_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unread_messages" */
export type Unread_Messages_Aggregate_Fields = {
  __typename?: 'unread_messages_aggregate_fields';
  avg?: Maybe<Unread_Messages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unread_Messages_Max_Fields>;
  min?: Maybe<Unread_Messages_Min_Fields>;
  stddev?: Maybe<Unread_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Unread_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unread_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Unread_Messages_Sum_Fields>;
  var_pop?: Maybe<Unread_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Unread_Messages_Var_Samp_Fields>;
  variance?: Maybe<Unread_Messages_Variance_Fields>;
};


/** aggregate fields of "unread_messages" */
export type Unread_Messages_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Unread_Messages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unread_messages" */
export type Unread_Messages_Aggregate_Order_By = {
  avg?: Maybe<Unread_Messages_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Unread_Messages_Max_Order_By>;
  min?: Maybe<Unread_Messages_Min_Order_By>;
  stddev?: Maybe<Unread_Messages_Stddev_Order_By>;
  stddev_pop?: Maybe<Unread_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Unread_Messages_Stddev_Samp_Order_By>;
  sum?: Maybe<Unread_Messages_Sum_Order_By>;
  var_pop?: Maybe<Unread_Messages_Var_Pop_Order_By>;
  var_samp?: Maybe<Unread_Messages_Var_Samp_Order_By>;
  variance?: Maybe<Unread_Messages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unread_messages" */
export type Unread_Messages_Arr_Rel_Insert_Input = {
  data: Array<Unread_Messages_Insert_Input>;
};

/** aggregate avg on columns */
export type Unread_Messages_Avg_Fields = {
  __typename?: 'unread_messages_avg_fields';
  not_notified_by_email?: Maybe<Scalars['Float']>;
  not_notified_in_app?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "unread_messages" */
export type Unread_Messages_Avg_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unread_messages". All fields are combined with a logical 'AND'. */
export type Unread_Messages_Bool_Exp = {
  _and?: Maybe<Array<Unread_Messages_Bool_Exp>>;
  _not?: Maybe<Unread_Messages_Bool_Exp>;
  _or?: Maybe<Array<Unread_Messages_Bool_Exp>>;
  conversation?: Maybe<Conversation_Bool_Exp>;
  conversation_id?: Maybe<Uuid_Comparison_Exp>;
  not_notified_by_email?: Maybe<Bigint_Comparison_Exp>;
  not_notified_in_app?: Maybe<Bigint_Comparison_Exp>;
  recipient?: Maybe<User_Bool_Exp>;
  recipient_id?: Maybe<Uuid_Comparison_Exp>;
  unread_count?: Maybe<Bigint_Comparison_Exp>;
};

/** input type for inserting data into table "unread_messages" */
export type Unread_Messages_Insert_Input = {
  conversation?: Maybe<Conversation_Obj_Rel_Insert_Input>;
  conversation_id?: Maybe<Scalars['uuid']>;
  not_notified_by_email?: Maybe<Scalars['bigint']>;
  not_notified_in_app?: Maybe<Scalars['bigint']>;
  recipient?: Maybe<User_Obj_Rel_Insert_Input>;
  recipient_id?: Maybe<Scalars['uuid']>;
  unread_count?: Maybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Unread_Messages_Max_Fields = {
  __typename?: 'unread_messages_max_fields';
  conversation_id?: Maybe<Scalars['uuid']>;
  not_notified_by_email?: Maybe<Scalars['bigint']>;
  not_notified_in_app?: Maybe<Scalars['bigint']>;
  recipient_id?: Maybe<Scalars['uuid']>;
  unread_count?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "unread_messages" */
export type Unread_Messages_Max_Order_By = {
  conversation_id?: Maybe<Order_By>;
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Unread_Messages_Min_Fields = {
  __typename?: 'unread_messages_min_fields';
  conversation_id?: Maybe<Scalars['uuid']>;
  not_notified_by_email?: Maybe<Scalars['bigint']>;
  not_notified_in_app?: Maybe<Scalars['bigint']>;
  recipient_id?: Maybe<Scalars['uuid']>;
  unread_count?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "unread_messages" */
export type Unread_Messages_Min_Order_By = {
  conversation_id?: Maybe<Order_By>;
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** Ordering options when selecting data from "unread_messages". */
export type Unread_Messages_Order_By = {
  conversation?: Maybe<Conversation_Order_By>;
  conversation_id?: Maybe<Order_By>;
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  recipient?: Maybe<User_Order_By>;
  recipient_id?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** select columns of table "unread_messages" */
export enum Unread_Messages_Select_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  NotNotifiedByEmail = 'not_notified_by_email',
  /** column name */
  NotNotifiedInApp = 'not_notified_in_app',
  /** column name */
  RecipientId = 'recipient_id',
  /** column name */
  UnreadCount = 'unread_count'
}

/** aggregate stddev on columns */
export type Unread_Messages_Stddev_Fields = {
  __typename?: 'unread_messages_stddev_fields';
  not_notified_by_email?: Maybe<Scalars['Float']>;
  not_notified_in_app?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "unread_messages" */
export type Unread_Messages_Stddev_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unread_Messages_Stddev_Pop_Fields = {
  __typename?: 'unread_messages_stddev_pop_fields';
  not_notified_by_email?: Maybe<Scalars['Float']>;
  not_notified_in_app?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "unread_messages" */
export type Unread_Messages_Stddev_Pop_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unread_Messages_Stddev_Samp_Fields = {
  __typename?: 'unread_messages_stddev_samp_fields';
  not_notified_by_email?: Maybe<Scalars['Float']>;
  not_notified_in_app?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "unread_messages" */
export type Unread_Messages_Stddev_Samp_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** Streaming cursor of the table "unread_messages" */
export type Unread_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unread_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unread_Messages_Stream_Cursor_Value_Input = {
  conversation_id?: Maybe<Scalars['uuid']>;
  not_notified_by_email?: Maybe<Scalars['bigint']>;
  not_notified_in_app?: Maybe<Scalars['bigint']>;
  recipient_id?: Maybe<Scalars['uuid']>;
  unread_count?: Maybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Unread_Messages_Sum_Fields = {
  __typename?: 'unread_messages_sum_fields';
  not_notified_by_email?: Maybe<Scalars['bigint']>;
  not_notified_in_app?: Maybe<Scalars['bigint']>;
  unread_count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "unread_messages" */
export type Unread_Messages_Sum_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Unread_Messages_Var_Pop_Fields = {
  __typename?: 'unread_messages_var_pop_fields';
  not_notified_by_email?: Maybe<Scalars['Float']>;
  not_notified_in_app?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "unread_messages" */
export type Unread_Messages_Var_Pop_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unread_Messages_Var_Samp_Fields = {
  __typename?: 'unread_messages_var_samp_fields';
  not_notified_by_email?: Maybe<Scalars['Float']>;
  not_notified_in_app?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "unread_messages" */
export type Unread_Messages_Var_Samp_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Unread_Messages_Variance_Fields = {
  __typename?: 'unread_messages_variance_fields';
  not_notified_by_email?: Maybe<Scalars['Float']>;
  not_notified_in_app?: Maybe<Scalars['Float']>;
  unread_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "unread_messages" */
export type Unread_Messages_Variance_Order_By = {
  not_notified_by_email?: Maybe<Order_By>;
  not_notified_in_app?: Maybe<Order_By>;
  unread_count?: Maybe<Order_By>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  /** An object relationship */
  admin?: Maybe<Admin>;
  /** An array relationship */
  applications: Array<Application>;
  /** An array relationship */
  applicationsByInterviewedBy: Array<Application>;
  /** An aggregate relationship */
  applicationsByInterviewedBy_aggregate: Application_Aggregate;
  /** An aggregate relationship */
  applications_aggregate: Application_Aggregate;
  archived?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  attached_documents: Array<Document_User>;
  /** An aggregate relationship */
  attached_documents_aggregate: Document_User_Aggregate;
  available: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  /** An array relationship */
  candidates: Array<Candidate>;
  /** An aggregate relationship */
  candidates_aggregate: Candidate_Aggregate;
  /** An array relationship */
  certifications: Array<User_Certification>;
  /** An aggregate relationship */
  certifications_aggregate: User_Certification_Aggregate;
  /** An array relationship */
  companies: Array<User_Company>;
  /** An array relationship */
  companiesByCreatedBy: Array<Company>;
  /** An aggregate relationship */
  companiesByCreatedBy_aggregate: Company_Aggregate;
  /** An aggregate relationship */
  companies_aggregate: User_Company_Aggregate;
  /** An array relationship */
  company_followers: Array<Company_Follower>;
  /** An aggregate relationship */
  company_followers_aggregate: Company_Follower_Aggregate;
  /** An array relationship */
  company_notifications: Array<Company_User_Notifications>;
  /** An aggregate relationship */
  company_notifications_aggregate: Company_User_Notifications_Aggregate;
  confirmed: Scalars['Boolean'];
  consent_at?: Maybe<Scalars['timestamp']>;
  consent_given?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  contractor_notes: Array<Contractor_Note>;
  /** An aggregate relationship */
  contractor_notes_aggregate: Contractor_Note_Aggregate;
  /** An array relationship */
  contractor_ratings: Array<Contractor_Rating>;
  /** An aggregate relationship */
  contractor_ratings_aggregate: Contractor_Rating_Aggregate;
  /** An array relationship */
  contracts: Array<Contractor>;
  /** An aggregate relationship */
  contracts_aggregate: Contractor_Aggregate;
  /** An array relationship */
  conversations: Array<User_Conversation>;
  /** An aggregate relationship */
  conversations_aggregate: User_Conversation_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  customRequestsByUpdatedById: Array<Custom_Request>;
  /** An aggregate relationship */
  customRequestsByUpdatedById_aggregate: Custom_Request_Aggregate;
  /** An array relationship */
  custom_requests: Array<Custom_Request>;
  /** An aggregate relationship */
  custom_requests_aggregate: Custom_Request_Aggregate;
  /** An array relationship */
  declined_visit_matches: Array<Declined_Visit_Matches>;
  /** An aggregate relationship */
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  /** An array relationship */
  document_custom_requests: Array<Document_Custom_Request>;
  /** An aggregate relationship */
  document_custom_requests_aggregate: Document_Custom_Request_Aggregate;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** An array relationship */
  educations: Array<User_Education>;
  /** An aggregate relationship */
  educations_aggregate: User_Education_Aggregate;
  email: Scalars['String'];
  emergency_contact?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  experiences: Array<User_Experience>;
  /** An aggregate relationship */
  experiences_aggregate: User_Experience_Aggregate;
  family_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  favorited_by_users: Array<User_Favorite>;
  /** An aggregate relationship */
  favorited_by_users_aggregate: User_Favorite_Aggregate;
  /** An array relationship */
  favorited_users: Array<User_Favorite>;
  /** An aggregate relationship */
  favorited_users_aggregate: User_Favorite_Aggregate;
  given_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An array relationship */
  invitationsByInvitedBy: Array<Invitation>;
  /** An aggregate relationship */
  invitationsByInvitedBy_aggregate: Invitation_Aggregate;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  /** An object relationship */
  invited_by?: Maybe<User>;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  is_public?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  manager?: Maybe<Manager>;
  /** An array relationship */
  manager_contractors: Array<Manager_Contractor>;
  /** An aggregate relationship */
  manager_contractors_aggregate: Manager_Contractor_Aggregate;
  marketplace: Scalars['Boolean'];
  /** An array relationship */
  messages: Array<Message>;
  /** An aggregate relationship */
  messages_aggregate: Message_Aggregate;
  /** An array relationship */
  onboardings: Array<Onboarding>;
  /** An aggregate relationship */
  onboardings_aggregate: Onboarding_Aggregate;
  /** An array relationship */
  payment_cards: Array<Payment_Card>;
  /** An aggregate relationship */
  payment_cards_aggregate: Payment_Card_Aggregate;
  pending: Scalars['Boolean'];
  pending_invite?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  private_data?: Maybe<User_Private_Data>;
  /** An object relationship */
  profile?: Maybe<User_Profile>;
  profile_completed: Scalars['Boolean'];
  /** An array relationship */
  projectActivityRequestMoreHoursByActorId: Array<Project_Activity_Request_More_Hours>;
  /** An aggregate relationship */
  projectActivityRequestMoreHoursByActorId_aggregate: Project_Activity_Request_More_Hours_Aggregate;
  /** An array relationship */
  project_activities: Array<Project_Activity>;
  /** An aggregate relationship */
  project_activities_aggregate: Project_Activity_Aggregate;
  /** An array relationship */
  project_activity_request_more_hours: Array<Project_Activity_Request_More_Hours>;
  /** An aggregate relationship */
  project_activity_request_more_hours_aggregate: Project_Activity_Request_More_Hours_Aggregate;
  /** An array relationship */
  rated_by_users: Array<User_Rating>;
  /** An aggregate relationship */
  rated_by_users_aggregate: User_Rating_Aggregate;
  /** An array relationship */
  rated_users: Array<User_Rating>;
  /** An aggregate relationship */
  rated_users_aggregate: User_Rating_Aggregate;
  /** An array relationship */
  recipient_messages: Array<Recipient_Message>;
  /** An aggregate relationship */
  recipient_messages_aggregate: Recipient_Message_Aggregate;
  /** An array relationship */
  resource_information_cards: Array<Resource_Information_Card>;
  /** An aggregate relationship */
  resource_information_cards_aggregate: Resource_Information_Card_Aggregate;
  role: Scalars['String'];
  /** An array relationship */
  skills: Array<Skill>;
  /** An aggregate relationship */
  skills_aggregate: Skill_Aggregate;
  /** An array relationship */
  smart_match_bookmarks: Array<Smart_Match_Bookmark>;
  /** An aggregate relationship */
  smart_match_bookmarks_aggregate: Smart_Match_Bookmark_Aggregate;
  /** An array relationship */
  soft_skills: Array<Soft_Skill>;
  /** An aggregate relationship */
  soft_skills_aggregate: Soft_Skill_Aggregate;
  stripe_customer_id?: Maybe<Scalars['String']>;
  subscription_required: Scalars['Boolean'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  userProfileByManagementsByAddedById: Array<User_Profile_By_Management>;
  /** An aggregate relationship */
  userProfileByManagementsByAddedById_aggregate: User_Profile_By_Management_Aggregate;
  /** An array relationship */
  user_experiences: Array<User_Experience>;
  /** An aggregate relationship */
  user_experiences_aggregate: User_Experience_Aggregate;
  /** An array relationship */
  user_job_titles: Array<User_Job_Title>;
  /** An aggregate relationship */
  user_job_titles_aggregate: User_Job_Title_Aggregate;
  /** An array relationship */
  user_profile_by_managements: Array<User_Profile_By_Management>;
  /** An aggregate relationship */
  user_profile_by_managements_aggregate: User_Profile_By_Management_Aggregate;
  /** An array relationship */
  user_skills: Array<User_Skill>;
  /** An aggregate relationship */
  user_skills_aggregate: User_Skill_Aggregate;
  /** An array relationship */
  user_soft_skills: Array<User_Soft_Skill>;
  /** An aggregate relationship */
  user_soft_skills_aggregate: User_Soft_Skill_Aggregate;
  /** An array relationship */
  user_transportations: Array<User_Transportation>;
  /** An aggregate relationship */
  user_transportations_aggregate: User_Transportation_Aggregate;
  /** An array relationship */
  watched_by_users: Array<User_Watchlist>;
  /** An aggregate relationship */
  watched_by_users_aggregate: User_Watchlist_Aggregate;
  /** An array relationship */
  watched_users: Array<User_Watchlist>;
  /** An aggregate relationship */
  watched_users_aggregate: User_Watchlist_Aggregate;
};


/** columns and relationships of "user" */
export type UserApplicationsArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserApplicationsByInterviewedByArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserApplicationsByInterviewedBy_AggregateArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserApplications_AggregateArgs = {
  distinct_on?: Maybe<Array<Application_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Application_Order_By>>;
  where?: Maybe<Application_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserAttached_DocumentsArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserAttached_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_User_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_User_Order_By>>;
  where?: Maybe<Document_User_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCandidatesArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCandidates_AggregateArgs = {
  distinct_on?: Maybe<Array<Candidate_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Candidate_Order_By>>;
  where?: Maybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCertificationsArgs = {
  distinct_on?: Maybe<Array<User_Certification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Certification_Order_By>>;
  where?: Maybe<User_Certification_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCertifications_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Certification_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Certification_Order_By>>;
  where?: Maybe<User_Certification_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompaniesArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompaniesByCreatedByArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompaniesByCreatedBy_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Order_By>>;
  where?: Maybe<Company_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompanies_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Company_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Company_Order_By>>;
  where?: Maybe<User_Company_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompany_FollowersArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompany_Followers_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_Follower_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_Follower_Order_By>>;
  where?: Maybe<Company_Follower_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompany_NotificationsArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCompany_Notifications_AggregateArgs = {
  distinct_on?: Maybe<Array<Company_User_Notifications_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Company_User_Notifications_Order_By>>;
  where?: Maybe<Company_User_Notifications_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserContractor_NotesArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserContractor_Notes_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Note_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Note_Order_By>>;
  where?: Maybe<Contractor_Note_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserContractor_RatingsArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserContractor_Ratings_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Rating_Order_By>>;
  where?: Maybe<Contractor_Rating_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserContractsArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserContracts_AggregateArgs = {
  distinct_on?: Maybe<Array<Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contractor_Order_By>>;
  where?: Maybe<Contractor_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserConversationsArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserConversations_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Conversation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Conversation_Order_By>>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCustomRequestsByUpdatedByIdArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCustomRequestsByUpdatedById_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCustom_RequestsArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCustom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Custom_Request_Order_By>>;
  where?: Maybe<Custom_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDeclined_Visit_MatchesArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDeclined_Visit_Matches_AggregateArgs = {
  distinct_on?: Maybe<Array<Declined_Visit_Matches_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Declined_Visit_Matches_Order_By>>;
  where?: Maybe<Declined_Visit_Matches_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDocument_Custom_RequestsArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDocument_Custom_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Custom_Request_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Custom_Request_Order_By>>;
  where?: Maybe<Document_Custom_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDocumentsArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDocuments_AggregateArgs = {
  distinct_on?: Maybe<Array<Document_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Document_Order_By>>;
  where?: Maybe<Document_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEducationsArgs = {
  distinct_on?: Maybe<Array<User_Education_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Education_Order_By>>;
  where?: Maybe<User_Education_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEducations_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Education_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Education_Order_By>>;
  where?: Maybe<User_Education_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserEmergency_ContactArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "user" */
export type UserExperiencesArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserExperiences_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFavorited_By_UsersArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFavorited_By_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFavorited_UsersArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFavorited_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Favorite_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Favorite_Order_By>>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvitationsArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvitationsByInvitedByArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvitationsByInvitedBy_AggregateArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvitations_AggregateArgs = {
  distinct_on?: Maybe<Array<Invitation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invitation_Order_By>>;
  where?: Maybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoicesArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvoices_AggregateArgs = {
  distinct_on?: Maybe<Array<Invoice_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Invoice_Order_By>>;
  where?: Maybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserManager_ContractorsArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserManager_Contractors_AggregateArgs = {
  distinct_on?: Maybe<Array<Manager_Contractor_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manager_Contractor_Order_By>>;
  where?: Maybe<Manager_Contractor_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMessagesArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserMessages_AggregateArgs = {
  distinct_on?: Maybe<Array<Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Message_Order_By>>;
  where?: Maybe<Message_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOnboardingsArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOnboardings_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Onboarding_Order_By>>;
  where?: Maybe<Onboarding_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPayment_CardsArgs = {
  distinct_on?: Maybe<Array<Payment_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Card_Order_By>>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPayment_Cards_AggregateArgs = {
  distinct_on?: Maybe<Array<Payment_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Payment_Card_Order_By>>;
  where?: Maybe<Payment_Card_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProjectActivityRequestMoreHoursByActorIdArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProjectActivityRequestMoreHoursByActorId_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProject_ActivitiesArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProject_Activities_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Order_By>>;
  where?: Maybe<Project_Activity_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProject_Activity_Request_More_HoursArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProject_Activity_Request_More_Hours_AggregateArgs = {
  distinct_on?: Maybe<Array<Project_Activity_Request_More_Hours_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Project_Activity_Request_More_Hours_Order_By>>;
  where?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRated_By_UsersArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRated_By_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRated_UsersArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRated_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Rating_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Rating_Order_By>>;
  where?: Maybe<User_Rating_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRecipient_MessagesArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRecipient_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Recipient_Message_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Recipient_Message_Order_By>>;
  where?: Maybe<Recipient_Message_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserResource_Information_CardsArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserResource_Information_Cards_AggregateArgs = {
  distinct_on?: Maybe<Array<Resource_Information_Card_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Resource_Information_Card_Order_By>>;
  where?: Maybe<Resource_Information_Card_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSkillsArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSkills_AggregateArgs = {
  distinct_on?: Maybe<Array<Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Skill_Order_By>>;
  where?: Maybe<Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSmart_Match_BookmarksArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSmart_Match_Bookmarks_AggregateArgs = {
  distinct_on?: Maybe<Array<Smart_Match_Bookmark_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Smart_Match_Bookmark_Order_By>>;
  where?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSoft_SkillsArgs = {
  distinct_on?: Maybe<Array<Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Soft_Skill_Order_By>>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserSoft_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Soft_Skill_Order_By>>;
  where?: Maybe<Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserProfileByManagementsByAddedByIdArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUserProfileByManagementsByAddedById_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_ExperiencesArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Experiences_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Experience_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Experience_Order_By>>;
  where?: Maybe<User_Experience_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Job_TitlesArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Job_Titles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Job_Title_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Job_Title_Order_By>>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Profile_By_ManagementsArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Profile_By_Managements_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_By_Management_Order_By>>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_SkillsArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Soft_SkillsArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Soft_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_TransportationsArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Transportations_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWatched_By_UsersArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWatched_By_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWatched_UsersArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWatched_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Watchlist_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Watchlist_Order_By>>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};

/** columns and relationships of "user_affinda_profile" */
export type User_Affinda_Profile = {
  __typename?: 'user_affinda_profile';
  document_id: Scalars['String'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_affinda_profile" */
export type User_Affinda_Profile_Aggregate = {
  __typename?: 'user_affinda_profile_aggregate';
  aggregate?: Maybe<User_Affinda_Profile_Aggregate_Fields>;
  nodes: Array<User_Affinda_Profile>;
};

/** aggregate fields of "user_affinda_profile" */
export type User_Affinda_Profile_Aggregate_Fields = {
  __typename?: 'user_affinda_profile_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Affinda_Profile_Max_Fields>;
  min?: Maybe<User_Affinda_Profile_Min_Fields>;
};


/** aggregate fields of "user_affinda_profile" */
export type User_Affinda_Profile_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Affinda_Profile_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_affinda_profile". All fields are combined with a logical 'AND'. */
export type User_Affinda_Profile_Bool_Exp = {
  _and?: Maybe<Array<User_Affinda_Profile_Bool_Exp>>;
  _not?: Maybe<User_Affinda_Profile_Bool_Exp>;
  _or?: Maybe<Array<User_Affinda_Profile_Bool_Exp>>;
  document_id?: Maybe<String_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_affinda_profile" */
export enum User_Affinda_Profile_Constraint {
  /** unique or primary key constraint on columns "document_id" */
  UserAffindaProfilePkey = 'user_affinda_profile_pkey'
}

/** input type for inserting data into table "user_affinda_profile" */
export type User_Affinda_Profile_Insert_Input = {
  document_id?: Maybe<Scalars['String']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Affinda_Profile_Max_Fields = {
  __typename?: 'user_affinda_profile_max_fields';
  document_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Affinda_Profile_Min_Fields = {
  __typename?: 'user_affinda_profile_min_fields';
  document_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_affinda_profile" */
export type User_Affinda_Profile_Mutation_Response = {
  __typename?: 'user_affinda_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Affinda_Profile>;
};

/** on_conflict condition type for table "user_affinda_profile" */
export type User_Affinda_Profile_On_Conflict = {
  constraint: User_Affinda_Profile_Constraint;
  update_columns?: Array<User_Affinda_Profile_Update_Column>;
  where?: Maybe<User_Affinda_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "user_affinda_profile". */
export type User_Affinda_Profile_Order_By = {
  document_id?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_affinda_profile */
export type User_Affinda_Profile_Pk_Columns_Input = {
  document_id: Scalars['String'];
};

/** select columns of table "user_affinda_profile" */
export enum User_Affinda_Profile_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_affinda_profile" */
export type User_Affinda_Profile_Set_Input = {
  document_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_affinda_profile" */
export type User_Affinda_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Affinda_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Affinda_Profile_Stream_Cursor_Value_Input = {
  document_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_affinda_profile" */
export enum User_Affinda_Profile_Update_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Affinda_Profile_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Affinda_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Affinda_Profile_Bool_Exp;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  emergency_contact?: Maybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'user_avg_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: Maybe<Array<User_Bool_Exp>>;
  _not?: Maybe<User_Bool_Exp>;
  _or?: Maybe<Array<User_Bool_Exp>>;
  admin?: Maybe<Admin_Bool_Exp>;
  applications?: Maybe<Application_Bool_Exp>;
  applicationsByInterviewedBy?: Maybe<Application_Bool_Exp>;
  applicationsByInterviewedBy_aggregate?: Maybe<Application_Aggregate_Bool_Exp>;
  applications_aggregate?: Maybe<Application_Aggregate_Bool_Exp>;
  archived?: Maybe<Boolean_Comparison_Exp>;
  attached_documents?: Maybe<Document_User_Bool_Exp>;
  attached_documents_aggregate?: Maybe<Document_User_Aggregate_Bool_Exp>;
  available?: Maybe<Boolean_Comparison_Exp>;
  avatar?: Maybe<String_Comparison_Exp>;
  candidates?: Maybe<Candidate_Bool_Exp>;
  candidates_aggregate?: Maybe<Candidate_Aggregate_Bool_Exp>;
  certifications?: Maybe<User_Certification_Bool_Exp>;
  certifications_aggregate?: Maybe<User_Certification_Aggregate_Bool_Exp>;
  companies?: Maybe<User_Company_Bool_Exp>;
  companiesByCreatedBy?: Maybe<Company_Bool_Exp>;
  companiesByCreatedBy_aggregate?: Maybe<Company_Aggregate_Bool_Exp>;
  companies_aggregate?: Maybe<User_Company_Aggregate_Bool_Exp>;
  company_followers?: Maybe<Company_Follower_Bool_Exp>;
  company_followers_aggregate?: Maybe<Company_Follower_Aggregate_Bool_Exp>;
  company_notifications?: Maybe<Company_User_Notifications_Bool_Exp>;
  company_notifications_aggregate?: Maybe<Company_User_Notifications_Aggregate_Bool_Exp>;
  confirmed?: Maybe<Boolean_Comparison_Exp>;
  consent_at?: Maybe<Timestamp_Comparison_Exp>;
  consent_given?: Maybe<Boolean_Comparison_Exp>;
  contractor_notes?: Maybe<Contractor_Note_Bool_Exp>;
  contractor_notes_aggregate?: Maybe<Contractor_Note_Aggregate_Bool_Exp>;
  contractor_ratings?: Maybe<Contractor_Rating_Bool_Exp>;
  contractor_ratings_aggregate?: Maybe<Contractor_Rating_Aggregate_Bool_Exp>;
  contracts?: Maybe<Contractor_Bool_Exp>;
  contracts_aggregate?: Maybe<Contractor_Aggregate_Bool_Exp>;
  conversations?: Maybe<User_Conversation_Bool_Exp>;
  conversations_aggregate?: Maybe<User_Conversation_Aggregate_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by?: Maybe<Uuid_Comparison_Exp>;
  customRequestsByUpdatedById?: Maybe<Custom_Request_Bool_Exp>;
  customRequestsByUpdatedById_aggregate?: Maybe<Custom_Request_Aggregate_Bool_Exp>;
  custom_requests?: Maybe<Custom_Request_Bool_Exp>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Bool_Exp>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Bool_Exp>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Bool_Exp>;
  document_custom_requests?: Maybe<Document_Custom_Request_Bool_Exp>;
  document_custom_requests_aggregate?: Maybe<Document_Custom_Request_Aggregate_Bool_Exp>;
  documents?: Maybe<Document_Bool_Exp>;
  documents_aggregate?: Maybe<Document_Aggregate_Bool_Exp>;
  educations?: Maybe<User_Education_Bool_Exp>;
  educations_aggregate?: Maybe<User_Education_Aggregate_Bool_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  emergency_contact?: Maybe<Jsonb_Comparison_Exp>;
  experiences?: Maybe<User_Experience_Bool_Exp>;
  experiences_aggregate?: Maybe<User_Experience_Aggregate_Bool_Exp>;
  family_name?: Maybe<String_Comparison_Exp>;
  favorited_by_users?: Maybe<User_Favorite_Bool_Exp>;
  favorited_by_users_aggregate?: Maybe<User_Favorite_Aggregate_Bool_Exp>;
  favorited_users?: Maybe<User_Favorite_Bool_Exp>;
  favorited_users_aggregate?: Maybe<User_Favorite_Aggregate_Bool_Exp>;
  given_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  invitations?: Maybe<Invitation_Bool_Exp>;
  invitationsByInvitedBy?: Maybe<Invitation_Bool_Exp>;
  invitationsByInvitedBy_aggregate?: Maybe<Invitation_Aggregate_Bool_Exp>;
  invitations_aggregate?: Maybe<Invitation_Aggregate_Bool_Exp>;
  invited_by?: Maybe<User_Bool_Exp>;
  invoices?: Maybe<Invoice_Bool_Exp>;
  invoices_aggregate?: Maybe<Invoice_Aggregate_Bool_Exp>;
  is_public?: Maybe<Boolean_Comparison_Exp>;
  manager?: Maybe<Manager_Bool_Exp>;
  manager_contractors?: Maybe<Manager_Contractor_Bool_Exp>;
  manager_contractors_aggregate?: Maybe<Manager_Contractor_Aggregate_Bool_Exp>;
  marketplace?: Maybe<Boolean_Comparison_Exp>;
  messages?: Maybe<Message_Bool_Exp>;
  messages_aggregate?: Maybe<Message_Aggregate_Bool_Exp>;
  onboardings?: Maybe<Onboarding_Bool_Exp>;
  onboardings_aggregate?: Maybe<Onboarding_Aggregate_Bool_Exp>;
  payment_cards?: Maybe<Payment_Card_Bool_Exp>;
  payment_cards_aggregate?: Maybe<Payment_Card_Aggregate_Bool_Exp>;
  pending?: Maybe<Boolean_Comparison_Exp>;
  pending_invite?: Maybe<Boolean_Comparison_Exp>;
  phone?: Maybe<Bigint_Comparison_Exp>;
  private_data?: Maybe<User_Private_Data_Bool_Exp>;
  profile?: Maybe<User_Profile_Bool_Exp>;
  profile_completed?: Maybe<Boolean_Comparison_Exp>;
  projectActivityRequestMoreHoursByActorId?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
  projectActivityRequestMoreHoursByActorId_aggregate?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Bool_Exp>;
  project_activities?: Maybe<Project_Activity_Bool_Exp>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Bool_Exp>;
  project_activity_request_more_hours?: Maybe<Project_Activity_Request_More_Hours_Bool_Exp>;
  project_activity_request_more_hours_aggregate?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Bool_Exp>;
  rated_by_users?: Maybe<User_Rating_Bool_Exp>;
  rated_by_users_aggregate?: Maybe<User_Rating_Aggregate_Bool_Exp>;
  rated_users?: Maybe<User_Rating_Bool_Exp>;
  rated_users_aggregate?: Maybe<User_Rating_Aggregate_Bool_Exp>;
  recipient_messages?: Maybe<Recipient_Message_Bool_Exp>;
  recipient_messages_aggregate?: Maybe<Recipient_Message_Aggregate_Bool_Exp>;
  resource_information_cards?: Maybe<Resource_Information_Card_Bool_Exp>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Bool_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  skills?: Maybe<Skill_Bool_Exp>;
  skills_aggregate?: Maybe<Skill_Aggregate_Bool_Exp>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Bool_Exp>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Bool_Exp>;
  soft_skills?: Maybe<Soft_Skill_Bool_Exp>;
  soft_skills_aggregate?: Maybe<Soft_Skill_Aggregate_Bool_Exp>;
  stripe_customer_id?: Maybe<String_Comparison_Exp>;
  subscription_required?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  userProfileByManagementsByAddedById?: Maybe<User_Profile_By_Management_Bool_Exp>;
  userProfileByManagementsByAddedById_aggregate?: Maybe<User_Profile_By_Management_Aggregate_Bool_Exp>;
  user_experiences?: Maybe<User_Experience_Bool_Exp>;
  user_experiences_aggregate?: Maybe<User_Experience_Aggregate_Bool_Exp>;
  user_job_titles?: Maybe<User_Job_Title_Bool_Exp>;
  user_job_titles_aggregate?: Maybe<User_Job_Title_Aggregate_Bool_Exp>;
  user_profile_by_managements?: Maybe<User_Profile_By_Management_Bool_Exp>;
  user_profile_by_managements_aggregate?: Maybe<User_Profile_By_Management_Aggregate_Bool_Exp>;
  user_skills?: Maybe<User_Skill_Bool_Exp>;
  user_skills_aggregate?: Maybe<User_Skill_Aggregate_Bool_Exp>;
  user_soft_skills?: Maybe<User_Soft_Skill_Bool_Exp>;
  user_soft_skills_aggregate?: Maybe<User_Soft_Skill_Aggregate_Bool_Exp>;
  user_transportations?: Maybe<User_Transportation_Bool_Exp>;
  user_transportations_aggregate?: Maybe<User_Transportation_Aggregate_Bool_Exp>;
  watched_by_users?: Maybe<User_Watchlist_Bool_Exp>;
  watched_by_users_aggregate?: Maybe<User_Watchlist_Aggregate_Bool_Exp>;
  watched_users?: Maybe<User_Watchlist_Bool_Exp>;
  watched_users_aggregate?: Maybe<User_Watchlist_Aggregate_Bool_Exp>;
};

/** columns and relationships of "user_certification" */
export type User_Certification = {
  __typename?: 'user_certification';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
  year?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "user_certification" */
export type User_Certification_Aggregate = {
  __typename?: 'user_certification_aggregate';
  aggregate?: Maybe<User_Certification_Aggregate_Fields>;
  nodes: Array<User_Certification>;
};

export type User_Certification_Aggregate_Bool_Exp = {
  count?: Maybe<User_Certification_Aggregate_Bool_Exp_Count>;
};

export type User_Certification_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Certification_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Certification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_certification" */
export type User_Certification_Aggregate_Fields = {
  __typename?: 'user_certification_aggregate_fields';
  avg?: Maybe<User_Certification_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Certification_Max_Fields>;
  min?: Maybe<User_Certification_Min_Fields>;
  stddev?: Maybe<User_Certification_Stddev_Fields>;
  stddev_pop?: Maybe<User_Certification_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Certification_Stddev_Samp_Fields>;
  sum?: Maybe<User_Certification_Sum_Fields>;
  var_pop?: Maybe<User_Certification_Var_Pop_Fields>;
  var_samp?: Maybe<User_Certification_Var_Samp_Fields>;
  variance?: Maybe<User_Certification_Variance_Fields>;
};


/** aggregate fields of "user_certification" */
export type User_Certification_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Certification_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_certification" */
export type User_Certification_Aggregate_Order_By = {
  avg?: Maybe<User_Certification_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Certification_Max_Order_By>;
  min?: Maybe<User_Certification_Min_Order_By>;
  stddev?: Maybe<User_Certification_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Certification_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Certification_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Certification_Sum_Order_By>;
  var_pop?: Maybe<User_Certification_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Certification_Var_Samp_Order_By>;
  variance?: Maybe<User_Certification_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_certification" */
export type User_Certification_Arr_Rel_Insert_Input = {
  data: Array<User_Certification_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Certification_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Certification_Avg_Fields = {
  __typename?: 'user_certification_avg_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_certification" */
export type User_Certification_Avg_Order_By = {
  year?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_certification". All fields are combined with a logical 'AND'. */
export type User_Certification_Bool_Exp = {
  _and?: Maybe<Array<User_Certification_Bool_Exp>>;
  _not?: Maybe<User_Certification_Bool_Exp>;
  _or?: Maybe<Array<User_Certification_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  institution?: Maybe<String_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  year?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_certification" */
export enum User_Certification_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserCertificationPkey = 'user_certification_pkey'
}

/** input type for incrementing numeric columns in table "user_certification" */
export type User_Certification_Inc_Input = {
  year?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_certification" */
export type User_Certification_Insert_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Certification_Max_Fields = {
  __typename?: 'user_certification_max_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_certification" */
export type User_Certification_Max_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Certification_Min_Fields = {
  __typename?: 'user_certification_min_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_certification" */
export type User_Certification_Min_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_certification" */
export type User_Certification_Mutation_Response = {
  __typename?: 'user_certification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Certification>;
};

/** on_conflict condition type for table "user_certification" */
export type User_Certification_On_Conflict = {
  constraint: User_Certification_Constraint;
  update_columns?: Array<User_Certification_Update_Column>;
  where?: Maybe<User_Certification_Bool_Exp>;
};

/** Ordering options when selecting data from "user_certification". */
export type User_Certification_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** primary key columns input for table: user_certification */
export type User_Certification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_certification" */
export enum User_Certification_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Institution = 'institution',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "user_certification" */
export type User_Certification_Set_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Certification_Stddev_Fields = {
  __typename?: 'user_certification_stddev_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_certification" */
export type User_Certification_Stddev_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Certification_Stddev_Pop_Fields = {
  __typename?: 'user_certification_stddev_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_certification" */
export type User_Certification_Stddev_Pop_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Certification_Stddev_Samp_Fields = {
  __typename?: 'user_certification_stddev_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_certification" */
export type User_Certification_Stddev_Samp_Order_By = {
  year?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_certification" */
export type User_Certification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Certification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Certification_Stream_Cursor_Value_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Certification_Sum_Fields = {
  __typename?: 'user_certification_sum_fields';
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_certification" */
export type User_Certification_Sum_Order_By = {
  year?: Maybe<Order_By>;
};

/** update columns of table "user_certification" */
export enum User_Certification_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Institution = 'institution',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Year = 'year'
}

export type User_Certification_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Certification_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Certification_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Certification_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Certification_Var_Pop_Fields = {
  __typename?: 'user_certification_var_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_certification" */
export type User_Certification_Var_Pop_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Certification_Var_Samp_Fields = {
  __typename?: 'user_certification_var_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_certification" */
export type User_Certification_Var_Samp_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Certification_Variance_Fields = {
  __typename?: 'user_certification_variance_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_certification" */
export type User_Certification_Variance_Order_By = {
  year?: Maybe<Order_By>;
};

/** columns and relationships of "user_company" */
export type User_Company = {
  __typename?: 'user_company';
  /** An object relationship */
  company: Company;
  company_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_company" */
export type User_Company_Aggregate = {
  __typename?: 'user_company_aggregate';
  aggregate?: Maybe<User_Company_Aggregate_Fields>;
  nodes: Array<User_Company>;
};

export type User_Company_Aggregate_Bool_Exp = {
  count?: Maybe<User_Company_Aggregate_Bool_Exp_Count>;
};

export type User_Company_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Company_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Company_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_company" */
export type User_Company_Aggregate_Fields = {
  __typename?: 'user_company_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Company_Max_Fields>;
  min?: Maybe<User_Company_Min_Fields>;
};


/** aggregate fields of "user_company" */
export type User_Company_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Company_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_company" */
export type User_Company_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Company_Max_Order_By>;
  min?: Maybe<User_Company_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_company" */
export type User_Company_Arr_Rel_Insert_Input = {
  data: Array<User_Company_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Company_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_company". All fields are combined with a logical 'AND'. */
export type User_Company_Bool_Exp = {
  _and?: Maybe<Array<User_Company_Bool_Exp>>;
  _not?: Maybe<User_Company_Bool_Exp>;
  _or?: Maybe<Array<User_Company_Bool_Exp>>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_company" */
export enum User_Company_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserCompanyPkey = 'user_company_pkey'
}

/** input type for inserting data into table "user_company" */
export type User_Company_Insert_Input = {
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Company_Max_Fields = {
  __typename?: 'user_company_max_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_company" */
export type User_Company_Max_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Company_Min_Fields = {
  __typename?: 'user_company_min_fields';
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_company" */
export type User_Company_Min_Order_By = {
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_company" */
export type User_Company_Mutation_Response = {
  __typename?: 'user_company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Company>;
};

/** on_conflict condition type for table "user_company" */
export type User_Company_On_Conflict = {
  constraint: User_Company_Constraint;
  update_columns?: Array<User_Company_Update_Column>;
  where?: Maybe<User_Company_Bool_Exp>;
};

/** Ordering options when selecting data from "user_company". */
export type User_Company_Order_By = {
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_company */
export type User_Company_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_company" */
export enum User_Company_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_company" */
export type User_Company_Set_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_company" */
export type User_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Company_Stream_Cursor_Value_Input = {
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_company" */
export enum User_Company_Update_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type User_Company_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Company_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Company_Bool_Exp;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "stripe_customer_id" */
  UserPaymentCustomerIdKey = 'user_payment_customer_id_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** columns and relationships of "user_conversation" */
export type User_Conversation = {
  __typename?: 'user_conversation';
  /** An object relationship */
  conversation: Conversation;
  conversation_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  deleted: Scalars['Boolean'];
  id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_conversation" */
export type User_Conversation_Aggregate = {
  __typename?: 'user_conversation_aggregate';
  aggregate?: Maybe<User_Conversation_Aggregate_Fields>;
  nodes: Array<User_Conversation>;
};

export type User_Conversation_Aggregate_Bool_Exp = {
  bool_and?: Maybe<User_Conversation_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<User_Conversation_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<User_Conversation_Aggregate_Bool_Exp_Count>;
};

export type User_Conversation_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Conversation_Select_Column_User_Conversation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Conversation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Conversation_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Conversation_Select_Column_User_Conversation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Conversation_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Conversation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Conversation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Conversation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_conversation" */
export type User_Conversation_Aggregate_Fields = {
  __typename?: 'user_conversation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Conversation_Max_Fields>;
  min?: Maybe<User_Conversation_Min_Fields>;
};


/** aggregate fields of "user_conversation" */
export type User_Conversation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Conversation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_conversation" */
export type User_Conversation_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Conversation_Max_Order_By>;
  min?: Maybe<User_Conversation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_conversation" */
export type User_Conversation_Arr_Rel_Insert_Input = {
  data: Array<User_Conversation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Conversation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_conversation". All fields are combined with a logical 'AND'. */
export type User_Conversation_Bool_Exp = {
  _and?: Maybe<Array<User_Conversation_Bool_Exp>>;
  _not?: Maybe<User_Conversation_Bool_Exp>;
  _or?: Maybe<Array<User_Conversation_Bool_Exp>>;
  conversation?: Maybe<Conversation_Bool_Exp>;
  conversation_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_conversation" */
export enum User_Conversation_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserConversationPkey = 'user_conversation_pkey'
}

/** input type for inserting data into table "user_conversation" */
export type User_Conversation_Insert_Input = {
  conversation?: Maybe<Conversation_Obj_Rel_Insert_Input>;
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Conversation_Max_Fields = {
  __typename?: 'user_conversation_max_fields';
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_conversation" */
export type User_Conversation_Max_Order_By = {
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Conversation_Min_Fields = {
  __typename?: 'user_conversation_min_fields';
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_conversation" */
export type User_Conversation_Min_Order_By = {
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_conversation" */
export type User_Conversation_Mutation_Response = {
  __typename?: 'user_conversation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Conversation>;
};

/** on_conflict condition type for table "user_conversation" */
export type User_Conversation_On_Conflict = {
  constraint: User_Conversation_Constraint;
  update_columns?: Array<User_Conversation_Update_Column>;
  where?: Maybe<User_Conversation_Bool_Exp>;
};

/** Ordering options when selecting data from "user_conversation". */
export type User_Conversation_Order_By = {
  conversation?: Maybe<Conversation_Order_By>;
  conversation_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_conversation */
export type User_Conversation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_conversation" */
export enum User_Conversation_Select_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_conversation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_conversation" */
export enum User_Conversation_Select_Column_User_Conversation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "user_conversation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_conversation" */
export enum User_Conversation_Select_Column_User_Conversation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "user_conversation" */
export type User_Conversation_Set_Input = {
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_conversation" */
export type User_Conversation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Conversation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Conversation_Stream_Cursor_Value_Input = {
  conversation_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_conversation" */
export enum User_Conversation_Update_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Conversation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Conversation_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Conversation_Bool_Exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  emergency_contact?: Maybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  emergency_contact?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  emergency_contact?: Maybe<Scalars['String']>;
};

/** columns and relationships of "user_education" */
export type User_Education = {
  __typename?: 'user_education';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
  year?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "user_education" */
export type User_Education_Aggregate = {
  __typename?: 'user_education_aggregate';
  aggregate?: Maybe<User_Education_Aggregate_Fields>;
  nodes: Array<User_Education>;
};

export type User_Education_Aggregate_Bool_Exp = {
  count?: Maybe<User_Education_Aggregate_Bool_Exp_Count>;
};

export type User_Education_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Education_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Education_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_education" */
export type User_Education_Aggregate_Fields = {
  __typename?: 'user_education_aggregate_fields';
  avg?: Maybe<User_Education_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Education_Max_Fields>;
  min?: Maybe<User_Education_Min_Fields>;
  stddev?: Maybe<User_Education_Stddev_Fields>;
  stddev_pop?: Maybe<User_Education_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Education_Stddev_Samp_Fields>;
  sum?: Maybe<User_Education_Sum_Fields>;
  var_pop?: Maybe<User_Education_Var_Pop_Fields>;
  var_samp?: Maybe<User_Education_Var_Samp_Fields>;
  variance?: Maybe<User_Education_Variance_Fields>;
};


/** aggregate fields of "user_education" */
export type User_Education_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Education_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_education" */
export type User_Education_Aggregate_Order_By = {
  avg?: Maybe<User_Education_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Education_Max_Order_By>;
  min?: Maybe<User_Education_Min_Order_By>;
  stddev?: Maybe<User_Education_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Education_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Education_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Education_Sum_Order_By>;
  var_pop?: Maybe<User_Education_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Education_Var_Samp_Order_By>;
  variance?: Maybe<User_Education_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_education" */
export type User_Education_Arr_Rel_Insert_Input = {
  data: Array<User_Education_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Education_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Education_Avg_Fields = {
  __typename?: 'user_education_avg_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_education" */
export type User_Education_Avg_Order_By = {
  year?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_education". All fields are combined with a logical 'AND'. */
export type User_Education_Bool_Exp = {
  _and?: Maybe<Array<User_Education_Bool_Exp>>;
  _not?: Maybe<User_Education_Bool_Exp>;
  _or?: Maybe<Array<User_Education_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  institution?: Maybe<String_Comparison_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  summary?: Maybe<String_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  year?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_education" */
export enum User_Education_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserEducationPkey = 'user_education_pkey'
}

/** input type for incrementing numeric columns in table "user_education" */
export type User_Education_Inc_Input = {
  year?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_education" */
export type User_Education_Insert_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Education_Max_Fields = {
  __typename?: 'user_education_max_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_education" */
export type User_Education_Max_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Education_Min_Fields = {
  __typename?: 'user_education_min_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_education" */
export type User_Education_Min_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_education" */
export type User_Education_Mutation_Response = {
  __typename?: 'user_education_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Education>;
};

/** on_conflict condition type for table "user_education" */
export type User_Education_On_Conflict = {
  constraint: User_Education_Constraint;
  update_columns?: Array<User_Education_Update_Column>;
  where?: Maybe<User_Education_Bool_Exp>;
};

/** Ordering options when selecting data from "user_education". */
export type User_Education_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  institution?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
  year?: Maybe<Order_By>;
};

/** primary key columns input for table: user_education */
export type User_Education_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_education" */
export enum User_Education_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Institution = 'institution',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Summary = 'summary',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "user_education" */
export type User_Education_Set_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Education_Stddev_Fields = {
  __typename?: 'user_education_stddev_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_education" */
export type User_Education_Stddev_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Education_Stddev_Pop_Fields = {
  __typename?: 'user_education_stddev_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_education" */
export type User_Education_Stddev_Pop_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Education_Stddev_Samp_Fields = {
  __typename?: 'user_education_stddev_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_education" */
export type User_Education_Stddev_Samp_Order_By = {
  year?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_education" */
export type User_Education_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Education_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Education_Stream_Cursor_Value_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  institution?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Education_Sum_Fields = {
  __typename?: 'user_education_sum_fields';
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_education" */
export type User_Education_Sum_Order_By = {
  year?: Maybe<Order_By>;
};

/** update columns of table "user_education" */
export enum User_Education_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Institution = 'institution',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Summary = 'summary',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Year = 'year'
}

export type User_Education_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Education_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Education_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Education_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Education_Var_Pop_Fields = {
  __typename?: 'user_education_var_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_education" */
export type User_Education_Var_Pop_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Education_Var_Samp_Fields = {
  __typename?: 'user_education_var_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_education" */
export type User_Education_Var_Samp_Order_By = {
  year?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Education_Variance_Fields = {
  __typename?: 'user_education_variance_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_education" */
export type User_Education_Variance_Order_By = {
  year?: Maybe<Order_By>;
};

/** columns and relationships of "user_experience" */
export type User_Experience = {
  __typename?: 'user_experience';
  added_by_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An object relationship */
  industry?: Maybe<Industry>;
  industry_id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  ongoing: Scalars['Boolean'];
  /** An array relationship */
  skills: Array<Experience_Skill>;
  /** An aggregate relationship */
  skills_aggregate: Experience_Skill_Aggregate;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
};


/** columns and relationships of "user_experience" */
export type User_ExperienceSkillsArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};


/** columns and relationships of "user_experience" */
export type User_ExperienceSkills_AggregateArgs = {
  distinct_on?: Maybe<Array<Experience_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Experience_Skill_Order_By>>;
  where?: Maybe<Experience_Skill_Bool_Exp>;
};

/** aggregated selection of "user_experience" */
export type User_Experience_Aggregate = {
  __typename?: 'user_experience_aggregate';
  aggregate?: Maybe<User_Experience_Aggregate_Fields>;
  nodes: Array<User_Experience>;
};

export type User_Experience_Aggregate_Bool_Exp = {
  bool_and?: Maybe<User_Experience_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<User_Experience_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<User_Experience_Aggregate_Bool_Exp_Count>;
};

export type User_Experience_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Experience_Select_Column_User_Experience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Experience_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Experience_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Experience_Select_Column_User_Experience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Experience_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Experience_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Experience_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Experience_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_experience" */
export type User_Experience_Aggregate_Fields = {
  __typename?: 'user_experience_aggregate_fields';
  avg?: Maybe<User_Experience_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Experience_Max_Fields>;
  min?: Maybe<User_Experience_Min_Fields>;
  stddev?: Maybe<User_Experience_Stddev_Fields>;
  stddev_pop?: Maybe<User_Experience_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Experience_Stddev_Samp_Fields>;
  sum?: Maybe<User_Experience_Sum_Fields>;
  var_pop?: Maybe<User_Experience_Var_Pop_Fields>;
  var_samp?: Maybe<User_Experience_Var_Samp_Fields>;
  variance?: Maybe<User_Experience_Variance_Fields>;
};


/** aggregate fields of "user_experience" */
export type User_Experience_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Experience_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_experience" */
export type User_Experience_Aggregate_Order_By = {
  avg?: Maybe<User_Experience_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Experience_Max_Order_By>;
  min?: Maybe<User_Experience_Min_Order_By>;
  stddev?: Maybe<User_Experience_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Experience_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Experience_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Experience_Sum_Order_By>;
  var_pop?: Maybe<User_Experience_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Experience_Var_Samp_Order_By>;
  variance?: Maybe<User_Experience_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_experience" */
export type User_Experience_Arr_Rel_Insert_Input = {
  data: Array<User_Experience_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Experience_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Experience_Avg_Fields = {
  __typename?: 'user_experience_avg_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_experience" */
export type User_Experience_Avg_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_experience". All fields are combined with a logical 'AND'. */
export type User_Experience_Bool_Exp = {
  _and?: Maybe<Array<User_Experience_Bool_Exp>>;
  _not?: Maybe<User_Experience_Bool_Exp>;
  _or?: Maybe<Array<User_Experience_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  company_name?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  employment_type?: Maybe<String_Comparison_Exp>;
  end_date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  industry?: Maybe<Industry_Bool_Exp>;
  industry_id?: Maybe<Int_Comparison_Exp>;
  job_title?: Maybe<String_Comparison_Exp>;
  location?: Maybe<String_Comparison_Exp>;
  ongoing?: Maybe<Boolean_Comparison_Exp>;
  skills?: Maybe<Experience_Skill_Bool_Exp>;
  skills_aggregate?: Maybe<Experience_Skill_Aggregate_Bool_Exp>;
  start_date?: Maybe<Date_Comparison_Exp>;
  summary?: Maybe<String_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_experience" */
export enum User_Experience_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserExperiencePkey = 'user_experience_pkey'
}

/** input type for incrementing numeric columns in table "user_experience" */
export type User_Experience_Inc_Input = {
  industry_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_experience" */
export type User_Experience_Insert_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  industry?: Maybe<Industry_Obj_Rel_Insert_Input>;
  industry_id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  ongoing?: Maybe<Scalars['Boolean']>;
  skills?: Maybe<Experience_Skill_Arr_Rel_Insert_Input>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Experience_Max_Fields = {
  __typename?: 'user_experience_max_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_experience" */
export type User_Experience_Max_Order_By = {
  added_by_id?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  employment_type?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Experience_Min_Fields = {
  __typename?: 'user_experience_min_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_experience" */
export type User_Experience_Min_Order_By = {
  added_by_id?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  employment_type?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  start_date?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_experience" */
export type User_Experience_Mutation_Response = {
  __typename?: 'user_experience_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Experience>;
};

/** input type for inserting object relation for remote table "user_experience" */
export type User_Experience_Obj_Rel_Insert_Input = {
  data: User_Experience_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Experience_On_Conflict>;
};

/** on_conflict condition type for table "user_experience" */
export type User_Experience_On_Conflict = {
  constraint: User_Experience_Constraint;
  update_columns?: Array<User_Experience_Update_Column>;
  where?: Maybe<User_Experience_Bool_Exp>;
};

/** Ordering options when selecting data from "user_experience". */
export type User_Experience_Order_By = {
  added_by_id?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  employment_type?: Maybe<Order_By>;
  end_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry?: Maybe<Industry_Order_By>;
  industry_id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  ongoing?: Maybe<Order_By>;
  skills_aggregate?: Maybe<Experience_Skill_Aggregate_Order_By>;
  start_date?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_experience */
export type User_Experience_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_experience" */
export enum User_Experience_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmploymentType = 'employment_type',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IndustryId = 'industry_id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  Location = 'location',
  /** column name */
  Ongoing = 'ongoing',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Summary = 'summary',
  /** column name */
  UserId = 'user_id'
}

/** select "user_experience_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_experience" */
export enum User_Experience_Select_Column_User_Experience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Ongoing = 'ongoing'
}

/** select "user_experience_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_experience" */
export enum User_Experience_Select_Column_User_Experience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Ongoing = 'ongoing'
}

/** input type for updating data in table "user_experience" */
export type User_Experience_Set_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  ongoing?: Maybe<Scalars['Boolean']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Experience_Stddev_Fields = {
  __typename?: 'user_experience_stddev_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_experience" */
export type User_Experience_Stddev_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Experience_Stddev_Pop_Fields = {
  __typename?: 'user_experience_stddev_pop_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_experience" */
export type User_Experience_Stddev_Pop_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Experience_Stddev_Samp_Fields = {
  __typename?: 'user_experience_stddev_samp_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_experience" */
export type User_Experience_Stddev_Samp_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_experience" */
export type User_Experience_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Experience_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Experience_Stream_Cursor_Value_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  employment_type?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  industry_id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  ongoing?: Maybe<Scalars['Boolean']>;
  start_date?: Maybe<Scalars['date']>;
  summary?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Experience_Sum_Fields = {
  __typename?: 'user_experience_sum_fields';
  industry_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_experience" */
export type User_Experience_Sum_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** update columns of table "user_experience" */
export enum User_Experience_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmploymentType = 'employment_type',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IndustryId = 'industry_id',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  Location = 'location',
  /** column name */
  Ongoing = 'ongoing',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Summary = 'summary',
  /** column name */
  UserId = 'user_id'
}

export type User_Experience_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Experience_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Experience_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Experience_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Experience_Var_Pop_Fields = {
  __typename?: 'user_experience_var_pop_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_experience" */
export type User_Experience_Var_Pop_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Experience_Var_Samp_Fields = {
  __typename?: 'user_experience_var_samp_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_experience" */
export type User_Experience_Var_Samp_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Experience_Variance_Fields = {
  __typename?: 'user_experience_variance_fields';
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_experience" */
export type User_Experience_Variance_Order_By = {
  industry_id?: Maybe<Order_By>;
};

/** columns and relationships of "user_favorite" */
export type User_Favorite = {
  __typename?: 'user_favorite';
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  favorited: User;
  /** An object relationship */
  favorited_by: User;
  favorited_by_id: Scalars['uuid'];
  favorited_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "user_favorite" */
export type User_Favorite_Aggregate = {
  __typename?: 'user_favorite_aggregate';
  aggregate?: Maybe<User_Favorite_Aggregate_Fields>;
  nodes: Array<User_Favorite>;
};

export type User_Favorite_Aggregate_Bool_Exp = {
  count?: Maybe<User_Favorite_Aggregate_Bool_Exp_Count>;
};

export type User_Favorite_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Favorite_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Favorite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_favorite" */
export type User_Favorite_Aggregate_Fields = {
  __typename?: 'user_favorite_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Favorite_Max_Fields>;
  min?: Maybe<User_Favorite_Min_Fields>;
};


/** aggregate fields of "user_favorite" */
export type User_Favorite_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Favorite_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_favorite" */
export type User_Favorite_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Favorite_Max_Order_By>;
  min?: Maybe<User_Favorite_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_favorite" */
export type User_Favorite_Arr_Rel_Insert_Input = {
  data: Array<User_Favorite_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Favorite_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_favorite". All fields are combined with a logical 'AND'. */
export type User_Favorite_Bool_Exp = {
  _and?: Maybe<Array<User_Favorite_Bool_Exp>>;
  _not?: Maybe<User_Favorite_Bool_Exp>;
  _or?: Maybe<Array<User_Favorite_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  favorited?: Maybe<User_Bool_Exp>;
  favorited_by?: Maybe<User_Bool_Exp>;
  favorited_by_id?: Maybe<Uuid_Comparison_Exp>;
  favorited_id?: Maybe<Uuid_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_favorite" */
export enum User_Favorite_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserFavouritePkey = 'user_favourite_pkey'
}

/** input type for inserting data into table "user_favorite" */
export type User_Favorite_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  favorited?: Maybe<User_Obj_Rel_Insert_Input>;
  favorited_by?: Maybe<User_Obj_Rel_Insert_Input>;
  favorited_by_id?: Maybe<Scalars['uuid']>;
  favorited_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Favorite_Max_Fields = {
  __typename?: 'user_favorite_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  favorited_by_id?: Maybe<Scalars['uuid']>;
  favorited_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_favorite" */
export type User_Favorite_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  favorited_by_id?: Maybe<Order_By>;
  favorited_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Favorite_Min_Fields = {
  __typename?: 'user_favorite_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  favorited_by_id?: Maybe<Scalars['uuid']>;
  favorited_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_favorite" */
export type User_Favorite_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  favorited_by_id?: Maybe<Order_By>;
  favorited_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_favorite" */
export type User_Favorite_Mutation_Response = {
  __typename?: 'user_favorite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Favorite>;
};

/** on_conflict condition type for table "user_favorite" */
export type User_Favorite_On_Conflict = {
  constraint: User_Favorite_Constraint;
  update_columns?: Array<User_Favorite_Update_Column>;
  where?: Maybe<User_Favorite_Bool_Exp>;
};

/** Ordering options when selecting data from "user_favorite". */
export type User_Favorite_Order_By = {
  created_at?: Maybe<Order_By>;
  favorited?: Maybe<User_Order_By>;
  favorited_by?: Maybe<User_Order_By>;
  favorited_by_id?: Maybe<Order_By>;
  favorited_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_favorite */
export type User_Favorite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_favorite" */
export enum User_Favorite_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FavoritedById = 'favorited_by_id',
  /** column name */
  FavoritedId = 'favorited_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "user_favorite" */
export type User_Favorite_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  favorited_by_id?: Maybe<Scalars['uuid']>;
  favorited_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_favorite" */
export type User_Favorite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Favorite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Favorite_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  favorited_by_id?: Maybe<Scalars['uuid']>;
  favorited_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_favorite" */
export enum User_Favorite_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FavoritedById = 'favorited_by_id',
  /** column name */
  FavoritedId = 'favorited_id',
  /** column name */
  Id = 'id'
}

export type User_Favorite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Favorite_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Favorite_Bool_Exp;
};

/** input type for incrementing numeric columns in table "user" */
export type User_Inc_Input = {
  phone?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "user_industry" */
export type User_Industry = {
  __typename?: 'user_industry';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  industry: Industry;
  industry_id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User_Profile;
  user_id: Scalars['uuid'];
  /** An object relationship */
  user_profile?: Maybe<User_Profile>;
};

/** aggregated selection of "user_industry" */
export type User_Industry_Aggregate = {
  __typename?: 'user_industry_aggregate';
  aggregate?: Maybe<User_Industry_Aggregate_Fields>;
  nodes: Array<User_Industry>;
};

export type User_Industry_Aggregate_Bool_Exp = {
  count?: Maybe<User_Industry_Aggregate_Bool_Exp_Count>;
};

export type User_Industry_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Industry_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Industry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_industry" */
export type User_Industry_Aggregate_Fields = {
  __typename?: 'user_industry_aggregate_fields';
  avg?: Maybe<User_Industry_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Industry_Max_Fields>;
  min?: Maybe<User_Industry_Min_Fields>;
  stddev?: Maybe<User_Industry_Stddev_Fields>;
  stddev_pop?: Maybe<User_Industry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Industry_Stddev_Samp_Fields>;
  sum?: Maybe<User_Industry_Sum_Fields>;
  var_pop?: Maybe<User_Industry_Var_Pop_Fields>;
  var_samp?: Maybe<User_Industry_Var_Samp_Fields>;
  variance?: Maybe<User_Industry_Variance_Fields>;
};


/** aggregate fields of "user_industry" */
export type User_Industry_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Industry_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_industry" */
export type User_Industry_Aggregate_Order_By = {
  avg?: Maybe<User_Industry_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Industry_Max_Order_By>;
  min?: Maybe<User_Industry_Min_Order_By>;
  stddev?: Maybe<User_Industry_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Industry_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Industry_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Industry_Sum_Order_By>;
  var_pop?: Maybe<User_Industry_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Industry_Var_Samp_Order_By>;
  variance?: Maybe<User_Industry_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_industry" */
export type User_Industry_Arr_Rel_Insert_Input = {
  data: Array<User_Industry_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Industry_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Industry_Avg_Fields = {
  __typename?: 'user_industry_avg_fields';
  id?: Maybe<Scalars['Float']>;
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_industry" */
export type User_Industry_Avg_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_industry". All fields are combined with a logical 'AND'. */
export type User_Industry_Bool_Exp = {
  _and?: Maybe<Array<User_Industry_Bool_Exp>>;
  _not?: Maybe<User_Industry_Bool_Exp>;
  _or?: Maybe<Array<User_Industry_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  industry?: Maybe<Industry_Bool_Exp>;
  industry_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Profile_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  user_profile?: Maybe<User_Profile_Bool_Exp>;
};

/** unique or primary key constraints on table "user_industry" */
export enum User_Industry_Constraint {
  /** unique or primary key constraint on columns "user_id", "added_by_id", "industry_id" */
  UserIndustryIndustryIdUserIdAddedByIdKey = 'user_industry_industry_id_user_id_added_by_id_key',
  /** unique or primary key constraint on columns "id" */
  UserIndustryPkey = 'user_industry_pkey'
}

/** input type for incrementing numeric columns in table "user_industry" */
export type User_Industry_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  industry_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_industry" */
export type User_Industry_Insert_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  industry?: Maybe<Industry_Obj_Rel_Insert_Input>;
  industry_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Profile_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  user_profile?: Maybe<User_Profile_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Industry_Max_Fields = {
  __typename?: 'user_industry_max_fields';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  industry_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_industry" */
export type User_Industry_Max_Order_By = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Industry_Min_Fields = {
  __typename?: 'user_industry_min_fields';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  industry_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_industry" */
export type User_Industry_Min_Order_By = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_industry" */
export type User_Industry_Mutation_Response = {
  __typename?: 'user_industry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Industry>;
};

/** on_conflict condition type for table "user_industry" */
export type User_Industry_On_Conflict = {
  constraint: User_Industry_Constraint;
  update_columns?: Array<User_Industry_Update_Column>;
  where?: Maybe<User_Industry_Bool_Exp>;
};

/** Ordering options when selecting data from "user_industry". */
export type User_Industry_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  industry?: Maybe<Industry_Order_By>;
  industry_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Profile_Order_By>;
  user_id?: Maybe<Order_By>;
  user_profile?: Maybe<User_Profile_Order_By>;
};

/** primary key columns input for table: user_industry */
export type User_Industry_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_industry" */
export enum User_Industry_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndustryId = 'industry_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_industry" */
export type User_Industry_Set_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  industry_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Industry_Stddev_Fields = {
  __typename?: 'user_industry_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_industry" */
export type User_Industry_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Industry_Stddev_Pop_Fields = {
  __typename?: 'user_industry_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_industry" */
export type User_Industry_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Industry_Stddev_Samp_Fields = {
  __typename?: 'user_industry_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_industry" */
export type User_Industry_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_industry" */
export type User_Industry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Industry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Industry_Stream_Cursor_Value_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  industry_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Industry_Sum_Fields = {
  __typename?: 'user_industry_sum_fields';
  id?: Maybe<Scalars['Int']>;
  industry_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_industry" */
export type User_Industry_Sum_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** update columns of table "user_industry" */
export enum User_Industry_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IndustryId = 'industry_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Industry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Industry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Industry_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Industry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Industry_Var_Pop_Fields = {
  __typename?: 'user_industry_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_industry" */
export type User_Industry_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Industry_Var_Samp_Fields = {
  __typename?: 'user_industry_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_industry" */
export type User_Industry_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Industry_Variance_Fields = {
  __typename?: 'user_industry_variance_fields';
  id?: Maybe<Scalars['Float']>;
  industry_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_industry" */
export type User_Industry_Variance_Order_By = {
  id?: Maybe<Order_By>;
  industry_id?: Maybe<Order_By>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  admin?: Maybe<Admin_Obj_Rel_Insert_Input>;
  applications?: Maybe<Application_Arr_Rel_Insert_Input>;
  applicationsByInterviewedBy?: Maybe<Application_Arr_Rel_Insert_Input>;
  archived?: Maybe<Scalars['Boolean']>;
  attached_documents?: Maybe<Document_User_Arr_Rel_Insert_Input>;
  available?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  candidates?: Maybe<Candidate_Arr_Rel_Insert_Input>;
  certifications?: Maybe<User_Certification_Arr_Rel_Insert_Input>;
  companies?: Maybe<User_Company_Arr_Rel_Insert_Input>;
  companiesByCreatedBy?: Maybe<Company_Arr_Rel_Insert_Input>;
  company_followers?: Maybe<Company_Follower_Arr_Rel_Insert_Input>;
  company_notifications?: Maybe<Company_User_Notifications_Arr_Rel_Insert_Input>;
  confirmed?: Maybe<Scalars['Boolean']>;
  consent_at?: Maybe<Scalars['timestamp']>;
  consent_given?: Maybe<Scalars['Boolean']>;
  contractor_notes?: Maybe<Contractor_Note_Arr_Rel_Insert_Input>;
  contractor_ratings?: Maybe<Contractor_Rating_Arr_Rel_Insert_Input>;
  contracts?: Maybe<Contractor_Arr_Rel_Insert_Input>;
  conversations?: Maybe<User_Conversation_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  customRequestsByUpdatedById?: Maybe<Custom_Request_Arr_Rel_Insert_Input>;
  custom_requests?: Maybe<Custom_Request_Arr_Rel_Insert_Input>;
  declined_visit_matches?: Maybe<Declined_Visit_Matches_Arr_Rel_Insert_Input>;
  document_custom_requests?: Maybe<Document_Custom_Request_Arr_Rel_Insert_Input>;
  documents?: Maybe<Document_Arr_Rel_Insert_Input>;
  educations?: Maybe<User_Education_Arr_Rel_Insert_Input>;
  email?: Maybe<Scalars['String']>;
  emergency_contact?: Maybe<Scalars['jsonb']>;
  experiences?: Maybe<User_Experience_Arr_Rel_Insert_Input>;
  family_name?: Maybe<Scalars['String']>;
  favorited_by_users?: Maybe<User_Favorite_Arr_Rel_Insert_Input>;
  favorited_users?: Maybe<User_Favorite_Arr_Rel_Insert_Input>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invitations?: Maybe<Invitation_Arr_Rel_Insert_Input>;
  invitationsByInvitedBy?: Maybe<Invitation_Arr_Rel_Insert_Input>;
  invited_by?: Maybe<User_Obj_Rel_Insert_Input>;
  invoices?: Maybe<Invoice_Arr_Rel_Insert_Input>;
  is_public?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Manager_Obj_Rel_Insert_Input>;
  manager_contractors?: Maybe<Manager_Contractor_Arr_Rel_Insert_Input>;
  marketplace?: Maybe<Scalars['Boolean']>;
  messages?: Maybe<Message_Arr_Rel_Insert_Input>;
  onboardings?: Maybe<Onboarding_Arr_Rel_Insert_Input>;
  payment_cards?: Maybe<Payment_Card_Arr_Rel_Insert_Input>;
  pending?: Maybe<Scalars['Boolean']>;
  pending_invite?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['bigint']>;
  private_data?: Maybe<User_Private_Data_Obj_Rel_Insert_Input>;
  profile?: Maybe<User_Profile_Obj_Rel_Insert_Input>;
  profile_completed?: Maybe<Scalars['Boolean']>;
  projectActivityRequestMoreHoursByActorId?: Maybe<Project_Activity_Request_More_Hours_Arr_Rel_Insert_Input>;
  project_activities?: Maybe<Project_Activity_Arr_Rel_Insert_Input>;
  project_activity_request_more_hours?: Maybe<Project_Activity_Request_More_Hours_Arr_Rel_Insert_Input>;
  rated_by_users?: Maybe<User_Rating_Arr_Rel_Insert_Input>;
  rated_users?: Maybe<User_Rating_Arr_Rel_Insert_Input>;
  recipient_messages?: Maybe<Recipient_Message_Arr_Rel_Insert_Input>;
  resource_information_cards?: Maybe<Resource_Information_Card_Arr_Rel_Insert_Input>;
  role?: Maybe<Scalars['String']>;
  skills?: Maybe<Skill_Arr_Rel_Insert_Input>;
  smart_match_bookmarks?: Maybe<Smart_Match_Bookmark_Arr_Rel_Insert_Input>;
  soft_skills?: Maybe<Soft_Skill_Arr_Rel_Insert_Input>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  subscription_required?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userProfileByManagementsByAddedById?: Maybe<User_Profile_By_Management_Arr_Rel_Insert_Input>;
  user_experiences?: Maybe<User_Experience_Arr_Rel_Insert_Input>;
  user_job_titles?: Maybe<User_Job_Title_Arr_Rel_Insert_Input>;
  user_profile_by_managements?: Maybe<User_Profile_By_Management_Arr_Rel_Insert_Input>;
  user_skills?: Maybe<User_Skill_Arr_Rel_Insert_Input>;
  user_soft_skills?: Maybe<User_Soft_Skill_Arr_Rel_Insert_Input>;
  user_transportations?: Maybe<User_Transportation_Arr_Rel_Insert_Input>;
  watched_by_users?: Maybe<User_Watchlist_Arr_Rel_Insert_Input>;
  watched_users?: Maybe<User_Watchlist_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "user_job_title" */
export type User_Job_Title = {
  __typename?: 'user_job_title';
  added_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  company?: Maybe<Company>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['Int'];
  job_title: Scalars['String'];
  /** An object relationship */
  user?: Maybe<User>;
  /** An array relationship */
  user_profiles: Array<User_Profile>;
  /** An aggregate relationship */
  user_profiles_aggregate: User_Profile_Aggregate;
};


/** columns and relationships of "user_job_title" */
export type User_Job_TitleUser_ProfilesArgs = {
  distinct_on?: Maybe<Array<User_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_Order_By>>;
  where?: Maybe<User_Profile_Bool_Exp>;
};


/** columns and relationships of "user_job_title" */
export type User_Job_TitleUser_Profiles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Profile_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Profile_Order_By>>;
  where?: Maybe<User_Profile_Bool_Exp>;
};

/** aggregated selection of "user_job_title" */
export type User_Job_Title_Aggregate = {
  __typename?: 'user_job_title_aggregate';
  aggregate?: Maybe<User_Job_Title_Aggregate_Fields>;
  nodes: Array<User_Job_Title>;
};

export type User_Job_Title_Aggregate_Bool_Exp = {
  count?: Maybe<User_Job_Title_Aggregate_Bool_Exp_Count>;
};

export type User_Job_Title_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Job_Title_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Job_Title_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_job_title" */
export type User_Job_Title_Aggregate_Fields = {
  __typename?: 'user_job_title_aggregate_fields';
  avg?: Maybe<User_Job_Title_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Job_Title_Max_Fields>;
  min?: Maybe<User_Job_Title_Min_Fields>;
  stddev?: Maybe<User_Job_Title_Stddev_Fields>;
  stddev_pop?: Maybe<User_Job_Title_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Job_Title_Stddev_Samp_Fields>;
  sum?: Maybe<User_Job_Title_Sum_Fields>;
  var_pop?: Maybe<User_Job_Title_Var_Pop_Fields>;
  var_samp?: Maybe<User_Job_Title_Var_Samp_Fields>;
  variance?: Maybe<User_Job_Title_Variance_Fields>;
};


/** aggregate fields of "user_job_title" */
export type User_Job_Title_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Job_Title_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_job_title" */
export type User_Job_Title_Aggregate_Order_By = {
  avg?: Maybe<User_Job_Title_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Job_Title_Max_Order_By>;
  min?: Maybe<User_Job_Title_Min_Order_By>;
  stddev?: Maybe<User_Job_Title_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Job_Title_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Job_Title_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Job_Title_Sum_Order_By>;
  var_pop?: Maybe<User_Job_Title_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Job_Title_Var_Samp_Order_By>;
  variance?: Maybe<User_Job_Title_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_job_title" */
export type User_Job_Title_Arr_Rel_Insert_Input = {
  data: Array<User_Job_Title_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Job_Title_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Job_Title_Avg_Fields = {
  __typename?: 'user_job_title_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_job_title" */
export type User_Job_Title_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_job_title". All fields are combined with a logical 'AND'. */
export type User_Job_Title_Bool_Exp = {
  _and?: Maybe<Array<User_Job_Title_Bool_Exp>>;
  _not?: Maybe<User_Job_Title_Bool_Exp>;
  _or?: Maybe<Array<User_Job_Title_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  company?: Maybe<Company_Bool_Exp>;
  company_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamp_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  job_title?: Maybe<String_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_profiles?: Maybe<User_Profile_Bool_Exp>;
  user_profiles_aggregate?: Maybe<User_Profile_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user_job_title" */
export enum User_Job_Title_Constraint {
  /** unique or primary key constraint on columns "id", "job_title" */
  UserJobTitleIdJobTitleKey = 'user_job_title_id_job_title_key',
  /** unique or primary key constraint on columns "id" */
  UserJobTitlePkey = 'user_job_title_pkey'
}

/** input type for incrementing numeric columns in table "user_job_title" */
export type User_Job_Title_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_job_title" */
export type User_Job_Title_Insert_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  company?: Maybe<Company_Obj_Rel_Insert_Input>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_profiles?: Maybe<User_Profile_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Job_Title_Max_Fields = {
  __typename?: 'user_job_title_max_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_job_title" */
export type User_Job_Title_Max_Order_By = {
  added_by_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Job_Title_Min_Fields = {
  __typename?: 'user_job_title_min_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_job_title" */
export type User_Job_Title_Min_Order_By = {
  added_by_id?: Maybe<Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_job_title" */
export type User_Job_Title_Mutation_Response = {
  __typename?: 'user_job_title_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Job_Title>;
};

/** input type for inserting object relation for remote table "user_job_title" */
export type User_Job_Title_Obj_Rel_Insert_Input = {
  data: User_Job_Title_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Job_Title_On_Conflict>;
};

/** on_conflict condition type for table "user_job_title" */
export type User_Job_Title_On_Conflict = {
  constraint: User_Job_Title_Constraint;
  update_columns?: Array<User_Job_Title_Update_Column>;
  where?: Maybe<User_Job_Title_Bool_Exp>;
};

/** Ordering options when selecting data from "user_job_title". */
export type User_Job_Title_Order_By = {
  added_by_id?: Maybe<Order_By>;
  company?: Maybe<Company_Order_By>;
  company_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_profiles_aggregate?: Maybe<User_Profile_Aggregate_Order_By>;
};

/** primary key columns input for table: user_job_title */
export type User_Job_Title_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_job_title" */
export enum User_Job_Title_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'job_title'
}

/** input type for updating data in table "user_job_title" */
export type User_Job_Title_Set_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Job_Title_Stddev_Fields = {
  __typename?: 'user_job_title_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_job_title" */
export type User_Job_Title_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Job_Title_Stddev_Pop_Fields = {
  __typename?: 'user_job_title_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_job_title" */
export type User_Job_Title_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Job_Title_Stddev_Samp_Fields = {
  __typename?: 'user_job_title_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_job_title" */
export type User_Job_Title_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_job_title" */
export type User_Job_Title_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Job_Title_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Job_Title_Stream_Cursor_Value_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  company_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['Int']>;
  job_title?: Maybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type User_Job_Title_Sum_Fields = {
  __typename?: 'user_job_title_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_job_title" */
export type User_Job_Title_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "user_job_title" */
export enum User_Job_Title_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'job_title'
}

export type User_Job_Title_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Job_Title_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Job_Title_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Job_Title_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Job_Title_Var_Pop_Fields = {
  __typename?: 'user_job_title_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_job_title" */
export type User_Job_Title_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Job_Title_Var_Samp_Fields = {
  __typename?: 'user_job_title_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_job_title" */
export type User_Job_Title_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Job_Title_Variance_Fields = {
  __typename?: 'user_job_title_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_job_title" */
export type User_Job_Title_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "user_language" */
export type User_Language = {
  __typename?: 'user_language';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  language: Language;
  language_id: Scalars['Int'];
  proficiency_level: Scalars['Int'];
  /** An object relationship */
  user: User_Profile;
  user_id: Scalars['uuid'];
  /** An object relationship */
  user_profile?: Maybe<User_Profile>;
};

/** aggregated selection of "user_language" */
export type User_Language_Aggregate = {
  __typename?: 'user_language_aggregate';
  aggregate?: Maybe<User_Language_Aggregate_Fields>;
  nodes: Array<User_Language>;
};

export type User_Language_Aggregate_Bool_Exp = {
  count?: Maybe<User_Language_Aggregate_Bool_Exp_Count>;
};

export type User_Language_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Language_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Language_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_language" */
export type User_Language_Aggregate_Fields = {
  __typename?: 'user_language_aggregate_fields';
  avg?: Maybe<User_Language_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Language_Max_Fields>;
  min?: Maybe<User_Language_Min_Fields>;
  stddev?: Maybe<User_Language_Stddev_Fields>;
  stddev_pop?: Maybe<User_Language_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Language_Stddev_Samp_Fields>;
  sum?: Maybe<User_Language_Sum_Fields>;
  var_pop?: Maybe<User_Language_Var_Pop_Fields>;
  var_samp?: Maybe<User_Language_Var_Samp_Fields>;
  variance?: Maybe<User_Language_Variance_Fields>;
};


/** aggregate fields of "user_language" */
export type User_Language_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Language_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_language" */
export type User_Language_Aggregate_Order_By = {
  avg?: Maybe<User_Language_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Language_Max_Order_By>;
  min?: Maybe<User_Language_Min_Order_By>;
  stddev?: Maybe<User_Language_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Language_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Language_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Language_Sum_Order_By>;
  var_pop?: Maybe<User_Language_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Language_Var_Samp_Order_By>;
  variance?: Maybe<User_Language_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_language" */
export type User_Language_Arr_Rel_Insert_Input = {
  data: Array<User_Language_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Language_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Language_Avg_Fields = {
  __typename?: 'user_language_avg_fields';
  language_id?: Maybe<Scalars['Float']>;
  proficiency_level?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_language" */
export type User_Language_Avg_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_language". All fields are combined with a logical 'AND'. */
export type User_Language_Bool_Exp = {
  _and?: Maybe<Array<User_Language_Bool_Exp>>;
  _not?: Maybe<User_Language_Bool_Exp>;
  _or?: Maybe<Array<User_Language_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  language?: Maybe<Language_Bool_Exp>;
  language_id?: Maybe<Int_Comparison_Exp>;
  proficiency_level?: Maybe<Int_Comparison_Exp>;
  user?: Maybe<User_Profile_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  user_profile?: Maybe<User_Profile_Bool_Exp>;
};

/** unique or primary key constraints on table "user_language" */
export enum User_Language_Constraint {
  /** unique or primary key constraint on columns "user_id", "added_by_id", "language_id" */
  UserLanguageUserIdLanguageIdAddedByIdKey = 'user_language_user_id_language_id_added_by_id_key',
  /** unique or primary key constraint on columns "id" */
  UserLanguagesPkey = 'user_languages_pkey'
}

/** input type for incrementing numeric columns in table "user_language" */
export type User_Language_Inc_Input = {
  language_id?: Maybe<Scalars['Int']>;
  proficiency_level?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_language" */
export type User_Language_Insert_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  language?: Maybe<Language_Obj_Rel_Insert_Input>;
  language_id?: Maybe<Scalars['Int']>;
  proficiency_level?: Maybe<Scalars['Int']>;
  user?: Maybe<User_Profile_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  user_profile?: Maybe<User_Profile_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Language_Max_Fields = {
  __typename?: 'user_language_max_fields';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  language_id?: Maybe<Scalars['Int']>;
  proficiency_level?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_language" */
export type User_Language_Max_Order_By = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Language_Min_Fields = {
  __typename?: 'user_language_min_fields';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  language_id?: Maybe<Scalars['Int']>;
  proficiency_level?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_language" */
export type User_Language_Min_Order_By = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_language" */
export type User_Language_Mutation_Response = {
  __typename?: 'user_language_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Language>;
};

/** on_conflict condition type for table "user_language" */
export type User_Language_On_Conflict = {
  constraint: User_Language_Constraint;
  update_columns?: Array<User_Language_Update_Column>;
  where?: Maybe<User_Language_Bool_Exp>;
};

/** Ordering options when selecting data from "user_language". */
export type User_Language_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  language?: Maybe<Language_Order_By>;
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
  user?: Maybe<User_Profile_Order_By>;
  user_id?: Maybe<Order_By>;
  user_profile?: Maybe<User_Profile_Order_By>;
};

/** primary key columns input for table: user_language */
export type User_Language_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_language" */
export enum User_Language_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProficiencyLevel = 'proficiency_level',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_language" */
export type User_Language_Set_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  language_id?: Maybe<Scalars['Int']>;
  proficiency_level?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Language_Stddev_Fields = {
  __typename?: 'user_language_stddev_fields';
  language_id?: Maybe<Scalars['Float']>;
  proficiency_level?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_language" */
export type User_Language_Stddev_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Language_Stddev_Pop_Fields = {
  __typename?: 'user_language_stddev_pop_fields';
  language_id?: Maybe<Scalars['Float']>;
  proficiency_level?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_language" */
export type User_Language_Stddev_Pop_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Language_Stddev_Samp_Fields = {
  __typename?: 'user_language_stddev_samp_fields';
  language_id?: Maybe<Scalars['Float']>;
  proficiency_level?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_language" */
export type User_Language_Stddev_Samp_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_language" */
export type User_Language_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Language_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Language_Stream_Cursor_Value_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  language_id?: Maybe<Scalars['Int']>;
  proficiency_level?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Language_Sum_Fields = {
  __typename?: 'user_language_sum_fields';
  language_id?: Maybe<Scalars['Int']>;
  proficiency_level?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_language" */
export type User_Language_Sum_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** update columns of table "user_language" */
export enum User_Language_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LanguageId = 'language_id',
  /** column name */
  ProficiencyLevel = 'proficiency_level',
  /** column name */
  UserId = 'user_id'
}

export type User_Language_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Language_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Language_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Language_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Language_Var_Pop_Fields = {
  __typename?: 'user_language_var_pop_fields';
  language_id?: Maybe<Scalars['Float']>;
  proficiency_level?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_language" */
export type User_Language_Var_Pop_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Language_Var_Samp_Fields = {
  __typename?: 'user_language_var_samp_fields';
  language_id?: Maybe<Scalars['Float']>;
  proficiency_level?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_language" */
export type User_Language_Var_Samp_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Language_Variance_Fields = {
  __typename?: 'user_language_variance_fields';
  language_id?: Maybe<Scalars['Float']>;
  proficiency_level?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_language" */
export type User_Language_Variance_Order_By = {
  language_id?: Maybe<Order_By>;
  proficiency_level?: Maybe<Order_By>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  avatar?: Maybe<Scalars['String']>;
  consent_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['bigint']>;
  role?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  avatar?: Maybe<Scalars['String']>;
  consent_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['bigint']>;
  role?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: Maybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  admin?: Maybe<Admin_Order_By>;
  applicationsByInterviewedBy_aggregate?: Maybe<Application_Aggregate_Order_By>;
  applications_aggregate?: Maybe<Application_Aggregate_Order_By>;
  archived?: Maybe<Order_By>;
  attached_documents_aggregate?: Maybe<Document_User_Aggregate_Order_By>;
  available?: Maybe<Order_By>;
  avatar?: Maybe<Order_By>;
  candidates_aggregate?: Maybe<Candidate_Aggregate_Order_By>;
  certifications_aggregate?: Maybe<User_Certification_Aggregate_Order_By>;
  companiesByCreatedBy_aggregate?: Maybe<Company_Aggregate_Order_By>;
  companies_aggregate?: Maybe<User_Company_Aggregate_Order_By>;
  company_followers_aggregate?: Maybe<Company_Follower_Aggregate_Order_By>;
  company_notifications_aggregate?: Maybe<Company_User_Notifications_Aggregate_Order_By>;
  confirmed?: Maybe<Order_By>;
  consent_at?: Maybe<Order_By>;
  consent_given?: Maybe<Order_By>;
  contractor_notes_aggregate?: Maybe<Contractor_Note_Aggregate_Order_By>;
  contractor_ratings_aggregate?: Maybe<Contractor_Rating_Aggregate_Order_By>;
  contracts_aggregate?: Maybe<Contractor_Aggregate_Order_By>;
  conversations_aggregate?: Maybe<User_Conversation_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by?: Maybe<Order_By>;
  customRequestsByUpdatedById_aggregate?: Maybe<Custom_Request_Aggregate_Order_By>;
  custom_requests_aggregate?: Maybe<Custom_Request_Aggregate_Order_By>;
  declined_visit_matches_aggregate?: Maybe<Declined_Visit_Matches_Aggregate_Order_By>;
  document_custom_requests_aggregate?: Maybe<Document_Custom_Request_Aggregate_Order_By>;
  documents_aggregate?: Maybe<Document_Aggregate_Order_By>;
  educations_aggregate?: Maybe<User_Education_Aggregate_Order_By>;
  email?: Maybe<Order_By>;
  emergency_contact?: Maybe<Order_By>;
  experiences_aggregate?: Maybe<User_Experience_Aggregate_Order_By>;
  family_name?: Maybe<Order_By>;
  favorited_by_users_aggregate?: Maybe<User_Favorite_Aggregate_Order_By>;
  favorited_users_aggregate?: Maybe<User_Favorite_Aggregate_Order_By>;
  given_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  invitationsByInvitedBy_aggregate?: Maybe<Invitation_Aggregate_Order_By>;
  invitations_aggregate?: Maybe<Invitation_Aggregate_Order_By>;
  invited_by?: Maybe<User_Order_By>;
  invoices_aggregate?: Maybe<Invoice_Aggregate_Order_By>;
  is_public?: Maybe<Order_By>;
  manager?: Maybe<Manager_Order_By>;
  manager_contractors_aggregate?: Maybe<Manager_Contractor_Aggregate_Order_By>;
  marketplace?: Maybe<Order_By>;
  messages_aggregate?: Maybe<Message_Aggregate_Order_By>;
  onboardings_aggregate?: Maybe<Onboarding_Aggregate_Order_By>;
  payment_cards_aggregate?: Maybe<Payment_Card_Aggregate_Order_By>;
  pending?: Maybe<Order_By>;
  pending_invite?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  private_data?: Maybe<User_Private_Data_Order_By>;
  profile?: Maybe<User_Profile_Order_By>;
  profile_completed?: Maybe<Order_By>;
  projectActivityRequestMoreHoursByActorId_aggregate?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Order_By>;
  project_activities_aggregate?: Maybe<Project_Activity_Aggregate_Order_By>;
  project_activity_request_more_hours_aggregate?: Maybe<Project_Activity_Request_More_Hours_Aggregate_Order_By>;
  rated_by_users_aggregate?: Maybe<User_Rating_Aggregate_Order_By>;
  rated_users_aggregate?: Maybe<User_Rating_Aggregate_Order_By>;
  recipient_messages_aggregate?: Maybe<Recipient_Message_Aggregate_Order_By>;
  resource_information_cards_aggregate?: Maybe<Resource_Information_Card_Aggregate_Order_By>;
  role?: Maybe<Order_By>;
  skills_aggregate?: Maybe<Skill_Aggregate_Order_By>;
  smart_match_bookmarks_aggregate?: Maybe<Smart_Match_Bookmark_Aggregate_Order_By>;
  soft_skills_aggregate?: Maybe<Soft_Skill_Aggregate_Order_By>;
  stripe_customer_id?: Maybe<Order_By>;
  subscription_required?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  userProfileByManagementsByAddedById_aggregate?: Maybe<User_Profile_By_Management_Aggregate_Order_By>;
  user_experiences_aggregate?: Maybe<User_Experience_Aggregate_Order_By>;
  user_job_titles_aggregate?: Maybe<User_Job_Title_Aggregate_Order_By>;
  user_profile_by_managements_aggregate?: Maybe<User_Profile_By_Management_Aggregate_Order_By>;
  user_skills_aggregate?: Maybe<User_Skill_Aggregate_Order_By>;
  user_soft_skills_aggregate?: Maybe<User_Soft_Skill_Aggregate_Order_By>;
  user_transportations_aggregate?: Maybe<User_Transportation_Aggregate_Order_By>;
  watched_by_users_aggregate?: Maybe<User_Watchlist_Aggregate_Order_By>;
  watched_users_aggregate?: Maybe<User_Watchlist_Aggregate_Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  emergency_contact?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "user_private_data" */
export type User_Private_Data = {
  __typename?: 'user_private_data';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "user_private_data" */
export type User_Private_Data_Aggregate = {
  __typename?: 'user_private_data_aggregate';
  aggregate?: Maybe<User_Private_Data_Aggregate_Fields>;
  nodes: Array<User_Private_Data>;
};

/** aggregate fields of "user_private_data" */
export type User_Private_Data_Aggregate_Fields = {
  __typename?: 'user_private_data_aggregate_fields';
  avg?: Maybe<User_Private_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Private_Data_Max_Fields>;
  min?: Maybe<User_Private_Data_Min_Fields>;
  stddev?: Maybe<User_Private_Data_Stddev_Fields>;
  stddev_pop?: Maybe<User_Private_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Private_Data_Stddev_Samp_Fields>;
  sum?: Maybe<User_Private_Data_Sum_Fields>;
  var_pop?: Maybe<User_Private_Data_Var_Pop_Fields>;
  var_samp?: Maybe<User_Private_Data_Var_Samp_Fields>;
  variance?: Maybe<User_Private_Data_Variance_Fields>;
};


/** aggregate fields of "user_private_data" */
export type User_Private_Data_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Private_Data_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Private_Data_Avg_Fields = {
  __typename?: 'user_private_data_avg_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_private_data". All fields are combined with a logical 'AND'. */
export type User_Private_Data_Bool_Exp = {
  _and?: Maybe<Array<User_Private_Data_Bool_Exp>>;
  _not?: Maybe<User_Private_Data_Bool_Exp>;
  _or?: Maybe<Array<User_Private_Data_Bool_Exp>>;
  email?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<Bigint_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "user_private_data" */
export type User_Private_Data_Inc_Input = {
  phone?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_private_data" */
export type User_Private_Data_Insert_Input = {
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Private_Data_Max_Fields = {
  __typename?: 'user_private_data_max_fields';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Private_Data_Min_Fields = {
  __typename?: 'user_private_data_min_fields';
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_private_data" */
export type User_Private_Data_Mutation_Response = {
  __typename?: 'user_private_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Private_Data>;
};

/** input type for inserting object relation for remote table "user_private_data" */
export type User_Private_Data_Obj_Rel_Insert_Input = {
  data: User_Private_Data_Insert_Input;
};

/** Ordering options when selecting data from "user_private_data". */
export type User_Private_Data_Order_By = {
  email?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** select columns of table "user_private_data" */
export enum User_Private_Data_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Phone = 'phone',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_private_data" */
export type User_Private_Data_Set_Input = {
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Private_Data_Stddev_Fields = {
  __typename?: 'user_private_data_stddev_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Private_Data_Stddev_Pop_Fields = {
  __typename?: 'user_private_data_stddev_pop_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Private_Data_Stddev_Samp_Fields = {
  __typename?: 'user_private_data_stddev_samp_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_private_data" */
export type User_Private_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Private_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Private_Data_Stream_Cursor_Value_Input = {
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Private_Data_Sum_Fields = {
  __typename?: 'user_private_data_sum_fields';
  phone?: Maybe<Scalars['bigint']>;
};

export type User_Private_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Private_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Private_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Private_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Private_Data_Var_Pop_Fields = {
  __typename?: 'user_private_data_var_pop_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Private_Data_Var_Samp_Fields = {
  __typename?: 'user_private_data_var_samp_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Private_Data_Variance_Fields = {
  __typename?: 'user_private_data_variance_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_profile" */
export type User_Profile = {
  __typename?: 'user_profile';
  DNU_flag: Scalars['Boolean'];
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  /** An array relationship */
  industries: Array<User_Industry>;
  /** An aggregate relationship */
  industries_aggregate: User_Industry_Aggregate;
  job_title?: Maybe<Scalars['String']>;
  /** An array relationship */
  languages: Array<User_Language>;
  /** An aggregate relationship */
  languages_aggregate: User_Language_Aggregate;
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  /** An array relationship */
  skills: Array<User_Skill>;
  /** An aggregate relationship */
  skills_aggregate: User_Skill_Aggregate;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  /** An array relationship */
  transportation: Array<User_Transportation>;
  /** An aggregate relationship */
  transportation_aggregate: User_Transportation_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid'];
  /** An array relationship */
  user_industries: Array<User_Industry>;
  /** An aggregate relationship */
  user_industries_aggregate: User_Industry_Aggregate;
  user_job_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user_job_title?: Maybe<User_Job_Title>;
  /** An array relationship */
  user_languages: Array<User_Language>;
  /** An aggregate relationship */
  user_languages_aggregate: User_Language_Aggregate;
  /** An array relationship */
  user_soft_skills: Array<User_Soft_Skill>;
  /** An aggregate relationship */
  user_soft_skills_aggregate: User_Soft_Skill_Aggregate;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileIndustriesArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileIndustries_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileLanguagesArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileLanguages_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileSkillsArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileSkills_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Skill_Order_By>>;
  where?: Maybe<User_Skill_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileTransportationArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileTransportation_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Transportation_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Transportation_Order_By>>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileUser_IndustriesArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileUser_Industries_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Industry_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Industry_Order_By>>;
  where?: Maybe<User_Industry_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileUser_LanguagesArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileUser_Languages_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Language_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Language_Order_By>>;
  where?: Maybe<User_Language_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileUser_Soft_SkillsArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};


/** columns and relationships of "user_profile" */
export type User_ProfileUser_Soft_Skills_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Soft_Skill_Order_By>>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};

/** aggregated selection of "user_profile" */
export type User_Profile_Aggregate = {
  __typename?: 'user_profile_aggregate';
  aggregate?: Maybe<User_Profile_Aggregate_Fields>;
  nodes: Array<User_Profile>;
};

export type User_Profile_Aggregate_Bool_Exp = {
  bool_and?: Maybe<User_Profile_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<User_Profile_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<User_Profile_Aggregate_Bool_Exp_Count>;
};

export type User_Profile_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Profile_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Profile_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_profile" */
export type User_Profile_Aggregate_Fields = {
  __typename?: 'user_profile_aggregate_fields';
  avg?: Maybe<User_Profile_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Profile_Max_Fields>;
  min?: Maybe<User_Profile_Min_Fields>;
  stddev?: Maybe<User_Profile_Stddev_Fields>;
  stddev_pop?: Maybe<User_Profile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Profile_Stddev_Samp_Fields>;
  sum?: Maybe<User_Profile_Sum_Fields>;
  var_pop?: Maybe<User_Profile_Var_Pop_Fields>;
  var_samp?: Maybe<User_Profile_Var_Samp_Fields>;
  variance?: Maybe<User_Profile_Variance_Fields>;
};


/** aggregate fields of "user_profile" */
export type User_Profile_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Profile_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_profile" */
export type User_Profile_Aggregate_Order_By = {
  avg?: Maybe<User_Profile_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Profile_Max_Order_By>;
  min?: Maybe<User_Profile_Min_Order_By>;
  stddev?: Maybe<User_Profile_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Profile_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Profile_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Profile_Sum_Order_By>;
  var_pop?: Maybe<User_Profile_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Profile_Var_Samp_Order_By>;
  variance?: Maybe<User_Profile_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_profile" */
export type User_Profile_Arr_Rel_Insert_Input = {
  data: Array<User_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Profile_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Profile_Avg_Fields = {
  __typename?: 'user_profile_avg_fields';
  max_available_hours?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  user_job_id?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_profile" */
export type User_Profile_Avg_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_profile". All fields are combined with a logical 'AND'. */
export type User_Profile_Bool_Exp = {
  DNU_flag?: Maybe<Boolean_Comparison_Exp>;
  _and?: Maybe<Array<User_Profile_Bool_Exp>>;
  _not?: Maybe<User_Profile_Bool_Exp>;
  _or?: Maybe<Array<User_Profile_Bool_Exp>>;
  about?: Maybe<String_Comparison_Exp>;
  address?: Maybe<String_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  company_name?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency?: Maybe<Currency_Comparison_Exp>;
  demo_reel?: Maybe<String_Comparison_Exp>;
  industries?: Maybe<User_Industry_Bool_Exp>;
  industries_aggregate?: Maybe<User_Industry_Aggregate_Bool_Exp>;
  job_title?: Maybe<String_Comparison_Exp>;
  languages?: Maybe<User_Language_Bool_Exp>;
  languages_aggregate?: Maybe<User_Language_Aggregate_Bool_Exp>;
  max_available_hours?: Maybe<Int_Comparison_Exp>;
  max_rate?: Maybe<Numeric_Comparison_Exp>;
  min_rate?: Maybe<Numeric_Comparison_Exp>;
  occupation?: Maybe<String_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  rate_unit?: Maybe<String_Comparison_Exp>;
  resume?: Maybe<String_Comparison_Exp>;
  skills?: Maybe<User_Skill_Bool_Exp>;
  skills_aggregate?: Maybe<User_Skill_Aggregate_Bool_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  summary?: Maybe<String_Comparison_Exp>;
  transportation?: Maybe<User_Transportation_Bool_Exp>;
  transportation_aggregate?: Maybe<User_Transportation_Aggregate_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  user_industries?: Maybe<User_Industry_Bool_Exp>;
  user_industries_aggregate?: Maybe<User_Industry_Aggregate_Bool_Exp>;
  user_job_id?: Maybe<Int_Comparison_Exp>;
  user_job_title?: Maybe<User_Job_Title_Bool_Exp>;
  user_languages?: Maybe<User_Language_Bool_Exp>;
  user_languages_aggregate?: Maybe<User_Language_Aggregate_Bool_Exp>;
  user_soft_skills?: Maybe<User_Soft_Skill_Bool_Exp>;
  user_soft_skills_aggregate?: Maybe<User_Soft_Skill_Aggregate_Bool_Exp>;
  website?: Maybe<String_Comparison_Exp>;
  work_samples?: Maybe<String_Array_Comparison_Exp>;
  year_of_experience?: Maybe<Int_Comparison_Exp>;
};

/** Management's own version of contractor profile that contractor won't see */
export type User_Profile_By_Management = {
  __typename?: 'user_profile_by_management';
  about?: Maybe<Scalars['String']>;
  added_by_id: Scalars['uuid'];
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User;
  /** An object relationship */
  userByUserId: User;
  user_id: Scalars['uuid'];
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "user_profile_by_management" */
export type User_Profile_By_Management_Aggregate = {
  __typename?: 'user_profile_by_management_aggregate';
  aggregate?: Maybe<User_Profile_By_Management_Aggregate_Fields>;
  nodes: Array<User_Profile_By_Management>;
};

export type User_Profile_By_Management_Aggregate_Bool_Exp = {
  count?: Maybe<User_Profile_By_Management_Aggregate_Bool_Exp_Count>;
};

export type User_Profile_By_Management_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Profile_By_Management_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_profile_by_management" */
export type User_Profile_By_Management_Aggregate_Fields = {
  __typename?: 'user_profile_by_management_aggregate_fields';
  avg?: Maybe<User_Profile_By_Management_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Profile_By_Management_Max_Fields>;
  min?: Maybe<User_Profile_By_Management_Min_Fields>;
  stddev?: Maybe<User_Profile_By_Management_Stddev_Fields>;
  stddev_pop?: Maybe<User_Profile_By_Management_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Profile_By_Management_Stddev_Samp_Fields>;
  sum?: Maybe<User_Profile_By_Management_Sum_Fields>;
  var_pop?: Maybe<User_Profile_By_Management_Var_Pop_Fields>;
  var_samp?: Maybe<User_Profile_By_Management_Var_Samp_Fields>;
  variance?: Maybe<User_Profile_By_Management_Variance_Fields>;
};


/** aggregate fields of "user_profile_by_management" */
export type User_Profile_By_Management_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Profile_By_Management_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_profile_by_management" */
export type User_Profile_By_Management_Aggregate_Order_By = {
  avg?: Maybe<User_Profile_By_Management_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Profile_By_Management_Max_Order_By>;
  min?: Maybe<User_Profile_By_Management_Min_Order_By>;
  stddev?: Maybe<User_Profile_By_Management_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Profile_By_Management_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Profile_By_Management_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Profile_By_Management_Sum_Order_By>;
  var_pop?: Maybe<User_Profile_By_Management_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Profile_By_Management_Var_Samp_Order_By>;
  variance?: Maybe<User_Profile_By_Management_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_profile_by_management" */
export type User_Profile_By_Management_Arr_Rel_Insert_Input = {
  data: Array<User_Profile_By_Management_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Profile_By_Management_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Profile_By_Management_Avg_Fields = {
  __typename?: 'user_profile_by_management_avg_fields';
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Avg_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_profile_by_management". All fields are combined with a logical 'AND'. */
export type User_Profile_By_Management_Bool_Exp = {
  _and?: Maybe<Array<User_Profile_By_Management_Bool_Exp>>;
  _not?: Maybe<User_Profile_By_Management_Bool_Exp>;
  _or?: Maybe<Array<User_Profile_By_Management_Bool_Exp>>;
  about?: Maybe<String_Comparison_Exp>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  address?: Maybe<String_Comparison_Exp>;
  city?: Maybe<String_Comparison_Exp>;
  company_name?: Maybe<String_Comparison_Exp>;
  country?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency?: Maybe<Currency_Comparison_Exp>;
  demo_reel?: Maybe<String_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  job_title?: Maybe<String_Comparison_Exp>;
  max_rate?: Maybe<Numeric_Comparison_Exp>;
  min_rate?: Maybe<Numeric_Comparison_Exp>;
  occupation?: Maybe<String_Comparison_Exp>;
  phone?: Maybe<Bigint_Comparison_Exp>;
  postal_code?: Maybe<String_Comparison_Exp>;
  rate_unit?: Maybe<String_Comparison_Exp>;
  resume?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
  summary?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  userByUserId?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
  website?: Maybe<String_Comparison_Exp>;
  work_samples?: Maybe<String_Array_Comparison_Exp>;
  year_of_experience?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profile_by_management" */
export enum User_Profile_By_Management_Constraint {
  /** unique or primary key constraint on columns "user_id", "added_by_id" */
  UserProfileByManagementPkey = 'user_profile_by_management_pkey',
  /** unique or primary key constraint on columns "user_id", "added_by_id" */
  UserProfileByManagementUserIdAddedByIdKey = 'user_profile_by_management_user_id_added_by_id_key'
}

/** input type for incrementing numeric columns in table "user_profile_by_management" */
export type User_Profile_By_Management_Inc_Input = {
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['bigint']>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_profile_by_management" */
export type User_Profile_By_Management_Insert_Input = {
  about?: Maybe<Scalars['String']>;
  added_by_id?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  userByUserId?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Profile_By_Management_Max_Fields = {
  __typename?: 'user_profile_by_management_max_fields';
  about?: Maybe<Scalars['String']>;
  added_by_id?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Max_Order_By = {
  about?: Maybe<Order_By>;
  added_by_id?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  demo_reel?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  occupation?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  rate_unit?: Maybe<Order_By>;
  resume?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
  work_samples?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Profile_By_Management_Min_Fields = {
  __typename?: 'user_profile_by_management_min_fields';
  about?: Maybe<Scalars['String']>;
  added_by_id?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Min_Order_By = {
  about?: Maybe<Order_By>;
  added_by_id?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  demo_reel?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  occupation?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  rate_unit?: Maybe<Order_By>;
  resume?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
  work_samples?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_profile_by_management" */
export type User_Profile_By_Management_Mutation_Response = {
  __typename?: 'user_profile_by_management_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profile_By_Management>;
};

/** on_conflict condition type for table "user_profile_by_management" */
export type User_Profile_By_Management_On_Conflict = {
  constraint: User_Profile_By_Management_Constraint;
  update_columns?: Array<User_Profile_By_Management_Update_Column>;
  where?: Maybe<User_Profile_By_Management_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profile_by_management". */
export type User_Profile_By_Management_Order_By = {
  about?: Maybe<Order_By>;
  added_by_id?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  demo_reel?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  occupation?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  rate_unit?: Maybe<Order_By>;
  resume?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  userByUserId?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
  work_samples?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** primary key columns input for table: user_profile_by_management */
export type User_Profile_By_Management_Pk_Columns_Input = {
  added_by_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** select columns of table "user_profile_by_management" */
export enum User_Profile_By_Management_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DemoReel = 'demo_reel',
  /** column name */
  Email = 'email',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  RateUnit = 'rate_unit',
  /** column name */
  Resume = 'resume',
  /** column name */
  State = 'state',
  /** column name */
  Summary = 'summary',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Website = 'website',
  /** column name */
  WorkSamples = 'work_samples',
  /** column name */
  YearOfExperience = 'year_of_experience'
}

/** input type for updating data in table "user_profile_by_management" */
export type User_Profile_By_Management_Set_Input = {
  about?: Maybe<Scalars['String']>;
  added_by_id?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Profile_By_Management_Stddev_Fields = {
  __typename?: 'user_profile_by_management_stddev_fields';
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Stddev_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Profile_By_Management_Stddev_Pop_Fields = {
  __typename?: 'user_profile_by_management_stddev_pop_fields';
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Stddev_Pop_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Profile_By_Management_Stddev_Samp_Fields = {
  __typename?: 'user_profile_by_management_stddev_samp_fields';
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Stddev_Samp_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_profile_by_management" */
export type User_Profile_By_Management_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profile_By_Management_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profile_By_Management_Stream_Cursor_Value_Input = {
  about?: Maybe<Scalars['String']>;
  added_by_id?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['bigint']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Profile_By_Management_Sum_Fields = {
  __typename?: 'user_profile_by_management_sum_fields';
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['bigint']>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Sum_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** update columns of table "user_profile_by_management" */
export enum User_Profile_By_Management_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DemoReel = 'demo_reel',
  /** column name */
  Email = 'email',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  RateUnit = 'rate_unit',
  /** column name */
  Resume = 'resume',
  /** column name */
  State = 'state',
  /** column name */
  Summary = 'summary',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Website = 'website',
  /** column name */
  WorkSamples = 'work_samples',
  /** column name */
  YearOfExperience = 'year_of_experience'
}

export type User_Profile_By_Management_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Profile_By_Management_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Profile_By_Management_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profile_By_Management_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Profile_By_Management_Var_Pop_Fields = {
  __typename?: 'user_profile_by_management_var_pop_fields';
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Var_Pop_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Profile_By_Management_Var_Samp_Fields = {
  __typename?: 'user_profile_by_management_var_samp_fields';
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Var_Samp_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Profile_By_Management_Variance_Fields = {
  __typename?: 'user_profile_by_management_variance_fields';
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_profile_by_management" */
export type User_Profile_By_Management_Variance_Order_By = {
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  phone?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** unique or primary key constraints on table "user_profile" */
export enum User_Profile_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UserProfilePkey = 'user_profile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserProfileUserIdKey = 'user_profile_user_id_key'
}

/** input type for incrementing numeric columns in table "user_profile" */
export type User_Profile_Inc_Input = {
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  user_job_id?: Maybe<Scalars['Int']>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_profile" */
export type User_Profile_Insert_Input = {
  DNU_flag?: Maybe<Scalars['Boolean']>;
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  industries?: Maybe<User_Industry_Arr_Rel_Insert_Input>;
  job_title?: Maybe<Scalars['String']>;
  languages?: Maybe<User_Language_Arr_Rel_Insert_Input>;
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  skills?: Maybe<User_Skill_Arr_Rel_Insert_Input>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  transportation?: Maybe<User_Transportation_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
  user_industries?: Maybe<User_Industry_Arr_Rel_Insert_Input>;
  user_job_id?: Maybe<Scalars['Int']>;
  user_job_title?: Maybe<User_Job_Title_Obj_Rel_Insert_Input>;
  user_languages?: Maybe<User_Language_Arr_Rel_Insert_Input>;
  user_soft_skills?: Maybe<User_Soft_Skill_Arr_Rel_Insert_Input>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Profile_Max_Fields = {
  __typename?: 'user_profile_max_fields';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_job_id?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_profile" */
export type User_Profile_Max_Order_By = {
  about?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  demo_reel?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  occupation?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  rate_unit?: Maybe<Order_By>;
  resume?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
  work_samples?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Profile_Min_Fields = {
  __typename?: 'user_profile_min_fields';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_job_id?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_profile" */
export type User_Profile_Min_Order_By = {
  about?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  demo_reel?: Maybe<Order_By>;
  job_title?: Maybe<Order_By>;
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  occupation?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  rate_unit?: Maybe<Order_By>;
  resume?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  website?: Maybe<Order_By>;
  work_samples?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_profile" */
export type User_Profile_Mutation_Response = {
  __typename?: 'user_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profile>;
};

/** input type for inserting object relation for remote table "user_profile" */
export type User_Profile_Obj_Rel_Insert_Input = {
  data: User_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<User_Profile_On_Conflict>;
};

/** on_conflict condition type for table "user_profile" */
export type User_Profile_On_Conflict = {
  constraint: User_Profile_Constraint;
  update_columns?: Array<User_Profile_Update_Column>;
  where?: Maybe<User_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profile". */
export type User_Profile_Order_By = {
  DNU_flag?: Maybe<Order_By>;
  about?: Maybe<Order_By>;
  address?: Maybe<Order_By>;
  city?: Maybe<Order_By>;
  company_name?: Maybe<Order_By>;
  country?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Order_By>;
  demo_reel?: Maybe<Order_By>;
  industries_aggregate?: Maybe<User_Industry_Aggregate_Order_By>;
  job_title?: Maybe<Order_By>;
  languages_aggregate?: Maybe<User_Language_Aggregate_Order_By>;
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  occupation?: Maybe<Order_By>;
  postal_code?: Maybe<Order_By>;
  rate_unit?: Maybe<Order_By>;
  resume?: Maybe<Order_By>;
  skills_aggregate?: Maybe<User_Skill_Aggregate_Order_By>;
  state?: Maybe<Order_By>;
  summary?: Maybe<Order_By>;
  transportation_aggregate?: Maybe<User_Transportation_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
  user_industries_aggregate?: Maybe<User_Industry_Aggregate_Order_By>;
  user_job_id?: Maybe<Order_By>;
  user_job_title?: Maybe<User_Job_Title_Order_By>;
  user_languages_aggregate?: Maybe<User_Language_Aggregate_Order_By>;
  user_soft_skills_aggregate?: Maybe<User_Soft_Skill_Aggregate_Order_By>;
  website?: Maybe<Order_By>;
  work_samples?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** primary key columns input for table: user_profile */
export type User_Profile_Pk_Columns_Input = {
  user_id: Scalars['uuid'];
};

/** select columns of table "user_profile" */
export enum User_Profile_Select_Column {
  /** column name */
  DnuFlag = 'DNU_flag',
  /** column name */
  About = 'about',
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DemoReel = 'demo_reel',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  MaxAvailableHours = 'max_available_hours',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  RateUnit = 'rate_unit',
  /** column name */
  Resume = 'resume',
  /** column name */
  State = 'state',
  /** column name */
  Summary = 'summary',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserJobId = 'user_job_id',
  /** column name */
  Website = 'website',
  /** column name */
  WorkSamples = 'work_samples',
  /** column name */
  YearOfExperience = 'year_of_experience'
}

/** select "user_profile_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_profile" */
export enum User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DnuFlag = 'DNU_flag'
}

/** select "user_profile_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_profile" */
export enum User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DnuFlag = 'DNU_flag'
}

/** input type for updating data in table "user_profile" */
export type User_Profile_Set_Input = {
  DNU_flag?: Maybe<Scalars['Boolean']>;
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_job_id?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Profile_Stddev_Fields = {
  __typename?: 'user_profile_stddev_fields';
  max_available_hours?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  user_job_id?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_profile" */
export type User_Profile_Stddev_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Profile_Stddev_Pop_Fields = {
  __typename?: 'user_profile_stddev_pop_fields';
  max_available_hours?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  user_job_id?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_profile" */
export type User_Profile_Stddev_Pop_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Profile_Stddev_Samp_Fields = {
  __typename?: 'user_profile_stddev_samp_fields';
  max_available_hours?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  user_job_id?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_profile" */
export type User_Profile_Stddev_Samp_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_profile" */
export type User_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profile_Stream_Cursor_Value_Input = {
  DNU_flag?: Maybe<Scalars['Boolean']>;
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['currency']>;
  demo_reel?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  occupation?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  rate_unit?: Maybe<Scalars['String']>;
  resume?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  user_job_id?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
  work_samples?: Maybe<Array<Scalars['String']>>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Profile_Sum_Fields = {
  __typename?: 'user_profile_sum_fields';
  max_available_hours?: Maybe<Scalars['Int']>;
  max_rate?: Maybe<Scalars['numeric']>;
  min_rate?: Maybe<Scalars['numeric']>;
  user_job_id?: Maybe<Scalars['Int']>;
  year_of_experience?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_profile" */
export type User_Profile_Sum_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** update columns of table "user_profile" */
export enum User_Profile_Update_Column {
  /** column name */
  DnuFlag = 'DNU_flag',
  /** column name */
  About = 'about',
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DemoReel = 'demo_reel',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  MaxAvailableHours = 'max_available_hours',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  Occupation = 'occupation',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  RateUnit = 'rate_unit',
  /** column name */
  Resume = 'resume',
  /** column name */
  State = 'state',
  /** column name */
  Summary = 'summary',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserJobId = 'user_job_id',
  /** column name */
  Website = 'website',
  /** column name */
  WorkSamples = 'work_samples',
  /** column name */
  YearOfExperience = 'year_of_experience'
}

export type User_Profile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Profile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Profile_Var_Pop_Fields = {
  __typename?: 'user_profile_var_pop_fields';
  max_available_hours?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  user_job_id?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_profile" */
export type User_Profile_Var_Pop_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Profile_Var_Samp_Fields = {
  __typename?: 'user_profile_var_samp_fields';
  max_available_hours?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  user_job_id?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_profile" */
export type User_Profile_Var_Samp_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Profile_Variance_Fields = {
  __typename?: 'user_profile_variance_fields';
  max_available_hours?: Maybe<Scalars['Float']>;
  max_rate?: Maybe<Scalars['Float']>;
  min_rate?: Maybe<Scalars['Float']>;
  user_job_id?: Maybe<Scalars['Float']>;
  year_of_experience?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_profile" */
export type User_Profile_Variance_Order_By = {
  max_available_hours?: Maybe<Order_By>;
  max_rate?: Maybe<Order_By>;
  min_rate?: Maybe<Order_By>;
  user_job_id?: Maybe<Order_By>;
  year_of_experience?: Maybe<Order_By>;
};

/** columns and relationships of "user_rating" */
export type User_Rating = {
  __typename?: 'user_rating';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  rated_by_id: Scalars['uuid'];
  rated_id: Scalars['uuid'];
  score?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user: User;
  /** An object relationship */
  userByRatedById: User;
};

/** aggregated selection of "user_rating" */
export type User_Rating_Aggregate = {
  __typename?: 'user_rating_aggregate';
  aggregate?: Maybe<User_Rating_Aggregate_Fields>;
  nodes: Array<User_Rating>;
};

export type User_Rating_Aggregate_Bool_Exp = {
  count?: Maybe<User_Rating_Aggregate_Bool_Exp_Count>;
};

export type User_Rating_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Rating_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Rating_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_rating" */
export type User_Rating_Aggregate_Fields = {
  __typename?: 'user_rating_aggregate_fields';
  avg?: Maybe<User_Rating_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Rating_Max_Fields>;
  min?: Maybe<User_Rating_Min_Fields>;
  stddev?: Maybe<User_Rating_Stddev_Fields>;
  stddev_pop?: Maybe<User_Rating_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Rating_Stddev_Samp_Fields>;
  sum?: Maybe<User_Rating_Sum_Fields>;
  var_pop?: Maybe<User_Rating_Var_Pop_Fields>;
  var_samp?: Maybe<User_Rating_Var_Samp_Fields>;
  variance?: Maybe<User_Rating_Variance_Fields>;
};


/** aggregate fields of "user_rating" */
export type User_Rating_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Rating_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_rating" */
export type User_Rating_Aggregate_Order_By = {
  avg?: Maybe<User_Rating_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Rating_Max_Order_By>;
  min?: Maybe<User_Rating_Min_Order_By>;
  stddev?: Maybe<User_Rating_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Rating_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Rating_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Rating_Sum_Order_By>;
  var_pop?: Maybe<User_Rating_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Rating_Var_Samp_Order_By>;
  variance?: Maybe<User_Rating_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_rating" */
export type User_Rating_Arr_Rel_Insert_Input = {
  data: Array<User_Rating_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Rating_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Rating_Avg_Fields = {
  __typename?: 'user_rating_avg_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_rating" */
export type User_Rating_Avg_Order_By = {
  score?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_rating". All fields are combined with a logical 'AND'. */
export type User_Rating_Bool_Exp = {
  _and?: Maybe<Array<User_Rating_Bool_Exp>>;
  _not?: Maybe<User_Rating_Bool_Exp>;
  _or?: Maybe<Array<User_Rating_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  rated_by_id?: Maybe<Uuid_Comparison_Exp>;
  rated_id?: Maybe<Uuid_Comparison_Exp>;
  score?: Maybe<Int_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  userByRatedById?: Maybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "user_rating" */
export enum User_Rating_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserRatingPkey = 'user_rating_pkey'
}

/** input type for incrementing numeric columns in table "user_rating" */
export type User_Rating_Inc_Input = {
  score?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_rating" */
export type User_Rating_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  rated_by_id?: Maybe<Scalars['uuid']>;
  rated_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  userByRatedById?: Maybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Rating_Max_Fields = {
  __typename?: 'user_rating_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  rated_by_id?: Maybe<Scalars['uuid']>;
  rated_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_rating" */
export type User_Rating_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  rated_by_id?: Maybe<Order_By>;
  rated_id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Rating_Min_Fields = {
  __typename?: 'user_rating_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  rated_by_id?: Maybe<Scalars['uuid']>;
  rated_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_rating" */
export type User_Rating_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  rated_by_id?: Maybe<Order_By>;
  rated_id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_rating" */
export type User_Rating_Mutation_Response = {
  __typename?: 'user_rating_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Rating>;
};

/** on_conflict condition type for table "user_rating" */
export type User_Rating_On_Conflict = {
  constraint: User_Rating_Constraint;
  update_columns?: Array<User_Rating_Update_Column>;
  where?: Maybe<User_Rating_Bool_Exp>;
};

/** Ordering options when selecting data from "user_rating". */
export type User_Rating_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  rated_by_id?: Maybe<Order_By>;
  rated_id?: Maybe<Order_By>;
  score?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  userByRatedById?: Maybe<User_Order_By>;
};

/** primary key columns input for table: user_rating */
export type User_Rating_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_rating" */
export enum User_Rating_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RatedById = 'rated_by_id',
  /** column name */
  RatedId = 'rated_id',
  /** column name */
  Score = 'score'
}

/** input type for updating data in table "user_rating" */
export type User_Rating_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  rated_by_id?: Maybe<Scalars['uuid']>;
  rated_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Rating_Stddev_Fields = {
  __typename?: 'user_rating_stddev_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_rating" */
export type User_Rating_Stddev_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Rating_Stddev_Pop_Fields = {
  __typename?: 'user_rating_stddev_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_rating" */
export type User_Rating_Stddev_Pop_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Rating_Stddev_Samp_Fields = {
  __typename?: 'user_rating_stddev_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_rating" */
export type User_Rating_Stddev_Samp_Order_By = {
  score?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_rating" */
export type User_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Rating_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  rated_by_id?: Maybe<Scalars['uuid']>;
  rated_id?: Maybe<Scalars['uuid']>;
  score?: Maybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Rating_Sum_Fields = {
  __typename?: 'user_rating_sum_fields';
  score?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_rating" */
export type User_Rating_Sum_Order_By = {
  score?: Maybe<Order_By>;
};

/** update columns of table "user_rating" */
export enum User_Rating_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RatedById = 'rated_by_id',
  /** column name */
  RatedId = 'rated_id',
  /** column name */
  Score = 'score'
}

export type User_Rating_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Rating_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Rating_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Rating_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Rating_Var_Pop_Fields = {
  __typename?: 'user_rating_var_pop_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_rating" */
export type User_Rating_Var_Pop_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Rating_Var_Samp_Fields = {
  __typename?: 'user_rating_var_samp_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_rating" */
export type User_Rating_Var_Samp_Order_By = {
  score?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Rating_Variance_Fields = {
  __typename?: 'user_rating_variance_fields';
  score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_rating" */
export type User_Rating_Variance_Order_By = {
  score?: Maybe<Order_By>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Available = 'available',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  ConsentAt = 'consent_at',
  /** column name */
  ConsentGiven = 'consent_given',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  EmergencyContact = 'emergency_contact',
  /** column name */
  FamilyName = 'family_name',
  /** column name */
  GivenName = 'given_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  Marketplace = 'marketplace',
  /** column name */
  Pending = 'pending',
  /** column name */
  PendingInvite = 'pending_invite',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfileCompleted = 'profile_completed',
  /** column name */
  Role = 'role',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  SubscriptionRequired = 'subscription_required',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  archived?: Maybe<Scalars['Boolean']>;
  available?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  consent_at?: Maybe<Scalars['timestamp']>;
  consent_given?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  emergency_contact?: Maybe<Scalars['jsonb']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_public?: Maybe<Scalars['Boolean']>;
  marketplace?: Maybe<Scalars['Boolean']>;
  pending?: Maybe<Scalars['Boolean']>;
  pending_invite?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['bigint']>;
  profile_completed?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  subscription_required?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "user_skill" */
export type User_Skill = {
  __typename?: 'user_skill';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  skill: Skill;
  skill_id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: User_Profile;
  /** An object relationship */
  userByAddedById?: Maybe<User>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_skill" */
export type User_Skill_Aggregate = {
  __typename?: 'user_skill_aggregate';
  aggregate?: Maybe<User_Skill_Aggregate_Fields>;
  nodes: Array<User_Skill>;
};

export type User_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<User_Skill_Aggregate_Bool_Exp_Count>;
};

export type User_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_skill" */
export type User_Skill_Aggregate_Fields = {
  __typename?: 'user_skill_aggregate_fields';
  avg?: Maybe<User_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Skill_Max_Fields>;
  min?: Maybe<User_Skill_Min_Fields>;
  stddev?: Maybe<User_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<User_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<User_Skill_Sum_Fields>;
  var_pop?: Maybe<User_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<User_Skill_Var_Samp_Fields>;
  variance?: Maybe<User_Skill_Variance_Fields>;
};


/** aggregate fields of "user_skill" */
export type User_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_skill" */
export type User_Skill_Aggregate_Order_By = {
  avg?: Maybe<User_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Skill_Max_Order_By>;
  min?: Maybe<User_Skill_Min_Order_By>;
  stddev?: Maybe<User_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Skill_Sum_Order_By>;
  var_pop?: Maybe<User_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Skill_Var_Samp_Order_By>;
  variance?: Maybe<User_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_skill" */
export type User_Skill_Arr_Rel_Insert_Input = {
  data: Array<User_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Skill_Avg_Fields = {
  __typename?: 'user_skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_skill" */
export type User_Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_skill". All fields are combined with a logical 'AND'. */
export type User_Skill_Bool_Exp = {
  _and?: Maybe<Array<User_Skill_Bool_Exp>>;
  _not?: Maybe<User_Skill_Bool_Exp>;
  _or?: Maybe<Array<User_Skill_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  skill?: Maybe<Skill_Bool_Exp>;
  skill_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Profile_Bool_Exp>;
  userByAddedById?: Maybe<User_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_skill" */
export enum User_Skill_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSkillPkey = 'user_skill_pkey',
  /** unique or primary key constraint on columns "user_id", "added_by_id", "skill_id" */
  UserSkillSkillIdUserIdAddedByIdKey = 'user_skill_skill_id_user_id_added_by_id_key'
}

/** input type for incrementing numeric columns in table "user_skill" */
export type User_Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_skill" */
export type User_Skill_Insert_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill?: Maybe<Skill_Obj_Rel_Insert_Input>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Profile_Obj_Rel_Insert_Input>;
  userByAddedById?: Maybe<User_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Skill_Max_Fields = {
  __typename?: 'user_skill_max_fields';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_skill" */
export type User_Skill_Max_Order_By = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Skill_Min_Fields = {
  __typename?: 'user_skill_min_fields';
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_skill" */
export type User_Skill_Min_Order_By = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_skill" */
export type User_Skill_Mutation_Response = {
  __typename?: 'user_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Skill>;
};

/** on_conflict condition type for table "user_skill" */
export type User_Skill_On_Conflict = {
  constraint: User_Skill_Constraint;
  update_columns?: Array<User_Skill_Update_Column>;
  where?: Maybe<User_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "user_skill". */
export type User_Skill_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  skill?: Maybe<Skill_Order_By>;
  skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Profile_Order_By>;
  userByAddedById?: Maybe<User_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_skill */
export type User_Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_skill" */
export enum User_Skill_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_skill" */
export type User_Skill_Set_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Skill_Stddev_Fields = {
  __typename?: 'user_skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_skill" */
export type User_Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Skill_Stddev_Pop_Fields = {
  __typename?: 'user_skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_skill" */
export type User_Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Skill_Stddev_Samp_Fields = {
  __typename?: 'user_skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_skill" */
export type User_Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_skill" */
export type User_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Skill_Stream_Cursor_Value_Input = {
  /** User who added the row. Is null if own info */
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Skill_Sum_Fields = {
  __typename?: 'user_skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
  skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_skill" */
export type User_Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** update columns of table "user_skill" */
export enum User_Skill_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SkillId = 'skill_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Skill_Var_Pop_Fields = {
  __typename?: 'user_skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_skill" */
export type User_Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Skill_Var_Samp_Fields = {
  __typename?: 'user_skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_skill" */
export type User_Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Skill_Variance_Fields = {
  __typename?: 'user_skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
  skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_skill" */
export type User_Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
  skill_id?: Maybe<Order_By>;
};

/** columns and relationships of "user_soft_skill" */
export type User_Soft_Skill = {
  __typename?: 'user_soft_skill';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  soft_skill: Soft_Skill;
  soft_skill_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<User>;
  /** An object relationship */
  userByAddedById: User_Profile;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_soft_skill" */
export type User_Soft_Skill_Aggregate = {
  __typename?: 'user_soft_skill_aggregate';
  aggregate?: Maybe<User_Soft_Skill_Aggregate_Fields>;
  nodes: Array<User_Soft_Skill>;
};

export type User_Soft_Skill_Aggregate_Bool_Exp = {
  count?: Maybe<User_Soft_Skill_Aggregate_Bool_Exp_Count>;
};

export type User_Soft_Skill_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Soft_Skill_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_soft_skill" */
export type User_Soft_Skill_Aggregate_Fields = {
  __typename?: 'user_soft_skill_aggregate_fields';
  avg?: Maybe<User_Soft_Skill_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Soft_Skill_Max_Fields>;
  min?: Maybe<User_Soft_Skill_Min_Fields>;
  stddev?: Maybe<User_Soft_Skill_Stddev_Fields>;
  stddev_pop?: Maybe<User_Soft_Skill_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Soft_Skill_Stddev_Samp_Fields>;
  sum?: Maybe<User_Soft_Skill_Sum_Fields>;
  var_pop?: Maybe<User_Soft_Skill_Var_Pop_Fields>;
  var_samp?: Maybe<User_Soft_Skill_Var_Samp_Fields>;
  variance?: Maybe<User_Soft_Skill_Variance_Fields>;
};


/** aggregate fields of "user_soft_skill" */
export type User_Soft_Skill_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Soft_Skill_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_soft_skill" */
export type User_Soft_Skill_Aggregate_Order_By = {
  avg?: Maybe<User_Soft_Skill_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Soft_Skill_Max_Order_By>;
  min?: Maybe<User_Soft_Skill_Min_Order_By>;
  stddev?: Maybe<User_Soft_Skill_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Soft_Skill_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Soft_Skill_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Soft_Skill_Sum_Order_By>;
  var_pop?: Maybe<User_Soft_Skill_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Soft_Skill_Var_Samp_Order_By>;
  variance?: Maybe<User_Soft_Skill_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_soft_skill" */
export type User_Soft_Skill_Arr_Rel_Insert_Input = {
  data: Array<User_Soft_Skill_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Soft_Skill_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Soft_Skill_Avg_Fields = {
  __typename?: 'user_soft_skill_avg_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Avg_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_soft_skill". All fields are combined with a logical 'AND'. */
export type User_Soft_Skill_Bool_Exp = {
  _and?: Maybe<Array<User_Soft_Skill_Bool_Exp>>;
  _not?: Maybe<User_Soft_Skill_Bool_Exp>;
  _or?: Maybe<Array<User_Soft_Skill_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  soft_skill?: Maybe<Soft_Skill_Bool_Exp>;
  soft_skill_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<User_Bool_Exp>;
  userByAddedById?: Maybe<User_Profile_Bool_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_soft_skill" */
export enum User_Soft_Skill_Constraint {
  /** unique or primary key constraint on columns "user_id", "added_by_id", "soft_skill_id" */
  SoftSkillsAddedByIdUserIdSoftSkillIdKey = 'soft_skills_added_by_id_user_id_soft_skill_id_key',
  /** unique or primary key constraint on columns "id" */
  SoftSkillsPkey = 'soft_skills_pkey'
}

/** input type for incrementing numeric columns in table "user_soft_skill" */
export type User_Soft_Skill_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_soft_skill" */
export type User_Soft_Skill_Insert_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  soft_skill?: Maybe<Soft_Skill_Obj_Rel_Insert_Input>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<User_Obj_Rel_Insert_Input>;
  userByAddedById?: Maybe<User_Profile_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Soft_Skill_Max_Fields = {
  __typename?: 'user_soft_skill_max_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Max_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Soft_Skill_Min_Fields = {
  __typename?: 'user_soft_skill_min_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Min_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_soft_skill" */
export type User_Soft_Skill_Mutation_Response = {
  __typename?: 'user_soft_skill_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Soft_Skill>;
};

/** on_conflict condition type for table "user_soft_skill" */
export type User_Soft_Skill_On_Conflict = {
  constraint: User_Soft_Skill_Constraint;
  update_columns?: Array<User_Soft_Skill_Update_Column>;
  where?: Maybe<User_Soft_Skill_Bool_Exp>;
};

/** Ordering options when selecting data from "user_soft_skill". */
export type User_Soft_Skill_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  soft_skill?: Maybe<Soft_Skill_Order_By>;
  soft_skill_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<User_Order_By>;
  userByAddedById?: Maybe<User_Profile_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_soft_skill */
export type User_Soft_Skill_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user_soft_skill" */
export enum User_Soft_Skill_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SoftSkillId = 'soft_skill_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_soft_skill" */
export type User_Soft_Skill_Set_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Soft_Skill_Stddev_Fields = {
  __typename?: 'user_soft_skill_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Soft_Skill_Stddev_Pop_Fields = {
  __typename?: 'user_soft_skill_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Soft_Skill_Stddev_Samp_Fields = {
  __typename?: 'user_soft_skill_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** Streaming cursor of the table "user_soft_skill" */
export type User_Soft_Skill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Soft_Skill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Soft_Skill_Stream_Cursor_Value_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Soft_Skill_Sum_Fields = {
  __typename?: 'user_soft_skill_sum_fields';
  id?: Maybe<Scalars['Int']>;
  soft_skill_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Sum_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** update columns of table "user_soft_skill" */
export enum User_Soft_Skill_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SoftSkillId = 'soft_skill_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Soft_Skill_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Soft_Skill_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Soft_Skill_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Soft_Skill_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Soft_Skill_Var_Pop_Fields = {
  __typename?: 'user_soft_skill_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Soft_Skill_Var_Samp_Fields = {
  __typename?: 'user_soft_skill_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Soft_Skill_Variance_Fields = {
  __typename?: 'user_soft_skill_variance_fields';
  id?: Maybe<Scalars['Float']>;
  soft_skill_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_soft_skill" */
export type User_Soft_Skill_Variance_Order_By = {
  id?: Maybe<Order_By>;
  soft_skill_id?: Maybe<Order_By>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  archived?: Maybe<Scalars['Boolean']>;
  available?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  consent_at?: Maybe<Scalars['timestamp']>;
  consent_given?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  emergency_contact?: Maybe<Scalars['jsonb']>;
  family_name?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_public?: Maybe<Scalars['Boolean']>;
  marketplace?: Maybe<Scalars['Boolean']>;
  pending?: Maybe<Scalars['Boolean']>;
  pending_invite?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['bigint']>;
  profile_completed?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  subscription_required?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'user_sum_fields';
  phone?: Maybe<Scalars['bigint']>;
};

/** columns and relationships of "user_transportation" */
export type User_Transportation = {
  __typename?: 'user_transportation';
  added_by_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  transportation_type: Scalars['String'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_transportation" */
export type User_Transportation_Aggregate = {
  __typename?: 'user_transportation_aggregate';
  aggregate?: Maybe<User_Transportation_Aggregate_Fields>;
  nodes: Array<User_Transportation>;
};

export type User_Transportation_Aggregate_Bool_Exp = {
  count?: Maybe<User_Transportation_Aggregate_Bool_Exp_Count>;
};

export type User_Transportation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Transportation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Transportation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_transportation" */
export type User_Transportation_Aggregate_Fields = {
  __typename?: 'user_transportation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Transportation_Max_Fields>;
  min?: Maybe<User_Transportation_Min_Fields>;
};


/** aggregate fields of "user_transportation" */
export type User_Transportation_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Transportation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_transportation" */
export type User_Transportation_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Transportation_Max_Order_By>;
  min?: Maybe<User_Transportation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_transportation" */
export type User_Transportation_Arr_Rel_Insert_Input = {
  data: Array<User_Transportation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Transportation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_transportation". All fields are combined with a logical 'AND'. */
export type User_Transportation_Bool_Exp = {
  _and?: Maybe<Array<User_Transportation_Bool_Exp>>;
  _not?: Maybe<User_Transportation_Bool_Exp>;
  _or?: Maybe<Array<User_Transportation_Bool_Exp>>;
  added_by_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  transportation_type?: Maybe<String_Comparison_Exp>;
  user_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_transportation" */
export enum User_Transportation_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserTransportationPkey = 'user_transportation_pkey',
  /** unique or primary key constraint on columns "user_id", "transportation_type" */
  UserTransportationUserIdTransportationTypeKey = 'user_transportation_user_id_transportation_type_key'
}

/** input type for inserting data into table "user_transportation" */
export type User_Transportation_Insert_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Transportation_Max_Fields = {
  __typename?: 'user_transportation_max_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_transportation" */
export type User_Transportation_Max_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  transportation_type?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Transportation_Min_Fields = {
  __typename?: 'user_transportation_min_fields';
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_transportation" */
export type User_Transportation_Min_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  transportation_type?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_transportation" */
export type User_Transportation_Mutation_Response = {
  __typename?: 'user_transportation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Transportation>;
};

/** on_conflict condition type for table "user_transportation" */
export type User_Transportation_On_Conflict = {
  constraint: User_Transportation_Constraint;
  update_columns?: Array<User_Transportation_Update_Column>;
  where?: Maybe<User_Transportation_Bool_Exp>;
};

/** Ordering options when selecting data from "user_transportation". */
export type User_Transportation_Order_By = {
  added_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  transportation_type?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_transportation */
export type User_Transportation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_transportation" */
export enum User_Transportation_Select_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransportationType = 'transportation_type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_transportation" */
export type User_Transportation_Set_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_transportation" */
export type User_Transportation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Transportation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Transportation_Stream_Cursor_Value_Input = {
  added_by_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  transportation_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_transportation" */
export enum User_Transportation_Update_Column {
  /** column name */
  AddedById = 'added_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransportationType = 'transportation_type',
  /** column name */
  UserId = 'user_id'
}

export type User_Transportation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Transportation_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Transportation_Bool_Exp;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  Available = 'available',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  ConsentAt = 'consent_at',
  /** column name */
  ConsentGiven = 'consent_given',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  EmergencyContact = 'emergency_contact',
  /** column name */
  FamilyName = 'family_name',
  /** column name */
  GivenName = 'given_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  Marketplace = 'marketplace',
  /** column name */
  Pending = 'pending',
  /** column name */
  PendingInvite = 'pending_invite',
  /** column name */
  Phone = 'phone',
  /** column name */
  ProfileCompleted = 'profile_completed',
  /** column name */
  Role = 'role',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  SubscriptionRequired = 'subscription_required',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: Maybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: Maybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: Maybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: Maybe<User_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<User_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: Maybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'user_variance_fields';
  phone?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_watchlist" */
export type User_Watchlist = {
  __typename?: 'user_watchlist';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  watched: User;
  /** An object relationship */
  watched_by: User;
  watched_by_id: Scalars['uuid'];
  watched_id: Scalars['uuid'];
};

/** aggregated selection of "user_watchlist" */
export type User_Watchlist_Aggregate = {
  __typename?: 'user_watchlist_aggregate';
  aggregate?: Maybe<User_Watchlist_Aggregate_Fields>;
  nodes: Array<User_Watchlist>;
};

export type User_Watchlist_Aggregate_Bool_Exp = {
  count?: Maybe<User_Watchlist_Aggregate_Bool_Exp_Count>;
};

export type User_Watchlist_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<User_Watchlist_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<User_Watchlist_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_watchlist" */
export type User_Watchlist_Aggregate_Fields = {
  __typename?: 'user_watchlist_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Watchlist_Max_Fields>;
  min?: Maybe<User_Watchlist_Min_Fields>;
};


/** aggregate fields of "user_watchlist" */
export type User_Watchlist_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Watchlist_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_watchlist" */
export type User_Watchlist_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<User_Watchlist_Max_Order_By>;
  min?: Maybe<User_Watchlist_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_watchlist" */
export type User_Watchlist_Arr_Rel_Insert_Input = {
  data: Array<User_Watchlist_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<User_Watchlist_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_watchlist". All fields are combined with a logical 'AND'. */
export type User_Watchlist_Bool_Exp = {
  _and?: Maybe<Array<User_Watchlist_Bool_Exp>>;
  _not?: Maybe<User_Watchlist_Bool_Exp>;
  _or?: Maybe<Array<User_Watchlist_Bool_Exp>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  watched?: Maybe<User_Bool_Exp>;
  watched_by?: Maybe<User_Bool_Exp>;
  watched_by_id?: Maybe<Uuid_Comparison_Exp>;
  watched_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_watchlist" */
export enum User_Watchlist_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserWatchlistPkey = 'user_watchlist_pkey'
}

/** input type for inserting data into table "user_watchlist" */
export type User_Watchlist_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  watched?: Maybe<User_Obj_Rel_Insert_Input>;
  watched_by?: Maybe<User_Obj_Rel_Insert_Input>;
  watched_by_id?: Maybe<Scalars['uuid']>;
  watched_id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Watchlist_Max_Fields = {
  __typename?: 'user_watchlist_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  watched_by_id?: Maybe<Scalars['uuid']>;
  watched_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_watchlist" */
export type User_Watchlist_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  watched_by_id?: Maybe<Order_By>;
  watched_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Watchlist_Min_Fields = {
  __typename?: 'user_watchlist_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  watched_by_id?: Maybe<Scalars['uuid']>;
  watched_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_watchlist" */
export type User_Watchlist_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  watched_by_id?: Maybe<Order_By>;
  watched_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_watchlist" */
export type User_Watchlist_Mutation_Response = {
  __typename?: 'user_watchlist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Watchlist>;
};

/** on_conflict condition type for table "user_watchlist" */
export type User_Watchlist_On_Conflict = {
  constraint: User_Watchlist_Constraint;
  update_columns?: Array<User_Watchlist_Update_Column>;
  where?: Maybe<User_Watchlist_Bool_Exp>;
};

/** Ordering options when selecting data from "user_watchlist". */
export type User_Watchlist_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  watched?: Maybe<User_Order_By>;
  watched_by?: Maybe<User_Order_By>;
  watched_by_id?: Maybe<Order_By>;
  watched_id?: Maybe<Order_By>;
};

/** primary key columns input for table: user_watchlist */
export type User_Watchlist_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_watchlist" */
export enum User_Watchlist_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  WatchedById = 'watched_by_id',
  /** column name */
  WatchedId = 'watched_id'
}

/** input type for updating data in table "user_watchlist" */
export type User_Watchlist_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  watched_by_id?: Maybe<Scalars['uuid']>;
  watched_id?: Maybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_watchlist" */
export type User_Watchlist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Watchlist_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Watchlist_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  watched_by_id?: Maybe<Scalars['uuid']>;
  watched_id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_watchlist" */
export enum User_Watchlist_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  WatchedById = 'watched_by_id',
  /** column name */
  WatchedId = 'watched_id'
}

export type User_Watchlist_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<User_Watchlist_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Watchlist_Bool_Exp;
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Boolean_comparison_exp: Boolean_Comparison_Exp;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Float_comparison_exp: Float_Comparison_Exp;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Int_comparison_exp: Int_Comparison_Exp;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  String_array_comparison_exp: String_Array_Comparison_Exp;
  String: ResolverTypeWrapper<Scalars['String']>;
  String_comparison_exp: String_Comparison_Exp;
  admin: ResolverTypeWrapper<Admin>;
  admin_aggregate: ResolverTypeWrapper<Admin_Aggregate>;
  admin_aggregate_bool_exp: Admin_Aggregate_Bool_Exp;
  admin_aggregate_bool_exp_bool_and: Admin_Aggregate_Bool_Exp_Bool_And;
  admin_aggregate_bool_exp_bool_or: Admin_Aggregate_Bool_Exp_Bool_Or;
  admin_aggregate_bool_exp_count: Admin_Aggregate_Bool_Exp_Count;
  admin_aggregate_fields: ResolverTypeWrapper<Admin_Aggregate_Fields>;
  admin_aggregate_order_by: Admin_Aggregate_Order_By;
  admin_arr_rel_insert_input: Admin_Arr_Rel_Insert_Input;
  admin_bool_exp: Admin_Bool_Exp;
  admin_constraint: Admin_Constraint;
  admin_insert_input: Admin_Insert_Input;
  admin_max_fields: ResolverTypeWrapper<Admin_Max_Fields>;
  admin_max_order_by: Admin_Max_Order_By;
  admin_min_fields: ResolverTypeWrapper<Admin_Min_Fields>;
  admin_min_order_by: Admin_Min_Order_By;
  admin_mutation_response: ResolverTypeWrapper<Admin_Mutation_Response>;
  admin_obj_rel_insert_input: Admin_Obj_Rel_Insert_Input;
  admin_on_conflict: Admin_On_Conflict;
  admin_order_by: Admin_Order_By;
  admin_pk_columns_input: Admin_Pk_Columns_Input;
  admin_select_column: Admin_Select_Column;
  admin_select_column_admin_aggregate_bool_exp_bool_and_arguments_columns: Admin_Select_Column_Admin_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  admin_select_column_admin_aggregate_bool_exp_bool_or_arguments_columns: Admin_Select_Column_Admin_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  admin_set_input: Admin_Set_Input;
  admin_stream_cursor_input: Admin_Stream_Cursor_Input;
  admin_stream_cursor_value_input: Admin_Stream_Cursor_Value_Input;
  admin_update_column: Admin_Update_Column;
  admin_updates: Admin_Updates;
  applicant_enum: ResolverTypeWrapper<Scalars['applicant_enum']>;
  applicant_enum_comparison_exp: Applicant_Enum_Comparison_Exp;
  application: ResolverTypeWrapper<Application>;
  application_aggregate: ResolverTypeWrapper<Application_Aggregate>;
  application_aggregate_bool_exp: Application_Aggregate_Bool_Exp;
  application_aggregate_bool_exp_bool_and: Application_Aggregate_Bool_Exp_Bool_And;
  application_aggregate_bool_exp_bool_or: Application_Aggregate_Bool_Exp_Bool_Or;
  application_aggregate_bool_exp_count: Application_Aggregate_Bool_Exp_Count;
  application_aggregate_fields: ResolverTypeWrapper<Application_Aggregate_Fields>;
  application_aggregate_order_by: Application_Aggregate_Order_By;
  application_arr_rel_insert_input: Application_Arr_Rel_Insert_Input;
  application_bool_exp: Application_Bool_Exp;
  application_constraint: Application_Constraint;
  application_insert_input: Application_Insert_Input;
  application_max_fields: ResolverTypeWrapper<Application_Max_Fields>;
  application_max_order_by: Application_Max_Order_By;
  application_min_fields: ResolverTypeWrapper<Application_Min_Fields>;
  application_min_order_by: Application_Min_Order_By;
  application_mutation_response: ResolverTypeWrapper<Application_Mutation_Response>;
  application_obj_rel_insert_input: Application_Obj_Rel_Insert_Input;
  application_on_conflict: Application_On_Conflict;
  application_order_by: Application_Order_By;
  application_pk_columns_input: Application_Pk_Columns_Input;
  application_select_column: Application_Select_Column;
  application_select_column_application_aggregate_bool_exp_bool_and_arguments_columns: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  application_select_column_application_aggregate_bool_exp_bool_or_arguments_columns: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  application_set_input: Application_Set_Input;
  application_stream_cursor_input: Application_Stream_Cursor_Input;
  application_stream_cursor_value_input: Application_Stream_Cursor_Value_Input;
  application_update_column: Application_Update_Column;
  application_updates: Application_Updates;
  bigint: ResolverTypeWrapper<Scalars['bigint']>;
  bigint_comparison_exp: Bigint_Comparison_Exp;
  candidate: ResolverTypeWrapper<Candidate>;
  candidate_aggregate: ResolverTypeWrapper<Candidate_Aggregate>;
  candidate_aggregate_bool_exp: Candidate_Aggregate_Bool_Exp;
  candidate_aggregate_bool_exp_count: Candidate_Aggregate_Bool_Exp_Count;
  candidate_aggregate_fields: ResolverTypeWrapper<Candidate_Aggregate_Fields>;
  candidate_aggregate_order_by: Candidate_Aggregate_Order_By;
  candidate_arr_rel_insert_input: Candidate_Arr_Rel_Insert_Input;
  candidate_bool_exp: Candidate_Bool_Exp;
  candidate_constraint: Candidate_Constraint;
  candidate_insert_input: Candidate_Insert_Input;
  candidate_max_fields: ResolverTypeWrapper<Candidate_Max_Fields>;
  candidate_max_order_by: Candidate_Max_Order_By;
  candidate_min_fields: ResolverTypeWrapper<Candidate_Min_Fields>;
  candidate_min_order_by: Candidate_Min_Order_By;
  candidate_mutation_response: ResolverTypeWrapper<Candidate_Mutation_Response>;
  candidate_obj_rel_insert_input: Candidate_Obj_Rel_Insert_Input;
  candidate_on_conflict: Candidate_On_Conflict;
  candidate_order_by: Candidate_Order_By;
  candidate_pk_columns_input: Candidate_Pk_Columns_Input;
  candidate_select_column: Candidate_Select_Column;
  candidate_set_input: Candidate_Set_Input;
  candidate_stream_cursor_input: Candidate_Stream_Cursor_Input;
  candidate_stream_cursor_value_input: Candidate_Stream_Cursor_Value_Input;
  candidate_update_column: Candidate_Update_Column;
  candidate_updates: Candidate_Updates;
  chart_admin_contractors: ResolverTypeWrapper<Chart_Admin_Contractors>;
  chart_admin_contractors_aggregate: ResolverTypeWrapper<Chart_Admin_Contractors_Aggregate>;
  chart_admin_contractors_aggregate_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Aggregate_Fields>;
  chart_admin_contractors_avg_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Avg_Fields>;
  chart_admin_contractors_bool_exp: Chart_Admin_Contractors_Bool_Exp;
  chart_admin_contractors_max_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Max_Fields>;
  chart_admin_contractors_min_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Min_Fields>;
  chart_admin_contractors_order_by: Chart_Admin_Contractors_Order_By;
  chart_admin_contractors_select_column: Chart_Admin_Contractors_Select_Column;
  chart_admin_contractors_stddev_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Stddev_Fields>;
  chart_admin_contractors_stddev_pop_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Stddev_Pop_Fields>;
  chart_admin_contractors_stddev_samp_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Stddev_Samp_Fields>;
  chart_admin_contractors_stream_cursor_input: Chart_Admin_Contractors_Stream_Cursor_Input;
  chart_admin_contractors_stream_cursor_value_input: Chart_Admin_Contractors_Stream_Cursor_Value_Input;
  chart_admin_contractors_sum_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Sum_Fields>;
  chart_admin_contractors_var_pop_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Var_Pop_Fields>;
  chart_admin_contractors_var_samp_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Var_Samp_Fields>;
  chart_admin_contractors_variance_fields: ResolverTypeWrapper<Chart_Admin_Contractors_Variance_Fields>;
  chart_manager_contractors: ResolverTypeWrapper<Chart_Manager_Contractors>;
  chart_manager_contractors_aggregate: ResolverTypeWrapper<Chart_Manager_Contractors_Aggregate>;
  chart_manager_contractors_aggregate_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Aggregate_Fields>;
  chart_manager_contractors_avg_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Avg_Fields>;
  chart_manager_contractors_bool_exp: Chart_Manager_Contractors_Bool_Exp;
  chart_manager_contractors_max_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Max_Fields>;
  chart_manager_contractors_min_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Min_Fields>;
  chart_manager_contractors_order_by: Chart_Manager_Contractors_Order_By;
  chart_manager_contractors_select_column: Chart_Manager_Contractors_Select_Column;
  chart_manager_contractors_stddev_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Stddev_Fields>;
  chart_manager_contractors_stddev_pop_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Stddev_Pop_Fields>;
  chart_manager_contractors_stddev_samp_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Stddev_Samp_Fields>;
  chart_manager_contractors_stream_cursor_input: Chart_Manager_Contractors_Stream_Cursor_Input;
  chart_manager_contractors_stream_cursor_value_input: Chart_Manager_Contractors_Stream_Cursor_Value_Input;
  chart_manager_contractors_sum_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Sum_Fields>;
  chart_manager_contractors_var_pop_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Var_Pop_Fields>;
  chart_manager_contractors_var_samp_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Var_Samp_Fields>;
  chart_manager_contractors_variance_fields: ResolverTypeWrapper<Chart_Manager_Contractors_Variance_Fields>;
  chart_projects: ResolverTypeWrapper<Chart_Projects>;
  chart_projects_aggregate: ResolverTypeWrapper<Chart_Projects_Aggregate>;
  chart_projects_aggregate_fields: ResolverTypeWrapper<Chart_Projects_Aggregate_Fields>;
  chart_projects_avg_fields: ResolverTypeWrapper<Chart_Projects_Avg_Fields>;
  chart_projects_bool_exp: Chart_Projects_Bool_Exp;
  chart_projects_max_fields: ResolverTypeWrapper<Chart_Projects_Max_Fields>;
  chart_projects_min_fields: ResolverTypeWrapper<Chart_Projects_Min_Fields>;
  chart_projects_order_by: Chart_Projects_Order_By;
  chart_projects_select_column: Chart_Projects_Select_Column;
  chart_projects_stddev_fields: ResolverTypeWrapper<Chart_Projects_Stddev_Fields>;
  chart_projects_stddev_pop_fields: ResolverTypeWrapper<Chart_Projects_Stddev_Pop_Fields>;
  chart_projects_stddev_samp_fields: ResolverTypeWrapper<Chart_Projects_Stddev_Samp_Fields>;
  chart_projects_stream_cursor_input: Chart_Projects_Stream_Cursor_Input;
  chart_projects_stream_cursor_value_input: Chart_Projects_Stream_Cursor_Value_Input;
  chart_projects_sum_fields: ResolverTypeWrapper<Chart_Projects_Sum_Fields>;
  chart_projects_var_pop_fields: ResolverTypeWrapper<Chart_Projects_Var_Pop_Fields>;
  chart_projects_var_samp_fields: ResolverTypeWrapper<Chart_Projects_Var_Samp_Fields>;
  chart_projects_variance_fields: ResolverTypeWrapper<Chart_Projects_Variance_Fields>;
  checkin_status: ResolverTypeWrapper<Checkin_Status>;
  checkin_status_aggregate: ResolverTypeWrapper<Checkin_Status_Aggregate>;
  checkin_status_aggregate_fields: ResolverTypeWrapper<Checkin_Status_Aggregate_Fields>;
  checkin_status_bool_exp: Checkin_Status_Bool_Exp;
  checkin_status_constraint: Checkin_Status_Constraint;
  checkin_status_insert_input: Checkin_Status_Insert_Input;
  checkin_status_max_fields: ResolverTypeWrapper<Checkin_Status_Max_Fields>;
  checkin_status_min_fields: ResolverTypeWrapper<Checkin_Status_Min_Fields>;
  checkin_status_mutation_response: ResolverTypeWrapper<Checkin_Status_Mutation_Response>;
  checkin_status_on_conflict: Checkin_Status_On_Conflict;
  checkin_status_order_by: Checkin_Status_Order_By;
  checkin_status_pk_columns_input: Checkin_Status_Pk_Columns_Input;
  checkin_status_select_column: Checkin_Status_Select_Column;
  checkin_status_set_input: Checkin_Status_Set_Input;
  checkin_status_stream_cursor_input: Checkin_Status_Stream_Cursor_Input;
  checkin_status_stream_cursor_value_input: Checkin_Status_Stream_Cursor_Value_Input;
  checkin_status_update_column: Checkin_Status_Update_Column;
  checkin_status_updates: Checkin_Status_Updates;
  checkout_status: ResolverTypeWrapper<Checkout_Status>;
  checkout_status_aggregate: ResolverTypeWrapper<Checkout_Status_Aggregate>;
  checkout_status_aggregate_fields: ResolverTypeWrapper<Checkout_Status_Aggregate_Fields>;
  checkout_status_bool_exp: Checkout_Status_Bool_Exp;
  checkout_status_constraint: Checkout_Status_Constraint;
  checkout_status_insert_input: Checkout_Status_Insert_Input;
  checkout_status_max_fields: ResolverTypeWrapper<Checkout_Status_Max_Fields>;
  checkout_status_min_fields: ResolverTypeWrapper<Checkout_Status_Min_Fields>;
  checkout_status_mutation_response: ResolverTypeWrapper<Checkout_Status_Mutation_Response>;
  checkout_status_on_conflict: Checkout_Status_On_Conflict;
  checkout_status_order_by: Checkout_Status_Order_By;
  checkout_status_pk_columns_input: Checkout_Status_Pk_Columns_Input;
  checkout_status_select_column: Checkout_Status_Select_Column;
  checkout_status_set_input: Checkout_Status_Set_Input;
  checkout_status_stream_cursor_input: Checkout_Status_Stream_Cursor_Input;
  checkout_status_stream_cursor_value_input: Checkout_Status_Stream_Cursor_Value_Input;
  checkout_status_update_column: Checkout_Status_Update_Column;
  checkout_status_updates: Checkout_Status_Updates;
  client_care_plan: ResolverTypeWrapper<Client_Care_Plan>;
  client_care_plan_aggregate: ResolverTypeWrapper<Client_Care_Plan_Aggregate>;
  client_care_plan_aggregate_bool_exp: Client_Care_Plan_Aggregate_Bool_Exp;
  client_care_plan_aggregate_bool_exp_count: Client_Care_Plan_Aggregate_Bool_Exp_Count;
  client_care_plan_aggregate_fields: ResolverTypeWrapper<Client_Care_Plan_Aggregate_Fields>;
  client_care_plan_aggregate_order_by: Client_Care_Plan_Aggregate_Order_By;
  client_care_plan_arr_rel_insert_input: Client_Care_Plan_Arr_Rel_Insert_Input;
  client_care_plan_bool_exp: Client_Care_Plan_Bool_Exp;
  client_care_plan_constraint: Client_Care_Plan_Constraint;
  client_care_plan_insert_input: Client_Care_Plan_Insert_Input;
  client_care_plan_max_fields: ResolverTypeWrapper<Client_Care_Plan_Max_Fields>;
  client_care_plan_max_order_by: Client_Care_Plan_Max_Order_By;
  client_care_plan_min_fields: ResolverTypeWrapper<Client_Care_Plan_Min_Fields>;
  client_care_plan_min_order_by: Client_Care_Plan_Min_Order_By;
  client_care_plan_mutation_response: ResolverTypeWrapper<Client_Care_Plan_Mutation_Response>;
  client_care_plan_obj_rel_insert_input: Client_Care_Plan_Obj_Rel_Insert_Input;
  client_care_plan_on_conflict: Client_Care_Plan_On_Conflict;
  client_care_plan_order_by: Client_Care_Plan_Order_By;
  client_care_plan_pk_columns_input: Client_Care_Plan_Pk_Columns_Input;
  client_care_plan_select_column: Client_Care_Plan_Select_Column;
  client_care_plan_set_input: Client_Care_Plan_Set_Input;
  client_care_plan_stream_cursor_input: Client_Care_Plan_Stream_Cursor_Input;
  client_care_plan_stream_cursor_value_input: Client_Care_Plan_Stream_Cursor_Value_Input;
  client_care_plan_update_column: Client_Care_Plan_Update_Column;
  client_care_plan_updates: Client_Care_Plan_Updates;
  client_medications: ResolverTypeWrapper<Client_Medications>;
  client_medications_aggregate: ResolverTypeWrapper<Client_Medications_Aggregate>;
  client_medications_aggregate_bool_exp: Client_Medications_Aggregate_Bool_Exp;
  client_medications_aggregate_bool_exp_count: Client_Medications_Aggregate_Bool_Exp_Count;
  client_medications_aggregate_fields: ResolverTypeWrapper<Client_Medications_Aggregate_Fields>;
  client_medications_aggregate_order_by: Client_Medications_Aggregate_Order_By;
  client_medications_arr_rel_insert_input: Client_Medications_Arr_Rel_Insert_Input;
  client_medications_bool_exp: Client_Medications_Bool_Exp;
  client_medications_constraint: Client_Medications_Constraint;
  client_medications_insert_input: Client_Medications_Insert_Input;
  client_medications_max_fields: ResolverTypeWrapper<Client_Medications_Max_Fields>;
  client_medications_max_order_by: Client_Medications_Max_Order_By;
  client_medications_min_fields: ResolverTypeWrapper<Client_Medications_Min_Fields>;
  client_medications_min_order_by: Client_Medications_Min_Order_By;
  client_medications_mutation_response: ResolverTypeWrapper<Client_Medications_Mutation_Response>;
  client_medications_on_conflict: Client_Medications_On_Conflict;
  client_medications_order_by: Client_Medications_Order_By;
  client_medications_pk_columns_input: Client_Medications_Pk_Columns_Input;
  client_medications_select_column: Client_Medications_Select_Column;
  client_medications_set_input: Client_Medications_Set_Input;
  client_medications_stream_cursor_input: Client_Medications_Stream_Cursor_Input;
  client_medications_stream_cursor_value_input: Client_Medications_Stream_Cursor_Value_Input;
  client_medications_update_column: Client_Medications_Update_Column;
  client_medications_updates: Client_Medications_Updates;
  company: ResolverTypeWrapper<Company>;
  company_aggregate: ResolverTypeWrapper<Company_Aggregate>;
  company_aggregate_bool_exp: Company_Aggregate_Bool_Exp;
  company_aggregate_bool_exp_bool_and: Company_Aggregate_Bool_Exp_Bool_And;
  company_aggregate_bool_exp_bool_or: Company_Aggregate_Bool_Exp_Bool_Or;
  company_aggregate_bool_exp_count: Company_Aggregate_Bool_Exp_Count;
  company_aggregate_fields: ResolverTypeWrapper<Company_Aggregate_Fields>;
  company_aggregate_order_by: Company_Aggregate_Order_By;
  company_arr_rel_insert_input: Company_Arr_Rel_Insert_Input;
  company_avg_fields: ResolverTypeWrapper<Company_Avg_Fields>;
  company_avg_order_by: Company_Avg_Order_By;
  company_bool_exp: Company_Bool_Exp;
  company_constraint: Company_Constraint;
  company_follower: ResolverTypeWrapper<Company_Follower>;
  company_follower_aggregate: ResolverTypeWrapper<Company_Follower_Aggregate>;
  company_follower_aggregate_bool_exp: Company_Follower_Aggregate_Bool_Exp;
  company_follower_aggregate_bool_exp_count: Company_Follower_Aggregate_Bool_Exp_Count;
  company_follower_aggregate_fields: ResolverTypeWrapper<Company_Follower_Aggregate_Fields>;
  company_follower_aggregate_order_by: Company_Follower_Aggregate_Order_By;
  company_follower_arr_rel_insert_input: Company_Follower_Arr_Rel_Insert_Input;
  company_follower_bool_exp: Company_Follower_Bool_Exp;
  company_follower_constraint: Company_Follower_Constraint;
  company_follower_insert_input: Company_Follower_Insert_Input;
  company_follower_max_fields: ResolverTypeWrapper<Company_Follower_Max_Fields>;
  company_follower_max_order_by: Company_Follower_Max_Order_By;
  company_follower_min_fields: ResolverTypeWrapper<Company_Follower_Min_Fields>;
  company_follower_min_order_by: Company_Follower_Min_Order_By;
  company_follower_mutation_response: ResolverTypeWrapper<Company_Follower_Mutation_Response>;
  company_follower_on_conflict: Company_Follower_On_Conflict;
  company_follower_order_by: Company_Follower_Order_By;
  company_follower_pk_columns_input: Company_Follower_Pk_Columns_Input;
  company_follower_select_column: Company_Follower_Select_Column;
  company_follower_set_input: Company_Follower_Set_Input;
  company_follower_stream_cursor_input: Company_Follower_Stream_Cursor_Input;
  company_follower_stream_cursor_value_input: Company_Follower_Stream_Cursor_Value_Input;
  company_follower_update_column: Company_Follower_Update_Column;
  company_follower_updates: Company_Follower_Updates;
  company_inc_input: Company_Inc_Input;
  company_insert_input: Company_Insert_Input;
  company_managers_view_all_contractors_access: ResolverTypeWrapper<Scalars['company_managers_view_all_contractors_access']>;
  company_managers_view_all_contractors_access_comparison_exp: Company_Managers_View_All_Contractors_Access_Comparison_Exp;
  company_marketplace_access: ResolverTypeWrapper<Scalars['company_marketplace_access']>;
  company_marketplace_access_comparison_exp: Company_Marketplace_Access_Comparison_Exp;
  company_max_fields: ResolverTypeWrapper<Company_Max_Fields>;
  company_max_order_by: Company_Max_Order_By;
  company_min_fields: ResolverTypeWrapper<Company_Min_Fields>;
  company_min_order_by: Company_Min_Order_By;
  company_mutation_response: ResolverTypeWrapper<Company_Mutation_Response>;
  company_obj_rel_insert_input: Company_Obj_Rel_Insert_Input;
  company_on_conflict: Company_On_Conflict;
  company_order_by: Company_Order_By;
  company_pk_columns_input: Company_Pk_Columns_Input;
  company_select_column: Company_Select_Column;
  company_select_column_company_aggregate_bool_exp_bool_and_arguments_columns: Company_Select_Column_Company_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  company_select_column_company_aggregate_bool_exp_bool_or_arguments_columns: Company_Select_Column_Company_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  company_set_input: Company_Set_Input;
  company_stddev_fields: ResolverTypeWrapper<Company_Stddev_Fields>;
  company_stddev_order_by: Company_Stddev_Order_By;
  company_stddev_pop_fields: ResolverTypeWrapper<Company_Stddev_Pop_Fields>;
  company_stddev_pop_order_by: Company_Stddev_Pop_Order_By;
  company_stddev_samp_fields: ResolverTypeWrapper<Company_Stddev_Samp_Fields>;
  company_stddev_samp_order_by: Company_Stddev_Samp_Order_By;
  company_stream_cursor_input: Company_Stream_Cursor_Input;
  company_stream_cursor_value_input: Company_Stream_Cursor_Value_Input;
  company_sum_fields: ResolverTypeWrapper<Company_Sum_Fields>;
  company_sum_order_by: Company_Sum_Order_By;
  company_update_column: Company_Update_Column;
  company_updates: Company_Updates;
  company_user_notifications: ResolverTypeWrapper<Company_User_Notifications>;
  company_user_notifications_aggregate: ResolverTypeWrapper<Company_User_Notifications_Aggregate>;
  company_user_notifications_aggregate_bool_exp: Company_User_Notifications_Aggregate_Bool_Exp;
  company_user_notifications_aggregate_bool_exp_count: Company_User_Notifications_Aggregate_Bool_Exp_Count;
  company_user_notifications_aggregate_fields: ResolverTypeWrapper<Company_User_Notifications_Aggregate_Fields>;
  company_user_notifications_aggregate_order_by: Company_User_Notifications_Aggregate_Order_By;
  company_user_notifications_arr_rel_insert_input: Company_User_Notifications_Arr_Rel_Insert_Input;
  company_user_notifications_bool_exp: Company_User_Notifications_Bool_Exp;
  company_user_notifications_constraint: Company_User_Notifications_Constraint;
  company_user_notifications_insert_input: Company_User_Notifications_Insert_Input;
  company_user_notifications_max_fields: ResolverTypeWrapper<Company_User_Notifications_Max_Fields>;
  company_user_notifications_max_order_by: Company_User_Notifications_Max_Order_By;
  company_user_notifications_min_fields: ResolverTypeWrapper<Company_User_Notifications_Min_Fields>;
  company_user_notifications_min_order_by: Company_User_Notifications_Min_Order_By;
  company_user_notifications_mutation_response: ResolverTypeWrapper<Company_User_Notifications_Mutation_Response>;
  company_user_notifications_on_conflict: Company_User_Notifications_On_Conflict;
  company_user_notifications_order_by: Company_User_Notifications_Order_By;
  company_user_notifications_pk_columns_input: Company_User_Notifications_Pk_Columns_Input;
  company_user_notifications_select_column: Company_User_Notifications_Select_Column;
  company_user_notifications_set_input: Company_User_Notifications_Set_Input;
  company_user_notifications_stream_cursor_input: Company_User_Notifications_Stream_Cursor_Input;
  company_user_notifications_stream_cursor_value_input: Company_User_Notifications_Stream_Cursor_Value_Input;
  company_user_notifications_update_column: Company_User_Notifications_Update_Column;
  company_user_notifications_updates: Company_User_Notifications_Updates;
  company_var_pop_fields: ResolverTypeWrapper<Company_Var_Pop_Fields>;
  company_var_pop_order_by: Company_Var_Pop_Order_By;
  company_var_samp_fields: ResolverTypeWrapper<Company_Var_Samp_Fields>;
  company_var_samp_order_by: Company_Var_Samp_Order_By;
  company_variance_fields: ResolverTypeWrapper<Company_Variance_Fields>;
  company_variance_order_by: Company_Variance_Order_By;
  contractor: ResolverTypeWrapper<Contractor>;
  contractor_aggregate: ResolverTypeWrapper<Contractor_Aggregate>;
  contractor_aggregate_bool_exp: Contractor_Aggregate_Bool_Exp;
  contractor_aggregate_bool_exp_bool_and: Contractor_Aggregate_Bool_Exp_Bool_And;
  contractor_aggregate_bool_exp_bool_or: Contractor_Aggregate_Bool_Exp_Bool_Or;
  contractor_aggregate_bool_exp_count: Contractor_Aggregate_Bool_Exp_Count;
  contractor_aggregate_fields: ResolverTypeWrapper<Contractor_Aggregate_Fields>;
  contractor_aggregate_order_by: Contractor_Aggregate_Order_By;
  contractor_arr_rel_insert_input: Contractor_Arr_Rel_Insert_Input;
  contractor_avg_fields: ResolverTypeWrapper<Contractor_Avg_Fields>;
  contractor_avg_order_by: Contractor_Avg_Order_By;
  contractor_bool_exp: Contractor_Bool_Exp;
  contractor_constraint: Contractor_Constraint;
  contractor_inc_input: Contractor_Inc_Input;
  contractor_insert_input: Contractor_Insert_Input;
  contractor_max_fields: ResolverTypeWrapper<Contractor_Max_Fields>;
  contractor_max_order_by: Contractor_Max_Order_By;
  contractor_min_fields: ResolverTypeWrapper<Contractor_Min_Fields>;
  contractor_min_order_by: Contractor_Min_Order_By;
  contractor_mutation_response: ResolverTypeWrapper<Contractor_Mutation_Response>;
  contractor_note: ResolverTypeWrapper<Contractor_Note>;
  contractor_note_aggregate: ResolverTypeWrapper<Contractor_Note_Aggregate>;
  contractor_note_aggregate_bool_exp: Contractor_Note_Aggregate_Bool_Exp;
  contractor_note_aggregate_bool_exp_count: Contractor_Note_Aggregate_Bool_Exp_Count;
  contractor_note_aggregate_fields: ResolverTypeWrapper<Contractor_Note_Aggregate_Fields>;
  contractor_note_aggregate_order_by: Contractor_Note_Aggregate_Order_By;
  contractor_note_arr_rel_insert_input: Contractor_Note_Arr_Rel_Insert_Input;
  contractor_note_bool_exp: Contractor_Note_Bool_Exp;
  contractor_note_constraint: Contractor_Note_Constraint;
  contractor_note_insert_input: Contractor_Note_Insert_Input;
  contractor_note_max_fields: ResolverTypeWrapper<Contractor_Note_Max_Fields>;
  contractor_note_max_order_by: Contractor_Note_Max_Order_By;
  contractor_note_min_fields: ResolverTypeWrapper<Contractor_Note_Min_Fields>;
  contractor_note_min_order_by: Contractor_Note_Min_Order_By;
  contractor_note_mutation_response: ResolverTypeWrapper<Contractor_Note_Mutation_Response>;
  contractor_note_on_conflict: Contractor_Note_On_Conflict;
  contractor_note_order_by: Contractor_Note_Order_By;
  contractor_note_pk_columns_input: Contractor_Note_Pk_Columns_Input;
  contractor_note_select_column: Contractor_Note_Select_Column;
  contractor_note_set_input: Contractor_Note_Set_Input;
  contractor_note_stream_cursor_input: Contractor_Note_Stream_Cursor_Input;
  contractor_note_stream_cursor_value_input: Contractor_Note_Stream_Cursor_Value_Input;
  contractor_note_update_column: Contractor_Note_Update_Column;
  contractor_note_updates: Contractor_Note_Updates;
  contractor_obj_rel_insert_input: Contractor_Obj_Rel_Insert_Input;
  contractor_on_conflict: Contractor_On_Conflict;
  contractor_order_by: Contractor_Order_By;
  contractor_pk_columns_input: Contractor_Pk_Columns_Input;
  contractor_posting: ResolverTypeWrapper<Contractor_Posting>;
  contractor_posting_aggregate: ResolverTypeWrapper<Contractor_Posting_Aggregate>;
  contractor_posting_aggregate_bool_exp: Contractor_Posting_Aggregate_Bool_Exp;
  contractor_posting_aggregate_bool_exp_count: Contractor_Posting_Aggregate_Bool_Exp_Count;
  contractor_posting_aggregate_fields: ResolverTypeWrapper<Contractor_Posting_Aggregate_Fields>;
  contractor_posting_aggregate_order_by: Contractor_Posting_Aggregate_Order_By;
  contractor_posting_arr_rel_insert_input: Contractor_Posting_Arr_Rel_Insert_Input;
  contractor_posting_avg_fields: ResolverTypeWrapper<Contractor_Posting_Avg_Fields>;
  contractor_posting_avg_order_by: Contractor_Posting_Avg_Order_By;
  contractor_posting_bool_exp: Contractor_Posting_Bool_Exp;
  contractor_posting_constraint: Contractor_Posting_Constraint;
  contractor_posting_inc_input: Contractor_Posting_Inc_Input;
  contractor_posting_insert_input: Contractor_Posting_Insert_Input;
  contractor_posting_max_fields: ResolverTypeWrapper<Contractor_Posting_Max_Fields>;
  contractor_posting_max_order_by: Contractor_Posting_Max_Order_By;
  contractor_posting_min_fields: ResolverTypeWrapper<Contractor_Posting_Min_Fields>;
  contractor_posting_min_order_by: Contractor_Posting_Min_Order_By;
  contractor_posting_mutation_response: ResolverTypeWrapper<Contractor_Posting_Mutation_Response>;
  contractor_posting_on_conflict: Contractor_Posting_On_Conflict;
  contractor_posting_order_by: Contractor_Posting_Order_By;
  contractor_posting_pk_columns_input: Contractor_Posting_Pk_Columns_Input;
  contractor_posting_select_column: Contractor_Posting_Select_Column;
  contractor_posting_set_input: Contractor_Posting_Set_Input;
  contractor_posting_stddev_fields: ResolverTypeWrapper<Contractor_Posting_Stddev_Fields>;
  contractor_posting_stddev_order_by: Contractor_Posting_Stddev_Order_By;
  contractor_posting_stddev_pop_fields: ResolverTypeWrapper<Contractor_Posting_Stddev_Pop_Fields>;
  contractor_posting_stddev_pop_order_by: Contractor_Posting_Stddev_Pop_Order_By;
  contractor_posting_stddev_samp_fields: ResolverTypeWrapper<Contractor_Posting_Stddev_Samp_Fields>;
  contractor_posting_stddev_samp_order_by: Contractor_Posting_Stddev_Samp_Order_By;
  contractor_posting_stream_cursor_input: Contractor_Posting_Stream_Cursor_Input;
  contractor_posting_stream_cursor_value_input: Contractor_Posting_Stream_Cursor_Value_Input;
  contractor_posting_sum_fields: ResolverTypeWrapper<Contractor_Posting_Sum_Fields>;
  contractor_posting_sum_order_by: Contractor_Posting_Sum_Order_By;
  contractor_posting_update_column: Contractor_Posting_Update_Column;
  contractor_posting_updates: Contractor_Posting_Updates;
  contractor_posting_var_pop_fields: ResolverTypeWrapper<Contractor_Posting_Var_Pop_Fields>;
  contractor_posting_var_pop_order_by: Contractor_Posting_Var_Pop_Order_By;
  contractor_posting_var_samp_fields: ResolverTypeWrapper<Contractor_Posting_Var_Samp_Fields>;
  contractor_posting_var_samp_order_by: Contractor_Posting_Var_Samp_Order_By;
  contractor_posting_variance_fields: ResolverTypeWrapper<Contractor_Posting_Variance_Fields>;
  contractor_posting_variance_order_by: Contractor_Posting_Variance_Order_By;
  contractor_project: ResolverTypeWrapper<Contractor_Project>;
  contractor_project_aggregate: ResolverTypeWrapper<Contractor_Project_Aggregate>;
  contractor_project_aggregate_bool_exp: Contractor_Project_Aggregate_Bool_Exp;
  contractor_project_aggregate_bool_exp_count: Contractor_Project_Aggregate_Bool_Exp_Count;
  contractor_project_aggregate_fields: ResolverTypeWrapper<Contractor_Project_Aggregate_Fields>;
  contractor_project_aggregate_order_by: Contractor_Project_Aggregate_Order_By;
  contractor_project_arr_rel_insert_input: Contractor_Project_Arr_Rel_Insert_Input;
  contractor_project_bool_exp: Contractor_Project_Bool_Exp;
  contractor_project_constraint: Contractor_Project_Constraint;
  contractor_project_insert_input: Contractor_Project_Insert_Input;
  contractor_project_max_fields: ResolverTypeWrapper<Contractor_Project_Max_Fields>;
  contractor_project_max_order_by: Contractor_Project_Max_Order_By;
  contractor_project_min_fields: ResolverTypeWrapper<Contractor_Project_Min_Fields>;
  contractor_project_min_order_by: Contractor_Project_Min_Order_By;
  contractor_project_mutation_response: ResolverTypeWrapper<Contractor_Project_Mutation_Response>;
  contractor_project_on_conflict: Contractor_Project_On_Conflict;
  contractor_project_order_by: Contractor_Project_Order_By;
  contractor_project_pk_columns_input: Contractor_Project_Pk_Columns_Input;
  contractor_project_select_column: Contractor_Project_Select_Column;
  contractor_project_set_input: Contractor_Project_Set_Input;
  contractor_project_stream_cursor_input: Contractor_Project_Stream_Cursor_Input;
  contractor_project_stream_cursor_value_input: Contractor_Project_Stream_Cursor_Value_Input;
  contractor_project_update_column: Contractor_Project_Update_Column;
  contractor_project_updates: Contractor_Project_Updates;
  contractor_rating: ResolverTypeWrapper<Contractor_Rating>;
  contractor_rating_aggregate: ResolverTypeWrapper<Contractor_Rating_Aggregate>;
  contractor_rating_aggregate_bool_exp: Contractor_Rating_Aggregate_Bool_Exp;
  contractor_rating_aggregate_bool_exp_bool_and: Contractor_Rating_Aggregate_Bool_Exp_Bool_And;
  contractor_rating_aggregate_bool_exp_bool_or: Contractor_Rating_Aggregate_Bool_Exp_Bool_Or;
  contractor_rating_aggregate_bool_exp_count: Contractor_Rating_Aggregate_Bool_Exp_Count;
  contractor_rating_aggregate_fields: ResolverTypeWrapper<Contractor_Rating_Aggregate_Fields>;
  contractor_rating_aggregate_order_by: Contractor_Rating_Aggregate_Order_By;
  contractor_rating_arr_rel_insert_input: Contractor_Rating_Arr_Rel_Insert_Input;
  contractor_rating_avg_fields: ResolverTypeWrapper<Contractor_Rating_Avg_Fields>;
  contractor_rating_avg_order_by: Contractor_Rating_Avg_Order_By;
  contractor_rating_bool_exp: Contractor_Rating_Bool_Exp;
  contractor_rating_constraint: Contractor_Rating_Constraint;
  contractor_rating_inc_input: Contractor_Rating_Inc_Input;
  contractor_rating_insert_input: Contractor_Rating_Insert_Input;
  contractor_rating_max_fields: ResolverTypeWrapper<Contractor_Rating_Max_Fields>;
  contractor_rating_max_order_by: Contractor_Rating_Max_Order_By;
  contractor_rating_min_fields: ResolverTypeWrapper<Contractor_Rating_Min_Fields>;
  contractor_rating_min_order_by: Contractor_Rating_Min_Order_By;
  contractor_rating_mutation_response: ResolverTypeWrapper<Contractor_Rating_Mutation_Response>;
  contractor_rating_on_conflict: Contractor_Rating_On_Conflict;
  contractor_rating_order_by: Contractor_Rating_Order_By;
  contractor_rating_pk_columns_input: Contractor_Rating_Pk_Columns_Input;
  contractor_rating_select_column: Contractor_Rating_Select_Column;
  contractor_rating_select_column_contractor_rating_aggregate_bool_exp_bool_and_arguments_columns: Contractor_Rating_Select_Column_Contractor_Rating_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  contractor_rating_select_column_contractor_rating_aggregate_bool_exp_bool_or_arguments_columns: Contractor_Rating_Select_Column_Contractor_Rating_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  contractor_rating_set_input: Contractor_Rating_Set_Input;
  contractor_rating_stddev_fields: ResolverTypeWrapper<Contractor_Rating_Stddev_Fields>;
  contractor_rating_stddev_order_by: Contractor_Rating_Stddev_Order_By;
  contractor_rating_stddev_pop_fields: ResolverTypeWrapper<Contractor_Rating_Stddev_Pop_Fields>;
  contractor_rating_stddev_pop_order_by: Contractor_Rating_Stddev_Pop_Order_By;
  contractor_rating_stddev_samp_fields: ResolverTypeWrapper<Contractor_Rating_Stddev_Samp_Fields>;
  contractor_rating_stddev_samp_order_by: Contractor_Rating_Stddev_Samp_Order_By;
  contractor_rating_stream_cursor_input: Contractor_Rating_Stream_Cursor_Input;
  contractor_rating_stream_cursor_value_input: Contractor_Rating_Stream_Cursor_Value_Input;
  contractor_rating_sum_fields: ResolverTypeWrapper<Contractor_Rating_Sum_Fields>;
  contractor_rating_sum_order_by: Contractor_Rating_Sum_Order_By;
  contractor_rating_update_column: Contractor_Rating_Update_Column;
  contractor_rating_updates: Contractor_Rating_Updates;
  contractor_rating_var_pop_fields: ResolverTypeWrapper<Contractor_Rating_Var_Pop_Fields>;
  contractor_rating_var_pop_order_by: Contractor_Rating_Var_Pop_Order_By;
  contractor_rating_var_samp_fields: ResolverTypeWrapper<Contractor_Rating_Var_Samp_Fields>;
  contractor_rating_var_samp_order_by: Contractor_Rating_Var_Samp_Order_By;
  contractor_rating_variance_fields: ResolverTypeWrapper<Contractor_Rating_Variance_Fields>;
  contractor_rating_variance_order_by: Contractor_Rating_Variance_Order_By;
  contractor_select_column: Contractor_Select_Column;
  contractor_select_column_contractor_aggregate_bool_exp_bool_and_arguments_columns: Contractor_Select_Column_Contractor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  contractor_select_column_contractor_aggregate_bool_exp_bool_or_arguments_columns: Contractor_Select_Column_Contractor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  contractor_set_input: Contractor_Set_Input;
  contractor_staff_note: ResolverTypeWrapper<Contractor_Staff_Note>;
  contractor_staff_note_aggregate: ResolverTypeWrapper<Contractor_Staff_Note_Aggregate>;
  contractor_staff_note_aggregate_bool_exp: Contractor_Staff_Note_Aggregate_Bool_Exp;
  contractor_staff_note_aggregate_bool_exp_count: Contractor_Staff_Note_Aggregate_Bool_Exp_Count;
  contractor_staff_note_aggregate_fields: ResolverTypeWrapper<Contractor_Staff_Note_Aggregate_Fields>;
  contractor_staff_note_aggregate_order_by: Contractor_Staff_Note_Aggregate_Order_By;
  contractor_staff_note_arr_rel_insert_input: Contractor_Staff_Note_Arr_Rel_Insert_Input;
  contractor_staff_note_bool_exp: Contractor_Staff_Note_Bool_Exp;
  contractor_staff_note_constraint: Contractor_Staff_Note_Constraint;
  contractor_staff_note_insert_input: Contractor_Staff_Note_Insert_Input;
  contractor_staff_note_max_fields: ResolverTypeWrapper<Contractor_Staff_Note_Max_Fields>;
  contractor_staff_note_max_order_by: Contractor_Staff_Note_Max_Order_By;
  contractor_staff_note_min_fields: ResolverTypeWrapper<Contractor_Staff_Note_Min_Fields>;
  contractor_staff_note_min_order_by: Contractor_Staff_Note_Min_Order_By;
  contractor_staff_note_mutation_response: ResolverTypeWrapper<Contractor_Staff_Note_Mutation_Response>;
  contractor_staff_note_on_conflict: Contractor_Staff_Note_On_Conflict;
  contractor_staff_note_order_by: Contractor_Staff_Note_Order_By;
  contractor_staff_note_pk_columns_input: Contractor_Staff_Note_Pk_Columns_Input;
  contractor_staff_note_select_column: Contractor_Staff_Note_Select_Column;
  contractor_staff_note_set_input: Contractor_Staff_Note_Set_Input;
  contractor_staff_note_stream_cursor_input: Contractor_Staff_Note_Stream_Cursor_Input;
  contractor_staff_note_stream_cursor_value_input: Contractor_Staff_Note_Stream_Cursor_Value_Input;
  contractor_staff_note_update_column: Contractor_Staff_Note_Update_Column;
  contractor_staff_note_updates: Contractor_Staff_Note_Updates;
  contractor_stddev_fields: ResolverTypeWrapper<Contractor_Stddev_Fields>;
  contractor_stddev_order_by: Contractor_Stddev_Order_By;
  contractor_stddev_pop_fields: ResolverTypeWrapper<Contractor_Stddev_Pop_Fields>;
  contractor_stddev_pop_order_by: Contractor_Stddev_Pop_Order_By;
  contractor_stddev_samp_fields: ResolverTypeWrapper<Contractor_Stddev_Samp_Fields>;
  contractor_stddev_samp_order_by: Contractor_Stddev_Samp_Order_By;
  contractor_stream_cursor_input: Contractor_Stream_Cursor_Input;
  contractor_stream_cursor_value_input: Contractor_Stream_Cursor_Value_Input;
  contractor_sum_fields: ResolverTypeWrapper<Contractor_Sum_Fields>;
  contractor_sum_order_by: Contractor_Sum_Order_By;
  contractor_update_column: Contractor_Update_Column;
  contractor_updates: Contractor_Updates;
  contractor_var_pop_fields: ResolverTypeWrapper<Contractor_Var_Pop_Fields>;
  contractor_var_pop_order_by: Contractor_Var_Pop_Order_By;
  contractor_var_samp_fields: ResolverTypeWrapper<Contractor_Var_Samp_Fields>;
  contractor_var_samp_order_by: Contractor_Var_Samp_Order_By;
  contractor_variance_fields: ResolverTypeWrapper<Contractor_Variance_Fields>;
  contractor_variance_order_by: Contractor_Variance_Order_By;
  conversation: ResolverTypeWrapper<Conversation>;
  conversation_aggregate: ResolverTypeWrapper<Conversation_Aggregate>;
  conversation_aggregate_fields: ResolverTypeWrapper<Conversation_Aggregate_Fields>;
  conversation_bool_exp: Conversation_Bool_Exp;
  conversation_constraint: Conversation_Constraint;
  conversation_insert_input: Conversation_Insert_Input;
  conversation_max_fields: ResolverTypeWrapper<Conversation_Max_Fields>;
  conversation_min_fields: ResolverTypeWrapper<Conversation_Min_Fields>;
  conversation_mutation_response: ResolverTypeWrapper<Conversation_Mutation_Response>;
  conversation_obj_rel_insert_input: Conversation_Obj_Rel_Insert_Input;
  conversation_on_conflict: Conversation_On_Conflict;
  conversation_order_by: Conversation_Order_By;
  conversation_pk_columns_input: Conversation_Pk_Columns_Input;
  conversation_select_column: Conversation_Select_Column;
  conversation_set_input: Conversation_Set_Input;
  conversation_stream_cursor_input: Conversation_Stream_Cursor_Input;
  conversation_stream_cursor_value_input: Conversation_Stream_Cursor_Value_Input;
  conversation_update_column: Conversation_Update_Column;
  conversation_updates: Conversation_Updates;
  currency: ResolverTypeWrapper<Scalars['currency']>;
  currency_comparison_exp: Currency_Comparison_Exp;
  cursor_ordering: Cursor_Ordering;
  custom_request: ResolverTypeWrapper<Custom_Request>;
  custom_request_aggregate: ResolverTypeWrapper<Custom_Request_Aggregate>;
  custom_request_aggregate_bool_exp: Custom_Request_Aggregate_Bool_Exp;
  custom_request_aggregate_bool_exp_count: Custom_Request_Aggregate_Bool_Exp_Count;
  custom_request_aggregate_fields: ResolverTypeWrapper<Custom_Request_Aggregate_Fields>;
  custom_request_aggregate_order_by: Custom_Request_Aggregate_Order_By;
  custom_request_arr_rel_insert_input: Custom_Request_Arr_Rel_Insert_Input;
  custom_request_bool_exp: Custom_Request_Bool_Exp;
  custom_request_constraint: Custom_Request_Constraint;
  custom_request_insert_input: Custom_Request_Insert_Input;
  custom_request_max_fields: ResolverTypeWrapper<Custom_Request_Max_Fields>;
  custom_request_max_order_by: Custom_Request_Max_Order_By;
  custom_request_min_fields: ResolverTypeWrapper<Custom_Request_Min_Fields>;
  custom_request_min_order_by: Custom_Request_Min_Order_By;
  custom_request_mutation_response: ResolverTypeWrapper<Custom_Request_Mutation_Response>;
  custom_request_obj_rel_insert_input: Custom_Request_Obj_Rel_Insert_Input;
  custom_request_on_conflict: Custom_Request_On_Conflict;
  custom_request_order_by: Custom_Request_Order_By;
  custom_request_pk_columns_input: Custom_Request_Pk_Columns_Input;
  custom_request_select_column: Custom_Request_Select_Column;
  custom_request_set_input: Custom_Request_Set_Input;
  custom_request_skills: ResolverTypeWrapper<Custom_Request_Skills>;
  custom_request_skills_aggregate: ResolverTypeWrapper<Custom_Request_Skills_Aggregate>;
  custom_request_skills_aggregate_bool_exp: Custom_Request_Skills_Aggregate_Bool_Exp;
  custom_request_skills_aggregate_bool_exp_count: Custom_Request_Skills_Aggregate_Bool_Exp_Count;
  custom_request_skills_aggregate_fields: ResolverTypeWrapper<Custom_Request_Skills_Aggregate_Fields>;
  custom_request_skills_aggregate_order_by: Custom_Request_Skills_Aggregate_Order_By;
  custom_request_skills_arr_rel_insert_input: Custom_Request_Skills_Arr_Rel_Insert_Input;
  custom_request_skills_avg_fields: ResolverTypeWrapper<Custom_Request_Skills_Avg_Fields>;
  custom_request_skills_avg_order_by: Custom_Request_Skills_Avg_Order_By;
  custom_request_skills_bool_exp: Custom_Request_Skills_Bool_Exp;
  custom_request_skills_constraint: Custom_Request_Skills_Constraint;
  custom_request_skills_inc_input: Custom_Request_Skills_Inc_Input;
  custom_request_skills_insert_input: Custom_Request_Skills_Insert_Input;
  custom_request_skills_max_fields: ResolverTypeWrapper<Custom_Request_Skills_Max_Fields>;
  custom_request_skills_max_order_by: Custom_Request_Skills_Max_Order_By;
  custom_request_skills_min_fields: ResolverTypeWrapper<Custom_Request_Skills_Min_Fields>;
  custom_request_skills_min_order_by: Custom_Request_Skills_Min_Order_By;
  custom_request_skills_mutation_response: ResolverTypeWrapper<Custom_Request_Skills_Mutation_Response>;
  custom_request_skills_on_conflict: Custom_Request_Skills_On_Conflict;
  custom_request_skills_order_by: Custom_Request_Skills_Order_By;
  custom_request_skills_pk_columns_input: Custom_Request_Skills_Pk_Columns_Input;
  custom_request_skills_select_column: Custom_Request_Skills_Select_Column;
  custom_request_skills_set_input: Custom_Request_Skills_Set_Input;
  custom_request_skills_stddev_fields: ResolverTypeWrapper<Custom_Request_Skills_Stddev_Fields>;
  custom_request_skills_stddev_order_by: Custom_Request_Skills_Stddev_Order_By;
  custom_request_skills_stddev_pop_fields: ResolverTypeWrapper<Custom_Request_Skills_Stddev_Pop_Fields>;
  custom_request_skills_stddev_pop_order_by: Custom_Request_Skills_Stddev_Pop_Order_By;
  custom_request_skills_stddev_samp_fields: ResolverTypeWrapper<Custom_Request_Skills_Stddev_Samp_Fields>;
  custom_request_skills_stddev_samp_order_by: Custom_Request_Skills_Stddev_Samp_Order_By;
  custom_request_skills_stream_cursor_input: Custom_Request_Skills_Stream_Cursor_Input;
  custom_request_skills_stream_cursor_value_input: Custom_Request_Skills_Stream_Cursor_Value_Input;
  custom_request_skills_sum_fields: ResolverTypeWrapper<Custom_Request_Skills_Sum_Fields>;
  custom_request_skills_sum_order_by: Custom_Request_Skills_Sum_Order_By;
  custom_request_skills_update_column: Custom_Request_Skills_Update_Column;
  custom_request_skills_updates: Custom_Request_Skills_Updates;
  custom_request_skills_var_pop_fields: ResolverTypeWrapper<Custom_Request_Skills_Var_Pop_Fields>;
  custom_request_skills_var_pop_order_by: Custom_Request_Skills_Var_Pop_Order_By;
  custom_request_skills_var_samp_fields: ResolverTypeWrapper<Custom_Request_Skills_Var_Samp_Fields>;
  custom_request_skills_var_samp_order_by: Custom_Request_Skills_Var_Samp_Order_By;
  custom_request_skills_variance_fields: ResolverTypeWrapper<Custom_Request_Skills_Variance_Fields>;
  custom_request_skills_variance_order_by: Custom_Request_Skills_Variance_Order_By;
  custom_request_status: ResolverTypeWrapper<Scalars['custom_request_status']>;
  custom_request_status_comparison_exp: Custom_Request_Status_Comparison_Exp;
  custom_request_stream_cursor_input: Custom_Request_Stream_Cursor_Input;
  custom_request_stream_cursor_value_input: Custom_Request_Stream_Cursor_Value_Input;
  custom_request_update_column: Custom_Request_Update_Column;
  custom_request_updates: Custom_Request_Updates;
  date: ResolverTypeWrapper<Scalars['date']>;
  date_comparison_exp: Date_Comparison_Exp;
  declined_visit_matches: ResolverTypeWrapper<Declined_Visit_Matches>;
  declined_visit_matches_aggregate: ResolverTypeWrapper<Declined_Visit_Matches_Aggregate>;
  declined_visit_matches_aggregate_bool_exp: Declined_Visit_Matches_Aggregate_Bool_Exp;
  declined_visit_matches_aggregate_bool_exp_count: Declined_Visit_Matches_Aggregate_Bool_Exp_Count;
  declined_visit_matches_aggregate_fields: ResolverTypeWrapper<Declined_Visit_Matches_Aggregate_Fields>;
  declined_visit_matches_aggregate_order_by: Declined_Visit_Matches_Aggregate_Order_By;
  declined_visit_matches_arr_rel_insert_input: Declined_Visit_Matches_Arr_Rel_Insert_Input;
  declined_visit_matches_avg_fields: ResolverTypeWrapper<Declined_Visit_Matches_Avg_Fields>;
  declined_visit_matches_avg_order_by: Declined_Visit_Matches_Avg_Order_By;
  declined_visit_matches_bool_exp: Declined_Visit_Matches_Bool_Exp;
  declined_visit_matches_constraint: Declined_Visit_Matches_Constraint;
  declined_visit_matches_inc_input: Declined_Visit_Matches_Inc_Input;
  declined_visit_matches_insert_input: Declined_Visit_Matches_Insert_Input;
  declined_visit_matches_max_fields: ResolverTypeWrapper<Declined_Visit_Matches_Max_Fields>;
  declined_visit_matches_max_order_by: Declined_Visit_Matches_Max_Order_By;
  declined_visit_matches_min_fields: ResolverTypeWrapper<Declined_Visit_Matches_Min_Fields>;
  declined_visit_matches_min_order_by: Declined_Visit_Matches_Min_Order_By;
  declined_visit_matches_mutation_response: ResolverTypeWrapper<Declined_Visit_Matches_Mutation_Response>;
  declined_visit_matches_on_conflict: Declined_Visit_Matches_On_Conflict;
  declined_visit_matches_order_by: Declined_Visit_Matches_Order_By;
  declined_visit_matches_pk_columns_input: Declined_Visit_Matches_Pk_Columns_Input;
  declined_visit_matches_select_column: Declined_Visit_Matches_Select_Column;
  declined_visit_matches_set_input: Declined_Visit_Matches_Set_Input;
  declined_visit_matches_stddev_fields: ResolverTypeWrapper<Declined_Visit_Matches_Stddev_Fields>;
  declined_visit_matches_stddev_order_by: Declined_Visit_Matches_Stddev_Order_By;
  declined_visit_matches_stddev_pop_fields: ResolverTypeWrapper<Declined_Visit_Matches_Stddev_Pop_Fields>;
  declined_visit_matches_stddev_pop_order_by: Declined_Visit_Matches_Stddev_Pop_Order_By;
  declined_visit_matches_stddev_samp_fields: ResolverTypeWrapper<Declined_Visit_Matches_Stddev_Samp_Fields>;
  declined_visit_matches_stddev_samp_order_by: Declined_Visit_Matches_Stddev_Samp_Order_By;
  declined_visit_matches_stream_cursor_input: Declined_Visit_Matches_Stream_Cursor_Input;
  declined_visit_matches_stream_cursor_value_input: Declined_Visit_Matches_Stream_Cursor_Value_Input;
  declined_visit_matches_sum_fields: ResolverTypeWrapper<Declined_Visit_Matches_Sum_Fields>;
  declined_visit_matches_sum_order_by: Declined_Visit_Matches_Sum_Order_By;
  declined_visit_matches_update_column: Declined_Visit_Matches_Update_Column;
  declined_visit_matches_updates: Declined_Visit_Matches_Updates;
  declined_visit_matches_var_pop_fields: ResolverTypeWrapper<Declined_Visit_Matches_Var_Pop_Fields>;
  declined_visit_matches_var_pop_order_by: Declined_Visit_Matches_Var_Pop_Order_By;
  declined_visit_matches_var_samp_fields: ResolverTypeWrapper<Declined_Visit_Matches_Var_Samp_Fields>;
  declined_visit_matches_var_samp_order_by: Declined_Visit_Matches_Var_Samp_Order_By;
  declined_visit_matches_variance_fields: ResolverTypeWrapper<Declined_Visit_Matches_Variance_Fields>;
  declined_visit_matches_variance_order_by: Declined_Visit_Matches_Variance_Order_By;
  document: ResolverTypeWrapper<Document>;
  document_aggregate: ResolverTypeWrapper<Document_Aggregate>;
  document_aggregate_bool_exp: Document_Aggregate_Bool_Exp;
  document_aggregate_bool_exp_count: Document_Aggregate_Bool_Exp_Count;
  document_aggregate_fields: ResolverTypeWrapper<Document_Aggregate_Fields>;
  document_aggregate_order_by: Document_Aggregate_Order_By;
  document_arr_rel_insert_input: Document_Arr_Rel_Insert_Input;
  document_bool_exp: Document_Bool_Exp;
  document_constraint: Document_Constraint;
  document_contractor_access: ResolverTypeWrapper<Document_Contractor_Access>;
  document_contractor_access_aggregate: ResolverTypeWrapper<Document_Contractor_Access_Aggregate>;
  document_contractor_access_aggregate_bool_exp: Document_Contractor_Access_Aggregate_Bool_Exp;
  document_contractor_access_aggregate_bool_exp_count: Document_Contractor_Access_Aggregate_Bool_Exp_Count;
  document_contractor_access_aggregate_fields: ResolverTypeWrapper<Document_Contractor_Access_Aggregate_Fields>;
  document_contractor_access_aggregate_order_by: Document_Contractor_Access_Aggregate_Order_By;
  document_contractor_access_arr_rel_insert_input: Document_Contractor_Access_Arr_Rel_Insert_Input;
  document_contractor_access_bool_exp: Document_Contractor_Access_Bool_Exp;
  document_contractor_access_constraint: Document_Contractor_Access_Constraint;
  document_contractor_access_insert_input: Document_Contractor_Access_Insert_Input;
  document_contractor_access_max_fields: ResolverTypeWrapper<Document_Contractor_Access_Max_Fields>;
  document_contractor_access_max_order_by: Document_Contractor_Access_Max_Order_By;
  document_contractor_access_min_fields: ResolverTypeWrapper<Document_Contractor_Access_Min_Fields>;
  document_contractor_access_min_order_by: Document_Contractor_Access_Min_Order_By;
  document_contractor_access_mutation_response: ResolverTypeWrapper<Document_Contractor_Access_Mutation_Response>;
  document_contractor_access_on_conflict: Document_Contractor_Access_On_Conflict;
  document_contractor_access_order_by: Document_Contractor_Access_Order_By;
  document_contractor_access_pk_columns_input: Document_Contractor_Access_Pk_Columns_Input;
  document_contractor_access_select_column: Document_Contractor_Access_Select_Column;
  document_contractor_access_set_input: Document_Contractor_Access_Set_Input;
  document_contractor_access_stream_cursor_input: Document_Contractor_Access_Stream_Cursor_Input;
  document_contractor_access_stream_cursor_value_input: Document_Contractor_Access_Stream_Cursor_Value_Input;
  document_contractor_access_update_column: Document_Contractor_Access_Update_Column;
  document_contractor_access_updates: Document_Contractor_Access_Updates;
  document_custom_request: ResolverTypeWrapper<Document_Custom_Request>;
  document_custom_request_aggregate: ResolverTypeWrapper<Document_Custom_Request_Aggregate>;
  document_custom_request_aggregate_bool_exp: Document_Custom_Request_Aggregate_Bool_Exp;
  document_custom_request_aggregate_bool_exp_count: Document_Custom_Request_Aggregate_Bool_Exp_Count;
  document_custom_request_aggregate_fields: ResolverTypeWrapper<Document_Custom_Request_Aggregate_Fields>;
  document_custom_request_aggregate_order_by: Document_Custom_Request_Aggregate_Order_By;
  document_custom_request_arr_rel_insert_input: Document_Custom_Request_Arr_Rel_Insert_Input;
  document_custom_request_bool_exp: Document_Custom_Request_Bool_Exp;
  document_custom_request_constraint: Document_Custom_Request_Constraint;
  document_custom_request_insert_input: Document_Custom_Request_Insert_Input;
  document_custom_request_max_fields: ResolverTypeWrapper<Document_Custom_Request_Max_Fields>;
  document_custom_request_max_order_by: Document_Custom_Request_Max_Order_By;
  document_custom_request_min_fields: ResolverTypeWrapper<Document_Custom_Request_Min_Fields>;
  document_custom_request_min_order_by: Document_Custom_Request_Min_Order_By;
  document_custom_request_mutation_response: ResolverTypeWrapper<Document_Custom_Request_Mutation_Response>;
  document_custom_request_on_conflict: Document_Custom_Request_On_Conflict;
  document_custom_request_order_by: Document_Custom_Request_Order_By;
  document_custom_request_pk_columns_input: Document_Custom_Request_Pk_Columns_Input;
  document_custom_request_select_column: Document_Custom_Request_Select_Column;
  document_custom_request_set_input: Document_Custom_Request_Set_Input;
  document_custom_request_stream_cursor_input: Document_Custom_Request_Stream_Cursor_Input;
  document_custom_request_stream_cursor_value_input: Document_Custom_Request_Stream_Cursor_Value_Input;
  document_custom_request_update_column: Document_Custom_Request_Update_Column;
  document_custom_request_updates: Document_Custom_Request_Updates;
  document_insert_input: Document_Insert_Input;
  document_max_fields: ResolverTypeWrapper<Document_Max_Fields>;
  document_max_order_by: Document_Max_Order_By;
  document_min_fields: ResolverTypeWrapper<Document_Min_Fields>;
  document_min_order_by: Document_Min_Order_By;
  document_mutation_response: ResolverTypeWrapper<Document_Mutation_Response>;
  document_obj_rel_insert_input: Document_Obj_Rel_Insert_Input;
  document_on_conflict: Document_On_Conflict;
  document_order_by: Document_Order_By;
  document_pk_columns_input: Document_Pk_Columns_Input;
  document_project: ResolverTypeWrapper<Document_Project>;
  document_project_access_scope: ResolverTypeWrapper<Scalars['document_project_access_scope']>;
  document_project_access_scope_comparison_exp: Document_Project_Access_Scope_Comparison_Exp;
  document_project_aggregate: ResolverTypeWrapper<Document_Project_Aggregate>;
  document_project_aggregate_bool_exp: Document_Project_Aggregate_Bool_Exp;
  document_project_aggregate_bool_exp_bool_and: Document_Project_Aggregate_Bool_Exp_Bool_And;
  document_project_aggregate_bool_exp_bool_or: Document_Project_Aggregate_Bool_Exp_Bool_Or;
  document_project_aggregate_bool_exp_count: Document_Project_Aggregate_Bool_Exp_Count;
  document_project_aggregate_fields: ResolverTypeWrapper<Document_Project_Aggregate_Fields>;
  document_project_aggregate_order_by: Document_Project_Aggregate_Order_By;
  document_project_arr_rel_insert_input: Document_Project_Arr_Rel_Insert_Input;
  document_project_bool_exp: Document_Project_Bool_Exp;
  document_project_constraint: Document_Project_Constraint;
  document_project_insert_input: Document_Project_Insert_Input;
  document_project_max_fields: ResolverTypeWrapper<Document_Project_Max_Fields>;
  document_project_max_order_by: Document_Project_Max_Order_By;
  document_project_min_fields: ResolverTypeWrapper<Document_Project_Min_Fields>;
  document_project_min_order_by: Document_Project_Min_Order_By;
  document_project_mutation_response: ResolverTypeWrapper<Document_Project_Mutation_Response>;
  document_project_on_conflict: Document_Project_On_Conflict;
  document_project_order_by: Document_Project_Order_By;
  document_project_pk_columns_input: Document_Project_Pk_Columns_Input;
  document_project_select_column: Document_Project_Select_Column;
  document_project_select_column_document_project_aggregate_bool_exp_bool_and_arguments_columns: Document_Project_Select_Column_Document_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  document_project_select_column_document_project_aggregate_bool_exp_bool_or_arguments_columns: Document_Project_Select_Column_Document_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  document_project_set_input: Document_Project_Set_Input;
  document_project_stream_cursor_input: Document_Project_Stream_Cursor_Input;
  document_project_stream_cursor_value_input: Document_Project_Stream_Cursor_Value_Input;
  document_project_update_column: Document_Project_Update_Column;
  document_project_updates: Document_Project_Updates;
  document_select_column: Document_Select_Column;
  document_set_input: Document_Set_Input;
  document_stream_cursor_input: Document_Stream_Cursor_Input;
  document_stream_cursor_value_input: Document_Stream_Cursor_Value_Input;
  document_update_column: Document_Update_Column;
  document_updates: Document_Updates;
  document_user: ResolverTypeWrapper<Document_User>;
  document_user_aggregate: ResolverTypeWrapper<Document_User_Aggregate>;
  document_user_aggregate_bool_exp: Document_User_Aggregate_Bool_Exp;
  document_user_aggregate_bool_exp_count: Document_User_Aggregate_Bool_Exp_Count;
  document_user_aggregate_fields: ResolverTypeWrapper<Document_User_Aggregate_Fields>;
  document_user_aggregate_order_by: Document_User_Aggregate_Order_By;
  document_user_arr_rel_insert_input: Document_User_Arr_Rel_Insert_Input;
  document_user_bool_exp: Document_User_Bool_Exp;
  document_user_constraint: Document_User_Constraint;
  document_user_insert_input: Document_User_Insert_Input;
  document_user_max_fields: ResolverTypeWrapper<Document_User_Max_Fields>;
  document_user_max_order_by: Document_User_Max_Order_By;
  document_user_min_fields: ResolverTypeWrapper<Document_User_Min_Fields>;
  document_user_min_order_by: Document_User_Min_Order_By;
  document_user_mutation_response: ResolverTypeWrapper<Document_User_Mutation_Response>;
  document_user_on_conflict: Document_User_On_Conflict;
  document_user_order_by: Document_User_Order_By;
  document_user_pk_columns_input: Document_User_Pk_Columns_Input;
  document_user_select_column: Document_User_Select_Column;
  document_user_set_input: Document_User_Set_Input;
  document_user_stream_cursor_input: Document_User_Stream_Cursor_Input;
  document_user_stream_cursor_value_input: Document_User_Stream_Cursor_Value_Input;
  document_user_update_column: Document_User_Update_Column;
  document_user_updates: Document_User_Updates;
  email_regex: ResolverTypeWrapper<Email_Regex>;
  email_regex_aggregate: ResolverTypeWrapper<Email_Regex_Aggregate>;
  email_regex_aggregate_fields: ResolverTypeWrapper<Email_Regex_Aggregate_Fields>;
  email_regex_avg_fields: ResolverTypeWrapper<Email_Regex_Avg_Fields>;
  email_regex_bool_exp: Email_Regex_Bool_Exp;
  email_regex_constraint: Email_Regex_Constraint;
  email_regex_inc_input: Email_Regex_Inc_Input;
  email_regex_insert_input: Email_Regex_Insert_Input;
  email_regex_max_fields: ResolverTypeWrapper<Email_Regex_Max_Fields>;
  email_regex_min_fields: ResolverTypeWrapper<Email_Regex_Min_Fields>;
  email_regex_mutation_response: ResolverTypeWrapper<Email_Regex_Mutation_Response>;
  email_regex_on_conflict: Email_Regex_On_Conflict;
  email_regex_order_by: Email_Regex_Order_By;
  email_regex_pk_columns_input: Email_Regex_Pk_Columns_Input;
  email_regex_select_column: Email_Regex_Select_Column;
  email_regex_set_input: Email_Regex_Set_Input;
  email_regex_stddev_fields: ResolverTypeWrapper<Email_Regex_Stddev_Fields>;
  email_regex_stddev_pop_fields: ResolverTypeWrapper<Email_Regex_Stddev_Pop_Fields>;
  email_regex_stddev_samp_fields: ResolverTypeWrapper<Email_Regex_Stddev_Samp_Fields>;
  email_regex_stream_cursor_input: Email_Regex_Stream_Cursor_Input;
  email_regex_stream_cursor_value_input: Email_Regex_Stream_Cursor_Value_Input;
  email_regex_sum_fields: ResolverTypeWrapper<Email_Regex_Sum_Fields>;
  email_regex_update_column: Email_Regex_Update_Column;
  email_regex_updates: Email_Regex_Updates;
  email_regex_var_pop_fields: ResolverTypeWrapper<Email_Regex_Var_Pop_Fields>;
  email_regex_var_samp_fields: ResolverTypeWrapper<Email_Regex_Var_Samp_Fields>;
  email_regex_variance_fields: ResolverTypeWrapper<Email_Regex_Variance_Fields>;
  experience_skill: ResolverTypeWrapper<Experience_Skill>;
  experience_skill_aggregate: ResolverTypeWrapper<Experience_Skill_Aggregate>;
  experience_skill_aggregate_bool_exp: Experience_Skill_Aggregate_Bool_Exp;
  experience_skill_aggregate_bool_exp_count: Experience_Skill_Aggregate_Bool_Exp_Count;
  experience_skill_aggregate_fields: ResolverTypeWrapper<Experience_Skill_Aggregate_Fields>;
  experience_skill_aggregate_order_by: Experience_Skill_Aggregate_Order_By;
  experience_skill_arr_rel_insert_input: Experience_Skill_Arr_Rel_Insert_Input;
  experience_skill_avg_fields: ResolverTypeWrapper<Experience_Skill_Avg_Fields>;
  experience_skill_avg_order_by: Experience_Skill_Avg_Order_By;
  experience_skill_bool_exp: Experience_Skill_Bool_Exp;
  experience_skill_constraint: Experience_Skill_Constraint;
  experience_skill_inc_input: Experience_Skill_Inc_Input;
  experience_skill_insert_input: Experience_Skill_Insert_Input;
  experience_skill_max_fields: ResolverTypeWrapper<Experience_Skill_Max_Fields>;
  experience_skill_max_order_by: Experience_Skill_Max_Order_By;
  experience_skill_min_fields: ResolverTypeWrapper<Experience_Skill_Min_Fields>;
  experience_skill_min_order_by: Experience_Skill_Min_Order_By;
  experience_skill_mutation_response: ResolverTypeWrapper<Experience_Skill_Mutation_Response>;
  experience_skill_on_conflict: Experience_Skill_On_Conflict;
  experience_skill_order_by: Experience_Skill_Order_By;
  experience_skill_pk_columns_input: Experience_Skill_Pk_Columns_Input;
  experience_skill_select_column: Experience_Skill_Select_Column;
  experience_skill_set_input: Experience_Skill_Set_Input;
  experience_skill_stddev_fields: ResolverTypeWrapper<Experience_Skill_Stddev_Fields>;
  experience_skill_stddev_order_by: Experience_Skill_Stddev_Order_By;
  experience_skill_stddev_pop_fields: ResolverTypeWrapper<Experience_Skill_Stddev_Pop_Fields>;
  experience_skill_stddev_pop_order_by: Experience_Skill_Stddev_Pop_Order_By;
  experience_skill_stddev_samp_fields: ResolverTypeWrapper<Experience_Skill_Stddev_Samp_Fields>;
  experience_skill_stddev_samp_order_by: Experience_Skill_Stddev_Samp_Order_By;
  experience_skill_stream_cursor_input: Experience_Skill_Stream_Cursor_Input;
  experience_skill_stream_cursor_value_input: Experience_Skill_Stream_Cursor_Value_Input;
  experience_skill_sum_fields: ResolverTypeWrapper<Experience_Skill_Sum_Fields>;
  experience_skill_sum_order_by: Experience_Skill_Sum_Order_By;
  experience_skill_update_column: Experience_Skill_Update_Column;
  experience_skill_updates: Experience_Skill_Updates;
  experience_skill_var_pop_fields: ResolverTypeWrapper<Experience_Skill_Var_Pop_Fields>;
  experience_skill_var_pop_order_by: Experience_Skill_Var_Pop_Order_By;
  experience_skill_var_samp_fields: ResolverTypeWrapper<Experience_Skill_Var_Samp_Fields>;
  experience_skill_var_samp_order_by: Experience_Skill_Var_Samp_Order_By;
  experience_skill_variance_fields: ResolverTypeWrapper<Experience_Skill_Variance_Fields>;
  experience_skill_variance_order_by: Experience_Skill_Variance_Order_By;
  float8: ResolverTypeWrapper<Scalars['float8']>;
  float8_comparison_exp: Float8_Comparison_Exp;
  gender: ResolverTypeWrapper<Gender>;
  gender_aggregate: ResolverTypeWrapper<Gender_Aggregate>;
  gender_aggregate_fields: ResolverTypeWrapper<Gender_Aggregate_Fields>;
  gender_bool_exp: Gender_Bool_Exp;
  gender_constraint: Gender_Constraint;
  gender_enum: Gender_Enum;
  gender_enum_comparison_exp: Gender_Enum_Comparison_Exp;
  gender_insert_input: Gender_Insert_Input;
  gender_max_fields: ResolverTypeWrapper<Gender_Max_Fields>;
  gender_min_fields: ResolverTypeWrapper<Gender_Min_Fields>;
  gender_mutation_response: ResolverTypeWrapper<Gender_Mutation_Response>;
  gender_obj_rel_insert_input: Gender_Obj_Rel_Insert_Input;
  gender_on_conflict: Gender_On_Conflict;
  gender_order_by: Gender_Order_By;
  gender_pk_columns_input: Gender_Pk_Columns_Input;
  gender_select_column: Gender_Select_Column;
  gender_set_input: Gender_Set_Input;
  gender_stream_cursor_input: Gender_Stream_Cursor_Input;
  gender_stream_cursor_value_input: Gender_Stream_Cursor_Value_Input;
  gender_update_column: Gender_Update_Column;
  gender_updates: Gender_Updates;
  industry: ResolverTypeWrapper<Industry>;
  industry_aggregate: ResolverTypeWrapper<Industry_Aggregate>;
  industry_aggregate_fields: ResolverTypeWrapper<Industry_Aggregate_Fields>;
  industry_avg_fields: ResolverTypeWrapper<Industry_Avg_Fields>;
  industry_bool_exp: Industry_Bool_Exp;
  industry_constraint: Industry_Constraint;
  industry_inc_input: Industry_Inc_Input;
  industry_insert_input: Industry_Insert_Input;
  industry_max_fields: ResolverTypeWrapper<Industry_Max_Fields>;
  industry_min_fields: ResolverTypeWrapper<Industry_Min_Fields>;
  industry_mutation_response: ResolverTypeWrapper<Industry_Mutation_Response>;
  industry_obj_rel_insert_input: Industry_Obj_Rel_Insert_Input;
  industry_on_conflict: Industry_On_Conflict;
  industry_order_by: Industry_Order_By;
  industry_pk_columns_input: Industry_Pk_Columns_Input;
  industry_select_column: Industry_Select_Column;
  industry_set_input: Industry_Set_Input;
  industry_stddev_fields: ResolverTypeWrapper<Industry_Stddev_Fields>;
  industry_stddev_pop_fields: ResolverTypeWrapper<Industry_Stddev_Pop_Fields>;
  industry_stddev_samp_fields: ResolverTypeWrapper<Industry_Stddev_Samp_Fields>;
  industry_stream_cursor_input: Industry_Stream_Cursor_Input;
  industry_stream_cursor_value_input: Industry_Stream_Cursor_Value_Input;
  industry_sum_fields: ResolverTypeWrapper<Industry_Sum_Fields>;
  industry_update_column: Industry_Update_Column;
  industry_updates: Industry_Updates;
  industry_var_pop_fields: ResolverTypeWrapper<Industry_Var_Pop_Fields>;
  industry_var_samp_fields: ResolverTypeWrapper<Industry_Var_Samp_Fields>;
  industry_variance_fields: ResolverTypeWrapper<Industry_Variance_Fields>;
  invitation: ResolverTypeWrapper<Invitation>;
  invitation_aggregate: ResolverTypeWrapper<Invitation_Aggregate>;
  invitation_aggregate_bool_exp: Invitation_Aggregate_Bool_Exp;
  invitation_aggregate_bool_exp_bool_and: Invitation_Aggregate_Bool_Exp_Bool_And;
  invitation_aggregate_bool_exp_bool_or: Invitation_Aggregate_Bool_Exp_Bool_Or;
  invitation_aggregate_bool_exp_count: Invitation_Aggregate_Bool_Exp_Count;
  invitation_aggregate_fields: ResolverTypeWrapper<Invitation_Aggregate_Fields>;
  invitation_aggregate_order_by: Invitation_Aggregate_Order_By;
  invitation_arr_rel_insert_input: Invitation_Arr_Rel_Insert_Input;
  invitation_bool_exp: Invitation_Bool_Exp;
  invitation_constraint: Invitation_Constraint;
  invitation_insert_input: Invitation_Insert_Input;
  invitation_max_fields: ResolverTypeWrapper<Invitation_Max_Fields>;
  invitation_max_order_by: Invitation_Max_Order_By;
  invitation_min_fields: ResolverTypeWrapper<Invitation_Min_Fields>;
  invitation_min_order_by: Invitation_Min_Order_By;
  invitation_mutation_response: ResolverTypeWrapper<Invitation_Mutation_Response>;
  invitation_on_conflict: Invitation_On_Conflict;
  invitation_order_by: Invitation_Order_By;
  invitation_pk_columns_input: Invitation_Pk_Columns_Input;
  invitation_select_column: Invitation_Select_Column;
  invitation_select_column_invitation_aggregate_bool_exp_bool_and_arguments_columns: Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  invitation_select_column_invitation_aggregate_bool_exp_bool_or_arguments_columns: Invitation_Select_Column_Invitation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  invitation_set_input: Invitation_Set_Input;
  invitation_stream_cursor_input: Invitation_Stream_Cursor_Input;
  invitation_stream_cursor_value_input: Invitation_Stream_Cursor_Value_Input;
  invitation_update_column: Invitation_Update_Column;
  invitation_updates: Invitation_Updates;
  invoice: ResolverTypeWrapper<Invoice>;
  invoice_aggregate: ResolverTypeWrapper<Invoice_Aggregate>;
  invoice_aggregate_bool_exp: Invoice_Aggregate_Bool_Exp;
  invoice_aggregate_bool_exp_avg: Invoice_Aggregate_Bool_Exp_Avg;
  invoice_aggregate_bool_exp_bool_and: Invoice_Aggregate_Bool_Exp_Bool_And;
  invoice_aggregate_bool_exp_bool_or: Invoice_Aggregate_Bool_Exp_Bool_Or;
  invoice_aggregate_bool_exp_corr: Invoice_Aggregate_Bool_Exp_Corr;
  invoice_aggregate_bool_exp_corr_arguments: Invoice_Aggregate_Bool_Exp_Corr_Arguments;
  invoice_aggregate_bool_exp_count: Invoice_Aggregate_Bool_Exp_Count;
  invoice_aggregate_bool_exp_covar_samp: Invoice_Aggregate_Bool_Exp_Covar_Samp;
  invoice_aggregate_bool_exp_covar_samp_arguments: Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  invoice_aggregate_bool_exp_max: Invoice_Aggregate_Bool_Exp_Max;
  invoice_aggregate_bool_exp_min: Invoice_Aggregate_Bool_Exp_Min;
  invoice_aggregate_bool_exp_stddev_samp: Invoice_Aggregate_Bool_Exp_Stddev_Samp;
  invoice_aggregate_bool_exp_sum: Invoice_Aggregate_Bool_Exp_Sum;
  invoice_aggregate_bool_exp_var_samp: Invoice_Aggregate_Bool_Exp_Var_Samp;
  invoice_aggregate_fields: ResolverTypeWrapper<Invoice_Aggregate_Fields>;
  invoice_aggregate_order_by: Invoice_Aggregate_Order_By;
  invoice_append_input: Invoice_Append_Input;
  invoice_arr_rel_insert_input: Invoice_Arr_Rel_Insert_Input;
  invoice_avg_fields: ResolverTypeWrapper<Invoice_Avg_Fields>;
  invoice_avg_order_by: Invoice_Avg_Order_By;
  invoice_bool_exp: Invoice_Bool_Exp;
  invoice_constraint: Invoice_Constraint;
  invoice_delete_at_path_input: Invoice_Delete_At_Path_Input;
  invoice_delete_elem_input: Invoice_Delete_Elem_Input;
  invoice_delete_key_input: Invoice_Delete_Key_Input;
  invoice_inc_input: Invoice_Inc_Input;
  invoice_insert_input: Invoice_Insert_Input;
  invoice_max_fields: ResolverTypeWrapper<Invoice_Max_Fields>;
  invoice_max_order_by: Invoice_Max_Order_By;
  invoice_min_fields: ResolverTypeWrapper<Invoice_Min_Fields>;
  invoice_min_order_by: Invoice_Min_Order_By;
  invoice_mutation_response: ResolverTypeWrapper<Invoice_Mutation_Response>;
  invoice_on_conflict: Invoice_On_Conflict;
  invoice_order_by: Invoice_Order_By;
  invoice_pk_columns_input: Invoice_Pk_Columns_Input;
  invoice_prepend_input: Invoice_Prepend_Input;
  invoice_select_column: Invoice_Select_Column;
  invoice_select_column_invoice_aggregate_bool_exp_avg_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_bool_and_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_bool_or_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_corr_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_covar_samp_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_max_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Max_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_min_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Min_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_stddev_samp_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_sum_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  invoice_select_column_invoice_aggregate_bool_exp_var_samp_arguments_columns: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  invoice_set_input: Invoice_Set_Input;
  invoice_stddev_fields: ResolverTypeWrapper<Invoice_Stddev_Fields>;
  invoice_stddev_order_by: Invoice_Stddev_Order_By;
  invoice_stddev_pop_fields: ResolverTypeWrapper<Invoice_Stddev_Pop_Fields>;
  invoice_stddev_pop_order_by: Invoice_Stddev_Pop_Order_By;
  invoice_stddev_samp_fields: ResolverTypeWrapper<Invoice_Stddev_Samp_Fields>;
  invoice_stddev_samp_order_by: Invoice_Stddev_Samp_Order_By;
  invoice_stream_cursor_input: Invoice_Stream_Cursor_Input;
  invoice_stream_cursor_value_input: Invoice_Stream_Cursor_Value_Input;
  invoice_sum_fields: ResolverTypeWrapper<Invoice_Sum_Fields>;
  invoice_sum_order_by: Invoice_Sum_Order_By;
  invoice_update_column: Invoice_Update_Column;
  invoice_updates: Invoice_Updates;
  invoice_var_pop_fields: ResolverTypeWrapper<Invoice_Var_Pop_Fields>;
  invoice_var_pop_order_by: Invoice_Var_Pop_Order_By;
  invoice_var_samp_fields: ResolverTypeWrapper<Invoice_Var_Samp_Fields>;
  invoice_var_samp_order_by: Invoice_Var_Samp_Order_By;
  invoice_variance_fields: ResolverTypeWrapper<Invoice_Variance_Fields>;
  invoice_variance_order_by: Invoice_Variance_Order_By;
  jsonb: ResolverTypeWrapper<Scalars['jsonb']>;
  jsonb_cast_exp: Jsonb_Cast_Exp;
  jsonb_comparison_exp: Jsonb_Comparison_Exp;
  language: ResolverTypeWrapper<Language>;
  language_aggregate: ResolverTypeWrapper<Language_Aggregate>;
  language_aggregate_fields: ResolverTypeWrapper<Language_Aggregate_Fields>;
  language_avg_fields: ResolverTypeWrapper<Language_Avg_Fields>;
  language_bool_exp: Language_Bool_Exp;
  language_constraint: Language_Constraint;
  language_inc_input: Language_Inc_Input;
  language_insert_input: Language_Insert_Input;
  language_max_fields: ResolverTypeWrapper<Language_Max_Fields>;
  language_min_fields: ResolverTypeWrapper<Language_Min_Fields>;
  language_mutation_response: ResolverTypeWrapper<Language_Mutation_Response>;
  language_obj_rel_insert_input: Language_Obj_Rel_Insert_Input;
  language_on_conflict: Language_On_Conflict;
  language_order_by: Language_Order_By;
  language_pk_columns_input: Language_Pk_Columns_Input;
  language_select_column: Language_Select_Column;
  language_set_input: Language_Set_Input;
  language_stddev_fields: ResolverTypeWrapper<Language_Stddev_Fields>;
  language_stddev_pop_fields: ResolverTypeWrapper<Language_Stddev_Pop_Fields>;
  language_stddev_samp_fields: ResolverTypeWrapper<Language_Stddev_Samp_Fields>;
  language_stream_cursor_input: Language_Stream_Cursor_Input;
  language_stream_cursor_value_input: Language_Stream_Cursor_Value_Input;
  language_sum_fields: ResolverTypeWrapper<Language_Sum_Fields>;
  language_update_column: Language_Update_Column;
  language_updates: Language_Updates;
  language_var_pop_fields: ResolverTypeWrapper<Language_Var_Pop_Fields>;
  language_var_samp_fields: ResolverTypeWrapper<Language_Var_Samp_Fields>;
  language_variance_fields: ResolverTypeWrapper<Language_Variance_Fields>;
  manager: ResolverTypeWrapper<Manager>;
  manager_aggregate: ResolverTypeWrapper<Manager_Aggregate>;
  manager_aggregate_bool_exp: Manager_Aggregate_Bool_Exp;
  manager_aggregate_bool_exp_bool_and: Manager_Aggregate_Bool_Exp_Bool_And;
  manager_aggregate_bool_exp_bool_or: Manager_Aggregate_Bool_Exp_Bool_Or;
  manager_aggregate_bool_exp_count: Manager_Aggregate_Bool_Exp_Count;
  manager_aggregate_fields: ResolverTypeWrapper<Manager_Aggregate_Fields>;
  manager_aggregate_order_by: Manager_Aggregate_Order_By;
  manager_arr_rel_insert_input: Manager_Arr_Rel_Insert_Input;
  manager_bool_exp: Manager_Bool_Exp;
  manager_constraint: Manager_Constraint;
  manager_contractor: ResolverTypeWrapper<Manager_Contractor>;
  manager_contractor_aggregate: ResolverTypeWrapper<Manager_Contractor_Aggregate>;
  manager_contractor_aggregate_bool_exp: Manager_Contractor_Aggregate_Bool_Exp;
  manager_contractor_aggregate_bool_exp_bool_and: Manager_Contractor_Aggregate_Bool_Exp_Bool_And;
  manager_contractor_aggregate_bool_exp_bool_or: Manager_Contractor_Aggregate_Bool_Exp_Bool_Or;
  manager_contractor_aggregate_bool_exp_count: Manager_Contractor_Aggregate_Bool_Exp_Count;
  manager_contractor_aggregate_fields: ResolverTypeWrapper<Manager_Contractor_Aggregate_Fields>;
  manager_contractor_aggregate_order_by: Manager_Contractor_Aggregate_Order_By;
  manager_contractor_arr_rel_insert_input: Manager_Contractor_Arr_Rel_Insert_Input;
  manager_contractor_bool_exp: Manager_Contractor_Bool_Exp;
  manager_contractor_constraint: Manager_Contractor_Constraint;
  manager_contractor_insert_input: Manager_Contractor_Insert_Input;
  manager_contractor_max_fields: ResolverTypeWrapper<Manager_Contractor_Max_Fields>;
  manager_contractor_max_order_by: Manager_Contractor_Max_Order_By;
  manager_contractor_min_fields: ResolverTypeWrapper<Manager_Contractor_Min_Fields>;
  manager_contractor_min_order_by: Manager_Contractor_Min_Order_By;
  manager_contractor_mutation_response: ResolverTypeWrapper<Manager_Contractor_Mutation_Response>;
  manager_contractor_on_conflict: Manager_Contractor_On_Conflict;
  manager_contractor_order_by: Manager_Contractor_Order_By;
  manager_contractor_pk_columns_input: Manager_Contractor_Pk_Columns_Input;
  manager_contractor_select_column: Manager_Contractor_Select_Column;
  manager_contractor_select_column_manager_contractor_aggregate_bool_exp_bool_and_arguments_columns: Manager_Contractor_Select_Column_Manager_Contractor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  manager_contractor_select_column_manager_contractor_aggregate_bool_exp_bool_or_arguments_columns: Manager_Contractor_Select_Column_Manager_Contractor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  manager_contractor_set_input: Manager_Contractor_Set_Input;
  manager_contractor_stream_cursor_input: Manager_Contractor_Stream_Cursor_Input;
  manager_contractor_stream_cursor_value_input: Manager_Contractor_Stream_Cursor_Value_Input;
  manager_contractor_update_column: Manager_Contractor_Update_Column;
  manager_contractor_updates: Manager_Contractor_Updates;
  manager_insert_input: Manager_Insert_Input;
  manager_max_fields: ResolverTypeWrapper<Manager_Max_Fields>;
  manager_max_order_by: Manager_Max_Order_By;
  manager_min_fields: ResolverTypeWrapper<Manager_Min_Fields>;
  manager_min_order_by: Manager_Min_Order_By;
  manager_mutation_response: ResolverTypeWrapper<Manager_Mutation_Response>;
  manager_obj_rel_insert_input: Manager_Obj_Rel_Insert_Input;
  manager_on_conflict: Manager_On_Conflict;
  manager_order_by: Manager_Order_By;
  manager_pk_columns_input: Manager_Pk_Columns_Input;
  manager_select_column: Manager_Select_Column;
  manager_select_column_manager_aggregate_bool_exp_bool_and_arguments_columns: Manager_Select_Column_Manager_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  manager_select_column_manager_aggregate_bool_exp_bool_or_arguments_columns: Manager_Select_Column_Manager_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  manager_set_input: Manager_Set_Input;
  manager_stream_cursor_input: Manager_Stream_Cursor_Input;
  manager_stream_cursor_value_input: Manager_Stream_Cursor_Value_Input;
  manager_update_column: Manager_Update_Column;
  manager_updates: Manager_Updates;
  message: ResolverTypeWrapper<Message>;
  message_aggregate: ResolverTypeWrapper<Message_Aggregate>;
  message_aggregate_bool_exp: Message_Aggregate_Bool_Exp;
  message_aggregate_bool_exp_bool_and: Message_Aggregate_Bool_Exp_Bool_And;
  message_aggregate_bool_exp_bool_or: Message_Aggregate_Bool_Exp_Bool_Or;
  message_aggregate_bool_exp_count: Message_Aggregate_Bool_Exp_Count;
  message_aggregate_fields: ResolverTypeWrapper<Message_Aggregate_Fields>;
  message_aggregate_order_by: Message_Aggregate_Order_By;
  message_arr_rel_insert_input: Message_Arr_Rel_Insert_Input;
  message_bool_exp: Message_Bool_Exp;
  message_constraint: Message_Constraint;
  message_insert_input: Message_Insert_Input;
  message_max_fields: ResolverTypeWrapper<Message_Max_Fields>;
  message_max_order_by: Message_Max_Order_By;
  message_min_fields: ResolverTypeWrapper<Message_Min_Fields>;
  message_min_order_by: Message_Min_Order_By;
  message_mutation_response: ResolverTypeWrapper<Message_Mutation_Response>;
  message_obj_rel_insert_input: Message_Obj_Rel_Insert_Input;
  message_on_conflict: Message_On_Conflict;
  message_order_by: Message_Order_By;
  message_pk_columns_input: Message_Pk_Columns_Input;
  message_select_column: Message_Select_Column;
  message_select_column_message_aggregate_bool_exp_bool_and_arguments_columns: Message_Select_Column_Message_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  message_select_column_message_aggregate_bool_exp_bool_or_arguments_columns: Message_Select_Column_Message_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  message_set_input: Message_Set_Input;
  message_stream_cursor_input: Message_Stream_Cursor_Input;
  message_stream_cursor_value_input: Message_Stream_Cursor_Value_Input;
  message_update_column: Message_Update_Column;
  message_updates: Message_Updates;
  mutation_root: ResolverTypeWrapper<{}>;
  notification: ResolverTypeWrapper<Notification>;
  notification_aggregate: ResolverTypeWrapper<Notification_Aggregate>;
  notification_aggregate_fields: ResolverTypeWrapper<Notification_Aggregate_Fields>;
  notification_bool_exp: Notification_Bool_Exp;
  notification_constraint: Notification_Constraint;
  notification_insert_input: Notification_Insert_Input;
  notification_max_fields: ResolverTypeWrapper<Notification_Max_Fields>;
  notification_min_fields: ResolverTypeWrapper<Notification_Min_Fields>;
  notification_mutation_response: ResolverTypeWrapper<Notification_Mutation_Response>;
  notification_on_conflict: Notification_On_Conflict;
  notification_order_by: Notification_Order_By;
  notification_pk_columns_input: Notification_Pk_Columns_Input;
  notification_select_column: Notification_Select_Column;
  notification_set_input: Notification_Set_Input;
  notification_stream_cursor_input: Notification_Stream_Cursor_Input;
  notification_stream_cursor_value_input: Notification_Stream_Cursor_Value_Input;
  notification_update_column: Notification_Update_Column;
  notification_updates: Notification_Updates;
  numeric: ResolverTypeWrapper<Scalars['numeric']>;
  numeric_comparison_exp: Numeric_Comparison_Exp;
  onboarding: ResolverTypeWrapper<Onboarding>;
  onboarding_aggregate: ResolverTypeWrapper<Onboarding_Aggregate>;
  onboarding_aggregate_bool_exp: Onboarding_Aggregate_Bool_Exp;
  onboarding_aggregate_bool_exp_count: Onboarding_Aggregate_Bool_Exp_Count;
  onboarding_aggregate_fields: ResolverTypeWrapper<Onboarding_Aggregate_Fields>;
  onboarding_aggregate_order_by: Onboarding_Aggregate_Order_By;
  onboarding_arr_rel_insert_input: Onboarding_Arr_Rel_Insert_Input;
  onboarding_bool_exp: Onboarding_Bool_Exp;
  onboarding_constraint: Onboarding_Constraint;
  onboarding_insert_input: Onboarding_Insert_Input;
  onboarding_max_fields: ResolverTypeWrapper<Onboarding_Max_Fields>;
  onboarding_max_order_by: Onboarding_Max_Order_By;
  onboarding_min_fields: ResolverTypeWrapper<Onboarding_Min_Fields>;
  onboarding_min_order_by: Onboarding_Min_Order_By;
  onboarding_mutation_response: ResolverTypeWrapper<Onboarding_Mutation_Response>;
  onboarding_on_conflict: Onboarding_On_Conflict;
  onboarding_order_by: Onboarding_Order_By;
  onboarding_pk_columns_input: Onboarding_Pk_Columns_Input;
  onboarding_select_column: Onboarding_Select_Column;
  onboarding_set_input: Onboarding_Set_Input;
  onboarding_stream_cursor_input: Onboarding_Stream_Cursor_Input;
  onboarding_stream_cursor_value_input: Onboarding_Stream_Cursor_Value_Input;
  onboarding_update_column: Onboarding_Update_Column;
  onboarding_updates: Onboarding_Updates;
  order_by: Order_By;
  payment_card: ResolverTypeWrapper<Payment_Card>;
  payment_card_aggregate: ResolverTypeWrapper<Payment_Card_Aggregate>;
  payment_card_aggregate_bool_exp: Payment_Card_Aggregate_Bool_Exp;
  payment_card_aggregate_bool_exp_count: Payment_Card_Aggregate_Bool_Exp_Count;
  payment_card_aggregate_fields: ResolverTypeWrapper<Payment_Card_Aggregate_Fields>;
  payment_card_aggregate_order_by: Payment_Card_Aggregate_Order_By;
  payment_card_arr_rel_insert_input: Payment_Card_Arr_Rel_Insert_Input;
  payment_card_bool_exp: Payment_Card_Bool_Exp;
  payment_card_constraint: Payment_Card_Constraint;
  payment_card_insert_input: Payment_Card_Insert_Input;
  payment_card_max_fields: ResolverTypeWrapper<Payment_Card_Max_Fields>;
  payment_card_max_order_by: Payment_Card_Max_Order_By;
  payment_card_min_fields: ResolverTypeWrapper<Payment_Card_Min_Fields>;
  payment_card_min_order_by: Payment_Card_Min_Order_By;
  payment_card_mutation_response: ResolverTypeWrapper<Payment_Card_Mutation_Response>;
  payment_card_obj_rel_insert_input: Payment_Card_Obj_Rel_Insert_Input;
  payment_card_on_conflict: Payment_Card_On_Conflict;
  payment_card_order_by: Payment_Card_Order_By;
  payment_card_pk_columns_input: Payment_Card_Pk_Columns_Input;
  payment_card_select_column: Payment_Card_Select_Column;
  payment_card_set_input: Payment_Card_Set_Input;
  payment_card_stream_cursor_input: Payment_Card_Stream_Cursor_Input;
  payment_card_stream_cursor_value_input: Payment_Card_Stream_Cursor_Value_Input;
  payment_card_update_column: Payment_Card_Update_Column;
  payment_card_updates: Payment_Card_Updates;
  posting: ResolverTypeWrapper<Posting>;
  posting_aggregate: ResolverTypeWrapper<Posting_Aggregate>;
  posting_aggregate_bool_exp: Posting_Aggregate_Bool_Exp;
  posting_aggregate_bool_exp_bool_and: Posting_Aggregate_Bool_Exp_Bool_And;
  posting_aggregate_bool_exp_bool_or: Posting_Aggregate_Bool_Exp_Bool_Or;
  posting_aggregate_bool_exp_count: Posting_Aggregate_Bool_Exp_Count;
  posting_aggregate_fields: ResolverTypeWrapper<Posting_Aggregate_Fields>;
  posting_aggregate_order_by: Posting_Aggregate_Order_By;
  posting_arr_rel_insert_input: Posting_Arr_Rel_Insert_Input;
  posting_avg_fields: ResolverTypeWrapper<Posting_Avg_Fields>;
  posting_avg_order_by: Posting_Avg_Order_By;
  posting_bool_exp: Posting_Bool_Exp;
  posting_constraint: Posting_Constraint;
  posting_inc_input: Posting_Inc_Input;
  posting_industry: ResolverTypeWrapper<Posting_Industry>;
  posting_industry_aggregate: ResolverTypeWrapper<Posting_Industry_Aggregate>;
  posting_industry_aggregate_bool_exp: Posting_Industry_Aggregate_Bool_Exp;
  posting_industry_aggregate_bool_exp_count: Posting_Industry_Aggregate_Bool_Exp_Count;
  posting_industry_aggregate_fields: ResolverTypeWrapper<Posting_Industry_Aggregate_Fields>;
  posting_industry_aggregate_order_by: Posting_Industry_Aggregate_Order_By;
  posting_industry_arr_rel_insert_input: Posting_Industry_Arr_Rel_Insert_Input;
  posting_industry_avg_fields: ResolverTypeWrapper<Posting_Industry_Avg_Fields>;
  posting_industry_avg_order_by: Posting_Industry_Avg_Order_By;
  posting_industry_bool_exp: Posting_Industry_Bool_Exp;
  posting_industry_constraint: Posting_Industry_Constraint;
  posting_industry_inc_input: Posting_Industry_Inc_Input;
  posting_industry_insert_input: Posting_Industry_Insert_Input;
  posting_industry_max_fields: ResolverTypeWrapper<Posting_Industry_Max_Fields>;
  posting_industry_max_order_by: Posting_Industry_Max_Order_By;
  posting_industry_min_fields: ResolverTypeWrapper<Posting_Industry_Min_Fields>;
  posting_industry_min_order_by: Posting_Industry_Min_Order_By;
  posting_industry_mutation_response: ResolverTypeWrapper<Posting_Industry_Mutation_Response>;
  posting_industry_on_conflict: Posting_Industry_On_Conflict;
  posting_industry_order_by: Posting_Industry_Order_By;
  posting_industry_pk_columns_input: Posting_Industry_Pk_Columns_Input;
  posting_industry_select_column: Posting_Industry_Select_Column;
  posting_industry_set_input: Posting_Industry_Set_Input;
  posting_industry_stddev_fields: ResolverTypeWrapper<Posting_Industry_Stddev_Fields>;
  posting_industry_stddev_order_by: Posting_Industry_Stddev_Order_By;
  posting_industry_stddev_pop_fields: ResolverTypeWrapper<Posting_Industry_Stddev_Pop_Fields>;
  posting_industry_stddev_pop_order_by: Posting_Industry_Stddev_Pop_Order_By;
  posting_industry_stddev_samp_fields: ResolverTypeWrapper<Posting_Industry_Stddev_Samp_Fields>;
  posting_industry_stddev_samp_order_by: Posting_Industry_Stddev_Samp_Order_By;
  posting_industry_stream_cursor_input: Posting_Industry_Stream_Cursor_Input;
  posting_industry_stream_cursor_value_input: Posting_Industry_Stream_Cursor_Value_Input;
  posting_industry_sum_fields: ResolverTypeWrapper<Posting_Industry_Sum_Fields>;
  posting_industry_sum_order_by: Posting_Industry_Sum_Order_By;
  posting_industry_update_column: Posting_Industry_Update_Column;
  posting_industry_updates: Posting_Industry_Updates;
  posting_industry_var_pop_fields: ResolverTypeWrapper<Posting_Industry_Var_Pop_Fields>;
  posting_industry_var_pop_order_by: Posting_Industry_Var_Pop_Order_By;
  posting_industry_var_samp_fields: ResolverTypeWrapper<Posting_Industry_Var_Samp_Fields>;
  posting_industry_var_samp_order_by: Posting_Industry_Var_Samp_Order_By;
  posting_industry_variance_fields: ResolverTypeWrapper<Posting_Industry_Variance_Fields>;
  posting_industry_variance_order_by: Posting_Industry_Variance_Order_By;
  posting_insert_input: Posting_Insert_Input;
  posting_max_fields: ResolverTypeWrapper<Posting_Max_Fields>;
  posting_max_order_by: Posting_Max_Order_By;
  posting_min_fields: ResolverTypeWrapper<Posting_Min_Fields>;
  posting_min_order_by: Posting_Min_Order_By;
  posting_mutation_response: ResolverTypeWrapper<Posting_Mutation_Response>;
  posting_obj_rel_insert_input: Posting_Obj_Rel_Insert_Input;
  posting_on_conflict: Posting_On_Conflict;
  posting_order_by: Posting_Order_By;
  posting_pk_columns_input: Posting_Pk_Columns_Input;
  posting_select_column: Posting_Select_Column;
  posting_select_column_posting_aggregate_bool_exp_bool_and_arguments_columns: Posting_Select_Column_Posting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  posting_select_column_posting_aggregate_bool_exp_bool_or_arguments_columns: Posting_Select_Column_Posting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  posting_set_input: Posting_Set_Input;
  posting_skill: ResolverTypeWrapper<Posting_Skill>;
  posting_skill_aggregate: ResolverTypeWrapper<Posting_Skill_Aggregate>;
  posting_skill_aggregate_bool_exp: Posting_Skill_Aggregate_Bool_Exp;
  posting_skill_aggregate_bool_exp_count: Posting_Skill_Aggregate_Bool_Exp_Count;
  posting_skill_aggregate_fields: ResolverTypeWrapper<Posting_Skill_Aggregate_Fields>;
  posting_skill_aggregate_order_by: Posting_Skill_Aggregate_Order_By;
  posting_skill_arr_rel_insert_input: Posting_Skill_Arr_Rel_Insert_Input;
  posting_skill_avg_fields: ResolverTypeWrapper<Posting_Skill_Avg_Fields>;
  posting_skill_avg_order_by: Posting_Skill_Avg_Order_By;
  posting_skill_bool_exp: Posting_Skill_Bool_Exp;
  posting_skill_constraint: Posting_Skill_Constraint;
  posting_skill_inc_input: Posting_Skill_Inc_Input;
  posting_skill_insert_input: Posting_Skill_Insert_Input;
  posting_skill_max_fields: ResolverTypeWrapper<Posting_Skill_Max_Fields>;
  posting_skill_max_order_by: Posting_Skill_Max_Order_By;
  posting_skill_min_fields: ResolverTypeWrapper<Posting_Skill_Min_Fields>;
  posting_skill_min_order_by: Posting_Skill_Min_Order_By;
  posting_skill_mutation_response: ResolverTypeWrapper<Posting_Skill_Mutation_Response>;
  posting_skill_on_conflict: Posting_Skill_On_Conflict;
  posting_skill_order_by: Posting_Skill_Order_By;
  posting_skill_pk_columns_input: Posting_Skill_Pk_Columns_Input;
  posting_skill_select_column: Posting_Skill_Select_Column;
  posting_skill_set_input: Posting_Skill_Set_Input;
  posting_skill_stddev_fields: ResolverTypeWrapper<Posting_Skill_Stddev_Fields>;
  posting_skill_stddev_order_by: Posting_Skill_Stddev_Order_By;
  posting_skill_stddev_pop_fields: ResolverTypeWrapper<Posting_Skill_Stddev_Pop_Fields>;
  posting_skill_stddev_pop_order_by: Posting_Skill_Stddev_Pop_Order_By;
  posting_skill_stddev_samp_fields: ResolverTypeWrapper<Posting_Skill_Stddev_Samp_Fields>;
  posting_skill_stddev_samp_order_by: Posting_Skill_Stddev_Samp_Order_By;
  posting_skill_stream_cursor_input: Posting_Skill_Stream_Cursor_Input;
  posting_skill_stream_cursor_value_input: Posting_Skill_Stream_Cursor_Value_Input;
  posting_skill_sum_fields: ResolverTypeWrapper<Posting_Skill_Sum_Fields>;
  posting_skill_sum_order_by: Posting_Skill_Sum_Order_By;
  posting_skill_update_column: Posting_Skill_Update_Column;
  posting_skill_updates: Posting_Skill_Updates;
  posting_skill_var_pop_fields: ResolverTypeWrapper<Posting_Skill_Var_Pop_Fields>;
  posting_skill_var_pop_order_by: Posting_Skill_Var_Pop_Order_By;
  posting_skill_var_samp_fields: ResolverTypeWrapper<Posting_Skill_Var_Samp_Fields>;
  posting_skill_var_samp_order_by: Posting_Skill_Var_Samp_Order_By;
  posting_skill_variance_fields: ResolverTypeWrapper<Posting_Skill_Variance_Fields>;
  posting_skill_variance_order_by: Posting_Skill_Variance_Order_By;
  posting_stddev_fields: ResolverTypeWrapper<Posting_Stddev_Fields>;
  posting_stddev_order_by: Posting_Stddev_Order_By;
  posting_stddev_pop_fields: ResolverTypeWrapper<Posting_Stddev_Pop_Fields>;
  posting_stddev_pop_order_by: Posting_Stddev_Pop_Order_By;
  posting_stddev_samp_fields: ResolverTypeWrapper<Posting_Stddev_Samp_Fields>;
  posting_stddev_samp_order_by: Posting_Stddev_Samp_Order_By;
  posting_stream_cursor_input: Posting_Stream_Cursor_Input;
  posting_stream_cursor_value_input: Posting_Stream_Cursor_Value_Input;
  posting_sum_fields: ResolverTypeWrapper<Posting_Sum_Fields>;
  posting_sum_order_by: Posting_Sum_Order_By;
  posting_tags: ResolverTypeWrapper<Posting_Tags>;
  posting_tags_aggregate: ResolverTypeWrapper<Posting_Tags_Aggregate>;
  posting_tags_aggregate_bool_exp: Posting_Tags_Aggregate_Bool_Exp;
  posting_tags_aggregate_bool_exp_count: Posting_Tags_Aggregate_Bool_Exp_Count;
  posting_tags_aggregate_fields: ResolverTypeWrapper<Posting_Tags_Aggregate_Fields>;
  posting_tags_aggregate_order_by: Posting_Tags_Aggregate_Order_By;
  posting_tags_arr_rel_insert_input: Posting_Tags_Arr_Rel_Insert_Input;
  posting_tags_bool_exp: Posting_Tags_Bool_Exp;
  posting_tags_constraint: Posting_Tags_Constraint;
  posting_tags_insert_input: Posting_Tags_Insert_Input;
  posting_tags_max_fields: ResolverTypeWrapper<Posting_Tags_Max_Fields>;
  posting_tags_max_order_by: Posting_Tags_Max_Order_By;
  posting_tags_min_fields: ResolverTypeWrapper<Posting_Tags_Min_Fields>;
  posting_tags_min_order_by: Posting_Tags_Min_Order_By;
  posting_tags_mutation_response: ResolverTypeWrapper<Posting_Tags_Mutation_Response>;
  posting_tags_on_conflict: Posting_Tags_On_Conflict;
  posting_tags_order_by: Posting_Tags_Order_By;
  posting_tags_pk_columns_input: Posting_Tags_Pk_Columns_Input;
  posting_tags_select_column: Posting_Tags_Select_Column;
  posting_tags_set_input: Posting_Tags_Set_Input;
  posting_tags_stream_cursor_input: Posting_Tags_Stream_Cursor_Input;
  posting_tags_stream_cursor_value_input: Posting_Tags_Stream_Cursor_Value_Input;
  posting_tags_update_column: Posting_Tags_Update_Column;
  posting_tags_updates: Posting_Tags_Updates;
  posting_update_column: Posting_Update_Column;
  posting_updates: Posting_Updates;
  posting_var_pop_fields: ResolverTypeWrapper<Posting_Var_Pop_Fields>;
  posting_var_pop_order_by: Posting_Var_Pop_Order_By;
  posting_var_samp_fields: ResolverTypeWrapper<Posting_Var_Samp_Fields>;
  posting_var_samp_order_by: Posting_Var_Samp_Order_By;
  posting_variance_fields: ResolverTypeWrapper<Posting_Variance_Fields>;
  posting_variance_order_by: Posting_Variance_Order_By;
  project: ResolverTypeWrapper<Project>;
  project_activity: ResolverTypeWrapper<Project_Activity>;
  project_activity_aggregate: ResolverTypeWrapper<Project_Activity_Aggregate>;
  project_activity_aggregate_bool_exp: Project_Activity_Aggregate_Bool_Exp;
  project_activity_aggregate_bool_exp_bool_and: Project_Activity_Aggregate_Bool_Exp_Bool_And;
  project_activity_aggregate_bool_exp_bool_or: Project_Activity_Aggregate_Bool_Exp_Bool_Or;
  project_activity_aggregate_bool_exp_count: Project_Activity_Aggregate_Bool_Exp_Count;
  project_activity_aggregate_fields: ResolverTypeWrapper<Project_Activity_Aggregate_Fields>;
  project_activity_aggregate_order_by: Project_Activity_Aggregate_Order_By;
  project_activity_arr_rel_insert_input: Project_Activity_Arr_Rel_Insert_Input;
  project_activity_avg_fields: ResolverTypeWrapper<Project_Activity_Avg_Fields>;
  project_activity_avg_order_by: Project_Activity_Avg_Order_By;
  project_activity_bool_exp: Project_Activity_Bool_Exp;
  project_activity_constraint: Project_Activity_Constraint;
  project_activity_inc_input: Project_Activity_Inc_Input;
  project_activity_insert_input: Project_Activity_Insert_Input;
  project_activity_max_fields: ResolverTypeWrapper<Project_Activity_Max_Fields>;
  project_activity_max_order_by: Project_Activity_Max_Order_By;
  project_activity_min_fields: ResolverTypeWrapper<Project_Activity_Min_Fields>;
  project_activity_min_order_by: Project_Activity_Min_Order_By;
  project_activity_mutation_response: ResolverTypeWrapper<Project_Activity_Mutation_Response>;
  project_activity_note: ResolverTypeWrapper<Project_Activity_Note>;
  project_activity_note_aggregate: ResolverTypeWrapper<Project_Activity_Note_Aggregate>;
  project_activity_note_aggregate_bool_exp: Project_Activity_Note_Aggregate_Bool_Exp;
  project_activity_note_aggregate_bool_exp_count: Project_Activity_Note_Aggregate_Bool_Exp_Count;
  project_activity_note_aggregate_fields: ResolverTypeWrapper<Project_Activity_Note_Aggregate_Fields>;
  project_activity_note_aggregate_order_by: Project_Activity_Note_Aggregate_Order_By;
  project_activity_note_arr_rel_insert_input: Project_Activity_Note_Arr_Rel_Insert_Input;
  project_activity_note_bool_exp: Project_Activity_Note_Bool_Exp;
  project_activity_note_constraint: Project_Activity_Note_Constraint;
  project_activity_note_insert_input: Project_Activity_Note_Insert_Input;
  project_activity_note_max_fields: ResolverTypeWrapper<Project_Activity_Note_Max_Fields>;
  project_activity_note_max_order_by: Project_Activity_Note_Max_Order_By;
  project_activity_note_min_fields: ResolverTypeWrapper<Project_Activity_Note_Min_Fields>;
  project_activity_note_min_order_by: Project_Activity_Note_Min_Order_By;
  project_activity_note_mutation_response: ResolverTypeWrapper<Project_Activity_Note_Mutation_Response>;
  project_activity_note_on_conflict: Project_Activity_Note_On_Conflict;
  project_activity_note_order_by: Project_Activity_Note_Order_By;
  project_activity_note_pk_columns_input: Project_Activity_Note_Pk_Columns_Input;
  project_activity_note_select_column: Project_Activity_Note_Select_Column;
  project_activity_note_set_input: Project_Activity_Note_Set_Input;
  project_activity_note_stream_cursor_input: Project_Activity_Note_Stream_Cursor_Input;
  project_activity_note_stream_cursor_value_input: Project_Activity_Note_Stream_Cursor_Value_Input;
  project_activity_note_update_column: Project_Activity_Note_Update_Column;
  project_activity_note_updates: Project_Activity_Note_Updates;
  project_activity_obj_rel_insert_input: Project_Activity_Obj_Rel_Insert_Input;
  project_activity_on_conflict: Project_Activity_On_Conflict;
  project_activity_order_by: Project_Activity_Order_By;
  project_activity_pk_columns_input: Project_Activity_Pk_Columns_Input;
  project_activity_request_more_hours: ResolverTypeWrapper<Project_Activity_Request_More_Hours>;
  project_activity_request_more_hours_aggregate: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Aggregate>;
  project_activity_request_more_hours_aggregate_bool_exp: Project_Activity_Request_More_Hours_Aggregate_Bool_Exp;
  project_activity_request_more_hours_aggregate_bool_exp_count: Project_Activity_Request_More_Hours_Aggregate_Bool_Exp_Count;
  project_activity_request_more_hours_aggregate_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Aggregate_Fields>;
  project_activity_request_more_hours_aggregate_order_by: Project_Activity_Request_More_Hours_Aggregate_Order_By;
  project_activity_request_more_hours_arr_rel_insert_input: Project_Activity_Request_More_Hours_Arr_Rel_Insert_Input;
  project_activity_request_more_hours_avg_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Avg_Fields>;
  project_activity_request_more_hours_avg_order_by: Project_Activity_Request_More_Hours_Avg_Order_By;
  project_activity_request_more_hours_bool_exp: Project_Activity_Request_More_Hours_Bool_Exp;
  project_activity_request_more_hours_constraint: Project_Activity_Request_More_Hours_Constraint;
  project_activity_request_more_hours_inc_input: Project_Activity_Request_More_Hours_Inc_Input;
  project_activity_request_more_hours_insert_input: Project_Activity_Request_More_Hours_Insert_Input;
  project_activity_request_more_hours_max_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Max_Fields>;
  project_activity_request_more_hours_max_order_by: Project_Activity_Request_More_Hours_Max_Order_By;
  project_activity_request_more_hours_min_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Min_Fields>;
  project_activity_request_more_hours_min_order_by: Project_Activity_Request_More_Hours_Min_Order_By;
  project_activity_request_more_hours_mutation_response: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Mutation_Response>;
  project_activity_request_more_hours_on_conflict: Project_Activity_Request_More_Hours_On_Conflict;
  project_activity_request_more_hours_order_by: Project_Activity_Request_More_Hours_Order_By;
  project_activity_request_more_hours_pk_columns_input: Project_Activity_Request_More_Hours_Pk_Columns_Input;
  project_activity_request_more_hours_select_column: Project_Activity_Request_More_Hours_Select_Column;
  project_activity_request_more_hours_set_input: Project_Activity_Request_More_Hours_Set_Input;
  project_activity_request_more_hours_stddev_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Stddev_Fields>;
  project_activity_request_more_hours_stddev_order_by: Project_Activity_Request_More_Hours_Stddev_Order_By;
  project_activity_request_more_hours_stddev_pop_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Stddev_Pop_Fields>;
  project_activity_request_more_hours_stddev_pop_order_by: Project_Activity_Request_More_Hours_Stddev_Pop_Order_By;
  project_activity_request_more_hours_stddev_samp_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Stddev_Samp_Fields>;
  project_activity_request_more_hours_stddev_samp_order_by: Project_Activity_Request_More_Hours_Stddev_Samp_Order_By;
  project_activity_request_more_hours_stream_cursor_input: Project_Activity_Request_More_Hours_Stream_Cursor_Input;
  project_activity_request_more_hours_stream_cursor_value_input: Project_Activity_Request_More_Hours_Stream_Cursor_Value_Input;
  project_activity_request_more_hours_sum_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Sum_Fields>;
  project_activity_request_more_hours_sum_order_by: Project_Activity_Request_More_Hours_Sum_Order_By;
  project_activity_request_more_hours_update_column: Project_Activity_Request_More_Hours_Update_Column;
  project_activity_request_more_hours_updates: Project_Activity_Request_More_Hours_Updates;
  project_activity_request_more_hours_var_pop_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Var_Pop_Fields>;
  project_activity_request_more_hours_var_pop_order_by: Project_Activity_Request_More_Hours_Var_Pop_Order_By;
  project_activity_request_more_hours_var_samp_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Var_Samp_Fields>;
  project_activity_request_more_hours_var_samp_order_by: Project_Activity_Request_More_Hours_Var_Samp_Order_By;
  project_activity_request_more_hours_variance_fields: ResolverTypeWrapper<Project_Activity_Request_More_Hours_Variance_Fields>;
  project_activity_request_more_hours_variance_order_by: Project_Activity_Request_More_Hours_Variance_Order_By;
  project_activity_select_column: Project_Activity_Select_Column;
  project_activity_select_column_project_activity_aggregate_bool_exp_bool_and_arguments_columns: Project_Activity_Select_Column_Project_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  project_activity_select_column_project_activity_aggregate_bool_exp_bool_or_arguments_columns: Project_Activity_Select_Column_Project_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  project_activity_set_input: Project_Activity_Set_Input;
  project_activity_skill: ResolverTypeWrapper<Project_Activity_Skill>;
  project_activity_skill_aggregate: ResolverTypeWrapper<Project_Activity_Skill_Aggregate>;
  project_activity_skill_aggregate_bool_exp: Project_Activity_Skill_Aggregate_Bool_Exp;
  project_activity_skill_aggregate_bool_exp_count: Project_Activity_Skill_Aggregate_Bool_Exp_Count;
  project_activity_skill_aggregate_fields: ResolverTypeWrapper<Project_Activity_Skill_Aggregate_Fields>;
  project_activity_skill_aggregate_order_by: Project_Activity_Skill_Aggregate_Order_By;
  project_activity_skill_arr_rel_insert_input: Project_Activity_Skill_Arr_Rel_Insert_Input;
  project_activity_skill_avg_fields: ResolverTypeWrapper<Project_Activity_Skill_Avg_Fields>;
  project_activity_skill_avg_order_by: Project_Activity_Skill_Avg_Order_By;
  project_activity_skill_bool_exp: Project_Activity_Skill_Bool_Exp;
  project_activity_skill_constraint: Project_Activity_Skill_Constraint;
  project_activity_skill_inc_input: Project_Activity_Skill_Inc_Input;
  project_activity_skill_insert_input: Project_Activity_Skill_Insert_Input;
  project_activity_skill_max_fields: ResolverTypeWrapper<Project_Activity_Skill_Max_Fields>;
  project_activity_skill_max_order_by: Project_Activity_Skill_Max_Order_By;
  project_activity_skill_min_fields: ResolverTypeWrapper<Project_Activity_Skill_Min_Fields>;
  project_activity_skill_min_order_by: Project_Activity_Skill_Min_Order_By;
  project_activity_skill_mutation_response: ResolverTypeWrapper<Project_Activity_Skill_Mutation_Response>;
  project_activity_skill_on_conflict: Project_Activity_Skill_On_Conflict;
  project_activity_skill_order_by: Project_Activity_Skill_Order_By;
  project_activity_skill_pk_columns_input: Project_Activity_Skill_Pk_Columns_Input;
  project_activity_skill_select_column: Project_Activity_Skill_Select_Column;
  project_activity_skill_set_input: Project_Activity_Skill_Set_Input;
  project_activity_skill_stddev_fields: ResolverTypeWrapper<Project_Activity_Skill_Stddev_Fields>;
  project_activity_skill_stddev_order_by: Project_Activity_Skill_Stddev_Order_By;
  project_activity_skill_stddev_pop_fields: ResolverTypeWrapper<Project_Activity_Skill_Stddev_Pop_Fields>;
  project_activity_skill_stddev_pop_order_by: Project_Activity_Skill_Stddev_Pop_Order_By;
  project_activity_skill_stddev_samp_fields: ResolverTypeWrapper<Project_Activity_Skill_Stddev_Samp_Fields>;
  project_activity_skill_stddev_samp_order_by: Project_Activity_Skill_Stddev_Samp_Order_By;
  project_activity_skill_stream_cursor_input: Project_Activity_Skill_Stream_Cursor_Input;
  project_activity_skill_stream_cursor_value_input: Project_Activity_Skill_Stream_Cursor_Value_Input;
  project_activity_skill_sum_fields: ResolverTypeWrapper<Project_Activity_Skill_Sum_Fields>;
  project_activity_skill_sum_order_by: Project_Activity_Skill_Sum_Order_By;
  project_activity_skill_update_column: Project_Activity_Skill_Update_Column;
  project_activity_skill_updates: Project_Activity_Skill_Updates;
  project_activity_skill_var_pop_fields: ResolverTypeWrapper<Project_Activity_Skill_Var_Pop_Fields>;
  project_activity_skill_var_pop_order_by: Project_Activity_Skill_Var_Pop_Order_By;
  project_activity_skill_var_samp_fields: ResolverTypeWrapper<Project_Activity_Skill_Var_Samp_Fields>;
  project_activity_skill_var_samp_order_by: Project_Activity_Skill_Var_Samp_Order_By;
  project_activity_skill_variance_fields: ResolverTypeWrapper<Project_Activity_Skill_Variance_Fields>;
  project_activity_skill_variance_order_by: Project_Activity_Skill_Variance_Order_By;
  project_activity_soft_skill: ResolverTypeWrapper<Project_Activity_Soft_Skill>;
  project_activity_soft_skill_aggregate: ResolverTypeWrapper<Project_Activity_Soft_Skill_Aggregate>;
  project_activity_soft_skill_aggregate_bool_exp: Project_Activity_Soft_Skill_Aggregate_Bool_Exp;
  project_activity_soft_skill_aggregate_bool_exp_count: Project_Activity_Soft_Skill_Aggregate_Bool_Exp_Count;
  project_activity_soft_skill_aggregate_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Aggregate_Fields>;
  project_activity_soft_skill_aggregate_order_by: Project_Activity_Soft_Skill_Aggregate_Order_By;
  project_activity_soft_skill_arr_rel_insert_input: Project_Activity_Soft_Skill_Arr_Rel_Insert_Input;
  project_activity_soft_skill_avg_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Avg_Fields>;
  project_activity_soft_skill_avg_order_by: Project_Activity_Soft_Skill_Avg_Order_By;
  project_activity_soft_skill_bool_exp: Project_Activity_Soft_Skill_Bool_Exp;
  project_activity_soft_skill_constraint: Project_Activity_Soft_Skill_Constraint;
  project_activity_soft_skill_inc_input: Project_Activity_Soft_Skill_Inc_Input;
  project_activity_soft_skill_insert_input: Project_Activity_Soft_Skill_Insert_Input;
  project_activity_soft_skill_max_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Max_Fields>;
  project_activity_soft_skill_max_order_by: Project_Activity_Soft_Skill_Max_Order_By;
  project_activity_soft_skill_min_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Min_Fields>;
  project_activity_soft_skill_min_order_by: Project_Activity_Soft_Skill_Min_Order_By;
  project_activity_soft_skill_mutation_response: ResolverTypeWrapper<Project_Activity_Soft_Skill_Mutation_Response>;
  project_activity_soft_skill_on_conflict: Project_Activity_Soft_Skill_On_Conflict;
  project_activity_soft_skill_order_by: Project_Activity_Soft_Skill_Order_By;
  project_activity_soft_skill_pk_columns_input: Project_Activity_Soft_Skill_Pk_Columns_Input;
  project_activity_soft_skill_select_column: Project_Activity_Soft_Skill_Select_Column;
  project_activity_soft_skill_set_input: Project_Activity_Soft_Skill_Set_Input;
  project_activity_soft_skill_stddev_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Stddev_Fields>;
  project_activity_soft_skill_stddev_order_by: Project_Activity_Soft_Skill_Stddev_Order_By;
  project_activity_soft_skill_stddev_pop_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Stddev_Pop_Fields>;
  project_activity_soft_skill_stddev_pop_order_by: Project_Activity_Soft_Skill_Stddev_Pop_Order_By;
  project_activity_soft_skill_stddev_samp_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Stddev_Samp_Fields>;
  project_activity_soft_skill_stddev_samp_order_by: Project_Activity_Soft_Skill_Stddev_Samp_Order_By;
  project_activity_soft_skill_stream_cursor_input: Project_Activity_Soft_Skill_Stream_Cursor_Input;
  project_activity_soft_skill_stream_cursor_value_input: Project_Activity_Soft_Skill_Stream_Cursor_Value_Input;
  project_activity_soft_skill_sum_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Sum_Fields>;
  project_activity_soft_skill_sum_order_by: Project_Activity_Soft_Skill_Sum_Order_By;
  project_activity_soft_skill_update_column: Project_Activity_Soft_Skill_Update_Column;
  project_activity_soft_skill_updates: Project_Activity_Soft_Skill_Updates;
  project_activity_soft_skill_var_pop_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Var_Pop_Fields>;
  project_activity_soft_skill_var_pop_order_by: Project_Activity_Soft_Skill_Var_Pop_Order_By;
  project_activity_soft_skill_var_samp_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Var_Samp_Fields>;
  project_activity_soft_skill_var_samp_order_by: Project_Activity_Soft_Skill_Var_Samp_Order_By;
  project_activity_soft_skill_variance_fields: ResolverTypeWrapper<Project_Activity_Soft_Skill_Variance_Fields>;
  project_activity_soft_skill_variance_order_by: Project_Activity_Soft_Skill_Variance_Order_By;
  project_activity_stddev_fields: ResolverTypeWrapper<Project_Activity_Stddev_Fields>;
  project_activity_stddev_order_by: Project_Activity_Stddev_Order_By;
  project_activity_stddev_pop_fields: ResolverTypeWrapper<Project_Activity_Stddev_Pop_Fields>;
  project_activity_stddev_pop_order_by: Project_Activity_Stddev_Pop_Order_By;
  project_activity_stddev_samp_fields: ResolverTypeWrapper<Project_Activity_Stddev_Samp_Fields>;
  project_activity_stddev_samp_order_by: Project_Activity_Stddev_Samp_Order_By;
  project_activity_stream_cursor_input: Project_Activity_Stream_Cursor_Input;
  project_activity_stream_cursor_value_input: Project_Activity_Stream_Cursor_Value_Input;
  project_activity_sum_fields: ResolverTypeWrapper<Project_Activity_Sum_Fields>;
  project_activity_sum_order_by: Project_Activity_Sum_Order_By;
  project_activity_tag: ResolverTypeWrapper<Project_Activity_Tag>;
  project_activity_tag_aggregate: ResolverTypeWrapper<Project_Activity_Tag_Aggregate>;
  project_activity_tag_aggregate_bool_exp: Project_Activity_Tag_Aggregate_Bool_Exp;
  project_activity_tag_aggregate_bool_exp_count: Project_Activity_Tag_Aggregate_Bool_Exp_Count;
  project_activity_tag_aggregate_fields: ResolverTypeWrapper<Project_Activity_Tag_Aggregate_Fields>;
  project_activity_tag_aggregate_order_by: Project_Activity_Tag_Aggregate_Order_By;
  project_activity_tag_arr_rel_insert_input: Project_Activity_Tag_Arr_Rel_Insert_Input;
  project_activity_tag_avg_fields: ResolverTypeWrapper<Project_Activity_Tag_Avg_Fields>;
  project_activity_tag_avg_order_by: Project_Activity_Tag_Avg_Order_By;
  project_activity_tag_bool_exp: Project_Activity_Tag_Bool_Exp;
  project_activity_tag_constraint: Project_Activity_Tag_Constraint;
  project_activity_tag_inc_input: Project_Activity_Tag_Inc_Input;
  project_activity_tag_insert_input: Project_Activity_Tag_Insert_Input;
  project_activity_tag_max_fields: ResolverTypeWrapper<Project_Activity_Tag_Max_Fields>;
  project_activity_tag_max_order_by: Project_Activity_Tag_Max_Order_By;
  project_activity_tag_min_fields: ResolverTypeWrapper<Project_Activity_Tag_Min_Fields>;
  project_activity_tag_min_order_by: Project_Activity_Tag_Min_Order_By;
  project_activity_tag_mutation_response: ResolverTypeWrapper<Project_Activity_Tag_Mutation_Response>;
  project_activity_tag_on_conflict: Project_Activity_Tag_On_Conflict;
  project_activity_tag_order_by: Project_Activity_Tag_Order_By;
  project_activity_tag_pk_columns_input: Project_Activity_Tag_Pk_Columns_Input;
  project_activity_tag_select_column: Project_Activity_Tag_Select_Column;
  project_activity_tag_set_input: Project_Activity_Tag_Set_Input;
  project_activity_tag_stddev_fields: ResolverTypeWrapper<Project_Activity_Tag_Stddev_Fields>;
  project_activity_tag_stddev_order_by: Project_Activity_Tag_Stddev_Order_By;
  project_activity_tag_stddev_pop_fields: ResolverTypeWrapper<Project_Activity_Tag_Stddev_Pop_Fields>;
  project_activity_tag_stddev_pop_order_by: Project_Activity_Tag_Stddev_Pop_Order_By;
  project_activity_tag_stddev_samp_fields: ResolverTypeWrapper<Project_Activity_Tag_Stddev_Samp_Fields>;
  project_activity_tag_stddev_samp_order_by: Project_Activity_Tag_Stddev_Samp_Order_By;
  project_activity_tag_stream_cursor_input: Project_Activity_Tag_Stream_Cursor_Input;
  project_activity_tag_stream_cursor_value_input: Project_Activity_Tag_Stream_Cursor_Value_Input;
  project_activity_tag_sum_fields: ResolverTypeWrapper<Project_Activity_Tag_Sum_Fields>;
  project_activity_tag_sum_order_by: Project_Activity_Tag_Sum_Order_By;
  project_activity_tag_update_column: Project_Activity_Tag_Update_Column;
  project_activity_tag_updates: Project_Activity_Tag_Updates;
  project_activity_tag_var_pop_fields: ResolverTypeWrapper<Project_Activity_Tag_Var_Pop_Fields>;
  project_activity_tag_var_pop_order_by: Project_Activity_Tag_Var_Pop_Order_By;
  project_activity_tag_var_samp_fields: ResolverTypeWrapper<Project_Activity_Tag_Var_Samp_Fields>;
  project_activity_tag_var_samp_order_by: Project_Activity_Tag_Var_Samp_Order_By;
  project_activity_tag_variance_fields: ResolverTypeWrapper<Project_Activity_Tag_Variance_Fields>;
  project_activity_tag_variance_order_by: Project_Activity_Tag_Variance_Order_By;
  project_activity_time: ResolverTypeWrapper<Project_Activity_Time>;
  project_activity_time_aggregate: ResolverTypeWrapper<Project_Activity_Time_Aggregate>;
  project_activity_time_aggregate_bool_exp: Project_Activity_Time_Aggregate_Bool_Exp;
  project_activity_time_aggregate_bool_exp_count: Project_Activity_Time_Aggregate_Bool_Exp_Count;
  project_activity_time_aggregate_fields: ResolverTypeWrapper<Project_Activity_Time_Aggregate_Fields>;
  project_activity_time_aggregate_order_by: Project_Activity_Time_Aggregate_Order_By;
  project_activity_time_arr_rel_insert_input: Project_Activity_Time_Arr_Rel_Insert_Input;
  project_activity_time_avg_fields: ResolverTypeWrapper<Project_Activity_Time_Avg_Fields>;
  project_activity_time_avg_order_by: Project_Activity_Time_Avg_Order_By;
  project_activity_time_bool_exp: Project_Activity_Time_Bool_Exp;
  project_activity_time_constraint: Project_Activity_Time_Constraint;
  project_activity_time_inc_input: Project_Activity_Time_Inc_Input;
  project_activity_time_insert_input: Project_Activity_Time_Insert_Input;
  project_activity_time_max_fields: ResolverTypeWrapper<Project_Activity_Time_Max_Fields>;
  project_activity_time_max_order_by: Project_Activity_Time_Max_Order_By;
  project_activity_time_min_fields: ResolverTypeWrapper<Project_Activity_Time_Min_Fields>;
  project_activity_time_min_order_by: Project_Activity_Time_Min_Order_By;
  project_activity_time_mutation_response: ResolverTypeWrapper<Project_Activity_Time_Mutation_Response>;
  project_activity_time_obj_rel_insert_input: Project_Activity_Time_Obj_Rel_Insert_Input;
  project_activity_time_on_conflict: Project_Activity_Time_On_Conflict;
  project_activity_time_order_by: Project_Activity_Time_Order_By;
  project_activity_time_pk_columns_input: Project_Activity_Time_Pk_Columns_Input;
  project_activity_time_select_column: Project_Activity_Time_Select_Column;
  project_activity_time_set_input: Project_Activity_Time_Set_Input;
  project_activity_time_stddev_fields: ResolverTypeWrapper<Project_Activity_Time_Stddev_Fields>;
  project_activity_time_stddev_order_by: Project_Activity_Time_Stddev_Order_By;
  project_activity_time_stddev_pop_fields: ResolverTypeWrapper<Project_Activity_Time_Stddev_Pop_Fields>;
  project_activity_time_stddev_pop_order_by: Project_Activity_Time_Stddev_Pop_Order_By;
  project_activity_time_stddev_samp_fields: ResolverTypeWrapper<Project_Activity_Time_Stddev_Samp_Fields>;
  project_activity_time_stddev_samp_order_by: Project_Activity_Time_Stddev_Samp_Order_By;
  project_activity_time_stream_cursor_input: Project_Activity_Time_Stream_Cursor_Input;
  project_activity_time_stream_cursor_value_input: Project_Activity_Time_Stream_Cursor_Value_Input;
  project_activity_time_sum_fields: ResolverTypeWrapper<Project_Activity_Time_Sum_Fields>;
  project_activity_time_sum_order_by: Project_Activity_Time_Sum_Order_By;
  project_activity_time_update_column: Project_Activity_Time_Update_Column;
  project_activity_time_updates: Project_Activity_Time_Updates;
  project_activity_time_var_pop_fields: ResolverTypeWrapper<Project_Activity_Time_Var_Pop_Fields>;
  project_activity_time_var_pop_order_by: Project_Activity_Time_Var_Pop_Order_By;
  project_activity_time_var_samp_fields: ResolverTypeWrapper<Project_Activity_Time_Var_Samp_Fields>;
  project_activity_time_var_samp_order_by: Project_Activity_Time_Var_Samp_Order_By;
  project_activity_time_variance_fields: ResolverTypeWrapper<Project_Activity_Time_Variance_Fields>;
  project_activity_time_variance_order_by: Project_Activity_Time_Variance_Order_By;
  project_activity_tracked_time: ResolverTypeWrapper<Project_Activity_Tracked_Time>;
  project_activity_tracked_time_aggregate: ResolverTypeWrapper<Project_Activity_Tracked_Time_Aggregate>;
  project_activity_tracked_time_aggregate_bool_exp: Project_Activity_Tracked_Time_Aggregate_Bool_Exp;
  project_activity_tracked_time_aggregate_bool_exp_count: Project_Activity_Tracked_Time_Aggregate_Bool_Exp_Count;
  project_activity_tracked_time_aggregate_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Aggregate_Fields>;
  project_activity_tracked_time_aggregate_order_by: Project_Activity_Tracked_Time_Aggregate_Order_By;
  project_activity_tracked_time_arr_rel_insert_input: Project_Activity_Tracked_Time_Arr_Rel_Insert_Input;
  project_activity_tracked_time_avg_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Avg_Fields>;
  project_activity_tracked_time_avg_order_by: Project_Activity_Tracked_Time_Avg_Order_By;
  project_activity_tracked_time_bool_exp: Project_Activity_Tracked_Time_Bool_Exp;
  project_activity_tracked_time_constraint: Project_Activity_Tracked_Time_Constraint;
  project_activity_tracked_time_inc_input: Project_Activity_Tracked_Time_Inc_Input;
  project_activity_tracked_time_insert_input: Project_Activity_Tracked_Time_Insert_Input;
  project_activity_tracked_time_max_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Max_Fields>;
  project_activity_tracked_time_max_order_by: Project_Activity_Tracked_Time_Max_Order_By;
  project_activity_tracked_time_min_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Min_Fields>;
  project_activity_tracked_time_min_order_by: Project_Activity_Tracked_Time_Min_Order_By;
  project_activity_tracked_time_mutation_response: ResolverTypeWrapper<Project_Activity_Tracked_Time_Mutation_Response>;
  project_activity_tracked_time_on_conflict: Project_Activity_Tracked_Time_On_Conflict;
  project_activity_tracked_time_order_by: Project_Activity_Tracked_Time_Order_By;
  project_activity_tracked_time_pk_columns_input: Project_Activity_Tracked_Time_Pk_Columns_Input;
  project_activity_tracked_time_select_column: Project_Activity_Tracked_Time_Select_Column;
  project_activity_tracked_time_set_input: Project_Activity_Tracked_Time_Set_Input;
  project_activity_tracked_time_stddev_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Stddev_Fields>;
  project_activity_tracked_time_stddev_order_by: Project_Activity_Tracked_Time_Stddev_Order_By;
  project_activity_tracked_time_stddev_pop_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Stddev_Pop_Fields>;
  project_activity_tracked_time_stddev_pop_order_by: Project_Activity_Tracked_Time_Stddev_Pop_Order_By;
  project_activity_tracked_time_stddev_samp_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Stddev_Samp_Fields>;
  project_activity_tracked_time_stddev_samp_order_by: Project_Activity_Tracked_Time_Stddev_Samp_Order_By;
  project_activity_tracked_time_stream_cursor_input: Project_Activity_Tracked_Time_Stream_Cursor_Input;
  project_activity_tracked_time_stream_cursor_value_input: Project_Activity_Tracked_Time_Stream_Cursor_Value_Input;
  project_activity_tracked_time_sum_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Sum_Fields>;
  project_activity_tracked_time_sum_order_by: Project_Activity_Tracked_Time_Sum_Order_By;
  project_activity_tracked_time_update_column: Project_Activity_Tracked_Time_Update_Column;
  project_activity_tracked_time_updates: Project_Activity_Tracked_Time_Updates;
  project_activity_tracked_time_var_pop_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Var_Pop_Fields>;
  project_activity_tracked_time_var_pop_order_by: Project_Activity_Tracked_Time_Var_Pop_Order_By;
  project_activity_tracked_time_var_samp_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Var_Samp_Fields>;
  project_activity_tracked_time_var_samp_order_by: Project_Activity_Tracked_Time_Var_Samp_Order_By;
  project_activity_tracked_time_variance_fields: ResolverTypeWrapper<Project_Activity_Tracked_Time_Variance_Fields>;
  project_activity_tracked_time_variance_order_by: Project_Activity_Tracked_Time_Variance_Order_By;
  project_activity_update_column: Project_Activity_Update_Column;
  project_activity_updates: Project_Activity_Updates;
  project_activity_var_pop_fields: ResolverTypeWrapper<Project_Activity_Var_Pop_Fields>;
  project_activity_var_pop_order_by: Project_Activity_Var_Pop_Order_By;
  project_activity_var_samp_fields: ResolverTypeWrapper<Project_Activity_Var_Samp_Fields>;
  project_activity_var_samp_order_by: Project_Activity_Var_Samp_Order_By;
  project_activity_variance_fields: ResolverTypeWrapper<Project_Activity_Variance_Fields>;
  project_activity_variance_order_by: Project_Activity_Variance_Order_By;
  project_aggregate: ResolverTypeWrapper<Project_Aggregate>;
  project_aggregate_bool_exp: Project_Aggregate_Bool_Exp;
  project_aggregate_bool_exp_bool_and: Project_Aggregate_Bool_Exp_Bool_And;
  project_aggregate_bool_exp_bool_or: Project_Aggregate_Bool_Exp_Bool_Or;
  project_aggregate_bool_exp_count: Project_Aggregate_Bool_Exp_Count;
  project_aggregate_fields: ResolverTypeWrapper<Project_Aggregate_Fields>;
  project_aggregate_order_by: Project_Aggregate_Order_By;
  project_arr_rel_insert_input: Project_Arr_Rel_Insert_Input;
  project_avg_fields: ResolverTypeWrapper<Project_Avg_Fields>;
  project_avg_order_by: Project_Avg_Order_By;
  project_bool_exp: Project_Bool_Exp;
  project_constraint: Project_Constraint;
  project_inc_input: Project_Inc_Input;
  project_insert_input: Project_Insert_Input;
  project_max_fields: ResolverTypeWrapper<Project_Max_Fields>;
  project_max_order_by: Project_Max_Order_By;
  project_min_fields: ResolverTypeWrapper<Project_Min_Fields>;
  project_min_order_by: Project_Min_Order_By;
  project_mutation_response: ResolverTypeWrapper<Project_Mutation_Response>;
  project_obj_rel_insert_input: Project_Obj_Rel_Insert_Input;
  project_on_conflict: Project_On_Conflict;
  project_order_by: Project_Order_By;
  project_pk_columns_input: Project_Pk_Columns_Input;
  project_select_column: Project_Select_Column;
  project_select_column_project_aggregate_bool_exp_bool_and_arguments_columns: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  project_select_column_project_aggregate_bool_exp_bool_or_arguments_columns: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  project_set_input: Project_Set_Input;
  project_skill: ResolverTypeWrapper<Project_Skill>;
  project_skill_aggregate: ResolverTypeWrapper<Project_Skill_Aggregate>;
  project_skill_aggregate_bool_exp: Project_Skill_Aggregate_Bool_Exp;
  project_skill_aggregate_bool_exp_count: Project_Skill_Aggregate_Bool_Exp_Count;
  project_skill_aggregate_fields: ResolverTypeWrapper<Project_Skill_Aggregate_Fields>;
  project_skill_aggregate_order_by: Project_Skill_Aggregate_Order_By;
  project_skill_arr_rel_insert_input: Project_Skill_Arr_Rel_Insert_Input;
  project_skill_avg_fields: ResolverTypeWrapper<Project_Skill_Avg_Fields>;
  project_skill_avg_order_by: Project_Skill_Avg_Order_By;
  project_skill_bool_exp: Project_Skill_Bool_Exp;
  project_skill_constraint: Project_Skill_Constraint;
  project_skill_inc_input: Project_Skill_Inc_Input;
  project_skill_insert_input: Project_Skill_Insert_Input;
  project_skill_max_fields: ResolverTypeWrapper<Project_Skill_Max_Fields>;
  project_skill_max_order_by: Project_Skill_Max_Order_By;
  project_skill_min_fields: ResolverTypeWrapper<Project_Skill_Min_Fields>;
  project_skill_min_order_by: Project_Skill_Min_Order_By;
  project_skill_mutation_response: ResolverTypeWrapper<Project_Skill_Mutation_Response>;
  project_skill_on_conflict: Project_Skill_On_Conflict;
  project_skill_order_by: Project_Skill_Order_By;
  project_skill_pk_columns_input: Project_Skill_Pk_Columns_Input;
  project_skill_select_column: Project_Skill_Select_Column;
  project_skill_set_input: Project_Skill_Set_Input;
  project_skill_stddev_fields: ResolverTypeWrapper<Project_Skill_Stddev_Fields>;
  project_skill_stddev_order_by: Project_Skill_Stddev_Order_By;
  project_skill_stddev_pop_fields: ResolverTypeWrapper<Project_Skill_Stddev_Pop_Fields>;
  project_skill_stddev_pop_order_by: Project_Skill_Stddev_Pop_Order_By;
  project_skill_stddev_samp_fields: ResolverTypeWrapper<Project_Skill_Stddev_Samp_Fields>;
  project_skill_stddev_samp_order_by: Project_Skill_Stddev_Samp_Order_By;
  project_skill_stream_cursor_input: Project_Skill_Stream_Cursor_Input;
  project_skill_stream_cursor_value_input: Project_Skill_Stream_Cursor_Value_Input;
  project_skill_sum_fields: ResolverTypeWrapper<Project_Skill_Sum_Fields>;
  project_skill_sum_order_by: Project_Skill_Sum_Order_By;
  project_skill_update_column: Project_Skill_Update_Column;
  project_skill_updates: Project_Skill_Updates;
  project_skill_var_pop_fields: ResolverTypeWrapper<Project_Skill_Var_Pop_Fields>;
  project_skill_var_pop_order_by: Project_Skill_Var_Pop_Order_By;
  project_skill_var_samp_fields: ResolverTypeWrapper<Project_Skill_Var_Samp_Fields>;
  project_skill_var_samp_order_by: Project_Skill_Var_Samp_Order_By;
  project_skill_variance_fields: ResolverTypeWrapper<Project_Skill_Variance_Fields>;
  project_skill_variance_order_by: Project_Skill_Variance_Order_By;
  project_soft_skill: ResolverTypeWrapper<Project_Soft_Skill>;
  project_soft_skill_aggregate: ResolverTypeWrapper<Project_Soft_Skill_Aggregate>;
  project_soft_skill_aggregate_bool_exp: Project_Soft_Skill_Aggregate_Bool_Exp;
  project_soft_skill_aggregate_bool_exp_count: Project_Soft_Skill_Aggregate_Bool_Exp_Count;
  project_soft_skill_aggregate_fields: ResolverTypeWrapper<Project_Soft_Skill_Aggregate_Fields>;
  project_soft_skill_aggregate_order_by: Project_Soft_Skill_Aggregate_Order_By;
  project_soft_skill_arr_rel_insert_input: Project_Soft_Skill_Arr_Rel_Insert_Input;
  project_soft_skill_avg_fields: ResolverTypeWrapper<Project_Soft_Skill_Avg_Fields>;
  project_soft_skill_avg_order_by: Project_Soft_Skill_Avg_Order_By;
  project_soft_skill_bool_exp: Project_Soft_Skill_Bool_Exp;
  project_soft_skill_constraint: Project_Soft_Skill_Constraint;
  project_soft_skill_inc_input: Project_Soft_Skill_Inc_Input;
  project_soft_skill_insert_input: Project_Soft_Skill_Insert_Input;
  project_soft_skill_max_fields: ResolverTypeWrapper<Project_Soft_Skill_Max_Fields>;
  project_soft_skill_max_order_by: Project_Soft_Skill_Max_Order_By;
  project_soft_skill_min_fields: ResolverTypeWrapper<Project_Soft_Skill_Min_Fields>;
  project_soft_skill_min_order_by: Project_Soft_Skill_Min_Order_By;
  project_soft_skill_mutation_response: ResolverTypeWrapper<Project_Soft_Skill_Mutation_Response>;
  project_soft_skill_on_conflict: Project_Soft_Skill_On_Conflict;
  project_soft_skill_order_by: Project_Soft_Skill_Order_By;
  project_soft_skill_pk_columns_input: Project_Soft_Skill_Pk_Columns_Input;
  project_soft_skill_select_column: Project_Soft_Skill_Select_Column;
  project_soft_skill_set_input: Project_Soft_Skill_Set_Input;
  project_soft_skill_stddev_fields: ResolverTypeWrapper<Project_Soft_Skill_Stddev_Fields>;
  project_soft_skill_stddev_order_by: Project_Soft_Skill_Stddev_Order_By;
  project_soft_skill_stddev_pop_fields: ResolverTypeWrapper<Project_Soft_Skill_Stddev_Pop_Fields>;
  project_soft_skill_stddev_pop_order_by: Project_Soft_Skill_Stddev_Pop_Order_By;
  project_soft_skill_stddev_samp_fields: ResolverTypeWrapper<Project_Soft_Skill_Stddev_Samp_Fields>;
  project_soft_skill_stddev_samp_order_by: Project_Soft_Skill_Stddev_Samp_Order_By;
  project_soft_skill_stream_cursor_input: Project_Soft_Skill_Stream_Cursor_Input;
  project_soft_skill_stream_cursor_value_input: Project_Soft_Skill_Stream_Cursor_Value_Input;
  project_soft_skill_sum_fields: ResolverTypeWrapper<Project_Soft_Skill_Sum_Fields>;
  project_soft_skill_sum_order_by: Project_Soft_Skill_Sum_Order_By;
  project_soft_skill_update_column: Project_Soft_Skill_Update_Column;
  project_soft_skill_updates: Project_Soft_Skill_Updates;
  project_soft_skill_var_pop_fields: ResolverTypeWrapper<Project_Soft_Skill_Var_Pop_Fields>;
  project_soft_skill_var_pop_order_by: Project_Soft_Skill_Var_Pop_Order_By;
  project_soft_skill_var_samp_fields: ResolverTypeWrapper<Project_Soft_Skill_Var_Samp_Fields>;
  project_soft_skill_var_samp_order_by: Project_Soft_Skill_Var_Samp_Order_By;
  project_soft_skill_variance_fields: ResolverTypeWrapper<Project_Soft_Skill_Variance_Fields>;
  project_soft_skill_variance_order_by: Project_Soft_Skill_Variance_Order_By;
  project_stddev_fields: ResolverTypeWrapper<Project_Stddev_Fields>;
  project_stddev_order_by: Project_Stddev_Order_By;
  project_stddev_pop_fields: ResolverTypeWrapper<Project_Stddev_Pop_Fields>;
  project_stddev_pop_order_by: Project_Stddev_Pop_Order_By;
  project_stddev_samp_fields: ResolverTypeWrapper<Project_Stddev_Samp_Fields>;
  project_stddev_samp_order_by: Project_Stddev_Samp_Order_By;
  project_stream_cursor_input: Project_Stream_Cursor_Input;
  project_stream_cursor_value_input: Project_Stream_Cursor_Value_Input;
  project_sum_fields: ResolverTypeWrapper<Project_Sum_Fields>;
  project_sum_order_by: Project_Sum_Order_By;
  project_tag: ResolverTypeWrapper<Project_Tag>;
  project_tag_aggregate: ResolverTypeWrapper<Project_Tag_Aggregate>;
  project_tag_aggregate_bool_exp: Project_Tag_Aggregate_Bool_Exp;
  project_tag_aggregate_bool_exp_count: Project_Tag_Aggregate_Bool_Exp_Count;
  project_tag_aggregate_fields: ResolverTypeWrapper<Project_Tag_Aggregate_Fields>;
  project_tag_aggregate_order_by: Project_Tag_Aggregate_Order_By;
  project_tag_arr_rel_insert_input: Project_Tag_Arr_Rel_Insert_Input;
  project_tag_avg_fields: ResolverTypeWrapper<Project_Tag_Avg_Fields>;
  project_tag_avg_order_by: Project_Tag_Avg_Order_By;
  project_tag_bool_exp: Project_Tag_Bool_Exp;
  project_tag_constraint: Project_Tag_Constraint;
  project_tag_inc_input: Project_Tag_Inc_Input;
  project_tag_insert_input: Project_Tag_Insert_Input;
  project_tag_max_fields: ResolverTypeWrapper<Project_Tag_Max_Fields>;
  project_tag_max_order_by: Project_Tag_Max_Order_By;
  project_tag_min_fields: ResolverTypeWrapper<Project_Tag_Min_Fields>;
  project_tag_min_order_by: Project_Tag_Min_Order_By;
  project_tag_mutation_response: ResolverTypeWrapper<Project_Tag_Mutation_Response>;
  project_tag_on_conflict: Project_Tag_On_Conflict;
  project_tag_order_by: Project_Tag_Order_By;
  project_tag_pk_columns_input: Project_Tag_Pk_Columns_Input;
  project_tag_select_column: Project_Tag_Select_Column;
  project_tag_set_input: Project_Tag_Set_Input;
  project_tag_stddev_fields: ResolverTypeWrapper<Project_Tag_Stddev_Fields>;
  project_tag_stddev_order_by: Project_Tag_Stddev_Order_By;
  project_tag_stddev_pop_fields: ResolverTypeWrapper<Project_Tag_Stddev_Pop_Fields>;
  project_tag_stddev_pop_order_by: Project_Tag_Stddev_Pop_Order_By;
  project_tag_stddev_samp_fields: ResolverTypeWrapper<Project_Tag_Stddev_Samp_Fields>;
  project_tag_stddev_samp_order_by: Project_Tag_Stddev_Samp_Order_By;
  project_tag_stream_cursor_input: Project_Tag_Stream_Cursor_Input;
  project_tag_stream_cursor_value_input: Project_Tag_Stream_Cursor_Value_Input;
  project_tag_sum_fields: ResolverTypeWrapper<Project_Tag_Sum_Fields>;
  project_tag_sum_order_by: Project_Tag_Sum_Order_By;
  project_tag_update_column: Project_Tag_Update_Column;
  project_tag_updates: Project_Tag_Updates;
  project_tag_var_pop_fields: ResolverTypeWrapper<Project_Tag_Var_Pop_Fields>;
  project_tag_var_pop_order_by: Project_Tag_Var_Pop_Order_By;
  project_tag_var_samp_fields: ResolverTypeWrapper<Project_Tag_Var_Samp_Fields>;
  project_tag_var_samp_order_by: Project_Tag_Var_Samp_Order_By;
  project_tag_variance_fields: ResolverTypeWrapper<Project_Tag_Variance_Fields>;
  project_tag_variance_order_by: Project_Tag_Variance_Order_By;
  project_update_column: Project_Update_Column;
  project_updates: Project_Updates;
  project_var_pop_fields: ResolverTypeWrapper<Project_Var_Pop_Fields>;
  project_var_pop_order_by: Project_Var_Pop_Order_By;
  project_var_samp_fields: ResolverTypeWrapper<Project_Var_Samp_Fields>;
  project_var_samp_order_by: Project_Var_Samp_Order_By;
  project_variance_fields: ResolverTypeWrapper<Project_Variance_Fields>;
  project_variance_order_by: Project_Variance_Order_By;
  public_project_details: ResolverTypeWrapper<Public_Project_Details>;
  public_project_details_aggregate: ResolverTypeWrapper<Public_Project_Details_Aggregate>;
  public_project_details_aggregate_fields: ResolverTypeWrapper<Public_Project_Details_Aggregate_Fields>;
  public_project_details_bool_exp: Public_Project_Details_Bool_Exp;
  public_project_details_insert_input: Public_Project_Details_Insert_Input;
  public_project_details_max_fields: ResolverTypeWrapper<Public_Project_Details_Max_Fields>;
  public_project_details_min_fields: ResolverTypeWrapper<Public_Project_Details_Min_Fields>;
  public_project_details_obj_rel_insert_input: Public_Project_Details_Obj_Rel_Insert_Input;
  public_project_details_order_by: Public_Project_Details_Order_By;
  public_project_details_select_column: Public_Project_Details_Select_Column;
  public_project_details_stream_cursor_input: Public_Project_Details_Stream_Cursor_Input;
  public_project_details_stream_cursor_value_input: Public_Project_Details_Stream_Cursor_Value_Input;
  query_root: ResolverTypeWrapper<{}>;
  recipient_message: ResolverTypeWrapper<Recipient_Message>;
  recipient_message_aggregate: ResolverTypeWrapper<Recipient_Message_Aggregate>;
  recipient_message_aggregate_bool_exp: Recipient_Message_Aggregate_Bool_Exp;
  recipient_message_aggregate_bool_exp_bool_and: Recipient_Message_Aggregate_Bool_Exp_Bool_And;
  recipient_message_aggregate_bool_exp_bool_or: Recipient_Message_Aggregate_Bool_Exp_Bool_Or;
  recipient_message_aggregate_bool_exp_count: Recipient_Message_Aggregate_Bool_Exp_Count;
  recipient_message_aggregate_fields: ResolverTypeWrapper<Recipient_Message_Aggregate_Fields>;
  recipient_message_aggregate_order_by: Recipient_Message_Aggregate_Order_By;
  recipient_message_arr_rel_insert_input: Recipient_Message_Arr_Rel_Insert_Input;
  recipient_message_bool_exp: Recipient_Message_Bool_Exp;
  recipient_message_constraint: Recipient_Message_Constraint;
  recipient_message_insert_input: Recipient_Message_Insert_Input;
  recipient_message_max_fields: ResolverTypeWrapper<Recipient_Message_Max_Fields>;
  recipient_message_max_order_by: Recipient_Message_Max_Order_By;
  recipient_message_min_fields: ResolverTypeWrapper<Recipient_Message_Min_Fields>;
  recipient_message_min_order_by: Recipient_Message_Min_Order_By;
  recipient_message_mutation_response: ResolverTypeWrapper<Recipient_Message_Mutation_Response>;
  recipient_message_on_conflict: Recipient_Message_On_Conflict;
  recipient_message_order_by: Recipient_Message_Order_By;
  recipient_message_pk_columns_input: Recipient_Message_Pk_Columns_Input;
  recipient_message_select_column: Recipient_Message_Select_Column;
  recipient_message_select_column_recipient_message_aggregate_bool_exp_bool_and_arguments_columns: Recipient_Message_Select_Column_Recipient_Message_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  recipient_message_select_column_recipient_message_aggregate_bool_exp_bool_or_arguments_columns: Recipient_Message_Select_Column_Recipient_Message_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  recipient_message_set_input: Recipient_Message_Set_Input;
  recipient_message_stream_cursor_input: Recipient_Message_Stream_Cursor_Input;
  recipient_message_stream_cursor_value_input: Recipient_Message_Stream_Cursor_Value_Input;
  recipient_message_update_column: Recipient_Message_Update_Column;
  recipient_message_updates: Recipient_Message_Updates;
  resource_information_card: ResolverTypeWrapper<Resource_Information_Card>;
  resource_information_card_aggregate: ResolverTypeWrapper<Resource_Information_Card_Aggregate>;
  resource_information_card_aggregate_bool_exp: Resource_Information_Card_Aggregate_Bool_Exp;
  resource_information_card_aggregate_bool_exp_bool_and: Resource_Information_Card_Aggregate_Bool_Exp_Bool_And;
  resource_information_card_aggregate_bool_exp_bool_or: Resource_Information_Card_Aggregate_Bool_Exp_Bool_Or;
  resource_information_card_aggregate_bool_exp_count: Resource_Information_Card_Aggregate_Bool_Exp_Count;
  resource_information_card_aggregate_fields: ResolverTypeWrapper<Resource_Information_Card_Aggregate_Fields>;
  resource_information_card_aggregate_order_by: Resource_Information_Card_Aggregate_Order_By;
  resource_information_card_arr_rel_insert_input: Resource_Information_Card_Arr_Rel_Insert_Input;
  resource_information_card_avg_fields: ResolverTypeWrapper<Resource_Information_Card_Avg_Fields>;
  resource_information_card_avg_order_by: Resource_Information_Card_Avg_Order_By;
  resource_information_card_bool_exp: Resource_Information_Card_Bool_Exp;
  resource_information_card_constraint: Resource_Information_Card_Constraint;
  resource_information_card_inc_input: Resource_Information_Card_Inc_Input;
  resource_information_card_insert_input: Resource_Information_Card_Insert_Input;
  resource_information_card_max_fields: ResolverTypeWrapper<Resource_Information_Card_Max_Fields>;
  resource_information_card_max_order_by: Resource_Information_Card_Max_Order_By;
  resource_information_card_min_fields: ResolverTypeWrapper<Resource_Information_Card_Min_Fields>;
  resource_information_card_min_order_by: Resource_Information_Card_Min_Order_By;
  resource_information_card_mutation_response: ResolverTypeWrapper<Resource_Information_Card_Mutation_Response>;
  resource_information_card_on_conflict: Resource_Information_Card_On_Conflict;
  resource_information_card_order_by: Resource_Information_Card_Order_By;
  resource_information_card_pk_columns_input: Resource_Information_Card_Pk_Columns_Input;
  resource_information_card_select_column: Resource_Information_Card_Select_Column;
  resource_information_card_select_column_resource_information_card_aggregate_bool_exp_bool_and_arguments_columns: Resource_Information_Card_Select_Column_Resource_Information_Card_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  resource_information_card_select_column_resource_information_card_aggregate_bool_exp_bool_or_arguments_columns: Resource_Information_Card_Select_Column_Resource_Information_Card_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  resource_information_card_set_input: Resource_Information_Card_Set_Input;
  resource_information_card_stddev_fields: ResolverTypeWrapper<Resource_Information_Card_Stddev_Fields>;
  resource_information_card_stddev_order_by: Resource_Information_Card_Stddev_Order_By;
  resource_information_card_stddev_pop_fields: ResolverTypeWrapper<Resource_Information_Card_Stddev_Pop_Fields>;
  resource_information_card_stddev_pop_order_by: Resource_Information_Card_Stddev_Pop_Order_By;
  resource_information_card_stddev_samp_fields: ResolverTypeWrapper<Resource_Information_Card_Stddev_Samp_Fields>;
  resource_information_card_stddev_samp_order_by: Resource_Information_Card_Stddev_Samp_Order_By;
  resource_information_card_stream_cursor_input: Resource_Information_Card_Stream_Cursor_Input;
  resource_information_card_stream_cursor_value_input: Resource_Information_Card_Stream_Cursor_Value_Input;
  resource_information_card_sum_fields: ResolverTypeWrapper<Resource_Information_Card_Sum_Fields>;
  resource_information_card_sum_order_by: Resource_Information_Card_Sum_Order_By;
  resource_information_card_update_column: Resource_Information_Card_Update_Column;
  resource_information_card_updates: Resource_Information_Card_Updates;
  resource_information_card_var_pop_fields: ResolverTypeWrapper<Resource_Information_Card_Var_Pop_Fields>;
  resource_information_card_var_pop_order_by: Resource_Information_Card_Var_Pop_Order_By;
  resource_information_card_var_samp_fields: ResolverTypeWrapper<Resource_Information_Card_Var_Samp_Fields>;
  resource_information_card_var_samp_order_by: Resource_Information_Card_Var_Samp_Order_By;
  resource_information_card_variance_fields: ResolverTypeWrapper<Resource_Information_Card_Variance_Fields>;
  resource_information_card_variance_order_by: Resource_Information_Card_Variance_Order_By;
  search_industry_args: Search_Industry_Args;
  search_skill_args: Search_Skill_Args;
  skill: ResolverTypeWrapper<Skill>;
  skill_aggregate: ResolverTypeWrapper<Skill_Aggregate>;
  skill_aggregate_bool_exp: Skill_Aggregate_Bool_Exp;
  skill_aggregate_bool_exp_count: Skill_Aggregate_Bool_Exp_Count;
  skill_aggregate_fields: ResolverTypeWrapper<Skill_Aggregate_Fields>;
  skill_aggregate_order_by: Skill_Aggregate_Order_By;
  skill_arr_rel_insert_input: Skill_Arr_Rel_Insert_Input;
  skill_avg_fields: ResolverTypeWrapper<Skill_Avg_Fields>;
  skill_avg_order_by: Skill_Avg_Order_By;
  skill_bool_exp: Skill_Bool_Exp;
  skill_constraint: Skill_Constraint;
  skill_inc_input: Skill_Inc_Input;
  skill_insert_input: Skill_Insert_Input;
  skill_max_fields: ResolverTypeWrapper<Skill_Max_Fields>;
  skill_max_order_by: Skill_Max_Order_By;
  skill_min_fields: ResolverTypeWrapper<Skill_Min_Fields>;
  skill_min_order_by: Skill_Min_Order_By;
  skill_mutation_response: ResolverTypeWrapper<Skill_Mutation_Response>;
  skill_obj_rel_insert_input: Skill_Obj_Rel_Insert_Input;
  skill_on_conflict: Skill_On_Conflict;
  skill_order_by: Skill_Order_By;
  skill_pk_columns_input: Skill_Pk_Columns_Input;
  skill_select_column: Skill_Select_Column;
  skill_set_input: Skill_Set_Input;
  skill_stddev_fields: ResolverTypeWrapper<Skill_Stddev_Fields>;
  skill_stddev_order_by: Skill_Stddev_Order_By;
  skill_stddev_pop_fields: ResolverTypeWrapper<Skill_Stddev_Pop_Fields>;
  skill_stddev_pop_order_by: Skill_Stddev_Pop_Order_By;
  skill_stddev_samp_fields: ResolverTypeWrapper<Skill_Stddev_Samp_Fields>;
  skill_stddev_samp_order_by: Skill_Stddev_Samp_Order_By;
  skill_stream_cursor_input: Skill_Stream_Cursor_Input;
  skill_stream_cursor_value_input: Skill_Stream_Cursor_Value_Input;
  skill_sum_fields: ResolverTypeWrapper<Skill_Sum_Fields>;
  skill_sum_order_by: Skill_Sum_Order_By;
  skill_update_column: Skill_Update_Column;
  skill_updates: Skill_Updates;
  skill_var_pop_fields: ResolverTypeWrapper<Skill_Var_Pop_Fields>;
  skill_var_pop_order_by: Skill_Var_Pop_Order_By;
  skill_var_samp_fields: ResolverTypeWrapper<Skill_Var_Samp_Fields>;
  skill_var_samp_order_by: Skill_Var_Samp_Order_By;
  skill_variance_fields: ResolverTypeWrapper<Skill_Variance_Fields>;
  skill_variance_order_by: Skill_Variance_Order_By;
  skills_short_name_first: ResolverTypeWrapper<Skills_Short_Name_First>;
  skills_short_name_first_aggregate: ResolverTypeWrapper<Skills_Short_Name_First_Aggregate>;
  skills_short_name_first_aggregate_fields: ResolverTypeWrapper<Skills_Short_Name_First_Aggregate_Fields>;
  skills_short_name_first_avg_fields: ResolverTypeWrapper<Skills_Short_Name_First_Avg_Fields>;
  skills_short_name_first_bool_exp: Skills_Short_Name_First_Bool_Exp;
  skills_short_name_first_inc_input: Skills_Short_Name_First_Inc_Input;
  skills_short_name_first_insert_input: Skills_Short_Name_First_Insert_Input;
  skills_short_name_first_max_fields: ResolverTypeWrapper<Skills_Short_Name_First_Max_Fields>;
  skills_short_name_first_min_fields: ResolverTypeWrapper<Skills_Short_Name_First_Min_Fields>;
  skills_short_name_first_mutation_response: ResolverTypeWrapper<Skills_Short_Name_First_Mutation_Response>;
  skills_short_name_first_order_by: Skills_Short_Name_First_Order_By;
  skills_short_name_first_select_column: Skills_Short_Name_First_Select_Column;
  skills_short_name_first_set_input: Skills_Short_Name_First_Set_Input;
  skills_short_name_first_stddev_fields: ResolverTypeWrapper<Skills_Short_Name_First_Stddev_Fields>;
  skills_short_name_first_stddev_pop_fields: ResolverTypeWrapper<Skills_Short_Name_First_Stddev_Pop_Fields>;
  skills_short_name_first_stddev_samp_fields: ResolverTypeWrapper<Skills_Short_Name_First_Stddev_Samp_Fields>;
  skills_short_name_first_stream_cursor_input: Skills_Short_Name_First_Stream_Cursor_Input;
  skills_short_name_first_stream_cursor_value_input: Skills_Short_Name_First_Stream_Cursor_Value_Input;
  skills_short_name_first_sum_fields: ResolverTypeWrapper<Skills_Short_Name_First_Sum_Fields>;
  skills_short_name_first_updates: Skills_Short_Name_First_Updates;
  skills_short_name_first_var_pop_fields: ResolverTypeWrapper<Skills_Short_Name_First_Var_Pop_Fields>;
  skills_short_name_first_var_samp_fields: ResolverTypeWrapper<Skills_Short_Name_First_Var_Samp_Fields>;
  skills_short_name_first_variance_fields: ResolverTypeWrapper<Skills_Short_Name_First_Variance_Fields>;
  smart_match_bookmark: ResolverTypeWrapper<Smart_Match_Bookmark>;
  smart_match_bookmark_aggregate: ResolverTypeWrapper<Smart_Match_Bookmark_Aggregate>;
  smart_match_bookmark_aggregate_bool_exp: Smart_Match_Bookmark_Aggregate_Bool_Exp;
  smart_match_bookmark_aggregate_bool_exp_count: Smart_Match_Bookmark_Aggregate_Bool_Exp_Count;
  smart_match_bookmark_aggregate_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Aggregate_Fields>;
  smart_match_bookmark_aggregate_order_by: Smart_Match_Bookmark_Aggregate_Order_By;
  smart_match_bookmark_arr_rel_insert_input: Smart_Match_Bookmark_Arr_Rel_Insert_Input;
  smart_match_bookmark_avg_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Avg_Fields>;
  smart_match_bookmark_avg_order_by: Smart_Match_Bookmark_Avg_Order_By;
  smart_match_bookmark_bool_exp: Smart_Match_Bookmark_Bool_Exp;
  smart_match_bookmark_constraint: Smart_Match_Bookmark_Constraint;
  smart_match_bookmark_inc_input: Smart_Match_Bookmark_Inc_Input;
  smart_match_bookmark_insert_input: Smart_Match_Bookmark_Insert_Input;
  smart_match_bookmark_max_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Max_Fields>;
  smart_match_bookmark_max_order_by: Smart_Match_Bookmark_Max_Order_By;
  smart_match_bookmark_min_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Min_Fields>;
  smart_match_bookmark_min_order_by: Smart_Match_Bookmark_Min_Order_By;
  smart_match_bookmark_mutation_response: ResolverTypeWrapper<Smart_Match_Bookmark_Mutation_Response>;
  smart_match_bookmark_obj_rel_insert_input: Smart_Match_Bookmark_Obj_Rel_Insert_Input;
  smart_match_bookmark_on_conflict: Smart_Match_Bookmark_On_Conflict;
  smart_match_bookmark_order_by: Smart_Match_Bookmark_Order_By;
  smart_match_bookmark_pk_columns_input: Smart_Match_Bookmark_Pk_Columns_Input;
  smart_match_bookmark_select_column: Smart_Match_Bookmark_Select_Column;
  smart_match_bookmark_set_input: Smart_Match_Bookmark_Set_Input;
  smart_match_bookmark_stddev_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Stddev_Fields>;
  smart_match_bookmark_stddev_order_by: Smart_Match_Bookmark_Stddev_Order_By;
  smart_match_bookmark_stddev_pop_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Stddev_Pop_Fields>;
  smart_match_bookmark_stddev_pop_order_by: Smart_Match_Bookmark_Stddev_Pop_Order_By;
  smart_match_bookmark_stddev_samp_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Stddev_Samp_Fields>;
  smart_match_bookmark_stddev_samp_order_by: Smart_Match_Bookmark_Stddev_Samp_Order_By;
  smart_match_bookmark_stream_cursor_input: Smart_Match_Bookmark_Stream_Cursor_Input;
  smart_match_bookmark_stream_cursor_value_input: Smart_Match_Bookmark_Stream_Cursor_Value_Input;
  smart_match_bookmark_sum_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Sum_Fields>;
  smart_match_bookmark_sum_order_by: Smart_Match_Bookmark_Sum_Order_By;
  smart_match_bookmark_update_column: Smart_Match_Bookmark_Update_Column;
  smart_match_bookmark_updates: Smart_Match_Bookmark_Updates;
  smart_match_bookmark_var_pop_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Var_Pop_Fields>;
  smart_match_bookmark_var_pop_order_by: Smart_Match_Bookmark_Var_Pop_Order_By;
  smart_match_bookmark_var_samp_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Var_Samp_Fields>;
  smart_match_bookmark_var_samp_order_by: Smart_Match_Bookmark_Var_Samp_Order_By;
  smart_match_bookmark_variance_fields: ResolverTypeWrapper<Smart_Match_Bookmark_Variance_Fields>;
  smart_match_bookmark_variance_order_by: Smart_Match_Bookmark_Variance_Order_By;
  smart_match_config_transportation: ResolverTypeWrapper<Smart_Match_Config_Transportation>;
  smart_match_config_transportation_aggregate: ResolverTypeWrapper<Smart_Match_Config_Transportation_Aggregate>;
  smart_match_config_transportation_aggregate_bool_exp: Smart_Match_Config_Transportation_Aggregate_Bool_Exp;
  smart_match_config_transportation_aggregate_bool_exp_count: Smart_Match_Config_Transportation_Aggregate_Bool_Exp_Count;
  smart_match_config_transportation_aggregate_fields: ResolverTypeWrapper<Smart_Match_Config_Transportation_Aggregate_Fields>;
  smart_match_config_transportation_aggregate_order_by: Smart_Match_Config_Transportation_Aggregate_Order_By;
  smart_match_config_transportation_arr_rel_insert_input: Smart_Match_Config_Transportation_Arr_Rel_Insert_Input;
  smart_match_config_transportation_bool_exp: Smart_Match_Config_Transportation_Bool_Exp;
  smart_match_config_transportation_constraint: Smart_Match_Config_Transportation_Constraint;
  smart_match_config_transportation_insert_input: Smart_Match_Config_Transportation_Insert_Input;
  smart_match_config_transportation_max_fields: ResolverTypeWrapper<Smart_Match_Config_Transportation_Max_Fields>;
  smart_match_config_transportation_max_order_by: Smart_Match_Config_Transportation_Max_Order_By;
  smart_match_config_transportation_min_fields: ResolverTypeWrapper<Smart_Match_Config_Transportation_Min_Fields>;
  smart_match_config_transportation_min_order_by: Smart_Match_Config_Transportation_Min_Order_By;
  smart_match_config_transportation_mutation_response: ResolverTypeWrapper<Smart_Match_Config_Transportation_Mutation_Response>;
  smart_match_config_transportation_on_conflict: Smart_Match_Config_Transportation_On_Conflict;
  smart_match_config_transportation_order_by: Smart_Match_Config_Transportation_Order_By;
  smart_match_config_transportation_pk_columns_input: Smart_Match_Config_Transportation_Pk_Columns_Input;
  smart_match_config_transportation_select_column: Smart_Match_Config_Transportation_Select_Column;
  smart_match_config_transportation_set_input: Smart_Match_Config_Transportation_Set_Input;
  smart_match_config_transportation_stream_cursor_input: Smart_Match_Config_Transportation_Stream_Cursor_Input;
  smart_match_config_transportation_stream_cursor_value_input: Smart_Match_Config_Transportation_Stream_Cursor_Value_Input;
  smart_match_config_transportation_update_column: Smart_Match_Config_Transportation_Update_Column;
  smart_match_config_transportation_updates: Smart_Match_Config_Transportation_Updates;
  smart_match_configs: ResolverTypeWrapper<Smart_Match_Configs>;
  smart_match_configs_aggregate: ResolverTypeWrapper<Smart_Match_Configs_Aggregate>;
  smart_match_configs_aggregate_fields: ResolverTypeWrapper<Smart_Match_Configs_Aggregate_Fields>;
  smart_match_configs_avg_fields: ResolverTypeWrapper<Smart_Match_Configs_Avg_Fields>;
  smart_match_configs_bool_exp: Smart_Match_Configs_Bool_Exp;
  smart_match_configs_constraint: Smart_Match_Configs_Constraint;
  smart_match_configs_inc_input: Smart_Match_Configs_Inc_Input;
  smart_match_configs_insert_input: Smart_Match_Configs_Insert_Input;
  smart_match_configs_max_fields: ResolverTypeWrapper<Smart_Match_Configs_Max_Fields>;
  smart_match_configs_min_fields: ResolverTypeWrapper<Smart_Match_Configs_Min_Fields>;
  smart_match_configs_mutation_response: ResolverTypeWrapper<Smart_Match_Configs_Mutation_Response>;
  smart_match_configs_obj_rel_insert_input: Smart_Match_Configs_Obj_Rel_Insert_Input;
  smart_match_configs_on_conflict: Smart_Match_Configs_On_Conflict;
  smart_match_configs_order_by: Smart_Match_Configs_Order_By;
  smart_match_configs_pk_columns_input: Smart_Match_Configs_Pk_Columns_Input;
  smart_match_configs_select_column: Smart_Match_Configs_Select_Column;
  smart_match_configs_set_input: Smart_Match_Configs_Set_Input;
  smart_match_configs_stddev_fields: ResolverTypeWrapper<Smart_Match_Configs_Stddev_Fields>;
  smart_match_configs_stddev_pop_fields: ResolverTypeWrapper<Smart_Match_Configs_Stddev_Pop_Fields>;
  smart_match_configs_stddev_samp_fields: ResolverTypeWrapper<Smart_Match_Configs_Stddev_Samp_Fields>;
  smart_match_configs_stream_cursor_input: Smart_Match_Configs_Stream_Cursor_Input;
  smart_match_configs_stream_cursor_value_input: Smart_Match_Configs_Stream_Cursor_Value_Input;
  smart_match_configs_sum_fields: ResolverTypeWrapper<Smart_Match_Configs_Sum_Fields>;
  smart_match_configs_update_column: Smart_Match_Configs_Update_Column;
  smart_match_configs_updates: Smart_Match_Configs_Updates;
  smart_match_configs_var_pop_fields: ResolverTypeWrapper<Smart_Match_Configs_Var_Pop_Fields>;
  smart_match_configs_var_samp_fields: ResolverTypeWrapper<Smart_Match_Configs_Var_Samp_Fields>;
  smart_match_configs_variance_fields: ResolverTypeWrapper<Smart_Match_Configs_Variance_Fields>;
  smart_match_criteria_order: ResolverTypeWrapper<Smart_Match_Criteria_Order>;
  smart_match_criteria_order_aggregate: ResolverTypeWrapper<Smart_Match_Criteria_Order_Aggregate>;
  smart_match_criteria_order_aggregate_bool_exp: Smart_Match_Criteria_Order_Aggregate_Bool_Exp;
  smart_match_criteria_order_aggregate_bool_exp_count: Smart_Match_Criteria_Order_Aggregate_Bool_Exp_Count;
  smart_match_criteria_order_aggregate_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Aggregate_Fields>;
  smart_match_criteria_order_aggregate_order_by: Smart_Match_Criteria_Order_Aggregate_Order_By;
  smart_match_criteria_order_arr_rel_insert_input: Smart_Match_Criteria_Order_Arr_Rel_Insert_Input;
  smart_match_criteria_order_avg_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Avg_Fields>;
  smart_match_criteria_order_avg_order_by: Smart_Match_Criteria_Order_Avg_Order_By;
  smart_match_criteria_order_bool_exp: Smart_Match_Criteria_Order_Bool_Exp;
  smart_match_criteria_order_constraint: Smart_Match_Criteria_Order_Constraint;
  smart_match_criteria_order_inc_input: Smart_Match_Criteria_Order_Inc_Input;
  smart_match_criteria_order_insert_input: Smart_Match_Criteria_Order_Insert_Input;
  smart_match_criteria_order_max_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Max_Fields>;
  smart_match_criteria_order_max_order_by: Smart_Match_Criteria_Order_Max_Order_By;
  smart_match_criteria_order_min_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Min_Fields>;
  smart_match_criteria_order_min_order_by: Smart_Match_Criteria_Order_Min_Order_By;
  smart_match_criteria_order_mutation_response: ResolverTypeWrapper<Smart_Match_Criteria_Order_Mutation_Response>;
  smart_match_criteria_order_on_conflict: Smart_Match_Criteria_Order_On_Conflict;
  smart_match_criteria_order_order_by: Smart_Match_Criteria_Order_Order_By;
  smart_match_criteria_order_pk_columns_input: Smart_Match_Criteria_Order_Pk_Columns_Input;
  smart_match_criteria_order_select_column: Smart_Match_Criteria_Order_Select_Column;
  smart_match_criteria_order_set_input: Smart_Match_Criteria_Order_Set_Input;
  smart_match_criteria_order_stddev_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Stddev_Fields>;
  smart_match_criteria_order_stddev_order_by: Smart_Match_Criteria_Order_Stddev_Order_By;
  smart_match_criteria_order_stddev_pop_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Stddev_Pop_Fields>;
  smart_match_criteria_order_stddev_pop_order_by: Smart_Match_Criteria_Order_Stddev_Pop_Order_By;
  smart_match_criteria_order_stddev_samp_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Stddev_Samp_Fields>;
  smart_match_criteria_order_stddev_samp_order_by: Smart_Match_Criteria_Order_Stddev_Samp_Order_By;
  smart_match_criteria_order_stream_cursor_input: Smart_Match_Criteria_Order_Stream_Cursor_Input;
  smart_match_criteria_order_stream_cursor_value_input: Smart_Match_Criteria_Order_Stream_Cursor_Value_Input;
  smart_match_criteria_order_sum_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Sum_Fields>;
  smart_match_criteria_order_sum_order_by: Smart_Match_Criteria_Order_Sum_Order_By;
  smart_match_criteria_order_update_column: Smart_Match_Criteria_Order_Update_Column;
  smart_match_criteria_order_updates: Smart_Match_Criteria_Order_Updates;
  smart_match_criteria_order_var_pop_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Var_Pop_Fields>;
  smart_match_criteria_order_var_pop_order_by: Smart_Match_Criteria_Order_Var_Pop_Order_By;
  smart_match_criteria_order_var_samp_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Var_Samp_Fields>;
  smart_match_criteria_order_var_samp_order_by: Smart_Match_Criteria_Order_Var_Samp_Order_By;
  smart_match_criteria_order_variance_fields: ResolverTypeWrapper<Smart_Match_Criteria_Order_Variance_Fields>;
  smart_match_criteria_order_variance_order_by: Smart_Match_Criteria_Order_Variance_Order_By;
  soft_skill: ResolverTypeWrapper<Soft_Skill>;
  soft_skill_aggregate: ResolverTypeWrapper<Soft_Skill_Aggregate>;
  soft_skill_aggregate_bool_exp: Soft_Skill_Aggregate_Bool_Exp;
  soft_skill_aggregate_bool_exp_count: Soft_Skill_Aggregate_Bool_Exp_Count;
  soft_skill_aggregate_fields: ResolverTypeWrapper<Soft_Skill_Aggregate_Fields>;
  soft_skill_aggregate_order_by: Soft_Skill_Aggregate_Order_By;
  soft_skill_arr_rel_insert_input: Soft_Skill_Arr_Rel_Insert_Input;
  soft_skill_avg_fields: ResolverTypeWrapper<Soft_Skill_Avg_Fields>;
  soft_skill_avg_order_by: Soft_Skill_Avg_Order_By;
  soft_skill_bool_exp: Soft_Skill_Bool_Exp;
  soft_skill_constraint: Soft_Skill_Constraint;
  soft_skill_inc_input: Soft_Skill_Inc_Input;
  soft_skill_insert_input: Soft_Skill_Insert_Input;
  soft_skill_max_fields: ResolverTypeWrapper<Soft_Skill_Max_Fields>;
  soft_skill_max_order_by: Soft_Skill_Max_Order_By;
  soft_skill_min_fields: ResolverTypeWrapper<Soft_Skill_Min_Fields>;
  soft_skill_min_order_by: Soft_Skill_Min_Order_By;
  soft_skill_mutation_response: ResolverTypeWrapper<Soft_Skill_Mutation_Response>;
  soft_skill_obj_rel_insert_input: Soft_Skill_Obj_Rel_Insert_Input;
  soft_skill_on_conflict: Soft_Skill_On_Conflict;
  soft_skill_order_by: Soft_Skill_Order_By;
  soft_skill_pk_columns_input: Soft_Skill_Pk_Columns_Input;
  soft_skill_select_column: Soft_Skill_Select_Column;
  soft_skill_set_input: Soft_Skill_Set_Input;
  soft_skill_stddev_fields: ResolverTypeWrapper<Soft_Skill_Stddev_Fields>;
  soft_skill_stddev_order_by: Soft_Skill_Stddev_Order_By;
  soft_skill_stddev_pop_fields: ResolverTypeWrapper<Soft_Skill_Stddev_Pop_Fields>;
  soft_skill_stddev_pop_order_by: Soft_Skill_Stddev_Pop_Order_By;
  soft_skill_stddev_samp_fields: ResolverTypeWrapper<Soft_Skill_Stddev_Samp_Fields>;
  soft_skill_stddev_samp_order_by: Soft_Skill_Stddev_Samp_Order_By;
  soft_skill_stream_cursor_input: Soft_Skill_Stream_Cursor_Input;
  soft_skill_stream_cursor_value_input: Soft_Skill_Stream_Cursor_Value_Input;
  soft_skill_sum_fields: ResolverTypeWrapper<Soft_Skill_Sum_Fields>;
  soft_skill_sum_order_by: Soft_Skill_Sum_Order_By;
  soft_skill_update_column: Soft_Skill_Update_Column;
  soft_skill_updates: Soft_Skill_Updates;
  soft_skill_var_pop_fields: ResolverTypeWrapper<Soft_Skill_Var_Pop_Fields>;
  soft_skill_var_pop_order_by: Soft_Skill_Var_Pop_Order_By;
  soft_skill_var_samp_fields: ResolverTypeWrapper<Soft_Skill_Var_Samp_Fields>;
  soft_skill_var_samp_order_by: Soft_Skill_Var_Samp_Order_By;
  soft_skill_variance_fields: ResolverTypeWrapper<Soft_Skill_Variance_Fields>;
  soft_skill_variance_order_by: Soft_Skill_Variance_Order_By;
  source: ResolverTypeWrapper<Source>;
  source_aggregate: ResolverTypeWrapper<Source_Aggregate>;
  source_aggregate_fields: ResolverTypeWrapper<Source_Aggregate_Fields>;
  source_bool_exp: Source_Bool_Exp;
  source_constraint: Source_Constraint;
  source_insert_input: Source_Insert_Input;
  source_max_fields: ResolverTypeWrapper<Source_Max_Fields>;
  source_min_fields: ResolverTypeWrapper<Source_Min_Fields>;
  source_mutation_response: ResolverTypeWrapper<Source_Mutation_Response>;
  source_obj_rel_insert_input: Source_Obj_Rel_Insert_Input;
  source_on_conflict: Source_On_Conflict;
  source_order_by: Source_Order_By;
  source_pk_columns_input: Source_Pk_Columns_Input;
  source_select_column: Source_Select_Column;
  source_set_input: Source_Set_Input;
  source_stream_cursor_input: Source_Stream_Cursor_Input;
  source_stream_cursor_value_input: Source_Stream_Cursor_Value_Input;
  source_update_column: Source_Update_Column;
  source_updates: Source_Updates;
  subscription: ResolverTypeWrapper<Subscription>;
  subscription_aggregate: ResolverTypeWrapper<Subscription_Aggregate>;
  subscription_aggregate_bool_exp: Subscription_Aggregate_Bool_Exp;
  subscription_aggregate_bool_exp_bool_and: Subscription_Aggregate_Bool_Exp_Bool_And;
  subscription_aggregate_bool_exp_bool_or: Subscription_Aggregate_Bool_Exp_Bool_Or;
  subscription_aggregate_bool_exp_count: Subscription_Aggregate_Bool_Exp_Count;
  subscription_aggregate_fields: ResolverTypeWrapper<Subscription_Aggregate_Fields>;
  subscription_aggregate_order_by: Subscription_Aggregate_Order_By;
  subscription_arr_rel_insert_input: Subscription_Arr_Rel_Insert_Input;
  subscription_avg_fields: ResolverTypeWrapper<Subscription_Avg_Fields>;
  subscription_avg_order_by: Subscription_Avg_Order_By;
  subscription_bool_exp: Subscription_Bool_Exp;
  subscription_constraint: Subscription_Constraint;
  subscription_inc_input: Subscription_Inc_Input;
  subscription_insert_input: Subscription_Insert_Input;
  subscription_max_fields: ResolverTypeWrapper<Subscription_Max_Fields>;
  subscription_max_order_by: Subscription_Max_Order_By;
  subscription_min_fields: ResolverTypeWrapper<Subscription_Min_Fields>;
  subscription_min_order_by: Subscription_Min_Order_By;
  subscription_mutation_response: ResolverTypeWrapper<Subscription_Mutation_Response>;
  subscription_on_conflict: Subscription_On_Conflict;
  subscription_order_by: Subscription_Order_By;
  subscription_pk_columns_input: Subscription_Pk_Columns_Input;
  subscription_plan: ResolverTypeWrapper<Subscription_Plan>;
  subscription_plan_access_permissions: ResolverTypeWrapper<Subscription_Plan_Access_Permissions>;
  subscription_plan_access_permissions_aggregate: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Aggregate>;
  subscription_plan_access_permissions_aggregate_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Aggregate_Fields>;
  subscription_plan_access_permissions_avg_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Avg_Fields>;
  subscription_plan_access_permissions_bool_exp: Subscription_Plan_Access_Permissions_Bool_Exp;
  subscription_plan_access_permissions_constraint: Subscription_Plan_Access_Permissions_Constraint;
  subscription_plan_access_permissions_inc_input: Subscription_Plan_Access_Permissions_Inc_Input;
  subscription_plan_access_permissions_insert_input: Subscription_Plan_Access_Permissions_Insert_Input;
  subscription_plan_access_permissions_max_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Max_Fields>;
  subscription_plan_access_permissions_min_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Min_Fields>;
  subscription_plan_access_permissions_mutation_response: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Mutation_Response>;
  subscription_plan_access_permissions_obj_rel_insert_input: Subscription_Plan_Access_Permissions_Obj_Rel_Insert_Input;
  subscription_plan_access_permissions_on_conflict: Subscription_Plan_Access_Permissions_On_Conflict;
  subscription_plan_access_permissions_order_by: Subscription_Plan_Access_Permissions_Order_By;
  subscription_plan_access_permissions_pk_columns_input: Subscription_Plan_Access_Permissions_Pk_Columns_Input;
  subscription_plan_access_permissions_select_column: Subscription_Plan_Access_Permissions_Select_Column;
  subscription_plan_access_permissions_set_input: Subscription_Plan_Access_Permissions_Set_Input;
  subscription_plan_access_permissions_stddev_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Stddev_Fields>;
  subscription_plan_access_permissions_stddev_pop_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Stddev_Pop_Fields>;
  subscription_plan_access_permissions_stddev_samp_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Stddev_Samp_Fields>;
  subscription_plan_access_permissions_stream_cursor_input: Subscription_Plan_Access_Permissions_Stream_Cursor_Input;
  subscription_plan_access_permissions_stream_cursor_value_input: Subscription_Plan_Access_Permissions_Stream_Cursor_Value_Input;
  subscription_plan_access_permissions_sum_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Sum_Fields>;
  subscription_plan_access_permissions_update_column: Subscription_Plan_Access_Permissions_Update_Column;
  subscription_plan_access_permissions_updates: Subscription_Plan_Access_Permissions_Updates;
  subscription_plan_access_permissions_var_pop_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Var_Pop_Fields>;
  subscription_plan_access_permissions_var_samp_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Var_Samp_Fields>;
  subscription_plan_access_permissions_variance_fields: ResolverTypeWrapper<Subscription_Plan_Access_Permissions_Variance_Fields>;
  subscription_plan_aggregate: ResolverTypeWrapper<Subscription_Plan_Aggregate>;
  subscription_plan_aggregate_bool_exp: Subscription_Plan_Aggregate_Bool_Exp;
  subscription_plan_aggregate_bool_exp_bool_and: Subscription_Plan_Aggregate_Bool_Exp_Bool_And;
  subscription_plan_aggregate_bool_exp_bool_or: Subscription_Plan_Aggregate_Bool_Exp_Bool_Or;
  subscription_plan_aggregate_bool_exp_count: Subscription_Plan_Aggregate_Bool_Exp_Count;
  subscription_plan_aggregate_fields: ResolverTypeWrapper<Subscription_Plan_Aggregate_Fields>;
  subscription_plan_aggregate_order_by: Subscription_Plan_Aggregate_Order_By;
  subscription_plan_arr_rel_insert_input: Subscription_Plan_Arr_Rel_Insert_Input;
  subscription_plan_bool_exp: Subscription_Plan_Bool_Exp;
  subscription_plan_constraint: Subscription_Plan_Constraint;
  subscription_plan_insert_input: Subscription_Plan_Insert_Input;
  subscription_plan_max_fields: ResolverTypeWrapper<Subscription_Plan_Max_Fields>;
  subscription_plan_max_order_by: Subscription_Plan_Max_Order_By;
  subscription_plan_min_fields: ResolverTypeWrapper<Subscription_Plan_Min_Fields>;
  subscription_plan_min_order_by: Subscription_Plan_Min_Order_By;
  subscription_plan_mutation_response: ResolverTypeWrapper<Subscription_Plan_Mutation_Response>;
  subscription_plan_obj_rel_insert_input: Subscription_Plan_Obj_Rel_Insert_Input;
  subscription_plan_on_conflict: Subscription_Plan_On_Conflict;
  subscription_plan_order_by: Subscription_Plan_Order_By;
  subscription_plan_pk_columns_input: Subscription_Plan_Pk_Columns_Input;
  subscription_plan_select_column: Subscription_Plan_Select_Column;
  subscription_plan_select_column_subscription_plan_aggregate_bool_exp_bool_and_arguments_columns: Subscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  subscription_plan_select_column_subscription_plan_aggregate_bool_exp_bool_or_arguments_columns: Subscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  subscription_plan_set_input: Subscription_Plan_Set_Input;
  subscription_plan_stream_cursor_input: Subscription_Plan_Stream_Cursor_Input;
  subscription_plan_stream_cursor_value_input: Subscription_Plan_Stream_Cursor_Value_Input;
  subscription_plan_update_column: Subscription_Plan_Update_Column;
  subscription_plan_updates: Subscription_Plan_Updates;
  subscription_root: ResolverTypeWrapper<{}>;
  subscription_select_column: Subscription_Select_Column;
  subscription_select_column_subscription_aggregate_bool_exp_bool_and_arguments_columns: Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  subscription_select_column_subscription_aggregate_bool_exp_bool_or_arguments_columns: Subscription_Select_Column_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  subscription_set_input: Subscription_Set_Input;
  subscription_stddev_fields: ResolverTypeWrapper<Subscription_Stddev_Fields>;
  subscription_stddev_order_by: Subscription_Stddev_Order_By;
  subscription_stddev_pop_fields: ResolverTypeWrapper<Subscription_Stddev_Pop_Fields>;
  subscription_stddev_pop_order_by: Subscription_Stddev_Pop_Order_By;
  subscription_stddev_samp_fields: ResolverTypeWrapper<Subscription_Stddev_Samp_Fields>;
  subscription_stddev_samp_order_by: Subscription_Stddev_Samp_Order_By;
  subscription_stream_cursor_input: Subscription_Stream_Cursor_Input;
  subscription_stream_cursor_value_input: Subscription_Stream_Cursor_Value_Input;
  subscription_sum_fields: ResolverTypeWrapper<Subscription_Sum_Fields>;
  subscription_sum_order_by: Subscription_Sum_Order_By;
  subscription_update_column: Subscription_Update_Column;
  subscription_updates: Subscription_Updates;
  subscription_var_pop_fields: ResolverTypeWrapper<Subscription_Var_Pop_Fields>;
  subscription_var_pop_order_by: Subscription_Var_Pop_Order_By;
  subscription_var_samp_fields: ResolverTypeWrapper<Subscription_Var_Samp_Fields>;
  subscription_var_samp_order_by: Subscription_Var_Samp_Order_By;
  subscription_variance_fields: ResolverTypeWrapper<Subscription_Variance_Fields>;
  subscription_variance_order_by: Subscription_Variance_Order_By;
  tag: ResolverTypeWrapper<Tag>;
  tag_aggregate: ResolverTypeWrapper<Tag_Aggregate>;
  tag_aggregate_fields: ResolverTypeWrapper<Tag_Aggregate_Fields>;
  tag_bool_exp: Tag_Bool_Exp;
  tag_constraint: Tag_Constraint;
  tag_insert_input: Tag_Insert_Input;
  tag_max_fields: ResolverTypeWrapper<Tag_Max_Fields>;
  tag_min_fields: ResolverTypeWrapper<Tag_Min_Fields>;
  tag_mutation_response: ResolverTypeWrapper<Tag_Mutation_Response>;
  tag_obj_rel_insert_input: Tag_Obj_Rel_Insert_Input;
  tag_on_conflict: Tag_On_Conflict;
  tag_order_by: Tag_Order_By;
  tag_pk_columns_input: Tag_Pk_Columns_Input;
  tag_select_column: Tag_Select_Column;
  tag_set_input: Tag_Set_Input;
  tag_stream_cursor_input: Tag_Stream_Cursor_Input;
  tag_stream_cursor_value_input: Tag_Stream_Cursor_Value_Input;
  tag_update_column: Tag_Update_Column;
  tag_updates: Tag_Updates;
  team: ResolverTypeWrapper<Team>;
  team_aggregate: ResolverTypeWrapper<Team_Aggregate>;
  team_aggregate_bool_exp: Team_Aggregate_Bool_Exp;
  team_aggregate_bool_exp_bool_and: Team_Aggregate_Bool_Exp_Bool_And;
  team_aggregate_bool_exp_bool_or: Team_Aggregate_Bool_Exp_Bool_Or;
  team_aggregate_bool_exp_count: Team_Aggregate_Bool_Exp_Count;
  team_aggregate_fields: ResolverTypeWrapper<Team_Aggregate_Fields>;
  team_aggregate_order_by: Team_Aggregate_Order_By;
  team_arr_rel_insert_input: Team_Arr_Rel_Insert_Input;
  team_bool_exp: Team_Bool_Exp;
  team_constraint: Team_Constraint;
  team_contractor: ResolverTypeWrapper<Team_Contractor>;
  team_contractor_aggregate: ResolverTypeWrapper<Team_Contractor_Aggregate>;
  team_contractor_aggregate_bool_exp: Team_Contractor_Aggregate_Bool_Exp;
  team_contractor_aggregate_bool_exp_count: Team_Contractor_Aggregate_Bool_Exp_Count;
  team_contractor_aggregate_fields: ResolverTypeWrapper<Team_Contractor_Aggregate_Fields>;
  team_contractor_aggregate_order_by: Team_Contractor_Aggregate_Order_By;
  team_contractor_arr_rel_insert_input: Team_Contractor_Arr_Rel_Insert_Input;
  team_contractor_bool_exp: Team_Contractor_Bool_Exp;
  team_contractor_constraint: Team_Contractor_Constraint;
  team_contractor_insert_input: Team_Contractor_Insert_Input;
  team_contractor_max_fields: ResolverTypeWrapper<Team_Contractor_Max_Fields>;
  team_contractor_max_order_by: Team_Contractor_Max_Order_By;
  team_contractor_min_fields: ResolverTypeWrapper<Team_Contractor_Min_Fields>;
  team_contractor_min_order_by: Team_Contractor_Min_Order_By;
  team_contractor_mutation_response: ResolverTypeWrapper<Team_Contractor_Mutation_Response>;
  team_contractor_on_conflict: Team_Contractor_On_Conflict;
  team_contractor_order_by: Team_Contractor_Order_By;
  team_contractor_pk_columns_input: Team_Contractor_Pk_Columns_Input;
  team_contractor_select_column: Team_Contractor_Select_Column;
  team_contractor_set_input: Team_Contractor_Set_Input;
  team_contractor_stream_cursor_input: Team_Contractor_Stream_Cursor_Input;
  team_contractor_stream_cursor_value_input: Team_Contractor_Stream_Cursor_Value_Input;
  team_contractor_update_column: Team_Contractor_Update_Column;
  team_contractor_updates: Team_Contractor_Updates;
  team_insert_input: Team_Insert_Input;
  team_manager: ResolverTypeWrapper<Team_Manager>;
  team_manager_aggregate: ResolverTypeWrapper<Team_Manager_Aggregate>;
  team_manager_aggregate_bool_exp: Team_Manager_Aggregate_Bool_Exp;
  team_manager_aggregate_bool_exp_count: Team_Manager_Aggregate_Bool_Exp_Count;
  team_manager_aggregate_fields: ResolverTypeWrapper<Team_Manager_Aggregate_Fields>;
  team_manager_aggregate_order_by: Team_Manager_Aggregate_Order_By;
  team_manager_arr_rel_insert_input: Team_Manager_Arr_Rel_Insert_Input;
  team_manager_bool_exp: Team_Manager_Bool_Exp;
  team_manager_constraint: Team_Manager_Constraint;
  team_manager_insert_input: Team_Manager_Insert_Input;
  team_manager_max_fields: ResolverTypeWrapper<Team_Manager_Max_Fields>;
  team_manager_max_order_by: Team_Manager_Max_Order_By;
  team_manager_min_fields: ResolverTypeWrapper<Team_Manager_Min_Fields>;
  team_manager_min_order_by: Team_Manager_Min_Order_By;
  team_manager_mutation_response: ResolverTypeWrapper<Team_Manager_Mutation_Response>;
  team_manager_on_conflict: Team_Manager_On_Conflict;
  team_manager_order_by: Team_Manager_Order_By;
  team_manager_pk_columns_input: Team_Manager_Pk_Columns_Input;
  team_manager_select_column: Team_Manager_Select_Column;
  team_manager_set_input: Team_Manager_Set_Input;
  team_manager_stream_cursor_input: Team_Manager_Stream_Cursor_Input;
  team_manager_stream_cursor_value_input: Team_Manager_Stream_Cursor_Value_Input;
  team_manager_update_column: Team_Manager_Update_Column;
  team_manager_updates: Team_Manager_Updates;
  team_max_fields: ResolverTypeWrapper<Team_Max_Fields>;
  team_max_order_by: Team_Max_Order_By;
  team_min_fields: ResolverTypeWrapper<Team_Min_Fields>;
  team_min_order_by: Team_Min_Order_By;
  team_mutation_response: ResolverTypeWrapper<Team_Mutation_Response>;
  team_obj_rel_insert_input: Team_Obj_Rel_Insert_Input;
  team_on_conflict: Team_On_Conflict;
  team_order_by: Team_Order_By;
  team_pk_columns_input: Team_Pk_Columns_Input;
  team_posting: ResolverTypeWrapper<Team_Posting>;
  team_posting_aggregate: ResolverTypeWrapper<Team_Posting_Aggregate>;
  team_posting_aggregate_bool_exp: Team_Posting_Aggregate_Bool_Exp;
  team_posting_aggregate_bool_exp_count: Team_Posting_Aggregate_Bool_Exp_Count;
  team_posting_aggregate_fields: ResolverTypeWrapper<Team_Posting_Aggregate_Fields>;
  team_posting_aggregate_order_by: Team_Posting_Aggregate_Order_By;
  team_posting_arr_rel_insert_input: Team_Posting_Arr_Rel_Insert_Input;
  team_posting_bool_exp: Team_Posting_Bool_Exp;
  team_posting_constraint: Team_Posting_Constraint;
  team_posting_insert_input: Team_Posting_Insert_Input;
  team_posting_max_fields: ResolverTypeWrapper<Team_Posting_Max_Fields>;
  team_posting_max_order_by: Team_Posting_Max_Order_By;
  team_posting_min_fields: ResolverTypeWrapper<Team_Posting_Min_Fields>;
  team_posting_min_order_by: Team_Posting_Min_Order_By;
  team_posting_mutation_response: ResolverTypeWrapper<Team_Posting_Mutation_Response>;
  team_posting_on_conflict: Team_Posting_On_Conflict;
  team_posting_order_by: Team_Posting_Order_By;
  team_posting_pk_columns_input: Team_Posting_Pk_Columns_Input;
  team_posting_select_column: Team_Posting_Select_Column;
  team_posting_set_input: Team_Posting_Set_Input;
  team_posting_stream_cursor_input: Team_Posting_Stream_Cursor_Input;
  team_posting_stream_cursor_value_input: Team_Posting_Stream_Cursor_Value_Input;
  team_posting_update_column: Team_Posting_Update_Column;
  team_posting_updates: Team_Posting_Updates;
  team_project: ResolverTypeWrapper<Team_Project>;
  team_project_aggregate: ResolverTypeWrapper<Team_Project_Aggregate>;
  team_project_aggregate_bool_exp: Team_Project_Aggregate_Bool_Exp;
  team_project_aggregate_bool_exp_count: Team_Project_Aggregate_Bool_Exp_Count;
  team_project_aggregate_fields: ResolverTypeWrapper<Team_Project_Aggregate_Fields>;
  team_project_aggregate_order_by: Team_Project_Aggregate_Order_By;
  team_project_arr_rel_insert_input: Team_Project_Arr_Rel_Insert_Input;
  team_project_bool_exp: Team_Project_Bool_Exp;
  team_project_constraint: Team_Project_Constraint;
  team_project_insert_input: Team_Project_Insert_Input;
  team_project_max_fields: ResolverTypeWrapper<Team_Project_Max_Fields>;
  team_project_max_order_by: Team_Project_Max_Order_By;
  team_project_min_fields: ResolverTypeWrapper<Team_Project_Min_Fields>;
  team_project_min_order_by: Team_Project_Min_Order_By;
  team_project_mutation_response: ResolverTypeWrapper<Team_Project_Mutation_Response>;
  team_project_on_conflict: Team_Project_On_Conflict;
  team_project_order_by: Team_Project_Order_By;
  team_project_pk_columns_input: Team_Project_Pk_Columns_Input;
  team_project_select_column: Team_Project_Select_Column;
  team_project_set_input: Team_Project_Set_Input;
  team_project_stream_cursor_input: Team_Project_Stream_Cursor_Input;
  team_project_stream_cursor_value_input: Team_Project_Stream_Cursor_Value_Input;
  team_project_update_column: Team_Project_Update_Column;
  team_project_updates: Team_Project_Updates;
  team_select_column: Team_Select_Column;
  team_select_column_team_aggregate_bool_exp_bool_and_arguments_columns: Team_Select_Column_Team_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  team_select_column_team_aggregate_bool_exp_bool_or_arguments_columns: Team_Select_Column_Team_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  team_set_input: Team_Set_Input;
  team_skill: ResolverTypeWrapper<Team_Skill>;
  team_skill_aggregate: ResolverTypeWrapper<Team_Skill_Aggregate>;
  team_skill_aggregate_bool_exp: Team_Skill_Aggregate_Bool_Exp;
  team_skill_aggregate_bool_exp_count: Team_Skill_Aggregate_Bool_Exp_Count;
  team_skill_aggregate_fields: ResolverTypeWrapper<Team_Skill_Aggregate_Fields>;
  team_skill_aggregate_order_by: Team_Skill_Aggregate_Order_By;
  team_skill_arr_rel_insert_input: Team_Skill_Arr_Rel_Insert_Input;
  team_skill_avg_fields: ResolverTypeWrapper<Team_Skill_Avg_Fields>;
  team_skill_avg_order_by: Team_Skill_Avg_Order_By;
  team_skill_bool_exp: Team_Skill_Bool_Exp;
  team_skill_constraint: Team_Skill_Constraint;
  team_skill_inc_input: Team_Skill_Inc_Input;
  team_skill_insert_input: Team_Skill_Insert_Input;
  team_skill_max_fields: ResolverTypeWrapper<Team_Skill_Max_Fields>;
  team_skill_max_order_by: Team_Skill_Max_Order_By;
  team_skill_min_fields: ResolverTypeWrapper<Team_Skill_Min_Fields>;
  team_skill_min_order_by: Team_Skill_Min_Order_By;
  team_skill_mutation_response: ResolverTypeWrapper<Team_Skill_Mutation_Response>;
  team_skill_on_conflict: Team_Skill_On_Conflict;
  team_skill_order_by: Team_Skill_Order_By;
  team_skill_pk_columns_input: Team_Skill_Pk_Columns_Input;
  team_skill_select_column: Team_Skill_Select_Column;
  team_skill_set_input: Team_Skill_Set_Input;
  team_skill_stddev_fields: ResolverTypeWrapper<Team_Skill_Stddev_Fields>;
  team_skill_stddev_order_by: Team_Skill_Stddev_Order_By;
  team_skill_stddev_pop_fields: ResolverTypeWrapper<Team_Skill_Stddev_Pop_Fields>;
  team_skill_stddev_pop_order_by: Team_Skill_Stddev_Pop_Order_By;
  team_skill_stddev_samp_fields: ResolverTypeWrapper<Team_Skill_Stddev_Samp_Fields>;
  team_skill_stddev_samp_order_by: Team_Skill_Stddev_Samp_Order_By;
  team_skill_stream_cursor_input: Team_Skill_Stream_Cursor_Input;
  team_skill_stream_cursor_value_input: Team_Skill_Stream_Cursor_Value_Input;
  team_skill_sum_fields: ResolverTypeWrapper<Team_Skill_Sum_Fields>;
  team_skill_sum_order_by: Team_Skill_Sum_Order_By;
  team_skill_update_column: Team_Skill_Update_Column;
  team_skill_updates: Team_Skill_Updates;
  team_skill_var_pop_fields: ResolverTypeWrapper<Team_Skill_Var_Pop_Fields>;
  team_skill_var_pop_order_by: Team_Skill_Var_Pop_Order_By;
  team_skill_var_samp_fields: ResolverTypeWrapper<Team_Skill_Var_Samp_Fields>;
  team_skill_var_samp_order_by: Team_Skill_Var_Samp_Order_By;
  team_skill_variance_fields: ResolverTypeWrapper<Team_Skill_Variance_Fields>;
  team_skill_variance_order_by: Team_Skill_Variance_Order_By;
  team_stream_cursor_input: Team_Stream_Cursor_Input;
  team_stream_cursor_value_input: Team_Stream_Cursor_Value_Input;
  team_update_column: Team_Update_Column;
  team_updates: Team_Updates;
  time: ResolverTypeWrapper<Scalars['time']>;
  time_comparison_exp: Time_Comparison_Exp;
  timesheet: ResolverTypeWrapper<Timesheet>;
  timesheet_aggregate: ResolverTypeWrapper<Timesheet_Aggregate>;
  timesheet_aggregate_fields: ResolverTypeWrapper<Timesheet_Aggregate_Fields>;
  timesheet_avg_fields: ResolverTypeWrapper<Timesheet_Avg_Fields>;
  timesheet_bool_exp: Timesheet_Bool_Exp;
  timesheet_constraint: Timesheet_Constraint;
  timesheet_inc_input: Timesheet_Inc_Input;
  timesheet_insert_input: Timesheet_Insert_Input;
  timesheet_max_fields: ResolverTypeWrapper<Timesheet_Max_Fields>;
  timesheet_min_fields: ResolverTypeWrapper<Timesheet_Min_Fields>;
  timesheet_mutation_response: ResolverTypeWrapper<Timesheet_Mutation_Response>;
  timesheet_obj_rel_insert_input: Timesheet_Obj_Rel_Insert_Input;
  timesheet_on_conflict: Timesheet_On_Conflict;
  timesheet_order_by: Timesheet_Order_By;
  timesheet_pk_columns_input: Timesheet_Pk_Columns_Input;
  timesheet_select_column: Timesheet_Select_Column;
  timesheet_set_input: Timesheet_Set_Input;
  timesheet_stddev_fields: ResolverTypeWrapper<Timesheet_Stddev_Fields>;
  timesheet_stddev_pop_fields: ResolverTypeWrapper<Timesheet_Stddev_Pop_Fields>;
  timesheet_stddev_samp_fields: ResolverTypeWrapper<Timesheet_Stddev_Samp_Fields>;
  timesheet_stream_cursor_input: Timesheet_Stream_Cursor_Input;
  timesheet_stream_cursor_value_input: Timesheet_Stream_Cursor_Value_Input;
  timesheet_sum_fields: ResolverTypeWrapper<Timesheet_Sum_Fields>;
  timesheet_update_column: Timesheet_Update_Column;
  timesheet_updates: Timesheet_Updates;
  timesheet_var_pop_fields: ResolverTypeWrapper<Timesheet_Var_Pop_Fields>;
  timesheet_var_samp_fields: ResolverTypeWrapper<Timesheet_Var_Samp_Fields>;
  timesheet_variance_fields: ResolverTypeWrapper<Timesheet_Variance_Fields>;
  timestamp: ResolverTypeWrapper<Scalars['timestamp']>;
  timestamp_comparison_exp: Timestamp_Comparison_Exp;
  timestamptz: ResolverTypeWrapper<Scalars['timestamptz']>;
  timestamptz_comparison_exp: Timestamptz_Comparison_Exp;
  timetz: ResolverTypeWrapper<Scalars['timetz']>;
  timetz_comparison_exp: Timetz_Comparison_Exp;
  type_of_visit: ResolverTypeWrapper<Type_Of_Visit>;
  type_of_visit_aggregate: ResolverTypeWrapper<Type_Of_Visit_Aggregate>;
  type_of_visit_aggregate_fields: ResolverTypeWrapper<Type_Of_Visit_Aggregate_Fields>;
  type_of_visit_bool_exp: Type_Of_Visit_Bool_Exp;
  type_of_visit_constraint: Type_Of_Visit_Constraint;
  type_of_visit_enum: Type_Of_Visit_Enum;
  type_of_visit_enum_comparison_exp: Type_Of_Visit_Enum_Comparison_Exp;
  type_of_visit_insert_input: Type_Of_Visit_Insert_Input;
  type_of_visit_max_fields: ResolverTypeWrapper<Type_Of_Visit_Max_Fields>;
  type_of_visit_min_fields: ResolverTypeWrapper<Type_Of_Visit_Min_Fields>;
  type_of_visit_mutation_response: ResolverTypeWrapper<Type_Of_Visit_Mutation_Response>;
  type_of_visit_on_conflict: Type_Of_Visit_On_Conflict;
  type_of_visit_order_by: Type_Of_Visit_Order_By;
  type_of_visit_pk_columns_input: Type_Of_Visit_Pk_Columns_Input;
  type_of_visit_select_column: Type_Of_Visit_Select_Column;
  type_of_visit_set_input: Type_Of_Visit_Set_Input;
  type_of_visit_stream_cursor_input: Type_Of_Visit_Stream_Cursor_Input;
  type_of_visit_stream_cursor_value_input: Type_Of_Visit_Stream_Cursor_Value_Input;
  type_of_visit_update_column: Type_Of_Visit_Update_Column;
  type_of_visit_updates: Type_Of_Visit_Updates;
  unread_messages: ResolverTypeWrapper<Unread_Messages>;
  unread_messages_aggregate: ResolverTypeWrapper<Unread_Messages_Aggregate>;
  unread_messages_aggregate_bool_exp: Unread_Messages_Aggregate_Bool_Exp;
  unread_messages_aggregate_bool_exp_count: Unread_Messages_Aggregate_Bool_Exp_Count;
  unread_messages_aggregate_fields: ResolverTypeWrapper<Unread_Messages_Aggregate_Fields>;
  unread_messages_aggregate_order_by: Unread_Messages_Aggregate_Order_By;
  unread_messages_arr_rel_insert_input: Unread_Messages_Arr_Rel_Insert_Input;
  unread_messages_avg_fields: ResolverTypeWrapper<Unread_Messages_Avg_Fields>;
  unread_messages_avg_order_by: Unread_Messages_Avg_Order_By;
  unread_messages_bool_exp: Unread_Messages_Bool_Exp;
  unread_messages_insert_input: Unread_Messages_Insert_Input;
  unread_messages_max_fields: ResolverTypeWrapper<Unread_Messages_Max_Fields>;
  unread_messages_max_order_by: Unread_Messages_Max_Order_By;
  unread_messages_min_fields: ResolverTypeWrapper<Unread_Messages_Min_Fields>;
  unread_messages_min_order_by: Unread_Messages_Min_Order_By;
  unread_messages_order_by: Unread_Messages_Order_By;
  unread_messages_select_column: Unread_Messages_Select_Column;
  unread_messages_stddev_fields: ResolverTypeWrapper<Unread_Messages_Stddev_Fields>;
  unread_messages_stddev_order_by: Unread_Messages_Stddev_Order_By;
  unread_messages_stddev_pop_fields: ResolverTypeWrapper<Unread_Messages_Stddev_Pop_Fields>;
  unread_messages_stddev_pop_order_by: Unread_Messages_Stddev_Pop_Order_By;
  unread_messages_stddev_samp_fields: ResolverTypeWrapper<Unread_Messages_Stddev_Samp_Fields>;
  unread_messages_stddev_samp_order_by: Unread_Messages_Stddev_Samp_Order_By;
  unread_messages_stream_cursor_input: Unread_Messages_Stream_Cursor_Input;
  unread_messages_stream_cursor_value_input: Unread_Messages_Stream_Cursor_Value_Input;
  unread_messages_sum_fields: ResolverTypeWrapper<Unread_Messages_Sum_Fields>;
  unread_messages_sum_order_by: Unread_Messages_Sum_Order_By;
  unread_messages_var_pop_fields: ResolverTypeWrapper<Unread_Messages_Var_Pop_Fields>;
  unread_messages_var_pop_order_by: Unread_Messages_Var_Pop_Order_By;
  unread_messages_var_samp_fields: ResolverTypeWrapper<Unread_Messages_Var_Samp_Fields>;
  unread_messages_var_samp_order_by: Unread_Messages_Var_Samp_Order_By;
  unread_messages_variance_fields: ResolverTypeWrapper<Unread_Messages_Variance_Fields>;
  unread_messages_variance_order_by: Unread_Messages_Variance_Order_By;
  user: ResolverTypeWrapper<User>;
  user_affinda_profile: ResolverTypeWrapper<User_Affinda_Profile>;
  user_affinda_profile_aggregate: ResolverTypeWrapper<User_Affinda_Profile_Aggregate>;
  user_affinda_profile_aggregate_fields: ResolverTypeWrapper<User_Affinda_Profile_Aggregate_Fields>;
  user_affinda_profile_bool_exp: User_Affinda_Profile_Bool_Exp;
  user_affinda_profile_constraint: User_Affinda_Profile_Constraint;
  user_affinda_profile_insert_input: User_Affinda_Profile_Insert_Input;
  user_affinda_profile_max_fields: ResolverTypeWrapper<User_Affinda_Profile_Max_Fields>;
  user_affinda_profile_min_fields: ResolverTypeWrapper<User_Affinda_Profile_Min_Fields>;
  user_affinda_profile_mutation_response: ResolverTypeWrapper<User_Affinda_Profile_Mutation_Response>;
  user_affinda_profile_on_conflict: User_Affinda_Profile_On_Conflict;
  user_affinda_profile_order_by: User_Affinda_Profile_Order_By;
  user_affinda_profile_pk_columns_input: User_Affinda_Profile_Pk_Columns_Input;
  user_affinda_profile_select_column: User_Affinda_Profile_Select_Column;
  user_affinda_profile_set_input: User_Affinda_Profile_Set_Input;
  user_affinda_profile_stream_cursor_input: User_Affinda_Profile_Stream_Cursor_Input;
  user_affinda_profile_stream_cursor_value_input: User_Affinda_Profile_Stream_Cursor_Value_Input;
  user_affinda_profile_update_column: User_Affinda_Profile_Update_Column;
  user_affinda_profile_updates: User_Affinda_Profile_Updates;
  user_aggregate: ResolverTypeWrapper<User_Aggregate>;
  user_aggregate_fields: ResolverTypeWrapper<User_Aggregate_Fields>;
  user_append_input: User_Append_Input;
  user_avg_fields: ResolverTypeWrapper<User_Avg_Fields>;
  user_bool_exp: User_Bool_Exp;
  user_certification: ResolverTypeWrapper<User_Certification>;
  user_certification_aggregate: ResolverTypeWrapper<User_Certification_Aggregate>;
  user_certification_aggregate_bool_exp: User_Certification_Aggregate_Bool_Exp;
  user_certification_aggregate_bool_exp_count: User_Certification_Aggregate_Bool_Exp_Count;
  user_certification_aggregate_fields: ResolverTypeWrapper<User_Certification_Aggregate_Fields>;
  user_certification_aggregate_order_by: User_Certification_Aggregate_Order_By;
  user_certification_arr_rel_insert_input: User_Certification_Arr_Rel_Insert_Input;
  user_certification_avg_fields: ResolverTypeWrapper<User_Certification_Avg_Fields>;
  user_certification_avg_order_by: User_Certification_Avg_Order_By;
  user_certification_bool_exp: User_Certification_Bool_Exp;
  user_certification_constraint: User_Certification_Constraint;
  user_certification_inc_input: User_Certification_Inc_Input;
  user_certification_insert_input: User_Certification_Insert_Input;
  user_certification_max_fields: ResolverTypeWrapper<User_Certification_Max_Fields>;
  user_certification_max_order_by: User_Certification_Max_Order_By;
  user_certification_min_fields: ResolverTypeWrapper<User_Certification_Min_Fields>;
  user_certification_min_order_by: User_Certification_Min_Order_By;
  user_certification_mutation_response: ResolverTypeWrapper<User_Certification_Mutation_Response>;
  user_certification_on_conflict: User_Certification_On_Conflict;
  user_certification_order_by: User_Certification_Order_By;
  user_certification_pk_columns_input: User_Certification_Pk_Columns_Input;
  user_certification_select_column: User_Certification_Select_Column;
  user_certification_set_input: User_Certification_Set_Input;
  user_certification_stddev_fields: ResolverTypeWrapper<User_Certification_Stddev_Fields>;
  user_certification_stddev_order_by: User_Certification_Stddev_Order_By;
  user_certification_stddev_pop_fields: ResolverTypeWrapper<User_Certification_Stddev_Pop_Fields>;
  user_certification_stddev_pop_order_by: User_Certification_Stddev_Pop_Order_By;
  user_certification_stddev_samp_fields: ResolverTypeWrapper<User_Certification_Stddev_Samp_Fields>;
  user_certification_stddev_samp_order_by: User_Certification_Stddev_Samp_Order_By;
  user_certification_stream_cursor_input: User_Certification_Stream_Cursor_Input;
  user_certification_stream_cursor_value_input: User_Certification_Stream_Cursor_Value_Input;
  user_certification_sum_fields: ResolverTypeWrapper<User_Certification_Sum_Fields>;
  user_certification_sum_order_by: User_Certification_Sum_Order_By;
  user_certification_update_column: User_Certification_Update_Column;
  user_certification_updates: User_Certification_Updates;
  user_certification_var_pop_fields: ResolverTypeWrapper<User_Certification_Var_Pop_Fields>;
  user_certification_var_pop_order_by: User_Certification_Var_Pop_Order_By;
  user_certification_var_samp_fields: ResolverTypeWrapper<User_Certification_Var_Samp_Fields>;
  user_certification_var_samp_order_by: User_Certification_Var_Samp_Order_By;
  user_certification_variance_fields: ResolverTypeWrapper<User_Certification_Variance_Fields>;
  user_certification_variance_order_by: User_Certification_Variance_Order_By;
  user_company: ResolverTypeWrapper<User_Company>;
  user_company_aggregate: ResolverTypeWrapper<User_Company_Aggregate>;
  user_company_aggregate_bool_exp: User_Company_Aggregate_Bool_Exp;
  user_company_aggregate_bool_exp_count: User_Company_Aggregate_Bool_Exp_Count;
  user_company_aggregate_fields: ResolverTypeWrapper<User_Company_Aggregate_Fields>;
  user_company_aggregate_order_by: User_Company_Aggregate_Order_By;
  user_company_arr_rel_insert_input: User_Company_Arr_Rel_Insert_Input;
  user_company_bool_exp: User_Company_Bool_Exp;
  user_company_constraint: User_Company_Constraint;
  user_company_insert_input: User_Company_Insert_Input;
  user_company_max_fields: ResolverTypeWrapper<User_Company_Max_Fields>;
  user_company_max_order_by: User_Company_Max_Order_By;
  user_company_min_fields: ResolverTypeWrapper<User_Company_Min_Fields>;
  user_company_min_order_by: User_Company_Min_Order_By;
  user_company_mutation_response: ResolverTypeWrapper<User_Company_Mutation_Response>;
  user_company_on_conflict: User_Company_On_Conflict;
  user_company_order_by: User_Company_Order_By;
  user_company_pk_columns_input: User_Company_Pk_Columns_Input;
  user_company_select_column: User_Company_Select_Column;
  user_company_set_input: User_Company_Set_Input;
  user_company_stream_cursor_input: User_Company_Stream_Cursor_Input;
  user_company_stream_cursor_value_input: User_Company_Stream_Cursor_Value_Input;
  user_company_update_column: User_Company_Update_Column;
  user_company_updates: User_Company_Updates;
  user_constraint: User_Constraint;
  user_conversation: ResolverTypeWrapper<User_Conversation>;
  user_conversation_aggregate: ResolverTypeWrapper<User_Conversation_Aggregate>;
  user_conversation_aggregate_bool_exp: User_Conversation_Aggregate_Bool_Exp;
  user_conversation_aggregate_bool_exp_bool_and: User_Conversation_Aggregate_Bool_Exp_Bool_And;
  user_conversation_aggregate_bool_exp_bool_or: User_Conversation_Aggregate_Bool_Exp_Bool_Or;
  user_conversation_aggregate_bool_exp_count: User_Conversation_Aggregate_Bool_Exp_Count;
  user_conversation_aggregate_fields: ResolverTypeWrapper<User_Conversation_Aggregate_Fields>;
  user_conversation_aggregate_order_by: User_Conversation_Aggregate_Order_By;
  user_conversation_arr_rel_insert_input: User_Conversation_Arr_Rel_Insert_Input;
  user_conversation_bool_exp: User_Conversation_Bool_Exp;
  user_conversation_constraint: User_Conversation_Constraint;
  user_conversation_insert_input: User_Conversation_Insert_Input;
  user_conversation_max_fields: ResolverTypeWrapper<User_Conversation_Max_Fields>;
  user_conversation_max_order_by: User_Conversation_Max_Order_By;
  user_conversation_min_fields: ResolverTypeWrapper<User_Conversation_Min_Fields>;
  user_conversation_min_order_by: User_Conversation_Min_Order_By;
  user_conversation_mutation_response: ResolverTypeWrapper<User_Conversation_Mutation_Response>;
  user_conversation_on_conflict: User_Conversation_On_Conflict;
  user_conversation_order_by: User_Conversation_Order_By;
  user_conversation_pk_columns_input: User_Conversation_Pk_Columns_Input;
  user_conversation_select_column: User_Conversation_Select_Column;
  user_conversation_select_column_user_conversation_aggregate_bool_exp_bool_and_arguments_columns: User_Conversation_Select_Column_User_Conversation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  user_conversation_select_column_user_conversation_aggregate_bool_exp_bool_or_arguments_columns: User_Conversation_Select_Column_User_Conversation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  user_conversation_set_input: User_Conversation_Set_Input;
  user_conversation_stream_cursor_input: User_Conversation_Stream_Cursor_Input;
  user_conversation_stream_cursor_value_input: User_Conversation_Stream_Cursor_Value_Input;
  user_conversation_update_column: User_Conversation_Update_Column;
  user_conversation_updates: User_Conversation_Updates;
  user_delete_at_path_input: User_Delete_At_Path_Input;
  user_delete_elem_input: User_Delete_Elem_Input;
  user_delete_key_input: User_Delete_Key_Input;
  user_education: ResolverTypeWrapper<User_Education>;
  user_education_aggregate: ResolverTypeWrapper<User_Education_Aggregate>;
  user_education_aggregate_bool_exp: User_Education_Aggregate_Bool_Exp;
  user_education_aggregate_bool_exp_count: User_Education_Aggregate_Bool_Exp_Count;
  user_education_aggregate_fields: ResolverTypeWrapper<User_Education_Aggregate_Fields>;
  user_education_aggregate_order_by: User_Education_Aggregate_Order_By;
  user_education_arr_rel_insert_input: User_Education_Arr_Rel_Insert_Input;
  user_education_avg_fields: ResolverTypeWrapper<User_Education_Avg_Fields>;
  user_education_avg_order_by: User_Education_Avg_Order_By;
  user_education_bool_exp: User_Education_Bool_Exp;
  user_education_constraint: User_Education_Constraint;
  user_education_inc_input: User_Education_Inc_Input;
  user_education_insert_input: User_Education_Insert_Input;
  user_education_max_fields: ResolverTypeWrapper<User_Education_Max_Fields>;
  user_education_max_order_by: User_Education_Max_Order_By;
  user_education_min_fields: ResolverTypeWrapper<User_Education_Min_Fields>;
  user_education_min_order_by: User_Education_Min_Order_By;
  user_education_mutation_response: ResolverTypeWrapper<User_Education_Mutation_Response>;
  user_education_on_conflict: User_Education_On_Conflict;
  user_education_order_by: User_Education_Order_By;
  user_education_pk_columns_input: User_Education_Pk_Columns_Input;
  user_education_select_column: User_Education_Select_Column;
  user_education_set_input: User_Education_Set_Input;
  user_education_stddev_fields: ResolverTypeWrapper<User_Education_Stddev_Fields>;
  user_education_stddev_order_by: User_Education_Stddev_Order_By;
  user_education_stddev_pop_fields: ResolverTypeWrapper<User_Education_Stddev_Pop_Fields>;
  user_education_stddev_pop_order_by: User_Education_Stddev_Pop_Order_By;
  user_education_stddev_samp_fields: ResolverTypeWrapper<User_Education_Stddev_Samp_Fields>;
  user_education_stddev_samp_order_by: User_Education_Stddev_Samp_Order_By;
  user_education_stream_cursor_input: User_Education_Stream_Cursor_Input;
  user_education_stream_cursor_value_input: User_Education_Stream_Cursor_Value_Input;
  user_education_sum_fields: ResolverTypeWrapper<User_Education_Sum_Fields>;
  user_education_sum_order_by: User_Education_Sum_Order_By;
  user_education_update_column: User_Education_Update_Column;
  user_education_updates: User_Education_Updates;
  user_education_var_pop_fields: ResolverTypeWrapper<User_Education_Var_Pop_Fields>;
  user_education_var_pop_order_by: User_Education_Var_Pop_Order_By;
  user_education_var_samp_fields: ResolverTypeWrapper<User_Education_Var_Samp_Fields>;
  user_education_var_samp_order_by: User_Education_Var_Samp_Order_By;
  user_education_variance_fields: ResolverTypeWrapper<User_Education_Variance_Fields>;
  user_education_variance_order_by: User_Education_Variance_Order_By;
  user_experience: ResolverTypeWrapper<User_Experience>;
  user_experience_aggregate: ResolverTypeWrapper<User_Experience_Aggregate>;
  user_experience_aggregate_bool_exp: User_Experience_Aggregate_Bool_Exp;
  user_experience_aggregate_bool_exp_bool_and: User_Experience_Aggregate_Bool_Exp_Bool_And;
  user_experience_aggregate_bool_exp_bool_or: User_Experience_Aggregate_Bool_Exp_Bool_Or;
  user_experience_aggregate_bool_exp_count: User_Experience_Aggregate_Bool_Exp_Count;
  user_experience_aggregate_fields: ResolverTypeWrapper<User_Experience_Aggregate_Fields>;
  user_experience_aggregate_order_by: User_Experience_Aggregate_Order_By;
  user_experience_arr_rel_insert_input: User_Experience_Arr_Rel_Insert_Input;
  user_experience_avg_fields: ResolverTypeWrapper<User_Experience_Avg_Fields>;
  user_experience_avg_order_by: User_Experience_Avg_Order_By;
  user_experience_bool_exp: User_Experience_Bool_Exp;
  user_experience_constraint: User_Experience_Constraint;
  user_experience_inc_input: User_Experience_Inc_Input;
  user_experience_insert_input: User_Experience_Insert_Input;
  user_experience_max_fields: ResolverTypeWrapper<User_Experience_Max_Fields>;
  user_experience_max_order_by: User_Experience_Max_Order_By;
  user_experience_min_fields: ResolverTypeWrapper<User_Experience_Min_Fields>;
  user_experience_min_order_by: User_Experience_Min_Order_By;
  user_experience_mutation_response: ResolverTypeWrapper<User_Experience_Mutation_Response>;
  user_experience_obj_rel_insert_input: User_Experience_Obj_Rel_Insert_Input;
  user_experience_on_conflict: User_Experience_On_Conflict;
  user_experience_order_by: User_Experience_Order_By;
  user_experience_pk_columns_input: User_Experience_Pk_Columns_Input;
  user_experience_select_column: User_Experience_Select_Column;
  user_experience_select_column_user_experience_aggregate_bool_exp_bool_and_arguments_columns: User_Experience_Select_Column_User_Experience_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  user_experience_select_column_user_experience_aggregate_bool_exp_bool_or_arguments_columns: User_Experience_Select_Column_User_Experience_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  user_experience_set_input: User_Experience_Set_Input;
  user_experience_stddev_fields: ResolverTypeWrapper<User_Experience_Stddev_Fields>;
  user_experience_stddev_order_by: User_Experience_Stddev_Order_By;
  user_experience_stddev_pop_fields: ResolverTypeWrapper<User_Experience_Stddev_Pop_Fields>;
  user_experience_stddev_pop_order_by: User_Experience_Stddev_Pop_Order_By;
  user_experience_stddev_samp_fields: ResolverTypeWrapper<User_Experience_Stddev_Samp_Fields>;
  user_experience_stddev_samp_order_by: User_Experience_Stddev_Samp_Order_By;
  user_experience_stream_cursor_input: User_Experience_Stream_Cursor_Input;
  user_experience_stream_cursor_value_input: User_Experience_Stream_Cursor_Value_Input;
  user_experience_sum_fields: ResolverTypeWrapper<User_Experience_Sum_Fields>;
  user_experience_sum_order_by: User_Experience_Sum_Order_By;
  user_experience_update_column: User_Experience_Update_Column;
  user_experience_updates: User_Experience_Updates;
  user_experience_var_pop_fields: ResolverTypeWrapper<User_Experience_Var_Pop_Fields>;
  user_experience_var_pop_order_by: User_Experience_Var_Pop_Order_By;
  user_experience_var_samp_fields: ResolverTypeWrapper<User_Experience_Var_Samp_Fields>;
  user_experience_var_samp_order_by: User_Experience_Var_Samp_Order_By;
  user_experience_variance_fields: ResolverTypeWrapper<User_Experience_Variance_Fields>;
  user_experience_variance_order_by: User_Experience_Variance_Order_By;
  user_favorite: ResolverTypeWrapper<User_Favorite>;
  user_favorite_aggregate: ResolverTypeWrapper<User_Favorite_Aggregate>;
  user_favorite_aggregate_bool_exp: User_Favorite_Aggregate_Bool_Exp;
  user_favorite_aggregate_bool_exp_count: User_Favorite_Aggregate_Bool_Exp_Count;
  user_favorite_aggregate_fields: ResolverTypeWrapper<User_Favorite_Aggregate_Fields>;
  user_favorite_aggregate_order_by: User_Favorite_Aggregate_Order_By;
  user_favorite_arr_rel_insert_input: User_Favorite_Arr_Rel_Insert_Input;
  user_favorite_bool_exp: User_Favorite_Bool_Exp;
  user_favorite_constraint: User_Favorite_Constraint;
  user_favorite_insert_input: User_Favorite_Insert_Input;
  user_favorite_max_fields: ResolverTypeWrapper<User_Favorite_Max_Fields>;
  user_favorite_max_order_by: User_Favorite_Max_Order_By;
  user_favorite_min_fields: ResolverTypeWrapper<User_Favorite_Min_Fields>;
  user_favorite_min_order_by: User_Favorite_Min_Order_By;
  user_favorite_mutation_response: ResolverTypeWrapper<User_Favorite_Mutation_Response>;
  user_favorite_on_conflict: User_Favorite_On_Conflict;
  user_favorite_order_by: User_Favorite_Order_By;
  user_favorite_pk_columns_input: User_Favorite_Pk_Columns_Input;
  user_favorite_select_column: User_Favorite_Select_Column;
  user_favorite_set_input: User_Favorite_Set_Input;
  user_favorite_stream_cursor_input: User_Favorite_Stream_Cursor_Input;
  user_favorite_stream_cursor_value_input: User_Favorite_Stream_Cursor_Value_Input;
  user_favorite_update_column: User_Favorite_Update_Column;
  user_favorite_updates: User_Favorite_Updates;
  user_inc_input: User_Inc_Input;
  user_industry: ResolverTypeWrapper<User_Industry>;
  user_industry_aggregate: ResolverTypeWrapper<User_Industry_Aggregate>;
  user_industry_aggregate_bool_exp: User_Industry_Aggregate_Bool_Exp;
  user_industry_aggregate_bool_exp_count: User_Industry_Aggregate_Bool_Exp_Count;
  user_industry_aggregate_fields: ResolverTypeWrapper<User_Industry_Aggregate_Fields>;
  user_industry_aggregate_order_by: User_Industry_Aggregate_Order_By;
  user_industry_arr_rel_insert_input: User_Industry_Arr_Rel_Insert_Input;
  user_industry_avg_fields: ResolverTypeWrapper<User_Industry_Avg_Fields>;
  user_industry_avg_order_by: User_Industry_Avg_Order_By;
  user_industry_bool_exp: User_Industry_Bool_Exp;
  user_industry_constraint: User_Industry_Constraint;
  user_industry_inc_input: User_Industry_Inc_Input;
  user_industry_insert_input: User_Industry_Insert_Input;
  user_industry_max_fields: ResolverTypeWrapper<User_Industry_Max_Fields>;
  user_industry_max_order_by: User_Industry_Max_Order_By;
  user_industry_min_fields: ResolverTypeWrapper<User_Industry_Min_Fields>;
  user_industry_min_order_by: User_Industry_Min_Order_By;
  user_industry_mutation_response: ResolverTypeWrapper<User_Industry_Mutation_Response>;
  user_industry_on_conflict: User_Industry_On_Conflict;
  user_industry_order_by: User_Industry_Order_By;
  user_industry_pk_columns_input: User_Industry_Pk_Columns_Input;
  user_industry_select_column: User_Industry_Select_Column;
  user_industry_set_input: User_Industry_Set_Input;
  user_industry_stddev_fields: ResolverTypeWrapper<User_Industry_Stddev_Fields>;
  user_industry_stddev_order_by: User_Industry_Stddev_Order_By;
  user_industry_stddev_pop_fields: ResolverTypeWrapper<User_Industry_Stddev_Pop_Fields>;
  user_industry_stddev_pop_order_by: User_Industry_Stddev_Pop_Order_By;
  user_industry_stddev_samp_fields: ResolverTypeWrapper<User_Industry_Stddev_Samp_Fields>;
  user_industry_stddev_samp_order_by: User_Industry_Stddev_Samp_Order_By;
  user_industry_stream_cursor_input: User_Industry_Stream_Cursor_Input;
  user_industry_stream_cursor_value_input: User_Industry_Stream_Cursor_Value_Input;
  user_industry_sum_fields: ResolverTypeWrapper<User_Industry_Sum_Fields>;
  user_industry_sum_order_by: User_Industry_Sum_Order_By;
  user_industry_update_column: User_Industry_Update_Column;
  user_industry_updates: User_Industry_Updates;
  user_industry_var_pop_fields: ResolverTypeWrapper<User_Industry_Var_Pop_Fields>;
  user_industry_var_pop_order_by: User_Industry_Var_Pop_Order_By;
  user_industry_var_samp_fields: ResolverTypeWrapper<User_Industry_Var_Samp_Fields>;
  user_industry_var_samp_order_by: User_Industry_Var_Samp_Order_By;
  user_industry_variance_fields: ResolverTypeWrapper<User_Industry_Variance_Fields>;
  user_industry_variance_order_by: User_Industry_Variance_Order_By;
  user_insert_input: User_Insert_Input;
  user_job_title: ResolverTypeWrapper<User_Job_Title>;
  user_job_title_aggregate: ResolverTypeWrapper<User_Job_Title_Aggregate>;
  user_job_title_aggregate_bool_exp: User_Job_Title_Aggregate_Bool_Exp;
  user_job_title_aggregate_bool_exp_count: User_Job_Title_Aggregate_Bool_Exp_Count;
  user_job_title_aggregate_fields: ResolverTypeWrapper<User_Job_Title_Aggregate_Fields>;
  user_job_title_aggregate_order_by: User_Job_Title_Aggregate_Order_By;
  user_job_title_arr_rel_insert_input: User_Job_Title_Arr_Rel_Insert_Input;
  user_job_title_avg_fields: ResolverTypeWrapper<User_Job_Title_Avg_Fields>;
  user_job_title_avg_order_by: User_Job_Title_Avg_Order_By;
  user_job_title_bool_exp: User_Job_Title_Bool_Exp;
  user_job_title_constraint: User_Job_Title_Constraint;
  user_job_title_inc_input: User_Job_Title_Inc_Input;
  user_job_title_insert_input: User_Job_Title_Insert_Input;
  user_job_title_max_fields: ResolverTypeWrapper<User_Job_Title_Max_Fields>;
  user_job_title_max_order_by: User_Job_Title_Max_Order_By;
  user_job_title_min_fields: ResolverTypeWrapper<User_Job_Title_Min_Fields>;
  user_job_title_min_order_by: User_Job_Title_Min_Order_By;
  user_job_title_mutation_response: ResolverTypeWrapper<User_Job_Title_Mutation_Response>;
  user_job_title_obj_rel_insert_input: User_Job_Title_Obj_Rel_Insert_Input;
  user_job_title_on_conflict: User_Job_Title_On_Conflict;
  user_job_title_order_by: User_Job_Title_Order_By;
  user_job_title_pk_columns_input: User_Job_Title_Pk_Columns_Input;
  user_job_title_select_column: User_Job_Title_Select_Column;
  user_job_title_set_input: User_Job_Title_Set_Input;
  user_job_title_stddev_fields: ResolverTypeWrapper<User_Job_Title_Stddev_Fields>;
  user_job_title_stddev_order_by: User_Job_Title_Stddev_Order_By;
  user_job_title_stddev_pop_fields: ResolverTypeWrapper<User_Job_Title_Stddev_Pop_Fields>;
  user_job_title_stddev_pop_order_by: User_Job_Title_Stddev_Pop_Order_By;
  user_job_title_stddev_samp_fields: ResolverTypeWrapper<User_Job_Title_Stddev_Samp_Fields>;
  user_job_title_stddev_samp_order_by: User_Job_Title_Stddev_Samp_Order_By;
  user_job_title_stream_cursor_input: User_Job_Title_Stream_Cursor_Input;
  user_job_title_stream_cursor_value_input: User_Job_Title_Stream_Cursor_Value_Input;
  user_job_title_sum_fields: ResolverTypeWrapper<User_Job_Title_Sum_Fields>;
  user_job_title_sum_order_by: User_Job_Title_Sum_Order_By;
  user_job_title_update_column: User_Job_Title_Update_Column;
  user_job_title_updates: User_Job_Title_Updates;
  user_job_title_var_pop_fields: ResolverTypeWrapper<User_Job_Title_Var_Pop_Fields>;
  user_job_title_var_pop_order_by: User_Job_Title_Var_Pop_Order_By;
  user_job_title_var_samp_fields: ResolverTypeWrapper<User_Job_Title_Var_Samp_Fields>;
  user_job_title_var_samp_order_by: User_Job_Title_Var_Samp_Order_By;
  user_job_title_variance_fields: ResolverTypeWrapper<User_Job_Title_Variance_Fields>;
  user_job_title_variance_order_by: User_Job_Title_Variance_Order_By;
  user_language: ResolverTypeWrapper<User_Language>;
  user_language_aggregate: ResolverTypeWrapper<User_Language_Aggregate>;
  user_language_aggregate_bool_exp: User_Language_Aggregate_Bool_Exp;
  user_language_aggregate_bool_exp_count: User_Language_Aggregate_Bool_Exp_Count;
  user_language_aggregate_fields: ResolverTypeWrapper<User_Language_Aggregate_Fields>;
  user_language_aggregate_order_by: User_Language_Aggregate_Order_By;
  user_language_arr_rel_insert_input: User_Language_Arr_Rel_Insert_Input;
  user_language_avg_fields: ResolverTypeWrapper<User_Language_Avg_Fields>;
  user_language_avg_order_by: User_Language_Avg_Order_By;
  user_language_bool_exp: User_Language_Bool_Exp;
  user_language_constraint: User_Language_Constraint;
  user_language_inc_input: User_Language_Inc_Input;
  user_language_insert_input: User_Language_Insert_Input;
  user_language_max_fields: ResolverTypeWrapper<User_Language_Max_Fields>;
  user_language_max_order_by: User_Language_Max_Order_By;
  user_language_min_fields: ResolverTypeWrapper<User_Language_Min_Fields>;
  user_language_min_order_by: User_Language_Min_Order_By;
  user_language_mutation_response: ResolverTypeWrapper<User_Language_Mutation_Response>;
  user_language_on_conflict: User_Language_On_Conflict;
  user_language_order_by: User_Language_Order_By;
  user_language_pk_columns_input: User_Language_Pk_Columns_Input;
  user_language_select_column: User_Language_Select_Column;
  user_language_set_input: User_Language_Set_Input;
  user_language_stddev_fields: ResolverTypeWrapper<User_Language_Stddev_Fields>;
  user_language_stddev_order_by: User_Language_Stddev_Order_By;
  user_language_stddev_pop_fields: ResolverTypeWrapper<User_Language_Stddev_Pop_Fields>;
  user_language_stddev_pop_order_by: User_Language_Stddev_Pop_Order_By;
  user_language_stddev_samp_fields: ResolverTypeWrapper<User_Language_Stddev_Samp_Fields>;
  user_language_stddev_samp_order_by: User_Language_Stddev_Samp_Order_By;
  user_language_stream_cursor_input: User_Language_Stream_Cursor_Input;
  user_language_stream_cursor_value_input: User_Language_Stream_Cursor_Value_Input;
  user_language_sum_fields: ResolverTypeWrapper<User_Language_Sum_Fields>;
  user_language_sum_order_by: User_Language_Sum_Order_By;
  user_language_update_column: User_Language_Update_Column;
  user_language_updates: User_Language_Updates;
  user_language_var_pop_fields: ResolverTypeWrapper<User_Language_Var_Pop_Fields>;
  user_language_var_pop_order_by: User_Language_Var_Pop_Order_By;
  user_language_var_samp_fields: ResolverTypeWrapper<User_Language_Var_Samp_Fields>;
  user_language_var_samp_order_by: User_Language_Var_Samp_Order_By;
  user_language_variance_fields: ResolverTypeWrapper<User_Language_Variance_Fields>;
  user_language_variance_order_by: User_Language_Variance_Order_By;
  user_max_fields: ResolverTypeWrapper<User_Max_Fields>;
  user_min_fields: ResolverTypeWrapper<User_Min_Fields>;
  user_mutation_response: ResolverTypeWrapper<User_Mutation_Response>;
  user_obj_rel_insert_input: User_Obj_Rel_Insert_Input;
  user_on_conflict: User_On_Conflict;
  user_order_by: User_Order_By;
  user_pk_columns_input: User_Pk_Columns_Input;
  user_prepend_input: User_Prepend_Input;
  user_private_data: ResolverTypeWrapper<User_Private_Data>;
  user_private_data_aggregate: ResolverTypeWrapper<User_Private_Data_Aggregate>;
  user_private_data_aggregate_fields: ResolverTypeWrapper<User_Private_Data_Aggregate_Fields>;
  user_private_data_avg_fields: ResolverTypeWrapper<User_Private_Data_Avg_Fields>;
  user_private_data_bool_exp: User_Private_Data_Bool_Exp;
  user_private_data_inc_input: User_Private_Data_Inc_Input;
  user_private_data_insert_input: User_Private_Data_Insert_Input;
  user_private_data_max_fields: ResolverTypeWrapper<User_Private_Data_Max_Fields>;
  user_private_data_min_fields: ResolverTypeWrapper<User_Private_Data_Min_Fields>;
  user_private_data_mutation_response: ResolverTypeWrapper<User_Private_Data_Mutation_Response>;
  user_private_data_obj_rel_insert_input: User_Private_Data_Obj_Rel_Insert_Input;
  user_private_data_order_by: User_Private_Data_Order_By;
  user_private_data_select_column: User_Private_Data_Select_Column;
  user_private_data_set_input: User_Private_Data_Set_Input;
  user_private_data_stddev_fields: ResolverTypeWrapper<User_Private_Data_Stddev_Fields>;
  user_private_data_stddev_pop_fields: ResolverTypeWrapper<User_Private_Data_Stddev_Pop_Fields>;
  user_private_data_stddev_samp_fields: ResolverTypeWrapper<User_Private_Data_Stddev_Samp_Fields>;
  user_private_data_stream_cursor_input: User_Private_Data_Stream_Cursor_Input;
  user_private_data_stream_cursor_value_input: User_Private_Data_Stream_Cursor_Value_Input;
  user_private_data_sum_fields: ResolverTypeWrapper<User_Private_Data_Sum_Fields>;
  user_private_data_updates: User_Private_Data_Updates;
  user_private_data_var_pop_fields: ResolverTypeWrapper<User_Private_Data_Var_Pop_Fields>;
  user_private_data_var_samp_fields: ResolverTypeWrapper<User_Private_Data_Var_Samp_Fields>;
  user_private_data_variance_fields: ResolverTypeWrapper<User_Private_Data_Variance_Fields>;
  user_profile: ResolverTypeWrapper<User_Profile>;
  user_profile_aggregate: ResolverTypeWrapper<User_Profile_Aggregate>;
  user_profile_aggregate_bool_exp: User_Profile_Aggregate_Bool_Exp;
  user_profile_aggregate_bool_exp_bool_and: User_Profile_Aggregate_Bool_Exp_Bool_And;
  user_profile_aggregate_bool_exp_bool_or: User_Profile_Aggregate_Bool_Exp_Bool_Or;
  user_profile_aggregate_bool_exp_count: User_Profile_Aggregate_Bool_Exp_Count;
  user_profile_aggregate_fields: ResolverTypeWrapper<User_Profile_Aggregate_Fields>;
  user_profile_aggregate_order_by: User_Profile_Aggregate_Order_By;
  user_profile_arr_rel_insert_input: User_Profile_Arr_Rel_Insert_Input;
  user_profile_avg_fields: ResolverTypeWrapper<User_Profile_Avg_Fields>;
  user_profile_avg_order_by: User_Profile_Avg_Order_By;
  user_profile_bool_exp: User_Profile_Bool_Exp;
  user_profile_by_management: ResolverTypeWrapper<User_Profile_By_Management>;
  user_profile_by_management_aggregate: ResolverTypeWrapper<User_Profile_By_Management_Aggregate>;
  user_profile_by_management_aggregate_bool_exp: User_Profile_By_Management_Aggregate_Bool_Exp;
  user_profile_by_management_aggregate_bool_exp_count: User_Profile_By_Management_Aggregate_Bool_Exp_Count;
  user_profile_by_management_aggregate_fields: ResolverTypeWrapper<User_Profile_By_Management_Aggregate_Fields>;
  user_profile_by_management_aggregate_order_by: User_Profile_By_Management_Aggregate_Order_By;
  user_profile_by_management_arr_rel_insert_input: User_Profile_By_Management_Arr_Rel_Insert_Input;
  user_profile_by_management_avg_fields: ResolverTypeWrapper<User_Profile_By_Management_Avg_Fields>;
  user_profile_by_management_avg_order_by: User_Profile_By_Management_Avg_Order_By;
  user_profile_by_management_bool_exp: User_Profile_By_Management_Bool_Exp;
  user_profile_by_management_constraint: User_Profile_By_Management_Constraint;
  user_profile_by_management_inc_input: User_Profile_By_Management_Inc_Input;
  user_profile_by_management_insert_input: User_Profile_By_Management_Insert_Input;
  user_profile_by_management_max_fields: ResolverTypeWrapper<User_Profile_By_Management_Max_Fields>;
  user_profile_by_management_max_order_by: User_Profile_By_Management_Max_Order_By;
  user_profile_by_management_min_fields: ResolverTypeWrapper<User_Profile_By_Management_Min_Fields>;
  user_profile_by_management_min_order_by: User_Profile_By_Management_Min_Order_By;
  user_profile_by_management_mutation_response: ResolverTypeWrapper<User_Profile_By_Management_Mutation_Response>;
  user_profile_by_management_on_conflict: User_Profile_By_Management_On_Conflict;
  user_profile_by_management_order_by: User_Profile_By_Management_Order_By;
  user_profile_by_management_pk_columns_input: User_Profile_By_Management_Pk_Columns_Input;
  user_profile_by_management_select_column: User_Profile_By_Management_Select_Column;
  user_profile_by_management_set_input: User_Profile_By_Management_Set_Input;
  user_profile_by_management_stddev_fields: ResolverTypeWrapper<User_Profile_By_Management_Stddev_Fields>;
  user_profile_by_management_stddev_order_by: User_Profile_By_Management_Stddev_Order_By;
  user_profile_by_management_stddev_pop_fields: ResolverTypeWrapper<User_Profile_By_Management_Stddev_Pop_Fields>;
  user_profile_by_management_stddev_pop_order_by: User_Profile_By_Management_Stddev_Pop_Order_By;
  user_profile_by_management_stddev_samp_fields: ResolverTypeWrapper<User_Profile_By_Management_Stddev_Samp_Fields>;
  user_profile_by_management_stddev_samp_order_by: User_Profile_By_Management_Stddev_Samp_Order_By;
  user_profile_by_management_stream_cursor_input: User_Profile_By_Management_Stream_Cursor_Input;
  user_profile_by_management_stream_cursor_value_input: User_Profile_By_Management_Stream_Cursor_Value_Input;
  user_profile_by_management_sum_fields: ResolverTypeWrapper<User_Profile_By_Management_Sum_Fields>;
  user_profile_by_management_sum_order_by: User_Profile_By_Management_Sum_Order_By;
  user_profile_by_management_update_column: User_Profile_By_Management_Update_Column;
  user_profile_by_management_updates: User_Profile_By_Management_Updates;
  user_profile_by_management_var_pop_fields: ResolverTypeWrapper<User_Profile_By_Management_Var_Pop_Fields>;
  user_profile_by_management_var_pop_order_by: User_Profile_By_Management_Var_Pop_Order_By;
  user_profile_by_management_var_samp_fields: ResolverTypeWrapper<User_Profile_By_Management_Var_Samp_Fields>;
  user_profile_by_management_var_samp_order_by: User_Profile_By_Management_Var_Samp_Order_By;
  user_profile_by_management_variance_fields: ResolverTypeWrapper<User_Profile_By_Management_Variance_Fields>;
  user_profile_by_management_variance_order_by: User_Profile_By_Management_Variance_Order_By;
  user_profile_constraint: User_Profile_Constraint;
  user_profile_inc_input: User_Profile_Inc_Input;
  user_profile_insert_input: User_Profile_Insert_Input;
  user_profile_max_fields: ResolverTypeWrapper<User_Profile_Max_Fields>;
  user_profile_max_order_by: User_Profile_Max_Order_By;
  user_profile_min_fields: ResolverTypeWrapper<User_Profile_Min_Fields>;
  user_profile_min_order_by: User_Profile_Min_Order_By;
  user_profile_mutation_response: ResolverTypeWrapper<User_Profile_Mutation_Response>;
  user_profile_obj_rel_insert_input: User_Profile_Obj_Rel_Insert_Input;
  user_profile_on_conflict: User_Profile_On_Conflict;
  user_profile_order_by: User_Profile_Order_By;
  user_profile_pk_columns_input: User_Profile_Pk_Columns_Input;
  user_profile_select_column: User_Profile_Select_Column;
  user_profile_select_column_user_profile_aggregate_bool_exp_bool_and_arguments_columns: User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  user_profile_select_column_user_profile_aggregate_bool_exp_bool_or_arguments_columns: User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  user_profile_set_input: User_Profile_Set_Input;
  user_profile_stddev_fields: ResolverTypeWrapper<User_Profile_Stddev_Fields>;
  user_profile_stddev_order_by: User_Profile_Stddev_Order_By;
  user_profile_stddev_pop_fields: ResolverTypeWrapper<User_Profile_Stddev_Pop_Fields>;
  user_profile_stddev_pop_order_by: User_Profile_Stddev_Pop_Order_By;
  user_profile_stddev_samp_fields: ResolverTypeWrapper<User_Profile_Stddev_Samp_Fields>;
  user_profile_stddev_samp_order_by: User_Profile_Stddev_Samp_Order_By;
  user_profile_stream_cursor_input: User_Profile_Stream_Cursor_Input;
  user_profile_stream_cursor_value_input: User_Profile_Stream_Cursor_Value_Input;
  user_profile_sum_fields: ResolverTypeWrapper<User_Profile_Sum_Fields>;
  user_profile_sum_order_by: User_Profile_Sum_Order_By;
  user_profile_update_column: User_Profile_Update_Column;
  user_profile_updates: User_Profile_Updates;
  user_profile_var_pop_fields: ResolverTypeWrapper<User_Profile_Var_Pop_Fields>;
  user_profile_var_pop_order_by: User_Profile_Var_Pop_Order_By;
  user_profile_var_samp_fields: ResolverTypeWrapper<User_Profile_Var_Samp_Fields>;
  user_profile_var_samp_order_by: User_Profile_Var_Samp_Order_By;
  user_profile_variance_fields: ResolverTypeWrapper<User_Profile_Variance_Fields>;
  user_profile_variance_order_by: User_Profile_Variance_Order_By;
  user_rating: ResolverTypeWrapper<User_Rating>;
  user_rating_aggregate: ResolverTypeWrapper<User_Rating_Aggregate>;
  user_rating_aggregate_bool_exp: User_Rating_Aggregate_Bool_Exp;
  user_rating_aggregate_bool_exp_count: User_Rating_Aggregate_Bool_Exp_Count;
  user_rating_aggregate_fields: ResolverTypeWrapper<User_Rating_Aggregate_Fields>;
  user_rating_aggregate_order_by: User_Rating_Aggregate_Order_By;
  user_rating_arr_rel_insert_input: User_Rating_Arr_Rel_Insert_Input;
  user_rating_avg_fields: ResolverTypeWrapper<User_Rating_Avg_Fields>;
  user_rating_avg_order_by: User_Rating_Avg_Order_By;
  user_rating_bool_exp: User_Rating_Bool_Exp;
  user_rating_constraint: User_Rating_Constraint;
  user_rating_inc_input: User_Rating_Inc_Input;
  user_rating_insert_input: User_Rating_Insert_Input;
  user_rating_max_fields: ResolverTypeWrapper<User_Rating_Max_Fields>;
  user_rating_max_order_by: User_Rating_Max_Order_By;
  user_rating_min_fields: ResolverTypeWrapper<User_Rating_Min_Fields>;
  user_rating_min_order_by: User_Rating_Min_Order_By;
  user_rating_mutation_response: ResolverTypeWrapper<User_Rating_Mutation_Response>;
  user_rating_on_conflict: User_Rating_On_Conflict;
  user_rating_order_by: User_Rating_Order_By;
  user_rating_pk_columns_input: User_Rating_Pk_Columns_Input;
  user_rating_select_column: User_Rating_Select_Column;
  user_rating_set_input: User_Rating_Set_Input;
  user_rating_stddev_fields: ResolverTypeWrapper<User_Rating_Stddev_Fields>;
  user_rating_stddev_order_by: User_Rating_Stddev_Order_By;
  user_rating_stddev_pop_fields: ResolverTypeWrapper<User_Rating_Stddev_Pop_Fields>;
  user_rating_stddev_pop_order_by: User_Rating_Stddev_Pop_Order_By;
  user_rating_stddev_samp_fields: ResolverTypeWrapper<User_Rating_Stddev_Samp_Fields>;
  user_rating_stddev_samp_order_by: User_Rating_Stddev_Samp_Order_By;
  user_rating_stream_cursor_input: User_Rating_Stream_Cursor_Input;
  user_rating_stream_cursor_value_input: User_Rating_Stream_Cursor_Value_Input;
  user_rating_sum_fields: ResolverTypeWrapper<User_Rating_Sum_Fields>;
  user_rating_sum_order_by: User_Rating_Sum_Order_By;
  user_rating_update_column: User_Rating_Update_Column;
  user_rating_updates: User_Rating_Updates;
  user_rating_var_pop_fields: ResolverTypeWrapper<User_Rating_Var_Pop_Fields>;
  user_rating_var_pop_order_by: User_Rating_Var_Pop_Order_By;
  user_rating_var_samp_fields: ResolverTypeWrapper<User_Rating_Var_Samp_Fields>;
  user_rating_var_samp_order_by: User_Rating_Var_Samp_Order_By;
  user_rating_variance_fields: ResolverTypeWrapper<User_Rating_Variance_Fields>;
  user_rating_variance_order_by: User_Rating_Variance_Order_By;
  user_select_column: User_Select_Column;
  user_set_input: User_Set_Input;
  user_skill: ResolverTypeWrapper<User_Skill>;
  user_skill_aggregate: ResolverTypeWrapper<User_Skill_Aggregate>;
  user_skill_aggregate_bool_exp: User_Skill_Aggregate_Bool_Exp;
  user_skill_aggregate_bool_exp_count: User_Skill_Aggregate_Bool_Exp_Count;
  user_skill_aggregate_fields: ResolverTypeWrapper<User_Skill_Aggregate_Fields>;
  user_skill_aggregate_order_by: User_Skill_Aggregate_Order_By;
  user_skill_arr_rel_insert_input: User_Skill_Arr_Rel_Insert_Input;
  user_skill_avg_fields: ResolverTypeWrapper<User_Skill_Avg_Fields>;
  user_skill_avg_order_by: User_Skill_Avg_Order_By;
  user_skill_bool_exp: User_Skill_Bool_Exp;
  user_skill_constraint: User_Skill_Constraint;
  user_skill_inc_input: User_Skill_Inc_Input;
  user_skill_insert_input: User_Skill_Insert_Input;
  user_skill_max_fields: ResolverTypeWrapper<User_Skill_Max_Fields>;
  user_skill_max_order_by: User_Skill_Max_Order_By;
  user_skill_min_fields: ResolverTypeWrapper<User_Skill_Min_Fields>;
  user_skill_min_order_by: User_Skill_Min_Order_By;
  user_skill_mutation_response: ResolverTypeWrapper<User_Skill_Mutation_Response>;
  user_skill_on_conflict: User_Skill_On_Conflict;
  user_skill_order_by: User_Skill_Order_By;
  user_skill_pk_columns_input: User_Skill_Pk_Columns_Input;
  user_skill_select_column: User_Skill_Select_Column;
  user_skill_set_input: User_Skill_Set_Input;
  user_skill_stddev_fields: ResolverTypeWrapper<User_Skill_Stddev_Fields>;
  user_skill_stddev_order_by: User_Skill_Stddev_Order_By;
  user_skill_stddev_pop_fields: ResolverTypeWrapper<User_Skill_Stddev_Pop_Fields>;
  user_skill_stddev_pop_order_by: User_Skill_Stddev_Pop_Order_By;
  user_skill_stddev_samp_fields: ResolverTypeWrapper<User_Skill_Stddev_Samp_Fields>;
  user_skill_stddev_samp_order_by: User_Skill_Stddev_Samp_Order_By;
  user_skill_stream_cursor_input: User_Skill_Stream_Cursor_Input;
  user_skill_stream_cursor_value_input: User_Skill_Stream_Cursor_Value_Input;
  user_skill_sum_fields: ResolverTypeWrapper<User_Skill_Sum_Fields>;
  user_skill_sum_order_by: User_Skill_Sum_Order_By;
  user_skill_update_column: User_Skill_Update_Column;
  user_skill_updates: User_Skill_Updates;
  user_skill_var_pop_fields: ResolverTypeWrapper<User_Skill_Var_Pop_Fields>;
  user_skill_var_pop_order_by: User_Skill_Var_Pop_Order_By;
  user_skill_var_samp_fields: ResolverTypeWrapper<User_Skill_Var_Samp_Fields>;
  user_skill_var_samp_order_by: User_Skill_Var_Samp_Order_By;
  user_skill_variance_fields: ResolverTypeWrapper<User_Skill_Variance_Fields>;
  user_skill_variance_order_by: User_Skill_Variance_Order_By;
  user_soft_skill: ResolverTypeWrapper<User_Soft_Skill>;
  user_soft_skill_aggregate: ResolverTypeWrapper<User_Soft_Skill_Aggregate>;
  user_soft_skill_aggregate_bool_exp: User_Soft_Skill_Aggregate_Bool_Exp;
  user_soft_skill_aggregate_bool_exp_count: User_Soft_Skill_Aggregate_Bool_Exp_Count;
  user_soft_skill_aggregate_fields: ResolverTypeWrapper<User_Soft_Skill_Aggregate_Fields>;
  user_soft_skill_aggregate_order_by: User_Soft_Skill_Aggregate_Order_By;
  user_soft_skill_arr_rel_insert_input: User_Soft_Skill_Arr_Rel_Insert_Input;
  user_soft_skill_avg_fields: ResolverTypeWrapper<User_Soft_Skill_Avg_Fields>;
  user_soft_skill_avg_order_by: User_Soft_Skill_Avg_Order_By;
  user_soft_skill_bool_exp: User_Soft_Skill_Bool_Exp;
  user_soft_skill_constraint: User_Soft_Skill_Constraint;
  user_soft_skill_inc_input: User_Soft_Skill_Inc_Input;
  user_soft_skill_insert_input: User_Soft_Skill_Insert_Input;
  user_soft_skill_max_fields: ResolverTypeWrapper<User_Soft_Skill_Max_Fields>;
  user_soft_skill_max_order_by: User_Soft_Skill_Max_Order_By;
  user_soft_skill_min_fields: ResolverTypeWrapper<User_Soft_Skill_Min_Fields>;
  user_soft_skill_min_order_by: User_Soft_Skill_Min_Order_By;
  user_soft_skill_mutation_response: ResolverTypeWrapper<User_Soft_Skill_Mutation_Response>;
  user_soft_skill_on_conflict: User_Soft_Skill_On_Conflict;
  user_soft_skill_order_by: User_Soft_Skill_Order_By;
  user_soft_skill_pk_columns_input: User_Soft_Skill_Pk_Columns_Input;
  user_soft_skill_select_column: User_Soft_Skill_Select_Column;
  user_soft_skill_set_input: User_Soft_Skill_Set_Input;
  user_soft_skill_stddev_fields: ResolverTypeWrapper<User_Soft_Skill_Stddev_Fields>;
  user_soft_skill_stddev_order_by: User_Soft_Skill_Stddev_Order_By;
  user_soft_skill_stddev_pop_fields: ResolverTypeWrapper<User_Soft_Skill_Stddev_Pop_Fields>;
  user_soft_skill_stddev_pop_order_by: User_Soft_Skill_Stddev_Pop_Order_By;
  user_soft_skill_stddev_samp_fields: ResolverTypeWrapper<User_Soft_Skill_Stddev_Samp_Fields>;
  user_soft_skill_stddev_samp_order_by: User_Soft_Skill_Stddev_Samp_Order_By;
  user_soft_skill_stream_cursor_input: User_Soft_Skill_Stream_Cursor_Input;
  user_soft_skill_stream_cursor_value_input: User_Soft_Skill_Stream_Cursor_Value_Input;
  user_soft_skill_sum_fields: ResolverTypeWrapper<User_Soft_Skill_Sum_Fields>;
  user_soft_skill_sum_order_by: User_Soft_Skill_Sum_Order_By;
  user_soft_skill_update_column: User_Soft_Skill_Update_Column;
  user_soft_skill_updates: User_Soft_Skill_Updates;
  user_soft_skill_var_pop_fields: ResolverTypeWrapper<User_Soft_Skill_Var_Pop_Fields>;
  user_soft_skill_var_pop_order_by: User_Soft_Skill_Var_Pop_Order_By;
  user_soft_skill_var_samp_fields: ResolverTypeWrapper<User_Soft_Skill_Var_Samp_Fields>;
  user_soft_skill_var_samp_order_by: User_Soft_Skill_Var_Samp_Order_By;
  user_soft_skill_variance_fields: ResolverTypeWrapper<User_Soft_Skill_Variance_Fields>;
  user_soft_skill_variance_order_by: User_Soft_Skill_Variance_Order_By;
  user_stddev_fields: ResolverTypeWrapper<User_Stddev_Fields>;
  user_stddev_pop_fields: ResolverTypeWrapper<User_Stddev_Pop_Fields>;
  user_stddev_samp_fields: ResolverTypeWrapper<User_Stddev_Samp_Fields>;
  user_stream_cursor_input: User_Stream_Cursor_Input;
  user_stream_cursor_value_input: User_Stream_Cursor_Value_Input;
  user_sum_fields: ResolverTypeWrapper<User_Sum_Fields>;
  user_transportation: ResolverTypeWrapper<User_Transportation>;
  user_transportation_aggregate: ResolverTypeWrapper<User_Transportation_Aggregate>;
  user_transportation_aggregate_bool_exp: User_Transportation_Aggregate_Bool_Exp;
  user_transportation_aggregate_bool_exp_count: User_Transportation_Aggregate_Bool_Exp_Count;
  user_transportation_aggregate_fields: ResolverTypeWrapper<User_Transportation_Aggregate_Fields>;
  user_transportation_aggregate_order_by: User_Transportation_Aggregate_Order_By;
  user_transportation_arr_rel_insert_input: User_Transportation_Arr_Rel_Insert_Input;
  user_transportation_bool_exp: User_Transportation_Bool_Exp;
  user_transportation_constraint: User_Transportation_Constraint;
  user_transportation_insert_input: User_Transportation_Insert_Input;
  user_transportation_max_fields: ResolverTypeWrapper<User_Transportation_Max_Fields>;
  user_transportation_max_order_by: User_Transportation_Max_Order_By;
  user_transportation_min_fields: ResolverTypeWrapper<User_Transportation_Min_Fields>;
  user_transportation_min_order_by: User_Transportation_Min_Order_By;
  user_transportation_mutation_response: ResolverTypeWrapper<User_Transportation_Mutation_Response>;
  user_transportation_on_conflict: User_Transportation_On_Conflict;
  user_transportation_order_by: User_Transportation_Order_By;
  user_transportation_pk_columns_input: User_Transportation_Pk_Columns_Input;
  user_transportation_select_column: User_Transportation_Select_Column;
  user_transportation_set_input: User_Transportation_Set_Input;
  user_transportation_stream_cursor_input: User_Transportation_Stream_Cursor_Input;
  user_transportation_stream_cursor_value_input: User_Transportation_Stream_Cursor_Value_Input;
  user_transportation_update_column: User_Transportation_Update_Column;
  user_transportation_updates: User_Transportation_Updates;
  user_update_column: User_Update_Column;
  user_updates: User_Updates;
  user_var_pop_fields: ResolverTypeWrapper<User_Var_Pop_Fields>;
  user_var_samp_fields: ResolverTypeWrapper<User_Var_Samp_Fields>;
  user_variance_fields: ResolverTypeWrapper<User_Variance_Fields>;
  user_watchlist: ResolverTypeWrapper<User_Watchlist>;
  user_watchlist_aggregate: ResolverTypeWrapper<User_Watchlist_Aggregate>;
  user_watchlist_aggregate_bool_exp: User_Watchlist_Aggregate_Bool_Exp;
  user_watchlist_aggregate_bool_exp_count: User_Watchlist_Aggregate_Bool_Exp_Count;
  user_watchlist_aggregate_fields: ResolverTypeWrapper<User_Watchlist_Aggregate_Fields>;
  user_watchlist_aggregate_order_by: User_Watchlist_Aggregate_Order_By;
  user_watchlist_arr_rel_insert_input: User_Watchlist_Arr_Rel_Insert_Input;
  user_watchlist_bool_exp: User_Watchlist_Bool_Exp;
  user_watchlist_constraint: User_Watchlist_Constraint;
  user_watchlist_insert_input: User_Watchlist_Insert_Input;
  user_watchlist_max_fields: ResolverTypeWrapper<User_Watchlist_Max_Fields>;
  user_watchlist_max_order_by: User_Watchlist_Max_Order_By;
  user_watchlist_min_fields: ResolverTypeWrapper<User_Watchlist_Min_Fields>;
  user_watchlist_min_order_by: User_Watchlist_Min_Order_By;
  user_watchlist_mutation_response: ResolverTypeWrapper<User_Watchlist_Mutation_Response>;
  user_watchlist_on_conflict: User_Watchlist_On_Conflict;
  user_watchlist_order_by: User_Watchlist_Order_By;
  user_watchlist_pk_columns_input: User_Watchlist_Pk_Columns_Input;
  user_watchlist_select_column: User_Watchlist_Select_Column;
  user_watchlist_set_input: User_Watchlist_Set_Input;
  user_watchlist_stream_cursor_input: User_Watchlist_Stream_Cursor_Input;
  user_watchlist_stream_cursor_value_input: User_Watchlist_Stream_Cursor_Value_Input;
  user_watchlist_update_column: User_Watchlist_Update_Column;
  user_watchlist_updates: User_Watchlist_Updates;
  uuid: ResolverTypeWrapper<Scalars['uuid']>;
  uuid_comparison_exp: Uuid_Comparison_Exp;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean_comparison_exp: Boolean_Comparison_Exp;
  Boolean: Scalars['Boolean'];
  Float_comparison_exp: Float_Comparison_Exp;
  Float: Scalars['Float'];
  Int_comparison_exp: Int_Comparison_Exp;
  Int: Scalars['Int'];
  String_array_comparison_exp: String_Array_Comparison_Exp;
  String: Scalars['String'];
  String_comparison_exp: String_Comparison_Exp;
  admin: Admin;
  admin_aggregate: Admin_Aggregate;
  admin_aggregate_bool_exp: Admin_Aggregate_Bool_Exp;
  admin_aggregate_bool_exp_bool_and: Admin_Aggregate_Bool_Exp_Bool_And;
  admin_aggregate_bool_exp_bool_or: Admin_Aggregate_Bool_Exp_Bool_Or;
  admin_aggregate_bool_exp_count: Admin_Aggregate_Bool_Exp_Count;
  admin_aggregate_fields: Admin_Aggregate_Fields;
  admin_aggregate_order_by: Admin_Aggregate_Order_By;
  admin_arr_rel_insert_input: Admin_Arr_Rel_Insert_Input;
  admin_bool_exp: Admin_Bool_Exp;
  admin_insert_input: Admin_Insert_Input;
  admin_max_fields: Admin_Max_Fields;
  admin_max_order_by: Admin_Max_Order_By;
  admin_min_fields: Admin_Min_Fields;
  admin_min_order_by: Admin_Min_Order_By;
  admin_mutation_response: Admin_Mutation_Response;
  admin_obj_rel_insert_input: Admin_Obj_Rel_Insert_Input;
  admin_on_conflict: Admin_On_Conflict;
  admin_order_by: Admin_Order_By;
  admin_pk_columns_input: Admin_Pk_Columns_Input;
  admin_set_input: Admin_Set_Input;
  admin_stream_cursor_input: Admin_Stream_Cursor_Input;
  admin_stream_cursor_value_input: Admin_Stream_Cursor_Value_Input;
  admin_updates: Admin_Updates;
  applicant_enum: Scalars['applicant_enum'];
  applicant_enum_comparison_exp: Applicant_Enum_Comparison_Exp;
  application: Application;
  application_aggregate: Application_Aggregate;
  application_aggregate_bool_exp: Application_Aggregate_Bool_Exp;
  application_aggregate_bool_exp_bool_and: Application_Aggregate_Bool_Exp_Bool_And;
  application_aggregate_bool_exp_bool_or: Application_Aggregate_Bool_Exp_Bool_Or;
  application_aggregate_bool_exp_count: Application_Aggregate_Bool_Exp_Count;
  application_aggregate_fields: Application_Aggregate_Fields;
  application_aggregate_order_by: Application_Aggregate_Order_By;
  application_arr_rel_insert_input: Application_Arr_Rel_Insert_Input;
  application_bool_exp: Application_Bool_Exp;
  application_insert_input: Application_Insert_Input;
  application_max_fields: Application_Max_Fields;
  application_max_order_by: Application_Max_Order_By;
  application_min_fields: Application_Min_Fields;
  application_min_order_by: Application_Min_Order_By;
  application_mutation_response: Application_Mutation_Response;
  application_obj_rel_insert_input: Application_Obj_Rel_Insert_Input;
  application_on_conflict: Application_On_Conflict;
  application_order_by: Application_Order_By;
  application_pk_columns_input: Application_Pk_Columns_Input;
  application_set_input: Application_Set_Input;
  application_stream_cursor_input: Application_Stream_Cursor_Input;
  application_stream_cursor_value_input: Application_Stream_Cursor_Value_Input;
  application_updates: Application_Updates;
  bigint: Scalars['bigint'];
  bigint_comparison_exp: Bigint_Comparison_Exp;
  candidate: Candidate;
  candidate_aggregate: Candidate_Aggregate;
  candidate_aggregate_bool_exp: Candidate_Aggregate_Bool_Exp;
  candidate_aggregate_bool_exp_count: Candidate_Aggregate_Bool_Exp_Count;
  candidate_aggregate_fields: Candidate_Aggregate_Fields;
  candidate_aggregate_order_by: Candidate_Aggregate_Order_By;
  candidate_arr_rel_insert_input: Candidate_Arr_Rel_Insert_Input;
  candidate_bool_exp: Candidate_Bool_Exp;
  candidate_insert_input: Candidate_Insert_Input;
  candidate_max_fields: Candidate_Max_Fields;
  candidate_max_order_by: Candidate_Max_Order_By;
  candidate_min_fields: Candidate_Min_Fields;
  candidate_min_order_by: Candidate_Min_Order_By;
  candidate_mutation_response: Candidate_Mutation_Response;
  candidate_obj_rel_insert_input: Candidate_Obj_Rel_Insert_Input;
  candidate_on_conflict: Candidate_On_Conflict;
  candidate_order_by: Candidate_Order_By;
  candidate_pk_columns_input: Candidate_Pk_Columns_Input;
  candidate_set_input: Candidate_Set_Input;
  candidate_stream_cursor_input: Candidate_Stream_Cursor_Input;
  candidate_stream_cursor_value_input: Candidate_Stream_Cursor_Value_Input;
  candidate_updates: Candidate_Updates;
  chart_admin_contractors: Chart_Admin_Contractors;
  chart_admin_contractors_aggregate: Chart_Admin_Contractors_Aggregate;
  chart_admin_contractors_aggregate_fields: Chart_Admin_Contractors_Aggregate_Fields;
  chart_admin_contractors_avg_fields: Chart_Admin_Contractors_Avg_Fields;
  chart_admin_contractors_bool_exp: Chart_Admin_Contractors_Bool_Exp;
  chart_admin_contractors_max_fields: Chart_Admin_Contractors_Max_Fields;
  chart_admin_contractors_min_fields: Chart_Admin_Contractors_Min_Fields;
  chart_admin_contractors_order_by: Chart_Admin_Contractors_Order_By;
  chart_admin_contractors_stddev_fields: Chart_Admin_Contractors_Stddev_Fields;
  chart_admin_contractors_stddev_pop_fields: Chart_Admin_Contractors_Stddev_Pop_Fields;
  chart_admin_contractors_stddev_samp_fields: Chart_Admin_Contractors_Stddev_Samp_Fields;
  chart_admin_contractors_stream_cursor_input: Chart_Admin_Contractors_Stream_Cursor_Input;
  chart_admin_contractors_stream_cursor_value_input: Chart_Admin_Contractors_Stream_Cursor_Value_Input;
  chart_admin_contractors_sum_fields: Chart_Admin_Contractors_Sum_Fields;
  chart_admin_contractors_var_pop_fields: Chart_Admin_Contractors_Var_Pop_Fields;
  chart_admin_contractors_var_samp_fields: Chart_Admin_Contractors_Var_Samp_Fields;
  chart_admin_contractors_variance_fields: Chart_Admin_Contractors_Variance_Fields;
  chart_manager_contractors: Chart_Manager_Contractors;
  chart_manager_contractors_aggregate: Chart_Manager_Contractors_Aggregate;
  chart_manager_contractors_aggregate_fields: Chart_Manager_Contractors_Aggregate_Fields;
  chart_manager_contractors_avg_fields: Chart_Manager_Contractors_Avg_Fields;
  chart_manager_contractors_bool_exp: Chart_Manager_Contractors_Bool_Exp;
  chart_manager_contractors_max_fields: Chart_Manager_Contractors_Max_Fields;
  chart_manager_contractors_min_fields: Chart_Manager_Contractors_Min_Fields;
  chart_manager_contractors_order_by: Chart_Manager_Contractors_Order_By;
  chart_manager_contractors_stddev_fields: Chart_Manager_Contractors_Stddev_Fields;
  chart_manager_contractors_stddev_pop_fields: Chart_Manager_Contractors_Stddev_Pop_Fields;
  chart_manager_contractors_stddev_samp_fields: Chart_Manager_Contractors_Stddev_Samp_Fields;
  chart_manager_contractors_stream_cursor_input: Chart_Manager_Contractors_Stream_Cursor_Input;
  chart_manager_contractors_stream_cursor_value_input: Chart_Manager_Contractors_Stream_Cursor_Value_Input;
  chart_manager_contractors_sum_fields: Chart_Manager_Contractors_Sum_Fields;
  chart_manager_contractors_var_pop_fields: Chart_Manager_Contractors_Var_Pop_Fields;
  chart_manager_contractors_var_samp_fields: Chart_Manager_Contractors_Var_Samp_Fields;
  chart_manager_contractors_variance_fields: Chart_Manager_Contractors_Variance_Fields;
  chart_projects: Chart_Projects;
  chart_projects_aggregate: Chart_Projects_Aggregate;
  chart_projects_aggregate_fields: Chart_Projects_Aggregate_Fields;
  chart_projects_avg_fields: Chart_Projects_Avg_Fields;
  chart_projects_bool_exp: Chart_Projects_Bool_Exp;
  chart_projects_max_fields: Chart_Projects_Max_Fields;
  chart_projects_min_fields: Chart_Projects_Min_Fields;
  chart_projects_order_by: Chart_Projects_Order_By;
  chart_projects_stddev_fields: Chart_Projects_Stddev_Fields;
  chart_projects_stddev_pop_fields: Chart_Projects_Stddev_Pop_Fields;
  chart_projects_stddev_samp_fields: Chart_Projects_Stddev_Samp_Fields;
  chart_projects_stream_cursor_input: Chart_Projects_Stream_Cursor_Input;
  chart_projects_stream_cursor_value_input: Chart_Projects_Stream_Cursor_Value_Input;
  chart_projects_sum_fields: Chart_Projects_Sum_Fields;
  chart_projects_var_pop_fields: Chart_Projects_Var_Pop_Fields;
  chart_projects_var_samp_fields: Chart_Projects_Var_Samp_Fields;
  chart_projects_variance_fields: Chart_Projects_Variance_Fields;
  checkin_status: Checkin_Status;
  checkin_status_aggregate: Checkin_Status_Aggregate;
  checkin_status_aggregate_fields: Checkin_Status_Aggregate_Fields;
  checkin_status_bool_exp: Checkin_Status_Bool_Exp;
  checkin_status_insert_input: Checkin_Status_Insert_Input;
  checkin_status_max_fields: Checkin_Status_Max_Fields;
  checkin_status_min_fields: Checkin_Status_Min_Fields;
  checkin_status_mutation_response: Checkin_Status_Mutation_Response;
  checkin_status_on_conflict: Checkin_Status_On_Conflict;
  checkin_status_order_by: Checkin_Status_Order_By;
  checkin_status_pk_columns_input: Checkin_Status_Pk_Columns_Input;
  checkin_status_set_input: Checkin_Status_Set_Input;
  checkin_status_stream_cursor_input: Checkin_Status_Stream_Cursor_Input;
  checkin_status_stream_cursor_value_input: Checkin_Status_Stream_Cursor_Value_Input;
  checkin_status_updates: Checkin_Status_Updates;
  checkout_status: Checkout_Status;
  checkout_status_aggregate: Checkout_Status_Aggregate;
  checkout_status_aggregate_fields: Checkout_Status_Aggregate_Fields;
  checkout_status_bool_exp: Checkout_Status_Bool_Exp;
  checkout_status_insert_input: Checkout_Status_Insert_Input;
  checkout_status_max_fields: Checkout_Status_Max_Fields;
  checkout_status_min_fields: Checkout_Status_Min_Fields;
  checkout_status_mutation_response: Checkout_Status_Mutation_Response;
  checkout_status_on_conflict: Checkout_Status_On_Conflict;
  checkout_status_order_by: Checkout_Status_Order_By;
  checkout_status_pk_columns_input: Checkout_Status_Pk_Columns_Input;
  checkout_status_set_input: Checkout_Status_Set_Input;
  checkout_status_stream_cursor_input: Checkout_Status_Stream_Cursor_Input;
  checkout_status_stream_cursor_value_input: Checkout_Status_Stream_Cursor_Value_Input;
  checkout_status_updates: Checkout_Status_Updates;
  client_care_plan: Client_Care_Plan;
  client_care_plan_aggregate: Client_Care_Plan_Aggregate;
  client_care_plan_aggregate_bool_exp: Client_Care_Plan_Aggregate_Bool_Exp;
  client_care_plan_aggregate_bool_exp_count: Client_Care_Plan_Aggregate_Bool_Exp_Count;
  client_care_plan_aggregate_fields: Client_Care_Plan_Aggregate_Fields;
  client_care_plan_aggregate_order_by: Client_Care_Plan_Aggregate_Order_By;
  client_care_plan_arr_rel_insert_input: Client_Care_Plan_Arr_Rel_Insert_Input;
  client_care_plan_bool_exp: Client_Care_Plan_Bool_Exp;
  client_care_plan_insert_input: Client_Care_Plan_Insert_Input;
  client_care_plan_max_fields: Client_Care_Plan_Max_Fields;
  client_care_plan_max_order_by: Client_Care_Plan_Max_Order_By;
  client_care_plan_min_fields: Client_Care_Plan_Min_Fields;
  client_care_plan_min_order_by: Client_Care_Plan_Min_Order_By;
  client_care_plan_mutation_response: Client_Care_Plan_Mutation_Response;
  client_care_plan_obj_rel_insert_input: Client_Care_Plan_Obj_Rel_Insert_Input;
  client_care_plan_on_conflict: Client_Care_Plan_On_Conflict;
  client_care_plan_order_by: Client_Care_Plan_Order_By;
  client_care_plan_pk_columns_input: Client_Care_Plan_Pk_Columns_Input;
  client_care_plan_set_input: Client_Care_Plan_Set_Input;
  client_care_plan_stream_cursor_input: Client_Care_Plan_Stream_Cursor_Input;
  client_care_plan_stream_cursor_value_input: Client_Care_Plan_Stream_Cursor_Value_Input;
  client_care_plan_updates: Client_Care_Plan_Updates;
  client_medications: Client_Medications;
  client_medications_aggregate: Client_Medications_Aggregate;
  client_medications_aggregate_bool_exp: Client_Medications_Aggregate_Bool_Exp;
  client_medications_aggregate_bool_exp_count: Client_Medications_Aggregate_Bool_Exp_Count;
  client_medications_aggregate_fields: Client_Medications_Aggregate_Fields;
  client_medications_aggregate_order_by: Client_Medications_Aggregate_Order_By;
  client_medications_arr_rel_insert_input: Client_Medications_Arr_Rel_Insert_Input;
  client_medications_bool_exp: Client_Medications_Bool_Exp;
  client_medications_insert_input: Client_Medications_Insert_Input;
  client_medications_max_fields: Client_Medications_Max_Fields;
  client_medications_max_order_by: Client_Medications_Max_Order_By;
  client_medications_min_fields: Client_Medications_Min_Fields;
  client_medications_min_order_by: Client_Medications_Min_Order_By;
  client_medications_mutation_response: Client_Medications_Mutation_Response;
  client_medications_on_conflict: Client_Medications_On_Conflict;
  client_medications_order_by: Client_Medications_Order_By;
  client_medications_pk_columns_input: Client_Medications_Pk_Columns_Input;
  client_medications_set_input: Client_Medications_Set_Input;
  client_medications_stream_cursor_input: Client_Medications_Stream_Cursor_Input;
  client_medications_stream_cursor_value_input: Client_Medications_Stream_Cursor_Value_Input;
  client_medications_updates: Client_Medications_Updates;
  company: Company;
  company_aggregate: Company_Aggregate;
  company_aggregate_bool_exp: Company_Aggregate_Bool_Exp;
  company_aggregate_bool_exp_bool_and: Company_Aggregate_Bool_Exp_Bool_And;
  company_aggregate_bool_exp_bool_or: Company_Aggregate_Bool_Exp_Bool_Or;
  company_aggregate_bool_exp_count: Company_Aggregate_Bool_Exp_Count;
  company_aggregate_fields: Company_Aggregate_Fields;
  company_aggregate_order_by: Company_Aggregate_Order_By;
  company_arr_rel_insert_input: Company_Arr_Rel_Insert_Input;
  company_avg_fields: Company_Avg_Fields;
  company_avg_order_by: Company_Avg_Order_By;
  company_bool_exp: Company_Bool_Exp;
  company_follower: Company_Follower;
  company_follower_aggregate: Company_Follower_Aggregate;
  company_follower_aggregate_bool_exp: Company_Follower_Aggregate_Bool_Exp;
  company_follower_aggregate_bool_exp_count: Company_Follower_Aggregate_Bool_Exp_Count;
  company_follower_aggregate_fields: Company_Follower_Aggregate_Fields;
  company_follower_aggregate_order_by: Company_Follower_Aggregate_Order_By;
  company_follower_arr_rel_insert_input: Company_Follower_Arr_Rel_Insert_Input;
  company_follower_bool_exp: Company_Follower_Bool_Exp;
  company_follower_insert_input: Company_Follower_Insert_Input;
  company_follower_max_fields: Company_Follower_Max_Fields;
  company_follower_max_order_by: Company_Follower_Max_Order_By;
  company_follower_min_fields: Company_Follower_Min_Fields;
  company_follower_min_order_by: Company_Follower_Min_Order_By;
  company_follower_mutation_response: Company_Follower_Mutation_Response;
  company_follower_on_conflict: Company_Follower_On_Conflict;
  company_follower_order_by: Company_Follower_Order_By;
  company_follower_pk_columns_input: Company_Follower_Pk_Columns_Input;
  company_follower_set_input: Company_Follower_Set_Input;
  company_follower_stream_cursor_input: Company_Follower_Stream_Cursor_Input;
  company_follower_stream_cursor_value_input: Company_Follower_Stream_Cursor_Value_Input;
  company_follower_updates: Company_Follower_Updates;
  company_inc_input: Company_Inc_Input;
  company_insert_input: Company_Insert_Input;
  company_managers_view_all_contractors_access: Scalars['company_managers_view_all_contractors_access'];
  company_managers_view_all_contractors_access_comparison_exp: Company_Managers_View_All_Contractors_Access_Comparison_Exp;
  company_marketplace_access: Scalars['company_marketplace_access'];
  company_marketplace_access_comparison_exp: Company_Marketplace_Access_Comparison_Exp;
  company_max_fields: Company_Max_Fields;
  company_max_order_by: Company_Max_Order_By;
  company_min_fields: Company_Min_Fields;
  company_min_order_by: Company_Min_Order_By;
  company_mutation_response: Company_Mutation_Response;
  company_obj_rel_insert_input: Company_Obj_Rel_Insert_Input;
  company_on_conflict: Company_On_Conflict;
  company_order_by: Company_Order_By;
  company_pk_columns_input: Company_Pk_Columns_Input;
  company_set_input: Company_Set_Input;
  company_stddev_fields: Company_Stddev_Fields;
  company_stddev_order_by: Company_Stddev_Order_By;
  company_stddev_pop_fields: Company_Stddev_Pop_Fields;
  company_stddev_pop_order_by: Company_Stddev_Pop_Order_By;
  company_stddev_samp_fields: Company_Stddev_Samp_Fields;
  company_stddev_samp_order_by: Company_Stddev_Samp_Order_By;
  company_stream_cursor_input: Company_Stream_Cursor_Input;
  company_stream_cursor_value_input: Company_Stream_Cursor_Value_Input;
  company_sum_fields: Company_Sum_Fields;
  company_sum_order_by: Company_Sum_Order_By;
  company_updates: Company_Updates;
  company_user_notifications: Company_User_Notifications;
  company_user_notifications_aggregate: Company_User_Notifications_Aggregate;
  company_user_notifications_aggregate_bool_exp: Company_User_Notifications_Aggregate_Bool_Exp;
  company_user_notifications_aggregate_bool_exp_count: Company_User_Notifications_Aggregate_Bool_Exp_Count;
  company_user_notifications_aggregate_fields: Company_User_Notifications_Aggregate_Fields;
  company_user_notifications_aggregate_order_by: Company_User_Notifications_Aggregate_Order_By;
  company_user_notifications_arr_rel_insert_input: Company_User_Notifications_Arr_Rel_Insert_Input;
  company_user_notifications_bool_exp: Company_User_Notifications_Bool_Exp;
  company_user_notifications_insert_input: Company_User_Notifications_Insert_Input;
  company_user_notifications_max_fields: Company_User_Notifications_Max_Fields;
  company_user_notifications_max_order_by: Company_User_Notifications_Max_Order_By;
  company_user_notifications_min_fields: Company_User_Notifications_Min_Fields;
  company_user_notifications_min_order_by: Company_User_Notifications_Min_Order_By;
  company_user_notifications_mutation_response: Company_User_Notifications_Mutation_Response;
  company_user_notifications_on_conflict: Company_User_Notifications_On_Conflict;
  company_user_notifications_order_by: Company_User_Notifications_Order_By;
  company_user_notifications_pk_columns_input: Company_User_Notifications_Pk_Columns_Input;
  company_user_notifications_set_input: Company_User_Notifications_Set_Input;
  company_user_notifications_stream_cursor_input: Company_User_Notifications_Stream_Cursor_Input;
  company_user_notifications_stream_cursor_value_input: Company_User_Notifications_Stream_Cursor_Value_Input;
  company_user_notifications_updates: Company_User_Notifications_Updates;
  company_var_pop_fields: Company_Var_Pop_Fields;
  company_var_pop_order_by: Company_Var_Pop_Order_By;
  company_var_samp_fields: Company_Var_Samp_Fields;
  company_var_samp_order_by: Company_Var_Samp_Order_By;
  company_variance_fields: Company_Variance_Fields;
  company_variance_order_by: Company_Variance_Order_By;
  contractor: Contractor;
  contractor_aggregate: Contractor_Aggregate;
  contractor_aggregate_bool_exp: Contractor_Aggregate_Bool_Exp;
  contractor_aggregate_bool_exp_bool_and: Contractor_Aggregate_Bool_Exp_Bool_And;
  contractor_aggregate_bool_exp_bool_or: Contractor_Aggregate_Bool_Exp_Bool_Or;
  contractor_aggregate_bool_exp_count: Contractor_Aggregate_Bool_Exp_Count;
  contractor_aggregate_fields: Contractor_Aggregate_Fields;
  contractor_aggregate_order_by: Contractor_Aggregate_Order_By;
  contractor_arr_rel_insert_input: Contractor_Arr_Rel_Insert_Input;
  contractor_avg_fields: Contractor_Avg_Fields;
  contractor_avg_order_by: Contractor_Avg_Order_By;
  contractor_bool_exp: Contractor_Bool_Exp;
  contractor_inc_input: Contractor_Inc_Input;
  contractor_insert_input: Contractor_Insert_Input;
  contractor_max_fields: Contractor_Max_Fields;
  contractor_max_order_by: Contractor_Max_Order_By;
  contractor_min_fields: Contractor_Min_Fields;
  contractor_min_order_by: Contractor_Min_Order_By;
  contractor_mutation_response: Contractor_Mutation_Response;
  contractor_note: Contractor_Note;
  contractor_note_aggregate: Contractor_Note_Aggregate;
  contractor_note_aggregate_bool_exp: Contractor_Note_Aggregate_Bool_Exp;
  contractor_note_aggregate_bool_exp_count: Contractor_Note_Aggregate_Bool_Exp_Count;
  contractor_note_aggregate_fields: Contractor_Note_Aggregate_Fields;
  contractor_note_aggregate_order_by: Contractor_Note_Aggregate_Order_By;
  contractor_note_arr_rel_insert_input: Contractor_Note_Arr_Rel_Insert_Input;
  contractor_note_bool_exp: Contractor_Note_Bool_Exp;
  contractor_note_insert_input: Contractor_Note_Insert_Input;
  contractor_note_max_fields: Contractor_Note_Max_Fields;
  contractor_note_max_order_by: Contractor_Note_Max_Order_By;
  contractor_note_min_fields: Contractor_Note_Min_Fields;
  contractor_note_min_order_by: Contractor_Note_Min_Order_By;
  contractor_note_mutation_response: Contractor_Note_Mutation_Response;
  contractor_note_on_conflict: Contractor_Note_On_Conflict;
  contractor_note_order_by: Contractor_Note_Order_By;
  contractor_note_pk_columns_input: Contractor_Note_Pk_Columns_Input;
  contractor_note_set_input: Contractor_Note_Set_Input;
  contractor_note_stream_cursor_input: Contractor_Note_Stream_Cursor_Input;
  contractor_note_stream_cursor_value_input: Contractor_Note_Stream_Cursor_Value_Input;
  contractor_note_updates: Contractor_Note_Updates;
  contractor_obj_rel_insert_input: Contractor_Obj_Rel_Insert_Input;
  contractor_on_conflict: Contractor_On_Conflict;
  contractor_order_by: Contractor_Order_By;
  contractor_pk_columns_input: Contractor_Pk_Columns_Input;
  contractor_posting: Contractor_Posting;
  contractor_posting_aggregate: Contractor_Posting_Aggregate;
  contractor_posting_aggregate_bool_exp: Contractor_Posting_Aggregate_Bool_Exp;
  contractor_posting_aggregate_bool_exp_count: Contractor_Posting_Aggregate_Bool_Exp_Count;
  contractor_posting_aggregate_fields: Contractor_Posting_Aggregate_Fields;
  contractor_posting_aggregate_order_by: Contractor_Posting_Aggregate_Order_By;
  contractor_posting_arr_rel_insert_input: Contractor_Posting_Arr_Rel_Insert_Input;
  contractor_posting_avg_fields: Contractor_Posting_Avg_Fields;
  contractor_posting_avg_order_by: Contractor_Posting_Avg_Order_By;
  contractor_posting_bool_exp: Contractor_Posting_Bool_Exp;
  contractor_posting_inc_input: Contractor_Posting_Inc_Input;
  contractor_posting_insert_input: Contractor_Posting_Insert_Input;
  contractor_posting_max_fields: Contractor_Posting_Max_Fields;
  contractor_posting_max_order_by: Contractor_Posting_Max_Order_By;
  contractor_posting_min_fields: Contractor_Posting_Min_Fields;
  contractor_posting_min_order_by: Contractor_Posting_Min_Order_By;
  contractor_posting_mutation_response: Contractor_Posting_Mutation_Response;
  contractor_posting_on_conflict: Contractor_Posting_On_Conflict;
  contractor_posting_order_by: Contractor_Posting_Order_By;
  contractor_posting_pk_columns_input: Contractor_Posting_Pk_Columns_Input;
  contractor_posting_set_input: Contractor_Posting_Set_Input;
  contractor_posting_stddev_fields: Contractor_Posting_Stddev_Fields;
  contractor_posting_stddev_order_by: Contractor_Posting_Stddev_Order_By;
  contractor_posting_stddev_pop_fields: Contractor_Posting_Stddev_Pop_Fields;
  contractor_posting_stddev_pop_order_by: Contractor_Posting_Stddev_Pop_Order_By;
  contractor_posting_stddev_samp_fields: Contractor_Posting_Stddev_Samp_Fields;
  contractor_posting_stddev_samp_order_by: Contractor_Posting_Stddev_Samp_Order_By;
  contractor_posting_stream_cursor_input: Contractor_Posting_Stream_Cursor_Input;
  contractor_posting_stream_cursor_value_input: Contractor_Posting_Stream_Cursor_Value_Input;
  contractor_posting_sum_fields: Contractor_Posting_Sum_Fields;
  contractor_posting_sum_order_by: Contractor_Posting_Sum_Order_By;
  contractor_posting_updates: Contractor_Posting_Updates;
  contractor_posting_var_pop_fields: Contractor_Posting_Var_Pop_Fields;
  contractor_posting_var_pop_order_by: Contractor_Posting_Var_Pop_Order_By;
  contractor_posting_var_samp_fields: Contractor_Posting_Var_Samp_Fields;
  contractor_posting_var_samp_order_by: Contractor_Posting_Var_Samp_Order_By;
  contractor_posting_variance_fields: Contractor_Posting_Variance_Fields;
  contractor_posting_variance_order_by: Contractor_Posting_Variance_Order_By;
  contractor_project: Contractor_Project;
  contractor_project_aggregate: Contractor_Project_Aggregate;
  contractor_project_aggregate_bool_exp: Contractor_Project_Aggregate_Bool_Exp;
  contractor_project_aggregate_bool_exp_count: Contractor_Project_Aggregate_Bool_Exp_Count;
  contractor_project_aggregate_fields: Contractor_Project_Aggregate_Fields;
  contractor_project_aggregate_order_by: Contractor_Project_Aggregate_Order_By;
  contractor_project_arr_rel_insert_input: Contractor_Project_Arr_Rel_Insert_Input;
  contractor_project_bool_exp: Contractor_Project_Bool_Exp;
  contractor_project_insert_input: Contractor_Project_Insert_Input;
  contractor_project_max_fields: Contractor_Project_Max_Fields;
  contractor_project_max_order_by: Contractor_Project_Max_Order_By;
  contractor_project_min_fields: Contractor_Project_Min_Fields;
  contractor_project_min_order_by: Contractor_Project_Min_Order_By;
  contractor_project_mutation_response: Contractor_Project_Mutation_Response;
  contractor_project_on_conflict: Contractor_Project_On_Conflict;
  contractor_project_order_by: Contractor_Project_Order_By;
  contractor_project_pk_columns_input: Contractor_Project_Pk_Columns_Input;
  contractor_project_set_input: Contractor_Project_Set_Input;
  contractor_project_stream_cursor_input: Contractor_Project_Stream_Cursor_Input;
  contractor_project_stream_cursor_value_input: Contractor_Project_Stream_Cursor_Value_Input;
  contractor_project_updates: Contractor_Project_Updates;
  contractor_rating: Contractor_Rating;
  contractor_rating_aggregate: Contractor_Rating_Aggregate;
  contractor_rating_aggregate_bool_exp: Contractor_Rating_Aggregate_Bool_Exp;
  contractor_rating_aggregate_bool_exp_bool_and: Contractor_Rating_Aggregate_Bool_Exp_Bool_And;
  contractor_rating_aggregate_bool_exp_bool_or: Contractor_Rating_Aggregate_Bool_Exp_Bool_Or;
  contractor_rating_aggregate_bool_exp_count: Contractor_Rating_Aggregate_Bool_Exp_Count;
  contractor_rating_aggregate_fields: Contractor_Rating_Aggregate_Fields;
  contractor_rating_aggregate_order_by: Contractor_Rating_Aggregate_Order_By;
  contractor_rating_arr_rel_insert_input: Contractor_Rating_Arr_Rel_Insert_Input;
  contractor_rating_avg_fields: Contractor_Rating_Avg_Fields;
  contractor_rating_avg_order_by: Contractor_Rating_Avg_Order_By;
  contractor_rating_bool_exp: Contractor_Rating_Bool_Exp;
  contractor_rating_inc_input: Contractor_Rating_Inc_Input;
  contractor_rating_insert_input: Contractor_Rating_Insert_Input;
  contractor_rating_max_fields: Contractor_Rating_Max_Fields;
  contractor_rating_max_order_by: Contractor_Rating_Max_Order_By;
  contractor_rating_min_fields: Contractor_Rating_Min_Fields;
  contractor_rating_min_order_by: Contractor_Rating_Min_Order_By;
  contractor_rating_mutation_response: Contractor_Rating_Mutation_Response;
  contractor_rating_on_conflict: Contractor_Rating_On_Conflict;
  contractor_rating_order_by: Contractor_Rating_Order_By;
  contractor_rating_pk_columns_input: Contractor_Rating_Pk_Columns_Input;
  contractor_rating_set_input: Contractor_Rating_Set_Input;
  contractor_rating_stddev_fields: Contractor_Rating_Stddev_Fields;
  contractor_rating_stddev_order_by: Contractor_Rating_Stddev_Order_By;
  contractor_rating_stddev_pop_fields: Contractor_Rating_Stddev_Pop_Fields;
  contractor_rating_stddev_pop_order_by: Contractor_Rating_Stddev_Pop_Order_By;
  contractor_rating_stddev_samp_fields: Contractor_Rating_Stddev_Samp_Fields;
  contractor_rating_stddev_samp_order_by: Contractor_Rating_Stddev_Samp_Order_By;
  contractor_rating_stream_cursor_input: Contractor_Rating_Stream_Cursor_Input;
  contractor_rating_stream_cursor_value_input: Contractor_Rating_Stream_Cursor_Value_Input;
  contractor_rating_sum_fields: Contractor_Rating_Sum_Fields;
  contractor_rating_sum_order_by: Contractor_Rating_Sum_Order_By;
  contractor_rating_updates: Contractor_Rating_Updates;
  contractor_rating_var_pop_fields: Contractor_Rating_Var_Pop_Fields;
  contractor_rating_var_pop_order_by: Contractor_Rating_Var_Pop_Order_By;
  contractor_rating_var_samp_fields: Contractor_Rating_Var_Samp_Fields;
  contractor_rating_var_samp_order_by: Contractor_Rating_Var_Samp_Order_By;
  contractor_rating_variance_fields: Contractor_Rating_Variance_Fields;
  contractor_rating_variance_order_by: Contractor_Rating_Variance_Order_By;
  contractor_set_input: Contractor_Set_Input;
  contractor_staff_note: Contractor_Staff_Note;
  contractor_staff_note_aggregate: Contractor_Staff_Note_Aggregate;
  contractor_staff_note_aggregate_bool_exp: Contractor_Staff_Note_Aggregate_Bool_Exp;
  contractor_staff_note_aggregate_bool_exp_count: Contractor_Staff_Note_Aggregate_Bool_Exp_Count;
  contractor_staff_note_aggregate_fields: Contractor_Staff_Note_Aggregate_Fields;
  contractor_staff_note_aggregate_order_by: Contractor_Staff_Note_Aggregate_Order_By;
  contractor_staff_note_arr_rel_insert_input: Contractor_Staff_Note_Arr_Rel_Insert_Input;
  contractor_staff_note_bool_exp: Contractor_Staff_Note_Bool_Exp;
  contractor_staff_note_insert_input: Contractor_Staff_Note_Insert_Input;
  contractor_staff_note_max_fields: Contractor_Staff_Note_Max_Fields;
  contractor_staff_note_max_order_by: Contractor_Staff_Note_Max_Order_By;
  contractor_staff_note_min_fields: Contractor_Staff_Note_Min_Fields;
  contractor_staff_note_min_order_by: Contractor_Staff_Note_Min_Order_By;
  contractor_staff_note_mutation_response: Contractor_Staff_Note_Mutation_Response;
  contractor_staff_note_on_conflict: Contractor_Staff_Note_On_Conflict;
  contractor_staff_note_order_by: Contractor_Staff_Note_Order_By;
  contractor_staff_note_pk_columns_input: Contractor_Staff_Note_Pk_Columns_Input;
  contractor_staff_note_set_input: Contractor_Staff_Note_Set_Input;
  contractor_staff_note_stream_cursor_input: Contractor_Staff_Note_Stream_Cursor_Input;
  contractor_staff_note_stream_cursor_value_input: Contractor_Staff_Note_Stream_Cursor_Value_Input;
  contractor_staff_note_updates: Contractor_Staff_Note_Updates;
  contractor_stddev_fields: Contractor_Stddev_Fields;
  contractor_stddev_order_by: Contractor_Stddev_Order_By;
  contractor_stddev_pop_fields: Contractor_Stddev_Pop_Fields;
  contractor_stddev_pop_order_by: Contractor_Stddev_Pop_Order_By;
  contractor_stddev_samp_fields: Contractor_Stddev_Samp_Fields;
  contractor_stddev_samp_order_by: Contractor_Stddev_Samp_Order_By;
  contractor_stream_cursor_input: Contractor_Stream_Cursor_Input;
  contractor_stream_cursor_value_input: Contractor_Stream_Cursor_Value_Input;
  contractor_sum_fields: Contractor_Sum_Fields;
  contractor_sum_order_by: Contractor_Sum_Order_By;
  contractor_updates: Contractor_Updates;
  contractor_var_pop_fields: Contractor_Var_Pop_Fields;
  contractor_var_pop_order_by: Contractor_Var_Pop_Order_By;
  contractor_var_samp_fields: Contractor_Var_Samp_Fields;
  contractor_var_samp_order_by: Contractor_Var_Samp_Order_By;
  contractor_variance_fields: Contractor_Variance_Fields;
  contractor_variance_order_by: Contractor_Variance_Order_By;
  conversation: Conversation;
  conversation_aggregate: Conversation_Aggregate;
  conversation_aggregate_fields: Conversation_Aggregate_Fields;
  conversation_bool_exp: Conversation_Bool_Exp;
  conversation_insert_input: Conversation_Insert_Input;
  conversation_max_fields: Conversation_Max_Fields;
  conversation_min_fields: Conversation_Min_Fields;
  conversation_mutation_response: Conversation_Mutation_Response;
  conversation_obj_rel_insert_input: Conversation_Obj_Rel_Insert_Input;
  conversation_on_conflict: Conversation_On_Conflict;
  conversation_order_by: Conversation_Order_By;
  conversation_pk_columns_input: Conversation_Pk_Columns_Input;
  conversation_set_input: Conversation_Set_Input;
  conversation_stream_cursor_input: Conversation_Stream_Cursor_Input;
  conversation_stream_cursor_value_input: Conversation_Stream_Cursor_Value_Input;
  conversation_updates: Conversation_Updates;
  currency: Scalars['currency'];
  currency_comparison_exp: Currency_Comparison_Exp;
  custom_request: Custom_Request;
  custom_request_aggregate: Custom_Request_Aggregate;
  custom_request_aggregate_bool_exp: Custom_Request_Aggregate_Bool_Exp;
  custom_request_aggregate_bool_exp_count: Custom_Request_Aggregate_Bool_Exp_Count;
  custom_request_aggregate_fields: Custom_Request_Aggregate_Fields;
  custom_request_aggregate_order_by: Custom_Request_Aggregate_Order_By;
  custom_request_arr_rel_insert_input: Custom_Request_Arr_Rel_Insert_Input;
  custom_request_bool_exp: Custom_Request_Bool_Exp;
  custom_request_insert_input: Custom_Request_Insert_Input;
  custom_request_max_fields: Custom_Request_Max_Fields;
  custom_request_max_order_by: Custom_Request_Max_Order_By;
  custom_request_min_fields: Custom_Request_Min_Fields;
  custom_request_min_order_by: Custom_Request_Min_Order_By;
  custom_request_mutation_response: Custom_Request_Mutation_Response;
  custom_request_obj_rel_insert_input: Custom_Request_Obj_Rel_Insert_Input;
  custom_request_on_conflict: Custom_Request_On_Conflict;
  custom_request_order_by: Custom_Request_Order_By;
  custom_request_pk_columns_input: Custom_Request_Pk_Columns_Input;
  custom_request_set_input: Custom_Request_Set_Input;
  custom_request_skills: Custom_Request_Skills;
  custom_request_skills_aggregate: Custom_Request_Skills_Aggregate;
  custom_request_skills_aggregate_bool_exp: Custom_Request_Skills_Aggregate_Bool_Exp;
  custom_request_skills_aggregate_bool_exp_count: Custom_Request_Skills_Aggregate_Bool_Exp_Count;
  custom_request_skills_aggregate_fields: Custom_Request_Skills_Aggregate_Fields;
  custom_request_skills_aggregate_order_by: Custom_Request_Skills_Aggregate_Order_By;
  custom_request_skills_arr_rel_insert_input: Custom_Request_Skills_Arr_Rel_Insert_Input;
  custom_request_skills_avg_fields: Custom_Request_Skills_Avg_Fields;
  custom_request_skills_avg_order_by: Custom_Request_Skills_Avg_Order_By;
  custom_request_skills_bool_exp: Custom_Request_Skills_Bool_Exp;
  custom_request_skills_inc_input: Custom_Request_Skills_Inc_Input;
  custom_request_skills_insert_input: Custom_Request_Skills_Insert_Input;
  custom_request_skills_max_fields: Custom_Request_Skills_Max_Fields;
  custom_request_skills_max_order_by: Custom_Request_Skills_Max_Order_By;
  custom_request_skills_min_fields: Custom_Request_Skills_Min_Fields;
  custom_request_skills_min_order_by: Custom_Request_Skills_Min_Order_By;
  custom_request_skills_mutation_response: Custom_Request_Skills_Mutation_Response;
  custom_request_skills_on_conflict: Custom_Request_Skills_On_Conflict;
  custom_request_skills_order_by: Custom_Request_Skills_Order_By;
  custom_request_skills_pk_columns_input: Custom_Request_Skills_Pk_Columns_Input;
  custom_request_skills_set_input: Custom_Request_Skills_Set_Input;
  custom_request_skills_stddev_fields: Custom_Request_Skills_Stddev_Fields;
  custom_request_skills_stddev_order_by: Custom_Request_Skills_Stddev_Order_By;
  custom_request_skills_stddev_pop_fields: Custom_Request_Skills_Stddev_Pop_Fields;
  custom_request_skills_stddev_pop_order_by: Custom_Request_Skills_Stddev_Pop_Order_By;
  custom_request_skills_stddev_samp_fields: Custom_Request_Skills_Stddev_Samp_Fields;
  custom_request_skills_stddev_samp_order_by: Custom_Request_Skills_Stddev_Samp_Order_By;
  custom_request_skills_stream_cursor_input: Custom_Request_Skills_Stream_Cursor_Input;
  custom_request_skills_stream_cursor_value_input: Custom_Request_Skills_Stream_Cursor_Value_Input;
  custom_request_skills_sum_fields: Custom_Request_Skills_Sum_Fields;
  custom_request_skills_sum_order_by: Custom_Request_Skills_Sum_Order_By;
  custom_request_skills_updates: Custom_Request_Skills_Updates;
  custom_request_skills_var_pop_fields: Custom_Request_Skills_Var_Pop_Fields;
  custom_request_skills_var_pop_order_by: Custom_Request_Skills_Var_Pop_Order_By;
  custom_request_skills_var_samp_fields: Custom_Request_Skills_Var_Samp_Fields;
  custom_request_skills_var_samp_order_by: Custom_Request_Skills_Var_Samp_Order_By;
  custom_request_skills_variance_fields: Custom_Request_Skills_Variance_Fields;
  custom_request_skills_variance_order_by: Custom_Request_Skills_Variance_Order_By;
  custom_request_status: Scalars['custom_request_status'];
  custom_request_status_comparison_exp: Custom_Request_Status_Comparison_Exp;
  custom_request_stream_cursor_input: Custom_Request_Stream_Cursor_Input;
  custom_request_stream_cursor_value_input: Custom_Request_Stream_Cursor_Value_Input;
  custom_request_updates: Custom_Request_Updates;
  date: Scalars['date'];
  date_comparison_exp: Date_Comparison_Exp;
  declined_visit_matches: Declined_Visit_Matches;
  declined_visit_matches_aggregate: Declined_Visit_Matches_Aggregate;
  declined_visit_matches_aggregate_bool_exp: Declined_Visit_Matches_Aggregate_Bool_Exp;
  declined_visit_matches_aggregate_bool_exp_count: Declined_Visit_Matches_Aggregate_Bool_Exp_Count;
  declined_visit_matches_aggregate_fields: Declined_Visit_Matches_Aggregate_Fields;
  declined_visit_matches_aggregate_order_by: Declined_Visit_Matches_Aggregate_Order_By;
  declined_visit_matches_arr_rel_insert_input: Declined_Visit_Matches_Arr_Rel_Insert_Input;
  declined_visit_matches_avg_fields: Declined_Visit_Matches_Avg_Fields;
  declined_visit_matches_avg_order_by: Declined_Visit_Matches_Avg_Order_By;
  declined_visit_matches_bool_exp: Declined_Visit_Matches_Bool_Exp;
  declined_visit_matches_inc_input: Declined_Visit_Matches_Inc_Input;
  declined_visit_matches_insert_input: Declined_Visit_Matches_Insert_Input;
  declined_visit_matches_max_fields: Declined_Visit_Matches_Max_Fields;
  declined_visit_matches_max_order_by: Declined_Visit_Matches_Max_Order_By;
  declined_visit_matches_min_fields: Declined_Visit_Matches_Min_Fields;
  declined_visit_matches_min_order_by: Declined_Visit_Matches_Min_Order_By;
  declined_visit_matches_mutation_response: Declined_Visit_Matches_Mutation_Response;
  declined_visit_matches_on_conflict: Declined_Visit_Matches_On_Conflict;
  declined_visit_matches_order_by: Declined_Visit_Matches_Order_By;
  declined_visit_matches_pk_columns_input: Declined_Visit_Matches_Pk_Columns_Input;
  declined_visit_matches_set_input: Declined_Visit_Matches_Set_Input;
  declined_visit_matches_stddev_fields: Declined_Visit_Matches_Stddev_Fields;
  declined_visit_matches_stddev_order_by: Declined_Visit_Matches_Stddev_Order_By;
  declined_visit_matches_stddev_pop_fields: Declined_Visit_Matches_Stddev_Pop_Fields;
  declined_visit_matches_stddev_pop_order_by: Declined_Visit_Matches_Stddev_Pop_Order_By;
  declined_visit_matches_stddev_samp_fields: Declined_Visit_Matches_Stddev_Samp_Fields;
  declined_visit_matches_stddev_samp_order_by: Declined_Visit_Matches_Stddev_Samp_Order_By;
  declined_visit_matches_stream_cursor_input: Declined_Visit_Matches_Stream_Cursor_Input;
  declined_visit_matches_stream_cursor_value_input: Declined_Visit_Matches_Stream_Cursor_Value_Input;
  declined_visit_matches_sum_fields: Declined_Visit_Matches_Sum_Fields;
  declined_visit_matches_sum_order_by: Declined_Visit_Matches_Sum_Order_By;
  declined_visit_matches_updates: Declined_Visit_Matches_Updates;
  declined_visit_matches_var_pop_fields: Declined_Visit_Matches_Var_Pop_Fields;
  declined_visit_matches_var_pop_order_by: Declined_Visit_Matches_Var_Pop_Order_By;
  declined_visit_matches_var_samp_fields: Declined_Visit_Matches_Var_Samp_Fields;
  declined_visit_matches_var_samp_order_by: Declined_Visit_Matches_Var_Samp_Order_By;
  declined_visit_matches_variance_fields: Declined_Visit_Matches_Variance_Fields;
  declined_visit_matches_variance_order_by: Declined_Visit_Matches_Variance_Order_By;
  document: Document;
  document_aggregate: Document_Aggregate;
  document_aggregate_bool_exp: Document_Aggregate_Bool_Exp;
  document_aggregate_bool_exp_count: Document_Aggregate_Bool_Exp_Count;
  document_aggregate_fields: Document_Aggregate_Fields;
  document_aggregate_order_by: Document_Aggregate_Order_By;
  document_arr_rel_insert_input: Document_Arr_Rel_Insert_Input;
  document_bool_exp: Document_Bool_Exp;
  document_contractor_access: Document_Contractor_Access;
  document_contractor_access_aggregate: Document_Contractor_Access_Aggregate;
  document_contractor_access_aggregate_bool_exp: Document_Contractor_Access_Aggregate_Bool_Exp;
  document_contractor_access_aggregate_bool_exp_count: Document_Contractor_Access_Aggregate_Bool_Exp_Count;
  document_contractor_access_aggregate_fields: Document_Contractor_Access_Aggregate_Fields;
  document_contractor_access_aggregate_order_by: Document_Contractor_Access_Aggregate_Order_By;
  document_contractor_access_arr_rel_insert_input: Document_Contractor_Access_Arr_Rel_Insert_Input;
  document_contractor_access_bool_exp: Document_Contractor_Access_Bool_Exp;
  document_contractor_access_insert_input: Document_Contractor_Access_Insert_Input;
  document_contractor_access_max_fields: Document_Contractor_Access_Max_Fields;
  document_contractor_access_max_order_by: Document_Contractor_Access_Max_Order_By;
  document_contractor_access_min_fields: Document_Contractor_Access_Min_Fields;
  document_contractor_access_min_order_by: Document_Contractor_Access_Min_Order_By;
  document_contractor_access_mutation_response: Document_Contractor_Access_Mutation_Response;
  document_contractor_access_on_conflict: Document_Contractor_Access_On_Conflict;
  document_contractor_access_order_by: Document_Contractor_Access_Order_By;
  document_contractor_access_pk_columns_input: Document_Contractor_Access_Pk_Columns_Input;
  document_contractor_access_set_input: Document_Contractor_Access_Set_Input;
  document_contractor_access_stream_cursor_input: Document_Contractor_Access_Stream_Cursor_Input;
  document_contractor_access_stream_cursor_value_input: Document_Contractor_Access_Stream_Cursor_Value_Input;
  document_contractor_access_updates: Document_Contractor_Access_Updates;
  document_custom_request: Document_Custom_Request;
  document_custom_request_aggregate: Document_Custom_Request_Aggregate;
  document_custom_request_aggregate_bool_exp: Document_Custom_Request_Aggregate_Bool_Exp;
  document_custom_request_aggregate_bool_exp_count: Document_Custom_Request_Aggregate_Bool_Exp_Count;
  document_custom_request_aggregate_fields: Document_Custom_Request_Aggregate_Fields;
  document_custom_request_aggregate_order_by: Document_Custom_Request_Aggregate_Order_By;
  document_custom_request_arr_rel_insert_input: Document_Custom_Request_Arr_Rel_Insert_Input;
  document_custom_request_bool_exp: Document_Custom_Request_Bool_Exp;
  document_custom_request_insert_input: Document_Custom_Request_Insert_Input;
  document_custom_request_max_fields: Document_Custom_Request_Max_Fields;
  document_custom_request_max_order_by: Document_Custom_Request_Max_Order_By;
  document_custom_request_min_fields: Document_Custom_Request_Min_Fields;
  document_custom_request_min_order_by: Document_Custom_Request_Min_Order_By;
  document_custom_request_mutation_response: Document_Custom_Request_Mutation_Response;
  document_custom_request_on_conflict: Document_Custom_Request_On_Conflict;
  document_custom_request_order_by: Document_Custom_Request_Order_By;
  document_custom_request_pk_columns_input: Document_Custom_Request_Pk_Columns_Input;
  document_custom_request_set_input: Document_Custom_Request_Set_Input;
  document_custom_request_stream_cursor_input: Document_Custom_Request_Stream_Cursor_Input;
  document_custom_request_stream_cursor_value_input: Document_Custom_Request_Stream_Cursor_Value_Input;
  document_custom_request_updates: Document_Custom_Request_Updates;
  document_insert_input: Document_Insert_Input;
  document_max_fields: Document_Max_Fields;
  document_max_order_by: Document_Max_Order_By;
  document_min_fields: Document_Min_Fields;
  document_min_order_by: Document_Min_Order_By;
  document_mutation_response: Document_Mutation_Response;
  document_obj_rel_insert_input: Document_Obj_Rel_Insert_Input;
  document_on_conflict: Document_On_Conflict;
  document_order_by: Document_Order_By;
  document_pk_columns_input: Document_Pk_Columns_Input;
  document_project: Document_Project;
  document_project_access_scope: Scalars['document_project_access_scope'];
  document_project_access_scope_comparison_exp: Document_Project_Access_Scope_Comparison_Exp;
  document_project_aggregate: Document_Project_Aggregate;
  document_project_aggregate_bool_exp: Document_Project_Aggregate_Bool_Exp;
  document_project_aggregate_bool_exp_bool_and: Document_Project_Aggregate_Bool_Exp_Bool_And;
  document_project_aggregate_bool_exp_bool_or: Document_Project_Aggregate_Bool_Exp_Bool_Or;
  document_project_aggregate_bool_exp_count: Document_Project_Aggregate_Bool_Exp_Count;
  document_project_aggregate_fields: Document_Project_Aggregate_Fields;
  document_project_aggregate_order_by: Document_Project_Aggregate_Order_By;
  document_project_arr_rel_insert_input: Document_Project_Arr_Rel_Insert_Input;
  document_project_bool_exp: Document_Project_Bool_Exp;
  document_project_insert_input: Document_Project_Insert_Input;
  document_project_max_fields: Document_Project_Max_Fields;
  document_project_max_order_by: Document_Project_Max_Order_By;
  document_project_min_fields: Document_Project_Min_Fields;
  document_project_min_order_by: Document_Project_Min_Order_By;
  document_project_mutation_response: Document_Project_Mutation_Response;
  document_project_on_conflict: Document_Project_On_Conflict;
  document_project_order_by: Document_Project_Order_By;
  document_project_pk_columns_input: Document_Project_Pk_Columns_Input;
  document_project_set_input: Document_Project_Set_Input;
  document_project_stream_cursor_input: Document_Project_Stream_Cursor_Input;
  document_project_stream_cursor_value_input: Document_Project_Stream_Cursor_Value_Input;
  document_project_updates: Document_Project_Updates;
  document_set_input: Document_Set_Input;
  document_stream_cursor_input: Document_Stream_Cursor_Input;
  document_stream_cursor_value_input: Document_Stream_Cursor_Value_Input;
  document_updates: Document_Updates;
  document_user: Document_User;
  document_user_aggregate: Document_User_Aggregate;
  document_user_aggregate_bool_exp: Document_User_Aggregate_Bool_Exp;
  document_user_aggregate_bool_exp_count: Document_User_Aggregate_Bool_Exp_Count;
  document_user_aggregate_fields: Document_User_Aggregate_Fields;
  document_user_aggregate_order_by: Document_User_Aggregate_Order_By;
  document_user_arr_rel_insert_input: Document_User_Arr_Rel_Insert_Input;
  document_user_bool_exp: Document_User_Bool_Exp;
  document_user_insert_input: Document_User_Insert_Input;
  document_user_max_fields: Document_User_Max_Fields;
  document_user_max_order_by: Document_User_Max_Order_By;
  document_user_min_fields: Document_User_Min_Fields;
  document_user_min_order_by: Document_User_Min_Order_By;
  document_user_mutation_response: Document_User_Mutation_Response;
  document_user_on_conflict: Document_User_On_Conflict;
  document_user_order_by: Document_User_Order_By;
  document_user_pk_columns_input: Document_User_Pk_Columns_Input;
  document_user_set_input: Document_User_Set_Input;
  document_user_stream_cursor_input: Document_User_Stream_Cursor_Input;
  document_user_stream_cursor_value_input: Document_User_Stream_Cursor_Value_Input;
  document_user_updates: Document_User_Updates;
  email_regex: Email_Regex;
  email_regex_aggregate: Email_Regex_Aggregate;
  email_regex_aggregate_fields: Email_Regex_Aggregate_Fields;
  email_regex_avg_fields: Email_Regex_Avg_Fields;
  email_regex_bool_exp: Email_Regex_Bool_Exp;
  email_regex_inc_input: Email_Regex_Inc_Input;
  email_regex_insert_input: Email_Regex_Insert_Input;
  email_regex_max_fields: Email_Regex_Max_Fields;
  email_regex_min_fields: Email_Regex_Min_Fields;
  email_regex_mutation_response: Email_Regex_Mutation_Response;
  email_regex_on_conflict: Email_Regex_On_Conflict;
  email_regex_order_by: Email_Regex_Order_By;
  email_regex_pk_columns_input: Email_Regex_Pk_Columns_Input;
  email_regex_set_input: Email_Regex_Set_Input;
  email_regex_stddev_fields: Email_Regex_Stddev_Fields;
  email_regex_stddev_pop_fields: Email_Regex_Stddev_Pop_Fields;
  email_regex_stddev_samp_fields: Email_Regex_Stddev_Samp_Fields;
  email_regex_stream_cursor_input: Email_Regex_Stream_Cursor_Input;
  email_regex_stream_cursor_value_input: Email_Regex_Stream_Cursor_Value_Input;
  email_regex_sum_fields: Email_Regex_Sum_Fields;
  email_regex_updates: Email_Regex_Updates;
  email_regex_var_pop_fields: Email_Regex_Var_Pop_Fields;
  email_regex_var_samp_fields: Email_Regex_Var_Samp_Fields;
  email_regex_variance_fields: Email_Regex_Variance_Fields;
  experience_skill: Experience_Skill;
  experience_skill_aggregate: Experience_Skill_Aggregate;
  experience_skill_aggregate_bool_exp: Experience_Skill_Aggregate_Bool_Exp;
  experience_skill_aggregate_bool_exp_count: Experience_Skill_Aggregate_Bool_Exp_Count;
  experience_skill_aggregate_fields: Experience_Skill_Aggregate_Fields;
  experience_skill_aggregate_order_by: Experience_Skill_Aggregate_Order_By;
  experience_skill_arr_rel_insert_input: Experience_Skill_Arr_Rel_Insert_Input;
  experience_skill_avg_fields: Experience_Skill_Avg_Fields;
  experience_skill_avg_order_by: Experience_Skill_Avg_Order_By;
  experience_skill_bool_exp: Experience_Skill_Bool_Exp;
  experience_skill_inc_input: Experience_Skill_Inc_Input;
  experience_skill_insert_input: Experience_Skill_Insert_Input;
  experience_skill_max_fields: Experience_Skill_Max_Fields;
  experience_skill_max_order_by: Experience_Skill_Max_Order_By;
  experience_skill_min_fields: Experience_Skill_Min_Fields;
  experience_skill_min_order_by: Experience_Skill_Min_Order_By;
  experience_skill_mutation_response: Experience_Skill_Mutation_Response;
  experience_skill_on_conflict: Experience_Skill_On_Conflict;
  experience_skill_order_by: Experience_Skill_Order_By;
  experience_skill_pk_columns_input: Experience_Skill_Pk_Columns_Input;
  experience_skill_set_input: Experience_Skill_Set_Input;
  experience_skill_stddev_fields: Experience_Skill_Stddev_Fields;
  experience_skill_stddev_order_by: Experience_Skill_Stddev_Order_By;
  experience_skill_stddev_pop_fields: Experience_Skill_Stddev_Pop_Fields;
  experience_skill_stddev_pop_order_by: Experience_Skill_Stddev_Pop_Order_By;
  experience_skill_stddev_samp_fields: Experience_Skill_Stddev_Samp_Fields;
  experience_skill_stddev_samp_order_by: Experience_Skill_Stddev_Samp_Order_By;
  experience_skill_stream_cursor_input: Experience_Skill_Stream_Cursor_Input;
  experience_skill_stream_cursor_value_input: Experience_Skill_Stream_Cursor_Value_Input;
  experience_skill_sum_fields: Experience_Skill_Sum_Fields;
  experience_skill_sum_order_by: Experience_Skill_Sum_Order_By;
  experience_skill_updates: Experience_Skill_Updates;
  experience_skill_var_pop_fields: Experience_Skill_Var_Pop_Fields;
  experience_skill_var_pop_order_by: Experience_Skill_Var_Pop_Order_By;
  experience_skill_var_samp_fields: Experience_Skill_Var_Samp_Fields;
  experience_skill_var_samp_order_by: Experience_Skill_Var_Samp_Order_By;
  experience_skill_variance_fields: Experience_Skill_Variance_Fields;
  experience_skill_variance_order_by: Experience_Skill_Variance_Order_By;
  float8: Scalars['float8'];
  float8_comparison_exp: Float8_Comparison_Exp;
  gender: Gender;
  gender_aggregate: Gender_Aggregate;
  gender_aggregate_fields: Gender_Aggregate_Fields;
  gender_bool_exp: Gender_Bool_Exp;
  gender_enum_comparison_exp: Gender_Enum_Comparison_Exp;
  gender_insert_input: Gender_Insert_Input;
  gender_max_fields: Gender_Max_Fields;
  gender_min_fields: Gender_Min_Fields;
  gender_mutation_response: Gender_Mutation_Response;
  gender_obj_rel_insert_input: Gender_Obj_Rel_Insert_Input;
  gender_on_conflict: Gender_On_Conflict;
  gender_order_by: Gender_Order_By;
  gender_pk_columns_input: Gender_Pk_Columns_Input;
  gender_set_input: Gender_Set_Input;
  gender_stream_cursor_input: Gender_Stream_Cursor_Input;
  gender_stream_cursor_value_input: Gender_Stream_Cursor_Value_Input;
  gender_updates: Gender_Updates;
  industry: Industry;
  industry_aggregate: Industry_Aggregate;
  industry_aggregate_fields: Industry_Aggregate_Fields;
  industry_avg_fields: Industry_Avg_Fields;
  industry_bool_exp: Industry_Bool_Exp;
  industry_inc_input: Industry_Inc_Input;
  industry_insert_input: Industry_Insert_Input;
  industry_max_fields: Industry_Max_Fields;
  industry_min_fields: Industry_Min_Fields;
  industry_mutation_response: Industry_Mutation_Response;
  industry_obj_rel_insert_input: Industry_Obj_Rel_Insert_Input;
  industry_on_conflict: Industry_On_Conflict;
  industry_order_by: Industry_Order_By;
  industry_pk_columns_input: Industry_Pk_Columns_Input;
  industry_set_input: Industry_Set_Input;
  industry_stddev_fields: Industry_Stddev_Fields;
  industry_stddev_pop_fields: Industry_Stddev_Pop_Fields;
  industry_stddev_samp_fields: Industry_Stddev_Samp_Fields;
  industry_stream_cursor_input: Industry_Stream_Cursor_Input;
  industry_stream_cursor_value_input: Industry_Stream_Cursor_Value_Input;
  industry_sum_fields: Industry_Sum_Fields;
  industry_updates: Industry_Updates;
  industry_var_pop_fields: Industry_Var_Pop_Fields;
  industry_var_samp_fields: Industry_Var_Samp_Fields;
  industry_variance_fields: Industry_Variance_Fields;
  invitation: Invitation;
  invitation_aggregate: Invitation_Aggregate;
  invitation_aggregate_bool_exp: Invitation_Aggregate_Bool_Exp;
  invitation_aggregate_bool_exp_bool_and: Invitation_Aggregate_Bool_Exp_Bool_And;
  invitation_aggregate_bool_exp_bool_or: Invitation_Aggregate_Bool_Exp_Bool_Or;
  invitation_aggregate_bool_exp_count: Invitation_Aggregate_Bool_Exp_Count;
  invitation_aggregate_fields: Invitation_Aggregate_Fields;
  invitation_aggregate_order_by: Invitation_Aggregate_Order_By;
  invitation_arr_rel_insert_input: Invitation_Arr_Rel_Insert_Input;
  invitation_bool_exp: Invitation_Bool_Exp;
  invitation_insert_input: Invitation_Insert_Input;
  invitation_max_fields: Invitation_Max_Fields;
  invitation_max_order_by: Invitation_Max_Order_By;
  invitation_min_fields: Invitation_Min_Fields;
  invitation_min_order_by: Invitation_Min_Order_By;
  invitation_mutation_response: Invitation_Mutation_Response;
  invitation_on_conflict: Invitation_On_Conflict;
  invitation_order_by: Invitation_Order_By;
  invitation_pk_columns_input: Invitation_Pk_Columns_Input;
  invitation_set_input: Invitation_Set_Input;
  invitation_stream_cursor_input: Invitation_Stream_Cursor_Input;
  invitation_stream_cursor_value_input: Invitation_Stream_Cursor_Value_Input;
  invitation_updates: Invitation_Updates;
  invoice: Invoice;
  invoice_aggregate: Invoice_Aggregate;
  invoice_aggregate_bool_exp: Invoice_Aggregate_Bool_Exp;
  invoice_aggregate_bool_exp_avg: Invoice_Aggregate_Bool_Exp_Avg;
  invoice_aggregate_bool_exp_bool_and: Invoice_Aggregate_Bool_Exp_Bool_And;
  invoice_aggregate_bool_exp_bool_or: Invoice_Aggregate_Bool_Exp_Bool_Or;
  invoice_aggregate_bool_exp_corr: Invoice_Aggregate_Bool_Exp_Corr;
  invoice_aggregate_bool_exp_corr_arguments: Invoice_Aggregate_Bool_Exp_Corr_Arguments;
  invoice_aggregate_bool_exp_count: Invoice_Aggregate_Bool_Exp_Count;
  invoice_aggregate_bool_exp_covar_samp: Invoice_Aggregate_Bool_Exp_Covar_Samp;
  invoice_aggregate_bool_exp_covar_samp_arguments: Invoice_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  invoice_aggregate_bool_exp_max: Invoice_Aggregate_Bool_Exp_Max;
  invoice_aggregate_bool_exp_min: Invoice_Aggregate_Bool_Exp_Min;
  invoice_aggregate_bool_exp_stddev_samp: Invoice_Aggregate_Bool_Exp_Stddev_Samp;
  invoice_aggregate_bool_exp_sum: Invoice_Aggregate_Bool_Exp_Sum;
  invoice_aggregate_bool_exp_var_samp: Invoice_Aggregate_Bool_Exp_Var_Samp;
  invoice_aggregate_fields: Invoice_Aggregate_Fields;
  invoice_aggregate_order_by: Invoice_Aggregate_Order_By;
  invoice_append_input: Invoice_Append_Input;
  invoice_arr_rel_insert_input: Invoice_Arr_Rel_Insert_Input;
  invoice_avg_fields: Invoice_Avg_Fields;
  invoice_avg_order_by: Invoice_Avg_Order_By;
  invoice_bool_exp: Invoice_Bool_Exp;
  invoice_delete_at_path_input: Invoice_Delete_At_Path_Input;
  invoice_delete_elem_input: Invoice_Delete_Elem_Input;
  invoice_delete_key_input: Invoice_Delete_Key_Input;
  invoice_inc_input: Invoice_Inc_Input;
  invoice_insert_input: Invoice_Insert_Input;
  invoice_max_fields: Invoice_Max_Fields;
  invoice_max_order_by: Invoice_Max_Order_By;
  invoice_min_fields: Invoice_Min_Fields;
  invoice_min_order_by: Invoice_Min_Order_By;
  invoice_mutation_response: Invoice_Mutation_Response;
  invoice_on_conflict: Invoice_On_Conflict;
  invoice_order_by: Invoice_Order_By;
  invoice_pk_columns_input: Invoice_Pk_Columns_Input;
  invoice_prepend_input: Invoice_Prepend_Input;
  invoice_set_input: Invoice_Set_Input;
  invoice_stddev_fields: Invoice_Stddev_Fields;
  invoice_stddev_order_by: Invoice_Stddev_Order_By;
  invoice_stddev_pop_fields: Invoice_Stddev_Pop_Fields;
  invoice_stddev_pop_order_by: Invoice_Stddev_Pop_Order_By;
  invoice_stddev_samp_fields: Invoice_Stddev_Samp_Fields;
  invoice_stddev_samp_order_by: Invoice_Stddev_Samp_Order_By;
  invoice_stream_cursor_input: Invoice_Stream_Cursor_Input;
  invoice_stream_cursor_value_input: Invoice_Stream_Cursor_Value_Input;
  invoice_sum_fields: Invoice_Sum_Fields;
  invoice_sum_order_by: Invoice_Sum_Order_By;
  invoice_updates: Invoice_Updates;
  invoice_var_pop_fields: Invoice_Var_Pop_Fields;
  invoice_var_pop_order_by: Invoice_Var_Pop_Order_By;
  invoice_var_samp_fields: Invoice_Var_Samp_Fields;
  invoice_var_samp_order_by: Invoice_Var_Samp_Order_By;
  invoice_variance_fields: Invoice_Variance_Fields;
  invoice_variance_order_by: Invoice_Variance_Order_By;
  jsonb: Scalars['jsonb'];
  jsonb_cast_exp: Jsonb_Cast_Exp;
  jsonb_comparison_exp: Jsonb_Comparison_Exp;
  language: Language;
  language_aggregate: Language_Aggregate;
  language_aggregate_fields: Language_Aggregate_Fields;
  language_avg_fields: Language_Avg_Fields;
  language_bool_exp: Language_Bool_Exp;
  language_inc_input: Language_Inc_Input;
  language_insert_input: Language_Insert_Input;
  language_max_fields: Language_Max_Fields;
  language_min_fields: Language_Min_Fields;
  language_mutation_response: Language_Mutation_Response;
  language_obj_rel_insert_input: Language_Obj_Rel_Insert_Input;
  language_on_conflict: Language_On_Conflict;
  language_order_by: Language_Order_By;
  language_pk_columns_input: Language_Pk_Columns_Input;
  language_set_input: Language_Set_Input;
  language_stddev_fields: Language_Stddev_Fields;
  language_stddev_pop_fields: Language_Stddev_Pop_Fields;
  language_stddev_samp_fields: Language_Stddev_Samp_Fields;
  language_stream_cursor_input: Language_Stream_Cursor_Input;
  language_stream_cursor_value_input: Language_Stream_Cursor_Value_Input;
  language_sum_fields: Language_Sum_Fields;
  language_updates: Language_Updates;
  language_var_pop_fields: Language_Var_Pop_Fields;
  language_var_samp_fields: Language_Var_Samp_Fields;
  language_variance_fields: Language_Variance_Fields;
  manager: Manager;
  manager_aggregate: Manager_Aggregate;
  manager_aggregate_bool_exp: Manager_Aggregate_Bool_Exp;
  manager_aggregate_bool_exp_bool_and: Manager_Aggregate_Bool_Exp_Bool_And;
  manager_aggregate_bool_exp_bool_or: Manager_Aggregate_Bool_Exp_Bool_Or;
  manager_aggregate_bool_exp_count: Manager_Aggregate_Bool_Exp_Count;
  manager_aggregate_fields: Manager_Aggregate_Fields;
  manager_aggregate_order_by: Manager_Aggregate_Order_By;
  manager_arr_rel_insert_input: Manager_Arr_Rel_Insert_Input;
  manager_bool_exp: Manager_Bool_Exp;
  manager_contractor: Manager_Contractor;
  manager_contractor_aggregate: Manager_Contractor_Aggregate;
  manager_contractor_aggregate_bool_exp: Manager_Contractor_Aggregate_Bool_Exp;
  manager_contractor_aggregate_bool_exp_bool_and: Manager_Contractor_Aggregate_Bool_Exp_Bool_And;
  manager_contractor_aggregate_bool_exp_bool_or: Manager_Contractor_Aggregate_Bool_Exp_Bool_Or;
  manager_contractor_aggregate_bool_exp_count: Manager_Contractor_Aggregate_Bool_Exp_Count;
  manager_contractor_aggregate_fields: Manager_Contractor_Aggregate_Fields;
  manager_contractor_aggregate_order_by: Manager_Contractor_Aggregate_Order_By;
  manager_contractor_arr_rel_insert_input: Manager_Contractor_Arr_Rel_Insert_Input;
  manager_contractor_bool_exp: Manager_Contractor_Bool_Exp;
  manager_contractor_insert_input: Manager_Contractor_Insert_Input;
  manager_contractor_max_fields: Manager_Contractor_Max_Fields;
  manager_contractor_max_order_by: Manager_Contractor_Max_Order_By;
  manager_contractor_min_fields: Manager_Contractor_Min_Fields;
  manager_contractor_min_order_by: Manager_Contractor_Min_Order_By;
  manager_contractor_mutation_response: Manager_Contractor_Mutation_Response;
  manager_contractor_on_conflict: Manager_Contractor_On_Conflict;
  manager_contractor_order_by: Manager_Contractor_Order_By;
  manager_contractor_pk_columns_input: Manager_Contractor_Pk_Columns_Input;
  manager_contractor_set_input: Manager_Contractor_Set_Input;
  manager_contractor_stream_cursor_input: Manager_Contractor_Stream_Cursor_Input;
  manager_contractor_stream_cursor_value_input: Manager_Contractor_Stream_Cursor_Value_Input;
  manager_contractor_updates: Manager_Contractor_Updates;
  manager_insert_input: Manager_Insert_Input;
  manager_max_fields: Manager_Max_Fields;
  manager_max_order_by: Manager_Max_Order_By;
  manager_min_fields: Manager_Min_Fields;
  manager_min_order_by: Manager_Min_Order_By;
  manager_mutation_response: Manager_Mutation_Response;
  manager_obj_rel_insert_input: Manager_Obj_Rel_Insert_Input;
  manager_on_conflict: Manager_On_Conflict;
  manager_order_by: Manager_Order_By;
  manager_pk_columns_input: Manager_Pk_Columns_Input;
  manager_set_input: Manager_Set_Input;
  manager_stream_cursor_input: Manager_Stream_Cursor_Input;
  manager_stream_cursor_value_input: Manager_Stream_Cursor_Value_Input;
  manager_updates: Manager_Updates;
  message: Message;
  message_aggregate: Message_Aggregate;
  message_aggregate_bool_exp: Message_Aggregate_Bool_Exp;
  message_aggregate_bool_exp_bool_and: Message_Aggregate_Bool_Exp_Bool_And;
  message_aggregate_bool_exp_bool_or: Message_Aggregate_Bool_Exp_Bool_Or;
  message_aggregate_bool_exp_count: Message_Aggregate_Bool_Exp_Count;
  message_aggregate_fields: Message_Aggregate_Fields;
  message_aggregate_order_by: Message_Aggregate_Order_By;
  message_arr_rel_insert_input: Message_Arr_Rel_Insert_Input;
  message_bool_exp: Message_Bool_Exp;
  message_insert_input: Message_Insert_Input;
  message_max_fields: Message_Max_Fields;
  message_max_order_by: Message_Max_Order_By;
  message_min_fields: Message_Min_Fields;
  message_min_order_by: Message_Min_Order_By;
  message_mutation_response: Message_Mutation_Response;
  message_obj_rel_insert_input: Message_Obj_Rel_Insert_Input;
  message_on_conflict: Message_On_Conflict;
  message_order_by: Message_Order_By;
  message_pk_columns_input: Message_Pk_Columns_Input;
  message_set_input: Message_Set_Input;
  message_stream_cursor_input: Message_Stream_Cursor_Input;
  message_stream_cursor_value_input: Message_Stream_Cursor_Value_Input;
  message_updates: Message_Updates;
  mutation_root: {};
  notification: Notification;
  notification_aggregate: Notification_Aggregate;
  notification_aggregate_fields: Notification_Aggregate_Fields;
  notification_bool_exp: Notification_Bool_Exp;
  notification_insert_input: Notification_Insert_Input;
  notification_max_fields: Notification_Max_Fields;
  notification_min_fields: Notification_Min_Fields;
  notification_mutation_response: Notification_Mutation_Response;
  notification_on_conflict: Notification_On_Conflict;
  notification_order_by: Notification_Order_By;
  notification_pk_columns_input: Notification_Pk_Columns_Input;
  notification_set_input: Notification_Set_Input;
  notification_stream_cursor_input: Notification_Stream_Cursor_Input;
  notification_stream_cursor_value_input: Notification_Stream_Cursor_Value_Input;
  notification_updates: Notification_Updates;
  numeric: Scalars['numeric'];
  numeric_comparison_exp: Numeric_Comparison_Exp;
  onboarding: Onboarding;
  onboarding_aggregate: Onboarding_Aggregate;
  onboarding_aggregate_bool_exp: Onboarding_Aggregate_Bool_Exp;
  onboarding_aggregate_bool_exp_count: Onboarding_Aggregate_Bool_Exp_Count;
  onboarding_aggregate_fields: Onboarding_Aggregate_Fields;
  onboarding_aggregate_order_by: Onboarding_Aggregate_Order_By;
  onboarding_arr_rel_insert_input: Onboarding_Arr_Rel_Insert_Input;
  onboarding_bool_exp: Onboarding_Bool_Exp;
  onboarding_insert_input: Onboarding_Insert_Input;
  onboarding_max_fields: Onboarding_Max_Fields;
  onboarding_max_order_by: Onboarding_Max_Order_By;
  onboarding_min_fields: Onboarding_Min_Fields;
  onboarding_min_order_by: Onboarding_Min_Order_By;
  onboarding_mutation_response: Onboarding_Mutation_Response;
  onboarding_on_conflict: Onboarding_On_Conflict;
  onboarding_order_by: Onboarding_Order_By;
  onboarding_pk_columns_input: Onboarding_Pk_Columns_Input;
  onboarding_set_input: Onboarding_Set_Input;
  onboarding_stream_cursor_input: Onboarding_Stream_Cursor_Input;
  onboarding_stream_cursor_value_input: Onboarding_Stream_Cursor_Value_Input;
  onboarding_updates: Onboarding_Updates;
  payment_card: Payment_Card;
  payment_card_aggregate: Payment_Card_Aggregate;
  payment_card_aggregate_bool_exp: Payment_Card_Aggregate_Bool_Exp;
  payment_card_aggregate_bool_exp_count: Payment_Card_Aggregate_Bool_Exp_Count;
  payment_card_aggregate_fields: Payment_Card_Aggregate_Fields;
  payment_card_aggregate_order_by: Payment_Card_Aggregate_Order_By;
  payment_card_arr_rel_insert_input: Payment_Card_Arr_Rel_Insert_Input;
  payment_card_bool_exp: Payment_Card_Bool_Exp;
  payment_card_insert_input: Payment_Card_Insert_Input;
  payment_card_max_fields: Payment_Card_Max_Fields;
  payment_card_max_order_by: Payment_Card_Max_Order_By;
  payment_card_min_fields: Payment_Card_Min_Fields;
  payment_card_min_order_by: Payment_Card_Min_Order_By;
  payment_card_mutation_response: Payment_Card_Mutation_Response;
  payment_card_obj_rel_insert_input: Payment_Card_Obj_Rel_Insert_Input;
  payment_card_on_conflict: Payment_Card_On_Conflict;
  payment_card_order_by: Payment_Card_Order_By;
  payment_card_pk_columns_input: Payment_Card_Pk_Columns_Input;
  payment_card_set_input: Payment_Card_Set_Input;
  payment_card_stream_cursor_input: Payment_Card_Stream_Cursor_Input;
  payment_card_stream_cursor_value_input: Payment_Card_Stream_Cursor_Value_Input;
  payment_card_updates: Payment_Card_Updates;
  posting: Posting;
  posting_aggregate: Posting_Aggregate;
  posting_aggregate_bool_exp: Posting_Aggregate_Bool_Exp;
  posting_aggregate_bool_exp_bool_and: Posting_Aggregate_Bool_Exp_Bool_And;
  posting_aggregate_bool_exp_bool_or: Posting_Aggregate_Bool_Exp_Bool_Or;
  posting_aggregate_bool_exp_count: Posting_Aggregate_Bool_Exp_Count;
  posting_aggregate_fields: Posting_Aggregate_Fields;
  posting_aggregate_order_by: Posting_Aggregate_Order_By;
  posting_arr_rel_insert_input: Posting_Arr_Rel_Insert_Input;
  posting_avg_fields: Posting_Avg_Fields;
  posting_avg_order_by: Posting_Avg_Order_By;
  posting_bool_exp: Posting_Bool_Exp;
  posting_inc_input: Posting_Inc_Input;
  posting_industry: Posting_Industry;
  posting_industry_aggregate: Posting_Industry_Aggregate;
  posting_industry_aggregate_bool_exp: Posting_Industry_Aggregate_Bool_Exp;
  posting_industry_aggregate_bool_exp_count: Posting_Industry_Aggregate_Bool_Exp_Count;
  posting_industry_aggregate_fields: Posting_Industry_Aggregate_Fields;
  posting_industry_aggregate_order_by: Posting_Industry_Aggregate_Order_By;
  posting_industry_arr_rel_insert_input: Posting_Industry_Arr_Rel_Insert_Input;
  posting_industry_avg_fields: Posting_Industry_Avg_Fields;
  posting_industry_avg_order_by: Posting_Industry_Avg_Order_By;
  posting_industry_bool_exp: Posting_Industry_Bool_Exp;
  posting_industry_inc_input: Posting_Industry_Inc_Input;
  posting_industry_insert_input: Posting_Industry_Insert_Input;
  posting_industry_max_fields: Posting_Industry_Max_Fields;
  posting_industry_max_order_by: Posting_Industry_Max_Order_By;
  posting_industry_min_fields: Posting_Industry_Min_Fields;
  posting_industry_min_order_by: Posting_Industry_Min_Order_By;
  posting_industry_mutation_response: Posting_Industry_Mutation_Response;
  posting_industry_on_conflict: Posting_Industry_On_Conflict;
  posting_industry_order_by: Posting_Industry_Order_By;
  posting_industry_pk_columns_input: Posting_Industry_Pk_Columns_Input;
  posting_industry_set_input: Posting_Industry_Set_Input;
  posting_industry_stddev_fields: Posting_Industry_Stddev_Fields;
  posting_industry_stddev_order_by: Posting_Industry_Stddev_Order_By;
  posting_industry_stddev_pop_fields: Posting_Industry_Stddev_Pop_Fields;
  posting_industry_stddev_pop_order_by: Posting_Industry_Stddev_Pop_Order_By;
  posting_industry_stddev_samp_fields: Posting_Industry_Stddev_Samp_Fields;
  posting_industry_stddev_samp_order_by: Posting_Industry_Stddev_Samp_Order_By;
  posting_industry_stream_cursor_input: Posting_Industry_Stream_Cursor_Input;
  posting_industry_stream_cursor_value_input: Posting_Industry_Stream_Cursor_Value_Input;
  posting_industry_sum_fields: Posting_Industry_Sum_Fields;
  posting_industry_sum_order_by: Posting_Industry_Sum_Order_By;
  posting_industry_updates: Posting_Industry_Updates;
  posting_industry_var_pop_fields: Posting_Industry_Var_Pop_Fields;
  posting_industry_var_pop_order_by: Posting_Industry_Var_Pop_Order_By;
  posting_industry_var_samp_fields: Posting_Industry_Var_Samp_Fields;
  posting_industry_var_samp_order_by: Posting_Industry_Var_Samp_Order_By;
  posting_industry_variance_fields: Posting_Industry_Variance_Fields;
  posting_industry_variance_order_by: Posting_Industry_Variance_Order_By;
  posting_insert_input: Posting_Insert_Input;
  posting_max_fields: Posting_Max_Fields;
  posting_max_order_by: Posting_Max_Order_By;
  posting_min_fields: Posting_Min_Fields;
  posting_min_order_by: Posting_Min_Order_By;
  posting_mutation_response: Posting_Mutation_Response;
  posting_obj_rel_insert_input: Posting_Obj_Rel_Insert_Input;
  posting_on_conflict: Posting_On_Conflict;
  posting_order_by: Posting_Order_By;
  posting_pk_columns_input: Posting_Pk_Columns_Input;
  posting_set_input: Posting_Set_Input;
  posting_skill: Posting_Skill;
  posting_skill_aggregate: Posting_Skill_Aggregate;
  posting_skill_aggregate_bool_exp: Posting_Skill_Aggregate_Bool_Exp;
  posting_skill_aggregate_bool_exp_count: Posting_Skill_Aggregate_Bool_Exp_Count;
  posting_skill_aggregate_fields: Posting_Skill_Aggregate_Fields;
  posting_skill_aggregate_order_by: Posting_Skill_Aggregate_Order_By;
  posting_skill_arr_rel_insert_input: Posting_Skill_Arr_Rel_Insert_Input;
  posting_skill_avg_fields: Posting_Skill_Avg_Fields;
  posting_skill_avg_order_by: Posting_Skill_Avg_Order_By;
  posting_skill_bool_exp: Posting_Skill_Bool_Exp;
  posting_skill_inc_input: Posting_Skill_Inc_Input;
  posting_skill_insert_input: Posting_Skill_Insert_Input;
  posting_skill_max_fields: Posting_Skill_Max_Fields;
  posting_skill_max_order_by: Posting_Skill_Max_Order_By;
  posting_skill_min_fields: Posting_Skill_Min_Fields;
  posting_skill_min_order_by: Posting_Skill_Min_Order_By;
  posting_skill_mutation_response: Posting_Skill_Mutation_Response;
  posting_skill_on_conflict: Posting_Skill_On_Conflict;
  posting_skill_order_by: Posting_Skill_Order_By;
  posting_skill_pk_columns_input: Posting_Skill_Pk_Columns_Input;
  posting_skill_set_input: Posting_Skill_Set_Input;
  posting_skill_stddev_fields: Posting_Skill_Stddev_Fields;
  posting_skill_stddev_order_by: Posting_Skill_Stddev_Order_By;
  posting_skill_stddev_pop_fields: Posting_Skill_Stddev_Pop_Fields;
  posting_skill_stddev_pop_order_by: Posting_Skill_Stddev_Pop_Order_By;
  posting_skill_stddev_samp_fields: Posting_Skill_Stddev_Samp_Fields;
  posting_skill_stddev_samp_order_by: Posting_Skill_Stddev_Samp_Order_By;
  posting_skill_stream_cursor_input: Posting_Skill_Stream_Cursor_Input;
  posting_skill_stream_cursor_value_input: Posting_Skill_Stream_Cursor_Value_Input;
  posting_skill_sum_fields: Posting_Skill_Sum_Fields;
  posting_skill_sum_order_by: Posting_Skill_Sum_Order_By;
  posting_skill_updates: Posting_Skill_Updates;
  posting_skill_var_pop_fields: Posting_Skill_Var_Pop_Fields;
  posting_skill_var_pop_order_by: Posting_Skill_Var_Pop_Order_By;
  posting_skill_var_samp_fields: Posting_Skill_Var_Samp_Fields;
  posting_skill_var_samp_order_by: Posting_Skill_Var_Samp_Order_By;
  posting_skill_variance_fields: Posting_Skill_Variance_Fields;
  posting_skill_variance_order_by: Posting_Skill_Variance_Order_By;
  posting_stddev_fields: Posting_Stddev_Fields;
  posting_stddev_order_by: Posting_Stddev_Order_By;
  posting_stddev_pop_fields: Posting_Stddev_Pop_Fields;
  posting_stddev_pop_order_by: Posting_Stddev_Pop_Order_By;
  posting_stddev_samp_fields: Posting_Stddev_Samp_Fields;
  posting_stddev_samp_order_by: Posting_Stddev_Samp_Order_By;
  posting_stream_cursor_input: Posting_Stream_Cursor_Input;
  posting_stream_cursor_value_input: Posting_Stream_Cursor_Value_Input;
  posting_sum_fields: Posting_Sum_Fields;
  posting_sum_order_by: Posting_Sum_Order_By;
  posting_tags: Posting_Tags;
  posting_tags_aggregate: Posting_Tags_Aggregate;
  posting_tags_aggregate_bool_exp: Posting_Tags_Aggregate_Bool_Exp;
  posting_tags_aggregate_bool_exp_count: Posting_Tags_Aggregate_Bool_Exp_Count;
  posting_tags_aggregate_fields: Posting_Tags_Aggregate_Fields;
  posting_tags_aggregate_order_by: Posting_Tags_Aggregate_Order_By;
  posting_tags_arr_rel_insert_input: Posting_Tags_Arr_Rel_Insert_Input;
  posting_tags_bool_exp: Posting_Tags_Bool_Exp;
  posting_tags_insert_input: Posting_Tags_Insert_Input;
  posting_tags_max_fields: Posting_Tags_Max_Fields;
  posting_tags_max_order_by: Posting_Tags_Max_Order_By;
  posting_tags_min_fields: Posting_Tags_Min_Fields;
  posting_tags_min_order_by: Posting_Tags_Min_Order_By;
  posting_tags_mutation_response: Posting_Tags_Mutation_Response;
  posting_tags_on_conflict: Posting_Tags_On_Conflict;
  posting_tags_order_by: Posting_Tags_Order_By;
  posting_tags_pk_columns_input: Posting_Tags_Pk_Columns_Input;
  posting_tags_set_input: Posting_Tags_Set_Input;
  posting_tags_stream_cursor_input: Posting_Tags_Stream_Cursor_Input;
  posting_tags_stream_cursor_value_input: Posting_Tags_Stream_Cursor_Value_Input;
  posting_tags_updates: Posting_Tags_Updates;
  posting_updates: Posting_Updates;
  posting_var_pop_fields: Posting_Var_Pop_Fields;
  posting_var_pop_order_by: Posting_Var_Pop_Order_By;
  posting_var_samp_fields: Posting_Var_Samp_Fields;
  posting_var_samp_order_by: Posting_Var_Samp_Order_By;
  posting_variance_fields: Posting_Variance_Fields;
  posting_variance_order_by: Posting_Variance_Order_By;
  project: Project;
  project_activity: Project_Activity;
  project_activity_aggregate: Project_Activity_Aggregate;
  project_activity_aggregate_bool_exp: Project_Activity_Aggregate_Bool_Exp;
  project_activity_aggregate_bool_exp_bool_and: Project_Activity_Aggregate_Bool_Exp_Bool_And;
  project_activity_aggregate_bool_exp_bool_or: Project_Activity_Aggregate_Bool_Exp_Bool_Or;
  project_activity_aggregate_bool_exp_count: Project_Activity_Aggregate_Bool_Exp_Count;
  project_activity_aggregate_fields: Project_Activity_Aggregate_Fields;
  project_activity_aggregate_order_by: Project_Activity_Aggregate_Order_By;
  project_activity_arr_rel_insert_input: Project_Activity_Arr_Rel_Insert_Input;
  project_activity_avg_fields: Project_Activity_Avg_Fields;
  project_activity_avg_order_by: Project_Activity_Avg_Order_By;
  project_activity_bool_exp: Project_Activity_Bool_Exp;
  project_activity_inc_input: Project_Activity_Inc_Input;
  project_activity_insert_input: Project_Activity_Insert_Input;
  project_activity_max_fields: Project_Activity_Max_Fields;
  project_activity_max_order_by: Project_Activity_Max_Order_By;
  project_activity_min_fields: Project_Activity_Min_Fields;
  project_activity_min_order_by: Project_Activity_Min_Order_By;
  project_activity_mutation_response: Project_Activity_Mutation_Response;
  project_activity_note: Project_Activity_Note;
  project_activity_note_aggregate: Project_Activity_Note_Aggregate;
  project_activity_note_aggregate_bool_exp: Project_Activity_Note_Aggregate_Bool_Exp;
  project_activity_note_aggregate_bool_exp_count: Project_Activity_Note_Aggregate_Bool_Exp_Count;
  project_activity_note_aggregate_fields: Project_Activity_Note_Aggregate_Fields;
  project_activity_note_aggregate_order_by: Project_Activity_Note_Aggregate_Order_By;
  project_activity_note_arr_rel_insert_input: Project_Activity_Note_Arr_Rel_Insert_Input;
  project_activity_note_bool_exp: Project_Activity_Note_Bool_Exp;
  project_activity_note_insert_input: Project_Activity_Note_Insert_Input;
  project_activity_note_max_fields: Project_Activity_Note_Max_Fields;
  project_activity_note_max_order_by: Project_Activity_Note_Max_Order_By;
  project_activity_note_min_fields: Project_Activity_Note_Min_Fields;
  project_activity_note_min_order_by: Project_Activity_Note_Min_Order_By;
  project_activity_note_mutation_response: Project_Activity_Note_Mutation_Response;
  project_activity_note_on_conflict: Project_Activity_Note_On_Conflict;
  project_activity_note_order_by: Project_Activity_Note_Order_By;
  project_activity_note_pk_columns_input: Project_Activity_Note_Pk_Columns_Input;
  project_activity_note_set_input: Project_Activity_Note_Set_Input;
  project_activity_note_stream_cursor_input: Project_Activity_Note_Stream_Cursor_Input;
  project_activity_note_stream_cursor_value_input: Project_Activity_Note_Stream_Cursor_Value_Input;
  project_activity_note_updates: Project_Activity_Note_Updates;
  project_activity_obj_rel_insert_input: Project_Activity_Obj_Rel_Insert_Input;
  project_activity_on_conflict: Project_Activity_On_Conflict;
  project_activity_order_by: Project_Activity_Order_By;
  project_activity_pk_columns_input: Project_Activity_Pk_Columns_Input;
  project_activity_request_more_hours: Project_Activity_Request_More_Hours;
  project_activity_request_more_hours_aggregate: Project_Activity_Request_More_Hours_Aggregate;
  project_activity_request_more_hours_aggregate_bool_exp: Project_Activity_Request_More_Hours_Aggregate_Bool_Exp;
  project_activity_request_more_hours_aggregate_bool_exp_count: Project_Activity_Request_More_Hours_Aggregate_Bool_Exp_Count;
  project_activity_request_more_hours_aggregate_fields: Project_Activity_Request_More_Hours_Aggregate_Fields;
  project_activity_request_more_hours_aggregate_order_by: Project_Activity_Request_More_Hours_Aggregate_Order_By;
  project_activity_request_more_hours_arr_rel_insert_input: Project_Activity_Request_More_Hours_Arr_Rel_Insert_Input;
  project_activity_request_more_hours_avg_fields: Project_Activity_Request_More_Hours_Avg_Fields;
  project_activity_request_more_hours_avg_order_by: Project_Activity_Request_More_Hours_Avg_Order_By;
  project_activity_request_more_hours_bool_exp: Project_Activity_Request_More_Hours_Bool_Exp;
  project_activity_request_more_hours_inc_input: Project_Activity_Request_More_Hours_Inc_Input;
  project_activity_request_more_hours_insert_input: Project_Activity_Request_More_Hours_Insert_Input;
  project_activity_request_more_hours_max_fields: Project_Activity_Request_More_Hours_Max_Fields;
  project_activity_request_more_hours_max_order_by: Project_Activity_Request_More_Hours_Max_Order_By;
  project_activity_request_more_hours_min_fields: Project_Activity_Request_More_Hours_Min_Fields;
  project_activity_request_more_hours_min_order_by: Project_Activity_Request_More_Hours_Min_Order_By;
  project_activity_request_more_hours_mutation_response: Project_Activity_Request_More_Hours_Mutation_Response;
  project_activity_request_more_hours_on_conflict: Project_Activity_Request_More_Hours_On_Conflict;
  project_activity_request_more_hours_order_by: Project_Activity_Request_More_Hours_Order_By;
  project_activity_request_more_hours_pk_columns_input: Project_Activity_Request_More_Hours_Pk_Columns_Input;
  project_activity_request_more_hours_set_input: Project_Activity_Request_More_Hours_Set_Input;
  project_activity_request_more_hours_stddev_fields: Project_Activity_Request_More_Hours_Stddev_Fields;
  project_activity_request_more_hours_stddev_order_by: Project_Activity_Request_More_Hours_Stddev_Order_By;
  project_activity_request_more_hours_stddev_pop_fields: Project_Activity_Request_More_Hours_Stddev_Pop_Fields;
  project_activity_request_more_hours_stddev_pop_order_by: Project_Activity_Request_More_Hours_Stddev_Pop_Order_By;
  project_activity_request_more_hours_stddev_samp_fields: Project_Activity_Request_More_Hours_Stddev_Samp_Fields;
  project_activity_request_more_hours_stddev_samp_order_by: Project_Activity_Request_More_Hours_Stddev_Samp_Order_By;
  project_activity_request_more_hours_stream_cursor_input: Project_Activity_Request_More_Hours_Stream_Cursor_Input;
  project_activity_request_more_hours_stream_cursor_value_input: Project_Activity_Request_More_Hours_Stream_Cursor_Value_Input;
  project_activity_request_more_hours_sum_fields: Project_Activity_Request_More_Hours_Sum_Fields;
  project_activity_request_more_hours_sum_order_by: Project_Activity_Request_More_Hours_Sum_Order_By;
  project_activity_request_more_hours_updates: Project_Activity_Request_More_Hours_Updates;
  project_activity_request_more_hours_var_pop_fields: Project_Activity_Request_More_Hours_Var_Pop_Fields;
  project_activity_request_more_hours_var_pop_order_by: Project_Activity_Request_More_Hours_Var_Pop_Order_By;
  project_activity_request_more_hours_var_samp_fields: Project_Activity_Request_More_Hours_Var_Samp_Fields;
  project_activity_request_more_hours_var_samp_order_by: Project_Activity_Request_More_Hours_Var_Samp_Order_By;
  project_activity_request_more_hours_variance_fields: Project_Activity_Request_More_Hours_Variance_Fields;
  project_activity_request_more_hours_variance_order_by: Project_Activity_Request_More_Hours_Variance_Order_By;
  project_activity_set_input: Project_Activity_Set_Input;
  project_activity_skill: Project_Activity_Skill;
  project_activity_skill_aggregate: Project_Activity_Skill_Aggregate;
  project_activity_skill_aggregate_bool_exp: Project_Activity_Skill_Aggregate_Bool_Exp;
  project_activity_skill_aggregate_bool_exp_count: Project_Activity_Skill_Aggregate_Bool_Exp_Count;
  project_activity_skill_aggregate_fields: Project_Activity_Skill_Aggregate_Fields;
  project_activity_skill_aggregate_order_by: Project_Activity_Skill_Aggregate_Order_By;
  project_activity_skill_arr_rel_insert_input: Project_Activity_Skill_Arr_Rel_Insert_Input;
  project_activity_skill_avg_fields: Project_Activity_Skill_Avg_Fields;
  project_activity_skill_avg_order_by: Project_Activity_Skill_Avg_Order_By;
  project_activity_skill_bool_exp: Project_Activity_Skill_Bool_Exp;
  project_activity_skill_inc_input: Project_Activity_Skill_Inc_Input;
  project_activity_skill_insert_input: Project_Activity_Skill_Insert_Input;
  project_activity_skill_max_fields: Project_Activity_Skill_Max_Fields;
  project_activity_skill_max_order_by: Project_Activity_Skill_Max_Order_By;
  project_activity_skill_min_fields: Project_Activity_Skill_Min_Fields;
  project_activity_skill_min_order_by: Project_Activity_Skill_Min_Order_By;
  project_activity_skill_mutation_response: Project_Activity_Skill_Mutation_Response;
  project_activity_skill_on_conflict: Project_Activity_Skill_On_Conflict;
  project_activity_skill_order_by: Project_Activity_Skill_Order_By;
  project_activity_skill_pk_columns_input: Project_Activity_Skill_Pk_Columns_Input;
  project_activity_skill_set_input: Project_Activity_Skill_Set_Input;
  project_activity_skill_stddev_fields: Project_Activity_Skill_Stddev_Fields;
  project_activity_skill_stddev_order_by: Project_Activity_Skill_Stddev_Order_By;
  project_activity_skill_stddev_pop_fields: Project_Activity_Skill_Stddev_Pop_Fields;
  project_activity_skill_stddev_pop_order_by: Project_Activity_Skill_Stddev_Pop_Order_By;
  project_activity_skill_stddev_samp_fields: Project_Activity_Skill_Stddev_Samp_Fields;
  project_activity_skill_stddev_samp_order_by: Project_Activity_Skill_Stddev_Samp_Order_By;
  project_activity_skill_stream_cursor_input: Project_Activity_Skill_Stream_Cursor_Input;
  project_activity_skill_stream_cursor_value_input: Project_Activity_Skill_Stream_Cursor_Value_Input;
  project_activity_skill_sum_fields: Project_Activity_Skill_Sum_Fields;
  project_activity_skill_sum_order_by: Project_Activity_Skill_Sum_Order_By;
  project_activity_skill_updates: Project_Activity_Skill_Updates;
  project_activity_skill_var_pop_fields: Project_Activity_Skill_Var_Pop_Fields;
  project_activity_skill_var_pop_order_by: Project_Activity_Skill_Var_Pop_Order_By;
  project_activity_skill_var_samp_fields: Project_Activity_Skill_Var_Samp_Fields;
  project_activity_skill_var_samp_order_by: Project_Activity_Skill_Var_Samp_Order_By;
  project_activity_skill_variance_fields: Project_Activity_Skill_Variance_Fields;
  project_activity_skill_variance_order_by: Project_Activity_Skill_Variance_Order_By;
  project_activity_soft_skill: Project_Activity_Soft_Skill;
  project_activity_soft_skill_aggregate: Project_Activity_Soft_Skill_Aggregate;
  project_activity_soft_skill_aggregate_bool_exp: Project_Activity_Soft_Skill_Aggregate_Bool_Exp;
  project_activity_soft_skill_aggregate_bool_exp_count: Project_Activity_Soft_Skill_Aggregate_Bool_Exp_Count;
  project_activity_soft_skill_aggregate_fields: Project_Activity_Soft_Skill_Aggregate_Fields;
  project_activity_soft_skill_aggregate_order_by: Project_Activity_Soft_Skill_Aggregate_Order_By;
  project_activity_soft_skill_arr_rel_insert_input: Project_Activity_Soft_Skill_Arr_Rel_Insert_Input;
  project_activity_soft_skill_avg_fields: Project_Activity_Soft_Skill_Avg_Fields;
  project_activity_soft_skill_avg_order_by: Project_Activity_Soft_Skill_Avg_Order_By;
  project_activity_soft_skill_bool_exp: Project_Activity_Soft_Skill_Bool_Exp;
  project_activity_soft_skill_inc_input: Project_Activity_Soft_Skill_Inc_Input;
  project_activity_soft_skill_insert_input: Project_Activity_Soft_Skill_Insert_Input;
  project_activity_soft_skill_max_fields: Project_Activity_Soft_Skill_Max_Fields;
  project_activity_soft_skill_max_order_by: Project_Activity_Soft_Skill_Max_Order_By;
  project_activity_soft_skill_min_fields: Project_Activity_Soft_Skill_Min_Fields;
  project_activity_soft_skill_min_order_by: Project_Activity_Soft_Skill_Min_Order_By;
  project_activity_soft_skill_mutation_response: Project_Activity_Soft_Skill_Mutation_Response;
  project_activity_soft_skill_on_conflict: Project_Activity_Soft_Skill_On_Conflict;
  project_activity_soft_skill_order_by: Project_Activity_Soft_Skill_Order_By;
  project_activity_soft_skill_pk_columns_input: Project_Activity_Soft_Skill_Pk_Columns_Input;
  project_activity_soft_skill_set_input: Project_Activity_Soft_Skill_Set_Input;
  project_activity_soft_skill_stddev_fields: Project_Activity_Soft_Skill_Stddev_Fields;
  project_activity_soft_skill_stddev_order_by: Project_Activity_Soft_Skill_Stddev_Order_By;
  project_activity_soft_skill_stddev_pop_fields: Project_Activity_Soft_Skill_Stddev_Pop_Fields;
  project_activity_soft_skill_stddev_pop_order_by: Project_Activity_Soft_Skill_Stddev_Pop_Order_By;
  project_activity_soft_skill_stddev_samp_fields: Project_Activity_Soft_Skill_Stddev_Samp_Fields;
  project_activity_soft_skill_stddev_samp_order_by: Project_Activity_Soft_Skill_Stddev_Samp_Order_By;
  project_activity_soft_skill_stream_cursor_input: Project_Activity_Soft_Skill_Stream_Cursor_Input;
  project_activity_soft_skill_stream_cursor_value_input: Project_Activity_Soft_Skill_Stream_Cursor_Value_Input;
  project_activity_soft_skill_sum_fields: Project_Activity_Soft_Skill_Sum_Fields;
  project_activity_soft_skill_sum_order_by: Project_Activity_Soft_Skill_Sum_Order_By;
  project_activity_soft_skill_updates: Project_Activity_Soft_Skill_Updates;
  project_activity_soft_skill_var_pop_fields: Project_Activity_Soft_Skill_Var_Pop_Fields;
  project_activity_soft_skill_var_pop_order_by: Project_Activity_Soft_Skill_Var_Pop_Order_By;
  project_activity_soft_skill_var_samp_fields: Project_Activity_Soft_Skill_Var_Samp_Fields;
  project_activity_soft_skill_var_samp_order_by: Project_Activity_Soft_Skill_Var_Samp_Order_By;
  project_activity_soft_skill_variance_fields: Project_Activity_Soft_Skill_Variance_Fields;
  project_activity_soft_skill_variance_order_by: Project_Activity_Soft_Skill_Variance_Order_By;
  project_activity_stddev_fields: Project_Activity_Stddev_Fields;
  project_activity_stddev_order_by: Project_Activity_Stddev_Order_By;
  project_activity_stddev_pop_fields: Project_Activity_Stddev_Pop_Fields;
  project_activity_stddev_pop_order_by: Project_Activity_Stddev_Pop_Order_By;
  project_activity_stddev_samp_fields: Project_Activity_Stddev_Samp_Fields;
  project_activity_stddev_samp_order_by: Project_Activity_Stddev_Samp_Order_By;
  project_activity_stream_cursor_input: Project_Activity_Stream_Cursor_Input;
  project_activity_stream_cursor_value_input: Project_Activity_Stream_Cursor_Value_Input;
  project_activity_sum_fields: Project_Activity_Sum_Fields;
  project_activity_sum_order_by: Project_Activity_Sum_Order_By;
  project_activity_tag: Project_Activity_Tag;
  project_activity_tag_aggregate: Project_Activity_Tag_Aggregate;
  project_activity_tag_aggregate_bool_exp: Project_Activity_Tag_Aggregate_Bool_Exp;
  project_activity_tag_aggregate_bool_exp_count: Project_Activity_Tag_Aggregate_Bool_Exp_Count;
  project_activity_tag_aggregate_fields: Project_Activity_Tag_Aggregate_Fields;
  project_activity_tag_aggregate_order_by: Project_Activity_Tag_Aggregate_Order_By;
  project_activity_tag_arr_rel_insert_input: Project_Activity_Tag_Arr_Rel_Insert_Input;
  project_activity_tag_avg_fields: Project_Activity_Tag_Avg_Fields;
  project_activity_tag_avg_order_by: Project_Activity_Tag_Avg_Order_By;
  project_activity_tag_bool_exp: Project_Activity_Tag_Bool_Exp;
  project_activity_tag_inc_input: Project_Activity_Tag_Inc_Input;
  project_activity_tag_insert_input: Project_Activity_Tag_Insert_Input;
  project_activity_tag_max_fields: Project_Activity_Tag_Max_Fields;
  project_activity_tag_max_order_by: Project_Activity_Tag_Max_Order_By;
  project_activity_tag_min_fields: Project_Activity_Tag_Min_Fields;
  project_activity_tag_min_order_by: Project_Activity_Tag_Min_Order_By;
  project_activity_tag_mutation_response: Project_Activity_Tag_Mutation_Response;
  project_activity_tag_on_conflict: Project_Activity_Tag_On_Conflict;
  project_activity_tag_order_by: Project_Activity_Tag_Order_By;
  project_activity_tag_pk_columns_input: Project_Activity_Tag_Pk_Columns_Input;
  project_activity_tag_set_input: Project_Activity_Tag_Set_Input;
  project_activity_tag_stddev_fields: Project_Activity_Tag_Stddev_Fields;
  project_activity_tag_stddev_order_by: Project_Activity_Tag_Stddev_Order_By;
  project_activity_tag_stddev_pop_fields: Project_Activity_Tag_Stddev_Pop_Fields;
  project_activity_tag_stddev_pop_order_by: Project_Activity_Tag_Stddev_Pop_Order_By;
  project_activity_tag_stddev_samp_fields: Project_Activity_Tag_Stddev_Samp_Fields;
  project_activity_tag_stddev_samp_order_by: Project_Activity_Tag_Stddev_Samp_Order_By;
  project_activity_tag_stream_cursor_input: Project_Activity_Tag_Stream_Cursor_Input;
  project_activity_tag_stream_cursor_value_input: Project_Activity_Tag_Stream_Cursor_Value_Input;
  project_activity_tag_sum_fields: Project_Activity_Tag_Sum_Fields;
  project_activity_tag_sum_order_by: Project_Activity_Tag_Sum_Order_By;
  project_activity_tag_updates: Project_Activity_Tag_Updates;
  project_activity_tag_var_pop_fields: Project_Activity_Tag_Var_Pop_Fields;
  project_activity_tag_var_pop_order_by: Project_Activity_Tag_Var_Pop_Order_By;
  project_activity_tag_var_samp_fields: Project_Activity_Tag_Var_Samp_Fields;
  project_activity_tag_var_samp_order_by: Project_Activity_Tag_Var_Samp_Order_By;
  project_activity_tag_variance_fields: Project_Activity_Tag_Variance_Fields;
  project_activity_tag_variance_order_by: Project_Activity_Tag_Variance_Order_By;
  project_activity_time: Project_Activity_Time;
  project_activity_time_aggregate: Project_Activity_Time_Aggregate;
  project_activity_time_aggregate_bool_exp: Project_Activity_Time_Aggregate_Bool_Exp;
  project_activity_time_aggregate_bool_exp_count: Project_Activity_Time_Aggregate_Bool_Exp_Count;
  project_activity_time_aggregate_fields: Project_Activity_Time_Aggregate_Fields;
  project_activity_time_aggregate_order_by: Project_Activity_Time_Aggregate_Order_By;
  project_activity_time_arr_rel_insert_input: Project_Activity_Time_Arr_Rel_Insert_Input;
  project_activity_time_avg_fields: Project_Activity_Time_Avg_Fields;
  project_activity_time_avg_order_by: Project_Activity_Time_Avg_Order_By;
  project_activity_time_bool_exp: Project_Activity_Time_Bool_Exp;
  project_activity_time_inc_input: Project_Activity_Time_Inc_Input;
  project_activity_time_insert_input: Project_Activity_Time_Insert_Input;
  project_activity_time_max_fields: Project_Activity_Time_Max_Fields;
  project_activity_time_max_order_by: Project_Activity_Time_Max_Order_By;
  project_activity_time_min_fields: Project_Activity_Time_Min_Fields;
  project_activity_time_min_order_by: Project_Activity_Time_Min_Order_By;
  project_activity_time_mutation_response: Project_Activity_Time_Mutation_Response;
  project_activity_time_obj_rel_insert_input: Project_Activity_Time_Obj_Rel_Insert_Input;
  project_activity_time_on_conflict: Project_Activity_Time_On_Conflict;
  project_activity_time_order_by: Project_Activity_Time_Order_By;
  project_activity_time_pk_columns_input: Project_Activity_Time_Pk_Columns_Input;
  project_activity_time_set_input: Project_Activity_Time_Set_Input;
  project_activity_time_stddev_fields: Project_Activity_Time_Stddev_Fields;
  project_activity_time_stddev_order_by: Project_Activity_Time_Stddev_Order_By;
  project_activity_time_stddev_pop_fields: Project_Activity_Time_Stddev_Pop_Fields;
  project_activity_time_stddev_pop_order_by: Project_Activity_Time_Stddev_Pop_Order_By;
  project_activity_time_stddev_samp_fields: Project_Activity_Time_Stddev_Samp_Fields;
  project_activity_time_stddev_samp_order_by: Project_Activity_Time_Stddev_Samp_Order_By;
  project_activity_time_stream_cursor_input: Project_Activity_Time_Stream_Cursor_Input;
  project_activity_time_stream_cursor_value_input: Project_Activity_Time_Stream_Cursor_Value_Input;
  project_activity_time_sum_fields: Project_Activity_Time_Sum_Fields;
  project_activity_time_sum_order_by: Project_Activity_Time_Sum_Order_By;
  project_activity_time_updates: Project_Activity_Time_Updates;
  project_activity_time_var_pop_fields: Project_Activity_Time_Var_Pop_Fields;
  project_activity_time_var_pop_order_by: Project_Activity_Time_Var_Pop_Order_By;
  project_activity_time_var_samp_fields: Project_Activity_Time_Var_Samp_Fields;
  project_activity_time_var_samp_order_by: Project_Activity_Time_Var_Samp_Order_By;
  project_activity_time_variance_fields: Project_Activity_Time_Variance_Fields;
  project_activity_time_variance_order_by: Project_Activity_Time_Variance_Order_By;
  project_activity_tracked_time: Project_Activity_Tracked_Time;
  project_activity_tracked_time_aggregate: Project_Activity_Tracked_Time_Aggregate;
  project_activity_tracked_time_aggregate_bool_exp: Project_Activity_Tracked_Time_Aggregate_Bool_Exp;
  project_activity_tracked_time_aggregate_bool_exp_count: Project_Activity_Tracked_Time_Aggregate_Bool_Exp_Count;
  project_activity_tracked_time_aggregate_fields: Project_Activity_Tracked_Time_Aggregate_Fields;
  project_activity_tracked_time_aggregate_order_by: Project_Activity_Tracked_Time_Aggregate_Order_By;
  project_activity_tracked_time_arr_rel_insert_input: Project_Activity_Tracked_Time_Arr_Rel_Insert_Input;
  project_activity_tracked_time_avg_fields: Project_Activity_Tracked_Time_Avg_Fields;
  project_activity_tracked_time_avg_order_by: Project_Activity_Tracked_Time_Avg_Order_By;
  project_activity_tracked_time_bool_exp: Project_Activity_Tracked_Time_Bool_Exp;
  project_activity_tracked_time_inc_input: Project_Activity_Tracked_Time_Inc_Input;
  project_activity_tracked_time_insert_input: Project_Activity_Tracked_Time_Insert_Input;
  project_activity_tracked_time_max_fields: Project_Activity_Tracked_Time_Max_Fields;
  project_activity_tracked_time_max_order_by: Project_Activity_Tracked_Time_Max_Order_By;
  project_activity_tracked_time_min_fields: Project_Activity_Tracked_Time_Min_Fields;
  project_activity_tracked_time_min_order_by: Project_Activity_Tracked_Time_Min_Order_By;
  project_activity_tracked_time_mutation_response: Project_Activity_Tracked_Time_Mutation_Response;
  project_activity_tracked_time_on_conflict: Project_Activity_Tracked_Time_On_Conflict;
  project_activity_tracked_time_order_by: Project_Activity_Tracked_Time_Order_By;
  project_activity_tracked_time_pk_columns_input: Project_Activity_Tracked_Time_Pk_Columns_Input;
  project_activity_tracked_time_set_input: Project_Activity_Tracked_Time_Set_Input;
  project_activity_tracked_time_stddev_fields: Project_Activity_Tracked_Time_Stddev_Fields;
  project_activity_tracked_time_stddev_order_by: Project_Activity_Tracked_Time_Stddev_Order_By;
  project_activity_tracked_time_stddev_pop_fields: Project_Activity_Tracked_Time_Stddev_Pop_Fields;
  project_activity_tracked_time_stddev_pop_order_by: Project_Activity_Tracked_Time_Stddev_Pop_Order_By;
  project_activity_tracked_time_stddev_samp_fields: Project_Activity_Tracked_Time_Stddev_Samp_Fields;
  project_activity_tracked_time_stddev_samp_order_by: Project_Activity_Tracked_Time_Stddev_Samp_Order_By;
  project_activity_tracked_time_stream_cursor_input: Project_Activity_Tracked_Time_Stream_Cursor_Input;
  project_activity_tracked_time_stream_cursor_value_input: Project_Activity_Tracked_Time_Stream_Cursor_Value_Input;
  project_activity_tracked_time_sum_fields: Project_Activity_Tracked_Time_Sum_Fields;
  project_activity_tracked_time_sum_order_by: Project_Activity_Tracked_Time_Sum_Order_By;
  project_activity_tracked_time_updates: Project_Activity_Tracked_Time_Updates;
  project_activity_tracked_time_var_pop_fields: Project_Activity_Tracked_Time_Var_Pop_Fields;
  project_activity_tracked_time_var_pop_order_by: Project_Activity_Tracked_Time_Var_Pop_Order_By;
  project_activity_tracked_time_var_samp_fields: Project_Activity_Tracked_Time_Var_Samp_Fields;
  project_activity_tracked_time_var_samp_order_by: Project_Activity_Tracked_Time_Var_Samp_Order_By;
  project_activity_tracked_time_variance_fields: Project_Activity_Tracked_Time_Variance_Fields;
  project_activity_tracked_time_variance_order_by: Project_Activity_Tracked_Time_Variance_Order_By;
  project_activity_updates: Project_Activity_Updates;
  project_activity_var_pop_fields: Project_Activity_Var_Pop_Fields;
  project_activity_var_pop_order_by: Project_Activity_Var_Pop_Order_By;
  project_activity_var_samp_fields: Project_Activity_Var_Samp_Fields;
  project_activity_var_samp_order_by: Project_Activity_Var_Samp_Order_By;
  project_activity_variance_fields: Project_Activity_Variance_Fields;
  project_activity_variance_order_by: Project_Activity_Variance_Order_By;
  project_aggregate: Project_Aggregate;
  project_aggregate_bool_exp: Project_Aggregate_Bool_Exp;
  project_aggregate_bool_exp_bool_and: Project_Aggregate_Bool_Exp_Bool_And;
  project_aggregate_bool_exp_bool_or: Project_Aggregate_Bool_Exp_Bool_Or;
  project_aggregate_bool_exp_count: Project_Aggregate_Bool_Exp_Count;
  project_aggregate_fields: Project_Aggregate_Fields;
  project_aggregate_order_by: Project_Aggregate_Order_By;
  project_arr_rel_insert_input: Project_Arr_Rel_Insert_Input;
  project_avg_fields: Project_Avg_Fields;
  project_avg_order_by: Project_Avg_Order_By;
  project_bool_exp: Project_Bool_Exp;
  project_inc_input: Project_Inc_Input;
  project_insert_input: Project_Insert_Input;
  project_max_fields: Project_Max_Fields;
  project_max_order_by: Project_Max_Order_By;
  project_min_fields: Project_Min_Fields;
  project_min_order_by: Project_Min_Order_By;
  project_mutation_response: Project_Mutation_Response;
  project_obj_rel_insert_input: Project_Obj_Rel_Insert_Input;
  project_on_conflict: Project_On_Conflict;
  project_order_by: Project_Order_By;
  project_pk_columns_input: Project_Pk_Columns_Input;
  project_set_input: Project_Set_Input;
  project_skill: Project_Skill;
  project_skill_aggregate: Project_Skill_Aggregate;
  project_skill_aggregate_bool_exp: Project_Skill_Aggregate_Bool_Exp;
  project_skill_aggregate_bool_exp_count: Project_Skill_Aggregate_Bool_Exp_Count;
  project_skill_aggregate_fields: Project_Skill_Aggregate_Fields;
  project_skill_aggregate_order_by: Project_Skill_Aggregate_Order_By;
  project_skill_arr_rel_insert_input: Project_Skill_Arr_Rel_Insert_Input;
  project_skill_avg_fields: Project_Skill_Avg_Fields;
  project_skill_avg_order_by: Project_Skill_Avg_Order_By;
  project_skill_bool_exp: Project_Skill_Bool_Exp;
  project_skill_inc_input: Project_Skill_Inc_Input;
  project_skill_insert_input: Project_Skill_Insert_Input;
  project_skill_max_fields: Project_Skill_Max_Fields;
  project_skill_max_order_by: Project_Skill_Max_Order_By;
  project_skill_min_fields: Project_Skill_Min_Fields;
  project_skill_min_order_by: Project_Skill_Min_Order_By;
  project_skill_mutation_response: Project_Skill_Mutation_Response;
  project_skill_on_conflict: Project_Skill_On_Conflict;
  project_skill_order_by: Project_Skill_Order_By;
  project_skill_pk_columns_input: Project_Skill_Pk_Columns_Input;
  project_skill_set_input: Project_Skill_Set_Input;
  project_skill_stddev_fields: Project_Skill_Stddev_Fields;
  project_skill_stddev_order_by: Project_Skill_Stddev_Order_By;
  project_skill_stddev_pop_fields: Project_Skill_Stddev_Pop_Fields;
  project_skill_stddev_pop_order_by: Project_Skill_Stddev_Pop_Order_By;
  project_skill_stddev_samp_fields: Project_Skill_Stddev_Samp_Fields;
  project_skill_stddev_samp_order_by: Project_Skill_Stddev_Samp_Order_By;
  project_skill_stream_cursor_input: Project_Skill_Stream_Cursor_Input;
  project_skill_stream_cursor_value_input: Project_Skill_Stream_Cursor_Value_Input;
  project_skill_sum_fields: Project_Skill_Sum_Fields;
  project_skill_sum_order_by: Project_Skill_Sum_Order_By;
  project_skill_updates: Project_Skill_Updates;
  project_skill_var_pop_fields: Project_Skill_Var_Pop_Fields;
  project_skill_var_pop_order_by: Project_Skill_Var_Pop_Order_By;
  project_skill_var_samp_fields: Project_Skill_Var_Samp_Fields;
  project_skill_var_samp_order_by: Project_Skill_Var_Samp_Order_By;
  project_skill_variance_fields: Project_Skill_Variance_Fields;
  project_skill_variance_order_by: Project_Skill_Variance_Order_By;
  project_soft_skill: Project_Soft_Skill;
  project_soft_skill_aggregate: Project_Soft_Skill_Aggregate;
  project_soft_skill_aggregate_bool_exp: Project_Soft_Skill_Aggregate_Bool_Exp;
  project_soft_skill_aggregate_bool_exp_count: Project_Soft_Skill_Aggregate_Bool_Exp_Count;
  project_soft_skill_aggregate_fields: Project_Soft_Skill_Aggregate_Fields;
  project_soft_skill_aggregate_order_by: Project_Soft_Skill_Aggregate_Order_By;
  project_soft_skill_arr_rel_insert_input: Project_Soft_Skill_Arr_Rel_Insert_Input;
  project_soft_skill_avg_fields: Project_Soft_Skill_Avg_Fields;
  project_soft_skill_avg_order_by: Project_Soft_Skill_Avg_Order_By;
  project_soft_skill_bool_exp: Project_Soft_Skill_Bool_Exp;
  project_soft_skill_inc_input: Project_Soft_Skill_Inc_Input;
  project_soft_skill_insert_input: Project_Soft_Skill_Insert_Input;
  project_soft_skill_max_fields: Project_Soft_Skill_Max_Fields;
  project_soft_skill_max_order_by: Project_Soft_Skill_Max_Order_By;
  project_soft_skill_min_fields: Project_Soft_Skill_Min_Fields;
  project_soft_skill_min_order_by: Project_Soft_Skill_Min_Order_By;
  project_soft_skill_mutation_response: Project_Soft_Skill_Mutation_Response;
  project_soft_skill_on_conflict: Project_Soft_Skill_On_Conflict;
  project_soft_skill_order_by: Project_Soft_Skill_Order_By;
  project_soft_skill_pk_columns_input: Project_Soft_Skill_Pk_Columns_Input;
  project_soft_skill_set_input: Project_Soft_Skill_Set_Input;
  project_soft_skill_stddev_fields: Project_Soft_Skill_Stddev_Fields;
  project_soft_skill_stddev_order_by: Project_Soft_Skill_Stddev_Order_By;
  project_soft_skill_stddev_pop_fields: Project_Soft_Skill_Stddev_Pop_Fields;
  project_soft_skill_stddev_pop_order_by: Project_Soft_Skill_Stddev_Pop_Order_By;
  project_soft_skill_stddev_samp_fields: Project_Soft_Skill_Stddev_Samp_Fields;
  project_soft_skill_stddev_samp_order_by: Project_Soft_Skill_Stddev_Samp_Order_By;
  project_soft_skill_stream_cursor_input: Project_Soft_Skill_Stream_Cursor_Input;
  project_soft_skill_stream_cursor_value_input: Project_Soft_Skill_Stream_Cursor_Value_Input;
  project_soft_skill_sum_fields: Project_Soft_Skill_Sum_Fields;
  project_soft_skill_sum_order_by: Project_Soft_Skill_Sum_Order_By;
  project_soft_skill_updates: Project_Soft_Skill_Updates;
  project_soft_skill_var_pop_fields: Project_Soft_Skill_Var_Pop_Fields;
  project_soft_skill_var_pop_order_by: Project_Soft_Skill_Var_Pop_Order_By;
  project_soft_skill_var_samp_fields: Project_Soft_Skill_Var_Samp_Fields;
  project_soft_skill_var_samp_order_by: Project_Soft_Skill_Var_Samp_Order_By;
  project_soft_skill_variance_fields: Project_Soft_Skill_Variance_Fields;
  project_soft_skill_variance_order_by: Project_Soft_Skill_Variance_Order_By;
  project_stddev_fields: Project_Stddev_Fields;
  project_stddev_order_by: Project_Stddev_Order_By;
  project_stddev_pop_fields: Project_Stddev_Pop_Fields;
  project_stddev_pop_order_by: Project_Stddev_Pop_Order_By;
  project_stddev_samp_fields: Project_Stddev_Samp_Fields;
  project_stddev_samp_order_by: Project_Stddev_Samp_Order_By;
  project_stream_cursor_input: Project_Stream_Cursor_Input;
  project_stream_cursor_value_input: Project_Stream_Cursor_Value_Input;
  project_sum_fields: Project_Sum_Fields;
  project_sum_order_by: Project_Sum_Order_By;
  project_tag: Project_Tag;
  project_tag_aggregate: Project_Tag_Aggregate;
  project_tag_aggregate_bool_exp: Project_Tag_Aggregate_Bool_Exp;
  project_tag_aggregate_bool_exp_count: Project_Tag_Aggregate_Bool_Exp_Count;
  project_tag_aggregate_fields: Project_Tag_Aggregate_Fields;
  project_tag_aggregate_order_by: Project_Tag_Aggregate_Order_By;
  project_tag_arr_rel_insert_input: Project_Tag_Arr_Rel_Insert_Input;
  project_tag_avg_fields: Project_Tag_Avg_Fields;
  project_tag_avg_order_by: Project_Tag_Avg_Order_By;
  project_tag_bool_exp: Project_Tag_Bool_Exp;
  project_tag_inc_input: Project_Tag_Inc_Input;
  project_tag_insert_input: Project_Tag_Insert_Input;
  project_tag_max_fields: Project_Tag_Max_Fields;
  project_tag_max_order_by: Project_Tag_Max_Order_By;
  project_tag_min_fields: Project_Tag_Min_Fields;
  project_tag_min_order_by: Project_Tag_Min_Order_By;
  project_tag_mutation_response: Project_Tag_Mutation_Response;
  project_tag_on_conflict: Project_Tag_On_Conflict;
  project_tag_order_by: Project_Tag_Order_By;
  project_tag_pk_columns_input: Project_Tag_Pk_Columns_Input;
  project_tag_set_input: Project_Tag_Set_Input;
  project_tag_stddev_fields: Project_Tag_Stddev_Fields;
  project_tag_stddev_order_by: Project_Tag_Stddev_Order_By;
  project_tag_stddev_pop_fields: Project_Tag_Stddev_Pop_Fields;
  project_tag_stddev_pop_order_by: Project_Tag_Stddev_Pop_Order_By;
  project_tag_stddev_samp_fields: Project_Tag_Stddev_Samp_Fields;
  project_tag_stddev_samp_order_by: Project_Tag_Stddev_Samp_Order_By;
  project_tag_stream_cursor_input: Project_Tag_Stream_Cursor_Input;
  project_tag_stream_cursor_value_input: Project_Tag_Stream_Cursor_Value_Input;
  project_tag_sum_fields: Project_Tag_Sum_Fields;
  project_tag_sum_order_by: Project_Tag_Sum_Order_By;
  project_tag_updates: Project_Tag_Updates;
  project_tag_var_pop_fields: Project_Tag_Var_Pop_Fields;
  project_tag_var_pop_order_by: Project_Tag_Var_Pop_Order_By;
  project_tag_var_samp_fields: Project_Tag_Var_Samp_Fields;
  project_tag_var_samp_order_by: Project_Tag_Var_Samp_Order_By;
  project_tag_variance_fields: Project_Tag_Variance_Fields;
  project_tag_variance_order_by: Project_Tag_Variance_Order_By;
  project_updates: Project_Updates;
  project_var_pop_fields: Project_Var_Pop_Fields;
  project_var_pop_order_by: Project_Var_Pop_Order_By;
  project_var_samp_fields: Project_Var_Samp_Fields;
  project_var_samp_order_by: Project_Var_Samp_Order_By;
  project_variance_fields: Project_Variance_Fields;
  project_variance_order_by: Project_Variance_Order_By;
  public_project_details: Public_Project_Details;
  public_project_details_aggregate: Public_Project_Details_Aggregate;
  public_project_details_aggregate_fields: Public_Project_Details_Aggregate_Fields;
  public_project_details_bool_exp: Public_Project_Details_Bool_Exp;
  public_project_details_insert_input: Public_Project_Details_Insert_Input;
  public_project_details_max_fields: Public_Project_Details_Max_Fields;
  public_project_details_min_fields: Public_Project_Details_Min_Fields;
  public_project_details_obj_rel_insert_input: Public_Project_Details_Obj_Rel_Insert_Input;
  public_project_details_order_by: Public_Project_Details_Order_By;
  public_project_details_stream_cursor_input: Public_Project_Details_Stream_Cursor_Input;
  public_project_details_stream_cursor_value_input: Public_Project_Details_Stream_Cursor_Value_Input;
  query_root: {};
  recipient_message: Recipient_Message;
  recipient_message_aggregate: Recipient_Message_Aggregate;
  recipient_message_aggregate_bool_exp: Recipient_Message_Aggregate_Bool_Exp;
  recipient_message_aggregate_bool_exp_bool_and: Recipient_Message_Aggregate_Bool_Exp_Bool_And;
  recipient_message_aggregate_bool_exp_bool_or: Recipient_Message_Aggregate_Bool_Exp_Bool_Or;
  recipient_message_aggregate_bool_exp_count: Recipient_Message_Aggregate_Bool_Exp_Count;
  recipient_message_aggregate_fields: Recipient_Message_Aggregate_Fields;
  recipient_message_aggregate_order_by: Recipient_Message_Aggregate_Order_By;
  recipient_message_arr_rel_insert_input: Recipient_Message_Arr_Rel_Insert_Input;
  recipient_message_bool_exp: Recipient_Message_Bool_Exp;
  recipient_message_insert_input: Recipient_Message_Insert_Input;
  recipient_message_max_fields: Recipient_Message_Max_Fields;
  recipient_message_max_order_by: Recipient_Message_Max_Order_By;
  recipient_message_min_fields: Recipient_Message_Min_Fields;
  recipient_message_min_order_by: Recipient_Message_Min_Order_By;
  recipient_message_mutation_response: Recipient_Message_Mutation_Response;
  recipient_message_on_conflict: Recipient_Message_On_Conflict;
  recipient_message_order_by: Recipient_Message_Order_By;
  recipient_message_pk_columns_input: Recipient_Message_Pk_Columns_Input;
  recipient_message_set_input: Recipient_Message_Set_Input;
  recipient_message_stream_cursor_input: Recipient_Message_Stream_Cursor_Input;
  recipient_message_stream_cursor_value_input: Recipient_Message_Stream_Cursor_Value_Input;
  recipient_message_updates: Recipient_Message_Updates;
  resource_information_card: Resource_Information_Card;
  resource_information_card_aggregate: Resource_Information_Card_Aggregate;
  resource_information_card_aggregate_bool_exp: Resource_Information_Card_Aggregate_Bool_Exp;
  resource_information_card_aggregate_bool_exp_bool_and: Resource_Information_Card_Aggregate_Bool_Exp_Bool_And;
  resource_information_card_aggregate_bool_exp_bool_or: Resource_Information_Card_Aggregate_Bool_Exp_Bool_Or;
  resource_information_card_aggregate_bool_exp_count: Resource_Information_Card_Aggregate_Bool_Exp_Count;
  resource_information_card_aggregate_fields: Resource_Information_Card_Aggregate_Fields;
  resource_information_card_aggregate_order_by: Resource_Information_Card_Aggregate_Order_By;
  resource_information_card_arr_rel_insert_input: Resource_Information_Card_Arr_Rel_Insert_Input;
  resource_information_card_avg_fields: Resource_Information_Card_Avg_Fields;
  resource_information_card_avg_order_by: Resource_Information_Card_Avg_Order_By;
  resource_information_card_bool_exp: Resource_Information_Card_Bool_Exp;
  resource_information_card_inc_input: Resource_Information_Card_Inc_Input;
  resource_information_card_insert_input: Resource_Information_Card_Insert_Input;
  resource_information_card_max_fields: Resource_Information_Card_Max_Fields;
  resource_information_card_max_order_by: Resource_Information_Card_Max_Order_By;
  resource_information_card_min_fields: Resource_Information_Card_Min_Fields;
  resource_information_card_min_order_by: Resource_Information_Card_Min_Order_By;
  resource_information_card_mutation_response: Resource_Information_Card_Mutation_Response;
  resource_information_card_on_conflict: Resource_Information_Card_On_Conflict;
  resource_information_card_order_by: Resource_Information_Card_Order_By;
  resource_information_card_pk_columns_input: Resource_Information_Card_Pk_Columns_Input;
  resource_information_card_set_input: Resource_Information_Card_Set_Input;
  resource_information_card_stddev_fields: Resource_Information_Card_Stddev_Fields;
  resource_information_card_stddev_order_by: Resource_Information_Card_Stddev_Order_By;
  resource_information_card_stddev_pop_fields: Resource_Information_Card_Stddev_Pop_Fields;
  resource_information_card_stddev_pop_order_by: Resource_Information_Card_Stddev_Pop_Order_By;
  resource_information_card_stddev_samp_fields: Resource_Information_Card_Stddev_Samp_Fields;
  resource_information_card_stddev_samp_order_by: Resource_Information_Card_Stddev_Samp_Order_By;
  resource_information_card_stream_cursor_input: Resource_Information_Card_Stream_Cursor_Input;
  resource_information_card_stream_cursor_value_input: Resource_Information_Card_Stream_Cursor_Value_Input;
  resource_information_card_sum_fields: Resource_Information_Card_Sum_Fields;
  resource_information_card_sum_order_by: Resource_Information_Card_Sum_Order_By;
  resource_information_card_updates: Resource_Information_Card_Updates;
  resource_information_card_var_pop_fields: Resource_Information_Card_Var_Pop_Fields;
  resource_information_card_var_pop_order_by: Resource_Information_Card_Var_Pop_Order_By;
  resource_information_card_var_samp_fields: Resource_Information_Card_Var_Samp_Fields;
  resource_information_card_var_samp_order_by: Resource_Information_Card_Var_Samp_Order_By;
  resource_information_card_variance_fields: Resource_Information_Card_Variance_Fields;
  resource_information_card_variance_order_by: Resource_Information_Card_Variance_Order_By;
  search_industry_args: Search_Industry_Args;
  search_skill_args: Search_Skill_Args;
  skill: Skill;
  skill_aggregate: Skill_Aggregate;
  skill_aggregate_bool_exp: Skill_Aggregate_Bool_Exp;
  skill_aggregate_bool_exp_count: Skill_Aggregate_Bool_Exp_Count;
  skill_aggregate_fields: Skill_Aggregate_Fields;
  skill_aggregate_order_by: Skill_Aggregate_Order_By;
  skill_arr_rel_insert_input: Skill_Arr_Rel_Insert_Input;
  skill_avg_fields: Skill_Avg_Fields;
  skill_avg_order_by: Skill_Avg_Order_By;
  skill_bool_exp: Skill_Bool_Exp;
  skill_inc_input: Skill_Inc_Input;
  skill_insert_input: Skill_Insert_Input;
  skill_max_fields: Skill_Max_Fields;
  skill_max_order_by: Skill_Max_Order_By;
  skill_min_fields: Skill_Min_Fields;
  skill_min_order_by: Skill_Min_Order_By;
  skill_mutation_response: Skill_Mutation_Response;
  skill_obj_rel_insert_input: Skill_Obj_Rel_Insert_Input;
  skill_on_conflict: Skill_On_Conflict;
  skill_order_by: Skill_Order_By;
  skill_pk_columns_input: Skill_Pk_Columns_Input;
  skill_set_input: Skill_Set_Input;
  skill_stddev_fields: Skill_Stddev_Fields;
  skill_stddev_order_by: Skill_Stddev_Order_By;
  skill_stddev_pop_fields: Skill_Stddev_Pop_Fields;
  skill_stddev_pop_order_by: Skill_Stddev_Pop_Order_By;
  skill_stddev_samp_fields: Skill_Stddev_Samp_Fields;
  skill_stddev_samp_order_by: Skill_Stddev_Samp_Order_By;
  skill_stream_cursor_input: Skill_Stream_Cursor_Input;
  skill_stream_cursor_value_input: Skill_Stream_Cursor_Value_Input;
  skill_sum_fields: Skill_Sum_Fields;
  skill_sum_order_by: Skill_Sum_Order_By;
  skill_updates: Skill_Updates;
  skill_var_pop_fields: Skill_Var_Pop_Fields;
  skill_var_pop_order_by: Skill_Var_Pop_Order_By;
  skill_var_samp_fields: Skill_Var_Samp_Fields;
  skill_var_samp_order_by: Skill_Var_Samp_Order_By;
  skill_variance_fields: Skill_Variance_Fields;
  skill_variance_order_by: Skill_Variance_Order_By;
  skills_short_name_first: Skills_Short_Name_First;
  skills_short_name_first_aggregate: Skills_Short_Name_First_Aggregate;
  skills_short_name_first_aggregate_fields: Skills_Short_Name_First_Aggregate_Fields;
  skills_short_name_first_avg_fields: Skills_Short_Name_First_Avg_Fields;
  skills_short_name_first_bool_exp: Skills_Short_Name_First_Bool_Exp;
  skills_short_name_first_inc_input: Skills_Short_Name_First_Inc_Input;
  skills_short_name_first_insert_input: Skills_Short_Name_First_Insert_Input;
  skills_short_name_first_max_fields: Skills_Short_Name_First_Max_Fields;
  skills_short_name_first_min_fields: Skills_Short_Name_First_Min_Fields;
  skills_short_name_first_mutation_response: Skills_Short_Name_First_Mutation_Response;
  skills_short_name_first_order_by: Skills_Short_Name_First_Order_By;
  skills_short_name_first_set_input: Skills_Short_Name_First_Set_Input;
  skills_short_name_first_stddev_fields: Skills_Short_Name_First_Stddev_Fields;
  skills_short_name_first_stddev_pop_fields: Skills_Short_Name_First_Stddev_Pop_Fields;
  skills_short_name_first_stddev_samp_fields: Skills_Short_Name_First_Stddev_Samp_Fields;
  skills_short_name_first_stream_cursor_input: Skills_Short_Name_First_Stream_Cursor_Input;
  skills_short_name_first_stream_cursor_value_input: Skills_Short_Name_First_Stream_Cursor_Value_Input;
  skills_short_name_first_sum_fields: Skills_Short_Name_First_Sum_Fields;
  skills_short_name_first_updates: Skills_Short_Name_First_Updates;
  skills_short_name_first_var_pop_fields: Skills_Short_Name_First_Var_Pop_Fields;
  skills_short_name_first_var_samp_fields: Skills_Short_Name_First_Var_Samp_Fields;
  skills_short_name_first_variance_fields: Skills_Short_Name_First_Variance_Fields;
  smart_match_bookmark: Smart_Match_Bookmark;
  smart_match_bookmark_aggregate: Smart_Match_Bookmark_Aggregate;
  smart_match_bookmark_aggregate_bool_exp: Smart_Match_Bookmark_Aggregate_Bool_Exp;
  smart_match_bookmark_aggregate_bool_exp_count: Smart_Match_Bookmark_Aggregate_Bool_Exp_Count;
  smart_match_bookmark_aggregate_fields: Smart_Match_Bookmark_Aggregate_Fields;
  smart_match_bookmark_aggregate_order_by: Smart_Match_Bookmark_Aggregate_Order_By;
  smart_match_bookmark_arr_rel_insert_input: Smart_Match_Bookmark_Arr_Rel_Insert_Input;
  smart_match_bookmark_avg_fields: Smart_Match_Bookmark_Avg_Fields;
  smart_match_bookmark_avg_order_by: Smart_Match_Bookmark_Avg_Order_By;
  smart_match_bookmark_bool_exp: Smart_Match_Bookmark_Bool_Exp;
  smart_match_bookmark_inc_input: Smart_Match_Bookmark_Inc_Input;
  smart_match_bookmark_insert_input: Smart_Match_Bookmark_Insert_Input;
  smart_match_bookmark_max_fields: Smart_Match_Bookmark_Max_Fields;
  smart_match_bookmark_max_order_by: Smart_Match_Bookmark_Max_Order_By;
  smart_match_bookmark_min_fields: Smart_Match_Bookmark_Min_Fields;
  smart_match_bookmark_min_order_by: Smart_Match_Bookmark_Min_Order_By;
  smart_match_bookmark_mutation_response: Smart_Match_Bookmark_Mutation_Response;
  smart_match_bookmark_obj_rel_insert_input: Smart_Match_Bookmark_Obj_Rel_Insert_Input;
  smart_match_bookmark_on_conflict: Smart_Match_Bookmark_On_Conflict;
  smart_match_bookmark_order_by: Smart_Match_Bookmark_Order_By;
  smart_match_bookmark_pk_columns_input: Smart_Match_Bookmark_Pk_Columns_Input;
  smart_match_bookmark_set_input: Smart_Match_Bookmark_Set_Input;
  smart_match_bookmark_stddev_fields: Smart_Match_Bookmark_Stddev_Fields;
  smart_match_bookmark_stddev_order_by: Smart_Match_Bookmark_Stddev_Order_By;
  smart_match_bookmark_stddev_pop_fields: Smart_Match_Bookmark_Stddev_Pop_Fields;
  smart_match_bookmark_stddev_pop_order_by: Smart_Match_Bookmark_Stddev_Pop_Order_By;
  smart_match_bookmark_stddev_samp_fields: Smart_Match_Bookmark_Stddev_Samp_Fields;
  smart_match_bookmark_stddev_samp_order_by: Smart_Match_Bookmark_Stddev_Samp_Order_By;
  smart_match_bookmark_stream_cursor_input: Smart_Match_Bookmark_Stream_Cursor_Input;
  smart_match_bookmark_stream_cursor_value_input: Smart_Match_Bookmark_Stream_Cursor_Value_Input;
  smart_match_bookmark_sum_fields: Smart_Match_Bookmark_Sum_Fields;
  smart_match_bookmark_sum_order_by: Smart_Match_Bookmark_Sum_Order_By;
  smart_match_bookmark_updates: Smart_Match_Bookmark_Updates;
  smart_match_bookmark_var_pop_fields: Smart_Match_Bookmark_Var_Pop_Fields;
  smart_match_bookmark_var_pop_order_by: Smart_Match_Bookmark_Var_Pop_Order_By;
  smart_match_bookmark_var_samp_fields: Smart_Match_Bookmark_Var_Samp_Fields;
  smart_match_bookmark_var_samp_order_by: Smart_Match_Bookmark_Var_Samp_Order_By;
  smart_match_bookmark_variance_fields: Smart_Match_Bookmark_Variance_Fields;
  smart_match_bookmark_variance_order_by: Smart_Match_Bookmark_Variance_Order_By;
  smart_match_config_transportation: Smart_Match_Config_Transportation;
  smart_match_config_transportation_aggregate: Smart_Match_Config_Transportation_Aggregate;
  smart_match_config_transportation_aggregate_bool_exp: Smart_Match_Config_Transportation_Aggregate_Bool_Exp;
  smart_match_config_transportation_aggregate_bool_exp_count: Smart_Match_Config_Transportation_Aggregate_Bool_Exp_Count;
  smart_match_config_transportation_aggregate_fields: Smart_Match_Config_Transportation_Aggregate_Fields;
  smart_match_config_transportation_aggregate_order_by: Smart_Match_Config_Transportation_Aggregate_Order_By;
  smart_match_config_transportation_arr_rel_insert_input: Smart_Match_Config_Transportation_Arr_Rel_Insert_Input;
  smart_match_config_transportation_bool_exp: Smart_Match_Config_Transportation_Bool_Exp;
  smart_match_config_transportation_insert_input: Smart_Match_Config_Transportation_Insert_Input;
  smart_match_config_transportation_max_fields: Smart_Match_Config_Transportation_Max_Fields;
  smart_match_config_transportation_max_order_by: Smart_Match_Config_Transportation_Max_Order_By;
  smart_match_config_transportation_min_fields: Smart_Match_Config_Transportation_Min_Fields;
  smart_match_config_transportation_min_order_by: Smart_Match_Config_Transportation_Min_Order_By;
  smart_match_config_transportation_mutation_response: Smart_Match_Config_Transportation_Mutation_Response;
  smart_match_config_transportation_on_conflict: Smart_Match_Config_Transportation_On_Conflict;
  smart_match_config_transportation_order_by: Smart_Match_Config_Transportation_Order_By;
  smart_match_config_transportation_pk_columns_input: Smart_Match_Config_Transportation_Pk_Columns_Input;
  smart_match_config_transportation_set_input: Smart_Match_Config_Transportation_Set_Input;
  smart_match_config_transportation_stream_cursor_input: Smart_Match_Config_Transportation_Stream_Cursor_Input;
  smart_match_config_transportation_stream_cursor_value_input: Smart_Match_Config_Transportation_Stream_Cursor_Value_Input;
  smart_match_config_transportation_updates: Smart_Match_Config_Transportation_Updates;
  smart_match_configs: Smart_Match_Configs;
  smart_match_configs_aggregate: Smart_Match_Configs_Aggregate;
  smart_match_configs_aggregate_fields: Smart_Match_Configs_Aggregate_Fields;
  smart_match_configs_avg_fields: Smart_Match_Configs_Avg_Fields;
  smart_match_configs_bool_exp: Smart_Match_Configs_Bool_Exp;
  smart_match_configs_inc_input: Smart_Match_Configs_Inc_Input;
  smart_match_configs_insert_input: Smart_Match_Configs_Insert_Input;
  smart_match_configs_max_fields: Smart_Match_Configs_Max_Fields;
  smart_match_configs_min_fields: Smart_Match_Configs_Min_Fields;
  smart_match_configs_mutation_response: Smart_Match_Configs_Mutation_Response;
  smart_match_configs_obj_rel_insert_input: Smart_Match_Configs_Obj_Rel_Insert_Input;
  smart_match_configs_on_conflict: Smart_Match_Configs_On_Conflict;
  smart_match_configs_order_by: Smart_Match_Configs_Order_By;
  smart_match_configs_pk_columns_input: Smart_Match_Configs_Pk_Columns_Input;
  smart_match_configs_set_input: Smart_Match_Configs_Set_Input;
  smart_match_configs_stddev_fields: Smart_Match_Configs_Stddev_Fields;
  smart_match_configs_stddev_pop_fields: Smart_Match_Configs_Stddev_Pop_Fields;
  smart_match_configs_stddev_samp_fields: Smart_Match_Configs_Stddev_Samp_Fields;
  smart_match_configs_stream_cursor_input: Smart_Match_Configs_Stream_Cursor_Input;
  smart_match_configs_stream_cursor_value_input: Smart_Match_Configs_Stream_Cursor_Value_Input;
  smart_match_configs_sum_fields: Smart_Match_Configs_Sum_Fields;
  smart_match_configs_updates: Smart_Match_Configs_Updates;
  smart_match_configs_var_pop_fields: Smart_Match_Configs_Var_Pop_Fields;
  smart_match_configs_var_samp_fields: Smart_Match_Configs_Var_Samp_Fields;
  smart_match_configs_variance_fields: Smart_Match_Configs_Variance_Fields;
  smart_match_criteria_order: Smart_Match_Criteria_Order;
  smart_match_criteria_order_aggregate: Smart_Match_Criteria_Order_Aggregate;
  smart_match_criteria_order_aggregate_bool_exp: Smart_Match_Criteria_Order_Aggregate_Bool_Exp;
  smart_match_criteria_order_aggregate_bool_exp_count: Smart_Match_Criteria_Order_Aggregate_Bool_Exp_Count;
  smart_match_criteria_order_aggregate_fields: Smart_Match_Criteria_Order_Aggregate_Fields;
  smart_match_criteria_order_aggregate_order_by: Smart_Match_Criteria_Order_Aggregate_Order_By;
  smart_match_criteria_order_arr_rel_insert_input: Smart_Match_Criteria_Order_Arr_Rel_Insert_Input;
  smart_match_criteria_order_avg_fields: Smart_Match_Criteria_Order_Avg_Fields;
  smart_match_criteria_order_avg_order_by: Smart_Match_Criteria_Order_Avg_Order_By;
  smart_match_criteria_order_bool_exp: Smart_Match_Criteria_Order_Bool_Exp;
  smart_match_criteria_order_inc_input: Smart_Match_Criteria_Order_Inc_Input;
  smart_match_criteria_order_insert_input: Smart_Match_Criteria_Order_Insert_Input;
  smart_match_criteria_order_max_fields: Smart_Match_Criteria_Order_Max_Fields;
  smart_match_criteria_order_max_order_by: Smart_Match_Criteria_Order_Max_Order_By;
  smart_match_criteria_order_min_fields: Smart_Match_Criteria_Order_Min_Fields;
  smart_match_criteria_order_min_order_by: Smart_Match_Criteria_Order_Min_Order_By;
  smart_match_criteria_order_mutation_response: Smart_Match_Criteria_Order_Mutation_Response;
  smart_match_criteria_order_on_conflict: Smart_Match_Criteria_Order_On_Conflict;
  smart_match_criteria_order_order_by: Smart_Match_Criteria_Order_Order_By;
  smart_match_criteria_order_pk_columns_input: Smart_Match_Criteria_Order_Pk_Columns_Input;
  smart_match_criteria_order_set_input: Smart_Match_Criteria_Order_Set_Input;
  smart_match_criteria_order_stddev_fields: Smart_Match_Criteria_Order_Stddev_Fields;
  smart_match_criteria_order_stddev_order_by: Smart_Match_Criteria_Order_Stddev_Order_By;
  smart_match_criteria_order_stddev_pop_fields: Smart_Match_Criteria_Order_Stddev_Pop_Fields;
  smart_match_criteria_order_stddev_pop_order_by: Smart_Match_Criteria_Order_Stddev_Pop_Order_By;
  smart_match_criteria_order_stddev_samp_fields: Smart_Match_Criteria_Order_Stddev_Samp_Fields;
  smart_match_criteria_order_stddev_samp_order_by: Smart_Match_Criteria_Order_Stddev_Samp_Order_By;
  smart_match_criteria_order_stream_cursor_input: Smart_Match_Criteria_Order_Stream_Cursor_Input;
  smart_match_criteria_order_stream_cursor_value_input: Smart_Match_Criteria_Order_Stream_Cursor_Value_Input;
  smart_match_criteria_order_sum_fields: Smart_Match_Criteria_Order_Sum_Fields;
  smart_match_criteria_order_sum_order_by: Smart_Match_Criteria_Order_Sum_Order_By;
  smart_match_criteria_order_updates: Smart_Match_Criteria_Order_Updates;
  smart_match_criteria_order_var_pop_fields: Smart_Match_Criteria_Order_Var_Pop_Fields;
  smart_match_criteria_order_var_pop_order_by: Smart_Match_Criteria_Order_Var_Pop_Order_By;
  smart_match_criteria_order_var_samp_fields: Smart_Match_Criteria_Order_Var_Samp_Fields;
  smart_match_criteria_order_var_samp_order_by: Smart_Match_Criteria_Order_Var_Samp_Order_By;
  smart_match_criteria_order_variance_fields: Smart_Match_Criteria_Order_Variance_Fields;
  smart_match_criteria_order_variance_order_by: Smart_Match_Criteria_Order_Variance_Order_By;
  soft_skill: Soft_Skill;
  soft_skill_aggregate: Soft_Skill_Aggregate;
  soft_skill_aggregate_bool_exp: Soft_Skill_Aggregate_Bool_Exp;
  soft_skill_aggregate_bool_exp_count: Soft_Skill_Aggregate_Bool_Exp_Count;
  soft_skill_aggregate_fields: Soft_Skill_Aggregate_Fields;
  soft_skill_aggregate_order_by: Soft_Skill_Aggregate_Order_By;
  soft_skill_arr_rel_insert_input: Soft_Skill_Arr_Rel_Insert_Input;
  soft_skill_avg_fields: Soft_Skill_Avg_Fields;
  soft_skill_avg_order_by: Soft_Skill_Avg_Order_By;
  soft_skill_bool_exp: Soft_Skill_Bool_Exp;
  soft_skill_inc_input: Soft_Skill_Inc_Input;
  soft_skill_insert_input: Soft_Skill_Insert_Input;
  soft_skill_max_fields: Soft_Skill_Max_Fields;
  soft_skill_max_order_by: Soft_Skill_Max_Order_By;
  soft_skill_min_fields: Soft_Skill_Min_Fields;
  soft_skill_min_order_by: Soft_Skill_Min_Order_By;
  soft_skill_mutation_response: Soft_Skill_Mutation_Response;
  soft_skill_obj_rel_insert_input: Soft_Skill_Obj_Rel_Insert_Input;
  soft_skill_on_conflict: Soft_Skill_On_Conflict;
  soft_skill_order_by: Soft_Skill_Order_By;
  soft_skill_pk_columns_input: Soft_Skill_Pk_Columns_Input;
  soft_skill_set_input: Soft_Skill_Set_Input;
  soft_skill_stddev_fields: Soft_Skill_Stddev_Fields;
  soft_skill_stddev_order_by: Soft_Skill_Stddev_Order_By;
  soft_skill_stddev_pop_fields: Soft_Skill_Stddev_Pop_Fields;
  soft_skill_stddev_pop_order_by: Soft_Skill_Stddev_Pop_Order_By;
  soft_skill_stddev_samp_fields: Soft_Skill_Stddev_Samp_Fields;
  soft_skill_stddev_samp_order_by: Soft_Skill_Stddev_Samp_Order_By;
  soft_skill_stream_cursor_input: Soft_Skill_Stream_Cursor_Input;
  soft_skill_stream_cursor_value_input: Soft_Skill_Stream_Cursor_Value_Input;
  soft_skill_sum_fields: Soft_Skill_Sum_Fields;
  soft_skill_sum_order_by: Soft_Skill_Sum_Order_By;
  soft_skill_updates: Soft_Skill_Updates;
  soft_skill_var_pop_fields: Soft_Skill_Var_Pop_Fields;
  soft_skill_var_pop_order_by: Soft_Skill_Var_Pop_Order_By;
  soft_skill_var_samp_fields: Soft_Skill_Var_Samp_Fields;
  soft_skill_var_samp_order_by: Soft_Skill_Var_Samp_Order_By;
  soft_skill_variance_fields: Soft_Skill_Variance_Fields;
  soft_skill_variance_order_by: Soft_Skill_Variance_Order_By;
  source: Source;
  source_aggregate: Source_Aggregate;
  source_aggregate_fields: Source_Aggregate_Fields;
  source_bool_exp: Source_Bool_Exp;
  source_insert_input: Source_Insert_Input;
  source_max_fields: Source_Max_Fields;
  source_min_fields: Source_Min_Fields;
  source_mutation_response: Source_Mutation_Response;
  source_obj_rel_insert_input: Source_Obj_Rel_Insert_Input;
  source_on_conflict: Source_On_Conflict;
  source_order_by: Source_Order_By;
  source_pk_columns_input: Source_Pk_Columns_Input;
  source_set_input: Source_Set_Input;
  source_stream_cursor_input: Source_Stream_Cursor_Input;
  source_stream_cursor_value_input: Source_Stream_Cursor_Value_Input;
  source_updates: Source_Updates;
  subscription: Subscription;
  subscription_aggregate: Subscription_Aggregate;
  subscription_aggregate_bool_exp: Subscription_Aggregate_Bool_Exp;
  subscription_aggregate_bool_exp_bool_and: Subscription_Aggregate_Bool_Exp_Bool_And;
  subscription_aggregate_bool_exp_bool_or: Subscription_Aggregate_Bool_Exp_Bool_Or;
  subscription_aggregate_bool_exp_count: Subscription_Aggregate_Bool_Exp_Count;
  subscription_aggregate_fields: Subscription_Aggregate_Fields;
  subscription_aggregate_order_by: Subscription_Aggregate_Order_By;
  subscription_arr_rel_insert_input: Subscription_Arr_Rel_Insert_Input;
  subscription_avg_fields: Subscription_Avg_Fields;
  subscription_avg_order_by: Subscription_Avg_Order_By;
  subscription_bool_exp: Subscription_Bool_Exp;
  subscription_inc_input: Subscription_Inc_Input;
  subscription_insert_input: Subscription_Insert_Input;
  subscription_max_fields: Subscription_Max_Fields;
  subscription_max_order_by: Subscription_Max_Order_By;
  subscription_min_fields: Subscription_Min_Fields;
  subscription_min_order_by: Subscription_Min_Order_By;
  subscription_mutation_response: Subscription_Mutation_Response;
  subscription_on_conflict: Subscription_On_Conflict;
  subscription_order_by: Subscription_Order_By;
  subscription_pk_columns_input: Subscription_Pk_Columns_Input;
  subscription_plan: Subscription_Plan;
  subscription_plan_access_permissions: Subscription_Plan_Access_Permissions;
  subscription_plan_access_permissions_aggregate: Subscription_Plan_Access_Permissions_Aggregate;
  subscription_plan_access_permissions_aggregate_fields: Subscription_Plan_Access_Permissions_Aggregate_Fields;
  subscription_plan_access_permissions_avg_fields: Subscription_Plan_Access_Permissions_Avg_Fields;
  subscription_plan_access_permissions_bool_exp: Subscription_Plan_Access_Permissions_Bool_Exp;
  subscription_plan_access_permissions_inc_input: Subscription_Plan_Access_Permissions_Inc_Input;
  subscription_plan_access_permissions_insert_input: Subscription_Plan_Access_Permissions_Insert_Input;
  subscription_plan_access_permissions_max_fields: Subscription_Plan_Access_Permissions_Max_Fields;
  subscription_plan_access_permissions_min_fields: Subscription_Plan_Access_Permissions_Min_Fields;
  subscription_plan_access_permissions_mutation_response: Subscription_Plan_Access_Permissions_Mutation_Response;
  subscription_plan_access_permissions_obj_rel_insert_input: Subscription_Plan_Access_Permissions_Obj_Rel_Insert_Input;
  subscription_plan_access_permissions_on_conflict: Subscription_Plan_Access_Permissions_On_Conflict;
  subscription_plan_access_permissions_order_by: Subscription_Plan_Access_Permissions_Order_By;
  subscription_plan_access_permissions_pk_columns_input: Subscription_Plan_Access_Permissions_Pk_Columns_Input;
  subscription_plan_access_permissions_set_input: Subscription_Plan_Access_Permissions_Set_Input;
  subscription_plan_access_permissions_stddev_fields: Subscription_Plan_Access_Permissions_Stddev_Fields;
  subscription_plan_access_permissions_stddev_pop_fields: Subscription_Plan_Access_Permissions_Stddev_Pop_Fields;
  subscription_plan_access_permissions_stddev_samp_fields: Subscription_Plan_Access_Permissions_Stddev_Samp_Fields;
  subscription_plan_access_permissions_stream_cursor_input: Subscription_Plan_Access_Permissions_Stream_Cursor_Input;
  subscription_plan_access_permissions_stream_cursor_value_input: Subscription_Plan_Access_Permissions_Stream_Cursor_Value_Input;
  subscription_plan_access_permissions_sum_fields: Subscription_Plan_Access_Permissions_Sum_Fields;
  subscription_plan_access_permissions_updates: Subscription_Plan_Access_Permissions_Updates;
  subscription_plan_access_permissions_var_pop_fields: Subscription_Plan_Access_Permissions_Var_Pop_Fields;
  subscription_plan_access_permissions_var_samp_fields: Subscription_Plan_Access_Permissions_Var_Samp_Fields;
  subscription_plan_access_permissions_variance_fields: Subscription_Plan_Access_Permissions_Variance_Fields;
  subscription_plan_aggregate: Subscription_Plan_Aggregate;
  subscription_plan_aggregate_bool_exp: Subscription_Plan_Aggregate_Bool_Exp;
  subscription_plan_aggregate_bool_exp_bool_and: Subscription_Plan_Aggregate_Bool_Exp_Bool_And;
  subscription_plan_aggregate_bool_exp_bool_or: Subscription_Plan_Aggregate_Bool_Exp_Bool_Or;
  subscription_plan_aggregate_bool_exp_count: Subscription_Plan_Aggregate_Bool_Exp_Count;
  subscription_plan_aggregate_fields: Subscription_Plan_Aggregate_Fields;
  subscription_plan_aggregate_order_by: Subscription_Plan_Aggregate_Order_By;
  subscription_plan_arr_rel_insert_input: Subscription_Plan_Arr_Rel_Insert_Input;
  subscription_plan_bool_exp: Subscription_Plan_Bool_Exp;
  subscription_plan_insert_input: Subscription_Plan_Insert_Input;
  subscription_plan_max_fields: Subscription_Plan_Max_Fields;
  subscription_plan_max_order_by: Subscription_Plan_Max_Order_By;
  subscription_plan_min_fields: Subscription_Plan_Min_Fields;
  subscription_plan_min_order_by: Subscription_Plan_Min_Order_By;
  subscription_plan_mutation_response: Subscription_Plan_Mutation_Response;
  subscription_plan_obj_rel_insert_input: Subscription_Plan_Obj_Rel_Insert_Input;
  subscription_plan_on_conflict: Subscription_Plan_On_Conflict;
  subscription_plan_order_by: Subscription_Plan_Order_By;
  subscription_plan_pk_columns_input: Subscription_Plan_Pk_Columns_Input;
  subscription_plan_set_input: Subscription_Plan_Set_Input;
  subscription_plan_stream_cursor_input: Subscription_Plan_Stream_Cursor_Input;
  subscription_plan_stream_cursor_value_input: Subscription_Plan_Stream_Cursor_Value_Input;
  subscription_plan_updates: Subscription_Plan_Updates;
  subscription_root: {};
  subscription_set_input: Subscription_Set_Input;
  subscription_stddev_fields: Subscription_Stddev_Fields;
  subscription_stddev_order_by: Subscription_Stddev_Order_By;
  subscription_stddev_pop_fields: Subscription_Stddev_Pop_Fields;
  subscription_stddev_pop_order_by: Subscription_Stddev_Pop_Order_By;
  subscription_stddev_samp_fields: Subscription_Stddev_Samp_Fields;
  subscription_stddev_samp_order_by: Subscription_Stddev_Samp_Order_By;
  subscription_stream_cursor_input: Subscription_Stream_Cursor_Input;
  subscription_stream_cursor_value_input: Subscription_Stream_Cursor_Value_Input;
  subscription_sum_fields: Subscription_Sum_Fields;
  subscription_sum_order_by: Subscription_Sum_Order_By;
  subscription_updates: Subscription_Updates;
  subscription_var_pop_fields: Subscription_Var_Pop_Fields;
  subscription_var_pop_order_by: Subscription_Var_Pop_Order_By;
  subscription_var_samp_fields: Subscription_Var_Samp_Fields;
  subscription_var_samp_order_by: Subscription_Var_Samp_Order_By;
  subscription_variance_fields: Subscription_Variance_Fields;
  subscription_variance_order_by: Subscription_Variance_Order_By;
  tag: Tag;
  tag_aggregate: Tag_Aggregate;
  tag_aggregate_fields: Tag_Aggregate_Fields;
  tag_bool_exp: Tag_Bool_Exp;
  tag_insert_input: Tag_Insert_Input;
  tag_max_fields: Tag_Max_Fields;
  tag_min_fields: Tag_Min_Fields;
  tag_mutation_response: Tag_Mutation_Response;
  tag_obj_rel_insert_input: Tag_Obj_Rel_Insert_Input;
  tag_on_conflict: Tag_On_Conflict;
  tag_order_by: Tag_Order_By;
  tag_pk_columns_input: Tag_Pk_Columns_Input;
  tag_set_input: Tag_Set_Input;
  tag_stream_cursor_input: Tag_Stream_Cursor_Input;
  tag_stream_cursor_value_input: Tag_Stream_Cursor_Value_Input;
  tag_updates: Tag_Updates;
  team: Team;
  team_aggregate: Team_Aggregate;
  team_aggregate_bool_exp: Team_Aggregate_Bool_Exp;
  team_aggregate_bool_exp_bool_and: Team_Aggregate_Bool_Exp_Bool_And;
  team_aggregate_bool_exp_bool_or: Team_Aggregate_Bool_Exp_Bool_Or;
  team_aggregate_bool_exp_count: Team_Aggregate_Bool_Exp_Count;
  team_aggregate_fields: Team_Aggregate_Fields;
  team_aggregate_order_by: Team_Aggregate_Order_By;
  team_arr_rel_insert_input: Team_Arr_Rel_Insert_Input;
  team_bool_exp: Team_Bool_Exp;
  team_contractor: Team_Contractor;
  team_contractor_aggregate: Team_Contractor_Aggregate;
  team_contractor_aggregate_bool_exp: Team_Contractor_Aggregate_Bool_Exp;
  team_contractor_aggregate_bool_exp_count: Team_Contractor_Aggregate_Bool_Exp_Count;
  team_contractor_aggregate_fields: Team_Contractor_Aggregate_Fields;
  team_contractor_aggregate_order_by: Team_Contractor_Aggregate_Order_By;
  team_contractor_arr_rel_insert_input: Team_Contractor_Arr_Rel_Insert_Input;
  team_contractor_bool_exp: Team_Contractor_Bool_Exp;
  team_contractor_insert_input: Team_Contractor_Insert_Input;
  team_contractor_max_fields: Team_Contractor_Max_Fields;
  team_contractor_max_order_by: Team_Contractor_Max_Order_By;
  team_contractor_min_fields: Team_Contractor_Min_Fields;
  team_contractor_min_order_by: Team_Contractor_Min_Order_By;
  team_contractor_mutation_response: Team_Contractor_Mutation_Response;
  team_contractor_on_conflict: Team_Contractor_On_Conflict;
  team_contractor_order_by: Team_Contractor_Order_By;
  team_contractor_pk_columns_input: Team_Contractor_Pk_Columns_Input;
  team_contractor_set_input: Team_Contractor_Set_Input;
  team_contractor_stream_cursor_input: Team_Contractor_Stream_Cursor_Input;
  team_contractor_stream_cursor_value_input: Team_Contractor_Stream_Cursor_Value_Input;
  team_contractor_updates: Team_Contractor_Updates;
  team_insert_input: Team_Insert_Input;
  team_manager: Team_Manager;
  team_manager_aggregate: Team_Manager_Aggregate;
  team_manager_aggregate_bool_exp: Team_Manager_Aggregate_Bool_Exp;
  team_manager_aggregate_bool_exp_count: Team_Manager_Aggregate_Bool_Exp_Count;
  team_manager_aggregate_fields: Team_Manager_Aggregate_Fields;
  team_manager_aggregate_order_by: Team_Manager_Aggregate_Order_By;
  team_manager_arr_rel_insert_input: Team_Manager_Arr_Rel_Insert_Input;
  team_manager_bool_exp: Team_Manager_Bool_Exp;
  team_manager_insert_input: Team_Manager_Insert_Input;
  team_manager_max_fields: Team_Manager_Max_Fields;
  team_manager_max_order_by: Team_Manager_Max_Order_By;
  team_manager_min_fields: Team_Manager_Min_Fields;
  team_manager_min_order_by: Team_Manager_Min_Order_By;
  team_manager_mutation_response: Team_Manager_Mutation_Response;
  team_manager_on_conflict: Team_Manager_On_Conflict;
  team_manager_order_by: Team_Manager_Order_By;
  team_manager_pk_columns_input: Team_Manager_Pk_Columns_Input;
  team_manager_set_input: Team_Manager_Set_Input;
  team_manager_stream_cursor_input: Team_Manager_Stream_Cursor_Input;
  team_manager_stream_cursor_value_input: Team_Manager_Stream_Cursor_Value_Input;
  team_manager_updates: Team_Manager_Updates;
  team_max_fields: Team_Max_Fields;
  team_max_order_by: Team_Max_Order_By;
  team_min_fields: Team_Min_Fields;
  team_min_order_by: Team_Min_Order_By;
  team_mutation_response: Team_Mutation_Response;
  team_obj_rel_insert_input: Team_Obj_Rel_Insert_Input;
  team_on_conflict: Team_On_Conflict;
  team_order_by: Team_Order_By;
  team_pk_columns_input: Team_Pk_Columns_Input;
  team_posting: Team_Posting;
  team_posting_aggregate: Team_Posting_Aggregate;
  team_posting_aggregate_bool_exp: Team_Posting_Aggregate_Bool_Exp;
  team_posting_aggregate_bool_exp_count: Team_Posting_Aggregate_Bool_Exp_Count;
  team_posting_aggregate_fields: Team_Posting_Aggregate_Fields;
  team_posting_aggregate_order_by: Team_Posting_Aggregate_Order_By;
  team_posting_arr_rel_insert_input: Team_Posting_Arr_Rel_Insert_Input;
  team_posting_bool_exp: Team_Posting_Bool_Exp;
  team_posting_insert_input: Team_Posting_Insert_Input;
  team_posting_max_fields: Team_Posting_Max_Fields;
  team_posting_max_order_by: Team_Posting_Max_Order_By;
  team_posting_min_fields: Team_Posting_Min_Fields;
  team_posting_min_order_by: Team_Posting_Min_Order_By;
  team_posting_mutation_response: Team_Posting_Mutation_Response;
  team_posting_on_conflict: Team_Posting_On_Conflict;
  team_posting_order_by: Team_Posting_Order_By;
  team_posting_pk_columns_input: Team_Posting_Pk_Columns_Input;
  team_posting_set_input: Team_Posting_Set_Input;
  team_posting_stream_cursor_input: Team_Posting_Stream_Cursor_Input;
  team_posting_stream_cursor_value_input: Team_Posting_Stream_Cursor_Value_Input;
  team_posting_updates: Team_Posting_Updates;
  team_project: Team_Project;
  team_project_aggregate: Team_Project_Aggregate;
  team_project_aggregate_bool_exp: Team_Project_Aggregate_Bool_Exp;
  team_project_aggregate_bool_exp_count: Team_Project_Aggregate_Bool_Exp_Count;
  team_project_aggregate_fields: Team_Project_Aggregate_Fields;
  team_project_aggregate_order_by: Team_Project_Aggregate_Order_By;
  team_project_arr_rel_insert_input: Team_Project_Arr_Rel_Insert_Input;
  team_project_bool_exp: Team_Project_Bool_Exp;
  team_project_insert_input: Team_Project_Insert_Input;
  team_project_max_fields: Team_Project_Max_Fields;
  team_project_max_order_by: Team_Project_Max_Order_By;
  team_project_min_fields: Team_Project_Min_Fields;
  team_project_min_order_by: Team_Project_Min_Order_By;
  team_project_mutation_response: Team_Project_Mutation_Response;
  team_project_on_conflict: Team_Project_On_Conflict;
  team_project_order_by: Team_Project_Order_By;
  team_project_pk_columns_input: Team_Project_Pk_Columns_Input;
  team_project_set_input: Team_Project_Set_Input;
  team_project_stream_cursor_input: Team_Project_Stream_Cursor_Input;
  team_project_stream_cursor_value_input: Team_Project_Stream_Cursor_Value_Input;
  team_project_updates: Team_Project_Updates;
  team_set_input: Team_Set_Input;
  team_skill: Team_Skill;
  team_skill_aggregate: Team_Skill_Aggregate;
  team_skill_aggregate_bool_exp: Team_Skill_Aggregate_Bool_Exp;
  team_skill_aggregate_bool_exp_count: Team_Skill_Aggregate_Bool_Exp_Count;
  team_skill_aggregate_fields: Team_Skill_Aggregate_Fields;
  team_skill_aggregate_order_by: Team_Skill_Aggregate_Order_By;
  team_skill_arr_rel_insert_input: Team_Skill_Arr_Rel_Insert_Input;
  team_skill_avg_fields: Team_Skill_Avg_Fields;
  team_skill_avg_order_by: Team_Skill_Avg_Order_By;
  team_skill_bool_exp: Team_Skill_Bool_Exp;
  team_skill_inc_input: Team_Skill_Inc_Input;
  team_skill_insert_input: Team_Skill_Insert_Input;
  team_skill_max_fields: Team_Skill_Max_Fields;
  team_skill_max_order_by: Team_Skill_Max_Order_By;
  team_skill_min_fields: Team_Skill_Min_Fields;
  team_skill_min_order_by: Team_Skill_Min_Order_By;
  team_skill_mutation_response: Team_Skill_Mutation_Response;
  team_skill_on_conflict: Team_Skill_On_Conflict;
  team_skill_order_by: Team_Skill_Order_By;
  team_skill_pk_columns_input: Team_Skill_Pk_Columns_Input;
  team_skill_set_input: Team_Skill_Set_Input;
  team_skill_stddev_fields: Team_Skill_Stddev_Fields;
  team_skill_stddev_order_by: Team_Skill_Stddev_Order_By;
  team_skill_stddev_pop_fields: Team_Skill_Stddev_Pop_Fields;
  team_skill_stddev_pop_order_by: Team_Skill_Stddev_Pop_Order_By;
  team_skill_stddev_samp_fields: Team_Skill_Stddev_Samp_Fields;
  team_skill_stddev_samp_order_by: Team_Skill_Stddev_Samp_Order_By;
  team_skill_stream_cursor_input: Team_Skill_Stream_Cursor_Input;
  team_skill_stream_cursor_value_input: Team_Skill_Stream_Cursor_Value_Input;
  team_skill_sum_fields: Team_Skill_Sum_Fields;
  team_skill_sum_order_by: Team_Skill_Sum_Order_By;
  team_skill_updates: Team_Skill_Updates;
  team_skill_var_pop_fields: Team_Skill_Var_Pop_Fields;
  team_skill_var_pop_order_by: Team_Skill_Var_Pop_Order_By;
  team_skill_var_samp_fields: Team_Skill_Var_Samp_Fields;
  team_skill_var_samp_order_by: Team_Skill_Var_Samp_Order_By;
  team_skill_variance_fields: Team_Skill_Variance_Fields;
  team_skill_variance_order_by: Team_Skill_Variance_Order_By;
  team_stream_cursor_input: Team_Stream_Cursor_Input;
  team_stream_cursor_value_input: Team_Stream_Cursor_Value_Input;
  team_updates: Team_Updates;
  time: Scalars['time'];
  time_comparison_exp: Time_Comparison_Exp;
  timesheet: Timesheet;
  timesheet_aggregate: Timesheet_Aggregate;
  timesheet_aggregate_fields: Timesheet_Aggregate_Fields;
  timesheet_avg_fields: Timesheet_Avg_Fields;
  timesheet_bool_exp: Timesheet_Bool_Exp;
  timesheet_inc_input: Timesheet_Inc_Input;
  timesheet_insert_input: Timesheet_Insert_Input;
  timesheet_max_fields: Timesheet_Max_Fields;
  timesheet_min_fields: Timesheet_Min_Fields;
  timesheet_mutation_response: Timesheet_Mutation_Response;
  timesheet_obj_rel_insert_input: Timesheet_Obj_Rel_Insert_Input;
  timesheet_on_conflict: Timesheet_On_Conflict;
  timesheet_order_by: Timesheet_Order_By;
  timesheet_pk_columns_input: Timesheet_Pk_Columns_Input;
  timesheet_set_input: Timesheet_Set_Input;
  timesheet_stddev_fields: Timesheet_Stddev_Fields;
  timesheet_stddev_pop_fields: Timesheet_Stddev_Pop_Fields;
  timesheet_stddev_samp_fields: Timesheet_Stddev_Samp_Fields;
  timesheet_stream_cursor_input: Timesheet_Stream_Cursor_Input;
  timesheet_stream_cursor_value_input: Timesheet_Stream_Cursor_Value_Input;
  timesheet_sum_fields: Timesheet_Sum_Fields;
  timesheet_updates: Timesheet_Updates;
  timesheet_var_pop_fields: Timesheet_Var_Pop_Fields;
  timesheet_var_samp_fields: Timesheet_Var_Samp_Fields;
  timesheet_variance_fields: Timesheet_Variance_Fields;
  timestamp: Scalars['timestamp'];
  timestamp_comparison_exp: Timestamp_Comparison_Exp;
  timestamptz: Scalars['timestamptz'];
  timestamptz_comparison_exp: Timestamptz_Comparison_Exp;
  timetz: Scalars['timetz'];
  timetz_comparison_exp: Timetz_Comparison_Exp;
  type_of_visit: Type_Of_Visit;
  type_of_visit_aggregate: Type_Of_Visit_Aggregate;
  type_of_visit_aggregate_fields: Type_Of_Visit_Aggregate_Fields;
  type_of_visit_bool_exp: Type_Of_Visit_Bool_Exp;
  type_of_visit_enum_comparison_exp: Type_Of_Visit_Enum_Comparison_Exp;
  type_of_visit_insert_input: Type_Of_Visit_Insert_Input;
  type_of_visit_max_fields: Type_Of_Visit_Max_Fields;
  type_of_visit_min_fields: Type_Of_Visit_Min_Fields;
  type_of_visit_mutation_response: Type_Of_Visit_Mutation_Response;
  type_of_visit_on_conflict: Type_Of_Visit_On_Conflict;
  type_of_visit_order_by: Type_Of_Visit_Order_By;
  type_of_visit_pk_columns_input: Type_Of_Visit_Pk_Columns_Input;
  type_of_visit_set_input: Type_Of_Visit_Set_Input;
  type_of_visit_stream_cursor_input: Type_Of_Visit_Stream_Cursor_Input;
  type_of_visit_stream_cursor_value_input: Type_Of_Visit_Stream_Cursor_Value_Input;
  type_of_visit_updates: Type_Of_Visit_Updates;
  unread_messages: Unread_Messages;
  unread_messages_aggregate: Unread_Messages_Aggregate;
  unread_messages_aggregate_bool_exp: Unread_Messages_Aggregate_Bool_Exp;
  unread_messages_aggregate_bool_exp_count: Unread_Messages_Aggregate_Bool_Exp_Count;
  unread_messages_aggregate_fields: Unread_Messages_Aggregate_Fields;
  unread_messages_aggregate_order_by: Unread_Messages_Aggregate_Order_By;
  unread_messages_arr_rel_insert_input: Unread_Messages_Arr_Rel_Insert_Input;
  unread_messages_avg_fields: Unread_Messages_Avg_Fields;
  unread_messages_avg_order_by: Unread_Messages_Avg_Order_By;
  unread_messages_bool_exp: Unread_Messages_Bool_Exp;
  unread_messages_insert_input: Unread_Messages_Insert_Input;
  unread_messages_max_fields: Unread_Messages_Max_Fields;
  unread_messages_max_order_by: Unread_Messages_Max_Order_By;
  unread_messages_min_fields: Unread_Messages_Min_Fields;
  unread_messages_min_order_by: Unread_Messages_Min_Order_By;
  unread_messages_order_by: Unread_Messages_Order_By;
  unread_messages_stddev_fields: Unread_Messages_Stddev_Fields;
  unread_messages_stddev_order_by: Unread_Messages_Stddev_Order_By;
  unread_messages_stddev_pop_fields: Unread_Messages_Stddev_Pop_Fields;
  unread_messages_stddev_pop_order_by: Unread_Messages_Stddev_Pop_Order_By;
  unread_messages_stddev_samp_fields: Unread_Messages_Stddev_Samp_Fields;
  unread_messages_stddev_samp_order_by: Unread_Messages_Stddev_Samp_Order_By;
  unread_messages_stream_cursor_input: Unread_Messages_Stream_Cursor_Input;
  unread_messages_stream_cursor_value_input: Unread_Messages_Stream_Cursor_Value_Input;
  unread_messages_sum_fields: Unread_Messages_Sum_Fields;
  unread_messages_sum_order_by: Unread_Messages_Sum_Order_By;
  unread_messages_var_pop_fields: Unread_Messages_Var_Pop_Fields;
  unread_messages_var_pop_order_by: Unread_Messages_Var_Pop_Order_By;
  unread_messages_var_samp_fields: Unread_Messages_Var_Samp_Fields;
  unread_messages_var_samp_order_by: Unread_Messages_Var_Samp_Order_By;
  unread_messages_variance_fields: Unread_Messages_Variance_Fields;
  unread_messages_variance_order_by: Unread_Messages_Variance_Order_By;
  user: User;
  user_affinda_profile: User_Affinda_Profile;
  user_affinda_profile_aggregate: User_Affinda_Profile_Aggregate;
  user_affinda_profile_aggregate_fields: User_Affinda_Profile_Aggregate_Fields;
  user_affinda_profile_bool_exp: User_Affinda_Profile_Bool_Exp;
  user_affinda_profile_insert_input: User_Affinda_Profile_Insert_Input;
  user_affinda_profile_max_fields: User_Affinda_Profile_Max_Fields;
  user_affinda_profile_min_fields: User_Affinda_Profile_Min_Fields;
  user_affinda_profile_mutation_response: User_Affinda_Profile_Mutation_Response;
  user_affinda_profile_on_conflict: User_Affinda_Profile_On_Conflict;
  user_affinda_profile_order_by: User_Affinda_Profile_Order_By;
  user_affinda_profile_pk_columns_input: User_Affinda_Profile_Pk_Columns_Input;
  user_affinda_profile_set_input: User_Affinda_Profile_Set_Input;
  user_affinda_profile_stream_cursor_input: User_Affinda_Profile_Stream_Cursor_Input;
  user_affinda_profile_stream_cursor_value_input: User_Affinda_Profile_Stream_Cursor_Value_Input;
  user_affinda_profile_updates: User_Affinda_Profile_Updates;
  user_aggregate: User_Aggregate;
  user_aggregate_fields: User_Aggregate_Fields;
  user_append_input: User_Append_Input;
  user_avg_fields: User_Avg_Fields;
  user_bool_exp: User_Bool_Exp;
  user_certification: User_Certification;
  user_certification_aggregate: User_Certification_Aggregate;
  user_certification_aggregate_bool_exp: User_Certification_Aggregate_Bool_Exp;
  user_certification_aggregate_bool_exp_count: User_Certification_Aggregate_Bool_Exp_Count;
  user_certification_aggregate_fields: User_Certification_Aggregate_Fields;
  user_certification_aggregate_order_by: User_Certification_Aggregate_Order_By;
  user_certification_arr_rel_insert_input: User_Certification_Arr_Rel_Insert_Input;
  user_certification_avg_fields: User_Certification_Avg_Fields;
  user_certification_avg_order_by: User_Certification_Avg_Order_By;
  user_certification_bool_exp: User_Certification_Bool_Exp;
  user_certification_inc_input: User_Certification_Inc_Input;
  user_certification_insert_input: User_Certification_Insert_Input;
  user_certification_max_fields: User_Certification_Max_Fields;
  user_certification_max_order_by: User_Certification_Max_Order_By;
  user_certification_min_fields: User_Certification_Min_Fields;
  user_certification_min_order_by: User_Certification_Min_Order_By;
  user_certification_mutation_response: User_Certification_Mutation_Response;
  user_certification_on_conflict: User_Certification_On_Conflict;
  user_certification_order_by: User_Certification_Order_By;
  user_certification_pk_columns_input: User_Certification_Pk_Columns_Input;
  user_certification_set_input: User_Certification_Set_Input;
  user_certification_stddev_fields: User_Certification_Stddev_Fields;
  user_certification_stddev_order_by: User_Certification_Stddev_Order_By;
  user_certification_stddev_pop_fields: User_Certification_Stddev_Pop_Fields;
  user_certification_stddev_pop_order_by: User_Certification_Stddev_Pop_Order_By;
  user_certification_stddev_samp_fields: User_Certification_Stddev_Samp_Fields;
  user_certification_stddev_samp_order_by: User_Certification_Stddev_Samp_Order_By;
  user_certification_stream_cursor_input: User_Certification_Stream_Cursor_Input;
  user_certification_stream_cursor_value_input: User_Certification_Stream_Cursor_Value_Input;
  user_certification_sum_fields: User_Certification_Sum_Fields;
  user_certification_sum_order_by: User_Certification_Sum_Order_By;
  user_certification_updates: User_Certification_Updates;
  user_certification_var_pop_fields: User_Certification_Var_Pop_Fields;
  user_certification_var_pop_order_by: User_Certification_Var_Pop_Order_By;
  user_certification_var_samp_fields: User_Certification_Var_Samp_Fields;
  user_certification_var_samp_order_by: User_Certification_Var_Samp_Order_By;
  user_certification_variance_fields: User_Certification_Variance_Fields;
  user_certification_variance_order_by: User_Certification_Variance_Order_By;
  user_company: User_Company;
  user_company_aggregate: User_Company_Aggregate;
  user_company_aggregate_bool_exp: User_Company_Aggregate_Bool_Exp;
  user_company_aggregate_bool_exp_count: User_Company_Aggregate_Bool_Exp_Count;
  user_company_aggregate_fields: User_Company_Aggregate_Fields;
  user_company_aggregate_order_by: User_Company_Aggregate_Order_By;
  user_company_arr_rel_insert_input: User_Company_Arr_Rel_Insert_Input;
  user_company_bool_exp: User_Company_Bool_Exp;
  user_company_insert_input: User_Company_Insert_Input;
  user_company_max_fields: User_Company_Max_Fields;
  user_company_max_order_by: User_Company_Max_Order_By;
  user_company_min_fields: User_Company_Min_Fields;
  user_company_min_order_by: User_Company_Min_Order_By;
  user_company_mutation_response: User_Company_Mutation_Response;
  user_company_on_conflict: User_Company_On_Conflict;
  user_company_order_by: User_Company_Order_By;
  user_company_pk_columns_input: User_Company_Pk_Columns_Input;
  user_company_set_input: User_Company_Set_Input;
  user_company_stream_cursor_input: User_Company_Stream_Cursor_Input;
  user_company_stream_cursor_value_input: User_Company_Stream_Cursor_Value_Input;
  user_company_updates: User_Company_Updates;
  user_conversation: User_Conversation;
  user_conversation_aggregate: User_Conversation_Aggregate;
  user_conversation_aggregate_bool_exp: User_Conversation_Aggregate_Bool_Exp;
  user_conversation_aggregate_bool_exp_bool_and: User_Conversation_Aggregate_Bool_Exp_Bool_And;
  user_conversation_aggregate_bool_exp_bool_or: User_Conversation_Aggregate_Bool_Exp_Bool_Or;
  user_conversation_aggregate_bool_exp_count: User_Conversation_Aggregate_Bool_Exp_Count;
  user_conversation_aggregate_fields: User_Conversation_Aggregate_Fields;
  user_conversation_aggregate_order_by: User_Conversation_Aggregate_Order_By;
  user_conversation_arr_rel_insert_input: User_Conversation_Arr_Rel_Insert_Input;
  user_conversation_bool_exp: User_Conversation_Bool_Exp;
  user_conversation_insert_input: User_Conversation_Insert_Input;
  user_conversation_max_fields: User_Conversation_Max_Fields;
  user_conversation_max_order_by: User_Conversation_Max_Order_By;
  user_conversation_min_fields: User_Conversation_Min_Fields;
  user_conversation_min_order_by: User_Conversation_Min_Order_By;
  user_conversation_mutation_response: User_Conversation_Mutation_Response;
  user_conversation_on_conflict: User_Conversation_On_Conflict;
  user_conversation_order_by: User_Conversation_Order_By;
  user_conversation_pk_columns_input: User_Conversation_Pk_Columns_Input;
  user_conversation_set_input: User_Conversation_Set_Input;
  user_conversation_stream_cursor_input: User_Conversation_Stream_Cursor_Input;
  user_conversation_stream_cursor_value_input: User_Conversation_Stream_Cursor_Value_Input;
  user_conversation_updates: User_Conversation_Updates;
  user_delete_at_path_input: User_Delete_At_Path_Input;
  user_delete_elem_input: User_Delete_Elem_Input;
  user_delete_key_input: User_Delete_Key_Input;
  user_education: User_Education;
  user_education_aggregate: User_Education_Aggregate;
  user_education_aggregate_bool_exp: User_Education_Aggregate_Bool_Exp;
  user_education_aggregate_bool_exp_count: User_Education_Aggregate_Bool_Exp_Count;
  user_education_aggregate_fields: User_Education_Aggregate_Fields;
  user_education_aggregate_order_by: User_Education_Aggregate_Order_By;
  user_education_arr_rel_insert_input: User_Education_Arr_Rel_Insert_Input;
  user_education_avg_fields: User_Education_Avg_Fields;
  user_education_avg_order_by: User_Education_Avg_Order_By;
  user_education_bool_exp: User_Education_Bool_Exp;
  user_education_inc_input: User_Education_Inc_Input;
  user_education_insert_input: User_Education_Insert_Input;
  user_education_max_fields: User_Education_Max_Fields;
  user_education_max_order_by: User_Education_Max_Order_By;
  user_education_min_fields: User_Education_Min_Fields;
  user_education_min_order_by: User_Education_Min_Order_By;
  user_education_mutation_response: User_Education_Mutation_Response;
  user_education_on_conflict: User_Education_On_Conflict;
  user_education_order_by: User_Education_Order_By;
  user_education_pk_columns_input: User_Education_Pk_Columns_Input;
  user_education_set_input: User_Education_Set_Input;
  user_education_stddev_fields: User_Education_Stddev_Fields;
  user_education_stddev_order_by: User_Education_Stddev_Order_By;
  user_education_stddev_pop_fields: User_Education_Stddev_Pop_Fields;
  user_education_stddev_pop_order_by: User_Education_Stddev_Pop_Order_By;
  user_education_stddev_samp_fields: User_Education_Stddev_Samp_Fields;
  user_education_stddev_samp_order_by: User_Education_Stddev_Samp_Order_By;
  user_education_stream_cursor_input: User_Education_Stream_Cursor_Input;
  user_education_stream_cursor_value_input: User_Education_Stream_Cursor_Value_Input;
  user_education_sum_fields: User_Education_Sum_Fields;
  user_education_sum_order_by: User_Education_Sum_Order_By;
  user_education_updates: User_Education_Updates;
  user_education_var_pop_fields: User_Education_Var_Pop_Fields;
  user_education_var_pop_order_by: User_Education_Var_Pop_Order_By;
  user_education_var_samp_fields: User_Education_Var_Samp_Fields;
  user_education_var_samp_order_by: User_Education_Var_Samp_Order_By;
  user_education_variance_fields: User_Education_Variance_Fields;
  user_education_variance_order_by: User_Education_Variance_Order_By;
  user_experience: User_Experience;
  user_experience_aggregate: User_Experience_Aggregate;
  user_experience_aggregate_bool_exp: User_Experience_Aggregate_Bool_Exp;
  user_experience_aggregate_bool_exp_bool_and: User_Experience_Aggregate_Bool_Exp_Bool_And;
  user_experience_aggregate_bool_exp_bool_or: User_Experience_Aggregate_Bool_Exp_Bool_Or;
  user_experience_aggregate_bool_exp_count: User_Experience_Aggregate_Bool_Exp_Count;
  user_experience_aggregate_fields: User_Experience_Aggregate_Fields;
  user_experience_aggregate_order_by: User_Experience_Aggregate_Order_By;
  user_experience_arr_rel_insert_input: User_Experience_Arr_Rel_Insert_Input;
  user_experience_avg_fields: User_Experience_Avg_Fields;
  user_experience_avg_order_by: User_Experience_Avg_Order_By;
  user_experience_bool_exp: User_Experience_Bool_Exp;
  user_experience_inc_input: User_Experience_Inc_Input;
  user_experience_insert_input: User_Experience_Insert_Input;
  user_experience_max_fields: User_Experience_Max_Fields;
  user_experience_max_order_by: User_Experience_Max_Order_By;
  user_experience_min_fields: User_Experience_Min_Fields;
  user_experience_min_order_by: User_Experience_Min_Order_By;
  user_experience_mutation_response: User_Experience_Mutation_Response;
  user_experience_obj_rel_insert_input: User_Experience_Obj_Rel_Insert_Input;
  user_experience_on_conflict: User_Experience_On_Conflict;
  user_experience_order_by: User_Experience_Order_By;
  user_experience_pk_columns_input: User_Experience_Pk_Columns_Input;
  user_experience_set_input: User_Experience_Set_Input;
  user_experience_stddev_fields: User_Experience_Stddev_Fields;
  user_experience_stddev_order_by: User_Experience_Stddev_Order_By;
  user_experience_stddev_pop_fields: User_Experience_Stddev_Pop_Fields;
  user_experience_stddev_pop_order_by: User_Experience_Stddev_Pop_Order_By;
  user_experience_stddev_samp_fields: User_Experience_Stddev_Samp_Fields;
  user_experience_stddev_samp_order_by: User_Experience_Stddev_Samp_Order_By;
  user_experience_stream_cursor_input: User_Experience_Stream_Cursor_Input;
  user_experience_stream_cursor_value_input: User_Experience_Stream_Cursor_Value_Input;
  user_experience_sum_fields: User_Experience_Sum_Fields;
  user_experience_sum_order_by: User_Experience_Sum_Order_By;
  user_experience_updates: User_Experience_Updates;
  user_experience_var_pop_fields: User_Experience_Var_Pop_Fields;
  user_experience_var_pop_order_by: User_Experience_Var_Pop_Order_By;
  user_experience_var_samp_fields: User_Experience_Var_Samp_Fields;
  user_experience_var_samp_order_by: User_Experience_Var_Samp_Order_By;
  user_experience_variance_fields: User_Experience_Variance_Fields;
  user_experience_variance_order_by: User_Experience_Variance_Order_By;
  user_favorite: User_Favorite;
  user_favorite_aggregate: User_Favorite_Aggregate;
  user_favorite_aggregate_bool_exp: User_Favorite_Aggregate_Bool_Exp;
  user_favorite_aggregate_bool_exp_count: User_Favorite_Aggregate_Bool_Exp_Count;
  user_favorite_aggregate_fields: User_Favorite_Aggregate_Fields;
  user_favorite_aggregate_order_by: User_Favorite_Aggregate_Order_By;
  user_favorite_arr_rel_insert_input: User_Favorite_Arr_Rel_Insert_Input;
  user_favorite_bool_exp: User_Favorite_Bool_Exp;
  user_favorite_insert_input: User_Favorite_Insert_Input;
  user_favorite_max_fields: User_Favorite_Max_Fields;
  user_favorite_max_order_by: User_Favorite_Max_Order_By;
  user_favorite_min_fields: User_Favorite_Min_Fields;
  user_favorite_min_order_by: User_Favorite_Min_Order_By;
  user_favorite_mutation_response: User_Favorite_Mutation_Response;
  user_favorite_on_conflict: User_Favorite_On_Conflict;
  user_favorite_order_by: User_Favorite_Order_By;
  user_favorite_pk_columns_input: User_Favorite_Pk_Columns_Input;
  user_favorite_set_input: User_Favorite_Set_Input;
  user_favorite_stream_cursor_input: User_Favorite_Stream_Cursor_Input;
  user_favorite_stream_cursor_value_input: User_Favorite_Stream_Cursor_Value_Input;
  user_favorite_updates: User_Favorite_Updates;
  user_inc_input: User_Inc_Input;
  user_industry: User_Industry;
  user_industry_aggregate: User_Industry_Aggregate;
  user_industry_aggregate_bool_exp: User_Industry_Aggregate_Bool_Exp;
  user_industry_aggregate_bool_exp_count: User_Industry_Aggregate_Bool_Exp_Count;
  user_industry_aggregate_fields: User_Industry_Aggregate_Fields;
  user_industry_aggregate_order_by: User_Industry_Aggregate_Order_By;
  user_industry_arr_rel_insert_input: User_Industry_Arr_Rel_Insert_Input;
  user_industry_avg_fields: User_Industry_Avg_Fields;
  user_industry_avg_order_by: User_Industry_Avg_Order_By;
  user_industry_bool_exp: User_Industry_Bool_Exp;
  user_industry_inc_input: User_Industry_Inc_Input;
  user_industry_insert_input: User_Industry_Insert_Input;
  user_industry_max_fields: User_Industry_Max_Fields;
  user_industry_max_order_by: User_Industry_Max_Order_By;
  user_industry_min_fields: User_Industry_Min_Fields;
  user_industry_min_order_by: User_Industry_Min_Order_By;
  user_industry_mutation_response: User_Industry_Mutation_Response;
  user_industry_on_conflict: User_Industry_On_Conflict;
  user_industry_order_by: User_Industry_Order_By;
  user_industry_pk_columns_input: User_Industry_Pk_Columns_Input;
  user_industry_set_input: User_Industry_Set_Input;
  user_industry_stddev_fields: User_Industry_Stddev_Fields;
  user_industry_stddev_order_by: User_Industry_Stddev_Order_By;
  user_industry_stddev_pop_fields: User_Industry_Stddev_Pop_Fields;
  user_industry_stddev_pop_order_by: User_Industry_Stddev_Pop_Order_By;
  user_industry_stddev_samp_fields: User_Industry_Stddev_Samp_Fields;
  user_industry_stddev_samp_order_by: User_Industry_Stddev_Samp_Order_By;
  user_industry_stream_cursor_input: User_Industry_Stream_Cursor_Input;
  user_industry_stream_cursor_value_input: User_Industry_Stream_Cursor_Value_Input;
  user_industry_sum_fields: User_Industry_Sum_Fields;
  user_industry_sum_order_by: User_Industry_Sum_Order_By;
  user_industry_updates: User_Industry_Updates;
  user_industry_var_pop_fields: User_Industry_Var_Pop_Fields;
  user_industry_var_pop_order_by: User_Industry_Var_Pop_Order_By;
  user_industry_var_samp_fields: User_Industry_Var_Samp_Fields;
  user_industry_var_samp_order_by: User_Industry_Var_Samp_Order_By;
  user_industry_variance_fields: User_Industry_Variance_Fields;
  user_industry_variance_order_by: User_Industry_Variance_Order_By;
  user_insert_input: User_Insert_Input;
  user_job_title: User_Job_Title;
  user_job_title_aggregate: User_Job_Title_Aggregate;
  user_job_title_aggregate_bool_exp: User_Job_Title_Aggregate_Bool_Exp;
  user_job_title_aggregate_bool_exp_count: User_Job_Title_Aggregate_Bool_Exp_Count;
  user_job_title_aggregate_fields: User_Job_Title_Aggregate_Fields;
  user_job_title_aggregate_order_by: User_Job_Title_Aggregate_Order_By;
  user_job_title_arr_rel_insert_input: User_Job_Title_Arr_Rel_Insert_Input;
  user_job_title_avg_fields: User_Job_Title_Avg_Fields;
  user_job_title_avg_order_by: User_Job_Title_Avg_Order_By;
  user_job_title_bool_exp: User_Job_Title_Bool_Exp;
  user_job_title_inc_input: User_Job_Title_Inc_Input;
  user_job_title_insert_input: User_Job_Title_Insert_Input;
  user_job_title_max_fields: User_Job_Title_Max_Fields;
  user_job_title_max_order_by: User_Job_Title_Max_Order_By;
  user_job_title_min_fields: User_Job_Title_Min_Fields;
  user_job_title_min_order_by: User_Job_Title_Min_Order_By;
  user_job_title_mutation_response: User_Job_Title_Mutation_Response;
  user_job_title_obj_rel_insert_input: User_Job_Title_Obj_Rel_Insert_Input;
  user_job_title_on_conflict: User_Job_Title_On_Conflict;
  user_job_title_order_by: User_Job_Title_Order_By;
  user_job_title_pk_columns_input: User_Job_Title_Pk_Columns_Input;
  user_job_title_set_input: User_Job_Title_Set_Input;
  user_job_title_stddev_fields: User_Job_Title_Stddev_Fields;
  user_job_title_stddev_order_by: User_Job_Title_Stddev_Order_By;
  user_job_title_stddev_pop_fields: User_Job_Title_Stddev_Pop_Fields;
  user_job_title_stddev_pop_order_by: User_Job_Title_Stddev_Pop_Order_By;
  user_job_title_stddev_samp_fields: User_Job_Title_Stddev_Samp_Fields;
  user_job_title_stddev_samp_order_by: User_Job_Title_Stddev_Samp_Order_By;
  user_job_title_stream_cursor_input: User_Job_Title_Stream_Cursor_Input;
  user_job_title_stream_cursor_value_input: User_Job_Title_Stream_Cursor_Value_Input;
  user_job_title_sum_fields: User_Job_Title_Sum_Fields;
  user_job_title_sum_order_by: User_Job_Title_Sum_Order_By;
  user_job_title_updates: User_Job_Title_Updates;
  user_job_title_var_pop_fields: User_Job_Title_Var_Pop_Fields;
  user_job_title_var_pop_order_by: User_Job_Title_Var_Pop_Order_By;
  user_job_title_var_samp_fields: User_Job_Title_Var_Samp_Fields;
  user_job_title_var_samp_order_by: User_Job_Title_Var_Samp_Order_By;
  user_job_title_variance_fields: User_Job_Title_Variance_Fields;
  user_job_title_variance_order_by: User_Job_Title_Variance_Order_By;
  user_language: User_Language;
  user_language_aggregate: User_Language_Aggregate;
  user_language_aggregate_bool_exp: User_Language_Aggregate_Bool_Exp;
  user_language_aggregate_bool_exp_count: User_Language_Aggregate_Bool_Exp_Count;
  user_language_aggregate_fields: User_Language_Aggregate_Fields;
  user_language_aggregate_order_by: User_Language_Aggregate_Order_By;
  user_language_arr_rel_insert_input: User_Language_Arr_Rel_Insert_Input;
  user_language_avg_fields: User_Language_Avg_Fields;
  user_language_avg_order_by: User_Language_Avg_Order_By;
  user_language_bool_exp: User_Language_Bool_Exp;
  user_language_inc_input: User_Language_Inc_Input;
  user_language_insert_input: User_Language_Insert_Input;
  user_language_max_fields: User_Language_Max_Fields;
  user_language_max_order_by: User_Language_Max_Order_By;
  user_language_min_fields: User_Language_Min_Fields;
  user_language_min_order_by: User_Language_Min_Order_By;
  user_language_mutation_response: User_Language_Mutation_Response;
  user_language_on_conflict: User_Language_On_Conflict;
  user_language_order_by: User_Language_Order_By;
  user_language_pk_columns_input: User_Language_Pk_Columns_Input;
  user_language_set_input: User_Language_Set_Input;
  user_language_stddev_fields: User_Language_Stddev_Fields;
  user_language_stddev_order_by: User_Language_Stddev_Order_By;
  user_language_stddev_pop_fields: User_Language_Stddev_Pop_Fields;
  user_language_stddev_pop_order_by: User_Language_Stddev_Pop_Order_By;
  user_language_stddev_samp_fields: User_Language_Stddev_Samp_Fields;
  user_language_stddev_samp_order_by: User_Language_Stddev_Samp_Order_By;
  user_language_stream_cursor_input: User_Language_Stream_Cursor_Input;
  user_language_stream_cursor_value_input: User_Language_Stream_Cursor_Value_Input;
  user_language_sum_fields: User_Language_Sum_Fields;
  user_language_sum_order_by: User_Language_Sum_Order_By;
  user_language_updates: User_Language_Updates;
  user_language_var_pop_fields: User_Language_Var_Pop_Fields;
  user_language_var_pop_order_by: User_Language_Var_Pop_Order_By;
  user_language_var_samp_fields: User_Language_Var_Samp_Fields;
  user_language_var_samp_order_by: User_Language_Var_Samp_Order_By;
  user_language_variance_fields: User_Language_Variance_Fields;
  user_language_variance_order_by: User_Language_Variance_Order_By;
  user_max_fields: User_Max_Fields;
  user_min_fields: User_Min_Fields;
  user_mutation_response: User_Mutation_Response;
  user_obj_rel_insert_input: User_Obj_Rel_Insert_Input;
  user_on_conflict: User_On_Conflict;
  user_order_by: User_Order_By;
  user_pk_columns_input: User_Pk_Columns_Input;
  user_prepend_input: User_Prepend_Input;
  user_private_data: User_Private_Data;
  user_private_data_aggregate: User_Private_Data_Aggregate;
  user_private_data_aggregate_fields: User_Private_Data_Aggregate_Fields;
  user_private_data_avg_fields: User_Private_Data_Avg_Fields;
  user_private_data_bool_exp: User_Private_Data_Bool_Exp;
  user_private_data_inc_input: User_Private_Data_Inc_Input;
  user_private_data_insert_input: User_Private_Data_Insert_Input;
  user_private_data_max_fields: User_Private_Data_Max_Fields;
  user_private_data_min_fields: User_Private_Data_Min_Fields;
  user_private_data_mutation_response: User_Private_Data_Mutation_Response;
  user_private_data_obj_rel_insert_input: User_Private_Data_Obj_Rel_Insert_Input;
  user_private_data_order_by: User_Private_Data_Order_By;
  user_private_data_set_input: User_Private_Data_Set_Input;
  user_private_data_stddev_fields: User_Private_Data_Stddev_Fields;
  user_private_data_stddev_pop_fields: User_Private_Data_Stddev_Pop_Fields;
  user_private_data_stddev_samp_fields: User_Private_Data_Stddev_Samp_Fields;
  user_private_data_stream_cursor_input: User_Private_Data_Stream_Cursor_Input;
  user_private_data_stream_cursor_value_input: User_Private_Data_Stream_Cursor_Value_Input;
  user_private_data_sum_fields: User_Private_Data_Sum_Fields;
  user_private_data_updates: User_Private_Data_Updates;
  user_private_data_var_pop_fields: User_Private_Data_Var_Pop_Fields;
  user_private_data_var_samp_fields: User_Private_Data_Var_Samp_Fields;
  user_private_data_variance_fields: User_Private_Data_Variance_Fields;
  user_profile: User_Profile;
  user_profile_aggregate: User_Profile_Aggregate;
  user_profile_aggregate_bool_exp: User_Profile_Aggregate_Bool_Exp;
  user_profile_aggregate_bool_exp_bool_and: User_Profile_Aggregate_Bool_Exp_Bool_And;
  user_profile_aggregate_bool_exp_bool_or: User_Profile_Aggregate_Bool_Exp_Bool_Or;
  user_profile_aggregate_bool_exp_count: User_Profile_Aggregate_Bool_Exp_Count;
  user_profile_aggregate_fields: User_Profile_Aggregate_Fields;
  user_profile_aggregate_order_by: User_Profile_Aggregate_Order_By;
  user_profile_arr_rel_insert_input: User_Profile_Arr_Rel_Insert_Input;
  user_profile_avg_fields: User_Profile_Avg_Fields;
  user_profile_avg_order_by: User_Profile_Avg_Order_By;
  user_profile_bool_exp: User_Profile_Bool_Exp;
  user_profile_by_management: User_Profile_By_Management;
  user_profile_by_management_aggregate: User_Profile_By_Management_Aggregate;
  user_profile_by_management_aggregate_bool_exp: User_Profile_By_Management_Aggregate_Bool_Exp;
  user_profile_by_management_aggregate_bool_exp_count: User_Profile_By_Management_Aggregate_Bool_Exp_Count;
  user_profile_by_management_aggregate_fields: User_Profile_By_Management_Aggregate_Fields;
  user_profile_by_management_aggregate_order_by: User_Profile_By_Management_Aggregate_Order_By;
  user_profile_by_management_arr_rel_insert_input: User_Profile_By_Management_Arr_Rel_Insert_Input;
  user_profile_by_management_avg_fields: User_Profile_By_Management_Avg_Fields;
  user_profile_by_management_avg_order_by: User_Profile_By_Management_Avg_Order_By;
  user_profile_by_management_bool_exp: User_Profile_By_Management_Bool_Exp;
  user_profile_by_management_inc_input: User_Profile_By_Management_Inc_Input;
  user_profile_by_management_insert_input: User_Profile_By_Management_Insert_Input;
  user_profile_by_management_max_fields: User_Profile_By_Management_Max_Fields;
  user_profile_by_management_max_order_by: User_Profile_By_Management_Max_Order_By;
  user_profile_by_management_min_fields: User_Profile_By_Management_Min_Fields;
  user_profile_by_management_min_order_by: User_Profile_By_Management_Min_Order_By;
  user_profile_by_management_mutation_response: User_Profile_By_Management_Mutation_Response;
  user_profile_by_management_on_conflict: User_Profile_By_Management_On_Conflict;
  user_profile_by_management_order_by: User_Profile_By_Management_Order_By;
  user_profile_by_management_pk_columns_input: User_Profile_By_Management_Pk_Columns_Input;
  user_profile_by_management_set_input: User_Profile_By_Management_Set_Input;
  user_profile_by_management_stddev_fields: User_Profile_By_Management_Stddev_Fields;
  user_profile_by_management_stddev_order_by: User_Profile_By_Management_Stddev_Order_By;
  user_profile_by_management_stddev_pop_fields: User_Profile_By_Management_Stddev_Pop_Fields;
  user_profile_by_management_stddev_pop_order_by: User_Profile_By_Management_Stddev_Pop_Order_By;
  user_profile_by_management_stddev_samp_fields: User_Profile_By_Management_Stddev_Samp_Fields;
  user_profile_by_management_stddev_samp_order_by: User_Profile_By_Management_Stddev_Samp_Order_By;
  user_profile_by_management_stream_cursor_input: User_Profile_By_Management_Stream_Cursor_Input;
  user_profile_by_management_stream_cursor_value_input: User_Profile_By_Management_Stream_Cursor_Value_Input;
  user_profile_by_management_sum_fields: User_Profile_By_Management_Sum_Fields;
  user_profile_by_management_sum_order_by: User_Profile_By_Management_Sum_Order_By;
  user_profile_by_management_updates: User_Profile_By_Management_Updates;
  user_profile_by_management_var_pop_fields: User_Profile_By_Management_Var_Pop_Fields;
  user_profile_by_management_var_pop_order_by: User_Profile_By_Management_Var_Pop_Order_By;
  user_profile_by_management_var_samp_fields: User_Profile_By_Management_Var_Samp_Fields;
  user_profile_by_management_var_samp_order_by: User_Profile_By_Management_Var_Samp_Order_By;
  user_profile_by_management_variance_fields: User_Profile_By_Management_Variance_Fields;
  user_profile_by_management_variance_order_by: User_Profile_By_Management_Variance_Order_By;
  user_profile_inc_input: User_Profile_Inc_Input;
  user_profile_insert_input: User_Profile_Insert_Input;
  user_profile_max_fields: User_Profile_Max_Fields;
  user_profile_max_order_by: User_Profile_Max_Order_By;
  user_profile_min_fields: User_Profile_Min_Fields;
  user_profile_min_order_by: User_Profile_Min_Order_By;
  user_profile_mutation_response: User_Profile_Mutation_Response;
  user_profile_obj_rel_insert_input: User_Profile_Obj_Rel_Insert_Input;
  user_profile_on_conflict: User_Profile_On_Conflict;
  user_profile_order_by: User_Profile_Order_By;
  user_profile_pk_columns_input: User_Profile_Pk_Columns_Input;
  user_profile_set_input: User_Profile_Set_Input;
  user_profile_stddev_fields: User_Profile_Stddev_Fields;
  user_profile_stddev_order_by: User_Profile_Stddev_Order_By;
  user_profile_stddev_pop_fields: User_Profile_Stddev_Pop_Fields;
  user_profile_stddev_pop_order_by: User_Profile_Stddev_Pop_Order_By;
  user_profile_stddev_samp_fields: User_Profile_Stddev_Samp_Fields;
  user_profile_stddev_samp_order_by: User_Profile_Stddev_Samp_Order_By;
  user_profile_stream_cursor_input: User_Profile_Stream_Cursor_Input;
  user_profile_stream_cursor_value_input: User_Profile_Stream_Cursor_Value_Input;
  user_profile_sum_fields: User_Profile_Sum_Fields;
  user_profile_sum_order_by: User_Profile_Sum_Order_By;
  user_profile_updates: User_Profile_Updates;
  user_profile_var_pop_fields: User_Profile_Var_Pop_Fields;
  user_profile_var_pop_order_by: User_Profile_Var_Pop_Order_By;
  user_profile_var_samp_fields: User_Profile_Var_Samp_Fields;
  user_profile_var_samp_order_by: User_Profile_Var_Samp_Order_By;
  user_profile_variance_fields: User_Profile_Variance_Fields;
  user_profile_variance_order_by: User_Profile_Variance_Order_By;
  user_rating: User_Rating;
  user_rating_aggregate: User_Rating_Aggregate;
  user_rating_aggregate_bool_exp: User_Rating_Aggregate_Bool_Exp;
  user_rating_aggregate_bool_exp_count: User_Rating_Aggregate_Bool_Exp_Count;
  user_rating_aggregate_fields: User_Rating_Aggregate_Fields;
  user_rating_aggregate_order_by: User_Rating_Aggregate_Order_By;
  user_rating_arr_rel_insert_input: User_Rating_Arr_Rel_Insert_Input;
  user_rating_avg_fields: User_Rating_Avg_Fields;
  user_rating_avg_order_by: User_Rating_Avg_Order_By;
  user_rating_bool_exp: User_Rating_Bool_Exp;
  user_rating_inc_input: User_Rating_Inc_Input;
  user_rating_insert_input: User_Rating_Insert_Input;
  user_rating_max_fields: User_Rating_Max_Fields;
  user_rating_max_order_by: User_Rating_Max_Order_By;
  user_rating_min_fields: User_Rating_Min_Fields;
  user_rating_min_order_by: User_Rating_Min_Order_By;
  user_rating_mutation_response: User_Rating_Mutation_Response;
  user_rating_on_conflict: User_Rating_On_Conflict;
  user_rating_order_by: User_Rating_Order_By;
  user_rating_pk_columns_input: User_Rating_Pk_Columns_Input;
  user_rating_set_input: User_Rating_Set_Input;
  user_rating_stddev_fields: User_Rating_Stddev_Fields;
  user_rating_stddev_order_by: User_Rating_Stddev_Order_By;
  user_rating_stddev_pop_fields: User_Rating_Stddev_Pop_Fields;
  user_rating_stddev_pop_order_by: User_Rating_Stddev_Pop_Order_By;
  user_rating_stddev_samp_fields: User_Rating_Stddev_Samp_Fields;
  user_rating_stddev_samp_order_by: User_Rating_Stddev_Samp_Order_By;
  user_rating_stream_cursor_input: User_Rating_Stream_Cursor_Input;
  user_rating_stream_cursor_value_input: User_Rating_Stream_Cursor_Value_Input;
  user_rating_sum_fields: User_Rating_Sum_Fields;
  user_rating_sum_order_by: User_Rating_Sum_Order_By;
  user_rating_updates: User_Rating_Updates;
  user_rating_var_pop_fields: User_Rating_Var_Pop_Fields;
  user_rating_var_pop_order_by: User_Rating_Var_Pop_Order_By;
  user_rating_var_samp_fields: User_Rating_Var_Samp_Fields;
  user_rating_var_samp_order_by: User_Rating_Var_Samp_Order_By;
  user_rating_variance_fields: User_Rating_Variance_Fields;
  user_rating_variance_order_by: User_Rating_Variance_Order_By;
  user_set_input: User_Set_Input;
  user_skill: User_Skill;
  user_skill_aggregate: User_Skill_Aggregate;
  user_skill_aggregate_bool_exp: User_Skill_Aggregate_Bool_Exp;
  user_skill_aggregate_bool_exp_count: User_Skill_Aggregate_Bool_Exp_Count;
  user_skill_aggregate_fields: User_Skill_Aggregate_Fields;
  user_skill_aggregate_order_by: User_Skill_Aggregate_Order_By;
  user_skill_arr_rel_insert_input: User_Skill_Arr_Rel_Insert_Input;
  user_skill_avg_fields: User_Skill_Avg_Fields;
  user_skill_avg_order_by: User_Skill_Avg_Order_By;
  user_skill_bool_exp: User_Skill_Bool_Exp;
  user_skill_inc_input: User_Skill_Inc_Input;
  user_skill_insert_input: User_Skill_Insert_Input;
  user_skill_max_fields: User_Skill_Max_Fields;
  user_skill_max_order_by: User_Skill_Max_Order_By;
  user_skill_min_fields: User_Skill_Min_Fields;
  user_skill_min_order_by: User_Skill_Min_Order_By;
  user_skill_mutation_response: User_Skill_Mutation_Response;
  user_skill_on_conflict: User_Skill_On_Conflict;
  user_skill_order_by: User_Skill_Order_By;
  user_skill_pk_columns_input: User_Skill_Pk_Columns_Input;
  user_skill_set_input: User_Skill_Set_Input;
  user_skill_stddev_fields: User_Skill_Stddev_Fields;
  user_skill_stddev_order_by: User_Skill_Stddev_Order_By;
  user_skill_stddev_pop_fields: User_Skill_Stddev_Pop_Fields;
  user_skill_stddev_pop_order_by: User_Skill_Stddev_Pop_Order_By;
  user_skill_stddev_samp_fields: User_Skill_Stddev_Samp_Fields;
  user_skill_stddev_samp_order_by: User_Skill_Stddev_Samp_Order_By;
  user_skill_stream_cursor_input: User_Skill_Stream_Cursor_Input;
  user_skill_stream_cursor_value_input: User_Skill_Stream_Cursor_Value_Input;
  user_skill_sum_fields: User_Skill_Sum_Fields;
  user_skill_sum_order_by: User_Skill_Sum_Order_By;
  user_skill_updates: User_Skill_Updates;
  user_skill_var_pop_fields: User_Skill_Var_Pop_Fields;
  user_skill_var_pop_order_by: User_Skill_Var_Pop_Order_By;
  user_skill_var_samp_fields: User_Skill_Var_Samp_Fields;
  user_skill_var_samp_order_by: User_Skill_Var_Samp_Order_By;
  user_skill_variance_fields: User_Skill_Variance_Fields;
  user_skill_variance_order_by: User_Skill_Variance_Order_By;
  user_soft_skill: User_Soft_Skill;
  user_soft_skill_aggregate: User_Soft_Skill_Aggregate;
  user_soft_skill_aggregate_bool_exp: User_Soft_Skill_Aggregate_Bool_Exp;
  user_soft_skill_aggregate_bool_exp_count: User_Soft_Skill_Aggregate_Bool_Exp_Count;
  user_soft_skill_aggregate_fields: User_Soft_Skill_Aggregate_Fields;
  user_soft_skill_aggregate_order_by: User_Soft_Skill_Aggregate_Order_By;
  user_soft_skill_arr_rel_insert_input: User_Soft_Skill_Arr_Rel_Insert_Input;
  user_soft_skill_avg_fields: User_Soft_Skill_Avg_Fields;
  user_soft_skill_avg_order_by: User_Soft_Skill_Avg_Order_By;
  user_soft_skill_bool_exp: User_Soft_Skill_Bool_Exp;
  user_soft_skill_inc_input: User_Soft_Skill_Inc_Input;
  user_soft_skill_insert_input: User_Soft_Skill_Insert_Input;
  user_soft_skill_max_fields: User_Soft_Skill_Max_Fields;
  user_soft_skill_max_order_by: User_Soft_Skill_Max_Order_By;
  user_soft_skill_min_fields: User_Soft_Skill_Min_Fields;
  user_soft_skill_min_order_by: User_Soft_Skill_Min_Order_By;
  user_soft_skill_mutation_response: User_Soft_Skill_Mutation_Response;
  user_soft_skill_on_conflict: User_Soft_Skill_On_Conflict;
  user_soft_skill_order_by: User_Soft_Skill_Order_By;
  user_soft_skill_pk_columns_input: User_Soft_Skill_Pk_Columns_Input;
  user_soft_skill_set_input: User_Soft_Skill_Set_Input;
  user_soft_skill_stddev_fields: User_Soft_Skill_Stddev_Fields;
  user_soft_skill_stddev_order_by: User_Soft_Skill_Stddev_Order_By;
  user_soft_skill_stddev_pop_fields: User_Soft_Skill_Stddev_Pop_Fields;
  user_soft_skill_stddev_pop_order_by: User_Soft_Skill_Stddev_Pop_Order_By;
  user_soft_skill_stddev_samp_fields: User_Soft_Skill_Stddev_Samp_Fields;
  user_soft_skill_stddev_samp_order_by: User_Soft_Skill_Stddev_Samp_Order_By;
  user_soft_skill_stream_cursor_input: User_Soft_Skill_Stream_Cursor_Input;
  user_soft_skill_stream_cursor_value_input: User_Soft_Skill_Stream_Cursor_Value_Input;
  user_soft_skill_sum_fields: User_Soft_Skill_Sum_Fields;
  user_soft_skill_sum_order_by: User_Soft_Skill_Sum_Order_By;
  user_soft_skill_updates: User_Soft_Skill_Updates;
  user_soft_skill_var_pop_fields: User_Soft_Skill_Var_Pop_Fields;
  user_soft_skill_var_pop_order_by: User_Soft_Skill_Var_Pop_Order_By;
  user_soft_skill_var_samp_fields: User_Soft_Skill_Var_Samp_Fields;
  user_soft_skill_var_samp_order_by: User_Soft_Skill_Var_Samp_Order_By;
  user_soft_skill_variance_fields: User_Soft_Skill_Variance_Fields;
  user_soft_skill_variance_order_by: User_Soft_Skill_Variance_Order_By;
  user_stddev_fields: User_Stddev_Fields;
  user_stddev_pop_fields: User_Stddev_Pop_Fields;
  user_stddev_samp_fields: User_Stddev_Samp_Fields;
  user_stream_cursor_input: User_Stream_Cursor_Input;
  user_stream_cursor_value_input: User_Stream_Cursor_Value_Input;
  user_sum_fields: User_Sum_Fields;
  user_transportation: User_Transportation;
  user_transportation_aggregate: User_Transportation_Aggregate;
  user_transportation_aggregate_bool_exp: User_Transportation_Aggregate_Bool_Exp;
  user_transportation_aggregate_bool_exp_count: User_Transportation_Aggregate_Bool_Exp_Count;
  user_transportation_aggregate_fields: User_Transportation_Aggregate_Fields;
  user_transportation_aggregate_order_by: User_Transportation_Aggregate_Order_By;
  user_transportation_arr_rel_insert_input: User_Transportation_Arr_Rel_Insert_Input;
  user_transportation_bool_exp: User_Transportation_Bool_Exp;
  user_transportation_insert_input: User_Transportation_Insert_Input;
  user_transportation_max_fields: User_Transportation_Max_Fields;
  user_transportation_max_order_by: User_Transportation_Max_Order_By;
  user_transportation_min_fields: User_Transportation_Min_Fields;
  user_transportation_min_order_by: User_Transportation_Min_Order_By;
  user_transportation_mutation_response: User_Transportation_Mutation_Response;
  user_transportation_on_conflict: User_Transportation_On_Conflict;
  user_transportation_order_by: User_Transportation_Order_By;
  user_transportation_pk_columns_input: User_Transportation_Pk_Columns_Input;
  user_transportation_set_input: User_Transportation_Set_Input;
  user_transportation_stream_cursor_input: User_Transportation_Stream_Cursor_Input;
  user_transportation_stream_cursor_value_input: User_Transportation_Stream_Cursor_Value_Input;
  user_transportation_updates: User_Transportation_Updates;
  user_updates: User_Updates;
  user_var_pop_fields: User_Var_Pop_Fields;
  user_var_samp_fields: User_Var_Samp_Fields;
  user_variance_fields: User_Variance_Fields;
  user_watchlist: User_Watchlist;
  user_watchlist_aggregate: User_Watchlist_Aggregate;
  user_watchlist_aggregate_bool_exp: User_Watchlist_Aggregate_Bool_Exp;
  user_watchlist_aggregate_bool_exp_count: User_Watchlist_Aggregate_Bool_Exp_Count;
  user_watchlist_aggregate_fields: User_Watchlist_Aggregate_Fields;
  user_watchlist_aggregate_order_by: User_Watchlist_Aggregate_Order_By;
  user_watchlist_arr_rel_insert_input: User_Watchlist_Arr_Rel_Insert_Input;
  user_watchlist_bool_exp: User_Watchlist_Bool_Exp;
  user_watchlist_insert_input: User_Watchlist_Insert_Input;
  user_watchlist_max_fields: User_Watchlist_Max_Fields;
  user_watchlist_max_order_by: User_Watchlist_Max_Order_By;
  user_watchlist_min_fields: User_Watchlist_Min_Fields;
  user_watchlist_min_order_by: User_Watchlist_Min_Order_By;
  user_watchlist_mutation_response: User_Watchlist_Mutation_Response;
  user_watchlist_on_conflict: User_Watchlist_On_Conflict;
  user_watchlist_order_by: User_Watchlist_Order_By;
  user_watchlist_pk_columns_input: User_Watchlist_Pk_Columns_Input;
  user_watchlist_set_input: User_Watchlist_Set_Input;
  user_watchlist_stream_cursor_input: User_Watchlist_Stream_Cursor_Input;
  user_watchlist_stream_cursor_value_input: User_Watchlist_Stream_Cursor_Value_Input;
  user_watchlist_updates: User_Watchlist_Updates;
  uuid: Scalars['uuid'];
  uuid_comparison_exp: Uuid_Comparison_Exp;
};

export type CachedDirectiveArgs = {   ttl?: Scalars['Int'];
  refresh?: Scalars['Boolean']; };

export type CachedDirectiveResolver<Result, Parent, ContextType = any, Args = CachedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AdminResolvers<ContextType = any, ParentType extends ResolversParentTypes['admin'] = ResolversParentTypes['admin']> = {
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  declined_visit_matches?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<AdminDeclined_Visit_MatchesArgs, never>>;
  declined_visit_matches_aggregate?: Resolver<ResolversTypes['declined_visit_matches_aggregate'], ParentType, ContextType, RequireFields<AdminDeclined_Visit_Matches_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  smart_match_bookmarks?: Resolver<Array<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<AdminSmart_Match_BookmarksArgs, never>>;
  smart_match_bookmarks_aggregate?: Resolver<ResolversTypes['smart_match_bookmark_aggregate'], ParentType, ContextType, RequireFields<AdminSmart_Match_Bookmarks_AggregateArgs, never>>;
  smart_match_config?: Resolver<Maybe<ResolversTypes['smart_match_configs']>, ParentType, ContextType>;
  subscription_info_showed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Admin_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['admin_aggregate'] = ResolversParentTypes['admin_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['admin_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['admin']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Admin_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['admin_aggregate_fields'] = ResolversParentTypes['admin_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Admin_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['admin_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['admin_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Admin_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['admin_max_fields'] = ResolversParentTypes['admin_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Admin_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['admin_min_fields'] = ResolversParentTypes['admin_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Admin_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['admin_mutation_response'] = ResolversParentTypes['admin_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['admin']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Applicant_EnumScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['applicant_enum'], any> {
  name: 'applicant_enum';
}

export type ApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['application'] = ResolversParentTypes['application']> = {
  candidates?: Resolver<Array<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<ApplicationCandidatesArgs, never>>;
  candidates_aggregate?: Resolver<ResolversTypes['candidate_aggregate'], ParentType, ContextType, RequireFields<ApplicationCandidates_AggregateArgs, never>>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document?: Resolver<Maybe<ResolversTypes['document']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  interviewed_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  interviewer?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  is_cancelled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posting?: Resolver<ResolversTypes['posting'], ParentType, ContextType>;
  posting_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['applicant_enum']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Application_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['application_aggregate'] = ResolversParentTypes['application_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['application_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['application']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Application_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['application_aggregate_fields'] = ResolversParentTypes['application_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Application_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['application_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['application_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Application_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['application_max_fields'] = ResolversParentTypes['application_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  interviewed_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['applicant_enum']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Application_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['application_min_fields'] = ResolversParentTypes['application_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  interviewed_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['applicant_enum']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Application_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['application_mutation_response'] = ResolversParentTypes['application_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['application']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigintScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['bigint'], any> {
  name: 'bigint';
}

export type CandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['candidate'] = ResolversParentTypes['candidate']> = {
  application?: Resolver<ResolversTypes['application'], ParentType, ContextType>;
  application_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  onboardings?: Resolver<Array<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<CandidateOnboardingsArgs, never>>;
  onboardings_aggregate?: Resolver<ResolversTypes['onboarding_aggregate'], ParentType, ContextType, RequireFields<CandidateOnboardings_AggregateArgs, never>>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Candidate_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['candidate_aggregate'] = ResolversParentTypes['candidate_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['candidate_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['candidate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Candidate_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['candidate_aggregate_fields'] = ResolversParentTypes['candidate_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Candidate_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['candidate_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['candidate_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Candidate_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['candidate_max_fields'] = ResolversParentTypes['candidate_max_fields']> = {
  application_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Candidate_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['candidate_min_fields'] = ResolversParentTypes['candidate_min_fields']> = {
  application_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Candidate_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['candidate_mutation_response'] = ResolversParentTypes['candidate_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['candidate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_ContractorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors'] = ResolversParentTypes['chart_admin_contractors']> = {
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_aggregate'] = ResolversParentTypes['chart_admin_contractors_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['chart_admin_contractors']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_aggregate_fields'] = ResolversParentTypes['chart_admin_contractors_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Chart_Admin_Contractors_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['chart_admin_contractors_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_avg_fields'] = ResolversParentTypes['chart_admin_contractors_avg_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_max_fields'] = ResolversParentTypes['chart_admin_contractors_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_min_fields'] = ResolversParentTypes['chart_admin_contractors_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_stddev_fields'] = ResolversParentTypes['chart_admin_contractors_stddev_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_stddev_pop_fields'] = ResolversParentTypes['chart_admin_contractors_stddev_pop_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_stddev_samp_fields'] = ResolversParentTypes['chart_admin_contractors_stddev_samp_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_sum_fields'] = ResolversParentTypes['chart_admin_contractors_sum_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_var_pop_fields'] = ResolversParentTypes['chart_admin_contractors_var_pop_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_var_samp_fields'] = ResolversParentTypes['chart_admin_contractors_var_samp_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Admin_Contractors_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_admin_contractors_variance_fields'] = ResolversParentTypes['chart_admin_contractors_variance_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_ContractorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors'] = ResolversParentTypes['chart_manager_contractors']> = {
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_db_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_aggregate'] = ResolversParentTypes['chart_manager_contractors_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['chart_manager_contractors']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_aggregate_fields'] = ResolversParentTypes['chart_manager_contractors_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Chart_Manager_Contractors_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['chart_manager_contractors_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_avg_fields'] = ResolversParentTypes['chart_manager_contractors_avg_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_max_fields'] = ResolversParentTypes['chart_manager_contractors_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  manager_db_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_min_fields'] = ResolversParentTypes['chart_manager_contractors_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  manager_db_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_stddev_fields'] = ResolversParentTypes['chart_manager_contractors_stddev_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_stddev_pop_fields'] = ResolversParentTypes['chart_manager_contractors_stddev_pop_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_stddev_samp_fields'] = ResolversParentTypes['chart_manager_contractors_stddev_samp_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_sum_fields'] = ResolversParentTypes['chart_manager_contractors_sum_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_var_pop_fields'] = ResolversParentTypes['chart_manager_contractors_var_pop_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_var_samp_fields'] = ResolversParentTypes['chart_manager_contractors_var_samp_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Manager_Contractors_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_manager_contractors_variance_fields'] = ResolversParentTypes['chart_manager_contractors_variance_fields']> = {
  manager_db_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  manager_request_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_ProjectsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects'] = ResolversParentTypes['chart_projects']> = {
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_aggregate'] = ResolversParentTypes['chart_projects_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['chart_projects_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['chart_projects']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_aggregate_fields'] = ResolversParentTypes['chart_projects_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['chart_projects_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Chart_Projects_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['chart_projects_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['chart_projects_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['chart_projects_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['chart_projects_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['chart_projects_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['chart_projects_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['chart_projects_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['chart_projects_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['chart_projects_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_avg_fields'] = ResolversParentTypes['chart_projects_avg_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_max_fields'] = ResolversParentTypes['chart_projects_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_min_fields'] = ResolversParentTypes['chart_projects_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  created_at_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_stddev_fields'] = ResolversParentTypes['chart_projects_stddev_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_stddev_pop_fields'] = ResolversParentTypes['chart_projects_stddev_pop_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_stddev_samp_fields'] = ResolversParentTypes['chart_projects_stddev_samp_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_sum_fields'] = ResolversParentTypes['chart_projects_sum_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_var_pop_fields'] = ResolversParentTypes['chart_projects_var_pop_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_var_samp_fields'] = ResolversParentTypes['chart_projects_var_samp_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Chart_Projects_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['chart_projects_variance_fields'] = ResolversParentTypes['chart_projects_variance_fields']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkin_StatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkin_status'] = ResolversParentTypes['checkin_status']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkin_Status_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkin_status_aggregate'] = ResolversParentTypes['checkin_status_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['checkin_status_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['checkin_status']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkin_Status_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkin_status_aggregate_fields'] = ResolversParentTypes['checkin_status_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Checkin_Status_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['checkin_status_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['checkin_status_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkin_Status_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkin_status_max_fields'] = ResolversParentTypes['checkin_status_max_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkin_Status_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkin_status_min_fields'] = ResolversParentTypes['checkin_status_min_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkin_Status_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkin_status_mutation_response'] = ResolversParentTypes['checkin_status_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['checkin_status']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout_StatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkout_status'] = ResolversParentTypes['checkout_status']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout_Status_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkout_status_aggregate'] = ResolversParentTypes['checkout_status_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['checkout_status_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['checkout_status']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout_Status_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkout_status_aggregate_fields'] = ResolversParentTypes['checkout_status_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Checkout_Status_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['checkout_status_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['checkout_status_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout_Status_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkout_status_max_fields'] = ResolversParentTypes['checkout_status_max_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout_Status_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkout_status_min_fields'] = ResolversParentTypes['checkout_status_min_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout_Status_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkout_status_mutation_response'] = ResolversParentTypes['checkout_status_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['checkout_status']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Care_PlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_care_plan'] = ResolversParentTypes['client_care_plan']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_environmental?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_food?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_medication?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ambulance_pain_monitoring?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ambulance_support_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bathing_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bathing_supervision_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  care_plan_created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  care_plan_end_date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_start_date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_services?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  client_services_gen_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_goals_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_goals_special_requirement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_copy_attached?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  doc_incident_reports?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doc_progress_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fall_risk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['gender_enum']>, ParentType, ContextType>;
  genderByGender?: Resolver<Maybe<ResolversTypes['gender']>, ParentType, ContextType>;
  home_env_accessibility_issues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_pets?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_safety?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  housekeeping_assistance_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  housekeeping_daily_task?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  infectious_diseases?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medication_goals_supervision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medication_goals_timing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_diagnosis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_cultural_practice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_goals_hygiene?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_goals_self_care?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_hobbies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_social?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_related_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  review_changes_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_new_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_reporting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_wound?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substance_use_considerations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_hygiene?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Care_Plan_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_care_plan_aggregate'] = ResolversParentTypes['client_care_plan_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['client_care_plan_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['client_care_plan']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Care_Plan_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_care_plan_aggregate_fields'] = ResolversParentTypes['client_care_plan_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Client_Care_Plan_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['client_care_plan_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['client_care_plan_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Care_Plan_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_care_plan_max_fields'] = ResolversParentTypes['client_care_plan_max_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_environmental?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_food?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_medication?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ambulance_pain_monitoring?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ambulance_support_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bathing_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bathing_supervision_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  care_plan_created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  care_plan_end_date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_start_date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_services?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  client_services_gen_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_goals_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_goals_special_requirement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_copy_attached?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  doc_incident_reports?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doc_progress_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fall_risk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_accessibility_issues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_pets?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_safety?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  housekeeping_assistance_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  housekeeping_daily_task?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  infectious_diseases?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medication_goals_supervision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medication_goals_timing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_diagnosis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_cultural_practice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_goals_hygiene?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_goals_self_care?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_hobbies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_social?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_related_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  review_changes_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_new_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_reporting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_wound?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substance_use_considerations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_hygiene?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Care_Plan_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_care_plan_min_fields'] = ResolversParentTypes['client_care_plan_min_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_environmental?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_food?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allergy_medication?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ambulance_pain_monitoring?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ambulance_support_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bathing_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bathing_supervision_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  care_plan_created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  care_plan_end_date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_start_date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  care_plan_updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_services?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  client_services_gen_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_goals_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_goals_special_requirement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_copy_attached?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  doc_incident_reports?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doc_progress_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fall_risk?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_accessibility_issues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_pets?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  home_env_safety?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  housekeeping_assistance_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  housekeeping_daily_task?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  infectious_diseases?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medication_goals_supervision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medication_goals_timing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_diagnosis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrition_goals_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_cultural_practice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_goals_hygiene?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_goals_self_care?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_hobbies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personal_social?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precautions_related_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  review_changes_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  review_new_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_reporting?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skin_goals_wound?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  substance_use_considerations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_hygiene?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toileting_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Care_Plan_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_care_plan_mutation_response'] = ResolversParentTypes['client_care_plan_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['client_care_plan']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_MedicationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_medications'] = ResolversParentTypes['client_medications']> = {
  client_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  dosage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Medications_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_medications_aggregate'] = ResolversParentTypes['client_medications_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['client_medications_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['client_medications']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Medications_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_medications_aggregate_fields'] = ResolversParentTypes['client_medications_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Client_Medications_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['client_medications_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['client_medications_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Medications_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_medications_max_fields'] = ResolversParentTypes['client_medications_max_fields']> = {
  client_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  dosage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Medications_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_medications_min_fields'] = ResolversParentTypes['client_medications_min_fields']> = {
  client_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  dosage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Client_Medications_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['client_medications_mutation_response'] = ResolversParentTypes['client_medications_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['client_medications']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['company'] = ResolversParentTypes['company']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  admins?: Resolver<Array<ResolversTypes['admin']>, ParentType, ContextType, RequireFields<CompanyAdminsArgs, never>>;
  admins_aggregate?: Resolver<ResolversTypes['admin_aggregate'], ParentType, ContextType, RequireFields<CompanyAdmins_AggregateArgs, never>>;
  allow_managers_view_all_contractors?: Resolver<Maybe<ResolversTypes['company_managers_view_all_contractors_access']>, ParentType, ContextType>;
  allow_managers_view_all_projects?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allow_managers_view_all_teams?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  business_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  candidates?: Resolver<Array<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<CompanyCandidatesArgs, never>>;
  candidates_aggregate?: Resolver<ResolversTypes['candidate_aggregate'], ParentType, ContextType, RequireFields<CompanyCandidates_AggregateArgs, never>>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractors?: Resolver<Array<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<CompanyContractorsArgs, never>>;
  contractors_aggregate?: Resolver<ResolversTypes['contractor_aggregate'], ParentType, ContextType, RequireFields<CompanyContractors_AggregateArgs, never>>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  custom_requests?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<CompanyCustom_RequestsArgs, never>>;
  custom_requests_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<CompanyCustom_Requests_AggregateArgs, never>>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['document']>, ParentType, ContextType, RequireFields<CompanyDocumentsArgs, never>>;
  documents_aggregate?: Resolver<ResolversTypes['document_aggregate'], ParentType, ContextType, RequireFields<CompanyDocuments_AggregateArgs, never>>;
  followers?: Resolver<Array<ResolversTypes['company_follower']>, ParentType, ContextType, RequireFields<CompanyFollowersArgs, never>>;
  followers_aggregate?: Resolver<ResolversTypes['company_follower_aggregate'], ParentType, ContextType, RequireFields<CompanyFollowers_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invitations?: Resolver<Array<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<CompanyInvitationsArgs, never>>;
  invitations_aggregate?: Resolver<ResolversTypes['invitation_aggregate'], ParentType, ContextType, RequireFields<CompanyInvitations_AggregateArgs, never>>;
  managers?: Resolver<Array<ResolversTypes['manager']>, ParentType, ContextType, RequireFields<CompanyManagersArgs, never>>;
  managers_aggregate?: Resolver<ResolversTypes['manager_aggregate'], ParentType, ContextType, RequireFields<CompanyManagers_AggregateArgs, never>>;
  marketplace_access_type?: Resolver<ResolversTypes['company_marketplace_access'], ParentType, ContextType>;
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onboardings?: Resolver<Array<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<CompanyOnboardingsArgs, never>>;
  onboardings_aggregate?: Resolver<ResolversTypes['onboarding_aggregate'], ParentType, ContextType, RequireFields<CompanyOnboardings_AggregateArgs, never>>;
  phone_number?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postings?: Resolver<Array<ResolversTypes['posting']>, ParentType, ContextType, RequireFields<CompanyPostingsArgs, never>>;
  postings_aggregate?: Resolver<ResolversTypes['posting_aggregate'], ParentType, ContextType, RequireFields<CompanyPostings_AggregateArgs, never>>;
  private?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  projects?: Resolver<Array<ResolversTypes['project']>, ParentType, ContextType, RequireFields<CompanyProjectsArgs, never>>;
  projects_aggregate?: Resolver<ResolversTypes['project_aggregate'], ParentType, ContextType, RequireFields<CompanyProjects_AggregateArgs, never>>;
  skills?: Resolver<Array<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<CompanySkillsArgs, never>>;
  skills_aggregate?: Resolver<ResolversTypes['skill_aggregate'], ParentType, ContextType, RequireFields<CompanySkills_AggregateArgs, never>>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptions?: Resolver<Array<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<CompanySubscriptionsArgs, never>>;
  subscriptions_aggregate?: Resolver<ResolversTypes['subscription_aggregate'], ParentType, ContextType, RequireFields<CompanySubscriptions_AggregateArgs, never>>;
  teams?: Resolver<Array<ResolversTypes['team']>, ParentType, ContextType, RequireFields<CompanyTeamsArgs, never>>;
  teams_aggregate?: Resolver<ResolversTypes['team_aggregate'], ParentType, ContextType, RequireFields<CompanyTeams_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_job_titles?: Resolver<Array<ResolversTypes['user_job_title']>, ParentType, ContextType, RequireFields<CompanyUser_Job_TitlesArgs, never>>;
  user_job_titles_aggregate?: Resolver<ResolversTypes['user_job_title_aggregate'], ParentType, ContextType, RequireFields<CompanyUser_Job_Titles_AggregateArgs, never>>;
  users?: Resolver<Array<ResolversTypes['user_company']>, ParentType, ContextType, RequireFields<CompanyUsersArgs, never>>;
  users_aggregate?: Resolver<ResolversTypes['user_company_aggregate'], ParentType, ContextType, RequireFields<CompanyUsers_AggregateArgs, never>>;
  users_disabled_notifications?: Resolver<Array<ResolversTypes['company_user_notifications']>, ParentType, ContextType, RequireFields<CompanyUsers_Disabled_NotificationsArgs, never>>;
  users_disabled_notifications_aggregate?: Resolver<ResolversTypes['company_user_notifications_aggregate'], ParentType, ContextType, RequireFields<CompanyUsers_Disabled_Notifications_AggregateArgs, never>>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_aggregate'] = ResolversParentTypes['company_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['company_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_aggregate_fields'] = ResolversParentTypes['company_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['company_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Company_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['company_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['company_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['company_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['company_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['company_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['company_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['company_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['company_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['company_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_avg_fields'] = ResolversParentTypes['company_avg_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_FollowerResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_follower'] = ResolversParentTypes['company_follower']> = {
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Follower_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_follower_aggregate'] = ResolversParentTypes['company_follower_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['company_follower_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['company_follower']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Follower_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_follower_aggregate_fields'] = ResolversParentTypes['company_follower_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Company_Follower_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['company_follower_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['company_follower_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Follower_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_follower_max_fields'] = ResolversParentTypes['company_follower_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Follower_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_follower_min_fields'] = ResolversParentTypes['company_follower_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Follower_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_follower_mutation_response'] = ResolversParentTypes['company_follower_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['company_follower']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Company_Managers_View_All_Contractors_AccessScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['company_managers_view_all_contractors_access'], any> {
  name: 'company_managers_view_all_contractors_access';
}

export interface Company_Marketplace_AccessScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['company_marketplace_access'], any> {
  name: 'company_marketplace_access';
}

export type Company_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_max_fields'] = ResolversParentTypes['company_max_fields']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allow_managers_view_all_contractors?: Resolver<Maybe<ResolversTypes['company_managers_view_all_contractors_access']>, ParentType, ContextType>;
  business_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketplace_access_type?: Resolver<Maybe<ResolversTypes['company_marketplace_access']>, ParentType, ContextType>;
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_min_fields'] = ResolversParentTypes['company_min_fields']> = {
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allow_managers_view_all_contractors?: Resolver<Maybe<ResolversTypes['company_managers_view_all_contractors_access']>, ParentType, ContextType>;
  business_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketplace_access_type?: Resolver<Maybe<ResolversTypes['company_marketplace_access']>, ParentType, ContextType>;
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_mutation_response'] = ResolversParentTypes['company_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_stddev_fields'] = ResolversParentTypes['company_stddev_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_stddev_pop_fields'] = ResolversParentTypes['company_stddev_pop_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_stddev_samp_fields'] = ResolversParentTypes['company_stddev_samp_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_sum_fields'] = ResolversParentTypes['company_sum_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_User_NotificationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_user_notifications'] = ResolversParentTypes['company_user_notifications']> = {
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_User_Notifications_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_user_notifications_aggregate'] = ResolversParentTypes['company_user_notifications_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['company_user_notifications_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['company_user_notifications']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_User_Notifications_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_user_notifications_aggregate_fields'] = ResolversParentTypes['company_user_notifications_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Company_User_Notifications_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['company_user_notifications_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['company_user_notifications_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_User_Notifications_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_user_notifications_max_fields'] = ResolversParentTypes['company_user_notifications_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_User_Notifications_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_user_notifications_min_fields'] = ResolversParentTypes['company_user_notifications_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_User_Notifications_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_user_notifications_mutation_response'] = ResolversParentTypes['company_user_notifications_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['company_user_notifications']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_var_pop_fields'] = ResolversParentTypes['company_var_pop_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_var_samp_fields'] = ResolversParentTypes['company_var_samp_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Company_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['company_variance_fields'] = ResolversParentTypes['company_variance_fields']> = {
  max_admin_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_contractor_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_manager_limit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number_of_employee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractorResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor'] = ResolversParentTypes['contractor']> = {
  approved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  availability?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  contractor_notes?: Resolver<Array<ResolversTypes['contractor_note']>, ParentType, ContextType, RequireFields<ContractorContractor_NotesArgs, never>>;
  contractor_notes_aggregate?: Resolver<ResolversTypes['contractor_note_aggregate'], ParentType, ContextType, RequireFields<ContractorContractor_Notes_AggregateArgs, never>>;
  contractor_ratings?: Resolver<Array<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<ContractorContractor_RatingsArgs, never>>;
  contractor_ratings_aggregate?: Resolver<ResolversTypes['contractor_rating_aggregate'], ParentType, ContextType, RequireFields<ContractorContractor_Ratings_AggregateArgs, never>>;
  contractor_staff_notes?: Resolver<Array<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<ContractorContractor_Staff_NotesArgs, never>>;
  contractor_staff_notes_aggregate?: Resolver<ResolversTypes['contractor_staff_note_aggregate'], ParentType, ContextType, RequireFields<ContractorContractor_Staff_Notes_AggregateArgs, never>>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  document_contractor_accesses?: Resolver<Array<ResolversTypes['document_contractor_access']>, ParentType, ContextType, RequireFields<ContractorDocument_Contractor_AccessesArgs, never>>;
  document_contractor_accesses_aggregate?: Resolver<ResolversTypes['document_contractor_access_aggregate'], ParentType, ContextType, RequireFields<ContractorDocument_Contractor_Accesses_AggregateArgs, never>>;
  from_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  managers?: Resolver<Array<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<ContractorManagersArgs, never>>;
  managers_aggregate?: Resolver<ResolversTypes['manager_contractor_aggregate'], ParentType, ContextType, RequireFields<ContractorManagers_AggregateArgs, never>>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postings?: Resolver<Array<ResolversTypes['contractor_posting']>, ParentType, ContextType, RequireFields<ContractorPostingsArgs, never>>;
  postings_aggregate?: Resolver<ResolversTypes['contractor_posting_aggregate'], ParentType, ContextType, RequireFields<ContractorPostings_AggregateArgs, never>>;
  profile_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activities?: Resolver<Array<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<ContractorProject_ActivitiesArgs, never>>;
  project_activities_aggregate?: Resolver<ResolversTypes['project_activity_aggregate'], ParentType, ContextType, RequireFields<ContractorProject_Activities_AggregateArgs, never>>;
  project_activity_times?: Resolver<Array<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<ContractorProject_Activity_TimesArgs, never>>;
  project_activity_times_aggregate?: Resolver<ResolversTypes['project_activity_time_aggregate'], ParentType, ContextType, RequireFields<ContractorProject_Activity_Times_AggregateArgs, never>>;
  projects?: Resolver<Array<ResolversTypes['contractor_project']>, ParentType, ContextType, RequireFields<ContractorProjectsArgs, never>>;
  projects_aggregate?: Resolver<ResolversTypes['contractor_project_aggregate'], ParentType, ContextType, RequireFields<ContractorProjects_AggregateArgs, never>>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resource_information_cards?: Resolver<Array<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<ContractorResource_Information_CardsArgs, never>>;
  resource_information_cards_aggregate?: Resolver<ResolversTypes['resource_information_card_aggregate'], ParentType, ContextType, RequireFields<ContractorResource_Information_Cards_AggregateArgs, never>>;
  source?: Resolver<Maybe<ResolversTypes['source']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['tag']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  teams?: Resolver<Array<ResolversTypes['team_contractor']>, ParentType, ContextType, RequireFields<ContractorTeamsArgs, never>>;
  teams_aggregate?: Resolver<ResolversTypes['team_contractor_aggregate'], ParentType, ContextType, RequireFields<ContractorTeams_AggregateArgs, never>>;
  to_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_aggregate'] = ResolversParentTypes['contractor_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contractor_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contractor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_aggregate_fields'] = ResolversParentTypes['contractor_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['contractor_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Contractor_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['contractor_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contractor_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['contractor_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['contractor_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['contractor_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['contractor_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['contractor_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['contractor_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['contractor_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_avg_fields'] = ResolversParentTypes['contractor_avg_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_max_fields'] = ResolversParentTypes['contractor_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_min_fields'] = ResolversParentTypes['contractor_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_mutation_response'] = ResolversParentTypes['contractor_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contractor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_NoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_note'] = ResolversParentTypes['contractor_note']> = {
  contractor?: Resolver<Maybe<ResolversTypes['contractor']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Note_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_note_aggregate'] = ResolversParentTypes['contractor_note_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contractor_note_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contractor_note']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Note_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_note_aggregate_fields'] = ResolversParentTypes['contractor_note_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Contractor_Note_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['contractor_note_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contractor_note_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Note_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_note_max_fields'] = ResolversParentTypes['contractor_note_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Note_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_note_min_fields'] = ResolversParentTypes['contractor_note_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Note_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_note_mutation_response'] = ResolversParentTypes['contractor_note_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contractor_note']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_PostingResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting'] = ResolversParentTypes['contractor_posting']> = {
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  posting?: Resolver<ResolversTypes['posting'], ParentType, ContextType>;
  posting_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_aggregate'] = ResolversParentTypes['contractor_posting_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contractor_posting_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contractor_posting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_aggregate_fields'] = ResolversParentTypes['contractor_posting_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['contractor_posting_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Contractor_Posting_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['contractor_posting_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contractor_posting_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['contractor_posting_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['contractor_posting_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['contractor_posting_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['contractor_posting_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['contractor_posting_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['contractor_posting_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['contractor_posting_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_avg_fields'] = ResolversParentTypes['contractor_posting_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_max_fields'] = ResolversParentTypes['contractor_posting_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_min_fields'] = ResolversParentTypes['contractor_posting_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_mutation_response'] = ResolversParentTypes['contractor_posting_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contractor_posting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_stddev_fields'] = ResolversParentTypes['contractor_posting_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_stddev_pop_fields'] = ResolversParentTypes['contractor_posting_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_stddev_samp_fields'] = ResolversParentTypes['contractor_posting_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_sum_fields'] = ResolversParentTypes['contractor_posting_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_var_pop_fields'] = ResolversParentTypes['contractor_posting_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_var_samp_fields'] = ResolversParentTypes['contractor_posting_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Posting_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_posting_variance_fields'] = ResolversParentTypes['contractor_posting_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_project'] = ResolversParentTypes['contractor_project']> = {
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Project_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_project_aggregate'] = ResolversParentTypes['contractor_project_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contractor_project_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contractor_project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Project_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_project_aggregate_fields'] = ResolversParentTypes['contractor_project_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Contractor_Project_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['contractor_project_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contractor_project_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Project_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_project_max_fields'] = ResolversParentTypes['contractor_project_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Project_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_project_min_fields'] = ResolversParentTypes['contractor_project_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Project_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_project_mutation_response'] = ResolversParentTypes['contractor_project_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contractor_project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_RatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating'] = ResolversParentTypes['contractor_rating']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  project_activity?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType>;
  public_project_details?: Resolver<Maybe<ResolversTypes['public_project_details']>, ParentType, ContextType>;
  review?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reviewer?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  reviewer_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_aggregate'] = ResolversParentTypes['contractor_rating_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contractor_rating_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contractor_rating']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_aggregate_fields'] = ResolversParentTypes['contractor_rating_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['contractor_rating_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Contractor_Rating_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['contractor_rating_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contractor_rating_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['contractor_rating_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['contractor_rating_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['contractor_rating_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['contractor_rating_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['contractor_rating_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['contractor_rating_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['contractor_rating_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_avg_fields'] = ResolversParentTypes['contractor_rating_avg_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_max_fields'] = ResolversParentTypes['contractor_rating_max_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  review?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviewer_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_min_fields'] = ResolversParentTypes['contractor_rating_min_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  review?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviewer_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_mutation_response'] = ResolversParentTypes['contractor_rating_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contractor_rating']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_stddev_fields'] = ResolversParentTypes['contractor_rating_stddev_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_stddev_pop_fields'] = ResolversParentTypes['contractor_rating_stddev_pop_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_stddev_samp_fields'] = ResolversParentTypes['contractor_rating_stddev_samp_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_sum_fields'] = ResolversParentTypes['contractor_rating_sum_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_var_pop_fields'] = ResolversParentTypes['contractor_rating_var_pop_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_var_samp_fields'] = ResolversParentTypes['contractor_rating_var_samp_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Rating_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_rating_variance_fields'] = ResolversParentTypes['contractor_rating_variance_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Staff_NoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_staff_note'] = ResolversParentTypes['contractor_staff_note']> = {
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType>;
  project_activity?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Staff_Note_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_staff_note_aggregate'] = ResolversParentTypes['contractor_staff_note_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contractor_staff_note_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contractor_staff_note']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Staff_Note_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_staff_note_aggregate_fields'] = ResolversParentTypes['contractor_staff_note_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Contractor_Staff_Note_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['contractor_staff_note_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contractor_staff_note_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Staff_Note_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_staff_note_max_fields'] = ResolversParentTypes['contractor_staff_note_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Staff_Note_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_staff_note_min_fields'] = ResolversParentTypes['contractor_staff_note_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Staff_Note_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_staff_note_mutation_response'] = ResolversParentTypes['contractor_staff_note_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contractor_staff_note']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_stddev_fields'] = ResolversParentTypes['contractor_stddev_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_stddev_pop_fields'] = ResolversParentTypes['contractor_stddev_pop_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_stddev_samp_fields'] = ResolversParentTypes['contractor_stddev_samp_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_sum_fields'] = ResolversParentTypes['contractor_sum_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_var_pop_fields'] = ResolversParentTypes['contractor_var_pop_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_var_samp_fields'] = ResolversParentTypes['contractor_var_samp_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contractor_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contractor_variance_fields'] = ResolversParentTypes['contractor_variance_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConversationResolvers<ContextType = any, ParentType extends ResolversParentTypes['conversation'] = ResolversParentTypes['conversation']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  custom_requests?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<ConversationCustom_RequestsArgs, never>>;
  custom_requests_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<ConversationCustom_Requests_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  is_custom_request_conversation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType, RequireFields<ConversationMessagesArgs, never>>;
  messages_aggregate?: Resolver<ResolversTypes['message_aggregate'], ParentType, ContextType, RequireFields<ConversationMessages_AggregateArgs, never>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipient_messages?: Resolver<Array<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<ConversationRecipient_MessagesArgs, never>>;
  recipient_messages_aggregate?: Resolver<ResolversTypes['recipient_message_aggregate'], ParentType, ContextType, RequireFields<ConversationRecipient_Messages_AggregateArgs, never>>;
  unread_view?: Resolver<Array<ResolversTypes['unread_messages']>, ParentType, ContextType, RequireFields<ConversationUnread_ViewArgs, never>>;
  unread_view_aggregate?: Resolver<ResolversTypes['unread_messages_aggregate'], ParentType, ContextType, RequireFields<ConversationUnread_View_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['user_conversation']>, ParentType, ContextType, RequireFields<ConversationUsersArgs, never>>;
  users_aggregate?: Resolver<ResolversTypes['user_conversation_aggregate'], ParentType, ContextType, RequireFields<ConversationUsers_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Conversation_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['conversation_aggregate'] = ResolversParentTypes['conversation_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['conversation_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['conversation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Conversation_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['conversation_aggregate_fields'] = ResolversParentTypes['conversation_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Conversation_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['conversation_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['conversation_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Conversation_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['conversation_max_fields'] = ResolversParentTypes['conversation_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Conversation_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['conversation_min_fields'] = ResolversParentTypes['conversation_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Conversation_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['conversation_mutation_response'] = ResolversParentTypes['conversation_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['conversation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CurrencyScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['currency'], any> {
  name: 'currency';
}

export type Custom_RequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request'] = ResolversParentTypes['custom_request']> = {
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  conversation?: Resolver<Maybe<ResolversTypes['conversation']>, ParentType, ContextType>;
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  created_by?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  created_by_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  custom_request_skills?: Resolver<Array<ResolversTypes['custom_request_skills']>, ParentType, ContextType, RequireFields<Custom_RequestCustom_Request_SkillsArgs, never>>;
  custom_request_skills_aggregate?: Resolver<ResolversTypes['custom_request_skills_aggregate'], ParentType, ContextType, RequireFields<Custom_RequestCustom_Request_Skills_AggregateArgs, never>>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  document_custom_requests?: Resolver<Array<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<Custom_RequestDocument_Custom_RequestsArgs, never>>;
  document_custom_requests_aggregate?: Resolver<ResolversTypes['document_custom_request_aggregate'], ParentType, ContextType, RequireFields<Custom_RequestDocument_Custom_Requests_AggregateArgs, never>>;
  from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  job_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number_of_contractors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType>;
  project_activity?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['custom_request_status'], ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['tag']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  updated_by?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  updated_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_aggregate'] = ResolversParentTypes['custom_request_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['custom_request_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_aggregate_fields'] = ResolversParentTypes['custom_request_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Custom_Request_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['custom_request_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['custom_request_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_max_fields'] = ResolversParentTypes['custom_request_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number_of_contractors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['custom_request_status']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updated_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_min_fields'] = ResolversParentTypes['custom_request_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number_of_contractors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['custom_request_status']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updated_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_mutation_response'] = ResolversParentTypes['custom_request_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_SkillsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills'] = ResolversParentTypes['custom_request_skills']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  customRequest?: Resolver<ResolversTypes['custom_request'], ParentType, ContextType>;
  custom_request_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['skill'], ParentType, ContextType>;
  skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_aggregate'] = ResolversParentTypes['custom_request_skills_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['custom_request_skills_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['custom_request_skills']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_aggregate_fields'] = ResolversParentTypes['custom_request_skills_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['custom_request_skills_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Custom_Request_Skills_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['custom_request_skills_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['custom_request_skills_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['custom_request_skills_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['custom_request_skills_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['custom_request_skills_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['custom_request_skills_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['custom_request_skills_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['custom_request_skills_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['custom_request_skills_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_avg_fields'] = ResolversParentTypes['custom_request_skills_avg_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_max_fields'] = ResolversParentTypes['custom_request_skills_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  custom_request_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_min_fields'] = ResolversParentTypes['custom_request_skills_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  custom_request_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_mutation_response'] = ResolversParentTypes['custom_request_skills_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['custom_request_skills']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_stddev_fields'] = ResolversParentTypes['custom_request_skills_stddev_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_stddev_pop_fields'] = ResolversParentTypes['custom_request_skills_stddev_pop_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_stddev_samp_fields'] = ResolversParentTypes['custom_request_skills_stddev_samp_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_sum_fields'] = ResolversParentTypes['custom_request_skills_sum_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_var_pop_fields'] = ResolversParentTypes['custom_request_skills_var_pop_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_var_samp_fields'] = ResolversParentTypes['custom_request_skills_var_samp_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Custom_Request_Skills_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['custom_request_skills_variance_fields'] = ResolversParentTypes['custom_request_skills_variance_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Custom_Request_StatusScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['custom_request_status'], any> {
  name: 'custom_request_status';
}

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['date'], any> {
  name: 'date';
}

export type Declined_Visit_MatchesResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches'] = ResolversParentTypes['declined_visit_matches']> = {
  admin?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType>;
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  bookmark_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  match_percentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  project_activity?: Resolver<ResolversTypes['project_activity'], ParentType, ContextType>;
  project_activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  smart_match_bookmark?: Resolver<Maybe<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_aggregate'] = ResolversParentTypes['declined_visit_matches_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['declined_visit_matches_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_aggregate_fields'] = ResolversParentTypes['declined_visit_matches_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['declined_visit_matches_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Declined_Visit_Matches_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['declined_visit_matches_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['declined_visit_matches_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['declined_visit_matches_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['declined_visit_matches_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['declined_visit_matches_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['declined_visit_matches_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['declined_visit_matches_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['declined_visit_matches_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['declined_visit_matches_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_avg_fields'] = ResolversParentTypes['declined_visit_matches_avg_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_max_fields'] = ResolversParentTypes['declined_visit_matches_max_fields']> = {
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  bookmark_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  match_percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_min_fields'] = ResolversParentTypes['declined_visit_matches_min_fields']> = {
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  bookmark_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  match_percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_mutation_response'] = ResolversParentTypes['declined_visit_matches_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_stddev_fields'] = ResolversParentTypes['declined_visit_matches_stddev_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_stddev_pop_fields'] = ResolversParentTypes['declined_visit_matches_stddev_pop_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_stddev_samp_fields'] = ResolversParentTypes['declined_visit_matches_stddev_samp_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_sum_fields'] = ResolversParentTypes['declined_visit_matches_sum_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_var_pop_fields'] = ResolversParentTypes['declined_visit_matches_var_pop_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_var_samp_fields'] = ResolversParentTypes['declined_visit_matches_var_samp_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Declined_Visit_Matches_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['declined_visit_matches_variance_fields'] = ResolversParentTypes['declined_visit_matches_variance_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['document'] = ResolversParentTypes['document']> = {
  added_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applications?: Resolver<Array<ResolversTypes['application']>, ParentType, ContextType, RequireFields<DocumentApplicationsArgs, never>>;
  applications_aggregate?: Resolver<ResolversTypes['application_aggregate'], ParentType, ContextType, RequireFields<DocumentApplications_AggregateArgs, never>>;
  attached_to?: Resolver<Array<ResolversTypes['document_user']>, ParentType, ContextType, RequireFields<DocumentAttached_ToArgs, never>>;
  attached_to_aggregate?: Resolver<ResolversTypes['document_user_aggregate'], ParentType, ContextType, RequireFields<DocumentAttached_To_AggregateArgs, never>>;
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_contractor_accesses?: Resolver<Array<ResolversTypes['document_contractor_access']>, ParentType, ContextType, RequireFields<DocumentDocument_Contractor_AccessesArgs, never>>;
  document_contractor_accesses_aggregate?: Resolver<ResolversTypes['document_contractor_access_aggregate'], ParentType, ContextType, RequireFields<DocumentDocument_Contractor_Accesses_AggregateArgs, never>>;
  document_custom_requests?: Resolver<Array<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<DocumentDocument_Custom_RequestsArgs, never>>;
  document_custom_requests_aggregate?: Resolver<ResolversTypes['document_custom_request_aggregate'], ParentType, ContextType, RequireFields<DocumentDocument_Custom_Requests_AggregateArgs, never>>;
  document_projects?: Resolver<Array<ResolversTypes['document_project']>, ParentType, ContextType, RequireFields<DocumentDocument_ProjectsArgs, never>>;
  document_projects_aggregate?: Resolver<ResolversTypes['document_project_aggregate'], ParentType, ContextType, RequireFields<DocumentDocument_Projects_AggregateArgs, never>>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  team?: Resolver<Maybe<ResolversTypes['team']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uploaded_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_aggregate'] = ResolversParentTypes['document_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['document_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['document']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_aggregate_fields'] = ResolversParentTypes['document_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Document_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['document_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['document_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Contractor_AccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_contractor_access'] = ResolversParentTypes['document_contractor_access']> = {
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  document?: Resolver<ResolversTypes['document'], ParentType, ContextType>;
  document_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Contractor_Access_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_contractor_access_aggregate'] = ResolversParentTypes['document_contractor_access_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['document_contractor_access_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['document_contractor_access']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Contractor_Access_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_contractor_access_aggregate_fields'] = ResolversParentTypes['document_contractor_access_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Document_Contractor_Access_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['document_contractor_access_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['document_contractor_access_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Contractor_Access_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_contractor_access_max_fields'] = ResolversParentTypes['document_contractor_access_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Contractor_Access_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_contractor_access_min_fields'] = ResolversParentTypes['document_contractor_access_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Contractor_Access_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_contractor_access_mutation_response'] = ResolversParentTypes['document_contractor_access_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['document_contractor_access']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Custom_RequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_custom_request'] = ResolversParentTypes['document_custom_request']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  created_by?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  custom_request?: Resolver<ResolversTypes['custom_request'], ParentType, ContextType>;
  custom_request_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  document?: Resolver<ResolversTypes['document'], ParentType, ContextType>;
  document_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Custom_Request_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_custom_request_aggregate'] = ResolversParentTypes['document_custom_request_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['document_custom_request_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['document_custom_request']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Custom_Request_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_custom_request_aggregate_fields'] = ResolversParentTypes['document_custom_request_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Document_Custom_Request_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['document_custom_request_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['document_custom_request_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Custom_Request_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_custom_request_max_fields'] = ResolversParentTypes['document_custom_request_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  custom_request_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Custom_Request_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_custom_request_min_fields'] = ResolversParentTypes['document_custom_request_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  custom_request_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Custom_Request_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_custom_request_mutation_response'] = ResolversParentTypes['document_custom_request_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['document_custom_request']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_max_fields'] = ResolversParentTypes['document_max_fields']> = {
  added_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uploaded_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_min_fields'] = ResolversParentTypes['document_min_fields']> = {
  added_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uploaded_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_mutation_response'] = ResolversParentTypes['document_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['document']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_project'] = ResolversParentTypes['document_project']> = {
  access_scope?: Resolver<ResolversTypes['document_project_access_scope'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document?: Resolver<ResolversTypes['document'], ParentType, ContextType>;
  document_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  is_core_plan?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Document_Project_Access_ScopeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['document_project_access_scope'], any> {
  name: 'document_project_access_scope';
}

export type Document_Project_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_project_aggregate'] = ResolversParentTypes['document_project_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['document_project_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['document_project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Project_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_project_aggregate_fields'] = ResolversParentTypes['document_project_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Document_Project_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['document_project_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['document_project_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Project_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_project_max_fields'] = ResolversParentTypes['document_project_max_fields']> = {
  access_scope?: Resolver<Maybe<ResolversTypes['document_project_access_scope']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Project_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_project_min_fields'] = ResolversParentTypes['document_project_min_fields']> = {
  access_scope?: Resolver<Maybe<ResolversTypes['document_project_access_scope']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_Project_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_project_mutation_response'] = ResolversParentTypes['document_project_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['document_project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_user'] = ResolversParentTypes['document_user']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  document?: Resolver<ResolversTypes['document'], ParentType, ContextType>;
  document_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_User_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_user_aggregate'] = ResolversParentTypes['document_user_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['document_user_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['document_user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_User_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_user_aggregate_fields'] = ResolversParentTypes['document_user_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Document_User_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['document_user_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['document_user_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_User_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_user_max_fields'] = ResolversParentTypes['document_user_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_User_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_user_min_fields'] = ResolversParentTypes['document_user_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  document_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Document_User_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['document_user_mutation_response'] = ResolversParentTypes['document_user_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['document_user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_RegexResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex'] = ResolversParentTypes['email_regex']> = {
  active_status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email_extension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_aggregate'] = ResolversParentTypes['email_regex_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['email_regex_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['email_regex']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_aggregate_fields'] = ResolversParentTypes['email_regex_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['email_regex_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Email_Regex_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['email_regex_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['email_regex_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['email_regex_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['email_regex_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['email_regex_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['email_regex_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['email_regex_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['email_regex_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['email_regex_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_avg_fields'] = ResolversParentTypes['email_regex_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_max_fields'] = ResolversParentTypes['email_regex_max_fields']> = {
  email_extension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_min_fields'] = ResolversParentTypes['email_regex_min_fields']> = {
  email_extension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_mutation_response'] = ResolversParentTypes['email_regex_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['email_regex']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_stddev_fields'] = ResolversParentTypes['email_regex_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_stddev_pop_fields'] = ResolversParentTypes['email_regex_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_stddev_samp_fields'] = ResolversParentTypes['email_regex_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_sum_fields'] = ResolversParentTypes['email_regex_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_var_pop_fields'] = ResolversParentTypes['email_regex_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_var_samp_fields'] = ResolversParentTypes['email_regex_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Email_Regex_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['email_regex_variance_fields'] = ResolversParentTypes['email_regex_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill'] = ResolversParentTypes['experience_skill']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  experience?: Resolver<ResolversTypes['user_experience'], ParentType, ContextType>;
  experience_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['skill'], ParentType, ContextType>;
  skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_aggregate'] = ResolversParentTypes['experience_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['experience_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['experience_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_aggregate_fields'] = ResolversParentTypes['experience_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['experience_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Experience_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['experience_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['experience_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['experience_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['experience_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['experience_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['experience_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['experience_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['experience_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['experience_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_avg_fields'] = ResolversParentTypes['experience_skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_max_fields'] = ResolversParentTypes['experience_skill_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  experience_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_min_fields'] = ResolversParentTypes['experience_skill_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  experience_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_mutation_response'] = ResolversParentTypes['experience_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['experience_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_stddev_fields'] = ResolversParentTypes['experience_skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_stddev_pop_fields'] = ResolversParentTypes['experience_skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_stddev_samp_fields'] = ResolversParentTypes['experience_skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_sum_fields'] = ResolversParentTypes['experience_skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_var_pop_fields'] = ResolversParentTypes['experience_skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_var_samp_fields'] = ResolversParentTypes['experience_skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Experience_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['experience_skill_variance_fields'] = ResolversParentTypes['experience_skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface Float8ScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['float8'], any> {
  name: 'float8';
}

export type GenderResolvers<ContextType = any, ParentType extends ResolversParentTypes['gender'] = ResolversParentTypes['gender']> = {
  client_care_plans?: Resolver<Array<ResolversTypes['client_care_plan']>, ParentType, ContextType, RequireFields<GenderClient_Care_PlansArgs, never>>;
  client_care_plans_aggregate?: Resolver<ResolversTypes['client_care_plan_aggregate'], ParentType, ContextType, RequireFields<GenderClient_Care_Plans_AggregateArgs, never>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Gender_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['gender_aggregate'] = ResolversParentTypes['gender_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['gender_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['gender']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Gender_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['gender_aggregate_fields'] = ResolversParentTypes['gender_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Gender_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['gender_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['gender_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Gender_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['gender_max_fields'] = ResolversParentTypes['gender_max_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Gender_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['gender_min_fields'] = ResolversParentTypes['gender_min_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Gender_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['gender_mutation_response'] = ResolversParentTypes['gender_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['gender']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IndustryResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry'] = ResolversParentTypes['industry']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  posting_industries?: Resolver<Array<ResolversTypes['posting_industry']>, ParentType, ContextType, RequireFields<IndustryPosting_IndustriesArgs, never>>;
  posting_industries_aggregate?: Resolver<ResolversTypes['posting_industry_aggregate'], ParentType, ContextType, RequireFields<IndustryPosting_Industries_AggregateArgs, never>>;
  user_experiences?: Resolver<Array<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<IndustryUser_ExperiencesArgs, never>>;
  user_experiences_aggregate?: Resolver<ResolversTypes['user_experience_aggregate'], ParentType, ContextType, RequireFields<IndustryUser_Experiences_AggregateArgs, never>>;
  users?: Resolver<Array<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<IndustryUsersArgs, never>>;
  users_aggregate?: Resolver<ResolversTypes['user_industry_aggregate'], ParentType, ContextType, RequireFields<IndustryUsers_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_aggregate'] = ResolversParentTypes['industry_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['industry_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['industry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_aggregate_fields'] = ResolversParentTypes['industry_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['industry_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Industry_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['industry_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['industry_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['industry_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['industry_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['industry_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['industry_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['industry_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['industry_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['industry_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_avg_fields'] = ResolversParentTypes['industry_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_max_fields'] = ResolversParentTypes['industry_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_min_fields'] = ResolversParentTypes['industry_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_mutation_response'] = ResolversParentTypes['industry_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['industry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_stddev_fields'] = ResolversParentTypes['industry_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_stddev_pop_fields'] = ResolversParentTypes['industry_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_stddev_samp_fields'] = ResolversParentTypes['industry_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_sum_fields'] = ResolversParentTypes['industry_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_var_pop_fields'] = ResolversParentTypes['industry_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_var_samp_fields'] = ResolversParentTypes['industry_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Industry_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['industry_variance_fields'] = ResolversParentTypes['industry_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['invitation'] = ResolversParentTypes['invitation']> = {
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  given_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  invited_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invited_by_user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  new_user?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invitation_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['invitation_aggregate'] = ResolversParentTypes['invitation_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['invitation_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['invitation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invitation_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invitation_aggregate_fields'] = ResolversParentTypes['invitation_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Invitation_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['invitation_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['invitation_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invitation_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invitation_max_fields'] = ResolversParentTypes['invitation_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  given_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invited_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invitation_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invitation_min_fields'] = ResolversParentTypes['invitation_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  given_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invited_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invitation_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['invitation_mutation_response'] = ResolversParentTypes['invitation_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['invitation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice'] = ResolversParentTypes['invoice']> = {
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  external_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, RequireFields<InvoiceFileArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  invoice_ref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_submission_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  is_opened?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_activities?: Resolver<Array<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<InvoiceProject_ActivitiesArgs, never>>;
  project_activities_aggregate?: Resolver<ResolversTypes['project_activity_aggregate'], ParentType, ContextType, RequireFields<InvoiceProject_Activities_AggregateArgs, never>>;
  project_activity_times?: Resolver<Array<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<InvoiceProject_Activity_TimesArgs, never>>;
  project_activity_times_aggregate?: Resolver<ResolversTypes['project_activity_time_aggregate'], ParentType, ContextType, RequireFields<InvoiceProject_Activity_Times_AggregateArgs, never>>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submit_by?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  total_amount?: Resolver<ResolversTypes['float8'], ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_aggregate'] = ResolversParentTypes['invoice_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['invoice_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['invoice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_aggregate_fields'] = ResolversParentTypes['invoice_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['invoice_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Invoice_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['invoice_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['invoice_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['invoice_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['invoice_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['invoice_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['invoice_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['invoice_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['invoice_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['invoice_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_avg_fields'] = ResolversParentTypes['invoice_avg_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_max_fields'] = ResolversParentTypes['invoice_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  external_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invoice_ref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_submission_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submit_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_min_fields'] = ResolversParentTypes['invoice_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  external_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invoice_ref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoice_submission_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submit_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_mutation_response'] = ResolversParentTypes['invoice_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['invoice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_stddev_fields'] = ResolversParentTypes['invoice_stddev_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_stddev_pop_fields'] = ResolversParentTypes['invoice_stddev_pop_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_stddev_samp_fields'] = ResolversParentTypes['invoice_stddev_samp_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_sum_fields'] = ResolversParentTypes['invoice_sum_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_var_pop_fields'] = ResolversParentTypes['invoice_var_pop_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_var_samp_fields'] = ResolversParentTypes['invoice_var_samp_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoice_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoice_variance_fields'] = ResolversParentTypes['invoice_variance_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonbScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['jsonb'], any> {
  name: 'jsonb';
}

export type LanguageResolvers<ContextType = any, ParentType extends ResolversParentTypes['language'] = ResolversParentTypes['language']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  native_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_languages?: Resolver<Array<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<LanguageUser_LanguagesArgs, never>>;
  user_languages_aggregate?: Resolver<ResolversTypes['user_language_aggregate'], ParentType, ContextType, RequireFields<LanguageUser_Languages_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_aggregate'] = ResolversParentTypes['language_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['language_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['language']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_aggregate_fields'] = ResolversParentTypes['language_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['language_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Language_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['language_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['language_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['language_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['language_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['language_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['language_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['language_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['language_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['language_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_avg_fields'] = ResolversParentTypes['language_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_max_fields'] = ResolversParentTypes['language_max_fields']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  native_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_min_fields'] = ResolversParentTypes['language_min_fields']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  native_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_mutation_response'] = ResolversParentTypes['language_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['language']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_stddev_fields'] = ResolversParentTypes['language_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_stddev_pop_fields'] = ResolversParentTypes['language_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_stddev_samp_fields'] = ResolversParentTypes['language_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_sum_fields'] = ResolversParentTypes['language_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_var_pop_fields'] = ResolversParentTypes['language_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_var_samp_fields'] = ResolversParentTypes['language_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Language_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['language_variance_fields'] = ResolversParentTypes['language_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagerResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager'] = ResolversParentTypes['manager']> = {
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  contractors?: Resolver<Array<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<ManagerContractorsArgs, never>>;
  contractors_aggregate?: Resolver<ResolversTypes['manager_contractor_aggregate'], ParentType, ContextType, RequireFields<ManagerContractors_AggregateArgs, never>>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  declined_visit_matches?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<ManagerDeclined_Visit_MatchesArgs, never>>;
  declined_visit_matches_aggregate?: Resolver<ResolversTypes['declined_visit_matches_aggregate'], ParentType, ContextType, RequireFields<ManagerDeclined_Visit_Matches_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  marketplace_access_allowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  marketplace_access_requested?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  postings?: Resolver<Array<ResolversTypes['posting']>, ParentType, ContextType, RequireFields<ManagerPostingsArgs, never>>;
  postings_aggregate?: Resolver<ResolversTypes['posting_aggregate'], ParentType, ContextType, RequireFields<ManagerPostings_AggregateArgs, never>>;
  projects?: Resolver<Array<ResolversTypes['project']>, ParentType, ContextType, RequireFields<ManagerProjectsArgs, never>>;
  projects_aggregate?: Resolver<ResolversTypes['project_aggregate'], ParentType, ContextType, RequireFields<ManagerProjects_AggregateArgs, never>>;
  resources_access_allowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  smart_match_bookmarks?: Resolver<Array<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<ManagerSmart_Match_BookmarksArgs, never>>;
  smart_match_bookmarks_aggregate?: Resolver<ResolversTypes['smart_match_bookmark_aggregate'], ParentType, ContextType, RequireFields<ManagerSmart_Match_Bookmarks_AggregateArgs, never>>;
  smart_match_config?: Resolver<Maybe<ResolversTypes['smart_match_configs']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teams?: Resolver<Array<ResolversTypes['team_manager']>, ParentType, ContextType, RequireFields<ManagerTeamsArgs, never>>;
  teams_aggregate?: Resolver<ResolversTypes['team_manager_aggregate'], ParentType, ContextType, RequireFields<ManagerTeams_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_aggregate'] = ResolversParentTypes['manager_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['manager_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['manager']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_aggregate_fields'] = ResolversParentTypes['manager_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Manager_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['manager_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['manager_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_ContractorResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_contractor'] = ResolversParentTypes['manager_contractor']> = {
  approved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_by_user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  manager?: Resolver<ResolversTypes['manager'], ParentType, ContextType>;
  manager_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Contractor_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_contractor_aggregate'] = ResolversParentTypes['manager_contractor_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['manager_contractor_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['manager_contractor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Contractor_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_contractor_aggregate_fields'] = ResolversParentTypes['manager_contractor_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Manager_Contractor_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['manager_contractor_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['manager_contractor_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Contractor_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_contractor_max_fields'] = ResolversParentTypes['manager_contractor_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Contractor_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_contractor_min_fields'] = ResolversParentTypes['manager_contractor_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Contractor_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_contractor_mutation_response'] = ResolversParentTypes['manager_contractor_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['manager_contractor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_max_fields'] = ResolversParentTypes['manager_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_min_fields'] = ResolversParentTypes['manager_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Manager_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['manager_mutation_response'] = ResolversParentTypes['manager_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['manager']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['message'] = ResolversParentTypes['message']> = {
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversation?: Resolver<ResolversTypes['conversation'], ParentType, ContextType>;
  conversation_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  notified_by_email?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notified_in_app?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recipient_message?: Resolver<Array<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<MessageRecipient_MessageArgs, never>>;
  recipient_message_aggregate?: Resolver<ResolversTypes['recipient_message_aggregate'], ParentType, ContextType, RequireFields<MessageRecipient_Message_AggregateArgs, never>>;
  sender?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  sender_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Message_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['message_aggregate'] = ResolversParentTypes['message_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['message_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Message_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['message_aggregate_fields'] = ResolversParentTypes['message_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Message_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['message_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['message_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Message_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['message_max_fields'] = ResolversParentTypes['message_max_fields']> = {
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sender_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Message_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['message_min_fields'] = ResolversParentTypes['message_min_fields']> = {
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sender_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Message_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['message_mutation_response'] = ResolversParentTypes['message_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Mutation_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['mutation_root'] = ResolversParentTypes['mutation_root']> = {
  delete_admin?: Resolver<Maybe<ResolversTypes['admin_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AdminArgs, 'where'>>;
  delete_admin_by_pk?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Admin_By_PkArgs, 'id'>>;
  delete_application?: Resolver<Maybe<ResolversTypes['application_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ApplicationArgs, 'where'>>;
  delete_application_by_pk?: Resolver<Maybe<ResolversTypes['application']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Application_By_PkArgs, 'id'>>;
  delete_candidate?: Resolver<Maybe<ResolversTypes['candidate_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CandidateArgs, 'where'>>;
  delete_candidate_by_pk?: Resolver<Maybe<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Candidate_By_PkArgs, 'id'>>;
  delete_checkin_status?: Resolver<Maybe<ResolversTypes['checkin_status_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Checkin_StatusArgs, 'where'>>;
  delete_checkin_status_by_pk?: Resolver<Maybe<ResolversTypes['checkin_status']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Checkin_Status_By_PkArgs, 'value'>>;
  delete_checkout_status?: Resolver<Maybe<ResolversTypes['checkout_status_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Checkout_StatusArgs, 'where'>>;
  delete_checkout_status_by_pk?: Resolver<Maybe<ResolversTypes['checkout_status']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Checkout_Status_By_PkArgs, 'value'>>;
  delete_client_care_plan?: Resolver<Maybe<ResolversTypes['client_care_plan_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Client_Care_PlanArgs, 'where'>>;
  delete_client_care_plan_by_pk?: Resolver<Maybe<ResolversTypes['client_care_plan']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Client_Care_Plan_By_PkArgs, 'id'>>;
  delete_client_medications?: Resolver<Maybe<ResolversTypes['client_medications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Client_MedicationsArgs, 'where'>>;
  delete_client_medications_by_pk?: Resolver<Maybe<ResolversTypes['client_medications']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Client_Medications_By_PkArgs, 'id'>>;
  delete_company?: Resolver<Maybe<ResolversTypes['company_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CompanyArgs, 'where'>>;
  delete_company_by_pk?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Company_By_PkArgs, 'id'>>;
  delete_company_follower?: Resolver<Maybe<ResolversTypes['company_follower_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Company_FollowerArgs, 'where'>>;
  delete_company_follower_by_pk?: Resolver<Maybe<ResolversTypes['company_follower']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Company_Follower_By_PkArgs, 'id'>>;
  delete_company_user_notifications?: Resolver<Maybe<ResolversTypes['company_user_notifications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Company_User_NotificationsArgs, 'where'>>;
  delete_company_user_notifications_by_pk?: Resolver<Maybe<ResolversTypes['company_user_notifications']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Company_User_Notifications_By_PkArgs, 'id'>>;
  delete_contractor?: Resolver<Maybe<ResolversTypes['contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ContractorArgs, 'where'>>;
  delete_contractor_by_pk?: Resolver<Maybe<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_By_PkArgs, 'id'>>;
  delete_contractor_note?: Resolver<Maybe<ResolversTypes['contractor_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_NoteArgs, 'where'>>;
  delete_contractor_note_by_pk?: Resolver<Maybe<ResolversTypes['contractor_note']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_Note_By_PkArgs, 'id'>>;
  delete_contractor_posting?: Resolver<Maybe<ResolversTypes['contractor_posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_PostingArgs, 'where'>>;
  delete_contractor_posting_by_pk?: Resolver<Maybe<ResolversTypes['contractor_posting']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_Posting_By_PkArgs, 'id'>>;
  delete_contractor_project?: Resolver<Maybe<ResolversTypes['contractor_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_ProjectArgs, 'where'>>;
  delete_contractor_project_by_pk?: Resolver<Maybe<ResolversTypes['contractor_project']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_Project_By_PkArgs, 'id'>>;
  delete_contractor_rating?: Resolver<Maybe<ResolversTypes['contractor_rating_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_RatingArgs, 'where'>>;
  delete_contractor_rating_by_pk?: Resolver<Maybe<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_Rating_By_PkArgs, 'id'>>;
  delete_contractor_staff_note?: Resolver<Maybe<ResolversTypes['contractor_staff_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_Staff_NoteArgs, 'where'>>;
  delete_contractor_staff_note_by_pk?: Resolver<Maybe<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contractor_Staff_Note_By_PkArgs, 'id'>>;
  delete_conversation?: Resolver<Maybe<ResolversTypes['conversation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ConversationArgs, 'where'>>;
  delete_conversation_by_pk?: Resolver<Maybe<ResolversTypes['conversation']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Conversation_By_PkArgs, 'id'>>;
  delete_custom_request?: Resolver<Maybe<ResolversTypes['custom_request_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Custom_RequestArgs, 'where'>>;
  delete_custom_request_by_pk?: Resolver<Maybe<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Custom_Request_By_PkArgs, 'id'>>;
  delete_custom_request_skills?: Resolver<Maybe<ResolversTypes['custom_request_skills_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Custom_Request_SkillsArgs, 'where'>>;
  delete_custom_request_skills_by_pk?: Resolver<Maybe<ResolversTypes['custom_request_skills']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Custom_Request_Skills_By_PkArgs, 'id'>>;
  delete_declined_visit_matches?: Resolver<Maybe<ResolversTypes['declined_visit_matches_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Declined_Visit_MatchesArgs, 'where'>>;
  delete_declined_visit_matches_by_pk?: Resolver<Maybe<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Declined_Visit_Matches_By_PkArgs, 'id'>>;
  delete_document?: Resolver<Maybe<ResolversTypes['document_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_DocumentArgs, 'where'>>;
  delete_document_by_pk?: Resolver<Maybe<ResolversTypes['document']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_By_PkArgs, 'id'>>;
  delete_document_contractor_access?: Resolver<Maybe<ResolversTypes['document_contractor_access_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_Contractor_AccessArgs, 'where'>>;
  delete_document_contractor_access_by_pk?: Resolver<Maybe<ResolversTypes['document_contractor_access']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_Contractor_Access_By_PkArgs, 'id'>>;
  delete_document_custom_request?: Resolver<Maybe<ResolversTypes['document_custom_request_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_Custom_RequestArgs, 'where'>>;
  delete_document_custom_request_by_pk?: Resolver<Maybe<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_Custom_Request_By_PkArgs, 'id'>>;
  delete_document_project?: Resolver<Maybe<ResolversTypes['document_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_ProjectArgs, 'where'>>;
  delete_document_project_by_pk?: Resolver<Maybe<ResolversTypes['document_project']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_Project_By_PkArgs, 'id'>>;
  delete_document_user?: Resolver<Maybe<ResolversTypes['document_user_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_UserArgs, 'where'>>;
  delete_document_user_by_pk?: Resolver<Maybe<ResolversTypes['document_user']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Document_User_By_PkArgs, 'id'>>;
  delete_email_regex?: Resolver<Maybe<ResolversTypes['email_regex_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Email_RegexArgs, 'where'>>;
  delete_email_regex_by_pk?: Resolver<Maybe<ResolversTypes['email_regex']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Email_Regex_By_PkArgs, 'id'>>;
  delete_experience_skill?: Resolver<Maybe<ResolversTypes['experience_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Experience_SkillArgs, 'where'>>;
  delete_experience_skill_by_pk?: Resolver<Maybe<ResolversTypes['experience_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Experience_Skill_By_PkArgs, 'id'>>;
  delete_gender?: Resolver<Maybe<ResolversTypes['gender_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_GenderArgs, 'where'>>;
  delete_gender_by_pk?: Resolver<Maybe<ResolversTypes['gender']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Gender_By_PkArgs, 'value'>>;
  delete_industry?: Resolver<Maybe<ResolversTypes['industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_IndustryArgs, 'where'>>;
  delete_industry_by_pk?: Resolver<Maybe<ResolversTypes['industry']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Industry_By_PkArgs, 'id'>>;
  delete_invitation?: Resolver<Maybe<ResolversTypes['invitation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_InvitationArgs, 'where'>>;
  delete_invitation_by_pk?: Resolver<Maybe<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Invitation_By_PkArgs, 'id'>>;
  delete_invoice?: Resolver<Maybe<ResolversTypes['invoice_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_InvoiceArgs, 'where'>>;
  delete_invoice_by_pk?: Resolver<Maybe<ResolversTypes['invoice']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Invoice_By_PkArgs, 'id'>>;
  delete_language?: Resolver<Maybe<ResolversTypes['language_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_LanguageArgs, 'where'>>;
  delete_language_by_pk?: Resolver<Maybe<ResolversTypes['language']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Language_By_PkArgs, 'id'>>;
  delete_manager?: Resolver<Maybe<ResolversTypes['manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ManagerArgs, 'where'>>;
  delete_manager_by_pk?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Manager_By_PkArgs, 'id'>>;
  delete_manager_contractor?: Resolver<Maybe<ResolversTypes['manager_contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Manager_ContractorArgs, 'where'>>;
  delete_manager_contractor_by_pk?: Resolver<Maybe<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Manager_Contractor_By_PkArgs, 'id'>>;
  delete_message?: Resolver<Maybe<ResolversTypes['message_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_MessageArgs, 'where'>>;
  delete_message_by_pk?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Message_By_PkArgs, 'id'>>;
  delete_notification?: Resolver<Maybe<ResolversTypes['notification_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_NotificationArgs, 'where'>>;
  delete_notification_by_pk?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Notification_By_PkArgs, 'id'>>;
  delete_onboarding?: Resolver<Maybe<ResolversTypes['onboarding_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_OnboardingArgs, 'where'>>;
  delete_onboarding_by_pk?: Resolver<Maybe<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Onboarding_By_PkArgs, 'id'>>;
  delete_payment_card?: Resolver<Maybe<ResolversTypes['payment_card_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Payment_CardArgs, 'where'>>;
  delete_payment_card_by_pk?: Resolver<Maybe<ResolversTypes['payment_card']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Payment_Card_By_PkArgs, 'id'>>;
  delete_posting?: Resolver<Maybe<ResolversTypes['posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_PostingArgs, 'where'>>;
  delete_posting_by_pk?: Resolver<Maybe<ResolversTypes['posting']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Posting_By_PkArgs, 'id'>>;
  delete_posting_industry?: Resolver<Maybe<ResolversTypes['posting_industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Posting_IndustryArgs, 'where'>>;
  delete_posting_industry_by_pk?: Resolver<Maybe<ResolversTypes['posting_industry']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Posting_Industry_By_PkArgs, 'id'>>;
  delete_posting_skill?: Resolver<Maybe<ResolversTypes['posting_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Posting_SkillArgs, 'where'>>;
  delete_posting_skill_by_pk?: Resolver<Maybe<ResolversTypes['posting_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Posting_Skill_By_PkArgs, 'id'>>;
  delete_posting_tags?: Resolver<Maybe<ResolversTypes['posting_tags_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Posting_TagsArgs, 'where'>>;
  delete_posting_tags_by_pk?: Resolver<Maybe<ResolversTypes['posting_tags']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Posting_Tags_By_PkArgs, 'id'>>;
  delete_project?: Resolver<Maybe<ResolversTypes['project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ProjectArgs, 'where'>>;
  delete_project_activity?: Resolver<Maybe<ResolversTypes['project_activity_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_ActivityArgs, 'where'>>;
  delete_project_activity_by_pk?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_By_PkArgs, 'id'>>;
  delete_project_activity_note?: Resolver<Maybe<ResolversTypes['project_activity_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_NoteArgs, 'where'>>;
  delete_project_activity_note_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_note']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Note_By_PkArgs, 'id'>>;
  delete_project_activity_request_more_hours?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Request_More_HoursArgs, 'where'>>;
  delete_project_activity_request_more_hours_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Request_More_Hours_By_PkArgs, 'id'>>;
  delete_project_activity_skill?: Resolver<Maybe<ResolversTypes['project_activity_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_SkillArgs, 'where'>>;
  delete_project_activity_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Skill_By_PkArgs, 'id'>>;
  delete_project_activity_soft_skill?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Soft_SkillArgs, 'where'>>;
  delete_project_activity_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Soft_Skill_By_PkArgs, 'id'>>;
  delete_project_activity_tag?: Resolver<Maybe<ResolversTypes['project_activity_tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_TagArgs, 'where'>>;
  delete_project_activity_tag_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_tag']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Tag_By_PkArgs, 'id'>>;
  delete_project_activity_time?: Resolver<Maybe<ResolversTypes['project_activity_time_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_TimeArgs, 'where'>>;
  delete_project_activity_time_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Time_By_PkArgs, 'id'>>;
  delete_project_activity_tracked_time?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Tracked_TimeArgs, 'where'>>;
  delete_project_activity_tracked_time_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Activity_Tracked_Time_By_PkArgs, 'id'>>;
  delete_project_by_pk?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_By_PkArgs, 'id'>>;
  delete_project_skill?: Resolver<Maybe<ResolversTypes['project_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_SkillArgs, 'where'>>;
  delete_project_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Skill_By_PkArgs, 'id'>>;
  delete_project_soft_skill?: Resolver<Maybe<ResolversTypes['project_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Soft_SkillArgs, 'where'>>;
  delete_project_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Soft_Skill_By_PkArgs, 'id'>>;
  delete_project_tag?: Resolver<Maybe<ResolversTypes['project_tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_TagArgs, 'where'>>;
  delete_project_tag_by_pk?: Resolver<Maybe<ResolversTypes['project_tag']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Project_Tag_By_PkArgs, 'id'>>;
  delete_recipient_message?: Resolver<Maybe<ResolversTypes['recipient_message_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Recipient_MessageArgs, 'where'>>;
  delete_recipient_message_by_pk?: Resolver<Maybe<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Recipient_Message_By_PkArgs, 'id'>>;
  delete_resource_information_card?: Resolver<Maybe<ResolversTypes['resource_information_card_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Resource_Information_CardArgs, 'where'>>;
  delete_resource_information_card_by_pk?: Resolver<Maybe<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Resource_Information_Card_By_PkArgs, 'id'>>;
  delete_skill?: Resolver<Maybe<ResolversTypes['skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SkillArgs, 'where'>>;
  delete_skill_by_pk?: Resolver<Maybe<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Skill_By_PkArgs, 'id'>>;
  delete_skills_short_name_first?: Resolver<Maybe<ResolversTypes['skills_short_name_first_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Skills_Short_Name_FirstArgs, 'where'>>;
  delete_smart_match_bookmark?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_BookmarkArgs, 'where'>>;
  delete_smart_match_bookmark_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_Bookmark_By_PkArgs, 'id'>>;
  delete_smart_match_config_transportation?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_Config_TransportationArgs, 'where'>>;
  delete_smart_match_config_transportation_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_Config_Transportation_By_PkArgs, 'id'>>;
  delete_smart_match_configs?: Resolver<Maybe<ResolversTypes['smart_match_configs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_ConfigsArgs, 'where'>>;
  delete_smart_match_configs_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_configs']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_Configs_By_PkArgs, 'id'>>;
  delete_smart_match_criteria_order?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_Criteria_OrderArgs, 'where'>>;
  delete_smart_match_criteria_order_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Smart_Match_Criteria_Order_By_PkArgs, 'id'>>;
  delete_soft_skill?: Resolver<Maybe<ResolversTypes['soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Soft_SkillArgs, 'where'>>;
  delete_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Soft_Skill_By_PkArgs, 'id'>>;
  delete_source?: Resolver<Maybe<ResolversTypes['source_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SourceArgs, 'where'>>;
  delete_source_by_pk?: Resolver<Maybe<ResolversTypes['source']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Source_By_PkArgs, 'id'>>;
  delete_subscription?: Resolver<Maybe<ResolversTypes['subscription_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SubscriptionArgs, 'where'>>;
  delete_subscription_by_pk?: Resolver<Maybe<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Subscription_By_PkArgs, 'id'>>;
  delete_subscription_plan?: Resolver<Maybe<ResolversTypes['subscription_plan_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Subscription_PlanArgs, 'where'>>;
  delete_subscription_plan_access_permissions?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Subscription_Plan_Access_PermissionsArgs, 'where'>>;
  delete_subscription_plan_access_permissions_by_pk?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Subscription_Plan_Access_Permissions_By_PkArgs, 'id'>>;
  delete_subscription_plan_by_pk?: Resolver<Maybe<ResolversTypes['subscription_plan']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Subscription_Plan_By_PkArgs, 'id'>>;
  delete_tag?: Resolver<Maybe<ResolversTypes['tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_TagArgs, 'where'>>;
  delete_tag_by_pk?: Resolver<Maybe<ResolversTypes['tag']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Tag_By_PkArgs, 'id'>>;
  delete_team?: Resolver<Maybe<ResolversTypes['team_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_TeamArgs, 'where'>>;
  delete_team_by_pk?: Resolver<Maybe<ResolversTypes['team']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_By_PkArgs, 'id'>>;
  delete_team_contractor?: Resolver<Maybe<ResolversTypes['team_contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_ContractorArgs, 'where'>>;
  delete_team_contractor_by_pk?: Resolver<Maybe<ResolversTypes['team_contractor']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_Contractor_By_PkArgs, 'id'>>;
  delete_team_manager?: Resolver<Maybe<ResolversTypes['team_manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_ManagerArgs, 'where'>>;
  delete_team_manager_by_pk?: Resolver<Maybe<ResolversTypes['team_manager']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_Manager_By_PkArgs, 'id'>>;
  delete_team_posting?: Resolver<Maybe<ResolversTypes['team_posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_PostingArgs, 'where'>>;
  delete_team_posting_by_pk?: Resolver<Maybe<ResolversTypes['team_posting']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_Posting_By_PkArgs, 'id'>>;
  delete_team_project?: Resolver<Maybe<ResolversTypes['team_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_ProjectArgs, 'where'>>;
  delete_team_project_by_pk?: Resolver<Maybe<ResolversTypes['team_project']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_Project_By_PkArgs, 'id'>>;
  delete_team_skill?: Resolver<Maybe<ResolversTypes['team_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_SkillArgs, 'where'>>;
  delete_team_skill_by_pk?: Resolver<Maybe<ResolversTypes['team_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Team_Skill_By_PkArgs, 'id'>>;
  delete_timesheet?: Resolver<Maybe<ResolversTypes['timesheet_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_TimesheetArgs, 'where'>>;
  delete_timesheet_by_pk?: Resolver<Maybe<ResolversTypes['timesheet']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Timesheet_By_PkArgs, 'id'>>;
  delete_type_of_visit?: Resolver<Maybe<ResolversTypes['type_of_visit_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Type_Of_VisitArgs, 'where'>>;
  delete_type_of_visit_by_pk?: Resolver<Maybe<ResolversTypes['type_of_visit']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Type_Of_Visit_By_PkArgs, 'value'>>;
  delete_user?: Resolver<Maybe<ResolversTypes['user_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_UserArgs, 'where'>>;
  delete_user_affinda_profile?: Resolver<Maybe<ResolversTypes['user_affinda_profile_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Affinda_ProfileArgs, 'where'>>;
  delete_user_affinda_profile_by_pk?: Resolver<Maybe<ResolversTypes['user_affinda_profile']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Affinda_Profile_By_PkArgs, 'document_id'>>;
  delete_user_by_pk?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_By_PkArgs, 'id'>>;
  delete_user_certification?: Resolver<Maybe<ResolversTypes['user_certification_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_CertificationArgs, 'where'>>;
  delete_user_certification_by_pk?: Resolver<Maybe<ResolversTypes['user_certification']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Certification_By_PkArgs, 'id'>>;
  delete_user_company?: Resolver<Maybe<ResolversTypes['user_company_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_CompanyArgs, 'where'>>;
  delete_user_company_by_pk?: Resolver<Maybe<ResolversTypes['user_company']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Company_By_PkArgs, 'id'>>;
  delete_user_conversation?: Resolver<Maybe<ResolversTypes['user_conversation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_ConversationArgs, 'where'>>;
  delete_user_conversation_by_pk?: Resolver<Maybe<ResolversTypes['user_conversation']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Conversation_By_PkArgs, 'id'>>;
  delete_user_education?: Resolver<Maybe<ResolversTypes['user_education_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_EducationArgs, 'where'>>;
  delete_user_education_by_pk?: Resolver<Maybe<ResolversTypes['user_education']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Education_By_PkArgs, 'id'>>;
  delete_user_experience?: Resolver<Maybe<ResolversTypes['user_experience_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_ExperienceArgs, 'where'>>;
  delete_user_experience_by_pk?: Resolver<Maybe<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Experience_By_PkArgs, 'id'>>;
  delete_user_favorite?: Resolver<Maybe<ResolversTypes['user_favorite_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_FavoriteArgs, 'where'>>;
  delete_user_favorite_by_pk?: Resolver<Maybe<ResolversTypes['user_favorite']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Favorite_By_PkArgs, 'id'>>;
  delete_user_industry?: Resolver<Maybe<ResolversTypes['user_industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_IndustryArgs, 'where'>>;
  delete_user_industry_by_pk?: Resolver<Maybe<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Industry_By_PkArgs, 'id'>>;
  delete_user_job_title?: Resolver<Maybe<ResolversTypes['user_job_title_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Job_TitleArgs, 'where'>>;
  delete_user_job_title_by_pk?: Resolver<Maybe<ResolversTypes['user_job_title']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Job_Title_By_PkArgs, 'id'>>;
  delete_user_language?: Resolver<Maybe<ResolversTypes['user_language_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_LanguageArgs, 'where'>>;
  delete_user_language_by_pk?: Resolver<Maybe<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Language_By_PkArgs, 'id'>>;
  delete_user_private_data?: Resolver<Maybe<ResolversTypes['user_private_data_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Private_DataArgs, 'where'>>;
  delete_user_profile?: Resolver<Maybe<ResolversTypes['user_profile_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_ProfileArgs, 'where'>>;
  delete_user_profile_by_management?: Resolver<Maybe<ResolversTypes['user_profile_by_management_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Profile_By_ManagementArgs, 'where'>>;
  delete_user_profile_by_management_by_pk?: Resolver<Maybe<ResolversTypes['user_profile_by_management']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Profile_By_Management_By_PkArgs, 'added_by_id' | 'user_id'>>;
  delete_user_profile_by_pk?: Resolver<Maybe<ResolversTypes['user_profile']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Profile_By_PkArgs, 'user_id'>>;
  delete_user_rating?: Resolver<Maybe<ResolversTypes['user_rating_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_RatingArgs, 'where'>>;
  delete_user_rating_by_pk?: Resolver<Maybe<ResolversTypes['user_rating']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Rating_By_PkArgs, 'id'>>;
  delete_user_skill?: Resolver<Maybe<ResolversTypes['user_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_SkillArgs, 'where'>>;
  delete_user_skill_by_pk?: Resolver<Maybe<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Skill_By_PkArgs, 'id'>>;
  delete_user_soft_skill?: Resolver<Maybe<ResolversTypes['user_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Soft_SkillArgs, 'where'>>;
  delete_user_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['user_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Soft_Skill_By_PkArgs, 'id'>>;
  delete_user_transportation?: Resolver<Maybe<ResolversTypes['user_transportation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_TransportationArgs, 'where'>>;
  delete_user_transportation_by_pk?: Resolver<Maybe<ResolversTypes['user_transportation']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Transportation_By_PkArgs, 'id'>>;
  delete_user_watchlist?: Resolver<Maybe<ResolversTypes['user_watchlist_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_WatchlistArgs, 'where'>>;
  delete_user_watchlist_by_pk?: Resolver<Maybe<ResolversTypes['user_watchlist']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_User_Watchlist_By_PkArgs, 'id'>>;
  insert_admin?: Resolver<Maybe<ResolversTypes['admin_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AdminArgs, 'objects'>>;
  insert_admin_one?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Admin_OneArgs, 'object'>>;
  insert_application?: Resolver<Maybe<ResolversTypes['application_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ApplicationArgs, 'objects'>>;
  insert_application_one?: Resolver<Maybe<ResolversTypes['application']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Application_OneArgs, 'object'>>;
  insert_candidate?: Resolver<Maybe<ResolversTypes['candidate_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CandidateArgs, 'objects'>>;
  insert_candidate_one?: Resolver<Maybe<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Candidate_OneArgs, 'object'>>;
  insert_checkin_status?: Resolver<Maybe<ResolversTypes['checkin_status_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Checkin_StatusArgs, 'objects'>>;
  insert_checkin_status_one?: Resolver<Maybe<ResolversTypes['checkin_status']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Checkin_Status_OneArgs, 'object'>>;
  insert_checkout_status?: Resolver<Maybe<ResolversTypes['checkout_status_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Checkout_StatusArgs, 'objects'>>;
  insert_checkout_status_one?: Resolver<Maybe<ResolversTypes['checkout_status']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Checkout_Status_OneArgs, 'object'>>;
  insert_client_care_plan?: Resolver<Maybe<ResolversTypes['client_care_plan_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Client_Care_PlanArgs, 'objects'>>;
  insert_client_care_plan_one?: Resolver<Maybe<ResolversTypes['client_care_plan']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Client_Care_Plan_OneArgs, 'object'>>;
  insert_client_medications?: Resolver<Maybe<ResolversTypes['client_medications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Client_MedicationsArgs, 'objects'>>;
  insert_client_medications_one?: Resolver<Maybe<ResolversTypes['client_medications']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Client_Medications_OneArgs, 'object'>>;
  insert_company?: Resolver<Maybe<ResolversTypes['company_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CompanyArgs, 'objects'>>;
  insert_company_follower?: Resolver<Maybe<ResolversTypes['company_follower_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Company_FollowerArgs, 'objects'>>;
  insert_company_follower_one?: Resolver<Maybe<ResolversTypes['company_follower']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Company_Follower_OneArgs, 'object'>>;
  insert_company_one?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Company_OneArgs, 'object'>>;
  insert_company_user_notifications?: Resolver<Maybe<ResolversTypes['company_user_notifications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Company_User_NotificationsArgs, 'objects'>>;
  insert_company_user_notifications_one?: Resolver<Maybe<ResolversTypes['company_user_notifications']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Company_User_Notifications_OneArgs, 'object'>>;
  insert_contractor?: Resolver<Maybe<ResolversTypes['contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ContractorArgs, 'objects'>>;
  insert_contractor_note?: Resolver<Maybe<ResolversTypes['contractor_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_NoteArgs, 'objects'>>;
  insert_contractor_note_one?: Resolver<Maybe<ResolversTypes['contractor_note']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_Note_OneArgs, 'object'>>;
  insert_contractor_one?: Resolver<Maybe<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_OneArgs, 'object'>>;
  insert_contractor_posting?: Resolver<Maybe<ResolversTypes['contractor_posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_PostingArgs, 'objects'>>;
  insert_contractor_posting_one?: Resolver<Maybe<ResolversTypes['contractor_posting']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_Posting_OneArgs, 'object'>>;
  insert_contractor_project?: Resolver<Maybe<ResolversTypes['contractor_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_ProjectArgs, 'objects'>>;
  insert_contractor_project_one?: Resolver<Maybe<ResolversTypes['contractor_project']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_Project_OneArgs, 'object'>>;
  insert_contractor_rating?: Resolver<Maybe<ResolversTypes['contractor_rating_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_RatingArgs, 'objects'>>;
  insert_contractor_rating_one?: Resolver<Maybe<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_Rating_OneArgs, 'object'>>;
  insert_contractor_staff_note?: Resolver<Maybe<ResolversTypes['contractor_staff_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_Staff_NoteArgs, 'objects'>>;
  insert_contractor_staff_note_one?: Resolver<Maybe<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contractor_Staff_Note_OneArgs, 'object'>>;
  insert_conversation?: Resolver<Maybe<ResolversTypes['conversation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ConversationArgs, 'objects'>>;
  insert_conversation_one?: Resolver<Maybe<ResolversTypes['conversation']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Conversation_OneArgs, 'object'>>;
  insert_custom_request?: Resolver<Maybe<ResolversTypes['custom_request_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Custom_RequestArgs, 'objects'>>;
  insert_custom_request_one?: Resolver<Maybe<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Custom_Request_OneArgs, 'object'>>;
  insert_custom_request_skills?: Resolver<Maybe<ResolversTypes['custom_request_skills_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Custom_Request_SkillsArgs, 'objects'>>;
  insert_custom_request_skills_one?: Resolver<Maybe<ResolversTypes['custom_request_skills']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Custom_Request_Skills_OneArgs, 'object'>>;
  insert_declined_visit_matches?: Resolver<Maybe<ResolversTypes['declined_visit_matches_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Declined_Visit_MatchesArgs, 'objects'>>;
  insert_declined_visit_matches_one?: Resolver<Maybe<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Declined_Visit_Matches_OneArgs, 'object'>>;
  insert_document?: Resolver<Maybe<ResolversTypes['document_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_DocumentArgs, 'objects'>>;
  insert_document_contractor_access?: Resolver<Maybe<ResolversTypes['document_contractor_access_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_Contractor_AccessArgs, 'objects'>>;
  insert_document_contractor_access_one?: Resolver<Maybe<ResolversTypes['document_contractor_access']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_Contractor_Access_OneArgs, 'object'>>;
  insert_document_custom_request?: Resolver<Maybe<ResolversTypes['document_custom_request_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_Custom_RequestArgs, 'objects'>>;
  insert_document_custom_request_one?: Resolver<Maybe<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_Custom_Request_OneArgs, 'object'>>;
  insert_document_one?: Resolver<Maybe<ResolversTypes['document']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_OneArgs, 'object'>>;
  insert_document_project?: Resolver<Maybe<ResolversTypes['document_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_ProjectArgs, 'objects'>>;
  insert_document_project_one?: Resolver<Maybe<ResolversTypes['document_project']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_Project_OneArgs, 'object'>>;
  insert_document_user?: Resolver<Maybe<ResolversTypes['document_user_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_UserArgs, 'objects'>>;
  insert_document_user_one?: Resolver<Maybe<ResolversTypes['document_user']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Document_User_OneArgs, 'object'>>;
  insert_email_regex?: Resolver<Maybe<ResolversTypes['email_regex_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Email_RegexArgs, 'objects'>>;
  insert_email_regex_one?: Resolver<Maybe<ResolversTypes['email_regex']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Email_Regex_OneArgs, 'object'>>;
  insert_experience_skill?: Resolver<Maybe<ResolversTypes['experience_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Experience_SkillArgs, 'objects'>>;
  insert_experience_skill_one?: Resolver<Maybe<ResolversTypes['experience_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Experience_Skill_OneArgs, 'object'>>;
  insert_gender?: Resolver<Maybe<ResolversTypes['gender_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_GenderArgs, 'objects'>>;
  insert_gender_one?: Resolver<Maybe<ResolversTypes['gender']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Gender_OneArgs, 'object'>>;
  insert_industry?: Resolver<Maybe<ResolversTypes['industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_IndustryArgs, 'objects'>>;
  insert_industry_one?: Resolver<Maybe<ResolversTypes['industry']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Industry_OneArgs, 'object'>>;
  insert_invitation?: Resolver<Maybe<ResolversTypes['invitation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_InvitationArgs, 'objects'>>;
  insert_invitation_one?: Resolver<Maybe<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Invitation_OneArgs, 'object'>>;
  insert_invoice?: Resolver<Maybe<ResolversTypes['invoice_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_InvoiceArgs, 'objects'>>;
  insert_invoice_one?: Resolver<Maybe<ResolversTypes['invoice']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Invoice_OneArgs, 'object'>>;
  insert_language?: Resolver<Maybe<ResolversTypes['language_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_LanguageArgs, 'objects'>>;
  insert_language_one?: Resolver<Maybe<ResolversTypes['language']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Language_OneArgs, 'object'>>;
  insert_manager?: Resolver<Maybe<ResolversTypes['manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ManagerArgs, 'objects'>>;
  insert_manager_contractor?: Resolver<Maybe<ResolversTypes['manager_contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Manager_ContractorArgs, 'objects'>>;
  insert_manager_contractor_one?: Resolver<Maybe<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Manager_Contractor_OneArgs, 'object'>>;
  insert_manager_one?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Manager_OneArgs, 'object'>>;
  insert_message?: Resolver<Maybe<ResolversTypes['message_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_MessageArgs, 'objects'>>;
  insert_message_one?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Message_OneArgs, 'object'>>;
  insert_notification?: Resolver<Maybe<ResolversTypes['notification_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_NotificationArgs, 'objects'>>;
  insert_notification_one?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Notification_OneArgs, 'object'>>;
  insert_onboarding?: Resolver<Maybe<ResolversTypes['onboarding_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_OnboardingArgs, 'objects'>>;
  insert_onboarding_one?: Resolver<Maybe<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Onboarding_OneArgs, 'object'>>;
  insert_payment_card?: Resolver<Maybe<ResolversTypes['payment_card_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Payment_CardArgs, 'objects'>>;
  insert_payment_card_one?: Resolver<Maybe<ResolversTypes['payment_card']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Payment_Card_OneArgs, 'object'>>;
  insert_posting?: Resolver<Maybe<ResolversTypes['posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_PostingArgs, 'objects'>>;
  insert_posting_industry?: Resolver<Maybe<ResolversTypes['posting_industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Posting_IndustryArgs, 'objects'>>;
  insert_posting_industry_one?: Resolver<Maybe<ResolversTypes['posting_industry']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Posting_Industry_OneArgs, 'object'>>;
  insert_posting_one?: Resolver<Maybe<ResolversTypes['posting']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Posting_OneArgs, 'object'>>;
  insert_posting_skill?: Resolver<Maybe<ResolversTypes['posting_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Posting_SkillArgs, 'objects'>>;
  insert_posting_skill_one?: Resolver<Maybe<ResolversTypes['posting_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Posting_Skill_OneArgs, 'object'>>;
  insert_posting_tags?: Resolver<Maybe<ResolversTypes['posting_tags_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Posting_TagsArgs, 'objects'>>;
  insert_posting_tags_one?: Resolver<Maybe<ResolversTypes['posting_tags']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Posting_Tags_OneArgs, 'object'>>;
  insert_project?: Resolver<Maybe<ResolversTypes['project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ProjectArgs, 'objects'>>;
  insert_project_activity?: Resolver<Maybe<ResolversTypes['project_activity_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_ActivityArgs, 'objects'>>;
  insert_project_activity_note?: Resolver<Maybe<ResolversTypes['project_activity_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_NoteArgs, 'objects'>>;
  insert_project_activity_note_one?: Resolver<Maybe<ResolversTypes['project_activity_note']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Note_OneArgs, 'object'>>;
  insert_project_activity_one?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_OneArgs, 'object'>>;
  insert_project_activity_request_more_hours?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Request_More_HoursArgs, 'objects'>>;
  insert_project_activity_request_more_hours_one?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Request_More_Hours_OneArgs, 'object'>>;
  insert_project_activity_skill?: Resolver<Maybe<ResolversTypes['project_activity_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_SkillArgs, 'objects'>>;
  insert_project_activity_skill_one?: Resolver<Maybe<ResolversTypes['project_activity_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Skill_OneArgs, 'object'>>;
  insert_project_activity_soft_skill?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Soft_SkillArgs, 'objects'>>;
  insert_project_activity_soft_skill_one?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Soft_Skill_OneArgs, 'object'>>;
  insert_project_activity_tag?: Resolver<Maybe<ResolversTypes['project_activity_tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_TagArgs, 'objects'>>;
  insert_project_activity_tag_one?: Resolver<Maybe<ResolversTypes['project_activity_tag']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Tag_OneArgs, 'object'>>;
  insert_project_activity_time?: Resolver<Maybe<ResolversTypes['project_activity_time_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_TimeArgs, 'objects'>>;
  insert_project_activity_time_one?: Resolver<Maybe<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Time_OneArgs, 'object'>>;
  insert_project_activity_tracked_time?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Tracked_TimeArgs, 'objects'>>;
  insert_project_activity_tracked_time_one?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Activity_Tracked_Time_OneArgs, 'object'>>;
  insert_project_one?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_OneArgs, 'object'>>;
  insert_project_skill?: Resolver<Maybe<ResolversTypes['project_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_SkillArgs, 'objects'>>;
  insert_project_skill_one?: Resolver<Maybe<ResolversTypes['project_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Skill_OneArgs, 'object'>>;
  insert_project_soft_skill?: Resolver<Maybe<ResolversTypes['project_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Soft_SkillArgs, 'objects'>>;
  insert_project_soft_skill_one?: Resolver<Maybe<ResolversTypes['project_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Soft_Skill_OneArgs, 'object'>>;
  insert_project_tag?: Resolver<Maybe<ResolversTypes['project_tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_TagArgs, 'objects'>>;
  insert_project_tag_one?: Resolver<Maybe<ResolversTypes['project_tag']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Project_Tag_OneArgs, 'object'>>;
  insert_recipient_message?: Resolver<Maybe<ResolversTypes['recipient_message_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Recipient_MessageArgs, 'objects'>>;
  insert_recipient_message_one?: Resolver<Maybe<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Recipient_Message_OneArgs, 'object'>>;
  insert_resource_information_card?: Resolver<Maybe<ResolversTypes['resource_information_card_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Resource_Information_CardArgs, 'objects'>>;
  insert_resource_information_card_one?: Resolver<Maybe<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Resource_Information_Card_OneArgs, 'object'>>;
  insert_skill?: Resolver<Maybe<ResolversTypes['skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SkillArgs, 'objects'>>;
  insert_skill_one?: Resolver<Maybe<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Skill_OneArgs, 'object'>>;
  insert_skills_short_name_first?: Resolver<Maybe<ResolversTypes['skills_short_name_first_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Skills_Short_Name_FirstArgs, 'objects'>>;
  insert_skills_short_name_first_one?: Resolver<Maybe<ResolversTypes['skills_short_name_first']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Skills_Short_Name_First_OneArgs, 'object'>>;
  insert_smart_match_bookmark?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_BookmarkArgs, 'objects'>>;
  insert_smart_match_bookmark_one?: Resolver<Maybe<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_Bookmark_OneArgs, 'object'>>;
  insert_smart_match_config_transportation?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_Config_TransportationArgs, 'objects'>>;
  insert_smart_match_config_transportation_one?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_Config_Transportation_OneArgs, 'object'>>;
  insert_smart_match_configs?: Resolver<Maybe<ResolversTypes['smart_match_configs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_ConfigsArgs, 'objects'>>;
  insert_smart_match_configs_one?: Resolver<Maybe<ResolversTypes['smart_match_configs']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_Configs_OneArgs, 'object'>>;
  insert_smart_match_criteria_order?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_Criteria_OrderArgs, 'objects'>>;
  insert_smart_match_criteria_order_one?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Smart_Match_Criteria_Order_OneArgs, 'object'>>;
  insert_soft_skill?: Resolver<Maybe<ResolversTypes['soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Soft_SkillArgs, 'objects'>>;
  insert_soft_skill_one?: Resolver<Maybe<ResolversTypes['soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Soft_Skill_OneArgs, 'object'>>;
  insert_source?: Resolver<Maybe<ResolversTypes['source_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SourceArgs, 'objects'>>;
  insert_source_one?: Resolver<Maybe<ResolversTypes['source']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Source_OneArgs, 'object'>>;
  insert_subscription?: Resolver<Maybe<ResolversTypes['subscription_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SubscriptionArgs, 'objects'>>;
  insert_subscription_one?: Resolver<Maybe<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Subscription_OneArgs, 'object'>>;
  insert_subscription_plan?: Resolver<Maybe<ResolversTypes['subscription_plan_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Subscription_PlanArgs, 'objects'>>;
  insert_subscription_plan_access_permissions?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Subscription_Plan_Access_PermissionsArgs, 'objects'>>;
  insert_subscription_plan_access_permissions_one?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Subscription_Plan_Access_Permissions_OneArgs, 'object'>>;
  insert_subscription_plan_one?: Resolver<Maybe<ResolversTypes['subscription_plan']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Subscription_Plan_OneArgs, 'object'>>;
  insert_tag?: Resolver<Maybe<ResolversTypes['tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_TagArgs, 'objects'>>;
  insert_tag_one?: Resolver<Maybe<ResolversTypes['tag']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Tag_OneArgs, 'object'>>;
  insert_team?: Resolver<Maybe<ResolversTypes['team_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_TeamArgs, 'objects'>>;
  insert_team_contractor?: Resolver<Maybe<ResolversTypes['team_contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_ContractorArgs, 'objects'>>;
  insert_team_contractor_one?: Resolver<Maybe<ResolversTypes['team_contractor']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_Contractor_OneArgs, 'object'>>;
  insert_team_manager?: Resolver<Maybe<ResolversTypes['team_manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_ManagerArgs, 'objects'>>;
  insert_team_manager_one?: Resolver<Maybe<ResolversTypes['team_manager']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_Manager_OneArgs, 'object'>>;
  insert_team_one?: Resolver<Maybe<ResolversTypes['team']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_OneArgs, 'object'>>;
  insert_team_posting?: Resolver<Maybe<ResolversTypes['team_posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_PostingArgs, 'objects'>>;
  insert_team_posting_one?: Resolver<Maybe<ResolversTypes['team_posting']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_Posting_OneArgs, 'object'>>;
  insert_team_project?: Resolver<Maybe<ResolversTypes['team_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_ProjectArgs, 'objects'>>;
  insert_team_project_one?: Resolver<Maybe<ResolversTypes['team_project']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_Project_OneArgs, 'object'>>;
  insert_team_skill?: Resolver<Maybe<ResolversTypes['team_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_SkillArgs, 'objects'>>;
  insert_team_skill_one?: Resolver<Maybe<ResolversTypes['team_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Team_Skill_OneArgs, 'object'>>;
  insert_timesheet?: Resolver<Maybe<ResolversTypes['timesheet_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_TimesheetArgs, 'objects'>>;
  insert_timesheet_one?: Resolver<Maybe<ResolversTypes['timesheet']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Timesheet_OneArgs, 'object'>>;
  insert_type_of_visit?: Resolver<Maybe<ResolversTypes['type_of_visit_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Type_Of_VisitArgs, 'objects'>>;
  insert_type_of_visit_one?: Resolver<Maybe<ResolversTypes['type_of_visit']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Type_Of_Visit_OneArgs, 'object'>>;
  insert_user?: Resolver<Maybe<ResolversTypes['user_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_UserArgs, 'objects'>>;
  insert_user_affinda_profile?: Resolver<Maybe<ResolversTypes['user_affinda_profile_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Affinda_ProfileArgs, 'objects'>>;
  insert_user_affinda_profile_one?: Resolver<Maybe<ResolversTypes['user_affinda_profile']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Affinda_Profile_OneArgs, 'object'>>;
  insert_user_certification?: Resolver<Maybe<ResolversTypes['user_certification_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_CertificationArgs, 'objects'>>;
  insert_user_certification_one?: Resolver<Maybe<ResolversTypes['user_certification']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Certification_OneArgs, 'object'>>;
  insert_user_company?: Resolver<Maybe<ResolversTypes['user_company_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_CompanyArgs, 'objects'>>;
  insert_user_company_one?: Resolver<Maybe<ResolversTypes['user_company']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Company_OneArgs, 'object'>>;
  insert_user_conversation?: Resolver<Maybe<ResolversTypes['user_conversation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_ConversationArgs, 'objects'>>;
  insert_user_conversation_one?: Resolver<Maybe<ResolversTypes['user_conversation']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Conversation_OneArgs, 'object'>>;
  insert_user_education?: Resolver<Maybe<ResolversTypes['user_education_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_EducationArgs, 'objects'>>;
  insert_user_education_one?: Resolver<Maybe<ResolversTypes['user_education']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Education_OneArgs, 'object'>>;
  insert_user_experience?: Resolver<Maybe<ResolversTypes['user_experience_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_ExperienceArgs, 'objects'>>;
  insert_user_experience_one?: Resolver<Maybe<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Experience_OneArgs, 'object'>>;
  insert_user_favorite?: Resolver<Maybe<ResolversTypes['user_favorite_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_FavoriteArgs, 'objects'>>;
  insert_user_favorite_one?: Resolver<Maybe<ResolversTypes['user_favorite']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Favorite_OneArgs, 'object'>>;
  insert_user_industry?: Resolver<Maybe<ResolversTypes['user_industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_IndustryArgs, 'objects'>>;
  insert_user_industry_one?: Resolver<Maybe<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Industry_OneArgs, 'object'>>;
  insert_user_job_title?: Resolver<Maybe<ResolversTypes['user_job_title_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Job_TitleArgs, 'objects'>>;
  insert_user_job_title_one?: Resolver<Maybe<ResolversTypes['user_job_title']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Job_Title_OneArgs, 'object'>>;
  insert_user_language?: Resolver<Maybe<ResolversTypes['user_language_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_LanguageArgs, 'objects'>>;
  insert_user_language_one?: Resolver<Maybe<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Language_OneArgs, 'object'>>;
  insert_user_one?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_OneArgs, 'object'>>;
  insert_user_private_data?: Resolver<Maybe<ResolversTypes['user_private_data_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Private_DataArgs, 'objects'>>;
  insert_user_private_data_one?: Resolver<Maybe<ResolversTypes['user_private_data']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Private_Data_OneArgs, 'object'>>;
  insert_user_profile?: Resolver<Maybe<ResolversTypes['user_profile_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_ProfileArgs, 'objects'>>;
  insert_user_profile_by_management?: Resolver<Maybe<ResolversTypes['user_profile_by_management_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Profile_By_ManagementArgs, 'objects'>>;
  insert_user_profile_by_management_one?: Resolver<Maybe<ResolversTypes['user_profile_by_management']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Profile_By_Management_OneArgs, 'object'>>;
  insert_user_profile_one?: Resolver<Maybe<ResolversTypes['user_profile']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Profile_OneArgs, 'object'>>;
  insert_user_rating?: Resolver<Maybe<ResolversTypes['user_rating_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_RatingArgs, 'objects'>>;
  insert_user_rating_one?: Resolver<Maybe<ResolversTypes['user_rating']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Rating_OneArgs, 'object'>>;
  insert_user_skill?: Resolver<Maybe<ResolversTypes['user_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_SkillArgs, 'objects'>>;
  insert_user_skill_one?: Resolver<Maybe<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Skill_OneArgs, 'object'>>;
  insert_user_soft_skill?: Resolver<Maybe<ResolversTypes['user_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Soft_SkillArgs, 'objects'>>;
  insert_user_soft_skill_one?: Resolver<Maybe<ResolversTypes['user_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Soft_Skill_OneArgs, 'object'>>;
  insert_user_transportation?: Resolver<Maybe<ResolversTypes['user_transportation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_TransportationArgs, 'objects'>>;
  insert_user_transportation_one?: Resolver<Maybe<ResolversTypes['user_transportation']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Transportation_OneArgs, 'object'>>;
  insert_user_watchlist?: Resolver<Maybe<ResolversTypes['user_watchlist_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_WatchlistArgs, 'objects'>>;
  insert_user_watchlist_one?: Resolver<Maybe<ResolversTypes['user_watchlist']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_User_Watchlist_OneArgs, 'object'>>;
  update_admin?: Resolver<Maybe<ResolversTypes['admin_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AdminArgs, 'where'>>;
  update_admin_by_pk?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Admin_By_PkArgs, 'pk_columns'>>;
  update_admin_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['admin_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Admin_ManyArgs, 'updates'>>;
  update_application?: Resolver<Maybe<ResolversTypes['application_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ApplicationArgs, 'where'>>;
  update_application_by_pk?: Resolver<Maybe<ResolversTypes['application']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Application_By_PkArgs, 'pk_columns'>>;
  update_application_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['application_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Application_ManyArgs, 'updates'>>;
  update_candidate?: Resolver<Maybe<ResolversTypes['candidate_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CandidateArgs, 'where'>>;
  update_candidate_by_pk?: Resolver<Maybe<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Candidate_By_PkArgs, 'pk_columns'>>;
  update_candidate_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['candidate_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Candidate_ManyArgs, 'updates'>>;
  update_checkin_status?: Resolver<Maybe<ResolversTypes['checkin_status_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Checkin_StatusArgs, 'where'>>;
  update_checkin_status_by_pk?: Resolver<Maybe<ResolversTypes['checkin_status']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Checkin_Status_By_PkArgs, 'pk_columns'>>;
  update_checkin_status_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['checkin_status_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Checkin_Status_ManyArgs, 'updates'>>;
  update_checkout_status?: Resolver<Maybe<ResolversTypes['checkout_status_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Checkout_StatusArgs, 'where'>>;
  update_checkout_status_by_pk?: Resolver<Maybe<ResolversTypes['checkout_status']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Checkout_Status_By_PkArgs, 'pk_columns'>>;
  update_checkout_status_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['checkout_status_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Checkout_Status_ManyArgs, 'updates'>>;
  update_client_care_plan?: Resolver<Maybe<ResolversTypes['client_care_plan_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Client_Care_PlanArgs, 'where'>>;
  update_client_care_plan_by_pk?: Resolver<Maybe<ResolversTypes['client_care_plan']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Client_Care_Plan_By_PkArgs, 'pk_columns'>>;
  update_client_care_plan_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['client_care_plan_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Client_Care_Plan_ManyArgs, 'updates'>>;
  update_client_medications?: Resolver<Maybe<ResolversTypes['client_medications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Client_MedicationsArgs, 'where'>>;
  update_client_medications_by_pk?: Resolver<Maybe<ResolversTypes['client_medications']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Client_Medications_By_PkArgs, 'pk_columns'>>;
  update_client_medications_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['client_medications_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Client_Medications_ManyArgs, 'updates'>>;
  update_company?: Resolver<Maybe<ResolversTypes['company_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CompanyArgs, 'where'>>;
  update_company_by_pk?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_By_PkArgs, 'pk_columns'>>;
  update_company_follower?: Resolver<Maybe<ResolversTypes['company_follower_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_FollowerArgs, 'where'>>;
  update_company_follower_by_pk?: Resolver<Maybe<ResolversTypes['company_follower']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_Follower_By_PkArgs, 'pk_columns'>>;
  update_company_follower_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['company_follower_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_Follower_ManyArgs, 'updates'>>;
  update_company_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['company_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_ManyArgs, 'updates'>>;
  update_company_user_notifications?: Resolver<Maybe<ResolversTypes['company_user_notifications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_User_NotificationsArgs, 'where'>>;
  update_company_user_notifications_by_pk?: Resolver<Maybe<ResolversTypes['company_user_notifications']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_User_Notifications_By_PkArgs, 'pk_columns'>>;
  update_company_user_notifications_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['company_user_notifications_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Company_User_Notifications_ManyArgs, 'updates'>>;
  update_contractor?: Resolver<Maybe<ResolversTypes['contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ContractorArgs, 'where'>>;
  update_contractor_by_pk?: Resolver<Maybe<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_By_PkArgs, 'pk_columns'>>;
  update_contractor_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contractor_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_ManyArgs, 'updates'>>;
  update_contractor_note?: Resolver<Maybe<ResolversTypes['contractor_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_NoteArgs, 'where'>>;
  update_contractor_note_by_pk?: Resolver<Maybe<ResolversTypes['contractor_note']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Note_By_PkArgs, 'pk_columns'>>;
  update_contractor_note_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contractor_note_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Note_ManyArgs, 'updates'>>;
  update_contractor_posting?: Resolver<Maybe<ResolversTypes['contractor_posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_PostingArgs, 'where'>>;
  update_contractor_posting_by_pk?: Resolver<Maybe<ResolversTypes['contractor_posting']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Posting_By_PkArgs, 'pk_columns'>>;
  update_contractor_posting_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contractor_posting_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Posting_ManyArgs, 'updates'>>;
  update_contractor_project?: Resolver<Maybe<ResolversTypes['contractor_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_ProjectArgs, 'where'>>;
  update_contractor_project_by_pk?: Resolver<Maybe<ResolversTypes['contractor_project']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Project_By_PkArgs, 'pk_columns'>>;
  update_contractor_project_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contractor_project_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Project_ManyArgs, 'updates'>>;
  update_contractor_rating?: Resolver<Maybe<ResolversTypes['contractor_rating_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_RatingArgs, 'where'>>;
  update_contractor_rating_by_pk?: Resolver<Maybe<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Rating_By_PkArgs, 'pk_columns'>>;
  update_contractor_rating_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contractor_rating_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Rating_ManyArgs, 'updates'>>;
  update_contractor_staff_note?: Resolver<Maybe<ResolversTypes['contractor_staff_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Staff_NoteArgs, 'where'>>;
  update_contractor_staff_note_by_pk?: Resolver<Maybe<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Staff_Note_By_PkArgs, 'pk_columns'>>;
  update_contractor_staff_note_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contractor_staff_note_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contractor_Staff_Note_ManyArgs, 'updates'>>;
  update_conversation?: Resolver<Maybe<ResolversTypes['conversation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ConversationArgs, 'where'>>;
  update_conversation_by_pk?: Resolver<Maybe<ResolversTypes['conversation']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Conversation_By_PkArgs, 'pk_columns'>>;
  update_conversation_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['conversation_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Conversation_ManyArgs, 'updates'>>;
  update_custom_request?: Resolver<Maybe<ResolversTypes['custom_request_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Custom_RequestArgs, 'where'>>;
  update_custom_request_by_pk?: Resolver<Maybe<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Custom_Request_By_PkArgs, 'pk_columns'>>;
  update_custom_request_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['custom_request_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Custom_Request_ManyArgs, 'updates'>>;
  update_custom_request_skills?: Resolver<Maybe<ResolversTypes['custom_request_skills_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Custom_Request_SkillsArgs, 'where'>>;
  update_custom_request_skills_by_pk?: Resolver<Maybe<ResolversTypes['custom_request_skills']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Custom_Request_Skills_By_PkArgs, 'pk_columns'>>;
  update_custom_request_skills_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['custom_request_skills_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Custom_Request_Skills_ManyArgs, 'updates'>>;
  update_declined_visit_matches?: Resolver<Maybe<ResolversTypes['declined_visit_matches_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Declined_Visit_MatchesArgs, 'where'>>;
  update_declined_visit_matches_by_pk?: Resolver<Maybe<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Declined_Visit_Matches_By_PkArgs, 'pk_columns'>>;
  update_declined_visit_matches_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['declined_visit_matches_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Declined_Visit_Matches_ManyArgs, 'updates'>>;
  update_document?: Resolver<Maybe<ResolversTypes['document_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_DocumentArgs, 'where'>>;
  update_document_by_pk?: Resolver<Maybe<ResolversTypes['document']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_By_PkArgs, 'pk_columns'>>;
  update_document_contractor_access?: Resolver<Maybe<ResolversTypes['document_contractor_access_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Contractor_AccessArgs, 'where'>>;
  update_document_contractor_access_by_pk?: Resolver<Maybe<ResolversTypes['document_contractor_access']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Contractor_Access_By_PkArgs, 'pk_columns'>>;
  update_document_contractor_access_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['document_contractor_access_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Contractor_Access_ManyArgs, 'updates'>>;
  update_document_custom_request?: Resolver<Maybe<ResolversTypes['document_custom_request_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Custom_RequestArgs, 'where'>>;
  update_document_custom_request_by_pk?: Resolver<Maybe<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Custom_Request_By_PkArgs, 'pk_columns'>>;
  update_document_custom_request_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['document_custom_request_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Custom_Request_ManyArgs, 'updates'>>;
  update_document_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['document_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_ManyArgs, 'updates'>>;
  update_document_project?: Resolver<Maybe<ResolversTypes['document_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_ProjectArgs, 'where'>>;
  update_document_project_by_pk?: Resolver<Maybe<ResolversTypes['document_project']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Project_By_PkArgs, 'pk_columns'>>;
  update_document_project_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['document_project_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_Project_ManyArgs, 'updates'>>;
  update_document_user?: Resolver<Maybe<ResolversTypes['document_user_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_UserArgs, 'where'>>;
  update_document_user_by_pk?: Resolver<Maybe<ResolversTypes['document_user']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_User_By_PkArgs, 'pk_columns'>>;
  update_document_user_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['document_user_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Document_User_ManyArgs, 'updates'>>;
  update_email_regex?: Resolver<Maybe<ResolversTypes['email_regex_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Email_RegexArgs, 'where'>>;
  update_email_regex_by_pk?: Resolver<Maybe<ResolversTypes['email_regex']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Email_Regex_By_PkArgs, 'pk_columns'>>;
  update_email_regex_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['email_regex_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Email_Regex_ManyArgs, 'updates'>>;
  update_experience_skill?: Resolver<Maybe<ResolversTypes['experience_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Experience_SkillArgs, 'where'>>;
  update_experience_skill_by_pk?: Resolver<Maybe<ResolversTypes['experience_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Experience_Skill_By_PkArgs, 'pk_columns'>>;
  update_experience_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['experience_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Experience_Skill_ManyArgs, 'updates'>>;
  update_gender?: Resolver<Maybe<ResolversTypes['gender_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_GenderArgs, 'where'>>;
  update_gender_by_pk?: Resolver<Maybe<ResolversTypes['gender']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Gender_By_PkArgs, 'pk_columns'>>;
  update_gender_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['gender_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Gender_ManyArgs, 'updates'>>;
  update_industry?: Resolver<Maybe<ResolversTypes['industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_IndustryArgs, 'where'>>;
  update_industry_by_pk?: Resolver<Maybe<ResolversTypes['industry']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Industry_By_PkArgs, 'pk_columns'>>;
  update_industry_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['industry_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Industry_ManyArgs, 'updates'>>;
  update_invitation?: Resolver<Maybe<ResolversTypes['invitation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_InvitationArgs, 'where'>>;
  update_invitation_by_pk?: Resolver<Maybe<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Invitation_By_PkArgs, 'pk_columns'>>;
  update_invitation_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['invitation_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Invitation_ManyArgs, 'updates'>>;
  update_invoice?: Resolver<Maybe<ResolversTypes['invoice_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_InvoiceArgs, 'where'>>;
  update_invoice_by_pk?: Resolver<Maybe<ResolversTypes['invoice']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Invoice_By_PkArgs, 'pk_columns'>>;
  update_invoice_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['invoice_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Invoice_ManyArgs, 'updates'>>;
  update_language?: Resolver<Maybe<ResolversTypes['language_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_LanguageArgs, 'where'>>;
  update_language_by_pk?: Resolver<Maybe<ResolversTypes['language']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Language_By_PkArgs, 'pk_columns'>>;
  update_language_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['language_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Language_ManyArgs, 'updates'>>;
  update_manager?: Resolver<Maybe<ResolversTypes['manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ManagerArgs, 'where'>>;
  update_manager_by_pk?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Manager_By_PkArgs, 'pk_columns'>>;
  update_manager_contractor?: Resolver<Maybe<ResolversTypes['manager_contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Manager_ContractorArgs, 'where'>>;
  update_manager_contractor_by_pk?: Resolver<Maybe<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Manager_Contractor_By_PkArgs, 'pk_columns'>>;
  update_manager_contractor_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['manager_contractor_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Manager_Contractor_ManyArgs, 'updates'>>;
  update_manager_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['manager_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Manager_ManyArgs, 'updates'>>;
  update_message?: Resolver<Maybe<ResolversTypes['message_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_MessageArgs, 'where'>>;
  update_message_by_pk?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Message_By_PkArgs, 'pk_columns'>>;
  update_message_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['message_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Message_ManyArgs, 'updates'>>;
  update_notification?: Resolver<Maybe<ResolversTypes['notification_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_NotificationArgs, 'where'>>;
  update_notification_by_pk?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Notification_By_PkArgs, 'pk_columns'>>;
  update_notification_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['notification_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Notification_ManyArgs, 'updates'>>;
  update_onboarding?: Resolver<Maybe<ResolversTypes['onboarding_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_OnboardingArgs, 'where'>>;
  update_onboarding_by_pk?: Resolver<Maybe<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Onboarding_By_PkArgs, 'pk_columns'>>;
  update_onboarding_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['onboarding_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Onboarding_ManyArgs, 'updates'>>;
  update_payment_card?: Resolver<Maybe<ResolversTypes['payment_card_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Payment_CardArgs, 'where'>>;
  update_payment_card_by_pk?: Resolver<Maybe<ResolversTypes['payment_card']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Payment_Card_By_PkArgs, 'pk_columns'>>;
  update_payment_card_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['payment_card_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Payment_Card_ManyArgs, 'updates'>>;
  update_posting?: Resolver<Maybe<ResolversTypes['posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_PostingArgs, 'where'>>;
  update_posting_by_pk?: Resolver<Maybe<ResolversTypes['posting']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_By_PkArgs, 'pk_columns'>>;
  update_posting_industry?: Resolver<Maybe<ResolversTypes['posting_industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_IndustryArgs, 'where'>>;
  update_posting_industry_by_pk?: Resolver<Maybe<ResolversTypes['posting_industry']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_Industry_By_PkArgs, 'pk_columns'>>;
  update_posting_industry_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['posting_industry_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_Industry_ManyArgs, 'updates'>>;
  update_posting_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['posting_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_ManyArgs, 'updates'>>;
  update_posting_skill?: Resolver<Maybe<ResolversTypes['posting_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_SkillArgs, 'where'>>;
  update_posting_skill_by_pk?: Resolver<Maybe<ResolversTypes['posting_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_Skill_By_PkArgs, 'pk_columns'>>;
  update_posting_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['posting_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_Skill_ManyArgs, 'updates'>>;
  update_posting_tags?: Resolver<Maybe<ResolversTypes['posting_tags_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_TagsArgs, 'where'>>;
  update_posting_tags_by_pk?: Resolver<Maybe<ResolversTypes['posting_tags']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_Tags_By_PkArgs, 'pk_columns'>>;
  update_posting_tags_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['posting_tags_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Posting_Tags_ManyArgs, 'updates'>>;
  update_project?: Resolver<Maybe<ResolversTypes['project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ProjectArgs, 'where'>>;
  update_project_activity?: Resolver<Maybe<ResolversTypes['project_activity_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_ActivityArgs, 'where'>>;
  update_project_activity_by_pk?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_By_PkArgs, 'pk_columns'>>;
  update_project_activity_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_ManyArgs, 'updates'>>;
  update_project_activity_note?: Resolver<Maybe<ResolversTypes['project_activity_note_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_NoteArgs, 'where'>>;
  update_project_activity_note_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_note']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Note_By_PkArgs, 'pk_columns'>>;
  update_project_activity_note_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_note_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Note_ManyArgs, 'updates'>>;
  update_project_activity_request_more_hours?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Request_More_HoursArgs, 'where'>>;
  update_project_activity_request_more_hours_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Request_More_Hours_By_PkArgs, 'pk_columns'>>;
  update_project_activity_request_more_hours_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_request_more_hours_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Request_More_Hours_ManyArgs, 'updates'>>;
  update_project_activity_skill?: Resolver<Maybe<ResolversTypes['project_activity_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_SkillArgs, 'where'>>;
  update_project_activity_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Skill_By_PkArgs, 'pk_columns'>>;
  update_project_activity_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Skill_ManyArgs, 'updates'>>;
  update_project_activity_soft_skill?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Soft_SkillArgs, 'where'>>;
  update_project_activity_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Soft_Skill_By_PkArgs, 'pk_columns'>>;
  update_project_activity_soft_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_soft_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Soft_Skill_ManyArgs, 'updates'>>;
  update_project_activity_tag?: Resolver<Maybe<ResolversTypes['project_activity_tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_TagArgs, 'where'>>;
  update_project_activity_tag_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_tag']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Tag_By_PkArgs, 'pk_columns'>>;
  update_project_activity_tag_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_tag_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Tag_ManyArgs, 'updates'>>;
  update_project_activity_time?: Resolver<Maybe<ResolversTypes['project_activity_time_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_TimeArgs, 'where'>>;
  update_project_activity_time_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Time_By_PkArgs, 'pk_columns'>>;
  update_project_activity_time_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_time_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Time_ManyArgs, 'updates'>>;
  update_project_activity_tracked_time?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Tracked_TimeArgs, 'where'>>;
  update_project_activity_tracked_time_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Tracked_Time_By_PkArgs, 'pk_columns'>>;
  update_project_activity_tracked_time_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_activity_tracked_time_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Activity_Tracked_Time_ManyArgs, 'updates'>>;
  update_project_by_pk?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_By_PkArgs, 'pk_columns'>>;
  update_project_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_ManyArgs, 'updates'>>;
  update_project_skill?: Resolver<Maybe<ResolversTypes['project_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_SkillArgs, 'where'>>;
  update_project_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Skill_By_PkArgs, 'pk_columns'>>;
  update_project_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Skill_ManyArgs, 'updates'>>;
  update_project_soft_skill?: Resolver<Maybe<ResolversTypes['project_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Soft_SkillArgs, 'where'>>;
  update_project_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Soft_Skill_By_PkArgs, 'pk_columns'>>;
  update_project_soft_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_soft_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Soft_Skill_ManyArgs, 'updates'>>;
  update_project_tag?: Resolver<Maybe<ResolversTypes['project_tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_TagArgs, 'where'>>;
  update_project_tag_by_pk?: Resolver<Maybe<ResolversTypes['project_tag']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Tag_By_PkArgs, 'pk_columns'>>;
  update_project_tag_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['project_tag_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Project_Tag_ManyArgs, 'updates'>>;
  update_recipient_message?: Resolver<Maybe<ResolversTypes['recipient_message_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Recipient_MessageArgs, 'where'>>;
  update_recipient_message_by_pk?: Resolver<Maybe<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Recipient_Message_By_PkArgs, 'pk_columns'>>;
  update_recipient_message_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['recipient_message_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Recipient_Message_ManyArgs, 'updates'>>;
  update_resource_information_card?: Resolver<Maybe<ResolversTypes['resource_information_card_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Resource_Information_CardArgs, 'where'>>;
  update_resource_information_card_by_pk?: Resolver<Maybe<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Resource_Information_Card_By_PkArgs, 'pk_columns'>>;
  update_resource_information_card_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['resource_information_card_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Resource_Information_Card_ManyArgs, 'updates'>>;
  update_skill?: Resolver<Maybe<ResolversTypes['skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SkillArgs, 'where'>>;
  update_skill_by_pk?: Resolver<Maybe<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Skill_By_PkArgs, 'pk_columns'>>;
  update_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Skill_ManyArgs, 'updates'>>;
  update_skills_short_name_first?: Resolver<Maybe<ResolversTypes['skills_short_name_first_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Skills_Short_Name_FirstArgs, 'where'>>;
  update_skills_short_name_first_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['skills_short_name_first_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Skills_Short_Name_First_ManyArgs, 'updates'>>;
  update_smart_match_bookmark?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_BookmarkArgs, 'where'>>;
  update_smart_match_bookmark_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Bookmark_By_PkArgs, 'pk_columns'>>;
  update_smart_match_bookmark_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['smart_match_bookmark_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Bookmark_ManyArgs, 'updates'>>;
  update_smart_match_config_transportation?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Config_TransportationArgs, 'where'>>;
  update_smart_match_config_transportation_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Config_Transportation_By_PkArgs, 'pk_columns'>>;
  update_smart_match_config_transportation_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['smart_match_config_transportation_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Config_Transportation_ManyArgs, 'updates'>>;
  update_smart_match_configs?: Resolver<Maybe<ResolversTypes['smart_match_configs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_ConfigsArgs, 'where'>>;
  update_smart_match_configs_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_configs']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Configs_By_PkArgs, 'pk_columns'>>;
  update_smart_match_configs_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['smart_match_configs_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Configs_ManyArgs, 'updates'>>;
  update_smart_match_criteria_order?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Criteria_OrderArgs, 'where'>>;
  update_smart_match_criteria_order_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Criteria_Order_By_PkArgs, 'pk_columns'>>;
  update_smart_match_criteria_order_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['smart_match_criteria_order_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Smart_Match_Criteria_Order_ManyArgs, 'updates'>>;
  update_soft_skill?: Resolver<Maybe<ResolversTypes['soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Soft_SkillArgs, 'where'>>;
  update_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Soft_Skill_By_PkArgs, 'pk_columns'>>;
  update_soft_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['soft_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Soft_Skill_ManyArgs, 'updates'>>;
  update_source?: Resolver<Maybe<ResolversTypes['source_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SourceArgs, 'where'>>;
  update_source_by_pk?: Resolver<Maybe<ResolversTypes['source']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Source_By_PkArgs, 'pk_columns'>>;
  update_source_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['source_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Source_ManyArgs, 'updates'>>;
  update_subscription?: Resolver<Maybe<ResolversTypes['subscription_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SubscriptionArgs, 'where'>>;
  update_subscription_by_pk?: Resolver<Maybe<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_By_PkArgs, 'pk_columns'>>;
  update_subscription_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['subscription_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_ManyArgs, 'updates'>>;
  update_subscription_plan?: Resolver<Maybe<ResolversTypes['subscription_plan_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_PlanArgs, 'where'>>;
  update_subscription_plan_access_permissions?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_Plan_Access_PermissionsArgs, 'where'>>;
  update_subscription_plan_access_permissions_by_pk?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_Plan_Access_Permissions_By_PkArgs, 'pk_columns'>>;
  update_subscription_plan_access_permissions_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['subscription_plan_access_permissions_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_Plan_Access_Permissions_ManyArgs, 'updates'>>;
  update_subscription_plan_by_pk?: Resolver<Maybe<ResolversTypes['subscription_plan']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_Plan_By_PkArgs, 'pk_columns'>>;
  update_subscription_plan_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['subscription_plan_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Subscription_Plan_ManyArgs, 'updates'>>;
  update_tag?: Resolver<Maybe<ResolversTypes['tag_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_TagArgs, 'where'>>;
  update_tag_by_pk?: Resolver<Maybe<ResolversTypes['tag']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Tag_By_PkArgs, 'pk_columns'>>;
  update_tag_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['tag_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Tag_ManyArgs, 'updates'>>;
  update_team?: Resolver<Maybe<ResolversTypes['team_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_TeamArgs, 'where'>>;
  update_team_by_pk?: Resolver<Maybe<ResolversTypes['team']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_By_PkArgs, 'pk_columns'>>;
  update_team_contractor?: Resolver<Maybe<ResolversTypes['team_contractor_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_ContractorArgs, 'where'>>;
  update_team_contractor_by_pk?: Resolver<Maybe<ResolversTypes['team_contractor']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Contractor_By_PkArgs, 'pk_columns'>>;
  update_team_contractor_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['team_contractor_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Contractor_ManyArgs, 'updates'>>;
  update_team_manager?: Resolver<Maybe<ResolversTypes['team_manager_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_ManagerArgs, 'where'>>;
  update_team_manager_by_pk?: Resolver<Maybe<ResolversTypes['team_manager']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Manager_By_PkArgs, 'pk_columns'>>;
  update_team_manager_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['team_manager_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Manager_ManyArgs, 'updates'>>;
  update_team_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['team_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_ManyArgs, 'updates'>>;
  update_team_posting?: Resolver<Maybe<ResolversTypes['team_posting_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_PostingArgs, 'where'>>;
  update_team_posting_by_pk?: Resolver<Maybe<ResolversTypes['team_posting']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Posting_By_PkArgs, 'pk_columns'>>;
  update_team_posting_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['team_posting_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Posting_ManyArgs, 'updates'>>;
  update_team_project?: Resolver<Maybe<ResolversTypes['team_project_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_ProjectArgs, 'where'>>;
  update_team_project_by_pk?: Resolver<Maybe<ResolversTypes['team_project']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Project_By_PkArgs, 'pk_columns'>>;
  update_team_project_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['team_project_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Project_ManyArgs, 'updates'>>;
  update_team_skill?: Resolver<Maybe<ResolversTypes['team_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_SkillArgs, 'where'>>;
  update_team_skill_by_pk?: Resolver<Maybe<ResolversTypes['team_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Skill_By_PkArgs, 'pk_columns'>>;
  update_team_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['team_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Team_Skill_ManyArgs, 'updates'>>;
  update_timesheet?: Resolver<Maybe<ResolversTypes['timesheet_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_TimesheetArgs, 'where'>>;
  update_timesheet_by_pk?: Resolver<Maybe<ResolversTypes['timesheet']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Timesheet_By_PkArgs, 'pk_columns'>>;
  update_timesheet_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['timesheet_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Timesheet_ManyArgs, 'updates'>>;
  update_type_of_visit?: Resolver<Maybe<ResolversTypes['type_of_visit_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Type_Of_VisitArgs, 'where'>>;
  update_type_of_visit_by_pk?: Resolver<Maybe<ResolversTypes['type_of_visit']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Type_Of_Visit_By_PkArgs, 'pk_columns'>>;
  update_type_of_visit_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['type_of_visit_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Type_Of_Visit_ManyArgs, 'updates'>>;
  update_user?: Resolver<Maybe<ResolversTypes['user_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UserArgs, 'where'>>;
  update_user_affinda_profile?: Resolver<Maybe<ResolversTypes['user_affinda_profile_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Affinda_ProfileArgs, 'where'>>;
  update_user_affinda_profile_by_pk?: Resolver<Maybe<ResolversTypes['user_affinda_profile']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Affinda_Profile_By_PkArgs, 'pk_columns'>>;
  update_user_affinda_profile_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_affinda_profile_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Affinda_Profile_ManyArgs, 'updates'>>;
  update_user_by_pk?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_By_PkArgs, 'pk_columns'>>;
  update_user_certification?: Resolver<Maybe<ResolversTypes['user_certification_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_CertificationArgs, 'where'>>;
  update_user_certification_by_pk?: Resolver<Maybe<ResolversTypes['user_certification']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Certification_By_PkArgs, 'pk_columns'>>;
  update_user_certification_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_certification_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Certification_ManyArgs, 'updates'>>;
  update_user_company?: Resolver<Maybe<ResolversTypes['user_company_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_CompanyArgs, 'where'>>;
  update_user_company_by_pk?: Resolver<Maybe<ResolversTypes['user_company']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Company_By_PkArgs, 'pk_columns'>>;
  update_user_company_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_company_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Company_ManyArgs, 'updates'>>;
  update_user_conversation?: Resolver<Maybe<ResolversTypes['user_conversation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_ConversationArgs, 'where'>>;
  update_user_conversation_by_pk?: Resolver<Maybe<ResolversTypes['user_conversation']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Conversation_By_PkArgs, 'pk_columns'>>;
  update_user_conversation_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_conversation_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Conversation_ManyArgs, 'updates'>>;
  update_user_education?: Resolver<Maybe<ResolversTypes['user_education_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_EducationArgs, 'where'>>;
  update_user_education_by_pk?: Resolver<Maybe<ResolversTypes['user_education']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Education_By_PkArgs, 'pk_columns'>>;
  update_user_education_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_education_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Education_ManyArgs, 'updates'>>;
  update_user_experience?: Resolver<Maybe<ResolversTypes['user_experience_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_ExperienceArgs, 'where'>>;
  update_user_experience_by_pk?: Resolver<Maybe<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Experience_By_PkArgs, 'pk_columns'>>;
  update_user_experience_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_experience_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Experience_ManyArgs, 'updates'>>;
  update_user_favorite?: Resolver<Maybe<ResolversTypes['user_favorite_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_FavoriteArgs, 'where'>>;
  update_user_favorite_by_pk?: Resolver<Maybe<ResolversTypes['user_favorite']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Favorite_By_PkArgs, 'pk_columns'>>;
  update_user_favorite_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_favorite_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Favorite_ManyArgs, 'updates'>>;
  update_user_industry?: Resolver<Maybe<ResolversTypes['user_industry_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_IndustryArgs, 'where'>>;
  update_user_industry_by_pk?: Resolver<Maybe<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Industry_By_PkArgs, 'pk_columns'>>;
  update_user_industry_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_industry_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Industry_ManyArgs, 'updates'>>;
  update_user_job_title?: Resolver<Maybe<ResolversTypes['user_job_title_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Job_TitleArgs, 'where'>>;
  update_user_job_title_by_pk?: Resolver<Maybe<ResolversTypes['user_job_title']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Job_Title_By_PkArgs, 'pk_columns'>>;
  update_user_job_title_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_job_title_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Job_Title_ManyArgs, 'updates'>>;
  update_user_language?: Resolver<Maybe<ResolversTypes['user_language_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_LanguageArgs, 'where'>>;
  update_user_language_by_pk?: Resolver<Maybe<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Language_By_PkArgs, 'pk_columns'>>;
  update_user_language_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_language_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Language_ManyArgs, 'updates'>>;
  update_user_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_ManyArgs, 'updates'>>;
  update_user_private_data?: Resolver<Maybe<ResolversTypes['user_private_data_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Private_DataArgs, 'where'>>;
  update_user_private_data_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_private_data_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Private_Data_ManyArgs, 'updates'>>;
  update_user_profile?: Resolver<Maybe<ResolversTypes['user_profile_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_ProfileArgs, 'where'>>;
  update_user_profile_by_management?: Resolver<Maybe<ResolversTypes['user_profile_by_management_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Profile_By_ManagementArgs, 'where'>>;
  update_user_profile_by_management_by_pk?: Resolver<Maybe<ResolversTypes['user_profile_by_management']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Profile_By_Management_By_PkArgs, 'pk_columns'>>;
  update_user_profile_by_management_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_profile_by_management_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Profile_By_Management_ManyArgs, 'updates'>>;
  update_user_profile_by_pk?: Resolver<Maybe<ResolversTypes['user_profile']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Profile_By_PkArgs, 'pk_columns'>>;
  update_user_profile_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_profile_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Profile_ManyArgs, 'updates'>>;
  update_user_rating?: Resolver<Maybe<ResolversTypes['user_rating_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_RatingArgs, 'where'>>;
  update_user_rating_by_pk?: Resolver<Maybe<ResolversTypes['user_rating']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Rating_By_PkArgs, 'pk_columns'>>;
  update_user_rating_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_rating_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Rating_ManyArgs, 'updates'>>;
  update_user_skill?: Resolver<Maybe<ResolversTypes['user_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_SkillArgs, 'where'>>;
  update_user_skill_by_pk?: Resolver<Maybe<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Skill_By_PkArgs, 'pk_columns'>>;
  update_user_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Skill_ManyArgs, 'updates'>>;
  update_user_soft_skill?: Resolver<Maybe<ResolversTypes['user_soft_skill_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Soft_SkillArgs, 'where'>>;
  update_user_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['user_soft_skill']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Soft_Skill_By_PkArgs, 'pk_columns'>>;
  update_user_soft_skill_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_soft_skill_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Soft_Skill_ManyArgs, 'updates'>>;
  update_user_transportation?: Resolver<Maybe<ResolversTypes['user_transportation_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_TransportationArgs, 'where'>>;
  update_user_transportation_by_pk?: Resolver<Maybe<ResolversTypes['user_transportation']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Transportation_By_PkArgs, 'pk_columns'>>;
  update_user_transportation_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_transportation_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Transportation_ManyArgs, 'updates'>>;
  update_user_watchlist?: Resolver<Maybe<ResolversTypes['user_watchlist_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_WatchlistArgs, 'where'>>;
  update_user_watchlist_by_pk?: Resolver<Maybe<ResolversTypes['user_watchlist']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Watchlist_By_PkArgs, 'pk_columns'>>;
  update_user_watchlist_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['user_watchlist_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_User_Watchlist_ManyArgs, 'updates'>>;
};

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['notification'] = ResolversParentTypes['notification']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  shown?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notification_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['notification_aggregate'] = ResolversParentTypes['notification_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['notification_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notification_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notification_aggregate_fields'] = ResolversParentTypes['notification_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Notification_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['notification_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['notification_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notification_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notification_max_fields'] = ResolversParentTypes['notification_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notification_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notification_min_fields'] = ResolversParentTypes['notification_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notification_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['notification_mutation_response'] = ResolversParentTypes['notification_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface NumericScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['numeric'], any> {
  name: 'numeric';
}

export type OnboardingResolvers<ContextType = any, ParentType extends ResolversParentTypes['onboarding'] = ResolversParentTypes['onboarding']> = {
  candidate?: Resolver<Maybe<ResolversTypes['candidate']>, ParentType, ContextType>;
  candidate_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Onboarding_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['onboarding_aggregate'] = ResolversParentTypes['onboarding_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['onboarding_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['onboarding']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Onboarding_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['onboarding_aggregate_fields'] = ResolversParentTypes['onboarding_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Onboarding_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['onboarding_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['onboarding_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Onboarding_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['onboarding_max_fields'] = ResolversParentTypes['onboarding_max_fields']> = {
  candidate_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Onboarding_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['onboarding_min_fields'] = ResolversParentTypes['onboarding_min_fields']> = {
  candidate_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Onboarding_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['onboarding_mutation_response'] = ResolversParentTypes['onboarding_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['onboarding']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Payment_CardResolvers<ContextType = any, ParentType extends ResolversParentTypes['payment_card'] = ResolversParentTypes['payment_card']> = {
  brand?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  exp_month?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  exp_year?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  last4?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripe_card_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptions?: Resolver<Array<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<Payment_CardSubscriptionsArgs, never>>;
  subscriptions_aggregate?: Resolver<ResolversTypes['subscription_aggregate'], ParentType, ContextType, RequireFields<Payment_CardSubscriptions_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Payment_Card_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['payment_card_aggregate'] = ResolversParentTypes['payment_card_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['payment_card_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['payment_card']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Payment_Card_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['payment_card_aggregate_fields'] = ResolversParentTypes['payment_card_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Payment_Card_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['payment_card_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['payment_card_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Payment_Card_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['payment_card_max_fields'] = ResolversParentTypes['payment_card_max_fields']> = {
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  exp_month?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exp_year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  last4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_card_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Payment_Card_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['payment_card_min_fields'] = ResolversParentTypes['payment_card_min_fields']> = {
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  exp_month?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exp_year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  last4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_card_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Payment_Card_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['payment_card_mutation_response'] = ResolversParentTypes['payment_card_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['payment_card']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostingResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting'] = ResolversParentTypes['posting']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  applications?: Resolver<Array<ResolversTypes['application']>, ParentType, ContextType, RequireFields<PostingApplicationsArgs, never>>;
  applications_aggregate?: Resolver<ResolversTypes['application_aggregate'], ParentType, ContextType, RequireFields<PostingApplications_AggregateArgs, never>>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  contractor_postings?: Resolver<Array<ResolversTypes['contractor_posting']>, ParentType, ContextType, RequireFields<PostingContractor_PostingsArgs, never>>;
  contractor_postings_aggregate?: Resolver<ResolversTypes['contractor_posting_aggregate'], ParentType, ContextType, RequireFields<PostingContractor_Postings_AggregateArgs, never>>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  duration_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employment_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  industries?: Resolver<Array<ResolversTypes['posting_industry']>, ParentType, ContextType, RequireFields<PostingIndustriesArgs, never>>;
  industries_aggregate?: Resolver<ResolversTypes['posting_industry_aggregate'], ParentType, ContextType, RequireFields<PostingIndustries_AggregateArgs, never>>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  posting_tags?: Resolver<Array<ResolversTypes['posting_tags']>, ParentType, ContextType, RequireFields<PostingPosting_TagsArgs, never>>;
  posting_tags_aggregate?: Resolver<ResolversTypes['posting_tags_aggregate'], ParentType, ContextType, RequireFields<PostingPosting_Tags_AggregateArgs, never>>;
  public?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  skills?: Resolver<Array<ResolversTypes['posting_skill']>, ParentType, ContextType, RequireFields<PostingSkillsArgs, never>>;
  skills_aggregate?: Resolver<ResolversTypes['posting_skill_aggregate'], ParentType, ContextType, RequireFields<PostingSkills_AggregateArgs, never>>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  team_postings?: Resolver<Array<ResolversTypes['team_posting']>, ParentType, ContextType, RequireFields<PostingTeam_PostingsArgs, never>>;
  team_postings_aggregate?: Resolver<ResolversTypes['team_posting_aggregate'], ParentType, ContextType, RequireFields<PostingTeam_Postings_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_aggregate'] = ResolversParentTypes['posting_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['posting_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['posting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_aggregate_fields'] = ResolversParentTypes['posting_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['posting_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Posting_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['posting_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['posting_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['posting_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['posting_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['posting_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['posting_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['posting_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['posting_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['posting_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_avg_fields'] = ResolversParentTypes['posting_avg_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_IndustryResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry'] = ResolversParentTypes['posting_industry']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['industry'], ParentType, ContextType>;
  industry_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  posting?: Resolver<ResolversTypes['posting'], ParentType, ContextType>;
  posting_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_aggregate'] = ResolversParentTypes['posting_industry_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['posting_industry_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['posting_industry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_aggregate_fields'] = ResolversParentTypes['posting_industry_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['posting_industry_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Posting_Industry_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['posting_industry_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['posting_industry_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['posting_industry_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['posting_industry_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['posting_industry_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['posting_industry_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['posting_industry_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['posting_industry_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['posting_industry_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_avg_fields'] = ResolversParentTypes['posting_industry_avg_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_max_fields'] = ResolversParentTypes['posting_industry_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_min_fields'] = ResolversParentTypes['posting_industry_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_mutation_response'] = ResolversParentTypes['posting_industry_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['posting_industry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_stddev_fields'] = ResolversParentTypes['posting_industry_stddev_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_stddev_pop_fields'] = ResolversParentTypes['posting_industry_stddev_pop_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_stddev_samp_fields'] = ResolversParentTypes['posting_industry_stddev_samp_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_sum_fields'] = ResolversParentTypes['posting_industry_sum_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_var_pop_fields'] = ResolversParentTypes['posting_industry_var_pop_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_var_samp_fields'] = ResolversParentTypes['posting_industry_var_samp_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Industry_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_industry_variance_fields'] = ResolversParentTypes['posting_industry_variance_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_max_fields'] = ResolversParentTypes['posting_max_fields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  duration_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employment_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_min_fields'] = ResolversParentTypes['posting_min_fields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  duration_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employment_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_mutation_response'] = ResolversParentTypes['posting_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['posting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill'] = ResolversParentTypes['posting_skill']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  posting?: Resolver<ResolversTypes['posting'], ParentType, ContextType>;
  posting_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['skill'], ParentType, ContextType>;
  skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_aggregate'] = ResolversParentTypes['posting_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['posting_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['posting_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_aggregate_fields'] = ResolversParentTypes['posting_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['posting_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Posting_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['posting_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['posting_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['posting_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['posting_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['posting_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['posting_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['posting_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['posting_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['posting_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_avg_fields'] = ResolversParentTypes['posting_skill_avg_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_max_fields'] = ResolversParentTypes['posting_skill_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_min_fields'] = ResolversParentTypes['posting_skill_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_mutation_response'] = ResolversParentTypes['posting_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['posting_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_stddev_fields'] = ResolversParentTypes['posting_skill_stddev_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_stddev_pop_fields'] = ResolversParentTypes['posting_skill_stddev_pop_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_stddev_samp_fields'] = ResolversParentTypes['posting_skill_stddev_samp_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_sum_fields'] = ResolversParentTypes['posting_skill_sum_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_var_pop_fields'] = ResolversParentTypes['posting_skill_var_pop_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_var_samp_fields'] = ResolversParentTypes['posting_skill_var_samp_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_skill_variance_fields'] = ResolversParentTypes['posting_skill_variance_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_stddev_fields'] = ResolversParentTypes['posting_stddev_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_stddev_pop_fields'] = ResolversParentTypes['posting_stddev_pop_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_stddev_samp_fields'] = ResolversParentTypes['posting_stddev_samp_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_sum_fields'] = ResolversParentTypes['posting_sum_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_TagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_tags'] = ResolversParentTypes['posting_tags']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  posting?: Resolver<ResolversTypes['posting'], ParentType, ContextType>;
  posting_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  tag?: Resolver<ResolversTypes['tag'], ParentType, ContextType>;
  tag_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Tags_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_tags_aggregate'] = ResolversParentTypes['posting_tags_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['posting_tags_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['posting_tags']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Tags_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_tags_aggregate_fields'] = ResolversParentTypes['posting_tags_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Posting_Tags_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['posting_tags_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['posting_tags_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Tags_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_tags_max_fields'] = ResolversParentTypes['posting_tags_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Tags_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_tags_min_fields'] = ResolversParentTypes['posting_tags_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Tags_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_tags_mutation_response'] = ResolversParentTypes['posting_tags_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['posting_tags']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_var_pop_fields'] = ResolversParentTypes['posting_var_pop_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_var_samp_fields'] = ResolversParentTypes['posting_var_samp_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Posting_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['posting_variance_fields'] = ResolversParentTypes['posting_variance_fields']> = {
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  estimate_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['project'] = ResolversParentTypes['project']> = {
  access_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  access_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  access_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  access_type_other?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accessibility_issues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  additional_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_other_information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_special_instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  allergies_environmental?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allergies_food?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allergies_medication?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_care_plan?: Resolver<Maybe<ResolversTypes['client_care_plan']>, ParentType, ContextType>;
  client_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_medications?: Resolver<Array<ResolversTypes['client_medications']>, ParentType, ContextType, RequireFields<ProjectClient_MedicationsArgs, never>>;
  client_medications_aggregate?: Resolver<ResolversTypes['client_medications_aggregate'], ParentType, ContextType, RequireFields<ProjectClient_Medications_AggregateArgs, never>>;
  client_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_others?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_ability?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_languages_spoken?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  communication_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_others?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  community_resources?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  contractor_staff_notes?: Resolver<Array<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<ProjectContractor_Staff_NotesArgs, never>>;
  contractor_staff_notes_aggregate?: Resolver<ResolversTypes['contractor_staff_note_aggregate'], ParentType, ContextType, RequireFields<ProjectContractor_Staff_Notes_AggregateArgs, never>>;
  contractors?: Resolver<Array<ResolversTypes['contractor_project']>, ParentType, ContextType, RequireFields<ProjectContractorsArgs, never>>;
  contractors_aggregate?: Resolver<ResolversTypes['contractor_project_aggregate'], ParentType, ContextType, RequireFields<ProjectContractors_AggregateArgs, never>>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cultural_considerations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom_requests?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<ProjectCustom_RequestsArgs, never>>;
  custom_requests_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<ProjectCustom_Requests_AggregateArgs, never>>;
  date_completed?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  date_started?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  desired_outcomes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_restrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_copy_attached?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  drafted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email_address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_additional_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_contact_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_relationship?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_secondary_contact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enable_visit_based_clock_ins?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  extra_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_medical_history?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_support?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hobbies?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  home_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  immunizations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interpreter_needed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['invoice']>, ParentType, ContextType, RequireFields<ProjectInvoicesArgs, never>>;
  invoices_aggregate?: Resolver<ResolversTypes['invoice_aggregate'], ParentType, ContextType, RequireFields<ProjectInvoices_AggregateArgs, never>>;
  is_clockin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long_term_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  medical_conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mobility_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notify_admin_by_email?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  notify_manager_by_email?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  past_conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  past_surgeries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pets?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_communication_style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previous_hospitalizations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primary_contact_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  professional_care_contacts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activities?: Resolver<Array<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<ProjectProject_ActivitiesArgs, never>>;
  project_activities_aggregate?: Resolver<ResolversTypes['project_activity_aggregate'], ParentType, ContextType, RequireFields<ProjectProject_Activities_AggregateArgs, never>>;
  project_documents?: Resolver<Array<ResolversTypes['document_project']>, ParentType, ContextType, RequireFields<ProjectProject_DocumentsArgs, never>>;
  project_documents_aggregate?: Resolver<ResolversTypes['document_project_aggregate'], ParentType, ContextType, RequireFields<ProjectProject_Documents_AggregateArgs, never>>;
  project_skills?: Resolver<Array<ResolversTypes['project_skill']>, ParentType, ContextType, RequireFields<ProjectProject_SkillsArgs, never>>;
  project_skills_aggregate?: Resolver<ResolversTypes['project_skill_aggregate'], ParentType, ContextType, RequireFields<ProjectProject_Skills_AggregateArgs, never>>;
  project_soft_skills?: Resolver<Array<ResolversTypes['project_soft_skill']>, ParentType, ContextType, RequireFields<ProjectProject_Soft_SkillsArgs, never>>;
  project_soft_skills_aggregate?: Resolver<ResolversTypes['project_soft_skill_aggregate'], ParentType, ContextType, RequireFields<ProjectProject_Soft_Skills_AggregateArgs, never>>;
  project_tags?: Resolver<Array<ResolversTypes['project_tag']>, ParentType, ContextType, RequireFields<ProjectProject_TagsArgs, never>>;
  project_tags_aggregate?: Resolver<ResolversTypes['project_tag_aggregate'], ParentType, ContextType, RequireFields<ProjectProject_Tags_AggregateArgs, never>>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  religious_practices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  safety_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondar_contact_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self_directed_care_preferences?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  short_term_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  smart_home_features?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smart_match_bookmarks?: Resolver<Array<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<ProjectSmart_Match_BookmarksArgs, never>>;
  smart_match_bookmarks_aggregate?: Resolver<ResolversTypes['smart_match_bookmark_aggregate'], ParentType, ContextType, RequireFields<ProjectSmart_Match_Bookmarks_AggregateArgs, never>>;
  social_connections?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specific_care_needs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  support_type?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  teams?: Resolver<Array<ResolversTypes['team_project']>, ParentType, ContextType, RequireFields<ProjectTeamsArgs, never>>;
  teams_aggregate?: Resolver<ResolversTypes['team_project_aggregate'], ParentType, ContextType, RequireFields<ProjectTeams_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visual_communication_style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_ActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity'] = ResolversParentTypes['project_activity']> = {
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  accepted_on?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  budget?: Resolver<ResolversTypes['numeric'], ParentType, ContextType>;
  cancelled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  check_geo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  checkin_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkin_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  checkout_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkout_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  contractor?: Resolver<Maybe<ResolversTypes['contractor']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_ratings?: Resolver<Array<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<Project_ActivityContractor_RatingsArgs, never>>;
  contractor_ratings_aggregate?: Resolver<ResolversTypes['contractor_rating_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityContractor_Ratings_AggregateArgs, never>>;
  contractor_staff_notes?: Resolver<Array<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<Project_ActivityContractor_Staff_NotesArgs, never>>;
  contractor_staff_notes_aggregate?: Resolver<ResolversTypes['contractor_staff_note_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityContractor_Staff_Notes_AggregateArgs, never>>;
  contractor_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['currency'], ParentType, ContextType>;
  custom_requests?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<Project_ActivityCustom_RequestsArgs, never>>;
  custom_requests_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityCustom_Requests_AggregateArgs, never>>;
  declined_visit_matches?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<Project_ActivityDeclined_Visit_MatchesArgs, never>>;
  declined_visit_matches_aggregate?: Resolver<ResolversTypes['declined_visit_matches_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityDeclined_Visit_Matches_AggregateArgs, never>>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disable_time_alerts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  drafted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  extra_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra_notes_created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  extra_notes_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fallback_num?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  final_report_confirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  invoice_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  is_empty_visit_notify?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  last_email_alert_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_activity_notes?: Resolver<Array<ResolversTypes['project_activity_note']>, ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_NotesArgs, never>>;
  project_activity_notes_aggregate?: Resolver<ResolversTypes['project_activity_note_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Notes_AggregateArgs, never>>;
  project_activity_request_more_hours?: Resolver<Array<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Request_More_HoursArgs, never>>;
  project_activity_request_more_hours_aggregate?: Resolver<ResolversTypes['project_activity_request_more_hours_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Request_More_Hours_AggregateArgs, never>>;
  project_activity_skills?: Resolver<Array<ResolversTypes['project_activity_skill']>, ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_SkillsArgs, never>>;
  project_activity_skills_aggregate?: Resolver<ResolversTypes['project_activity_skill_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Skills_AggregateArgs, never>>;
  project_activity_soft_skills?: Resolver<Array<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Soft_SkillsArgs, never>>;
  project_activity_soft_skills_aggregate?: Resolver<ResolversTypes['project_activity_soft_skill_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Soft_Skills_AggregateArgs, never>>;
  project_activity_tags?: Resolver<Array<ResolversTypes['project_activity_tag']>, ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_TagsArgs, never>>;
  project_activity_tags_aggregate?: Resolver<ResolversTypes['project_activity_tag_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Tags_AggregateArgs, never>>;
  project_activity_times?: Resolver<Array<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_TimesArgs, never>>;
  project_activity_times_aggregate?: Resolver<ResolversTypes['project_activity_time_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Times_AggregateArgs, never>>;
  project_activity_tracked_times?: Resolver<Array<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Tracked_TimesArgs, never>>;
  project_activity_tracked_times_aggregate?: Resolver<ResolversTypes['project_activity_tracked_time_aggregate'], ParentType, ContextType, RequireFields<Project_ActivityProject_Activity_Tracked_Times_AggregateArgs, never>>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  rejected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type_of_visit?: Resolver<Maybe<ResolversTypes['type_of_visit_enum']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  virtual?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  virtual_meeting_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_aggregate'] = ResolversParentTypes['project_activity_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_aggregate_fields'] = ResolversParentTypes['project_activity_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_activity_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_activity_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_activity_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_activity_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_activity_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_activity_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_activity_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_activity_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_avg_fields'] = ResolversParentTypes['project_activity_avg_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_max_fields'] = ResolversParentTypes['project_activity_max_fields']> = {
  accepted_on?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  budget?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  checkin_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkin_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  checkout_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkout_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  extra_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra_notes_created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  extra_notes_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fallback_num?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invoice_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  last_email_alert_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  virtual_meeting_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_min_fields'] = ResolversParentTypes['project_activity_min_fields']> = {
  accepted_on?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  budget?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  checkin_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkin_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  checkout_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkout_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  extra_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra_notes_created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  extra_notes_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fallback_num?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invoice_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  last_email_alert_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note_updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  virtual_meeting_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_mutation_response'] = ResolversParentTypes['project_activity_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_NoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_note'] = ResolversParentTypes['project_activity_note']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  project_activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Note_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_note_aggregate'] = ResolversParentTypes['project_activity_note_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_note_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity_note']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Note_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_note_aggregate_fields'] = ResolversParentTypes['project_activity_note_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Note_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_note_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_note_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Note_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_note_max_fields'] = ResolversParentTypes['project_activity_note_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Note_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_note_min_fields'] = ResolversParentTypes['project_activity_note_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Note_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_note_mutation_response'] = ResolversParentTypes['project_activity_note_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity_note']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_HoursResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours'] = ResolversParentTypes['project_activity_request_more_hours']> = {
  activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  actor?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  actor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['date'], ParentType, ContextType>;
  decline_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hours?: Resolver<ResolversTypes['numeric'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  project_activity?: Resolver<ResolversTypes['project_activity'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requester?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  requester_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_aggregate'] = ResolversParentTypes['project_activity_request_more_hours_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_aggregate_fields'] = ResolversParentTypes['project_activity_request_more_hours_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Request_More_Hours_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_avg_fields'] = ResolversParentTypes['project_activity_request_more_hours_avg_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_max_fields'] = ResolversParentTypes['project_activity_request_more_hours_max_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  actor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  decline_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requester_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_min_fields'] = ResolversParentTypes['project_activity_request_more_hours_min_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  actor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  decline_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requester_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_mutation_response'] = ResolversParentTypes['project_activity_request_more_hours_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_stddev_fields'] = ResolversParentTypes['project_activity_request_more_hours_stddev_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_stddev_pop_fields'] = ResolversParentTypes['project_activity_request_more_hours_stddev_pop_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_stddev_samp_fields'] = ResolversParentTypes['project_activity_request_more_hours_stddev_samp_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_sum_fields'] = ResolversParentTypes['project_activity_request_more_hours_sum_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_var_pop_fields'] = ResolversParentTypes['project_activity_request_more_hours_var_pop_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_var_samp_fields'] = ResolversParentTypes['project_activity_request_more_hours_var_samp_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Request_More_Hours_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_request_more_hours_variance_fields'] = ResolversParentTypes['project_activity_request_more_hours_variance_fields']> = {
  hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill'] = ResolversParentTypes['project_activity_skill']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  project_activity?: Resolver<ResolversTypes['project_activity'], ParentType, ContextType>;
  project_activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['skill'], ParentType, ContextType>;
  skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_aggregate'] = ResolversParentTypes['project_activity_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_aggregate_fields'] = ResolversParentTypes['project_activity_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_activity_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_activity_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_activity_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_activity_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_activity_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_activity_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_activity_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_activity_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_avg_fields'] = ResolversParentTypes['project_activity_skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_max_fields'] = ResolversParentTypes['project_activity_skill_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_min_fields'] = ResolversParentTypes['project_activity_skill_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_mutation_response'] = ResolversParentTypes['project_activity_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_stddev_fields'] = ResolversParentTypes['project_activity_skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_stddev_pop_fields'] = ResolversParentTypes['project_activity_skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_stddev_samp_fields'] = ResolversParentTypes['project_activity_skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_sum_fields'] = ResolversParentTypes['project_activity_skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_var_pop_fields'] = ResolversParentTypes['project_activity_skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_var_samp_fields'] = ResolversParentTypes['project_activity_skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_skill_variance_fields'] = ResolversParentTypes['project_activity_skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill'] = ResolversParentTypes['project_activity_soft_skill']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  project_activity?: Resolver<ResolversTypes['project_activity'], ParentType, ContextType>;
  project_activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  soft_skill?: Resolver<ResolversTypes['soft_skill'], ParentType, ContextType>;
  soft_skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_aggregate'] = ResolversParentTypes['project_activity_soft_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_aggregate_fields'] = ResolversParentTypes['project_activity_soft_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Soft_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_avg_fields'] = ResolversParentTypes['project_activity_soft_skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_max_fields'] = ResolversParentTypes['project_activity_soft_skill_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_min_fields'] = ResolversParentTypes['project_activity_soft_skill_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_mutation_response'] = ResolversParentTypes['project_activity_soft_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_stddev_fields'] = ResolversParentTypes['project_activity_soft_skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_stddev_pop_fields'] = ResolversParentTypes['project_activity_soft_skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_stddev_samp_fields'] = ResolversParentTypes['project_activity_soft_skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_sum_fields'] = ResolversParentTypes['project_activity_soft_skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_var_pop_fields'] = ResolversParentTypes['project_activity_soft_skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_var_samp_fields'] = ResolversParentTypes['project_activity_soft_skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Soft_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_soft_skill_variance_fields'] = ResolversParentTypes['project_activity_soft_skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_stddev_fields'] = ResolversParentTypes['project_activity_stddev_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_stddev_pop_fields'] = ResolversParentTypes['project_activity_stddev_pop_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_stddev_samp_fields'] = ResolversParentTypes['project_activity_stddev_samp_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_sum_fields'] = ResolversParentTypes['project_activity_sum_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag'] = ResolversParentTypes['project_activity_tag']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  project_activity?: Resolver<ResolversTypes['project_activity'], ParentType, ContextType>;
  project_activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  tag?: Resolver<ResolversTypes['tag'], ParentType, ContextType>;
  tag_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_aggregate'] = ResolversParentTypes['project_activity_tag_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_tag_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity_tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_aggregate_fields'] = ResolversParentTypes['project_activity_tag_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_activity_tag_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Tag_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_tag_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_tag_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_activity_tag_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_activity_tag_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_activity_tag_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_activity_tag_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_activity_tag_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_activity_tag_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_activity_tag_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_avg_fields'] = ResolversParentTypes['project_activity_tag_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_max_fields'] = ResolversParentTypes['project_activity_tag_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_min_fields'] = ResolversParentTypes['project_activity_tag_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_mutation_response'] = ResolversParentTypes['project_activity_tag_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity_tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_stddev_fields'] = ResolversParentTypes['project_activity_tag_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_stddev_pop_fields'] = ResolversParentTypes['project_activity_tag_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_stddev_samp_fields'] = ResolversParentTypes['project_activity_tag_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_sum_fields'] = ResolversParentTypes['project_activity_tag_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_var_pop_fields'] = ResolversParentTypes['project_activity_tag_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_var_samp_fields'] = ResolversParentTypes['project_activity_tag_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tag_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tag_variance_fields'] = ResolversParentTypes['project_activity_tag_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_TimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time'] = ResolversParentTypes['project_activity_time']> = {
  activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['time']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  invoice_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activity?: Resolver<ResolversTypes['project_activity'], ParentType, ContextType>;
  project_activity_tracked_times?: Resolver<Array<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<Project_Activity_TimeProject_Activity_Tracked_TimesArgs, never>>;
  project_activity_tracked_times_aggregate?: Resolver<ResolversTypes['project_activity_tracked_time_aggregate'], ParentType, ContextType, RequireFields<Project_Activity_TimeProject_Activity_Tracked_Times_AggregateArgs, never>>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['time']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['numeric'], ParentType, ContextType>;
  timesheet?: Resolver<Maybe<ResolversTypes['timesheet']>, ParentType, ContextType>;
  timesheet_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tracked_date?: Resolver<ResolversTypes['date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_aggregate'] = ResolversParentTypes['project_activity_time_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_time_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity_time']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_aggregate_fields'] = ResolversParentTypes['project_activity_time_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_activity_time_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Time_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_time_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_time_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_activity_time_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_activity_time_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_activity_time_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_activity_time_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_activity_time_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_activity_time_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_activity_time_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_avg_fields'] = ResolversParentTypes['project_activity_time_avg_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_max_fields'] = ResolversParentTypes['project_activity_time_max_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invoice_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  timesheet_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tracked_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_min_fields'] = ResolversParentTypes['project_activity_time_min_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  invoice_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  timesheet_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tracked_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_mutation_response'] = ResolversParentTypes['project_activity_time_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity_time']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_stddev_fields'] = ResolversParentTypes['project_activity_time_stddev_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_stddev_pop_fields'] = ResolversParentTypes['project_activity_time_stddev_pop_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_stddev_samp_fields'] = ResolversParentTypes['project_activity_time_stddev_samp_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_sum_fields'] = ResolversParentTypes['project_activity_time_sum_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_var_pop_fields'] = ResolversParentTypes['project_activity_time_var_pop_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_var_samp_fields'] = ResolversParentTypes['project_activity_time_var_samp_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Time_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_time_variance_fields'] = ResolversParentTypes['project_activity_time_variance_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_TimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time'] = ResolversParentTypes['project_activity_tracked_time']> = {
  activity_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  activity_time_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_activity?: Resolver<ResolversTypes['project_activity'], ParentType, ContextType>;
  project_activity_time?: Resolver<Maybe<ResolversTypes['project_activity_time']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timesheet?: Resolver<Maybe<ResolversTypes['timesheet']>, ParentType, ContextType>;
  timesheet_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_aggregate'] = ResolversParentTypes['project_activity_tracked_time_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_aggregate_fields'] = ResolversParentTypes['project_activity_tracked_time_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Activity_Tracked_Time_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_avg_fields'] = ResolversParentTypes['project_activity_tracked_time_avg_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_max_fields'] = ResolversParentTypes['project_activity_tracked_time_max_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activity_time_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timesheet_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_min_fields'] = ResolversParentTypes['project_activity_tracked_time_min_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activity_time_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_time?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_time?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timesheet_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_mutation_response'] = ResolversParentTypes['project_activity_tracked_time_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_stddev_fields'] = ResolversParentTypes['project_activity_tracked_time_stddev_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_stddev_pop_fields'] = ResolversParentTypes['project_activity_tracked_time_stddev_pop_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_stddev_samp_fields'] = ResolversParentTypes['project_activity_tracked_time_stddev_samp_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_sum_fields'] = ResolversParentTypes['project_activity_tracked_time_sum_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_var_pop_fields'] = ResolversParentTypes['project_activity_tracked_time_var_pop_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_var_samp_fields'] = ResolversParentTypes['project_activity_tracked_time_var_samp_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Tracked_Time_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_tracked_time_variance_fields'] = ResolversParentTypes['project_activity_tracked_time_variance_fields']> = {
  time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_var_pop_fields'] = ResolversParentTypes['project_activity_var_pop_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_var_samp_fields'] = ResolversParentTypes['project_activity_var_samp_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Activity_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_activity_variance_fields'] = ResolversParentTypes['project_activity_variance_fields']> = {
  budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  confirmed_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_cost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  final_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requested_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_aggregate'] = ResolversParentTypes['project_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_aggregate_fields'] = ResolversParentTypes['project_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_avg_fields'] = ResolversParentTypes['project_avg_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_max_fields'] = ResolversParentTypes['project_max_fields']> = {
  access_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  access_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  access_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  access_type_other?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accessibility_issues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_other_information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_special_instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  allergies_environmental?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allergies_food?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allergies_medication?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_others?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_ability?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_languages_spoken?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  communication_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_others?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  community_resources?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cultural_considerations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_completed?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  date_started?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  desired_outcomes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_restrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_copy_attached?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email_address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_additional_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_contact_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_relationship?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_secondary_contact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  extra_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_medical_history?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_support?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hobbies?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  home_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  immunizations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interpreter_needed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long_term_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  medical_conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mobility_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  past_conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  past_surgeries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pets?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_communication_style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previous_hospitalizations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primary_contact_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  professional_care_contacts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  religious_practices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  safety_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondar_contact_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self_directed_care_preferences?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  short_term_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smart_home_features?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  social_connections?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specific_care_needs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  support_type?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visual_communication_style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_min_fields'] = ResolversParentTypes['project_min_fields']> = {
  access_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  access_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  access_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  access_type_other?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accessibility_issues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_other_information?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additional_special_instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  allergies_environmental?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allergies_food?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  allergies_medication?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cognitive_others?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_ability?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_languages_spoken?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  communication_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  communication_others?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  community_resources?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cultural_considerations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_completed?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  date_started?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  desired_outcomes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dietary_restrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_copy_attached?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnr_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email_address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_additional_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_contact_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_relationship?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency_secondary_contact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  extra_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_medical_history?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_support?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hobbies?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  home_general_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  immunizations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interests?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interpreter_needed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long_term_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  medical_conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mobility_level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobility_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  past_conditions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  past_surgeries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pets?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  phone_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_communication_style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferred_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previous_hospitalizations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primary_contact_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  professional_care_contacts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  religious_practices?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  safety_concerns?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondar_contact_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self_directed_care_preferences?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  short_term_goals?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smart_home_features?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  social_connections?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_instructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specific_care_needs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  support_type?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updated_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visual_communication_style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_mutation_response'] = ResolversParentTypes['project_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill'] = ResolversParentTypes['project_skill']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['skill'], ParentType, ContextType>;
  skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_aggregate'] = ResolversParentTypes['project_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_aggregate_fields'] = ResolversParentTypes['project_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_avg_fields'] = ResolversParentTypes['project_skill_avg_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_max_fields'] = ResolversParentTypes['project_skill_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_min_fields'] = ResolversParentTypes['project_skill_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_mutation_response'] = ResolversParentTypes['project_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_stddev_fields'] = ResolversParentTypes['project_skill_stddev_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_stddev_pop_fields'] = ResolversParentTypes['project_skill_stddev_pop_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_stddev_samp_fields'] = ResolversParentTypes['project_skill_stddev_samp_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_sum_fields'] = ResolversParentTypes['project_skill_sum_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_var_pop_fields'] = ResolversParentTypes['project_skill_var_pop_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_var_samp_fields'] = ResolversParentTypes['project_skill_var_samp_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_skill_variance_fields'] = ResolversParentTypes['project_skill_variance_fields']> = {
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill'] = ResolversParentTypes['project_soft_skill']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  soft_skill?: Resolver<ResolversTypes['soft_skill'], ParentType, ContextType>;
  soft_skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_aggregate'] = ResolversParentTypes['project_soft_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_soft_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_aggregate_fields'] = ResolversParentTypes['project_soft_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_soft_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Soft_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_soft_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_soft_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_soft_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_soft_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_soft_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_soft_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_soft_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_soft_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_soft_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_avg_fields'] = ResolversParentTypes['project_soft_skill_avg_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_max_fields'] = ResolversParentTypes['project_soft_skill_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_min_fields'] = ResolversParentTypes['project_soft_skill_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_mutation_response'] = ResolversParentTypes['project_soft_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_stddev_fields'] = ResolversParentTypes['project_soft_skill_stddev_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_stddev_pop_fields'] = ResolversParentTypes['project_soft_skill_stddev_pop_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_stddev_samp_fields'] = ResolversParentTypes['project_soft_skill_stddev_samp_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_sum_fields'] = ResolversParentTypes['project_soft_skill_sum_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_var_pop_fields'] = ResolversParentTypes['project_soft_skill_var_pop_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_var_samp_fields'] = ResolversParentTypes['project_soft_skill_var_samp_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Soft_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_soft_skill_variance_fields'] = ResolversParentTypes['project_soft_skill_variance_fields']> = {
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_stddev_fields'] = ResolversParentTypes['project_stddev_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_stddev_pop_fields'] = ResolversParentTypes['project_stddev_pop_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_stddev_samp_fields'] = ResolversParentTypes['project_stddev_samp_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_sum_fields'] = ResolversParentTypes['project_sum_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag'] = ResolversParentTypes['project_tag']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  tag?: Resolver<ResolversTypes['tag'], ParentType, ContextType>;
  tag_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_aggregate'] = ResolversParentTypes['project_tag_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['project_tag_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['project_tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_aggregate_fields'] = ResolversParentTypes['project_tag_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['project_tag_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Project_Tag_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['project_tag_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['project_tag_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['project_tag_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['project_tag_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['project_tag_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['project_tag_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['project_tag_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['project_tag_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['project_tag_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_avg_fields'] = ResolversParentTypes['project_tag_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_max_fields'] = ResolversParentTypes['project_tag_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_min_fields'] = ResolversParentTypes['project_tag_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_mutation_response'] = ResolversParentTypes['project_tag_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['project_tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_stddev_fields'] = ResolversParentTypes['project_tag_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_stddev_pop_fields'] = ResolversParentTypes['project_tag_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_stddev_samp_fields'] = ResolversParentTypes['project_tag_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_sum_fields'] = ResolversParentTypes['project_tag_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_var_pop_fields'] = ResolversParentTypes['project_tag_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_var_samp_fields'] = ResolversParentTypes['project_tag_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Tag_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_tag_variance_fields'] = ResolversParentTypes['project_tag_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_var_pop_fields'] = ResolversParentTypes['project_var_pop_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_var_samp_fields'] = ResolversParentTypes['project_var_samp_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Project_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['project_variance_fields'] = ResolversParentTypes['project_variance_fields']> = {
  age?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_budget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Public_Project_DetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['public_project_details'] = ResolversParentTypes['public_project_details']> = {
  activity_deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activity_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType>;
  project_activity?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Public_Project_Details_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['public_project_details_aggregate'] = ResolversParentTypes['public_project_details_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['public_project_details_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['public_project_details']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Public_Project_Details_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['public_project_details_aggregate_fields'] = ResolversParentTypes['public_project_details_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Public_Project_Details_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['public_project_details_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['public_project_details_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Public_Project_Details_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['public_project_details_max_fields'] = ResolversParentTypes['public_project_details_max_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activity_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Public_Project_Details_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['public_project_details_min_fields'] = ResolversParentTypes['public_project_details_min_fields']> = {
  activity_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activity_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Query_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['query_root'] = ResolversParentTypes['query_root']> = {
  admin?: Resolver<Array<ResolversTypes['admin']>, ParentType, ContextType, RequireFields<Query_RootAdminArgs, never>>;
  admin_aggregate?: Resolver<ResolversTypes['admin_aggregate'], ParentType, ContextType, RequireFields<Query_RootAdmin_AggregateArgs, never>>;
  admin_by_pk?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType, RequireFields<Query_RootAdmin_By_PkArgs, 'id'>>;
  application?: Resolver<Array<ResolversTypes['application']>, ParentType, ContextType, RequireFields<Query_RootApplicationArgs, never>>;
  application_aggregate?: Resolver<ResolversTypes['application_aggregate'], ParentType, ContextType, RequireFields<Query_RootApplication_AggregateArgs, never>>;
  application_by_pk?: Resolver<Maybe<ResolversTypes['application']>, ParentType, ContextType, RequireFields<Query_RootApplication_By_PkArgs, 'id'>>;
  candidate?: Resolver<Array<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<Query_RootCandidateArgs, never>>;
  candidate_aggregate?: Resolver<ResolversTypes['candidate_aggregate'], ParentType, ContextType, RequireFields<Query_RootCandidate_AggregateArgs, never>>;
  candidate_by_pk?: Resolver<Maybe<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<Query_RootCandidate_By_PkArgs, 'id'>>;
  chart_admin_contractors?: Resolver<Array<ResolversTypes['chart_admin_contractors']>, ParentType, ContextType, RequireFields<Query_RootChart_Admin_ContractorsArgs, never>>;
  chart_admin_contractors_aggregate?: Resolver<ResolversTypes['chart_admin_contractors_aggregate'], ParentType, ContextType, RequireFields<Query_RootChart_Admin_Contractors_AggregateArgs, never>>;
  chart_manager_contractors?: Resolver<Array<ResolversTypes['chart_manager_contractors']>, ParentType, ContextType, RequireFields<Query_RootChart_Manager_ContractorsArgs, never>>;
  chart_manager_contractors_aggregate?: Resolver<ResolversTypes['chart_manager_contractors_aggregate'], ParentType, ContextType, RequireFields<Query_RootChart_Manager_Contractors_AggregateArgs, never>>;
  chart_projects?: Resolver<Array<ResolversTypes['chart_projects']>, ParentType, ContextType, RequireFields<Query_RootChart_ProjectsArgs, never>>;
  chart_projects_aggregate?: Resolver<ResolversTypes['chart_projects_aggregate'], ParentType, ContextType, RequireFields<Query_RootChart_Projects_AggregateArgs, never>>;
  checkin_status?: Resolver<Array<ResolversTypes['checkin_status']>, ParentType, ContextType, RequireFields<Query_RootCheckin_StatusArgs, never>>;
  checkin_status_aggregate?: Resolver<ResolversTypes['checkin_status_aggregate'], ParentType, ContextType, RequireFields<Query_RootCheckin_Status_AggregateArgs, never>>;
  checkin_status_by_pk?: Resolver<Maybe<ResolversTypes['checkin_status']>, ParentType, ContextType, RequireFields<Query_RootCheckin_Status_By_PkArgs, 'value'>>;
  checkout_status?: Resolver<Array<ResolversTypes['checkout_status']>, ParentType, ContextType, RequireFields<Query_RootCheckout_StatusArgs, never>>;
  checkout_status_aggregate?: Resolver<ResolversTypes['checkout_status_aggregate'], ParentType, ContextType, RequireFields<Query_RootCheckout_Status_AggregateArgs, never>>;
  checkout_status_by_pk?: Resolver<Maybe<ResolversTypes['checkout_status']>, ParentType, ContextType, RequireFields<Query_RootCheckout_Status_By_PkArgs, 'value'>>;
  client_care_plan?: Resolver<Array<ResolversTypes['client_care_plan']>, ParentType, ContextType, RequireFields<Query_RootClient_Care_PlanArgs, never>>;
  client_care_plan_aggregate?: Resolver<ResolversTypes['client_care_plan_aggregate'], ParentType, ContextType, RequireFields<Query_RootClient_Care_Plan_AggregateArgs, never>>;
  client_care_plan_by_pk?: Resolver<Maybe<ResolversTypes['client_care_plan']>, ParentType, ContextType, RequireFields<Query_RootClient_Care_Plan_By_PkArgs, 'id'>>;
  client_medications?: Resolver<Array<ResolversTypes['client_medications']>, ParentType, ContextType, RequireFields<Query_RootClient_MedicationsArgs, never>>;
  client_medications_aggregate?: Resolver<ResolversTypes['client_medications_aggregate'], ParentType, ContextType, RequireFields<Query_RootClient_Medications_AggregateArgs, never>>;
  client_medications_by_pk?: Resolver<Maybe<ResolversTypes['client_medications']>, ParentType, ContextType, RequireFields<Query_RootClient_Medications_By_PkArgs, 'id'>>;
  company?: Resolver<Array<ResolversTypes['company']>, ParentType, ContextType, RequireFields<Query_RootCompanyArgs, never>>;
  company_aggregate?: Resolver<ResolversTypes['company_aggregate'], ParentType, ContextType, RequireFields<Query_RootCompany_AggregateArgs, never>>;
  company_by_pk?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType, RequireFields<Query_RootCompany_By_PkArgs, 'id'>>;
  company_follower?: Resolver<Array<ResolversTypes['company_follower']>, ParentType, ContextType, RequireFields<Query_RootCompany_FollowerArgs, never>>;
  company_follower_aggregate?: Resolver<ResolversTypes['company_follower_aggregate'], ParentType, ContextType, RequireFields<Query_RootCompany_Follower_AggregateArgs, never>>;
  company_follower_by_pk?: Resolver<Maybe<ResolversTypes['company_follower']>, ParentType, ContextType, RequireFields<Query_RootCompany_Follower_By_PkArgs, 'id'>>;
  company_user_notifications?: Resolver<Array<ResolversTypes['company_user_notifications']>, ParentType, ContextType, RequireFields<Query_RootCompany_User_NotificationsArgs, never>>;
  company_user_notifications_aggregate?: Resolver<ResolversTypes['company_user_notifications_aggregate'], ParentType, ContextType, RequireFields<Query_RootCompany_User_Notifications_AggregateArgs, never>>;
  company_user_notifications_by_pk?: Resolver<Maybe<ResolversTypes['company_user_notifications']>, ParentType, ContextType, RequireFields<Query_RootCompany_User_Notifications_By_PkArgs, 'id'>>;
  contractor?: Resolver<Array<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<Query_RootContractorArgs, never>>;
  contractor_aggregate?: Resolver<ResolversTypes['contractor_aggregate'], ParentType, ContextType, RequireFields<Query_RootContractor_AggregateArgs, never>>;
  contractor_by_pk?: Resolver<Maybe<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<Query_RootContractor_By_PkArgs, 'id'>>;
  contractor_note?: Resolver<Array<ResolversTypes['contractor_note']>, ParentType, ContextType, RequireFields<Query_RootContractor_NoteArgs, never>>;
  contractor_note_aggregate?: Resolver<ResolversTypes['contractor_note_aggregate'], ParentType, ContextType, RequireFields<Query_RootContractor_Note_AggregateArgs, never>>;
  contractor_note_by_pk?: Resolver<Maybe<ResolversTypes['contractor_note']>, ParentType, ContextType, RequireFields<Query_RootContractor_Note_By_PkArgs, 'id'>>;
  contractor_posting?: Resolver<Array<ResolversTypes['contractor_posting']>, ParentType, ContextType, RequireFields<Query_RootContractor_PostingArgs, never>>;
  contractor_posting_aggregate?: Resolver<ResolversTypes['contractor_posting_aggregate'], ParentType, ContextType, RequireFields<Query_RootContractor_Posting_AggregateArgs, never>>;
  contractor_posting_by_pk?: Resolver<Maybe<ResolversTypes['contractor_posting']>, ParentType, ContextType, RequireFields<Query_RootContractor_Posting_By_PkArgs, 'id'>>;
  contractor_project?: Resolver<Array<ResolversTypes['contractor_project']>, ParentType, ContextType, RequireFields<Query_RootContractor_ProjectArgs, never>>;
  contractor_project_aggregate?: Resolver<ResolversTypes['contractor_project_aggregate'], ParentType, ContextType, RequireFields<Query_RootContractor_Project_AggregateArgs, never>>;
  contractor_project_by_pk?: Resolver<Maybe<ResolversTypes['contractor_project']>, ParentType, ContextType, RequireFields<Query_RootContractor_Project_By_PkArgs, 'id'>>;
  contractor_rating?: Resolver<Array<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<Query_RootContractor_RatingArgs, never>>;
  contractor_rating_aggregate?: Resolver<ResolversTypes['contractor_rating_aggregate'], ParentType, ContextType, RequireFields<Query_RootContractor_Rating_AggregateArgs, never>>;
  contractor_rating_by_pk?: Resolver<Maybe<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<Query_RootContractor_Rating_By_PkArgs, 'id'>>;
  contractor_staff_note?: Resolver<Array<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<Query_RootContractor_Staff_NoteArgs, never>>;
  contractor_staff_note_aggregate?: Resolver<ResolversTypes['contractor_staff_note_aggregate'], ParentType, ContextType, RequireFields<Query_RootContractor_Staff_Note_AggregateArgs, never>>;
  contractor_staff_note_by_pk?: Resolver<Maybe<ResolversTypes['contractor_staff_note']>, ParentType, ContextType, RequireFields<Query_RootContractor_Staff_Note_By_PkArgs, 'id'>>;
  conversation?: Resolver<Array<ResolversTypes['conversation']>, ParentType, ContextType, RequireFields<Query_RootConversationArgs, never>>;
  conversation_aggregate?: Resolver<ResolversTypes['conversation_aggregate'], ParentType, ContextType, RequireFields<Query_RootConversation_AggregateArgs, never>>;
  conversation_by_pk?: Resolver<Maybe<ResolversTypes['conversation']>, ParentType, ContextType, RequireFields<Query_RootConversation_By_PkArgs, 'id'>>;
  custom_request?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<Query_RootCustom_RequestArgs, never>>;
  custom_request_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<Query_RootCustom_Request_AggregateArgs, never>>;
  custom_request_by_pk?: Resolver<Maybe<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<Query_RootCustom_Request_By_PkArgs, 'id'>>;
  custom_request_skills?: Resolver<Array<ResolversTypes['custom_request_skills']>, ParentType, ContextType, RequireFields<Query_RootCustom_Request_SkillsArgs, never>>;
  custom_request_skills_aggregate?: Resolver<ResolversTypes['custom_request_skills_aggregate'], ParentType, ContextType, RequireFields<Query_RootCustom_Request_Skills_AggregateArgs, never>>;
  custom_request_skills_by_pk?: Resolver<Maybe<ResolversTypes['custom_request_skills']>, ParentType, ContextType, RequireFields<Query_RootCustom_Request_Skills_By_PkArgs, 'id'>>;
  declined_visit_matches?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<Query_RootDeclined_Visit_MatchesArgs, never>>;
  declined_visit_matches_aggregate?: Resolver<ResolversTypes['declined_visit_matches_aggregate'], ParentType, ContextType, RequireFields<Query_RootDeclined_Visit_Matches_AggregateArgs, never>>;
  declined_visit_matches_by_pk?: Resolver<Maybe<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<Query_RootDeclined_Visit_Matches_By_PkArgs, 'id'>>;
  document?: Resolver<Array<ResolversTypes['document']>, ParentType, ContextType, RequireFields<Query_RootDocumentArgs, never>>;
  document_aggregate?: Resolver<ResolversTypes['document_aggregate'], ParentType, ContextType, RequireFields<Query_RootDocument_AggregateArgs, never>>;
  document_by_pk?: Resolver<Maybe<ResolversTypes['document']>, ParentType, ContextType, RequireFields<Query_RootDocument_By_PkArgs, 'id'>>;
  document_contractor_access?: Resolver<Array<ResolversTypes['document_contractor_access']>, ParentType, ContextType, RequireFields<Query_RootDocument_Contractor_AccessArgs, never>>;
  document_contractor_access_aggregate?: Resolver<ResolversTypes['document_contractor_access_aggregate'], ParentType, ContextType, RequireFields<Query_RootDocument_Contractor_Access_AggregateArgs, never>>;
  document_contractor_access_by_pk?: Resolver<Maybe<ResolversTypes['document_contractor_access']>, ParentType, ContextType, RequireFields<Query_RootDocument_Contractor_Access_By_PkArgs, 'id'>>;
  document_custom_request?: Resolver<Array<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<Query_RootDocument_Custom_RequestArgs, never>>;
  document_custom_request_aggregate?: Resolver<ResolversTypes['document_custom_request_aggregate'], ParentType, ContextType, RequireFields<Query_RootDocument_Custom_Request_AggregateArgs, never>>;
  document_custom_request_by_pk?: Resolver<Maybe<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<Query_RootDocument_Custom_Request_By_PkArgs, 'id'>>;
  document_project?: Resolver<Array<ResolversTypes['document_project']>, ParentType, ContextType, RequireFields<Query_RootDocument_ProjectArgs, never>>;
  document_project_aggregate?: Resolver<ResolversTypes['document_project_aggregate'], ParentType, ContextType, RequireFields<Query_RootDocument_Project_AggregateArgs, never>>;
  document_project_by_pk?: Resolver<Maybe<ResolversTypes['document_project']>, ParentType, ContextType, RequireFields<Query_RootDocument_Project_By_PkArgs, 'id'>>;
  document_user?: Resolver<Array<ResolversTypes['document_user']>, ParentType, ContextType, RequireFields<Query_RootDocument_UserArgs, never>>;
  document_user_aggregate?: Resolver<ResolversTypes['document_user_aggregate'], ParentType, ContextType, RequireFields<Query_RootDocument_User_AggregateArgs, never>>;
  document_user_by_pk?: Resolver<Maybe<ResolversTypes['document_user']>, ParentType, ContextType, RequireFields<Query_RootDocument_User_By_PkArgs, 'id'>>;
  email_regex?: Resolver<Array<ResolversTypes['email_regex']>, ParentType, ContextType, RequireFields<Query_RootEmail_RegexArgs, never>>;
  email_regex_aggregate?: Resolver<ResolversTypes['email_regex_aggregate'], ParentType, ContextType, RequireFields<Query_RootEmail_Regex_AggregateArgs, never>>;
  email_regex_by_pk?: Resolver<Maybe<ResolversTypes['email_regex']>, ParentType, ContextType, RequireFields<Query_RootEmail_Regex_By_PkArgs, 'id'>>;
  experience_skill?: Resolver<Array<ResolversTypes['experience_skill']>, ParentType, ContextType, RequireFields<Query_RootExperience_SkillArgs, never>>;
  experience_skill_aggregate?: Resolver<ResolversTypes['experience_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootExperience_Skill_AggregateArgs, never>>;
  experience_skill_by_pk?: Resolver<Maybe<ResolversTypes['experience_skill']>, ParentType, ContextType, RequireFields<Query_RootExperience_Skill_By_PkArgs, 'id'>>;
  gender?: Resolver<Array<ResolversTypes['gender']>, ParentType, ContextType, RequireFields<Query_RootGenderArgs, never>>;
  gender_aggregate?: Resolver<ResolversTypes['gender_aggregate'], ParentType, ContextType, RequireFields<Query_RootGender_AggregateArgs, never>>;
  gender_by_pk?: Resolver<Maybe<ResolversTypes['gender']>, ParentType, ContextType, RequireFields<Query_RootGender_By_PkArgs, 'value'>>;
  industry?: Resolver<Array<ResolversTypes['industry']>, ParentType, ContextType, RequireFields<Query_RootIndustryArgs, never>>;
  industry_aggregate?: Resolver<ResolversTypes['industry_aggregate'], ParentType, ContextType, RequireFields<Query_RootIndustry_AggregateArgs, never>>;
  industry_by_pk?: Resolver<Maybe<ResolversTypes['industry']>, ParentType, ContextType, RequireFields<Query_RootIndustry_By_PkArgs, 'id'>>;
  invitation?: Resolver<Array<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<Query_RootInvitationArgs, never>>;
  invitation_aggregate?: Resolver<ResolversTypes['invitation_aggregate'], ParentType, ContextType, RequireFields<Query_RootInvitation_AggregateArgs, never>>;
  invitation_by_pk?: Resolver<Maybe<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<Query_RootInvitation_By_PkArgs, 'id'>>;
  invoice?: Resolver<Array<ResolversTypes['invoice']>, ParentType, ContextType, RequireFields<Query_RootInvoiceArgs, never>>;
  invoice_aggregate?: Resolver<ResolversTypes['invoice_aggregate'], ParentType, ContextType, RequireFields<Query_RootInvoice_AggregateArgs, never>>;
  invoice_by_pk?: Resolver<Maybe<ResolversTypes['invoice']>, ParentType, ContextType, RequireFields<Query_RootInvoice_By_PkArgs, 'id'>>;
  language?: Resolver<Array<ResolversTypes['language']>, ParentType, ContextType, RequireFields<Query_RootLanguageArgs, never>>;
  language_aggregate?: Resolver<ResolversTypes['language_aggregate'], ParentType, ContextType, RequireFields<Query_RootLanguage_AggregateArgs, never>>;
  language_by_pk?: Resolver<Maybe<ResolversTypes['language']>, ParentType, ContextType, RequireFields<Query_RootLanguage_By_PkArgs, 'id'>>;
  manager?: Resolver<Array<ResolversTypes['manager']>, ParentType, ContextType, RequireFields<Query_RootManagerArgs, never>>;
  manager_aggregate?: Resolver<ResolversTypes['manager_aggregate'], ParentType, ContextType, RequireFields<Query_RootManager_AggregateArgs, never>>;
  manager_by_pk?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType, RequireFields<Query_RootManager_By_PkArgs, 'id'>>;
  manager_contractor?: Resolver<Array<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<Query_RootManager_ContractorArgs, never>>;
  manager_contractor_aggregate?: Resolver<ResolversTypes['manager_contractor_aggregate'], ParentType, ContextType, RequireFields<Query_RootManager_Contractor_AggregateArgs, never>>;
  manager_contractor_by_pk?: Resolver<Maybe<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<Query_RootManager_Contractor_By_PkArgs, 'id'>>;
  message?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType, RequireFields<Query_RootMessageArgs, never>>;
  message_aggregate?: Resolver<ResolversTypes['message_aggregate'], ParentType, ContextType, RequireFields<Query_RootMessage_AggregateArgs, never>>;
  message_by_pk?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<Query_RootMessage_By_PkArgs, 'id'>>;
  notification?: Resolver<Array<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<Query_RootNotificationArgs, never>>;
  notification_aggregate?: Resolver<ResolversTypes['notification_aggregate'], ParentType, ContextType, RequireFields<Query_RootNotification_AggregateArgs, never>>;
  notification_by_pk?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<Query_RootNotification_By_PkArgs, 'id'>>;
  onboarding?: Resolver<Array<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<Query_RootOnboardingArgs, never>>;
  onboarding_aggregate?: Resolver<ResolversTypes['onboarding_aggregate'], ParentType, ContextType, RequireFields<Query_RootOnboarding_AggregateArgs, never>>;
  onboarding_by_pk?: Resolver<Maybe<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<Query_RootOnboarding_By_PkArgs, 'id'>>;
  payment_card?: Resolver<Array<ResolversTypes['payment_card']>, ParentType, ContextType, RequireFields<Query_RootPayment_CardArgs, never>>;
  payment_card_aggregate?: Resolver<ResolversTypes['payment_card_aggregate'], ParentType, ContextType, RequireFields<Query_RootPayment_Card_AggregateArgs, never>>;
  payment_card_by_pk?: Resolver<Maybe<ResolversTypes['payment_card']>, ParentType, ContextType, RequireFields<Query_RootPayment_Card_By_PkArgs, 'id'>>;
  posting?: Resolver<Array<ResolversTypes['posting']>, ParentType, ContextType, RequireFields<Query_RootPostingArgs, never>>;
  posting_aggregate?: Resolver<ResolversTypes['posting_aggregate'], ParentType, ContextType, RequireFields<Query_RootPosting_AggregateArgs, never>>;
  posting_by_pk?: Resolver<Maybe<ResolversTypes['posting']>, ParentType, ContextType, RequireFields<Query_RootPosting_By_PkArgs, 'id'>>;
  posting_industry?: Resolver<Array<ResolversTypes['posting_industry']>, ParentType, ContextType, RequireFields<Query_RootPosting_IndustryArgs, never>>;
  posting_industry_aggregate?: Resolver<ResolversTypes['posting_industry_aggregate'], ParentType, ContextType, RequireFields<Query_RootPosting_Industry_AggregateArgs, never>>;
  posting_industry_by_pk?: Resolver<Maybe<ResolversTypes['posting_industry']>, ParentType, ContextType, RequireFields<Query_RootPosting_Industry_By_PkArgs, 'id'>>;
  posting_skill?: Resolver<Array<ResolversTypes['posting_skill']>, ParentType, ContextType, RequireFields<Query_RootPosting_SkillArgs, never>>;
  posting_skill_aggregate?: Resolver<ResolversTypes['posting_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootPosting_Skill_AggregateArgs, never>>;
  posting_skill_by_pk?: Resolver<Maybe<ResolversTypes['posting_skill']>, ParentType, ContextType, RequireFields<Query_RootPosting_Skill_By_PkArgs, 'id'>>;
  posting_tags?: Resolver<Array<ResolversTypes['posting_tags']>, ParentType, ContextType, RequireFields<Query_RootPosting_TagsArgs, never>>;
  posting_tags_aggregate?: Resolver<ResolversTypes['posting_tags_aggregate'], ParentType, ContextType, RequireFields<Query_RootPosting_Tags_AggregateArgs, never>>;
  posting_tags_by_pk?: Resolver<Maybe<ResolversTypes['posting_tags']>, ParentType, ContextType, RequireFields<Query_RootPosting_Tags_By_PkArgs, 'id'>>;
  project?: Resolver<Array<ResolversTypes['project']>, ParentType, ContextType, RequireFields<Query_RootProjectArgs, never>>;
  project_activity?: Resolver<Array<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<Query_RootProject_ActivityArgs, never>>;
  project_activity_aggregate?: Resolver<ResolversTypes['project_activity_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_AggregateArgs, never>>;
  project_activity_by_pk?: Resolver<Maybe<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_By_PkArgs, 'id'>>;
  project_activity_note?: Resolver<Array<ResolversTypes['project_activity_note']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_NoteArgs, never>>;
  project_activity_note_aggregate?: Resolver<ResolversTypes['project_activity_note_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_Note_AggregateArgs, never>>;
  project_activity_note_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_note']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Note_By_PkArgs, 'id'>>;
  project_activity_request_more_hours?: Resolver<Array<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Request_More_HoursArgs, never>>;
  project_activity_request_more_hours_aggregate?: Resolver<ResolversTypes['project_activity_request_more_hours_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_Request_More_Hours_AggregateArgs, never>>;
  project_activity_request_more_hours_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Request_More_Hours_By_PkArgs, 'id'>>;
  project_activity_skill?: Resolver<Array<ResolversTypes['project_activity_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_SkillArgs, never>>;
  project_activity_skill_aggregate?: Resolver<ResolversTypes['project_activity_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_Skill_AggregateArgs, never>>;
  project_activity_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Skill_By_PkArgs, 'id'>>;
  project_activity_soft_skill?: Resolver<Array<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Soft_SkillArgs, never>>;
  project_activity_soft_skill_aggregate?: Resolver<ResolversTypes['project_activity_soft_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_Soft_Skill_AggregateArgs, never>>;
  project_activity_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_soft_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Soft_Skill_By_PkArgs, 'id'>>;
  project_activity_tag?: Resolver<Array<ResolversTypes['project_activity_tag']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_TagArgs, never>>;
  project_activity_tag_aggregate?: Resolver<ResolversTypes['project_activity_tag_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_Tag_AggregateArgs, never>>;
  project_activity_tag_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_tag']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Tag_By_PkArgs, 'id'>>;
  project_activity_time?: Resolver<Array<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_TimeArgs, never>>;
  project_activity_time_aggregate?: Resolver<ResolversTypes['project_activity_time_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_Time_AggregateArgs, never>>;
  project_activity_time_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Time_By_PkArgs, 'id'>>;
  project_activity_tracked_time?: Resolver<Array<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Tracked_TimeArgs, never>>;
  project_activity_tracked_time_aggregate?: Resolver<ResolversTypes['project_activity_tracked_time_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Activity_Tracked_Time_AggregateArgs, never>>;
  project_activity_tracked_time_by_pk?: Resolver<Maybe<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<Query_RootProject_Activity_Tracked_Time_By_PkArgs, 'id'>>;
  project_aggregate?: Resolver<ResolversTypes['project_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_AggregateArgs, never>>;
  project_by_pk?: Resolver<Maybe<ResolversTypes['project']>, ParentType, ContextType, RequireFields<Query_RootProject_By_PkArgs, 'id'>>;
  project_skill?: Resolver<Array<ResolversTypes['project_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_SkillArgs, never>>;
  project_skill_aggregate?: Resolver<ResolversTypes['project_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Skill_AggregateArgs, never>>;
  project_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_Skill_By_PkArgs, 'id'>>;
  project_soft_skill?: Resolver<Array<ResolversTypes['project_soft_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_Soft_SkillArgs, never>>;
  project_soft_skill_aggregate?: Resolver<ResolversTypes['project_soft_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Soft_Skill_AggregateArgs, never>>;
  project_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['project_soft_skill']>, ParentType, ContextType, RequireFields<Query_RootProject_Soft_Skill_By_PkArgs, 'id'>>;
  project_tag?: Resolver<Array<ResolversTypes['project_tag']>, ParentType, ContextType, RequireFields<Query_RootProject_TagArgs, never>>;
  project_tag_aggregate?: Resolver<ResolversTypes['project_tag_aggregate'], ParentType, ContextType, RequireFields<Query_RootProject_Tag_AggregateArgs, never>>;
  project_tag_by_pk?: Resolver<Maybe<ResolversTypes['project_tag']>, ParentType, ContextType, RequireFields<Query_RootProject_Tag_By_PkArgs, 'id'>>;
  public_project_details?: Resolver<Array<ResolversTypes['public_project_details']>, ParentType, ContextType, RequireFields<Query_RootPublic_Project_DetailsArgs, never>>;
  public_project_details_aggregate?: Resolver<ResolversTypes['public_project_details_aggregate'], ParentType, ContextType, RequireFields<Query_RootPublic_Project_Details_AggregateArgs, never>>;
  recipient_message?: Resolver<Array<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<Query_RootRecipient_MessageArgs, never>>;
  recipient_message_aggregate?: Resolver<ResolversTypes['recipient_message_aggregate'], ParentType, ContextType, RequireFields<Query_RootRecipient_Message_AggregateArgs, never>>;
  recipient_message_by_pk?: Resolver<Maybe<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<Query_RootRecipient_Message_By_PkArgs, 'id'>>;
  resource_information_card?: Resolver<Array<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<Query_RootResource_Information_CardArgs, never>>;
  resource_information_card_aggregate?: Resolver<ResolversTypes['resource_information_card_aggregate'], ParentType, ContextType, RequireFields<Query_RootResource_Information_Card_AggregateArgs, never>>;
  resource_information_card_by_pk?: Resolver<Maybe<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<Query_RootResource_Information_Card_By_PkArgs, 'id'>>;
  search_industry?: Resolver<Array<ResolversTypes['industry']>, ParentType, ContextType, RequireFields<Query_RootSearch_IndustryArgs, 'args'>>;
  search_industry_aggregate?: Resolver<ResolversTypes['industry_aggregate'], ParentType, ContextType, RequireFields<Query_RootSearch_Industry_AggregateArgs, 'args'>>;
  search_skill?: Resolver<Array<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<Query_RootSearch_SkillArgs, 'args'>>;
  search_skill_aggregate?: Resolver<ResolversTypes['skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootSearch_Skill_AggregateArgs, 'args'>>;
  skill?: Resolver<Array<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<Query_RootSkillArgs, never>>;
  skill_aggregate?: Resolver<ResolversTypes['skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootSkill_AggregateArgs, never>>;
  skill_by_pk?: Resolver<Maybe<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<Query_RootSkill_By_PkArgs, 'id'>>;
  skills_short_name_first?: Resolver<Array<ResolversTypes['skills_short_name_first']>, ParentType, ContextType, RequireFields<Query_RootSkills_Short_Name_FirstArgs, never>>;
  skills_short_name_first_aggregate?: Resolver<ResolversTypes['skills_short_name_first_aggregate'], ParentType, ContextType, RequireFields<Query_RootSkills_Short_Name_First_AggregateArgs, never>>;
  smart_match_bookmark?: Resolver<Array<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_BookmarkArgs, never>>;
  smart_match_bookmark_aggregate?: Resolver<ResolversTypes['smart_match_bookmark_aggregate'], ParentType, ContextType, RequireFields<Query_RootSmart_Match_Bookmark_AggregateArgs, never>>;
  smart_match_bookmark_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_Bookmark_By_PkArgs, 'id'>>;
  smart_match_config_transportation?: Resolver<Array<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_Config_TransportationArgs, never>>;
  smart_match_config_transportation_aggregate?: Resolver<ResolversTypes['smart_match_config_transportation_aggregate'], ParentType, ContextType, RequireFields<Query_RootSmart_Match_Config_Transportation_AggregateArgs, never>>;
  smart_match_config_transportation_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_Config_Transportation_By_PkArgs, 'id'>>;
  smart_match_configs?: Resolver<Array<ResolversTypes['smart_match_configs']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_ConfigsArgs, never>>;
  smart_match_configs_aggregate?: Resolver<ResolversTypes['smart_match_configs_aggregate'], ParentType, ContextType, RequireFields<Query_RootSmart_Match_Configs_AggregateArgs, never>>;
  smart_match_configs_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_configs']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_Configs_By_PkArgs, 'id'>>;
  smart_match_criteria_order?: Resolver<Array<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_Criteria_OrderArgs, never>>;
  smart_match_criteria_order_aggregate?: Resolver<ResolversTypes['smart_match_criteria_order_aggregate'], ParentType, ContextType, RequireFields<Query_RootSmart_Match_Criteria_Order_AggregateArgs, never>>;
  smart_match_criteria_order_by_pk?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType, RequireFields<Query_RootSmart_Match_Criteria_Order_By_PkArgs, 'id'>>;
  soft_skill?: Resolver<Array<ResolversTypes['soft_skill']>, ParentType, ContextType, RequireFields<Query_RootSoft_SkillArgs, never>>;
  soft_skill_aggregate?: Resolver<ResolversTypes['soft_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootSoft_Skill_AggregateArgs, never>>;
  soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['soft_skill']>, ParentType, ContextType, RequireFields<Query_RootSoft_Skill_By_PkArgs, 'id'>>;
  source?: Resolver<Array<ResolversTypes['source']>, ParentType, ContextType, RequireFields<Query_RootSourceArgs, never>>;
  source_aggregate?: Resolver<ResolversTypes['source_aggregate'], ParentType, ContextType, RequireFields<Query_RootSource_AggregateArgs, never>>;
  source_by_pk?: Resolver<Maybe<ResolversTypes['source']>, ParentType, ContextType, RequireFields<Query_RootSource_By_PkArgs, 'id'>>;
  subscription?: Resolver<Array<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<Query_RootSubscriptionArgs, never>>;
  subscription_aggregate?: Resolver<ResolversTypes['subscription_aggregate'], ParentType, ContextType, RequireFields<Query_RootSubscription_AggregateArgs, never>>;
  subscription_by_pk?: Resolver<Maybe<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<Query_RootSubscription_By_PkArgs, 'id'>>;
  subscription_plan?: Resolver<Array<ResolversTypes['subscription_plan']>, ParentType, ContextType, RequireFields<Query_RootSubscription_PlanArgs, never>>;
  subscription_plan_access_permissions?: Resolver<Array<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType, RequireFields<Query_RootSubscription_Plan_Access_PermissionsArgs, never>>;
  subscription_plan_access_permissions_aggregate?: Resolver<ResolversTypes['subscription_plan_access_permissions_aggregate'], ParentType, ContextType, RequireFields<Query_RootSubscription_Plan_Access_Permissions_AggregateArgs, never>>;
  subscription_plan_access_permissions_by_pk?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType, RequireFields<Query_RootSubscription_Plan_Access_Permissions_By_PkArgs, 'id'>>;
  subscription_plan_aggregate?: Resolver<ResolversTypes['subscription_plan_aggregate'], ParentType, ContextType, RequireFields<Query_RootSubscription_Plan_AggregateArgs, never>>;
  subscription_plan_by_pk?: Resolver<Maybe<ResolversTypes['subscription_plan']>, ParentType, ContextType, RequireFields<Query_RootSubscription_Plan_By_PkArgs, 'id'>>;
  tag?: Resolver<Array<ResolversTypes['tag']>, ParentType, ContextType, RequireFields<Query_RootTagArgs, never>>;
  tag_aggregate?: Resolver<ResolversTypes['tag_aggregate'], ParentType, ContextType, RequireFields<Query_RootTag_AggregateArgs, never>>;
  tag_by_pk?: Resolver<Maybe<ResolversTypes['tag']>, ParentType, ContextType, RequireFields<Query_RootTag_By_PkArgs, 'id'>>;
  team?: Resolver<Array<ResolversTypes['team']>, ParentType, ContextType, RequireFields<Query_RootTeamArgs, never>>;
  team_aggregate?: Resolver<ResolversTypes['team_aggregate'], ParentType, ContextType, RequireFields<Query_RootTeam_AggregateArgs, never>>;
  team_by_pk?: Resolver<Maybe<ResolversTypes['team']>, ParentType, ContextType, RequireFields<Query_RootTeam_By_PkArgs, 'id'>>;
  team_contractor?: Resolver<Array<ResolversTypes['team_contractor']>, ParentType, ContextType, RequireFields<Query_RootTeam_ContractorArgs, never>>;
  team_contractor_aggregate?: Resolver<ResolversTypes['team_contractor_aggregate'], ParentType, ContextType, RequireFields<Query_RootTeam_Contractor_AggregateArgs, never>>;
  team_contractor_by_pk?: Resolver<Maybe<ResolversTypes['team_contractor']>, ParentType, ContextType, RequireFields<Query_RootTeam_Contractor_By_PkArgs, 'id'>>;
  team_manager?: Resolver<Array<ResolversTypes['team_manager']>, ParentType, ContextType, RequireFields<Query_RootTeam_ManagerArgs, never>>;
  team_manager_aggregate?: Resolver<ResolversTypes['team_manager_aggregate'], ParentType, ContextType, RequireFields<Query_RootTeam_Manager_AggregateArgs, never>>;
  team_manager_by_pk?: Resolver<Maybe<ResolversTypes['team_manager']>, ParentType, ContextType, RequireFields<Query_RootTeam_Manager_By_PkArgs, 'id'>>;
  team_posting?: Resolver<Array<ResolversTypes['team_posting']>, ParentType, ContextType, RequireFields<Query_RootTeam_PostingArgs, never>>;
  team_posting_aggregate?: Resolver<ResolversTypes['team_posting_aggregate'], ParentType, ContextType, RequireFields<Query_RootTeam_Posting_AggregateArgs, never>>;
  team_posting_by_pk?: Resolver<Maybe<ResolversTypes['team_posting']>, ParentType, ContextType, RequireFields<Query_RootTeam_Posting_By_PkArgs, 'id'>>;
  team_project?: Resolver<Array<ResolversTypes['team_project']>, ParentType, ContextType, RequireFields<Query_RootTeam_ProjectArgs, never>>;
  team_project_aggregate?: Resolver<ResolversTypes['team_project_aggregate'], ParentType, ContextType, RequireFields<Query_RootTeam_Project_AggregateArgs, never>>;
  team_project_by_pk?: Resolver<Maybe<ResolversTypes['team_project']>, ParentType, ContextType, RequireFields<Query_RootTeam_Project_By_PkArgs, 'id'>>;
  team_skill?: Resolver<Array<ResolversTypes['team_skill']>, ParentType, ContextType, RequireFields<Query_RootTeam_SkillArgs, never>>;
  team_skill_aggregate?: Resolver<ResolversTypes['team_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootTeam_Skill_AggregateArgs, never>>;
  team_skill_by_pk?: Resolver<Maybe<ResolversTypes['team_skill']>, ParentType, ContextType, RequireFields<Query_RootTeam_Skill_By_PkArgs, 'id'>>;
  timesheet?: Resolver<Array<ResolversTypes['timesheet']>, ParentType, ContextType, RequireFields<Query_RootTimesheetArgs, never>>;
  timesheet_aggregate?: Resolver<ResolversTypes['timesheet_aggregate'], ParentType, ContextType, RequireFields<Query_RootTimesheet_AggregateArgs, never>>;
  timesheet_by_pk?: Resolver<Maybe<ResolversTypes['timesheet']>, ParentType, ContextType, RequireFields<Query_RootTimesheet_By_PkArgs, 'id'>>;
  type_of_visit?: Resolver<Array<ResolversTypes['type_of_visit']>, ParentType, ContextType, RequireFields<Query_RootType_Of_VisitArgs, never>>;
  type_of_visit_aggregate?: Resolver<ResolversTypes['type_of_visit_aggregate'], ParentType, ContextType, RequireFields<Query_RootType_Of_Visit_AggregateArgs, never>>;
  type_of_visit_by_pk?: Resolver<Maybe<ResolversTypes['type_of_visit']>, ParentType, ContextType, RequireFields<Query_RootType_Of_Visit_By_PkArgs, 'value'>>;
  unread_messages?: Resolver<Array<ResolversTypes['unread_messages']>, ParentType, ContextType, RequireFields<Query_RootUnread_MessagesArgs, never>>;
  unread_messages_aggregate?: Resolver<ResolversTypes['unread_messages_aggregate'], ParentType, ContextType, RequireFields<Query_RootUnread_Messages_AggregateArgs, never>>;
  user?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType, RequireFields<Query_RootUserArgs, never>>;
  user_affinda_profile?: Resolver<Array<ResolversTypes['user_affinda_profile']>, ParentType, ContextType, RequireFields<Query_RootUser_Affinda_ProfileArgs, never>>;
  user_affinda_profile_aggregate?: Resolver<ResolversTypes['user_affinda_profile_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Affinda_Profile_AggregateArgs, never>>;
  user_affinda_profile_by_pk?: Resolver<Maybe<ResolversTypes['user_affinda_profile']>, ParentType, ContextType, RequireFields<Query_RootUser_Affinda_Profile_By_PkArgs, 'document_id'>>;
  user_aggregate?: Resolver<ResolversTypes['user_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_AggregateArgs, never>>;
  user_by_pk?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<Query_RootUser_By_PkArgs, 'id'>>;
  user_certification?: Resolver<Array<ResolversTypes['user_certification']>, ParentType, ContextType, RequireFields<Query_RootUser_CertificationArgs, never>>;
  user_certification_aggregate?: Resolver<ResolversTypes['user_certification_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Certification_AggregateArgs, never>>;
  user_certification_by_pk?: Resolver<Maybe<ResolversTypes['user_certification']>, ParentType, ContextType, RequireFields<Query_RootUser_Certification_By_PkArgs, 'id'>>;
  user_company?: Resolver<Array<ResolversTypes['user_company']>, ParentType, ContextType, RequireFields<Query_RootUser_CompanyArgs, never>>;
  user_company_aggregate?: Resolver<ResolversTypes['user_company_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Company_AggregateArgs, never>>;
  user_company_by_pk?: Resolver<Maybe<ResolversTypes['user_company']>, ParentType, ContextType, RequireFields<Query_RootUser_Company_By_PkArgs, 'id'>>;
  user_conversation?: Resolver<Array<ResolversTypes['user_conversation']>, ParentType, ContextType, RequireFields<Query_RootUser_ConversationArgs, never>>;
  user_conversation_aggregate?: Resolver<ResolversTypes['user_conversation_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Conversation_AggregateArgs, never>>;
  user_conversation_by_pk?: Resolver<Maybe<ResolversTypes['user_conversation']>, ParentType, ContextType, RequireFields<Query_RootUser_Conversation_By_PkArgs, 'id'>>;
  user_education?: Resolver<Array<ResolversTypes['user_education']>, ParentType, ContextType, RequireFields<Query_RootUser_EducationArgs, never>>;
  user_education_aggregate?: Resolver<ResolversTypes['user_education_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Education_AggregateArgs, never>>;
  user_education_by_pk?: Resolver<Maybe<ResolversTypes['user_education']>, ParentType, ContextType, RequireFields<Query_RootUser_Education_By_PkArgs, 'id'>>;
  user_experience?: Resolver<Array<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<Query_RootUser_ExperienceArgs, never>>;
  user_experience_aggregate?: Resolver<ResolversTypes['user_experience_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Experience_AggregateArgs, never>>;
  user_experience_by_pk?: Resolver<Maybe<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<Query_RootUser_Experience_By_PkArgs, 'id'>>;
  user_favorite?: Resolver<Array<ResolversTypes['user_favorite']>, ParentType, ContextType, RequireFields<Query_RootUser_FavoriteArgs, never>>;
  user_favorite_aggregate?: Resolver<ResolversTypes['user_favorite_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Favorite_AggregateArgs, never>>;
  user_favorite_by_pk?: Resolver<Maybe<ResolversTypes['user_favorite']>, ParentType, ContextType, RequireFields<Query_RootUser_Favorite_By_PkArgs, 'id'>>;
  user_industry?: Resolver<Array<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<Query_RootUser_IndustryArgs, never>>;
  user_industry_aggregate?: Resolver<ResolversTypes['user_industry_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Industry_AggregateArgs, never>>;
  user_industry_by_pk?: Resolver<Maybe<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<Query_RootUser_Industry_By_PkArgs, 'id'>>;
  user_job_title?: Resolver<Array<ResolversTypes['user_job_title']>, ParentType, ContextType, RequireFields<Query_RootUser_Job_TitleArgs, never>>;
  user_job_title_aggregate?: Resolver<ResolversTypes['user_job_title_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Job_Title_AggregateArgs, never>>;
  user_job_title_by_pk?: Resolver<Maybe<ResolversTypes['user_job_title']>, ParentType, ContextType, RequireFields<Query_RootUser_Job_Title_By_PkArgs, 'id'>>;
  user_language?: Resolver<Array<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<Query_RootUser_LanguageArgs, never>>;
  user_language_aggregate?: Resolver<ResolversTypes['user_language_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Language_AggregateArgs, never>>;
  user_language_by_pk?: Resolver<Maybe<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<Query_RootUser_Language_By_PkArgs, 'id'>>;
  user_private_data?: Resolver<Array<ResolversTypes['user_private_data']>, ParentType, ContextType, RequireFields<Query_RootUser_Private_DataArgs, never>>;
  user_private_data_aggregate?: Resolver<ResolversTypes['user_private_data_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Private_Data_AggregateArgs, never>>;
  user_profile?: Resolver<Array<ResolversTypes['user_profile']>, ParentType, ContextType, RequireFields<Query_RootUser_ProfileArgs, never>>;
  user_profile_aggregate?: Resolver<ResolversTypes['user_profile_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Profile_AggregateArgs, never>>;
  user_profile_by_management?: Resolver<Array<ResolversTypes['user_profile_by_management']>, ParentType, ContextType, RequireFields<Query_RootUser_Profile_By_ManagementArgs, never>>;
  user_profile_by_management_aggregate?: Resolver<ResolversTypes['user_profile_by_management_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Profile_By_Management_AggregateArgs, never>>;
  user_profile_by_management_by_pk?: Resolver<Maybe<ResolversTypes['user_profile_by_management']>, ParentType, ContextType, RequireFields<Query_RootUser_Profile_By_Management_By_PkArgs, 'added_by_id' | 'user_id'>>;
  user_profile_by_pk?: Resolver<Maybe<ResolversTypes['user_profile']>, ParentType, ContextType, RequireFields<Query_RootUser_Profile_By_PkArgs, 'user_id'>>;
  user_rating?: Resolver<Array<ResolversTypes['user_rating']>, ParentType, ContextType, RequireFields<Query_RootUser_RatingArgs, never>>;
  user_rating_aggregate?: Resolver<ResolversTypes['user_rating_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Rating_AggregateArgs, never>>;
  user_rating_by_pk?: Resolver<Maybe<ResolversTypes['user_rating']>, ParentType, ContextType, RequireFields<Query_RootUser_Rating_By_PkArgs, 'id'>>;
  user_skill?: Resolver<Array<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<Query_RootUser_SkillArgs, never>>;
  user_skill_aggregate?: Resolver<ResolversTypes['user_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Skill_AggregateArgs, never>>;
  user_skill_by_pk?: Resolver<Maybe<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<Query_RootUser_Skill_By_PkArgs, 'id'>>;
  user_soft_skill?: Resolver<Array<ResolversTypes['user_soft_skill']>, ParentType, ContextType, RequireFields<Query_RootUser_Soft_SkillArgs, never>>;
  user_soft_skill_aggregate?: Resolver<ResolversTypes['user_soft_skill_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Soft_Skill_AggregateArgs, never>>;
  user_soft_skill_by_pk?: Resolver<Maybe<ResolversTypes['user_soft_skill']>, ParentType, ContextType, RequireFields<Query_RootUser_Soft_Skill_By_PkArgs, 'id'>>;
  user_transportation?: Resolver<Array<ResolversTypes['user_transportation']>, ParentType, ContextType, RequireFields<Query_RootUser_TransportationArgs, never>>;
  user_transportation_aggregate?: Resolver<ResolversTypes['user_transportation_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Transportation_AggregateArgs, never>>;
  user_transportation_by_pk?: Resolver<Maybe<ResolversTypes['user_transportation']>, ParentType, ContextType, RequireFields<Query_RootUser_Transportation_By_PkArgs, 'id'>>;
  user_watchlist?: Resolver<Array<ResolversTypes['user_watchlist']>, ParentType, ContextType, RequireFields<Query_RootUser_WatchlistArgs, never>>;
  user_watchlist_aggregate?: Resolver<ResolversTypes['user_watchlist_aggregate'], ParentType, ContextType, RequireFields<Query_RootUser_Watchlist_AggregateArgs, never>>;
  user_watchlist_by_pk?: Resolver<Maybe<ResolversTypes['user_watchlist']>, ParentType, ContextType, RequireFields<Query_RootUser_Watchlist_By_PkArgs, 'id'>>;
};

export type Recipient_MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['recipient_message'] = ResolversParentTypes['recipient_message']> = {
  conversation?: Resolver<ResolversTypes['conversation'], ParentType, ContextType>;
  conversation_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['message'], ParentType, ContextType>;
  message_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  notified_by_email?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notified_in_app?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  recipient_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Recipient_Message_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['recipient_message_aggregate'] = ResolversParentTypes['recipient_message_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['recipient_message_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['recipient_message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Recipient_Message_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['recipient_message_aggregate_fields'] = ResolversParentTypes['recipient_message_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Recipient_Message_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['recipient_message_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['recipient_message_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Recipient_Message_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['recipient_message_max_fields'] = ResolversParentTypes['recipient_message_max_fields']> = {
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  message_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  recipient_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Recipient_Message_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['recipient_message_min_fields'] = ResolversParentTypes['recipient_message_min_fields']> = {
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  message_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  recipient_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Recipient_Message_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['recipient_message_mutation_response'] = ResolversParentTypes['recipient_message_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['recipient_message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_CardResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card'] = ResolversParentTypes['resource_information_card']> = {
  availability?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contractor?: Resolver<Maybe<ResolversTypes['contractor']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['source']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['tag']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_aggregate'] = ResolversParentTypes['resource_information_card_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['resource_information_card_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['resource_information_card']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_aggregate_fields'] = ResolversParentTypes['resource_information_card_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['resource_information_card_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Resource_Information_Card_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['resource_information_card_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['resource_information_card_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['resource_information_card_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['resource_information_card_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['resource_information_card_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['resource_information_card_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['resource_information_card_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['resource_information_card_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['resource_information_card_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_avg_fields'] = ResolversParentTypes['resource_information_card_avg_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_max_fields'] = ResolversParentTypes['resource_information_card_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_min_fields'] = ResolversParentTypes['resource_information_card_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  from_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profile_link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  source_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  tag_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  to_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_mutation_response'] = ResolversParentTypes['resource_information_card_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['resource_information_card']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_stddev_fields'] = ResolversParentTypes['resource_information_card_stddev_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_stddev_pop_fields'] = ResolversParentTypes['resource_information_card_stddev_pop_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_stddev_samp_fields'] = ResolversParentTypes['resource_information_card_stddev_samp_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_sum_fields'] = ResolversParentTypes['resource_information_card_sum_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_var_pop_fields'] = ResolversParentTypes['resource_information_card_var_pop_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_var_samp_fields'] = ResolversParentTypes['resource_information_card_var_samp_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resource_Information_Card_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['resource_information_card_variance_fields'] = ResolversParentTypes['resource_information_card_variance_fields']> = {
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill'] = ResolversParentTypes['skill']> = {
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  custom_request_skills?: Resolver<Array<ResolversTypes['custom_request_skills']>, ParentType, ContextType, RequireFields<SkillCustom_Request_SkillsArgs, never>>;
  custom_request_skills_aggregate?: Resolver<ResolversTypes['custom_request_skills_aggregate'], ParentType, ContextType, RequireFields<SkillCustom_Request_Skills_AggregateArgs, never>>;
  experiences?: Resolver<Array<ResolversTypes['experience_skill']>, ParentType, ContextType, RequireFields<SkillExperiencesArgs, never>>;
  experiences_aggregate?: Resolver<ResolversTypes['experience_skill_aggregate'], ParentType, ContextType, RequireFields<SkillExperiences_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postings?: Resolver<Array<ResolversTypes['posting_skill']>, ParentType, ContextType, RequireFields<SkillPostingsArgs, never>>;
  postings_aggregate?: Resolver<ResolversTypes['posting_skill_aggregate'], ParentType, ContextType, RequireFields<SkillPostings_AggregateArgs, never>>;
  project_activity_skills?: Resolver<Array<ResolversTypes['project_activity_skill']>, ParentType, ContextType, RequireFields<SkillProject_Activity_SkillsArgs, never>>;
  project_activity_skills_aggregate?: Resolver<ResolversTypes['project_activity_skill_aggregate'], ParentType, ContextType, RequireFields<SkillProject_Activity_Skills_AggregateArgs, never>>;
  project_skills?: Resolver<Array<ResolversTypes['project_skill']>, ParentType, ContextType, RequireFields<SkillProject_SkillsArgs, never>>;
  project_skills_aggregate?: Resolver<ResolversTypes['project_skill_aggregate'], ParentType, ContextType, RequireFields<SkillProject_Skills_AggregateArgs, never>>;
  teams?: Resolver<Array<ResolversTypes['team_skill']>, ParentType, ContextType, RequireFields<SkillTeamsArgs, never>>;
  teams_aggregate?: Resolver<ResolversTypes['team_skill_aggregate'], ParentType, ContextType, RequireFields<SkillTeams_AggregateArgs, never>>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<SkillUsersArgs, never>>;
  users_aggregate?: Resolver<ResolversTypes['user_skill_aggregate'], ParentType, ContextType, RequireFields<SkillUsers_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_aggregate'] = ResolversParentTypes['skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_aggregate_fields'] = ResolversParentTypes['skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_avg_fields'] = ResolversParentTypes['skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_max_fields'] = ResolversParentTypes['skill_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_min_fields'] = ResolversParentTypes['skill_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_mutation_response'] = ResolversParentTypes['skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_stddev_fields'] = ResolversParentTypes['skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_stddev_pop_fields'] = ResolversParentTypes['skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_stddev_samp_fields'] = ResolversParentTypes['skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_sum_fields'] = ResolversParentTypes['skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_var_pop_fields'] = ResolversParentTypes['skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_var_samp_fields'] = ResolversParentTypes['skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skill_variance_fields'] = ResolversParentTypes['skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_FirstResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first'] = ResolversParentTypes['skills_short_name_first']> = {
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_aggregate'] = ResolversParentTypes['skills_short_name_first_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['skills_short_name_first_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['skills_short_name_first']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_aggregate_fields'] = ResolversParentTypes['skills_short_name_first_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['skills_short_name_first_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Skills_Short_Name_First_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['skills_short_name_first_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['skills_short_name_first_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['skills_short_name_first_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['skills_short_name_first_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['skills_short_name_first_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['skills_short_name_first_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['skills_short_name_first_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['skills_short_name_first_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['skills_short_name_first_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_avg_fields'] = ResolversParentTypes['skills_short_name_first_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_max_fields'] = ResolversParentTypes['skills_short_name_first_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_min_fields'] = ResolversParentTypes['skills_short_name_first_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_mutation_response'] = ResolversParentTypes['skills_short_name_first_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['skills_short_name_first']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_stddev_fields'] = ResolversParentTypes['skills_short_name_first_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_stddev_pop_fields'] = ResolversParentTypes['skills_short_name_first_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_stddev_samp_fields'] = ResolversParentTypes['skills_short_name_first_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_sum_fields'] = ResolversParentTypes['skills_short_name_first_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_var_pop_fields'] = ResolversParentTypes['skills_short_name_first_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_var_samp_fields'] = ResolversParentTypes['skills_short_name_first_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Skills_Short_Name_First_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['skills_short_name_first_variance_fields'] = ResolversParentTypes['skills_short_name_first_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_BookmarkResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark'] = ResolversParentTypes['smart_match_bookmark']> = {
  admin?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType>;
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  bookmarked_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  declined_visit_matches?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<Smart_Match_BookmarkDeclined_Visit_MatchesArgs, never>>;
  declined_visit_matches_aggregate?: Resolver<ResolversTypes['declined_visit_matches_aggregate'], ParentType, ContextType, RequireFields<Smart_Match_BookmarkDeclined_Visit_Matches_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  match_percentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_aggregate'] = ResolversParentTypes['smart_match_bookmark_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_aggregate_fields'] = ResolversParentTypes['smart_match_bookmark_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Smart_Match_Bookmark_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smart_match_bookmark_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_avg_fields'] = ResolversParentTypes['smart_match_bookmark_avg_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_max_fields'] = ResolversParentTypes['smart_match_bookmark_max_fields']> = {
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  bookmarked_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  match_percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_min_fields'] = ResolversParentTypes['smart_match_bookmark_min_fields']> = {
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  bookmarked_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  match_percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_mutation_response'] = ResolversParentTypes['smart_match_bookmark_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_stddev_fields'] = ResolversParentTypes['smart_match_bookmark_stddev_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_stddev_pop_fields'] = ResolversParentTypes['smart_match_bookmark_stddev_pop_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_stddev_samp_fields'] = ResolversParentTypes['smart_match_bookmark_stddev_samp_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_sum_fields'] = ResolversParentTypes['smart_match_bookmark_sum_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_var_pop_fields'] = ResolversParentTypes['smart_match_bookmark_var_pop_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_var_samp_fields'] = ResolversParentTypes['smart_match_bookmark_var_samp_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Bookmark_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_bookmark_variance_fields'] = ResolversParentTypes['smart_match_bookmark_variance_fields']> = {
  match_percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Config_TransportationResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_config_transportation'] = ResolversParentTypes['smart_match_config_transportation']> = {
  config_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  smart_match_config?: Resolver<ResolversTypes['smart_match_configs'], ParentType, ContextType>;
  transportation_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Config_Transportation_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_config_transportation_aggregate'] = ResolversParentTypes['smart_match_config_transportation_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Config_Transportation_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_config_transportation_aggregate_fields'] = ResolversParentTypes['smart_match_config_transportation_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Smart_Match_Config_Transportation_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smart_match_config_transportation_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Config_Transportation_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_config_transportation_max_fields'] = ResolversParentTypes['smart_match_config_transportation_max_fields']> = {
  config_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  transportation_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Config_Transportation_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_config_transportation_min_fields'] = ResolversParentTypes['smart_match_config_transportation_min_fields']> = {
  config_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  transportation_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Config_Transportation_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_config_transportation_mutation_response'] = ResolversParentTypes['smart_match_config_transportation_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_ConfigsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs'] = ResolversParentTypes['smart_match_configs']> = {
  admin?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType>;
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  availability_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  exclude_do_not_use_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  favourited_resource_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hours_available_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hours_available_min?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  location_radius_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  location_radius_unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location_radius_value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  preferred_language_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previous_engagements_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  previous_engagements_min?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rating_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rating_min_stars?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  required_skills_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  smart_match_config_transportations?: Resolver<Array<ResolversTypes['smart_match_config_transportation']>, ParentType, ContextType, RequireFields<Smart_Match_ConfigsSmart_Match_Config_TransportationsArgs, never>>;
  smart_match_config_transportations_aggregate?: Resolver<ResolversTypes['smart_match_config_transportation_aggregate'], ParentType, ContextType, RequireFields<Smart_Match_ConfigsSmart_Match_Config_Transportations_AggregateArgs, never>>;
  smart_match_criteria_orders?: Resolver<Array<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType, RequireFields<Smart_Match_ConfigsSmart_Match_Criteria_OrdersArgs, never>>;
  smart_match_criteria_orders_aggregate?: Resolver<ResolversTypes['smart_match_criteria_order_aggregate'], ParentType, ContextType, RequireFields<Smart_Match_ConfigsSmart_Match_Criteria_Orders_AggregateArgs, never>>;
  smart_match_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  soft_skills_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title_type_match_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transportation_enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_aggregate'] = ResolversParentTypes['smart_match_configs_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smart_match_configs_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smart_match_configs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_aggregate_fields'] = ResolversParentTypes['smart_match_configs_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smart_match_configs_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Smart_Match_Configs_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['smart_match_configs_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smart_match_configs_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smart_match_configs_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['smart_match_configs_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['smart_match_configs_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smart_match_configs_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['smart_match_configs_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['smart_match_configs_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smart_match_configs_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_avg_fields'] = ResolversParentTypes['smart_match_configs_avg_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_max_fields'] = ResolversParentTypes['smart_match_configs_max_fields']> = {
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  hours_available_min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  location_radius_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_min_fields'] = ResolversParentTypes['smart_match_configs_min_fields']> = {
  admin_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  hours_available_min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  location_radius_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_mutation_response'] = ResolversParentTypes['smart_match_configs_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smart_match_configs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_stddev_fields'] = ResolversParentTypes['smart_match_configs_stddev_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_stddev_pop_fields'] = ResolversParentTypes['smart_match_configs_stddev_pop_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_stddev_samp_fields'] = ResolversParentTypes['smart_match_configs_stddev_samp_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_sum_fields'] = ResolversParentTypes['smart_match_configs_sum_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_var_pop_fields'] = ResolversParentTypes['smart_match_configs_var_pop_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_var_samp_fields'] = ResolversParentTypes['smart_match_configs_var_samp_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Configs_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_configs_variance_fields'] = ResolversParentTypes['smart_match_configs_variance_fields']> = {
  hours_available_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location_radius_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preferred_language_proficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previous_engagements_min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_min_stars?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_OrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order'] = ResolversParentTypes['smart_match_criteria_order']> = {
  config_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  criterion_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  smart_match_config?: Resolver<ResolversTypes['smart_match_configs'], ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_aggregate'] = ResolversParentTypes['smart_match_criteria_order_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_aggregate_fields'] = ResolversParentTypes['smart_match_criteria_order_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Smart_Match_Criteria_Order_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smart_match_criteria_order_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_avg_fields'] = ResolversParentTypes['smart_match_criteria_order_avg_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_max_fields'] = ResolversParentTypes['smart_match_criteria_order_max_fields']> = {
  config_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  criterion_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_min_fields'] = ResolversParentTypes['smart_match_criteria_order_min_fields']> = {
  config_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  criterion_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_mutation_response'] = ResolversParentTypes['smart_match_criteria_order_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smart_match_criteria_order']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_stddev_fields'] = ResolversParentTypes['smart_match_criteria_order_stddev_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_stddev_pop_fields'] = ResolversParentTypes['smart_match_criteria_order_stddev_pop_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_stddev_samp_fields'] = ResolversParentTypes['smart_match_criteria_order_stddev_samp_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_sum_fields'] = ResolversParentTypes['smart_match_criteria_order_sum_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_var_pop_fields'] = ResolversParentTypes['smart_match_criteria_order_var_pop_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_var_samp_fields'] = ResolversParentTypes['smart_match_criteria_order_var_samp_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Smart_Match_Criteria_Order_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smart_match_criteria_order_variance_fields'] = ResolversParentTypes['smart_match_criteria_order_variance_fields']> = {
  sort_order?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill'] = ResolversParentTypes['soft_skill']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_aggregate'] = ResolversParentTypes['soft_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['soft_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_aggregate_fields'] = ResolversParentTypes['soft_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['soft_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Soft_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['soft_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['soft_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['soft_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['soft_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['soft_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['soft_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['soft_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['soft_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['soft_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_avg_fields'] = ResolversParentTypes['soft_skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_max_fields'] = ResolversParentTypes['soft_skill_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_min_fields'] = ResolversParentTypes['soft_skill_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_mutation_response'] = ResolversParentTypes['soft_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_stddev_fields'] = ResolversParentTypes['soft_skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_stddev_pop_fields'] = ResolversParentTypes['soft_skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_stddev_samp_fields'] = ResolversParentTypes['soft_skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_sum_fields'] = ResolversParentTypes['soft_skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_var_pop_fields'] = ResolversParentTypes['soft_skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_var_samp_fields'] = ResolversParentTypes['soft_skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Soft_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['soft_skill_variance_fields'] = ResolversParentTypes['soft_skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['source'] = ResolversParentTypes['source']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resource_information_cards?: Resolver<Array<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<SourceResource_Information_CardsArgs, never>>;
  resource_information_cards_aggregate?: Resolver<ResolversTypes['resource_information_card_aggregate'], ParentType, ContextType, RequireFields<SourceResource_Information_Cards_AggregateArgs, never>>;
  source_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Source_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['source_aggregate'] = ResolversParentTypes['source_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['source_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['source']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Source_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['source_aggregate_fields'] = ResolversParentTypes['source_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Source_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['source_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['source_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Source_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['source_max_fields'] = ResolversParentTypes['source_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Source_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['source_min_fields'] = ResolversParentTypes['source_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Source_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['source_mutation_response'] = ResolversParentTypes['source_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['source']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription'] = ResolversParentTypes['subscription']> = {
  cancel_at_period_end?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canceled_by_user?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  current_period_end?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  payment_card?: Resolver<Maybe<ResolversTypes['payment_card']>, ParentType, ContextType>;
  payment_card_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripe_subscription_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_subscription_item_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscription_plan?: Resolver<ResolversTypes['subscription_plan'], ParentType, ContextType>;
  subscription_plan_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_aggregate'] = ResolversParentTypes['subscription_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['subscription_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['subscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_aggregate_fields'] = ResolversParentTypes['subscription_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['subscription_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Subscription_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['subscription_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['subscription_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['subscription_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['subscription_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['subscription_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['subscription_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['subscription_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['subscription_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['subscription_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_avg_fields'] = ResolversParentTypes['subscription_avg_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_max_fields'] = ResolversParentTypes['subscription_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  current_period_end?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  payment_card_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_subscription_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_subscription_item_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscription_plan_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_min_fields'] = ResolversParentTypes['subscription_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  current_period_end?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  payment_card_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_subscription_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_subscription_item_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscription_plan_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_mutation_response'] = ResolversParentTypes['subscription_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['subscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_PlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan'] = ResolversParentTypes['subscription_plan']> = {
  access_permissions_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  inner_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_price_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_product_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscription_plan_access_permission?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType>;
  subscriptions?: Resolver<Array<ResolversTypes['subscription']>, ParentType, ContextType, RequireFields<Subscription_PlanSubscriptionsArgs, never>>;
  subscriptions_aggregate?: Resolver<ResolversTypes['subscription_aggregate'], ParentType, ContextType, RequireFields<Subscription_PlanSubscriptions_AggregateArgs, never>>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_PermissionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions'] = ResolversParentTypes['subscription_plan_access_permissions']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  managers_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscription_plans?: Resolver<Array<ResolversTypes['subscription_plan']>, ParentType, ContextType, RequireFields<Subscription_Plan_Access_PermissionsSubscription_PlansArgs, never>>;
  subscription_plans_aggregate?: Resolver<ResolversTypes['subscription_plan_aggregate'], ParentType, ContextType, RequireFields<Subscription_Plan_Access_PermissionsSubscription_Plans_AggregateArgs, never>>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_aggregate'] = ResolversParentTypes['subscription_plan_access_permissions_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_aggregate_fields'] = ResolversParentTypes['subscription_plan_access_permissions_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Subscription_Plan_Access_Permissions_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['subscription_plan_access_permissions_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_avg_fields'] = ResolversParentTypes['subscription_plan_access_permissions_avg_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_max_fields'] = ResolversParentTypes['subscription_plan_access_permissions_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  managers_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_min_fields'] = ResolversParentTypes['subscription_plan_access_permissions_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  managers_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_mutation_response'] = ResolversParentTypes['subscription_plan_access_permissions_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['subscription_plan_access_permissions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_stddev_fields'] = ResolversParentTypes['subscription_plan_access_permissions_stddev_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_stddev_pop_fields'] = ResolversParentTypes['subscription_plan_access_permissions_stddev_pop_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_stddev_samp_fields'] = ResolversParentTypes['subscription_plan_access_permissions_stddev_samp_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_sum_fields'] = ResolversParentTypes['subscription_plan_access_permissions_sum_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_var_pop_fields'] = ResolversParentTypes['subscription_plan_access_permissions_var_pop_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_var_samp_fields'] = ResolversParentTypes['subscription_plan_access_permissions_var_samp_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Access_Permissions_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_access_permissions_variance_fields'] = ResolversParentTypes['subscription_plan_access_permissions_variance_fields']> = {
  managers_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_aggregate'] = ResolversParentTypes['subscription_plan_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['subscription_plan_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['subscription_plan']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_aggregate_fields'] = ResolversParentTypes['subscription_plan_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Subscription_Plan_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['subscription_plan_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['subscription_plan_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_max_fields'] = ResolversParentTypes['subscription_plan_max_fields']> = {
  access_permissions_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  inner_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_price_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_product_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_min_fields'] = ResolversParentTypes['subscription_plan_min_fields']> = {
  access_permissions_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  inner_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_price_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_product_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Plan_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_plan_mutation_response'] = ResolversParentTypes['subscription_plan_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['subscription_plan']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_root'] = ResolversParentTypes['subscription_root']> = {
  admin?: SubscriptionResolver<Array<ResolversTypes['admin']>, "admin", ParentType, ContextType, RequireFields<Subscription_RootAdminArgs, never>>;
  admin_aggregate?: SubscriptionResolver<ResolversTypes['admin_aggregate'], "admin_aggregate", ParentType, ContextType, RequireFields<Subscription_RootAdmin_AggregateArgs, never>>;
  admin_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['admin']>, "admin_by_pk", ParentType, ContextType, RequireFields<Subscription_RootAdmin_By_PkArgs, 'id'>>;
  admin_stream?: SubscriptionResolver<Array<ResolversTypes['admin']>, "admin_stream", ParentType, ContextType, RequireFields<Subscription_RootAdmin_StreamArgs, 'batch_size' | 'cursor'>>;
  application?: SubscriptionResolver<Array<ResolversTypes['application']>, "application", ParentType, ContextType, RequireFields<Subscription_RootApplicationArgs, never>>;
  application_aggregate?: SubscriptionResolver<ResolversTypes['application_aggregate'], "application_aggregate", ParentType, ContextType, RequireFields<Subscription_RootApplication_AggregateArgs, never>>;
  application_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['application']>, "application_by_pk", ParentType, ContextType, RequireFields<Subscription_RootApplication_By_PkArgs, 'id'>>;
  application_stream?: SubscriptionResolver<Array<ResolversTypes['application']>, "application_stream", ParentType, ContextType, RequireFields<Subscription_RootApplication_StreamArgs, 'batch_size' | 'cursor'>>;
  candidate?: SubscriptionResolver<Array<ResolversTypes['candidate']>, "candidate", ParentType, ContextType, RequireFields<Subscription_RootCandidateArgs, never>>;
  candidate_aggregate?: SubscriptionResolver<ResolversTypes['candidate_aggregate'], "candidate_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCandidate_AggregateArgs, never>>;
  candidate_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['candidate']>, "candidate_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCandidate_By_PkArgs, 'id'>>;
  candidate_stream?: SubscriptionResolver<Array<ResolversTypes['candidate']>, "candidate_stream", ParentType, ContextType, RequireFields<Subscription_RootCandidate_StreamArgs, 'batch_size' | 'cursor'>>;
  chart_admin_contractors?: SubscriptionResolver<Array<ResolversTypes['chart_admin_contractors']>, "chart_admin_contractors", ParentType, ContextType, RequireFields<Subscription_RootChart_Admin_ContractorsArgs, never>>;
  chart_admin_contractors_aggregate?: SubscriptionResolver<ResolversTypes['chart_admin_contractors_aggregate'], "chart_admin_contractors_aggregate", ParentType, ContextType, RequireFields<Subscription_RootChart_Admin_Contractors_AggregateArgs, never>>;
  chart_admin_contractors_stream?: SubscriptionResolver<Array<ResolversTypes['chart_admin_contractors']>, "chart_admin_contractors_stream", ParentType, ContextType, RequireFields<Subscription_RootChart_Admin_Contractors_StreamArgs, 'batch_size' | 'cursor'>>;
  chart_manager_contractors?: SubscriptionResolver<Array<ResolversTypes['chart_manager_contractors']>, "chart_manager_contractors", ParentType, ContextType, RequireFields<Subscription_RootChart_Manager_ContractorsArgs, never>>;
  chart_manager_contractors_aggregate?: SubscriptionResolver<ResolversTypes['chart_manager_contractors_aggregate'], "chart_manager_contractors_aggregate", ParentType, ContextType, RequireFields<Subscription_RootChart_Manager_Contractors_AggregateArgs, never>>;
  chart_manager_contractors_stream?: SubscriptionResolver<Array<ResolversTypes['chart_manager_contractors']>, "chart_manager_contractors_stream", ParentType, ContextType, RequireFields<Subscription_RootChart_Manager_Contractors_StreamArgs, 'batch_size' | 'cursor'>>;
  chart_projects?: SubscriptionResolver<Array<ResolversTypes['chart_projects']>, "chart_projects", ParentType, ContextType, RequireFields<Subscription_RootChart_ProjectsArgs, never>>;
  chart_projects_aggregate?: SubscriptionResolver<ResolversTypes['chart_projects_aggregate'], "chart_projects_aggregate", ParentType, ContextType, RequireFields<Subscription_RootChart_Projects_AggregateArgs, never>>;
  chart_projects_stream?: SubscriptionResolver<Array<ResolversTypes['chart_projects']>, "chart_projects_stream", ParentType, ContextType, RequireFields<Subscription_RootChart_Projects_StreamArgs, 'batch_size' | 'cursor'>>;
  checkin_status?: SubscriptionResolver<Array<ResolversTypes['checkin_status']>, "checkin_status", ParentType, ContextType, RequireFields<Subscription_RootCheckin_StatusArgs, never>>;
  checkin_status_aggregate?: SubscriptionResolver<ResolversTypes['checkin_status_aggregate'], "checkin_status_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCheckin_Status_AggregateArgs, never>>;
  checkin_status_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['checkin_status']>, "checkin_status_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCheckin_Status_By_PkArgs, 'value'>>;
  checkin_status_stream?: SubscriptionResolver<Array<ResolversTypes['checkin_status']>, "checkin_status_stream", ParentType, ContextType, RequireFields<Subscription_RootCheckin_Status_StreamArgs, 'batch_size' | 'cursor'>>;
  checkout_status?: SubscriptionResolver<Array<ResolversTypes['checkout_status']>, "checkout_status", ParentType, ContextType, RequireFields<Subscription_RootCheckout_StatusArgs, never>>;
  checkout_status_aggregate?: SubscriptionResolver<ResolversTypes['checkout_status_aggregate'], "checkout_status_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCheckout_Status_AggregateArgs, never>>;
  checkout_status_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['checkout_status']>, "checkout_status_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCheckout_Status_By_PkArgs, 'value'>>;
  checkout_status_stream?: SubscriptionResolver<Array<ResolversTypes['checkout_status']>, "checkout_status_stream", ParentType, ContextType, RequireFields<Subscription_RootCheckout_Status_StreamArgs, 'batch_size' | 'cursor'>>;
  client_care_plan?: SubscriptionResolver<Array<ResolversTypes['client_care_plan']>, "client_care_plan", ParentType, ContextType, RequireFields<Subscription_RootClient_Care_PlanArgs, never>>;
  client_care_plan_aggregate?: SubscriptionResolver<ResolversTypes['client_care_plan_aggregate'], "client_care_plan_aggregate", ParentType, ContextType, RequireFields<Subscription_RootClient_Care_Plan_AggregateArgs, never>>;
  client_care_plan_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['client_care_plan']>, "client_care_plan_by_pk", ParentType, ContextType, RequireFields<Subscription_RootClient_Care_Plan_By_PkArgs, 'id'>>;
  client_care_plan_stream?: SubscriptionResolver<Array<ResolversTypes['client_care_plan']>, "client_care_plan_stream", ParentType, ContextType, RequireFields<Subscription_RootClient_Care_Plan_StreamArgs, 'batch_size' | 'cursor'>>;
  client_medications?: SubscriptionResolver<Array<ResolversTypes['client_medications']>, "client_medications", ParentType, ContextType, RequireFields<Subscription_RootClient_MedicationsArgs, never>>;
  client_medications_aggregate?: SubscriptionResolver<ResolversTypes['client_medications_aggregate'], "client_medications_aggregate", ParentType, ContextType, RequireFields<Subscription_RootClient_Medications_AggregateArgs, never>>;
  client_medications_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['client_medications']>, "client_medications_by_pk", ParentType, ContextType, RequireFields<Subscription_RootClient_Medications_By_PkArgs, 'id'>>;
  client_medications_stream?: SubscriptionResolver<Array<ResolversTypes['client_medications']>, "client_medications_stream", ParentType, ContextType, RequireFields<Subscription_RootClient_Medications_StreamArgs, 'batch_size' | 'cursor'>>;
  company?: SubscriptionResolver<Array<ResolversTypes['company']>, "company", ParentType, ContextType, RequireFields<Subscription_RootCompanyArgs, never>>;
  company_aggregate?: SubscriptionResolver<ResolversTypes['company_aggregate'], "company_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCompany_AggregateArgs, never>>;
  company_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['company']>, "company_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCompany_By_PkArgs, 'id'>>;
  company_follower?: SubscriptionResolver<Array<ResolversTypes['company_follower']>, "company_follower", ParentType, ContextType, RequireFields<Subscription_RootCompany_FollowerArgs, never>>;
  company_follower_aggregate?: SubscriptionResolver<ResolversTypes['company_follower_aggregate'], "company_follower_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCompany_Follower_AggregateArgs, never>>;
  company_follower_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['company_follower']>, "company_follower_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCompany_Follower_By_PkArgs, 'id'>>;
  company_follower_stream?: SubscriptionResolver<Array<ResolversTypes['company_follower']>, "company_follower_stream", ParentType, ContextType, RequireFields<Subscription_RootCompany_Follower_StreamArgs, 'batch_size' | 'cursor'>>;
  company_stream?: SubscriptionResolver<Array<ResolversTypes['company']>, "company_stream", ParentType, ContextType, RequireFields<Subscription_RootCompany_StreamArgs, 'batch_size' | 'cursor'>>;
  company_user_notifications?: SubscriptionResolver<Array<ResolversTypes['company_user_notifications']>, "company_user_notifications", ParentType, ContextType, RequireFields<Subscription_RootCompany_User_NotificationsArgs, never>>;
  company_user_notifications_aggregate?: SubscriptionResolver<ResolversTypes['company_user_notifications_aggregate'], "company_user_notifications_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCompany_User_Notifications_AggregateArgs, never>>;
  company_user_notifications_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['company_user_notifications']>, "company_user_notifications_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCompany_User_Notifications_By_PkArgs, 'id'>>;
  company_user_notifications_stream?: SubscriptionResolver<Array<ResolversTypes['company_user_notifications']>, "company_user_notifications_stream", ParentType, ContextType, RequireFields<Subscription_RootCompany_User_Notifications_StreamArgs, 'batch_size' | 'cursor'>>;
  contractor?: SubscriptionResolver<Array<ResolversTypes['contractor']>, "contractor", ParentType, ContextType, RequireFields<Subscription_RootContractorArgs, never>>;
  contractor_aggregate?: SubscriptionResolver<ResolversTypes['contractor_aggregate'], "contractor_aggregate", ParentType, ContextType, RequireFields<Subscription_RootContractor_AggregateArgs, never>>;
  contractor_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contractor']>, "contractor_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContractor_By_PkArgs, 'id'>>;
  contractor_note?: SubscriptionResolver<Array<ResolversTypes['contractor_note']>, "contractor_note", ParentType, ContextType, RequireFields<Subscription_RootContractor_NoteArgs, never>>;
  contractor_note_aggregate?: SubscriptionResolver<ResolversTypes['contractor_note_aggregate'], "contractor_note_aggregate", ParentType, ContextType, RequireFields<Subscription_RootContractor_Note_AggregateArgs, never>>;
  contractor_note_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contractor_note']>, "contractor_note_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContractor_Note_By_PkArgs, 'id'>>;
  contractor_note_stream?: SubscriptionResolver<Array<ResolversTypes['contractor_note']>, "contractor_note_stream", ParentType, ContextType, RequireFields<Subscription_RootContractor_Note_StreamArgs, 'batch_size' | 'cursor'>>;
  contractor_posting?: SubscriptionResolver<Array<ResolversTypes['contractor_posting']>, "contractor_posting", ParentType, ContextType, RequireFields<Subscription_RootContractor_PostingArgs, never>>;
  contractor_posting_aggregate?: SubscriptionResolver<ResolversTypes['contractor_posting_aggregate'], "contractor_posting_aggregate", ParentType, ContextType, RequireFields<Subscription_RootContractor_Posting_AggregateArgs, never>>;
  contractor_posting_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contractor_posting']>, "contractor_posting_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContractor_Posting_By_PkArgs, 'id'>>;
  contractor_posting_stream?: SubscriptionResolver<Array<ResolversTypes['contractor_posting']>, "contractor_posting_stream", ParentType, ContextType, RequireFields<Subscription_RootContractor_Posting_StreamArgs, 'batch_size' | 'cursor'>>;
  contractor_project?: SubscriptionResolver<Array<ResolversTypes['contractor_project']>, "contractor_project", ParentType, ContextType, RequireFields<Subscription_RootContractor_ProjectArgs, never>>;
  contractor_project_aggregate?: SubscriptionResolver<ResolversTypes['contractor_project_aggregate'], "contractor_project_aggregate", ParentType, ContextType, RequireFields<Subscription_RootContractor_Project_AggregateArgs, never>>;
  contractor_project_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contractor_project']>, "contractor_project_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContractor_Project_By_PkArgs, 'id'>>;
  contractor_project_stream?: SubscriptionResolver<Array<ResolversTypes['contractor_project']>, "contractor_project_stream", ParentType, ContextType, RequireFields<Subscription_RootContractor_Project_StreamArgs, 'batch_size' | 'cursor'>>;
  contractor_rating?: SubscriptionResolver<Array<ResolversTypes['contractor_rating']>, "contractor_rating", ParentType, ContextType, RequireFields<Subscription_RootContractor_RatingArgs, never>>;
  contractor_rating_aggregate?: SubscriptionResolver<ResolversTypes['contractor_rating_aggregate'], "contractor_rating_aggregate", ParentType, ContextType, RequireFields<Subscription_RootContractor_Rating_AggregateArgs, never>>;
  contractor_rating_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contractor_rating']>, "contractor_rating_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContractor_Rating_By_PkArgs, 'id'>>;
  contractor_rating_stream?: SubscriptionResolver<Array<ResolversTypes['contractor_rating']>, "contractor_rating_stream", ParentType, ContextType, RequireFields<Subscription_RootContractor_Rating_StreamArgs, 'batch_size' | 'cursor'>>;
  contractor_staff_note?: SubscriptionResolver<Array<ResolversTypes['contractor_staff_note']>, "contractor_staff_note", ParentType, ContextType, RequireFields<Subscription_RootContractor_Staff_NoteArgs, never>>;
  contractor_staff_note_aggregate?: SubscriptionResolver<ResolversTypes['contractor_staff_note_aggregate'], "contractor_staff_note_aggregate", ParentType, ContextType, RequireFields<Subscription_RootContractor_Staff_Note_AggregateArgs, never>>;
  contractor_staff_note_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contractor_staff_note']>, "contractor_staff_note_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContractor_Staff_Note_By_PkArgs, 'id'>>;
  contractor_staff_note_stream?: SubscriptionResolver<Array<ResolversTypes['contractor_staff_note']>, "contractor_staff_note_stream", ParentType, ContextType, RequireFields<Subscription_RootContractor_Staff_Note_StreamArgs, 'batch_size' | 'cursor'>>;
  contractor_stream?: SubscriptionResolver<Array<ResolversTypes['contractor']>, "contractor_stream", ParentType, ContextType, RequireFields<Subscription_RootContractor_StreamArgs, 'batch_size' | 'cursor'>>;
  conversation?: SubscriptionResolver<Array<ResolversTypes['conversation']>, "conversation", ParentType, ContextType, RequireFields<Subscription_RootConversationArgs, never>>;
  conversation_aggregate?: SubscriptionResolver<ResolversTypes['conversation_aggregate'], "conversation_aggregate", ParentType, ContextType, RequireFields<Subscription_RootConversation_AggregateArgs, never>>;
  conversation_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['conversation']>, "conversation_by_pk", ParentType, ContextType, RequireFields<Subscription_RootConversation_By_PkArgs, 'id'>>;
  conversation_stream?: SubscriptionResolver<Array<ResolversTypes['conversation']>, "conversation_stream", ParentType, ContextType, RequireFields<Subscription_RootConversation_StreamArgs, 'batch_size' | 'cursor'>>;
  custom_request?: SubscriptionResolver<Array<ResolversTypes['custom_request']>, "custom_request", ParentType, ContextType, RequireFields<Subscription_RootCustom_RequestArgs, never>>;
  custom_request_aggregate?: SubscriptionResolver<ResolversTypes['custom_request_aggregate'], "custom_request_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCustom_Request_AggregateArgs, never>>;
  custom_request_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['custom_request']>, "custom_request_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCustom_Request_By_PkArgs, 'id'>>;
  custom_request_skills?: SubscriptionResolver<Array<ResolversTypes['custom_request_skills']>, "custom_request_skills", ParentType, ContextType, RequireFields<Subscription_RootCustom_Request_SkillsArgs, never>>;
  custom_request_skills_aggregate?: SubscriptionResolver<ResolversTypes['custom_request_skills_aggregate'], "custom_request_skills_aggregate", ParentType, ContextType, RequireFields<Subscription_RootCustom_Request_Skills_AggregateArgs, never>>;
  custom_request_skills_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['custom_request_skills']>, "custom_request_skills_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCustom_Request_Skills_By_PkArgs, 'id'>>;
  custom_request_skills_stream?: SubscriptionResolver<Array<ResolversTypes['custom_request_skills']>, "custom_request_skills_stream", ParentType, ContextType, RequireFields<Subscription_RootCustom_Request_Skills_StreamArgs, 'batch_size' | 'cursor'>>;
  custom_request_stream?: SubscriptionResolver<Array<ResolversTypes['custom_request']>, "custom_request_stream", ParentType, ContextType, RequireFields<Subscription_RootCustom_Request_StreamArgs, 'batch_size' | 'cursor'>>;
  declined_visit_matches?: SubscriptionResolver<Array<ResolversTypes['declined_visit_matches']>, "declined_visit_matches", ParentType, ContextType, RequireFields<Subscription_RootDeclined_Visit_MatchesArgs, never>>;
  declined_visit_matches_aggregate?: SubscriptionResolver<ResolversTypes['declined_visit_matches_aggregate'], "declined_visit_matches_aggregate", ParentType, ContextType, RequireFields<Subscription_RootDeclined_Visit_Matches_AggregateArgs, never>>;
  declined_visit_matches_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['declined_visit_matches']>, "declined_visit_matches_by_pk", ParentType, ContextType, RequireFields<Subscription_RootDeclined_Visit_Matches_By_PkArgs, 'id'>>;
  declined_visit_matches_stream?: SubscriptionResolver<Array<ResolversTypes['declined_visit_matches']>, "declined_visit_matches_stream", ParentType, ContextType, RequireFields<Subscription_RootDeclined_Visit_Matches_StreamArgs, 'batch_size' | 'cursor'>>;
  document?: SubscriptionResolver<Array<ResolversTypes['document']>, "document", ParentType, ContextType, RequireFields<Subscription_RootDocumentArgs, never>>;
  document_aggregate?: SubscriptionResolver<ResolversTypes['document_aggregate'], "document_aggregate", ParentType, ContextType, RequireFields<Subscription_RootDocument_AggregateArgs, never>>;
  document_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['document']>, "document_by_pk", ParentType, ContextType, RequireFields<Subscription_RootDocument_By_PkArgs, 'id'>>;
  document_contractor_access?: SubscriptionResolver<Array<ResolversTypes['document_contractor_access']>, "document_contractor_access", ParentType, ContextType, RequireFields<Subscription_RootDocument_Contractor_AccessArgs, never>>;
  document_contractor_access_aggregate?: SubscriptionResolver<ResolversTypes['document_contractor_access_aggregate'], "document_contractor_access_aggregate", ParentType, ContextType, RequireFields<Subscription_RootDocument_Contractor_Access_AggregateArgs, never>>;
  document_contractor_access_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['document_contractor_access']>, "document_contractor_access_by_pk", ParentType, ContextType, RequireFields<Subscription_RootDocument_Contractor_Access_By_PkArgs, 'id'>>;
  document_contractor_access_stream?: SubscriptionResolver<Array<ResolversTypes['document_contractor_access']>, "document_contractor_access_stream", ParentType, ContextType, RequireFields<Subscription_RootDocument_Contractor_Access_StreamArgs, 'batch_size' | 'cursor'>>;
  document_custom_request?: SubscriptionResolver<Array<ResolversTypes['document_custom_request']>, "document_custom_request", ParentType, ContextType, RequireFields<Subscription_RootDocument_Custom_RequestArgs, never>>;
  document_custom_request_aggregate?: SubscriptionResolver<ResolversTypes['document_custom_request_aggregate'], "document_custom_request_aggregate", ParentType, ContextType, RequireFields<Subscription_RootDocument_Custom_Request_AggregateArgs, never>>;
  document_custom_request_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['document_custom_request']>, "document_custom_request_by_pk", ParentType, ContextType, RequireFields<Subscription_RootDocument_Custom_Request_By_PkArgs, 'id'>>;
  document_custom_request_stream?: SubscriptionResolver<Array<ResolversTypes['document_custom_request']>, "document_custom_request_stream", ParentType, ContextType, RequireFields<Subscription_RootDocument_Custom_Request_StreamArgs, 'batch_size' | 'cursor'>>;
  document_project?: SubscriptionResolver<Array<ResolversTypes['document_project']>, "document_project", ParentType, ContextType, RequireFields<Subscription_RootDocument_ProjectArgs, never>>;
  document_project_aggregate?: SubscriptionResolver<ResolversTypes['document_project_aggregate'], "document_project_aggregate", ParentType, ContextType, RequireFields<Subscription_RootDocument_Project_AggregateArgs, never>>;
  document_project_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['document_project']>, "document_project_by_pk", ParentType, ContextType, RequireFields<Subscription_RootDocument_Project_By_PkArgs, 'id'>>;
  document_project_stream?: SubscriptionResolver<Array<ResolversTypes['document_project']>, "document_project_stream", ParentType, ContextType, RequireFields<Subscription_RootDocument_Project_StreamArgs, 'batch_size' | 'cursor'>>;
  document_stream?: SubscriptionResolver<Array<ResolversTypes['document']>, "document_stream", ParentType, ContextType, RequireFields<Subscription_RootDocument_StreamArgs, 'batch_size' | 'cursor'>>;
  document_user?: SubscriptionResolver<Array<ResolversTypes['document_user']>, "document_user", ParentType, ContextType, RequireFields<Subscription_RootDocument_UserArgs, never>>;
  document_user_aggregate?: SubscriptionResolver<ResolversTypes['document_user_aggregate'], "document_user_aggregate", ParentType, ContextType, RequireFields<Subscription_RootDocument_User_AggregateArgs, never>>;
  document_user_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['document_user']>, "document_user_by_pk", ParentType, ContextType, RequireFields<Subscription_RootDocument_User_By_PkArgs, 'id'>>;
  document_user_stream?: SubscriptionResolver<Array<ResolversTypes['document_user']>, "document_user_stream", ParentType, ContextType, RequireFields<Subscription_RootDocument_User_StreamArgs, 'batch_size' | 'cursor'>>;
  email_regex?: SubscriptionResolver<Array<ResolversTypes['email_regex']>, "email_regex", ParentType, ContextType, RequireFields<Subscription_RootEmail_RegexArgs, never>>;
  email_regex_aggregate?: SubscriptionResolver<ResolversTypes['email_regex_aggregate'], "email_regex_aggregate", ParentType, ContextType, RequireFields<Subscription_RootEmail_Regex_AggregateArgs, never>>;
  email_regex_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['email_regex']>, "email_regex_by_pk", ParentType, ContextType, RequireFields<Subscription_RootEmail_Regex_By_PkArgs, 'id'>>;
  email_regex_stream?: SubscriptionResolver<Array<ResolversTypes['email_regex']>, "email_regex_stream", ParentType, ContextType, RequireFields<Subscription_RootEmail_Regex_StreamArgs, 'batch_size' | 'cursor'>>;
  experience_skill?: SubscriptionResolver<Array<ResolversTypes['experience_skill']>, "experience_skill", ParentType, ContextType, RequireFields<Subscription_RootExperience_SkillArgs, never>>;
  experience_skill_aggregate?: SubscriptionResolver<ResolversTypes['experience_skill_aggregate'], "experience_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootExperience_Skill_AggregateArgs, never>>;
  experience_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['experience_skill']>, "experience_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootExperience_Skill_By_PkArgs, 'id'>>;
  experience_skill_stream?: SubscriptionResolver<Array<ResolversTypes['experience_skill']>, "experience_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootExperience_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  gender?: SubscriptionResolver<Array<ResolversTypes['gender']>, "gender", ParentType, ContextType, RequireFields<Subscription_RootGenderArgs, never>>;
  gender_aggregate?: SubscriptionResolver<ResolversTypes['gender_aggregate'], "gender_aggregate", ParentType, ContextType, RequireFields<Subscription_RootGender_AggregateArgs, never>>;
  gender_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['gender']>, "gender_by_pk", ParentType, ContextType, RequireFields<Subscription_RootGender_By_PkArgs, 'value'>>;
  gender_stream?: SubscriptionResolver<Array<ResolversTypes['gender']>, "gender_stream", ParentType, ContextType, RequireFields<Subscription_RootGender_StreamArgs, 'batch_size' | 'cursor'>>;
  industry?: SubscriptionResolver<Array<ResolversTypes['industry']>, "industry", ParentType, ContextType, RequireFields<Subscription_RootIndustryArgs, never>>;
  industry_aggregate?: SubscriptionResolver<ResolversTypes['industry_aggregate'], "industry_aggregate", ParentType, ContextType, RequireFields<Subscription_RootIndustry_AggregateArgs, never>>;
  industry_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['industry']>, "industry_by_pk", ParentType, ContextType, RequireFields<Subscription_RootIndustry_By_PkArgs, 'id'>>;
  industry_stream?: SubscriptionResolver<Array<ResolversTypes['industry']>, "industry_stream", ParentType, ContextType, RequireFields<Subscription_RootIndustry_StreamArgs, 'batch_size' | 'cursor'>>;
  invitation?: SubscriptionResolver<Array<ResolversTypes['invitation']>, "invitation", ParentType, ContextType, RequireFields<Subscription_RootInvitationArgs, never>>;
  invitation_aggregate?: SubscriptionResolver<ResolversTypes['invitation_aggregate'], "invitation_aggregate", ParentType, ContextType, RequireFields<Subscription_RootInvitation_AggregateArgs, never>>;
  invitation_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['invitation']>, "invitation_by_pk", ParentType, ContextType, RequireFields<Subscription_RootInvitation_By_PkArgs, 'id'>>;
  invitation_stream?: SubscriptionResolver<Array<ResolversTypes['invitation']>, "invitation_stream", ParentType, ContextType, RequireFields<Subscription_RootInvitation_StreamArgs, 'batch_size' | 'cursor'>>;
  invoice?: SubscriptionResolver<Array<ResolversTypes['invoice']>, "invoice", ParentType, ContextType, RequireFields<Subscription_RootInvoiceArgs, never>>;
  invoice_aggregate?: SubscriptionResolver<ResolversTypes['invoice_aggregate'], "invoice_aggregate", ParentType, ContextType, RequireFields<Subscription_RootInvoice_AggregateArgs, never>>;
  invoice_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['invoice']>, "invoice_by_pk", ParentType, ContextType, RequireFields<Subscription_RootInvoice_By_PkArgs, 'id'>>;
  invoice_stream?: SubscriptionResolver<Array<ResolversTypes['invoice']>, "invoice_stream", ParentType, ContextType, RequireFields<Subscription_RootInvoice_StreamArgs, 'batch_size' | 'cursor'>>;
  language?: SubscriptionResolver<Array<ResolversTypes['language']>, "language", ParentType, ContextType, RequireFields<Subscription_RootLanguageArgs, never>>;
  language_aggregate?: SubscriptionResolver<ResolversTypes['language_aggregate'], "language_aggregate", ParentType, ContextType, RequireFields<Subscription_RootLanguage_AggregateArgs, never>>;
  language_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['language']>, "language_by_pk", ParentType, ContextType, RequireFields<Subscription_RootLanguage_By_PkArgs, 'id'>>;
  language_stream?: SubscriptionResolver<Array<ResolversTypes['language']>, "language_stream", ParentType, ContextType, RequireFields<Subscription_RootLanguage_StreamArgs, 'batch_size' | 'cursor'>>;
  manager?: SubscriptionResolver<Array<ResolversTypes['manager']>, "manager", ParentType, ContextType, RequireFields<Subscription_RootManagerArgs, never>>;
  manager_aggregate?: SubscriptionResolver<ResolversTypes['manager_aggregate'], "manager_aggregate", ParentType, ContextType, RequireFields<Subscription_RootManager_AggregateArgs, never>>;
  manager_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['manager']>, "manager_by_pk", ParentType, ContextType, RequireFields<Subscription_RootManager_By_PkArgs, 'id'>>;
  manager_contractor?: SubscriptionResolver<Array<ResolversTypes['manager_contractor']>, "manager_contractor", ParentType, ContextType, RequireFields<Subscription_RootManager_ContractorArgs, never>>;
  manager_contractor_aggregate?: SubscriptionResolver<ResolversTypes['manager_contractor_aggregate'], "manager_contractor_aggregate", ParentType, ContextType, RequireFields<Subscription_RootManager_Contractor_AggregateArgs, never>>;
  manager_contractor_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['manager_contractor']>, "manager_contractor_by_pk", ParentType, ContextType, RequireFields<Subscription_RootManager_Contractor_By_PkArgs, 'id'>>;
  manager_contractor_stream?: SubscriptionResolver<Array<ResolversTypes['manager_contractor']>, "manager_contractor_stream", ParentType, ContextType, RequireFields<Subscription_RootManager_Contractor_StreamArgs, 'batch_size' | 'cursor'>>;
  manager_stream?: SubscriptionResolver<Array<ResolversTypes['manager']>, "manager_stream", ParentType, ContextType, RequireFields<Subscription_RootManager_StreamArgs, 'batch_size' | 'cursor'>>;
  message?: SubscriptionResolver<Array<ResolversTypes['message']>, "message", ParentType, ContextType, RequireFields<Subscription_RootMessageArgs, never>>;
  message_aggregate?: SubscriptionResolver<ResolversTypes['message_aggregate'], "message_aggregate", ParentType, ContextType, RequireFields<Subscription_RootMessage_AggregateArgs, never>>;
  message_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['message']>, "message_by_pk", ParentType, ContextType, RequireFields<Subscription_RootMessage_By_PkArgs, 'id'>>;
  message_stream?: SubscriptionResolver<Array<ResolversTypes['message']>, "message_stream", ParentType, ContextType, RequireFields<Subscription_RootMessage_StreamArgs, 'batch_size' | 'cursor'>>;
  notification?: SubscriptionResolver<Array<ResolversTypes['notification']>, "notification", ParentType, ContextType, RequireFields<Subscription_RootNotificationArgs, never>>;
  notification_aggregate?: SubscriptionResolver<ResolversTypes['notification_aggregate'], "notification_aggregate", ParentType, ContextType, RequireFields<Subscription_RootNotification_AggregateArgs, never>>;
  notification_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['notification']>, "notification_by_pk", ParentType, ContextType, RequireFields<Subscription_RootNotification_By_PkArgs, 'id'>>;
  notification_stream?: SubscriptionResolver<Array<ResolversTypes['notification']>, "notification_stream", ParentType, ContextType, RequireFields<Subscription_RootNotification_StreamArgs, 'batch_size' | 'cursor'>>;
  onboarding?: SubscriptionResolver<Array<ResolversTypes['onboarding']>, "onboarding", ParentType, ContextType, RequireFields<Subscription_RootOnboardingArgs, never>>;
  onboarding_aggregate?: SubscriptionResolver<ResolversTypes['onboarding_aggregate'], "onboarding_aggregate", ParentType, ContextType, RequireFields<Subscription_RootOnboarding_AggregateArgs, never>>;
  onboarding_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['onboarding']>, "onboarding_by_pk", ParentType, ContextType, RequireFields<Subscription_RootOnboarding_By_PkArgs, 'id'>>;
  onboarding_stream?: SubscriptionResolver<Array<ResolversTypes['onboarding']>, "onboarding_stream", ParentType, ContextType, RequireFields<Subscription_RootOnboarding_StreamArgs, 'batch_size' | 'cursor'>>;
  payment_card?: SubscriptionResolver<Array<ResolversTypes['payment_card']>, "payment_card", ParentType, ContextType, RequireFields<Subscription_RootPayment_CardArgs, never>>;
  payment_card_aggregate?: SubscriptionResolver<ResolversTypes['payment_card_aggregate'], "payment_card_aggregate", ParentType, ContextType, RequireFields<Subscription_RootPayment_Card_AggregateArgs, never>>;
  payment_card_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['payment_card']>, "payment_card_by_pk", ParentType, ContextType, RequireFields<Subscription_RootPayment_Card_By_PkArgs, 'id'>>;
  payment_card_stream?: SubscriptionResolver<Array<ResolversTypes['payment_card']>, "payment_card_stream", ParentType, ContextType, RequireFields<Subscription_RootPayment_Card_StreamArgs, 'batch_size' | 'cursor'>>;
  posting?: SubscriptionResolver<Array<ResolversTypes['posting']>, "posting", ParentType, ContextType, RequireFields<Subscription_RootPostingArgs, never>>;
  posting_aggregate?: SubscriptionResolver<ResolversTypes['posting_aggregate'], "posting_aggregate", ParentType, ContextType, RequireFields<Subscription_RootPosting_AggregateArgs, never>>;
  posting_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['posting']>, "posting_by_pk", ParentType, ContextType, RequireFields<Subscription_RootPosting_By_PkArgs, 'id'>>;
  posting_industry?: SubscriptionResolver<Array<ResolversTypes['posting_industry']>, "posting_industry", ParentType, ContextType, RequireFields<Subscription_RootPosting_IndustryArgs, never>>;
  posting_industry_aggregate?: SubscriptionResolver<ResolversTypes['posting_industry_aggregate'], "posting_industry_aggregate", ParentType, ContextType, RequireFields<Subscription_RootPosting_Industry_AggregateArgs, never>>;
  posting_industry_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['posting_industry']>, "posting_industry_by_pk", ParentType, ContextType, RequireFields<Subscription_RootPosting_Industry_By_PkArgs, 'id'>>;
  posting_industry_stream?: SubscriptionResolver<Array<ResolversTypes['posting_industry']>, "posting_industry_stream", ParentType, ContextType, RequireFields<Subscription_RootPosting_Industry_StreamArgs, 'batch_size' | 'cursor'>>;
  posting_skill?: SubscriptionResolver<Array<ResolversTypes['posting_skill']>, "posting_skill", ParentType, ContextType, RequireFields<Subscription_RootPosting_SkillArgs, never>>;
  posting_skill_aggregate?: SubscriptionResolver<ResolversTypes['posting_skill_aggregate'], "posting_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootPosting_Skill_AggregateArgs, never>>;
  posting_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['posting_skill']>, "posting_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootPosting_Skill_By_PkArgs, 'id'>>;
  posting_skill_stream?: SubscriptionResolver<Array<ResolversTypes['posting_skill']>, "posting_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootPosting_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  posting_stream?: SubscriptionResolver<Array<ResolversTypes['posting']>, "posting_stream", ParentType, ContextType, RequireFields<Subscription_RootPosting_StreamArgs, 'batch_size' | 'cursor'>>;
  posting_tags?: SubscriptionResolver<Array<ResolversTypes['posting_tags']>, "posting_tags", ParentType, ContextType, RequireFields<Subscription_RootPosting_TagsArgs, never>>;
  posting_tags_aggregate?: SubscriptionResolver<ResolversTypes['posting_tags_aggregate'], "posting_tags_aggregate", ParentType, ContextType, RequireFields<Subscription_RootPosting_Tags_AggregateArgs, never>>;
  posting_tags_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['posting_tags']>, "posting_tags_by_pk", ParentType, ContextType, RequireFields<Subscription_RootPosting_Tags_By_PkArgs, 'id'>>;
  posting_tags_stream?: SubscriptionResolver<Array<ResolversTypes['posting_tags']>, "posting_tags_stream", ParentType, ContextType, RequireFields<Subscription_RootPosting_Tags_StreamArgs, 'batch_size' | 'cursor'>>;
  project?: SubscriptionResolver<Array<ResolversTypes['project']>, "project", ParentType, ContextType, RequireFields<Subscription_RootProjectArgs, never>>;
  project_activity?: SubscriptionResolver<Array<ResolversTypes['project_activity']>, "project_activity", ParentType, ContextType, RequireFields<Subscription_RootProject_ActivityArgs, never>>;
  project_activity_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_aggregate'], "project_activity_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_AggregateArgs, never>>;
  project_activity_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity']>, "project_activity_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_By_PkArgs, 'id'>>;
  project_activity_note?: SubscriptionResolver<Array<ResolversTypes['project_activity_note']>, "project_activity_note", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_NoteArgs, never>>;
  project_activity_note_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_note_aggregate'], "project_activity_note_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Note_AggregateArgs, never>>;
  project_activity_note_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity_note']>, "project_activity_note_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Note_By_PkArgs, 'id'>>;
  project_activity_note_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity_note']>, "project_activity_note_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Note_StreamArgs, 'batch_size' | 'cursor'>>;
  project_activity_request_more_hours?: SubscriptionResolver<Array<ResolversTypes['project_activity_request_more_hours']>, "project_activity_request_more_hours", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Request_More_HoursArgs, never>>;
  project_activity_request_more_hours_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_request_more_hours_aggregate'], "project_activity_request_more_hours_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Request_More_Hours_AggregateArgs, never>>;
  project_activity_request_more_hours_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity_request_more_hours']>, "project_activity_request_more_hours_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Request_More_Hours_By_PkArgs, 'id'>>;
  project_activity_request_more_hours_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity_request_more_hours']>, "project_activity_request_more_hours_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Request_More_Hours_StreamArgs, 'batch_size' | 'cursor'>>;
  project_activity_skill?: SubscriptionResolver<Array<ResolversTypes['project_activity_skill']>, "project_activity_skill", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_SkillArgs, never>>;
  project_activity_skill_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_skill_aggregate'], "project_activity_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Skill_AggregateArgs, never>>;
  project_activity_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity_skill']>, "project_activity_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Skill_By_PkArgs, 'id'>>;
  project_activity_skill_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity_skill']>, "project_activity_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  project_activity_soft_skill?: SubscriptionResolver<Array<ResolversTypes['project_activity_soft_skill']>, "project_activity_soft_skill", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Soft_SkillArgs, never>>;
  project_activity_soft_skill_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_soft_skill_aggregate'], "project_activity_soft_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Soft_Skill_AggregateArgs, never>>;
  project_activity_soft_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity_soft_skill']>, "project_activity_soft_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Soft_Skill_By_PkArgs, 'id'>>;
  project_activity_soft_skill_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity_soft_skill']>, "project_activity_soft_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Soft_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  project_activity_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity']>, "project_activity_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_StreamArgs, 'batch_size' | 'cursor'>>;
  project_activity_tag?: SubscriptionResolver<Array<ResolversTypes['project_activity_tag']>, "project_activity_tag", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_TagArgs, never>>;
  project_activity_tag_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_tag_aggregate'], "project_activity_tag_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Tag_AggregateArgs, never>>;
  project_activity_tag_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity_tag']>, "project_activity_tag_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Tag_By_PkArgs, 'id'>>;
  project_activity_tag_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity_tag']>, "project_activity_tag_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Tag_StreamArgs, 'batch_size' | 'cursor'>>;
  project_activity_time?: SubscriptionResolver<Array<ResolversTypes['project_activity_time']>, "project_activity_time", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_TimeArgs, never>>;
  project_activity_time_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_time_aggregate'], "project_activity_time_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Time_AggregateArgs, never>>;
  project_activity_time_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity_time']>, "project_activity_time_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Time_By_PkArgs, 'id'>>;
  project_activity_time_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity_time']>, "project_activity_time_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Time_StreamArgs, 'batch_size' | 'cursor'>>;
  project_activity_tracked_time?: SubscriptionResolver<Array<ResolversTypes['project_activity_tracked_time']>, "project_activity_tracked_time", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Tracked_TimeArgs, never>>;
  project_activity_tracked_time_aggregate?: SubscriptionResolver<ResolversTypes['project_activity_tracked_time_aggregate'], "project_activity_tracked_time_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Tracked_Time_AggregateArgs, never>>;
  project_activity_tracked_time_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_activity_tracked_time']>, "project_activity_tracked_time_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Tracked_Time_By_PkArgs, 'id'>>;
  project_activity_tracked_time_stream?: SubscriptionResolver<Array<ResolversTypes['project_activity_tracked_time']>, "project_activity_tracked_time_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Activity_Tracked_Time_StreamArgs, 'batch_size' | 'cursor'>>;
  project_aggregate?: SubscriptionResolver<ResolversTypes['project_aggregate'], "project_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_AggregateArgs, never>>;
  project_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project']>, "project_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_By_PkArgs, 'id'>>;
  project_skill?: SubscriptionResolver<Array<ResolversTypes['project_skill']>, "project_skill", ParentType, ContextType, RequireFields<Subscription_RootProject_SkillArgs, never>>;
  project_skill_aggregate?: SubscriptionResolver<ResolversTypes['project_skill_aggregate'], "project_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Skill_AggregateArgs, never>>;
  project_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_skill']>, "project_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Skill_By_PkArgs, 'id'>>;
  project_skill_stream?: SubscriptionResolver<Array<ResolversTypes['project_skill']>, "project_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  project_soft_skill?: SubscriptionResolver<Array<ResolversTypes['project_soft_skill']>, "project_soft_skill", ParentType, ContextType, RequireFields<Subscription_RootProject_Soft_SkillArgs, never>>;
  project_soft_skill_aggregate?: SubscriptionResolver<ResolversTypes['project_soft_skill_aggregate'], "project_soft_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Soft_Skill_AggregateArgs, never>>;
  project_soft_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_soft_skill']>, "project_soft_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Soft_Skill_By_PkArgs, 'id'>>;
  project_soft_skill_stream?: SubscriptionResolver<Array<ResolversTypes['project_soft_skill']>, "project_soft_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Soft_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  project_stream?: SubscriptionResolver<Array<ResolversTypes['project']>, "project_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_StreamArgs, 'batch_size' | 'cursor'>>;
  project_tag?: SubscriptionResolver<Array<ResolversTypes['project_tag']>, "project_tag", ParentType, ContextType, RequireFields<Subscription_RootProject_TagArgs, never>>;
  project_tag_aggregate?: SubscriptionResolver<ResolversTypes['project_tag_aggregate'], "project_tag_aggregate", ParentType, ContextType, RequireFields<Subscription_RootProject_Tag_AggregateArgs, never>>;
  project_tag_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['project_tag']>, "project_tag_by_pk", ParentType, ContextType, RequireFields<Subscription_RootProject_Tag_By_PkArgs, 'id'>>;
  project_tag_stream?: SubscriptionResolver<Array<ResolversTypes['project_tag']>, "project_tag_stream", ParentType, ContextType, RequireFields<Subscription_RootProject_Tag_StreamArgs, 'batch_size' | 'cursor'>>;
  public_project_details?: SubscriptionResolver<Array<ResolversTypes['public_project_details']>, "public_project_details", ParentType, ContextType, RequireFields<Subscription_RootPublic_Project_DetailsArgs, never>>;
  public_project_details_aggregate?: SubscriptionResolver<ResolversTypes['public_project_details_aggregate'], "public_project_details_aggregate", ParentType, ContextType, RequireFields<Subscription_RootPublic_Project_Details_AggregateArgs, never>>;
  public_project_details_stream?: SubscriptionResolver<Array<ResolversTypes['public_project_details']>, "public_project_details_stream", ParentType, ContextType, RequireFields<Subscription_RootPublic_Project_Details_StreamArgs, 'batch_size' | 'cursor'>>;
  recipient_message?: SubscriptionResolver<Array<ResolversTypes['recipient_message']>, "recipient_message", ParentType, ContextType, RequireFields<Subscription_RootRecipient_MessageArgs, never>>;
  recipient_message_aggregate?: SubscriptionResolver<ResolversTypes['recipient_message_aggregate'], "recipient_message_aggregate", ParentType, ContextType, RequireFields<Subscription_RootRecipient_Message_AggregateArgs, never>>;
  recipient_message_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['recipient_message']>, "recipient_message_by_pk", ParentType, ContextType, RequireFields<Subscription_RootRecipient_Message_By_PkArgs, 'id'>>;
  recipient_message_stream?: SubscriptionResolver<Array<ResolversTypes['recipient_message']>, "recipient_message_stream", ParentType, ContextType, RequireFields<Subscription_RootRecipient_Message_StreamArgs, 'batch_size' | 'cursor'>>;
  resource_information_card?: SubscriptionResolver<Array<ResolversTypes['resource_information_card']>, "resource_information_card", ParentType, ContextType, RequireFields<Subscription_RootResource_Information_CardArgs, never>>;
  resource_information_card_aggregate?: SubscriptionResolver<ResolversTypes['resource_information_card_aggregate'], "resource_information_card_aggregate", ParentType, ContextType, RequireFields<Subscription_RootResource_Information_Card_AggregateArgs, never>>;
  resource_information_card_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['resource_information_card']>, "resource_information_card_by_pk", ParentType, ContextType, RequireFields<Subscription_RootResource_Information_Card_By_PkArgs, 'id'>>;
  resource_information_card_stream?: SubscriptionResolver<Array<ResolversTypes['resource_information_card']>, "resource_information_card_stream", ParentType, ContextType, RequireFields<Subscription_RootResource_Information_Card_StreamArgs, 'batch_size' | 'cursor'>>;
  search_industry?: SubscriptionResolver<Array<ResolversTypes['industry']>, "search_industry", ParentType, ContextType, RequireFields<Subscription_RootSearch_IndustryArgs, 'args'>>;
  search_industry_aggregate?: SubscriptionResolver<ResolversTypes['industry_aggregate'], "search_industry_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSearch_Industry_AggregateArgs, 'args'>>;
  search_skill?: SubscriptionResolver<Array<ResolversTypes['skill']>, "search_skill", ParentType, ContextType, RequireFields<Subscription_RootSearch_SkillArgs, 'args'>>;
  search_skill_aggregate?: SubscriptionResolver<ResolversTypes['skill_aggregate'], "search_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSearch_Skill_AggregateArgs, 'args'>>;
  skill?: SubscriptionResolver<Array<ResolversTypes['skill']>, "skill", ParentType, ContextType, RequireFields<Subscription_RootSkillArgs, never>>;
  skill_aggregate?: SubscriptionResolver<ResolversTypes['skill_aggregate'], "skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSkill_AggregateArgs, never>>;
  skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['skill']>, "skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSkill_By_PkArgs, 'id'>>;
  skill_stream?: SubscriptionResolver<Array<ResolversTypes['skill']>, "skill_stream", ParentType, ContextType, RequireFields<Subscription_RootSkill_StreamArgs, 'batch_size' | 'cursor'>>;
  skills_short_name_first?: SubscriptionResolver<Array<ResolversTypes['skills_short_name_first']>, "skills_short_name_first", ParentType, ContextType, RequireFields<Subscription_RootSkills_Short_Name_FirstArgs, never>>;
  skills_short_name_first_aggregate?: SubscriptionResolver<ResolversTypes['skills_short_name_first_aggregate'], "skills_short_name_first_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSkills_Short_Name_First_AggregateArgs, never>>;
  skills_short_name_first_stream?: SubscriptionResolver<Array<ResolversTypes['skills_short_name_first']>, "skills_short_name_first_stream", ParentType, ContextType, RequireFields<Subscription_RootSkills_Short_Name_First_StreamArgs, 'batch_size' | 'cursor'>>;
  smart_match_bookmark?: SubscriptionResolver<Array<ResolversTypes['smart_match_bookmark']>, "smart_match_bookmark", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_BookmarkArgs, never>>;
  smart_match_bookmark_aggregate?: SubscriptionResolver<ResolversTypes['smart_match_bookmark_aggregate'], "smart_match_bookmark_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Bookmark_AggregateArgs, never>>;
  smart_match_bookmark_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['smart_match_bookmark']>, "smart_match_bookmark_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Bookmark_By_PkArgs, 'id'>>;
  smart_match_bookmark_stream?: SubscriptionResolver<Array<ResolversTypes['smart_match_bookmark']>, "smart_match_bookmark_stream", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Bookmark_StreamArgs, 'batch_size' | 'cursor'>>;
  smart_match_config_transportation?: SubscriptionResolver<Array<ResolversTypes['smart_match_config_transportation']>, "smart_match_config_transportation", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Config_TransportationArgs, never>>;
  smart_match_config_transportation_aggregate?: SubscriptionResolver<ResolversTypes['smart_match_config_transportation_aggregate'], "smart_match_config_transportation_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Config_Transportation_AggregateArgs, never>>;
  smart_match_config_transportation_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['smart_match_config_transportation']>, "smart_match_config_transportation_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Config_Transportation_By_PkArgs, 'id'>>;
  smart_match_config_transportation_stream?: SubscriptionResolver<Array<ResolversTypes['smart_match_config_transportation']>, "smart_match_config_transportation_stream", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Config_Transportation_StreamArgs, 'batch_size' | 'cursor'>>;
  smart_match_configs?: SubscriptionResolver<Array<ResolversTypes['smart_match_configs']>, "smart_match_configs", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_ConfigsArgs, never>>;
  smart_match_configs_aggregate?: SubscriptionResolver<ResolversTypes['smart_match_configs_aggregate'], "smart_match_configs_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Configs_AggregateArgs, never>>;
  smart_match_configs_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['smart_match_configs']>, "smart_match_configs_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Configs_By_PkArgs, 'id'>>;
  smart_match_configs_stream?: SubscriptionResolver<Array<ResolversTypes['smart_match_configs']>, "smart_match_configs_stream", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Configs_StreamArgs, 'batch_size' | 'cursor'>>;
  smart_match_criteria_order?: SubscriptionResolver<Array<ResolversTypes['smart_match_criteria_order']>, "smart_match_criteria_order", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Criteria_OrderArgs, never>>;
  smart_match_criteria_order_aggregate?: SubscriptionResolver<ResolversTypes['smart_match_criteria_order_aggregate'], "smart_match_criteria_order_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Criteria_Order_AggregateArgs, never>>;
  smart_match_criteria_order_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['smart_match_criteria_order']>, "smart_match_criteria_order_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Criteria_Order_By_PkArgs, 'id'>>;
  smart_match_criteria_order_stream?: SubscriptionResolver<Array<ResolversTypes['smart_match_criteria_order']>, "smart_match_criteria_order_stream", ParentType, ContextType, RequireFields<Subscription_RootSmart_Match_Criteria_Order_StreamArgs, 'batch_size' | 'cursor'>>;
  soft_skill?: SubscriptionResolver<Array<ResolversTypes['soft_skill']>, "soft_skill", ParentType, ContextType, RequireFields<Subscription_RootSoft_SkillArgs, never>>;
  soft_skill_aggregate?: SubscriptionResolver<ResolversTypes['soft_skill_aggregate'], "soft_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSoft_Skill_AggregateArgs, never>>;
  soft_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['soft_skill']>, "soft_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSoft_Skill_By_PkArgs, 'id'>>;
  soft_skill_stream?: SubscriptionResolver<Array<ResolversTypes['soft_skill']>, "soft_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootSoft_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  source?: SubscriptionResolver<Array<ResolversTypes['source']>, "source", ParentType, ContextType, RequireFields<Subscription_RootSourceArgs, never>>;
  source_aggregate?: SubscriptionResolver<ResolversTypes['source_aggregate'], "source_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSource_AggregateArgs, never>>;
  source_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['source']>, "source_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSource_By_PkArgs, 'id'>>;
  source_stream?: SubscriptionResolver<Array<ResolversTypes['source']>, "source_stream", ParentType, ContextType, RequireFields<Subscription_RootSource_StreamArgs, 'batch_size' | 'cursor'>>;
  subscription?: SubscriptionResolver<Array<ResolversTypes['subscription']>, "subscription", ParentType, ContextType, RequireFields<Subscription_RootSubscriptionArgs, never>>;
  subscription_aggregate?: SubscriptionResolver<ResolversTypes['subscription_aggregate'], "subscription_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSubscription_AggregateArgs, never>>;
  subscription_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['subscription']>, "subscription_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSubscription_By_PkArgs, 'id'>>;
  subscription_plan?: SubscriptionResolver<Array<ResolversTypes['subscription_plan']>, "subscription_plan", ParentType, ContextType, RequireFields<Subscription_RootSubscription_PlanArgs, never>>;
  subscription_plan_access_permissions?: SubscriptionResolver<Array<ResolversTypes['subscription_plan_access_permissions']>, "subscription_plan_access_permissions", ParentType, ContextType, RequireFields<Subscription_RootSubscription_Plan_Access_PermissionsArgs, never>>;
  subscription_plan_access_permissions_aggregate?: SubscriptionResolver<ResolversTypes['subscription_plan_access_permissions_aggregate'], "subscription_plan_access_permissions_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSubscription_Plan_Access_Permissions_AggregateArgs, never>>;
  subscription_plan_access_permissions_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['subscription_plan_access_permissions']>, "subscription_plan_access_permissions_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSubscription_Plan_Access_Permissions_By_PkArgs, 'id'>>;
  subscription_plan_access_permissions_stream?: SubscriptionResolver<Array<ResolversTypes['subscription_plan_access_permissions']>, "subscription_plan_access_permissions_stream", ParentType, ContextType, RequireFields<Subscription_RootSubscription_Plan_Access_Permissions_StreamArgs, 'batch_size' | 'cursor'>>;
  subscription_plan_aggregate?: SubscriptionResolver<ResolversTypes['subscription_plan_aggregate'], "subscription_plan_aggregate", ParentType, ContextType, RequireFields<Subscription_RootSubscription_Plan_AggregateArgs, never>>;
  subscription_plan_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['subscription_plan']>, "subscription_plan_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSubscription_Plan_By_PkArgs, 'id'>>;
  subscription_plan_stream?: SubscriptionResolver<Array<ResolversTypes['subscription_plan']>, "subscription_plan_stream", ParentType, ContextType, RequireFields<Subscription_RootSubscription_Plan_StreamArgs, 'batch_size' | 'cursor'>>;
  subscription_stream?: SubscriptionResolver<Array<ResolversTypes['subscription']>, "subscription_stream", ParentType, ContextType, RequireFields<Subscription_RootSubscription_StreamArgs, 'batch_size' | 'cursor'>>;
  tag?: SubscriptionResolver<Array<ResolversTypes['tag']>, "tag", ParentType, ContextType, RequireFields<Subscription_RootTagArgs, never>>;
  tag_aggregate?: SubscriptionResolver<ResolversTypes['tag_aggregate'], "tag_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTag_AggregateArgs, never>>;
  tag_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['tag']>, "tag_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTag_By_PkArgs, 'id'>>;
  tag_stream?: SubscriptionResolver<Array<ResolversTypes['tag']>, "tag_stream", ParentType, ContextType, RequireFields<Subscription_RootTag_StreamArgs, 'batch_size' | 'cursor'>>;
  team?: SubscriptionResolver<Array<ResolversTypes['team']>, "team", ParentType, ContextType, RequireFields<Subscription_RootTeamArgs, never>>;
  team_aggregate?: SubscriptionResolver<ResolversTypes['team_aggregate'], "team_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTeam_AggregateArgs, never>>;
  team_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['team']>, "team_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTeam_By_PkArgs, 'id'>>;
  team_contractor?: SubscriptionResolver<Array<ResolversTypes['team_contractor']>, "team_contractor", ParentType, ContextType, RequireFields<Subscription_RootTeam_ContractorArgs, never>>;
  team_contractor_aggregate?: SubscriptionResolver<ResolversTypes['team_contractor_aggregate'], "team_contractor_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTeam_Contractor_AggregateArgs, never>>;
  team_contractor_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['team_contractor']>, "team_contractor_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTeam_Contractor_By_PkArgs, 'id'>>;
  team_contractor_stream?: SubscriptionResolver<Array<ResolversTypes['team_contractor']>, "team_contractor_stream", ParentType, ContextType, RequireFields<Subscription_RootTeam_Contractor_StreamArgs, 'batch_size' | 'cursor'>>;
  team_manager?: SubscriptionResolver<Array<ResolversTypes['team_manager']>, "team_manager", ParentType, ContextType, RequireFields<Subscription_RootTeam_ManagerArgs, never>>;
  team_manager_aggregate?: SubscriptionResolver<ResolversTypes['team_manager_aggregate'], "team_manager_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTeam_Manager_AggregateArgs, never>>;
  team_manager_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['team_manager']>, "team_manager_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTeam_Manager_By_PkArgs, 'id'>>;
  team_manager_stream?: SubscriptionResolver<Array<ResolversTypes['team_manager']>, "team_manager_stream", ParentType, ContextType, RequireFields<Subscription_RootTeam_Manager_StreamArgs, 'batch_size' | 'cursor'>>;
  team_posting?: SubscriptionResolver<Array<ResolversTypes['team_posting']>, "team_posting", ParentType, ContextType, RequireFields<Subscription_RootTeam_PostingArgs, never>>;
  team_posting_aggregate?: SubscriptionResolver<ResolversTypes['team_posting_aggregate'], "team_posting_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTeam_Posting_AggregateArgs, never>>;
  team_posting_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['team_posting']>, "team_posting_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTeam_Posting_By_PkArgs, 'id'>>;
  team_posting_stream?: SubscriptionResolver<Array<ResolversTypes['team_posting']>, "team_posting_stream", ParentType, ContextType, RequireFields<Subscription_RootTeam_Posting_StreamArgs, 'batch_size' | 'cursor'>>;
  team_project?: SubscriptionResolver<Array<ResolversTypes['team_project']>, "team_project", ParentType, ContextType, RequireFields<Subscription_RootTeam_ProjectArgs, never>>;
  team_project_aggregate?: SubscriptionResolver<ResolversTypes['team_project_aggregate'], "team_project_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTeam_Project_AggregateArgs, never>>;
  team_project_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['team_project']>, "team_project_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTeam_Project_By_PkArgs, 'id'>>;
  team_project_stream?: SubscriptionResolver<Array<ResolversTypes['team_project']>, "team_project_stream", ParentType, ContextType, RequireFields<Subscription_RootTeam_Project_StreamArgs, 'batch_size' | 'cursor'>>;
  team_skill?: SubscriptionResolver<Array<ResolversTypes['team_skill']>, "team_skill", ParentType, ContextType, RequireFields<Subscription_RootTeam_SkillArgs, never>>;
  team_skill_aggregate?: SubscriptionResolver<ResolversTypes['team_skill_aggregate'], "team_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTeam_Skill_AggregateArgs, never>>;
  team_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['team_skill']>, "team_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTeam_Skill_By_PkArgs, 'id'>>;
  team_skill_stream?: SubscriptionResolver<Array<ResolversTypes['team_skill']>, "team_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootTeam_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  team_stream?: SubscriptionResolver<Array<ResolversTypes['team']>, "team_stream", ParentType, ContextType, RequireFields<Subscription_RootTeam_StreamArgs, 'batch_size' | 'cursor'>>;
  timesheet?: SubscriptionResolver<Array<ResolversTypes['timesheet']>, "timesheet", ParentType, ContextType, RequireFields<Subscription_RootTimesheetArgs, never>>;
  timesheet_aggregate?: SubscriptionResolver<ResolversTypes['timesheet_aggregate'], "timesheet_aggregate", ParentType, ContextType, RequireFields<Subscription_RootTimesheet_AggregateArgs, never>>;
  timesheet_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['timesheet']>, "timesheet_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTimesheet_By_PkArgs, 'id'>>;
  timesheet_stream?: SubscriptionResolver<Array<ResolversTypes['timesheet']>, "timesheet_stream", ParentType, ContextType, RequireFields<Subscription_RootTimesheet_StreamArgs, 'batch_size' | 'cursor'>>;
  type_of_visit?: SubscriptionResolver<Array<ResolversTypes['type_of_visit']>, "type_of_visit", ParentType, ContextType, RequireFields<Subscription_RootType_Of_VisitArgs, never>>;
  type_of_visit_aggregate?: SubscriptionResolver<ResolversTypes['type_of_visit_aggregate'], "type_of_visit_aggregate", ParentType, ContextType, RequireFields<Subscription_RootType_Of_Visit_AggregateArgs, never>>;
  type_of_visit_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['type_of_visit']>, "type_of_visit_by_pk", ParentType, ContextType, RequireFields<Subscription_RootType_Of_Visit_By_PkArgs, 'value'>>;
  type_of_visit_stream?: SubscriptionResolver<Array<ResolversTypes['type_of_visit']>, "type_of_visit_stream", ParentType, ContextType, RequireFields<Subscription_RootType_Of_Visit_StreamArgs, 'batch_size' | 'cursor'>>;
  unread_messages?: SubscriptionResolver<Array<ResolversTypes['unread_messages']>, "unread_messages", ParentType, ContextType, RequireFields<Subscription_RootUnread_MessagesArgs, never>>;
  unread_messages_aggregate?: SubscriptionResolver<ResolversTypes['unread_messages_aggregate'], "unread_messages_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUnread_Messages_AggregateArgs, never>>;
  unread_messages_stream?: SubscriptionResolver<Array<ResolversTypes['unread_messages']>, "unread_messages_stream", ParentType, ContextType, RequireFields<Subscription_RootUnread_Messages_StreamArgs, 'batch_size' | 'cursor'>>;
  user?: SubscriptionResolver<Array<ResolversTypes['user']>, "user", ParentType, ContextType, RequireFields<Subscription_RootUserArgs, never>>;
  user_affinda_profile?: SubscriptionResolver<Array<ResolversTypes['user_affinda_profile']>, "user_affinda_profile", ParentType, ContextType, RequireFields<Subscription_RootUser_Affinda_ProfileArgs, never>>;
  user_affinda_profile_aggregate?: SubscriptionResolver<ResolversTypes['user_affinda_profile_aggregate'], "user_affinda_profile_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Affinda_Profile_AggregateArgs, never>>;
  user_affinda_profile_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_affinda_profile']>, "user_affinda_profile_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Affinda_Profile_By_PkArgs, 'document_id'>>;
  user_affinda_profile_stream?: SubscriptionResolver<Array<ResolversTypes['user_affinda_profile']>, "user_affinda_profile_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Affinda_Profile_StreamArgs, 'batch_size' | 'cursor'>>;
  user_aggregate?: SubscriptionResolver<ResolversTypes['user_aggregate'], "user_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_AggregateArgs, never>>;
  user_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user']>, "user_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_By_PkArgs, 'id'>>;
  user_certification?: SubscriptionResolver<Array<ResolversTypes['user_certification']>, "user_certification", ParentType, ContextType, RequireFields<Subscription_RootUser_CertificationArgs, never>>;
  user_certification_aggregate?: SubscriptionResolver<ResolversTypes['user_certification_aggregate'], "user_certification_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Certification_AggregateArgs, never>>;
  user_certification_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_certification']>, "user_certification_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Certification_By_PkArgs, 'id'>>;
  user_certification_stream?: SubscriptionResolver<Array<ResolversTypes['user_certification']>, "user_certification_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Certification_StreamArgs, 'batch_size' | 'cursor'>>;
  user_company?: SubscriptionResolver<Array<ResolversTypes['user_company']>, "user_company", ParentType, ContextType, RequireFields<Subscription_RootUser_CompanyArgs, never>>;
  user_company_aggregate?: SubscriptionResolver<ResolversTypes['user_company_aggregate'], "user_company_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Company_AggregateArgs, never>>;
  user_company_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_company']>, "user_company_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Company_By_PkArgs, 'id'>>;
  user_company_stream?: SubscriptionResolver<Array<ResolversTypes['user_company']>, "user_company_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Company_StreamArgs, 'batch_size' | 'cursor'>>;
  user_conversation?: SubscriptionResolver<Array<ResolversTypes['user_conversation']>, "user_conversation", ParentType, ContextType, RequireFields<Subscription_RootUser_ConversationArgs, never>>;
  user_conversation_aggregate?: SubscriptionResolver<ResolversTypes['user_conversation_aggregate'], "user_conversation_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Conversation_AggregateArgs, never>>;
  user_conversation_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_conversation']>, "user_conversation_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Conversation_By_PkArgs, 'id'>>;
  user_conversation_stream?: SubscriptionResolver<Array<ResolversTypes['user_conversation']>, "user_conversation_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Conversation_StreamArgs, 'batch_size' | 'cursor'>>;
  user_education?: SubscriptionResolver<Array<ResolversTypes['user_education']>, "user_education", ParentType, ContextType, RequireFields<Subscription_RootUser_EducationArgs, never>>;
  user_education_aggregate?: SubscriptionResolver<ResolversTypes['user_education_aggregate'], "user_education_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Education_AggregateArgs, never>>;
  user_education_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_education']>, "user_education_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Education_By_PkArgs, 'id'>>;
  user_education_stream?: SubscriptionResolver<Array<ResolversTypes['user_education']>, "user_education_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Education_StreamArgs, 'batch_size' | 'cursor'>>;
  user_experience?: SubscriptionResolver<Array<ResolversTypes['user_experience']>, "user_experience", ParentType, ContextType, RequireFields<Subscription_RootUser_ExperienceArgs, never>>;
  user_experience_aggregate?: SubscriptionResolver<ResolversTypes['user_experience_aggregate'], "user_experience_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Experience_AggregateArgs, never>>;
  user_experience_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_experience']>, "user_experience_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Experience_By_PkArgs, 'id'>>;
  user_experience_stream?: SubscriptionResolver<Array<ResolversTypes['user_experience']>, "user_experience_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Experience_StreamArgs, 'batch_size' | 'cursor'>>;
  user_favorite?: SubscriptionResolver<Array<ResolversTypes['user_favorite']>, "user_favorite", ParentType, ContextType, RequireFields<Subscription_RootUser_FavoriteArgs, never>>;
  user_favorite_aggregate?: SubscriptionResolver<ResolversTypes['user_favorite_aggregate'], "user_favorite_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Favorite_AggregateArgs, never>>;
  user_favorite_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_favorite']>, "user_favorite_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Favorite_By_PkArgs, 'id'>>;
  user_favorite_stream?: SubscriptionResolver<Array<ResolversTypes['user_favorite']>, "user_favorite_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Favorite_StreamArgs, 'batch_size' | 'cursor'>>;
  user_industry?: SubscriptionResolver<Array<ResolversTypes['user_industry']>, "user_industry", ParentType, ContextType, RequireFields<Subscription_RootUser_IndustryArgs, never>>;
  user_industry_aggregate?: SubscriptionResolver<ResolversTypes['user_industry_aggregate'], "user_industry_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Industry_AggregateArgs, never>>;
  user_industry_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_industry']>, "user_industry_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Industry_By_PkArgs, 'id'>>;
  user_industry_stream?: SubscriptionResolver<Array<ResolversTypes['user_industry']>, "user_industry_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Industry_StreamArgs, 'batch_size' | 'cursor'>>;
  user_job_title?: SubscriptionResolver<Array<ResolversTypes['user_job_title']>, "user_job_title", ParentType, ContextType, RequireFields<Subscription_RootUser_Job_TitleArgs, never>>;
  user_job_title_aggregate?: SubscriptionResolver<ResolversTypes['user_job_title_aggregate'], "user_job_title_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Job_Title_AggregateArgs, never>>;
  user_job_title_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_job_title']>, "user_job_title_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Job_Title_By_PkArgs, 'id'>>;
  user_job_title_stream?: SubscriptionResolver<Array<ResolversTypes['user_job_title']>, "user_job_title_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Job_Title_StreamArgs, 'batch_size' | 'cursor'>>;
  user_language?: SubscriptionResolver<Array<ResolversTypes['user_language']>, "user_language", ParentType, ContextType, RequireFields<Subscription_RootUser_LanguageArgs, never>>;
  user_language_aggregate?: SubscriptionResolver<ResolversTypes['user_language_aggregate'], "user_language_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Language_AggregateArgs, never>>;
  user_language_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_language']>, "user_language_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Language_By_PkArgs, 'id'>>;
  user_language_stream?: SubscriptionResolver<Array<ResolversTypes['user_language']>, "user_language_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Language_StreamArgs, 'batch_size' | 'cursor'>>;
  user_private_data?: SubscriptionResolver<Array<ResolversTypes['user_private_data']>, "user_private_data", ParentType, ContextType, RequireFields<Subscription_RootUser_Private_DataArgs, never>>;
  user_private_data_aggregate?: SubscriptionResolver<ResolversTypes['user_private_data_aggregate'], "user_private_data_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Private_Data_AggregateArgs, never>>;
  user_private_data_stream?: SubscriptionResolver<Array<ResolversTypes['user_private_data']>, "user_private_data_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Private_Data_StreamArgs, 'batch_size' | 'cursor'>>;
  user_profile?: SubscriptionResolver<Array<ResolversTypes['user_profile']>, "user_profile", ParentType, ContextType, RequireFields<Subscription_RootUser_ProfileArgs, never>>;
  user_profile_aggregate?: SubscriptionResolver<ResolversTypes['user_profile_aggregate'], "user_profile_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Profile_AggregateArgs, never>>;
  user_profile_by_management?: SubscriptionResolver<Array<ResolversTypes['user_profile_by_management']>, "user_profile_by_management", ParentType, ContextType, RequireFields<Subscription_RootUser_Profile_By_ManagementArgs, never>>;
  user_profile_by_management_aggregate?: SubscriptionResolver<ResolversTypes['user_profile_by_management_aggregate'], "user_profile_by_management_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Profile_By_Management_AggregateArgs, never>>;
  user_profile_by_management_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_profile_by_management']>, "user_profile_by_management_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Profile_By_Management_By_PkArgs, 'added_by_id' | 'user_id'>>;
  user_profile_by_management_stream?: SubscriptionResolver<Array<ResolversTypes['user_profile_by_management']>, "user_profile_by_management_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Profile_By_Management_StreamArgs, 'batch_size' | 'cursor'>>;
  user_profile_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_profile']>, "user_profile_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Profile_By_PkArgs, 'user_id'>>;
  user_profile_stream?: SubscriptionResolver<Array<ResolversTypes['user_profile']>, "user_profile_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Profile_StreamArgs, 'batch_size' | 'cursor'>>;
  user_rating?: SubscriptionResolver<Array<ResolversTypes['user_rating']>, "user_rating", ParentType, ContextType, RequireFields<Subscription_RootUser_RatingArgs, never>>;
  user_rating_aggregate?: SubscriptionResolver<ResolversTypes['user_rating_aggregate'], "user_rating_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Rating_AggregateArgs, never>>;
  user_rating_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_rating']>, "user_rating_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Rating_By_PkArgs, 'id'>>;
  user_rating_stream?: SubscriptionResolver<Array<ResolversTypes['user_rating']>, "user_rating_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Rating_StreamArgs, 'batch_size' | 'cursor'>>;
  user_skill?: SubscriptionResolver<Array<ResolversTypes['user_skill']>, "user_skill", ParentType, ContextType, RequireFields<Subscription_RootUser_SkillArgs, never>>;
  user_skill_aggregate?: SubscriptionResolver<ResolversTypes['user_skill_aggregate'], "user_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Skill_AggregateArgs, never>>;
  user_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_skill']>, "user_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Skill_By_PkArgs, 'id'>>;
  user_skill_stream?: SubscriptionResolver<Array<ResolversTypes['user_skill']>, "user_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  user_soft_skill?: SubscriptionResolver<Array<ResolversTypes['user_soft_skill']>, "user_soft_skill", ParentType, ContextType, RequireFields<Subscription_RootUser_Soft_SkillArgs, never>>;
  user_soft_skill_aggregate?: SubscriptionResolver<ResolversTypes['user_soft_skill_aggregate'], "user_soft_skill_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Soft_Skill_AggregateArgs, never>>;
  user_soft_skill_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_soft_skill']>, "user_soft_skill_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Soft_Skill_By_PkArgs, 'id'>>;
  user_soft_skill_stream?: SubscriptionResolver<Array<ResolversTypes['user_soft_skill']>, "user_soft_skill_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Soft_Skill_StreamArgs, 'batch_size' | 'cursor'>>;
  user_stream?: SubscriptionResolver<Array<ResolversTypes['user']>, "user_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_StreamArgs, 'batch_size' | 'cursor'>>;
  user_transportation?: SubscriptionResolver<Array<ResolversTypes['user_transportation']>, "user_transportation", ParentType, ContextType, RequireFields<Subscription_RootUser_TransportationArgs, never>>;
  user_transportation_aggregate?: SubscriptionResolver<ResolversTypes['user_transportation_aggregate'], "user_transportation_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Transportation_AggregateArgs, never>>;
  user_transportation_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_transportation']>, "user_transportation_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Transportation_By_PkArgs, 'id'>>;
  user_transportation_stream?: SubscriptionResolver<Array<ResolversTypes['user_transportation']>, "user_transportation_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Transportation_StreamArgs, 'batch_size' | 'cursor'>>;
  user_watchlist?: SubscriptionResolver<Array<ResolversTypes['user_watchlist']>, "user_watchlist", ParentType, ContextType, RequireFields<Subscription_RootUser_WatchlistArgs, never>>;
  user_watchlist_aggregate?: SubscriptionResolver<ResolversTypes['user_watchlist_aggregate'], "user_watchlist_aggregate", ParentType, ContextType, RequireFields<Subscription_RootUser_Watchlist_AggregateArgs, never>>;
  user_watchlist_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['user_watchlist']>, "user_watchlist_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUser_Watchlist_By_PkArgs, 'id'>>;
  user_watchlist_stream?: SubscriptionResolver<Array<ResolversTypes['user_watchlist']>, "user_watchlist_stream", ParentType, ContextType, RequireFields<Subscription_RootUser_Watchlist_StreamArgs, 'batch_size' | 'cursor'>>;
};

export type Subscription_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_stddev_fields'] = ResolversParentTypes['subscription_stddev_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_stddev_pop_fields'] = ResolversParentTypes['subscription_stddev_pop_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_stddev_samp_fields'] = ResolversParentTypes['subscription_stddev_samp_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_sum_fields'] = ResolversParentTypes['subscription_sum_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_var_pop_fields'] = ResolversParentTypes['subscription_var_pop_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_var_samp_fields'] = ResolversParentTypes['subscription_var_samp_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_variance_fields'] = ResolversParentTypes['subscription_variance_fields']> = {
  current_period_end?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['tag'] = ResolversParentTypes['tag']> = {
  contractors?: Resolver<Array<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<TagContractorsArgs, never>>;
  contractors_aggregate?: Resolver<ResolversTypes['contractor_aggregate'], ParentType, ContextType, RequireFields<TagContractors_AggregateArgs, never>>;
  custom_requests?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<TagCustom_RequestsArgs, never>>;
  custom_requests_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<TagCustom_Requests_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  posting_tags?: Resolver<Array<ResolversTypes['posting_tags']>, ParentType, ContextType, RequireFields<TagPosting_TagsArgs, never>>;
  posting_tags_aggregate?: Resolver<ResolversTypes['posting_tags_aggregate'], ParentType, ContextType, RequireFields<TagPosting_Tags_AggregateArgs, never>>;
  project_activity_tags?: Resolver<Array<ResolversTypes['project_activity_tag']>, ParentType, ContextType, RequireFields<TagProject_Activity_TagsArgs, never>>;
  project_activity_tags_aggregate?: Resolver<ResolversTypes['project_activity_tag_aggregate'], ParentType, ContextType, RequireFields<TagProject_Activity_Tags_AggregateArgs, never>>;
  project_tags?: Resolver<Array<ResolversTypes['project_tag']>, ParentType, ContextType, RequireFields<TagProject_TagsArgs, never>>;
  project_tags_aggregate?: Resolver<ResolversTypes['project_tag_aggregate'], ParentType, ContextType, RequireFields<TagProject_Tags_AggregateArgs, never>>;
  resource_information_cards?: Resolver<Array<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<TagResource_Information_CardsArgs, never>>;
  resource_information_cards_aggregate?: Resolver<ResolversTypes['resource_information_card_aggregate'], ParentType, ContextType, RequireFields<TagResource_Information_Cards_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Tag_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['tag_aggregate'] = ResolversParentTypes['tag_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['tag_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Tag_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['tag_aggregate_fields'] = ResolversParentTypes['tag_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Tag_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['tag_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['tag_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Tag_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['tag_max_fields'] = ResolversParentTypes['tag_max_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Tag_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['tag_min_fields'] = ResolversParentTypes['tag_min_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Tag_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['tag_mutation_response'] = ResolversParentTypes['tag_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['team'] = ResolversParentTypes['team']> = {
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  contractors?: Resolver<Array<ResolversTypes['team_contractor']>, ParentType, ContextType, RequireFields<TeamContractorsArgs, never>>;
  contractors_aggregate?: Resolver<ResolversTypes['team_contractor_aggregate'], ParentType, ContextType, RequireFields<TeamContractors_AggregateArgs, never>>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['document']>, ParentType, ContextType, RequireFields<TeamDocumentsArgs, never>>;
  documents_aggregate?: Resolver<ResolversTypes['document_aggregate'], ParentType, ContextType, RequireFields<TeamDocuments_AggregateArgs, never>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managers?: Resolver<Array<ResolversTypes['team_manager']>, ParentType, ContextType, RequireFields<TeamManagersArgs, never>>;
  managers_aggregate?: Resolver<ResolversTypes['team_manager_aggregate'], ParentType, ContextType, RequireFields<TeamManagers_AggregateArgs, never>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postings?: Resolver<Array<ResolversTypes['team_posting']>, ParentType, ContextType, RequireFields<TeamPostingsArgs, never>>;
  postings_aggregate?: Resolver<ResolversTypes['team_posting_aggregate'], ParentType, ContextType, RequireFields<TeamPostings_AggregateArgs, never>>;
  projects?: Resolver<Array<ResolversTypes['team_project']>, ParentType, ContextType, RequireFields<TeamProjectsArgs, never>>;
  projects_aggregate?: Resolver<ResolversTypes['team_project_aggregate'], ParentType, ContextType, RequireFields<TeamProjects_AggregateArgs, never>>;
  skills?: Resolver<Array<ResolversTypes['team_skill']>, ParentType, ContextType, RequireFields<TeamSkillsArgs, never>>;
  skills_aggregate?: Resolver<ResolversTypes['team_skill_aggregate'], ParentType, ContextType, RequireFields<TeamSkills_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_aggregate'] = ResolversParentTypes['team_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['team_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['team']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_aggregate_fields'] = ResolversParentTypes['team_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Team_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['team_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['team_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_ContractorResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_contractor'] = ResolversParentTypes['team_contractor']> = {
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  team?: Resolver<ResolversTypes['team'], ParentType, ContextType>;
  team_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Contractor_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_contractor_aggregate'] = ResolversParentTypes['team_contractor_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['team_contractor_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['team_contractor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Contractor_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_contractor_aggregate_fields'] = ResolversParentTypes['team_contractor_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Team_Contractor_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['team_contractor_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['team_contractor_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Contractor_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_contractor_max_fields'] = ResolversParentTypes['team_contractor_max_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Contractor_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_contractor_min_fields'] = ResolversParentTypes['team_contractor_min_fields']> = {
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Contractor_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_contractor_mutation_response'] = ResolversParentTypes['team_contractor_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['team_contractor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_ManagerResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_manager'] = ResolversParentTypes['team_manager']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  manager?: Resolver<ResolversTypes['manager'], ParentType, ContextType>;
  manager_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  team?: Resolver<ResolversTypes['team'], ParentType, ContextType>;
  team_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Manager_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_manager_aggregate'] = ResolversParentTypes['team_manager_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['team_manager_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['team_manager']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Manager_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_manager_aggregate_fields'] = ResolversParentTypes['team_manager_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Team_Manager_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['team_manager_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['team_manager_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Manager_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_manager_max_fields'] = ResolversParentTypes['team_manager_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Manager_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_manager_min_fields'] = ResolversParentTypes['team_manager_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  manager_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Manager_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_manager_mutation_response'] = ResolversParentTypes['team_manager_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['team_manager']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_max_fields'] = ResolversParentTypes['team_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_min_fields'] = ResolversParentTypes['team_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_mutation_response'] = ResolversParentTypes['team_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['team']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_PostingResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_posting'] = ResolversParentTypes['team_posting']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  posting?: Resolver<ResolversTypes['posting'], ParentType, ContextType>;
  posting_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  team?: Resolver<ResolversTypes['team'], ParentType, ContextType>;
  team_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Posting_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_posting_aggregate'] = ResolversParentTypes['team_posting_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['team_posting_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['team_posting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Posting_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_posting_aggregate_fields'] = ResolversParentTypes['team_posting_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Team_Posting_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['team_posting_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['team_posting_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Posting_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_posting_max_fields'] = ResolversParentTypes['team_posting_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Posting_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_posting_min_fields'] = ResolversParentTypes['team_posting_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  posting_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Posting_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_posting_mutation_response'] = ResolversParentTypes['team_posting_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['team_posting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_project'] = ResolversParentTypes['team_project']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  project?: Resolver<ResolversTypes['project'], ParentType, ContextType>;
  project_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  team?: Resolver<ResolversTypes['team'], ParentType, ContextType>;
  team_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Project_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_project_aggregate'] = ResolversParentTypes['team_project_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['team_project_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['team_project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Project_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_project_aggregate_fields'] = ResolversParentTypes['team_project_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Team_Project_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['team_project_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['team_project_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Project_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_project_max_fields'] = ResolversParentTypes['team_project_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Project_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_project_min_fields'] = ResolversParentTypes['team_project_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  project_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Project_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_project_mutation_response'] = ResolversParentTypes['team_project_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['team_project']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill'] = ResolversParentTypes['team_skill']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['skill'], ParentType, ContextType>;
  skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  team?: Resolver<ResolversTypes['team'], ParentType, ContextType>;
  team_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_aggregate'] = ResolversParentTypes['team_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['team_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['team_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_aggregate_fields'] = ResolversParentTypes['team_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['team_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Team_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['team_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['team_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['team_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['team_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['team_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['team_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['team_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['team_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['team_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_avg_fields'] = ResolversParentTypes['team_skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_max_fields'] = ResolversParentTypes['team_skill_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_min_fields'] = ResolversParentTypes['team_skill_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  team_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_mutation_response'] = ResolversParentTypes['team_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['team_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_stddev_fields'] = ResolversParentTypes['team_skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_stddev_pop_fields'] = ResolversParentTypes['team_skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_stddev_samp_fields'] = ResolversParentTypes['team_skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_sum_fields'] = ResolversParentTypes['team_skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_var_pop_fields'] = ResolversParentTypes['team_skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_var_samp_fields'] = ResolversParentTypes['team_skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Team_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['team_skill_variance_fields'] = ResolversParentTypes['team_skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['time'], any> {
  name: 'time';
}

export type TimesheetResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet'] = ResolversParentTypes['timesheet']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  approved_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor?: Resolver<ResolversTypes['contractor'], ParentType, ContextType>;
  contractor_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<ResolversTypes['date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  is_new?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  project_activity_times?: Resolver<Array<ResolversTypes['project_activity_time']>, ParentType, ContextType, RequireFields<TimesheetProject_Activity_TimesArgs, never>>;
  project_activity_times_aggregate?: Resolver<ResolversTypes['project_activity_time_aggregate'], ParentType, ContextType, RequireFields<TimesheetProject_Activity_Times_AggregateArgs, never>>;
  project_activity_tracked_times?: Resolver<Array<ResolversTypes['project_activity_tracked_time']>, ParentType, ContextType, RequireFields<TimesheetProject_Activity_Tracked_TimesArgs, never>>;
  project_activity_tracked_times_aggregate?: Resolver<ResolversTypes['project_activity_tracked_time_aggregate'], ParentType, ContextType, RequireFields<TimesheetProject_Activity_Tracked_Times_AggregateArgs, never>>;
  reject_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<ResolversTypes['date'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_aggregate'] = ResolversParentTypes['timesheet_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['timesheet_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['timesheet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_aggregate_fields'] = ResolversParentTypes['timesheet_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['timesheet_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Timesheet_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['timesheet_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['timesheet_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['timesheet_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['timesheet_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['timesheet_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['timesheet_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['timesheet_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['timesheet_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['timesheet_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_avg_fields'] = ResolversParentTypes['timesheet_avg_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_max_fields'] = ResolversParentTypes['timesheet_max_fields']> = {
  approved_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  reject_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_min_fields'] = ResolversParentTypes['timesheet_min_fields']> = {
  approved_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  contractor_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  reject_reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tracked_time?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_mutation_response'] = ResolversParentTypes['timesheet_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['timesheet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_stddev_fields'] = ResolversParentTypes['timesheet_stddev_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_stddev_pop_fields'] = ResolversParentTypes['timesheet_stddev_pop_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_stddev_samp_fields'] = ResolversParentTypes['timesheet_stddev_samp_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_sum_fields'] = ResolversParentTypes['timesheet_sum_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['float8']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_var_pop_fields'] = ResolversParentTypes['timesheet_var_pop_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_var_samp_fields'] = ResolversParentTypes['timesheet_var_samp_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Timesheet_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['timesheet_variance_fields'] = ResolversParentTypes['timesheet_variance_fields']> = {
  tracked_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamp'], any> {
  name: 'timestamp';
}

export interface TimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamptz'], any> {
  name: 'timestamptz';
}

export interface TimetzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timetz'], any> {
  name: 'timetz';
}

export type Type_Of_VisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['type_of_visit'] = ResolversParentTypes['type_of_visit']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Type_Of_Visit_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['type_of_visit_aggregate'] = ResolversParentTypes['type_of_visit_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['type_of_visit_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['type_of_visit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Type_Of_Visit_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['type_of_visit_aggregate_fields'] = ResolversParentTypes['type_of_visit_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Type_Of_Visit_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['type_of_visit_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['type_of_visit_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Type_Of_Visit_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['type_of_visit_max_fields'] = ResolversParentTypes['type_of_visit_max_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Type_Of_Visit_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['type_of_visit_min_fields'] = ResolversParentTypes['type_of_visit_min_fields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Type_Of_Visit_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['type_of_visit_mutation_response'] = ResolversParentTypes['type_of_visit_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['type_of_visit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_MessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages'] = ResolversParentTypes['unread_messages']> = {
  conversation?: Resolver<Maybe<ResolversTypes['conversation']>, ParentType, ContextType>;
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  recipient?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  recipient_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_aggregate'] = ResolversParentTypes['unread_messages_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['unread_messages_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['unread_messages']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_aggregate_fields'] = ResolversParentTypes['unread_messages_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['unread_messages_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<Unread_Messages_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['unread_messages_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['unread_messages_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['unread_messages_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['unread_messages_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['unread_messages_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['unread_messages_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['unread_messages_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['unread_messages_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['unread_messages_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_avg_fields'] = ResolversParentTypes['unread_messages_avg_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_max_fields'] = ResolversParentTypes['unread_messages_max_fields']> = {
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  recipient_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_min_fields'] = ResolversParentTypes['unread_messages_min_fields']> = {
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  recipient_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_stddev_fields'] = ResolversParentTypes['unread_messages_stddev_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_stddev_pop_fields'] = ResolversParentTypes['unread_messages_stddev_pop_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_stddev_samp_fields'] = ResolversParentTypes['unread_messages_stddev_samp_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_sum_fields'] = ResolversParentTypes['unread_messages_sum_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_var_pop_fields'] = ResolversParentTypes['unread_messages_var_pop_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_var_samp_fields'] = ResolversParentTypes['unread_messages_var_samp_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Unread_Messages_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['unread_messages_variance_fields'] = ResolversParentTypes['unread_messages_variance_fields']> = {
  not_notified_by_email?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  not_notified_in_app?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unread_count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['user'] = ResolversParentTypes['user']> = {
  admin?: Resolver<Maybe<ResolversTypes['admin']>, ParentType, ContextType>;
  applications?: Resolver<Array<ResolversTypes['application']>, ParentType, ContextType, RequireFields<UserApplicationsArgs, never>>;
  applicationsByInterviewedBy?: Resolver<Array<ResolversTypes['application']>, ParentType, ContextType, RequireFields<UserApplicationsByInterviewedByArgs, never>>;
  applicationsByInterviewedBy_aggregate?: Resolver<ResolversTypes['application_aggregate'], ParentType, ContextType, RequireFields<UserApplicationsByInterviewedBy_AggregateArgs, never>>;
  applications_aggregate?: Resolver<ResolversTypes['application_aggregate'], ParentType, ContextType, RequireFields<UserApplications_AggregateArgs, never>>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attached_documents?: Resolver<Array<ResolversTypes['document_user']>, ParentType, ContextType, RequireFields<UserAttached_DocumentsArgs, never>>;
  attached_documents_aggregate?: Resolver<ResolversTypes['document_user_aggregate'], ParentType, ContextType, RequireFields<UserAttached_Documents_AggregateArgs, never>>;
  available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  candidates?: Resolver<Array<ResolversTypes['candidate']>, ParentType, ContextType, RequireFields<UserCandidatesArgs, never>>;
  candidates_aggregate?: Resolver<ResolversTypes['candidate_aggregate'], ParentType, ContextType, RequireFields<UserCandidates_AggregateArgs, never>>;
  certifications?: Resolver<Array<ResolversTypes['user_certification']>, ParentType, ContextType, RequireFields<UserCertificationsArgs, never>>;
  certifications_aggregate?: Resolver<ResolversTypes['user_certification_aggregate'], ParentType, ContextType, RequireFields<UserCertifications_AggregateArgs, never>>;
  companies?: Resolver<Array<ResolversTypes['user_company']>, ParentType, ContextType, RequireFields<UserCompaniesArgs, never>>;
  companiesByCreatedBy?: Resolver<Array<ResolversTypes['company']>, ParentType, ContextType, RequireFields<UserCompaniesByCreatedByArgs, never>>;
  companiesByCreatedBy_aggregate?: Resolver<ResolversTypes['company_aggregate'], ParentType, ContextType, RequireFields<UserCompaniesByCreatedBy_AggregateArgs, never>>;
  companies_aggregate?: Resolver<ResolversTypes['user_company_aggregate'], ParentType, ContextType, RequireFields<UserCompanies_AggregateArgs, never>>;
  company_followers?: Resolver<Array<ResolversTypes['company_follower']>, ParentType, ContextType, RequireFields<UserCompany_FollowersArgs, never>>;
  company_followers_aggregate?: Resolver<ResolversTypes['company_follower_aggregate'], ParentType, ContextType, RequireFields<UserCompany_Followers_AggregateArgs, never>>;
  company_notifications?: Resolver<Array<ResolversTypes['company_user_notifications']>, ParentType, ContextType, RequireFields<UserCompany_NotificationsArgs, never>>;
  company_notifications_aggregate?: Resolver<ResolversTypes['company_user_notifications_aggregate'], ParentType, ContextType, RequireFields<UserCompany_Notifications_AggregateArgs, never>>;
  confirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  consent_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  consent_given?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  contractor_notes?: Resolver<Array<ResolversTypes['contractor_note']>, ParentType, ContextType, RequireFields<UserContractor_NotesArgs, never>>;
  contractor_notes_aggregate?: Resolver<ResolversTypes['contractor_note_aggregate'], ParentType, ContextType, RequireFields<UserContractor_Notes_AggregateArgs, never>>;
  contractor_ratings?: Resolver<Array<ResolversTypes['contractor_rating']>, ParentType, ContextType, RequireFields<UserContractor_RatingsArgs, never>>;
  contractor_ratings_aggregate?: Resolver<ResolversTypes['contractor_rating_aggregate'], ParentType, ContextType, RequireFields<UserContractor_Ratings_AggregateArgs, never>>;
  contracts?: Resolver<Array<ResolversTypes['contractor']>, ParentType, ContextType, RequireFields<UserContractsArgs, never>>;
  contracts_aggregate?: Resolver<ResolversTypes['contractor_aggregate'], ParentType, ContextType, RequireFields<UserContracts_AggregateArgs, never>>;
  conversations?: Resolver<Array<ResolversTypes['user_conversation']>, ParentType, ContextType, RequireFields<UserConversationsArgs, never>>;
  conversations_aggregate?: Resolver<ResolversTypes['user_conversation_aggregate'], ParentType, ContextType, RequireFields<UserConversations_AggregateArgs, never>>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  customRequestsByUpdatedById?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<UserCustomRequestsByUpdatedByIdArgs, never>>;
  customRequestsByUpdatedById_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<UserCustomRequestsByUpdatedById_AggregateArgs, never>>;
  custom_requests?: Resolver<Array<ResolversTypes['custom_request']>, ParentType, ContextType, RequireFields<UserCustom_RequestsArgs, never>>;
  custom_requests_aggregate?: Resolver<ResolversTypes['custom_request_aggregate'], ParentType, ContextType, RequireFields<UserCustom_Requests_AggregateArgs, never>>;
  declined_visit_matches?: Resolver<Array<ResolversTypes['declined_visit_matches']>, ParentType, ContextType, RequireFields<UserDeclined_Visit_MatchesArgs, never>>;
  declined_visit_matches_aggregate?: Resolver<ResolversTypes['declined_visit_matches_aggregate'], ParentType, ContextType, RequireFields<UserDeclined_Visit_Matches_AggregateArgs, never>>;
  document_custom_requests?: Resolver<Array<ResolversTypes['document_custom_request']>, ParentType, ContextType, RequireFields<UserDocument_Custom_RequestsArgs, never>>;
  document_custom_requests_aggregate?: Resolver<ResolversTypes['document_custom_request_aggregate'], ParentType, ContextType, RequireFields<UserDocument_Custom_Requests_AggregateArgs, never>>;
  documents?: Resolver<Array<ResolversTypes['document']>, ParentType, ContextType, RequireFields<UserDocumentsArgs, never>>;
  documents_aggregate?: Resolver<ResolversTypes['document_aggregate'], ParentType, ContextType, RequireFields<UserDocuments_AggregateArgs, never>>;
  educations?: Resolver<Array<ResolversTypes['user_education']>, ParentType, ContextType, RequireFields<UserEducationsArgs, never>>;
  educations_aggregate?: Resolver<ResolversTypes['user_education_aggregate'], ParentType, ContextType, RequireFields<UserEducations_AggregateArgs, never>>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emergency_contact?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, RequireFields<UserEmergency_ContactArgs, never>>;
  experiences?: Resolver<Array<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<UserExperiencesArgs, never>>;
  experiences_aggregate?: Resolver<ResolversTypes['user_experience_aggregate'], ParentType, ContextType, RequireFields<UserExperiences_AggregateArgs, never>>;
  family_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  favorited_by_users?: Resolver<Array<ResolversTypes['user_favorite']>, ParentType, ContextType, RequireFields<UserFavorited_By_UsersArgs, never>>;
  favorited_by_users_aggregate?: Resolver<ResolversTypes['user_favorite_aggregate'], ParentType, ContextType, RequireFields<UserFavorited_By_Users_AggregateArgs, never>>;
  favorited_users?: Resolver<Array<ResolversTypes['user_favorite']>, ParentType, ContextType, RequireFields<UserFavorited_UsersArgs, never>>;
  favorited_users_aggregate?: Resolver<ResolversTypes['user_favorite_aggregate'], ParentType, ContextType, RequireFields<UserFavorited_Users_AggregateArgs, never>>;
  given_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  invitations?: Resolver<Array<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<UserInvitationsArgs, never>>;
  invitationsByInvitedBy?: Resolver<Array<ResolversTypes['invitation']>, ParentType, ContextType, RequireFields<UserInvitationsByInvitedByArgs, never>>;
  invitationsByInvitedBy_aggregate?: Resolver<ResolversTypes['invitation_aggregate'], ParentType, ContextType, RequireFields<UserInvitationsByInvitedBy_AggregateArgs, never>>;
  invitations_aggregate?: Resolver<ResolversTypes['invitation_aggregate'], ParentType, ContextType, RequireFields<UserInvitations_AggregateArgs, never>>;
  invited_by?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['invoice']>, ParentType, ContextType, RequireFields<UserInvoicesArgs, never>>;
  invoices_aggregate?: Resolver<ResolversTypes['invoice_aggregate'], ParentType, ContextType, RequireFields<UserInvoices_AggregateArgs, never>>;
  is_public?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['manager']>, ParentType, ContextType>;
  manager_contractors?: Resolver<Array<ResolversTypes['manager_contractor']>, ParentType, ContextType, RequireFields<UserManager_ContractorsArgs, never>>;
  manager_contractors_aggregate?: Resolver<ResolversTypes['manager_contractor_aggregate'], ParentType, ContextType, RequireFields<UserManager_Contractors_AggregateArgs, never>>;
  marketplace?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType, RequireFields<UserMessagesArgs, never>>;
  messages_aggregate?: Resolver<ResolversTypes['message_aggregate'], ParentType, ContextType, RequireFields<UserMessages_AggregateArgs, never>>;
  onboardings?: Resolver<Array<ResolversTypes['onboarding']>, ParentType, ContextType, RequireFields<UserOnboardingsArgs, never>>;
  onboardings_aggregate?: Resolver<ResolversTypes['onboarding_aggregate'], ParentType, ContextType, RequireFields<UserOnboardings_AggregateArgs, never>>;
  payment_cards?: Resolver<Array<ResolversTypes['payment_card']>, ParentType, ContextType, RequireFields<UserPayment_CardsArgs, never>>;
  payment_cards_aggregate?: Resolver<ResolversTypes['payment_card_aggregate'], ParentType, ContextType, RequireFields<UserPayment_Cards_AggregateArgs, never>>;
  pending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pending_invite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  private_data?: Resolver<Maybe<ResolversTypes['user_private_data']>, ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes['user_profile']>, ParentType, ContextType>;
  profile_completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  projectActivityRequestMoreHoursByActorId?: Resolver<Array<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<UserProjectActivityRequestMoreHoursByActorIdArgs, never>>;
  projectActivityRequestMoreHoursByActorId_aggregate?: Resolver<ResolversTypes['project_activity_request_more_hours_aggregate'], ParentType, ContextType, RequireFields<UserProjectActivityRequestMoreHoursByActorId_AggregateArgs, never>>;
  project_activities?: Resolver<Array<ResolversTypes['project_activity']>, ParentType, ContextType, RequireFields<UserProject_ActivitiesArgs, never>>;
  project_activities_aggregate?: Resolver<ResolversTypes['project_activity_aggregate'], ParentType, ContextType, RequireFields<UserProject_Activities_AggregateArgs, never>>;
  project_activity_request_more_hours?: Resolver<Array<ResolversTypes['project_activity_request_more_hours']>, ParentType, ContextType, RequireFields<UserProject_Activity_Request_More_HoursArgs, never>>;
  project_activity_request_more_hours_aggregate?: Resolver<ResolversTypes['project_activity_request_more_hours_aggregate'], ParentType, ContextType, RequireFields<UserProject_Activity_Request_More_Hours_AggregateArgs, never>>;
  rated_by_users?: Resolver<Array<ResolversTypes['user_rating']>, ParentType, ContextType, RequireFields<UserRated_By_UsersArgs, never>>;
  rated_by_users_aggregate?: Resolver<ResolversTypes['user_rating_aggregate'], ParentType, ContextType, RequireFields<UserRated_By_Users_AggregateArgs, never>>;
  rated_users?: Resolver<Array<ResolversTypes['user_rating']>, ParentType, ContextType, RequireFields<UserRated_UsersArgs, never>>;
  rated_users_aggregate?: Resolver<ResolversTypes['user_rating_aggregate'], ParentType, ContextType, RequireFields<UserRated_Users_AggregateArgs, never>>;
  recipient_messages?: Resolver<Array<ResolversTypes['recipient_message']>, ParentType, ContextType, RequireFields<UserRecipient_MessagesArgs, never>>;
  recipient_messages_aggregate?: Resolver<ResolversTypes['recipient_message_aggregate'], ParentType, ContextType, RequireFields<UserRecipient_Messages_AggregateArgs, never>>;
  resource_information_cards?: Resolver<Array<ResolversTypes['resource_information_card']>, ParentType, ContextType, RequireFields<UserResource_Information_CardsArgs, never>>;
  resource_information_cards_aggregate?: Resolver<ResolversTypes['resource_information_card_aggregate'], ParentType, ContextType, RequireFields<UserResource_Information_Cards_AggregateArgs, never>>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  skills?: Resolver<Array<ResolversTypes['skill']>, ParentType, ContextType, RequireFields<UserSkillsArgs, never>>;
  skills_aggregate?: Resolver<ResolversTypes['skill_aggregate'], ParentType, ContextType, RequireFields<UserSkills_AggregateArgs, never>>;
  smart_match_bookmarks?: Resolver<Array<ResolversTypes['smart_match_bookmark']>, ParentType, ContextType, RequireFields<UserSmart_Match_BookmarksArgs, never>>;
  smart_match_bookmarks_aggregate?: Resolver<ResolversTypes['smart_match_bookmark_aggregate'], ParentType, ContextType, RequireFields<UserSmart_Match_Bookmarks_AggregateArgs, never>>;
  soft_skills?: Resolver<Array<ResolversTypes['soft_skill']>, ParentType, ContextType, RequireFields<UserSoft_SkillsArgs, never>>;
  soft_skills_aggregate?: Resolver<ResolversTypes['soft_skill_aggregate'], ParentType, ContextType, RequireFields<UserSoft_Skills_AggregateArgs, never>>;
  stripe_customer_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscription_required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userProfileByManagementsByAddedById?: Resolver<Array<ResolversTypes['user_profile_by_management']>, ParentType, ContextType, RequireFields<UserUserProfileByManagementsByAddedByIdArgs, never>>;
  userProfileByManagementsByAddedById_aggregate?: Resolver<ResolversTypes['user_profile_by_management_aggregate'], ParentType, ContextType, RequireFields<UserUserProfileByManagementsByAddedById_AggregateArgs, never>>;
  user_experiences?: Resolver<Array<ResolversTypes['user_experience']>, ParentType, ContextType, RequireFields<UserUser_ExperiencesArgs, never>>;
  user_experiences_aggregate?: Resolver<ResolversTypes['user_experience_aggregate'], ParentType, ContextType, RequireFields<UserUser_Experiences_AggregateArgs, never>>;
  user_job_titles?: Resolver<Array<ResolversTypes['user_job_title']>, ParentType, ContextType, RequireFields<UserUser_Job_TitlesArgs, never>>;
  user_job_titles_aggregate?: Resolver<ResolversTypes['user_job_title_aggregate'], ParentType, ContextType, RequireFields<UserUser_Job_Titles_AggregateArgs, never>>;
  user_profile_by_managements?: Resolver<Array<ResolversTypes['user_profile_by_management']>, ParentType, ContextType, RequireFields<UserUser_Profile_By_ManagementsArgs, never>>;
  user_profile_by_managements_aggregate?: Resolver<ResolversTypes['user_profile_by_management_aggregate'], ParentType, ContextType, RequireFields<UserUser_Profile_By_Managements_AggregateArgs, never>>;
  user_skills?: Resolver<Array<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<UserUser_SkillsArgs, never>>;
  user_skills_aggregate?: Resolver<ResolversTypes['user_skill_aggregate'], ParentType, ContextType, RequireFields<UserUser_Skills_AggregateArgs, never>>;
  user_soft_skills?: Resolver<Array<ResolversTypes['user_soft_skill']>, ParentType, ContextType, RequireFields<UserUser_Soft_SkillsArgs, never>>;
  user_soft_skills_aggregate?: Resolver<ResolversTypes['user_soft_skill_aggregate'], ParentType, ContextType, RequireFields<UserUser_Soft_Skills_AggregateArgs, never>>;
  user_transportations?: Resolver<Array<ResolversTypes['user_transportation']>, ParentType, ContextType, RequireFields<UserUser_TransportationsArgs, never>>;
  user_transportations_aggregate?: Resolver<ResolversTypes['user_transportation_aggregate'], ParentType, ContextType, RequireFields<UserUser_Transportations_AggregateArgs, never>>;
  watched_by_users?: Resolver<Array<ResolversTypes['user_watchlist']>, ParentType, ContextType, RequireFields<UserWatched_By_UsersArgs, never>>;
  watched_by_users_aggregate?: Resolver<ResolversTypes['user_watchlist_aggregate'], ParentType, ContextType, RequireFields<UserWatched_By_Users_AggregateArgs, never>>;
  watched_users?: Resolver<Array<ResolversTypes['user_watchlist']>, ParentType, ContextType, RequireFields<UserWatched_UsersArgs, never>>;
  watched_users_aggregate?: Resolver<ResolversTypes['user_watchlist_aggregate'], ParentType, ContextType, RequireFields<UserWatched_Users_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Affinda_ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_affinda_profile'] = ResolversParentTypes['user_affinda_profile']> = {
  document_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Affinda_Profile_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_affinda_profile_aggregate'] = ResolversParentTypes['user_affinda_profile_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_affinda_profile_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_affinda_profile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Affinda_Profile_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_affinda_profile_aggregate_fields'] = ResolversParentTypes['user_affinda_profile_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Affinda_Profile_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_affinda_profile_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_affinda_profile_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Affinda_Profile_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_affinda_profile_max_fields'] = ResolversParentTypes['user_affinda_profile_max_fields']> = {
  document_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Affinda_Profile_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_affinda_profile_min_fields'] = ResolversParentTypes['user_affinda_profile_min_fields']> = {
  document_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Affinda_Profile_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_affinda_profile_mutation_response'] = ResolversParentTypes['user_affinda_profile_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_affinda_profile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_aggregate'] = ResolversParentTypes['user_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_aggregate_fields'] = ResolversParentTypes['user_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_avg_fields'] = ResolversParentTypes['user_avg_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_CertificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification'] = ResolversParentTypes['user_certification']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_aggregate'] = ResolversParentTypes['user_certification_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_certification_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_certification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_aggregate_fields'] = ResolversParentTypes['user_certification_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_certification_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Certification_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_certification_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_certification_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_certification_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_certification_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_certification_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_certification_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_certification_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_certification_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_certification_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_avg_fields'] = ResolversParentTypes['user_certification_avg_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_max_fields'] = ResolversParentTypes['user_certification_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_min_fields'] = ResolversParentTypes['user_certification_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_mutation_response'] = ResolversParentTypes['user_certification_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_certification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_stddev_fields'] = ResolversParentTypes['user_certification_stddev_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_stddev_pop_fields'] = ResolversParentTypes['user_certification_stddev_pop_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_stddev_samp_fields'] = ResolversParentTypes['user_certification_stddev_samp_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_sum_fields'] = ResolversParentTypes['user_certification_sum_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_var_pop_fields'] = ResolversParentTypes['user_certification_var_pop_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_var_samp_fields'] = ResolversParentTypes['user_certification_var_samp_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Certification_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_certification_variance_fields'] = ResolversParentTypes['user_certification_variance_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_company'] = ResolversParentTypes['user_company']> = {
  company?: Resolver<ResolversTypes['company'], ParentType, ContextType>;
  company_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Company_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_company_aggregate'] = ResolversParentTypes['user_company_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_company_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Company_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_company_aggregate_fields'] = ResolversParentTypes['user_company_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Company_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_company_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_company_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Company_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_company_max_fields'] = ResolversParentTypes['user_company_max_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Company_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_company_min_fields'] = ResolversParentTypes['user_company_min_fields']> = {
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Company_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_company_mutation_response'] = ResolversParentTypes['user_company_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_ConversationResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_conversation'] = ResolversParentTypes['user_conversation']> = {
  conversation?: Resolver<ResolversTypes['conversation'], ParentType, ContextType>;
  conversation_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Conversation_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_conversation_aggregate'] = ResolversParentTypes['user_conversation_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_conversation_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_conversation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Conversation_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_conversation_aggregate_fields'] = ResolversParentTypes['user_conversation_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Conversation_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_conversation_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_conversation_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Conversation_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_conversation_max_fields'] = ResolversParentTypes['user_conversation_max_fields']> = {
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Conversation_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_conversation_min_fields'] = ResolversParentTypes['user_conversation_min_fields']> = {
  conversation_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Conversation_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_conversation_mutation_response'] = ResolversParentTypes['user_conversation_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_conversation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_EducationResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education'] = ResolversParentTypes['user_education']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_aggregate'] = ResolversParentTypes['user_education_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_education_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_education']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_aggregate_fields'] = ResolversParentTypes['user_education_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_education_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Education_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_education_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_education_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_education_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_education_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_education_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_education_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_education_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_education_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_education_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_avg_fields'] = ResolversParentTypes['user_education_avg_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_max_fields'] = ResolversParentTypes['user_education_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_min_fields'] = ResolversParentTypes['user_education_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  institution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_mutation_response'] = ResolversParentTypes['user_education_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_education']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_stddev_fields'] = ResolversParentTypes['user_education_stddev_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_stddev_pop_fields'] = ResolversParentTypes['user_education_stddev_pop_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_stddev_samp_fields'] = ResolversParentTypes['user_education_stddev_samp_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_sum_fields'] = ResolversParentTypes['user_education_sum_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_var_pop_fields'] = ResolversParentTypes['user_education_var_pop_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_var_samp_fields'] = ResolversParentTypes['user_education_var_samp_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Education_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_education_variance_fields'] = ResolversParentTypes['user_education_variance_fields']> = {
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_ExperienceResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience'] = ResolversParentTypes['user_experience']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  employment_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['industry']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ongoing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  skills?: Resolver<Array<ResolversTypes['experience_skill']>, ParentType, ContextType, RequireFields<User_ExperienceSkillsArgs, never>>;
  skills_aggregate?: Resolver<ResolversTypes['experience_skill_aggregate'], ParentType, ContextType, RequireFields<User_ExperienceSkills_AggregateArgs, never>>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_aggregate'] = ResolversParentTypes['user_experience_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_experience_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_experience']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_aggregate_fields'] = ResolversParentTypes['user_experience_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_experience_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Experience_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_experience_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_experience_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_experience_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_experience_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_experience_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_experience_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_experience_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_experience_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_experience_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_avg_fields'] = ResolversParentTypes['user_experience_avg_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_max_fields'] = ResolversParentTypes['user_experience_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  employment_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_min_fields'] = ResolversParentTypes['user_experience_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  employment_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start_date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_mutation_response'] = ResolversParentTypes['user_experience_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_experience']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_stddev_fields'] = ResolversParentTypes['user_experience_stddev_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_stddev_pop_fields'] = ResolversParentTypes['user_experience_stddev_pop_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_stddev_samp_fields'] = ResolversParentTypes['user_experience_stddev_samp_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_sum_fields'] = ResolversParentTypes['user_experience_sum_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_var_pop_fields'] = ResolversParentTypes['user_experience_var_pop_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_var_samp_fields'] = ResolversParentTypes['user_experience_var_samp_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Experience_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_experience_variance_fields'] = ResolversParentTypes['user_experience_variance_fields']> = {
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_FavoriteResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_favorite'] = ResolversParentTypes['user_favorite']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  favorited?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  favorited_by?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  favorited_by_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  favorited_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Favorite_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_favorite_aggregate'] = ResolversParentTypes['user_favorite_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_favorite_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_favorite']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Favorite_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_favorite_aggregate_fields'] = ResolversParentTypes['user_favorite_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Favorite_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_favorite_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_favorite_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Favorite_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_favorite_max_fields'] = ResolversParentTypes['user_favorite_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  favorited_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  favorited_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Favorite_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_favorite_min_fields'] = ResolversParentTypes['user_favorite_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  favorited_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  favorited_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Favorite_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_favorite_mutation_response'] = ResolversParentTypes['user_favorite_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_favorite']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_IndustryResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry'] = ResolversParentTypes['user_industry']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['industry'], ParentType, ContextType>;
  industry_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user_profile'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user_profile?: Resolver<Maybe<ResolversTypes['user_profile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_aggregate'] = ResolversParentTypes['user_industry_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_industry_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_industry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_aggregate_fields'] = ResolversParentTypes['user_industry_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_industry_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Industry_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_industry_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_industry_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_industry_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_industry_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_industry_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_industry_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_industry_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_industry_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_industry_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_avg_fields'] = ResolversParentTypes['user_industry_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_max_fields'] = ResolversParentTypes['user_industry_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_min_fields'] = ResolversParentTypes['user_industry_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_mutation_response'] = ResolversParentTypes['user_industry_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_industry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_stddev_fields'] = ResolversParentTypes['user_industry_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_stddev_pop_fields'] = ResolversParentTypes['user_industry_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_stddev_samp_fields'] = ResolversParentTypes['user_industry_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_sum_fields'] = ResolversParentTypes['user_industry_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_var_pop_fields'] = ResolversParentTypes['user_industry_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_var_samp_fields'] = ResolversParentTypes['user_industry_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Industry_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_industry_variance_fields'] = ResolversParentTypes['user_industry_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  industry_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_TitleResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title'] = ResolversParentTypes['user_job_title']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['company']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  job_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_profiles?: Resolver<Array<ResolversTypes['user_profile']>, ParentType, ContextType, RequireFields<User_Job_TitleUser_ProfilesArgs, never>>;
  user_profiles_aggregate?: Resolver<ResolversTypes['user_profile_aggregate'], ParentType, ContextType, RequireFields<User_Job_TitleUser_Profiles_AggregateArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_aggregate'] = ResolversParentTypes['user_job_title_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_job_title_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_job_title']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_aggregate_fields'] = ResolversParentTypes['user_job_title_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_job_title_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Job_Title_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_job_title_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_job_title_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_job_title_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_job_title_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_job_title_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_job_title_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_job_title_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_job_title_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_job_title_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_avg_fields'] = ResolversParentTypes['user_job_title_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_max_fields'] = ResolversParentTypes['user_job_title_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_min_fields'] = ResolversParentTypes['user_job_title_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  company_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_mutation_response'] = ResolversParentTypes['user_job_title_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_job_title']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_stddev_fields'] = ResolversParentTypes['user_job_title_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_stddev_pop_fields'] = ResolversParentTypes['user_job_title_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_stddev_samp_fields'] = ResolversParentTypes['user_job_title_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_sum_fields'] = ResolversParentTypes['user_job_title_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_var_pop_fields'] = ResolversParentTypes['user_job_title_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_var_samp_fields'] = ResolversParentTypes['user_job_title_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Job_Title_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_job_title_variance_fields'] = ResolversParentTypes['user_job_title_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_LanguageResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language'] = ResolversParentTypes['user_language']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  language?: Resolver<ResolversTypes['language'], ParentType, ContextType>;
  language_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  proficiency_level?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user_profile'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user_profile?: Resolver<Maybe<ResolversTypes['user_profile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_aggregate'] = ResolversParentTypes['user_language_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_language_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_language']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_aggregate_fields'] = ResolversParentTypes['user_language_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_language_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Language_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_language_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_language_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_language_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_language_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_language_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_language_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_language_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_language_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_language_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_avg_fields'] = ResolversParentTypes['user_language_avg_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_max_fields'] = ResolversParentTypes['user_language_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  language_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_min_fields'] = ResolversParentTypes['user_language_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  language_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_mutation_response'] = ResolversParentTypes['user_language_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_language']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_stddev_fields'] = ResolversParentTypes['user_language_stddev_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_stddev_pop_fields'] = ResolversParentTypes['user_language_stddev_pop_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_stddev_samp_fields'] = ResolversParentTypes['user_language_stddev_samp_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_sum_fields'] = ResolversParentTypes['user_language_sum_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_var_pop_fields'] = ResolversParentTypes['user_language_var_pop_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_var_samp_fields'] = ResolversParentTypes['user_language_var_samp_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Language_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_language_variance_fields'] = ResolversParentTypes['user_language_variance_fields']> = {
  language_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  proficiency_level?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_max_fields'] = ResolversParentTypes['user_max_fields']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consent_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  given_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_customer_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_min_fields'] = ResolversParentTypes['user_min_fields']> = {
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consent_at?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  created_by?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  family_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  given_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stripe_customer_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_mutation_response'] = ResolversParentTypes['user_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_DataResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data'] = ResolversParentTypes['user_private_data']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_aggregate'] = ResolversParentTypes['user_private_data_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_private_data_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_private_data']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_aggregate_fields'] = ResolversParentTypes['user_private_data_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_private_data_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Private_Data_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_private_data_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_private_data_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_private_data_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_private_data_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_private_data_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_private_data_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_private_data_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_private_data_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_private_data_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_avg_fields'] = ResolversParentTypes['user_private_data_avg_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_max_fields'] = ResolversParentTypes['user_private_data_max_fields']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_min_fields'] = ResolversParentTypes['user_private_data_min_fields']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_mutation_response'] = ResolversParentTypes['user_private_data_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_private_data']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_stddev_fields'] = ResolversParentTypes['user_private_data_stddev_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_stddev_pop_fields'] = ResolversParentTypes['user_private_data_stddev_pop_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_stddev_samp_fields'] = ResolversParentTypes['user_private_data_stddev_samp_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_sum_fields'] = ResolversParentTypes['user_private_data_sum_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_var_pop_fields'] = ResolversParentTypes['user_private_data_var_pop_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_var_samp_fields'] = ResolversParentTypes['user_private_data_var_samp_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Private_Data_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_private_data_variance_fields'] = ResolversParentTypes['user_private_data_variance_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile'] = ResolversParentTypes['user_profile']> = {
  DNU_flag?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  demo_reel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  industries?: Resolver<Array<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<User_ProfileIndustriesArgs, never>>;
  industries_aggregate?: Resolver<ResolversTypes['user_industry_aggregate'], ParentType, ContextType, RequireFields<User_ProfileIndustries_AggregateArgs, never>>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  languages?: Resolver<Array<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<User_ProfileLanguagesArgs, never>>;
  languages_aggregate?: Resolver<ResolversTypes['user_language_aggregate'], ParentType, ContextType, RequireFields<User_ProfileLanguages_AggregateArgs, never>>;
  max_available_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skills?: Resolver<Array<ResolversTypes['user_skill']>, ParentType, ContextType, RequireFields<User_ProfileSkillsArgs, never>>;
  skills_aggregate?: Resolver<ResolversTypes['user_skill_aggregate'], ParentType, ContextType, RequireFields<User_ProfileSkills_AggregateArgs, never>>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transportation?: Resolver<Array<ResolversTypes['user_transportation']>, ParentType, ContextType, RequireFields<User_ProfileTransportationArgs, never>>;
  transportation_aggregate?: Resolver<ResolversTypes['user_transportation_aggregate'], ParentType, ContextType, RequireFields<User_ProfileTransportation_AggregateArgs, never>>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  user_industries?: Resolver<Array<ResolversTypes['user_industry']>, ParentType, ContextType, RequireFields<User_ProfileUser_IndustriesArgs, never>>;
  user_industries_aggregate?: Resolver<ResolversTypes['user_industry_aggregate'], ParentType, ContextType, RequireFields<User_ProfileUser_Industries_AggregateArgs, never>>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user_job_title?: Resolver<Maybe<ResolversTypes['user_job_title']>, ParentType, ContextType>;
  user_languages?: Resolver<Array<ResolversTypes['user_language']>, ParentType, ContextType, RequireFields<User_ProfileUser_LanguagesArgs, never>>;
  user_languages_aggregate?: Resolver<ResolversTypes['user_language_aggregate'], ParentType, ContextType, RequireFields<User_ProfileUser_Languages_AggregateArgs, never>>;
  user_soft_skills?: Resolver<Array<ResolversTypes['user_soft_skill']>, ParentType, ContextType, RequireFields<User_ProfileUser_Soft_SkillsArgs, never>>;
  user_soft_skills_aggregate?: Resolver<ResolversTypes['user_soft_skill_aggregate'], ParentType, ContextType, RequireFields<User_ProfileUser_Soft_Skills_AggregateArgs, never>>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  work_samples?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_aggregate'] = ResolversParentTypes['user_profile_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_profile_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_profile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_aggregate_fields'] = ResolversParentTypes['user_profile_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_profile_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Profile_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_profile_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_profile_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_profile_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_profile_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_profile_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_profile_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_profile_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_profile_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_profile_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_avg_fields'] = ResolversParentTypes['user_profile_avg_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_ManagementResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management'] = ResolversParentTypes['user_profile_by_management']> = {
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  added_by_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  demo_reel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  userByUserId?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  work_samples?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_aggregate'] = ResolversParentTypes['user_profile_by_management_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_profile_by_management_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_profile_by_management']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_aggregate_fields'] = ResolversParentTypes['user_profile_by_management_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_profile_by_management_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Profile_By_Management_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_profile_by_management_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_profile_by_management_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_profile_by_management_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_profile_by_management_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_profile_by_management_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_profile_by_management_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_profile_by_management_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_profile_by_management_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_profile_by_management_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_avg_fields'] = ResolversParentTypes['user_profile_by_management_avg_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_max_fields'] = ResolversParentTypes['user_profile_by_management_max_fields']> = {
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  demo_reel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  work_samples?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_min_fields'] = ResolversParentTypes['user_profile_by_management_min_fields']> = {
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  demo_reel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  work_samples?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_mutation_response'] = ResolversParentTypes['user_profile_by_management_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_profile_by_management']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_stddev_fields'] = ResolversParentTypes['user_profile_by_management_stddev_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_stddev_pop_fields'] = ResolversParentTypes['user_profile_by_management_stddev_pop_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_stddev_samp_fields'] = ResolversParentTypes['user_profile_by_management_stddev_samp_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_sum_fields'] = ResolversParentTypes['user_profile_by_management_sum_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_var_pop_fields'] = ResolversParentTypes['user_profile_by_management_var_pop_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_var_samp_fields'] = ResolversParentTypes['user_profile_by_management_var_samp_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_By_Management_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_by_management_variance_fields'] = ResolversParentTypes['user_profile_by_management_variance_fields']> = {
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_max_fields'] = ResolversParentTypes['user_profile_max_fields']> = {
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  demo_reel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_available_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  work_samples?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_min_fields'] = ResolversParentTypes['user_profile_min_fields']> = {
  about?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['currency']>, ParentType, ContextType>;
  demo_reel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  job_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max_available_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  occupation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resume?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  work_samples?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_mutation_response'] = ResolversParentTypes['user_profile_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_profile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_stddev_fields'] = ResolversParentTypes['user_profile_stddev_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_stddev_pop_fields'] = ResolversParentTypes['user_profile_stddev_pop_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_stddev_samp_fields'] = ResolversParentTypes['user_profile_stddev_samp_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_sum_fields'] = ResolversParentTypes['user_profile_sum_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_var_pop_fields'] = ResolversParentTypes['user_profile_var_pop_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_var_samp_fields'] = ResolversParentTypes['user_profile_var_samp_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Profile_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_profile_variance_fields'] = ResolversParentTypes['user_profile_variance_fields']> = {
  max_available_hours?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user_job_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year_of_experience?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_RatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating'] = ResolversParentTypes['user_rating']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  rated_by_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  rated_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  userByRatedById?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_aggregate'] = ResolversParentTypes['user_rating_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_rating_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_rating']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_aggregate_fields'] = ResolversParentTypes['user_rating_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_rating_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Rating_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_rating_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_rating_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_rating_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_rating_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_rating_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_rating_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_rating_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_rating_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_rating_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_avg_fields'] = ResolversParentTypes['user_rating_avg_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_max_fields'] = ResolversParentTypes['user_rating_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  rated_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  rated_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_min_fields'] = ResolversParentTypes['user_rating_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  rated_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  rated_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_mutation_response'] = ResolversParentTypes['user_rating_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_rating']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_stddev_fields'] = ResolversParentTypes['user_rating_stddev_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_stddev_pop_fields'] = ResolversParentTypes['user_rating_stddev_pop_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_stddev_samp_fields'] = ResolversParentTypes['user_rating_stddev_samp_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_sum_fields'] = ResolversParentTypes['user_rating_sum_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_var_pop_fields'] = ResolversParentTypes['user_rating_var_pop_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_var_samp_fields'] = ResolversParentTypes['user_rating_var_samp_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Rating_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_rating_variance_fields'] = ResolversParentTypes['user_rating_variance_fields']> = {
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill'] = ResolversParentTypes['user_skill']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  skill?: Resolver<ResolversTypes['skill'], ParentType, ContextType>;
  skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user_profile'], ParentType, ContextType>;
  userByAddedById?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_aggregate'] = ResolversParentTypes['user_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_aggregate_fields'] = ResolversParentTypes['user_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_avg_fields'] = ResolversParentTypes['user_skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_max_fields'] = ResolversParentTypes['user_skill_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_min_fields'] = ResolversParentTypes['user_skill_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_mutation_response'] = ResolversParentTypes['user_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_stddev_fields'] = ResolversParentTypes['user_skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_stddev_pop_fields'] = ResolversParentTypes['user_skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_stddev_samp_fields'] = ResolversParentTypes['user_skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_sum_fields'] = ResolversParentTypes['user_skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_var_pop_fields'] = ResolversParentTypes['user_skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_var_samp_fields'] = ResolversParentTypes['user_skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_skill_variance_fields'] = ResolversParentTypes['user_skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_SkillResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill'] = ResolversParentTypes['user_soft_skill']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  soft_skill?: Resolver<ResolversTypes['soft_skill'], ParentType, ContextType>;
  soft_skill_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updated_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  userByAddedById?: Resolver<ResolversTypes['user_profile'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_aggregate'] = ResolversParentTypes['user_soft_skill_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_soft_skill_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_aggregate_fields'] = ResolversParentTypes['user_soft_skill_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['user_soft_skill_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Soft_Skill_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_soft_skill_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_soft_skill_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['user_soft_skill_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['user_soft_skill_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['user_soft_skill_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['user_soft_skill_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['user_soft_skill_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['user_soft_skill_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['user_soft_skill_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_avg_fields'] = ResolversParentTypes['user_soft_skill_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_max_fields'] = ResolversParentTypes['user_soft_skill_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_min_fields'] = ResolversParentTypes['user_soft_skill_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_mutation_response'] = ResolversParentTypes['user_soft_skill_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_soft_skill']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_stddev_fields'] = ResolversParentTypes['user_soft_skill_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_stddev_pop_fields'] = ResolversParentTypes['user_soft_skill_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_stddev_samp_fields'] = ResolversParentTypes['user_soft_skill_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_sum_fields'] = ResolversParentTypes['user_soft_skill_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_var_pop_fields'] = ResolversParentTypes['user_soft_skill_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_var_samp_fields'] = ResolversParentTypes['user_soft_skill_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Soft_Skill_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_soft_skill_variance_fields'] = ResolversParentTypes['user_soft_skill_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soft_skill_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_stddev_fields'] = ResolversParentTypes['user_stddev_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_stddev_pop_fields'] = ResolversParentTypes['user_stddev_pop_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_stddev_samp_fields'] = ResolversParentTypes['user_stddev_samp_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_sum_fields'] = ResolversParentTypes['user_sum_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['bigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_TransportationResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_transportation'] = ResolversParentTypes['user_transportation']> = {
  added_by_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  transportation_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Transportation_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_transportation_aggregate'] = ResolversParentTypes['user_transportation_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_transportation_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_transportation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Transportation_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_transportation_aggregate_fields'] = ResolversParentTypes['user_transportation_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Transportation_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_transportation_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_transportation_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Transportation_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_transportation_max_fields'] = ResolversParentTypes['user_transportation_max_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  transportation_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Transportation_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_transportation_min_fields'] = ResolversParentTypes['user_transportation_min_fields']> = {
  added_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  transportation_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Transportation_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_transportation_mutation_response'] = ResolversParentTypes['user_transportation_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_transportation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_var_pop_fields'] = ResolversParentTypes['user_var_pop_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_var_samp_fields'] = ResolversParentTypes['user_var_samp_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_variance_fields'] = ResolversParentTypes['user_variance_fields']> = {
  phone?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_WatchlistResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_watchlist'] = ResolversParentTypes['user_watchlist']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  watched?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  watched_by?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  watched_by_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  watched_id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Watchlist_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_watchlist_aggregate'] = ResolversParentTypes['user_watchlist_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['user_watchlist_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user_watchlist']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Watchlist_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_watchlist_aggregate_fields'] = ResolversParentTypes['user_watchlist_aggregate_fields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<User_Watchlist_Aggregate_FieldsCountArgs, never>>;
  max?: Resolver<Maybe<ResolversTypes['user_watchlist_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['user_watchlist_min_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Watchlist_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_watchlist_max_fields'] = ResolversParentTypes['user_watchlist_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  watched_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  watched_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Watchlist_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_watchlist_min_fields'] = ResolversParentTypes['user_watchlist_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  watched_by_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  watched_id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type User_Watchlist_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['user_watchlist_mutation_response'] = ResolversParentTypes['user_watchlist_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user_watchlist']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['uuid'], any> {
  name: 'uuid';
}

export type Resolvers<ContextType = any> = {
  admin?: AdminResolvers<ContextType>;
  admin_aggregate?: Admin_AggregateResolvers<ContextType>;
  admin_aggregate_fields?: Admin_Aggregate_FieldsResolvers<ContextType>;
  admin_max_fields?: Admin_Max_FieldsResolvers<ContextType>;
  admin_min_fields?: Admin_Min_FieldsResolvers<ContextType>;
  admin_mutation_response?: Admin_Mutation_ResponseResolvers<ContextType>;
  applicant_enum?: GraphQLScalarType;
  application?: ApplicationResolvers<ContextType>;
  application_aggregate?: Application_AggregateResolvers<ContextType>;
  application_aggregate_fields?: Application_Aggregate_FieldsResolvers<ContextType>;
  application_max_fields?: Application_Max_FieldsResolvers<ContextType>;
  application_min_fields?: Application_Min_FieldsResolvers<ContextType>;
  application_mutation_response?: Application_Mutation_ResponseResolvers<ContextType>;
  bigint?: GraphQLScalarType;
  candidate?: CandidateResolvers<ContextType>;
  candidate_aggregate?: Candidate_AggregateResolvers<ContextType>;
  candidate_aggregate_fields?: Candidate_Aggregate_FieldsResolvers<ContextType>;
  candidate_max_fields?: Candidate_Max_FieldsResolvers<ContextType>;
  candidate_min_fields?: Candidate_Min_FieldsResolvers<ContextType>;
  candidate_mutation_response?: Candidate_Mutation_ResponseResolvers<ContextType>;
  chart_admin_contractors?: Chart_Admin_ContractorsResolvers<ContextType>;
  chart_admin_contractors_aggregate?: Chart_Admin_Contractors_AggregateResolvers<ContextType>;
  chart_admin_contractors_aggregate_fields?: Chart_Admin_Contractors_Aggregate_FieldsResolvers<ContextType>;
  chart_admin_contractors_avg_fields?: Chart_Admin_Contractors_Avg_FieldsResolvers<ContextType>;
  chart_admin_contractors_max_fields?: Chart_Admin_Contractors_Max_FieldsResolvers<ContextType>;
  chart_admin_contractors_min_fields?: Chart_Admin_Contractors_Min_FieldsResolvers<ContextType>;
  chart_admin_contractors_stddev_fields?: Chart_Admin_Contractors_Stddev_FieldsResolvers<ContextType>;
  chart_admin_contractors_stddev_pop_fields?: Chart_Admin_Contractors_Stddev_Pop_FieldsResolvers<ContextType>;
  chart_admin_contractors_stddev_samp_fields?: Chart_Admin_Contractors_Stddev_Samp_FieldsResolvers<ContextType>;
  chart_admin_contractors_sum_fields?: Chart_Admin_Contractors_Sum_FieldsResolvers<ContextType>;
  chart_admin_contractors_var_pop_fields?: Chart_Admin_Contractors_Var_Pop_FieldsResolvers<ContextType>;
  chart_admin_contractors_var_samp_fields?: Chart_Admin_Contractors_Var_Samp_FieldsResolvers<ContextType>;
  chart_admin_contractors_variance_fields?: Chart_Admin_Contractors_Variance_FieldsResolvers<ContextType>;
  chart_manager_contractors?: Chart_Manager_ContractorsResolvers<ContextType>;
  chart_manager_contractors_aggregate?: Chart_Manager_Contractors_AggregateResolvers<ContextType>;
  chart_manager_contractors_aggregate_fields?: Chart_Manager_Contractors_Aggregate_FieldsResolvers<ContextType>;
  chart_manager_contractors_avg_fields?: Chart_Manager_Contractors_Avg_FieldsResolvers<ContextType>;
  chart_manager_contractors_max_fields?: Chart_Manager_Contractors_Max_FieldsResolvers<ContextType>;
  chart_manager_contractors_min_fields?: Chart_Manager_Contractors_Min_FieldsResolvers<ContextType>;
  chart_manager_contractors_stddev_fields?: Chart_Manager_Contractors_Stddev_FieldsResolvers<ContextType>;
  chart_manager_contractors_stddev_pop_fields?: Chart_Manager_Contractors_Stddev_Pop_FieldsResolvers<ContextType>;
  chart_manager_contractors_stddev_samp_fields?: Chart_Manager_Contractors_Stddev_Samp_FieldsResolvers<ContextType>;
  chart_manager_contractors_sum_fields?: Chart_Manager_Contractors_Sum_FieldsResolvers<ContextType>;
  chart_manager_contractors_var_pop_fields?: Chart_Manager_Contractors_Var_Pop_FieldsResolvers<ContextType>;
  chart_manager_contractors_var_samp_fields?: Chart_Manager_Contractors_Var_Samp_FieldsResolvers<ContextType>;
  chart_manager_contractors_variance_fields?: Chart_Manager_Contractors_Variance_FieldsResolvers<ContextType>;
  chart_projects?: Chart_ProjectsResolvers<ContextType>;
  chart_projects_aggregate?: Chart_Projects_AggregateResolvers<ContextType>;
  chart_projects_aggregate_fields?: Chart_Projects_Aggregate_FieldsResolvers<ContextType>;
  chart_projects_avg_fields?: Chart_Projects_Avg_FieldsResolvers<ContextType>;
  chart_projects_max_fields?: Chart_Projects_Max_FieldsResolvers<ContextType>;
  chart_projects_min_fields?: Chart_Projects_Min_FieldsResolvers<ContextType>;
  chart_projects_stddev_fields?: Chart_Projects_Stddev_FieldsResolvers<ContextType>;
  chart_projects_stddev_pop_fields?: Chart_Projects_Stddev_Pop_FieldsResolvers<ContextType>;
  chart_projects_stddev_samp_fields?: Chart_Projects_Stddev_Samp_FieldsResolvers<ContextType>;
  chart_projects_sum_fields?: Chart_Projects_Sum_FieldsResolvers<ContextType>;
  chart_projects_var_pop_fields?: Chart_Projects_Var_Pop_FieldsResolvers<ContextType>;
  chart_projects_var_samp_fields?: Chart_Projects_Var_Samp_FieldsResolvers<ContextType>;
  chart_projects_variance_fields?: Chart_Projects_Variance_FieldsResolvers<ContextType>;
  checkin_status?: Checkin_StatusResolvers<ContextType>;
  checkin_status_aggregate?: Checkin_Status_AggregateResolvers<ContextType>;
  checkin_status_aggregate_fields?: Checkin_Status_Aggregate_FieldsResolvers<ContextType>;
  checkin_status_max_fields?: Checkin_Status_Max_FieldsResolvers<ContextType>;
  checkin_status_min_fields?: Checkin_Status_Min_FieldsResolvers<ContextType>;
  checkin_status_mutation_response?: Checkin_Status_Mutation_ResponseResolvers<ContextType>;
  checkout_status?: Checkout_StatusResolvers<ContextType>;
  checkout_status_aggregate?: Checkout_Status_AggregateResolvers<ContextType>;
  checkout_status_aggregate_fields?: Checkout_Status_Aggregate_FieldsResolvers<ContextType>;
  checkout_status_max_fields?: Checkout_Status_Max_FieldsResolvers<ContextType>;
  checkout_status_min_fields?: Checkout_Status_Min_FieldsResolvers<ContextType>;
  checkout_status_mutation_response?: Checkout_Status_Mutation_ResponseResolvers<ContextType>;
  client_care_plan?: Client_Care_PlanResolvers<ContextType>;
  client_care_plan_aggregate?: Client_Care_Plan_AggregateResolvers<ContextType>;
  client_care_plan_aggregate_fields?: Client_Care_Plan_Aggregate_FieldsResolvers<ContextType>;
  client_care_plan_max_fields?: Client_Care_Plan_Max_FieldsResolvers<ContextType>;
  client_care_plan_min_fields?: Client_Care_Plan_Min_FieldsResolvers<ContextType>;
  client_care_plan_mutation_response?: Client_Care_Plan_Mutation_ResponseResolvers<ContextType>;
  client_medications?: Client_MedicationsResolvers<ContextType>;
  client_medications_aggregate?: Client_Medications_AggregateResolvers<ContextType>;
  client_medications_aggregate_fields?: Client_Medications_Aggregate_FieldsResolvers<ContextType>;
  client_medications_max_fields?: Client_Medications_Max_FieldsResolvers<ContextType>;
  client_medications_min_fields?: Client_Medications_Min_FieldsResolvers<ContextType>;
  client_medications_mutation_response?: Client_Medications_Mutation_ResponseResolvers<ContextType>;
  company?: CompanyResolvers<ContextType>;
  company_aggregate?: Company_AggregateResolvers<ContextType>;
  company_aggregate_fields?: Company_Aggregate_FieldsResolvers<ContextType>;
  company_avg_fields?: Company_Avg_FieldsResolvers<ContextType>;
  company_follower?: Company_FollowerResolvers<ContextType>;
  company_follower_aggregate?: Company_Follower_AggregateResolvers<ContextType>;
  company_follower_aggregate_fields?: Company_Follower_Aggregate_FieldsResolvers<ContextType>;
  company_follower_max_fields?: Company_Follower_Max_FieldsResolvers<ContextType>;
  company_follower_min_fields?: Company_Follower_Min_FieldsResolvers<ContextType>;
  company_follower_mutation_response?: Company_Follower_Mutation_ResponseResolvers<ContextType>;
  company_managers_view_all_contractors_access?: GraphQLScalarType;
  company_marketplace_access?: GraphQLScalarType;
  company_max_fields?: Company_Max_FieldsResolvers<ContextType>;
  company_min_fields?: Company_Min_FieldsResolvers<ContextType>;
  company_mutation_response?: Company_Mutation_ResponseResolvers<ContextType>;
  company_stddev_fields?: Company_Stddev_FieldsResolvers<ContextType>;
  company_stddev_pop_fields?: Company_Stddev_Pop_FieldsResolvers<ContextType>;
  company_stddev_samp_fields?: Company_Stddev_Samp_FieldsResolvers<ContextType>;
  company_sum_fields?: Company_Sum_FieldsResolvers<ContextType>;
  company_user_notifications?: Company_User_NotificationsResolvers<ContextType>;
  company_user_notifications_aggregate?: Company_User_Notifications_AggregateResolvers<ContextType>;
  company_user_notifications_aggregate_fields?: Company_User_Notifications_Aggregate_FieldsResolvers<ContextType>;
  company_user_notifications_max_fields?: Company_User_Notifications_Max_FieldsResolvers<ContextType>;
  company_user_notifications_min_fields?: Company_User_Notifications_Min_FieldsResolvers<ContextType>;
  company_user_notifications_mutation_response?: Company_User_Notifications_Mutation_ResponseResolvers<ContextType>;
  company_var_pop_fields?: Company_Var_Pop_FieldsResolvers<ContextType>;
  company_var_samp_fields?: Company_Var_Samp_FieldsResolvers<ContextType>;
  company_variance_fields?: Company_Variance_FieldsResolvers<ContextType>;
  contractor?: ContractorResolvers<ContextType>;
  contractor_aggregate?: Contractor_AggregateResolvers<ContextType>;
  contractor_aggregate_fields?: Contractor_Aggregate_FieldsResolvers<ContextType>;
  contractor_avg_fields?: Contractor_Avg_FieldsResolvers<ContextType>;
  contractor_max_fields?: Contractor_Max_FieldsResolvers<ContextType>;
  contractor_min_fields?: Contractor_Min_FieldsResolvers<ContextType>;
  contractor_mutation_response?: Contractor_Mutation_ResponseResolvers<ContextType>;
  contractor_note?: Contractor_NoteResolvers<ContextType>;
  contractor_note_aggregate?: Contractor_Note_AggregateResolvers<ContextType>;
  contractor_note_aggregate_fields?: Contractor_Note_Aggregate_FieldsResolvers<ContextType>;
  contractor_note_max_fields?: Contractor_Note_Max_FieldsResolvers<ContextType>;
  contractor_note_min_fields?: Contractor_Note_Min_FieldsResolvers<ContextType>;
  contractor_note_mutation_response?: Contractor_Note_Mutation_ResponseResolvers<ContextType>;
  contractor_posting?: Contractor_PostingResolvers<ContextType>;
  contractor_posting_aggregate?: Contractor_Posting_AggregateResolvers<ContextType>;
  contractor_posting_aggregate_fields?: Contractor_Posting_Aggregate_FieldsResolvers<ContextType>;
  contractor_posting_avg_fields?: Contractor_Posting_Avg_FieldsResolvers<ContextType>;
  contractor_posting_max_fields?: Contractor_Posting_Max_FieldsResolvers<ContextType>;
  contractor_posting_min_fields?: Contractor_Posting_Min_FieldsResolvers<ContextType>;
  contractor_posting_mutation_response?: Contractor_Posting_Mutation_ResponseResolvers<ContextType>;
  contractor_posting_stddev_fields?: Contractor_Posting_Stddev_FieldsResolvers<ContextType>;
  contractor_posting_stddev_pop_fields?: Contractor_Posting_Stddev_Pop_FieldsResolvers<ContextType>;
  contractor_posting_stddev_samp_fields?: Contractor_Posting_Stddev_Samp_FieldsResolvers<ContextType>;
  contractor_posting_sum_fields?: Contractor_Posting_Sum_FieldsResolvers<ContextType>;
  contractor_posting_var_pop_fields?: Contractor_Posting_Var_Pop_FieldsResolvers<ContextType>;
  contractor_posting_var_samp_fields?: Contractor_Posting_Var_Samp_FieldsResolvers<ContextType>;
  contractor_posting_variance_fields?: Contractor_Posting_Variance_FieldsResolvers<ContextType>;
  contractor_project?: Contractor_ProjectResolvers<ContextType>;
  contractor_project_aggregate?: Contractor_Project_AggregateResolvers<ContextType>;
  contractor_project_aggregate_fields?: Contractor_Project_Aggregate_FieldsResolvers<ContextType>;
  contractor_project_max_fields?: Contractor_Project_Max_FieldsResolvers<ContextType>;
  contractor_project_min_fields?: Contractor_Project_Min_FieldsResolvers<ContextType>;
  contractor_project_mutation_response?: Contractor_Project_Mutation_ResponseResolvers<ContextType>;
  contractor_rating?: Contractor_RatingResolvers<ContextType>;
  contractor_rating_aggregate?: Contractor_Rating_AggregateResolvers<ContextType>;
  contractor_rating_aggregate_fields?: Contractor_Rating_Aggregate_FieldsResolvers<ContextType>;
  contractor_rating_avg_fields?: Contractor_Rating_Avg_FieldsResolvers<ContextType>;
  contractor_rating_max_fields?: Contractor_Rating_Max_FieldsResolvers<ContextType>;
  contractor_rating_min_fields?: Contractor_Rating_Min_FieldsResolvers<ContextType>;
  contractor_rating_mutation_response?: Contractor_Rating_Mutation_ResponseResolvers<ContextType>;
  contractor_rating_stddev_fields?: Contractor_Rating_Stddev_FieldsResolvers<ContextType>;
  contractor_rating_stddev_pop_fields?: Contractor_Rating_Stddev_Pop_FieldsResolvers<ContextType>;
  contractor_rating_stddev_samp_fields?: Contractor_Rating_Stddev_Samp_FieldsResolvers<ContextType>;
  contractor_rating_sum_fields?: Contractor_Rating_Sum_FieldsResolvers<ContextType>;
  contractor_rating_var_pop_fields?: Contractor_Rating_Var_Pop_FieldsResolvers<ContextType>;
  contractor_rating_var_samp_fields?: Contractor_Rating_Var_Samp_FieldsResolvers<ContextType>;
  contractor_rating_variance_fields?: Contractor_Rating_Variance_FieldsResolvers<ContextType>;
  contractor_staff_note?: Contractor_Staff_NoteResolvers<ContextType>;
  contractor_staff_note_aggregate?: Contractor_Staff_Note_AggregateResolvers<ContextType>;
  contractor_staff_note_aggregate_fields?: Contractor_Staff_Note_Aggregate_FieldsResolvers<ContextType>;
  contractor_staff_note_max_fields?: Contractor_Staff_Note_Max_FieldsResolvers<ContextType>;
  contractor_staff_note_min_fields?: Contractor_Staff_Note_Min_FieldsResolvers<ContextType>;
  contractor_staff_note_mutation_response?: Contractor_Staff_Note_Mutation_ResponseResolvers<ContextType>;
  contractor_stddev_fields?: Contractor_Stddev_FieldsResolvers<ContextType>;
  contractor_stddev_pop_fields?: Contractor_Stddev_Pop_FieldsResolvers<ContextType>;
  contractor_stddev_samp_fields?: Contractor_Stddev_Samp_FieldsResolvers<ContextType>;
  contractor_sum_fields?: Contractor_Sum_FieldsResolvers<ContextType>;
  contractor_var_pop_fields?: Contractor_Var_Pop_FieldsResolvers<ContextType>;
  contractor_var_samp_fields?: Contractor_Var_Samp_FieldsResolvers<ContextType>;
  contractor_variance_fields?: Contractor_Variance_FieldsResolvers<ContextType>;
  conversation?: ConversationResolvers<ContextType>;
  conversation_aggregate?: Conversation_AggregateResolvers<ContextType>;
  conversation_aggregate_fields?: Conversation_Aggregate_FieldsResolvers<ContextType>;
  conversation_max_fields?: Conversation_Max_FieldsResolvers<ContextType>;
  conversation_min_fields?: Conversation_Min_FieldsResolvers<ContextType>;
  conversation_mutation_response?: Conversation_Mutation_ResponseResolvers<ContextType>;
  currency?: GraphQLScalarType;
  custom_request?: Custom_RequestResolvers<ContextType>;
  custom_request_aggregate?: Custom_Request_AggregateResolvers<ContextType>;
  custom_request_aggregate_fields?: Custom_Request_Aggregate_FieldsResolvers<ContextType>;
  custom_request_max_fields?: Custom_Request_Max_FieldsResolvers<ContextType>;
  custom_request_min_fields?: Custom_Request_Min_FieldsResolvers<ContextType>;
  custom_request_mutation_response?: Custom_Request_Mutation_ResponseResolvers<ContextType>;
  custom_request_skills?: Custom_Request_SkillsResolvers<ContextType>;
  custom_request_skills_aggregate?: Custom_Request_Skills_AggregateResolvers<ContextType>;
  custom_request_skills_aggregate_fields?: Custom_Request_Skills_Aggregate_FieldsResolvers<ContextType>;
  custom_request_skills_avg_fields?: Custom_Request_Skills_Avg_FieldsResolvers<ContextType>;
  custom_request_skills_max_fields?: Custom_Request_Skills_Max_FieldsResolvers<ContextType>;
  custom_request_skills_min_fields?: Custom_Request_Skills_Min_FieldsResolvers<ContextType>;
  custom_request_skills_mutation_response?: Custom_Request_Skills_Mutation_ResponseResolvers<ContextType>;
  custom_request_skills_stddev_fields?: Custom_Request_Skills_Stddev_FieldsResolvers<ContextType>;
  custom_request_skills_stddev_pop_fields?: Custom_Request_Skills_Stddev_Pop_FieldsResolvers<ContextType>;
  custom_request_skills_stddev_samp_fields?: Custom_Request_Skills_Stddev_Samp_FieldsResolvers<ContextType>;
  custom_request_skills_sum_fields?: Custom_Request_Skills_Sum_FieldsResolvers<ContextType>;
  custom_request_skills_var_pop_fields?: Custom_Request_Skills_Var_Pop_FieldsResolvers<ContextType>;
  custom_request_skills_var_samp_fields?: Custom_Request_Skills_Var_Samp_FieldsResolvers<ContextType>;
  custom_request_skills_variance_fields?: Custom_Request_Skills_Variance_FieldsResolvers<ContextType>;
  custom_request_status?: GraphQLScalarType;
  date?: GraphQLScalarType;
  declined_visit_matches?: Declined_Visit_MatchesResolvers<ContextType>;
  declined_visit_matches_aggregate?: Declined_Visit_Matches_AggregateResolvers<ContextType>;
  declined_visit_matches_aggregate_fields?: Declined_Visit_Matches_Aggregate_FieldsResolvers<ContextType>;
  declined_visit_matches_avg_fields?: Declined_Visit_Matches_Avg_FieldsResolvers<ContextType>;
  declined_visit_matches_max_fields?: Declined_Visit_Matches_Max_FieldsResolvers<ContextType>;
  declined_visit_matches_min_fields?: Declined_Visit_Matches_Min_FieldsResolvers<ContextType>;
  declined_visit_matches_mutation_response?: Declined_Visit_Matches_Mutation_ResponseResolvers<ContextType>;
  declined_visit_matches_stddev_fields?: Declined_Visit_Matches_Stddev_FieldsResolvers<ContextType>;
  declined_visit_matches_stddev_pop_fields?: Declined_Visit_Matches_Stddev_Pop_FieldsResolvers<ContextType>;
  declined_visit_matches_stddev_samp_fields?: Declined_Visit_Matches_Stddev_Samp_FieldsResolvers<ContextType>;
  declined_visit_matches_sum_fields?: Declined_Visit_Matches_Sum_FieldsResolvers<ContextType>;
  declined_visit_matches_var_pop_fields?: Declined_Visit_Matches_Var_Pop_FieldsResolvers<ContextType>;
  declined_visit_matches_var_samp_fields?: Declined_Visit_Matches_Var_Samp_FieldsResolvers<ContextType>;
  declined_visit_matches_variance_fields?: Declined_Visit_Matches_Variance_FieldsResolvers<ContextType>;
  document?: DocumentResolvers<ContextType>;
  document_aggregate?: Document_AggregateResolvers<ContextType>;
  document_aggregate_fields?: Document_Aggregate_FieldsResolvers<ContextType>;
  document_contractor_access?: Document_Contractor_AccessResolvers<ContextType>;
  document_contractor_access_aggregate?: Document_Contractor_Access_AggregateResolvers<ContextType>;
  document_contractor_access_aggregate_fields?: Document_Contractor_Access_Aggregate_FieldsResolvers<ContextType>;
  document_contractor_access_max_fields?: Document_Contractor_Access_Max_FieldsResolvers<ContextType>;
  document_contractor_access_min_fields?: Document_Contractor_Access_Min_FieldsResolvers<ContextType>;
  document_contractor_access_mutation_response?: Document_Contractor_Access_Mutation_ResponseResolvers<ContextType>;
  document_custom_request?: Document_Custom_RequestResolvers<ContextType>;
  document_custom_request_aggregate?: Document_Custom_Request_AggregateResolvers<ContextType>;
  document_custom_request_aggregate_fields?: Document_Custom_Request_Aggregate_FieldsResolvers<ContextType>;
  document_custom_request_max_fields?: Document_Custom_Request_Max_FieldsResolvers<ContextType>;
  document_custom_request_min_fields?: Document_Custom_Request_Min_FieldsResolvers<ContextType>;
  document_custom_request_mutation_response?: Document_Custom_Request_Mutation_ResponseResolvers<ContextType>;
  document_max_fields?: Document_Max_FieldsResolvers<ContextType>;
  document_min_fields?: Document_Min_FieldsResolvers<ContextType>;
  document_mutation_response?: Document_Mutation_ResponseResolvers<ContextType>;
  document_project?: Document_ProjectResolvers<ContextType>;
  document_project_access_scope?: GraphQLScalarType;
  document_project_aggregate?: Document_Project_AggregateResolvers<ContextType>;
  document_project_aggregate_fields?: Document_Project_Aggregate_FieldsResolvers<ContextType>;
  document_project_max_fields?: Document_Project_Max_FieldsResolvers<ContextType>;
  document_project_min_fields?: Document_Project_Min_FieldsResolvers<ContextType>;
  document_project_mutation_response?: Document_Project_Mutation_ResponseResolvers<ContextType>;
  document_user?: Document_UserResolvers<ContextType>;
  document_user_aggregate?: Document_User_AggregateResolvers<ContextType>;
  document_user_aggregate_fields?: Document_User_Aggregate_FieldsResolvers<ContextType>;
  document_user_max_fields?: Document_User_Max_FieldsResolvers<ContextType>;
  document_user_min_fields?: Document_User_Min_FieldsResolvers<ContextType>;
  document_user_mutation_response?: Document_User_Mutation_ResponseResolvers<ContextType>;
  email_regex?: Email_RegexResolvers<ContextType>;
  email_regex_aggregate?: Email_Regex_AggregateResolvers<ContextType>;
  email_regex_aggregate_fields?: Email_Regex_Aggregate_FieldsResolvers<ContextType>;
  email_regex_avg_fields?: Email_Regex_Avg_FieldsResolvers<ContextType>;
  email_regex_max_fields?: Email_Regex_Max_FieldsResolvers<ContextType>;
  email_regex_min_fields?: Email_Regex_Min_FieldsResolvers<ContextType>;
  email_regex_mutation_response?: Email_Regex_Mutation_ResponseResolvers<ContextType>;
  email_regex_stddev_fields?: Email_Regex_Stddev_FieldsResolvers<ContextType>;
  email_regex_stddev_pop_fields?: Email_Regex_Stddev_Pop_FieldsResolvers<ContextType>;
  email_regex_stddev_samp_fields?: Email_Regex_Stddev_Samp_FieldsResolvers<ContextType>;
  email_regex_sum_fields?: Email_Regex_Sum_FieldsResolvers<ContextType>;
  email_regex_var_pop_fields?: Email_Regex_Var_Pop_FieldsResolvers<ContextType>;
  email_regex_var_samp_fields?: Email_Regex_Var_Samp_FieldsResolvers<ContextType>;
  email_regex_variance_fields?: Email_Regex_Variance_FieldsResolvers<ContextType>;
  experience_skill?: Experience_SkillResolvers<ContextType>;
  experience_skill_aggregate?: Experience_Skill_AggregateResolvers<ContextType>;
  experience_skill_aggregate_fields?: Experience_Skill_Aggregate_FieldsResolvers<ContextType>;
  experience_skill_avg_fields?: Experience_Skill_Avg_FieldsResolvers<ContextType>;
  experience_skill_max_fields?: Experience_Skill_Max_FieldsResolvers<ContextType>;
  experience_skill_min_fields?: Experience_Skill_Min_FieldsResolvers<ContextType>;
  experience_skill_mutation_response?: Experience_Skill_Mutation_ResponseResolvers<ContextType>;
  experience_skill_stddev_fields?: Experience_Skill_Stddev_FieldsResolvers<ContextType>;
  experience_skill_stddev_pop_fields?: Experience_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  experience_skill_stddev_samp_fields?: Experience_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  experience_skill_sum_fields?: Experience_Skill_Sum_FieldsResolvers<ContextType>;
  experience_skill_var_pop_fields?: Experience_Skill_Var_Pop_FieldsResolvers<ContextType>;
  experience_skill_var_samp_fields?: Experience_Skill_Var_Samp_FieldsResolvers<ContextType>;
  experience_skill_variance_fields?: Experience_Skill_Variance_FieldsResolvers<ContextType>;
  float8?: GraphQLScalarType;
  gender?: GenderResolvers<ContextType>;
  gender_aggregate?: Gender_AggregateResolvers<ContextType>;
  gender_aggregate_fields?: Gender_Aggregate_FieldsResolvers<ContextType>;
  gender_max_fields?: Gender_Max_FieldsResolvers<ContextType>;
  gender_min_fields?: Gender_Min_FieldsResolvers<ContextType>;
  gender_mutation_response?: Gender_Mutation_ResponseResolvers<ContextType>;
  industry?: IndustryResolvers<ContextType>;
  industry_aggregate?: Industry_AggregateResolvers<ContextType>;
  industry_aggregate_fields?: Industry_Aggregate_FieldsResolvers<ContextType>;
  industry_avg_fields?: Industry_Avg_FieldsResolvers<ContextType>;
  industry_max_fields?: Industry_Max_FieldsResolvers<ContextType>;
  industry_min_fields?: Industry_Min_FieldsResolvers<ContextType>;
  industry_mutation_response?: Industry_Mutation_ResponseResolvers<ContextType>;
  industry_stddev_fields?: Industry_Stddev_FieldsResolvers<ContextType>;
  industry_stddev_pop_fields?: Industry_Stddev_Pop_FieldsResolvers<ContextType>;
  industry_stddev_samp_fields?: Industry_Stddev_Samp_FieldsResolvers<ContextType>;
  industry_sum_fields?: Industry_Sum_FieldsResolvers<ContextType>;
  industry_var_pop_fields?: Industry_Var_Pop_FieldsResolvers<ContextType>;
  industry_var_samp_fields?: Industry_Var_Samp_FieldsResolvers<ContextType>;
  industry_variance_fields?: Industry_Variance_FieldsResolvers<ContextType>;
  invitation?: InvitationResolvers<ContextType>;
  invitation_aggregate?: Invitation_AggregateResolvers<ContextType>;
  invitation_aggregate_fields?: Invitation_Aggregate_FieldsResolvers<ContextType>;
  invitation_max_fields?: Invitation_Max_FieldsResolvers<ContextType>;
  invitation_min_fields?: Invitation_Min_FieldsResolvers<ContextType>;
  invitation_mutation_response?: Invitation_Mutation_ResponseResolvers<ContextType>;
  invoice?: InvoiceResolvers<ContextType>;
  invoice_aggregate?: Invoice_AggregateResolvers<ContextType>;
  invoice_aggregate_fields?: Invoice_Aggregate_FieldsResolvers<ContextType>;
  invoice_avg_fields?: Invoice_Avg_FieldsResolvers<ContextType>;
  invoice_max_fields?: Invoice_Max_FieldsResolvers<ContextType>;
  invoice_min_fields?: Invoice_Min_FieldsResolvers<ContextType>;
  invoice_mutation_response?: Invoice_Mutation_ResponseResolvers<ContextType>;
  invoice_stddev_fields?: Invoice_Stddev_FieldsResolvers<ContextType>;
  invoice_stddev_pop_fields?: Invoice_Stddev_Pop_FieldsResolvers<ContextType>;
  invoice_stddev_samp_fields?: Invoice_Stddev_Samp_FieldsResolvers<ContextType>;
  invoice_sum_fields?: Invoice_Sum_FieldsResolvers<ContextType>;
  invoice_var_pop_fields?: Invoice_Var_Pop_FieldsResolvers<ContextType>;
  invoice_var_samp_fields?: Invoice_Var_Samp_FieldsResolvers<ContextType>;
  invoice_variance_fields?: Invoice_Variance_FieldsResolvers<ContextType>;
  jsonb?: GraphQLScalarType;
  language?: LanguageResolvers<ContextType>;
  language_aggregate?: Language_AggregateResolvers<ContextType>;
  language_aggregate_fields?: Language_Aggregate_FieldsResolvers<ContextType>;
  language_avg_fields?: Language_Avg_FieldsResolvers<ContextType>;
  language_max_fields?: Language_Max_FieldsResolvers<ContextType>;
  language_min_fields?: Language_Min_FieldsResolvers<ContextType>;
  language_mutation_response?: Language_Mutation_ResponseResolvers<ContextType>;
  language_stddev_fields?: Language_Stddev_FieldsResolvers<ContextType>;
  language_stddev_pop_fields?: Language_Stddev_Pop_FieldsResolvers<ContextType>;
  language_stddev_samp_fields?: Language_Stddev_Samp_FieldsResolvers<ContextType>;
  language_sum_fields?: Language_Sum_FieldsResolvers<ContextType>;
  language_var_pop_fields?: Language_Var_Pop_FieldsResolvers<ContextType>;
  language_var_samp_fields?: Language_Var_Samp_FieldsResolvers<ContextType>;
  language_variance_fields?: Language_Variance_FieldsResolvers<ContextType>;
  manager?: ManagerResolvers<ContextType>;
  manager_aggregate?: Manager_AggregateResolvers<ContextType>;
  manager_aggregate_fields?: Manager_Aggregate_FieldsResolvers<ContextType>;
  manager_contractor?: Manager_ContractorResolvers<ContextType>;
  manager_contractor_aggregate?: Manager_Contractor_AggregateResolvers<ContextType>;
  manager_contractor_aggregate_fields?: Manager_Contractor_Aggregate_FieldsResolvers<ContextType>;
  manager_contractor_max_fields?: Manager_Contractor_Max_FieldsResolvers<ContextType>;
  manager_contractor_min_fields?: Manager_Contractor_Min_FieldsResolvers<ContextType>;
  manager_contractor_mutation_response?: Manager_Contractor_Mutation_ResponseResolvers<ContextType>;
  manager_max_fields?: Manager_Max_FieldsResolvers<ContextType>;
  manager_min_fields?: Manager_Min_FieldsResolvers<ContextType>;
  manager_mutation_response?: Manager_Mutation_ResponseResolvers<ContextType>;
  message?: MessageResolvers<ContextType>;
  message_aggregate?: Message_AggregateResolvers<ContextType>;
  message_aggregate_fields?: Message_Aggregate_FieldsResolvers<ContextType>;
  message_max_fields?: Message_Max_FieldsResolvers<ContextType>;
  message_min_fields?: Message_Min_FieldsResolvers<ContextType>;
  message_mutation_response?: Message_Mutation_ResponseResolvers<ContextType>;
  mutation_root?: Mutation_RootResolvers<ContextType>;
  notification?: NotificationResolvers<ContextType>;
  notification_aggregate?: Notification_AggregateResolvers<ContextType>;
  notification_aggregate_fields?: Notification_Aggregate_FieldsResolvers<ContextType>;
  notification_max_fields?: Notification_Max_FieldsResolvers<ContextType>;
  notification_min_fields?: Notification_Min_FieldsResolvers<ContextType>;
  notification_mutation_response?: Notification_Mutation_ResponseResolvers<ContextType>;
  numeric?: GraphQLScalarType;
  onboarding?: OnboardingResolvers<ContextType>;
  onboarding_aggregate?: Onboarding_AggregateResolvers<ContextType>;
  onboarding_aggregate_fields?: Onboarding_Aggregate_FieldsResolvers<ContextType>;
  onboarding_max_fields?: Onboarding_Max_FieldsResolvers<ContextType>;
  onboarding_min_fields?: Onboarding_Min_FieldsResolvers<ContextType>;
  onboarding_mutation_response?: Onboarding_Mutation_ResponseResolvers<ContextType>;
  payment_card?: Payment_CardResolvers<ContextType>;
  payment_card_aggregate?: Payment_Card_AggregateResolvers<ContextType>;
  payment_card_aggregate_fields?: Payment_Card_Aggregate_FieldsResolvers<ContextType>;
  payment_card_max_fields?: Payment_Card_Max_FieldsResolvers<ContextType>;
  payment_card_min_fields?: Payment_Card_Min_FieldsResolvers<ContextType>;
  payment_card_mutation_response?: Payment_Card_Mutation_ResponseResolvers<ContextType>;
  posting?: PostingResolvers<ContextType>;
  posting_aggregate?: Posting_AggregateResolvers<ContextType>;
  posting_aggregate_fields?: Posting_Aggregate_FieldsResolvers<ContextType>;
  posting_avg_fields?: Posting_Avg_FieldsResolvers<ContextType>;
  posting_industry?: Posting_IndustryResolvers<ContextType>;
  posting_industry_aggregate?: Posting_Industry_AggregateResolvers<ContextType>;
  posting_industry_aggregate_fields?: Posting_Industry_Aggregate_FieldsResolvers<ContextType>;
  posting_industry_avg_fields?: Posting_Industry_Avg_FieldsResolvers<ContextType>;
  posting_industry_max_fields?: Posting_Industry_Max_FieldsResolvers<ContextType>;
  posting_industry_min_fields?: Posting_Industry_Min_FieldsResolvers<ContextType>;
  posting_industry_mutation_response?: Posting_Industry_Mutation_ResponseResolvers<ContextType>;
  posting_industry_stddev_fields?: Posting_Industry_Stddev_FieldsResolvers<ContextType>;
  posting_industry_stddev_pop_fields?: Posting_Industry_Stddev_Pop_FieldsResolvers<ContextType>;
  posting_industry_stddev_samp_fields?: Posting_Industry_Stddev_Samp_FieldsResolvers<ContextType>;
  posting_industry_sum_fields?: Posting_Industry_Sum_FieldsResolvers<ContextType>;
  posting_industry_var_pop_fields?: Posting_Industry_Var_Pop_FieldsResolvers<ContextType>;
  posting_industry_var_samp_fields?: Posting_Industry_Var_Samp_FieldsResolvers<ContextType>;
  posting_industry_variance_fields?: Posting_Industry_Variance_FieldsResolvers<ContextType>;
  posting_max_fields?: Posting_Max_FieldsResolvers<ContextType>;
  posting_min_fields?: Posting_Min_FieldsResolvers<ContextType>;
  posting_mutation_response?: Posting_Mutation_ResponseResolvers<ContextType>;
  posting_skill?: Posting_SkillResolvers<ContextType>;
  posting_skill_aggregate?: Posting_Skill_AggregateResolvers<ContextType>;
  posting_skill_aggregate_fields?: Posting_Skill_Aggregate_FieldsResolvers<ContextType>;
  posting_skill_avg_fields?: Posting_Skill_Avg_FieldsResolvers<ContextType>;
  posting_skill_max_fields?: Posting_Skill_Max_FieldsResolvers<ContextType>;
  posting_skill_min_fields?: Posting_Skill_Min_FieldsResolvers<ContextType>;
  posting_skill_mutation_response?: Posting_Skill_Mutation_ResponseResolvers<ContextType>;
  posting_skill_stddev_fields?: Posting_Skill_Stddev_FieldsResolvers<ContextType>;
  posting_skill_stddev_pop_fields?: Posting_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  posting_skill_stddev_samp_fields?: Posting_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  posting_skill_sum_fields?: Posting_Skill_Sum_FieldsResolvers<ContextType>;
  posting_skill_var_pop_fields?: Posting_Skill_Var_Pop_FieldsResolvers<ContextType>;
  posting_skill_var_samp_fields?: Posting_Skill_Var_Samp_FieldsResolvers<ContextType>;
  posting_skill_variance_fields?: Posting_Skill_Variance_FieldsResolvers<ContextType>;
  posting_stddev_fields?: Posting_Stddev_FieldsResolvers<ContextType>;
  posting_stddev_pop_fields?: Posting_Stddev_Pop_FieldsResolvers<ContextType>;
  posting_stddev_samp_fields?: Posting_Stddev_Samp_FieldsResolvers<ContextType>;
  posting_sum_fields?: Posting_Sum_FieldsResolvers<ContextType>;
  posting_tags?: Posting_TagsResolvers<ContextType>;
  posting_tags_aggregate?: Posting_Tags_AggregateResolvers<ContextType>;
  posting_tags_aggregate_fields?: Posting_Tags_Aggregate_FieldsResolvers<ContextType>;
  posting_tags_max_fields?: Posting_Tags_Max_FieldsResolvers<ContextType>;
  posting_tags_min_fields?: Posting_Tags_Min_FieldsResolvers<ContextType>;
  posting_tags_mutation_response?: Posting_Tags_Mutation_ResponseResolvers<ContextType>;
  posting_var_pop_fields?: Posting_Var_Pop_FieldsResolvers<ContextType>;
  posting_var_samp_fields?: Posting_Var_Samp_FieldsResolvers<ContextType>;
  posting_variance_fields?: Posting_Variance_FieldsResolvers<ContextType>;
  project?: ProjectResolvers<ContextType>;
  project_activity?: Project_ActivityResolvers<ContextType>;
  project_activity_aggregate?: Project_Activity_AggregateResolvers<ContextType>;
  project_activity_aggregate_fields?: Project_Activity_Aggregate_FieldsResolvers<ContextType>;
  project_activity_avg_fields?: Project_Activity_Avg_FieldsResolvers<ContextType>;
  project_activity_max_fields?: Project_Activity_Max_FieldsResolvers<ContextType>;
  project_activity_min_fields?: Project_Activity_Min_FieldsResolvers<ContextType>;
  project_activity_mutation_response?: Project_Activity_Mutation_ResponseResolvers<ContextType>;
  project_activity_note?: Project_Activity_NoteResolvers<ContextType>;
  project_activity_note_aggregate?: Project_Activity_Note_AggregateResolvers<ContextType>;
  project_activity_note_aggregate_fields?: Project_Activity_Note_Aggregate_FieldsResolvers<ContextType>;
  project_activity_note_max_fields?: Project_Activity_Note_Max_FieldsResolvers<ContextType>;
  project_activity_note_min_fields?: Project_Activity_Note_Min_FieldsResolvers<ContextType>;
  project_activity_note_mutation_response?: Project_Activity_Note_Mutation_ResponseResolvers<ContextType>;
  project_activity_request_more_hours?: Project_Activity_Request_More_HoursResolvers<ContextType>;
  project_activity_request_more_hours_aggregate?: Project_Activity_Request_More_Hours_AggregateResolvers<ContextType>;
  project_activity_request_more_hours_aggregate_fields?: Project_Activity_Request_More_Hours_Aggregate_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_avg_fields?: Project_Activity_Request_More_Hours_Avg_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_max_fields?: Project_Activity_Request_More_Hours_Max_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_min_fields?: Project_Activity_Request_More_Hours_Min_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_mutation_response?: Project_Activity_Request_More_Hours_Mutation_ResponseResolvers<ContextType>;
  project_activity_request_more_hours_stddev_fields?: Project_Activity_Request_More_Hours_Stddev_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_stddev_pop_fields?: Project_Activity_Request_More_Hours_Stddev_Pop_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_stddev_samp_fields?: Project_Activity_Request_More_Hours_Stddev_Samp_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_sum_fields?: Project_Activity_Request_More_Hours_Sum_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_var_pop_fields?: Project_Activity_Request_More_Hours_Var_Pop_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_var_samp_fields?: Project_Activity_Request_More_Hours_Var_Samp_FieldsResolvers<ContextType>;
  project_activity_request_more_hours_variance_fields?: Project_Activity_Request_More_Hours_Variance_FieldsResolvers<ContextType>;
  project_activity_skill?: Project_Activity_SkillResolvers<ContextType>;
  project_activity_skill_aggregate?: Project_Activity_Skill_AggregateResolvers<ContextType>;
  project_activity_skill_aggregate_fields?: Project_Activity_Skill_Aggregate_FieldsResolvers<ContextType>;
  project_activity_skill_avg_fields?: Project_Activity_Skill_Avg_FieldsResolvers<ContextType>;
  project_activity_skill_max_fields?: Project_Activity_Skill_Max_FieldsResolvers<ContextType>;
  project_activity_skill_min_fields?: Project_Activity_Skill_Min_FieldsResolvers<ContextType>;
  project_activity_skill_mutation_response?: Project_Activity_Skill_Mutation_ResponseResolvers<ContextType>;
  project_activity_skill_stddev_fields?: Project_Activity_Skill_Stddev_FieldsResolvers<ContextType>;
  project_activity_skill_stddev_pop_fields?: Project_Activity_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  project_activity_skill_stddev_samp_fields?: Project_Activity_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  project_activity_skill_sum_fields?: Project_Activity_Skill_Sum_FieldsResolvers<ContextType>;
  project_activity_skill_var_pop_fields?: Project_Activity_Skill_Var_Pop_FieldsResolvers<ContextType>;
  project_activity_skill_var_samp_fields?: Project_Activity_Skill_Var_Samp_FieldsResolvers<ContextType>;
  project_activity_skill_variance_fields?: Project_Activity_Skill_Variance_FieldsResolvers<ContextType>;
  project_activity_soft_skill?: Project_Activity_Soft_SkillResolvers<ContextType>;
  project_activity_soft_skill_aggregate?: Project_Activity_Soft_Skill_AggregateResolvers<ContextType>;
  project_activity_soft_skill_aggregate_fields?: Project_Activity_Soft_Skill_Aggregate_FieldsResolvers<ContextType>;
  project_activity_soft_skill_avg_fields?: Project_Activity_Soft_Skill_Avg_FieldsResolvers<ContextType>;
  project_activity_soft_skill_max_fields?: Project_Activity_Soft_Skill_Max_FieldsResolvers<ContextType>;
  project_activity_soft_skill_min_fields?: Project_Activity_Soft_Skill_Min_FieldsResolvers<ContextType>;
  project_activity_soft_skill_mutation_response?: Project_Activity_Soft_Skill_Mutation_ResponseResolvers<ContextType>;
  project_activity_soft_skill_stddev_fields?: Project_Activity_Soft_Skill_Stddev_FieldsResolvers<ContextType>;
  project_activity_soft_skill_stddev_pop_fields?: Project_Activity_Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  project_activity_soft_skill_stddev_samp_fields?: Project_Activity_Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  project_activity_soft_skill_sum_fields?: Project_Activity_Soft_Skill_Sum_FieldsResolvers<ContextType>;
  project_activity_soft_skill_var_pop_fields?: Project_Activity_Soft_Skill_Var_Pop_FieldsResolvers<ContextType>;
  project_activity_soft_skill_var_samp_fields?: Project_Activity_Soft_Skill_Var_Samp_FieldsResolvers<ContextType>;
  project_activity_soft_skill_variance_fields?: Project_Activity_Soft_Skill_Variance_FieldsResolvers<ContextType>;
  project_activity_stddev_fields?: Project_Activity_Stddev_FieldsResolvers<ContextType>;
  project_activity_stddev_pop_fields?: Project_Activity_Stddev_Pop_FieldsResolvers<ContextType>;
  project_activity_stddev_samp_fields?: Project_Activity_Stddev_Samp_FieldsResolvers<ContextType>;
  project_activity_sum_fields?: Project_Activity_Sum_FieldsResolvers<ContextType>;
  project_activity_tag?: Project_Activity_TagResolvers<ContextType>;
  project_activity_tag_aggregate?: Project_Activity_Tag_AggregateResolvers<ContextType>;
  project_activity_tag_aggregate_fields?: Project_Activity_Tag_Aggregate_FieldsResolvers<ContextType>;
  project_activity_tag_avg_fields?: Project_Activity_Tag_Avg_FieldsResolvers<ContextType>;
  project_activity_tag_max_fields?: Project_Activity_Tag_Max_FieldsResolvers<ContextType>;
  project_activity_tag_min_fields?: Project_Activity_Tag_Min_FieldsResolvers<ContextType>;
  project_activity_tag_mutation_response?: Project_Activity_Tag_Mutation_ResponseResolvers<ContextType>;
  project_activity_tag_stddev_fields?: Project_Activity_Tag_Stddev_FieldsResolvers<ContextType>;
  project_activity_tag_stddev_pop_fields?: Project_Activity_Tag_Stddev_Pop_FieldsResolvers<ContextType>;
  project_activity_tag_stddev_samp_fields?: Project_Activity_Tag_Stddev_Samp_FieldsResolvers<ContextType>;
  project_activity_tag_sum_fields?: Project_Activity_Tag_Sum_FieldsResolvers<ContextType>;
  project_activity_tag_var_pop_fields?: Project_Activity_Tag_Var_Pop_FieldsResolvers<ContextType>;
  project_activity_tag_var_samp_fields?: Project_Activity_Tag_Var_Samp_FieldsResolvers<ContextType>;
  project_activity_tag_variance_fields?: Project_Activity_Tag_Variance_FieldsResolvers<ContextType>;
  project_activity_time?: Project_Activity_TimeResolvers<ContextType>;
  project_activity_time_aggregate?: Project_Activity_Time_AggregateResolvers<ContextType>;
  project_activity_time_aggregate_fields?: Project_Activity_Time_Aggregate_FieldsResolvers<ContextType>;
  project_activity_time_avg_fields?: Project_Activity_Time_Avg_FieldsResolvers<ContextType>;
  project_activity_time_max_fields?: Project_Activity_Time_Max_FieldsResolvers<ContextType>;
  project_activity_time_min_fields?: Project_Activity_Time_Min_FieldsResolvers<ContextType>;
  project_activity_time_mutation_response?: Project_Activity_Time_Mutation_ResponseResolvers<ContextType>;
  project_activity_time_stddev_fields?: Project_Activity_Time_Stddev_FieldsResolvers<ContextType>;
  project_activity_time_stddev_pop_fields?: Project_Activity_Time_Stddev_Pop_FieldsResolvers<ContextType>;
  project_activity_time_stddev_samp_fields?: Project_Activity_Time_Stddev_Samp_FieldsResolvers<ContextType>;
  project_activity_time_sum_fields?: Project_Activity_Time_Sum_FieldsResolvers<ContextType>;
  project_activity_time_var_pop_fields?: Project_Activity_Time_Var_Pop_FieldsResolvers<ContextType>;
  project_activity_time_var_samp_fields?: Project_Activity_Time_Var_Samp_FieldsResolvers<ContextType>;
  project_activity_time_variance_fields?: Project_Activity_Time_Variance_FieldsResolvers<ContextType>;
  project_activity_tracked_time?: Project_Activity_Tracked_TimeResolvers<ContextType>;
  project_activity_tracked_time_aggregate?: Project_Activity_Tracked_Time_AggregateResolvers<ContextType>;
  project_activity_tracked_time_aggregate_fields?: Project_Activity_Tracked_Time_Aggregate_FieldsResolvers<ContextType>;
  project_activity_tracked_time_avg_fields?: Project_Activity_Tracked_Time_Avg_FieldsResolvers<ContextType>;
  project_activity_tracked_time_max_fields?: Project_Activity_Tracked_Time_Max_FieldsResolvers<ContextType>;
  project_activity_tracked_time_min_fields?: Project_Activity_Tracked_Time_Min_FieldsResolvers<ContextType>;
  project_activity_tracked_time_mutation_response?: Project_Activity_Tracked_Time_Mutation_ResponseResolvers<ContextType>;
  project_activity_tracked_time_stddev_fields?: Project_Activity_Tracked_Time_Stddev_FieldsResolvers<ContextType>;
  project_activity_tracked_time_stddev_pop_fields?: Project_Activity_Tracked_Time_Stddev_Pop_FieldsResolvers<ContextType>;
  project_activity_tracked_time_stddev_samp_fields?: Project_Activity_Tracked_Time_Stddev_Samp_FieldsResolvers<ContextType>;
  project_activity_tracked_time_sum_fields?: Project_Activity_Tracked_Time_Sum_FieldsResolvers<ContextType>;
  project_activity_tracked_time_var_pop_fields?: Project_Activity_Tracked_Time_Var_Pop_FieldsResolvers<ContextType>;
  project_activity_tracked_time_var_samp_fields?: Project_Activity_Tracked_Time_Var_Samp_FieldsResolvers<ContextType>;
  project_activity_tracked_time_variance_fields?: Project_Activity_Tracked_Time_Variance_FieldsResolvers<ContextType>;
  project_activity_var_pop_fields?: Project_Activity_Var_Pop_FieldsResolvers<ContextType>;
  project_activity_var_samp_fields?: Project_Activity_Var_Samp_FieldsResolvers<ContextType>;
  project_activity_variance_fields?: Project_Activity_Variance_FieldsResolvers<ContextType>;
  project_aggregate?: Project_AggregateResolvers<ContextType>;
  project_aggregate_fields?: Project_Aggregate_FieldsResolvers<ContextType>;
  project_avg_fields?: Project_Avg_FieldsResolvers<ContextType>;
  project_max_fields?: Project_Max_FieldsResolvers<ContextType>;
  project_min_fields?: Project_Min_FieldsResolvers<ContextType>;
  project_mutation_response?: Project_Mutation_ResponseResolvers<ContextType>;
  project_skill?: Project_SkillResolvers<ContextType>;
  project_skill_aggregate?: Project_Skill_AggregateResolvers<ContextType>;
  project_skill_aggregate_fields?: Project_Skill_Aggregate_FieldsResolvers<ContextType>;
  project_skill_avg_fields?: Project_Skill_Avg_FieldsResolvers<ContextType>;
  project_skill_max_fields?: Project_Skill_Max_FieldsResolvers<ContextType>;
  project_skill_min_fields?: Project_Skill_Min_FieldsResolvers<ContextType>;
  project_skill_mutation_response?: Project_Skill_Mutation_ResponseResolvers<ContextType>;
  project_skill_stddev_fields?: Project_Skill_Stddev_FieldsResolvers<ContextType>;
  project_skill_stddev_pop_fields?: Project_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  project_skill_stddev_samp_fields?: Project_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  project_skill_sum_fields?: Project_Skill_Sum_FieldsResolvers<ContextType>;
  project_skill_var_pop_fields?: Project_Skill_Var_Pop_FieldsResolvers<ContextType>;
  project_skill_var_samp_fields?: Project_Skill_Var_Samp_FieldsResolvers<ContextType>;
  project_skill_variance_fields?: Project_Skill_Variance_FieldsResolvers<ContextType>;
  project_soft_skill?: Project_Soft_SkillResolvers<ContextType>;
  project_soft_skill_aggregate?: Project_Soft_Skill_AggregateResolvers<ContextType>;
  project_soft_skill_aggregate_fields?: Project_Soft_Skill_Aggregate_FieldsResolvers<ContextType>;
  project_soft_skill_avg_fields?: Project_Soft_Skill_Avg_FieldsResolvers<ContextType>;
  project_soft_skill_max_fields?: Project_Soft_Skill_Max_FieldsResolvers<ContextType>;
  project_soft_skill_min_fields?: Project_Soft_Skill_Min_FieldsResolvers<ContextType>;
  project_soft_skill_mutation_response?: Project_Soft_Skill_Mutation_ResponseResolvers<ContextType>;
  project_soft_skill_stddev_fields?: Project_Soft_Skill_Stddev_FieldsResolvers<ContextType>;
  project_soft_skill_stddev_pop_fields?: Project_Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  project_soft_skill_stddev_samp_fields?: Project_Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  project_soft_skill_sum_fields?: Project_Soft_Skill_Sum_FieldsResolvers<ContextType>;
  project_soft_skill_var_pop_fields?: Project_Soft_Skill_Var_Pop_FieldsResolvers<ContextType>;
  project_soft_skill_var_samp_fields?: Project_Soft_Skill_Var_Samp_FieldsResolvers<ContextType>;
  project_soft_skill_variance_fields?: Project_Soft_Skill_Variance_FieldsResolvers<ContextType>;
  project_stddev_fields?: Project_Stddev_FieldsResolvers<ContextType>;
  project_stddev_pop_fields?: Project_Stddev_Pop_FieldsResolvers<ContextType>;
  project_stddev_samp_fields?: Project_Stddev_Samp_FieldsResolvers<ContextType>;
  project_sum_fields?: Project_Sum_FieldsResolvers<ContextType>;
  project_tag?: Project_TagResolvers<ContextType>;
  project_tag_aggregate?: Project_Tag_AggregateResolvers<ContextType>;
  project_tag_aggregate_fields?: Project_Tag_Aggregate_FieldsResolvers<ContextType>;
  project_tag_avg_fields?: Project_Tag_Avg_FieldsResolvers<ContextType>;
  project_tag_max_fields?: Project_Tag_Max_FieldsResolvers<ContextType>;
  project_tag_min_fields?: Project_Tag_Min_FieldsResolvers<ContextType>;
  project_tag_mutation_response?: Project_Tag_Mutation_ResponseResolvers<ContextType>;
  project_tag_stddev_fields?: Project_Tag_Stddev_FieldsResolvers<ContextType>;
  project_tag_stddev_pop_fields?: Project_Tag_Stddev_Pop_FieldsResolvers<ContextType>;
  project_tag_stddev_samp_fields?: Project_Tag_Stddev_Samp_FieldsResolvers<ContextType>;
  project_tag_sum_fields?: Project_Tag_Sum_FieldsResolvers<ContextType>;
  project_tag_var_pop_fields?: Project_Tag_Var_Pop_FieldsResolvers<ContextType>;
  project_tag_var_samp_fields?: Project_Tag_Var_Samp_FieldsResolvers<ContextType>;
  project_tag_variance_fields?: Project_Tag_Variance_FieldsResolvers<ContextType>;
  project_var_pop_fields?: Project_Var_Pop_FieldsResolvers<ContextType>;
  project_var_samp_fields?: Project_Var_Samp_FieldsResolvers<ContextType>;
  project_variance_fields?: Project_Variance_FieldsResolvers<ContextType>;
  public_project_details?: Public_Project_DetailsResolvers<ContextType>;
  public_project_details_aggregate?: Public_Project_Details_AggregateResolvers<ContextType>;
  public_project_details_aggregate_fields?: Public_Project_Details_Aggregate_FieldsResolvers<ContextType>;
  public_project_details_max_fields?: Public_Project_Details_Max_FieldsResolvers<ContextType>;
  public_project_details_min_fields?: Public_Project_Details_Min_FieldsResolvers<ContextType>;
  query_root?: Query_RootResolvers<ContextType>;
  recipient_message?: Recipient_MessageResolvers<ContextType>;
  recipient_message_aggregate?: Recipient_Message_AggregateResolvers<ContextType>;
  recipient_message_aggregate_fields?: Recipient_Message_Aggregate_FieldsResolvers<ContextType>;
  recipient_message_max_fields?: Recipient_Message_Max_FieldsResolvers<ContextType>;
  recipient_message_min_fields?: Recipient_Message_Min_FieldsResolvers<ContextType>;
  recipient_message_mutation_response?: Recipient_Message_Mutation_ResponseResolvers<ContextType>;
  resource_information_card?: Resource_Information_CardResolvers<ContextType>;
  resource_information_card_aggregate?: Resource_Information_Card_AggregateResolvers<ContextType>;
  resource_information_card_aggregate_fields?: Resource_Information_Card_Aggregate_FieldsResolvers<ContextType>;
  resource_information_card_avg_fields?: Resource_Information_Card_Avg_FieldsResolvers<ContextType>;
  resource_information_card_max_fields?: Resource_Information_Card_Max_FieldsResolvers<ContextType>;
  resource_information_card_min_fields?: Resource_Information_Card_Min_FieldsResolvers<ContextType>;
  resource_information_card_mutation_response?: Resource_Information_Card_Mutation_ResponseResolvers<ContextType>;
  resource_information_card_stddev_fields?: Resource_Information_Card_Stddev_FieldsResolvers<ContextType>;
  resource_information_card_stddev_pop_fields?: Resource_Information_Card_Stddev_Pop_FieldsResolvers<ContextType>;
  resource_information_card_stddev_samp_fields?: Resource_Information_Card_Stddev_Samp_FieldsResolvers<ContextType>;
  resource_information_card_sum_fields?: Resource_Information_Card_Sum_FieldsResolvers<ContextType>;
  resource_information_card_var_pop_fields?: Resource_Information_Card_Var_Pop_FieldsResolvers<ContextType>;
  resource_information_card_var_samp_fields?: Resource_Information_Card_Var_Samp_FieldsResolvers<ContextType>;
  resource_information_card_variance_fields?: Resource_Information_Card_Variance_FieldsResolvers<ContextType>;
  skill?: SkillResolvers<ContextType>;
  skill_aggregate?: Skill_AggregateResolvers<ContextType>;
  skill_aggregate_fields?: Skill_Aggregate_FieldsResolvers<ContextType>;
  skill_avg_fields?: Skill_Avg_FieldsResolvers<ContextType>;
  skill_max_fields?: Skill_Max_FieldsResolvers<ContextType>;
  skill_min_fields?: Skill_Min_FieldsResolvers<ContextType>;
  skill_mutation_response?: Skill_Mutation_ResponseResolvers<ContextType>;
  skill_stddev_fields?: Skill_Stddev_FieldsResolvers<ContextType>;
  skill_stddev_pop_fields?: Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  skill_stddev_samp_fields?: Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  skill_sum_fields?: Skill_Sum_FieldsResolvers<ContextType>;
  skill_var_pop_fields?: Skill_Var_Pop_FieldsResolvers<ContextType>;
  skill_var_samp_fields?: Skill_Var_Samp_FieldsResolvers<ContextType>;
  skill_variance_fields?: Skill_Variance_FieldsResolvers<ContextType>;
  skills_short_name_first?: Skills_Short_Name_FirstResolvers<ContextType>;
  skills_short_name_first_aggregate?: Skills_Short_Name_First_AggregateResolvers<ContextType>;
  skills_short_name_first_aggregate_fields?: Skills_Short_Name_First_Aggregate_FieldsResolvers<ContextType>;
  skills_short_name_first_avg_fields?: Skills_Short_Name_First_Avg_FieldsResolvers<ContextType>;
  skills_short_name_first_max_fields?: Skills_Short_Name_First_Max_FieldsResolvers<ContextType>;
  skills_short_name_first_min_fields?: Skills_Short_Name_First_Min_FieldsResolvers<ContextType>;
  skills_short_name_first_mutation_response?: Skills_Short_Name_First_Mutation_ResponseResolvers<ContextType>;
  skills_short_name_first_stddev_fields?: Skills_Short_Name_First_Stddev_FieldsResolvers<ContextType>;
  skills_short_name_first_stddev_pop_fields?: Skills_Short_Name_First_Stddev_Pop_FieldsResolvers<ContextType>;
  skills_short_name_first_stddev_samp_fields?: Skills_Short_Name_First_Stddev_Samp_FieldsResolvers<ContextType>;
  skills_short_name_first_sum_fields?: Skills_Short_Name_First_Sum_FieldsResolvers<ContextType>;
  skills_short_name_first_var_pop_fields?: Skills_Short_Name_First_Var_Pop_FieldsResolvers<ContextType>;
  skills_short_name_first_var_samp_fields?: Skills_Short_Name_First_Var_Samp_FieldsResolvers<ContextType>;
  skills_short_name_first_variance_fields?: Skills_Short_Name_First_Variance_FieldsResolvers<ContextType>;
  smart_match_bookmark?: Smart_Match_BookmarkResolvers<ContextType>;
  smart_match_bookmark_aggregate?: Smart_Match_Bookmark_AggregateResolvers<ContextType>;
  smart_match_bookmark_aggregate_fields?: Smart_Match_Bookmark_Aggregate_FieldsResolvers<ContextType>;
  smart_match_bookmark_avg_fields?: Smart_Match_Bookmark_Avg_FieldsResolvers<ContextType>;
  smart_match_bookmark_max_fields?: Smart_Match_Bookmark_Max_FieldsResolvers<ContextType>;
  smart_match_bookmark_min_fields?: Smart_Match_Bookmark_Min_FieldsResolvers<ContextType>;
  smart_match_bookmark_mutation_response?: Smart_Match_Bookmark_Mutation_ResponseResolvers<ContextType>;
  smart_match_bookmark_stddev_fields?: Smart_Match_Bookmark_Stddev_FieldsResolvers<ContextType>;
  smart_match_bookmark_stddev_pop_fields?: Smart_Match_Bookmark_Stddev_Pop_FieldsResolvers<ContextType>;
  smart_match_bookmark_stddev_samp_fields?: Smart_Match_Bookmark_Stddev_Samp_FieldsResolvers<ContextType>;
  smart_match_bookmark_sum_fields?: Smart_Match_Bookmark_Sum_FieldsResolvers<ContextType>;
  smart_match_bookmark_var_pop_fields?: Smart_Match_Bookmark_Var_Pop_FieldsResolvers<ContextType>;
  smart_match_bookmark_var_samp_fields?: Smart_Match_Bookmark_Var_Samp_FieldsResolvers<ContextType>;
  smart_match_bookmark_variance_fields?: Smart_Match_Bookmark_Variance_FieldsResolvers<ContextType>;
  smart_match_config_transportation?: Smart_Match_Config_TransportationResolvers<ContextType>;
  smart_match_config_transportation_aggregate?: Smart_Match_Config_Transportation_AggregateResolvers<ContextType>;
  smart_match_config_transportation_aggregate_fields?: Smart_Match_Config_Transportation_Aggregate_FieldsResolvers<ContextType>;
  smart_match_config_transportation_max_fields?: Smart_Match_Config_Transportation_Max_FieldsResolvers<ContextType>;
  smart_match_config_transportation_min_fields?: Smart_Match_Config_Transportation_Min_FieldsResolvers<ContextType>;
  smart_match_config_transportation_mutation_response?: Smart_Match_Config_Transportation_Mutation_ResponseResolvers<ContextType>;
  smart_match_configs?: Smart_Match_ConfigsResolvers<ContextType>;
  smart_match_configs_aggregate?: Smart_Match_Configs_AggregateResolvers<ContextType>;
  smart_match_configs_aggregate_fields?: Smart_Match_Configs_Aggregate_FieldsResolvers<ContextType>;
  smart_match_configs_avg_fields?: Smart_Match_Configs_Avg_FieldsResolvers<ContextType>;
  smart_match_configs_max_fields?: Smart_Match_Configs_Max_FieldsResolvers<ContextType>;
  smart_match_configs_min_fields?: Smart_Match_Configs_Min_FieldsResolvers<ContextType>;
  smart_match_configs_mutation_response?: Smart_Match_Configs_Mutation_ResponseResolvers<ContextType>;
  smart_match_configs_stddev_fields?: Smart_Match_Configs_Stddev_FieldsResolvers<ContextType>;
  smart_match_configs_stddev_pop_fields?: Smart_Match_Configs_Stddev_Pop_FieldsResolvers<ContextType>;
  smart_match_configs_stddev_samp_fields?: Smart_Match_Configs_Stddev_Samp_FieldsResolvers<ContextType>;
  smart_match_configs_sum_fields?: Smart_Match_Configs_Sum_FieldsResolvers<ContextType>;
  smart_match_configs_var_pop_fields?: Smart_Match_Configs_Var_Pop_FieldsResolvers<ContextType>;
  smart_match_configs_var_samp_fields?: Smart_Match_Configs_Var_Samp_FieldsResolvers<ContextType>;
  smart_match_configs_variance_fields?: Smart_Match_Configs_Variance_FieldsResolvers<ContextType>;
  smart_match_criteria_order?: Smart_Match_Criteria_OrderResolvers<ContextType>;
  smart_match_criteria_order_aggregate?: Smart_Match_Criteria_Order_AggregateResolvers<ContextType>;
  smart_match_criteria_order_aggregate_fields?: Smart_Match_Criteria_Order_Aggregate_FieldsResolvers<ContextType>;
  smart_match_criteria_order_avg_fields?: Smart_Match_Criteria_Order_Avg_FieldsResolvers<ContextType>;
  smart_match_criteria_order_max_fields?: Smart_Match_Criteria_Order_Max_FieldsResolvers<ContextType>;
  smart_match_criteria_order_min_fields?: Smart_Match_Criteria_Order_Min_FieldsResolvers<ContextType>;
  smart_match_criteria_order_mutation_response?: Smart_Match_Criteria_Order_Mutation_ResponseResolvers<ContextType>;
  smart_match_criteria_order_stddev_fields?: Smart_Match_Criteria_Order_Stddev_FieldsResolvers<ContextType>;
  smart_match_criteria_order_stddev_pop_fields?: Smart_Match_Criteria_Order_Stddev_Pop_FieldsResolvers<ContextType>;
  smart_match_criteria_order_stddev_samp_fields?: Smart_Match_Criteria_Order_Stddev_Samp_FieldsResolvers<ContextType>;
  smart_match_criteria_order_sum_fields?: Smart_Match_Criteria_Order_Sum_FieldsResolvers<ContextType>;
  smart_match_criteria_order_var_pop_fields?: Smart_Match_Criteria_Order_Var_Pop_FieldsResolvers<ContextType>;
  smart_match_criteria_order_var_samp_fields?: Smart_Match_Criteria_Order_Var_Samp_FieldsResolvers<ContextType>;
  smart_match_criteria_order_variance_fields?: Smart_Match_Criteria_Order_Variance_FieldsResolvers<ContextType>;
  soft_skill?: Soft_SkillResolvers<ContextType>;
  soft_skill_aggregate?: Soft_Skill_AggregateResolvers<ContextType>;
  soft_skill_aggregate_fields?: Soft_Skill_Aggregate_FieldsResolvers<ContextType>;
  soft_skill_avg_fields?: Soft_Skill_Avg_FieldsResolvers<ContextType>;
  soft_skill_max_fields?: Soft_Skill_Max_FieldsResolvers<ContextType>;
  soft_skill_min_fields?: Soft_Skill_Min_FieldsResolvers<ContextType>;
  soft_skill_mutation_response?: Soft_Skill_Mutation_ResponseResolvers<ContextType>;
  soft_skill_stddev_fields?: Soft_Skill_Stddev_FieldsResolvers<ContextType>;
  soft_skill_stddev_pop_fields?: Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  soft_skill_stddev_samp_fields?: Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  soft_skill_sum_fields?: Soft_Skill_Sum_FieldsResolvers<ContextType>;
  soft_skill_var_pop_fields?: Soft_Skill_Var_Pop_FieldsResolvers<ContextType>;
  soft_skill_var_samp_fields?: Soft_Skill_Var_Samp_FieldsResolvers<ContextType>;
  soft_skill_variance_fields?: Soft_Skill_Variance_FieldsResolvers<ContextType>;
  source?: SourceResolvers<ContextType>;
  source_aggregate?: Source_AggregateResolvers<ContextType>;
  source_aggregate_fields?: Source_Aggregate_FieldsResolvers<ContextType>;
  source_max_fields?: Source_Max_FieldsResolvers<ContextType>;
  source_min_fields?: Source_Min_FieldsResolvers<ContextType>;
  source_mutation_response?: Source_Mutation_ResponseResolvers<ContextType>;
  subscription?: SubscriptionResolvers<ContextType>;
  subscription_aggregate?: Subscription_AggregateResolvers<ContextType>;
  subscription_aggregate_fields?: Subscription_Aggregate_FieldsResolvers<ContextType>;
  subscription_avg_fields?: Subscription_Avg_FieldsResolvers<ContextType>;
  subscription_max_fields?: Subscription_Max_FieldsResolvers<ContextType>;
  subscription_min_fields?: Subscription_Min_FieldsResolvers<ContextType>;
  subscription_mutation_response?: Subscription_Mutation_ResponseResolvers<ContextType>;
  subscription_plan?: Subscription_PlanResolvers<ContextType>;
  subscription_plan_access_permissions?: Subscription_Plan_Access_PermissionsResolvers<ContextType>;
  subscription_plan_access_permissions_aggregate?: Subscription_Plan_Access_Permissions_AggregateResolvers<ContextType>;
  subscription_plan_access_permissions_aggregate_fields?: Subscription_Plan_Access_Permissions_Aggregate_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_avg_fields?: Subscription_Plan_Access_Permissions_Avg_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_max_fields?: Subscription_Plan_Access_Permissions_Max_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_min_fields?: Subscription_Plan_Access_Permissions_Min_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_mutation_response?: Subscription_Plan_Access_Permissions_Mutation_ResponseResolvers<ContextType>;
  subscription_plan_access_permissions_stddev_fields?: Subscription_Plan_Access_Permissions_Stddev_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_stddev_pop_fields?: Subscription_Plan_Access_Permissions_Stddev_Pop_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_stddev_samp_fields?: Subscription_Plan_Access_Permissions_Stddev_Samp_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_sum_fields?: Subscription_Plan_Access_Permissions_Sum_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_var_pop_fields?: Subscription_Plan_Access_Permissions_Var_Pop_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_var_samp_fields?: Subscription_Plan_Access_Permissions_Var_Samp_FieldsResolvers<ContextType>;
  subscription_plan_access_permissions_variance_fields?: Subscription_Plan_Access_Permissions_Variance_FieldsResolvers<ContextType>;
  subscription_plan_aggregate?: Subscription_Plan_AggregateResolvers<ContextType>;
  subscription_plan_aggregate_fields?: Subscription_Plan_Aggregate_FieldsResolvers<ContextType>;
  subscription_plan_max_fields?: Subscription_Plan_Max_FieldsResolvers<ContextType>;
  subscription_plan_min_fields?: Subscription_Plan_Min_FieldsResolvers<ContextType>;
  subscription_plan_mutation_response?: Subscription_Plan_Mutation_ResponseResolvers<ContextType>;
  subscription_root?: Subscription_RootResolvers<ContextType>;
  subscription_stddev_fields?: Subscription_Stddev_FieldsResolvers<ContextType>;
  subscription_stddev_pop_fields?: Subscription_Stddev_Pop_FieldsResolvers<ContextType>;
  subscription_stddev_samp_fields?: Subscription_Stddev_Samp_FieldsResolvers<ContextType>;
  subscription_sum_fields?: Subscription_Sum_FieldsResolvers<ContextType>;
  subscription_var_pop_fields?: Subscription_Var_Pop_FieldsResolvers<ContextType>;
  subscription_var_samp_fields?: Subscription_Var_Samp_FieldsResolvers<ContextType>;
  subscription_variance_fields?: Subscription_Variance_FieldsResolvers<ContextType>;
  tag?: TagResolvers<ContextType>;
  tag_aggregate?: Tag_AggregateResolvers<ContextType>;
  tag_aggregate_fields?: Tag_Aggregate_FieldsResolvers<ContextType>;
  tag_max_fields?: Tag_Max_FieldsResolvers<ContextType>;
  tag_min_fields?: Tag_Min_FieldsResolvers<ContextType>;
  tag_mutation_response?: Tag_Mutation_ResponseResolvers<ContextType>;
  team?: TeamResolvers<ContextType>;
  team_aggregate?: Team_AggregateResolvers<ContextType>;
  team_aggregate_fields?: Team_Aggregate_FieldsResolvers<ContextType>;
  team_contractor?: Team_ContractorResolvers<ContextType>;
  team_contractor_aggregate?: Team_Contractor_AggregateResolvers<ContextType>;
  team_contractor_aggregate_fields?: Team_Contractor_Aggregate_FieldsResolvers<ContextType>;
  team_contractor_max_fields?: Team_Contractor_Max_FieldsResolvers<ContextType>;
  team_contractor_min_fields?: Team_Contractor_Min_FieldsResolvers<ContextType>;
  team_contractor_mutation_response?: Team_Contractor_Mutation_ResponseResolvers<ContextType>;
  team_manager?: Team_ManagerResolvers<ContextType>;
  team_manager_aggregate?: Team_Manager_AggregateResolvers<ContextType>;
  team_manager_aggregate_fields?: Team_Manager_Aggregate_FieldsResolvers<ContextType>;
  team_manager_max_fields?: Team_Manager_Max_FieldsResolvers<ContextType>;
  team_manager_min_fields?: Team_Manager_Min_FieldsResolvers<ContextType>;
  team_manager_mutation_response?: Team_Manager_Mutation_ResponseResolvers<ContextType>;
  team_max_fields?: Team_Max_FieldsResolvers<ContextType>;
  team_min_fields?: Team_Min_FieldsResolvers<ContextType>;
  team_mutation_response?: Team_Mutation_ResponseResolvers<ContextType>;
  team_posting?: Team_PostingResolvers<ContextType>;
  team_posting_aggregate?: Team_Posting_AggregateResolvers<ContextType>;
  team_posting_aggregate_fields?: Team_Posting_Aggregate_FieldsResolvers<ContextType>;
  team_posting_max_fields?: Team_Posting_Max_FieldsResolvers<ContextType>;
  team_posting_min_fields?: Team_Posting_Min_FieldsResolvers<ContextType>;
  team_posting_mutation_response?: Team_Posting_Mutation_ResponseResolvers<ContextType>;
  team_project?: Team_ProjectResolvers<ContextType>;
  team_project_aggregate?: Team_Project_AggregateResolvers<ContextType>;
  team_project_aggregate_fields?: Team_Project_Aggregate_FieldsResolvers<ContextType>;
  team_project_max_fields?: Team_Project_Max_FieldsResolvers<ContextType>;
  team_project_min_fields?: Team_Project_Min_FieldsResolvers<ContextType>;
  team_project_mutation_response?: Team_Project_Mutation_ResponseResolvers<ContextType>;
  team_skill?: Team_SkillResolvers<ContextType>;
  team_skill_aggregate?: Team_Skill_AggregateResolvers<ContextType>;
  team_skill_aggregate_fields?: Team_Skill_Aggregate_FieldsResolvers<ContextType>;
  team_skill_avg_fields?: Team_Skill_Avg_FieldsResolvers<ContextType>;
  team_skill_max_fields?: Team_Skill_Max_FieldsResolvers<ContextType>;
  team_skill_min_fields?: Team_Skill_Min_FieldsResolvers<ContextType>;
  team_skill_mutation_response?: Team_Skill_Mutation_ResponseResolvers<ContextType>;
  team_skill_stddev_fields?: Team_Skill_Stddev_FieldsResolvers<ContextType>;
  team_skill_stddev_pop_fields?: Team_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  team_skill_stddev_samp_fields?: Team_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  team_skill_sum_fields?: Team_Skill_Sum_FieldsResolvers<ContextType>;
  team_skill_var_pop_fields?: Team_Skill_Var_Pop_FieldsResolvers<ContextType>;
  team_skill_var_samp_fields?: Team_Skill_Var_Samp_FieldsResolvers<ContextType>;
  team_skill_variance_fields?: Team_Skill_Variance_FieldsResolvers<ContextType>;
  time?: GraphQLScalarType;
  timesheet?: TimesheetResolvers<ContextType>;
  timesheet_aggregate?: Timesheet_AggregateResolvers<ContextType>;
  timesheet_aggregate_fields?: Timesheet_Aggregate_FieldsResolvers<ContextType>;
  timesheet_avg_fields?: Timesheet_Avg_FieldsResolvers<ContextType>;
  timesheet_max_fields?: Timesheet_Max_FieldsResolvers<ContextType>;
  timesheet_min_fields?: Timesheet_Min_FieldsResolvers<ContextType>;
  timesheet_mutation_response?: Timesheet_Mutation_ResponseResolvers<ContextType>;
  timesheet_stddev_fields?: Timesheet_Stddev_FieldsResolvers<ContextType>;
  timesheet_stddev_pop_fields?: Timesheet_Stddev_Pop_FieldsResolvers<ContextType>;
  timesheet_stddev_samp_fields?: Timesheet_Stddev_Samp_FieldsResolvers<ContextType>;
  timesheet_sum_fields?: Timesheet_Sum_FieldsResolvers<ContextType>;
  timesheet_var_pop_fields?: Timesheet_Var_Pop_FieldsResolvers<ContextType>;
  timesheet_var_samp_fields?: Timesheet_Var_Samp_FieldsResolvers<ContextType>;
  timesheet_variance_fields?: Timesheet_Variance_FieldsResolvers<ContextType>;
  timestamp?: GraphQLScalarType;
  timestamptz?: GraphQLScalarType;
  timetz?: GraphQLScalarType;
  type_of_visit?: Type_Of_VisitResolvers<ContextType>;
  type_of_visit_aggregate?: Type_Of_Visit_AggregateResolvers<ContextType>;
  type_of_visit_aggregate_fields?: Type_Of_Visit_Aggregate_FieldsResolvers<ContextType>;
  type_of_visit_max_fields?: Type_Of_Visit_Max_FieldsResolvers<ContextType>;
  type_of_visit_min_fields?: Type_Of_Visit_Min_FieldsResolvers<ContextType>;
  type_of_visit_mutation_response?: Type_Of_Visit_Mutation_ResponseResolvers<ContextType>;
  unread_messages?: Unread_MessagesResolvers<ContextType>;
  unread_messages_aggregate?: Unread_Messages_AggregateResolvers<ContextType>;
  unread_messages_aggregate_fields?: Unread_Messages_Aggregate_FieldsResolvers<ContextType>;
  unread_messages_avg_fields?: Unread_Messages_Avg_FieldsResolvers<ContextType>;
  unread_messages_max_fields?: Unread_Messages_Max_FieldsResolvers<ContextType>;
  unread_messages_min_fields?: Unread_Messages_Min_FieldsResolvers<ContextType>;
  unread_messages_stddev_fields?: Unread_Messages_Stddev_FieldsResolvers<ContextType>;
  unread_messages_stddev_pop_fields?: Unread_Messages_Stddev_Pop_FieldsResolvers<ContextType>;
  unread_messages_stddev_samp_fields?: Unread_Messages_Stddev_Samp_FieldsResolvers<ContextType>;
  unread_messages_sum_fields?: Unread_Messages_Sum_FieldsResolvers<ContextType>;
  unread_messages_var_pop_fields?: Unread_Messages_Var_Pop_FieldsResolvers<ContextType>;
  unread_messages_var_samp_fields?: Unread_Messages_Var_Samp_FieldsResolvers<ContextType>;
  unread_messages_variance_fields?: Unread_Messages_Variance_FieldsResolvers<ContextType>;
  user?: UserResolvers<ContextType>;
  user_affinda_profile?: User_Affinda_ProfileResolvers<ContextType>;
  user_affinda_profile_aggregate?: User_Affinda_Profile_AggregateResolvers<ContextType>;
  user_affinda_profile_aggregate_fields?: User_Affinda_Profile_Aggregate_FieldsResolvers<ContextType>;
  user_affinda_profile_max_fields?: User_Affinda_Profile_Max_FieldsResolvers<ContextType>;
  user_affinda_profile_min_fields?: User_Affinda_Profile_Min_FieldsResolvers<ContextType>;
  user_affinda_profile_mutation_response?: User_Affinda_Profile_Mutation_ResponseResolvers<ContextType>;
  user_aggregate?: User_AggregateResolvers<ContextType>;
  user_aggregate_fields?: User_Aggregate_FieldsResolvers<ContextType>;
  user_avg_fields?: User_Avg_FieldsResolvers<ContextType>;
  user_certification?: User_CertificationResolvers<ContextType>;
  user_certification_aggregate?: User_Certification_AggregateResolvers<ContextType>;
  user_certification_aggregate_fields?: User_Certification_Aggregate_FieldsResolvers<ContextType>;
  user_certification_avg_fields?: User_Certification_Avg_FieldsResolvers<ContextType>;
  user_certification_max_fields?: User_Certification_Max_FieldsResolvers<ContextType>;
  user_certification_min_fields?: User_Certification_Min_FieldsResolvers<ContextType>;
  user_certification_mutation_response?: User_Certification_Mutation_ResponseResolvers<ContextType>;
  user_certification_stddev_fields?: User_Certification_Stddev_FieldsResolvers<ContextType>;
  user_certification_stddev_pop_fields?: User_Certification_Stddev_Pop_FieldsResolvers<ContextType>;
  user_certification_stddev_samp_fields?: User_Certification_Stddev_Samp_FieldsResolvers<ContextType>;
  user_certification_sum_fields?: User_Certification_Sum_FieldsResolvers<ContextType>;
  user_certification_var_pop_fields?: User_Certification_Var_Pop_FieldsResolvers<ContextType>;
  user_certification_var_samp_fields?: User_Certification_Var_Samp_FieldsResolvers<ContextType>;
  user_certification_variance_fields?: User_Certification_Variance_FieldsResolvers<ContextType>;
  user_company?: User_CompanyResolvers<ContextType>;
  user_company_aggregate?: User_Company_AggregateResolvers<ContextType>;
  user_company_aggregate_fields?: User_Company_Aggregate_FieldsResolvers<ContextType>;
  user_company_max_fields?: User_Company_Max_FieldsResolvers<ContextType>;
  user_company_min_fields?: User_Company_Min_FieldsResolvers<ContextType>;
  user_company_mutation_response?: User_Company_Mutation_ResponseResolvers<ContextType>;
  user_conversation?: User_ConversationResolvers<ContextType>;
  user_conversation_aggregate?: User_Conversation_AggregateResolvers<ContextType>;
  user_conversation_aggregate_fields?: User_Conversation_Aggregate_FieldsResolvers<ContextType>;
  user_conversation_max_fields?: User_Conversation_Max_FieldsResolvers<ContextType>;
  user_conversation_min_fields?: User_Conversation_Min_FieldsResolvers<ContextType>;
  user_conversation_mutation_response?: User_Conversation_Mutation_ResponseResolvers<ContextType>;
  user_education?: User_EducationResolvers<ContextType>;
  user_education_aggregate?: User_Education_AggregateResolvers<ContextType>;
  user_education_aggregate_fields?: User_Education_Aggregate_FieldsResolvers<ContextType>;
  user_education_avg_fields?: User_Education_Avg_FieldsResolvers<ContextType>;
  user_education_max_fields?: User_Education_Max_FieldsResolvers<ContextType>;
  user_education_min_fields?: User_Education_Min_FieldsResolvers<ContextType>;
  user_education_mutation_response?: User_Education_Mutation_ResponseResolvers<ContextType>;
  user_education_stddev_fields?: User_Education_Stddev_FieldsResolvers<ContextType>;
  user_education_stddev_pop_fields?: User_Education_Stddev_Pop_FieldsResolvers<ContextType>;
  user_education_stddev_samp_fields?: User_Education_Stddev_Samp_FieldsResolvers<ContextType>;
  user_education_sum_fields?: User_Education_Sum_FieldsResolvers<ContextType>;
  user_education_var_pop_fields?: User_Education_Var_Pop_FieldsResolvers<ContextType>;
  user_education_var_samp_fields?: User_Education_Var_Samp_FieldsResolvers<ContextType>;
  user_education_variance_fields?: User_Education_Variance_FieldsResolvers<ContextType>;
  user_experience?: User_ExperienceResolvers<ContextType>;
  user_experience_aggregate?: User_Experience_AggregateResolvers<ContextType>;
  user_experience_aggregate_fields?: User_Experience_Aggregate_FieldsResolvers<ContextType>;
  user_experience_avg_fields?: User_Experience_Avg_FieldsResolvers<ContextType>;
  user_experience_max_fields?: User_Experience_Max_FieldsResolvers<ContextType>;
  user_experience_min_fields?: User_Experience_Min_FieldsResolvers<ContextType>;
  user_experience_mutation_response?: User_Experience_Mutation_ResponseResolvers<ContextType>;
  user_experience_stddev_fields?: User_Experience_Stddev_FieldsResolvers<ContextType>;
  user_experience_stddev_pop_fields?: User_Experience_Stddev_Pop_FieldsResolvers<ContextType>;
  user_experience_stddev_samp_fields?: User_Experience_Stddev_Samp_FieldsResolvers<ContextType>;
  user_experience_sum_fields?: User_Experience_Sum_FieldsResolvers<ContextType>;
  user_experience_var_pop_fields?: User_Experience_Var_Pop_FieldsResolvers<ContextType>;
  user_experience_var_samp_fields?: User_Experience_Var_Samp_FieldsResolvers<ContextType>;
  user_experience_variance_fields?: User_Experience_Variance_FieldsResolvers<ContextType>;
  user_favorite?: User_FavoriteResolvers<ContextType>;
  user_favorite_aggregate?: User_Favorite_AggregateResolvers<ContextType>;
  user_favorite_aggregate_fields?: User_Favorite_Aggregate_FieldsResolvers<ContextType>;
  user_favorite_max_fields?: User_Favorite_Max_FieldsResolvers<ContextType>;
  user_favorite_min_fields?: User_Favorite_Min_FieldsResolvers<ContextType>;
  user_favorite_mutation_response?: User_Favorite_Mutation_ResponseResolvers<ContextType>;
  user_industry?: User_IndustryResolvers<ContextType>;
  user_industry_aggregate?: User_Industry_AggregateResolvers<ContextType>;
  user_industry_aggregate_fields?: User_Industry_Aggregate_FieldsResolvers<ContextType>;
  user_industry_avg_fields?: User_Industry_Avg_FieldsResolvers<ContextType>;
  user_industry_max_fields?: User_Industry_Max_FieldsResolvers<ContextType>;
  user_industry_min_fields?: User_Industry_Min_FieldsResolvers<ContextType>;
  user_industry_mutation_response?: User_Industry_Mutation_ResponseResolvers<ContextType>;
  user_industry_stddev_fields?: User_Industry_Stddev_FieldsResolvers<ContextType>;
  user_industry_stddev_pop_fields?: User_Industry_Stddev_Pop_FieldsResolvers<ContextType>;
  user_industry_stddev_samp_fields?: User_Industry_Stddev_Samp_FieldsResolvers<ContextType>;
  user_industry_sum_fields?: User_Industry_Sum_FieldsResolvers<ContextType>;
  user_industry_var_pop_fields?: User_Industry_Var_Pop_FieldsResolvers<ContextType>;
  user_industry_var_samp_fields?: User_Industry_Var_Samp_FieldsResolvers<ContextType>;
  user_industry_variance_fields?: User_Industry_Variance_FieldsResolvers<ContextType>;
  user_job_title?: User_Job_TitleResolvers<ContextType>;
  user_job_title_aggregate?: User_Job_Title_AggregateResolvers<ContextType>;
  user_job_title_aggregate_fields?: User_Job_Title_Aggregate_FieldsResolvers<ContextType>;
  user_job_title_avg_fields?: User_Job_Title_Avg_FieldsResolvers<ContextType>;
  user_job_title_max_fields?: User_Job_Title_Max_FieldsResolvers<ContextType>;
  user_job_title_min_fields?: User_Job_Title_Min_FieldsResolvers<ContextType>;
  user_job_title_mutation_response?: User_Job_Title_Mutation_ResponseResolvers<ContextType>;
  user_job_title_stddev_fields?: User_Job_Title_Stddev_FieldsResolvers<ContextType>;
  user_job_title_stddev_pop_fields?: User_Job_Title_Stddev_Pop_FieldsResolvers<ContextType>;
  user_job_title_stddev_samp_fields?: User_Job_Title_Stddev_Samp_FieldsResolvers<ContextType>;
  user_job_title_sum_fields?: User_Job_Title_Sum_FieldsResolvers<ContextType>;
  user_job_title_var_pop_fields?: User_Job_Title_Var_Pop_FieldsResolvers<ContextType>;
  user_job_title_var_samp_fields?: User_Job_Title_Var_Samp_FieldsResolvers<ContextType>;
  user_job_title_variance_fields?: User_Job_Title_Variance_FieldsResolvers<ContextType>;
  user_language?: User_LanguageResolvers<ContextType>;
  user_language_aggregate?: User_Language_AggregateResolvers<ContextType>;
  user_language_aggregate_fields?: User_Language_Aggregate_FieldsResolvers<ContextType>;
  user_language_avg_fields?: User_Language_Avg_FieldsResolvers<ContextType>;
  user_language_max_fields?: User_Language_Max_FieldsResolvers<ContextType>;
  user_language_min_fields?: User_Language_Min_FieldsResolvers<ContextType>;
  user_language_mutation_response?: User_Language_Mutation_ResponseResolvers<ContextType>;
  user_language_stddev_fields?: User_Language_Stddev_FieldsResolvers<ContextType>;
  user_language_stddev_pop_fields?: User_Language_Stddev_Pop_FieldsResolvers<ContextType>;
  user_language_stddev_samp_fields?: User_Language_Stddev_Samp_FieldsResolvers<ContextType>;
  user_language_sum_fields?: User_Language_Sum_FieldsResolvers<ContextType>;
  user_language_var_pop_fields?: User_Language_Var_Pop_FieldsResolvers<ContextType>;
  user_language_var_samp_fields?: User_Language_Var_Samp_FieldsResolvers<ContextType>;
  user_language_variance_fields?: User_Language_Variance_FieldsResolvers<ContextType>;
  user_max_fields?: User_Max_FieldsResolvers<ContextType>;
  user_min_fields?: User_Min_FieldsResolvers<ContextType>;
  user_mutation_response?: User_Mutation_ResponseResolvers<ContextType>;
  user_private_data?: User_Private_DataResolvers<ContextType>;
  user_private_data_aggregate?: User_Private_Data_AggregateResolvers<ContextType>;
  user_private_data_aggregate_fields?: User_Private_Data_Aggregate_FieldsResolvers<ContextType>;
  user_private_data_avg_fields?: User_Private_Data_Avg_FieldsResolvers<ContextType>;
  user_private_data_max_fields?: User_Private_Data_Max_FieldsResolvers<ContextType>;
  user_private_data_min_fields?: User_Private_Data_Min_FieldsResolvers<ContextType>;
  user_private_data_mutation_response?: User_Private_Data_Mutation_ResponseResolvers<ContextType>;
  user_private_data_stddev_fields?: User_Private_Data_Stddev_FieldsResolvers<ContextType>;
  user_private_data_stddev_pop_fields?: User_Private_Data_Stddev_Pop_FieldsResolvers<ContextType>;
  user_private_data_stddev_samp_fields?: User_Private_Data_Stddev_Samp_FieldsResolvers<ContextType>;
  user_private_data_sum_fields?: User_Private_Data_Sum_FieldsResolvers<ContextType>;
  user_private_data_var_pop_fields?: User_Private_Data_Var_Pop_FieldsResolvers<ContextType>;
  user_private_data_var_samp_fields?: User_Private_Data_Var_Samp_FieldsResolvers<ContextType>;
  user_private_data_variance_fields?: User_Private_Data_Variance_FieldsResolvers<ContextType>;
  user_profile?: User_ProfileResolvers<ContextType>;
  user_profile_aggregate?: User_Profile_AggregateResolvers<ContextType>;
  user_profile_aggregate_fields?: User_Profile_Aggregate_FieldsResolvers<ContextType>;
  user_profile_avg_fields?: User_Profile_Avg_FieldsResolvers<ContextType>;
  user_profile_by_management?: User_Profile_By_ManagementResolvers<ContextType>;
  user_profile_by_management_aggregate?: User_Profile_By_Management_AggregateResolvers<ContextType>;
  user_profile_by_management_aggregate_fields?: User_Profile_By_Management_Aggregate_FieldsResolvers<ContextType>;
  user_profile_by_management_avg_fields?: User_Profile_By_Management_Avg_FieldsResolvers<ContextType>;
  user_profile_by_management_max_fields?: User_Profile_By_Management_Max_FieldsResolvers<ContextType>;
  user_profile_by_management_min_fields?: User_Profile_By_Management_Min_FieldsResolvers<ContextType>;
  user_profile_by_management_mutation_response?: User_Profile_By_Management_Mutation_ResponseResolvers<ContextType>;
  user_profile_by_management_stddev_fields?: User_Profile_By_Management_Stddev_FieldsResolvers<ContextType>;
  user_profile_by_management_stddev_pop_fields?: User_Profile_By_Management_Stddev_Pop_FieldsResolvers<ContextType>;
  user_profile_by_management_stddev_samp_fields?: User_Profile_By_Management_Stddev_Samp_FieldsResolvers<ContextType>;
  user_profile_by_management_sum_fields?: User_Profile_By_Management_Sum_FieldsResolvers<ContextType>;
  user_profile_by_management_var_pop_fields?: User_Profile_By_Management_Var_Pop_FieldsResolvers<ContextType>;
  user_profile_by_management_var_samp_fields?: User_Profile_By_Management_Var_Samp_FieldsResolvers<ContextType>;
  user_profile_by_management_variance_fields?: User_Profile_By_Management_Variance_FieldsResolvers<ContextType>;
  user_profile_max_fields?: User_Profile_Max_FieldsResolvers<ContextType>;
  user_profile_min_fields?: User_Profile_Min_FieldsResolvers<ContextType>;
  user_profile_mutation_response?: User_Profile_Mutation_ResponseResolvers<ContextType>;
  user_profile_stddev_fields?: User_Profile_Stddev_FieldsResolvers<ContextType>;
  user_profile_stddev_pop_fields?: User_Profile_Stddev_Pop_FieldsResolvers<ContextType>;
  user_profile_stddev_samp_fields?: User_Profile_Stddev_Samp_FieldsResolvers<ContextType>;
  user_profile_sum_fields?: User_Profile_Sum_FieldsResolvers<ContextType>;
  user_profile_var_pop_fields?: User_Profile_Var_Pop_FieldsResolvers<ContextType>;
  user_profile_var_samp_fields?: User_Profile_Var_Samp_FieldsResolvers<ContextType>;
  user_profile_variance_fields?: User_Profile_Variance_FieldsResolvers<ContextType>;
  user_rating?: User_RatingResolvers<ContextType>;
  user_rating_aggregate?: User_Rating_AggregateResolvers<ContextType>;
  user_rating_aggregate_fields?: User_Rating_Aggregate_FieldsResolvers<ContextType>;
  user_rating_avg_fields?: User_Rating_Avg_FieldsResolvers<ContextType>;
  user_rating_max_fields?: User_Rating_Max_FieldsResolvers<ContextType>;
  user_rating_min_fields?: User_Rating_Min_FieldsResolvers<ContextType>;
  user_rating_mutation_response?: User_Rating_Mutation_ResponseResolvers<ContextType>;
  user_rating_stddev_fields?: User_Rating_Stddev_FieldsResolvers<ContextType>;
  user_rating_stddev_pop_fields?: User_Rating_Stddev_Pop_FieldsResolvers<ContextType>;
  user_rating_stddev_samp_fields?: User_Rating_Stddev_Samp_FieldsResolvers<ContextType>;
  user_rating_sum_fields?: User_Rating_Sum_FieldsResolvers<ContextType>;
  user_rating_var_pop_fields?: User_Rating_Var_Pop_FieldsResolvers<ContextType>;
  user_rating_var_samp_fields?: User_Rating_Var_Samp_FieldsResolvers<ContextType>;
  user_rating_variance_fields?: User_Rating_Variance_FieldsResolvers<ContextType>;
  user_skill?: User_SkillResolvers<ContextType>;
  user_skill_aggregate?: User_Skill_AggregateResolvers<ContextType>;
  user_skill_aggregate_fields?: User_Skill_Aggregate_FieldsResolvers<ContextType>;
  user_skill_avg_fields?: User_Skill_Avg_FieldsResolvers<ContextType>;
  user_skill_max_fields?: User_Skill_Max_FieldsResolvers<ContextType>;
  user_skill_min_fields?: User_Skill_Min_FieldsResolvers<ContextType>;
  user_skill_mutation_response?: User_Skill_Mutation_ResponseResolvers<ContextType>;
  user_skill_stddev_fields?: User_Skill_Stddev_FieldsResolvers<ContextType>;
  user_skill_stddev_pop_fields?: User_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  user_skill_stddev_samp_fields?: User_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  user_skill_sum_fields?: User_Skill_Sum_FieldsResolvers<ContextType>;
  user_skill_var_pop_fields?: User_Skill_Var_Pop_FieldsResolvers<ContextType>;
  user_skill_var_samp_fields?: User_Skill_Var_Samp_FieldsResolvers<ContextType>;
  user_skill_variance_fields?: User_Skill_Variance_FieldsResolvers<ContextType>;
  user_soft_skill?: User_Soft_SkillResolvers<ContextType>;
  user_soft_skill_aggregate?: User_Soft_Skill_AggregateResolvers<ContextType>;
  user_soft_skill_aggregate_fields?: User_Soft_Skill_Aggregate_FieldsResolvers<ContextType>;
  user_soft_skill_avg_fields?: User_Soft_Skill_Avg_FieldsResolvers<ContextType>;
  user_soft_skill_max_fields?: User_Soft_Skill_Max_FieldsResolvers<ContextType>;
  user_soft_skill_min_fields?: User_Soft_Skill_Min_FieldsResolvers<ContextType>;
  user_soft_skill_mutation_response?: User_Soft_Skill_Mutation_ResponseResolvers<ContextType>;
  user_soft_skill_stddev_fields?: User_Soft_Skill_Stddev_FieldsResolvers<ContextType>;
  user_soft_skill_stddev_pop_fields?: User_Soft_Skill_Stddev_Pop_FieldsResolvers<ContextType>;
  user_soft_skill_stddev_samp_fields?: User_Soft_Skill_Stddev_Samp_FieldsResolvers<ContextType>;
  user_soft_skill_sum_fields?: User_Soft_Skill_Sum_FieldsResolvers<ContextType>;
  user_soft_skill_var_pop_fields?: User_Soft_Skill_Var_Pop_FieldsResolvers<ContextType>;
  user_soft_skill_var_samp_fields?: User_Soft_Skill_Var_Samp_FieldsResolvers<ContextType>;
  user_soft_skill_variance_fields?: User_Soft_Skill_Variance_FieldsResolvers<ContextType>;
  user_stddev_fields?: User_Stddev_FieldsResolvers<ContextType>;
  user_stddev_pop_fields?: User_Stddev_Pop_FieldsResolvers<ContextType>;
  user_stddev_samp_fields?: User_Stddev_Samp_FieldsResolvers<ContextType>;
  user_sum_fields?: User_Sum_FieldsResolvers<ContextType>;
  user_transportation?: User_TransportationResolvers<ContextType>;
  user_transportation_aggregate?: User_Transportation_AggregateResolvers<ContextType>;
  user_transportation_aggregate_fields?: User_Transportation_Aggregate_FieldsResolvers<ContextType>;
  user_transportation_max_fields?: User_Transportation_Max_FieldsResolvers<ContextType>;
  user_transportation_min_fields?: User_Transportation_Min_FieldsResolvers<ContextType>;
  user_transportation_mutation_response?: User_Transportation_Mutation_ResponseResolvers<ContextType>;
  user_var_pop_fields?: User_Var_Pop_FieldsResolvers<ContextType>;
  user_var_samp_fields?: User_Var_Samp_FieldsResolvers<ContextType>;
  user_variance_fields?: User_Variance_FieldsResolvers<ContextType>;
  user_watchlist?: User_WatchlistResolvers<ContextType>;
  user_watchlist_aggregate?: User_Watchlist_AggregateResolvers<ContextType>;
  user_watchlist_aggregate_fields?: User_Watchlist_Aggregate_FieldsResolvers<ContextType>;
  user_watchlist_max_fields?: User_Watchlist_Max_FieldsResolvers<ContextType>;
  user_watchlist_min_fields?: User_Watchlist_Min_FieldsResolvers<ContextType>;
  user_watchlist_mutation_response?: User_Watchlist_Mutation_ResponseResolvers<ContextType>;
  uuid?: GraphQLScalarType;
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = {
  cached?: CachedDirectiveResolver<any, any, ContextType>;
};


/**
 * @deprecated
 * Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
 */
export type IDirectiveResolvers<ContextType = any> = DirectiveResolvers<ContextType>;